webpackJsonp([1,0],[
/* 0 */,
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(3)
	  , core      = __webpack_require__(29)
	  , hide      = __webpack_require__(16)
	  , redefine  = __webpack_require__(17)
	  , ctx       = __webpack_require__(30)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target)redefine(target, key, out, type & $export.U);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(5);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 3 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 4 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 5 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(67)('wks')
	  , uid        = __webpack_require__(46)
	  , Symbol     = __webpack_require__(3).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(4)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(2)
	  , IE8_DOM_DEFINE = __webpack_require__(122)
	  , toPrimitive    = __webpack_require__(28)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(7) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.warning = warning;
	exports.format = format;
	exports.isEmptyValue = isEmptyValue;
	exports.isEmptyObject = isEmptyObject;
	exports.asyncMap = asyncMap;
	exports.complementError = complementError;
	exports.deepMerge = deepMerge;
	var formatRegExp = /%[sdj%]/g;
	
	var warning2 = function warning2() {};
	
	if (false) {
	  warning2 = function warning2(type, message) {
	    if (typeof console !== 'undefined' && console.warn) {
	      console.warn(type, message);
	    }
	  };
	}
	
	function warning(type, errors) {
	  // only warn native warning, default type is string, confuses many people...
	  if (errors.every(function (e) {
	    return typeof e === 'string';
	  })) {
	    warning2(type, errors);
	  }
	}
	
	function format() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var i = 1;
	  var f = args[0];
	  var len = args.length;
	  if (typeof f === 'function') {
	    return f.apply(null, args.slice(1));
	  }
	  if (typeof f === 'string') {
	    var str = String(f).replace(formatRegExp, function (x) {
	      if (x === '%%') {
	        return '%';
	      }
	      if (i >= len) {
	        return x;
	      }
	      switch (x) {
	        case '%s':
	          return String(args[i++]);
	        case '%d':
	          return Number(args[i++]);
	        case '%j':
	          try {
	            return JSON.stringify(args[i++]);
	          } catch (_) {
	            return '[Circular]';
	          }
	          break;
	        default:
	          return x;
	      }
	    });
	    for (var arg = args[i]; i < len; arg = args[++i]) {
	      str += ' ' + arg;
	    }
	    return str;
	  }
	  return f;
	}
	
	function isNativeStringType(type) {
	  return type === 'string' || type === 'url' || type === 'hex' || type === 'email';
	}
	
	function isEmptyValue(value, type) {
	  if (value === undefined || value === null) {
	    return true;
	  }
	  if (type === 'array' && Array.isArray(value) && !value.length) {
	    return true;
	  }
	  if (isNativeStringType(type) && typeof value === 'string' && !value) {
	    return true;
	  }
	  return false;
	}
	
	function isEmptyObject(obj) {
	  return Object.keys(obj).length === 0;
	}
	
	function asyncParallelArray(arr, func, callback) {
	  var results = [];
	  var total = 0;
	  var arrLength = arr.length;
	
	  function count(errors) {
	    results.push.apply(results, errors);
	    total++;
	    if (total === arrLength) {
	      callback(results);
	    }
	  }
	
	  arr.forEach(function (a) {
	    func(a, count);
	  });
	}
	
	function asyncSerialArray(arr, func, callback) {
	  var index = 0;
	  var arrLength = arr.length;
	
	  function next(errors) {
	    if (errors && errors.length) {
	      callback(errors);
	      return;
	    }
	    var original = index;
	    index = index + 1;
	    if (original < arrLength) {
	      func(arr[original], next);
	    } else {
	      callback([]);
	    }
	  }
	
	  next([]);
	}
	
	function flattenObjArr(objArr) {
	  var ret = [];
	  Object.keys(objArr).forEach(function (k) {
	    ret.push.apply(ret, objArr[k]);
	  });
	  return ret;
	}
	
	function asyncMap(objArr, option, func, callback) {
	  if (option.first) {
	    var flattenArr = flattenObjArr(objArr);
	    return asyncSerialArray(flattenArr, func, callback);
	  }
	  var firstFields = option.firstFields || [];
	  if (firstFields === true) {
	    firstFields = Object.keys(objArr);
	  }
	  var objArrKeys = Object.keys(objArr);
	  var objArrLength = objArrKeys.length;
	  var total = 0;
	  var results = [];
	  var next = function next(errors) {
	    results.push.apply(results, errors);
	    total++;
	    if (total === objArrLength) {
	      callback(results);
	    }
	  };
	  objArrKeys.forEach(function (key) {
	    var arr = objArr[key];
	    if (firstFields.indexOf(key) !== -1) {
	      asyncSerialArray(arr, func, next);
	    } else {
	      asyncParallelArray(arr, func, next);
	    }
	  });
	}
	
	function complementError(rule) {
	  return function (oe) {
	    if (oe && oe.message) {
	      oe.field = oe.field || rule.fullField;
	      return oe;
	    }
	    return {
	      message: oe,
	      field: oe.field || rule.fullField
	    };
	  };
	}
	
	function deepMerge(target, source) {
	  if (source) {
	    for (var s in source) {
	      if (source.hasOwnProperty(s)) {
	        var value = source[s];
	        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && _typeof(target[s]) === 'object') {
	          target[s] = _extends({}, target[s], value);
	        } else {
	          target[s] = value;
	        }
	      }
	    }
	  }
	  return target;
	}

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(37)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * Vue.js v2.1.8
	 * (c) 2014-2016 Evan You
	 * Released under the MIT License.
	 */
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Vue = factory());
	}(this, (function () { 'use strict';
	
	/*  */
	
	/**
	 * Convert a value to a string that is actually rendered.
	 */
	function _toString (val) {
	  return val == null
	    ? ''
	    : typeof val === 'object'
	      ? JSON.stringify(val, null, 2)
	      : String(val)
	}
	
	/**
	 * Convert a input value to a number for persistence.
	 * If the conversion fails, return original string.
	 */
	function toNumber (val) {
	  var n = parseFloat(val, 10);
	  return (n || n === 0) ? n : val
	}
	
	/**
	 * Make a map and return a function for checking if a key
	 * is in that map.
	 */
	function makeMap (
	  str,
	  expectsLowerCase
	) {
	  var map = Object.create(null);
	  var list = str.split(',');
	  for (var i = 0; i < list.length; i++) {
	    map[list[i]] = true;
	  }
	  return expectsLowerCase
	    ? function (val) { return map[val.toLowerCase()]; }
	    : function (val) { return map[val]; }
	}
	
	/**
	 * Check if a tag is a built-in tag.
	 */
	var isBuiltInTag = makeMap('slot,component', true);
	
	/**
	 * Remove an item from an array
	 */
	function remove$1 (arr, item) {
	  if (arr.length) {
	    var index = arr.indexOf(item);
	    if (index > -1) {
	      return arr.splice(index, 1)
	    }
	  }
	}
	
	/**
	 * Check whether the object has the property.
	 */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	function hasOwn (obj, key) {
	  return hasOwnProperty.call(obj, key)
	}
	
	/**
	 * Check if value is primitive
	 */
	function isPrimitive (value) {
	  return typeof value === 'string' || typeof value === 'number'
	}
	
	/**
	 * Create a cached version of a pure function.
	 */
	function cached (fn) {
	  var cache = Object.create(null);
	  return (function cachedFn (str) {
	    var hit = cache[str];
	    return hit || (cache[str] = fn(str))
	  })
	}
	
	/**
	 * Camelize a hyphen-delmited string.
	 */
	var camelizeRE = /-(\w)/g;
	var camelize = cached(function (str) {
	  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
	});
	
	/**
	 * Capitalize a string.
	 */
	var capitalize = cached(function (str) {
	  return str.charAt(0).toUpperCase() + str.slice(1)
	});
	
	/**
	 * Hyphenate a camelCase string.
	 */
	var hyphenateRE = /([^-])([A-Z])/g;
	var hyphenate = cached(function (str) {
	  return str
	    .replace(hyphenateRE, '$1-$2')
	    .replace(hyphenateRE, '$1-$2')
	    .toLowerCase()
	});
	
	/**
	 * Simple bind, faster than native
	 */
	function bind$1 (fn, ctx) {
	  function boundFn (a) {
	    var l = arguments.length;
	    return l
	      ? l > 1
	        ? fn.apply(ctx, arguments)
	        : fn.call(ctx, a)
	      : fn.call(ctx)
	  }
	  // record original fn length
	  boundFn._length = fn.length;
	  return boundFn
	}
	
	/**
	 * Convert an Array-like object to a real Array.
	 */
	function toArray (list, start) {
	  start = start || 0;
	  var i = list.length - start;
	  var ret = new Array(i);
	  while (i--) {
	    ret[i] = list[i + start];
	  }
	  return ret
	}
	
	/**
	 * Mix properties into target object.
	 */
	function extend (to, _from) {
	  for (var key in _from) {
	    to[key] = _from[key];
	  }
	  return to
	}
	
	/**
	 * Quick object check - this is primarily used to tell
	 * Objects from primitive values when we know the value
	 * is a JSON-compliant type.
	 */
	function isObject (obj) {
	  return obj !== null && typeof obj === 'object'
	}
	
	/**
	 * Strict object type check. Only returns true
	 * for plain JavaScript objects.
	 */
	var toString = Object.prototype.toString;
	var OBJECT_STRING = '[object Object]';
	function isPlainObject (obj) {
	  return toString.call(obj) === OBJECT_STRING
	}
	
	/**
	 * Merge an Array of Objects into a single Object.
	 */
	function toObject (arr) {
	  var res = {};
	  for (var i = 0; i < arr.length; i++) {
	    if (arr[i]) {
	      extend(res, arr[i]);
	    }
	  }
	  return res
	}
	
	/**
	 * Perform no operation.
	 */
	function noop () {}
	
	/**
	 * Always return false.
	 */
	var no = function () { return false; };
	
	/**
	 * Return same value
	 */
	var identity = function (_) { return _; };
	
	/**
	 * Generate a static keys string from compiler modules.
	 */
	function genStaticKeys (modules) {
	  return modules.reduce(function (keys, m) {
	    return keys.concat(m.staticKeys || [])
	  }, []).join(',')
	}
	
	/**
	 * Check if two values are loosely equal - that is,
	 * if they are plain objects, do they have the same shape?
	 */
	function looseEqual (a, b) {
	  var isObjectA = isObject(a);
	  var isObjectB = isObject(b);
	  if (isObjectA && isObjectB) {
	    return JSON.stringify(a) === JSON.stringify(b)
	  } else if (!isObjectA && !isObjectB) {
	    return String(a) === String(b)
	  } else {
	    return false
	  }
	}
	
	function looseIndexOf (arr, val) {
	  for (var i = 0; i < arr.length; i++) {
	    if (looseEqual(arr[i], val)) { return i }
	  }
	  return -1
	}
	
	/*  */
	
	var config = {
	  /**
	   * Option merge strategies (used in core/util/options)
	   */
	  optionMergeStrategies: Object.create(null),
	
	  /**
	   * Whether to suppress warnings.
	   */
	  silent: false,
	
	  /**
	   * Whether to enable devtools
	   */
	  devtools: "development" !== 'production',
	
	  /**
	   * Error handler for watcher errors
	   */
	  errorHandler: null,
	
	  /**
	   * Ignore certain custom elements
	   */
	  ignoredElements: [],
	
	  /**
	   * Custom user key aliases for v-on
	   */
	  keyCodes: Object.create(null),
	
	  /**
	   * Check if a tag is reserved so that it cannot be registered as a
	   * component. This is platform-dependent and may be overwritten.
	   */
	  isReservedTag: no,
	
	  /**
	   * Check if a tag is an unknown element.
	   * Platform-dependent.
	   */
	  isUnknownElement: no,
	
	  /**
	   * Get the namespace of an element
	   */
	  getTagNamespace: noop,
	
	  /**
	   * Parse the real tag name for the specific platform.
	   */
	  parsePlatformTagName: identity,
	
	  /**
	   * Check if an attribute must be bound using property, e.g. value
	   * Platform-dependent.
	   */
	  mustUseProp: no,
	
	  /**
	   * List of asset types that a component can own.
	   */
	  _assetTypes: [
	    'component',
	    'directive',
	    'filter'
	  ],
	
	  /**
	   * List of lifecycle hooks.
	   */
	  _lifecycleHooks: [
	    'beforeCreate',
	    'created',
	    'beforeMount',
	    'mounted',
	    'beforeUpdate',
	    'updated',
	    'beforeDestroy',
	    'destroyed',
	    'activated',
	    'deactivated'
	  ],
	
	  /**
	   * Max circular updates allowed in a scheduler flush cycle.
	   */
	  _maxUpdateCount: 100
	};
	
	/*  */
	
	/**
	 * Check if a string starts with $ or _
	 */
	function isReserved (str) {
	  var c = (str + '').charCodeAt(0);
	  return c === 0x24 || c === 0x5F
	}
	
	/**
	 * Define a property.
	 */
	function def (obj, key, val, enumerable) {
	  Object.defineProperty(obj, key, {
	    value: val,
	    enumerable: !!enumerable,
	    writable: true,
	    configurable: true
	  });
	}
	
	/**
	 * Parse simple path.
	 */
	var bailRE = /[^\w.$]/;
	function parsePath (path) {
	  if (bailRE.test(path)) {
	    return
	  } else {
	    var segments = path.split('.');
	    return function (obj) {
	      for (var i = 0; i < segments.length; i++) {
	        if (!obj) { return }
	        obj = obj[segments[i]];
	      }
	      return obj
	    }
	  }
	}
	
	/*  */
	/* globals MutationObserver */
	
	// can we use __proto__?
	var hasProto = '__proto__' in {};
	
	// Browser environment sniffing
	var inBrowser = typeof window !== 'undefined';
	var UA = inBrowser && window.navigator.userAgent.toLowerCase();
	var isIE = UA && /msie|trident/.test(UA);
	var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
	var isEdge = UA && UA.indexOf('edge/') > 0;
	var isAndroid = UA && UA.indexOf('android') > 0;
	var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);
	
	// this needs to be lazy-evaled because vue may be required before
	// vue-server-renderer can set VUE_ENV
	var _isServer;
	var isServerRendering = function () {
	  if (_isServer === undefined) {
	    /* istanbul ignore if */
	    if (!inBrowser && typeof global !== 'undefined') {
	      // detect presence of vue-server-renderer and avoid
	      // Webpack shimming the process
	      _isServer = global['process'].env.VUE_ENV === 'server';
	    } else {
	      _isServer = false;
	    }
	  }
	  return _isServer
	};
	
	// detect devtools
	var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
	
	/* istanbul ignore next */
	function isNative (Ctor) {
	  return /native code/.test(Ctor.toString())
	}
	
	/**
	 * Defer a task to execute it asynchronously.
	 */
	var nextTick = (function () {
	  var callbacks = [];
	  var pending = false;
	  var timerFunc;
	
	  function nextTickHandler () {
	    pending = false;
	    var copies = callbacks.slice(0);
	    callbacks.length = 0;
	    for (var i = 0; i < copies.length; i++) {
	      copies[i]();
	    }
	  }
	
	  // the nextTick behavior leverages the microtask queue, which can be accessed
	  // via either native Promise.then or MutationObserver.
	  // MutationObserver has wider support, however it is seriously bugged in
	  // UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
	  // completely stops working after triggering a few times... so, if native
	  // Promise is available, we will use it:
	  /* istanbul ignore if */
	  if (typeof Promise !== 'undefined' && isNative(Promise)) {
	    var p = Promise.resolve();
	    var logError = function (err) { console.error(err); };
	    timerFunc = function () {
	      p.then(nextTickHandler).catch(logError);
	      // in problematic UIWebViews, Promise.then doesn't completely break, but
	      // it can get stuck in a weird state where callbacks are pushed into the
	      // microtask queue but the queue isn't being flushed, until the browser
	      // needs to do some other work, e.g. handle a timer. Therefore we can
	      // "force" the microtask queue to be flushed by adding an empty timer.
	      if (isIOS) { setTimeout(noop); }
	    };
	  } else if (typeof MutationObserver !== 'undefined' && (
	    isNative(MutationObserver) ||
	    // PhantomJS and iOS 7.x
	    MutationObserver.toString() === '[object MutationObserverConstructor]'
	  )) {
	    // use MutationObserver where native Promise is not available,
	    // e.g. PhantomJS IE11, iOS7, Android 4.4
	    var counter = 1;
	    var observer = new MutationObserver(nextTickHandler);
	    var textNode = document.createTextNode(String(counter));
	    observer.observe(textNode, {
	      characterData: true
	    });
	    timerFunc = function () {
	      counter = (counter + 1) % 2;
	      textNode.data = String(counter);
	    };
	  } else {
	    // fallback to setTimeout
	    /* istanbul ignore next */
	    timerFunc = function () {
	      setTimeout(nextTickHandler, 0);
	    };
	  }
	
	  return function queueNextTick (cb, ctx) {
	    var _resolve;
	    callbacks.push(function () {
	      if (cb) { cb.call(ctx); }
	      if (_resolve) { _resolve(ctx); }
	    });
	    if (!pending) {
	      pending = true;
	      timerFunc();
	    }
	    if (!cb && typeof Promise !== 'undefined') {
	      return new Promise(function (resolve) {
	        _resolve = resolve;
	      })
	    }
	  }
	})();
	
	var _Set;
	/* istanbul ignore if */
	if (typeof Set !== 'undefined' && isNative(Set)) {
	  // use native Set when available.
	  _Set = Set;
	} else {
	  // a non-standard Set polyfill that only works with primitive keys.
	  _Set = (function () {
	    function Set () {
	      this.set = Object.create(null);
	    }
	    Set.prototype.has = function has (key) {
	      return this.set[key] === true
	    };
	    Set.prototype.add = function add (key) {
	      this.set[key] = true;
	    };
	    Set.prototype.clear = function clear () {
	      this.set = Object.create(null);
	    };
	
	    return Set;
	  }());
	}
	
	var warn = noop;
	var formatComponentName;
	
	{
	  var hasConsole = typeof console !== 'undefined';
	
	  warn = function (msg, vm) {
	    if (hasConsole && (!config.silent)) {
	      console.error("[Vue warn]: " + msg + " " + (
	        vm ? formatLocation(formatComponentName(vm)) : ''
	      ));
	    }
	  };
	
	  formatComponentName = function (vm) {
	    if (vm.$root === vm) {
	      return 'root instance'
	    }
	    var name = vm._isVue
	      ? vm.$options.name || vm.$options._componentTag
	      : vm.name;
	    return (
	      (name ? ("component <" + name + ">") : "anonymous component") +
	      (vm._isVue && vm.$options.__file ? (" at " + (vm.$options.__file)) : '')
	    )
	  };
	
	  var formatLocation = function (str) {
	    if (str === 'anonymous component') {
	      str += " - use the \"name\" option for better debugging messages.";
	    }
	    return ("\n(found in " + str + ")")
	  };
	}
	
	/*  */
	
	
	var uid$1 = 0;
	
	/**
	 * A dep is an observable that can have multiple
	 * directives subscribing to it.
	 */
	var Dep = function Dep () {
	  this.id = uid$1++;
	  this.subs = [];
	};
	
	Dep.prototype.addSub = function addSub (sub) {
	  this.subs.push(sub);
	};
	
	Dep.prototype.removeSub = function removeSub (sub) {
	  remove$1(this.subs, sub);
	};
	
	Dep.prototype.depend = function depend () {
	  if (Dep.target) {
	    Dep.target.addDep(this);
	  }
	};
	
	Dep.prototype.notify = function notify () {
	  // stablize the subscriber list first
	  var subs = this.subs.slice();
	  for (var i = 0, l = subs.length; i < l; i++) {
	    subs[i].update();
	  }
	};
	
	// the current target watcher being evaluated.
	// this is globally unique because there could be only one
	// watcher being evaluated at any time.
	Dep.target = null;
	var targetStack = [];
	
	function pushTarget (_target) {
	  if (Dep.target) { targetStack.push(Dep.target); }
	  Dep.target = _target;
	}
	
	function popTarget () {
	  Dep.target = targetStack.pop();
	}
	
	/*
	 * not type checking this file because flow doesn't play well with
	 * dynamically accessing methods on Array prototype
	 */
	
	var arrayProto = Array.prototype;
	var arrayMethods = Object.create(arrayProto);[
	  'push',
	  'pop',
	  'shift',
	  'unshift',
	  'splice',
	  'sort',
	  'reverse'
	]
	.forEach(function (method) {
	  // cache original method
	  var original = arrayProto[method];
	  def(arrayMethods, method, function mutator () {
	    var arguments$1 = arguments;
	
	    // avoid leaking arguments:
	    // http://jsperf.com/closure-with-arguments
	    var i = arguments.length;
	    var args = new Array(i);
	    while (i--) {
	      args[i] = arguments$1[i];
	    }
	    var result = original.apply(this, args);
	    var ob = this.__ob__;
	    var inserted;
	    switch (method) {
	      case 'push':
	        inserted = args;
	        break
	      case 'unshift':
	        inserted = args;
	        break
	      case 'splice':
	        inserted = args.slice(2);
	        break
	    }
	    if (inserted) { ob.observeArray(inserted); }
	    // notify change
	    ob.dep.notify();
	    return result
	  });
	});
	
	/*  */
	
	var arrayKeys = Object.getOwnPropertyNames(arrayMethods);
	
	/**
	 * By default, when a reactive property is set, the new value is
	 * also converted to become reactive. However when passing down props,
	 * we don't want to force conversion because the value may be a nested value
	 * under a frozen data structure. Converting it would defeat the optimization.
	 */
	var observerState = {
	  shouldConvert: true,
	  isSettingProps: false
	};
	
	/**
	 * Observer class that are attached to each observed
	 * object. Once attached, the observer converts target
	 * object's property keys into getter/setters that
	 * collect dependencies and dispatches updates.
	 */
	var Observer = function Observer (value) {
	  this.value = value;
	  this.dep = new Dep();
	  this.vmCount = 0;
	  def(value, '__ob__', this);
	  if (Array.isArray(value)) {
	    var augment = hasProto
	      ? protoAugment
	      : copyAugment;
	    augment(value, arrayMethods, arrayKeys);
	    this.observeArray(value);
	  } else {
	    this.walk(value);
	  }
	};
	
	/**
	 * Walk through each property and convert them into
	 * getter/setters. This method should only be called when
	 * value type is Object.
	 */
	Observer.prototype.walk = function walk (obj) {
	  var keys = Object.keys(obj);
	  for (var i = 0; i < keys.length; i++) {
	    defineReactive$$1(obj, keys[i], obj[keys[i]]);
	  }
	};
	
	/**
	 * Observe a list of Array items.
	 */
	Observer.prototype.observeArray = function observeArray (items) {
	  for (var i = 0, l = items.length; i < l; i++) {
	    observe(items[i]);
	  }
	};
	
	// helpers
	
	/**
	 * Augment an target Object or Array by intercepting
	 * the prototype chain using __proto__
	 */
	function protoAugment (target, src) {
	  /* eslint-disable no-proto */
	  target.__proto__ = src;
	  /* eslint-enable no-proto */
	}
	
	/**
	 * Augment an target Object or Array by defining
	 * hidden properties.
	 */
	/* istanbul ignore next */
	function copyAugment (target, src, keys) {
	  for (var i = 0, l = keys.length; i < l; i++) {
	    var key = keys[i];
	    def(target, key, src[key]);
	  }
	}
	
	/**
	 * Attempt to create an observer instance for a value,
	 * returns the new observer if successfully observed,
	 * or the existing observer if the value already has one.
	 */
	function observe (value, asRootData) {
	  if (!isObject(value)) {
	    return
	  }
	  var ob;
	  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
	    ob = value.__ob__;
	  } else if (
	    observerState.shouldConvert &&
	    !isServerRendering() &&
	    (Array.isArray(value) || isPlainObject(value)) &&
	    Object.isExtensible(value) &&
	    !value._isVue
	  ) {
	    ob = new Observer(value);
	  }
	  if (asRootData && ob) {
	    ob.vmCount++;
	  }
	  return ob
	}
	
	/**
	 * Define a reactive property on an Object.
	 */
	function defineReactive$$1 (
	  obj,
	  key,
	  val,
	  customSetter
	) {
	  var dep = new Dep();
	
	  var property = Object.getOwnPropertyDescriptor(obj, key);
	  if (property && property.configurable === false) {
	    return
	  }
	
	  // cater for pre-defined getter/setters
	  var getter = property && property.get;
	  var setter = property && property.set;
	
	  var childOb = observe(val);
	  Object.defineProperty(obj, key, {
	    enumerable: true,
	    configurable: true,
	    get: function reactiveGetter () {
	      var value = getter ? getter.call(obj) : val;
	      if (Dep.target) {
	        dep.depend();
	        if (childOb) {
	          childOb.dep.depend();
	        }
	        if (Array.isArray(value)) {
	          dependArray(value);
	        }
	      }
	      return value
	    },
	    set: function reactiveSetter (newVal) {
	      var value = getter ? getter.call(obj) : val;
	      /* eslint-disable no-self-compare */
	      if (newVal === value || (newVal !== newVal && value !== value)) {
	        return
	      }
	      /* eslint-enable no-self-compare */
	      if ("development" !== 'production' && customSetter) {
	        customSetter();
	      }
	      if (setter) {
	        setter.call(obj, newVal);
	      } else {
	        val = newVal;
	      }
	      childOb = observe(newVal);
	      dep.notify();
	    }
	  });
	}
	
	/**
	 * Set a property on an object. Adds the new property and
	 * triggers change notification if the property doesn't
	 * already exist.
	 */
	function set$1 (obj, key, val) {
	  if (Array.isArray(obj)) {
	    obj.length = Math.max(obj.length, key);
	    obj.splice(key, 1, val);
	    return val
	  }
	  if (hasOwn(obj, key)) {
	    obj[key] = val;
	    return
	  }
	  var ob = obj.__ob__;
	  if (obj._isVue || (ob && ob.vmCount)) {
	    "development" !== 'production' && warn(
	      'Avoid adding reactive properties to a Vue instance or its root $data ' +
	      'at runtime - declare it upfront in the data option.'
	    );
	    return
	  }
	  if (!ob) {
	    obj[key] = val;
	    return
	  }
	  defineReactive$$1(ob.value, key, val);
	  ob.dep.notify();
	  return val
	}
	
	/**
	 * Delete a property and trigger change if necessary.
	 */
	function del (obj, key) {
	  var ob = obj.__ob__;
	  if (obj._isVue || (ob && ob.vmCount)) {
	    "development" !== 'production' && warn(
	      'Avoid deleting properties on a Vue instance or its root $data ' +
	      '- just set it to null.'
	    );
	    return
	  }
	  if (!hasOwn(obj, key)) {
	    return
	  }
	  delete obj[key];
	  if (!ob) {
	    return
	  }
	  ob.dep.notify();
	}
	
	/**
	 * Collect dependencies on array elements when the array is touched, since
	 * we cannot intercept array element access like property getters.
	 */
	function dependArray (value) {
	  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
	    e = value[i];
	    e && e.__ob__ && e.__ob__.dep.depend();
	    if (Array.isArray(e)) {
	      dependArray(e);
	    }
	  }
	}
	
	/*  */
	
	/**
	 * Option overwriting strategies are functions that handle
	 * how to merge a parent option value and a child option
	 * value into the final value.
	 */
	var strats = config.optionMergeStrategies;
	
	/**
	 * Options with restrictions
	 */
	{
	  strats.el = strats.propsData = function (parent, child, vm, key) {
	    if (!vm) {
	      warn(
	        "option \"" + key + "\" can only be used during instance " +
	        'creation with the `new` keyword.'
	      );
	    }
	    return defaultStrat(parent, child)
	  };
	}
	
	/**
	 * Helper that recursively merges two data objects together.
	 */
	function mergeData (to, from) {
	  if (!from) { return to }
	  var key, toVal, fromVal;
	  var keys = Object.keys(from);
	  for (var i = 0; i < keys.length; i++) {
	    key = keys[i];
	    toVal = to[key];
	    fromVal = from[key];
	    if (!hasOwn(to, key)) {
	      set$1(to, key, fromVal);
	    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
	      mergeData(toVal, fromVal);
	    }
	  }
	  return to
	}
	
	/**
	 * Data
	 */
	strats.data = function (
	  parentVal,
	  childVal,
	  vm
	) {
	  if (!vm) {
	    // in a Vue.extend merge, both should be functions
	    if (!childVal) {
	      return parentVal
	    }
	    if (typeof childVal !== 'function') {
	      "development" !== 'production' && warn(
	        'The "data" option should be a function ' +
	        'that returns a per-instance value in component ' +
	        'definitions.',
	        vm
	      );
	      return parentVal
	    }
	    if (!parentVal) {
	      return childVal
	    }
	    // when parentVal & childVal are both present,
	    // we need to return a function that returns the
	    // merged result of both functions... no need to
	    // check if parentVal is a function here because
	    // it has to be a function to pass previous merges.
	    return function mergedDataFn () {
	      return mergeData(
	        childVal.call(this),
	        parentVal.call(this)
	      )
	    }
	  } else if (parentVal || childVal) {
	    return function mergedInstanceDataFn () {
	      // instance merge
	      var instanceData = typeof childVal === 'function'
	        ? childVal.call(vm)
	        : childVal;
	      var defaultData = typeof parentVal === 'function'
	        ? parentVal.call(vm)
	        : undefined;
	      if (instanceData) {
	        return mergeData(instanceData, defaultData)
	      } else {
	        return defaultData
	      }
	    }
	  }
	};
	
	/**
	 * Hooks and param attributes are merged as arrays.
	 */
	function mergeHook (
	  parentVal,
	  childVal
	) {
	  return childVal
	    ? parentVal
	      ? parentVal.concat(childVal)
	      : Array.isArray(childVal)
	        ? childVal
	        : [childVal]
	    : parentVal
	}
	
	config._lifecycleHooks.forEach(function (hook) {
	  strats[hook] = mergeHook;
	});
	
	/**
	 * Assets
	 *
	 * When a vm is present (instance creation), we need to do
	 * a three-way merge between constructor options, instance
	 * options and parent options.
	 */
	function mergeAssets (parentVal, childVal) {
	  var res = Object.create(parentVal || null);
	  return childVal
	    ? extend(res, childVal)
	    : res
	}
	
	config._assetTypes.forEach(function (type) {
	  strats[type + 's'] = mergeAssets;
	});
	
	/**
	 * Watchers.
	 *
	 * Watchers hashes should not overwrite one
	 * another, so we merge them as arrays.
	 */
	strats.watch = function (parentVal, childVal) {
	  /* istanbul ignore if */
	  if (!childVal) { return parentVal }
	  if (!parentVal) { return childVal }
	  var ret = {};
	  extend(ret, parentVal);
	  for (var key in childVal) {
	    var parent = ret[key];
	    var child = childVal[key];
	    if (parent && !Array.isArray(parent)) {
	      parent = [parent];
	    }
	    ret[key] = parent
	      ? parent.concat(child)
	      : [child];
	  }
	  return ret
	};
	
	/**
	 * Other object hashes.
	 */
	strats.props =
	strats.methods =
	strats.computed = function (parentVal, childVal) {
	  if (!childVal) { return parentVal }
	  if (!parentVal) { return childVal }
	  var ret = Object.create(null);
	  extend(ret, parentVal);
	  extend(ret, childVal);
	  return ret
	};
	
	/**
	 * Default strategy.
	 */
	var defaultStrat = function (parentVal, childVal) {
	  return childVal === undefined
	    ? parentVal
	    : childVal
	};
	
	/**
	 * Validate component names
	 */
	function checkComponents (options) {
	  for (var key in options.components) {
	    var lower = key.toLowerCase();
	    if (isBuiltInTag(lower) || config.isReservedTag(lower)) {
	      warn(
	        'Do not use built-in or reserved HTML elements as component ' +
	        'id: ' + key
	      );
	    }
	  }
	}
	
	/**
	 * Ensure all props option syntax are normalized into the
	 * Object-based format.
	 */
	function normalizeProps (options) {
	  var props = options.props;
	  if (!props) { return }
	  var res = {};
	  var i, val, name;
	  if (Array.isArray(props)) {
	    i = props.length;
	    while (i--) {
	      val = props[i];
	      if (typeof val === 'string') {
	        name = camelize(val);
	        res[name] = { type: null };
	      } else {
	        warn('props must be strings when using array syntax.');
	      }
	    }
	  } else if (isPlainObject(props)) {
	    for (var key in props) {
	      val = props[key];
	      name = camelize(key);
	      res[name] = isPlainObject(val)
	        ? val
	        : { type: val };
	    }
	  }
	  options.props = res;
	}
	
	/**
	 * Normalize raw function directives into object format.
	 */
	function normalizeDirectives (options) {
	  var dirs = options.directives;
	  if (dirs) {
	    for (var key in dirs) {
	      var def = dirs[key];
	      if (typeof def === 'function') {
	        dirs[key] = { bind: def, update: def };
	      }
	    }
	  }
	}
	
	/**
	 * Merge two option objects into a new one.
	 * Core utility used in both instantiation and inheritance.
	 */
	function mergeOptions (
	  parent,
	  child,
	  vm
	) {
	  {
	    checkComponents(child);
	  }
	  normalizeProps(child);
	  normalizeDirectives(child);
	  var extendsFrom = child.extends;
	  if (extendsFrom) {
	    parent = typeof extendsFrom === 'function'
	      ? mergeOptions(parent, extendsFrom.options, vm)
	      : mergeOptions(parent, extendsFrom, vm);
	  }
	  if (child.mixins) {
	    for (var i = 0, l = child.mixins.length; i < l; i++) {
	      var mixin = child.mixins[i];
	      if (mixin.prototype instanceof Vue$3) {
	        mixin = mixin.options;
	      }
	      parent = mergeOptions(parent, mixin, vm);
	    }
	  }
	  var options = {};
	  var key;
	  for (key in parent) {
	    mergeField(key);
	  }
	  for (key in child) {
	    if (!hasOwn(parent, key)) {
	      mergeField(key);
	    }
	  }
	  function mergeField (key) {
	    var strat = strats[key] || defaultStrat;
	    options[key] = strat(parent[key], child[key], vm, key);
	  }
	  return options
	}
	
	/**
	 * Resolve an asset.
	 * This function is used because child instances need access
	 * to assets defined in its ancestor chain.
	 */
	function resolveAsset (
	  options,
	  type,
	  id,
	  warnMissing
	) {
	  /* istanbul ignore if */
	  if (typeof id !== 'string') {
	    return
	  }
	  var assets = options[type];
	  // check local registration variations first
	  if (hasOwn(assets, id)) { return assets[id] }
	  var camelizedId = camelize(id);
	  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
	  var PascalCaseId = capitalize(camelizedId);
	  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
	  // fallback to prototype chain
	  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
	  if ("development" !== 'production' && warnMissing && !res) {
	    warn(
	      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
	      options
	    );
	  }
	  return res
	}
	
	/*  */
	
	function validateProp (
	  key,
	  propOptions,
	  propsData,
	  vm
	) {
	  var prop = propOptions[key];
	  var absent = !hasOwn(propsData, key);
	  var value = propsData[key];
	  // handle boolean props
	  if (isType(Boolean, prop.type)) {
	    if (absent && !hasOwn(prop, 'default')) {
	      value = false;
	    } else if (!isType(String, prop.type) && (value === '' || value === hyphenate(key))) {
	      value = true;
	    }
	  }
	  // check default value
	  if (value === undefined) {
	    value = getPropDefaultValue(vm, prop, key);
	    // since the default value is a fresh copy,
	    // make sure to observe it.
	    var prevShouldConvert = observerState.shouldConvert;
	    observerState.shouldConvert = true;
	    observe(value);
	    observerState.shouldConvert = prevShouldConvert;
	  }
	  {
	    assertProp(prop, key, value, vm, absent);
	  }
	  return value
	}
	
	/**
	 * Get the default value of a prop.
	 */
	function getPropDefaultValue (vm, prop, key) {
	  // no default, return undefined
	  if (!hasOwn(prop, 'default')) {
	    return undefined
	  }
	  var def = prop.default;
	  // warn against non-factory defaults for Object & Array
	  if (isObject(def)) {
	    "development" !== 'production' && warn(
	      'Invalid default value for prop "' + key + '": ' +
	      'Props with type Object/Array must use a factory function ' +
	      'to return the default value.',
	      vm
	    );
	  }
	  // the raw prop value was also undefined from previous render,
	  // return previous default value to avoid unnecessary watcher trigger
	  if (vm && vm.$options.propsData &&
	    vm.$options.propsData[key] === undefined &&
	    vm[key] !== undefined) {
	    return vm[key]
	  }
	  // call factory function for non-Function types
	  return typeof def === 'function' && prop.type !== Function
	    ? def.call(vm)
	    : def
	}
	
	/**
	 * Assert whether a prop is valid.
	 */
	function assertProp (
	  prop,
	  name,
	  value,
	  vm,
	  absent
	) {
	  if (prop.required && absent) {
	    warn(
	      'Missing required prop: "' + name + '"',
	      vm
	    );
	    return
	  }
	  if (value == null && !prop.required) {
	    return
	  }
	  var type = prop.type;
	  var valid = !type || type === true;
	  var expectedTypes = [];
	  if (type) {
	    if (!Array.isArray(type)) {
	      type = [type];
	    }
	    for (var i = 0; i < type.length && !valid; i++) {
	      var assertedType = assertType(value, type[i]);
	      expectedTypes.push(assertedType.expectedType || '');
	      valid = assertedType.valid;
	    }
	  }
	  if (!valid) {
	    warn(
	      'Invalid prop: type check failed for prop "' + name + '".' +
	      ' Expected ' + expectedTypes.map(capitalize).join(', ') +
	      ', got ' + Object.prototype.toString.call(value).slice(8, -1) + '.',
	      vm
	    );
	    return
	  }
	  var validator = prop.validator;
	  if (validator) {
	    if (!validator(value)) {
	      warn(
	        'Invalid prop: custom validator check failed for prop "' + name + '".',
	        vm
	      );
	    }
	  }
	}
	
	/**
	 * Assert the type of a value
	 */
	function assertType (value, type) {
	  var valid;
	  var expectedType = getType(type);
	  if (expectedType === 'String') {
	    valid = typeof value === (expectedType = 'string');
	  } else if (expectedType === 'Number') {
	    valid = typeof value === (expectedType = 'number');
	  } else if (expectedType === 'Boolean') {
	    valid = typeof value === (expectedType = 'boolean');
	  } else if (expectedType === 'Function') {
	    valid = typeof value === (expectedType = 'function');
	  } else if (expectedType === 'Object') {
	    valid = isPlainObject(value);
	  } else if (expectedType === 'Array') {
	    valid = Array.isArray(value);
	  } else {
	    valid = value instanceof type;
	  }
	  return {
	    valid: valid,
	    expectedType: expectedType
	  }
	}
	
	/**
	 * Use function string name to check built-in types,
	 * because a simple equality check will fail when running
	 * across different vms / iframes.
	 */
	function getType (fn) {
	  var match = fn && fn.toString().match(/^\s*function (\w+)/);
	  return match && match[1]
	}
	
	function isType (type, fn) {
	  if (!Array.isArray(fn)) {
	    return getType(fn) === getType(type)
	  }
	  for (var i = 0, len = fn.length; i < len; i++) {
	    if (getType(fn[i]) === getType(type)) {
	      return true
	    }
	  }
	  /* istanbul ignore next */
	  return false
	}
	
	
	
	var util = Object.freeze({
		defineReactive: defineReactive$$1,
		_toString: _toString,
		toNumber: toNumber,
		makeMap: makeMap,
		isBuiltInTag: isBuiltInTag,
		remove: remove$1,
		hasOwn: hasOwn,
		isPrimitive: isPrimitive,
		cached: cached,
		camelize: camelize,
		capitalize: capitalize,
		hyphenate: hyphenate,
		bind: bind$1,
		toArray: toArray,
		extend: extend,
		isObject: isObject,
		isPlainObject: isPlainObject,
		toObject: toObject,
		noop: noop,
		no: no,
		identity: identity,
		genStaticKeys: genStaticKeys,
		looseEqual: looseEqual,
		looseIndexOf: looseIndexOf,
		isReserved: isReserved,
		def: def,
		parsePath: parsePath,
		hasProto: hasProto,
		inBrowser: inBrowser,
		UA: UA,
		isIE: isIE,
		isIE9: isIE9,
		isEdge: isEdge,
		isAndroid: isAndroid,
		isIOS: isIOS,
		isServerRendering: isServerRendering,
		devtools: devtools,
		nextTick: nextTick,
		get _Set () { return _Set; },
		mergeOptions: mergeOptions,
		resolveAsset: resolveAsset,
		get warn () { return warn; },
		get formatComponentName () { return formatComponentName; },
		validateProp: validateProp
	});
	
	/* not type checking this file because flow doesn't play well with Proxy */
	
	var initProxy;
	
	{
	  var allowedGlobals = makeMap(
	    'Infinity,undefined,NaN,isFinite,isNaN,' +
	    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
	    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
	    'require' // for Webpack/Browserify
	  );
	
	  var warnNonPresent = function (target, key) {
	    warn(
	      "Property or method \"" + key + "\" is not defined on the instance but " +
	      "referenced during render. Make sure to declare reactive data " +
	      "properties in the data option.",
	      target
	    );
	  };
	
	  var hasProxy =
	    typeof Proxy !== 'undefined' &&
	    Proxy.toString().match(/native code/);
	
	  if (hasProxy) {
	    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta');
	    config.keyCodes = new Proxy(config.keyCodes, {
	      set: function set (target, key, value) {
	        if (isBuiltInModifier(key)) {
	          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
	          return false
	        } else {
	          target[key] = value;
	          return true
	        }
	      }
	    });
	  }
	
	  var hasHandler = {
	    has: function has (target, key) {
	      var has = key in target;
	      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
	      if (!has && !isAllowed) {
	        warnNonPresent(target, key);
	      }
	      return has || !isAllowed
	    }
	  };
	
	  var getHandler = {
	    get: function get (target, key) {
	      if (typeof key === 'string' && !(key in target)) {
	        warnNonPresent(target, key);
	      }
	      return target[key]
	    }
	  };
	
	  initProxy = function initProxy (vm) {
	    if (hasProxy) {
	      // determine which proxy handler to use
	      var options = vm.$options;
	      var handlers = options.render && options.render._withStripped
	        ? getHandler
	        : hasHandler;
	      vm._renderProxy = new Proxy(vm, handlers);
	    } else {
	      vm._renderProxy = vm;
	    }
	  };
	}
	
	/*  */
	
	
	var queue = [];
	var has$1 = {};
	var circular = {};
	var waiting = false;
	var flushing = false;
	var index = 0;
	
	/**
	 * Reset the scheduler's state.
	 */
	function resetSchedulerState () {
	  queue.length = 0;
	  has$1 = {};
	  {
	    circular = {};
	  }
	  waiting = flushing = false;
	}
	
	/**
	 * Flush both queues and run the watchers.
	 */
	function flushSchedulerQueue () {
	  flushing = true;
	
	  // Sort queue before flush.
	  // This ensures that:
	  // 1. Components are updated from parent to child. (because parent is always
	  //    created before the child)
	  // 2. A component's user watchers are run before its render watcher (because
	  //    user watchers are created before the render watcher)
	  // 3. If a component is destroyed during a parent component's watcher run,
	  //    its watchers can be skipped.
	  queue.sort(function (a, b) { return a.id - b.id; });
	
	  // do not cache length because more watchers might be pushed
	  // as we run existing watchers
	  for (index = 0; index < queue.length; index++) {
	    var watcher = queue[index];
	    var id = watcher.id;
	    has$1[id] = null;
	    watcher.run();
	    // in dev build, check and stop circular updates.
	    if ("development" !== 'production' && has$1[id] != null) {
	      circular[id] = (circular[id] || 0) + 1;
	      if (circular[id] > config._maxUpdateCount) {
	        warn(
	          'You may have an infinite update loop ' + (
	            watcher.user
	              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
	              : "in a component render function."
	          ),
	          watcher.vm
	        );
	        break
	      }
	    }
	  }
	
	  // devtool hook
	  /* istanbul ignore if */
	  if (devtools && config.devtools) {
	    devtools.emit('flush');
	  }
	
	  resetSchedulerState();
	}
	
	/**
	 * Push a watcher into the watcher queue.
	 * Jobs with duplicate IDs will be skipped unless it's
	 * pushed when the queue is being flushed.
	 */
	function queueWatcher (watcher) {
	  var id = watcher.id;
	  if (has$1[id] == null) {
	    has$1[id] = true;
	    if (!flushing) {
	      queue.push(watcher);
	    } else {
	      // if already flushing, splice the watcher based on its id
	      // if already past its id, it will be run next immediately.
	      var i = queue.length - 1;
	      while (i >= 0 && queue[i].id > watcher.id) {
	        i--;
	      }
	      queue.splice(Math.max(i, index) + 1, 0, watcher);
	    }
	    // queue the flush
	    if (!waiting) {
	      waiting = true;
	      nextTick(flushSchedulerQueue);
	    }
	  }
	}
	
	/*  */
	
	var uid$2 = 0;
	
	/**
	 * A watcher parses an expression, collects dependencies,
	 * and fires callback when the expression value changes.
	 * This is used for both the $watch() api and directives.
	 */
	var Watcher = function Watcher (
	  vm,
	  expOrFn,
	  cb,
	  options
	) {
	  this.vm = vm;
	  vm._watchers.push(this);
	  // options
	  if (options) {
	    this.deep = !!options.deep;
	    this.user = !!options.user;
	    this.lazy = !!options.lazy;
	    this.sync = !!options.sync;
	  } else {
	    this.deep = this.user = this.lazy = this.sync = false;
	  }
	  this.cb = cb;
	  this.id = ++uid$2; // uid for batching
	  this.active = true;
	  this.dirty = this.lazy; // for lazy watchers
	  this.deps = [];
	  this.newDeps = [];
	  this.depIds = new _Set();
	  this.newDepIds = new _Set();
	  this.expression = expOrFn.toString();
	  // parse expression for getter
	  if (typeof expOrFn === 'function') {
	    this.getter = expOrFn;
	  } else {
	    this.getter = parsePath(expOrFn);
	    if (!this.getter) {
	      this.getter = function () {};
	      "development" !== 'production' && warn(
	        "Failed watching path: \"" + expOrFn + "\" " +
	        'Watcher only accepts simple dot-delimited paths. ' +
	        'For full control, use a function instead.',
	        vm
	      );
	    }
	  }
	  this.value = this.lazy
	    ? undefined
	    : this.get();
	};
	
	/**
	 * Evaluate the getter, and re-collect dependencies.
	 */
	Watcher.prototype.get = function get () {
	  pushTarget(this);
	  var value = this.getter.call(this.vm, this.vm);
	  // "touch" every property so they are all tracked as
	  // dependencies for deep watching
	  if (this.deep) {
	    traverse(value);
	  }
	  popTarget();
	  this.cleanupDeps();
	  return value
	};
	
	/**
	 * Add a dependency to this directive.
	 */
	Watcher.prototype.addDep = function addDep (dep) {
	  var id = dep.id;
	  if (!this.newDepIds.has(id)) {
	    this.newDepIds.add(id);
	    this.newDeps.push(dep);
	    if (!this.depIds.has(id)) {
	      dep.addSub(this);
	    }
	  }
	};
	
	/**
	 * Clean up for dependency collection.
	 */
	Watcher.prototype.cleanupDeps = function cleanupDeps () {
	    var this$1 = this;
	
	  var i = this.deps.length;
	  while (i--) {
	    var dep = this$1.deps[i];
	    if (!this$1.newDepIds.has(dep.id)) {
	      dep.removeSub(this$1);
	    }
	  }
	  var tmp = this.depIds;
	  this.depIds = this.newDepIds;
	  this.newDepIds = tmp;
	  this.newDepIds.clear();
	  tmp = this.deps;
	  this.deps = this.newDeps;
	  this.newDeps = tmp;
	  this.newDeps.length = 0;
	};
	
	/**
	 * Subscriber interface.
	 * Will be called when a dependency changes.
	 */
	Watcher.prototype.update = function update () {
	  /* istanbul ignore else */
	  if (this.lazy) {
	    this.dirty = true;
	  } else if (this.sync) {
	    this.run();
	  } else {
	    queueWatcher(this);
	  }
	};
	
	/**
	 * Scheduler job interface.
	 * Will be called by the scheduler.
	 */
	Watcher.prototype.run = function run () {
	  if (this.active) {
	    var value = this.get();
	    if (
	      value !== this.value ||
	      // Deep watchers and watchers on Object/Arrays should fire even
	      // when the value is the same, because the value may
	      // have mutated.
	      isObject(value) ||
	      this.deep
	    ) {
	      // set new value
	      var oldValue = this.value;
	      this.value = value;
	      if (this.user) {
	        try {
	          this.cb.call(this.vm, value, oldValue);
	        } catch (e) {
	          /* istanbul ignore else */
	          if (config.errorHandler) {
	            config.errorHandler.call(null, e, this.vm);
	          } else {
	            "development" !== 'production' && warn(
	              ("Error in watcher \"" + (this.expression) + "\""),
	              this.vm
	            );
	            throw e
	          }
	        }
	      } else {
	        this.cb.call(this.vm, value, oldValue);
	      }
	    }
	  }
	};
	
	/**
	 * Evaluate the value of the watcher.
	 * This only gets called for lazy watchers.
	 */
	Watcher.prototype.evaluate = function evaluate () {
	  this.value = this.get();
	  this.dirty = false;
	};
	
	/**
	 * Depend on all deps collected by this watcher.
	 */
	Watcher.prototype.depend = function depend () {
	    var this$1 = this;
	
	  var i = this.deps.length;
	  while (i--) {
	    this$1.deps[i].depend();
	  }
	};
	
	/**
	 * Remove self from all dependencies' subscriber list.
	 */
	Watcher.prototype.teardown = function teardown () {
	    var this$1 = this;
	
	  if (this.active) {
	    // remove self from vm's watcher list
	    // this is a somewhat expensive operation so we skip it
	    // if the vm is being destroyed.
	    if (!this.vm._isBeingDestroyed) {
	      remove$1(this.vm._watchers, this);
	    }
	    var i = this.deps.length;
	    while (i--) {
	      this$1.deps[i].removeSub(this$1);
	    }
	    this.active = false;
	  }
	};
	
	/**
	 * Recursively traverse an object to evoke all converted
	 * getters, so that every nested property inside the object
	 * is collected as a "deep" dependency.
	 */
	var seenObjects = new _Set();
	function traverse (val) {
	  seenObjects.clear();
	  _traverse(val, seenObjects);
	}
	
	function _traverse (val, seen) {
	  var i, keys;
	  var isA = Array.isArray(val);
	  if ((!isA && !isObject(val)) || !Object.isExtensible(val)) {
	    return
	  }
	  if (val.__ob__) {
	    var depId = val.__ob__.dep.id;
	    if (seen.has(depId)) {
	      return
	    }
	    seen.add(depId);
	  }
	  if (isA) {
	    i = val.length;
	    while (i--) { _traverse(val[i], seen); }
	  } else {
	    keys = Object.keys(val);
	    i = keys.length;
	    while (i--) { _traverse(val[keys[i]], seen); }
	  }
	}
	
	/*  */
	
	function initState (vm) {
	  vm._watchers = [];
	  var opts = vm.$options;
	  if (opts.props) { initProps(vm, opts.props); }
	  if (opts.methods) { initMethods(vm, opts.methods); }
	  if (opts.data) {
	    initData(vm);
	  } else {
	    observe(vm._data = {}, true /* asRootData */);
	  }
	  if (opts.computed) { initComputed(vm, opts.computed); }
	  if (opts.watch) { initWatch(vm, opts.watch); }
	}
	
	var isReservedProp = { key: 1, ref: 1, slot: 1 };
	
	function initProps (vm, props) {
	  var propsData = vm.$options.propsData || {};
	  var keys = vm.$options._propKeys = Object.keys(props);
	  var isRoot = !vm.$parent;
	  // root instance props should be converted
	  observerState.shouldConvert = isRoot;
	  var loop = function ( i ) {
	    var key = keys[i];
	    /* istanbul ignore else */
	    {
	      if (isReservedProp[key]) {
	        warn(
	          ("\"" + key + "\" is a reserved attribute and cannot be used as component prop."),
	          vm
	        );
	      }
	      defineReactive$$1(vm, key, validateProp(key, props, propsData, vm), function () {
	        if (vm.$parent && !observerState.isSettingProps) {
	          warn(
	            "Avoid mutating a prop directly since the value will be " +
	            "overwritten whenever the parent component re-renders. " +
	            "Instead, use a data or computed property based on the prop's " +
	            "value. Prop being mutated: \"" + key + "\"",
	            vm
	          );
	        }
	      });
	    }
	  };
	
	  for (var i = 0; i < keys.length; i++) loop( i );
	  observerState.shouldConvert = true;
	}
	
	function initData (vm) {
	  var data = vm.$options.data;
	  data = vm._data = typeof data === 'function'
	    ? data.call(vm)
	    : data || {};
	  if (!isPlainObject(data)) {
	    data = {};
	    "development" !== 'production' && warn(
	      'data functions should return an object:\n' +
	      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
	      vm
	    );
	  }
	  // proxy data on instance
	  var keys = Object.keys(data);
	  var props = vm.$options.props;
	  var i = keys.length;
	  while (i--) {
	    if (props && hasOwn(props, keys[i])) {
	      "development" !== 'production' && warn(
	        "The data property \"" + (keys[i]) + "\" is already declared as a prop. " +
	        "Use prop default value instead.",
	        vm
	      );
	    } else {
	      proxy(vm, keys[i]);
	    }
	  }
	  // observe data
	  observe(data, true /* asRootData */);
	}
	
	var computedSharedDefinition = {
	  enumerable: true,
	  configurable: true,
	  get: noop,
	  set: noop
	};
	
	function initComputed (vm, computed) {
	  for (var key in computed) {
	    /* istanbul ignore if */
	    if ("development" !== 'production' && key in vm) {
	      warn(
	        "existing instance property \"" + key + "\" will be " +
	        "overwritten by a computed property with the same name.",
	        vm
	      );
	    }
	    var userDef = computed[key];
	    if (typeof userDef === 'function') {
	      computedSharedDefinition.get = makeComputedGetter(userDef, vm);
	      computedSharedDefinition.set = noop;
	    } else {
	      computedSharedDefinition.get = userDef.get
	        ? userDef.cache !== false
	          ? makeComputedGetter(userDef.get, vm)
	          : bind$1(userDef.get, vm)
	        : noop;
	      computedSharedDefinition.set = userDef.set
	        ? bind$1(userDef.set, vm)
	        : noop;
	    }
	    Object.defineProperty(vm, key, computedSharedDefinition);
	  }
	}
	
	function makeComputedGetter (getter, owner) {
	  var watcher = new Watcher(owner, getter, noop, {
	    lazy: true
	  });
	  return function computedGetter () {
	    if (watcher.dirty) {
	      watcher.evaluate();
	    }
	    if (Dep.target) {
	      watcher.depend();
	    }
	    return watcher.value
	  }
	}
	
	function initMethods (vm, methods) {
	  for (var key in methods) {
	    vm[key] = methods[key] == null ? noop : bind$1(methods[key], vm);
	    if ("development" !== 'production' && methods[key] == null) {
	      warn(
	        "method \"" + key + "\" has an undefined value in the component definition. " +
	        "Did you reference the function correctly?",
	        vm
	      );
	    }
	  }
	}
	
	function initWatch (vm, watch) {
	  for (var key in watch) {
	    var handler = watch[key];
	    if (Array.isArray(handler)) {
	      for (var i = 0; i < handler.length; i++) {
	        createWatcher(vm, key, handler[i]);
	      }
	    } else {
	      createWatcher(vm, key, handler);
	    }
	  }
	}
	
	function createWatcher (vm, key, handler) {
	  var options;
	  if (isPlainObject(handler)) {
	    options = handler;
	    handler = handler.handler;
	  }
	  if (typeof handler === 'string') {
	    handler = vm[handler];
	  }
	  vm.$watch(key, handler, options);
	}
	
	function stateMixin (Vue) {
	  // flow somehow has problems with directly declared definition object
	  // when using Object.defineProperty, so we have to procedurally build up
	  // the object here.
	  var dataDef = {};
	  dataDef.get = function () {
	    return this._data
	  };
	  {
	    dataDef.set = function (newData) {
	      warn(
	        'Avoid replacing instance root $data. ' +
	        'Use nested data properties instead.',
	        this
	      );
	    };
	  }
	  Object.defineProperty(Vue.prototype, '$data', dataDef);
	
	  Vue.prototype.$set = set$1;
	  Vue.prototype.$delete = del;
	
	  Vue.prototype.$watch = function (
	    expOrFn,
	    cb,
	    options
	  ) {
	    var vm = this;
	    options = options || {};
	    options.user = true;
	    var watcher = new Watcher(vm, expOrFn, cb, options);
	    if (options.immediate) {
	      cb.call(vm, watcher.value);
	    }
	    return function unwatchFn () {
	      watcher.teardown();
	    }
	  };
	}
	
	function proxy (vm, key) {
	  if (!isReserved(key)) {
	    Object.defineProperty(vm, key, {
	      configurable: true,
	      enumerable: true,
	      get: function proxyGetter () {
	        return vm._data[key]
	      },
	      set: function proxySetter (val) {
	        vm._data[key] = val;
	      }
	    });
	  }
	}
	
	/*  */
	
	var VNode = function VNode (
	  tag,
	  data,
	  children,
	  text,
	  elm,
	  context,
	  componentOptions
	) {
	  this.tag = tag;
	  this.data = data;
	  this.children = children;
	  this.text = text;
	  this.elm = elm;
	  this.ns = undefined;
	  this.context = context;
	  this.functionalContext = undefined;
	  this.key = data && data.key;
	  this.componentOptions = componentOptions;
	  this.child = undefined;
	  this.parent = undefined;
	  this.raw = false;
	  this.isStatic = false;
	  this.isRootInsert = true;
	  this.isComment = false;
	  this.isCloned = false;
	  this.isOnce = false;
	};
	
	var createEmptyVNode = function () {
	  var node = new VNode();
	  node.text = '';
	  node.isComment = true;
	  return node
	};
	
	function createTextVNode (val) {
	  return new VNode(undefined, undefined, undefined, String(val))
	}
	
	// optimized shallow clone
	// used for static nodes and slot nodes because they may be reused across
	// multiple renders, cloning them avoids errors when DOM manipulations rely
	// on their elm reference.
	function cloneVNode (vnode) {
	  var cloned = new VNode(
	    vnode.tag,
	    vnode.data,
	    vnode.children,
	    vnode.text,
	    vnode.elm,
	    vnode.context,
	    vnode.componentOptions
	  );
	  cloned.ns = vnode.ns;
	  cloned.isStatic = vnode.isStatic;
	  cloned.key = vnode.key;
	  cloned.isCloned = true;
	  return cloned
	}
	
	function cloneVNodes (vnodes) {
	  var res = new Array(vnodes.length);
	  for (var i = 0; i < vnodes.length; i++) {
	    res[i] = cloneVNode(vnodes[i]);
	  }
	  return res
	}
	
	/*  */
	
	function mergeVNodeHook (def, hookKey, hook, key) {
	  key = key + hookKey;
	  var injectedHash = def.__injected || (def.__injected = {});
	  if (!injectedHash[key]) {
	    injectedHash[key] = true;
	    var oldHook = def[hookKey];
	    if (oldHook) {
	      def[hookKey] = function () {
	        oldHook.apply(this, arguments);
	        hook.apply(this, arguments);
	      };
	    } else {
	      def[hookKey] = hook;
	    }
	  }
	}
	
	/*  */
	
	function updateListeners (
	  on,
	  oldOn,
	  add,
	  remove$$1,
	  vm
	) {
	  var name, cur, old, fn, event, capture, once;
	  for (name in on) {
	    cur = on[name];
	    old = oldOn[name];
	    if (!cur) {
	      "development" !== 'production' && warn(
	        "Invalid handler for event \"" + name + "\": got " + String(cur),
	        vm
	      );
	    } else if (!old) {
	      once = name.charAt(0) === '~'; // Prefixed last, checked first
	      event = once ? name.slice(1) : name;
	      capture = event.charAt(0) === '!';
	      event = capture ? event.slice(1) : event;
	      if (Array.isArray(cur)) {
	        add(event, (cur.invoker = arrInvoker(cur)), once, capture);
	      } else {
	        if (!cur.invoker) {
	          fn = cur;
	          cur = on[name] = {};
	          cur.fn = fn;
	          cur.invoker = fnInvoker(cur);
	        }
	        add(event, cur.invoker, once, capture);
	      }
	    } else if (cur !== old) {
	      if (Array.isArray(old)) {
	        old.length = cur.length;
	        for (var i = 0; i < old.length; i++) { old[i] = cur[i]; }
	        on[name] = old;
	      } else {
	        old.fn = cur;
	        on[name] = old;
	      }
	    }
	  }
	  for (name in oldOn) {
	    if (!on[name]) {
	      once = name.charAt(0) === '~'; // Prefixed last, checked first
	      event = once ? name.slice(1) : name;
	      capture = event.charAt(0) === '!';
	      event = capture ? event.slice(1) : event;
	      remove$$1(event, oldOn[name].invoker, capture);
	    }
	  }
	}
	
	function arrInvoker (arr) {
	  return function (ev) {
	    var arguments$1 = arguments;
	
	    var single = arguments.length === 1;
	    for (var i = 0; i < arr.length; i++) {
	      single ? arr[i](ev) : arr[i].apply(null, arguments$1);
	    }
	  }
	}
	
	function fnInvoker (o) {
	  return function (ev) {
	    var single = arguments.length === 1;
	    single ? o.fn(ev) : o.fn.apply(null, arguments);
	  }
	}
	
	/*  */
	
	// The template compiler attempts to minimize the need for normalization by
	// statically analyzing the template at compile time.
	//
	// For plain HTML markup, normalization can be completely skipped because the
	// generated render function is guaranteed to return Array<VNode>. There are
	// two cases where extra normalization is needed:
	
	// 1. When the children contains components - because a functional component
	// may return an Array instead of a single root. In this case, just a simple
	// nomralization is needed - if any child is an Array, we flatten the whole
	// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
	// because functional components already normalize their own children.
	function simpleNormalizeChildren (children) {
	  for (var i = 0; i < children.length; i++) {
	    if (Array.isArray(children[i])) {
	      return Array.prototype.concat.apply([], children)
	    }
	  }
	  return children
	}
	
	// 2. When the children contains constrcuts that always generated nested Arrays,
	// e.g. <template>, <slot>, v-for, or when the children is provided by user
	// with hand-written render functions / JSX. In such cases a full normalization
	// is needed to cater to all possible types of children values.
	function normalizeChildren (children) {
	  return isPrimitive(children)
	    ? [createTextVNode(children)]
	    : Array.isArray(children)
	      ? normalizeArrayChildren(children)
	      : undefined
	}
	
	function normalizeArrayChildren (children, nestedIndex) {
	  var res = [];
	  var i, c, last;
	  for (i = 0; i < children.length; i++) {
	    c = children[i];
	    if (c == null || typeof c === 'boolean') { continue }
	    last = res[res.length - 1];
	    //  nested
	    if (Array.isArray(c)) {
	      res.push.apply(res, normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i)));
	    } else if (isPrimitive(c)) {
	      if (last && last.text) {
	        last.text += String(c);
	      } else if (c !== '') {
	        // convert primitive to vnode
	        res.push(createTextVNode(c));
	      }
	    } else {
	      if (c.text && last && last.text) {
	        res[res.length - 1] = createTextVNode(last.text + c.text);
	      } else {
	        // default key for nested array children (likely generated by v-for)
	        if (c.tag && c.key == null && nestedIndex != null) {
	          c.key = "__vlist" + nestedIndex + "_" + i + "__";
	        }
	        res.push(c);
	      }
	    }
	  }
	  return res
	}
	
	/*  */
	
	function getFirstComponentChild (children) {
	  return children && children.filter(function (c) { return c && c.componentOptions; })[0]
	}
	
	/*  */
	
	function initEvents (vm) {
	  vm._events = Object.create(null);
	  vm._hasHookEvent = false;
	  // init parent attached events
	  var listeners = vm.$options._parentListeners;
	  if (listeners) {
	    updateComponentListeners(vm, listeners);
	  }
	}
	
	var target;
	
	function add$1 (event, fn, once) {
	  if (once) {
	    target.$once(event, fn);
	  } else {
	    target.$on(event, fn);
	  }
	}
	
	function remove$2 (event, fn) {
	  target.$off(event, fn);
	}
	
	function updateComponentListeners (
	  vm,
	  listeners,
	  oldListeners
	) {
	  target = vm;
	  updateListeners(listeners, oldListeners || {}, add$1, remove$2, vm);
	}
	
	function eventsMixin (Vue) {
	  var hookRE = /^hook:/;
	  Vue.prototype.$on = function (event, fn) {
	    var vm = this;(vm._events[event] || (vm._events[event] = [])).push(fn);
	    // optimize hook:event cost by using a boolean flag marked at registration
	    // instead of a hash lookup
	    if (hookRE.test(event)) {
	      vm._hasHookEvent = true;
	    }
	    return vm
	  };
	
	  Vue.prototype.$once = function (event, fn) {
	    var vm = this;
	    function on () {
	      vm.$off(event, on);
	      fn.apply(vm, arguments);
	    }
	    on.fn = fn;
	    vm.$on(event, on);
	    return vm
	  };
	
	  Vue.prototype.$off = function (event, fn) {
	    var vm = this;
	    // all
	    if (!arguments.length) {
	      vm._events = Object.create(null);
	      return vm
	    }
	    // specific event
	    var cbs = vm._events[event];
	    if (!cbs) {
	      return vm
	    }
	    if (arguments.length === 1) {
	      vm._events[event] = null;
	      return vm
	    }
	    // specific handler
	    var cb;
	    var i = cbs.length;
	    while (i--) {
	      cb = cbs[i];
	      if (cb === fn || cb.fn === fn) {
	        cbs.splice(i, 1);
	        break
	      }
	    }
	    return vm
	  };
	
	  Vue.prototype.$emit = function (event) {
	    var vm = this;
	    var cbs = vm._events[event];
	    if (cbs) {
	      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
	      var args = toArray(arguments, 1);
	      for (var i = 0, l = cbs.length; i < l; i++) {
	        cbs[i].apply(vm, args);
	      }
	    }
	    return vm
	  };
	}
	
	/*  */
	
	var activeInstance = null;
	
	function initLifecycle (vm) {
	  var options = vm.$options;
	
	  // locate first non-abstract parent
	  var parent = options.parent;
	  if (parent && !options.abstract) {
	    while (parent.$options.abstract && parent.$parent) {
	      parent = parent.$parent;
	    }
	    parent.$children.push(vm);
	  }
	
	  vm.$parent = parent;
	  vm.$root = parent ? parent.$root : vm;
	
	  vm.$children = [];
	  vm.$refs = {};
	
	  vm._watcher = null;
	  vm._inactive = false;
	  vm._isMounted = false;
	  vm._isDestroyed = false;
	  vm._isBeingDestroyed = false;
	}
	
	function lifecycleMixin (Vue) {
	  Vue.prototype._mount = function (
	    el,
	    hydrating
	  ) {
	    var vm = this;
	    vm.$el = el;
	    if (!vm.$options.render) {
	      vm.$options.render = createEmptyVNode;
	      {
	        /* istanbul ignore if */
	        if (vm.$options.template && vm.$options.template.charAt(0) !== '#') {
	          warn(
	            'You are using the runtime-only build of Vue where the template ' +
	            'option is not available. Either pre-compile the templates into ' +
	            'render functions, or use the compiler-included build.',
	            vm
	          );
	        } else {
	          warn(
	            'Failed to mount component: template or render function not defined.',
	            vm
	          );
	        }
	      }
	    }
	    callHook(vm, 'beforeMount');
	    vm._watcher = new Watcher(vm, function () {
	      vm._update(vm._render(), hydrating);
	    }, noop);
	    hydrating = false;
	    // manually mounted instance, call mounted on self
	    // mounted is called for render-created child components in its inserted hook
	    if (vm.$vnode == null) {
	      vm._isMounted = true;
	      callHook(vm, 'mounted');
	    }
	    return vm
	  };
	
	  Vue.prototype._update = function (vnode, hydrating) {
	    var vm = this;
	    if (vm._isMounted) {
	      callHook(vm, 'beforeUpdate');
	    }
	    var prevEl = vm.$el;
	    var prevVnode = vm._vnode;
	    var prevActiveInstance = activeInstance;
	    activeInstance = vm;
	    vm._vnode = vnode;
	    // Vue.prototype.__patch__ is injected in entry points
	    // based on the rendering backend used.
	    if (!prevVnode) {
	      // initial render
	      vm.$el = vm.__patch__(
	        vm.$el, vnode, hydrating, false /* removeOnly */,
	        vm.$options._parentElm,
	        vm.$options._refElm
	      );
	    } else {
	      // updates
	      vm.$el = vm.__patch__(prevVnode, vnode);
	    }
	    activeInstance = prevActiveInstance;
	    // update __vue__ reference
	    if (prevEl) {
	      prevEl.__vue__ = null;
	    }
	    if (vm.$el) {
	      vm.$el.__vue__ = vm;
	    }
	    // if parent is an HOC, update its $el as well
	    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
	      vm.$parent.$el = vm.$el;
	    }
	    if (vm._isMounted) {
	      callHook(vm, 'updated');
	    }
	  };
	
	  Vue.prototype._updateFromParent = function (
	    propsData,
	    listeners,
	    parentVnode,
	    renderChildren
	  ) {
	    var vm = this;
	    var hasChildren = !!(vm.$options._renderChildren || renderChildren);
	    vm.$options._parentVnode = parentVnode;
	    vm.$vnode = parentVnode; // update vm's placeholder node without re-render
	    if (vm._vnode) { // update child tree's parent
	      vm._vnode.parent = parentVnode;
	    }
	    vm.$options._renderChildren = renderChildren;
	    // update props
	    if (propsData && vm.$options.props) {
	      observerState.shouldConvert = false;
	      {
	        observerState.isSettingProps = true;
	      }
	      var propKeys = vm.$options._propKeys || [];
	      for (var i = 0; i < propKeys.length; i++) {
	        var key = propKeys[i];
	        vm[key] = validateProp(key, vm.$options.props, propsData, vm);
	      }
	      observerState.shouldConvert = true;
	      {
	        observerState.isSettingProps = false;
	      }
	      vm.$options.propsData = propsData;
	    }
	    // update listeners
	    if (listeners) {
	      var oldListeners = vm.$options._parentListeners;
	      vm.$options._parentListeners = listeners;
	      updateComponentListeners(vm, listeners, oldListeners);
	    }
	    // resolve slots + force update if has children
	    if (hasChildren) {
	      vm.$slots = resolveSlots(renderChildren, parentVnode.context);
	      vm.$forceUpdate();
	    }
	  };
	
	  Vue.prototype.$forceUpdate = function () {
	    var vm = this;
	    if (vm._watcher) {
	      vm._watcher.update();
	    }
	  };
	
	  Vue.prototype.$destroy = function () {
	    var vm = this;
	    if (vm._isBeingDestroyed) {
	      return
	    }
	    callHook(vm, 'beforeDestroy');
	    vm._isBeingDestroyed = true;
	    // remove self from parent
	    var parent = vm.$parent;
	    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
	      remove$1(parent.$children, vm);
	    }
	    // teardown watchers
	    if (vm._watcher) {
	      vm._watcher.teardown();
	    }
	    var i = vm._watchers.length;
	    while (i--) {
	      vm._watchers[i].teardown();
	    }
	    // remove reference from data ob
	    // frozen object may not have observer.
	    if (vm._data.__ob__) {
	      vm._data.__ob__.vmCount--;
	    }
	    // call the last hook...
	    vm._isDestroyed = true;
	    callHook(vm, 'destroyed');
	    // turn off all instance listeners.
	    vm.$off();
	    // remove __vue__ reference
	    if (vm.$el) {
	      vm.$el.__vue__ = null;
	    }
	    // invoke destroy hooks on current rendered tree
	    vm.__patch__(vm._vnode, null);
	  };
	}
	
	function callHook (vm, hook) {
	  var handlers = vm.$options[hook];
	  if (handlers) {
	    for (var i = 0, j = handlers.length; i < j; i++) {
	      handlers[i].call(vm);
	    }
	  }
	  if (vm._hasHookEvent) {
	    vm.$emit('hook:' + hook);
	  }
	}
	
	/*  */
	
	var hooks = { init: init, prepatch: prepatch, insert: insert, destroy: destroy$1 };
	var hooksToMerge = Object.keys(hooks);
	
	function createComponent (
	  Ctor,
	  data,
	  context,
	  children,
	  tag
	) {
	  if (!Ctor) {
	    return
	  }
	
	  var baseCtor = context.$options._base;
	  if (isObject(Ctor)) {
	    Ctor = baseCtor.extend(Ctor);
	  }
	
	  if (typeof Ctor !== 'function') {
	    {
	      warn(("Invalid Component definition: " + (String(Ctor))), context);
	    }
	    return
	  }
	
	  // async component
	  if (!Ctor.cid) {
	    if (Ctor.resolved) {
	      Ctor = Ctor.resolved;
	    } else {
	      Ctor = resolveAsyncComponent(Ctor, baseCtor, function () {
	        // it's ok to queue this on every render because
	        // $forceUpdate is buffered by the scheduler.
	        context.$forceUpdate();
	      });
	      if (!Ctor) {
	        // return nothing if this is indeed an async component
	        // wait for the callback to trigger parent update.
	        return
	      }
	    }
	  }
	
	  // resolve constructor options in case global mixins are applied after
	  // component constructor creation
	  resolveConstructorOptions(Ctor);
	
	  data = data || {};
	
	  // extract props
	  var propsData = extractProps(data, Ctor);
	
	  // functional component
	  if (Ctor.options.functional) {
	    return createFunctionalComponent(Ctor, propsData, data, context, children)
	  }
	
	  // extract listeners, since these needs to be treated as
	  // child component listeners instead of DOM listeners
	  var listeners = data.on;
	  // replace with listeners with .native modifier
	  data.on = data.nativeOn;
	
	  if (Ctor.options.abstract) {
	    // abstract components do not keep anything
	    // other than props & listeners
	    data = {};
	  }
	
	  // merge component management hooks onto the placeholder node
	  mergeHooks(data);
	
	  // return a placeholder vnode
	  var name = Ctor.options.name || tag;
	  var vnode = new VNode(
	    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
	    data, undefined, undefined, undefined, context,
	    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children }
	  );
	  return vnode
	}
	
	function createFunctionalComponent (
	  Ctor,
	  propsData,
	  data,
	  context,
	  children
	) {
	  var props = {};
	  var propOptions = Ctor.options.props;
	  if (propOptions) {
	    for (var key in propOptions) {
	      props[key] = validateProp(key, propOptions, propsData);
	    }
	  }
	  // ensure the createElement function in functional components
	  // gets a unique context - this is necessary for correct named slot check
	  var _context = Object.create(context);
	  var h = function (a, b, c, d) { return createElement(_context, a, b, c, d, true); };
	  var vnode = Ctor.options.render.call(null, h, {
	    props: props,
	    data: data,
	    parent: context,
	    children: children,
	    slots: function () { return resolveSlots(children, context); }
	  });
	  if (vnode instanceof VNode) {
	    vnode.functionalContext = context;
	    if (data.slot) {
	      (vnode.data || (vnode.data = {})).slot = data.slot;
	    }
	  }
	  return vnode
	}
	
	function createComponentInstanceForVnode (
	  vnode, // we know it's MountedComponentVNode but flow doesn't
	  parent, // activeInstance in lifecycle state
	  parentElm,
	  refElm
	) {
	  var vnodeComponentOptions = vnode.componentOptions;
	  var options = {
	    _isComponent: true,
	    parent: parent,
	    propsData: vnodeComponentOptions.propsData,
	    _componentTag: vnodeComponentOptions.tag,
	    _parentVnode: vnode,
	    _parentListeners: vnodeComponentOptions.listeners,
	    _renderChildren: vnodeComponentOptions.children,
	    _parentElm: parentElm || null,
	    _refElm: refElm || null
	  };
	  // check inline-template render functions
	  var inlineTemplate = vnode.data.inlineTemplate;
	  if (inlineTemplate) {
	    options.render = inlineTemplate.render;
	    options.staticRenderFns = inlineTemplate.staticRenderFns;
	  }
	  return new vnodeComponentOptions.Ctor(options)
	}
	
	function init (
	  vnode,
	  hydrating,
	  parentElm,
	  refElm
	) {
	  if (!vnode.child || vnode.child._isDestroyed) {
	    var child = vnode.child = createComponentInstanceForVnode(
	      vnode,
	      activeInstance,
	      parentElm,
	      refElm
	    );
	    child.$mount(hydrating ? vnode.elm : undefined, hydrating);
	  } else if (vnode.data.keepAlive) {
	    // kept-alive components, treat as a patch
	    var mountedNode = vnode; // work around flow
	    prepatch(mountedNode, mountedNode);
	  }
	}
	
	function prepatch (
	  oldVnode,
	  vnode
	) {
	  var options = vnode.componentOptions;
	  var child = vnode.child = oldVnode.child;
	  child._updateFromParent(
	    options.propsData, // updated props
	    options.listeners, // updated listeners
	    vnode, // new parent vnode
	    options.children // new children
	  );
	}
	
	function insert (vnode) {
	  if (!vnode.child._isMounted) {
	    vnode.child._isMounted = true;
	    callHook(vnode.child, 'mounted');
	  }
	  if (vnode.data.keepAlive) {
	    vnode.child._inactive = false;
	    callHook(vnode.child, 'activated');
	  }
	}
	
	function destroy$1 (vnode) {
	  if (!vnode.child._isDestroyed) {
	    if (!vnode.data.keepAlive) {
	      vnode.child.$destroy();
	    } else {
	      vnode.child._inactive = true;
	      callHook(vnode.child, 'deactivated');
	    }
	  }
	}
	
	function resolveAsyncComponent (
	  factory,
	  baseCtor,
	  cb
	) {
	  if (factory.requested) {
	    // pool callbacks
	    factory.pendingCallbacks.push(cb);
	  } else {
	    factory.requested = true;
	    var cbs = factory.pendingCallbacks = [cb];
	    var sync = true;
	
	    var resolve = function (res) {
	      if (isObject(res)) {
	        res = baseCtor.extend(res);
	      }
	      // cache resolved
	      factory.resolved = res;
	      // invoke callbacks only if this is not a synchronous resolve
	      // (async resolves are shimmed as synchronous during SSR)
	      if (!sync) {
	        for (var i = 0, l = cbs.length; i < l; i++) {
	          cbs[i](res);
	        }
	      }
	    };
	
	    var reject = function (reason) {
	      "development" !== 'production' && warn(
	        "Failed to resolve async component: " + (String(factory)) +
	        (reason ? ("\nReason: " + reason) : '')
	      );
	    };
	
	    var res = factory(resolve, reject);
	
	    // handle promise
	    if (res && typeof res.then === 'function' && !factory.resolved) {
	      res.then(resolve, reject);
	    }
	
	    sync = false;
	    // return in case resolved synchronously
	    return factory.resolved
	  }
	}
	
	function extractProps (data, Ctor) {
	  // we are only extracting raw values here.
	  // validation and default values are handled in the child
	  // component itself.
	  var propOptions = Ctor.options.props;
	  if (!propOptions) {
	    return
	  }
	  var res = {};
	  var attrs = data.attrs;
	  var props = data.props;
	  var domProps = data.domProps;
	  if (attrs || props || domProps) {
	    for (var key in propOptions) {
	      var altKey = hyphenate(key);
	      checkProp(res, props, key, altKey, true) ||
	      checkProp(res, attrs, key, altKey) ||
	      checkProp(res, domProps, key, altKey);
	    }
	  }
	  return res
	}
	
	function checkProp (
	  res,
	  hash,
	  key,
	  altKey,
	  preserve
	) {
	  if (hash) {
	    if (hasOwn(hash, key)) {
	      res[key] = hash[key];
	      if (!preserve) {
	        delete hash[key];
	      }
	      return true
	    } else if (hasOwn(hash, altKey)) {
	      res[key] = hash[altKey];
	      if (!preserve) {
	        delete hash[altKey];
	      }
	      return true
	    }
	  }
	  return false
	}
	
	function mergeHooks (data) {
	  if (!data.hook) {
	    data.hook = {};
	  }
	  for (var i = 0; i < hooksToMerge.length; i++) {
	    var key = hooksToMerge[i];
	    var fromParent = data.hook[key];
	    var ours = hooks[key];
	    data.hook[key] = fromParent ? mergeHook$1(ours, fromParent) : ours;
	  }
	}
	
	function mergeHook$1 (one, two) {
	  return function (a, b, c, d) {
	    one(a, b, c, d);
	    two(a, b, c, d);
	  }
	}
	
	/*  */
	
	var SIMPLE_NORMALIZE = 1;
	var ALWAYS_NORMALIZE = 2;
	
	// wrapper function for providing a more flexible interface
	// without getting yelled at by flow
	function createElement (
	  context,
	  tag,
	  data,
	  children,
	  normalizationType,
	  alwaysNormalize
	) {
	  if (Array.isArray(data) || isPrimitive(data)) {
	    normalizationType = children;
	    children = data;
	    data = undefined;
	  }
	  if (alwaysNormalize) { normalizationType = ALWAYS_NORMALIZE; }
	  return _createElement(context, tag, data, children, normalizationType)
	}
	
	function _createElement (
	  context,
	  tag,
	  data,
	  children,
	  normalizationType
	) {
	  if (data && data.__ob__) {
	    "development" !== 'production' && warn(
	      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
	      'Always create fresh vnode data objects in each render!',
	      context
	    );
	    return createEmptyVNode()
	  }
	  if (!tag) {
	    // in case of component :is set to falsy value
	    return createEmptyVNode()
	  }
	  // support single function children as default scoped slot
	  if (Array.isArray(children) &&
	      typeof children[0] === 'function') {
	    data = data || {};
	    data.scopedSlots = { default: children[0] };
	    children.length = 0;
	  }
	  if (normalizationType === ALWAYS_NORMALIZE) {
	    children = normalizeChildren(children);
	  } else if (normalizationType === SIMPLE_NORMALIZE) {
	    children = simpleNormalizeChildren(children);
	  }
	  var vnode, ns;
	  if (typeof tag === 'string') {
	    var Ctor;
	    ns = config.getTagNamespace(tag);
	    if (config.isReservedTag(tag)) {
	      // platform built-in elements
	      vnode = new VNode(
	        config.parsePlatformTagName(tag), data, children,
	        undefined, undefined, context
	      );
	    } else if ((Ctor = resolveAsset(context.$options, 'components', tag))) {
	      // component
	      vnode = createComponent(Ctor, data, context, children, tag);
	    } else {
	      // unknown or unlisted namespaced elements
	      // check at runtime because it may get assigned a namespace when its
	      // parent normalizes children
	      vnode = new VNode(
	        tag, data, children,
	        undefined, undefined, context
	      );
	    }
	  } else {
	    // direct component options / constructor
	    vnode = createComponent(tag, data, context, children);
	  }
	  if (vnode) {
	    if (ns) { applyNS(vnode, ns); }
	    return vnode
	  } else {
	    return createEmptyVNode()
	  }
	}
	
	function applyNS (vnode, ns) {
	  vnode.ns = ns;
	  if (vnode.tag === 'foreignObject') {
	    // use default namespace inside foreignObject
	    return
	  }
	  if (vnode.children) {
	    for (var i = 0, l = vnode.children.length; i < l; i++) {
	      var child = vnode.children[i];
	      if (child.tag && !child.ns) {
	        applyNS(child, ns);
	      }
	    }
	  }
	}
	
	/*  */
	
	function initRender (vm) {
	  vm.$vnode = null; // the placeholder node in parent tree
	  vm._vnode = null; // the root of the child tree
	  vm._staticTrees = null;
	  var parentVnode = vm.$options._parentVnode;
	  var renderContext = parentVnode && parentVnode.context;
	  vm.$slots = resolveSlots(vm.$options._renderChildren, renderContext);
	  vm.$scopedSlots = {};
	  // bind the createElement fn to this instance
	  // so that we get proper render context inside it.
	  // args order: tag, data, children, normalizationType, alwaysNormalize
	  // internal version is used by render functions compiled from templates
	  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
	  // normalization is always applied for the public version, used in
	  // user-written render functions.
	  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };
	  if (vm.$options.el) {
	    vm.$mount(vm.$options.el);
	  }
	}
	
	function renderMixin (Vue) {
	  Vue.prototype.$nextTick = function (fn) {
	    return nextTick(fn, this)
	  };
	
	  Vue.prototype._render = function () {
	    var vm = this;
	    var ref = vm.$options;
	    var render = ref.render;
	    var staticRenderFns = ref.staticRenderFns;
	    var _parentVnode = ref._parentVnode;
	
	    if (vm._isMounted) {
	      // clone slot nodes on re-renders
	      for (var key in vm.$slots) {
	        vm.$slots[key] = cloneVNodes(vm.$slots[key]);
	      }
	    }
	
	    if (_parentVnode && _parentVnode.data.scopedSlots) {
	      vm.$scopedSlots = _parentVnode.data.scopedSlots;
	    }
	
	    if (staticRenderFns && !vm._staticTrees) {
	      vm._staticTrees = [];
	    }
	    // set parent vnode. this allows render functions to have access
	    // to the data on the placeholder node.
	    vm.$vnode = _parentVnode;
	    // render self
	    var vnode;
	    try {
	      vnode = render.call(vm._renderProxy, vm.$createElement);
	    } catch (e) {
	      /* istanbul ignore else */
	      if (config.errorHandler) {
	        config.errorHandler.call(null, e, vm);
	      } else {
	        {
	          warn(("Error when rendering " + (formatComponentName(vm)) + ":"));
	        }
	        throw e
	      }
	      // return previous vnode to prevent render error causing blank component
	      vnode = vm._vnode;
	    }
	    // return empty vnode in case the render function errored out
	    if (!(vnode instanceof VNode)) {
	      if ("development" !== 'production' && Array.isArray(vnode)) {
	        warn(
	          'Multiple root nodes returned from render function. Render function ' +
	          'should return a single root node.',
	          vm
	        );
	      }
	      vnode = createEmptyVNode();
	    }
	    // set parent
	    vnode.parent = _parentVnode;
	    return vnode
	  };
	
	  // toString for mustaches
	  Vue.prototype._s = _toString;
	  // convert text to vnode
	  Vue.prototype._v = createTextVNode;
	  // number conversion
	  Vue.prototype._n = toNumber;
	  // empty vnode
	  Vue.prototype._e = createEmptyVNode;
	  // loose equal
	  Vue.prototype._q = looseEqual;
	  // loose indexOf
	  Vue.prototype._i = looseIndexOf;
	
	  // render static tree by index
	  Vue.prototype._m = function renderStatic (
	    index,
	    isInFor
	  ) {
	    var tree = this._staticTrees[index];
	    // if has already-rendered static tree and not inside v-for,
	    // we can reuse the same tree by doing a shallow clone.
	    if (tree && !isInFor) {
	      return Array.isArray(tree)
	        ? cloneVNodes(tree)
	        : cloneVNode(tree)
	    }
	    // otherwise, render a fresh tree.
	    tree = this._staticTrees[index] = this.$options.staticRenderFns[index].call(this._renderProxy);
	    markStatic(tree, ("__static__" + index), false);
	    return tree
	  };
	
	  // mark node as static (v-once)
	  Vue.prototype._o = function markOnce (
	    tree,
	    index,
	    key
	  ) {
	    markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
	    return tree
	  };
	
	  function markStatic (tree, key, isOnce) {
	    if (Array.isArray(tree)) {
	      for (var i = 0; i < tree.length; i++) {
	        if (tree[i] && typeof tree[i] !== 'string') {
	          markStaticNode(tree[i], (key + "_" + i), isOnce);
	        }
	      }
	    } else {
	      markStaticNode(tree, key, isOnce);
	    }
	  }
	
	  function markStaticNode (node, key, isOnce) {
	    node.isStatic = true;
	    node.key = key;
	    node.isOnce = isOnce;
	  }
	
	  // filter resolution helper
	  Vue.prototype._f = function resolveFilter (id) {
	    return resolveAsset(this.$options, 'filters', id, true) || identity
	  };
	
	  // render v-for
	  Vue.prototype._l = function renderList (
	    val,
	    render
	  ) {
	    var ret, i, l, keys, key;
	    if (Array.isArray(val) || typeof val === 'string') {
	      ret = new Array(val.length);
	      for (i = 0, l = val.length; i < l; i++) {
	        ret[i] = render(val[i], i);
	      }
	    } else if (typeof val === 'number') {
	      ret = new Array(val);
	      for (i = 0; i < val; i++) {
	        ret[i] = render(i + 1, i);
	      }
	    } else if (isObject(val)) {
	      keys = Object.keys(val);
	      ret = new Array(keys.length);
	      for (i = 0, l = keys.length; i < l; i++) {
	        key = keys[i];
	        ret[i] = render(val[key], key, i);
	      }
	    }
	    return ret
	  };
	
	  // renderSlot
	  Vue.prototype._t = function (
	    name,
	    fallback,
	    props,
	    bindObject
	  ) {
	    var scopedSlotFn = this.$scopedSlots[name];
	    if (scopedSlotFn) { // scoped slot
	      props = props || {};
	      if (bindObject) {
	        extend(props, bindObject);
	      }
	      return scopedSlotFn(props) || fallback
	    } else {
	      var slotNodes = this.$slots[name];
	      // warn duplicate slot usage
	      if (slotNodes && "development" !== 'production') {
	        slotNodes._rendered && warn(
	          "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
	          "- this will likely cause render errors.",
	          this
	        );
	        slotNodes._rendered = true;
	      }
	      return slotNodes || fallback
	    }
	  };
	
	  // apply v-bind object
	  Vue.prototype._b = function bindProps (
	    data,
	    tag,
	    value,
	    asProp
	  ) {
	    if (value) {
	      if (!isObject(value)) {
	        "development" !== 'production' && warn(
	          'v-bind without argument expects an Object or Array value',
	          this
	        );
	      } else {
	        if (Array.isArray(value)) {
	          value = toObject(value);
	        }
	        for (var key in value) {
	          if (key === 'class' || key === 'style') {
	            data[key] = value[key];
	          } else {
	            var hash = asProp || config.mustUseProp(tag, key)
	              ? data.domProps || (data.domProps = {})
	              : data.attrs || (data.attrs = {});
	            hash[key] = value[key];
	          }
	        }
	      }
	    }
	    return data
	  };
	
	  // check v-on keyCodes
	  Vue.prototype._k = function checkKeyCodes (
	    eventKeyCode,
	    key,
	    builtInAlias
	  ) {
	    var keyCodes = config.keyCodes[key] || builtInAlias;
	    if (Array.isArray(keyCodes)) {
	      return keyCodes.indexOf(eventKeyCode) === -1
	    } else {
	      return keyCodes !== eventKeyCode
	    }
	  };
	}
	
	function resolveSlots (
	  children,
	  context
	) {
	  var slots = {};
	  if (!children) {
	    return slots
	  }
	  var defaultSlot = [];
	  var name, child;
	  for (var i = 0, l = children.length; i < l; i++) {
	    child = children[i];
	    // named slots should only be respected if the vnode was rendered in the
	    // same context.
	    if ((child.context === context || child.functionalContext === context) &&
	        child.data && (name = child.data.slot)) {
	      var slot = (slots[name] || (slots[name] = []));
	      if (child.tag === 'template') {
	        slot.push.apply(slot, child.children);
	      } else {
	        slot.push(child);
	      }
	    } else {
	      defaultSlot.push(child);
	    }
	  }
	  // ignore single whitespace
	  if (defaultSlot.length && !(
	    defaultSlot.length === 1 &&
	    (defaultSlot[0].text === ' ' || defaultSlot[0].isComment)
	  )) {
	    slots.default = defaultSlot;
	  }
	  return slots
	}
	
	/*  */
	
	var uid = 0;
	
	function initMixin (Vue) {
	  Vue.prototype._init = function (options) {
	    var vm = this;
	    // a uid
	    vm._uid = uid++;
	    // a flag to avoid this being observed
	    vm._isVue = true;
	    // merge options
	    if (options && options._isComponent) {
	      // optimize internal component instantiation
	      // since dynamic options merging is pretty slow, and none of the
	      // internal component options needs special treatment.
	      initInternalComponent(vm, options);
	    } else {
	      vm.$options = mergeOptions(
	        resolveConstructorOptions(vm.constructor),
	        options || {},
	        vm
	      );
	    }
	    /* istanbul ignore else */
	    {
	      initProxy(vm);
	    }
	    // expose real self
	    vm._self = vm;
	    initLifecycle(vm);
	    initEvents(vm);
	    callHook(vm, 'beforeCreate');
	    initState(vm);
	    callHook(vm, 'created');
	    initRender(vm);
	  };
	}
	
	function initInternalComponent (vm, options) {
	  var opts = vm.$options = Object.create(vm.constructor.options);
	  // doing this because it's faster than dynamic enumeration.
	  opts.parent = options.parent;
	  opts.propsData = options.propsData;
	  opts._parentVnode = options._parentVnode;
	  opts._parentListeners = options._parentListeners;
	  opts._renderChildren = options._renderChildren;
	  opts._componentTag = options._componentTag;
	  opts._parentElm = options._parentElm;
	  opts._refElm = options._refElm;
	  if (options.render) {
	    opts.render = options.render;
	    opts.staticRenderFns = options.staticRenderFns;
	  }
	}
	
	function resolveConstructorOptions (Ctor) {
	  var options = Ctor.options;
	  if (Ctor.super) {
	    var superOptions = Ctor.super.options;
	    var cachedSuperOptions = Ctor.superOptions;
	    var extendOptions = Ctor.extendOptions;
	    if (superOptions !== cachedSuperOptions) {
	      // super option changed
	      Ctor.superOptions = superOptions;
	      extendOptions.render = options.render;
	      extendOptions.staticRenderFns = options.staticRenderFns;
	      extendOptions._scopeId = options._scopeId;
	      options = Ctor.options = mergeOptions(superOptions, extendOptions);
	      if (options.name) {
	        options.components[options.name] = Ctor;
	      }
	    }
	  }
	  return options
	}
	
	function Vue$3 (options) {
	  if ("development" !== 'production' &&
	    !(this instanceof Vue$3)) {
	    warn('Vue is a constructor and should be called with the `new` keyword');
	  }
	  this._init(options);
	}
	
	initMixin(Vue$3);
	stateMixin(Vue$3);
	eventsMixin(Vue$3);
	lifecycleMixin(Vue$3);
	renderMixin(Vue$3);
	
	/*  */
	
	function initUse (Vue) {
	  Vue.use = function (plugin) {
	    /* istanbul ignore if */
	    if (plugin.installed) {
	      return
	    }
	    // additional parameters
	    var args = toArray(arguments, 1);
	    args.unshift(this);
	    if (typeof plugin.install === 'function') {
	      plugin.install.apply(plugin, args);
	    } else {
	      plugin.apply(null, args);
	    }
	    plugin.installed = true;
	    return this
	  };
	}
	
	/*  */
	
	function initMixin$1 (Vue) {
	  Vue.mixin = function (mixin) {
	    this.options = mergeOptions(this.options, mixin);
	  };
	}
	
	/*  */
	
	function initExtend (Vue) {
	  /**
	   * Each instance constructor, including Vue, has a unique
	   * cid. This enables us to create wrapped "child
	   * constructors" for prototypal inheritance and cache them.
	   */
	  Vue.cid = 0;
	  var cid = 1;
	
	  /**
	   * Class inheritance
	   */
	  Vue.extend = function (extendOptions) {
	    extendOptions = extendOptions || {};
	    var Super = this;
	    var SuperId = Super.cid;
	    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
	    if (cachedCtors[SuperId]) {
	      return cachedCtors[SuperId]
	    }
	    var name = extendOptions.name || Super.options.name;
	    {
	      if (!/^[a-zA-Z][\w-]*$/.test(name)) {
	        warn(
	          'Invalid component name: "' + name + '". Component names ' +
	          'can only contain alphanumeric characters and the hyphen, ' +
	          'and must start with a letter.'
	        );
	      }
	    }
	    var Sub = function VueComponent (options) {
	      this._init(options);
	    };
	    Sub.prototype = Object.create(Super.prototype);
	    Sub.prototype.constructor = Sub;
	    Sub.cid = cid++;
	    Sub.options = mergeOptions(
	      Super.options,
	      extendOptions
	    );
	    Sub['super'] = Super;
	    // allow further extension/mixin/plugin usage
	    Sub.extend = Super.extend;
	    Sub.mixin = Super.mixin;
	    Sub.use = Super.use;
	    // create asset registers, so extended classes
	    // can have their private assets too.
	    config._assetTypes.forEach(function (type) {
	      Sub[type] = Super[type];
	    });
	    // enable recursive self-lookup
	    if (name) {
	      Sub.options.components[name] = Sub;
	    }
	    // keep a reference to the super options at extension time.
	    // later at instantiation we can check if Super's options have
	    // been updated.
	    Sub.superOptions = Super.options;
	    Sub.extendOptions = extendOptions;
	    // cache constructor
	    cachedCtors[SuperId] = Sub;
	    return Sub
	  };
	}
	
	/*  */
	
	function initAssetRegisters (Vue) {
	  /**
	   * Create asset registration methods.
	   */
	  config._assetTypes.forEach(function (type) {
	    Vue[type] = function (
	      id,
	      definition
	    ) {
	      if (!definition) {
	        return this.options[type + 's'][id]
	      } else {
	        /* istanbul ignore if */
	        {
	          if (type === 'component' && config.isReservedTag(id)) {
	            warn(
	              'Do not use built-in or reserved HTML elements as component ' +
	              'id: ' + id
	            );
	          }
	        }
	        if (type === 'component' && isPlainObject(definition)) {
	          definition.name = definition.name || id;
	          definition = this.options._base.extend(definition);
	        }
	        if (type === 'directive' && typeof definition === 'function') {
	          definition = { bind: definition, update: definition };
	        }
	        this.options[type + 's'][id] = definition;
	        return definition
	      }
	    };
	  });
	}
	
	/*  */
	
	var patternTypes = [String, RegExp];
	
	function matches (pattern, name) {
	  if (typeof pattern === 'string') {
	    return pattern.split(',').indexOf(name) > -1
	  } else {
	    return pattern.test(name)
	  }
	}
	
	var KeepAlive = {
	  name: 'keep-alive',
	  abstract: true,
	  props: {
	    include: patternTypes,
	    exclude: patternTypes
	  },
	  created: function created () {
	    this.cache = Object.create(null);
	  },
	  render: function render () {
	    var vnode = getFirstComponentChild(this.$slots.default);
	    if (vnode && vnode.componentOptions) {
	      var opts = vnode.componentOptions;
	      // check pattern
	      var name = opts.Ctor.options.name || opts.tag;
	      if (name && (
	        (this.include && !matches(this.include, name)) ||
	        (this.exclude && matches(this.exclude, name))
	      )) {
	        return vnode
	      }
	      var key = vnode.key == null
	        // same constructor may get registered as different local components
	        // so cid alone is not enough (#3269)
	        ? opts.Ctor.cid + (opts.tag ? ("::" + (opts.tag)) : '')
	        : vnode.key;
	      if (this.cache[key]) {
	        vnode.child = this.cache[key].child;
	      } else {
	        this.cache[key] = vnode;
	      }
	      vnode.data.keepAlive = true;
	    }
	    return vnode
	  },
	  destroyed: function destroyed () {
	    var this$1 = this;
	
	    for (var key in this.cache) {
	      var vnode = this$1.cache[key];
	      callHook(vnode.child, 'deactivated');
	      vnode.child.$destroy();
	    }
	  }
	};
	
	var builtInComponents = {
	  KeepAlive: KeepAlive
	};
	
	/*  */
	
	function initGlobalAPI (Vue) {
	  // config
	  var configDef = {};
	  configDef.get = function () { return config; };
	  {
	    configDef.set = function () {
	      warn(
	        'Do not replace the Vue.config object, set individual fields instead.'
	      );
	    };
	  }
	  Object.defineProperty(Vue, 'config', configDef);
	  Vue.util = util;
	  Vue.set = set$1;
	  Vue.delete = del;
	  Vue.nextTick = nextTick;
	
	  Vue.options = Object.create(null);
	  config._assetTypes.forEach(function (type) {
	    Vue.options[type + 's'] = Object.create(null);
	  });
	
	  // this is used to identify the "base" constructor to extend all plain-object
	  // components with in Weex's multi-instance scenarios.
	  Vue.options._base = Vue;
	
	  extend(Vue.options.components, builtInComponents);
	
	  initUse(Vue);
	  initMixin$1(Vue);
	  initExtend(Vue);
	  initAssetRegisters(Vue);
	}
	
	initGlobalAPI(Vue$3);
	
	Object.defineProperty(Vue$3.prototype, '$isServer', {
	  get: isServerRendering
	});
	
	Vue$3.version = '2.1.8';
	
	/*  */
	
	// attributes that should be using props for binding
	var acceptValue = makeMap('input,textarea,option,select');
	var mustUseProp = function (tag, attr) {
	  return (
	    (attr === 'value' && acceptValue(tag)) ||
	    (attr === 'selected' && tag === 'option') ||
	    (attr === 'checked' && tag === 'input') ||
	    (attr === 'muted' && tag === 'video')
	  )
	};
	
	var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');
	
	var isBooleanAttr = makeMap(
	  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
	  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
	  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
	  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
	  'required,reversed,scoped,seamless,selected,sortable,translate,' +
	  'truespeed,typemustmatch,visible'
	);
	
	var xlinkNS = 'http://www.w3.org/1999/xlink';
	
	var isXlink = function (name) {
	  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
	};
	
	var getXlinkProp = function (name) {
	  return isXlink(name) ? name.slice(6, name.length) : ''
	};
	
	var isFalsyAttrValue = function (val) {
	  return val == null || val === false
	};
	
	/*  */
	
	function genClassForVnode (vnode) {
	  var data = vnode.data;
	  var parentNode = vnode;
	  var childNode = vnode;
	  while (childNode.child) {
	    childNode = childNode.child._vnode;
	    if (childNode.data) {
	      data = mergeClassData(childNode.data, data);
	    }
	  }
	  while ((parentNode = parentNode.parent)) {
	    if (parentNode.data) {
	      data = mergeClassData(data, parentNode.data);
	    }
	  }
	  return genClassFromData(data)
	}
	
	function mergeClassData (child, parent) {
	  return {
	    staticClass: concat(child.staticClass, parent.staticClass),
	    class: child.class
	      ? [child.class, parent.class]
	      : parent.class
	  }
	}
	
	function genClassFromData (data) {
	  var dynamicClass = data.class;
	  var staticClass = data.staticClass;
	  if (staticClass || dynamicClass) {
	    return concat(staticClass, stringifyClass(dynamicClass))
	  }
	  /* istanbul ignore next */
	  return ''
	}
	
	function concat (a, b) {
	  return a ? b ? (a + ' ' + b) : a : (b || '')
	}
	
	function stringifyClass (value) {
	  var res = '';
	  if (!value) {
	    return res
	  }
	  if (typeof value === 'string') {
	    return value
	  }
	  if (Array.isArray(value)) {
	    var stringified;
	    for (var i = 0, l = value.length; i < l; i++) {
	      if (value[i]) {
	        if ((stringified = stringifyClass(value[i]))) {
	          res += stringified + ' ';
	        }
	      }
	    }
	    return res.slice(0, -1)
	  }
	  if (isObject(value)) {
	    for (var key in value) {
	      if (value[key]) { res += key + ' '; }
	    }
	    return res.slice(0, -1)
	  }
	  /* istanbul ignore next */
	  return res
	}
	
	/*  */
	
	var namespaceMap = {
	  svg: 'http://www.w3.org/2000/svg',
	  math: 'http://www.w3.org/1998/Math/MathML'
	};
	
	var isHTMLTag = makeMap(
	  'html,body,base,head,link,meta,style,title,' +
	  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
	  'div,dd,dl,dt,figcaption,figure,hr,img,li,main,ol,p,pre,ul,' +
	  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
	  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
	  'embed,object,param,source,canvas,script,noscript,del,ins,' +
	  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
	  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
	  'output,progress,select,textarea,' +
	  'details,dialog,menu,menuitem,summary,' +
	  'content,element,shadow,template'
	);
	
	// this map is intentionally selective, only covering SVG elements that may
	// contain child elements.
	var isSVG = makeMap(
	  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,' +
	  'font-face,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
	  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
	  true
	);
	
	var isPreTag = function (tag) { return tag === 'pre'; };
	
	var isReservedTag = function (tag) {
	  return isHTMLTag(tag) || isSVG(tag)
	};
	
	function getTagNamespace (tag) {
	  if (isSVG(tag)) {
	    return 'svg'
	  }
	  // basic support for MathML
	  // note it doesn't support other MathML elements being component roots
	  if (tag === 'math') {
	    return 'math'
	  }
	}
	
	var unknownElementCache = Object.create(null);
	function isUnknownElement (tag) {
	  /* istanbul ignore if */
	  if (!inBrowser) {
	    return true
	  }
	  if (isReservedTag(tag)) {
	    return false
	  }
	  tag = tag.toLowerCase();
	  /* istanbul ignore if */
	  if (unknownElementCache[tag] != null) {
	    return unknownElementCache[tag]
	  }
	  var el = document.createElement(tag);
	  if (tag.indexOf('-') > -1) {
	    // http://stackoverflow.com/a/28210364/1070244
	    return (unknownElementCache[tag] = (
	      el.constructor === window.HTMLUnknownElement ||
	      el.constructor === window.HTMLElement
	    ))
	  } else {
	    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
	  }
	}
	
	/*  */
	
	/**
	 * Query an element selector if it's not an element already.
	 */
	function query (el) {
	  if (typeof el === 'string') {
	    var selector = el;
	    el = document.querySelector(el);
	    if (!el) {
	      "development" !== 'production' && warn(
	        'Cannot find element: ' + selector
	      );
	      return document.createElement('div')
	    }
	  }
	  return el
	}
	
	/*  */
	
	function createElement$1 (tagName, vnode) {
	  var elm = document.createElement(tagName);
	  if (tagName !== 'select') {
	    return elm
	  }
	  if (vnode.data && vnode.data.attrs && 'multiple' in vnode.data.attrs) {
	    elm.setAttribute('multiple', 'multiple');
	  }
	  return elm
	}
	
	function createElementNS (namespace, tagName) {
	  return document.createElementNS(namespaceMap[namespace], tagName)
	}
	
	function createTextNode (text) {
	  return document.createTextNode(text)
	}
	
	function createComment (text) {
	  return document.createComment(text)
	}
	
	function insertBefore (parentNode, newNode, referenceNode) {
	  parentNode.insertBefore(newNode, referenceNode);
	}
	
	function removeChild (node, child) {
	  node.removeChild(child);
	}
	
	function appendChild (node, child) {
	  node.appendChild(child);
	}
	
	function parentNode (node) {
	  return node.parentNode
	}
	
	function nextSibling (node) {
	  return node.nextSibling
	}
	
	function tagName (node) {
	  return node.tagName
	}
	
	function setTextContent (node, text) {
	  node.textContent = text;
	}
	
	function setAttribute (node, key, val) {
	  node.setAttribute(key, val);
	}
	
	
	var nodeOps = Object.freeze({
		createElement: createElement$1,
		createElementNS: createElementNS,
		createTextNode: createTextNode,
		createComment: createComment,
		insertBefore: insertBefore,
		removeChild: removeChild,
		appendChild: appendChild,
		parentNode: parentNode,
		nextSibling: nextSibling,
		tagName: tagName,
		setTextContent: setTextContent,
		setAttribute: setAttribute
	});
	
	/*  */
	
	var ref = {
	  create: function create (_, vnode) {
	    registerRef(vnode);
	  },
	  update: function update (oldVnode, vnode) {
	    if (oldVnode.data.ref !== vnode.data.ref) {
	      registerRef(oldVnode, true);
	      registerRef(vnode);
	    }
	  },
	  destroy: function destroy (vnode) {
	    registerRef(vnode, true);
	  }
	};
	
	function registerRef (vnode, isRemoval) {
	  var key = vnode.data.ref;
	  if (!key) { return }
	
	  var vm = vnode.context;
	  var ref = vnode.child || vnode.elm;
	  var refs = vm.$refs;
	  if (isRemoval) {
	    if (Array.isArray(refs[key])) {
	      remove$1(refs[key], ref);
	    } else if (refs[key] === ref) {
	      refs[key] = undefined;
	    }
	  } else {
	    if (vnode.data.refInFor) {
	      if (Array.isArray(refs[key]) && refs[key].indexOf(ref) < 0) {
	        refs[key].push(ref);
	      } else {
	        refs[key] = [ref];
	      }
	    } else {
	      refs[key] = ref;
	    }
	  }
	}
	
	/**
	 * Virtual DOM patching algorithm based on Snabbdom by
	 * Simon Friis Vindum (@paldepind)
	 * Licensed under the MIT License
	 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
	 *
	 * modified by Evan You (@yyx990803)
	 *
	
	/*
	 * Not type-checking this because this file is perf-critical and the cost
	 * of making flow understand it is not worth it.
	 */
	
	var emptyNode = new VNode('', {}, []);
	
	var hooks$1 = ['create', 'activate', 'update', 'remove', 'destroy'];
	
	function isUndef (s) {
	  return s == null
	}
	
	function isDef (s) {
	  return s != null
	}
	
	function sameVnode (vnode1, vnode2) {
	  return (
	    vnode1.key === vnode2.key &&
	    vnode1.tag === vnode2.tag &&
	    vnode1.isComment === vnode2.isComment &&
	    !vnode1.data === !vnode2.data
	  )
	}
	
	function createKeyToOldIdx (children, beginIdx, endIdx) {
	  var i, key;
	  var map = {};
	  for (i = beginIdx; i <= endIdx; ++i) {
	    key = children[i].key;
	    if (isDef(key)) { map[key] = i; }
	  }
	  return map
	}
	
	function createPatchFunction (backend) {
	  var i, j;
	  var cbs = {};
	
	  var modules = backend.modules;
	  var nodeOps = backend.nodeOps;
	
	  for (i = 0; i < hooks$1.length; ++i) {
	    cbs[hooks$1[i]] = [];
	    for (j = 0; j < modules.length; ++j) {
	      if (modules[j][hooks$1[i]] !== undefined) { cbs[hooks$1[i]].push(modules[j][hooks$1[i]]); }
	    }
	  }
	
	  function emptyNodeAt (elm) {
	    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
	  }
	
	  function createRmCb (childElm, listeners) {
	    function remove$$1 () {
	      if (--remove$$1.listeners === 0) {
	        removeNode(childElm);
	      }
	    }
	    remove$$1.listeners = listeners;
	    return remove$$1
	  }
	
	  function removeNode (el) {
	    var parent = nodeOps.parentNode(el);
	    // element may have already been removed due to v-html / v-text
	    if (parent) {
	      nodeOps.removeChild(parent, el);
	    }
	  }
	
	  var inPre = 0;
	  function createElm (vnode, insertedVnodeQueue, parentElm, refElm, nested) {
	    vnode.isRootInsert = !nested; // for transition enter check
	    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
	      return
	    }
	
	    var data = vnode.data;
	    var children = vnode.children;
	    var tag = vnode.tag;
	    if (isDef(tag)) {
	      {
	        if (data && data.pre) {
	          inPre++;
	        }
	        if (
	          !inPre &&
	          !vnode.ns &&
	          !(config.ignoredElements.length && config.ignoredElements.indexOf(tag) > -1) &&
	          config.isUnknownElement(tag)
	        ) {
	          warn(
	            'Unknown custom element: <' + tag + '> - did you ' +
	            'register the component correctly? For recursive components, ' +
	            'make sure to provide the "name" option.',
	            vnode.context
	          );
	        }
	      }
	      vnode.elm = vnode.ns
	        ? nodeOps.createElementNS(vnode.ns, tag)
	        : nodeOps.createElement(tag, vnode);
	      setScope(vnode);
	
	      /* istanbul ignore if */
	      {
	        createChildren(vnode, children, insertedVnodeQueue);
	        if (isDef(data)) {
	          invokeCreateHooks(vnode, insertedVnodeQueue);
	        }
	        insert(parentElm, vnode.elm, refElm);
	      }
	
	      if ("development" !== 'production' && data && data.pre) {
	        inPre--;
	      }
	    } else if (vnode.isComment) {
	      vnode.elm = nodeOps.createComment(vnode.text);
	      insert(parentElm, vnode.elm, refElm);
	    } else {
	      vnode.elm = nodeOps.createTextNode(vnode.text);
	      insert(parentElm, vnode.elm, refElm);
	    }
	  }
	
	  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
	    var i = vnode.data;
	    if (isDef(i)) {
	      var isReactivated = isDef(vnode.child) && i.keepAlive;
	      if (isDef(i = i.hook) && isDef(i = i.init)) {
	        i(vnode, false /* hydrating */, parentElm, refElm);
	      }
	      // after calling the init hook, if the vnode is a child component
	      // it should've created a child instance and mounted it. the child
	      // component also has set the placeholder vnode's elm.
	      // in that case we can just return the element and be done.
	      if (isDef(vnode.child)) {
	        initComponent(vnode, insertedVnodeQueue);
	        if (isReactivated) {
	          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
	        }
	        return true
	      }
	    }
	  }
	
	  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
	    var i;
	    // hack for #4339: a reactivated component with inner transition
	    // does not trigger because the inner node's created hooks are not called
	    // again. It's not ideal to involve module-specific logic in here but
	    // there doesn't seem to be a better way to do it.
	    var innerNode = vnode;
	    while (innerNode.child) {
	      innerNode = innerNode.child._vnode;
	      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
	        for (i = 0; i < cbs.activate.length; ++i) {
	          cbs.activate[i](emptyNode, innerNode);
	        }
	        insertedVnodeQueue.push(innerNode);
	        break
	      }
	    }
	    // unlike a newly created component,
	    // a reactivated keep-alive component doesn't insert itself
	    insert(parentElm, vnode.elm, refElm);
	  }
	
	  function insert (parent, elm, ref) {
	    if (parent) {
	      if (ref) {
	        nodeOps.insertBefore(parent, elm, ref);
	      } else {
	        nodeOps.appendChild(parent, elm);
	      }
	    }
	  }
	
	  function createChildren (vnode, children, insertedVnodeQueue) {
	    if (Array.isArray(children)) {
	      for (var i = 0; i < children.length; ++i) {
	        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true);
	      }
	    } else if (isPrimitive(vnode.text)) {
	      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(vnode.text));
	    }
	  }
	
	  function isPatchable (vnode) {
	    while (vnode.child) {
	      vnode = vnode.child._vnode;
	    }
	    return isDef(vnode.tag)
	  }
	
	  function invokeCreateHooks (vnode, insertedVnodeQueue) {
	    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
	      cbs.create[i$1](emptyNode, vnode);
	    }
	    i = vnode.data.hook; // Reuse variable
	    if (isDef(i)) {
	      if (i.create) { i.create(emptyNode, vnode); }
	      if (i.insert) { insertedVnodeQueue.push(vnode); }
	    }
	  }
	
	  function initComponent (vnode, insertedVnodeQueue) {
	    if (vnode.data.pendingInsert) {
	      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
	    }
	    vnode.elm = vnode.child.$el;
	    if (isPatchable(vnode)) {
	      invokeCreateHooks(vnode, insertedVnodeQueue);
	      setScope(vnode);
	    } else {
	      // empty component root.
	      // skip all element-related modules except for ref (#3455)
	      registerRef(vnode);
	      // make sure to invoke the insert hook
	      insertedVnodeQueue.push(vnode);
	    }
	  }
	
	  // set scope id attribute for scoped CSS.
	  // this is implemented as a special case to avoid the overhead
	  // of going through the normal attribute patching process.
	  function setScope (vnode) {
	    var i;
	    if (isDef(i = vnode.context) && isDef(i = i.$options._scopeId)) {
	      nodeOps.setAttribute(vnode.elm, i, '');
	    }
	    if (isDef(i = activeInstance) &&
	        i !== vnode.context &&
	        isDef(i = i.$options._scopeId)) {
	      nodeOps.setAttribute(vnode.elm, i, '');
	    }
	  }
	
	  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
	    for (; startIdx <= endIdx; ++startIdx) {
	      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm);
	    }
	  }
	
	  function invokeDestroyHook (vnode) {
	    var i, j;
	    var data = vnode.data;
	    if (isDef(data)) {
	      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
	      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
	    }
	    if (isDef(i = vnode.children)) {
	      for (j = 0; j < vnode.children.length; ++j) {
	        invokeDestroyHook(vnode.children[j]);
	      }
	    }
	  }
	
	  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
	    for (; startIdx <= endIdx; ++startIdx) {
	      var ch = vnodes[startIdx];
	      if (isDef(ch)) {
	        if (isDef(ch.tag)) {
	          removeAndInvokeRemoveHook(ch);
	          invokeDestroyHook(ch);
	        } else { // Text node
	          removeNode(ch.elm);
	        }
	      }
	    }
	  }
	
	  function removeAndInvokeRemoveHook (vnode, rm) {
	    if (rm || isDef(vnode.data)) {
	      var listeners = cbs.remove.length + 1;
	      if (!rm) {
	        // directly removing
	        rm = createRmCb(vnode.elm, listeners);
	      } else {
	        // we have a recursively passed down rm callback
	        // increase the listeners count
	        rm.listeners += listeners;
	      }
	      // recursively invoke hooks on child component root node
	      if (isDef(i = vnode.child) && isDef(i = i._vnode) && isDef(i.data)) {
	        removeAndInvokeRemoveHook(i, rm);
	      }
	      for (i = 0; i < cbs.remove.length; ++i) {
	        cbs.remove[i](vnode, rm);
	      }
	      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
	        i(vnode, rm);
	      } else {
	        rm();
	      }
	    } else {
	      removeNode(vnode.elm);
	    }
	  }
	
	  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
	    var oldStartIdx = 0;
	    var newStartIdx = 0;
	    var oldEndIdx = oldCh.length - 1;
	    var oldStartVnode = oldCh[0];
	    var oldEndVnode = oldCh[oldEndIdx];
	    var newEndIdx = newCh.length - 1;
	    var newStartVnode = newCh[0];
	    var newEndVnode = newCh[newEndIdx];
	    var oldKeyToIdx, idxInOld, elmToMove, refElm;
	
	    // removeOnly is a special flag used only by <transition-group>
	    // to ensure removed elements stay in correct relative positions
	    // during leaving transitions
	    var canMove = !removeOnly;
	
	    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
	      if (isUndef(oldStartVnode)) {
	        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
	      } else if (isUndef(oldEndVnode)) {
	        oldEndVnode = oldCh[--oldEndIdx];
	      } else if (sameVnode(oldStartVnode, newStartVnode)) {
	        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
	        oldStartVnode = oldCh[++oldStartIdx];
	        newStartVnode = newCh[++newStartIdx];
	      } else if (sameVnode(oldEndVnode, newEndVnode)) {
	        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
	        oldEndVnode = oldCh[--oldEndIdx];
	        newEndVnode = newCh[--newEndIdx];
	      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
	        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
	        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
	        oldStartVnode = oldCh[++oldStartIdx];
	        newEndVnode = newCh[--newEndIdx];
	      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
	        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
	        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
	        oldEndVnode = oldCh[--oldEndIdx];
	        newStartVnode = newCh[++newStartIdx];
	      } else {
	        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
	        idxInOld = isDef(newStartVnode.key) ? oldKeyToIdx[newStartVnode.key] : null;
	        if (isUndef(idxInOld)) { // New element
	          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
	          newStartVnode = newCh[++newStartIdx];
	        } else {
	          elmToMove = oldCh[idxInOld];
	          /* istanbul ignore if */
	          if ("development" !== 'production' && !elmToMove) {
	            warn(
	              'It seems there are duplicate keys that is causing an update error. ' +
	              'Make sure each v-for item has a unique key.'
	            );
	          }
	          if (sameVnode(elmToMove, newStartVnode)) {
	            patchVnode(elmToMove, newStartVnode, insertedVnodeQueue);
	            oldCh[idxInOld] = undefined;
	            canMove && nodeOps.insertBefore(parentElm, newStartVnode.elm, oldStartVnode.elm);
	            newStartVnode = newCh[++newStartIdx];
	          } else {
	            // same key but different element. treat as new element
	            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
	            newStartVnode = newCh[++newStartIdx];
	          }
	        }
	      }
	    }
	    if (oldStartIdx > oldEndIdx) {
	      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
	      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
	    } else if (newStartIdx > newEndIdx) {
	      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
	    }
	  }
	
	  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
	    if (oldVnode === vnode) {
	      return
	    }
	    // reuse element for static trees.
	    // note we only do this if the vnode is cloned -
	    // if the new node is not cloned it means the render functions have been
	    // reset by the hot-reload-api and we need to do a proper re-render.
	    if (vnode.isStatic &&
	        oldVnode.isStatic &&
	        vnode.key === oldVnode.key &&
	        (vnode.isCloned || vnode.isOnce)) {
	      vnode.elm = oldVnode.elm;
	      vnode.child = oldVnode.child;
	      return
	    }
	    var i;
	    var data = vnode.data;
	    var hasData = isDef(data);
	    if (hasData && isDef(i = data.hook) && isDef(i = i.prepatch)) {
	      i(oldVnode, vnode);
	    }
	    var elm = vnode.elm = oldVnode.elm;
	    var oldCh = oldVnode.children;
	    var ch = vnode.children;
	    if (hasData && isPatchable(vnode)) {
	      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
	      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
	    }
	    if (isUndef(vnode.text)) {
	      if (isDef(oldCh) && isDef(ch)) {
	        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
	      } else if (isDef(ch)) {
	        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
	        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
	      } else if (isDef(oldCh)) {
	        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
	      } else if (isDef(oldVnode.text)) {
	        nodeOps.setTextContent(elm, '');
	      }
	    } else if (oldVnode.text !== vnode.text) {
	      nodeOps.setTextContent(elm, vnode.text);
	    }
	    if (hasData) {
	      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
	    }
	  }
	
	  function invokeInsertHook (vnode, queue, initial) {
	    // delay insert hooks for component root nodes, invoke them after the
	    // element is really inserted
	    if (initial && vnode.parent) {
	      vnode.parent.data.pendingInsert = queue;
	    } else {
	      for (var i = 0; i < queue.length; ++i) {
	        queue[i].data.hook.insert(queue[i]);
	      }
	    }
	  }
	
	  var bailed = false;
	  // list of modules that can skip create hook during hydration because they
	  // are already rendered on the client or has no need for initialization
	  var isRenderedModule = makeMap('attrs,style,class,staticClass,staticStyle,key');
	
	  // Note: this is a browser-only function so we can assume elms are DOM nodes.
	  function hydrate (elm, vnode, insertedVnodeQueue) {
	    {
	      if (!assertNodeMatch(elm, vnode)) {
	        return false
	      }
	    }
	    vnode.elm = elm;
	    var tag = vnode.tag;
	    var data = vnode.data;
	    var children = vnode.children;
	    if (isDef(data)) {
	      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
	      if (isDef(i = vnode.child)) {
	        // child component. it should have hydrated its own tree.
	        initComponent(vnode, insertedVnodeQueue);
	        return true
	      }
	    }
	    if (isDef(tag)) {
	      if (isDef(children)) {
	        // empty element, allow client to pick up and populate children
	        if (!elm.hasChildNodes()) {
	          createChildren(vnode, children, insertedVnodeQueue);
	        } else {
	          var childrenMatch = true;
	          var childNode = elm.firstChild;
	          for (var i$1 = 0; i$1 < children.length; i$1++) {
	            if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue)) {
	              childrenMatch = false;
	              break
	            }
	            childNode = childNode.nextSibling;
	          }
	          // if childNode is not null, it means the actual childNodes list is
	          // longer than the virtual children list.
	          if (!childrenMatch || childNode) {
	            if ("development" !== 'production' &&
	                typeof console !== 'undefined' &&
	                !bailed) {
	              bailed = true;
	              console.warn('Parent: ', elm);
	              console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
	            }
	            return false
	          }
	        }
	      }
	      if (isDef(data)) {
	        for (var key in data) {
	          if (!isRenderedModule(key)) {
	            invokeCreateHooks(vnode, insertedVnodeQueue);
	            break
	          }
	        }
	      }
	    } else if (elm.data !== vnode.text) {
	      elm.data = vnode.text;
	    }
	    return true
	  }
	
	  function assertNodeMatch (node, vnode) {
	    if (vnode.tag) {
	      return (
	        vnode.tag.indexOf('vue-component') === 0 ||
	        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
	      )
	    } else {
	      return node.nodeType === (vnode.isComment ? 8 : 3)
	    }
	  }
	
	  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
	    if (!vnode) {
	      if (oldVnode) { invokeDestroyHook(oldVnode); }
	      return
	    }
	
	    var elm, parent;
	    var isInitialPatch = false;
	    var insertedVnodeQueue = [];
	
	    if (!oldVnode) {
	      // empty mount (likely as component), create new root element
	      isInitialPatch = true;
	      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
	    } else {
	      var isRealElement = isDef(oldVnode.nodeType);
	      if (!isRealElement && sameVnode(oldVnode, vnode)) {
	        // patch existing root node
	        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
	      } else {
	        if (isRealElement) {
	          // mounting to a real element
	          // check if this is server-rendered content and if we can perform
	          // a successful hydration.
	          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute('server-rendered')) {
	            oldVnode.removeAttribute('server-rendered');
	            hydrating = true;
	          }
	          if (hydrating) {
	            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
	              invokeInsertHook(vnode, insertedVnodeQueue, true);
	              return oldVnode
	            } else {
	              warn(
	                'The client-side rendered virtual DOM tree is not matching ' +
	                'server-rendered content. This is likely caused by incorrect ' +
	                'HTML markup, for example nesting block-level elements inside ' +
	                '<p>, or missing <tbody>. Bailing hydration and performing ' +
	                'full client-side render.'
	              );
	            }
	          }
	          // either not server-rendered, or hydration failed.
	          // create an empty node and replace it
	          oldVnode = emptyNodeAt(oldVnode);
	        }
	        // replacing existing element
	        elm = oldVnode.elm;
	        parent = nodeOps.parentNode(elm);
	        createElm(vnode, insertedVnodeQueue, parent, nodeOps.nextSibling(elm));
	
	        if (vnode.parent) {
	          // component root element replaced.
	          // update parent placeholder node element, recursively
	          var ancestor = vnode.parent;
	          while (ancestor) {
	            ancestor.elm = vnode.elm;
	            ancestor = ancestor.parent;
	          }
	          if (isPatchable(vnode)) {
	            for (var i = 0; i < cbs.create.length; ++i) {
	              cbs.create[i](emptyNode, vnode.parent);
	            }
	          }
	        }
	
	        if (parent !== null) {
	          removeVnodes(parent, [oldVnode], 0, 0);
	        } else if (isDef(oldVnode.tag)) {
	          invokeDestroyHook(oldVnode);
	        }
	      }
	    }
	
	    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
	    return vnode.elm
	  }
	}
	
	/*  */
	
	var directives = {
	  create: updateDirectives,
	  update: updateDirectives,
	  destroy: function unbindDirectives (vnode) {
	    updateDirectives(vnode, emptyNode);
	  }
	};
	
	function updateDirectives (oldVnode, vnode) {
	  if (oldVnode.data.directives || vnode.data.directives) {
	    _update(oldVnode, vnode);
	  }
	}
	
	function _update (oldVnode, vnode) {
	  var isCreate = oldVnode === emptyNode;
	  var isDestroy = vnode === emptyNode;
	  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
	  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);
	
	  var dirsWithInsert = [];
	  var dirsWithPostpatch = [];
	
	  var key, oldDir, dir;
	  for (key in newDirs) {
	    oldDir = oldDirs[key];
	    dir = newDirs[key];
	    if (!oldDir) {
	      // new directive, bind
	      callHook$1(dir, 'bind', vnode, oldVnode);
	      if (dir.def && dir.def.inserted) {
	        dirsWithInsert.push(dir);
	      }
	    } else {
	      // existing directive, update
	      dir.oldValue = oldDir.value;
	      callHook$1(dir, 'update', vnode, oldVnode);
	      if (dir.def && dir.def.componentUpdated) {
	        dirsWithPostpatch.push(dir);
	      }
	    }
	  }
	
	  if (dirsWithInsert.length) {
	    var callInsert = function () {
	      for (var i = 0; i < dirsWithInsert.length; i++) {
	        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
	      }
	    };
	    if (isCreate) {
	      mergeVNodeHook(vnode.data.hook || (vnode.data.hook = {}), 'insert', callInsert, 'dir-insert');
	    } else {
	      callInsert();
	    }
	  }
	
	  if (dirsWithPostpatch.length) {
	    mergeVNodeHook(vnode.data.hook || (vnode.data.hook = {}), 'postpatch', function () {
	      for (var i = 0; i < dirsWithPostpatch.length; i++) {
	        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
	      }
	    }, 'dir-postpatch');
	  }
	
	  if (!isCreate) {
	    for (key in oldDirs) {
	      if (!newDirs[key]) {
	        // no longer present, unbind
	        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
	      }
	    }
	  }
	}
	
	var emptyModifiers = Object.create(null);
	
	function normalizeDirectives$1 (
	  dirs,
	  vm
	) {
	  var res = Object.create(null);
	  if (!dirs) {
	    return res
	  }
	  var i, dir;
	  for (i = 0; i < dirs.length; i++) {
	    dir = dirs[i];
	    if (!dir.modifiers) {
	      dir.modifiers = emptyModifiers;
	    }
	    res[getRawDirName(dir)] = dir;
	    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
	  }
	  return res
	}
	
	function getRawDirName (dir) {
	  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
	}
	
	function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
	  var fn = dir.def && dir.def[hook];
	  if (fn) {
	    fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
	  }
	}
	
	var baseModules = [
	  ref,
	  directives
	];
	
	/*  */
	
	function updateAttrs (oldVnode, vnode) {
	  if (!oldVnode.data.attrs && !vnode.data.attrs) {
	    return
	  }
	  var key, cur, old;
	  var elm = vnode.elm;
	  var oldAttrs = oldVnode.data.attrs || {};
	  var attrs = vnode.data.attrs || {};
	  // clone observed objects, as the user probably wants to mutate it
	  if (attrs.__ob__) {
	    attrs = vnode.data.attrs = extend({}, attrs);
	  }
	
	  for (key in attrs) {
	    cur = attrs[key];
	    old = oldAttrs[key];
	    if (old !== cur) {
	      setAttr(elm, key, cur);
	    }
	  }
	  // #4391: in IE9, setting type can reset value for input[type=radio]
	  /* istanbul ignore if */
	  if (isIE9 && attrs.value !== oldAttrs.value) {
	    setAttr(elm, 'value', attrs.value);
	  }
	  for (key in oldAttrs) {
	    if (attrs[key] == null) {
	      if (isXlink(key)) {
	        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
	      } else if (!isEnumeratedAttr(key)) {
	        elm.removeAttribute(key);
	      }
	    }
	  }
	}
	
	function setAttr (el, key, value) {
	  if (isBooleanAttr(key)) {
	    // set attribute for blank value
	    // e.g. <option disabled>Select one</option>
	    if (isFalsyAttrValue(value)) {
	      el.removeAttribute(key);
	    } else {
	      el.setAttribute(key, key);
	    }
	  } else if (isEnumeratedAttr(key)) {
	    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
	  } else if (isXlink(key)) {
	    if (isFalsyAttrValue(value)) {
	      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
	    } else {
	      el.setAttributeNS(xlinkNS, key, value);
	    }
	  } else {
	    if (isFalsyAttrValue(value)) {
	      el.removeAttribute(key);
	    } else {
	      el.setAttribute(key, value);
	    }
	  }
	}
	
	var attrs = {
	  create: updateAttrs,
	  update: updateAttrs
	};
	
	/*  */
	
	function updateClass (oldVnode, vnode) {
	  var el = vnode.elm;
	  var data = vnode.data;
	  var oldData = oldVnode.data;
	  if (!data.staticClass && !data.class &&
	      (!oldData || (!oldData.staticClass && !oldData.class))) {
	    return
	  }
	
	  var cls = genClassForVnode(vnode);
	
	  // handle transition classes
	  var transitionClass = el._transitionClasses;
	  if (transitionClass) {
	    cls = concat(cls, stringifyClass(transitionClass));
	  }
	
	  // set the class
	  if (cls !== el._prevClass) {
	    el.setAttribute('class', cls);
	    el._prevClass = cls;
	  }
	}
	
	var klass = {
	  create: updateClass,
	  update: updateClass
	};
	
	/*  */
	
	var target$1;
	
	function add$2 (event, handler, once, capture) {
	  if (once) {
	    var oldHandler = handler;
	    handler = function (ev) {
	      remove$3(event, handler, capture);
	      arguments.length === 1
	        ? oldHandler(ev)
	        : oldHandler.apply(null, arguments);
	    };
	  }
	  target$1.addEventListener(event, handler, capture);
	}
	
	function remove$3 (event, handler, capture) {
	  target$1.removeEventListener(event, handler, capture);
	}
	
	function updateDOMListeners (oldVnode, vnode) {
	  if (!oldVnode.data.on && !vnode.data.on) {
	    return
	  }
	  var on = vnode.data.on || {};
	  var oldOn = oldVnode.data.on || {};
	  target$1 = vnode.elm;
	  updateListeners(on, oldOn, add$2, remove$3, vnode.context);
	}
	
	var events = {
	  create: updateDOMListeners,
	  update: updateDOMListeners
	};
	
	/*  */
	
	function updateDOMProps (oldVnode, vnode) {
	  if (!oldVnode.data.domProps && !vnode.data.domProps) {
	    return
	  }
	  var key, cur;
	  var elm = vnode.elm;
	  var oldProps = oldVnode.data.domProps || {};
	  var props = vnode.data.domProps || {};
	  // clone observed objects, as the user probably wants to mutate it
	  if (props.__ob__) {
	    props = vnode.data.domProps = extend({}, props);
	  }
	
	  for (key in oldProps) {
	    if (props[key] == null) {
	      elm[key] = '';
	    }
	  }
	  for (key in props) {
	    cur = props[key];
	    // ignore children if the node has textContent or innerHTML,
	    // as these will throw away existing DOM nodes and cause removal errors
	    // on subsequent patches (#3360)
	    if (key === 'textContent' || key === 'innerHTML') {
	      if (vnode.children) { vnode.children.length = 0; }
	      if (cur === oldProps[key]) { continue }
	    }
	    // #4521: if a click event triggers update before the change event is
	    // dispatched on a checkbox/radio input, the input's checked state will
	    // be reset and fail to trigger another update.
	    /* istanbul ignore next */
	    if (key === 'checked' && !isDirty(elm, cur)) {
	      continue
	    }
	    if (key === 'value') {
	      // store value as _value as well since
	      // non-string values will be stringified
	      elm._value = cur;
	      // avoid resetting cursor position when value is the same
	      var strCur = cur == null ? '' : String(cur);
	      if (shouldUpdateValue(elm, vnode, strCur)) {
	        elm.value = strCur;
	      }
	    } else {
	      elm[key] = cur;
	    }
	  }
	}
	
	// check platforms/web/util/attrs.js acceptValue
	
	
	function shouldUpdateValue (
	  elm,
	  vnode,
	  checkVal
	) {
	  if (!elm.composing && (
	    vnode.tag === 'option' ||
	    isDirty(elm, checkVal) ||
	    isInputChanged(vnode, checkVal)
	  )) {
	    return true
	  }
	  return false
	}
	
	function isDirty (elm, checkVal) {
	  return document.activeElement !== elm && elm.value !== checkVal
	}
	
	function isInputChanged (vnode, newVal) {
	  var value = vnode.elm.value;
	  var modifiers = vnode.elm._vModifiers; // injected by v-model runtime
	  if ((modifiers && modifiers.number) || vnode.elm.type === 'number') {
	    return toNumber(value) !== toNumber(newVal)
	  }
	  if (modifiers && modifiers.trim) {
	    return value.trim() !== newVal.trim()
	  }
	  return value !== newVal
	}
	
	var domProps = {
	  create: updateDOMProps,
	  update: updateDOMProps
	};
	
	/*  */
	
	var parseStyleText = cached(function (cssText) {
	  var res = {};
	  var listDelimiter = /;(?![^(]*\))/g;
	  var propertyDelimiter = /:(.+)/;
	  cssText.split(listDelimiter).forEach(function (item) {
	    if (item) {
	      var tmp = item.split(propertyDelimiter);
	      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
	    }
	  });
	  return res
	});
	
	// merge static and dynamic style data on the same vnode
	function normalizeStyleData (data) {
	  var style = normalizeStyleBinding(data.style);
	  // static style is pre-processed into an object during compilation
	  // and is always a fresh object, so it's safe to merge into it
	  return data.staticStyle
	    ? extend(data.staticStyle, style)
	    : style
	}
	
	// normalize possible array / string values into Object
	function normalizeStyleBinding (bindingStyle) {
	  if (Array.isArray(bindingStyle)) {
	    return toObject(bindingStyle)
	  }
	  if (typeof bindingStyle === 'string') {
	    return parseStyleText(bindingStyle)
	  }
	  return bindingStyle
	}
	
	/**
	 * parent component style should be after child's
	 * so that parent component's style could override it
	 */
	function getStyle (vnode, checkChild) {
	  var res = {};
	  var styleData;
	
	  if (checkChild) {
	    var childNode = vnode;
	    while (childNode.child) {
	      childNode = childNode.child._vnode;
	      if (childNode.data && (styleData = normalizeStyleData(childNode.data))) {
	        extend(res, styleData);
	      }
	    }
	  }
	
	  if ((styleData = normalizeStyleData(vnode.data))) {
	    extend(res, styleData);
	  }
	
	  var parentNode = vnode;
	  while ((parentNode = parentNode.parent)) {
	    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
	      extend(res, styleData);
	    }
	  }
	  return res
	}
	
	/*  */
	
	var cssVarRE = /^--/;
	var importantRE = /\s*!important$/;
	var setProp = function (el, name, val) {
	  /* istanbul ignore if */
	  if (cssVarRE.test(name)) {
	    el.style.setProperty(name, val);
	  } else if (importantRE.test(val)) {
	    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
	  } else {
	    el.style[normalize(name)] = val;
	  }
	};
	
	var prefixes = ['Webkit', 'Moz', 'ms'];
	
	var testEl;
	var normalize = cached(function (prop) {
	  testEl = testEl || document.createElement('div');
	  prop = camelize(prop);
	  if (prop !== 'filter' && (prop in testEl.style)) {
	    return prop
	  }
	  var upper = prop.charAt(0).toUpperCase() + prop.slice(1);
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefixed = prefixes[i] + upper;
	    if (prefixed in testEl.style) {
	      return prefixed
	    }
	  }
	});
	
	function updateStyle (oldVnode, vnode) {
	  var data = vnode.data;
	  var oldData = oldVnode.data;
	
	  if (!data.staticStyle && !data.style &&
	      !oldData.staticStyle && !oldData.style) {
	    return
	  }
	
	  var cur, name;
	  var el = vnode.elm;
	  var oldStaticStyle = oldVnode.data.staticStyle;
	  var oldStyleBinding = oldVnode.data.style || {};
	
	  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
	  var oldStyle = oldStaticStyle || oldStyleBinding;
	
	  var style = normalizeStyleBinding(vnode.data.style) || {};
	
	  vnode.data.style = style.__ob__ ? extend({}, style) : style;
	
	  var newStyle = getStyle(vnode, true);
	
	  for (name in oldStyle) {
	    if (newStyle[name] == null) {
	      setProp(el, name, '');
	    }
	  }
	  for (name in newStyle) {
	    cur = newStyle[name];
	    if (cur !== oldStyle[name]) {
	      // ie9 setting to null has no effect, must use empty string
	      setProp(el, name, cur == null ? '' : cur);
	    }
	  }
	}
	
	var style = {
	  create: updateStyle,
	  update: updateStyle
	};
	
	/*  */
	
	/**
	 * Add class with compatibility for SVG since classList is not supported on
	 * SVG elements in IE
	 */
	function addClass (el, cls) {
	  /* istanbul ignore if */
	  if (!cls || !cls.trim()) {
	    return
	  }
	
	  /* istanbul ignore else */
	  if (el.classList) {
	    if (cls.indexOf(' ') > -1) {
	      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
	    } else {
	      el.classList.add(cls);
	    }
	  } else {
	    var cur = ' ' + el.getAttribute('class') + ' ';
	    if (cur.indexOf(' ' + cls + ' ') < 0) {
	      el.setAttribute('class', (cur + cls).trim());
	    }
	  }
	}
	
	/**
	 * Remove class with compatibility for SVG since classList is not supported on
	 * SVG elements in IE
	 */
	function removeClass (el, cls) {
	  /* istanbul ignore if */
	  if (!cls || !cls.trim()) {
	    return
	  }
	
	  /* istanbul ignore else */
	  if (el.classList) {
	    if (cls.indexOf(' ') > -1) {
	      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
	    } else {
	      el.classList.remove(cls);
	    }
	  } else {
	    var cur = ' ' + el.getAttribute('class') + ' ';
	    var tar = ' ' + cls + ' ';
	    while (cur.indexOf(tar) >= 0) {
	      cur = cur.replace(tar, ' ');
	    }
	    el.setAttribute('class', cur.trim());
	  }
	}
	
	/*  */
	
	var hasTransition = inBrowser && !isIE9;
	var TRANSITION = 'transition';
	var ANIMATION = 'animation';
	
	// Transition property/event sniffing
	var transitionProp = 'transition';
	var transitionEndEvent = 'transitionend';
	var animationProp = 'animation';
	var animationEndEvent = 'animationend';
	if (hasTransition) {
	  /* istanbul ignore if */
	  if (window.ontransitionend === undefined &&
	    window.onwebkittransitionend !== undefined) {
	    transitionProp = 'WebkitTransition';
	    transitionEndEvent = 'webkitTransitionEnd';
	  }
	  if (window.onanimationend === undefined &&
	    window.onwebkitanimationend !== undefined) {
	    animationProp = 'WebkitAnimation';
	    animationEndEvent = 'webkitAnimationEnd';
	  }
	}
	
	var raf = (inBrowser && window.requestAnimationFrame) || setTimeout;
	function nextFrame (fn) {
	  raf(function () {
	    raf(fn);
	  });
	}
	
	function addTransitionClass (el, cls) {
	  (el._transitionClasses || (el._transitionClasses = [])).push(cls);
	  addClass(el, cls);
	}
	
	function removeTransitionClass (el, cls) {
	  if (el._transitionClasses) {
	    remove$1(el._transitionClasses, cls);
	  }
	  removeClass(el, cls);
	}
	
	function whenTransitionEnds (
	  el,
	  expectedType,
	  cb
	) {
	  var ref = getTransitionInfo(el, expectedType);
	  var type = ref.type;
	  var timeout = ref.timeout;
	  var propCount = ref.propCount;
	  if (!type) { return cb() }
	  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
	  var ended = 0;
	  var end = function () {
	    el.removeEventListener(event, onEnd);
	    cb();
	  };
	  var onEnd = function (e) {
	    if (e.target === el) {
	      if (++ended >= propCount) {
	        end();
	      }
	    }
	  };
	  setTimeout(function () {
	    if (ended < propCount) {
	      end();
	    }
	  }, timeout + 1);
	  el.addEventListener(event, onEnd);
	}
	
	var transformRE = /\b(transform|all)(,|$)/;
	
	function getTransitionInfo (el, expectedType) {
	  var styles = window.getComputedStyle(el);
	  var transitioneDelays = styles[transitionProp + 'Delay'].split(', ');
	  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
	  var transitionTimeout = getTimeout(transitioneDelays, transitionDurations);
	  var animationDelays = styles[animationProp + 'Delay'].split(', ');
	  var animationDurations = styles[animationProp + 'Duration'].split(', ');
	  var animationTimeout = getTimeout(animationDelays, animationDurations);
	
	  var type;
	  var timeout = 0;
	  var propCount = 0;
	  /* istanbul ignore if */
	  if (expectedType === TRANSITION) {
	    if (transitionTimeout > 0) {
	      type = TRANSITION;
	      timeout = transitionTimeout;
	      propCount = transitionDurations.length;
	    }
	  } else if (expectedType === ANIMATION) {
	    if (animationTimeout > 0) {
	      type = ANIMATION;
	      timeout = animationTimeout;
	      propCount = animationDurations.length;
	    }
	  } else {
	    timeout = Math.max(transitionTimeout, animationTimeout);
	    type = timeout > 0
	      ? transitionTimeout > animationTimeout
	        ? TRANSITION
	        : ANIMATION
	      : null;
	    propCount = type
	      ? type === TRANSITION
	        ? transitionDurations.length
	        : animationDurations.length
	      : 0;
	  }
	  var hasTransform =
	    type === TRANSITION &&
	    transformRE.test(styles[transitionProp + 'Property']);
	  return {
	    type: type,
	    timeout: timeout,
	    propCount: propCount,
	    hasTransform: hasTransform
	  }
	}
	
	function getTimeout (delays, durations) {
	  /* istanbul ignore next */
	  while (delays.length < durations.length) {
	    delays = delays.concat(delays);
	  }
	
	  return Math.max.apply(null, durations.map(function (d, i) {
	    return toMs(d) + toMs(delays[i])
	  }))
	}
	
	function toMs (s) {
	  return Number(s.slice(0, -1)) * 1000
	}
	
	/*  */
	
	function enter (vnode, toggleDisplay) {
	  var el = vnode.elm;
	
	  // call leave callback now
	  if (el._leaveCb) {
	    el._leaveCb.cancelled = true;
	    el._leaveCb();
	  }
	
	  var data = resolveTransition(vnode.data.transition);
	  if (!data) {
	    return
	  }
	
	  /* istanbul ignore if */
	  if (el._enterCb || el.nodeType !== 1) {
	    return
	  }
	
	  var css = data.css;
	  var type = data.type;
	  var enterClass = data.enterClass;
	  var enterToClass = data.enterToClass;
	  var enterActiveClass = data.enterActiveClass;
	  var appearClass = data.appearClass;
	  var appearToClass = data.appearToClass;
	  var appearActiveClass = data.appearActiveClass;
	  var beforeEnter = data.beforeEnter;
	  var enter = data.enter;
	  var afterEnter = data.afterEnter;
	  var enterCancelled = data.enterCancelled;
	  var beforeAppear = data.beforeAppear;
	  var appear = data.appear;
	  var afterAppear = data.afterAppear;
	  var appearCancelled = data.appearCancelled;
	
	  // activeInstance will always be the <transition> component managing this
	  // transition. One edge case to check is when the <transition> is placed
	  // as the root node of a child component. In that case we need to check
	  // <transition>'s parent for appear check.
	  var context = activeInstance;
	  var transitionNode = activeInstance.$vnode;
	  while (transitionNode && transitionNode.parent) {
	    transitionNode = transitionNode.parent;
	    context = transitionNode.context;
	  }
	
	  var isAppear = !context._isMounted || !vnode.isRootInsert;
	
	  if (isAppear && !appear && appear !== '') {
	    return
	  }
	
	  var startClass = isAppear ? appearClass : enterClass;
	  var activeClass = isAppear ? appearActiveClass : enterActiveClass;
	  var toClass = isAppear ? appearToClass : enterToClass;
	  var beforeEnterHook = isAppear ? (beforeAppear || beforeEnter) : beforeEnter;
	  var enterHook = isAppear ? (typeof appear === 'function' ? appear : enter) : enter;
	  var afterEnterHook = isAppear ? (afterAppear || afterEnter) : afterEnter;
	  var enterCancelledHook = isAppear ? (appearCancelled || enterCancelled) : enterCancelled;
	
	  var expectsCSS = css !== false && !isIE9;
	  var userWantsControl =
	    enterHook &&
	    // enterHook may be a bound method which exposes
	    // the length of original fn as _length
	    (enterHook._length || enterHook.length) > 1;
	
	  var cb = el._enterCb = once(function () {
	    if (expectsCSS) {
	      removeTransitionClass(el, toClass);
	      removeTransitionClass(el, activeClass);
	    }
	    if (cb.cancelled) {
	      if (expectsCSS) {
	        removeTransitionClass(el, startClass);
	      }
	      enterCancelledHook && enterCancelledHook(el);
	    } else {
	      afterEnterHook && afterEnterHook(el);
	    }
	    el._enterCb = null;
	  });
	
	  if (!vnode.data.show) {
	    // remove pending leave element on enter by injecting an insert hook
	    mergeVNodeHook(vnode.data.hook || (vnode.data.hook = {}), 'insert', function () {
	      var parent = el.parentNode;
	      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
	      if (pendingNode &&
	          pendingNode.context === vnode.context &&
	          pendingNode.tag === vnode.tag &&
	          pendingNode.elm._leaveCb) {
	        pendingNode.elm._leaveCb();
	      }
	      enterHook && enterHook(el, cb);
	    }, 'transition-insert');
	  }
	
	  // start enter transition
	  beforeEnterHook && beforeEnterHook(el);
	  if (expectsCSS) {
	    addTransitionClass(el, startClass);
	    addTransitionClass(el, activeClass);
	    nextFrame(function () {
	      addTransitionClass(el, toClass);
	      removeTransitionClass(el, startClass);
	      if (!cb.cancelled && !userWantsControl) {
	        whenTransitionEnds(el, type, cb);
	      }
	    });
	  }
	
	  if (vnode.data.show) {
	    toggleDisplay && toggleDisplay();
	    enterHook && enterHook(el, cb);
	  }
	
	  if (!expectsCSS && !userWantsControl) {
	    cb();
	  }
	}
	
	function leave (vnode, rm) {
	  var el = vnode.elm;
	
	  // call enter callback now
	  if (el._enterCb) {
	    el._enterCb.cancelled = true;
	    el._enterCb();
	  }
	
	  var data = resolveTransition(vnode.data.transition);
	  if (!data) {
	    return rm()
	  }
	
	  /* istanbul ignore if */
	  if (el._leaveCb || el.nodeType !== 1) {
	    return
	  }
	
	  var css = data.css;
	  var type = data.type;
	  var leaveClass = data.leaveClass;
	  var leaveToClass = data.leaveToClass;
	  var leaveActiveClass = data.leaveActiveClass;
	  var beforeLeave = data.beforeLeave;
	  var leave = data.leave;
	  var afterLeave = data.afterLeave;
	  var leaveCancelled = data.leaveCancelled;
	  var delayLeave = data.delayLeave;
	
	  var expectsCSS = css !== false && !isIE9;
	  var userWantsControl =
	    leave &&
	    // leave hook may be a bound method which exposes
	    // the length of original fn as _length
	    (leave._length || leave.length) > 1;
	
	  var cb = el._leaveCb = once(function () {
	    if (el.parentNode && el.parentNode._pending) {
	      el.parentNode._pending[vnode.key] = null;
	    }
	    if (expectsCSS) {
	      removeTransitionClass(el, leaveToClass);
	      removeTransitionClass(el, leaveActiveClass);
	    }
	    if (cb.cancelled) {
	      if (expectsCSS) {
	        removeTransitionClass(el, leaveClass);
	      }
	      leaveCancelled && leaveCancelled(el);
	    } else {
	      rm();
	      afterLeave && afterLeave(el);
	    }
	    el._leaveCb = null;
	  });
	
	  if (delayLeave) {
	    delayLeave(performLeave);
	  } else {
	    performLeave();
	  }
	
	  function performLeave () {
	    // the delayed leave may have already been cancelled
	    if (cb.cancelled) {
	      return
	    }
	    // record leaving element
	    if (!vnode.data.show) {
	      (el.parentNode._pending || (el.parentNode._pending = {}))[vnode.key] = vnode;
	    }
	    beforeLeave && beforeLeave(el);
	    if (expectsCSS) {
	      addTransitionClass(el, leaveClass);
	      addTransitionClass(el, leaveActiveClass);
	      nextFrame(function () {
	        addTransitionClass(el, leaveToClass);
	        removeTransitionClass(el, leaveClass);
	        if (!cb.cancelled && !userWantsControl) {
	          whenTransitionEnds(el, type, cb);
	        }
	      });
	    }
	    leave && leave(el, cb);
	    if (!expectsCSS && !userWantsControl) {
	      cb();
	    }
	  }
	}
	
	function resolveTransition (def$$1) {
	  if (!def$$1) {
	    return
	  }
	  /* istanbul ignore else */
	  if (typeof def$$1 === 'object') {
	    var res = {};
	    if (def$$1.css !== false) {
	      extend(res, autoCssTransition(def$$1.name || 'v'));
	    }
	    extend(res, def$$1);
	    return res
	  } else if (typeof def$$1 === 'string') {
	    return autoCssTransition(def$$1)
	  }
	}
	
	var autoCssTransition = cached(function (name) {
	  return {
	    enterClass: (name + "-enter"),
	    leaveClass: (name + "-leave"),
	    appearClass: (name + "-enter"),
	    enterToClass: (name + "-enter-to"),
	    leaveToClass: (name + "-leave-to"),
	    appearToClass: (name + "-enter-to"),
	    enterActiveClass: (name + "-enter-active"),
	    leaveActiveClass: (name + "-leave-active"),
	    appearActiveClass: (name + "-enter-active")
	  }
	});
	
	function once (fn) {
	  var called = false;
	  return function () {
	    if (!called) {
	      called = true;
	      fn();
	    }
	  }
	}
	
	function _enter (_, vnode) {
	  if (!vnode.data.show) {
	    enter(vnode);
	  }
	}
	
	var transition = inBrowser ? {
	  create: _enter,
	  activate: _enter,
	  remove: function remove (vnode, rm) {
	    /* istanbul ignore else */
	    if (!vnode.data.show) {
	      leave(vnode, rm);
	    } else {
	      rm();
	    }
	  }
	} : {};
	
	var platformModules = [
	  attrs,
	  klass,
	  events,
	  domProps,
	  style,
	  transition
	];
	
	/*  */
	
	// the directive module should be applied last, after all
	// built-in modules have been applied.
	var modules = platformModules.concat(baseModules);
	
	var patch$1 = createPatchFunction({ nodeOps: nodeOps, modules: modules });
	
	/**
	 * Not type checking this file because flow doesn't like attaching
	 * properties to Elements.
	 */
	
	var modelableTagRE = /^input|select|textarea|vue-component-[0-9]+(-[0-9a-zA-Z_-]*)?$/;
	
	/* istanbul ignore if */
	if (isIE9) {
	  // http://www.matts411.com/post/internet-explorer-9-oninput/
	  document.addEventListener('selectionchange', function () {
	    var el = document.activeElement;
	    if (el && el.vmodel) {
	      trigger(el, 'input');
	    }
	  });
	}
	
	var model = {
	  inserted: function inserted (el, binding, vnode) {
	    {
	      if (!modelableTagRE.test(vnode.tag)) {
	        warn(
	          "v-model is not supported on element type: <" + (vnode.tag) + ">. " +
	          'If you are working with contenteditable, it\'s recommended to ' +
	          'wrap a library dedicated for that purpose inside a custom component.',
	          vnode.context
	        );
	      }
	    }
	    if (vnode.tag === 'select') {
	      var cb = function () {
	        setSelected(el, binding, vnode.context);
	      };
	      cb();
	      /* istanbul ignore if */
	      if (isIE || isEdge) {
	        setTimeout(cb, 0);
	      }
	    } else if (vnode.tag === 'textarea' || el.type === 'text') {
	      el._vModifiers = binding.modifiers;
	      if (!binding.modifiers.lazy) {
	        if (!isAndroid) {
	          el.addEventListener('compositionstart', onCompositionStart);
	          el.addEventListener('compositionend', onCompositionEnd);
	        }
	        /* istanbul ignore if */
	        if (isIE9) {
	          el.vmodel = true;
	        }
	      }
	    }
	  },
	  componentUpdated: function componentUpdated (el, binding, vnode) {
	    if (vnode.tag === 'select') {
	      setSelected(el, binding, vnode.context);
	      // in case the options rendered by v-for have changed,
	      // it's possible that the value is out-of-sync with the rendered options.
	      // detect such cases and filter out values that no longer has a matching
	      // option in the DOM.
	      var needReset = el.multiple
	        ? binding.value.some(function (v) { return hasNoMatchingOption(v, el.options); })
	        : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, el.options);
	      if (needReset) {
	        trigger(el, 'change');
	      }
	    }
	  }
	};
	
	function setSelected (el, binding, vm) {
	  var value = binding.value;
	  var isMultiple = el.multiple;
	  if (isMultiple && !Array.isArray(value)) {
	    "development" !== 'production' && warn(
	      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
	      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
	      vm
	    );
	    return
	  }
	  var selected, option;
	  for (var i = 0, l = el.options.length; i < l; i++) {
	    option = el.options[i];
	    if (isMultiple) {
	      selected = looseIndexOf(value, getValue(option)) > -1;
	      if (option.selected !== selected) {
	        option.selected = selected;
	      }
	    } else {
	      if (looseEqual(getValue(option), value)) {
	        if (el.selectedIndex !== i) {
	          el.selectedIndex = i;
	        }
	        return
	      }
	    }
	  }
	  if (!isMultiple) {
	    el.selectedIndex = -1;
	  }
	}
	
	function hasNoMatchingOption (value, options) {
	  for (var i = 0, l = options.length; i < l; i++) {
	    if (looseEqual(getValue(options[i]), value)) {
	      return false
	    }
	  }
	  return true
	}
	
	function getValue (option) {
	  return '_value' in option
	    ? option._value
	    : option.value
	}
	
	function onCompositionStart (e) {
	  e.target.composing = true;
	}
	
	function onCompositionEnd (e) {
	  e.target.composing = false;
	  trigger(e.target, 'input');
	}
	
	function trigger (el, type) {
	  var e = document.createEvent('HTMLEvents');
	  e.initEvent(type, true, true);
	  el.dispatchEvent(e);
	}
	
	/*  */
	
	// recursively search for possible transition defined inside the component root
	function locateNode (vnode) {
	  return vnode.child && (!vnode.data || !vnode.data.transition)
	    ? locateNode(vnode.child._vnode)
	    : vnode
	}
	
	var show = {
	  bind: function bind (el, ref, vnode) {
	    var value = ref.value;
	
	    vnode = locateNode(vnode);
	    var transition = vnode.data && vnode.data.transition;
	    var originalDisplay = el.__vOriginalDisplay =
	      el.style.display === 'none' ? '' : el.style.display;
	    if (value && transition && !isIE9) {
	      vnode.data.show = true;
	      enter(vnode, function () {
	        el.style.display = originalDisplay;
	      });
	    } else {
	      el.style.display = value ? originalDisplay : 'none';
	    }
	  },
	
	  update: function update (el, ref, vnode) {
	    var value = ref.value;
	    var oldValue = ref.oldValue;
	
	    /* istanbul ignore if */
	    if (value === oldValue) { return }
	    vnode = locateNode(vnode);
	    var transition = vnode.data && vnode.data.transition;
	    if (transition && !isIE9) {
	      vnode.data.show = true;
	      if (value) {
	        enter(vnode, function () {
	          el.style.display = el.__vOriginalDisplay;
	        });
	      } else {
	        leave(vnode, function () {
	          el.style.display = 'none';
	        });
	      }
	    } else {
	      el.style.display = value ? el.__vOriginalDisplay : 'none';
	    }
	  },
	
	  unbind: function unbind (
	    el,
	    binding,
	    vnode,
	    oldVnode,
	    isDestroy
	  ) {
	    if (!isDestroy) {
	      el.style.display = el.__vOriginalDisplay;
	    }
	  }
	};
	
	var platformDirectives = {
	  model: model,
	  show: show
	};
	
	/*  */
	
	// Provides transition support for a single element/component.
	// supports transition mode (out-in / in-out)
	
	var transitionProps = {
	  name: String,
	  appear: Boolean,
	  css: Boolean,
	  mode: String,
	  type: String,
	  enterClass: String,
	  leaveClass: String,
	  enterToClass: String,
	  leaveToClass: String,
	  enterActiveClass: String,
	  leaveActiveClass: String,
	  appearClass: String,
	  appearActiveClass: String,
	  appearToClass: String
	};
	
	// in case the child is also an abstract component, e.g. <keep-alive>
	// we want to recursively retrieve the real component to be rendered
	function getRealChild (vnode) {
	  var compOptions = vnode && vnode.componentOptions;
	  if (compOptions && compOptions.Ctor.options.abstract) {
	    return getRealChild(getFirstComponentChild(compOptions.children))
	  } else {
	    return vnode
	  }
	}
	
	function extractTransitionData (comp) {
	  var data = {};
	  var options = comp.$options;
	  // props
	  for (var key in options.propsData) {
	    data[key] = comp[key];
	  }
	  // events.
	  // extract listeners and pass them directly to the transition methods
	  var listeners = options._parentListeners;
	  for (var key$1 in listeners) {
	    data[camelize(key$1)] = listeners[key$1].fn;
	  }
	  return data
	}
	
	function placeholder (h, rawChild) {
	  return /\d-keep-alive$/.test(rawChild.tag)
	    ? h('keep-alive')
	    : null
	}
	
	function hasParentTransition (vnode) {
	  while ((vnode = vnode.parent)) {
	    if (vnode.data.transition) {
	      return true
	    }
	  }
	}
	
	function isSameChild (child, oldChild) {
	  return oldChild.key === child.key && oldChild.tag === child.tag
	}
	
	var Transition = {
	  name: 'transition',
	  props: transitionProps,
	  abstract: true,
	  render: function render (h) {
	    var this$1 = this;
	
	    var children = this.$slots.default;
	    if (!children) {
	      return
	    }
	
	    // filter out text nodes (possible whitespaces)
	    children = children.filter(function (c) { return c.tag; });
	    /* istanbul ignore if */
	    if (!children.length) {
	      return
	    }
	
	    // warn multiple elements
	    if ("development" !== 'production' && children.length > 1) {
	      warn(
	        '<transition> can only be used on a single element. Use ' +
	        '<transition-group> for lists.',
	        this.$parent
	      );
	    }
	
	    var mode = this.mode;
	
	    // warn invalid mode
	    if ("development" !== 'production' &&
	        mode && mode !== 'in-out' && mode !== 'out-in') {
	      warn(
	        'invalid <transition> mode: ' + mode,
	        this.$parent
	      );
	    }
	
	    var rawChild = children[0];
	
	    // if this is a component root node and the component's
	    // parent container node also has transition, skip.
	    if (hasParentTransition(this.$vnode)) {
	      return rawChild
	    }
	
	    // apply transition data to child
	    // use getRealChild() to ignore abstract components e.g. keep-alive
	    var child = getRealChild(rawChild);
	    /* istanbul ignore if */
	    if (!child) {
	      return rawChild
	    }
	
	    if (this._leaving) {
	      return placeholder(h, rawChild)
	    }
	
	    var key = child.key = child.key == null || child.isStatic
	      ? ("__v" + (child.tag + this._uid) + "__")
	      : child.key;
	    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
	    var oldRawChild = this._vnode;
	    var oldChild = getRealChild(oldRawChild);
	
	    // mark v-show
	    // so that the transition module can hand over the control to the directive
	    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
	      child.data.show = true;
	    }
	
	    if (oldChild && oldChild.data && !isSameChild(child, oldChild)) {
	      // replace old child transition data with fresh one
	      // important for dynamic transitions!
	      var oldData = oldChild && (oldChild.data.transition = extend({}, data));
	      // handle transition mode
	      if (mode === 'out-in') {
	        // return placeholder node and queue update when leave finishes
	        this._leaving = true;
	        mergeVNodeHook(oldData, 'afterLeave', function () {
	          this$1._leaving = false;
	          this$1.$forceUpdate();
	        }, key);
	        return placeholder(h, rawChild)
	      } else if (mode === 'in-out') {
	        var delayedLeave;
	        var performLeave = function () { delayedLeave(); };
	        mergeVNodeHook(data, 'afterEnter', performLeave, key);
	        mergeVNodeHook(data, 'enterCancelled', performLeave, key);
	        mergeVNodeHook(oldData, 'delayLeave', function (leave) {
	          delayedLeave = leave;
	        }, key);
	      }
	    }
	
	    return rawChild
	  }
	};
	
	/*  */
	
	// Provides transition support for list items.
	// supports move transitions using the FLIP technique.
	
	// Because the vdom's children update algorithm is "unstable" - i.e.
	// it doesn't guarantee the relative positioning of removed elements,
	// we force transition-group to update its children into two passes:
	// in the first pass, we remove all nodes that need to be removed,
	// triggering their leaving transition; in the second pass, we insert/move
	// into the final disired state. This way in the second pass removed
	// nodes will remain where they should be.
	
	var props = extend({
	  tag: String,
	  moveClass: String
	}, transitionProps);
	
	delete props.mode;
	
	var TransitionGroup = {
	  props: props,
	
	  render: function render (h) {
	    var tag = this.tag || this.$vnode.data.tag || 'span';
	    var map = Object.create(null);
	    var prevChildren = this.prevChildren = this.children;
	    var rawChildren = this.$slots.default || [];
	    var children = this.children = [];
	    var transitionData = extractTransitionData(this);
	
	    for (var i = 0; i < rawChildren.length; i++) {
	      var c = rawChildren[i];
	      if (c.tag) {
	        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
	          children.push(c);
	          map[c.key] = c
	          ;(c.data || (c.data = {})).transition = transitionData;
	        } else {
	          var opts = c.componentOptions;
	          var name = opts
	            ? (opts.Ctor.options.name || opts.tag)
	            : c.tag;
	          warn(("<transition-group> children must be keyed: <" + name + ">"));
	        }
	      }
	    }
	
	    if (prevChildren) {
	      var kept = [];
	      var removed = [];
	      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
	        var c$1 = prevChildren[i$1];
	        c$1.data.transition = transitionData;
	        c$1.data.pos = c$1.elm.getBoundingClientRect();
	        if (map[c$1.key]) {
	          kept.push(c$1);
	        } else {
	          removed.push(c$1);
	        }
	      }
	      this.kept = h(tag, null, kept);
	      this.removed = removed;
	    }
	
	    return h(tag, null, children)
	  },
	
	  beforeUpdate: function beforeUpdate () {
	    // force removing pass
	    this.__patch__(
	      this._vnode,
	      this.kept,
	      false, // hydrating
	      true // removeOnly (!important, avoids unnecessary moves)
	    );
	    this._vnode = this.kept;
	  },
	
	  updated: function updated () {
	    var children = this.prevChildren;
	    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
	    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
	      return
	    }
	
	    // we divide the work into three loops to avoid mixing DOM reads and writes
	    // in each iteration - which helps prevent layout thrashing.
	    children.forEach(callPendingCbs);
	    children.forEach(recordPosition);
	    children.forEach(applyTranslation);
	
	    // force reflow to put everything in position
	    var f = document.body.offsetHeight; // eslint-disable-line
	
	    children.forEach(function (c) {
	      if (c.data.moved) {
	        var el = c.elm;
	        var s = el.style;
	        addTransitionClass(el, moveClass);
	        s.transform = s.WebkitTransform = s.transitionDuration = '';
	        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
	          if (!e || /transform$/.test(e.propertyName)) {
	            el.removeEventListener(transitionEndEvent, cb);
	            el._moveCb = null;
	            removeTransitionClass(el, moveClass);
	          }
	        });
	      }
	    });
	  },
	
	  methods: {
	    hasMove: function hasMove (el, moveClass) {
	      /* istanbul ignore if */
	      if (!hasTransition) {
	        return false
	      }
	      if (this._hasMove != null) {
	        return this._hasMove
	      }
	      addTransitionClass(el, moveClass);
	      var info = getTransitionInfo(el);
	      removeTransitionClass(el, moveClass);
	      return (this._hasMove = info.hasTransform)
	    }
	  }
	};
	
	function callPendingCbs (c) {
	  /* istanbul ignore if */
	  if (c.elm._moveCb) {
	    c.elm._moveCb();
	  }
	  /* istanbul ignore if */
	  if (c.elm._enterCb) {
	    c.elm._enterCb();
	  }
	}
	
	function recordPosition (c) {
	  c.data.newPos = c.elm.getBoundingClientRect();
	}
	
	function applyTranslation (c) {
	  var oldPos = c.data.pos;
	  var newPos = c.data.newPos;
	  var dx = oldPos.left - newPos.left;
	  var dy = oldPos.top - newPos.top;
	  if (dx || dy) {
	    c.data.moved = true;
	    var s = c.elm.style;
	    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
	    s.transitionDuration = '0s';
	  }
	}
	
	var platformComponents = {
	  Transition: Transition,
	  TransitionGroup: TransitionGroup
	};
	
	/*  */
	
	// install platform specific utils
	Vue$3.config.isUnknownElement = isUnknownElement;
	Vue$3.config.isReservedTag = isReservedTag;
	Vue$3.config.getTagNamespace = getTagNamespace;
	Vue$3.config.mustUseProp = mustUseProp;
	
	// install platform runtime directives & components
	extend(Vue$3.options.directives, platformDirectives);
	extend(Vue$3.options.components, platformComponents);
	
	// install platform patch function
	Vue$3.prototype.__patch__ = inBrowser ? patch$1 : noop;
	
	// wrap mount
	Vue$3.prototype.$mount = function (
	  el,
	  hydrating
	) {
	  el = el && inBrowser ? query(el) : undefined;
	  return this._mount(el, hydrating)
	};
	
	if ("development" !== 'production' &&
	    inBrowser && typeof console !== 'undefined') {
	  console[console.info ? 'info' : 'log'](
	    "You are running Vue in development mode.\n" +
	    "Make sure to turn on production mode when deploying for production.\n" +
	    "See more tips at https://vuejs.org/guide/deployment.html"
	  );
	}
	
	// devtools global hook
	/* istanbul ignore next */
	setTimeout(function () {
	  if (config.devtools) {
	    if (devtools) {
	      devtools.emit('init', Vue$3);
	    } else if (
	      "development" !== 'production' &&
	      inBrowser && !isEdge && /Chrome\/\d+/.test(window.navigator.userAgent)
	    ) {
	      console[console.info ? 'info' : 'log'](
	        'Download the Vue Devtools extension for a better development experience:\n' +
	        'https://github.com/vuejs/vue-devtools'
	      );
	    }
	  }
	}, 0);
	
	/*  */
	
	// check whether current browser encodes a char inside attribute values
	function shouldDecode (content, encoded) {
	  var div = document.createElement('div');
	  div.innerHTML = "<div a=\"" + content + "\">";
	  return div.innerHTML.indexOf(encoded) > 0
	}
	
	// #3663
	// IE encodes newlines inside attribute values while other browsers don't
	var shouldDecodeNewlines = inBrowser ? shouldDecode('\n', '&#10;') : false;
	
	/*  */
	
	var decoder;
	
	function decode (html) {
	  decoder = decoder || document.createElement('div');
	  decoder.innerHTML = html;
	  return decoder.textContent
	}
	
	/*  */
	
	var isUnaryTag = makeMap(
	  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
	  'link,meta,param,source,track,wbr',
	  true
	);
	
	// Elements that you can, intentionally, leave open
	// (and which close themselves)
	var canBeLeftOpenTag = makeMap(
	  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source',
	  true
	);
	
	// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
	// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
	var isNonPhrasingTag = makeMap(
	  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
	  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
	  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
	  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
	  'title,tr,track',
	  true
	);
	
	/**
	 * Not type-checking this file because it's mostly vendor code.
	 */
	
	/*!
	 * HTML Parser By John Resig (ejohn.org)
	 * Modified by Juriy "kangax" Zaytsev
	 * Original code by Erik Arvidsson, Mozilla Public License
	 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
	 */
	
	// Regular Expressions for parsing tags and attributes
	var singleAttrIdentifier = /([^\s"'<>/=]+)/;
	var singleAttrAssign = /(?:=)/;
	var singleAttrValues = [
	  // attr value double quotes
	  /"([^"]*)"+/.source,
	  // attr value, single quotes
	  /'([^']*)'+/.source,
	  // attr value, no quotes
	  /([^\s"'=<>`]+)/.source
	];
	var attribute = new RegExp(
	  '^\\s*' + singleAttrIdentifier.source +
	  '(?:\\s*(' + singleAttrAssign.source + ')' +
	  '\\s*(?:' + singleAttrValues.join('|') + '))?'
	);
	
	// could use https://www.w3.org/TR/1999/REC-xml-names-19990114/#NT-QName
	// but for Vue templates we can enforce a simple charset
	var ncname = '[a-zA-Z_][\\w\\-\\.]*';
	var qnameCapture = '((?:' + ncname + '\\:)?' + ncname + ')';
	var startTagOpen = new RegExp('^<' + qnameCapture);
	var startTagClose = /^\s*(\/?)>/;
	var endTag = new RegExp('^<\\/' + qnameCapture + '[^>]*>');
	var doctype = /^<!DOCTYPE [^>]+>/i;
	var comment = /^<!--/;
	var conditionalComment = /^<!\[/;
	
	var IS_REGEX_CAPTURING_BROKEN = false;
	'x'.replace(/x(.)?/g, function (m, g) {
	  IS_REGEX_CAPTURING_BROKEN = g === '';
	});
	
	// Special Elements (can contain anything)
	var isScriptOrStyle = makeMap('script,style', true);
	var hasLang = function (attr) { return attr.name === 'lang' && attr.value !== 'html'; };
	var isSpecialTag = function (tag, isSFC, stack) {
	  if (isScriptOrStyle(tag)) {
	    return true
	  }
	  if (isSFC && stack.length === 1) {
	    // top-level template that has no pre-processor
	    if (tag === 'template' && !stack[0].attrs.some(hasLang)) {
	      return false
	    } else {
	      return true
	    }
	  }
	  return false
	};
	
	var reCache = {};
	
	var ltRE = /&lt;/g;
	var gtRE = /&gt;/g;
	var nlRE = /&#10;/g;
	var ampRE = /&amp;/g;
	var quoteRE = /&quot;/g;
	
	function decodeAttr (value, shouldDecodeNewlines) {
	  if (shouldDecodeNewlines) {
	    value = value.replace(nlRE, '\n');
	  }
	  return value
	    .replace(ltRE, '<')
	    .replace(gtRE, '>')
	    .replace(ampRE, '&')
	    .replace(quoteRE, '"')
	}
	
	function parseHTML (html, options) {
	  var stack = [];
	  var expectHTML = options.expectHTML;
	  var isUnaryTag$$1 = options.isUnaryTag || no;
	  var index = 0;
	  var last, lastTag;
	  while (html) {
	    last = html;
	    // Make sure we're not in a script or style element
	    if (!lastTag || !isSpecialTag(lastTag, options.sfc, stack)) {
	      var textEnd = html.indexOf('<');
	      if (textEnd === 0) {
	        // Comment:
	        if (comment.test(html)) {
	          var commentEnd = html.indexOf('-->');
	
	          if (commentEnd >= 0) {
	            advance(commentEnd + 3);
	            continue
	          }
	        }
	
	        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
	        if (conditionalComment.test(html)) {
	          var conditionalEnd = html.indexOf(']>');
	
	          if (conditionalEnd >= 0) {
	            advance(conditionalEnd + 2);
	            continue
	          }
	        }
	
	        // Doctype:
	        var doctypeMatch = html.match(doctype);
	        if (doctypeMatch) {
	          advance(doctypeMatch[0].length);
	          continue
	        }
	
	        // End tag:
	        var endTagMatch = html.match(endTag);
	        if (endTagMatch) {
	          var curIndex = index;
	          advance(endTagMatch[0].length);
	          parseEndTag(endTagMatch[0], endTagMatch[1], curIndex, index);
	          continue
	        }
	
	        // Start tag:
	        var startTagMatch = parseStartTag();
	        if (startTagMatch) {
	          handleStartTag(startTagMatch);
	          continue
	        }
	      }
	
	      var text = (void 0), rest$1 = (void 0), next = (void 0);
	      if (textEnd > 0) {
	        rest$1 = html.slice(textEnd);
	        while (
	          !endTag.test(rest$1) &&
	          !startTagOpen.test(rest$1) &&
	          !comment.test(rest$1) &&
	          !conditionalComment.test(rest$1)
	        ) {
	          // < in plain text, be forgiving and treat it as text
	          next = rest$1.indexOf('<', 1);
	          if (next < 0) { break }
	          textEnd += next;
	          rest$1 = html.slice(textEnd);
	        }
	        text = html.substring(0, textEnd);
	        advance(textEnd);
	      }
	
	      if (textEnd < 0) {
	        text = html;
	        html = '';
	      }
	
	      if (options.chars && text) {
	        options.chars(text);
	      }
	    } else {
	      var stackedTag = lastTag.toLowerCase();
	      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
	      var endTagLength = 0;
	      var rest = html.replace(reStackedTag, function (all, text, endTag) {
	        endTagLength = endTag.length;
	        if (stackedTag !== 'script' && stackedTag !== 'style' && stackedTag !== 'noscript') {
	          text = text
	            .replace(/<!--([\s\S]*?)-->/g, '$1')
	            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
	        }
	        if (options.chars) {
	          options.chars(text);
	        }
	        return ''
	      });
	      index += html.length - rest.length;
	      html = rest;
	      parseEndTag('</' + stackedTag + '>', stackedTag, index - endTagLength, index);
	    }
	
	    if (html === last && options.chars) {
	      options.chars(html);
	      break
	    }
	  }
	
	  // Clean up any remaining tags
	  parseEndTag();
	
	  function advance (n) {
	    index += n;
	    html = html.substring(n);
	  }
	
	  function parseStartTag () {
	    var start = html.match(startTagOpen);
	    if (start) {
	      var match = {
	        tagName: start[1],
	        attrs: [],
	        start: index
	      };
	      advance(start[0].length);
	      var end, attr;
	      while (!(end = html.match(startTagClose)) && (attr = html.match(attribute))) {
	        advance(attr[0].length);
	        match.attrs.push(attr);
	      }
	      if (end) {
	        match.unarySlash = end[1];
	        advance(end[0].length);
	        match.end = index;
	        return match
	      }
	    }
	  }
	
	  function handleStartTag (match) {
	    var tagName = match.tagName;
	    var unarySlash = match.unarySlash;
	
	    if (expectHTML) {
	      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
	        parseEndTag('', lastTag);
	      }
	      if (canBeLeftOpenTag(tagName) && lastTag === tagName) {
	        parseEndTag('', tagName);
	      }
	    }
	
	    var unary = isUnaryTag$$1(tagName) || tagName === 'html' && lastTag === 'head' || !!unarySlash;
	
	    var l = match.attrs.length;
	    var attrs = new Array(l);
	    for (var i = 0; i < l; i++) {
	      var args = match.attrs[i];
	      // hackish work around FF bug https://bugzilla.mozilla.org/show_bug.cgi?id=369778
	      if (IS_REGEX_CAPTURING_BROKEN && args[0].indexOf('""') === -1) {
	        if (args[3] === '') { delete args[3]; }
	        if (args[4] === '') { delete args[4]; }
	        if (args[5] === '') { delete args[5]; }
	      }
	      var value = args[3] || args[4] || args[5] || '';
	      attrs[i] = {
	        name: args[1],
	        value: decodeAttr(
	          value,
	          options.shouldDecodeNewlines
	        )
	      };
	    }
	
	    if (!unary) {
	      stack.push({ tag: tagName, attrs: attrs });
	      lastTag = tagName;
	      unarySlash = '';
	    }
	
	    if (options.start) {
	      options.start(tagName, attrs, unary, match.start, match.end);
	    }
	  }
	
	  function parseEndTag (tag, tagName, start, end) {
	    var pos;
	    if (start == null) { start = index; }
	    if (end == null) { end = index; }
	
	    // Find the closest opened tag of the same type
	    if (tagName) {
	      var needle = tagName.toLowerCase();
	      for (pos = stack.length - 1; pos >= 0; pos--) {
	        if (stack[pos].tag.toLowerCase() === needle) {
	          break
	        }
	      }
	    } else {
	      // If no tag name is provided, clean shop
	      pos = 0;
	    }
	
	    if (pos >= 0) {
	      // Close all the open elements, up the stack
	      for (var i = stack.length - 1; i >= pos; i--) {
	        if (options.end) {
	          options.end(stack[i].tag, start, end);
	        }
	      }
	
	      // Remove the open elements from the stack
	      stack.length = pos;
	      lastTag = pos && stack[pos - 1].tag;
	    } else if (tagName.toLowerCase() === 'br') {
	      if (options.start) {
	        options.start(tagName, [], true, start, end);
	      }
	    } else if (tagName.toLowerCase() === 'p') {
	      if (options.start) {
	        options.start(tagName, [], false, start, end);
	      }
	      if (options.end) {
	        options.end(tagName, start, end);
	      }
	    }
	  }
	}
	
	/*  */
	
	function parseFilters (exp) {
	  var inSingle = false;
	  var inDouble = false;
	  var inTemplateString = false;
	  var inRegex = false;
	  var curly = 0;
	  var square = 0;
	  var paren = 0;
	  var lastFilterIndex = 0;
	  var c, prev, i, expression, filters;
	
	  for (i = 0; i < exp.length; i++) {
	    prev = c;
	    c = exp.charCodeAt(i);
	    if (inSingle) {
	      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
	    } else if (inDouble) {
	      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
	    } else if (inTemplateString) {
	      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
	    } else if (inRegex) {
	      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
	    } else if (
	      c === 0x7C && // pipe
	      exp.charCodeAt(i + 1) !== 0x7C &&
	      exp.charCodeAt(i - 1) !== 0x7C &&
	      !curly && !square && !paren
	    ) {
	      if (expression === undefined) {
	        // first filter, end of expression
	        lastFilterIndex = i + 1;
	        expression = exp.slice(0, i).trim();
	      } else {
	        pushFilter();
	      }
	    } else {
	      switch (c) {
	        case 0x22: inDouble = true; break         // "
	        case 0x27: inSingle = true; break         // '
	        case 0x60: inTemplateString = true; break // `
	        case 0x28: paren++; break                 // (
	        case 0x29: paren--; break                 // )
	        case 0x5B: square++; break                // [
	        case 0x5D: square--; break                // ]
	        case 0x7B: curly++; break                 // {
	        case 0x7D: curly--; break                 // }
	      }
	      if (c === 0x2f) { // /
	        var j = i - 1;
	        var p = (void 0);
	        // find first non-whitespace prev char
	        for (; j >= 0; j--) {
	          p = exp.charAt(j);
	          if (p !== ' ') { break }
	        }
	        if (!p || !/[\w$]/.test(p)) {
	          inRegex = true;
	        }
	      }
	    }
	  }
	
	  if (expression === undefined) {
	    expression = exp.slice(0, i).trim();
	  } else if (lastFilterIndex !== 0) {
	    pushFilter();
	  }
	
	  function pushFilter () {
	    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
	    lastFilterIndex = i + 1;
	  }
	
	  if (filters) {
	    for (i = 0; i < filters.length; i++) {
	      expression = wrapFilter(expression, filters[i]);
	    }
	  }
	
	  return expression
	}
	
	function wrapFilter (exp, filter) {
	  var i = filter.indexOf('(');
	  if (i < 0) {
	    // _f: resolveFilter
	    return ("_f(\"" + filter + "\")(" + exp + ")")
	  } else {
	    var name = filter.slice(0, i);
	    var args = filter.slice(i + 1);
	    return ("_f(\"" + name + "\")(" + exp + "," + args)
	  }
	}
	
	/*  */
	
	var defaultTagRE = /\{\{((?:.|\n)+?)\}\}/g;
	var regexEscapeRE = /[-.*+?^${}()|[\]/\\]/g;
	
	var buildRegex = cached(function (delimiters) {
	  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
	  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
	  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
	});
	
	function parseText (
	  text,
	  delimiters
	) {
	  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
	  if (!tagRE.test(text)) {
	    return
	  }
	  var tokens = [];
	  var lastIndex = tagRE.lastIndex = 0;
	  var match, index;
	  while ((match = tagRE.exec(text))) {
	    index = match.index;
	    // push text token
	    if (index > lastIndex) {
	      tokens.push(JSON.stringify(text.slice(lastIndex, index)));
	    }
	    // tag token
	    var exp = parseFilters(match[1].trim());
	    tokens.push(("_s(" + exp + ")"));
	    lastIndex = index + match[0].length;
	  }
	  if (lastIndex < text.length) {
	    tokens.push(JSON.stringify(text.slice(lastIndex)));
	  }
	  return tokens.join('+')
	}
	
	/*  */
	
	function baseWarn (msg) {
	  console.error(("[Vue parser]: " + msg));
	}
	
	function pluckModuleFunction (
	  modules,
	  key
	) {
	  return modules
	    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
	    : []
	}
	
	function addProp (el, name, value) {
	  (el.props || (el.props = [])).push({ name: name, value: value });
	}
	
	function addAttr (el, name, value) {
	  (el.attrs || (el.attrs = [])).push({ name: name, value: value });
	}
	
	function addDirective (
	  el,
	  name,
	  rawName,
	  value,
	  arg,
	  modifiers
	) {
	  (el.directives || (el.directives = [])).push({ name: name, rawName: rawName, value: value, arg: arg, modifiers: modifiers });
	}
	
	function addHandler (
	  el,
	  name,
	  value,
	  modifiers,
	  important
	) {
	  // check capture modifier
	  if (modifiers && modifiers.capture) {
	    delete modifiers.capture;
	    name = '!' + name; // mark the event as captured
	  }
	  if (modifiers && modifiers.once) {
	    delete modifiers.once;
	    name = '~' + name; // mark the event as once
	  }
	  var events;
	  if (modifiers && modifiers.native) {
	    delete modifiers.native;
	    events = el.nativeEvents || (el.nativeEvents = {});
	  } else {
	    events = el.events || (el.events = {});
	  }
	  var newHandler = { value: value, modifiers: modifiers };
	  var handlers = events[name];
	  /* istanbul ignore if */
	  if (Array.isArray(handlers)) {
	    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
	  } else if (handlers) {
	    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
	  } else {
	    events[name] = newHandler;
	  }
	}
	
	function getBindingAttr (
	  el,
	  name,
	  getStatic
	) {
	  var dynamicValue =
	    getAndRemoveAttr(el, ':' + name) ||
	    getAndRemoveAttr(el, 'v-bind:' + name);
	  if (dynamicValue != null) {
	    return parseFilters(dynamicValue)
	  } else if (getStatic !== false) {
	    var staticValue = getAndRemoveAttr(el, name);
	    if (staticValue != null) {
	      return JSON.stringify(staticValue)
	    }
	  }
	}
	
	function getAndRemoveAttr (el, name) {
	  var val;
	  if ((val = el.attrsMap[name]) != null) {
	    var list = el.attrsList;
	    for (var i = 0, l = list.length; i < l; i++) {
	      if (list[i].name === name) {
	        list.splice(i, 1);
	        break
	      }
	    }
	  }
	  return val
	}
	
	var len;
	var str;
	var chr;
	var index$1;
	var expressionPos;
	var expressionEndPos;
	
	/**
	 * parse directive model to do the array update transform. a[idx] = val => $$a.splice($$idx, 1, val)
	 *
	 * for loop possible cases:
	 *
	 * - test
	 * - test[idx]
	 * - test[test1[idx]]
	 * - test["a"][idx]
	 * - xxx.test[a[a].test1[idx]]
	 * - test.xxx.a["asa"][test1[idx]]
	 *
	 */
	
	function parseModel (val) {
	  str = val;
	  len = str.length;
	  index$1 = expressionPos = expressionEndPos = 0;
	
	  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
	    return {
	      exp: val,
	      idx: null
	    }
	  }
	
	  while (!eof()) {
	    chr = next();
	    /* istanbul ignore if */
	    if (isStringStart(chr)) {
	      parseString(chr);
	    } else if (chr === 0x5B) {
	      parseBracket(chr);
	    }
	  }
	
	  return {
	    exp: val.substring(0, expressionPos),
	    idx: val.substring(expressionPos + 1, expressionEndPos)
	  }
	}
	
	function next () {
	  return str.charCodeAt(++index$1)
	}
	
	function eof () {
	  return index$1 >= len
	}
	
	function isStringStart (chr) {
	  return chr === 0x22 || chr === 0x27
	}
	
	function parseBracket (chr) {
	  var inBracket = 1;
	  expressionPos = index$1;
	  while (!eof()) {
	    chr = next();
	    if (isStringStart(chr)) {
	      parseString(chr);
	      continue
	    }
	    if (chr === 0x5B) { inBracket++; }
	    if (chr === 0x5D) { inBracket--; }
	    if (inBracket === 0) {
	      expressionEndPos = index$1;
	      break
	    }
	  }
	}
	
	function parseString (chr) {
	  var stringQuote = chr;
	  while (!eof()) {
	    chr = next();
	    if (chr === stringQuote) {
	      break
	    }
	  }
	}
	
	/*  */
	
	var dirRE = /^v-|^@|^:/;
	var forAliasRE = /(.*?)\s+(?:in|of)\s+(.*)/;
	var forIteratorRE = /\((\{[^}]*\}|[^,]*),([^,]*)(?:,([^,]*))?\)/;
	var bindRE = /^:|^v-bind:/;
	var onRE = /^@|^v-on:/;
	var argRE = /:(.*)$/;
	var modifierRE = /\.[^.]+/g;
	
	var decodeHTMLCached = cached(decode);
	
	// configurable state
	var warn$1;
	var platformGetTagNamespace;
	var platformMustUseProp;
	var platformIsPreTag;
	var preTransforms;
	var transforms;
	var postTransforms;
	var delimiters;
	
	/**
	 * Convert HTML string to AST.
	 */
	function parse (
	  template,
	  options
	) {
	  warn$1 = options.warn || baseWarn;
	  platformGetTagNamespace = options.getTagNamespace || no;
	  platformMustUseProp = options.mustUseProp || no;
	  platformIsPreTag = options.isPreTag || no;
	  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
	  transforms = pluckModuleFunction(options.modules, 'transformNode');
	  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');
	  delimiters = options.delimiters;
	  var stack = [];
	  var preserveWhitespace = options.preserveWhitespace !== false;
	  var root;
	  var currentParent;
	  var inVPre = false;
	  var inPre = false;
	  var warned = false;
	  parseHTML(template, {
	    expectHTML: options.expectHTML,
	    isUnaryTag: options.isUnaryTag,
	    shouldDecodeNewlines: options.shouldDecodeNewlines,
	    start: function start (tag, attrs, unary) {
	      // check namespace.
	      // inherit parent ns if there is one
	      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);
	
	      // handle IE svg bug
	      /* istanbul ignore if */
	      if (isIE && ns === 'svg') {
	        attrs = guardIESVGBug(attrs);
	      }
	
	      var element = {
	        type: 1,
	        tag: tag,
	        attrsList: attrs,
	        attrsMap: makeAttrsMap(attrs),
	        parent: currentParent,
	        children: []
	      };
	      if (ns) {
	        element.ns = ns;
	      }
	
	      if (isForbiddenTag(element) && !isServerRendering()) {
	        element.forbidden = true;
	        "development" !== 'production' && warn$1(
	          'Templates should only be responsible for mapping the state to the ' +
	          'UI. Avoid placing tags with side-effects in your templates, such as ' +
	          "<" + tag + ">" + ', as they will not be parsed.'
	        );
	      }
	
	      // apply pre-transforms
	      for (var i = 0; i < preTransforms.length; i++) {
	        preTransforms[i](element, options);
	      }
	
	      if (!inVPre) {
	        processPre(element);
	        if (element.pre) {
	          inVPre = true;
	        }
	      }
	      if (platformIsPreTag(element.tag)) {
	        inPre = true;
	      }
	      if (inVPre) {
	        processRawAttrs(element);
	      } else {
	        processFor(element);
	        processIf(element);
	        processOnce(element);
	        processKey(element);
	
	        // determine whether this is a plain element after
	        // removing structural attributes
	        element.plain = !element.key && !attrs.length;
	
	        processRef(element);
	        processSlot(element);
	        processComponent(element);
	        for (var i$1 = 0; i$1 < transforms.length; i$1++) {
	          transforms[i$1](element, options);
	        }
	        processAttrs(element);
	      }
	
	      function checkRootConstraints (el) {
	        if ("development" !== 'production' && !warned) {
	          if (el.tag === 'slot' || el.tag === 'template') {
	            warned = true;
	            warn$1(
	              "Cannot use <" + (el.tag) + "> as component root element because it may " +
	              'contain multiple nodes:\n' + template
	            );
	          }
	          if (el.attrsMap.hasOwnProperty('v-for')) {
	            warned = true;
	            warn$1(
	              'Cannot use v-for on stateful component root element because ' +
	              'it renders multiple elements:\n' + template
	            );
	          }
	        }
	      }
	
	      // tree management
	      if (!root) {
	        root = element;
	        checkRootConstraints(root);
	      } else if (!stack.length) {
	        // allow root elements with v-if, v-else-if and v-else
	        if (root.if && (element.elseif || element.else)) {
	          checkRootConstraints(element);
	          addIfCondition(root, {
	            exp: element.elseif,
	            block: element
	          });
	        } else if ("development" !== 'production' && !warned) {
	          warned = true;
	          warn$1(
	            "Component template should contain exactly one root element:" +
	            "\n\n" + template + "\n\n" +
	            "If you are using v-if on multiple elements, " +
	            "use v-else-if to chain them instead."
	          );
	        }
	      }
	      if (currentParent && !element.forbidden) {
	        if (element.elseif || element.else) {
	          processIfConditions(element, currentParent);
	        } else if (element.slotScope) { // scoped slot
	          currentParent.plain = false;
	          var name = element.slotTarget || 'default';(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
	        } else {
	          currentParent.children.push(element);
	          element.parent = currentParent;
	        }
	      }
	      if (!unary) {
	        currentParent = element;
	        stack.push(element);
	      }
	      // apply post-transforms
	      for (var i$2 = 0; i$2 < postTransforms.length; i$2++) {
	        postTransforms[i$2](element, options);
	      }
	    },
	
	    end: function end () {
	      // remove trailing whitespace
	      var element = stack[stack.length - 1];
	      var lastNode = element.children[element.children.length - 1];
	      if (lastNode && lastNode.type === 3 && lastNode.text === ' ') {
	        element.children.pop();
	      }
	      // pop stack
	      stack.length -= 1;
	      currentParent = stack[stack.length - 1];
	      // check pre state
	      if (element.pre) {
	        inVPre = false;
	      }
	      if (platformIsPreTag(element.tag)) {
	        inPre = false;
	      }
	    },
	
	    chars: function chars (text) {
	      if (!currentParent) {
	        if ("development" !== 'production' && !warned && text === template) {
	          warned = true;
	          warn$1(
	            'Component template requires a root element, rather than just text:\n\n' + template
	          );
	        }
	        return
	      }
	      // IE textarea placeholder bug
	      /* istanbul ignore if */
	      if (isIE &&
	          currentParent.tag === 'textarea' &&
	          currentParent.attrsMap.placeholder === text) {
	        return
	      }
	      var children = currentParent.children;
	      text = inPre || text.trim()
	        ? decodeHTMLCached(text)
	        // only preserve whitespace if its not right after a starting tag
	        : preserveWhitespace && children.length ? ' ' : '';
	      if (text) {
	        var expression;
	        if (!inVPre && text !== ' ' && (expression = parseText(text, delimiters))) {
	          children.push({
	            type: 2,
	            expression: expression,
	            text: text
	          });
	        } else if (text !== ' ' || children[children.length - 1].text !== ' ') {
	          currentParent.children.push({
	            type: 3,
	            text: text
	          });
	        }
	      }
	    }
	  });
	  return root
	}
	
	function processPre (el) {
	  if (getAndRemoveAttr(el, 'v-pre') != null) {
	    el.pre = true;
	  }
	}
	
	function processRawAttrs (el) {
	  var l = el.attrsList.length;
	  if (l) {
	    var attrs = el.attrs = new Array(l);
	    for (var i = 0; i < l; i++) {
	      attrs[i] = {
	        name: el.attrsList[i].name,
	        value: JSON.stringify(el.attrsList[i].value)
	      };
	    }
	  } else if (!el.pre) {
	    // non root node in pre blocks with no attributes
	    el.plain = true;
	  }
	}
	
	function processKey (el) {
	  var exp = getBindingAttr(el, 'key');
	  if (exp) {
	    if ("development" !== 'production' && el.tag === 'template') {
	      warn$1("<template> cannot be keyed. Place the key on real elements instead.");
	    }
	    el.key = exp;
	  }
	}
	
	function processRef (el) {
	  var ref = getBindingAttr(el, 'ref');
	  if (ref) {
	    el.ref = ref;
	    el.refInFor = checkInFor(el);
	  }
	}
	
	function processFor (el) {
	  var exp;
	  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
	    var inMatch = exp.match(forAliasRE);
	    if (!inMatch) {
	      "development" !== 'production' && warn$1(
	        ("Invalid v-for expression: " + exp)
	      );
	      return
	    }
	    el.for = inMatch[2].trim();
	    var alias = inMatch[1].trim();
	    var iteratorMatch = alias.match(forIteratorRE);
	    if (iteratorMatch) {
	      el.alias = iteratorMatch[1].trim();
	      el.iterator1 = iteratorMatch[2].trim();
	      if (iteratorMatch[3]) {
	        el.iterator2 = iteratorMatch[3].trim();
	      }
	    } else {
	      el.alias = alias;
	    }
	  }
	}
	
	function processIf (el) {
	  var exp = getAndRemoveAttr(el, 'v-if');
	  if (exp) {
	    el.if = exp;
	    addIfCondition(el, {
	      exp: exp,
	      block: el
	    });
	  } else {
	    if (getAndRemoveAttr(el, 'v-else') != null) {
	      el.else = true;
	    }
	    var elseif = getAndRemoveAttr(el, 'v-else-if');
	    if (elseif) {
	      el.elseif = elseif;
	    }
	  }
	}
	
	function processIfConditions (el, parent) {
	  var prev = findPrevElement(parent.children);
	  if (prev && prev.if) {
	    addIfCondition(prev, {
	      exp: el.elseif,
	      block: el
	    });
	  } else {
	    warn$1(
	      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
	      "used on element <" + (el.tag) + "> without corresponding v-if."
	    );
	  }
	}
	
	function findPrevElement (children) {
	  var i = children.length;
	  while (i--) {
	    if (children[i].type === 1) {
	      return children[i]
	    } else {
	      if ("development" !== 'production' && children[i].text !== ' ') {
	        warn$1(
	          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
	          "will be ignored."
	        );
	      }
	      children.pop();
	    }
	  }
	}
	
	function addIfCondition (el, condition) {
	  if (!el.ifConditions) {
	    el.ifConditions = [];
	  }
	  el.ifConditions.push(condition);
	}
	
	function processOnce (el) {
	  var once = getAndRemoveAttr(el, 'v-once');
	  if (once != null) {
	    el.once = true;
	  }
	}
	
	function processSlot (el) {
	  if (el.tag === 'slot') {
	    el.slotName = getBindingAttr(el, 'name');
	    if ("development" !== 'production' && el.key) {
	      warn$1(
	        "`key` does not work on <slot> because slots are abstract outlets " +
	        "and can possibly expand into multiple elements. " +
	        "Use the key on a wrapping element instead."
	      );
	    }
	  } else {
	    var slotTarget = getBindingAttr(el, 'slot');
	    if (slotTarget) {
	      el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
	    }
	    if (el.tag === 'template') {
	      el.slotScope = getAndRemoveAttr(el, 'scope');
	    }
	  }
	}
	
	function processComponent (el) {
	  var binding;
	  if ((binding = getBindingAttr(el, 'is'))) {
	    el.component = binding;
	  }
	  if (getAndRemoveAttr(el, 'inline-template') != null) {
	    el.inlineTemplate = true;
	  }
	}
	
	function processAttrs (el) {
	  var list = el.attrsList;
	  var i, l, name, rawName, value, arg, modifiers, isProp;
	  for (i = 0, l = list.length; i < l; i++) {
	    name = rawName = list[i].name;
	    value = list[i].value;
	    if (dirRE.test(name)) {
	      // mark element as dynamic
	      el.hasBindings = true;
	      // modifiers
	      modifiers = parseModifiers(name);
	      if (modifiers) {
	        name = name.replace(modifierRE, '');
	      }
	      if (bindRE.test(name)) { // v-bind
	        name = name.replace(bindRE, '');
	        value = parseFilters(value);
	        isProp = false;
	        if (modifiers) {
	          if (modifiers.prop) {
	            isProp = true;
	            name = camelize(name);
	            if (name === 'innerHtml') { name = 'innerHTML'; }
	          }
	          if (modifiers.camel) {
	            name = camelize(name);
	          }
	        }
	        if (isProp || platformMustUseProp(el.tag, name)) {
	          addProp(el, name, value);
	        } else {
	          addAttr(el, name, value);
	        }
	      } else if (onRE.test(name)) { // v-on
	        name = name.replace(onRE, '');
	        addHandler(el, name, value, modifiers);
	      } else { // normal directives
	        name = name.replace(dirRE, '');
	        // parse arg
	        var argMatch = name.match(argRE);
	        if (argMatch && (arg = argMatch[1])) {
	          name = name.slice(0, -(arg.length + 1));
	        }
	        addDirective(el, name, rawName, value, arg, modifiers);
	        if ("development" !== 'production' && name === 'model') {
	          checkForAliasModel(el, value);
	        }
	      }
	    } else {
	      // literal attribute
	      {
	        var expression = parseText(value, delimiters);
	        if (expression) {
	          warn$1(
	            name + "=\"" + value + "\": " +
	            'Interpolation inside attributes has been removed. ' +
	            'Use v-bind or the colon shorthand instead. For example, ' +
	            'instead of <div id="{{ val }}">, use <div :id="val">.'
	          );
	        }
	      }
	      addAttr(el, name, JSON.stringify(value));
	      // #4530 also bind special attributes as props even if they are static
	      // so that patches between dynamic/static are consistent
	      if (platformMustUseProp(el.tag, name)) {
	        if (name === 'value') {
	          addProp(el, name, JSON.stringify(value));
	        } else {
	          addProp(el, name, 'true');
	        }
	      }
	    }
	  }
	}
	
	function checkInFor (el) {
	  var parent = el;
	  while (parent) {
	    if (parent.for !== undefined) {
	      return true
	    }
	    parent = parent.parent;
	  }
	  return false
	}
	
	function parseModifiers (name) {
	  var match = name.match(modifierRE);
	  if (match) {
	    var ret = {};
	    match.forEach(function (m) { ret[m.slice(1)] = true; });
	    return ret
	  }
	}
	
	function makeAttrsMap (attrs) {
	  var map = {};
	  for (var i = 0, l = attrs.length; i < l; i++) {
	    if ("development" !== 'production' && map[attrs[i].name] && !isIE) {
	      warn$1('duplicate attribute: ' + attrs[i].name);
	    }
	    map[attrs[i].name] = attrs[i].value;
	  }
	  return map
	}
	
	function isForbiddenTag (el) {
	  return (
	    el.tag === 'style' ||
	    (el.tag === 'script' && (
	      !el.attrsMap.type ||
	      el.attrsMap.type === 'text/javascript'
	    ))
	  )
	}
	
	var ieNSBug = /^xmlns:NS\d+/;
	var ieNSPrefix = /^NS\d+:/;
	
	/* istanbul ignore next */
	function guardIESVGBug (attrs) {
	  var res = [];
	  for (var i = 0; i < attrs.length; i++) {
	    var attr = attrs[i];
	    if (!ieNSBug.test(attr.name)) {
	      attr.name = attr.name.replace(ieNSPrefix, '');
	      res.push(attr);
	    }
	  }
	  return res
	}
	
	function checkForAliasModel (el, value) {
	  var _el = el;
	  while (_el) {
	    if (_el.for && _el.alias === value) {
	      warn$1(
	        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
	        "You are binding v-model directly to a v-for iteration alias. " +
	        "This will not be able to modify the v-for source array because " +
	        "writing to the alias is like modifying a function local variable. " +
	        "Consider using an array of objects and use v-model on an object property instead."
	      );
	    }
	    _el = _el.parent;
	  }
	}
	
	/*  */
	
	var isStaticKey;
	var isPlatformReservedTag;
	
	var genStaticKeysCached = cached(genStaticKeys$1);
	
	/**
	 * Goal of the optimizer: walk the generated template AST tree
	 * and detect sub-trees that are purely static, i.e. parts of
	 * the DOM that never needs to change.
	 *
	 * Once we detect these sub-trees, we can:
	 *
	 * 1. Hoist them into constants, so that we no longer need to
	 *    create fresh nodes for them on each re-render;
	 * 2. Completely skip them in the patching process.
	 */
	function optimize (root, options) {
	  if (!root) { return }
	  isStaticKey = genStaticKeysCached(options.staticKeys || '');
	  isPlatformReservedTag = options.isReservedTag || no;
	  // first pass: mark all non-static nodes.
	  markStatic(root);
	  // second pass: mark static roots.
	  markStaticRoots(root, false);
	}
	
	function genStaticKeys$1 (keys) {
	  return makeMap(
	    'type,tag,attrsList,attrsMap,plain,parent,children,attrs' +
	    (keys ? ',' + keys : '')
	  )
	}
	
	function markStatic (node) {
	  node.static = isStatic(node);
	  if (node.type === 1) {
	    // do not make component slot content static. this avoids
	    // 1. components not able to mutate slot nodes
	    // 2. static slot content fails for hot-reloading
	    if (
	      !isPlatformReservedTag(node.tag) &&
	      node.tag !== 'slot' &&
	      node.attrsMap['inline-template'] == null
	    ) {
	      return
	    }
	    for (var i = 0, l = node.children.length; i < l; i++) {
	      var child = node.children[i];
	      markStatic(child);
	      if (!child.static) {
	        node.static = false;
	      }
	    }
	  }
	}
	
	function markStaticRoots (node, isInFor) {
	  if (node.type === 1) {
	    if (node.static || node.once) {
	      node.staticInFor = isInFor;
	    }
	    // For a node to qualify as a static root, it should have children that
	    // are not just static text. Otherwise the cost of hoisting out will
	    // outweigh the benefits and it's better off to just always render it fresh.
	    if (node.static && node.children.length && !(
	      node.children.length === 1 &&
	      node.children[0].type === 3
	    )) {
	      node.staticRoot = true;
	      return
	    } else {
	      node.staticRoot = false;
	    }
	    if (node.children) {
	      for (var i = 0, l = node.children.length; i < l; i++) {
	        markStaticRoots(node.children[i], isInFor || !!node.for);
	      }
	    }
	    if (node.ifConditions) {
	      walkThroughConditionsBlocks(node.ifConditions, isInFor);
	    }
	  }
	}
	
	function walkThroughConditionsBlocks (conditionBlocks, isInFor) {
	  for (var i = 1, len = conditionBlocks.length; i < len; i++) {
	    markStaticRoots(conditionBlocks[i].block, isInFor);
	  }
	}
	
	function isStatic (node) {
	  if (node.type === 2) { // expression
	    return false
	  }
	  if (node.type === 3) { // text
	    return true
	  }
	  return !!(node.pre || (
	    !node.hasBindings && // no dynamic bindings
	    !node.if && !node.for && // not v-if or v-for or v-else
	    !isBuiltInTag(node.tag) && // not a built-in
	    isPlatformReservedTag(node.tag) && // not a component
	    !isDirectChildOfTemplateFor(node) &&
	    Object.keys(node).every(isStaticKey)
	  ))
	}
	
	function isDirectChildOfTemplateFor (node) {
	  while (node.parent) {
	    node = node.parent;
	    if (node.tag !== 'template') {
	      return false
	    }
	    if (node.for) {
	      return true
	    }
	  }
	  return false
	}
	
	/*  */
	
	var fnExpRE = /^\s*([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/;
	var simplePathRE = /^\s*[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['.*?']|\[".*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*\s*$/;
	
	// keyCode aliases
	var keyCodes = {
	  esc: 27,
	  tab: 9,
	  enter: 13,
	  space: 32,
	  up: 38,
	  left: 37,
	  right: 39,
	  down: 40,
	  'delete': [8, 46]
	};
	
	var modifierCode = {
	  stop: '$event.stopPropagation();',
	  prevent: '$event.preventDefault();',
	  self: 'if($event.target !== $event.currentTarget)return;',
	  ctrl: 'if(!$event.ctrlKey)return;',
	  shift: 'if(!$event.shiftKey)return;',
	  alt: 'if(!$event.altKey)return;',
	  meta: 'if(!$event.metaKey)return;'
	};
	
	function genHandlers (events, native) {
	  var res = native ? 'nativeOn:{' : 'on:{';
	  for (var name in events) {
	    res += "\"" + name + "\":" + (genHandler(name, events[name])) + ",";
	  }
	  return res.slice(0, -1) + '}'
	}
	
	function genHandler (
	  name,
	  handler
	) {
	  if (!handler) {
	    return 'function(){}'
	  } else if (Array.isArray(handler)) {
	    return ("[" + (handler.map(function (handler) { return genHandler(name, handler); }).join(',')) + "]")
	  } else if (!handler.modifiers) {
	    return fnExpRE.test(handler.value) || simplePathRE.test(handler.value)
	      ? handler.value
	      : ("function($event){" + (handler.value) + "}")
	  } else {
	    var code = '';
	    var keys = [];
	    for (var key in handler.modifiers) {
	      if (modifierCode[key]) {
	        code += modifierCode[key];
	      } else {
	        keys.push(key);
	      }
	    }
	    if (keys.length) {
	      code = genKeyFilter(keys) + code;
	    }
	    var handlerCode = simplePathRE.test(handler.value)
	      ? handler.value + '($event)'
	      : handler.value;
	    return 'function($event){' + code + handlerCode + '}'
	  }
	}
	
	function genKeyFilter (keys) {
	  return ("if(" + (keys.map(genFilterCode).join('&&')) + ")return;")
	}
	
	function genFilterCode (key) {
	  var keyVal = parseInt(key, 10);
	  if (keyVal) {
	    return ("$event.keyCode!==" + keyVal)
	  }
	  var alias = keyCodes[key];
	  return ("_k($event.keyCode," + (JSON.stringify(key)) + (alias ? ',' + JSON.stringify(alias) : '') + ")")
	}
	
	/*  */
	
	function bind$2 (el, dir) {
	  el.wrapData = function (code) {
	    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + (dir.modifiers && dir.modifiers.prop ? ',true' : '') + ")")
	  };
	}
	
	/*  */
	
	var baseDirectives = {
	  bind: bind$2,
	  cloak: noop
	};
	
	/*  */
	
	// configurable state
	var warn$2;
	var transforms$1;
	var dataGenFns;
	var platformDirectives$1;
	var isPlatformReservedTag$1;
	var staticRenderFns;
	var onceCount;
	var currentOptions;
	
	function generate (
	  ast,
	  options
	) {
	  // save previous staticRenderFns so generate calls can be nested
	  var prevStaticRenderFns = staticRenderFns;
	  var currentStaticRenderFns = staticRenderFns = [];
	  var prevOnceCount = onceCount;
	  onceCount = 0;
	  currentOptions = options;
	  warn$2 = options.warn || baseWarn;
	  transforms$1 = pluckModuleFunction(options.modules, 'transformCode');
	  dataGenFns = pluckModuleFunction(options.modules, 'genData');
	  platformDirectives$1 = options.directives || {};
	  isPlatformReservedTag$1 = options.isReservedTag || no;
	  var code = ast ? genElement(ast) : '_c("div")';
	  staticRenderFns = prevStaticRenderFns;
	  onceCount = prevOnceCount;
	  return {
	    render: ("with(this){return " + code + "}"),
	    staticRenderFns: currentStaticRenderFns
	  }
	}
	
	function genElement (el) {
	  if (el.staticRoot && !el.staticProcessed) {
	    return genStatic(el)
	  } else if (el.once && !el.onceProcessed) {
	    return genOnce(el)
	  } else if (el.for && !el.forProcessed) {
	    return genFor(el)
	  } else if (el.if && !el.ifProcessed) {
	    return genIf(el)
	  } else if (el.tag === 'template' && !el.slotTarget) {
	    return genChildren(el) || 'void 0'
	  } else if (el.tag === 'slot') {
	    return genSlot(el)
	  } else {
	    // component or element
	    var code;
	    if (el.component) {
	      code = genComponent(el.component, el);
	    } else {
	      var data = el.plain ? undefined : genData(el);
	
	      var children = el.inlineTemplate ? null : genChildren(el, true);
	      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
	    }
	    // module transforms
	    for (var i = 0; i < transforms$1.length; i++) {
	      code = transforms$1[i](el, code);
	    }
	    return code
	  }
	}
	
	// hoist static sub-trees out
	function genStatic (el) {
	  el.staticProcessed = true;
	  staticRenderFns.push(("with(this){return " + (genElement(el)) + "}"));
	  return ("_m(" + (staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
	}
	
	// v-once
	function genOnce (el) {
	  el.onceProcessed = true;
	  if (el.if && !el.ifProcessed) {
	    return genIf(el)
	  } else if (el.staticInFor) {
	    var key = '';
	    var parent = el.parent;
	    while (parent) {
	      if (parent.for) {
	        key = parent.key;
	        break
	      }
	      parent = parent.parent;
	    }
	    if (!key) {
	      "development" !== 'production' && warn$2(
	        "v-once can only be used inside v-for that is keyed. "
	      );
	      return genElement(el)
	    }
	    return ("_o(" + (genElement(el)) + "," + (onceCount++) + (key ? ("," + key) : "") + ")")
	  } else {
	    return genStatic(el)
	  }
	}
	
	function genIf (el) {
	  el.ifProcessed = true; // avoid recursion
	  return genIfConditions(el.ifConditions.slice())
	}
	
	function genIfConditions (conditions) {
	  if (!conditions.length) {
	    return '_e()'
	  }
	
	  var condition = conditions.shift();
	  if (condition.exp) {
	    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions)))
	  } else {
	    return ("" + (genTernaryExp(condition.block)))
	  }
	
	  // v-if with v-once should generate code like (a)?_m(0):_m(1)
	  function genTernaryExp (el) {
	    return el.once ? genOnce(el) : genElement(el)
	  }
	}
	
	function genFor (el) {
	  var exp = el.for;
	  var alias = el.alias;
	  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
	  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';
	  el.forProcessed = true; // avoid recursion
	  return "_l((" + exp + ")," +
	    "function(" + alias + iterator1 + iterator2 + "){" +
	      "return " + (genElement(el)) +
	    '})'
	}
	
	function genData (el) {
	  var data = '{';
	
	  // directives first.
	  // directives may mutate the el's other properties before they are generated.
	  var dirs = genDirectives(el);
	  if (dirs) { data += dirs + ','; }
	
	  // key
	  if (el.key) {
	    data += "key:" + (el.key) + ",";
	  }
	  // ref
	  if (el.ref) {
	    data += "ref:" + (el.ref) + ",";
	  }
	  if (el.refInFor) {
	    data += "refInFor:true,";
	  }
	  // pre
	  if (el.pre) {
	    data += "pre:true,";
	  }
	  // record original tag name for components using "is" attribute
	  if (el.component) {
	    data += "tag:\"" + (el.tag) + "\",";
	  }
	  // module data generation functions
	  for (var i = 0; i < dataGenFns.length; i++) {
	    data += dataGenFns[i](el);
	  }
	  // attributes
	  if (el.attrs) {
	    data += "attrs:{" + (genProps(el.attrs)) + "},";
	  }
	  // DOM props
	  if (el.props) {
	    data += "domProps:{" + (genProps(el.props)) + "},";
	  }
	  // event handlers
	  if (el.events) {
	    data += (genHandlers(el.events)) + ",";
	  }
	  if (el.nativeEvents) {
	    data += (genHandlers(el.nativeEvents, true)) + ",";
	  }
	  // slot target
	  if (el.slotTarget) {
	    data += "slot:" + (el.slotTarget) + ",";
	  }
	  // scoped slots
	  if (el.scopedSlots) {
	    data += (genScopedSlots(el.scopedSlots)) + ",";
	  }
	  // inline-template
	  if (el.inlineTemplate) {
	    var inlineTemplate = genInlineTemplate(el);
	    if (inlineTemplate) {
	      data += inlineTemplate + ",";
	    }
	  }
	  data = data.replace(/,$/, '') + '}';
	  // v-bind data wrap
	  if (el.wrapData) {
	    data = el.wrapData(data);
	  }
	  return data
	}
	
	function genDirectives (el) {
	  var dirs = el.directives;
	  if (!dirs) { return }
	  var res = 'directives:[';
	  var hasRuntime = false;
	  var i, l, dir, needRuntime;
	  for (i = 0, l = dirs.length; i < l; i++) {
	    dir = dirs[i];
	    needRuntime = true;
	    var gen = platformDirectives$1[dir.name] || baseDirectives[dir.name];
	    if (gen) {
	      // compile-time directive that manipulates AST.
	      // returns true if it also needs a runtime counterpart.
	      needRuntime = !!gen(el, dir, warn$2);
	    }
	    if (needRuntime) {
	      hasRuntime = true;
	      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:\"" + (dir.arg) + "\"") : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
	    }
	  }
	  if (hasRuntime) {
	    return res.slice(0, -1) + ']'
	  }
	}
	
	function genInlineTemplate (el) {
	  var ast = el.children[0];
	  if ("development" !== 'production' && (
	    el.children.length > 1 || ast.type !== 1
	  )) {
	    warn$2('Inline-template components must have exactly one child element.');
	  }
	  if (ast.type === 1) {
	    var inlineRenderFns = generate(ast, currentOptions);
	    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
	  }
	}
	
	function genScopedSlots (slots) {
	  return ("scopedSlots:{" + (Object.keys(slots).map(function (key) { return genScopedSlot(key, slots[key]); }).join(',')) + "}")
	}
	
	function genScopedSlot (key, el) {
	  return key + ":function(" + (String(el.attrsMap.scope)) + "){" +
	    "return " + (el.tag === 'template'
	      ? genChildren(el) || 'void 0'
	      : genElement(el)) + "}"
	}
	
	function genChildren (el, checkSkip) {
	  var children = el.children;
	  if (children.length) {
	    var el$1 = children[0];
	    // optimize single v-for
	    if (children.length === 1 &&
	        el$1.for &&
	        el$1.tag !== 'template' &&
	        el$1.tag !== 'slot') {
	      return genElement(el$1)
	    }
	    var normalizationType = getNormalizationType(children);
	    return ("[" + (children.map(genNode).join(',')) + "]" + (checkSkip
	        ? normalizationType ? ("," + normalizationType) : ''
	        : ''))
	  }
	}
	
	// determine the normalization needed for the children array.
	// 0: no normalization needed
	// 1: simple normalization needed (possible 1-level deep nested array)
	// 2: full normalization needed
	function getNormalizationType (children) {
	  var res = 0;
	  for (var i = 0; i < children.length; i++) {
	    var el = children[i];
	    if (needsNormalization(el) ||
	        (el.if && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
	      res = 2;
	      break
	    }
	    if (maybeComponent(el) ||
	        (el.if && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
	      res = 1;
	    }
	  }
	  return res
	}
	
	function needsNormalization (el) {
	  return el.for || el.tag === 'template' || el.tag === 'slot'
	}
	
	function maybeComponent (el) {
	  return el.type === 1 && !isPlatformReservedTag$1(el.tag)
	}
	
	function genNode (node) {
	  if (node.type === 1) {
	    return genElement(node)
	  } else {
	    return genText(node)
	  }
	}
	
	function genText (text) {
	  return ("_v(" + (text.type === 2
	    ? text.expression // no need for () because already wrapped in _s()
	    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
	}
	
	function genSlot (el) {
	  var slotName = el.slotName || '"default"';
	  var children = genChildren(el);
	  var res = "_t(" + slotName + (children ? ("," + children) : '');
	  var attrs = el.attrs && ("{" + (el.attrs.map(function (a) { return ((camelize(a.name)) + ":" + (a.value)); }).join(',')) + "}");
	  var bind$$1 = el.attrsMap['v-bind'];
	  if ((attrs || bind$$1) && !children) {
	    res += ",null";
	  }
	  if (attrs) {
	    res += "," + attrs;
	  }
	  if (bind$$1) {
	    res += (attrs ? '' : ',null') + "," + bind$$1;
	  }
	  return res + ')'
	}
	
	// componentName is el.component, take it as argument to shun flow's pessimistic refinement
	function genComponent (componentName, el) {
	  var children = el.inlineTemplate ? null : genChildren(el, true);
	  return ("_c(" + componentName + "," + (genData(el)) + (children ? ("," + children) : '') + ")")
	}
	
	function genProps (props) {
	  var res = '';
	  for (var i = 0; i < props.length; i++) {
	    var prop = props[i];
	    res += "\"" + (prop.name) + "\":" + (transformSpecialNewlines(prop.value)) + ",";
	  }
	  return res.slice(0, -1)
	}
	
	// #3895, #4268
	function transformSpecialNewlines (text) {
	  return text
	    .replace(/\u2028/g, '\\u2028')
	    .replace(/\u2029/g, '\\u2029')
	}
	
	/*  */
	
	/**
	 * Compile a template.
	 */
	function compile$1 (
	  template,
	  options
	) {
	  var ast = parse(template.trim(), options);
	  optimize(ast, options);
	  var code = generate(ast, options);
	  return {
	    ast: ast,
	    render: code.render,
	    staticRenderFns: code.staticRenderFns
	  }
	}
	
	/*  */
	
	// operators like typeof, instanceof and in are allowed
	var prohibitedKeywordRE = new RegExp('\\b' + (
	  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
	  'super,throw,while,yield,delete,export,import,return,switch,default,' +
	  'extends,finally,continue,debugger,function,arguments'
	).split(',').join('\\b|\\b') + '\\b');
	// check valid identifier for v-for
	var identRE = /[A-Za-z_$][\w$]*/;
	// strip strings in expressions
	var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;
	
	// detect problematic expressions in a template
	function detectErrors (ast) {
	  var errors = [];
	  if (ast) {
	    checkNode(ast, errors);
	  }
	  return errors
	}
	
	function checkNode (node, errors) {
	  if (node.type === 1) {
	    for (var name in node.attrsMap) {
	      if (dirRE.test(name)) {
	        var value = node.attrsMap[name];
	        if (value) {
	          if (name === 'v-for') {
	            checkFor(node, ("v-for=\"" + value + "\""), errors);
	          } else {
	            checkExpression(value, (name + "=\"" + value + "\""), errors);
	          }
	        }
	      }
	    }
	    if (node.children) {
	      for (var i = 0; i < node.children.length; i++) {
	        checkNode(node.children[i], errors);
	      }
	    }
	  } else if (node.type === 2) {
	    checkExpression(node.expression, node.text, errors);
	  }
	}
	
	function checkFor (node, text, errors) {
	  checkExpression(node.for || '', text, errors);
	  checkIdentifier(node.alias, 'v-for alias', text, errors);
	  checkIdentifier(node.iterator1, 'v-for iterator', text, errors);
	  checkIdentifier(node.iterator2, 'v-for iterator', text, errors);
	}
	
	function checkIdentifier (ident, type, text, errors) {
	  if (typeof ident === 'string' && !identRE.test(ident)) {
	    errors.push(("- invalid " + type + " \"" + ident + "\" in expression: " + text));
	  }
	}
	
	function checkExpression (exp, text, errors) {
	  try {
	    new Function(("return " + exp));
	  } catch (e) {
	    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
	    if (keywordMatch) {
	      errors.push(
	        "- avoid using JavaScript keyword as property name: " +
	        "\"" + (keywordMatch[0]) + "\" in expression " + text
	      );
	    } else {
	      errors.push(("- invalid expression: " + text));
	    }
	  }
	}
	
	/*  */
	
	function transformNode (el, options) {
	  var warn = options.warn || baseWarn;
	  var staticClass = getAndRemoveAttr(el, 'class');
	  if ("development" !== 'production' && staticClass) {
	    var expression = parseText(staticClass, options.delimiters);
	    if (expression) {
	      warn(
	        "class=\"" + staticClass + "\": " +
	        'Interpolation inside attributes has been removed. ' +
	        'Use v-bind or the colon shorthand instead. For example, ' +
	        'instead of <div class="{{ val }}">, use <div :class="val">.'
	      );
	    }
	  }
	  if (staticClass) {
	    el.staticClass = JSON.stringify(staticClass);
	  }
	  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
	  if (classBinding) {
	    el.classBinding = classBinding;
	  }
	}
	
	function genData$1 (el) {
	  var data = '';
	  if (el.staticClass) {
	    data += "staticClass:" + (el.staticClass) + ",";
	  }
	  if (el.classBinding) {
	    data += "class:" + (el.classBinding) + ",";
	  }
	  return data
	}
	
	var klass$1 = {
	  staticKeys: ['staticClass'],
	  transformNode: transformNode,
	  genData: genData$1
	};
	
	/*  */
	
	function transformNode$1 (el, options) {
	  var warn = options.warn || baseWarn;
	  var staticStyle = getAndRemoveAttr(el, 'style');
	  if (staticStyle) {
	    /* istanbul ignore if */
	    {
	      var expression = parseText(staticStyle, options.delimiters);
	      if (expression) {
	        warn(
	          "style=\"" + staticStyle + "\": " +
	          'Interpolation inside attributes has been removed. ' +
	          'Use v-bind or the colon shorthand instead. For example, ' +
	          'instead of <div style="{{ val }}">, use <div :style="val">.'
	        );
	      }
	    }
	    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
	  }
	
	  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
	  if (styleBinding) {
	    el.styleBinding = styleBinding;
	  }
	}
	
	function genData$2 (el) {
	  var data = '';
	  if (el.staticStyle) {
	    data += "staticStyle:" + (el.staticStyle) + ",";
	  }
	  if (el.styleBinding) {
	    data += "style:(" + (el.styleBinding) + "),";
	  }
	  return data
	}
	
	var style$1 = {
	  staticKeys: ['staticStyle'],
	  transformNode: transformNode$1,
	  genData: genData$2
	};
	
	var modules$1 = [
	  klass$1,
	  style$1
	];
	
	/*  */
	
	var warn$3;
	
	function model$1 (
	  el,
	  dir,
	  _warn
	) {
	  warn$3 = _warn;
	  var value = dir.value;
	  var modifiers = dir.modifiers;
	  var tag = el.tag;
	  var type = el.attrsMap.type;
	  {
	    var dynamicType = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
	    if (tag === 'input' && dynamicType) {
	      warn$3(
	        "<input :type=\"" + dynamicType + "\" v-model=\"" + value + "\">:\n" +
	        "v-model does not support dynamic input types. Use v-if branches instead."
	      );
	    }
	  }
	  if (tag === 'select') {
	    genSelect(el, value, modifiers);
	  } else if (tag === 'input' && type === 'checkbox') {
	    genCheckboxModel(el, value, modifiers);
	  } else if (tag === 'input' && type === 'radio') {
	    genRadioModel(el, value, modifiers);
	  } else {
	    genDefaultModel(el, value, modifiers);
	  }
	  // ensure runtime directive metadata
	  return true
	}
	
	function genCheckboxModel (
	  el,
	  value,
	  modifiers
	) {
	  if ("development" !== 'production' &&
	    el.attrsMap.checked != null) {
	    warn$3(
	      "<" + (el.tag) + " v-model=\"" + value + "\" checked>:\n" +
	      "inline checked attributes will be ignored when using v-model. " +
	      'Declare initial values in the component\'s data option instead.'
	    );
	  }
	  var number = modifiers && modifiers.number;
	  var valueBinding = getBindingAttr(el, 'value') || 'null';
	  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
	  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
	  addProp(el, 'checked',
	    "Array.isArray(" + value + ")" +
	      "?_i(" + value + "," + valueBinding + ")>-1" + (
	        trueValueBinding === 'true'
	          ? (":(" + value + ")")
	          : (":_q(" + value + "," + trueValueBinding + ")")
	      )
	  );
	  addHandler(el, 'change',
	    "var $$a=" + value + "," +
	        '$$el=$event.target,' +
	        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
	    'if(Array.isArray($$a)){' +
	      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
	          '$$i=_i($$a,$$v);' +
	      "if($$c){$$i<0&&(" + value + "=$$a.concat($$v))}" +
	      "else{$$i>-1&&(" + value + "=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}" +
	    "}else{" + value + "=$$c}",
	    null, true
	  );
	}
	
	function genRadioModel (
	    el,
	    value,
	    modifiers
	) {
	  if ("development" !== 'production' &&
	    el.attrsMap.checked != null) {
	    warn$3(
	      "<" + (el.tag) + " v-model=\"" + value + "\" checked>:\n" +
	      "inline checked attributes will be ignored when using v-model. " +
	      'Declare initial values in the component\'s data option instead.'
	    );
	  }
	  var number = modifiers && modifiers.number;
	  var valueBinding = getBindingAttr(el, 'value') || 'null';
	  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
	  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
	  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
	}
	
	function genDefaultModel (
	  el,
	  value,
	  modifiers
	) {
	  {
	    if (el.tag === 'input' && el.attrsMap.value) {
	      warn$3(
	        "<" + (el.tag) + " v-model=\"" + value + "\" value=\"" + (el.attrsMap.value) + "\">:\n" +
	        'inline value attributes will be ignored when using v-model. ' +
	        'Declare initial values in the component\'s data option instead.'
	      );
	    }
	    if (el.tag === 'textarea' && el.children.length) {
	      warn$3(
	        "<textarea v-model=\"" + value + "\">:\n" +
	        'inline content inside <textarea> will be ignored when using v-model. ' +
	        'Declare initial values in the component\'s data option instead.'
	      );
	    }
	  }
	
	  var type = el.attrsMap.type;
	  var ref = modifiers || {};
	  var lazy = ref.lazy;
	  var number = ref.number;
	  var trim = ref.trim;
	  var event = lazy || (isIE && type === 'range') ? 'change' : 'input';
	  var needCompositionGuard = !lazy && type !== 'range';
	  var isNative = el.tag === 'input' || el.tag === 'textarea';
	
	  var valueExpression = isNative
	    ? ("$event.target.value" + (trim ? '.trim()' : ''))
	    : trim ? "(typeof $event === 'string' ? $event.trim() : $event)" : "$event";
	  valueExpression = number || type === 'number'
	    ? ("_n(" + valueExpression + ")")
	    : valueExpression;
	
	  var code = genAssignmentCode(value, valueExpression);
	  if (isNative && needCompositionGuard) {
	    code = "if($event.target.composing)return;" + code;
	  }
	
	  // inputs with type="file" are read only and setting the input's
	  // value will throw an error.
	  if ("development" !== 'production' &&
	      type === 'file') {
	    warn$3(
	      "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
	      "File inputs are read only. Use a v-on:change listener instead."
	    );
	  }
	
	  addProp(el, 'value', isNative ? ("_s(" + value + ")") : ("(" + value + ")"));
	  addHandler(el, event, code, null, true);
	  if (trim || number || type === 'number') {
	    addHandler(el, 'blur', '$forceUpdate()');
	  }
	}
	
	function genSelect (
	    el,
	    value,
	    modifiers
	) {
	  {
	    el.children.some(checkOptionWarning);
	  }
	
	  var number = modifiers && modifiers.number;
	  var assignment = "Array.prototype.filter" +
	    ".call($event.target.options,function(o){return o.selected})" +
	    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
	    "return " + (number ? '_n(val)' : 'val') + "})" +
	    (el.attrsMap.multiple == null ? '[0]' : '');
	
	  var code = genAssignmentCode(value, assignment);
	  addHandler(el, 'change', code, null, true);
	}
	
	function checkOptionWarning (option) {
	  if (option.type === 1 &&
	    option.tag === 'option' &&
	    option.attrsMap.selected != null) {
	    warn$3(
	      "<select v-model=\"" + (option.parent.attrsMap['v-model']) + "\">:\n" +
	      'inline selected attributes on <option> will be ignored when using v-model. ' +
	      'Declare initial values in the component\'s data option instead.'
	    );
	    return true
	  }
	  return false
	}
	
	function genAssignmentCode (value, assignment) {
	  var modelRs = parseModel(value);
	  if (modelRs.idx === null) {
	    return (value + "=" + assignment)
	  } else {
	    return "var $$exp = " + (modelRs.exp) + ", $$idx = " + (modelRs.idx) + ";" +
	      "if (!Array.isArray($$exp)){" +
	        value + "=" + assignment + "}" +
	      "else{$$exp.splice($$idx, 1, " + assignment + ")}"
	  }
	}
	
	/*  */
	
	function text (el, dir) {
	  if (dir.value) {
	    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"));
	  }
	}
	
	/*  */
	
	function html (el, dir) {
	  if (dir.value) {
	    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"));
	  }
	}
	
	var directives$1 = {
	  model: model$1,
	  text: text,
	  html: html
	};
	
	/*  */
	
	var cache = Object.create(null);
	
	var baseOptions = {
	  expectHTML: true,
	  modules: modules$1,
	  staticKeys: genStaticKeys(modules$1),
	  directives: directives$1,
	  isReservedTag: isReservedTag,
	  isUnaryTag: isUnaryTag,
	  mustUseProp: mustUseProp,
	  getTagNamespace: getTagNamespace,
	  isPreTag: isPreTag
	};
	
	function compile$$1 (
	  template,
	  options
	) {
	  options = options
	    ? extend(extend({}, baseOptions), options)
	    : baseOptions;
	  return compile$1(template, options)
	}
	
	function compileToFunctions (
	  template,
	  options,
	  vm
	) {
	  var _warn = (options && options.warn) || warn;
	  // detect possible CSP restriction
	  /* istanbul ignore if */
	  {
	    try {
	      new Function('return 1');
	    } catch (e) {
	      if (e.toString().match(/unsafe-eval|CSP/)) {
	        _warn(
	          'It seems you are using the standalone build of Vue.js in an ' +
	          'environment with Content Security Policy that prohibits unsafe-eval. ' +
	          'The template compiler cannot work in this environment. Consider ' +
	          'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
	          'templates into render functions.'
	        );
	      }
	    }
	  }
	  var key = options && options.delimiters
	    ? String(options.delimiters) + template
	    : template;
	  if (cache[key]) {
	    return cache[key]
	  }
	  var res = {};
	  var compiled = compile$$1(template, options);
	  res.render = makeFunction(compiled.render);
	  var l = compiled.staticRenderFns.length;
	  res.staticRenderFns = new Array(l);
	  for (var i = 0; i < l; i++) {
	    res.staticRenderFns[i] = makeFunction(compiled.staticRenderFns[i]);
	  }
	  {
	    if (res.render === noop || res.staticRenderFns.some(function (fn) { return fn === noop; })) {
	      _warn(
	        "failed to compile template:\n\n" + template + "\n\n" +
	        detectErrors(compiled.ast).join('\n') +
	        '\n\n',
	        vm
	      );
	    }
	  }
	  return (cache[key] = res)
	}
	
	function makeFunction (code) {
	  try {
	    return new Function(code)
	  } catch (e) {
	    return noop
	  }
	}
	
	/*  */
	
	var idToTemplate = cached(function (id) {
	  var el = query(id);
	  return el && el.innerHTML
	});
	
	var mount = Vue$3.prototype.$mount;
	Vue$3.prototype.$mount = function (
	  el,
	  hydrating
	) {
	  el = el && query(el);
	
	  /* istanbul ignore if */
	  if (el === document.body || el === document.documentElement) {
	    "development" !== 'production' && warn(
	      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
	    );
	    return this
	  }
	
	  var options = this.$options;
	  // resolve template/el and convert to render function
	  if (!options.render) {
	    var template = options.template;
	    if (template) {
	      if (typeof template === 'string') {
	        if (template.charAt(0) === '#') {
	          template = idToTemplate(template);
	          /* istanbul ignore if */
	          if ("development" !== 'production' && !template) {
	            warn(
	              ("Template element not found or is empty: " + (options.template)),
	              this
	            );
	          }
	        }
	      } else if (template.nodeType) {
	        template = template.innerHTML;
	      } else {
	        {
	          warn('invalid template option:' + template, this);
	        }
	        return this
	      }
	    } else if (el) {
	      template = getOuterHTML(el);
	    }
	    if (template) {
	      var ref = compileToFunctions(template, {
	        warn: warn,
	        shouldDecodeNewlines: shouldDecodeNewlines,
	        delimiters: options.delimiters
	      }, this);
	      var render = ref.render;
	      var staticRenderFns = ref.staticRenderFns;
	      options.render = render;
	      options.staticRenderFns = staticRenderFns;
	    }
	  }
	  return mount.call(this, el, hydrating)
	};
	
	/**
	 * Get outerHTML of elements, taking care
	 * of SVG elements in IE as well.
	 */
	function getOuterHTML (el) {
	  if (el.outerHTML) {
	    return el.outerHTML
	  } else {
	    var container = document.createElement('div');
	    container.appendChild(el.cloneNode(true));
	    return container.innerHTML
	  }
	}
	
	Vue$3.compile = compileToFunctions;
	
	return Vue$3;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(23);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = {
	  required: __webpack_require__(106),
	  whitespace: __webpack_require__(159),
	  type: __webpack_require__(158),
	  range: __webpack_require__(157),
	  "enum": __webpack_require__(155),
	  pattern: __webpack_require__(156)
	};
	module.exports = exports['default'];

/***/ },
/* 14 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 15 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(8)
	  , createDesc = __webpack_require__(36);
	module.exports = __webpack_require__(7) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(3)
	  , hide      = __webpack_require__(16)
	  , has       = __webpack_require__(14)
	  , SRC       = __webpack_require__(46)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(29).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  var isFunction = typeof val == 'function';
	  if(isFunction)has(val, 'name') || hide(val, 'name', key);
	  if(O[key] === val)return;
	  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe){
	      delete O[key];
	      hide(O, key, val);
	    } else {
	      if(O[key])O[key] = val;
	      else hide(O, key, val);
	    }
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1)
	  , fails   = __webpack_require__(4)
	  , defined = __webpack_require__(23)
	  , quot    = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function(string, tag, attribute, value) {
	  var S  = String(defined(string))
	    , p1 = '<' + tag;
	  if(attribute !== '')p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function(NAME, exec){
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function(){
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(55)
	  , defined = __webpack_require__(23);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var pIE            = __webpack_require__(56)
	  , createDesc     = __webpack_require__(36)
	  , toIObject      = __webpack_require__(19)
	  , toPrimitive    = __webpack_require__(28)
	  , has            = __webpack_require__(14)
	  , IE8_DOM_DEFINE = __webpack_require__(122)
	  , gOPD           = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(7) ? gOPD : function getOwnPropertyDescriptor(O, P){
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if(IE8_DOM_DEFINE)try {
	    return gOPD(O, P);
	  } catch(e){ /* empty */ }
	  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
	};

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__(14)
	  , toObject    = __webpack_require__(12)
	  , IE_PROTO    = __webpack_require__(91)('IE_PROTO')
	  , ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

/***/ },
/* 22 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 23 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var fails = __webpack_require__(4);
	
	module.exports = function(method, arg){
	  return !!method && fails(function(){
	    arg ? method.call(null, function(){}, 1) : method.call(null);
	  });
	};

/***/ },
/* 25 */,
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx      = __webpack_require__(30)
	  , IObject  = __webpack_require__(55)
	  , toObject = __webpack_require__(12)
	  , toLength = __webpack_require__(10)
	  , asc      = __webpack_require__(225);
	module.exports = function(TYPE, $create){
	  var IS_MAP        = TYPE == 1
	    , IS_FILTER     = TYPE == 2
	    , IS_SOME       = TYPE == 3
	    , IS_EVERY      = TYPE == 4
	    , IS_FIND_INDEX = TYPE == 6
	    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
	    , create        = $create || asc;
	  return function($this, callbackfn, that){
	    var O      = toObject($this)
	      , self   = IObject(O)
	      , f      = ctx(callbackfn, that, 3)
	      , length = toLength(self.length)
	      , index  = 0
	      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
	      , val, res;
	    for(;length > index; index++)if(NO_HOLES || index in self){
	      val = self[index];
	      res = f(val, index, O);
	      if(TYPE){
	        if(IS_MAP)result[index] = res;            // map
	        else if(res)switch(TYPE){
	          case 3: return true;                    // some
	          case 5: return val;                     // find
	          case 6: return index;                   // findIndex
	          case 2: result.push(val);               // filter
	        } else if(IS_EVERY)return false;          // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(1)
	  , core    = __webpack_require__(29)
	  , fails   = __webpack_require__(4);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(5);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 29 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(15);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var Map     = __webpack_require__(138)
	  , $export = __webpack_require__(1)
	  , shared  = __webpack_require__(67)('metadata')
	  , store   = shared.store || (shared.store = new (__webpack_require__(141)));
	
	var getOrCreateMetadataMap = function(target, targetKey, create){
	  var targetMetadata = store.get(target);
	  if(!targetMetadata){
	    if(!create)return undefined;
	    store.set(target, targetMetadata = new Map);
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if(!keyMetadata){
	    if(!create)return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map);
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P){
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function(target, targetKey){
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false)
	    , keys        = [];
	  if(metadataMap)metadataMap.forEach(function(_, key){ keys.push(key); });
	  return keys;
	};
	var toMetaKey = function(it){
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function(O){
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	if(__webpack_require__(7)){
	  var LIBRARY             = __webpack_require__(39)
	    , global              = __webpack_require__(3)
	    , fails               = __webpack_require__(4)
	    , $export             = __webpack_require__(1)
	    , $typed              = __webpack_require__(68)
	    , $buffer             = __webpack_require__(98)
	    , ctx                 = __webpack_require__(30)
	    , anInstance          = __webpack_require__(38)
	    , propertyDesc        = __webpack_require__(36)
	    , hide                = __webpack_require__(16)
	    , redefineAll         = __webpack_require__(43)
	    , toInteger           = __webpack_require__(37)
	    , toLength            = __webpack_require__(10)
	    , toIndex             = __webpack_require__(45)
	    , toPrimitive         = __webpack_require__(28)
	    , has                 = __webpack_require__(14)
	    , same                = __webpack_require__(135)
	    , classof             = __webpack_require__(54)
	    , isObject            = __webpack_require__(5)
	    , toObject            = __webpack_require__(12)
	    , isArrayIter         = __webpack_require__(83)
	    , create              = __webpack_require__(40)
	    , getPrototypeOf      = __webpack_require__(21)
	    , gOPN                = __webpack_require__(41).f
	    , getIterFn           = __webpack_require__(100)
	    , uid                 = __webpack_require__(46)
	    , wks                 = __webpack_require__(6)
	    , createArrayMethod   = __webpack_require__(26)
	    , createArrayIncludes = __webpack_require__(58)
	    , speciesConstructor  = __webpack_require__(92)
	    , ArrayIterators      = __webpack_require__(101)
	    , Iterators           = __webpack_require__(50)
	    , $iterDetect         = __webpack_require__(64)
	    , setSpecies          = __webpack_require__(44)
	    , arrayFill           = __webpack_require__(76)
	    , arrayCopyWithin     = __webpack_require__(115)
	    , $DP                 = __webpack_require__(8)
	    , $GOPD               = __webpack_require__(20)
	    , dP                  = $DP.f
	    , gOPD                = $GOPD.f
	    , RangeError          = global.RangeError
	    , TypeError           = global.TypeError
	    , Uint8Array          = global.Uint8Array
	    , ARRAY_BUFFER        = 'ArrayBuffer'
	    , SHARED_BUFFER       = 'Shared' + ARRAY_BUFFER
	    , BYTES_PER_ELEMENT   = 'BYTES_PER_ELEMENT'
	    , PROTOTYPE           = 'prototype'
	    , ArrayProto          = Array[PROTOTYPE]
	    , $ArrayBuffer        = $buffer.ArrayBuffer
	    , $DataView           = $buffer.DataView
	    , arrayForEach        = createArrayMethod(0)
	    , arrayFilter         = createArrayMethod(2)
	    , arraySome           = createArrayMethod(3)
	    , arrayEvery          = createArrayMethod(4)
	    , arrayFind           = createArrayMethod(5)
	    , arrayFindIndex      = createArrayMethod(6)
	    , arrayIncludes       = createArrayIncludes(true)
	    , arrayIndexOf        = createArrayIncludes(false)
	    , arrayValues         = ArrayIterators.values
	    , arrayKeys           = ArrayIterators.keys
	    , arrayEntries        = ArrayIterators.entries
	    , arrayLastIndexOf    = ArrayProto.lastIndexOf
	    , arrayReduce         = ArrayProto.reduce
	    , arrayReduceRight    = ArrayProto.reduceRight
	    , arrayJoin           = ArrayProto.join
	    , arraySort           = ArrayProto.sort
	    , arraySlice          = ArrayProto.slice
	    , arrayToString       = ArrayProto.toString
	    , arrayToLocaleString = ArrayProto.toLocaleString
	    , ITERATOR            = wks('iterator')
	    , TAG                 = wks('toStringTag')
	    , TYPED_CONSTRUCTOR   = uid('typed_constructor')
	    , DEF_CONSTRUCTOR     = uid('def_constructor')
	    , ALL_CONSTRUCTORS    = $typed.CONSTR
	    , TYPED_ARRAY         = $typed.TYPED
	    , VIEW                = $typed.VIEW
	    , WRONG_LENGTH        = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function(O, length){
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function(){
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function(){
	    new Uint8Array(1).set({});
	  });
	
	  var strictToLength = function(it, SAME){
	    if(it === undefined)throw TypeError(WRONG_LENGTH);
	    var number = +it
	      , length = toLength(it);
	    if(SAME && !same(number, length))throw RangeError(WRONG_LENGTH);
	    return length;
	  };
	
	  var toOffset = function(it, BYTES){
	    var offset = toInteger(it);
	    if(offset < 0 || offset % BYTES)throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function(it){
	    if(isObject(it) && TYPED_ARRAY in it)return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function(C, length){
	    if(!(isObject(C) && TYPED_CONSTRUCTOR in C)){
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function(O, list){
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function(C, list){
	    var index  = 0
	      , length = list.length
	      , result = allocate(C, length);
	    while(length > index)result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function(it, key, internal){
	    dP(it, key, {get: function(){ return this._d[internal]; }});
	  };
	
	  var $from = function from(source /*, mapfn, thisArg */){
	    var O       = toObject(source)
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , iterFn  = getIterFn(O)
	      , i, length, values, result, step, iterator;
	    if(iterFn != undefined && !isArrayIter(iterFn)){
	      for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++){
	        values.push(step.value);
	      } O = values;
	    }
	    if(mapping && aLen > 2)mapfn = ctx(mapfn, arguments[2], 2);
	    for(i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++){
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/*...items*/){
	    var index  = 0
	      , length = arguments.length
	      , result = allocate(this, length);
	    while(length > index)result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function(){ arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString(){
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /*, end */){
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /*, thisArg */){
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /*, start, end */){ // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /*, thisArg */){
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /*, thisArg */){
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /*, thisArg */){
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /*, thisArg */){
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /*, fromIndex */){
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /*, fromIndex */){
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator){ // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /*, fromIndex */){ // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /*, thisArg */){
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse(){
	      var that   = this
	        , length = validate(that).length
	        , middle = Math.floor(length / 2)
	        , index  = 0
	        , value;
	      while(index < middle){
	        value         = that[index];
	        that[index++] = that[--length];
	        that[length]  = value;
	      } return that;
	    },
	    some: function some(callbackfn /*, thisArg */){
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn){
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end){
	      var O      = validate(this)
	        , length = O.length
	        , $begin = toIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end){
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /*, offset */){
	    validate(this);
	    var offset = toOffset(arguments[1], 1)
	      , length = this.length
	      , src    = toObject(arrayLike)
	      , len    = toLength(src.length)
	      , index  = 0;
	    if(len + offset > length)throw RangeError(WRONG_LENGTH);
	    while(index < len)this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries(){
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys(){
	      return arrayKeys.call(validate(this));
	    },
	    values: function values(){
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function(target, key){
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key){
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc){
	    if(isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ){
	      target[key] = desc.value;
	      return target;
	    } else return dP(target, key, desc);
	  };
	
	  if(!ALL_CONSTRUCTORS){
	    $GOPD.f = $getDesc;
	    $DP.f   = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty:           $setDesc
	  });
	
	  if(fails(function(){ arrayToString.call({}); })){
	    arrayToString = arrayToLocaleString = function toString(){
	      return arrayJoin.call(this);
	    }
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice:          $slice,
	    set:            $set,
	    constructor:    function(){ /* noop */ },
	    toString:       arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function(){ return this[TYPED_ARRAY]; }
	  });
	
	  module.exports = function(KEY, BYTES, wrapper, CLAMPED){
	    CLAMPED = !!CLAMPED;
	    var NAME       = KEY + (CLAMPED ? 'Clamped' : '') + 'Array'
	      , ISNT_UINT8 = NAME != 'Uint8Array'
	      , GETTER     = 'get' + KEY
	      , SETTER     = 'set' + KEY
	      , TypedArray = global[NAME]
	      , Base       = TypedArray || {}
	      , TAC        = TypedArray && getPrototypeOf(TypedArray)
	      , FORCED     = !TypedArray || !$typed.ABV
	      , O          = {}
	      , TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function(that, index){
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function(that, index, value){
	      var data = that._d;
	      if(CLAMPED)value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function(that, index){
	      dP(that, index, {
	        get: function(){
	          return getter(this, index);
	        },
	        set: function(value){
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if(FORCED){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME, '_d');
	        var index  = 0
	          , offset = 0
	          , buffer, byteLength, length, klass;
	        if(!isObject(data)){
	          length     = strictToLength(data, true)
	          byteLength = length * BYTES;
	          buffer     = new $ArrayBuffer(byteLength);
	        } else if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if($length === undefined){
	            if($len % BYTES)throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if(byteLength < 0)throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if(byteLength + offset > $len)throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if(TYPED_ARRAY in data){
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while(index < length)addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if(!$iterDetect(function(iter){
	      // V8 works with iterators, but fails in many other cases
	      // https://code.google.com/p/v8/issues/detail?id=4552
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if(!isObject(data))return new Base(strictToLength(data, ISNT_UINT8));
	        if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if(TYPED_ARRAY in data)return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function(key){
	        if(!(key in TypedArray))hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if(!LIBRARY)TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator   = TypedArrayPrototype[ITERATOR]
	      , CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined)
	      , $iterator         = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if(CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)){
	      dP(TypedArrayPrototype, TAG, {
	        get: function(){ return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES,
	      from: $from,
	      of: $of
	    });
	
	    if(!(BYTES_PER_ELEMENT in TypedArrayPrototype))hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, {set: $set});
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    $export($export.P + $export.F * (TypedArrayPrototype.toString != arrayToString), NAME, {toString: arrayToString});
	
	    $export($export.P + $export.F * fails(function(){
	      new TypedArray(1).slice();
	    }), NAME, {slice: $slice});
	
	    $export($export.P + $export.F * (fails(function(){
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString()
	    }) || !fails(function(){
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, {toLocaleString: $toLocaleString});
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if(!LIBRARY && !CORRECT_ITER_NAME)hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function(){ /* empty */ };

/***/ },
/* 33 */,
/* 34 */,
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	var META     = __webpack_require__(46)('meta')
	  , isObject = __webpack_require__(5)
	  , has      = __webpack_require__(14)
	  , setDesc  = __webpack_require__(8).f
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__(4)(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};

/***/ },
/* 36 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 37 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 38 */
/***/ function(module, exports) {

	module.exports = function(it, Constructor, name, forbiddenField){
	  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};

/***/ },
/* 39 */
/***/ function(module, exports) {

	module.exports = false;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__(2)
	  , dPs         = __webpack_require__(128)
	  , enumBugKeys = __webpack_require__(79)
	  , IE_PROTO    = __webpack_require__(91)('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(78)('iframe')
	    , i      = enumBugKeys.length
	    , lt     = '<'
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(81).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys      = __webpack_require__(130)
	  , hiddenKeys = __webpack_require__(79).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
	  return $keys(O, hiddenKeys);
	};

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(130)
	  , enumBugKeys = __webpack_require__(79);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(17);
	module.exports = function(target, src, safe){
	  for(var key in src)redefine(target, key, src[key], safe);
	  return target;
	};

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global      = __webpack_require__(3)
	  , dP          = __webpack_require__(8)
	  , DESCRIPTORS = __webpack_require__(7)
	  , SPECIES     = __webpack_require__(6)('species');
	
	module.exports = function(KEY){
	  var C = global[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(37)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 46 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getStyle = exports.once = exports.off = exports.on = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* istanbul ignore next */
	
	exports.hasClass = hasClass;
	exports.addClass = addClass;
	exports.removeClass = removeClass;
	exports.setStyle = setStyle;
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isServer = _vue2.default.prototype.$isServer;
	var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
	var MOZ_HACK_REGEXP = /^moz([A-Z])/;
	var ieVersion = isServer ? 0 : Number(document.documentMode);
	
	/* istanbul ignore next */
	var trim = function trim(string) {
	  return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
	};
	/* istanbul ignore next */
	var camelCase = function camelCase(name) {
	  return name.replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
	    return offset ? letter.toUpperCase() : letter;
	  }).replace(MOZ_HACK_REGEXP, 'Moz$1');
	};
	
	/* istanbul ignore next */
	var on = exports.on = function () {
	  if (!isServer && document.addEventListener) {
	    return function (element, event, handler) {
	      if (element && event && handler) {
	        element.addEventListener(event, handler, false);
	      }
	    };
	  } else {
	    return function (element, event, handler) {
	      if (element && event && handler) {
	        element.attachEvent('on' + event, handler);
	      }
	    };
	  }
	}();
	
	/* istanbul ignore next */
	var off = exports.off = function () {
	  if (!isServer && document.removeEventListener) {
	    return function (element, event, handler) {
	      if (element && event) {
	        element.removeEventListener(event, handler, false);
	      }
	    };
	  } else {
	    return function (element, event, handler) {
	      if (element && event) {
	        element.detachEvent('on' + event, handler);
	      }
	    };
	  }
	}();
	
	/* istanbul ignore next */
	var once = exports.once = function once(el, event, fn) {
	  var listener = function listener() {
	    if (fn) {
	      fn.apply(this, arguments);
	    }
	    off(el, event, listener);
	  };
	  on(el, event, listener);
	};
	
	/* istanbul ignore next */
	function hasClass(el, cls) {
	  if (!el || !cls) return false;
	  if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');
	  if (el.classList) {
	    return el.classList.contains(cls);
	  } else {
	    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
	  }
	};
	
	/* istanbul ignore next */
	function addClass(el, cls) {
	  if (!el) return;
	  var curClass = el.className;
	  var classes = (cls || '').split(' ');
	
	  for (var i = 0, j = classes.length; i < j; i++) {
	    var clsName = classes[i];
	    if (!clsName) continue;
	
	    if (el.classList) {
	      el.classList.add(clsName);
	    } else {
	      if (!hasClass(el, clsName)) {
	        curClass += ' ' + clsName;
	      }
	    }
	  }
	  if (!el.classList) {
	    el.className = curClass;
	  }
	};
	
	/* istanbul ignore next */
	function removeClass(el, cls) {
	  if (!el || !cls) return;
	  var classes = cls.split(' ');
	  var curClass = ' ' + el.className + ' ';
	
	  for (var i = 0, j = classes.length; i < j; i++) {
	    var clsName = classes[i];
	    if (!clsName) continue;
	
	    if (el.classList) {
	      el.classList.remove(clsName);
	    } else {
	      if (hasClass(el, clsName)) {
	        curClass = curClass.replace(' ' + clsName + ' ', ' ');
	      }
	    }
	  }
	  if (!el.classList) {
	    el.className = trim(curClass);
	  }
	};
	
	/* istanbul ignore next */
	var getStyle = exports.getStyle = ieVersion < 9 ? function (element, styleName) {
	  if (isServer) return;
	  if (!element || !styleName) return null;
	  styleName = camelCase(styleName);
	  if (styleName === 'float') {
	    styleName = 'styleFloat';
	  }
	  try {
	    switch (styleName) {
	      case 'opacity':
	        try {
	          return element.filters.item('alpha').opacity / 100;
	        } catch (e) {
	          return 1.0;
	        }
	      default:
	        return element.style[styleName] || element.currentStyle ? element.currentStyle[styleName] : null;
	    }
	  } catch (e) {
	    return element.style[styleName];
	  }
	} : function (element, styleName) {
	  if (isServer) return;
	  if (!element || !styleName) return null;
	  styleName = camelCase(styleName);
	  if (styleName === 'float') {
	    styleName = 'cssFloat';
	  }
	  try {
	    var computed = document.defaultView.getComputedStyle(element, '');
	    return element.style[styleName] || computed ? computed[styleName] : null;
	  } catch (e) {
	    return element.style[styleName];
	  }
	};
	
	/* istanbul ignore next */
	function setStyle(element, styleName, value) {
	  if (!element || !styleName) return;
	
	  if ((typeof styleName === 'undefined' ? 'undefined' : _typeof(styleName)) === 'object') {
	    for (var prop in styleName) {
	      if (styleName.hasOwnProperty(prop)) {
	        setStyle(element, prop, styleName[prop]);
	      }
	    }
	  } else {
	    styleName = camelCase(styleName);
	    if (styleName === 'opacity' && ieVersion < 9) {
	      element.style.filter = isNaN(value) ? '' : 'alpha(opacity=' + value * 100 + ')';
	    } else {
	      element.style[styleName] = value;
	    }
	  }
	};

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(6)('unscopables')
	  , ArrayProto  = Array.prototype;
	if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(16)(ArrayProto, UNSCOPABLES, {});
	module.exports = function(key){
	  ArrayProto[UNSCOPABLES][key] = true;
	};

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(30)
	  , call        = __webpack_require__(124)
	  , isArrayIter = __webpack_require__(83)
	  , anObject    = __webpack_require__(2)
	  , toLength    = __webpack_require__(10)
	  , getIterFn   = __webpack_require__(100)
	  , BREAK       = {}
	  , RETURN      = {};
	var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
	  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator, result;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if(result === BREAK || result === RETURN)return result;
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    result = call(iterator, f, step.value, entries);
	    if(result === BREAK || result === RETURN)return result;
	  }
	};
	exports.BREAK  = BREAK;
	exports.RETURN = RETURN;

/***/ },
/* 50 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(8).f
	  , has = __webpack_require__(14)
	  , TAG = __webpack_require__(6)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1)
	  , defined = __webpack_require__(23)
	  , fails   = __webpack_require__(4)
	  , spaces  = __webpack_require__(96)
	  , space   = '[' + spaces + ']'
	  , non     = '\u200b\u0085'
	  , ltrim   = RegExp('^' + space + space + '*')
	  , rtrim   = RegExp(space + space + '*$');
	
	var exporter = function(KEY, exec, ALIAS){
	  var exp   = {};
	  var FORCE = fails(function(){
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if(ALIAS)exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function(string, TYPE){
	  string = String(defined(string));
	  if(TYPE & 1)string = string.replace(ltrim, '');
	  if(TYPE & 2)string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;

/***/ },
/* 53 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	function _broadcast(componentName, eventName, params) {
	  this.$children.forEach(function (child) {
	    var name = child.$options.componentName;
	
	    if (name === componentName) {
	      child.$emit.apply(child, [eventName].concat(params));
	    } else {
	      _broadcast.apply(child, [componentName, eventName].concat([params]));
	    }
	  });
	}
	exports.default = {
	  methods: {
	    dispatch: function dispatch(componentName, eventName, params) {
	      var parent = this.$parent || this.$root;
	      var name = parent.$options.componentName;
	
	      while (parent && (!name || name !== componentName)) {
	        parent = parent.$parent;
	
	        if (parent) {
	          name = parent.$options.componentName;
	        }
	      }
	      if (parent) {
	        parent.$emit.apply(parent, [eventName].concat(params));
	      }
	    },
	    broadcast: function broadcast(componentName, eventName, params) {
	      _broadcast.call(this, componentName, eventName, params);
	    }
	  }
	};

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(22)
	  , TAG = __webpack_require__(6)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function(it, key){
	  try {
	    return it[key];
	  } catch(e){ /* empty */ }
	};
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(22);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 56 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ },
/* 57 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/*! tableau-2.0.3 */
	(function() {
	
	
	/*! BEGIN MscorlibSlim */
	
	
	
	////////////////////////////////////////////////////////////////////////////////
	// Globals and assembly registration
	////////////////////////////////////////////////////////////////////////////////
	
	var global = {};
	
	(function(global) {
	"use strict";
	
	var ss = { __assemblies: {} };
	
	ss.initAssembly = function assembly(obj, name, res) {
	  res = res || {};
	  obj.name = name;
	  obj.toString = function() { return this.name; };
	  obj.__types = {};
	  obj.getResourceNames = function() { return Object.keys(res); };
	  obj.getResourceDataBase64 = function(name) { return res[name] || null; };
	  obj.getResourceData = function(name) { var r = res[name]; return r ? ss.dec64(r) : null; };
	  ss.__assemblies[name] = obj;
	};
	ss.initAssembly(ss, 'mscorlib');
	
	
	
	////////////////////////////////////////////////////////////////////////////////
	// Utility methods (generated via Script.IsNull, etc.)
	////////////////////////////////////////////////////////////////////////////////
	
	
	ss.getAssemblies = function ss$getAssemblies() {
	  return Object.keys(ss.__assemblies).map(function(n) { return ss.__assemblies[n]; });
	};
	
	ss.isNullOrUndefined = function ss$isNullOrUndefined(o) {
	  return (o === null) || (o === undefined);
	};
	
	ss.isValue = function ss$isValue(o) {
	  return (o !== null) && (o !== undefined);
	};
	
	ss.referenceEquals = function ss$referenceEquals(a, b) {
	  return ss.isValue(a) ? a === b : !ss.isValue(b);
	};
	
	ss.mkdict = function ss$mkdict() {
	  var a = (arguments.length != 1 ? arguments : arguments[0]);
	  var r = {};
	  for (var i = 0; i < a.length; i += 2) {
	    r[a[i]] = a[i + 1];
	  }
	  return r;
	};
	
	ss.clone = function ss$clone(t, o) {
	  return o ? t.$clone(o) : o;
	}
	
	ss.coalesce = function ss$coalesce(a, b) {
	  return ss.isValue(a) ? a : b;
	};
	
	ss.isDate = function ss$isDate(obj) {
	  return Object.prototype.toString.call(obj) === '[object Date]';
	};
	
	ss.isArray = function ss$isArray(obj) {
	  return Object.prototype.toString.call(obj) === '[object Array]';
	};
	
	ss.isTypedArrayType = function ss$isTypedArrayType(type) {
	  return ['Float32Array', 'Float64Array', 'Int8Array', 'Int16Array', 'Int32Array', 'Uint8Array', 'Uint16Array', 'Uint32Array', 'Uint8ClampedArray'].indexOf(ss.getTypeFullName(type)) >= 0;
	};
	
	ss.isArrayOrTypedArray = function ss$isArray(obj) {
	  return ss.isArray(obj) || ss.isTypedArrayType(ss.getInstanceType(obj));
	};
	
	ss.getHashCode = function ss$getHashCode(obj) {
	  if (!ss.isValue(obj))
	    throw new ss_NullReferenceException('Cannot get hash code of null');
	  else if (typeof(obj.getHashCode) === 'function')
	    return obj.getHashCode();
	  else if (typeof(obj) === 'boolean') {
	    return obj ? 1 : 0;
	  }
	  else if (typeof(obj) === 'number') {
	    var s = obj.toExponential();
	    s = s.substr(0, s.indexOf('e'));
	    return parseInt(s.replace('.', ''), 10) & 0xffffffff;
	  }
	  else if (typeof(obj) === 'string') {
	    var res = 0;
	    for (var i = 0; i < obj.length; i++)
	      res = (res * 31 + obj.charCodeAt(i)) & 0xffffffff;
	    return res;
	  }
	  else if (ss.isDate(obj)) {
	    return obj.valueOf() & 0xffffffff;
	  }
	  else {
	    return ss.defaultHashCode(obj);
	  }
	};
	
	ss.defaultHashCode = function ss$defaultHashCode(obj) {
	  return obj.$__hashCode__ || (obj.$__hashCode__ = (Math.random() * 0x100000000) | 0);
	};
	
	
	ss.equals = function ss$equals(a, b) {
	    if (!ss.isValue(a))
	        throw new ss_NullReferenceException('Object is null');
	    else if (a !== ss && typeof(a.equals) === 'function')
	        return a.equals(b);
	    if (ss.isDate(a) && ss.isDate(b))
	        return a.valueOf() === b.valueOf();
	    else if (typeof(a) === 'function' && typeof(b) === 'function')
	        return ss.delegateEquals(a, b);
	    else if (ss.isNullOrUndefined(a) && ss.isNullOrUndefined(b))
	        return true;
	    else
	        return a === b;
	};
	
	ss.compare = function ss$compare(a, b) {
	  if (!ss.isValue(a))
	    throw new ss_NullReferenceException('Object is null');
	  else if (typeof(a) === 'number' || typeof(a) === 'string' || typeof(a) === 'boolean')
	    return a < b ? -1 : (a > b ? 1 : 0);
	  else if (ss.isDate(a))
	    return ss.compare(a.valueOf(), b.valueOf());
	  else
	    return a.compareTo(b);
	};
	
	ss.equalsT = function ss$equalsT(a, b) {
	  if (!ss.isValue(a))
	    throw new ss_NullReferenceException('Object is null');
	  else if (typeof(a) === 'number' || typeof(a) === 'string' || typeof(a) === 'boolean')
	    return a === b;
	  else if (ss.isDate(a))
	    return a.valueOf() === b.valueOf();
	  else
	    return a.equalsT(b);
	};
	
	ss.staticEquals = function ss$staticEquals(a, b) {
	  if (!ss.isValue(a))
	    return !ss.isValue(b);
	  else
	    return ss.isValue(b) ? ss.equals(a, b) : false;
	};
	
	ss.shallowCopy = function ss$shallowCopy(source, target) {
	  var keys = Object.keys(source);
	  for (var i = 0, l = keys.length; i < l; i++) {
	    var k = keys[i];
	    target[k] = source[k];
	  }
	};
	
	ss.isLower = function ss$isLower(c) {
	  var s = String.fromCharCode(c);
	  return s === s.toLowerCase() && s !== s.toUpperCase();
	};
	
	ss.isUpper = function ss$isUpper(c) {
	  var s = String.fromCharCode(c);
	  return s !== s.toLowerCase() && s === s.toUpperCase();
	};
	
	if (typeof(window) == 'object') {
	  // Browser-specific stuff that could go into the Web assembly, but that assembly does not have an associated JS file.
	  if (!window.Element) {
	    // IE does not have an Element constructor. This implementation should make casting to elements work.
	    window.Element = function() {};
	    window.Element.isInstanceOfType = function(instance) { return instance && typeof instance.constructor === 'undefined' && typeof instance.tagName === 'string'; };
	  }
	  window.Element.__typeName = 'Element';
	}
	
	///////////////////////////////////////////////////////////////////////////////
	// Object Extensions
	
	ss.clearKeys = function ss$clearKeys(d) {
	  for (var n in d) {
	    if (d.hasOwnProperty(n))
	      delete d[n];
	  }
	};
	
	ss.keyExists = function ss$keyExists(d, key) {
	  return d[key] !== undefined;
	};
	
	if (!Object.keys) {
	  Object.keys = (function() {
	    'use strict';
	    var hasOwnProperty = Object.prototype.hasOwnProperty,
	      hasDontEnumBug = !({toString: null}).propertyIsEnumerable('toString'),
	      dontEnums = ['toString','toLocaleString','valueOf','hasOwnProperty','isPrototypeOf','propertyIsEnumerable','constructor'],
	      dontEnumsLength = dontEnums.length;
	
	    return function (obj) {
	      if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) {
	        throw new TypeError('Object.keys called on non-object');
	      }
	
	      var result = [], prop, i;
	
	      for (prop in obj) {
	        if (hasOwnProperty.call(obj, prop)) {
	          result.push(prop);
	        }
	      }
	
	      if (hasDontEnumBug) {
	        for (i = 0; i < dontEnumsLength; i++) {
	          if (hasOwnProperty.call(obj, dontEnums[i])) {
	            result.push(dontEnums[i]);
	          }
	        }
	      }
	      return result;
	    };
	  }());
	}
	
	ss.getKeyCount = function ss$getKeyCount(d) {
	  return Object.keys(d).length;
	};
	
	////////////////////////////////////////////////////////////////////////////////
	// Type System Implementation
	////////////////////////////////////////////////////////////////////////////////
	
	// When FULL_TYPE_SYSTEM is not defined, then the code is not the full-blown
	// type system. It's Just enough to allow us to call base class methods.
	
	ss.__genericCache = {};
	
	ss._makeGenericTypeName = function ss$_makeGenericTypeName(genericType, typeArguments) {
	  var result = genericType.__typeName;
	  for (var i = 0; i < typeArguments.length; i++)
	    result += (i === 0 ? '[' : ',') + '[' + ss.getTypeQName(typeArguments[i]) + ']';
	  result += ']';
	  return result;
	};
	
	ss.makeGenericType = function ss$makeGenericType(genericType, typeArguments) {
	  var name = ss._makeGenericTypeName(genericType, typeArguments);
	  return ss.__genericCache[name] || genericType.apply(null, typeArguments);
	};
	
	ss.registerGenericClassInstance = function ss$registerGenericClassInstance(instance, genericType, typeArguments, members, baseType, interfaceTypes) {
	  var name = ss._makeGenericTypeName(genericType, typeArguments);
	  ss.__genericCache[name] = instance;
	  instance.__typeName = name;
	  instance.__genericTypeDefinition = genericType;
	  instance.__typeArguments = typeArguments;
	  ss.initClass(instance, genericType.__assembly, members, baseType(), interfaceTypes());
	};
	
	ss.registerGenericInterfaceInstance = function ss$registerGenericInterfaceInstance(instance, genericType, typeArguments, members, baseInterfaces) {
	  var name = ss._makeGenericTypeName(genericType, typeArguments);
	  ss.__genericCache[name] = instance;
	  instance.__typeName = name;
	  instance.__genericTypeDefinition = genericType;
	  instance.__typeArguments = typeArguments;
	  ss.initInterface(instance, genericType.__assembly, members, baseInterfaces());
	};
	
	ss.isGenericTypeDefinition = function ss$isGenericTypeDefinition(type) {
	  return type.__isGenericTypeDefinition || false;
	};
	
	ss.getGenericTypeDefinition = function ss$getGenericTypeDefinition(type) {
	  return type.__genericTypeDefinition || null;
	};
	
	ss.getGenericParameterCount = function ss$getGenericParameterCount(type) {
	  return type.__typeArgumentCount || 0;
	};
	
	ss.getGenericArguments = function ss$getGenericArguments(type) {
	  return type.__typeArguments || null;
	};
	
	
	ss.setMetadata = function ss$_setMetadata(type, metadata) {
	  if (metadata.members) {
	    for (var i = 0; i < metadata.members.length; i++) {
	      var m = metadata.members[i];
	      m.typeDef = type;
	      if (m.adder) m.adder.typeDef = type;
	      if (m.remover) m.remover.typeDef = type;
	      if (m.getter) m.getter.typeDef = type;
	      if (m.setter) m.setter.typeDef = type;
	    }
	  }
	  type.__metadata = metadata;
	  if (metadata.variance) {
	    type.isAssignableFrom = function(source) {
	      var check = function(target, type) {
	        if (type.__genericTypeDefinition === target.__genericTypeDefinition && type.__typeArguments.length == target.__typeArguments.length) {
	          for (var i = 0; i < target.__typeArguments.length; i++) {
	            var v = target.__metadata.variance[i], t = target.__typeArguments[i], s = type.__typeArguments[i];
	            switch (v) {
	              case 1: if (!ss.isAssignableFrom(t, s)) return false; break;
	              case 2: if (!ss.isAssignableFrom(s, t)) return false; break;
	              default: if (s !== t) return false;
	            }
	          }
	          return true;
	        }
	        return false;
	      };
	
	      if (source.__interface && check(this, source))
	        return true;
	      var ifs = ss.getInterfaces(source);
	      for (var i = 0; i < ifs.length; i++) {
	        if (ifs[i] === this || check(this, ifs[i]))
	          return true;
	      }
	      return false;
	    };
	  }
	}
	ss.setMetadata = function ss$_setMetadata(type, metadata) {
	};
	
	ss.initClass = function ss$initClass(ctor, asm, members, baseType, interfaces) {
	  ctor.__class = true;
	  ctor.__assembly = asm;
	  if (!ctor.__typeArguments)
	    asm.__types[ctor.__typeName] = ctor;
	  if (baseType && baseType !== Object) {
	    var f = function(){};
	    f.prototype = baseType.prototype;
	    ctor.prototype = new f();
	    ctor.prototype.constructor = ctor;
	  }
	  ss.shallowCopy(members, ctor.prototype);
	  if (interfaces)
	    ctor.__interfaces = interfaces;
	};
	
	ss.initGenericClass = function ss$initGenericClass(ctor, asm, typeArgumentCount) {
	  ctor.__class = true;
	  ctor.__assembly = asm;
	  asm.__types[ctor.__typeName] = ctor;
	  ctor.__typeArgumentCount = typeArgumentCount;
	  ctor.__isGenericTypeDefinition = true;
	};
	
	ss.initInterface = function ss$initInterface(ctor, asm, members, baseInterfaces) {
	  ctor.__interface = true;
	  ctor.__assembly = asm;
	  if (!ctor.__typeArguments)
	    asm.__types[ctor.__typeName] = ctor;
	  if (baseInterfaces)
	    ctor.__interfaces = baseInterfaces;
	  ss.shallowCopy(members, ctor.prototype);
	  ctor.isAssignableFrom = function(type) { return ss.contains(ss.getInterfaces(type), this); };
	};
	
	ss.initGenericInterface = function ss$initGenericClass(ctor, asm, typeArgumentCount) {
	  ctor.__interface = true;
	  ctor.__assembly = asm;
	  asm.__types[ctor.__typeName] = ctor;
	  ctor.__typeArgumentCount = typeArgumentCount;
	  ctor.__isGenericTypeDefinition = true;
	};
	
	ss.initEnum = function ss$initEnum(ctor, asm, members, namedValues) {
	  ctor.__enum = true;
	  ctor.__assembly = asm;
	  asm.__types[ctor.__typeName] = ctor;
	  ss.shallowCopy(members, ctor.prototype);
	  ctor.getDefaultValue = ctor.createInstance = function() { return namedValues ? null : 0; };
	  ctor.isInstanceOfType = function(instance) { return typeof(instance) == (namedValues ? 'string' : 'number'); };
	};
	
	ss.getBaseType = function ss$getBaseType(type) {
	  if (type === Object || type.__interface) {
	    return null;
	  }
	  else if (Object.getPrototypeOf) {
	    return Object.getPrototypeOf(type.prototype).constructor;
	  }
	  else {
	    var p = type.prototype;
	    if (Object.prototype.hasOwnProperty.call(p, 'constructor')) {
	      try {
	        var ownValue = p.constructor;
	        delete p.constructor;
	        return p.constructor;
	      }
	      finally {
	        p.constructor = ownValue;
	      }
	    }
	    return p.constructor;
	  }
	};
	
	ss.getTypeFullName = function ss$getTypeFullName(type) {
	  return type.__typeName || type.name || (type.toString().match(/^\s*function\s*([^\s(]+)/) || [])[1] || 'Object';
	};
	
	ss.getTypeQName = function ss$getTypeFullName(type) {
	  return ss.getTypeFullName(type) + (type.__assembly ? ', ' + type.__assembly.name : '');
	};
	
	ss.getTypeName = function ss$getTypeName(type) {
	  var fullName = ss.getTypeFullName(type);
	  var bIndex = fullName.indexOf('[');
	  var nsIndex = fullName.lastIndexOf('.', bIndex >= 0 ? bIndex : fullName.length);
	  return nsIndex > 0 ? fullName.substr(nsIndex + 1) : fullName;
	};
	
	ss.getTypeNamespace = function ss$getTypeNamespace(type) {
	  var fullName = ss.getTypeFullName(type);
	  var bIndex = fullName.indexOf('[');
	  var nsIndex = fullName.lastIndexOf('.', bIndex >= 0 ? bIndex : fullName.length);
	  return nsIndex > 0 ? fullName.substr(0, nsIndex) : '';
	};
	
	ss.getTypeAssembly = function ss$getTypeAssembly(type) {
	  if (ss.contains([Date, Number, Boolean, String, Function, Array], type))
	    return ss;
	  else
	    return type.__assembly || null;
	};
	
	ss._getAssemblyType = function ss$_getAssemblyType(asm, name) {
	  var result = [];
	  if (asm.__types) {
	    return asm.__types[name] || null;
	  }
	  else {
	    var a = name.split('.');
	    for (var i = 0; i < a.length; i++) {
	      asm = asm[a[i]];
	      if (!ss.isValue(asm))
	        return null;
	    }
	    if (typeof asm !== 'function')
	      return null;
	    return asm;
	  }
	};
	
	ss.getAssemblyTypes = function ss$getAssemblyTypes(asm) {
	  var result = [];
	  if (asm.__types) {
	    for (var t in asm.__types) {
	      if (asm.__types.hasOwnProperty(t))
	        result.push(asm.__types[t]);
	    }
	  }
	  else {
	    var traverse = function(s, n) {
	      for (var c in s) {
	        if (s.hasOwnProperty(c))
	          traverse(s[c], c);
	      }
	      if (typeof(s) === 'function' && ss.isUpper(n.charCodeAt(0)))
	        result.push(s);
	    };
	    traverse(asm, '');
	  }
	  return result;
	};
	
	ss.createAssemblyInstance = function ss$createAssemblyInstance(asm, typeName) {
	  var t = ss.getType(typeName, asm);
	  return t ? ss.createInstance(t) : null;
	};
	
	ss.getInterfaces = function ss$getInterfaces(type) {
	  if (type.__interfaces)
	    return type.__interfaces;
	  else if (type === Date || type === Number)
	    return [ ss_IEquatable, ss_IComparable, ss_IFormattable ];
	  else if (type === Boolean || type === String)
	    return [ ss_IEquatable, ss_IComparable ];
	  else if (type === Array || ss.isTypedArrayType(type))
	    return [ ss_IEnumerable, ss_ICollection, ss_IList ];
	  else
	    return [];
	};
	
	ss.isInstanceOfType = function ss$isInstanceOfType(instance, type) {
	  if (ss.isNullOrUndefined(instance))
	    return false;
	
	  if (typeof(type.isInstanceOfType) === 'function')
	    return type.isInstanceOfType(instance);
	
	  return ss.isAssignableFrom(type, ss.getInstanceType(instance));
	};
	
	ss.isAssignableFrom = function ss$isAssignableFrom(target, type) {
	  return target === type || (typeof(target.isAssignableFrom) === 'function' && target.isAssignableFrom(type)) || type.prototype instanceof target;
	};
	
	ss.isClass = function Type$isClass(type) {
	  return (type.__class == true || type === Array || type === Function || type === RegExp || type === String || type === Error || type === Object);
	};
	
	ss.isEnum = function Type$isEnum(type) {
	  return !!type.__enum;
	};
	
	ss.isFlags = function Type$isFlags(type) {
	  return type.__metadata && type.__metadata.enumFlags || false;
	};
	
	ss.isInterface = function Type$isInterface(type) {
	  return !!type.__interface;
	};
	
	ss.safeCast = function ss$safeCast(instance, type) {
	  if (type === true)
	    return instance;
	  else if (type === false)
	    return null;
	  else
	    return ss.isInstanceOfType(instance, type) ? instance : null;
	};
	
	ss.cast = function ss$cast(instance, type) {
	  if (instance === null || typeof(instance) === 'undefined')
	    return instance;
	  else if (type === true || (type !== false && ss.isInstanceOfType(instance, type)))
	    return instance;
	  throw new ss_InvalidCastException('Cannot cast object to type ' + ss.getTypeFullName(type));
	};
	
	ss.getInstanceType = function ss$getInstanceType(instance) {
	  if (!ss.isValue(instance))
	    throw new ss_NullReferenceException('Cannot get type of null');
	
	  // NOTE: We have to catch exceptions because the constructor
	  //       cannot be looked up on native COM objects
	  try {
	    return instance.constructor;
	  }
	  catch (ex) {
	    return Object;
	  }
	};
	
	ss._getType = function (typeName, asm, re) {
	  var outer = !re;
	  re = re || /[[,\]]/g;
	  var last = re.lastIndex, m = re.exec(typeName), tname, targs = [];
	  if (m) {
	    tname = typeName.substring(last, m.index);
	    switch (m[0]) {
	      case '[':
	        if (typeName[m.index + 1] != '[')
	          return null;
	        for (;;) {
	          re.exec(typeName);
	          var t = ss._getType(typeName, global, re);
	          if (!t)
	            return null;
	          targs.push(t);
	          m = re.exec(typeName);
	          if (m[0] === ']')
	            break;
	          else if (m[0] !== ',')
	            return null;
	        }
	        m = re.exec(typeName);
	        if (m && m[0] === ',') {
	          re.exec(typeName);
	          if (!(asm = ss.__assemblies[(re.lastIndex > 0 ? typeName.substring(m.index + 1, re.lastIndex - 1) : typeName.substring(m.index + 1)).trim()]))
	            return null;
	        }
	        break;
	
	      case ']':
	        break;
	
	      case ',':
	        re.exec(typeName);
	        if (!(asm = ss.__assemblies[(re.lastIndex > 0 ? typeName.substring(m.index + 1, re.lastIndex - 1) : typeName.substring(m.index + 1)).trim()]))
	          return null;
	        break;
	    }
	  }
	  else {
	    tname = typeName.substring(last);
	  }
	
	  if (outer && re.lastIndex)
	    return null;
	
	  var t = ss._getAssemblyType(asm, tname.trim());
	  return targs.length ? ss.makeGenericType(t, targs) : t;
	}
	
	ss.getType = function ss$getType(typeName, asm) {
	  return typeName ? ss._getType(typeName, asm || global) : null;
	};
	
	ss.getDefaultValue = function ss$getDefaultValue(type) {
	  if (typeof(type.getDefaultValue) === 'function')
	    return type.getDefaultValue();
	  else if (type === Boolean)
	    return false;
	  else if (type === Date)
	    return new Date(0);
	  else if (type === Number)
	    return 0;
	  return null;
	};
	
	ss.createInstance = function ss$createInstance(type) {
	  if (typeof(type.createInstance) === 'function')
	    return type.createInstance();
	  else if (type === Boolean)
	    return false;
	  else if (type === Date)
	    return new Date(0);
	  else if (type === Number)
	    return 0;
	  else if (type === String)
	    return '';
	  else
	    return new type();
	};
	
	
	///////////////////////////////////////////////////////////////////////////////
	// IFormattable
	
	var ss_IFormattable = function IFormattable$() { };
	
	ss_IFormattable.__typeName = 'ss.IFormattable';
	ss.IFormattable = ss_IFormattable;
	ss.initInterface(ss_IFormattable, ss, { format: null });
	
	
	///////////////////////////////////////////////////////////////////////////////
	// IComparable
	
	var ss_IComparable = function IComparable$() { };
	
	ss_IComparable.__typeName = 'ss.IComparable';
	ss.IComparable = ss_IComparable;
	ss.initInterface(ss_IComparable, ss, { compareTo: null });
	
	///////////////////////////////////////////////////////////////////////////////
	// IEquatable
	
	var ss_IEquatable = function IEquatable$() { };
	
	ss_IEquatable.__typeName = 'ss.IEquatable';
	ss.IEquatable = ss_IEquatable;
	ss.initInterface(ss_IEquatable, ss, { equalsT: null });
	
	///////////////////////////////////////////////////////////////////////////////
	// Number Extensions
	
	
	///////////////////////////////////////////////////////////////////////////////
	// String Extensions
	
	
	ss.isNullOrEmptyString = function ss$isNullOrEmptyString(s) {
	  return !s || !s.length;
	};
	
	
	if (!String.prototype.trim) {
	  String.prototype.trim = function String$trim() {
	    return ss.trimStartString(ss.trimEndString(this));
	  };
	}
	
	ss.trimEndString = function ss$trimEndString(s, chars) {
	  return s.replace(chars ? new RegExp('[' + String.fromCharCode.apply(null, chars) + ']+$') : /\s*$/, '');
	};
	
	ss.trimStartString = function ss$trimStartString(s, chars) {
	  return s.replace(chars ? new RegExp('^[' + String.fromCharCode.apply(null, chars) + ']+') : /^\s*/, '');
	};
	
	ss.trimString = function ss$trimString(s, chars) {
	  return ss.trimStartString(ss.trimEndString(s, chars), chars);
	};
	
	
	///////////////////////////////////////////////////////////////////////////////
	// Math Extensions
	
	
	///////////////////////////////////////////////////////////////////////////////
	// IFormatProvider
	
	///////////////////////////////////////////////////////////////////////////////
	// NumberFormatInfo
	
	///////////////////////////////////////////////////////////////////////////////
	// DateTimeFormatInfo
	
	///////////////////////////////////////////////////////////////////////////////
	// Array Extensions
	
	
	ss.arrayClone = function ss$arrayClone(arr) {
	    if (arr.length === 1) {
	        return [arr[0]];
	    }
	    else {
	        return Array.apply(null, arr);
	    }
	};
	
	
	if (!Array.prototype.map) {
	  Array.prototype.map = function Array$map(callback, instance) {
	    var length = this.length;
	    var mapped = new Array(length);
	    for (var i = 0; i < length; i++) {
	      if (i in this) {
	        mapped[i] = callback.call(instance, this[i], i, this);
	      }
	    }
	    return mapped;
	  };
	}
	
	
	if (!Array.prototype.some) {
	  Array.prototype.some = function Array$some(callback, instance) {
	    var length = this.length;
	    for (var i = 0; i < length; i++) {
	      if (i in this && callback.call(instance, this[i], i, this)) {
	        return true;
	      }
	    }
	    return false;
	  };
	}
	
	// Production steps of ECMA-262, Edition 5, 15.4.4.18
	// Reference: http://es5.github.io/#x15.4.4.18
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
	if (!Array.prototype.forEach) {
	
	  Array.prototype.forEach = function(callback, thisArg) {
	
	      var T, k;
	
	      if (this == null) {
	          throw new TypeError(' this is null or not defined');
	      }
	
	      // 1. Let O be the result of calling ToObject passing the |this| value as the argument.
	      var O = Object(this);
	
	      // 2. Let lenValue be the result of calling the Get internal method of O with the argument "length".
	      // 3. Let len be ToUint32(lenValue).
	      var len = O.length >>> 0;
	
	      // 4. If IsCallable(callback) is false, throw a TypeError exception.
	      // See: http://es5.github.com/#x9.11
	      if (typeof callback !== "function") {
	          throw new TypeError(callback + ' is not a function');
	      }
	
	      // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
	      if (arguments.length > 1) {
	          T = thisArg;
	      }
	
	      // 6. Let k be 0
	      k = 0;
	
	      // 7. Repeat, while k < len
	      while (k < len) {
	
	          var kValue;
	
	          // a. Let Pk be ToString(k).
	          //   This is implicit for LHS operands of the in operator
	          // b. Let kPresent be the result of calling the HasProperty internal method of O with argument Pk.
	          //   This step can be combined with c
	          // c. If kPresent is true, then
	          if (k in O) {
	
	              // i. Let kValue be the result of calling the Get internal method of O with argument Pk.
	              kValue = O[k];
	
	              // ii. Call the Call internal method of callback with T as the this value and
	              // argument list containing kValue, k, and O.
	              callback.call(T, kValue, k, O);
	          }
	          // d. Increase k by 1.
	          k++;
	      }
	      // 8. return undefined
	  };
	}
	
	// Production steps of ECMA-262, Edition 5
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter
	if (!Array.prototype.filter) {
	    Array.prototype.filter = function(fun/*, thisArg*/) {
	
	        if (this === void 0 || this === null) {
	            throw new TypeError();
	        }
	
	        var t = Object(this);
	        var len = t.length >>> 0;
	        if (typeof fun !== 'function') {
	            throw new TypeError();
	        }
	
	        var res = [];
	        var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
	        for (var i = 0; i < len; i++) {
	            if (i in t) {
	                var val = t[i];
	
	                // NOTE: Technically this should Object.defineProperty at
	                //       the next index, as push can be affected by
	                //       properties on Object.prototype and Array.prototype.
	                //       But that method's new, and collisions should be
	                //       rare, so use the more-compatible alternative.
	                if (fun.call(thisArg, val, i, t)) {
	                    res.push(val);
	                }
	            }
	        }
	
	        return res;
	    };
	}
	
	
	///////////////////////////////////////////////////////////////////////////////
	// Date Extensions
	
	
	///////////////////////////////////////////////////////////////////////////////
	// Function Extensions
	
	ss._delegateContains = function ss$_delegateContains(targets, object, method) {
	  for (var i = 0; i < targets.length; i += 2) {
	    if (targets[i] === object && targets[i + 1] === method) {
	      return true;
	    }
	  }
	  return false;
	};
	
	ss._mkdel = function ss$_mkdel(targets) {
	  var delegate = function() {
	    if (targets.length == 2) {
	      return targets[1].apply(targets[0], arguments);
	    }
	    else {
	      var clone = ss.arrayClone(targets);
	      for (var i = 0; i < clone.length; i += 2) {
	        if (ss._delegateContains(targets, clone[i], clone[i + 1])) {
	          clone[i + 1].apply(clone[i], arguments);
	        }
	      }
	      return null;
	    }
	  };
	  delegate._targets = targets;
	
	  return delegate;
	};
	
	ss.mkdel = function ss$mkdel(object, method) {
	  if (!object) {
	    return method;
	  }
	  return ss._mkdel([object, method]);
	};
	
	ss.delegateCombine = function ss$delegateCombine(delegate1, delegate2) {
	  if (!delegate1) {
	    if (!delegate2._targets) {
	      return ss.mkdel(null, delegate2);
	    }
	    return delegate2;
	  }
	  if (!delegate2) {
	    if (!delegate1._targets) {
	      return ss.mkdel(null, delegate1);
	    }
	    return delegate1;
	  }
	
	  var targets1 = delegate1._targets ? delegate1._targets : [null, delegate1];
	  var targets2 = delegate2._targets ? delegate2._targets : [null, delegate2];
	
	  return ss._mkdel(targets1.concat(targets2));
	};
	
	ss.delegateRemove = function ss$delegateRemove(delegate1, delegate2) {
	  if (!delegate1 || (delegate1 === delegate2)) {
	    return null;
	  }
	  if (!delegate2) {
	    return delegate1;
	  }
	
	  var targets = delegate1._targets;
	  var object = null;
	  var method;
	  if (delegate2._targets) {
	    object = delegate2._targets[0];
	    method = delegate2._targets[1];
	  }
	  else {
	    method = delegate2;
	  }
	
	  for (var i = 0; i < targets.length; i += 2) {
	    if ((targets[i] === object) && (targets[i + 1] === method)) {
	      if (targets.length == 2) {
	        return null;
	      }
	      var t = ss.arrayClone(targets);
	      t.splice(i, 2);
	      return ss._mkdel(t);
	    }
	  }
	
	  return delegate1;
	};
	
	ss.delegateEquals = function ss$delegateEquals(a, b) {
	    if (a === b)
	        return true;
	    if (!a._targets && !b._targets)
	        return false;
	    var ta = a._targets || [null, a], tb = b._targets || [null, b];
	    if (ta.length != tb.length)
	        return false;
	    for (var i = 0; i < ta.length; i++) {
	        if (ta[i] !== tb[i])
	            return false;
	    }
	    return true;
	};
	
	
	///////////////////////////////////////////////////////////////////////////////
	// RegExp Extensions
	
	
	///////////////////////////////////////////////////////////////////////////////
	// Debug Extensions
	
	
	///////////////////////////////////////////////////////////////////////////////
	// Enum
	
	var ss_Enum = function Enum$() {
	};
	ss_Enum.__typeName = 'ss.Enum';
	ss.Enum = ss_Enum;
	ss.initClass(ss_Enum, ss, {});
	
	
	ss_Enum.getValues = function Enum$getValues(enumType) {
	  var parts = [];
	  var values = enumType.prototype;
	  for (var i in values) {
	    if (values.hasOwnProperty(i))
	      parts.push(values[i]);
	  }
	  return parts;
	};
	
	///////////////////////////////////////////////////////////////////////////////
	// CultureInfo
	
	
	///////////////////////////////////////////////////////////////////////////////
	// IEnumerator
	
	var ss_IEnumerator = function IEnumerator$() { };
	
	ss_IEnumerator.__typeName = 'ss.IEnumerator';
	ss.IEnumerator = ss_IEnumerator;
	ss.initInterface(ss_IEnumerator, ss, { current: null, moveNext: null, reset: null }, [ss_IDisposable]);
	
	///////////////////////////////////////////////////////////////////////////////
	// IEnumerable
	
	var ss_IEnumerable = function IEnumerable$() { };
	
	ss_IEnumerable.__typeName = 'ss.IEnumerable';
	ss.IEnumerable = ss_IEnumerable;
	ss.initInterface(ss_IEnumerable, ss, { getEnumerator: null });
	
	ss.getEnumerator = function ss$getEnumerator(obj) {
	  return obj.getEnumerator ? obj.getEnumerator() : new ss_ArrayEnumerator(obj);
	};
	
	///////////////////////////////////////////////////////////////////////////////
	// ICollection
	
	var ss_ICollection = function ICollection$() { };
	
	ss_ICollection.__typeName = 'ss.ICollection';
	ss.ICollection = ss_ICollection;
	ss.initInterface(ss_ICollection, ss, { get_count: null, add: null, clear: null, contains: null, remove: null });
	
	ss.count = function ss$count(obj) {
	  return obj.get_count ? obj.get_count() : obj.length;
	};
	
	ss.add = function ss$add(obj, item) {
	  if (obj.add)
	    obj.add(item);
	  else if (ss.isArray(obj))
	    obj.push(item);
	  else
	    throw new ss_NotSupportedException();
	};
	
	ss.clear = function ss$clear(obj) {
	  if (obj.clear)
	    obj.clear();
	  else if (ss.isArray(obj))
	    obj.length = 0;
	  else
	    throw new ss_NotSupportedException();
	};
	
	ss.remove = function ss$remove(obj, item) {
	  if (obj.remove)
	    return obj.remove(item);
	  else if (ss.isArray(obj)) {
	    var index = ss.indexOf(obj, item);
	    if (index >= 0) {
	      obj.splice(index, 1);
	      return true;
	    }
	    return false;
	  }
	  else
	    throw new ss_NotSupportedException();
	};
	
	ss.contains = function ss$contains(obj, item) {
	  if (obj.contains)
	    return obj.contains(item);
	  else
	    return ss.indexOf(obj, item) >= 0;
	};
	
	///////////////////////////////////////////////////////////////////////////////
	// TimeSpan
	
	
	///////////////////////////////////////////////////////////////////////////////
	// IEqualityComparer
	
	var ss_IEqualityComparer = function IEqualityComparer$() { };
	
	ss_IEqualityComparer.__typeName = 'ss.IEqualityComparer';
	ss.IEqualityComparer = ss_IEqualityComparer;
	ss.initInterface(ss_IEqualityComparer, ss, { areEqual: null, getObjectHashCode: null });
	
	///////////////////////////////////////////////////////////////////////////////
	// IComparer
	
	var ss_IComparer = function IComparer$() { };
	
	ss_IComparer.__typeName = 'ss.IComparer';
	ss.IComparer = ss_IComparer;
	ss.initInterface(ss_IComparer, ss, { compare: null });
	
	///////////////////////////////////////////////////////////////////////////////
	// Nullable
	
	ss.unbox = function ss$unbox(instance) {
	  if (!ss.isValue(instance))
	    throw new ss_InvalidOperationException('Nullable object must have a value.');
	  return instance;
	};
	
	var ss_Nullable$1 = function Nullable$1$(T) {
	  var $type = function() {
	  };
	  $type.isInstanceOfType = function(instance) {
	    return ss.isInstanceOfType(instance, T);
	  };
	  ss.registerGenericClassInstance($type, ss_Nullable$1, [T], {}, function() { return null; }, function() { return []; });
	  return $type;
	};
	
	ss_Nullable$1.__typeName = 'ss.Nullable$1';
	ss.Nullable$1 = ss_Nullable$1;
	ss.initGenericClass(ss_Nullable$1, ss, 1);
	
	ss_Nullable$1.eq = function Nullable$eq(a, b) {
	  return !ss.isValue(a) ? !ss.isValue(b) : (a === b);
	};
	
	ss_Nullable$1.ne = function Nullable$eq(a, b) {
	  return !ss.isValue(a) ? ss.isValue(b) : (a !== b);
	};
	
	ss_Nullable$1.le = function Nullable$le(a, b) {
	  return ss.isValue(a) && ss.isValue(b) && a <= b;
	};
	
	ss_Nullable$1.ge = function Nullable$ge(a, b) {
	  return ss.isValue(a) && ss.isValue(b) && a >= b;
	};
	
	ss_Nullable$1.lt = function Nullable$lt(a, b) {
	  return ss.isValue(a) && ss.isValue(b) && a < b;
	};
	
	ss_Nullable$1.gt = function Nullable$gt(a, b) {
	  return ss.isValue(a) && ss.isValue(b) && a > b;
	};
	
	ss_Nullable$1.sub = function Nullable$sub(a, b) {
	  return ss.isValue(a) && ss.isValue(b) ? a - b : null;
	};
	
	ss_Nullable$1.add = function Nullable$add(a, b) {
	  return ss.isValue(a) && ss.isValue(b) ? a + b : null;
	};
	
	ss_Nullable$1.mod = function Nullable$mod(a, b) {
	  return ss.isValue(a) && ss.isValue(b) ? a % b : null;
	};
	
	ss_Nullable$1.div = function Nullable$divf(a, b) {
	  return ss.isValue(a) && ss.isValue(b) ? a / b : null;
	};
	
	ss_Nullable$1.mul = function Nullable$mul(a, b) {
	  return ss.isValue(a) && ss.isValue(b) ? a * b : null;
	};
	
	ss_Nullable$1.band = function Nullable$band(a, b) {
	  return ss.isValue(a) && ss.isValue(b) ? a & b : null;
	};
	
	ss_Nullable$1.bor = function Nullable$bor(a, b) {
	  return ss.isValue(a) && ss.isValue(b) ? a | b : null;
	};
	
	ss_Nullable$1.xor = function Nullable$xor(a, b) {
	  return ss.isValue(a) && ss.isValue(b) ? a ^ b : null;
	};
	
	ss_Nullable$1.shl = function Nullable$shl(a, b) {
	  return ss.isValue(a) && ss.isValue(b) ? a << b : null;
	};
	
	ss_Nullable$1.srs = function Nullable$srs(a, b) {
	  return ss.isValue(a) && ss.isValue(b) ? a >> b : null;
	};
	
	ss_Nullable$1.sru = function Nullable$sru(a, b) {
	  return ss.isValue(a) && ss.isValue(b) ? a >>> b : null;
	};
	
	ss_Nullable$1.and = function Nullable$and(a, b) {
	  if (a === true && b === true)
	    return true;
	  else if (a === false || b === false)
	    return false;
	  else
	    return null;
	};
	
	ss_Nullable$1.or = function Nullable$or(a, b) {
	  if (a === true || b === true)
	    return true;
	  else if (a === false && b === false)
	    return false;
	  else
	    return null;
	};
	
	ss_Nullable$1.not = function Nullable$not(a) {
	  return ss.isValue(a) ? !a : null;
	};
	
	ss_Nullable$1.neg = function Nullable$neg(a) {
	  return ss.isValue(a) ? -a : null;
	};
	
	ss_Nullable$1.pos = function Nullable$pos(a) {
	  return ss.isValue(a) ? +a : null;
	};
	
	ss_Nullable$1.cpl = function Nullable$cpl(a) {
	  return ss.isValue(a) ? ~a : null;
	};
	
	ss_Nullable$1.lift = function Nullable$lift() {
	  for (var i = 0; i < arguments.length; i++) {
	    if (!ss.isValue(arguments[i]))
	      return null;
	  }
	  return arguments[0].apply(null, Array.prototype.slice.call(arguments, 1));
	};
	
	///////////////////////////////////////////////////////////////////////////////
	// IList
	
	var ss_IList = function IList$() { };
	
	ss_IList.__typeName = 'ss.IList';
	ss.IList = ss_IList;
	ss.initInterface(ss_IList, ss, { get_item: null, set_item: null, indexOf: null, insert: null, removeAt: null }, [ss_ICollection, ss_IEnumerable]);
	
	ss.getItem = function ss$getItem(obj, index) {
	  return obj.get_item ? obj.get_item(index) : obj[index];
	}
	
	ss.setItem = function ss$setItem(obj, index, value) {
	  obj.set_item ? obj.set_item(index, value) : (obj[index] = value);
	}
	
	ss.indexOf = function ss$indexOf(obj, item) {
	  var itemType = typeof(item);
	  if ((!item || typeof(item.equals) !== 'function') && typeof(obj.indexOf) === 'function') {
	    // use indexOf if item is null or if item does not implement an equals function
	    return obj.indexOf(item);
	  } else if (ss.isArrayOrTypedArray(obj)) {
	    for (var i = 0; i < obj.length; i++) {
	      if (ss.staticEquals(obj[i], item)) {
	        return i;
	      }
	    }
	    return -1;
	  }
	  else
	    return obj.indexOf(item);
	};
	
	ss.insert = function ss$insert(obj, index, item) {
	  if (obj.insert)
	    obj.insert(index, item);
	  else if (ss.isArray(obj))
	    obj.splice(index, 0, item);
	  else
	    throw new ss_NotSupportedException();
	};
	
	ss.removeAt = function ss$removeAt(obj, index) {
	  if (obj.removeAt)
	    obj.removeAt(index);
	  else if (ss.isArray(obj))
	    obj.splice(index, 1);
	  else
	    throw new ss_NotSupportedException();
	};
	
	///////////////////////////////////////////////////////////////////////////////
	// IDictionary
	
	var ss_IDictionary = function IDictionary$() { };
	
	ss_IDictionary.__typeName = 'ss.IDictionary';
	ss.IDictionary = ss_IDictionary;
	ss.initInterface(ss_IDictionary, ss, { get_item: null, set_item: null, get_keys: null, get_values: null, containsKey: null, add: null, remove: null, tryGetValue: null }, [ss_IEnumerable]);
	
	///////////////////////////////////////////////////////////////////////////////
	// Int32
	
	var ss_Int32 = function Int32$() { };
	
	ss_Int32.__typeName = 'ss.Int32';
	ss.Int32 = ss_Int32;
	ss.initClass(ss_Int32, ss, {}, Object, [ ss_IEquatable, ss_IComparable, ss_IFormattable ]);
	ss_Int32.__class = false;
	
	ss_Int32.isInstanceOfType = function Int32$isInstanceOfType(instance) {
	  return typeof(instance) === 'number' && isFinite(instance) && Math.round(instance, 0) == instance;
	};
	
	ss_Int32.getDefaultValue = ss_Int32.createInstance = function Int32$getDefaultValue() {
	  return 0;
	};
	
	ss_Int32.div = function Int32$div(a, b) {
	  if (!ss.isValue(a) || !ss.isValue(b)) return null;
	  if (b === 0) throw new ss_DivideByZeroException();
	  return ss_Int32.trunc(a / b);
	};
	
	ss_Int32.trunc = function Int32$trunc(n) {
	  return ss.isValue(n) ? (n > 0 ? Math.floor(n) : Math.ceil(n)) : null;
	};
	
	ss_Int32.tryParse = function Int32$tryParse(s, result, min, max) {
	  result.$ = 0;
	  if (!/^[+-]?[0-9]+$/.test(s))
	    return 0;
	  var n = parseInt(s, 10);
	  if (n < min || n > max)
	    return false;
	  result.$ = n;
	  return true;
	};
	
	///////////////////////////////////////////////////////////////////////////////
	// MutableDateTime
	
	var ss_JsDate = function JsDate$() { };
	
	ss_JsDate.__typeName = 'ss.JsDate';
	ss.JsDate = ss_JsDate;
	ss.initClass(ss_JsDate, ss, {}, Object, [ ss_IEquatable, ss_IComparable ]);
	
	ss_JsDate.createInstance = function JsDate$createInstance() {
	    return new Date();
	};
	
	ss_JsDate.isInstanceOfType = function JsDate$isInstanceOfType(instance) {
	   return instance instanceof Date;
	};
	
	///////////////////////////////////////////////////////////////////////////////
	// ArrayEnumerator
	
	var ss_ArrayEnumerator = function ArrayEnumerator$(array) {
	  this._array = array;
	  this._index = -1;
	};
	ss_ArrayEnumerator.__typeName = 'ss.ArrayEnumerator';
	ss.ArrayEnumerator = ss_ArrayEnumerator;
	ss.initClass(ss_ArrayEnumerator, ss, {
	  moveNext: function ArrayEnumerator$moveNext() {
	    this._index++;
	    return (this._index < this._array.length);
	  },
	  reset: function ArrayEnumerator$reset() {
	    this._index = -1;
	  },
	  current: function ArrayEnumerator$current() {
	    if (this._index < 0 || this._index >= this._array.length)
	      throw 'Invalid operation';
	    return this._array[this._index];
	  },
	  dispose: function ArrayEnumerator$dispose() {
	  }
	}, null, [ss_IEnumerator, ss_IDisposable]);
	
	///////////////////////////////////////////////////////////////////////////////
	// ObjectEnumerator
	
	var ss_ObjectEnumerator = function ObjectEnumerator$(o) {
	  this._keys = Object.keys(o);
	  this._index = -1;
	  this._object = o;
	};
	
	ss_ObjectEnumerator.__typeName = 'ss.ObjectEnumerator';
	ss.ObjectEnumerator = ss_ObjectEnumerator;
	ss.initClass(ss_ObjectEnumerator, ss, {
	  moveNext: function ObjectEnumerator$moveNext() {
	    this._index++;
	    return (this._index < this._keys.length);
	  },
	  reset: function ObjectEnumerator$reset() {
	    this._index = -1;
	  },
	  current: function ObjectEnumerator$current() {
	    if (this._index < 0 || this._index >= this._keys.length)
	      throw new ss_InvalidOperationException('Invalid operation');
	    var k = this._keys[this._index];
	    return { key: k, value: this._object[k] };
	  },
	  dispose: function ObjectEnumerator$dispose() {
	  }
	}, null, [ss_IEnumerator, ss_IDisposable]);
	
	///////////////////////////////////////////////////////////////////////////////
	// EqualityComparer
	
	var ss_EqualityComparer = function EqualityComparer$() {
	};
	ss_EqualityComparer.__typeName = 'ss.EqualityComparer';
	ss.EqualityComparer = ss_EqualityComparer;
	ss.initClass(ss_EqualityComparer, ss, {
	  areEqual: function EqualityComparer$areEqual(x, y) {
	    return ss.staticEquals(x, y);
	  },
	  getObjectHashCode: function EqualityComparer$getObjectHashCode(obj) {
	    return ss.isValue(obj) ? ss.getHashCode(obj) : 0;
	  }
	}, null, [ss_IEqualityComparer]);
	ss_EqualityComparer.def = new ss_EqualityComparer();
	
	
	///////////////////////////////////////////////////////////////////////////////
	// Comparer
	
	var ss_Comparer = function Comparer$(f) {
	  this.f = f;
	};
	
	ss_Comparer.__typeName = 'ss.Comparer';
	ss.Comparer = ss_Comparer;
	ss.initClass(ss_Comparer, ss, {
	  compare: function Comparer$compare(x, y) {
	    return this.f(x, y);
	  }
	}, null, [ss_IComparer]);
	ss_Comparer.def = new ss_Comparer(function Comparer$defaultCompare(a, b) {
	  if (!ss.isValue(a))
	    return !ss.isValue(b)? 0 : -1;
	  else if (!ss.isValue(b))
	    return 1;
	  else
	    return ss.compare(a, b);
	});
	
	
	//#include "Dictionary.js"
	
	///////////////////////////////////////////////////////////////////////////////
	// IDisposable
	
	var ss_IDisposable = function IDisposable$() { };
	ss_IDisposable.__typeName = 'ss.IDisposable';
	ss.IDisposable = ss_IDisposable;
	ss.initInterface(ss_IDisposable, ss, { dispose: null });
	
	///////////////////////////////////////////////////////////////////////////////
	// StringBuilder
	
	var ss_StringBuilder = function StringBuilder$(s) {
	  this._parts = (ss.isValue(s) && s != '') ? [s] : [];
	  this.length = ss.isValue(s) ? s.length : 0;
	}
	
	ss_StringBuilder.__typeName = 'ss.StringBuilder';
	ss.StringBuilder = ss_StringBuilder;
	ss.initClass(ss_StringBuilder, ss, {
	  append: function StringBuilder$append(o) {
	    if (ss.isValue(o)) {
	      var s = o.toString();
	      ss.add(this._parts, s);
	      this.length += s.length;
	    }
	    return this;
	  },
	
	  appendChar: function StringBuilder$appendChar(c) {
	    return this.append(String.fromCharCode(c));
	  },
	
	  appendLine: function StringBuilder$appendLine(s) {
	    this.append(s);
	    this.append('\r\n');
	    return this;
	  },
	
	  appendLineChar: function StringBuilder$appendLineChar(c) {
	    return this.appendLine(String.fromCharCode(c));
	  },
	
	  clear: function StringBuilder$clear() {
	    this._parts = [];
	    this.length = 0;
	  },
	
	  toString: function StringBuilder$toString() {
	    return this._parts.join('');
	  }
	});
	
	///////////////////////////////////////////////////////////////////////////////
	// Random
	
	
	///////////////////////////////////////////////////////////////////////////////
	// EventArgs
	
	var ss_EventArgs = function EventArgs$() {
	}
	ss_EventArgs.__typeName = 'ss.EventArgs';
	ss.EventArgs = ss_EventArgs;
	ss.initClass(ss_EventArgs, ss, {});
	
	ss_EventArgs.Empty = new ss_EventArgs();
	
	///////////////////////////////////////////////////////////////////////////////
	// Exception
	
	var ss_Exception = function Exception$(message, innerException) {
	  this._message = message || 'An error occurred.';
	  this._innerException = innerException || null;
	  this._error = new Error();
	}
	
	ss_Exception.__typeName = 'ss.Exception';
	ss.Exception = ss_Exception;
	ss.initClass(ss_Exception, ss, {
	  get_message: function Exception$get_message() {
	    return this._message;
	  },
	  get_innerException: function Exception$get_innerException() {
	    return this._innerException;
	  },
	  get_stack: function Exception$get_stack() {
	    return this._error.stack;
	  }
	});
	
	ss_Exception.wrap = function Exception$wrap(o) {
	  if (ss.isInstanceOfType(o, ss_Exception)) {
	    return o;
	  }
	  else if (o instanceof TypeError) {
	    // TypeError can either be 'cannot read property blah of null/undefined' (proper NullReferenceException), or it can be eg. accessing a non-existent method of an object.
	    // As long as all code is compiled, they should with a very high probability indicate the use of a null reference.
	    return new ss_NullReferenceException(o.message, new ss_JsErrorException(o));
	  }
	  else if (o instanceof RangeError) {
	    return new ss_ArgumentOutOfRangeException(null, o.message, new ss_JsErrorException(o));
	  }
	  else if (o instanceof Error) {
	    return new ss_JsErrorException(o);
	  }
	  else {
	    return new ss_Exception(o.toString());
	  }
	};
	
	////////////////////////////////////////////////////////////////////////////////
	// NotImplementedException
	
	var ss_NotImplementedException = function NotImplementedException$(message, innerException) {
	  ss_Exception.call(this, message || 'The method or operation is not implemented.', innerException);
	};
	ss_NotImplementedException.__typeName = 'ss.NotImplementedException';
	ss.NotImplementedException = ss_NotImplementedException;
	ss.initClass(ss_NotImplementedException, ss, {}, ss_Exception);
	
	////////////////////////////////////////////////////////////////////////////////
	// NotSupportedException
	
	var ss_NotSupportedException = function NotSupportedException$(message, innerException) {
	  ss_Exception.call(this, message || 'Specified method is not supported.', innerException);
	};
	ss_NotSupportedException.__typeName = 'ss.NotSupportedException';
	ss.NotSupportedException = ss_NotSupportedException;
	ss.initClass(ss_NotSupportedException, ss, {}, ss_Exception);
	
	////////////////////////////////////////////////////////////////////////////////
	// AggregateException
	
	var ss_AggregateException = function AggregateException$(message, innerExceptions) {
	  this.innerExceptions = ss.isValue(innerExceptions) ? ss.arrayFromEnumerable(innerExceptions) : [];
	  ss_Exception.call(this, message || 'One or more errors occurred.', this.innerExceptions.length ? this.innerExceptions[0] : null);
	};
	
	ss_AggregateException.__typeName = 'ss.AggregateException';
	ss.AggregateException = ss_AggregateException;
	ss.initClass(ss_AggregateException, ss, {
	  flatten: function  AggregateException$flatten() {
	    var inner = [];
	    for (var i = 0; i < this.innerExceptions.length; i++) {
	      var e = this.innerExceptions[i];
	      if (ss.isInstanceOfType(e, ss_AggregateException)) {
	        inner.push.apply(inner, e.flatten().innerExceptions);
	      }
	      else {
	        inner.push(e);
	      }
	    }
	    return new ss_AggregateException(this._message, inner);
	  }
	}, ss_Exception);
	
	////////////////////////////////////////////////////////////////////////////////
	// PromiseException
	
	var ss_PromiseException = function PromiseException(args, message, innerException) {
	  ss_Exception.call(this, message || (args.length && args[0] ? args[0].toString() : 'An error occurred'), innerException);
	  this.arguments = ss.arrayClone(args);
	};
	
	ss_PromiseException.__typeName = 'ss.PromiseException';
	ss.PromiseException = ss_PromiseException;
	ss.initClass(ss_PromiseException, ss, {
	  get_arguments: function PromiseException$get_arguments() {
	    return this._arguments;
	  }
	}, ss_Exception);
	
	////////////////////////////////////////////////////////////////////////////////
	// JsErrorException
	
	var ss_JsErrorException = function JsErrorException$(error, message, innerException) {
	  ss_Exception.call(this, message || error.message, innerException);
	  this.error = error;
	};
	ss_JsErrorException.__typeName = 'ss.JsErrorException';
	ss.JsErrorException = ss_JsErrorException;
	ss.initClass(ss_JsErrorException, ss, {
	  get_stack: function Exception$get_stack() {
	    return this.error.stack;
	  }
	}, ss_Exception);
	
	////////////////////////////////////////////////////////////////////////////////
	// ArgumentException
	
	var ss_ArgumentException = function ArgumentException$(message, paramName, innerException) {
	  ss_Exception.call(this, message || 'Value does not fall within the expected range.', innerException);
	  this.paramName = paramName || null;
	};
	
	ss_ArgumentException.__typeName = 'ss.ArgumentException';
	ss.ArgumentException = ss_ArgumentException;
	ss.initClass(ss_ArgumentException, ss, {}, ss_Exception);
	
	////////////////////////////////////////////////////////////////////////////////
	// ArgumentNullException
	
	var ss_ArgumentNullException = function ArgumentNullException$(paramName, message, innerException) {
	  if (!message) {
	    message = 'Value cannot be null.';
	    if (paramName)
	      message += '\nParameter name: ' + paramName;
	  }
	
	  ss_ArgumentException.call(this, message, paramName, innerException);
	};
	
	ss_ArgumentNullException.__typeName = 'ss.ArgumentNullException';
	ss.ArgumentNullException = ss_ArgumentNullException;
	ss.initClass(ss_ArgumentNullException, ss, {}, ss_ArgumentException);
	
	////////////////////////////////////////////////////////////////////////////////
	// ArgumentNullException
	
	var ss_ArgumentOutOfRangeException = function ArgumentOutOfRangeException$(paramName, message, innerException, actualValue) {
	  if (!message) {
	    message = 'Value is out of range.';
	    if (paramName)
	      message += '\nParameter name: ' + paramName;
	  }
	
	  ss_ArgumentException.call(this, message, paramName, innerException);
	  this.actualValue = actualValue || null;
	};
	
	ss_ArgumentOutOfRangeException.__typeName = 'ss.ArgumentOutOfRangeException';
	ss.ArgumentOutOfRangeException = ss_ArgumentOutOfRangeException;
	ss.initClass(ss_ArgumentOutOfRangeException, ss, {}, ss_ArgumentException);
	
	////////////////////////////////////////////////////////////////////////////////
	// FormatException
	
	var ss_FormatException = function FormatException$(message, innerException) {
	  ss_Exception.call(this, message || 'Invalid format.', innerException);
	};
	ss_FormatException.__typeName = 'ss.FormatException';
	ss.FormatException = ss_FormatException;
	ss.initClass(ss_FormatException, ss, {}, ss_Exception);
	
	////////////////////////////////////////////////////////////////////////////////
	// DivideByZeroException
	
	var ss_DivideByZeroException = function DivideByZeroException$(message, innerException) {
	  ss_Exception.call(this, message || 'Division by 0.', innerException);
	};
	ss_DivideByZeroException.__typeName = 'ss.DivideByZeroException';
	ss.DivideByZeroException = ss_DivideByZeroException;
	ss.initClass(ss_DivideByZeroException, ss, {}, ss_Exception);
	
	////////////////////////////////////////////////////////////////////////////////
	// InvalidCastException
	
	var ss_InvalidCastException = function InvalidCastException$(message, innerException) {
	  ss_Exception.call(this, message || 'The cast is not valid.', innerException);
	};
	ss_InvalidCastException.__typeName = 'ss.InvalidCastException';
	ss.InvalidCastException = ss_InvalidCastException;
	ss.initClass(ss_InvalidCastException, ss, {}, ss_Exception);
	
	////////////////////////////////////////////////////////////////////////////////
	// InvalidOperationException
	
	var ss_InvalidOperationException = function InvalidOperationException$(message, innerException) {
	  ss_Exception.call(this, message || 'Operation is not valid due to the current state of the object.', innerException);
	};
	ss_InvalidOperationException.__typeName = 'ss.InvalidOperationException';
	ss.InvalidOperationException = ss_InvalidOperationException;
	ss.initClass(ss_InvalidOperationException, ss, {}, ss_Exception);
	
	////////////////////////////////////////////////////////////////////////////////
	// NullReferenceException
	
	var ss_NullReferenceException = function NullReferenceException$(message, innerException) {
	  ss_Exception.call(this, message || 'Object is null.', innerException);
	};
	ss_NullReferenceException.__typeName = 'ss.NullReferenceException';
	ss.NullReferenceException = ss_NullReferenceException;
	ss.initClass(ss_NullReferenceException, ss, {}, ss_Exception);
	
	////////////////////////////////////////////////////////////////////////////////
	// KeyNotFoundException
	
	var ss_KeyNotFoundException = function KeyNotFoundException$(message, innerException) {
	  ss_Exception.call(this, message || 'Key not found.', innerException);
	};
	ss_KeyNotFoundException.__typeName = 'ss.KeyNotFoundException';
	ss.KeyNotFoundException = ss_KeyNotFoundException;
	ss.initClass(ss_KeyNotFoundException, ss, {}, ss_Exception);
	
	////////////////////////////////////////////////////////////////////////////////
	// InvalidOperationException
	
	var ss_AmbiguousMatchException = function AmbiguousMatchException$(message, innerException) {
	  ss_Exception.call(this, message || 'Ambiguous match.', innerException);
	};
	ss_AmbiguousMatchException.__typeName = 'ss.AmbiguousMatchException';
	ss.AmbiguousMatchException = ss_AmbiguousMatchException;
	ss.initClass(ss_AmbiguousMatchException, ss, {}, ss_Exception);
	
	///////////////////////////////////////////////////////////////////////////////
	// IteratorBlockEnumerable
	
	var ss_IteratorBlockEnumerable = function IteratorBlockEnumerable$(getEnumerator, $this) {
	  this._getEnumerator = getEnumerator;
	  this._this = $this;
	};
	
	ss_IteratorBlockEnumerable.__typeName = 'ss.IteratorBlockEnumerable';
	ss.IteratorBlockEnumerable = ss_IteratorBlockEnumerable;
	ss.initClass(ss_IteratorBlockEnumerable, ss, {
	  getEnumerator: function IteratorBlockEnumerable$getEnumerator() {
	    return this._getEnumerator.call(this._this);
	  }
	}, null, [ss_IEnumerable]);
	
	///////////////////////////////////////////////////////////////////////////////
	// IteratorBlockEnumerator
	
	var ss_IteratorBlockEnumerator = function IteratorBlockEnumerator$(moveNext, getCurrent, dispose, $this) {
	  this._moveNext = moveNext;
	  this._getCurrent = getCurrent;
	  this._dispose = dispose;
	  this._this = $this;
	};
	
	ss_IteratorBlockEnumerator.__typeName = 'ss.IteratorBlockEnumerator';
	ss.IteratorBlockEnumerator = ss_IteratorBlockEnumerator;
	ss.initClass(ss_IteratorBlockEnumerator, ss, {
	  moveNext: function IteratorBlockEnumerator$moveNext() {
	    try {
	      return this._moveNext.call(this._this);
	    }
	    catch (ex) {
	      if (this._dispose)
	        this._dispose.call(this._this);
	      throw ex;
	    }
	  },
	  current: function IteratorBlockEnumerator$current() {
	    return this._getCurrent.call(this._this);
	  },
	  reset: function IteratorBlockEnumerator$reset() {
	    throw new ss_NotSupportedException('Reset is not supported.');
	  },
	  dispose: function IteratorBlockEnumerator$dispose() {
	    if (this._dispose)
	      this._dispose.call(this._this);
	  }
	}, null, [ss_IEnumerator, ss_IDisposable]);
	
	
	///////////////////////////////////////////////////////////////////////////////
	// Lazy
	
	var ss_Lazy = function Lazy$(valueFactory) {
	  this._valueFactory = valueFactory;
	  this.isValueCreated = false;
	};
	ss_Lazy.__typeName = 'ss.Lazy';
	ss.Lazy = ss_Lazy;
	ss.initClass(ss_Lazy, ss, {
	  value: function Lazy$value() {
	    if (!this.isValueCreated) {
	      this._value = this._valueFactory();
	      delete this._valueFactory;
	      this.isValueCreated = true;
	    }
	    return this._value;
	  }
	});
	
	
	///////////////////////////////////////////////////////////////////////////////
	// Task
	
	
	////////////////////////////////////////////////////////////////////////////////
	// TaskStatus
	
	
	///////////////////////////////////////////////////////////////////////////////
	// TaskCompletionSource
	
	
	///////////////////////////////////////////////////////////////////////////////
	// CancelEventArgs
	
	
	///////////////////////////////////////////////////////////////////////////////
	// Guid
	
	
	////////////////////////////////////////////////////////////////////////////////
	// IE8 shims
	////////////////////////////////////////////////////////////////////////////////
	
	if (typeof(global.HTMLElement) === 'undefined') {
	  global.HTMLElement = Element;
	}
	
	if (typeof(global.MessageEvent) === 'undefined') {
	  global.MessageEvent = Event;
	}
	
	// polyfill for IE8 not having Date.now.
	Date.now = Date.now || function() { return +new Date; };
	
	////////////////////////////////////////////////////////////////////////////////
	// Global Registration
	////////////////////////////////////////////////////////////////////////////////
	
	global.ss = ss;
	})(global);
	
	var ss = global.ss;
	var HTMLElement = global.HTMLElement;
	var MessageEvent = global.MessageEvent;
	
	/*! BEGIN CoreSlim */
	
	
	(function() {
		'dont use strict';
		var $asm = {};
		global.tab = global.tab || {};
		ss.initAssembly($asm, 'tabcoreslim');
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.CoreSlim.EscapingUtil
		var $tab_EscapingUtil = function() {
		};
		$tab_EscapingUtil.__typeName = 'tab.EscapingUtil';
		$tab_EscapingUtil.escapeHtml = function EscapingUtil$EscapeHtml(html) {
			var escaped = ss.coalesce(html, '');
			escaped = escaped.replace(new RegExp('&', 'g'), '&amp;');
			escaped = escaped.replace(new RegExp('<', 'g'), '&lt;');
			escaped = escaped.replace(new RegExp('>', 'g'), '&gt;');
			escaped = escaped.replace(new RegExp('"', 'g'), '&quot;');
			escaped = escaped.replace(new RegExp("'", 'g'), '&#39;');
			escaped = escaped.replace(new RegExp('/', 'g'), '&#47;');
			return escaped;
		};
		global.tab.EscapingUtil = $tab_EscapingUtil;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Core.ScriptEx
		var $tab_ScriptEx = function() {
		};
		$tab_ScriptEx.__typeName = 'tab.ScriptEx';
		global.tab.ScriptEx = $tab_ScriptEx;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.CoreSlim.WindowHelper
		var $tab_WindowHelper = function(window) {
			this.$window = null;
			this.$window = window;
		};
		$tab_WindowHelper.__typeName = 'tab.WindowHelper';
		$tab_WindowHelper.get_windowSelf = function WindowHelper$get_WindowSelf() {
			return window.self;
		};
		$tab_WindowHelper.get_selection = function WindowHelper$get_Selection() {
			if (typeof(window['getSelection']) === 'function') {
				return window.getSelection();
			}
			else if (typeof(document['getSelection']) === 'function') {
				return document.getSelection();
			}
			return null;
		};
		$tab_WindowHelper.close = function WindowHelper$Close(window) {
			window.close();
		};
		$tab_WindowHelper.getOpener = function WindowHelper$GetOpener(window) {
			return window.opener;
		};
		$tab_WindowHelper.getLocation = function WindowHelper$GetLocation(window) {
			return window.location;
		};
		$tab_WindowHelper.getPathAndSearch = function WindowHelper$GetPathAndSearch(window) {
			return window.location.pathname + window.location.search;
		};
		$tab_WindowHelper.setLocationHref = function WindowHelper$SetLocationHref(window, href) {
			window.location.href = href;
		};
		$tab_WindowHelper.locationReplace = function WindowHelper$LocationReplace(window, url) {
			window.location.replace(url);
		};
		$tab_WindowHelper.open = function WindowHelper$Open(href, target, options) {
			return window.open(href, target, options);
		};
		$tab_WindowHelper.reload = function WindowHelper$Reload(w, forceGet) {
			w.location.reload(forceGet);
		};
		$tab_WindowHelper.requestAnimationFrame = function WindowHelper$RequestAnimationFrame(action) {
			return $tab_WindowHelper.$requestAnimationFrameFunc(action);
		};
		$tab_WindowHelper.cancelAnimationFrame = function WindowHelper$CancelAnimationFrame(animationId) {
			if (ss.isValue(animationId)) {
				$tab_WindowHelper.$cancelAnimationFrameFunc(animationId);
			}
		};
		$tab_WindowHelper.setTimeout = function WindowHelper$SetTimeout(callback, milliseconds) {
			window.setTimeout(callback, milliseconds);
		};
		$tab_WindowHelper.addListener = function WindowHelper$AddListener(windowParam, eventName, messageListener) {
			if ('addEventListener' in windowParam) {
				windowParam.addEventListener(eventName, messageListener, false);
			}
			else {
				windowParam.attachEvent('on' + eventName, messageListener);
			}
		};
		$tab_WindowHelper.removeListener = function WindowHelper$RemoveListener(window, eventName, messageListener) {
			if ('removeEventListener' in window) {
				window.removeEventListener(eventName, messageListener, false);
			}
			else {
				window.detachEvent('on' + eventName, messageListener);
			}
		};
		$tab_WindowHelper.$setDefaultRequestAnimationFrameImpl = function WindowHelper$SetDefaultRequestAnimationFrameImpl() {
			var lastTime = 0;
			$tab_WindowHelper.$requestAnimationFrameFunc = function(callback) {
				var curTime = (new Date()).getTime();
				var timeToCall = Math.max(0, 16 - (curTime - lastTime));
				lastTime = curTime + timeToCall;
				var id = window.setTimeout(callback, timeToCall);
				return id;
			};
		};
		$tab_WindowHelper.clearSelection = function WindowHelper$ClearSelection() {
			var selection = $tab_WindowHelper.get_selection();
			if (ss.isValue(selection)) {
				if (typeof(selection['removeAllRanges']) === 'function') {
					selection.removeAllRanges();
				}
				else if (typeof(selection['empty']) === 'function') {
					selection['empty']();
				}
			}
		};
		global.tab.WindowHelper = $tab_WindowHelper;
		ss.initClass($tab_EscapingUtil, $asm, {});
		ss.initClass($tab_ScriptEx, $asm, {});
		ss.initClass($tab_WindowHelper, $asm, {
			get_pageXOffset: function WindowHelper$get_PageXOffset() {
				return $tab_WindowHelper.$pageXOffsetFunc(this.$window);
			},
			get_pageYOffset: function WindowHelper$get_PageYOffset() {
				return $tab_WindowHelper.$pageYOffsetFunc(this.$window);
			},
			get_clientWidth: function WindowHelper$get_ClientWidth() {
				return $tab_WindowHelper.$clientWidthFunc(this.$window);
			},
			get_clientHeight: function WindowHelper$get_ClientHeight() {
				return $tab_WindowHelper.$clientHeightFunc(this.$window);
			},
			get_innerWidth: function WindowHelper$get_InnerWidth() {
				return $tab_WindowHelper.$innerWidthFunc(this.$window);
			},
			get_outerWidth: function WindowHelper$get_OuterWidth() {
				return $tab_WindowHelper.$outerWidthFunc(this.$window);
			},
			get_innerHeight: function WindowHelper$get_InnerHeight() {
				return $tab_WindowHelper.$innerHeightFunc(this.$window);
			},
			get_outerHeight: function WindowHelper$get_OuterHeight() {
				return $tab_WindowHelper.$outerHeightFunc(this.$window);
			},
			get_screenLeft: function WindowHelper$get_ScreenLeft() {
				return $tab_WindowHelper.$screenLeftFunc(this.$window);
			},
			get_screenTop: function WindowHelper$get_ScreenTop() {
				return $tab_WindowHelper.$screenTopFunc(this.$window);
			}
		});
		(function() {
			$tab_WindowHelper.$innerWidthFunc = null;
			$tab_WindowHelper.$innerHeightFunc = null;
			$tab_WindowHelper.$clientWidthFunc = null;
			$tab_WindowHelper.$clientHeightFunc = null;
			$tab_WindowHelper.$pageXOffsetFunc = null;
			$tab_WindowHelper.$pageYOffsetFunc = null;
			$tab_WindowHelper.$screenLeftFunc = null;
			$tab_WindowHelper.$screenTopFunc = null;
			$tab_WindowHelper.$outerWidthFunc = null;
			$tab_WindowHelper.$outerHeightFunc = null;
			$tab_WindowHelper.$requestAnimationFrameFunc = null;
			$tab_WindowHelper.$cancelAnimationFrameFunc = null;
			if ('innerWidth' in window) {
				$tab_WindowHelper.$innerWidthFunc = function(w) {
					return w.innerWidth;
				};
			}
			else {
				$tab_WindowHelper.$innerWidthFunc = function(w1) {
					return w1.document.documentElement.offsetWidth;
				};
			}
			if ('outerWidth' in window) {
				$tab_WindowHelper.$outerWidthFunc = function(w2) {
					return w2.outerWidth;
				};
			}
			else {
				$tab_WindowHelper.$outerWidthFunc = $tab_WindowHelper.$innerWidthFunc;
			}
			if ('innerHeight' in window) {
				$tab_WindowHelper.$innerHeightFunc = function(w3) {
					return w3.innerHeight;
				};
			}
			else {
				$tab_WindowHelper.$innerHeightFunc = function(w4) {
					return w4.document.documentElement.offsetHeight;
				};
			}
			if ('outerHeight' in window) {
				$tab_WindowHelper.$outerHeightFunc = function(w5) {
					return w5.outerHeight;
				};
			}
			else {
				$tab_WindowHelper.$outerHeightFunc = $tab_WindowHelper.$innerHeightFunc;
			}
			if ('clientWidth' in window) {
				$tab_WindowHelper.$clientWidthFunc = function(w6) {
					return w6['clientWidth'];
				};
			}
			else {
				$tab_WindowHelper.$clientWidthFunc = function(w7) {
					return w7.document.documentElement.clientWidth;
				};
			}
			if ('clientHeight' in window) {
				$tab_WindowHelper.$clientHeightFunc = function(w8) {
					return w8['clientHeight'];
				};
			}
			else {
				$tab_WindowHelper.$clientHeightFunc = function(w9) {
					return w9.document.documentElement.clientHeight;
				};
			}
			if (ss.isValue(window.self.pageXOffset)) {
				$tab_WindowHelper.$pageXOffsetFunc = function(w10) {
					return w10.pageXOffset;
				};
			}
			else {
				$tab_WindowHelper.$pageXOffsetFunc = function(w11) {
					return w11.document.documentElement.scrollLeft;
				};
			}
			if (ss.isValue(window.self.pageYOffset)) {
				$tab_WindowHelper.$pageYOffsetFunc = function(w12) {
					return w12.pageYOffset;
				};
			}
			else {
				$tab_WindowHelper.$pageYOffsetFunc = function(w13) {
					return w13.document.documentElement.scrollTop;
				};
			}
			if ('screenLeft' in window) {
				$tab_WindowHelper.$screenLeftFunc = function(w14) {
					return ss.unbox(ss.cast(w14.screenLeft, ss.Int32));
				};
			}
			else {
				$tab_WindowHelper.$screenLeftFunc = function(w15) {
					return w15.screenX;
				};
			}
			if ('screenTop' in window) {
				$tab_WindowHelper.$screenTopFunc = function(w16) {
					return ss.unbox(ss.cast(w16.screenTop, ss.Int32));
				};
			}
			else {
				$tab_WindowHelper.$screenTopFunc = function(w17) {
					return w17.screenY;
				};
			}
			{
				var DefaultRequestName = 'requestAnimationFrame';
				var DefaultCancelName = 'cancelAnimationFrame';
				var vendors = ['ms', 'moz', 'webkit', 'o'];
				var requestFuncName = null;
				var cancelFuncName = null;
				if (DefaultRequestName in window) {
					requestFuncName = DefaultRequestName;
				}
				if (DefaultCancelName in window) {
					cancelFuncName = DefaultCancelName;
				}
				for (var ii = 0; ii < vendors.length && (ss.isNullOrUndefined(requestFuncName) || ss.isNullOrUndefined(cancelFuncName)); ++ii) {
					var vendor = vendors[ii];
					var funcName = vendor + 'RequestAnimationFrame';
					if (ss.isNullOrUndefined(requestFuncName) && funcName in window) {
						requestFuncName = funcName;
					}
					if (ss.isNullOrUndefined(cancelFuncName)) {
						funcName = vendor + 'CancelAnimationFrame';
						if (funcName in window) {
							cancelFuncName = funcName;
						}
						funcName = vendor + 'CancelRequestAnimationFrame';
						if (funcName in window) {
							cancelFuncName = funcName;
						}
					}
				}
				if (ss.isValue(requestFuncName)) {
					$tab_WindowHelper.$requestAnimationFrameFunc = function(callback) {
						return window[requestFuncName](callback);
					};
				}
				else {
					$tab_WindowHelper.$setDefaultRequestAnimationFrameImpl();
				}
				if (ss.isValue(cancelFuncName)) {
					$tab_WindowHelper.$cancelAnimationFrameFunc = function(animationId) {
						window[cancelFuncName](animationId);
					};
				}
				else {
					$tab_WindowHelper.$cancelAnimationFrameFunc = function(id) {
						window.clearTimeout(id);
					};
				}
			}
		})();
	})();
	
	// END CoreSlim
	
	var tab = global.tab;
	
	
	/*! API */
	(function() {
		'dont use strict';
		var $asm = {};
		global.tab = global.tab || {};
		global.tableauSoftware = global.tableauSoftware || {};
		ss.initAssembly($asm, 'Tableau.JavaScript.Vql.Api');
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.CrossDomainMessageRouter
		var $tab_$CrossDomainMessageRouter = function() {
			this.$nextHandlerId = 0;
			this.$handlers = {};
			this.$commandCallbacks = {};
			this.$customViewLoadCallbacks = {};
			this.$commandReturnAfterStateReadyQueues = {};
			if ($tab__Utility.hasWindowAddEventListener()) {
				window.addEventListener('message', ss.mkdel(this, this.$handleCrossDomainMessage), false);
			}
			else if ($tab__Utility.hasDocumentAttachEvent()) {
				var handler = ss.mkdel(this, this.$handleCrossDomainMessage);
				document.attachEvent('onmessage', handler);
				window.attachEvent('onmessage', handler);
			}
			else {
				window.onmessage = ss.mkdel(this, this.$handleCrossDomainMessage);
			}
			this.$nextHandlerId = 0;
		};
		$tab_$CrossDomainMessageRouter.__typeName = 'tab.$CrossDomainMessageRouter';
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.CustomViewEventContext
		var $tab_$CustomViewEventContext = function(workbook, customViewImpl) {
			this.$customViewImpl = null;
			$tab_EventContext.call(this, workbook, null);
			this.$customViewImpl = customViewImpl;
		};
		$tab_$CustomViewEventContext.__typeName = 'tab.$CustomViewEventContext';
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.DashboardZoneInfo
		var $tab_$DashboardZoneInfo = function() {
		};
		$tab_$DashboardZoneInfo.__typeName = 'tab.$DashboardZoneInfo';
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.DeferredUtil
		var $tab_$DeferredUtil = function() {
		};
		$tab_$DeferredUtil.__typeName = 'tab.$DeferredUtil';
		$tab_$DeferredUtil.$coerceToTrustedPromise = function DeferredUtil$CoerceToTrustedPromise(promiseOrValue) {
			var promise;
			if (promiseOrValue instanceof tableauSoftware.Promise) {
				promise = ss.cast(promiseOrValue, $tab__PromiseImpl);
			}
			else {
				if (ss.isValue(promiseOrValue) && typeof(promiseOrValue['valueOf']) === 'function') {
					promiseOrValue = promiseOrValue['valueOf']();
				}
				if ($tab_$DeferredUtil.$isPromise(promiseOrValue)) {
					var deferred = new $tab__DeferredImpl();
					ss.cast(promiseOrValue, $tab__PromiseImpl).then(ss.mkdel(deferred, deferred.resolve), ss.mkdel(deferred, deferred.reject));
					promise = deferred.get_promise();
				}
				else {
					promise = $tab_$DeferredUtil.$resolved(promiseOrValue);
				}
			}
			return promise;
		};
		$tab_$DeferredUtil.$reject = function DeferredUtil$Reject(promiseOrValue) {
			return $tab_$DeferredUtil.$coerceToTrustedPromise(promiseOrValue).then(function(value) {
				return $tab_$DeferredUtil.$rejected(ss.cast(value, ss.Exception));
			}, null);
		};
		$tab_$DeferredUtil.$resolved = function DeferredUtil$Resolved(value) {
			var p = new $tab__PromiseImpl(function(callback, errback) {
				try {
					return $tab_$DeferredUtil.$coerceToTrustedPromise((ss.isValue(callback) ? callback(value) : value));
				}
				catch ($t1) {
					var e = ss.Exception.wrap($t1);
					return $tab_$DeferredUtil.$rejected(e);
				}
			});
			return p;
		};
		$tab_$DeferredUtil.$rejected = function DeferredUtil$Rejected(reason) {
			var p = new $tab__PromiseImpl(function(callback, errback) {
				try {
					return (ss.isValue(errback) ? $tab_$DeferredUtil.$coerceToTrustedPromise(errback(reason)) : $tab_$DeferredUtil.$rejected(reason));
				}
				catch ($t1) {
					var e = ss.Exception.wrap($t1);
					return $tab_$DeferredUtil.$rejected(e);
				}
			});
			return p;
		};
		$tab_$DeferredUtil.$isPromise = function DeferredUtil$IsPromise(promiseOrValue) {
			return ss.isValue(promiseOrValue) && typeof(promiseOrValue['then']) === 'function';
		};
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.DoNothingCrossDomainHandler
		var $tab_$DoNothingCrossDomainHandler = function() {
			this.$handlerId = null;
			this.$1$CustomViewsListLoadField = null;
			this.$1$StateReadyForQueryField = null;
		};
		$tab_$DoNothingCrossDomainHandler.__typeName = 'tab.$DoNothingCrossDomainHandler';
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.FilterEventContext
		var $tab_$FilterEventContext = function(workbookImpl, worksheetImpl, fieldFieldName, filterCaption) {
			this.$fieldFieldName = null;
			this.$filterCaption = null;
			$tab_EventContext.call(this, workbookImpl, worksheetImpl);
			this.$fieldFieldName = fieldFieldName;
			this.$filterCaption = filterCaption;
		};
		$tab_$FilterEventContext.__typeName = 'tab.$FilterEventContext';
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.MarkImpl
		var $tab_$MarkImpl = function(tupleIdOrPairs) {
			this.$clonedPairs = null;
			this.$collection = new tab._Collection();
			this.$tupleId = 0;
			if ($tab__jQueryShim.isArray(tupleIdOrPairs)) {
				var pairArr = tupleIdOrPairs;
				for (var i = 0; i < pairArr.length; i++) {
					var pair = pairArr[i];
					if (!ss.isValue(pair.fieldName)) {
						throw $tab__TableauException.createInvalidParameter('pair.fieldName');
					}
					if (!ss.isValue(pair.value)) {
						throw $tab__TableauException.createInvalidParameter('pair.value');
					}
					var p = new $tableauSoftware_Pair(pair.fieldName, pair.value);
					this.$collection._add(p.fieldName, p);
				}
			}
			else {
				this.$tupleId = tupleIdOrPairs;
			}
		};
		$tab_$MarkImpl.__typeName = 'tab.$MarkImpl';
		$tab_$MarkImpl.$processSelectedMarks = function MarkImpl$ProcessSelectedMarks(marksPresModel) {
			var marks = new tab._Collection();
			if (ss.isNullOrUndefined(marksPresModel) || $tab__Utility.isNullOrEmpty(marksPresModel.marks)) {
				return marks;
			}
			for (var $t1 = 0; $t1 < marksPresModel.marks.length; $t1++) {
				var markPresModel = marksPresModel.marks[$t1];
				var tupleId = markPresModel.tupleId;
				var mark = new $tableauSoftware_Mark(tupleId);
				marks._add(tupleId.toString(), mark);
				for (var $t2 = 0; $t2 < markPresModel.pairs.length; $t2++) {
					var pairPresModel = markPresModel.pairs[$t2];
					var value = $tab__Utility.convertRawValue(pairPresModel.value, pairPresModel.valueDataType);
					var pair = new $tableauSoftware_Pair(pairPresModel.fieldName, value);
					pair.formattedValue = pairPresModel.formattedValue;
					if (!mark.$impl.get_$pairs()._has(pair.fieldName)) {
						mark.$impl.$addPair(pair);
					}
				}
			}
			return marks;
		};
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.MarksEventContext
		var $tab_$MarksEventContext = function(workbookImpl, worksheetImpl) {
			$tab_EventContext.call(this, workbookImpl, worksheetImpl);
		};
		$tab_$MarksEventContext.__typeName = 'tab.$MarksEventContext';
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.ParameterEventContext
		var $tab_$ParameterEventContext = function(workbookImpl, parameterName) {
			this.$parameterName = null;
			$tab_EventContext.call(this, workbookImpl, null);
			this.$parameterName = parameterName;
		};
		$tab_$ParameterEventContext.__typeName = 'tab.$ParameterEventContext';
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.ParameterImpl
		var $tab_$ParameterImpl = function(pm) {
			this.$parameter = null;
			this.$name = null;
			this.$currentValue = null;
			this.$dataType = null;
			this.$allowableValuesType = null;
			this.$allowableValues = null;
			this.$minValue = null;
			this.$maxValue = null;
			this.$stepSize = null;
			this.$dateStepPeriod = null;
			this.$name = pm.name;
			this.$currentValue = $tab__Utility.getDataValue(pm.currentValue);
			this.$dataType = $tab_ApiEnumConverter.convertParameterDataType(pm.dataType);
			this.$allowableValuesType = $tab_ApiEnumConverter.convertParameterAllowableValuesType(pm.allowableValuesType);
			if (ss.isValue(pm.allowableValues) && this.$allowableValuesType === 'list') {
				this.$allowableValues = [];
				for (var $t1 = 0; $t1 < pm.allowableValues.length; $t1++) {
					var adv = pm.allowableValues[$t1];
					this.$allowableValues.push($tab__Utility.getDataValue(adv));
				}
			}
			if (this.$allowableValuesType === 'range') {
				this.$minValue = $tab__Utility.getDataValue(pm.minValue);
				this.$maxValue = $tab__Utility.getDataValue(pm.maxValue);
				this.$stepSize = pm.stepSize;
				if ((this.$dataType === 'date' || this.$dataType === 'datetime') && ss.isValue(this.$stepSize) && ss.isValue(pm.dateStepPeriod)) {
					this.$dateStepPeriod = $tab_ApiEnumConverter.convertPeriodType(pm.dateStepPeriod);
				}
			}
		};
		$tab_$ParameterImpl.__typeName = 'tab.$ParameterImpl';
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.PublicEnums
		var $tab_$PublicEnums = function() {
		};
		$tab_$PublicEnums.__typeName = 'tab.$PublicEnums';
		$tab_$PublicEnums.$tryNormalizeEnum = function(T) {
			return function PublicEnums$TryNormalizeEnum(rawValue, value) {
				if (ss.isValue(rawValue)) {
					var lookup = rawValue.toString().toUpperCase();
					var $t1 = ss.Enum.getValues(T);
					for (var $t2 = 0; $t2 < $t1.length; $t2++) {
						var name = $t1[$t2];
						var compareValue = name.toUpperCase();
						if (ss.referenceEquals(lookup, compareValue)) {
							value.$ = name;
							return true;
						}
					}
				}
				value.$ = ss.getDefaultValue(T);
				return false;
			};
		};
		$tab_$PublicEnums.$normalizeEnum = function(T) {
			return function PublicEnums$NormalizeEnum(rawValue, paramName) {
				var value = {};
				if (!$tab_$PublicEnums.$tryNormalizeEnum(T).call(null, rawValue, value)) {
					throw $tab__TableauException.createInvalidParameter(paramName);
				}
				return value.$;
			};
		};
		$tab_$PublicEnums.$isValidEnum = function(T) {
			return function PublicEnums$IsValidEnum(rawValue) {
				var value = {};
				var valid = $tab_$PublicEnums.$tryNormalizeEnum(T).call(null, rawValue, value);
				return valid;
			};
		};
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.ApiBootstrap
		var $tab__ApiBootstrap = function() {
		};
		$tab__ApiBootstrap.__typeName = 'tab._ApiBootstrap';
		$tab__ApiBootstrap.initialize = function ApiBootstrap$Initialize() {
			$tab__ApiObjectRegistry.registerCrossDomainMessageRouter(function() {
				return new $tab_$CrossDomainMessageRouter();
			});
		};
		global.tab._ApiBootstrap = $tab__ApiBootstrap;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.ApiCommand
		var $tab__ApiCommand = function(name, commandId, handlerId, parameters) {
			this.$name = null;
			this.$handlerId = null;
			this.$commandId = null;
			this.$parameters = null;
			this.$name = name;
			this.$commandId = commandId;
			this.$handlerId = handlerId;
			this.$parameters = parameters;
		};
		$tab__ApiCommand.__typeName = 'tab._ApiCommand';
		$tab__ApiCommand.generateNextCommandId = function ApiCommand$GenerateNextCommandId() {
			var commandId = 'cmd' + $tab__ApiCommand.$nextCommandId;
			$tab__ApiCommand.$nextCommandId++;
			return commandId;
		};
		$tab__ApiCommand.parse = function ApiCommand$Parse(serialized) {
			var name;
			var index = serialized.indexOf(String.fromCharCode(44));
			if (index < 0) {
				name = ss.cast(serialized, String);
				return new $tab__ApiCommand(name, null, null, null);
			}
			name = ss.cast(serialized.substr(0, index), String);
			var sourceId;
			var secondPart = serialized.substr(index + 1);
			index = secondPart.indexOf(String.fromCharCode(44));
			if (index < 0) {
				sourceId = secondPart;
				return new $tab__ApiCommand(name, sourceId, null, null);
			}
			sourceId = secondPart.substr(0, index);
			var handlerId;
			var thirdPart = secondPart.substr(index + 1);
			index = thirdPart.indexOf(String.fromCharCode(44));
			if (index < 0) {
				handlerId = thirdPart;
				return new $tab__ApiCommand(name, sourceId, handlerId, null);
			}
			handlerId = thirdPart.substr(0, index);
			var parameters = thirdPart.substr(index + 1);
			$tab__ApiCommand.lastResponseMessage = serialized;
			if (name === 'api.GetClientInfoCommand') {
				$tab__ApiCommand.lastClientInfoResponseMessage = serialized;
			}
			return new $tab__ApiCommand(name, sourceId, handlerId, parameters);
		};
		global.tab._ApiCommand = $tab__ApiCommand;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.ApiObjectRegistry
		var $tab__ApiObjectRegistry = function() {
		};
		$tab__ApiObjectRegistry.__typeName = 'tab._ApiObjectRegistry';
		$tab__ApiObjectRegistry.registerCrossDomainMessageRouter = function ApiObjectRegistry$RegisterCrossDomainMessageRouter(objectCreationFunc) {
			return $tab__ApiObjectRegistry.$registerType($tab_ICrossDomainMessageRouter).call(null, objectCreationFunc);
		};
		$tab__ApiObjectRegistry.getCrossDomainMessageRouter = function ApiObjectRegistry$GetCrossDomainMessageRouter() {
			return $tab__ApiObjectRegistry.$getSingleton($tab_ICrossDomainMessageRouter).call(null);
		};
		$tab__ApiObjectRegistry.disposeCrossDomainMessageRouter = function ApiObjectRegistry$DisposeCrossDomainMessageRouter() {
			$tab__ApiObjectRegistry.$clearSingletonInstance($tab_ICrossDomainMessageRouter).call(null);
		};
		$tab__ApiObjectRegistry.$registerType = function(T) {
			return function ApiObjectRegistry$RegisterType(objectCreationFunc) {
				if (ss.isNullOrUndefined($tab__ApiObjectRegistry.$creationRegistry)) {
					$tab__ApiObjectRegistry.$creationRegistry = {};
				}
				var interfaceTypeName = ss.getTypeFullName(T);
				var previousType = $tab__ApiObjectRegistry.$creationRegistry[interfaceTypeName];
				$tab__ApiObjectRegistry.$creationRegistry[interfaceTypeName] = objectCreationFunc;
				return previousType;
			};
		};
		$tab__ApiObjectRegistry.$createType = function(T) {
			return function ApiObjectRegistry$CreateType() {
				if (ss.isNullOrUndefined($tab__ApiObjectRegistry.$creationRegistry)) {
					throw $tab__TableauException.createInternalError('No types registered');
				}
				var interfaceTypeName = ss.getTypeFullName(T);
				var creationFunc = $tab__ApiObjectRegistry.$creationRegistry[interfaceTypeName];
				if (ss.isNullOrUndefined(creationFunc)) {
					throw $tab__TableauException.createInternalError("No creation function has been registered for interface type '" + interfaceTypeName + "'.");
				}
				var instance = creationFunc();
				return instance;
			};
		};
		$tab__ApiObjectRegistry.$getSingleton = function(T) {
			return function ApiObjectRegistry$GetSingleton() {
				if (ss.isNullOrUndefined($tab__ApiObjectRegistry.$singletonInstanceRegistry)) {
					$tab__ApiObjectRegistry.$singletonInstanceRegistry = {};
				}
				var interfaceTypeName = ss.getTypeFullName(T);
				var instance = ss.cast($tab__ApiObjectRegistry.$singletonInstanceRegistry[interfaceTypeName], T);
				if (ss.isNullOrUndefined(instance)) {
					instance = $tab__ApiObjectRegistry.$createType(T).call(null);
					$tab__ApiObjectRegistry.$singletonInstanceRegistry[interfaceTypeName] = instance;
				}
				return instance;
			};
		};
		$tab__ApiObjectRegistry.$clearSingletonInstance = function(T) {
			return function ApiObjectRegistry$ClearSingletonInstance() {
				if (ss.isNullOrUndefined($tab__ApiObjectRegistry.$singletonInstanceRegistry)) {
					return null;
				}
				var interfaceTypeName = ss.getTypeFullName(T);
				var instance = ss.cast($tab__ApiObjectRegistry.$singletonInstanceRegistry[interfaceTypeName], T);
				delete $tab__ApiObjectRegistry.$singletonInstanceRegistry[interfaceTypeName];
				return instance;
			};
		};
		global.tab._ApiObjectRegistry = $tab__ApiObjectRegistry;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.ApiServerNotification
		var $tab__ApiServerNotification = function(workbookName, worksheetName, data) {
			this.$workbookName = null;
			this.$worksheetName = null;
			this.$data = null;
			this.$workbookName = workbookName;
			this.$worksheetName = worksheetName;
			this.$data = data;
		};
		$tab__ApiServerNotification.__typeName = 'tab._ApiServerNotification';
		$tab__ApiServerNotification.deserialize = function ApiServerNotification$Deserialize(json) {
			var param = JSON.parse(json);
			var workbookName = ss.cast(param['api.workbookName'], String);
			var worksheetName = ss.cast(param['api.worksheetName'], String);
			var data = param['api.commandData'];
			return new $tab__ApiServerNotification(workbookName, worksheetName, data);
		};
		global.tab._ApiServerNotification = $tab__ApiServerNotification;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.ApiServerResultParser
		var $tab__ApiServerResultParser = function(serverResult) {
			this.$commandResult = null;
			this.$commandData = null;
			var param = JSON.parse(serverResult);
			this.$commandResult = ss.cast(param['api.commandResult'], String);
			this.$commandData = param['api.commandData'];
		};
		$tab__ApiServerResultParser.__typeName = 'tab._ApiServerResultParser';
		global.tab._ApiServerResultParser = $tab__ApiServerResultParser;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.DoNotUseCollection
		var $tab__CollectionImpl = function() {
			this.$items = [];
			this.$itemMap = {};
		};
		$tab__CollectionImpl.__typeName = 'tab._CollectionImpl';
		global.tab._CollectionImpl = $tab__CollectionImpl;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.CustomViewImpl
		var $tab__CustomViewImpl = function(workbookImpl, name, messagingOptions) {
			this.$customView = null;
			this.$presModel = null;
			this.$workbookImpl = null;
			this.$messagingOptions = null;
			this.$name = null;
			this.$ownerName = null;
			this.$url = null;
			this.$isPublic = false;
			this.$isDefault = false;
			this.$isStale = false;
			this.$workbookImpl = workbookImpl;
			this.$name = name;
			this.$messagingOptions = messagingOptions;
			this.$isPublic = false;
			this.$isDefault = false;
			this.$isStale = false;
		};
		$tab__CustomViewImpl.__typeName = 'tab._CustomViewImpl';
		$tab__CustomViewImpl._getAsync = function CustomViewImpl$GetAsync(eventContext) {
			var deferred = new tab._Deferred();
			deferred.resolve(eventContext.get__customViewImpl().get_$customView());
			return deferred.get_promise();
		};
		$tab__CustomViewImpl._createNew = function CustomViewImpl$CreateNew(workbookImpl, messagingOptions, apiPresModel, defaultId) {
			var cv = new $tab__CustomViewImpl(workbookImpl, apiPresModel.name, messagingOptions);
			cv.$isPublic = apiPresModel.isPublic;
			cv.$url = apiPresModel.url;
			cv.$ownerName = apiPresModel.owner.friendlyName;
			cv.$isDefault = ss.isValue(defaultId) && ss.unbox(defaultId) === apiPresModel.id;
			cv.$presModel = apiPresModel;
			return cv;
		};
		$tab__CustomViewImpl._saveNewAsync = function CustomViewImpl$SaveNewAsync(workbookImpl, messagingOptions, name) {
			var deferred = new tab._Deferred();
			var param = {};
			param['api.customViewName'] = name;
			var returnHandler = $tab__CustomViewImpl.$createCustomViewCommandReturnHandler('api.SaveNewCustomViewCommand', deferred, function(result) {
				$tab__CustomViewImpl._processCustomViewUpdate(workbookImpl, messagingOptions, result, true);
				var newView = null;
				if (ss.isValue(workbookImpl.get_$updatedCustomViews())) {
					newView = workbookImpl.get_$updatedCustomViews().get_item(0);
				}
				deferred.resolve(newView);
			});
			messagingOptions.sendCommand(Object).call(messagingOptions, param, returnHandler);
			return deferred.get_promise();
		};
		$tab__CustomViewImpl._showCustomViewAsync = function CustomViewImpl$ShowCustomViewAsync(workbookImpl, messagingOptions, serverCustomizedView) {
			var deferred = new tab._Deferred();
			var param = {};
			if (ss.isValue(serverCustomizedView)) {
				param['api.customViewParam'] = serverCustomizedView;
			}
			var returnHandler = $tab__CustomViewImpl.$createCustomViewCommandReturnHandler('api.ShowCustomViewCommand', deferred, function(result) {
				var cv = workbookImpl.get_activeCustomView();
				deferred.resolve(cv);
			});
			messagingOptions.sendCommand(Object).call(messagingOptions, param, returnHandler);
			return deferred.get_promise();
		};
		$tab__CustomViewImpl._makeCurrentCustomViewDefaultAsync = function CustomViewImpl$MakeCurrentCustomViewDefaultAsync(workbookImpl, messagingOptions) {
			var deferred = new tab._Deferred();
			var param = {};
			var returnHandler = $tab__CustomViewImpl.$createCustomViewCommandReturnHandler('api.MakeCurrentCustomViewDefaultCommand', deferred, function(result) {
				var cv = workbookImpl.get_activeCustomView();
				deferred.resolve(cv);
			});
			messagingOptions.sendCommand(Object).call(messagingOptions, param, returnHandler);
			return deferred.get_promise();
		};
		$tab__CustomViewImpl._getCustomViewsAsync = function CustomViewImpl$GetCustomViewsAsync(workbookImpl, messagingOptions) {
			var deferred = new tab._Deferred();
			var returnHandler = new (ss.makeGenericType($tab_CommandReturnHandler$1, [Object]))('api.FetchCustomViewsCommand', 0, function(result) {
				$tab__CustomViewImpl._processCustomViews(workbookImpl, messagingOptions, result);
				deferred.resolve(workbookImpl.get_$customViews()._toApiCollection());
			}, function(remoteError, message) {
				deferred.reject($tab__TableauException.create('serverError', message));
			});
			messagingOptions.sendCommand(Object).call(messagingOptions, null, returnHandler);
			return deferred.get_promise();
		};
		$tab__CustomViewImpl._processCustomViews = function CustomViewImpl$ProcessCustomViews(workbookImpl, messagingOptions, info) {
			$tab__CustomViewImpl._processCustomViewUpdate(workbookImpl, messagingOptions, info, false);
		};
		$tab__CustomViewImpl._processCustomViewUpdate = function CustomViewImpl$ProcessCustomViewUpdate(workbookImpl, messagingOptions, info, doUpdateList) {
			if (doUpdateList) {
				workbookImpl.set_$updatedCustomViews(new tab._Collection());
			}
			workbookImpl.set_$currentCustomView(null);
			var defaultId = info.defaultCustomViewId;
			if (doUpdateList && ss.isValue(info.newView)) {
				var newViewImpl = $tab__CustomViewImpl._createNew(workbookImpl, messagingOptions, info.newView, defaultId);
				workbookImpl.get_$updatedCustomViews()._add(newViewImpl.get_$name(), newViewImpl.get_$customView());
			}
			workbookImpl.set_$removedCustomViews(workbookImpl.get_$customViews());
			workbookImpl.set_$customViews(new tab._Collection());
			if (ss.isValue(info.customViews)) {
				var list = info.customViews;
				if (list.length > 0) {
					for (var i = 0; i < list.length; i++) {
						var customViewImpl = $tab__CustomViewImpl._createNew(workbookImpl, messagingOptions, list[i], defaultId);
						workbookImpl.get_$customViews()._add(customViewImpl.get_$name(), customViewImpl.get_$customView());
						if (workbookImpl.get_$removedCustomViews()._has(customViewImpl.get_$name())) {
							workbookImpl.get_$removedCustomViews()._remove(customViewImpl.get_$name());
						}
						else if (doUpdateList) {
							if (!workbookImpl.get_$updatedCustomViews()._has(customViewImpl.get_$name())) {
								workbookImpl.get_$updatedCustomViews()._add(customViewImpl.get_$name(), customViewImpl.get_$customView());
							}
						}
						if (ss.isValue(info.currentView) && info.currentView.id === customViewImpl.$presModel.id) {
							workbookImpl.set_$currentCustomView(customViewImpl.get_$customView());
						}
					}
				}
			}
		};
		$tab__CustomViewImpl.$createCustomViewCommandReturnHandler = function CustomViewImpl$CreateCustomViewCommandReturnHandler(commandName, deferred, successCallback) {
			var errorCallback = function(remoteError, message) {
				deferred.reject($tab__TableauException.create('serverError', message));
			};
			return new (ss.makeGenericType($tab_CommandReturnHandler$1, [Object]))(commandName, 0, successCallback, errorCallback);
		};
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.DashboardImpl
		var $tab__DashboardImpl = function(sheetInfoImpl, workbookImpl, messagingOptions) {
			this.$dashboard = null;
			this.$worksheets = new tab._Collection();
			this.$dashboardObjects = new tab._Collection();
			$tab__SheetImpl.call(this, sheetInfoImpl, workbookImpl, messagingOptions);
		};
		$tab__DashboardImpl.__typeName = 'tab._DashboardImpl';
		global.tab._DashboardImpl = $tab__DashboardImpl;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.DataSourceImpl
		var $tab__DataSourceImpl = function(name, isPrimary) {
			this.$name = null;
			this.$fields = new tab._Collection();
			this.$isPrimary = false;
			this.$dataSource = null;
			$tab__Param.verifyString(name, 'name');
			this.$name = name;
			this.$isPrimary = isPrimary;
		};
		$tab__DataSourceImpl.__typeName = 'tab._DataSourceImpl';
		$tab__DataSourceImpl.processDataSource = function DataSourceImpl$ProcessDataSource(dataSourcePm) {
			var dataSourceImpl = new $tab__DataSourceImpl(dataSourcePm.name, dataSourcePm.isPrimary);
			var fields = ss.coalesce(dataSourcePm.fields, []);
			for (var $t1 = 0; $t1 < fields.length; $t1++) {
				var fieldPm = fields[$t1];
				var fieldRole = $tab_ApiEnumConverter.convertFieldRole(fieldPm.role);
				var fieldAggregation = $tab_ApiEnumConverter.convertFieldAggregation(fieldPm.aggregation);
				var field = new $tableauSoftware_Field(dataSourceImpl.get_dataSource(), fieldPm.name, fieldRole, fieldAggregation);
				dataSourceImpl.addField(field);
			}
			return dataSourceImpl;
		};
		$tab__DataSourceImpl.processDataSourcesForWorksheet = function DataSourceImpl$ProcessDataSourcesForWorksheet(pm) {
			var dataSources = new tab._Collection();
			var primaryDataSourceImpl = null;
			for (var $t1 = 0; $t1 < pm.dataSources.length; $t1++) {
				var dataSourcePm = pm.dataSources[$t1];
				var dataSourceImpl = $tab__DataSourceImpl.processDataSource(dataSourcePm);
				if (dataSourcePm.isPrimary) {
					primaryDataSourceImpl = dataSourceImpl;
				}
				else {
					dataSources._add(dataSourcePm.name, dataSourceImpl.get_dataSource());
				}
			}
			if (ss.isValue(primaryDataSourceImpl)) {
				dataSources._addToFirst(primaryDataSourceImpl.get_name(), primaryDataSourceImpl.get_dataSource());
			}
			return dataSources;
		};
		global.tab._DataSourceImpl = $tab__DataSourceImpl;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.DoNotUseDeferred
		var $tab__DeferredImpl = function() {
			this.$promise = null;
			this.$thenFunc = null;
			this.$listeners = [];
			this.$resolveFunc = null;
			this.$promise = new $tab__PromiseImpl(ss.mkdel(this, this.then));
			this.$thenFunc = ss.mkdel(this, this.$preResolutionThen);
			this.$resolveFunc = ss.mkdel(this, this.$transitionToFulfilled);
		};
		$tab__DeferredImpl.__typeName = 'tab._DeferredImpl';
		global.tab._DeferredImpl = $tab__DeferredImpl;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Core.jQueryInterface
		var $tab__jQueryShim = function() {
		};
		$tab__jQueryShim.__typeName = 'tab._jQueryShim';
		$tab__jQueryShim.isFunction = function jQueryInterface$IsFunction(obj) {
			return ss.referenceEquals($tab__jQueryShim.type(obj), $tab__jQueryShim.$functionType);
		};
		$tab__jQueryShim.isArray = function jQueryInterface$IsArray(obj) {
			if (ss.isValue(Array['isArray'])) {
				return ss.unbox(ss.cast(Array['isArray'](obj), Boolean));
			}
			return ss.referenceEquals($tab__jQueryShim.type(obj), $tab__jQueryShim.$arrayType);
		};
		$tab__jQueryShim.type = function jQueryInterface$Type(obj) {
			return (ss.isNullOrUndefined(obj) ? String(obj) : ($tab__jQueryShim.$class2type[ss.cast($tab__jQueryShim.$toString.call(obj), String)] || $tab__jQueryShim.$objectType));
		};
		$tab__jQueryShim.trim = function jQueryInterface$Trim(text) {
			if (ss.isValue($tab__jQueryShim.$trim)) {
				return (ss.isNullOrUndefined(text) ? '' : ss.cast($tab__jQueryShim.$trim.call(text), String));
			}
			return (ss.isNullOrUndefined(text) ? '' : text.toString().replace($tab__jQueryShim.$trimLeft, '').replace($tab__jQueryShim.$trimRight, ''));
		};
		$tab__jQueryShim.parseJSON = function jQueryInterface$ParseJson(data) {
			if (typeof(data) !== 'string' || ss.isNullOrUndefined(data)) {
				return null;
			}
			data = $tab__jQueryShim.trim(data);
			if (ss.isValue(JSON) && ss.isValue(JSON['parse'])) {
				return JSON.parse(data);
			}
			if ($tab__jQueryShim.$rvalidchars.test(data.replace($tab__jQueryShim.$rvalidescape, '@').replace($tab__jQueryShim.$rvalidtokens, ']').replace($tab__jQueryShim.$rvalidbraces, ''))) {
				return (new Function('return ' + data))();
			}
			throw new ss.Exception('Invalid JSON: ' + data);
		};
		global.tab._jQueryShim = $tab__jQueryShim;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.Param
		var $tab__Param = function() {
		};
		$tab__Param.__typeName = 'tab._Param';
		$tab__Param.verifyString = function Param$VerifyString(argumentValue, argumentName) {
			if (ss.isNullOrUndefined(argumentValue) || argumentValue.length === 0) {
				throw $tab__TableauException.createInternalStringArgumentException(argumentName);
			}
		};
		$tab__Param.verifyValue = function Param$VerifyValue(argumentValue, argumentName) {
			if (ss.isNullOrUndefined(argumentValue)) {
				throw $tab__TableauException.createInternalNullArgumentException(argumentName);
			}
		};
		global.tab._Param = $tab__Param;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.DoNotUsePromise
		var $tab__PromiseImpl = function(thenFunc) {
			this.then = null;
			this.then = thenFunc;
		};
		$tab__PromiseImpl.__typeName = 'tab._PromiseImpl';
		global.tab._PromiseImpl = $tab__PromiseImpl;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.TabRect
		var $tab__Rect = function(left, top, width, height) {
			this.left = 0;
			this.top = 0;
			this.width = 0;
			this.height = 0;
			this.left = left;
			this.top = top;
			this.width = width;
			this.height = height;
		};
		$tab__Rect.__typeName = 'tab._Rect';
		global.tab._Rect = $tab__Rect;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.SheetImpl
		var $tab__SheetImpl = function(sheetInfoImpl, workbookImpl, messagingOptions) {
			this.$name = null;
			this.$index = 0;
			this.$isActive = false;
			this.$isHidden = false;
			this.$sheetType = null;
			this.$size = null;
			this.$url = null;
			this.$workbookImpl = null;
			this.$messagingOptions = null;
			this.$parentStoryPointImpl = null;
			this.$zoneId = 0;
			$tab__Param.verifyValue(sheetInfoImpl, 'sheetInfoImpl');
			$tab__Param.verifyValue(workbookImpl, 'workbookImpl');
			$tab__Param.verifyValue(messagingOptions, 'messagingOptions');
			this.$name = sheetInfoImpl.name;
			this.$index = sheetInfoImpl.index;
			this.$isActive = sheetInfoImpl.isActive;
			this.$isHidden = sheetInfoImpl.isHidden;
			this.$sheetType = sheetInfoImpl.sheetType;
			this.$size = sheetInfoImpl.size;
			this.$url = sheetInfoImpl.url;
			this.$workbookImpl = workbookImpl;
			this.$messagingOptions = messagingOptions;
			this.$zoneId = sheetInfoImpl.zoneId;
		};
		$tab__SheetImpl.__typeName = 'tab._SheetImpl';
		$tab__SheetImpl.$convertValueToIntIfValid = function SheetImpl$ConvertValueToIntIfValid(value) {
			if (ss.isValue(value)) {
				return $tab__Utility.toInt(value);
			}
			return value;
		};
		$tab__SheetImpl.$normalizeSheetSize = function SheetImpl$NormalizeSheetSize(size) {
			var behavior = $tab_$PublicEnums.$normalizeEnum($tab_ApiSheetSizeBehavior).call(null, size.behavior, 'size.behavior');
			var minSize = size.minSize;
			if (ss.isValue(minSize)) {
				minSize = $tab_Size.$ctor($tab__SheetImpl.$convertValueToIntIfValid(size.minSize.width), $tab__SheetImpl.$convertValueToIntIfValid(size.minSize.height));
			}
			var maxSize = size.maxSize;
			if (ss.isValue(maxSize)) {
				maxSize = $tab_Size.$ctor($tab__SheetImpl.$convertValueToIntIfValid(size.maxSize.width), $tab__SheetImpl.$convertValueToIntIfValid(size.maxSize.height));
			}
			return $tab_SheetSize.$ctor(behavior, minSize, maxSize);
		};
		global.tab._SheetImpl = $tab__SheetImpl;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.ApiSheetInfoImpl
		var $tab__SheetInfoImpl = function() {
		};
		$tab__SheetInfoImpl.__typeName = 'tab._SheetInfoImpl';
		$tab__SheetInfoImpl.$ctor = function(name, sheetType, index, size, workbook, url, isActive, isHidden, zoneId) {
			var $this = new Object();
			$this.name = null;
			$this.index = 0;
			$this.workbook = null;
			$this.url = null;
			$this.isHidden = false;
			$this.sheetType = null;
			$this.zoneId = 0;
			$this.size = null;
			$this.isActive = false;
			$this.name = name;
			$this.sheetType = sheetType;
			$this.index = index;
			$this.size = size;
			$this.workbook = workbook;
			$this.url = url;
			$this.isActive = isActive;
			$this.isHidden = isHidden;
			$this.zoneId = zoneId;
			return $this;
		};
		global.tab._SheetInfoImpl = $tab__SheetInfoImpl;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.StoryImpl
		var $tab__StoryImpl = function(sheetInfoImpl, workbookImpl, messagingOptions, storyPm, findSheetFunc) {
			this.$activeStoryPointImpl = null;
			this.$findSheetFunc = null;
			this.$story = null;
			this.$storyPointsInfo = null;
			this.$2$ActiveStoryPointChangeField = null;
			$tab__SheetImpl.call(this, sheetInfoImpl, workbookImpl, messagingOptions);
			$tab__Param.verifyValue(storyPm, 'storyPm');
			$tab__Param.verifyValue(findSheetFunc, 'findSheetFunc');
			this.$findSheetFunc = findSheetFunc;
			this.update(storyPm);
		};
		$tab__StoryImpl.__typeName = 'tab._StoryImpl';
		global.tab._StoryImpl = $tab__StoryImpl;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.StoryPointImpl
		var $tab__StoryPointImpl = function(storyPointInfoImpl, containedSheetImpl) {
			this.$caption = null;
			this.$index = 0;
			this.$isActive = false;
			this.$isUpdated = false;
			this.$containedSheetImpl = null;
			this.$parentStoryImpl = null;
			this.$storyPoint = null;
			this.$storyPointId = 0;
			this.$isActive = storyPointInfoImpl.isActive;
			this.$isUpdated = storyPointInfoImpl.isUpdated;
			this.$caption = storyPointInfoImpl.caption;
			this.$index = storyPointInfoImpl.index;
			this.$parentStoryImpl = storyPointInfoImpl.parentStoryImpl;
			this.$storyPointId = storyPointInfoImpl.storyPointId;
			this.$containedSheetImpl = containedSheetImpl;
			if (ss.isValue(containedSheetImpl)) {
				this.$containedSheetImpl.set_parentStoryPointImpl(this);
				if (containedSheetImpl.get_sheetType() === 'dashboard') {
					var containedDashboardImpl = ss.cast(this.$containedSheetImpl, $tab__DashboardImpl);
					for (var i = 0; i < containedDashboardImpl.get_worksheets().get__length(); i++) {
						var worksheet = containedDashboardImpl.get_worksheets().get_item(i);
						worksheet._impl.set_parentStoryPointImpl(this);
					}
				}
			}
		};
		$tab__StoryPointImpl.__typeName = 'tab._StoryPointImpl';
		$tab__StoryPointImpl.createContainedSheet = function StoryPointImpl$CreateContainedSheet(containedSheetInfo, workbookImpl, messagingOptions, findSheetFunc) {
			var containedSheetType = $tab_ApiEnumConverter.convertSheetType(containedSheetInfo.sheetType);
			var index = -1;
			var size = $tab_SheetSizeFactory.createAutomatic();
			var isActive = false;
			var publishedSheetInfo = findSheetFunc(containedSheetInfo.name);
			var isHidden = ss.isNullOrUndefined(publishedSheetInfo);
			var url = (isHidden ? '' : publishedSheetInfo.getUrl());
			var sheetInfoImpl = $tab__SheetInfoImpl.$ctor(containedSheetInfo.name, containedSheetType, index, size, workbookImpl.get_workbook(), url, isActive, isHidden, containedSheetInfo.zoneId);
			if (containedSheetInfo.sheetType === 'worksheet') {
				var parentDashboardImpl = null;
				var worksheetImpl = new $tab__WorksheetImpl(sheetInfoImpl, workbookImpl, messagingOptions, parentDashboardImpl);
				return worksheetImpl;
			}
			else if (containedSheetInfo.sheetType === 'dashboard') {
				var dashboardImpl = new $tab__DashboardImpl(sheetInfoImpl, workbookImpl, messagingOptions);
				var dashboardZones = $tab__WorkbookImpl.$createDashboardZones(containedSheetInfo.dashboardZones);
				dashboardImpl.$addObjects(dashboardZones, findSheetFunc);
				return dashboardImpl;
			}
			else if (containedSheetInfo.sheetType === 'story') {
				throw $tab__TableauException.createInternalError('Cannot have a story embedded within another story.');
			}
			else {
				throw $tab__TableauException.createInternalError("Unknown sheet type '" + containedSheetInfo.sheetType + "'");
			}
		};
		global.tab._StoryPointImpl = $tab__StoryPointImpl;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.StoryPointInfoImpl
		var $tab__StoryPointInfoImpl = function() {
		};
		$tab__StoryPointInfoImpl.__typeName = 'tab._StoryPointInfoImpl';
		$tab__StoryPointInfoImpl.$ctor = function(caption, index, storyPointId, isActive, isUpdated, parentStoryImpl) {
			var $this = new Object();
			$this.storyPointId = 0;
			$this.parentStoryImpl = null;
			$this.caption = null;
			$this.index = 0;
			$this.isActive = false;
			$this.isUpdated = false;
			$this.caption = caption;
			$this.index = index;
			$this.storyPointId = storyPointId;
			$this.isActive = isActive;
			$this.isUpdated = isUpdated;
			$this.parentStoryImpl = parentStoryImpl;
			return $this;
		};
		global.tab._StoryPointInfoImpl = $tab__StoryPointInfoImpl;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.TableauException
		var $tab__TableauException = function() {
		};
		$tab__TableauException.__typeName = 'tab._TableauException';
		$tab__TableauException.create = function TableauException$Create(id, message) {
			var x = new ss.Exception(message);
			x['tableauSoftwareErrorCode'] = id;
			return x;
		};
		$tab__TableauException.createInternalError = function TableauException$CreateInternalError(details) {
			if (ss.isValue(details)) {
				return $tab__TableauException.create('internalError', 'Internal error. Please contact Tableau support with the following information: ' + details);
			}
			else {
				return $tab__TableauException.create('internalError', 'Internal error. Please contact Tableau support');
			}
		};
		$tab__TableauException.createInternalNullArgumentException = function TableauException$CreateInternalNullArgumentException(argumentName) {
			return $tab__TableauException.createInternalError("Null/undefined argument '" + argumentName + "'.");
		};
		$tab__TableauException.createInternalStringArgumentException = function TableauException$CreateInternalStringArgumentException(argumentName) {
			return $tab__TableauException.createInternalError("Invalid string argument '" + argumentName + "'.");
		};
		$tab__TableauException.createServerError = function TableauException$CreateServerError(message) {
			return $tab__TableauException.create('serverError', message);
		};
		$tab__TableauException.createNotActiveSheet = function TableauException$CreateNotActiveSheet() {
			return $tab__TableauException.create('notActiveSheet', 'Operation not allowed on non-active sheet');
		};
		$tab__TableauException.createInvalidCustomViewName = function TableauException$CreateInvalidCustomViewName(customViewName) {
			return $tab__TableauException.create('invalidCustomViewName', 'Invalid custom view name: ' + customViewName);
		};
		$tab__TableauException.createInvalidParameter = function TableauException$CreateInvalidParameter(paramName) {
			return $tab__TableauException.create('invalidParameter', 'Invalid parameter: ' + paramName);
		};
		$tab__TableauException.createInvalidFilterFieldNameOrValue = function TableauException$CreateInvalidFilterFieldNameOrValue(fieldName) {
			return $tab__TableauException.create('invalidFilterFieldNameOrValue', 'Invalid filter field name or value: ' + fieldName);
		};
		$tab__TableauException.createInvalidDateParameter = function TableauException$CreateInvalidDateParameter(paramName) {
			return $tab__TableauException.create('invalidDateParameter', 'Invalid date parameter: ' + paramName);
		};
		$tab__TableauException.createNullOrEmptyParameter = function TableauException$CreateNullOrEmptyParameter(paramName) {
			return $tab__TableauException.create('nullOrEmptyParameter', 'Parameter cannot be null or empty: ' + paramName);
		};
		$tab__TableauException.createMissingMaxSize = function TableauException$CreateMissingMaxSize() {
			return $tab__TableauException.create('missingMaxSize', 'Missing maxSize for SheetSizeBehavior.ATMOST');
		};
		$tab__TableauException.createMissingMinSize = function TableauException$CreateMissingMinSize() {
			return $tab__TableauException.create('missingMinSize', 'Missing minSize for SheetSizeBehavior.ATLEAST');
		};
		$tab__TableauException.createMissingMinMaxSize = function TableauException$CreateMissingMinMaxSize() {
			return $tab__TableauException.create('missingMinMaxSize', 'Missing minSize or maxSize for SheetSizeBehavior.RANGE');
		};
		$tab__TableauException.createInvalidRangeSize = function TableauException$CreateInvalidRangeSize() {
			return $tab__TableauException.create('invalidSize', 'Missing minSize or maxSize for SheetSizeBehavior.RANGE');
		};
		$tab__TableauException.createInvalidSizeValue = function TableauException$CreateInvalidSizeValue() {
			return $tab__TableauException.create('invalidSize', 'Size value cannot be less than zero');
		};
		$tab__TableauException.createInvalidSheetSizeParam = function TableauException$CreateInvalidSheetSizeParam() {
			return $tab__TableauException.create('invalidSize', 'Invalid sheet size parameter');
		};
		$tab__TableauException.createSizeConflictForExactly = function TableauException$CreateSizeConflictForExactly() {
			return $tab__TableauException.create('invalidSize', 'Conflicting size values for SheetSizeBehavior.EXACTLY');
		};
		$tab__TableauException.createInvalidSizeBehaviorOnWorksheet = function TableauException$CreateInvalidSizeBehaviorOnWorksheet() {
			return $tab__TableauException.create('invalidSizeBehaviorOnWorksheet', 'Only SheetSizeBehavior.AUTOMATIC is allowed on Worksheets');
		};
		$tab__TableauException.createNoUrlForHiddenWorksheet = function TableauException$CreateNoUrlForHiddenWorksheet() {
			return $tab__TableauException.create('noUrlForHiddenWorksheet', 'Hidden worksheets do not have a URL.');
		};
		$tab__TableauException.$createInvalidAggregationFieldName = function TableauException$CreateInvalidAggregationFieldName(fieldName) {
			return $tab__TableauException.create('invalidAggregationFieldName', "Invalid aggregation type for field '" + fieldName + "'");
		};
		$tab__TableauException.createIndexOutOfRange = function TableauException$CreateIndexOutOfRange(index) {
			return $tab__TableauException.create('indexOutOfRange', "Index '" + index + "' is out of range.");
		};
		$tab__TableauException.createUnsupportedEventName = function TableauException$CreateUnsupportedEventName(eventName) {
			return $tab__TableauException.create('unsupportedEventName', "Unsupported event '" + eventName + "'.");
		};
		$tab__TableauException.createBrowserNotCapable = function TableauException$CreateBrowserNotCapable() {
			return $tab__TableauException.create('browserNotCapable', 'This browser is incapable of supporting the Tableau JavaScript API.');
		};
		global.tab._TableauException = $tab__TableauException;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.Utility
		var $tab__Utility = function() {
		};
		$tab__Utility.__typeName = 'tab._Utility';
		$tab__Utility.isNullOrEmpty = function Utility$IsNullOrEmpty(value) {
			return ss.isNullOrUndefined(value) || (value['length'] || 0) <= 0;
		};
		$tab__Utility.isString = function Utility$IsString(value) {
			return typeof(value) === 'string';
		};
		$tab__Utility.isNumber = function Utility$IsNumber(value) {
			return typeof(value) === 'number';
		};
		$tab__Utility.isDate = function Utility$IsDate(value) {
			if (typeof(value) === 'object' && ss.isInstanceOfType(value, ss.JsDate)) {
				return true;
			}
			else if (!!(Object.prototype.toString.call(value) !== '[object Date]')) {
				return false;
			}
			return !isNaN(ss.cast(value, ss.JsDate).getTime());
		};
		$tab__Utility.isDateValid = function Utility$IsDateValid(dt) {
			return !isNaN(dt.getTime());
		};
		$tab__Utility.indexOf = function Utility$IndexOf(array, searchElement, fromIndex) {
			if (ss.isValue(Array.prototype['indexOf'])) {
				return ss.unbox(ss.cast(array['indexOf'](searchElement, fromIndex), ss.Int32));
			}
			fromIndex = fromIndex || 0;
			var length = array.length;
			if (length > 0) {
				for (var index = fromIndex; index < length; index++) {
					if (ss.referenceEquals(array[index], searchElement)) {
						return index;
					}
				}
			}
			return -1;
		};
		$tab__Utility.contains = function Utility$Contains(array, searchElement, fromIndex) {
			var index = $tab__Utility.indexOf(array, searchElement, fromIndex);
			return index >= 0;
		};
		$tab__Utility.getTopmostWindow = function Utility$GetTopmostWindow() {
			var win = window.self;
			while (ss.isValue(win.parent) && !ss.referenceEquals(win.parent, win)) {
				win = win.parent;
			}
			return win;
		};
		$tab__Utility.toInt = function Utility$ToInt(value) {
			if ($tab__Utility.isNumber(value)) {
				return ss.Int32.trunc(value);
			}
			var number = parseInt(value.toString(), 10);
			if (isNaN(number)) {
				return 0;
			}
			return number;
		};
		$tab__Utility.hasClass = function Utility$HasClass(element, className) {
			var regexClass = new RegExp('[\\n\\t\\r]', 'g');
			return ss.isValue(element) && (' ' + element.className + ' ').replace(regexClass, ' ').indexOf(' ' + className + ' ') > -1;
		};
		$tab__Utility.findParentWithClassName = function Utility$FindParentWithClassName(element, className, stopAtElement) {
			var parent = (ss.isValue(element) ? ss.cast(element.parentNode, HTMLElement) : null);
			stopAtElement = stopAtElement || document.body;
			while (ss.isValue(parent)) {
				if ($tab__Utility.hasClass(parent, className)) {
					return parent;
				}
				if (ss.referenceEquals(parent, stopAtElement)) {
					parent = null;
				}
				else {
					parent = ss.cast(parent.parentNode, HTMLElement);
				}
			}
			return parent;
		};
		$tab__Utility.hasJsonParse = function Utility$HasJsonParse() {
			return !!(ss.isValue(JSON) && ss.isValue(JSON.parse));
		};
		$tab__Utility.hasWindowPostMessage = function Utility$HasWindowPostMessage() {
			return !!ss.isValue(window.postMessage);
		};
		$tab__Utility.isPostMessageSynchronous = function Utility$IsPostMessageSynchronous() {
			if ($tab__Utility.isIE()) {
				var msieRegEx = new RegExp('(msie) ([\\w.]+)');
				var matches = msieRegEx.exec(window.navigator.userAgent.toLowerCase());
				var versionStr = matches[2] || '0';
				var version = parseInt(versionStr, 10);
				return version <= 8;
			}
			return false;
		};
		$tab__Utility.hasDocumentAttachEvent = function Utility$HasDocumentAttachEvent() {
			return !!ss.isValue(document.attachEvent);
		};
		$tab__Utility.hasWindowAddEventListener = function Utility$HasWindowAddEventListener() {
			return !!ss.isValue(window.addEventListener);
		};
		$tab__Utility.isElementOfTag = function Utility$IsElementOfTag(element, tagName) {
			return ss.isValue(element) && element.nodeType === 1 && ss.referenceEquals(element.tagName.toLowerCase(), tagName.toLowerCase());
		};
		$tab__Utility.elementToString = function Utility$ElementToString(element) {
			var str = new ss.StringBuilder();
			str.append(element.tagName.toLowerCase());
			if (!$tab__Utility.isNullOrEmpty(element.id)) {
				str.append('#').append(element.id);
			}
			if (!$tab__Utility.isNullOrEmpty(element.className)) {
				var classes = element.className.split(' ');
				str.append('.').append(classes.join('.'));
			}
			return str.toString();
		};
		$tab__Utility.tableauGCS = function Utility$TableauGCS(e) {
			if (typeof(window['getComputedStyle']) === 'function') {
				return window.getComputedStyle(e);
			}
			else {
				return e['currentStyle'];
			}
		};
		$tab__Utility.isIE = function Utility$IsIE() {
			return !!(window.navigator.userAgent.indexOf('MSIE') > -1 && ss.isNullOrUndefined(window.opera));
		};
		$tab__Utility.isSafari = function Utility$IsSafari() {
			var ua = window.navigator.userAgent;
			var isChrome = ua.indexOf('Chrome') >= 0;
			return ua.indexOf('Safari') >= 0 && !isChrome;
		};
		$tab__Utility.mobileDetect = function Utility$MobileDetect() {
			var ua = window.navigator.userAgent;
			if (ua.indexOf('iPad') !== -1) {
				return true;
			}
			if (ua.indexOf('Android') !== -1) {
				return true;
			}
			if (ua.indexOf('AppleWebKit') !== -1 && ua.indexOf('Mobile') !== -1) {
				return true;
			}
			return false;
		};
		$tab__Utility.visibleContentRectInDocumentCoordinates = function Utility$VisibleContentRectInDocumentCoordinates(element) {
			var visibleRect = $tab__Utility.contentRectInDocumentCoordinates(element);
			for (var currentElement = element.parentElement; ss.isValue(currentElement) && ss.isValue(currentElement.parentElement); currentElement = currentElement.parentElement) {
				var overflow = $tab__Utility.$getComputedStyle(currentElement).overflow;
				if (overflow === 'auto' || overflow === 'scroll' || overflow === 'hidden') {
					visibleRect = visibleRect.intersect($tab__Utility.contentRectInDocumentCoordinates(currentElement));
				}
			}
			var viewportRect = $tab__Utility.contentRectInDocumentCoordinates(document.documentElement);
			var win = new tab.WindowHelper(window.self);
			viewportRect.left += win.get_pageXOffset();
			viewportRect.top += win.get_pageYOffset();
			return visibleRect.intersect(viewportRect);
		};
		$tab__Utility.contentRectInDocumentCoordinates = function Utility$ContentRectInDocumentCoordinates(element) {
			var boundingClientRect = $tab__Utility.getBoundingClientRect(element);
			var style = $tab__Utility.$getComputedStyle(element);
			var paddingLeft = $tab__Utility.toInt(style.paddingLeft);
			var paddingTop = $tab__Utility.toInt(style.paddingTop);
			var borderLeft = $tab__Utility.toInt(style.borderLeftWidth);
			var borderTop = $tab__Utility.toInt(style.borderTopWidth);
			var contentSize = $tab__Utility.computeContentSize(element);
			var win = new tab.WindowHelper(window.self);
			var left = boundingClientRect.left + paddingLeft + borderLeft + win.get_pageXOffset();
			var top = boundingClientRect.top + paddingTop + borderTop + win.get_pageYOffset();
			return new $tab__Rect(left, top, contentSize.width, contentSize.height);
		};
		$tab__Utility.getBoundingClientRect = function Utility$GetBoundingClientRect(element) {
			var rect = element.getBoundingClientRect();
			var top = ss.Int32.trunc(rect.top);
			var left = ss.Int32.trunc(rect.left);
			var right = ss.Int32.trunc(rect.right);
			var bottom = ss.Int32.trunc(rect.bottom);
			return new $tab__Rect(left, top, right - left, bottom - top);
		};
		$tab__Utility.convertRawValue = function Utility$ConvertRawValue(rawValue, dataType) {
			if (ss.isNullOrUndefined(rawValue)) {
				return null;
			}
			switch (dataType) {
				case 'bool': {
					return rawValue;
				}
				case 'date':
				case 'number': {
					if (ss.isNullOrUndefined(rawValue)) {
						return Number.NaN;
					}
					return rawValue;
				}
				default:
				case 'string': {
					return rawValue;
				}
			}
		};
		$tab__Utility.getDataValue = function Utility$GetDataValue(dv) {
			if (ss.isNullOrUndefined(dv)) {
				return $tab_DataValue.$ctor(null, null, null);
			}
			return $tab_DataValue.$ctor($tab__Utility.convertRawValue(dv.value, dv.type), dv.formattedValue, dv.aliasedValue);
		};
		$tab__Utility.serializeDateForServer = function Utility$SerializeDateForServer(date) {
			var serializedDate = '';
			if (ss.isValue(date) && $tab__Utility.isDate(date)) {
				var year = date.getUTCFullYear();
				var month = date.getUTCMonth() + 1;
				var day = date.getUTCDate();
				var hh = date.getUTCHours();
				var mm = date.getUTCMinutes();
				var sec = date.getUTCSeconds();
				serializedDate = year + '-' + month + '-' + day + ' ' + hh + ':' + mm + ':' + sec;
			}
			return serializedDate;
		};
		$tab__Utility.computeContentSize = function Utility$ComputeContentSize(element) {
			var style = $tab__Utility.$getComputedStyle(element);
			var paddingLeft = parseFloat(style.paddingLeft);
			var paddingTop = parseFloat(style.paddingTop);
			var paddingRight = parseFloat(style.paddingRight);
			var paddingBottom = parseFloat(style.paddingBottom);
			var width = element.clientWidth - Math.round(paddingLeft + paddingRight);
			var height = element.clientHeight - Math.round(paddingTop + paddingBottom);
			return $tab_Size.$ctor(width, height);
		};
		$tab__Utility.$getComputedStyle = function Utility$GetComputedStyle(element) {
			if (typeof(window['getComputedStyle']) === 'function') {
				if (ss.isValue(element.ownerDocument.defaultView.opener)) {
					return element.ownerDocument.defaultView.getComputedStyle(element);
				}
				return window.getComputedStyle(element);
			}
			else if (ss.isValue(element['currentStyle'])) {
				return element['currentStyle'];
			}
			return element.style;
		};
		global.tab._Utility = $tab__Utility;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.VizManagerImpl
		var $tab__VizManagerImpl = function() {
		};
		$tab__VizManagerImpl.__typeName = 'tab._VizManagerImpl';
		$tab__VizManagerImpl.get_$clonedVizs = function VizManagerImpl$get_ClonedVizs() {
			return $tab__VizManagerImpl.$vizs.concat();
		};
		$tab__VizManagerImpl.$registerViz = function VizManagerImpl$RegisterViz(viz) {
			$tab__VizManagerImpl.$verifyVizNotAlreadyParented(viz);
			$tab__VizManagerImpl.$vizs.push(viz);
		};
		$tab__VizManagerImpl.$unregisterViz = function VizManagerImpl$UnregisterViz(viz) {
			for (var i = 0, len = $tab__VizManagerImpl.$vizs.length; i < len; i++) {
				if (ss.referenceEquals($tab__VizManagerImpl.$vizs[i], viz)) {
					$tab__VizManagerImpl.$vizs.splice(i, 1);
					break;
				}
			}
		};
		$tab__VizManagerImpl.$sendVisibleRects = function VizManagerImpl$SendVisibleRects() {
			for (var i = 0, len = $tab__VizManagerImpl.$vizs.length; i < len; i++) {
				$tab__VizManagerImpl.$vizs[i]._impl.$sendVisibleRect();
			}
		};
		$tab__VizManagerImpl.$verifyVizNotAlreadyParented = function VizManagerImpl$VerifyVizNotAlreadyParented(viz) {
			var parent = viz.getParentElement();
			for (var i = 0, len = $tab__VizManagerImpl.$vizs.length; i < len; i++) {
				if (ss.referenceEquals($tab__VizManagerImpl.$vizs[i].getParentElement(), parent)) {
					var message = "Another viz is already present in element '" + $tab__Utility.elementToString(parent) + "'.";
					throw $tab__TableauException.create('vizAlreadyInManager', message);
				}
			}
		};
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.VizParameters
		var $tab__VizParameters = function(element, url, options) {
			this.name = '';
			this.host_url = null;
			this.tabs = false;
			this.toolbar = false;
			this.toolBarPosition = null;
			this.handlerId = null;
			this.width = null;
			this.height = null;
			this.parentElement = null;
			this.userSuppliedParameters = null;
			this.fixedSize = false;
			this.$urlFromApi = null;
			this.$createOptions = null;
			if (ss.isNullOrUndefined(element) || ss.isNullOrUndefined(url)) {
				throw $tab__TableauException.create('noUrlOrParentElementNotFound', 'URL is empty or Parent element not found');
			}
			if (ss.isNullOrUndefined(options)) {
				options = new Object();
				options.hideTabs = false;
				options.hideToolbar = false;
				options.onFirstInteractive = null;
			}
			if (ss.isValue(options.height) || ss.isValue(options.width)) {
				this.fixedSize = true;
				if ($tab__Utility.isNumber(options.height)) {
					options.height = options.height.toString() + 'px';
				}
				if ($tab__Utility.isNumber(options.width)) {
					options.width = options.width.toString() + 'px';
				}
				this.height = (ss.isValue(options.height) ? options.height.toString() : null);
				this.width = (ss.isValue(options.width) ? options.width.toString() : null);
			}
			else {
				this.fixedSize = false;
			}
			this.tabs = !(options.hideTabs || false);
			this.toolbar = !(options.hideToolbar || false);
			this.parentElement = element;
			this.$createOptions = options;
			this.toolBarPosition = options.toolbarPosition;
			var urlParts = url.split('?');
			this.$urlFromApi = urlParts[0];
			if (urlParts.length === 2) {
				this.userSuppliedParameters = urlParts[1];
			}
			else {
				this.userSuppliedParameters = '';
			}
			var r = (new RegExp('.*?[^/:]/', '')).exec(this.$urlFromApi);
			if (ss.isNullOrUndefined(r) || r[0].toLowerCase().indexOf('http://') === -1 && r[0].toLowerCase().indexOf('https://') === -1) {
				throw $tab__TableauException.create('invalidUrl', 'Invalid url');
			}
			this.host_url = r[0].toLowerCase();
			this.name = this.$urlFromApi.replace(r[0], '');
			this.name = this.name.replace('views/', '');
		};
		$tab__VizParameters.__typeName = 'tab._VizParameters';
		global.tab._VizParameters = $tab__VizParameters;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.WorkbookImpl
		var $tab__WorkbookImpl = function(vizImpl, messagingOptions, callback) {
			this.$workbook = null;
			this.$vizImpl = null;
			this.$name = null;
			this.$activeSheetImpl = null;
			this.$activatingHiddenSheetImpl = null;
			this.$publishedSheetsInfo = new tab._Collection();
			this.$isDownloadAllowed = false;
			this.$messagingOptions = null;
			this.$currentCustomView = null;
			this.$customViews = new tab._Collection();
			this.$updatedCustomViews = new tab._Collection();
			this.$removedCustomViews = new tab._Collection();
			this.$parameters = null;
			this.$lastChangedParameterImpl = null;
			this.$vizImpl = vizImpl;
			this.$messagingOptions = messagingOptions;
			this.$getClientInfo(callback);
		};
		$tab__WorkbookImpl.__typeName = 'tab._WorkbookImpl';
		$tab__WorkbookImpl.$createDashboardZones = function WorkbookImpl$CreateDashboardZones(zones) {
			zones = ss.coalesce(zones, []);
			var zonesInfo = [];
			for (var i = 0; i < zones.length; i++) {
				var zone = zones[i];
				var objectType = $tab_ApiEnumConverter.convertDashboardObjectType(zone.zoneType);
				var size = $tab_Size.$ctor(zone.width, zone.height);
				var position = $tab_Point.$ctor(zone.x, zone.y);
				var name = zone.name;
				var zoneInfo = { name: name, objectType: objectType, position: position, size: size, zoneId: zone.zoneId };
				zonesInfo.push(zoneInfo);
			}
			return zonesInfo;
		};
		$tab__WorkbookImpl.$extractSheetName = function WorkbookImpl$ExtractSheetName(sheetOrInfoOrName) {
			if (ss.isNullOrUndefined(sheetOrInfoOrName)) {
				return null;
			}
			if ($tab__Utility.isString(sheetOrInfoOrName)) {
				return sheetOrInfoOrName;
			}
			var sheet = ss.safeCast(sheetOrInfoOrName, $tableauSoftware_Sheet);
			if (ss.isValue(sheet)) {
				return sheet.getName();
			}
			var info = ss.safeCast(sheetOrInfoOrName, $tableauSoftware_SheetInfo);
			if (ss.isValue(info)) {
				return info.getName();
			}
			return null;
		};
		$tab__WorkbookImpl.$createSheetSize = function WorkbookImpl$CreateSheetSize(sheetInfo) {
			if (ss.isNullOrUndefined(sheetInfo)) {
				return $tab_SheetSizeFactory.createAutomatic();
			}
			return $tab_SheetSizeFactory.fromSizeConstraints(sheetInfo.sizeConstraints);
		};
		$tab__WorkbookImpl.$processParameters = function WorkbookImpl$ProcessParameters(paramList) {
			var parameters = new tab._Collection();
			for (var $t1 = 0; $t1 < paramList.parameters.length; $t1++) {
				var model = paramList.parameters[$t1];
				var paramImpl = new $tab_$ParameterImpl(model);
				parameters._add(paramImpl.get_$name(), paramImpl.get_$parameter());
			}
			return parameters;
		};
		$tab__WorkbookImpl.$findAndCreateParameterImpl = function WorkbookImpl$FindAndCreateParameterImpl(parameterName, paramList) {
			for (var $t1 = 0; $t1 < paramList.parameters.length; $t1++) {
				var model = paramList.parameters[$t1];
				if (ss.referenceEquals(model.name, parameterName)) {
					return new $tab_$ParameterImpl(model);
				}
			}
			return null;
		};
		global.tab._WorkbookImpl = $tab__WorkbookImpl;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.WorksheetImpl
		var $tab__WorksheetImpl = function(sheetInfoImpl, workbookImpl, messagingOptions, parentDashboardImpl) {
			this.$worksheet = null;
			this.$parentDashboardImpl = null;
			this.$filters = new tab._Collection();
			this.$selectedMarks = new tab._Collection();
			$tab__SheetImpl.call(this, sheetInfoImpl, workbookImpl, messagingOptions);
			this.$parentDashboardImpl = parentDashboardImpl;
		};
		$tab__WorksheetImpl.__typeName = 'tab._WorksheetImpl';
		$tab__WorksheetImpl.$filterCommandError = function WorksheetImpl$FilterCommandError(rawPm) {
			var commandError = rawPm;
			if (ss.isValue(commandError) && ss.isValue(commandError.errorCode)) {
				var additionalInfo = (ss.isValue(commandError.additionalInformation) ? commandError.additionalInformation.toString() : '');
				switch (commandError.errorCode) {
					case 'invalidFilterFieldName': {
						return $tab__TableauException.create('invalidFilterFieldName', additionalInfo);
					}
					case 'invalidFilterFieldValue': {
						return $tab__TableauException.create('invalidFilterFieldValue', additionalInfo);
					}
					case 'invalidAggregationFieldName': {
						return $tab__TableauException.$createInvalidAggregationFieldName(additionalInfo);
					}
					default: {
						return $tab__TableauException.createServerError(additionalInfo);
					}
				}
			}
			return null;
		};
		$tab__WorksheetImpl.$normalizeRangeFilterOption = function WorksheetImpl$NormalizeRangeFilterOption(filterOptions) {
			if (ss.isNullOrUndefined(filterOptions)) {
				throw $tab__TableauException.createNullOrEmptyParameter('filterOptions');
			}
			if (ss.isNullOrUndefined(filterOptions.min) && ss.isNullOrUndefined(filterOptions.max)) {
				throw $tab__TableauException.create('invalidParameter', 'At least one of filterOptions.min or filterOptions.max must be specified.');
			}
			var fixedUpFilterOptions = new Object();
			if (ss.isValue(filterOptions.min)) {
				fixedUpFilterOptions.min = filterOptions.min;
			}
			if (ss.isValue(filterOptions.max)) {
				fixedUpFilterOptions.max = filterOptions.max;
			}
			if (ss.isValue(filterOptions.nullOption)) {
				fixedUpFilterOptions.nullOption = $tab_$PublicEnums.$normalizeEnum($tab_ApiNullOption).call(null, filterOptions.nullOption, 'filterOptions.nullOption');
			}
			return fixedUpFilterOptions;
		};
		$tab__WorksheetImpl.$normalizeRelativeDateFilterOptions = function WorksheetImpl$NormalizeRelativeDateFilterOptions(filterOptions) {
			if (ss.isNullOrUndefined(filterOptions)) {
				throw $tab__TableauException.createNullOrEmptyParameter('filterOptions');
			}
			var fixedUpFilterOptions = new Object();
			fixedUpFilterOptions.rangeType = $tab_$PublicEnums.$normalizeEnum($tab_ApiDateRangeType).call(null, filterOptions.rangeType, 'filterOptions.rangeType');
			fixedUpFilterOptions.periodType = $tab_$PublicEnums.$normalizeEnum($tab_ApiPeriodType).call(null, filterOptions.periodType, 'filterOptions.periodType');
			if (fixedUpFilterOptions.rangeType === 'lastn' || fixedUpFilterOptions.rangeType === 'nextn') {
				if (ss.isNullOrUndefined(filterOptions.rangeN)) {
					throw $tab__TableauException.create('missingRangeNForRelativeDateFilters', 'Missing rangeN field for a relative date filter of LASTN or NEXTN.');
				}
				fixedUpFilterOptions.rangeN = $tab__Utility.toInt(filterOptions.rangeN);
			}
			if (ss.isValue(filterOptions.anchorDate)) {
				if (!$tab__Utility.isDate(filterOptions.anchorDate) || !$tab__Utility.isDateValid(filterOptions.anchorDate)) {
					throw $tab__TableauException.createInvalidDateParameter('filterOptions.anchorDate');
				}
				fixedUpFilterOptions.anchorDate = filterOptions.anchorDate;
			}
			return fixedUpFilterOptions;
		};
		$tab__WorksheetImpl.$createFilterCommandReturnHandler = function WorksheetImpl$CreateFilterCommandReturnHandler(commandName, fieldName, deferred) {
			return new (ss.makeGenericType($tab_CommandReturnHandler$1, [Object]))(commandName, 1, function(result) {
				var error = $tab__WorksheetImpl.$filterCommandError(result);
				if (ss.isNullOrUndefined(error)) {
					deferred.resolve(fieldName);
				}
				else {
					deferred.reject(error);
				}
			}, function(remoteError, message) {
				if (remoteError) {
					deferred.reject($tab__TableauException.createInvalidFilterFieldNameOrValue(fieldName));
				}
				else {
					var error1 = $tab__TableauException.create('filterCannotBePerformed', message);
					deferred.reject(error1);
				}
			});
		};
		$tab__WorksheetImpl.$createSelectionCommandError = function WorksheetImpl$CreateSelectionCommandError(rawPm) {
			var commandError = rawPm;
			if (ss.isValue(commandError) && ss.isValue(commandError.errorCode)) {
				var additionalInfo = (ss.isValue(commandError.additionalInformation) ? commandError.additionalInformation.toString() : '');
				switch (commandError.errorCode) {
					case 'invalidSelectionFieldName': {
						return $tab__TableauException.create('invalidSelectionFieldName', additionalInfo);
					}
					case 'invalidSelectionValue': {
						return $tab__TableauException.create('invalidSelectionValue', additionalInfo);
					}
					case 'invalidSelectionDate': {
						return $tab__TableauException.create('invalidSelectionDate', additionalInfo);
					}
				}
			}
			return null;
		};
		global.tab._WorksheetImpl = $tab__WorksheetImpl;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.ApiDashboardObjectType
		var $tab_ApiDashboardObjectType = function() {
		};
		$tab_ApiDashboardObjectType.__typeName = 'tab.ApiDashboardObjectType';
		global.tab.ApiDashboardObjectType = $tab_ApiDashboardObjectType;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.ApiDateRangeType
		var $tab_ApiDateRangeType = function() {
		};
		$tab_ApiDateRangeType.__typeName = 'tab.ApiDateRangeType';
		global.tab.ApiDateRangeType = $tab_ApiDateRangeType;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.ApiEnumConverter
		var $tab_ApiEnumConverter = function() {
		};
		$tab_ApiEnumConverter.__typeName = 'tab.ApiEnumConverter';
		$tab_ApiEnumConverter.convertDashboardObjectType = function ApiEnumConverter$ConvertDashboardObjectType(crossDomainType) {
			switch (crossDomainType) {
				case 'blank': {
					return 'blank';
				}
				case 'image': {
					return 'image';
				}
				case 'legend': {
					return 'legend';
				}
				case 'pageFilter': {
					return 'pageFilter';
				}
				case 'parameterControl': {
					return 'parameterControl';
				}
				case 'quickFilter': {
					return 'quickFilter';
				}
				case 'text': {
					return 'text';
				}
				case 'title': {
					return 'title';
				}
				case 'webPage': {
					return 'webPage';
				}
				case 'worksheet': {
					return 'worksheet';
				}
				default: {
					throw $tab__TableauException.createInternalError('Unknown ApiCrossDomainDashboardObjectType: ' + crossDomainType);
				}
			}
		};
		$tab_ApiEnumConverter.convertDateRange = function ApiEnumConverter$ConvertDateRange(crossDomainType) {
			switch (crossDomainType) {
				case 'curr': {
					return 'curr';
				}
				case 'last': {
					return 'last';
				}
				case 'lastn': {
					return 'lastn';
				}
				case 'next': {
					return 'next';
				}
				case 'nextn': {
					return 'nextn';
				}
				case 'todate': {
					return 'todate';
				}
				default: {
					throw $tab__TableauException.createInternalError('Unknown ApiCrossDomainDateRangeType: ' + crossDomainType);
				}
			}
		};
		$tab_ApiEnumConverter.convertFieldAggregation = function ApiEnumConverter$ConvertFieldAggregation(crossDomainType) {
			switch (crossDomainType) {
				case 'ATTR': {
					return 'ATTR';
				}
				case 'AVG': {
					return 'AVG';
				}
				case 'COUNT': {
					return 'COUNT';
				}
				case 'COUNTD': {
					return 'COUNTD';
				}
				case 'DAY': {
					return 'DAY';
				}
				case 'END': {
					return 'END';
				}
				case 'HOUR': {
					return 'HOUR';
				}
				case 'INOUT': {
					return 'INOUT';
				}
				case 'KURTOSIS': {
					return 'KURTOSIS';
				}
				case 'MAX': {
					return 'MAX';
				}
				case 'MDY': {
					return 'MDY';
				}
				case 'MEDIAN': {
					return 'MEDIAN';
				}
				case 'MIN': {
					return 'MIN';
				}
				case 'MINUTE': {
					return 'MINUTE';
				}
				case 'MONTH': {
					return 'MONTH';
				}
				case 'MONTHYEAR': {
					return 'MONTHYEAR';
				}
				case 'NONE': {
					return 'NONE';
				}
				case 'PERCENTILE': {
					return 'PERCENTILE';
				}
				case 'QUART1': {
					return 'QUART1';
				}
				case 'QUART3': {
					return 'QUART3';
				}
				case 'QTR': {
					return 'QTR';
				}
				case 'SECOND': {
					return 'SECOND';
				}
				case 'SKEWNESS': {
					return 'SKEWNESS';
				}
				case 'STDEV': {
					return 'STDEV';
				}
				case 'STDEVP': {
					return 'STDEVP';
				}
				case 'SUM': {
					return 'SUM';
				}
				case 'SUM_XSQR': {
					return 'SUM_XSQR';
				}
				case 'TRUNC_DAY': {
					return 'TRUNC_DAY';
				}
				case 'TRUNC_HOUR': {
					return 'TRUNC_HOUR';
				}
				case 'TRUNC_MINUTE': {
					return 'TRUNC_MINUTE';
				}
				case 'TRUNC_MONTH': {
					return 'TRUNC_MONTH';
				}
				case 'TRUNC_QTR': {
					return 'TRUNC_QTR';
				}
				case 'TRUNC_SECOND': {
					return 'TRUNC_SECOND';
				}
				case 'TRUNC_WEEK': {
					return 'TRUNC_WEEK';
				}
				case 'TRUNC_YEAR': {
					return 'TRUNC_YEAR';
				}
				case 'USER': {
					return 'USER';
				}
				case 'VAR': {
					return 'VAR';
				}
				case 'VARP': {
					return 'VARP';
				}
				case 'WEEK': {
					return 'WEEK';
				}
				case 'WEEKDAY': {
					return 'WEEKDAY';
				}
				case 'YEAR': {
					return 'YEAR';
				}
				default: {
					throw $tab__TableauException.createInternalError('Unknown ApiCrossDomainFieldAggregationType: ' + crossDomainType);
				}
			}
		};
		$tab_ApiEnumConverter.convertFieldRole = function ApiEnumConverter$ConvertFieldRole(crossDomainType) {
			switch (crossDomainType) {
				case 'dimension': {
					return 'dimension';
				}
				case 'measure': {
					return 'measure';
				}
				case 'unknown': {
					return 'unknown';
				}
				default: {
					throw $tab__TableauException.createInternalError('Unknown ApiCrossDomainFieldRoleType: ' + crossDomainType);
				}
			}
		};
		$tab_ApiEnumConverter.convertFilterType = function ApiEnumConverter$ConvertFilterType(crossDomainType) {
			switch (crossDomainType) {
				case 'categorical': {
					return 'categorical';
				}
				case 'hierarchical': {
					return 'hierarchical';
				}
				case 'quantitative': {
					return 'quantitative';
				}
				case 'relativedate': {
					return 'relativedate';
				}
				default: {
					throw $tab__TableauException.createInternalError('Unknown ApiCrossDomainFilterType: ' + crossDomainType);
				}
			}
		};
		$tab_ApiEnumConverter.convertParameterAllowableValuesType = function ApiEnumConverter$ConvertParameterAllowableValuesType(crossDomainType) {
			switch (crossDomainType) {
				case 'all': {
					return 'all';
				}
				case 'list': {
					return 'list';
				}
				case 'range': {
					return 'range';
				}
				default: {
					throw $tab__TableauException.createInternalError('Unknown ApiCrossDomainParameterAllowableValuesType: ' + crossDomainType);
				}
			}
		};
		$tab_ApiEnumConverter.convertParameterDataType = function ApiEnumConverter$ConvertParameterDataType(crossDomainType) {
			switch (crossDomainType) {
				case 'boolean': {
					return 'boolean';
				}
				case 'date': {
					return 'date';
				}
				case 'datetime': {
					return 'datetime';
				}
				case 'float': {
					return 'float';
				}
				case 'integer': {
					return 'integer';
				}
				case 'string': {
					return 'string';
				}
				default: {
					throw $tab__TableauException.createInternalError('Unknown ApiCrossDomainParameterDataType: ' + crossDomainType);
				}
			}
		};
		$tab_ApiEnumConverter.convertPeriodType = function ApiEnumConverter$ConvertPeriodType(crossDomainType) {
			switch (crossDomainType) {
				case 'year': {
					return 'year';
				}
				case 'quarter': {
					return 'quarter';
				}
				case 'month': {
					return 'month';
				}
				case 'week': {
					return 'week';
				}
				case 'day': {
					return 'day';
				}
				case 'hour': {
					return 'hour';
				}
				case 'minute': {
					return 'minute';
				}
				case 'second': {
					return 'second';
				}
				default: {
					throw $tab__TableauException.createInternalError('Unknown ApiCrossDomainPeriodType: ' + crossDomainType);
				}
			}
		};
		$tab_ApiEnumConverter.convertSheetType = function ApiEnumConverter$ConvertSheetType(crossDomainType) {
			switch (crossDomainType) {
				case 'worksheet': {
					return 'worksheet';
				}
				case 'dashboard': {
					return 'dashboard';
				}
				case 'story': {
					return 'story';
				}
				default: {
					throw $tab__TableauException.createInternalError('Unknown ApiCrossDomainSheetType: ' + crossDomainType);
				}
			}
		};
		global.tab.ApiEnumConverter = $tab_ApiEnumConverter;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.ApiErrorCode
		var $tab_ApiErrorCode = function() {
		};
		$tab_ApiErrorCode.__typeName = 'tab.ApiErrorCode';
		global.tab.ApiErrorCode = $tab_ApiErrorCode;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.ApiFieldAggregationType
		var $tab_ApiFieldAggregationType = function() {
		};
		$tab_ApiFieldAggregationType.__typeName = 'tab.ApiFieldAggregationType';
		global.tab.ApiFieldAggregationType = $tab_ApiFieldAggregationType;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.ApiFieldRoleType
		var $tab_ApiFieldRoleType = function() {
		};
		$tab_ApiFieldRoleType.__typeName = 'tab.ApiFieldRoleType';
		global.tab.ApiFieldRoleType = $tab_ApiFieldRoleType;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.ApiFilterType
		var $tab_ApiFilterType = function() {
		};
		$tab_ApiFilterType.__typeName = 'tab.ApiFilterType';
		global.tab.ApiFilterType = $tab_ApiFilterType;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.ApiFilterUpdateType
		var $tab_ApiFilterUpdateType = function() {
		};
		$tab_ApiFilterUpdateType.__typeName = 'tab.ApiFilterUpdateType';
		global.tab.ApiFilterUpdateType = $tab_ApiFilterUpdateType;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.ApiNullOption
		var $tab_ApiNullOption = function() {
		};
		$tab_ApiNullOption.__typeName = 'tab.ApiNullOption';
		global.tab.ApiNullOption = $tab_ApiNullOption;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.ApiParameterAllowableValuesType
		var $tab_ApiParameterAllowableValuesType = function() {
		};
		$tab_ApiParameterAllowableValuesType.__typeName = 'tab.ApiParameterAllowableValuesType';
		global.tab.ApiParameterAllowableValuesType = $tab_ApiParameterAllowableValuesType;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.ApiParameterDataType
		var $tab_ApiParameterDataType = function() {
		};
		$tab_ApiParameterDataType.__typeName = 'tab.ApiParameterDataType';
		global.tab.ApiParameterDataType = $tab_ApiParameterDataType;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.ApiPeriodType
		var $tab_ApiPeriodType = function() {
		};
		$tab_ApiPeriodType.__typeName = 'tab.ApiPeriodType';
		global.tab.ApiPeriodType = $tab_ApiPeriodType;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.ApiSelectionUpdateType
		var $tab_ApiSelectionUpdateType = function() {
		};
		$tab_ApiSelectionUpdateType.__typeName = 'tab.ApiSelectionUpdateType';
		global.tab.ApiSelectionUpdateType = $tab_ApiSelectionUpdateType;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.ApiSheetSizeBehavior
		var $tab_ApiSheetSizeBehavior = function() {
		};
		$tab_ApiSheetSizeBehavior.__typeName = 'tab.ApiSheetSizeBehavior';
		global.tab.ApiSheetSizeBehavior = $tab_ApiSheetSizeBehavior;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.ApiSheetType
		var $tab_ApiSheetType = function() {
		};
		$tab_ApiSheetType.__typeName = 'tab.ApiSheetType';
		global.tab.ApiSheetType = $tab_ApiSheetType;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.ApiTableauEventName
		var $tab_ApiTableauEventName = function() {
		};
		$tab_ApiTableauEventName.__typeName = 'tab.ApiTableauEventName';
		global.tab.ApiTableauEventName = $tab_ApiTableauEventName;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.ApiToolbarPosition
		var $tab_ApiToolbarPosition = function() {
		};
		$tab_ApiToolbarPosition.__typeName = 'tab.ApiToolbarPosition';
		global.tab.ApiToolbarPosition = $tab_ApiToolbarPosition;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.CommandReturnHandler
		var $tab_CommandReturnHandler$1 = function(T) {
			var $type = function(commandName, successCallbackTiming, successCallback, errorCallback) {
				this.$commandName = null;
				this.$successCallbackTiming = 0;
				this.$successCallback = null;
				this.$errorCallback = null;
				this.$commandName = commandName;
				this.$successCallback = successCallback;
				this.$successCallbackTiming = successCallbackTiming;
				this.$errorCallback = errorCallback;
			};
			ss.registerGenericClassInstance($type, $tab_CommandReturnHandler$1, [T], {
				get_commandName: function CommandReturnHandler$get_CommandName() {
					return this.$commandName;
				},
				get_successCallback: function CommandReturnHandler$get_SuccessCallback() {
					return this.$successCallback;
				},
				get_successCallbackTiming: function CommandReturnHandler$get_SuccessCallbackTiming() {
					return this.$successCallbackTiming;
				},
				get_errorCallback: function CommandReturnHandler$get_ErrorCallback() {
					return this.$errorCallback;
				}
			}, function() {
				return null;
			}, function() {
				return [];
			});
			return $type;
		};
		$tab_CommandReturnHandler$1.__typeName = 'tab.CommandReturnHandler$1';
		ss.initGenericClass($tab_CommandReturnHandler$1, $asm, 1);
		global.tab.CommandReturnHandler$1 = $tab_CommandReturnHandler$1;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.CrossDomainMessagingOptions
		var $tab_CrossDomainMessagingOptions = function(router, handler) {
			this.$router = null;
			this.$handler = null;
			$tab__Param.verifyValue(router, 'router');
			$tab__Param.verifyValue(handler, 'handler');
			this.$router = router;
			this.$handler = handler;
		};
		$tab_CrossDomainMessagingOptions.__typeName = 'tab.CrossDomainMessagingOptions';
		global.tab.CrossDomainMessagingOptions = $tab_CrossDomainMessagingOptions;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.CustomViewEvent
		var $tab_CustomViewEvent = function(eventName, viz, customViewImpl) {
			this.$context = null;
			$tab_TableauEvent.call(this, eventName, viz);
			this.$context = new $tab_$CustomViewEventContext(viz._impl.get__workbookImpl(), customViewImpl);
		};
		$tab_CustomViewEvent.__typeName = 'tab.CustomViewEvent';
		global.tab.CustomViewEvent = $tab_CustomViewEvent;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.DataValue
		var $tab_DataValue = function() {
		};
		$tab_DataValue.__typeName = 'tab.DataValue';
		$tab_DataValue.$ctor = function(value, formattedValue, aliasedValue) {
			var $this = new Object();
			$this.value = null;
			$this.formattedValue = null;
			$this.value = value;
			if ($tab__Utility.isNullOrEmpty(aliasedValue)) {
				$this.formattedValue = formattedValue;
			}
			else {
				$this.formattedValue = aliasedValue;
			}
			return $this;
		};
		global.tab.DataValue = $tab_DataValue;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.EventContext
		var $tab_EventContext = function(workbookImpl, worksheetImpl) {
			this.$workbookImpl = null;
			this.$worksheetImpl = null;
			this.$workbookImpl = workbookImpl;
			this.$worksheetImpl = worksheetImpl;
		};
		$tab_EventContext.__typeName = 'tab.EventContext';
		global.tab.EventContext = $tab_EventContext;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.FilterEvent
		var $tab_FilterEvent = function(eventName, viz, worksheetImpl, fieldName, filterCaption) {
			this.$filterCaption = null;
			this.$context = null;
			$tab_WorksheetEvent.call(this, eventName, viz, worksheetImpl);
			this.$filterCaption = filterCaption;
			this.$context = new $tab_$FilterEventContext(viz._impl.get__workbookImpl(), worksheetImpl, fieldName, filterCaption);
		};
		$tab_FilterEvent.__typeName = 'tab.FilterEvent';
		global.tab.FilterEvent = $tab_FilterEvent;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.FirstVizSizeKnownEvent
		var $tab_FirstVizSizeKnownEvent = function(eventName, viz, vizSize) {
			this.$vizSize = null;
			$tab_TableauEvent.call(this, eventName, viz);
			this.$vizSize = vizSize;
		};
		$tab_FirstVizSizeKnownEvent.__typeName = 'tab.FirstVizSizeKnownEvent';
		global.tab.FirstVizSizeKnownEvent = $tab_FirstVizSizeKnownEvent;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.ICrossDomainMessageHandler
		var $tab_ICrossDomainMessageHandler = function() {
		};
		$tab_ICrossDomainMessageHandler.__typeName = 'tab.ICrossDomainMessageHandler';
		global.tab.ICrossDomainMessageHandler = $tab_ICrossDomainMessageHandler;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.ICrossDomainMessageRouter
		var $tab_ICrossDomainMessageRouter = function() {
		};
		$tab_ICrossDomainMessageRouter.__typeName = 'tab.ICrossDomainMessageRouter';
		global.tab.ICrossDomainMessageRouter = $tab_ICrossDomainMessageRouter;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Core.JsonUtil
		var $tab_JsonUtil = function() {
		};
		$tab_JsonUtil.__typeName = 'tab.JsonUtil';
		$tab_JsonUtil.parseJson = function JsonUtil$ParseJson(jsonValue) {
			if (ss.isNullOrEmptyString(jsonValue)) {
				return null;
			}
			return $tab__jQueryShim.parseJSON(jsonValue);
		};
		$tab_JsonUtil.toJson = function JsonUtil$ToJson(it, pretty, indentStr) {
			pretty = pretty || false;
			indentStr = indentStr || '';
			var stack = [];
			return $tab_JsonUtil.$serialize(it, pretty, indentStr, stack);
		};
		$tab_JsonUtil.$indexOf = function JsonUtil$IndexOf(stack, searchElement, fromIndex) {
			if (ss.isValue(Array.prototype['indexOf'])) {
				return stack.indexOf(searchElement, fromIndex);
			}
			fromIndex = fromIndex || 0;
			var length = stack.length;
			if (length > 0) {
				for (var index = fromIndex; index < length; index++) {
					if (ss.referenceEquals(stack[index], searchElement)) {
						return index;
					}
				}
			}
			return -1;
		};
		$tab_JsonUtil.$contains = function JsonUtil$Contains(stack, searchElement, fromIndex) {
			var index = $tab_JsonUtil.$indexOf(stack, searchElement, fromIndex);
			return index >= 0;
		};
		$tab_JsonUtil.$serialize = function JsonUtil$Serialize(it, pretty, indentStr, stack) {
			if ($tab_JsonUtil.$contains(stack, it)) {
				throw new ss.Exception('The object contains recursive reference of sub-objects');
			}
			if (typeof(it) === 'undefined') {
				return 'undefined';
			}
			if (ss.isNullOrUndefined(it)) {
				return 'null';
			}
			var objtype = $tab__jQueryShim.type(it);
			if (objtype === 'number' || objtype === 'boolean') {
				return it.toString();
			}
			if (objtype === 'string') {
				return $tab_JsonUtil.$escapeString(ss.cast(it, String));
			}
			stack.push(it);
			var newObj;
			indentStr = indentStr || '';
			var nextIndent = (pretty ? (indentStr + $tab_JsonUtil.$defaultIndentStr) : '');
			var tf = it.__json__ || it.json;
			if ($tab__jQueryShim.isFunction(tf)) {
				var jsonCallback = ss.cast(tf, Function);
				newObj = jsonCallback(it);
				if (!ss.referenceEquals(it, newObj)) {
					var res = $tab_JsonUtil.$serialize(newObj, pretty, nextIndent, stack);
					stack.pop();
					return res;
				}
			}
			if (!!(ss.isValue(it.nodeType) && ss.isValue(it.cloneNode))) {
				throw new ss.Exception("Can't serialize DOM nodes");
			}
			var separator = (pretty ? ' ' : '');
			var newLine = (pretty ? '\n' : '');
			if ($tab__jQueryShim.isArray(it)) {
				return $tab_JsonUtil.$serializeArray(it, pretty, indentStr, stack, nextIndent, newLine);
			}
			if (objtype === 'function') {
				stack.pop();
				return null;
			}
			return $tab_JsonUtil.$serializeGeneric(it, pretty, indentStr, stack, nextIndent, newLine, separator);
		};
		$tab_JsonUtil.$serializeGeneric = function JsonUtil$SerializeGeneric(it, pretty, indentStr, stack, nextIndent, newLine, separator) {
			var d = it;
			var bdr = new ss.StringBuilder('{');
			var init = false;
			var $t1 = new ss.ObjectEnumerator(d);
			try {
				while ($t1.moveNext()) {
					var e = $t1.current();
					var keyStr;
					var val;
					if (typeof(e.key) === 'number') {
						keyStr = '"' + e.key + '"';
					}
					else if (typeof(e.key) === 'string') {
						keyStr = $tab_JsonUtil.$escapeString(e.key);
					}
					else {
						continue;
					}
					val = $tab_JsonUtil.$serialize(e.value, pretty, nextIndent, stack);
					if (ss.isNullOrUndefined(val)) {
						continue;
					}
					if (init) {
						bdr.append(',');
					}
					bdr.append(newLine + nextIndent + keyStr + ':' + separator + val);
					init = true;
				}
			}
			finally {
				$t1.dispose();
			}
			bdr.append(newLine + indentStr + '}');
			stack.pop();
			return bdr.toString();
		};
		$tab_JsonUtil.$serializeArray = function JsonUtil$SerializeArray(it, pretty, indentStr, stack, nextIndent, newLine) {
			var initialized = false;
			var sb = new ss.StringBuilder('[');
			var a = ss.cast(it, Array);
			for (var i = 0; i < a.length; i++) {
				var o = a[i];
				var s = $tab_JsonUtil.$serialize(o, pretty, nextIndent, stack);
				if (ss.isNullOrUndefined(s)) {
					s = 'undefined';
				}
				if (initialized) {
					sb.append(',');
				}
				sb.append(newLine + nextIndent + s);
				initialized = true;
			}
			sb.append(newLine + indentStr + ']');
			stack.pop();
			return sb.toString();
		};
		$tab_JsonUtil.$escapeString = function JsonUtil$EscapeString(str) {
			str = '"' + str.replace(new RegExp('(["\\\\])', 'g'), '\\$1') + '"';
			str = str.replace(new RegExp('[\f]', 'g'), '\\f');
			str = str.replace(new RegExp('[\b]', 'g'), '\\b');
			str = str.replace(new RegExp('[\n]', 'g'), '\\n');
			str = str.replace(new RegExp('[\t]', 'g'), '\\t');
			str = str.replace(new RegExp('[\r]', 'g'), '\\r');
			return str;
		};
		global.tab.JsonUtil = $tab_JsonUtil;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.MarksEvent
		var $tab_MarksEvent = function(eventName, viz, worksheetImpl) {
			this.$context = null;
			$tab_WorksheetEvent.call(this, eventName, viz, worksheetImpl);
			this.$context = new $tab_$MarksEventContext(viz._impl.get__workbookImpl(), worksheetImpl);
		};
		$tab_MarksEvent.__typeName = 'tab.MarksEvent';
		global.tab.MarksEvent = $tab_MarksEvent;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.ParameterEvent
		var $tab_ParameterEvent = function(eventName, viz, parameterName) {
			this.$context = null;
			$tab_TableauEvent.call(this, eventName, viz);
			this.$context = new $tab_$ParameterEventContext(viz._impl.get__workbookImpl(), parameterName);
		};
		$tab_ParameterEvent.__typeName = 'tab.ParameterEvent';
		global.tab.ParameterEvent = $tab_ParameterEvent;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.Point
		var $tab_Point = function() {
		};
		$tab_Point.__typeName = 'tab.Point';
		$tab_Point.$ctor = function(x, y) {
			var $this = new Object();
			$this.x = 0;
			$this.y = 0;
			$this.x = x;
			$this.y = y;
			return $this;
		};
		global.tab.Point = $tab_Point;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.SheetSize
		var $tab_SheetSize = function() {
		};
		$tab_SheetSize.__typeName = 'tab.SheetSize';
		$tab_SheetSize.$ctor = function(behavior, minSize, maxSize) {
			var $this = new Object();
			$this.behavior = null;
			$this.minSize = null;
			$this.maxSize = null;
			$this.behavior = ss.coalesce(behavior, 'automatic');
			if (ss.isValue(minSize)) {
				$this.minSize = minSize;
			}
			else {
				delete $this['minSize'];
			}
			if (ss.isValue(maxSize)) {
				$this.maxSize = maxSize;
			}
			else {
				delete $this['maxSize'];
			}
			return $this;
		};
		global.tab.SheetSize = $tab_SheetSize;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.SheetSizeFactory
		var $tab_SheetSizeFactory = function() {
		};
		$tab_SheetSizeFactory.__typeName = 'tab.SheetSizeFactory';
		$tab_SheetSizeFactory.createAutomatic = function SheetSizeFactory$CreateAutomatic() {
			var size = $tab_SheetSize.$ctor('automatic', null, null);
			return size;
		};
		$tab_SheetSizeFactory.fromSizeConstraints = function SheetSizeFactory$FromSizeConstraints(vizSizePresModel) {
			var minHeight = vizSizePresModel.minHeight;
			var minWidth = vizSizePresModel.minWidth;
			var maxHeight = vizSizePresModel.maxHeight;
			var maxWidth = vizSizePresModel.maxWidth;
			var behavior = 'automatic';
			var minSize = null;
			var maxSize = null;
			if (minHeight === 0 && minWidth === 0) {
				if (maxHeight === 0 && maxWidth === 0) {
				}
				else {
					behavior = 'atmost';
					maxSize = $tab_Size.$ctor(maxWidth, maxHeight);
				}
			}
			else if (maxHeight === 0 && maxWidth === 0) {
				behavior = 'atleast';
				minSize = $tab_Size.$ctor(minWidth, minHeight);
			}
			else if (maxHeight === minHeight && maxWidth === minWidth) {
				behavior = 'exactly';
				minSize = $tab_Size.$ctor(minWidth, minHeight);
				maxSize = $tab_Size.$ctor(minWidth, minHeight);
			}
			else {
				behavior = 'range';
				minSize = $tab_Size.$ctor(minWidth, minHeight);
				maxSize = $tab_Size.$ctor(maxWidth, maxHeight);
			}
			return $tab_SheetSize.$ctor(behavior, minSize, maxSize);
		};
		global.tab.SheetSizeFactory = $tab_SheetSizeFactory;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.Size
		var $tab_Size = function() {
		};
		$tab_Size.__typeName = 'tab.Size';
		$tab_Size.$ctor = function(width, height) {
			var $this = new Object();
			$this.width = 0;
			$this.height = 0;
			$this.width = width;
			$this.height = height;
			return $this;
		};
		global.tab.Size = $tab_Size;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.StoryPointInfoImplUtil
		var $tab_StoryPointInfoImplUtil = function() {
		};
		$tab_StoryPointInfoImplUtil.__typeName = 'tab.StoryPointInfoImplUtil';
		$tab_StoryPointInfoImplUtil.clone = function StoryPointInfoImplUtil$Clone(impl) {
			return $tab__StoryPointInfoImpl.$ctor(impl.caption, impl.index, impl.storyPointId, impl.isActive, impl.isUpdated, impl.parentStoryImpl);
		};
		global.tab.StoryPointInfoImplUtil = $tab_StoryPointInfoImplUtil;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.StoryPointSwitchEvent
		var $tab_StoryPointSwitchEvent = function(eventName, viz, oldStoryPointInfo, newStoryPoint) {
			this.$oldStoryPointInfo = null;
			this.$newStoryPoint = null;
			$tab_TableauEvent.call(this, eventName, viz);
			this.$oldStoryPointInfo = oldStoryPointInfo;
			this.$newStoryPoint = newStoryPoint;
		};
		$tab_StoryPointSwitchEvent.__typeName = 'tab.StoryPointSwitchEvent';
		global.tab.StoryPointSwitchEvent = $tab_StoryPointSwitchEvent;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.TableauEvent
		var $tab_TableauEvent = function(eventName, viz) {
			this.$viz = null;
			this.$eventName = null;
			this.$viz = viz;
			this.$eventName = eventName;
		};
		$tab_TableauEvent.__typeName = 'tab.TableauEvent';
		global.tab.TableauEvent = $tab_TableauEvent;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.TabSwitchEvent
		var $tab_TabSwitchEvent = function(eventName, viz, oldName, newName) {
			this.$oldName = null;
			this.$newName = null;
			$tab_TableauEvent.call(this, eventName, viz);
			this.$oldName = oldName;
			this.$newName = newName;
		};
		$tab_TabSwitchEvent.__typeName = 'tab.TabSwitchEvent';
		global.tab.TabSwitchEvent = $tab_TabSwitchEvent;
		////////////////////////////////////////////////////////////////////////////////
		// Tableau.JavaScript.Vql.Api.VizImpl
		var $tab_VizImpl = function(messageRouter, viz, parentElement, url, options) {
			this.$workbookTabSwitchHandler = null;
			this.$viz = null;
			this.$iframe = null;
			this.$parameters = null;
			this.$initialAvailableSize = null;
			this.$instanceId = null;
			this.$workbookImpl = null;
			this.$onFirstInteractiveCallback = null;
			this.$onFirstVizSizeKnownCallback = null;
			this.$onFirstInteractiveAlreadyCalled = false;
			this.$areTabsHidden = false;
			this.$isToolbarHidden = false;
			this.$areAutomaticUpdatesPaused = false;
			this.$messagingOptions = null;
			this.$vizSize = null;
			this.$windowResizeHandler = null;
			this.$initializingWorkbookImpl = false;
			this.$1$CustomViewsListLoadField = null;
			this.$1$StateReadyForQueryField = null;
			this.$1$MarksSelectionField = null;
			this.$1$FilterChangeField = null;
			this.$1$ParameterValueChangeField = null;
			this.$1$CustomViewLoadField = null;
			this.$1$CustomViewSaveField = null;
			this.$1$CustomViewRemoveField = null;
			this.$1$CustomViewSetDefaultField = null;
			this.$1$TabSwitchField = null;
			this.$1$StoryPointSwitchField = null;
			this.$1$VizResizeField = null;
			if (!$tab__Utility.hasWindowPostMessage() || !$tab__Utility.hasJsonParse()) {
				throw $tab__TableauException.createBrowserNotCapable();
			}
			this.$messagingOptions = new $tab_CrossDomainMessagingOptions(messageRouter, this);
			this.$viz = viz;
			if (ss.isNullOrUndefined(parentElement) || parentElement.nodeType !== 1) {
				parentElement = document.body;
			}
			this.$parameters = new $tab__VizParameters(parentElement, url, options);
			if (ss.isValue(options)) {
				this.$onFirstInteractiveCallback = options.onFirstInteractive;
				this.$onFirstVizSizeKnownCallback = options.onFirstVizSizeKnown;
			}
		};
		$tab_VizImpl.__typeName = 'tab.VizImpl';
		global.tab.VizImpl = $tab_VizImpl;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.VizResizeEvent
		var $tab_VizResizeEvent = function(eventName, viz, availableSize) {
			this.$availableSize = null;
			$tab_TableauEvent.call(this, eventName, viz);
			this.$availableSize = availableSize;
		};
		$tab_VizResizeEvent.__typeName = 'tab.VizResizeEvent';
		global.tab.VizResizeEvent = $tab_VizResizeEvent;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.VizSize
		var $tab_VizSize = function() {
		};
		$tab_VizSize.__typeName = 'tab.VizSize';
		$tab_VizSize.$ctor = function(sheetSize, chromeHeight) {
			var $this = new Object();
			$this.sheetSize = null;
			$this.chromeHeight = 0;
			$this.sheetSize = sheetSize;
			$this.chromeHeight = chromeHeight;
			return $this;
		};
		global.tab.VizSize = $tab_VizSize;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.WorksheetEvent
		var $tab_WorksheetEvent = function(eventName, viz, worksheetImpl) {
			this.$worksheetImpl = null;
			$tab_TableauEvent.call(this, eventName, viz);
			this.$worksheetImpl = worksheetImpl;
		};
		$tab_WorksheetEvent.__typeName = 'tab.WorksheetEvent';
		global.tab.WorksheetEvent = $tab_WorksheetEvent;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.CategoricalFilter
		var $tableauSoftware_CategoricalFilter = function(worksheetImpl, pm) {
			this.$isExclude = false;
			this.$appliedValues = null;
			$tableauSoftware_Filter.call(this, worksheetImpl, pm);
			this.$initializeFromJson$1(pm);
		};
		$tableauSoftware_CategoricalFilter.__typeName = 'tableauSoftware.CategoricalFilter';
		global.tableauSoftware.CategoricalFilter = $tableauSoftware_CategoricalFilter;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.CustomView
		var $tableauSoftware_CustomView = function(customViewImpl) {
			this._impl = null;
			this._impl = customViewImpl;
		};
		$tableauSoftware_CustomView.__typeName = 'tableauSoftware.CustomView';
		global.tableauSoftware.CustomView = $tableauSoftware_CustomView;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.Dashboard
		var $tableauSoftware_Dashboard = function(dashboardImpl) {
			this._impl = null;
			$tableauSoftware_Sheet.call(this, dashboardImpl);
		};
		$tableauSoftware_Dashboard.__typeName = 'tableauSoftware.Dashboard';
		global.tableauSoftware.Dashboard = $tableauSoftware_Dashboard;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.DashboardObject
		var $tableauSoftware_DashboardObject = function(frameInfo, dashboard, worksheet) {
			this.$zoneInfo = null;
			this.$dashboard = null;
			this.$worksheet = null;
			if (frameInfo.objectType === 'worksheet' && ss.isNullOrUndefined(worksheet)) {
				throw $tab__TableauException.createInternalError('worksheet parameter is required for WORKSHEET objects');
			}
			else if (frameInfo.objectType !== 'worksheet' && ss.isValue(worksheet)) {
				throw $tab__TableauException.createInternalError('worksheet parameter should be undefined for non-WORKSHEET objects');
			}
			this.$zoneInfo = frameInfo;
			this.$dashboard = dashboard;
			this.$worksheet = worksheet;
		};
		$tableauSoftware_DashboardObject.__typeName = 'tableauSoftware.DashboardObject';
		global.tableauSoftware.DashboardObject = $tableauSoftware_DashboardObject;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.DataSource
		var $tableauSoftware_DataSource = function(impl) {
			this.$impl = null;
			this.$impl = impl;
		};
		$tableauSoftware_DataSource.__typeName = 'tableauSoftware.DataSource';
		global.tableauSoftware.DataSource = $tableauSoftware_DataSource;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.Field
		var $tableauSoftware_Field = function(dataSource, name, fieldRoleType, fieldAggrType) {
			this.$dataSource = null;
			this.$name = null;
			this.$fieldRoleType = null;
			this.$fieldAggrType = null;
			this.$dataSource = dataSource;
			this.$name = name;
			this.$fieldRoleType = fieldRoleType;
			this.$fieldAggrType = fieldAggrType;
		};
		$tableauSoftware_Field.__typeName = 'tableauSoftware.Field';
		global.tableauSoftware.Field = $tableauSoftware_Field;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.Filter
		var $tableauSoftware_Filter = function(worksheetImpl, pm) {
			this.$worksheetImpl = null;
			this.$type = null;
			this.$caption = null;
			this.$field = null;
			this.$dataSourceName = null;
			this.$fieldRole = null;
			this.$fieldAggregation = null;
			this.$worksheetImpl = worksheetImpl;
			this.$initializeFromJson(pm);
		};
		$tableauSoftware_Filter.__typeName = 'tableauSoftware.Filter';
		$tableauSoftware_Filter.$createFilter = function Filter$CreateFilter(worksheetImpl, pm) {
			switch (pm.filterType) {
				case 'categorical': {
					return new $tableauSoftware_CategoricalFilter(worksheetImpl, pm);
				}
				case 'relativedate': {
					return new $tableauSoftware_RelativeDateFilter(worksheetImpl, pm);
				}
				case 'hierarchical': {
					return new $tableauSoftware_HierarchicalFilter(worksheetImpl, pm);
				}
				case 'quantitative': {
					return new $tableauSoftware_QuantitativeFilter(worksheetImpl, pm);
				}
			}
			return null;
		};
		$tableauSoftware_Filter.$processFiltersList = function Filter$ProcessFiltersList(worksheetImpl, filtersListDict) {
			var filters = new tab._Collection();
			for (var $t1 = 0; $t1 < filtersListDict.filters.length; $t1++) {
				var filterPm = filtersListDict.filters[$t1];
				var filter = $tableauSoftware_Filter.$createFilter(worksheetImpl, filterPm);
				filters._add(filterPm.caption, filter);
			}
			return filters;
		};
		global.tableauSoftware.Filter = $tableauSoftware_Filter;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.HierarchicalFilter
		var $tableauSoftware_HierarchicalFilter = function(worksheetImpl, pm) {
			this.$levels = 0;
			$tableauSoftware_Filter.call(this, worksheetImpl, pm);
			this.$initializeFromJson$1(pm);
		};
		$tableauSoftware_HierarchicalFilter.__typeName = 'tableauSoftware.HierarchicalFilter';
		global.tableauSoftware.HierarchicalFilter = $tableauSoftware_HierarchicalFilter;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.Mark
		var $tableauSoftware_Mark = function(tupleId) {
			this.$impl = null;
			this.$impl = new $tab_$MarkImpl(tupleId);
		};
		$tableauSoftware_Mark.__typeName = 'tableauSoftware.Mark';
		global.tableauSoftware.Mark = $tableauSoftware_Mark;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.Pair
		var $tableauSoftware_Pair = function(fieldName, value) {
			this.fieldName = null;
			this.value = null;
			this.formattedValue = null;
			this.fieldName = fieldName;
			this.value = value;
			this.formattedValue = (ss.isValue(value) ? value.toString() : '');
		};
		$tableauSoftware_Pair.__typeName = 'tableauSoftware.Pair';
		global.tableauSoftware.Pair = $tableauSoftware_Pair;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.Parameter
		var $tableauSoftware_Parameter = function(impl) {
			this._impl = null;
			this._impl = impl;
		};
		$tableauSoftware_Parameter.__typeName = 'tableauSoftware.Parameter';
		global.tableauSoftware.Parameter = $tableauSoftware_Parameter;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.QuantitativeFilter
		var $tableauSoftware_QuantitativeFilter = function(worksheetImpl, pm) {
			this.$domainMin = null;
			this.$domainMax = null;
			this.$min = null;
			this.$max = null;
			this.$includeNullValues = false;
			$tableauSoftware_Filter.call(this, worksheetImpl, pm);
			this.$initializeFromJson$1(pm);
		};
		$tableauSoftware_QuantitativeFilter.__typeName = 'tableauSoftware.QuantitativeFilter';
		global.tableauSoftware.QuantitativeFilter = $tableauSoftware_QuantitativeFilter;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.RelativeDateFilter
		var $tableauSoftware_RelativeDateFilter = function(worksheetImpl, pm) {
			this.$periodType = null;
			this.$rangeType = null;
			this.$rangeN = 0;
			$tableauSoftware_Filter.call(this, worksheetImpl, pm);
			this.$initializeFromJson$1(pm);
		};
		$tableauSoftware_RelativeDateFilter.__typeName = 'tableauSoftware.RelativeDateFilter';
		global.tableauSoftware.RelativeDateFilter = $tableauSoftware_RelativeDateFilter;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.Sheet
		var $tableauSoftware_Sheet = function(sheetImpl) {
			this._impl = null;
			$tab__Param.verifyValue(sheetImpl, 'sheetImpl');
			this._impl = sheetImpl;
		};
		$tableauSoftware_Sheet.__typeName = 'tableauSoftware.Sheet';
		global.tableauSoftware.Sheet = $tableauSoftware_Sheet;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.ApiSheetInfo
		var $tableauSoftware_SheetInfo = function(impl) {
			this.$impl = null;
			this.$impl = impl;
		};
		$tableauSoftware_SheetInfo.__typeName = 'tableauSoftware.SheetInfo';
		global.tableauSoftware.SheetInfo = $tableauSoftware_SheetInfo;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.Story
		var $tableauSoftware_Story = function(storyImpl) {
			this._impl = null;
			$tableauSoftware_Sheet.call(this, storyImpl);
		};
		$tableauSoftware_Story.__typeName = 'tableauSoftware.Story';
		global.tableauSoftware.Story = $tableauSoftware_Story;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.StoryPoint
		var $tableauSoftware_StoryPoint = function(impl) {
			this.$impl = null;
			this.$impl = impl;
		};
		$tableauSoftware_StoryPoint.__typeName = 'tableauSoftware.StoryPoint';
		global.tableauSoftware.StoryPoint = $tableauSoftware_StoryPoint;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.StoryPointInfo
		var $tableauSoftware_StoryPointInfo = function(impl) {
			this._impl = null;
			this._impl = impl;
		};
		$tableauSoftware_StoryPointInfo.__typeName = 'tableauSoftware.StoryPointInfo';
		global.tableauSoftware.StoryPointInfo = $tableauSoftware_StoryPointInfo;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.Version
		var $tableauSoftware_Version = function(major, minor, patch, metadata) {
			this.$major = 0;
			this.$minor = 0;
			this.$patch = 0;
			this.$metadata = null;
			this.$major = major;
			this.$minor = minor;
			this.$patch = patch;
			this.$metadata = ss.coalesce(metadata, null);
		};
		$tableauSoftware_Version.__typeName = 'tableauSoftware.Version';
		$tableauSoftware_Version.getCurrent = function Version$GetCurrent() {
			return $tableauSoftware_Version.$currentVersion;
		};
		global.tableauSoftware.Version = $tableauSoftware_Version;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.Viz
		var $tableauSoftware_Viz = function(parentElement, url, options) {
			this._impl = null;
			var messageRouter = $tab__ApiObjectRegistry.getCrossDomainMessageRouter();
			this._impl = new $tab_VizImpl(messageRouter, this, parentElement, url, options);
			this._impl.$create();
		};
		$tableauSoftware_Viz.__typeName = 'tableauSoftware.Viz';
		$tableauSoftware_Viz.getLastRequestMessage = function Viz$GetLastRequestMessage() {
			return $tab__ApiCommand.lastRequestMessage;
		};
		$tableauSoftware_Viz.getLastResponseMessage = function Viz$GetLastResponseMessage() {
			return $tab__ApiCommand.lastResponseMessage;
		};
		$tableauSoftware_Viz.getLastClientInfoResponseMessage = function Viz$GetLastClientInfoResponseMessage() {
			return $tab__ApiCommand.lastClientInfoResponseMessage;
		};
		global.tableauSoftware.Viz = $tableauSoftware_Viz;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.VizManager
		var $tableauSoftware_VizManager = function() {
		};
		$tableauSoftware_VizManager.__typeName = 'tableauSoftware.VizManager';
		$tableauSoftware_VizManager.getVizs = function VizManager$GetVizs() {
			return $tab__VizManagerImpl.get_$clonedVizs();
		};
		global.tableauSoftware.VizManager = $tableauSoftware_VizManager;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.Workbook
		var $tableauSoftware_Workbook = function(workbookImpl) {
			this.$workbookImpl = null;
			this.$workbookImpl = workbookImpl;
		};
		$tableauSoftware_Workbook.__typeName = 'tableauSoftware.Workbook';
		global.tableauSoftware.Workbook = $tableauSoftware_Workbook;
		////////////////////////////////////////////////////////////////////////////////
		// tableauSoftware.Worksheet
		var $tableauSoftware_Worksheet = function(impl) {
			this._impl = null;
			$tableauSoftware_Sheet.call(this, impl);
		};
		$tableauSoftware_Worksheet.__typeName = 'tableauSoftware.Worksheet';
		global.tableauSoftware.Worksheet = $tableauSoftware_Worksheet;
		ss.initInterface($tab_ICrossDomainMessageRouter, $asm, { registerHandler: null, unregisterHandler: null, sendCommand: null });
		ss.initClass($tab_$CrossDomainMessageRouter, $asm, {
			registerHandler: function CrossDomainMessageRouter$RegisterHandler(handler) {
				var uniqueId = 'handler' + this.$nextHandlerId;
				if (ss.isValue(handler.get_handlerId()) || ss.isValue(this.$handlers[handler.get_handlerId()])) {
					throw $tab__TableauException.createInternalError("Handler '" + handler.get_handlerId() + "' is already registered.");
				}
				this.$nextHandlerId++;
				handler.set_handlerId(uniqueId);
				this.$handlers[uniqueId] = handler;
				handler.add_customViewsListLoad(ss.mkdel(this, this.$handleCustomViewsListLoad));
				handler.add_stateReadyForQuery(ss.mkdel(this, this.$handleStateReadyForQuery));
			},
			unregisterHandler: function CrossDomainMessageRouter$UnregisterHandler(handler) {
				if (ss.isValue(handler.get_handlerId()) || ss.isValue(this.$handlers[handler.get_handlerId()])) {
					delete this.$handlers[handler.get_handlerId()];
					handler.remove_customViewsListLoad(ss.mkdel(this, this.$handleCustomViewsListLoad));
					handler.remove_stateReadyForQuery(ss.mkdel(this, this.$handleStateReadyForQuery));
				}
			},
			sendCommand: function(T) {
				return function CrossDomainMessageRouter$SendCommand(source, commandParameters, returnHandler) {
					var iframe = source.get_iframe();
					var handlerId = source.get_handlerId();
					if (!$tab__Utility.hasWindowPostMessage() || ss.isNullOrUndefined(iframe) || ss.isNullOrUndefined(iframe.contentWindow)) {
						return;
					}
					var commandId = $tab__ApiCommand.generateNextCommandId();
					var callbackMap = this.$commandCallbacks[handlerId];
					if (ss.isNullOrUndefined(callbackMap)) {
						callbackMap = {};
						this.$commandCallbacks[handlerId] = callbackMap;
					}
					callbackMap[commandId] = returnHandler;
					var commandName = returnHandler.get_commandName();
					if (commandName === 'api.ShowCustomViewCommand') {
						var customViewCallbacks = this.$customViewLoadCallbacks[handlerId];
						if (ss.isNullOrUndefined(customViewCallbacks)) {
							customViewCallbacks = [];
							this.$customViewLoadCallbacks[handlerId] = customViewCallbacks;
						}
						customViewCallbacks.push(returnHandler);
					}
					var serializedParams = null;
					if (ss.isValue(commandParameters)) {
						serializedParams = $tab_JsonUtil.toJson(commandParameters, false, '');
					}
					var command = new $tab__ApiCommand(commandName, commandId, handlerId, serializedParams);
					var message = command.serialize();
					if ($tab__Utility.isPostMessageSynchronous()) {
						window.setTimeout(function() {
							iframe.contentWindow.postMessage(message, '*');
						}, 0);
					}
					else {
						iframe.contentWindow.postMessage(message, '*');
					}
				};
			},
			$handleCustomViewsListLoad: function CrossDomainMessageRouter$HandleCustomViewsListLoad(source) {
				var handlerId = source.get_handlerId();
				var customViewCallbacks = this.$customViewLoadCallbacks[handlerId];
				if (ss.isNullOrUndefined(customViewCallbacks)) {
					return;
				}
				for (var $t1 = 0; $t1 < customViewCallbacks.length; $t1++) {
					var returnHandler = customViewCallbacks[$t1];
					if (!ss.staticEquals(returnHandler.get_successCallback(), null)) {
						returnHandler.get_successCallback()(null);
					}
				}
				delete this.$customViewLoadCallbacks[handlerId];
			},
			$handleStateReadyForQuery: function CrossDomainMessageRouter$HandleStateReadyForQuery(source) {
				var queue = this.$commandReturnAfterStateReadyQueues[source.get_handlerId()];
				if ($tab__Utility.isNullOrEmpty(queue)) {
					return;
				}
				while (queue.length > 0) {
					var successCallback = queue.pop();
					if (ss.isValue(successCallback)) {
						successCallback();
					}
				}
			},
			$handleCrossDomainMessage: function CrossDomainMessageRouter$HandleCrossDomainMessage(e) {
				var messageEvent = ss.cast(e, MessageEvent);
				if (ss.isNullOrUndefined(messageEvent.data)) {
					return;
				}
				var command = $tab__ApiCommand.parse(messageEvent.data.toString());
				var rawName = command.get_rawName();
				var handlerId = command.get_handlerId();
				var handler = this.$handlers[handlerId];
				if (ss.isNullOrUndefined(handler) || !ss.referenceEquals(handler.get_handlerId(), command.get_handlerId())) {
					handler = new $tab_$DoNothingCrossDomainHandler();
				}
				if (command.get_isApiCommandName()) {
					if (ss.referenceEquals(command.get_commandId(), $tab__ApiCommand.crossDomainEventNotificationId)) {
						handler.handleEventNotification(command.get_name(), command.get_parameters());
						if (command.get_name() === 'api.FirstVizSizeKnownEvent') {
							messageEvent.source.postMessage('tableau.bootstrap'.toString(), '*');
						}
					}
					else {
						this.$handleCrossDomainResponse(command);
					}
				}
				else {
					this.$handleLegacyNotifications(rawName, handler);
				}
			},
			$handleCrossDomainResponse: function CrossDomainMessageRouter$HandleCrossDomainResponse(command) {
				var commandCallbackMap = this.$commandCallbacks[command.get_handlerId()];
				var returnHandler = (ss.isValue(commandCallbackMap) ? commandCallbackMap[command.get_commandId()] : null);
				if (ss.isNullOrUndefined(returnHandler)) {
					return;
				}
				delete commandCallbackMap[command.get_commandId()];
				if (command.get_name() !== returnHandler.get_commandName()) {
					return;
				}
				var crossDomainResult = new $tab__ApiServerResultParser(command.get_parameters());
				var commandResult = crossDomainResult.get_data();
				if (crossDomainResult.get_result() === 'api.success') {
					switch (returnHandler.get_successCallbackTiming()) {
						case 0: {
							if (ss.isValue(returnHandler.get_successCallback())) {
								returnHandler.get_successCallback()(commandResult);
							}
							break;
						}
						case 1: {
							var postponedCallback = function() {
								if (ss.isValue(returnHandler.get_successCallback())) {
									returnHandler.get_successCallback()(commandResult);
								}
							};
							var queue = this.$commandReturnAfterStateReadyQueues[command.get_handlerId()];
							if (ss.isNullOrUndefined(queue)) {
								queue = [];
								this.$commandReturnAfterStateReadyQueues[command.get_handlerId()] = queue;
							}
							queue.push(postponedCallback);
							break;
						}
						default: {
							throw $tab__TableauException.createInternalError('Unknown timing value: ' + returnHandler.get_successCallbackTiming());
						}
					}
				}
				else if (ss.isValue(returnHandler.get_errorCallback())) {
					var remoteError = crossDomainResult.get_result() === 'api.remotefailed';
					var errorMessage = (ss.isValue(commandResult) ? commandResult.toString() : '');
					returnHandler.get_errorCallback()(remoteError, errorMessage);
				}
			},
			$handleLegacyNotifications: function CrossDomainMessageRouter$HandleLegacyNotifications(messageName, handler) {
				if (ss.referenceEquals(messageName, 'layoutInfoReq'.toString())) {
					$tab__VizManagerImpl.$sendVisibleRects();
				}
				else if (ss.referenceEquals(messageName, 'tableau.completed'.toString()) || ss.referenceEquals(messageName, 'completed'.toString())) {
					handler.handleVizLoad();
				}
				else if (messageName === 'tableau.listening') {
					handler.handleVizListening();
				}
			}
		}, null, [$tab_ICrossDomainMessageRouter]);
		ss.initClass($tab_EventContext, $asm, {
			get__workbookImpl: function EventContext$get_WorkbookImpl() {
				return this.$workbookImpl;
			},
			get__worksheetImpl: function EventContext$get_WorksheetImpl() {
				return this.$worksheetImpl;
			}
		});
		ss.initClass($tab_$CustomViewEventContext, $asm, {
			get__customViewImpl: function CustomViewEventContext$get_CustomViewImpl() {
				return this.$customViewImpl;
			}
		}, $tab_EventContext);
		ss.initClass($tab_$DashboardZoneInfo, $asm, {});
		ss.initClass($tab_$DeferredUtil, $asm, {});
		ss.initInterface($tab_ICrossDomainMessageHandler, $asm, { add_customViewsListLoad: null, remove_customViewsListLoad: null, add_stateReadyForQuery: null, remove_stateReadyForQuery: null, get_iframe: null, get_handlerId: null, set_handlerId: null, handleVizLoad: null, handleVizListening: null, handleEventNotification: null });
		ss.initClass($tab_$DoNothingCrossDomainHandler, $asm, {
			add_customViewsListLoad: function DoNothingCrossDomainHandler$add_CustomViewsListLoad(value) {
				this.$1$CustomViewsListLoadField = ss.delegateCombine(this.$1$CustomViewsListLoadField, value);
			},
			remove_customViewsListLoad: function DoNothingCrossDomainHandler$remove_CustomViewsListLoad(value) {
				this.$1$CustomViewsListLoadField = ss.delegateRemove(this.$1$CustomViewsListLoadField, value);
			},
			add_stateReadyForQuery: function DoNothingCrossDomainHandler$add_StateReadyForQuery(value) {
				this.$1$StateReadyForQueryField = ss.delegateCombine(this.$1$StateReadyForQueryField, value);
			},
			remove_stateReadyForQuery: function DoNothingCrossDomainHandler$remove_StateReadyForQuery(value) {
				this.$1$StateReadyForQueryField = ss.delegateRemove(this.$1$StateReadyForQueryField, value);
			},
			get_iframe: function DoNothingCrossDomainHandler$get_Iframe() {
				return null;
			},
			get_handlerId: function DoNothingCrossDomainHandler$get_HandlerId() {
				return this.$handlerId;
			},
			set_handlerId: function DoNothingCrossDomainHandler$set_HandlerId(value) {
				this.$handlerId = value;
			},
			get_$serverRoot: function DoNothingCrossDomainHandler$get_ServerRoot() {
				return '*';
			},
			handleVizLoad: function DoNothingCrossDomainHandler$HandleVizLoad() {
			},
			handleVizListening: function DoNothingCrossDomainHandler$HandleVizListening() {
			},
			handleEventNotification: function DoNothingCrossDomainHandler$HandleEventNotification(eventName, parameters) {
			},
			$silenceTheCompilerWarning: function DoNothingCrossDomainHandler$SilenceTheCompilerWarning() {
				this.$1$CustomViewsListLoadField(null);
				this.$1$StateReadyForQueryField(null);
			}
		}, null, [$tab_ICrossDomainMessageHandler]);
		ss.initClass($tab_$FilterEventContext, $asm, {
			get__filterFieldName: function FilterEventContext$get_FilterFieldName() {
				return this.$fieldFieldName;
			},
			get_$filterCaption: function FilterEventContext$get_FilterCaption() {
				return this.$filterCaption;
			}
		}, $tab_EventContext);
		ss.initClass($tab_$MarkImpl, $asm, {
			get_$pairs: function MarkImpl$get_Pairs() {
				return this.$collection;
			},
			get_$tupleId: function MarkImpl$get_TupleId() {
				return this.$tupleId;
			},
			get_$clonedPairs: function MarkImpl$get_ClonedPairs() {
				if (ss.isNullOrUndefined(this.$clonedPairs)) {
					this.$clonedPairs = this.$collection._toApiCollection();
				}
				return this.$clonedPairs;
			},
			$addPair: function MarkImpl$AddPair(pair) {
				this.$collection._add(pair.fieldName, pair);
			}
		});
		ss.initClass($tab_$MarksEventContext, $asm, {}, $tab_EventContext);
		ss.initClass($tab_$ParameterEventContext, $asm, {
			get__parameterName: function ParameterEventContext$get_ParameterName() {
				return this.$parameterName;
			}
		}, $tab_EventContext);
		ss.initClass($tab_$ParameterImpl, $asm, {
			get_$parameter: function ParameterImpl$get_Parameter() {
				if (ss.isNullOrUndefined(this.$parameter)) {
					this.$parameter = new $tableauSoftware_Parameter(this);
				}
				return this.$parameter;
			},
			get_$name: function ParameterImpl$get_Name() {
				return this.$name;
			},
			get_$currentValue: function ParameterImpl$get_CurrentValue() {
				return this.$currentValue;
			},
			get_$dataType: function ParameterImpl$get_DataType() {
				return this.$dataType;
			},
			get_$allowableValuesType: function ParameterImpl$get_AllowableValuesType() {
				return this.$allowableValuesType;
			},
			get_$allowableValues: function ParameterImpl$get_AllowableValues() {
				return this.$allowableValues;
			},
			get_$minValue: function ParameterImpl$get_MinValue() {
				return this.$minValue;
			},
			get_$maxValue: function ParameterImpl$get_MaxValue() {
				return this.$maxValue;
			},
			get_$stepSize: function ParameterImpl$get_StepSize() {
				return this.$stepSize;
			},
			get_$dateStepPeriod: function ParameterImpl$get_DateStepPeriod() {
				return this.$dateStepPeriod;
			}
		});
		ss.initClass($tab_$PublicEnums, $asm, {});
		ss.initClass($tab__ApiBootstrap, $asm, {});
		ss.initClass($tab__ApiCommand, $asm, {
			get_name: function ApiCommand$get_Name() {
				return this.$name;
			},
			get_handlerId: function ApiCommand$get_HandlerId() {
				return this.$handlerId;
			},
			get_commandId: function ApiCommand$get_CommandId() {
				return this.$commandId;
			},
			get_parameters: function ApiCommand$get_Parameters() {
				return this.$parameters;
			},
			get_isApiCommandName: function ApiCommand$get_IsApiCommandName() {
				return this.get_rawName().indexOf('api.', 0) === 0;
			},
			get_rawName: function ApiCommand$get_RawName() {
				return this.$name.toString();
			},
			serialize: function ApiCommand$Serialize() {
				var message = [];
				message.push(this.$name);
				message.push(this.$commandId);
				message.push(this.$handlerId);
				if (ss.isValue(this.$parameters)) {
					message.push(this.$parameters);
				}
				var serializedMessage = message.join(',');
				$tab__ApiCommand.lastRequestMessage = serializedMessage;
				return serializedMessage;
			}
		});
		ss.initClass($tab__ApiObjectRegistry, $asm, {});
		ss.initClass($tab__ApiServerNotification, $asm, {
			get_workbookName: function ApiServerNotification$get_WorkbookName() {
				return this.$workbookName;
			},
			get_worksheetName: function ApiServerNotification$get_WorksheetName() {
				return this.$worksheetName;
			},
			get_data: function ApiServerNotification$get_Data() {
				return this.$data;
			},
			serialize: function ApiServerNotification$Serialize() {
				var serialized = {};
				serialized['api.workbookName'] = this.$workbookName;
				serialized['api.worksheetName'] = this.$worksheetName;
				serialized['api.commandData'] = this.$data;
				return JSON.stringify(serialized);
			}
		});
		ss.initClass($tab__ApiServerResultParser, $asm, {
			get_result: function ApiServerResultParser$get_Result() {
				return this.$commandResult;
			},
			get_data: function ApiServerResultParser$get_Data() {
				return this.$commandData;
			}
		});
		ss.initClass($tab__CollectionImpl, $asm, {
			get__length: function DoNotUseCollection$get_Length() {
				return this.$items.length;
			},
			get__rawArray: function DoNotUseCollection$get_RawArray() {
				return this.$items;
			},
			get_item: function DoNotUseCollection$get_Item(index) {
				return this.$items[index];
			},
			_get: function DoNotUseCollection$Get(key) {
				var validKey = this.$ensureValidKey(key);
				if (ss.isValue(this.$itemMap[validKey])) {
					return this.$itemMap[validKey];
				}
				return undefined;
			},
			_has: function DoNotUseCollection$Has(key) {
				return ss.isValue(this._get(key));
			},
			_add: function DoNotUseCollection$Add(key, item) {
				this.$verifyKeyAndItemParameters(key, item);
				var validKey = this.$ensureValidKey(key);
				this.$items.push(item);
				this.$itemMap[validKey] = item;
			},
			_addToFirst: function DoNotUseCollection$AddToFirst(key, item) {
				this.$verifyKeyAndItemParameters(key, item);
				var validKey = this.$ensureValidKey(key);
				this.$items.unshift(item);
				this.$itemMap[validKey] = item;
			},
			_remove: function DoNotUseCollection$Remove(key) {
				var validKey = this.$ensureValidKey(key);
				if (ss.isValue(this.$itemMap[validKey])) {
					var item = this.$itemMap[validKey];
					delete this.$itemMap[validKey];
					for (var index = 0; index < this.$items.length; index++) {
						if (ss.referenceEquals(this.$items[index], item)) {
							this.$items.splice(index, 1);
							break;
						}
					}
				}
			},
			_toApiCollection: function DoNotUseCollection$ToApiCollection() {
				var clone = this.$items.concat();
				clone.get = ss.mkdel(this, function(key) {
					return this._get(key);
				});
				clone.has = ss.mkdel(this, function(key1) {
					return this._has(key1);
				});
				return clone;
			},
			$verifyUniqueKeyParameter: function DoNotUseCollection$VerifyUniqueKeyParameter(key) {
				if ($tab__Utility.isNullOrEmpty(key)) {
					throw new ss.Exception('Null key');
				}
				if (this._has(key)) {
					//throw new ss.Exception("Duplicate key '" + key + "'");
				}
			},
			$verifyKeyAndItemParameters: function DoNotUseCollection$VerifyKeyAndItemParameters(key, item) {
				this.$verifyUniqueKeyParameter(key);
				if (ss.isNullOrUndefined(item)) {
					throw new ss.Exception('Null item');
				}
			},
			$ensureValidKey: function DoNotUseCollection$EnsureValidKey(key) {
				return '_' + key;
			}
		});
		ss.initClass($tab__CustomViewImpl, $asm, {
			get_$customView: function CustomViewImpl$get_CustomView() {
				if (ss.isNullOrUndefined(this.$customView)) {
					this.$customView = new $tableauSoftware_CustomView(this);
				}
				return this.$customView;
			},
			get_$workbook: function CustomViewImpl$get_Workbook() {
				return this.$workbookImpl.get_workbook();
			},
			get_$url: function CustomViewImpl$get_Url() {
				return this.$url;
			},
			get_$name: function CustomViewImpl$get_Name() {
				return this.$name;
			},
			set_$name: function CustomViewImpl$set_Name(value) {
				if (this.$isStale) {
					throw $tab__TableauException.create('staleDataReference', 'Stale data');
				}
				this.$name = value;
			},
			get_$ownerName: function CustomViewImpl$get_OwnerName() {
				return this.$ownerName;
			},
			get_$advertised: function CustomViewImpl$get_Advertised() {
				return this.$isPublic;
			},
			set_$advertised: function CustomViewImpl$set_Advertised(value) {
				if (this.$isStale) {
					throw $tab__TableauException.create('staleDataReference', 'Stale data');
				}
				this.$isPublic = value;
			},
			get_$isDefault: function CustomViewImpl$get_IsDefault() {
				return this.$isDefault;
			},
			$saveAsync: function CustomViewImpl$SaveAsync() {
				if (this.$isStale || ss.isNullOrUndefined(this.$presModel)) {
					throw $tab__TableauException.create('staleDataReference', 'Stale data');
				}
				this.$presModel.isPublic = this.$isPublic;
				this.$presModel.name = this.$name;
				var deferred = new tab._Deferred();
				var param = {};
				param['api.customViewParam'] = this.$presModel;
				var returnHandler = $tab__CustomViewImpl.$createCustomViewCommandReturnHandler('api.UpdateCustomViewCommand', deferred, ss.mkdel(this, function(result) {
					$tab__CustomViewImpl._processCustomViewUpdate(this.$workbookImpl, this.$messagingOptions, result, true);
					deferred.resolve(this.get_$customView());
				}));
				this.$messagingOptions.sendCommand(Object).call(this.$messagingOptions, param, returnHandler);
				return deferred.get_promise();
			},
			$removeAsync: function CustomViewImpl$RemoveAsync() {
				var deferred = new tab._Deferred();
				var param = {};
				param['api.customViewParam'] = this.$presModel;
				var returnHandler = $tab__CustomViewImpl.$createCustomViewCommandReturnHandler('api.RemoveCustomViewCommand', deferred, ss.mkdel(this, function(result) {
					this.$isStale = true;
					$tab__CustomViewImpl._processCustomViews(this.$workbookImpl, this.$messagingOptions, result);
					deferred.resolve(this.get_$customView());
				}));
				this.$messagingOptions.sendCommand(Object).call(this.$messagingOptions, param, returnHandler);
				return deferred.get_promise();
			},
			_showAsync: function CustomViewImpl$ShowAsync() {
				if (this.$isStale || ss.isNullOrUndefined(this.$presModel)) {
					throw $tab__TableauException.create('staleDataReference', 'Stale data');
				}
				return $tab__CustomViewImpl._showCustomViewAsync(this.$workbookImpl, this.$messagingOptions, this.$presModel);
			},
			$isDifferent: function CustomViewImpl$IsDifferent(other) {
				return !ss.referenceEquals(this.$ownerName, other.$ownerName) || !ss.referenceEquals(this.$url, other.$url) || this.$isPublic !== other.$isPublic || this.$isDefault !== other.$isDefault;
			}
		});
		ss.initClass($tab__SheetImpl, $asm, {
			get_sheet: null,
			get_name: function SheetImpl$get_Name() {
				return this.$name;
			},
			get_index: function SheetImpl$get_Index() {
				return this.$index;
			},
			get_workbookImpl: function SheetImpl$get_WorkbookImpl() {
				return this.$workbookImpl;
			},
			get_workbook: function SheetImpl$get_Workbook() {
				return this.$workbookImpl.get_workbook();
			},
			get_url: function SheetImpl$get_Url() {
				if (this.$isHidden) {
					throw $tab__TableauException.createNoUrlForHiddenWorksheet();
				}
				return this.$url;
			},
			get_size: function SheetImpl$get_Size() {
				return this.$size;
			},
			get_isHidden: function SheetImpl$get_IsHidden() {
				return this.$isHidden;
			},
			get_isActive: function SheetImpl$get_IsActive() {
				return this.$isActive;
			},
			set_isActive: function SheetImpl$set_IsActive(value) {
				this.$isActive = value;
			},
			get_isDashboard: function SheetImpl$get_IsDashboard() {
				return this.$sheetType === 'dashboard';
			},
			get_isStory: function SheetImpl$get_IsStory() {
				return this.$sheetType === 'story';
			},
			get_sheetType: function SheetImpl$get_SheetType() {
				return this.$sheetType;
			},
			get_parentStoryPoint: function SheetImpl$get_ParentStoryPoint() {
				if (ss.isValue(this.$parentStoryPointImpl)) {
					return this.$parentStoryPointImpl.get_storyPoint();
				}
				return null;
			},
			get_parentStoryPointImpl: function SheetImpl$get_ParentStoryPointImpl() {
				return this.$parentStoryPointImpl;
			},
			set_parentStoryPointImpl: function SheetImpl$set_ParentStoryPointImpl(value) {
				if (this.$sheetType === 'story') {
					throw $tab__TableauException.createInternalError('A story cannot be a child of another story.');
				}
				this.$parentStoryPointImpl = value;
			},
			get_zoneId: function SheetImpl$get_ZoneId() {
				return this.$zoneId;
			},
			get_messagingOptions: function SheetImpl$get_MessagingOptions() {
				return this.$messagingOptions;
			},
			changeSizeAsync: function SheetImpl$ChangeSizeAsync(newSize) {
				newSize = $tab__SheetImpl.$normalizeSheetSize(newSize);
				if (this.$sheetType === 'worksheet' && newSize.behavior !== 'automatic') {
					throw $tab__TableauException.createInvalidSizeBehaviorOnWorksheet();
				}
				var deferred = new tab._Deferred();
				if (this.$size.behavior === newSize.behavior && newSize.behavior === 'automatic') {
					deferred.resolve(newSize);
					return deferred.get_promise();
				}
				var dict = this.$processSheetSize(newSize);
				var param = {};
				param['api.setSheetSizeName'] = this.$name;
				param['api.minWidth'] = dict['api.minWidth'];
				param['api.minHeight'] = dict['api.minHeight'];
				param['api.maxWidth'] = dict['api.maxWidth'];
				param['api.maxHeight'] = dict['api.maxHeight'];
				var returnHandler = new (ss.makeGenericType($tab_CommandReturnHandler$1, [Object]))('api.SetSheetSizeCommand', 1, ss.mkdel(this, function(result) {
					this.get_workbookImpl()._update(ss.mkdel(this, function() {
						var updatedSize = this.get_workbookImpl().get_publishedSheets()._get(this.get_name()).getSize();
						deferred.resolve(updatedSize);
					}));
				}), function(remoteError, message) {
					deferred.reject($tab__TableauException.createServerError(message));
				});
				this.sendCommand(Object).call(this, param, returnHandler);
				return deferred.get_promise();
			},
			sendCommand: function(T) {
				return function SheetImpl$SendCommand(commandParameters, returnHandler) {
					this.$messagingOptions.sendCommand(T).call(this.$messagingOptions, commandParameters, returnHandler);
				};
			},
			$processSheetSize: function SheetImpl$ProcessSheetSize(newSize) {
				var fixedSheetSize = null;
				if (ss.isNullOrUndefined(newSize) || ss.isNullOrUndefined(newSize.behavior) || newSize.behavior !== 'automatic' && ss.isNullOrUndefined(newSize.minSize) && ss.isNullOrUndefined(newSize.maxSize)) {
					throw $tab__TableauException.createInvalidSheetSizeParam();
				}
				var minWidth = 0;
				var minHeight = 0;
				var maxWidth = 0;
				var maxHeight = 0;
				var dict = {};
				dict['api.minWidth'] = 0;
				dict['api.minHeight'] = 0;
				dict['api.maxWidth'] = 0;
				dict['api.maxHeight'] = 0;
				if (newSize.behavior === 'automatic') {
					fixedSheetSize = $tab_SheetSize.$ctor('automatic', undefined, undefined);
				}
				else if (newSize.behavior === 'atmost') {
					if (ss.isNullOrUndefined(newSize.maxSize) || ss.isNullOrUndefined(newSize.maxSize.width) || ss.isNullOrUndefined(newSize.maxSize.height)) {
						throw $tab__TableauException.createMissingMaxSize();
					}
					if (newSize.maxSize.width < 0 || newSize.maxSize.height < 0) {
						throw $tab__TableauException.createInvalidSizeValue();
					}
					dict['api.maxWidth'] = newSize.maxSize.width;
					dict['api.maxHeight'] = newSize.maxSize.height;
					fixedSheetSize = $tab_SheetSize.$ctor('atmost', undefined, newSize.maxSize);
				}
				else if (newSize.behavior === 'atleast') {
					if (ss.isNullOrUndefined(newSize.minSize) || ss.isNullOrUndefined(newSize.minSize.width) || ss.isNullOrUndefined(newSize.minSize.height)) {
						throw $tab__TableauException.createMissingMinSize();
					}
					if (newSize.minSize.width < 0 || newSize.minSize.height < 0) {
						throw $tab__TableauException.createInvalidSizeValue();
					}
					dict['api.minWidth'] = newSize.minSize.width;
					dict['api.minHeight'] = newSize.minSize.height;
					fixedSheetSize = $tab_SheetSize.$ctor('atleast', newSize.minSize, undefined);
				}
				else if (newSize.behavior === 'range') {
					if (ss.isNullOrUndefined(newSize.minSize) || ss.isNullOrUndefined(newSize.maxSize) || ss.isNullOrUndefined(newSize.minSize.width) || ss.isNullOrUndefined(newSize.maxSize.width) || ss.isNullOrUndefined(newSize.minSize.height) || ss.isNullOrUndefined(newSize.maxSize.height)) {
						throw $tab__TableauException.createMissingMinMaxSize();
					}
					if (newSize.minSize.width < 0 || newSize.minSize.height < 0 || newSize.maxSize.width < 0 || newSize.maxSize.height < 0 || newSize.minSize.width > newSize.maxSize.width || newSize.minSize.height > newSize.maxSize.height) {
						throw $tab__TableauException.createInvalidRangeSize();
					}
					dict['api.minWidth'] = newSize.minSize.width;
					dict['api.minHeight'] = newSize.minSize.height;
					dict['api.maxWidth'] = newSize.maxSize.width;
					dict['api.maxHeight'] = newSize.maxSize.height;
					fixedSheetSize = $tab_SheetSize.$ctor('range', newSize.minSize, newSize.maxSize);
				}
				else if (newSize.behavior === 'exactly') {
					if (ss.isValue(newSize.minSize) && ss.isValue(newSize.maxSize) && ss.isValue(newSize.minSize.width) && ss.isValue(newSize.maxSize.width) && ss.isValue(newSize.minSize.height) && ss.isValue(newSize.maxSize.height)) {
						minWidth = newSize.minSize.width;
						minHeight = newSize.minSize.height;
						maxWidth = newSize.maxSize.width;
						maxHeight = newSize.maxSize.height;
						if (minWidth !== maxWidth || minHeight !== maxHeight) {
							throw $tab__TableauException.createSizeConflictForExactly();
						}
					}
					else if (ss.isValue(newSize.minSize) && ss.isValue(newSize.minSize.width) && ss.isValue(newSize.minSize.height)) {
						minWidth = newSize.minSize.width;
						minHeight = newSize.minSize.height;
						maxWidth = minWidth;
						maxHeight = minHeight;
					}
					else if (ss.isValue(newSize.maxSize) && ss.isValue(newSize.maxSize.width) && ss.isValue(newSize.maxSize.height)) {
						maxWidth = newSize.maxSize.width;
						maxHeight = newSize.maxSize.height;
						minWidth = maxWidth;
						minHeight = maxHeight;
					}
					dict['api.minWidth'] = minWidth;
					dict['api.minHeight'] = minHeight;
					dict['api.maxWidth'] = maxWidth;
					dict['api.maxHeight'] = maxHeight;
					fixedSheetSize = $tab_SheetSize.$ctor('exactly', $tab_Size.$ctor(minWidth, minHeight), $tab_Size.$ctor(maxWidth, maxHeight));
				}
				this.$size = fixedSheetSize;
				return dict;
			}
		});
		ss.initClass($tab__DashboardImpl, $asm, {
			get_sheet: function DashboardImpl$get_Sheet() {
				return this.get_dashboard();
			},
			get_dashboard: function DashboardImpl$get_Dashboard() {
				if (ss.isNullOrUndefined(this.$dashboard)) {
					this.$dashboard = new $tableauSoftware_Dashboard(this);
				}
				return this.$dashboard;
			},
			get_worksheets: function DashboardImpl$get_Worksheets() {
				return this.$worksheets;
			},
			get_objects: function DashboardImpl$get_Objects() {
				return this.$dashboardObjects;
			},
			$addObjects: function DashboardImpl$AddObjects(zones, findSheetFunc) {
				this.$dashboardObjects = new tab._Collection();
				this.$worksheets = new tab._Collection();
				for (var i = 0; i < zones.length; i++) {
					var zone = zones[i];
					var worksheet = null;
					if (zones[i].objectType === 'worksheet') {
						var name = zone.name;
						if (ss.isNullOrUndefined(name)) {
							continue;
						}
						var index = this.$worksheets.get__length();
						var size = $tab_SheetSizeFactory.createAutomatic();
						var isActive = false;
						var publishedSheetInfo = findSheetFunc(name);
						var isHidden = ss.isNullOrUndefined(publishedSheetInfo);
						var url = (isHidden ? '' : publishedSheetInfo.getUrl());
						var sheetInfoImpl = $tab__SheetInfoImpl.$ctor(name, 'worksheet', index, size, this.get_workbook(), url, isActive, isHidden, zone.zoneId);
						var worksheetImpl = new $tab__WorksheetImpl(sheetInfoImpl, this.get_workbookImpl(), this.get_messagingOptions(), this);
						worksheet = worksheetImpl.get_worksheet();
						this.$worksheets._add(name, worksheetImpl.get_worksheet());
					}
					var obj = new $tableauSoftware_DashboardObject(zone, this.get_dashboard(), worksheet);
					this.$dashboardObjects._add(i.toString(), obj);
				}
			}
		}, $tab__SheetImpl);
		ss.initClass($tab__DataSourceImpl, $asm, {
			get_dataSource: function DataSourceImpl$get_DataSource() {
				if (ss.isNullOrUndefined(this.$dataSource)) {
					this.$dataSource = new $tableauSoftware_DataSource(this);
				}
				return this.$dataSource;
			},
			get_name: function DataSourceImpl$get_Name() {
				return this.$name;
			},
			get_fields: function DataSourceImpl$get_Fields() {
				return this.$fields;
			},
			get_isPrimary: function DataSourceImpl$get_IsPrimary() {
				return this.$isPrimary;
			},
			addField: function DataSourceImpl$AddField(field) {
				this.$fields._add(field.getName(), field);
			}
		});
		ss.initClass($tab__DeferredImpl, $asm, {
			get_promise: function DoNotUseDeferred$get_Promise() {
				return this.$promise;
			},
			all: function DoNotUseDeferred$All(promisesOrValues) {
				var allDone = new $tab__DeferredImpl();
				var length = promisesOrValues.length;
				var toResolve = length;
				var results = [];
				if (length === 0) {
					allDone.resolve(results);
					return allDone.get_promise();
				}
				var resolveOne = function(promiseOrValue, index) {
					var promise = $tab_$DeferredUtil.$coerceToTrustedPromise(promiseOrValue);
					promise.then(function(returnValue) {
						results[index] = returnValue;
						toResolve--;
						if (toResolve === 0) {
							allDone.resolve(results);
						}
						return null;
					}, function(e) {
						allDone.reject(e);
						return null;
					});
				};
				for (var i = 0; i < length; i++) {
					resolveOne(promisesOrValues[i], i);
				}
				return allDone.get_promise();
			},
			then: function DoNotUseDeferred$Then(callback, errback) {
				return this.$thenFunc(callback, errback);
			},
			resolve: function DoNotUseDeferred$Resolve(promiseOrValue) {
				return this.$resolveFunc(promiseOrValue);
			},
			reject: function DoNotUseDeferred$Reject(e) {
				return this.$resolveFunc($tab_$DeferredUtil.$rejected(e));
			},
			$preResolutionThen: function DoNotUseDeferred$PreResolutionThen(callback, errback) {
				var deferred = new $tab__DeferredImpl();
				this.$listeners.push(function(promise) {
					promise.then(callback, errback).then(ss.mkdel(deferred, deferred.resolve), ss.mkdel(deferred, deferred.reject));
				});
				return deferred.get_promise();
			},
			$transitionToFulfilled: function DoNotUseDeferred$TransitionToFulfilled(completed) {
				var completedPromise = $tab_$DeferredUtil.$coerceToTrustedPromise(completed);
				this.$thenFunc = completedPromise.then;
				this.$resolveFunc = $tab_$DeferredUtil.$coerceToTrustedPromise;
				for (var i = 0; i < this.$listeners.length; i++) {
					var listener = this.$listeners[i];
					listener(completedPromise);
				}
				this.$listeners = null;
				return completedPromise;
			}
		});
		ss.initClass($tab__jQueryShim, $asm, {});
		ss.initClass($tab__Param, $asm, {});
		ss.initClass($tab__PromiseImpl, $asm, {
			always: function DoNotUsePromise$Always(callback) {
				return ss.cast(this.then(callback, ss.cast(callback, Function)), $tab__PromiseImpl);
			},
			otherwise: function DoNotUsePromise$Otherwise(errback) {
				return ss.cast(this.then(null, errback), $tab__PromiseImpl);
			}
		});
		ss.initClass($tab__Rect, $asm, {
			intersect: function TabRect$Intersect(other) {
				var left = Math.max(this.left, other.left);
				var top = Math.max(this.top, other.top);
				var right = Math.min(this.left + this.width, other.left + other.width);
				var bottom = Math.min(this.top + this.height, other.top + other.height);
				if (right <= left || bottom <= top) {
					return new $tab__Rect(0, 0, 0, 0);
				}
				return new $tab__Rect(left, top, right - left, bottom - top);
			}
		});
		ss.initClass($tab__SheetInfoImpl, $asm, {}, Object);
		ss.initClass($tab__StoryImpl, $asm, {
			add_activeStoryPointChange: function StoryImpl$add_ActiveStoryPointChange(value) {
				this.$2$ActiveStoryPointChangeField = ss.delegateCombine(this.$2$ActiveStoryPointChangeField, value);
			},
			remove_activeStoryPointChange: function StoryImpl$remove_ActiveStoryPointChange(value) {
				this.$2$ActiveStoryPointChangeField = ss.delegateRemove(this.$2$ActiveStoryPointChangeField, value);
			},
			get_activeStoryPointImpl: function StoryImpl$get_ActiveStoryPointImpl() {
				return this.$activeStoryPointImpl;
			},
			get_sheet: function StoryImpl$get_Sheet() {
				return this.get_story();
			},
			get_story: function StoryImpl$get_Story() {
				if (ss.isNullOrUndefined(this.$story)) {
					this.$story = new $tableauSoftware_Story(this);
				}
				return this.$story;
			},
			get_storyPointsInfo: function StoryImpl$get_StoryPointsInfo() {
				return this.$storyPointsInfo;
			},
			update: function StoryImpl$Update(storyPm) {
				var activeStoryPointContainedSheetInfo = null;
				var newActiveStoryPointInfoImpl = null;
				this.$storyPointsInfo = this.$storyPointsInfo || new Array(storyPm.storyPoints.length);
				for (var i = 0; i < storyPm.storyPoints.length; i++) {
					var storyPointPm = storyPm.storyPoints[i];
					var caption = storyPointPm.caption;
					var isActive = i === storyPm.activeStoryPointIndex;
					var storyPointInfoImpl = $tab__StoryPointInfoImpl.$ctor(caption, i, storyPointPm.storyPointId, isActive, storyPointPm.isUpdated, this);
					if (ss.isNullOrUndefined(this.$storyPointsInfo[i])) {
						this.$storyPointsInfo[i] = new $tableauSoftware_StoryPointInfo(storyPointInfoImpl);
					}
					else if (this.$storyPointsInfo[i]._impl.storyPointId === storyPointInfoImpl.storyPointId) {
						var existing = this.$storyPointsInfo[i]._impl;
						existing.caption = storyPointInfoImpl.caption;
						existing.index = storyPointInfoImpl.index;
						existing.isActive = isActive;
						existing.isUpdated = storyPointInfoImpl.isUpdated;
					}
					else {
						this.$storyPointsInfo[i] = new $tableauSoftware_StoryPointInfo(storyPointInfoImpl);
					}
					if (isActive) {
						activeStoryPointContainedSheetInfo = storyPointPm.containedSheetInfo;
						newActiveStoryPointInfoImpl = storyPointInfoImpl;
					}
				}
				var deleteCount = this.$storyPointsInfo.length - storyPm.storyPoints.length;
				this.$storyPointsInfo.splice(storyPm.storyPoints.length, deleteCount);
				var activeStoryPointChanged = ss.isNullOrUndefined(this.$activeStoryPointImpl) || this.$activeStoryPointImpl.get_storyPointId() !== newActiveStoryPointInfoImpl.storyPointId;
				if (ss.isValue(this.$activeStoryPointImpl) && activeStoryPointChanged) {
					this.$activeStoryPointImpl.set_isActive(false);
				}
				var previouslyActiveStoryPoint = this.$activeStoryPointImpl;
				if (activeStoryPointChanged) {
					var containedSheetImpl = $tab__StoryPointImpl.createContainedSheet(activeStoryPointContainedSheetInfo, this.get_workbookImpl(), this.get_messagingOptions(), this.$findSheetFunc);
					this.$activeStoryPointImpl = new $tab__StoryPointImpl(newActiveStoryPointInfoImpl, containedSheetImpl);
				}
				else {
					this.$activeStoryPointImpl.set_isActive(newActiveStoryPointInfoImpl.isActive);
					this.$activeStoryPointImpl.set_isUpdated(newActiveStoryPointInfoImpl.isUpdated);
				}
				if (activeStoryPointChanged && ss.isValue(previouslyActiveStoryPoint)) {
					this.$raiseActiveStoryPointChange(this.$storyPointsInfo[previouslyActiveStoryPoint.get_index()], this.$activeStoryPointImpl.get_storyPoint());
				}
			},
			activatePreviousStoryPointAsync: function StoryImpl$ActivatePreviousStoryPointAsync() {
				return this.$activatePreviousNextStoryPointAsync('api.ActivatePreviousStoryPoint');
			},
			activateNextStoryPointAsync: function StoryImpl$ActivateNextStoryPointAsync() {
				return this.$activatePreviousNextStoryPointAsync('api.ActivateNextStoryPoint');
			},
			activateStoryPointAsync: function StoryImpl$ActivateStoryPointAsync(index) {
				var deferred = new tab._Deferred();
				if (index < 0 || index >= this.$storyPointsInfo.length) {
					throw $tab__TableauException.createIndexOutOfRange(index);
				}
				var previouslyActiveStoryPointImpl = this.get_activeStoryPointImpl();
				var commandParameters = {};
				commandParameters['api.storyPointIndex'] = index;
				var returnHandler = new (ss.makeGenericType($tab_CommandReturnHandler$1, [Object]))('api.ActivateStoryPoint', 0, ss.mkdel(this, function(result) {
					this.$updateActiveState(previouslyActiveStoryPointImpl, result);
					deferred.resolve(this.$activeStoryPointImpl.get_storyPoint());
				}), function(remoteError, errorMessage) {
					deferred.reject($tab__TableauException.createServerError(errorMessage));
				});
				this.sendCommand(Object).call(this, commandParameters, returnHandler);
				return deferred.get_promise();
			},
			revertStoryPointAsync: function StoryImpl$RevertStoryPointAsync(index) {
				index = index || this.$activeStoryPointImpl.get_index();
				if (index < 0 || index >= this.$storyPointsInfo.length) {
					throw $tab__TableauException.createIndexOutOfRange(index);
				}
				var deferred = new tab._Deferred();
				var commandParameters = {};
				commandParameters['api.storyPointIndex'] = index;
				var returnHandler = new (ss.makeGenericType($tab_CommandReturnHandler$1, [Object]))('api.RevertStoryPoint', 0, ss.mkdel(this, function(result) {
					this.$updateStoryPointInfo(index, result);
					deferred.resolve(this.$storyPointsInfo[index]);
				}), function(remoteError, errorMessage) {
					deferred.reject($tab__TableauException.createServerError(errorMessage));
				});
				this.sendCommand(Object).call(this, commandParameters, returnHandler);
				return deferred.get_promise();
			},
			$activatePreviousNextStoryPointAsync: function StoryImpl$ActivatePreviousNextStoryPointAsync(commandName) {
				if (commandName !== 'api.ActivatePreviousStoryPoint' && commandName !== 'api.ActivateNextStoryPoint') {
					throw $tab__TableauException.createInternalError("commandName '" + commandName + "' is invalid.");
				}
				var deferred = new tab._Deferred();
				var previouslyActiveStoryPointImpl = this.get_activeStoryPointImpl();
				var commandParameters = {};
				var returnHandler = new (ss.makeGenericType($tab_CommandReturnHandler$1, [Object]))(commandName, 0, ss.mkdel(this, function(result) {
					this.$updateActiveState(previouslyActiveStoryPointImpl, result);
					deferred.resolve(this.$activeStoryPointImpl.get_storyPoint());
				}), function(remoteError, errorMessage) {
					deferred.reject($tab__TableauException.createServerError(errorMessage));
				});
				this.sendCommand(Object).call(this, commandParameters, returnHandler);
				return deferred.get_promise();
			},
			$updateStoryPointInfo: function StoryImpl$UpdateStoryPointInfo(index, newStoryPointPm) {
				var existingImpl = this.$storyPointsInfo[index]._impl;
				if (existingImpl.storyPointId !== newStoryPointPm.storyPointId) {
					throw $tab__TableauException.createInternalError("We should not be updating a story point where the IDs don't match. Existing storyPointID=" + existingImpl.storyPointId + ', newStoryPointID=' + newStoryPointPm.storyPointId);
				}
				existingImpl.caption = newStoryPointPm.caption;
				existingImpl.isUpdated = newStoryPointPm.isUpdated;
				if (newStoryPointPm.storyPointId === this.$activeStoryPointImpl.get_storyPointId()) {
					this.$activeStoryPointImpl.set_isUpdated(newStoryPointPm.isUpdated);
				}
			},
			$updateActiveState: function StoryImpl$UpdateActiveState(previouslyActiveStoryPointImpl, newActiveStoryPointPm) {
				var newActiveIndex = newActiveStoryPointPm.index;
				if (previouslyActiveStoryPointImpl.get_index() === newActiveIndex) {
					return;
				}
				var oldStoryPointInfo = this.$storyPointsInfo[previouslyActiveStoryPointImpl.get_index()];
				var newStoryPointInfoImpl = this.$storyPointsInfo[newActiveIndex]._impl;
				var containedSheetImpl = $tab__StoryPointImpl.createContainedSheet(newActiveStoryPointPm.containedSheetInfo, this.get_workbookImpl(), this.get_messagingOptions(), this.$findSheetFunc);
				newStoryPointInfoImpl.isActive = true;
				this.$activeStoryPointImpl = new $tab__StoryPointImpl(newStoryPointInfoImpl, containedSheetImpl);
				previouslyActiveStoryPointImpl.set_isActive(false);
				oldStoryPointInfo._impl.isActive = false;
				this.$raiseActiveStoryPointChange(oldStoryPointInfo, this.$activeStoryPointImpl.get_storyPoint());
			},
			$raiseActiveStoryPointChange: function StoryImpl$RaiseActiveStoryPointChange(oldStoryPointInfo, newStoryPoint) {
				if (!ss.staticEquals(this.$2$ActiveStoryPointChangeField, null)) {
					this.$2$ActiveStoryPointChangeField(oldStoryPointInfo, newStoryPoint);
				}
			}
		}, $tab__SheetImpl);
		ss.initClass($tab__StoryPointImpl, $asm, {
			get_caption: function StoryPointImpl$get_Caption() {
				return this.$caption;
			},
			get_containedSheetImpl: function StoryPointImpl$get_ContainedSheetImpl() {
				return this.$containedSheetImpl;
			},
			get_index: function StoryPointImpl$get_Index() {
				return this.$index;
			},
			get_isActive: function StoryPointImpl$get_IsActive() {
				return this.$isActive;
			},
			set_isActive: function StoryPointImpl$set_IsActive(value) {
				this.$isActive = value;
			},
			get_isUpdated: function StoryPointImpl$get_IsUpdated() {
				return this.$isUpdated;
			},
			set_isUpdated: function StoryPointImpl$set_IsUpdated(value) {
				this.$isUpdated = value;
			},
			get_parentStoryImpl: function StoryPointImpl$get_ParentStoryImpl() {
				return this.$parentStoryImpl;
			},
			get_storyPoint: function StoryPointImpl$get_StoryPoint() {
				if (ss.isNullOrUndefined(this.$storyPoint)) {
					this.$storyPoint = new $tableauSoftware_StoryPoint(this);
				}
				return this.$storyPoint;
			},
			get_storyPointId: function StoryPointImpl$get_StoryPointId() {
				return this.$storyPointId;
			},
			$toInfoImpl: function StoryPointImpl$ToInfoImpl() {
				return $tab__StoryPointInfoImpl.$ctor(this.$caption, this.$index, this.$storyPointId, this.$isActive, this.$isUpdated, this.$parentStoryImpl);
			}
		});
		ss.initClass($tab__StoryPointInfoImpl, $asm, {}, Object);
		ss.initClass($tab__TableauException, $asm, {});
		ss.initClass($tab__Utility, $asm, {});
		ss.initClass($tab__VizManagerImpl, $asm, {});
		ss.initClass($tab__VizParameters, $asm, {
			get_url: function VizParameters$get_Url() {
				return this.$constructUrl();
			},
			get_baseUrl: function VizParameters$get_BaseUrl() {
				return this.$urlFromApi;
			},
			$constructUrl: function VizParameters$ConstructUrl() {
				var url = [];
				url.push(this.get_baseUrl());
				url.push('?');
				if (this.userSuppliedParameters.length > 0) {
					url.push(this.userSuppliedParameters);
					url.push('&');
				}
				url.push(':embed=y');
				url.push('&:showVizHome=n');
				//url.push('&:jsdebug=y');
				if (!this.fixedSize) {
					url.push('&:bootstrapWhenNotified=y');
				}
				if (!this.tabs) {
					url.push('&:tabs=n');
				}
				if (!this.toolbar) {
					url.push('&:toolbar=n');
				}
				else if (!ss.isNullOrUndefined(this.toolBarPosition)) {
					url.push('&:toolbar=');
					url.push(this.toolBarPosition.toString());
				}
				var userOptions = this.$createOptions;
				var $t1 = new ss.ObjectEnumerator(userOptions);
				try {
					while ($t1.moveNext()) {
						var entry = $t1.current();
						if (entry.key !== 'embed' && entry.key !== 'height' && entry.key !== 'width' && entry.key !== 'autoSize' && entry.key !== 'hideTabs' && entry.key !== 'hideToolbar' && entry.key !== 'onFirstInteractive' && entry.key !== 'onFirstVizSizeKnown' && entry.key !== 'toolbarPosition' && entry.key !== 'instanceIdToClone') {
							url.push('&');
							url.push(encodeURIComponent(entry.key));
							url.push('=');
							url.push(encodeURIComponent(entry.value.toString()));
						}
					}
				}
				finally {
					$t1.dispose();
				}
				url.push('&:apiID=' + this.handlerId);
				if (ss.isValue(this.$createOptions.instanceIdToClone)) {
					url.push('#' + this.$createOptions.instanceIdToClone);
				}
				return url.join('');
			}
		});
		ss.initClass($tab__WorkbookImpl, $asm, {
			get_workbook: function WorkbookImpl$get_Workbook() {
				if (ss.isNullOrUndefined(this.$workbook)) {
					this.$workbook = new $tableauSoftware_Workbook(this);
				}
				return this.$workbook;
			},
			get_viz: function WorkbookImpl$get_Viz() {
				return this.$vizImpl.get_$viz();
			},
			get_publishedSheets: function WorkbookImpl$get_PublishedSheets() {
				return this.$publishedSheetsInfo;
			},
			get_name: function WorkbookImpl$get_Name() {
				return this.$name;
			},
			get_activeSheetImpl: function WorkbookImpl$get_ActiveSheetImpl() {
				return this.$activeSheetImpl;
			},
			get_activeCustomView: function WorkbookImpl$get_ActiveCustomView() {
				return this.$currentCustomView;
			},
			get_isDownloadAllowed: function WorkbookImpl$get_IsDownloadAllowed() {
				return this.$isDownloadAllowed;
			},
			$findActiveSheetOrSheetWithinActiveDashboard: function WorkbookImpl$FindActiveSheetOrSheetWithinActiveDashboard(sheetOrInfoOrName) {
				if (ss.isNullOrUndefined(this.$activeSheetImpl)) {
					return null;
				}
				var sheetName = $tab__WorkbookImpl.$extractSheetName(sheetOrInfoOrName);
				if (ss.isNullOrUndefined(sheetName)) {
					return null;
				}
				if (ss.referenceEquals(sheetName, this.$activeSheetImpl.get_name())) {
					return this.$activeSheetImpl;
				}
				if (this.$activeSheetImpl.get_isDashboard()) {
					var dashboardImpl = ss.cast(this.$activeSheetImpl, $tab__DashboardImpl);
					var sheet = dashboardImpl.get_worksheets()._get(sheetName);
					if (ss.isValue(sheet)) {
						return sheet._impl;
					}
				}
				return null;
			},
			_setActiveSheetAsync: function WorkbookImpl$ActivateSheetAsync(sheetNameOrInfoOrIndex) {
				if ($tab__Utility.isNumber(sheetNameOrInfoOrIndex)) {
					var index = sheetNameOrInfoOrIndex;
					if (index < this.$publishedSheetsInfo.get__length() && index >= 0) {
						return this.$activateSheetWithInfoAsync(this.$publishedSheetsInfo.get_item(index).$impl);
					}
					else {
						throw $tab__TableauException.createIndexOutOfRange(index);
					}
				}
				var sheetName = $tab__WorkbookImpl.$extractSheetName(sheetNameOrInfoOrIndex);
				var sheetInfo = this.$publishedSheetsInfo._get(sheetName);
				if (ss.isValue(sheetInfo)) {
					return this.$activateSheetWithInfoAsync(sheetInfo.$impl);
				}
				else if (this.$activeSheetImpl.get_isDashboard()) {
					var d = ss.cast(this.$activeSheetImpl, $tab__DashboardImpl);
					var sheet = d.get_worksheets()._get(sheetName);
					if (ss.isValue(sheet)) {
						this.$activatingHiddenSheetImpl = null;
						var sheetUrl = '';
						if (sheet.getIsHidden()) {
							this.$activatingHiddenSheetImpl = sheet._impl;
						}
						else {
							sheetUrl = sheet._impl.get_url();
						}
						return this.$activateSheetInternalAsync(sheet._impl.get_name(), sheetUrl);
					}
				}
				throw $tab__TableauException.create('sheetNotInWorkbook', 'Sheet is not found in Workbook');
			},
			_revertAllAsync: function WorkbookImpl$RevertAllAsync() {
				var deferred = new tab._Deferred();
				var returnHandler = new (ss.makeGenericType($tab_CommandReturnHandler$1, [Object]))('api.RevertAllCommand', 1, function(result) {
					deferred.resolve();
				}, function(remoteError, message) {
					deferred.reject($tab__TableauException.createServerError(message));
				});
				this.$sendCommand(Object).call(this, null, returnHandler);
				return deferred.get_promise();
			},
			_update: function WorkbookImpl$Update(callback) {
				this.$getClientInfo(callback);
			},
			$activateSheetWithInfoAsync: function WorkbookImpl$ActivateSheetWithInfoAsync(sheetInfoImpl) {
				return this.$activateSheetInternalAsync(sheetInfoImpl.name, sheetInfoImpl.url);
			},
			$activateSheetInternalAsync: function WorkbookImpl$ActivateSheetInternalAsync(sheetName, sheetUrl) {
				var deferred = new tab._Deferred();
				if (ss.isValue(this.$activeSheetImpl) && ss.referenceEquals(sheetName, this.$activeSheetImpl.get_name())) {
					deferred.resolve(this.$activeSheetImpl.get_sheet());
					return deferred.get_promise();
				}
				var param = {};
				param['api.switchToSheetName'] = sheetName;
				param['api.switchToRepositoryUrl'] = sheetUrl;
				param['api.oldRepositoryUrl'] = this.$activeSheetImpl.get_url();
				var returnHandler = new (ss.makeGenericType($tab_CommandReturnHandler$1, [Object]))('api.SwitchActiveSheetCommand', 0, ss.mkdel(this, function(result) {
					this.$vizImpl.$workbookTabSwitchHandler = ss.mkdel(this, function() {
						this.$vizImpl.$workbookTabSwitchHandler = null;
						deferred.resolve(this.$activeSheetImpl.get_sheet());
					});
				}), function(remoteError, message) {
					deferred.reject($tab__TableauException.createServerError(message));
				});
				this.$sendCommand(Object).call(this, param, returnHandler);
				return deferred.get_promise();
			},
			_updateActiveSheetAsync: function WorkbookImpl$UpdateActiveSheetAsync() {
				var deferred = new tab._Deferred();
				var param = {};
				param['api.switchToSheetName'] = this.$activeSheetImpl.get_name();
				param['api.switchToRepositoryUrl'] = this.$activeSheetImpl.get_url();
				param['api.oldRepositoryUrl'] = this.$activeSheetImpl.get_url();
				var returnHandler = new (ss.makeGenericType($tab_CommandReturnHandler$1, [Object]))('api.UpdateActiveSheetCommand', 0, ss.mkdel(this, function(result) {
					deferred.resolve(this.$activeSheetImpl.get_sheet());
				}), function(remoteError, message) {
					deferred.reject($tab__TableauException.createServerError(message));
				});
				this.$sendCommand(Object).call(this, param, returnHandler);
				return deferred.get_promise();
			},
			$sendCommand: function(T) {
				return function WorkbookImpl$SendCommand(commandParameters, returnHandler) {
					this.$messagingOptions.sendCommand(T).call(this.$messagingOptions, commandParameters, returnHandler);
				};
			},
			$getClientInfo: function WorkbookImpl$GetClientInfo(callback) {
				var returnHandler = new (ss.makeGenericType($tab_CommandReturnHandler$1, [Object]))('api.GetClientInfoCommand', 0, ss.mkdel(this, function(result) {
					this.$processInfo(result);
					if (ss.isValue(callback)) {
						callback();
					}
				}), null);
				this.$sendCommand(Object).call(this, null, returnHandler);
			},
			$processInfo: function WorkbookImpl$ProcessInfo(clientInfo) {
				this.$name = clientInfo.workbookName;
				this.$isDownloadAllowed = clientInfo.isDownloadAllowed;
				this.$vizImpl.$setAreAutomaticUpdatesPaused(!clientInfo.isAutoUpdate);
				this.$vizImpl.set_instanceId(clientInfo.instanceId);
				this.$createSheetsInfo(clientInfo);
				this.$initializeActiveSheet(clientInfo);
			},
			$initializeActiveSheet: function WorkbookImpl$InitializeActiveSheet(clientInfo) {
				var currentSheetName = clientInfo.currentSheetName;
				var newActiveSheetInfo = this.$publishedSheetsInfo._get(currentSheetName);
				if (ss.isNullOrUndefined(newActiveSheetInfo) && ss.isNullOrUndefined(this.$activatingHiddenSheetImpl)) {
					throw $tab__TableauException.createInternalError('The active sheet was not specified in baseSheets');
				}
				if (ss.isValue(this.$activeSheetImpl) && ss.referenceEquals(this.$activeSheetImpl.get_name(), currentSheetName)) {
					return;
				}
				if (ss.isValue(this.$activeSheetImpl)) {
					this.$activeSheetImpl.set_isActive(false);
					var oldActiveSheetInfo = this.$publishedSheetsInfo._get(this.$activeSheetImpl.get_name());
					if (ss.isValue(oldActiveSheetInfo)) {
						oldActiveSheetInfo.$impl.isActive = false;
					}
					if (this.$activeSheetImpl.get_sheetType() === 'story') {
						var storyImpl = ss.cast(this.$activeSheetImpl, $tab__StoryImpl);
						storyImpl.remove_activeStoryPointChange(ss.mkdel(this.$vizImpl, this.$vizImpl.raiseStoryPointSwitch));
					}
				}
				if (ss.isValue(this.$activatingHiddenSheetImpl)) {
					var infoImpl = $tab__SheetInfoImpl.$ctor(this.$activatingHiddenSheetImpl.get_name(), 'worksheet', -1, this.$activatingHiddenSheetImpl.get_size(), this.get_workbook(), '', true, true, $tab__SheetImpl.noZoneId);
					this.$activatingHiddenSheetImpl = null;
					this.$activeSheetImpl = new $tab__WorksheetImpl(infoImpl, this, this.$messagingOptions, null);
				}
				else {
					var baseSheet = null;
					for (var i = 0, len = clientInfo.publishedSheets.length; i < len; i++) {
						if (ss.referenceEquals(clientInfo.publishedSheets[i].name, currentSheetName)) {
							baseSheet = clientInfo.publishedSheets[i];
							break;
						}
					}
					if (ss.isNullOrUndefined(baseSheet)) {
						throw $tab__TableauException.createInternalError('No base sheet was found corresponding to the active sheet.');
					}
					var findSheetFunc = ss.mkdel(this, function(sheetName) {
						return this.$publishedSheetsInfo._get(sheetName);
					});
					if (baseSheet.sheetType === 'dashboard') {
						var dashboardImpl = new $tab__DashboardImpl(newActiveSheetInfo.$impl, this, this.$messagingOptions);
						this.$activeSheetImpl = dashboardImpl;
						var dashboardFrames = $tab__WorkbookImpl.$createDashboardZones(clientInfo.dashboardZones);
						dashboardImpl.$addObjects(dashboardFrames, findSheetFunc);
					}
					else if (baseSheet.sheetType === 'story') {
						var storyImpl1 = new $tab__StoryImpl(newActiveSheetInfo.$impl, this, this.$messagingOptions, clientInfo.story, findSheetFunc);
						this.$activeSheetImpl = storyImpl1;
						storyImpl1.add_activeStoryPointChange(ss.mkdel(this.$vizImpl, this.$vizImpl.raiseStoryPointSwitch));
					}
					else {
						this.$activeSheetImpl = new $tab__WorksheetImpl(newActiveSheetInfo.$impl, this, this.$messagingOptions, null);
					}
					newActiveSheetInfo.$impl.isActive = true;
				}
				this.$activeSheetImpl.set_isActive(true);
			},
			$createSheetsInfo: function WorkbookImpl$CreateSheetsInfo(clientInfo) {
				var baseSheets = clientInfo.publishedSheets;
				if (ss.isNullOrUndefined(baseSheets)) {
					return;
				}
				for (var index = 0; index < baseSheets.length; index++) {
					var baseSheet = baseSheets[index];
					var sheetName = baseSheet.name;
					var sheetInfo = this.$publishedSheetsInfo._get(sheetName);
					var size = $tab__WorkbookImpl.$createSheetSize(baseSheet);
					if (ss.isNullOrUndefined(sheetInfo)) {
						var isActive = ss.referenceEquals(sheetName, clientInfo.currentSheetName);
						var sheetType = $tab_ApiEnumConverter.convertSheetType(baseSheet.sheetType);
						var sheetInfoImpl = $tab__SheetInfoImpl.$ctor(sheetName, sheetType, index, size, this.get_workbook(), baseSheet.repositoryUrl, isActive, false, $tab__SheetImpl.noZoneId);
						sheetInfo = new $tableauSoftware_SheetInfo(sheetInfoImpl);
						this.$publishedSheetsInfo._add(sheetName, sheetInfo);
					}
					else {
						sheetInfo.$impl.size = size;
					}
				}
			},
			get_$customViews: function WorkbookImpl$get_CustomViews() {
				return this.$customViews;
			},
			set_$customViews: function WorkbookImpl$set_CustomViews(value) {
				this.$customViews = value;
			},
			get_$updatedCustomViews: function WorkbookImpl$get_UpdatedCustomViews() {
				return this.$updatedCustomViews;
			},
			set_$updatedCustomViews: function WorkbookImpl$set_UpdatedCustomViews(value) {
				this.$updatedCustomViews = value;
			},
			get_$removedCustomViews: function WorkbookImpl$get_RemovedCustomViews() {
				return this.$removedCustomViews;
			},
			set_$removedCustomViews: function WorkbookImpl$set_RemovedCustomViews(value) {
				this.$removedCustomViews = value;
			},
			get_$currentCustomView: function WorkbookImpl$get_CurrentCustomView() {
				return this.$currentCustomView;
			},
			set_$currentCustomView: function WorkbookImpl$set_CurrentCustomView(value) {
				this.$currentCustomView = value;
			},
			$getCustomViewsAsync: function WorkbookImpl$GetCustomViewsAsync() {
				return $tab__CustomViewImpl._getCustomViewsAsync(this, this.$messagingOptions);
			},
			$showCustomViewAsync: function WorkbookImpl$ShowCustomViewAsync(customViewName) {
				if (ss.isNullOrUndefined(customViewName) || customViewName == "") {
					return $tab__CustomViewImpl._showCustomViewAsync(this, this.$messagingOptions, null);
				}
				else {
				    var cv = customViewName;
					if (ss.isNullOrUndefined(cv)) {
						var deferred = new tab._Deferred();
						deferred.reject($tab__TableauException.createInvalidCustomViewName(customViewName));
						return deferred.get_promise();
					}
					return cv._impl._showAsync();
				}
			},
			$removeCustomViewAsync: function WorkbookImpl$RemoveCustomViewAsync(cv) {
				return cv._impl.$removeAsync();
			},
			$rememberCustomViewAsync: function WorkbookImpl$RememberCustomViewAsync(customViewName) {
				if ($tab__Utility.isNullOrEmpty(customViewName)) {
					throw $tab__TableauException.createInvalidParameter('customViewName');
				}
				return $tab__CustomViewImpl._saveNewAsync(this, this.$messagingOptions, customViewName);
			},
			$setActiveCustomViewAsDefaultAsync: function WorkbookImpl$SetActiveCustomViewAsDefaultAsync() {
				return $tab__CustomViewImpl._makeCurrentCustomViewDefaultAsync(this, this.$messagingOptions);
			},
			get_$lastChangedParameterImpl: function WorkbookImpl$get_LastChangedParameterImpl() {
				return this.$lastChangedParameterImpl;
			},
			set_$lastChangedParameterImpl: function WorkbookImpl$set_LastChangedParameterImpl(value) {
				this.$lastChangedParameterImpl = value;
			},
			get_$parameters: function WorkbookImpl$get_Parameters() {
				return this.$parameters;
			},
			$getSingleParameterAsync: function WorkbookImpl$GetSingleParameterAsync(parameterName) {
				var deferred = new tab._Deferred();
				if (ss.isValue(this.$lastChangedParameterImpl)) {
					deferred.resolve(this.$lastChangedParameterImpl.get_$parameter());
					return deferred.get_promise();
				}
				var commandParameters = {};
				var returnHandler = new (ss.makeGenericType($tab_CommandReturnHandler$1, [Object]))('api.FetchParametersCommand', 0, ss.mkdel(this, function(result) {
					var parameterImpl = $tab__WorkbookImpl.$findAndCreateParameterImpl(parameterName, result);
					this.$lastChangedParameterImpl = parameterImpl;
					deferred.resolve(parameterImpl.get_$parameter());
				}), function(remoteError, message) {
					deferred.reject($tab__TableauException.createServerError(message));
				});
				this.$sendCommand(Object).call(this, commandParameters, returnHandler);
				return deferred.get_promise();
			},
			$getParametersAsync: function WorkbookImpl$GetParametersAsync() {
				var deferred = new tab._Deferred();
				var commandParameters = {};
				var returnHandler = new (ss.makeGenericType($tab_CommandReturnHandler$1, [Object]))('api.FetchParametersCommand', 0, ss.mkdel(this, function(result) {
					this.$parameters = $tab__WorkbookImpl.$processParameters(result);
					deferred.resolve(this.get_$parameters()._toApiCollection());
				}), function(remoteError, message) {
					deferred.reject($tab__TableauException.createServerError(message));
				});
				this.$sendCommand(Object).call(this, commandParameters, returnHandler);
				return deferred.get_promise();
			},
			$changeParameterValueAsync: function WorkbookImpl$ChangeParameterValueAsync(parameterName, value) {
				var deferred = new tab._Deferred();
				var parameterImpl = null;
				if (ss.isValue(this.$parameters)) {
					if (ss.isNullOrUndefined(this.$parameters._get(parameterName))) {
						deferred.reject($tab__TableauException.createInvalidParameter(parameterName));
						return deferred.get_promise();
					}
					parameterImpl = this.$parameters._get(parameterName)._impl;
					if (ss.isNullOrUndefined(parameterImpl)) {
						deferred.reject($tab__TableauException.createInvalidParameter(parameterName));
						return deferred.get_promise();
					}
				}
				var param = {};
				param['api.setParameterName'] = (ss.isValue(this.$parameters) ? parameterImpl.get_$name() : parameterName);
				if (ss.isValue(value) && $tab__Utility.isDate(value)) {
					var date = ss.cast(value, ss.JsDate);
					var dateStr = $tab__Utility.serializeDateForServer(date);
					param['api.setParameterValue'] = dateStr;
				}
				else {
					param['api.setParameterValue'] = (ss.isValue(value) ? value.toString() : null);
				}
				this.$lastChangedParameterImpl = null;
				var returnHandler = new (ss.makeGenericType($tab_CommandReturnHandler$1, [Object]))('api.SetParameterValueCommand', 0, ss.mkdel(this, function(result) {
					if (ss.isNullOrUndefined(result)) {
						deferred.reject($tab__TableauException.create('serverError', 'server error'));
						return;
					}
					if (!result.isValidPresModel) {
						deferred.reject($tab__TableauException.createInvalidParameter(parameterName));
						return;
					}
					var paramUpdated = new $tab_$ParameterImpl(result);
					this.$lastChangedParameterImpl = paramUpdated;
					deferred.resolve(paramUpdated.get_$parameter());
				}), function(remoteError, message) {
					deferred.reject($tab__TableauException.createInvalidParameter(parameterName));
				});
				this.$sendCommand(Object).call(this, param, returnHandler);
				return deferred.get_promise();
			}
		});
		ss.initClass($tab__WorksheetImpl, $asm, {
			get_sheet: function WorksheetImpl$get_Sheet() {
				return this.get_worksheet();
			},
			get_worksheet: function WorksheetImpl$get_Worksheet() {
				if (ss.isNullOrUndefined(this.$worksheet)) {
					this.$worksheet = new $tableauSoftware_Worksheet(this);
				}
				return this.$worksheet;
			},
			get_parentDashboardImpl: function WorksheetImpl$get_ParentDashboardImpl() {
				return this.$parentDashboardImpl;
			},
			get_parentDashboard: function WorksheetImpl$get_ParentDashboard() {
				if (ss.isValue(this.$parentDashboardImpl)) {
					return this.$parentDashboardImpl.get_dashboard();
				}
				return null;
			},
			$getDataSourcesAsync: function WorksheetImpl$GetDataSourcesAsync() {
				this.$verifyActiveSheetOrEmbeddedInActiveDashboard();
				var deferred = new tab._Deferred();
				var commandParameters = {};
				commandParameters['api.worksheetName'] = this.get_name();
				var returnHandler = new (ss.makeGenericType($tab_CommandReturnHandler$1, [Object]))('api.GetDataSourcesCommand', 0, function(result) {
					var dataSources = $tab__DataSourceImpl.processDataSourcesForWorksheet(result);
					deferred.resolve(dataSources._toApiCollection());
				}, function(remoteError, message) {
					deferred.reject($tab__TableauException.createServerError(message));
				});
				this.sendCommand(Object).call(this, commandParameters, returnHandler);
				return deferred.get_promise();
			},
			$getDataSourceAsync: function WorksheetImpl$GetDataSourceAsync(dataSourceName) {
				this.$verifyActiveSheetOrEmbeddedInActiveDashboard();
				var deferred = new tab._Deferred();
				var commandParameters = {};
				commandParameters['api.dataSourceName'] = dataSourceName;
				commandParameters['api.worksheetName'] = this.get_name();
				var returnHandler = new (ss.makeGenericType($tab_CommandReturnHandler$1, [Object]))('api.GetDataSourceCommand', 0, function(result) {
					var dataSourceImpl = $tab__DataSourceImpl.processDataSource(result);
					if (ss.isValue(dataSourceImpl)) {
						deferred.resolve(dataSourceImpl.get_dataSource());
					}
					else {
						deferred.reject($tab__TableauException.createServerError("Data source '" + dataSourceName + "' not found"));
					}
				}, function(remoteError, message) {
					deferred.reject($tab__TableauException.createServerError(message));
				});
				this.sendCommand(Object).call(this, commandParameters, returnHandler);
				return deferred.get_promise();
			},
			$verifyActiveSheetOrEmbeddedInActiveDashboard: function WorksheetImpl$VerifyActiveSheetOrEmbeddedInActiveDashboard() {
				var isRootAndActiveWorksheet = this.get_isActive();
				var isWithinActiveDashboard = ss.isValue(this.$parentDashboardImpl) && this.$parentDashboardImpl.get_isActive();
				var isWithinActiveStoryPoint = ss.isValue(this.get_parentStoryPointImpl()) && this.get_parentStoryPointImpl().get_parentStoryImpl().get_isActive();
				if (!isRootAndActiveWorksheet && !isWithinActiveDashboard && !isWithinActiveStoryPoint) {
					throw $tab__TableauException.createNotActiveSheet();
				}
			},
			$addVisualIdToCommand: function WorksheetImpl$AddVisualIdToCommand(commandParameters) {
				if (ss.isValue(this.get_parentStoryPointImpl())) {
					var visualId = {};
					visualId.worksheet = this.get_name();
					visualId.dashboard = (ss.isValue(this.get_parentDashboardImpl()) ? this.$parentDashboardImpl.get_name() : this.get_name());
					visualId.flipboardZoneId = this.get_parentStoryPointImpl().get_containedSheetImpl().get_zoneId();
					visualId.storyboard = this.get_parentStoryPointImpl().get_parentStoryImpl().get_name();
					visualId.storyPointId = this.get_parentStoryPointImpl().get_storyPointId();
					commandParameters['api.visualId'] = visualId;
				}
				else {
					commandParameters['api.worksheetName'] = this.get_name();
					if (ss.isValue(this.get_parentDashboardImpl())) {
						commandParameters['api.dashboardName'] = this.get_parentDashboardImpl().get_name();
					}
				}
			},
			get__filters: function WorksheetImpl$get_Filters() {
				return this.$filters;
			},
			set__filters: function WorksheetImpl$set_Filters(value) {
				this.$filters = value;
			},
			$getFilterAsync: function WorksheetImpl$GetFilterAsync(fieldName, fieldCaption, options) {
				if (!$tab__Utility.isNullOrEmpty(fieldName) && !$tab__Utility.isNullOrEmpty(fieldCaption)) {
					throw $tab__TableauException.createInternalError('Only fieldName OR fieldCaption is allowed, not both.');
				}
				options = options || new Object();
				var deferred = new tab._Deferred();
				var commandParameters = {};
				this.$addVisualIdToCommand(commandParameters);
				if (!$tab__Utility.isNullOrEmpty(fieldCaption) && $tab__Utility.isNullOrEmpty(fieldName)) {
					commandParameters['api.fieldCaption'] = fieldCaption;
				}
				if (!$tab__Utility.isNullOrEmpty(fieldName)) {
					commandParameters['api.fieldName'] = fieldName;
				}
				commandParameters['api.filterHierarchicalLevels'] = 0;
				commandParameters['api.ignoreDomain'] = options.ignoreDomain || false;
				var returnHandler = new (ss.makeGenericType($tab_CommandReturnHandler$1, [Object]))('api.GetOneFilterInfoCommand', 0, ss.mkdel(this, function(result) {
					var error = $tab__WorksheetImpl.$filterCommandError(result);
					if (ss.isNullOrUndefined(error)) {
						var filterJson = result;
						var filter = $tableauSoftware_Filter.$createFilter(this, filterJson);
						deferred.resolve(filter);
					}
					else {
						deferred.reject(error);
					}
				}), function(remoteError, message) {
					deferred.reject($tab__TableauException.createServerError(message));
				});
				this.sendCommand(Object).call(this, commandParameters, returnHandler);
				return deferred.get_promise();
			},
			$getFiltersAsync: function WorksheetImpl$GetFiltersAsync(options) {
				this.$verifyActiveSheetOrEmbeddedInActiveDashboard();
				options = options || new Object();
				var deferred = new tab._Deferred();
				var commandParameters = {};
				this.$addVisualIdToCommand(commandParameters);
				commandParameters['api.ignoreDomain'] = options.ignoreDomain || false;
				var returnHandler = new (ss.makeGenericType($tab_CommandReturnHandler$1, [Object]))('api.GetFiltersListCommand', 0, ss.mkdel(this, function(result) {
					this.set__filters($tableauSoftware_Filter.$processFiltersList(this, result));
					deferred.resolve(this.get__filters()._toApiCollection());
				}), function(remoteError, message) {
					deferred.reject($tab__TableauException.createServerError(message));
				});
				this.sendCommand(Object).call(this, commandParameters, returnHandler);
				return deferred.get_promise();
			},
			$applyFilterAsync: function WorksheetImpl$ApplyFilterAsync(fieldName, values, updateType, options) {
				return this.$applyFilterWithValuesInternalAsync(fieldName, values, updateType, options);
			},
			$clearFilterAsync: function WorksheetImpl$ClearFilterAsync(fieldName) {
				return this.$clearFilterInternalAsync(fieldName);
			},
			$applyRangeFilterAsync: function WorksheetImpl$ApplyRangeFilterAsync(fieldName, options) {
				var fixedUpFilterOptions = $tab__WorksheetImpl.$normalizeRangeFilterOption(options);
				return this.$applyRangeFilterInternalAsync(fieldName, fixedUpFilterOptions);
			},
			$applyRelativeDateFilterAsync: function WorksheetImpl$ApplyRelativeDateFilterAsync(fieldName, options) {
				var fixedUpFilterOptions = $tab__WorksheetImpl.$normalizeRelativeDateFilterOptions(options);
				return this.$applyRelativeDateFilterInternalAsync(fieldName, fixedUpFilterOptions);
			},
			$applyHierarchicalFilterAsync: function WorksheetImpl$ApplyHierarchicalFilterAsync(fieldName, values, updateType, options) {
				if (ss.isNullOrUndefined(values) && updateType !== 'all') {
					throw $tab__TableauException.createInvalidParameter('values');
				}
				return this.$applyHierarchicalFilterInternalAsync(fieldName, values, updateType, options);
			},
			$clearFilterInternalAsync: function WorksheetImpl$ClearFilterInternalAsync(fieldName) {
				this.$verifyActiveSheetOrEmbeddedInActiveDashboard();
				if ($tab__Utility.isNullOrEmpty(fieldName)) {
					throw $tab__TableauException.createNullOrEmptyParameter('fieldName');
				}
				var deferred = new tab._Deferred();
				var commandParameters = {};
				commandParameters['api.fieldCaption'] = fieldName;
				this.$addVisualIdToCommand(commandParameters);
				var returnHandler = $tab__WorksheetImpl.$createFilterCommandReturnHandler('api.ClearFilterCommand', fieldName, deferred);
				this.sendCommand(Object).call(this, commandParameters, returnHandler);
				return deferred.get_promise();
			},
			$applyFilterWithValuesInternalAsync: function WorksheetImpl$ApplyFilterWithValuesInternalAsync(fieldName, values, updateType, options) {
				this.$verifyActiveSheetOrEmbeddedInActiveDashboard();
				if ($tab__Utility.isNullOrEmpty(fieldName)) {
					throw $tab__TableauException.createNullOrEmptyParameter('fieldName');
				}
				updateType = $tab_$PublicEnums.$normalizeEnum($tab_ApiFilterUpdateType).call(null, updateType, 'updateType');
				var fieldValues = [];
				if ($tab__jQueryShim.isArray(values)) {
					for (var i = 0; i < values.length; i++) {
						fieldValues.push(values[i].toString());
					}
				}
				else if (ss.isValue(values)) {
					fieldValues.push(values.toString());
				}
				var deferred = new tab._Deferred();
				var commandParameters = {};
				commandParameters['api.fieldCaption'] = fieldName;
				commandParameters['api.filterUpdateType'] = updateType;
				commandParameters['api.exclude'] = ((ss.isValue(options) && options.isExcludeMode) ? true : false);
				if (updateType !== 'all') {
					commandParameters['api.filterCategoricalValues'] = fieldValues;
				}
				this.$addVisualIdToCommand(commandParameters);
				var returnHandler = $tab__WorksheetImpl.$createFilterCommandReturnHandler('api.ApplyCategoricalFilterCommand', fieldName, deferred);
				this.sendCommand(Object).call(this, commandParameters, returnHandler);
				return deferred.get_promise();
			},
			$applyRangeFilterInternalAsync: function WorksheetImpl$ApplyRangeFilterInternalAsync(fieldName, filterOptions) {
				this.$verifyActiveSheetOrEmbeddedInActiveDashboard();
				if ($tab__Utility.isNullOrEmpty(fieldName)) {
					throw $tab__TableauException.createNullOrEmptyParameter('fieldName');
				}
				if (ss.isNullOrUndefined(filterOptions)) {
					throw $tab__TableauException.createNullOrEmptyParameter('filterOptions');
				}
				var commandParameters = {};
				commandParameters['api.fieldCaption'] = fieldName;
				if (ss.isValue(filterOptions.min)) {
					if ($tab__Utility.isDate(filterOptions.min)) {
						var dt = ss.cast(filterOptions.min, ss.JsDate);
						if ($tab__Utility.isDateValid(dt)) {
							commandParameters['api.filterRangeMin'] = $tab__Utility.serializeDateForServer(dt);
						}
						else {
							throw $tab__TableauException.createInvalidDateParameter('filterOptions.min');
						}
					}
					else {
						commandParameters['api.filterRangeMin'] = filterOptions.min;
					}
				}
				if (ss.isValue(filterOptions.max)) {
					if ($tab__Utility.isDate(filterOptions.max)) {
						var dt1 = ss.cast(filterOptions.max, ss.JsDate);
						if ($tab__Utility.isDateValid(dt1)) {
							commandParameters['api.filterRangeMax'] = $tab__Utility.serializeDateForServer(dt1);
						}
						else {
							throw $tab__TableauException.createInvalidDateParameter('filterOptions.max');
						}
					}
					else {
						commandParameters['api.filterRangeMax'] = filterOptions.max;
					}
				}
				if (ss.isValue(filterOptions.nullOption)) {
					commandParameters['api.filterRangeNullOption'] = filterOptions.nullOption;
				}
				this.$addVisualIdToCommand(commandParameters);
				var deferred = new tab._Deferred();
				var returnHandler = $tab__WorksheetImpl.$createFilterCommandReturnHandler('api.ApplyRangeFilterCommand', fieldName, deferred);
				this.sendCommand(Object).call(this, commandParameters, returnHandler);
				return deferred.get_promise();
			},
			$applyRelativeDateFilterInternalAsync: function WorksheetImpl$ApplyRelativeDateFilterInternalAsync(fieldName, filterOptions) {
				this.$verifyActiveSheetOrEmbeddedInActiveDashboard();
				if ($tab__Utility.isNullOrEmpty(fieldName)) {
					throw $tab__TableauException.createInvalidParameter('fieldName');
				}
				else if (ss.isNullOrUndefined(filterOptions)) {
					throw $tab__TableauException.createInvalidParameter('filterOptions');
				}
				var commandParameters = {};
				commandParameters['api.fieldCaption'] = fieldName;
				if (ss.isValue(filterOptions)) {
					commandParameters['api.filterPeriodType'] = filterOptions.periodType;
					commandParameters['api.filterDateRangeType'] = filterOptions.rangeType;
					if (filterOptions.rangeType === 'lastn' || filterOptions.rangeType === 'nextn') {
						if (ss.isNullOrUndefined(filterOptions.rangeN)) {
							throw $tab__TableauException.create('missingRangeNForRelativeDateFilters', 'Missing rangeN field for a relative date filter of LASTN or NEXTN.');
						}
						commandParameters['api.filterDateRange'] = filterOptions.rangeN;
					}
					if (ss.isValue(filterOptions.anchorDate)) {
						commandParameters['api.filterDateArchorValue'] = $tab__Utility.serializeDateForServer(filterOptions.anchorDate);
					}
				}
				this.$addVisualIdToCommand(commandParameters);
				var deferred = new tab._Deferred();
				var returnHandler = $tab__WorksheetImpl.$createFilterCommandReturnHandler('api.ApplyRelativeDateFilterCommand', fieldName, deferred);
				this.sendCommand(Object).call(this, commandParameters, returnHandler);
				return deferred.get_promise();
			},
			$applyHierarchicalFilterInternalAsync: function WorksheetImpl$ApplyHierarchicalFilterInternalAsync(fieldName, values, updateType, options) {
				this.$verifyActiveSheetOrEmbeddedInActiveDashboard();
				if ($tab__Utility.isNullOrEmpty(fieldName)) {
					throw $tab__TableauException.createNullOrEmptyParameter('fieldName');
				}
				updateType = $tab_$PublicEnums.$normalizeEnum($tab_ApiFilterUpdateType).call(null, updateType, 'updateType');
				var fieldValues = null;
				var levelValues = null;
				if ($tab__jQueryShim.isArray(values)) {
					fieldValues = [];
					var arr = values;
					for (var i = 0; i < arr.length; i++) {
						fieldValues.push(arr[i].toString());
					}
				}
				else if ($tab__Utility.isString(values)) {
					fieldValues = [];
					fieldValues.push(values.toString());
				}
				else if (ss.isValue(values) && ss.isValue(values['levels'])) {
					var levelValue = values['levels'];
					levelValues = [];
					if ($tab__jQueryShim.isArray(levelValue)) {
						var levels = levelValue;
						for (var i1 = 0; i1 < levels.length; i1++) {
							levelValues.push(levels[i1].toString());
						}
					}
					else {
						levelValues.push(levelValue.toString());
					}
				}
				else if (ss.isValue(values)) {
					throw $tab__TableauException.createInvalidParameter('values');
				}
				var commandParameters = {};
				commandParameters['api.fieldCaption'] = fieldName;
				commandParameters['api.filterUpdateType'] = updateType;
				commandParameters['api.exclude'] = ((ss.isValue(options) && options.isExcludeMode) ? true : false);
				if (ss.isValue(fieldValues)) {
					commandParameters['api.filterHierarchicalValues'] = $tab_JsonUtil.toJson(fieldValues, false, '');
				}
				if (ss.isValue(levelValues)) {
					commandParameters['api.filterHierarchicalLevels'] = $tab_JsonUtil.toJson(levelValues, false, '');
				}
				this.$addVisualIdToCommand(commandParameters);
				var deferred = new tab._Deferred();
				var returnHandler = $tab__WorksheetImpl.$createFilterCommandReturnHandler('api.ApplyHierarchicalFilterCommand', fieldName, deferred);
				this.sendCommand(Object).call(this, commandParameters, returnHandler);
				return deferred.get_promise();
			},
			get_selectedMarks: function WorksheetImpl$get_SelectedMarks() {
				return this.$selectedMarks;
			},
			set_selectedMarks: function WorksheetImpl$set_SelectedMarks(value) {
				this.$selectedMarks = value;
			},
			$clearSelectedMarksAsync: function WorksheetImpl$ClearSelectedMarksAsync() {
				this.$verifyActiveSheetOrEmbeddedInActiveDashboard();
				var deferred = new tab._Deferred();
				var commandParameters = {};
				this.$addVisualIdToCommand(commandParameters);
				commandParameters['api.filterUpdateType'] = 'replace';
				var returnHandler = new (ss.makeGenericType($tab_CommandReturnHandler$1, [Object]))('api.SelectMarksCommand', 1, function(result) {
					deferred.resolve();
				}, function(remoteError, message) {
					deferred.reject($tab__TableauException.createServerError(message));
				});
				this.sendCommand(Object).call(this, commandParameters, returnHandler);
				return deferred.get_promise();
			},
			$selectMarksAsync: function WorksheetImpl$SelectMarksAsync(fieldNameOrFieldValuesMap, valueOrUpdateType, updateType) {
				this.$verifyActiveSheetOrEmbeddedInActiveDashboard();
				if (ss.isNullOrUndefined(fieldNameOrFieldValuesMap) && ss.isNullOrUndefined(valueOrUpdateType)) {
					return this.$clearSelectedMarksAsync();
				}
				if ($tab__Utility.isString(fieldNameOrFieldValuesMap) && ($tab__jQueryShim.isArray(valueOrUpdateType) || $tab__Utility.isString(valueOrUpdateType) || !$tab_$PublicEnums.$isValidEnum($tab_ApiSelectionUpdateType).call(null, valueOrUpdateType))) {
					return this.$selectMarksWithFieldNameAndValueAsync(ss.cast(fieldNameOrFieldValuesMap, String), valueOrUpdateType, updateType);
				}
				else if ($tab__jQueryShim.isArray(fieldNameOrFieldValuesMap)) {
					return this.$selectMarksWithMarksArrayAsync(fieldNameOrFieldValuesMap, ss.cast(valueOrUpdateType, String));
				}
				else {
					return this.$selectMarksWithMultiDimOptionAsync(fieldNameOrFieldValuesMap, ss.cast(valueOrUpdateType, String));
				}
			},
			$getSelectedMarksAsync: function WorksheetImpl$GetSelectedMarksAsync() {
				this.$verifyActiveSheetOrEmbeddedInActiveDashboard();
				var deferred = new tab._Deferred();
				var commandParameters = {};
				this.$addVisualIdToCommand(commandParameters);
				var returnHandler = new (ss.makeGenericType($tab_CommandReturnHandler$1, [Object]))('api.FetchSelectedMarksCommand', 0, ss.mkdel(this, function(result) {
					this.$selectedMarks = $tab_$MarkImpl.$processSelectedMarks(result);
					deferred.resolve(this.$selectedMarks._toApiCollection());
				}), function(remoteError, message) {
					deferred.reject($tab__TableauException.createServerError(message));
				});
				this.sendCommand(Object).call(this, commandParameters, returnHandler);
				return deferred.get_promise();
			},
			$selectMarksWithFieldNameAndValueAsync: function WorksheetImpl$SelectMarksWithFieldNameAndValueAsync(fieldName, value, updateType) {
				var catNameList = [];
				var catValueList = [];
				var hierNameList = [];
				var hierValueList = [];
				var rangeNameList = [];
				var rangeValueList = [];
				this.$parseMarksParam(catNameList, catValueList, hierNameList, hierValueList, rangeNameList, rangeValueList, fieldName, value);
				return this.$selectMarksWithValuesAsync(null, catNameList, catValueList, hierNameList, hierValueList, rangeNameList, rangeValueList, updateType);
			},
			$selectMarksWithMultiDimOptionAsync: function WorksheetImpl$SelectMarksWithMultiDimOptionAsync(fieldValuesMap, updateType) {
				var dict = fieldValuesMap;
				var catNameList = [];
				var catValueList = [];
				var hierNameList = [];
				var hierValueList = [];
				var rangeNameList = [];
				var rangeValueList = [];
				var $t1 = new ss.ObjectEnumerator(dict);
				try {
					while ($t1.moveNext()) {
						var ent = $t1.current();
						if (fieldValuesMap.hasOwnProperty(ent.key)) {
							if (!$tab__jQueryShim.isFunction(dict[ent.key])) {
								this.$parseMarksParam(catNameList, catValueList, hierNameList, hierValueList, rangeNameList, rangeValueList, ent.key, ent.value);
							}
						}
					}
				}
				finally {
					$t1.dispose();
				}
				return this.$selectMarksWithValuesAsync(null, catNameList, catValueList, hierNameList, hierValueList, rangeNameList, rangeValueList, updateType);
			},
			$selectMarksWithMarksArrayAsync: function WorksheetImpl$SelectMarksWithMarksArrayAsync(marksArray, updateType) {
				var catNameList = [];
				var catValueList = [];
				var hierNameList = [];
				var hierValueList = [];
				var rangeNameList = [];
				var rangeValueList = [];
				var tupleIdList = [];
				for (var i = 0; i < marksArray.length; i++) {
					var mark = marksArray[i];
					if (ss.isValue(mark.$impl.get_$tupleId()) && mark.$impl.get_$tupleId() > 0) {
						tupleIdList.push(mark.$impl.get_$tupleId());
					}
					else {
						var pairs = mark.$impl.get_$pairs();
						for (var j = 0; j < pairs.get__length(); j++) {
							var pair = pairs.get_item(j);
							if (pair.hasOwnProperty('fieldName') && pair.hasOwnProperty('value') && !$tab__jQueryShim.isFunction(pair.fieldName) && !$tab__jQueryShim.isFunction(pair.value)) {
								this.$parseMarksParam(catNameList, catValueList, hierNameList, hierValueList, rangeNameList, rangeValueList, pair.fieldName, pair.value);
							}
						}
					}
				}
				return this.$selectMarksWithValuesAsync(tupleIdList, catNameList, catValueList, hierNameList, hierValueList, rangeNameList, rangeValueList, updateType);
			},
			$parseMarksParam: function WorksheetImpl$ParseMarksParam(catNameList, catValueList, hierNameList, hierValueList, rangeNameList, rangeValueList, fieldName, value) {
				var sourceOptions = value;
				if ($tab__WorksheetImpl.$regexHierarchicalFieldName.test(fieldName)) {
					this.$addToParamLists(hierNameList, hierValueList, fieldName, value);
				}
				else if (ss.isValue(sourceOptions.min) || ss.isValue(sourceOptions.max)) {
					var range = new Object();
					if (ss.isValue(sourceOptions.min)) {
						if ($tab__Utility.isDate(sourceOptions.min)) {
							var dt = ss.cast(sourceOptions.min, ss.JsDate);
							if ($tab__Utility.isDateValid(dt)) {
								range.min = $tab__Utility.serializeDateForServer(dt);
							}
							else {
								throw $tab__TableauException.createInvalidDateParameter('options.min');
							}
						}
						else {
							range.min = sourceOptions.min;
						}
					}
					if (ss.isValue(sourceOptions.max)) {
						if ($tab__Utility.isDate(sourceOptions.max)) {
							var dt1 = ss.cast(sourceOptions.max, ss.JsDate);
							if ($tab__Utility.isDateValid(dt1)) {
								range.max = $tab__Utility.serializeDateForServer(dt1);
							}
							else {
								throw $tab__TableauException.createInvalidDateParameter('options.max');
							}
						}
						else {
							range.max = sourceOptions.max;
						}
					}
					if (ss.isValue(sourceOptions.nullOption)) {
						var nullOption = $tab_$PublicEnums.$normalizeEnum($tab_ApiNullOption).call(null, sourceOptions.nullOption, 'options.nullOption');
						range.nullOption = nullOption;
					}
					else {
						range.nullOption = 'allValues';
					}
					var jsonValue = $tab_JsonUtil.toJson(range, false, '');
					this.$addToParamLists(rangeNameList, rangeValueList, fieldName, jsonValue);
				}
				else {
					this.$addToParamLists(catNameList, catValueList, fieldName, value);
				}
			},
			$addToParamLists: function WorksheetImpl$AddToParamLists(paramNameList, paramValueList, paramName, paramValue) {
				var markValues = [];
				if ($tab__jQueryShim.isArray(paramValue)) {
					var values = ss.cast(paramValue, Array);
					for (var i = 0; i < values.length; i++) {
						markValues.push(values[i].toString());
					}
				}
				else {
					markValues.push(paramValue.toString());
				}
				paramValueList.push(markValues);
				paramNameList.push(paramName);
			},
			$selectMarksWithValuesAsync: function WorksheetImpl$SelectMarksWithValuesAsync(tupleIdList, catNameList, catValueList, hierNameList, hierValueList, rangeNameList, rangeValueList, updateType) {
				var commandParameters = {};
				this.$addVisualIdToCommand(commandParameters);
				updateType = $tab_$PublicEnums.$normalizeEnum($tab_ApiSelectionUpdateType).call(null, updateType, 'updateType');
				commandParameters['api.filterUpdateType'] = updateType;
				if (!$tab__Utility.isNullOrEmpty(tupleIdList)) {
					commandParameters['api.tupleIds'] = $tab_JsonUtil.toJson(tupleIdList, false, '');
				}
				if (!$tab__Utility.isNullOrEmpty(catNameList) && !$tab__Utility.isNullOrEmpty(catValueList)) {
					commandParameters['api.categoricalFieldCaption'] = $tab_JsonUtil.toJson(catNameList, false, '');
					var markValues = [];
					for (var i = 0; i < catValueList.length; i++) {
						var values = $tab_JsonUtil.toJson(catValueList[i], false, '');
						markValues.push(values);
					}
					commandParameters['api.categoricalMarkValues'] = $tab_JsonUtil.toJson(markValues, false, '');
				}
				if (!$tab__Utility.isNullOrEmpty(hierNameList) && !$tab__Utility.isNullOrEmpty(hierValueList)) {
					commandParameters['api.hierarchicalFieldCaption'] = $tab_JsonUtil.toJson(hierNameList, false, '');
					var markValues1 = [];
					for (var i1 = 0; i1 < hierValueList.length; i1++) {
						var values1 = $tab_JsonUtil.toJson(hierValueList[i1], false, '');
						markValues1.push(values1);
					}
					commandParameters['api.hierarchicalMarkValues'] = $tab_JsonUtil.toJson(markValues1, false, '');
				}
				if (!$tab__Utility.isNullOrEmpty(rangeNameList) && !$tab__Utility.isNullOrEmpty(rangeValueList)) {
					commandParameters['api.rangeFieldCaption'] = $tab_JsonUtil.toJson(rangeNameList, false, '');
					var markValues2 = [];
					for (var i2 = 0; i2 < rangeValueList.length; i2++) {
						var values2 = $tab_JsonUtil.toJson(rangeValueList[i2], false, '');
						markValues2.push(values2);
					}
					commandParameters['api.rangeMarkValues'] = $tab_JsonUtil.toJson(markValues2, false, '');
				}
				if ($tab__Utility.isNullOrEmpty(commandParameters['api.tupleIds']) && $tab__Utility.isNullOrEmpty(commandParameters['api.categoricalFieldCaption']) && $tab__Utility.isNullOrEmpty(commandParameters['api.hierarchicalFieldCaption']) && $tab__Utility.isNullOrEmpty(commandParameters['api.rangeFieldCaption'])) {
					throw $tab__TableauException.createInvalidParameter('fieldNameOrFieldValuesMap');
				}
				var deferred = new tab._Deferred();
				var returnHandler = new (ss.makeGenericType($tab_CommandReturnHandler$1, [Object]))('api.SelectMarksCommand', 1, function(result) {
					var error = $tab__WorksheetImpl.$createSelectionCommandError(result);
					if (ss.isNullOrUndefined(error)) {
						deferred.resolve();
					}
					else {
						deferred.reject(error);
					}
				}, function(remoteError, message) {
					deferred.reject($tab__TableauException.createServerError(message));
				});
				this.sendCommand(Object).call(this, commandParameters, returnHandler);
				return deferred.get_promise();
			}
		}, $tab__SheetImpl);
		ss.initEnum($tab_ApiDashboardObjectType, $asm, { blank: 'blank', worksheet: 'worksheet', quickFilter: 'quickFilter', parameterControl: 'parameterControl', pageFilter: 'pageFilter', legend: 'legend', title: 'title', text: 'text', image: 'image', webPage: 'webPage' }, true);
		ss.initEnum($tab_ApiDateRangeType, $asm, { last: 'last', lastn: 'lastn', next: 'next', nextn: 'nextn', curr: 'curr', todate: 'todate' }, true);
		ss.initClass($tab_ApiEnumConverter, $asm, {});
		ss.initEnum($tab_ApiErrorCode, $asm, { internalError: 'internalError', serverError: 'serverError', invalidAggregationFieldName: 'invalidAggregationFieldName', invalidParameter: 'invalidParameter', invalidUrl: 'invalidUrl', staleDataReference: 'staleDataReference', vizAlreadyInManager: 'vizAlreadyInManager', noUrlOrParentElementNotFound: 'noUrlOrParentElementNotFound', invalidFilterFieldName: 'invalidFilterFieldName', invalidFilterFieldValue: 'invalidFilterFieldValue', invalidFilterFieldNameOrValue: 'invalidFilterFieldNameOrValue', filterCannotBePerformed: 'filterCannotBePerformed', notActiveSheet: 'notActiveSheet', invalidCustomViewName: 'invalidCustomViewName', missingRangeNForRelativeDateFilters: 'missingRangeNForRelativeDateFilters', missingMaxSize: 'missingMaxSize', missingMinSize: 'missingMinSize', missingMinMaxSize: 'missingMinMaxSize', invalidSize: 'invalidSize', invalidSizeBehaviorOnWorksheet: 'invalidSizeBehaviorOnWorksheet', sheetNotInWorkbook: 'sheetNotInWorkbook', indexOutOfRange: 'indexOutOfRange', downloadWorkbookNotAllowed: 'downloadWorkbookNotAllowed', nullOrEmptyParameter: 'nullOrEmptyParameter', browserNotCapable: 'browserNotCapable', unsupportedEventName: 'unsupportedEventName', invalidDateParameter: 'invalidDateParameter', invalidSelectionFieldName: 'invalidSelectionFieldName', invalidSelectionValue: 'invalidSelectionValue', invalidSelectionDate: 'invalidSelectionDate', noUrlForHiddenWorksheet: 'noUrlForHiddenWorksheet', maxVizResizeAttempts: 'maxVizResizeAttempts' }, true);
		ss.initEnum($tab_ApiFieldAggregationType, $asm, { SUM: 'SUM', AVG: 'AVG', MIN: 'MIN', MAX: 'MAX', STDEV: 'STDEV', STDEVP: 'STDEVP', VAR: 'VAR', VARP: 'VARP', COUNT: 'COUNT', COUNTD: 'COUNTD', MEDIAN: 'MEDIAN', ATTR: 'ATTR', NONE: 'NONE', PERCENTILE: 'PERCENTILE', YEAR: 'YEAR', QTR: 'QTR', MONTH: 'MONTH', DAY: 'DAY', HOUR: 'HOUR', MINUTE: 'MINUTE', SECOND: 'SECOND', WEEK: 'WEEK', WEEKDAY: 'WEEKDAY', MONTHYEAR: 'MONTHYEAR', MDY: 'MDY', END: 'END', TRUNC_YEAR: 'TRUNC_YEAR', TRUNC_QTR: 'TRUNC_QTR', TRUNC_MONTH: 'TRUNC_MONTH', TRUNC_WEEK: 'TRUNC_WEEK', TRUNC_DAY: 'TRUNC_DAY', TRUNC_HOUR: 'TRUNC_HOUR', TRUNC_MINUTE: 'TRUNC_MINUTE', TRUNC_SECOND: 'TRUNC_SECOND', QUART1: 'QUART1', QUART3: 'QUART3', SKEWNESS: 'SKEWNESS', KURTOSIS: 'KURTOSIS', INOUT: 'INOUT', SUM_XSQR: 'SUM_XSQR', USER: 'USER' }, true);
		ss.initEnum($tab_ApiFieldRoleType, $asm, { dimension: 'dimension', measure: 'measure', unknown: 'unknown' }, true);
		ss.initEnum($tab_ApiFilterType, $asm, { categorical: 'categorical', quantitative: 'quantitative', hierarchical: 'hierarchical', relativedate: 'relativedate' }, true);
		ss.initEnum($tab_ApiFilterUpdateType, $asm, { all: 'all', replace: 'replace', add: 'add', remove: 'remove' }, true);
		ss.initEnum($tab_ApiNullOption, $asm, { nullValues: 'nullValues', nonNullValues: 'nonNullValues', allValues: 'allValues' }, true);
		ss.initEnum($tab_ApiParameterAllowableValuesType, $asm, { all: 'all', list: 'list', range: 'range' }, true);
		ss.initEnum($tab_ApiParameterDataType, $asm, { float: 'float', integer: 'integer', string: 'string', boolean: 'boolean', date: 'date', datetime: 'datetime' }, true);
		ss.initEnum($tab_ApiPeriodType, $asm, { year: 'year', quarter: 'quarter', month: 'month', week: 'week', day: 'day', hour: 'hour', minute: 'minute', second: 'second' }, true);
		ss.initEnum($tab_ApiSelectionUpdateType, $asm, { replace: 'replace', add: 'add', remove: 'remove' }, true);
		ss.initEnum($tab_ApiSheetSizeBehavior, $asm, { automatic: 'automatic', exactly: 'exactly', range: 'range', atleast: 'atleast', atmost: 'atmost' }, true);
		ss.initEnum($tab_ApiSheetType, $asm, { worksheet: 'worksheet', dashboard: 'dashboard', story: 'story' }, true);
		ss.initEnum($tab_ApiTableauEventName, $asm, { customviewload: 'customviewload', customviewremove: 'customviewremove', customviewsave: 'customviewsave', customviewsetdefault: 'customviewsetdefault', filterchange: 'filterchange', firstinteractive: 'firstinteractive', firstvizsizeknown: 'firstvizsizeknown', marksselection: 'marksselection', parametervaluechange: 'parametervaluechange', storypointswitch: 'storypointswitch', tabswitch: 'tabswitch', vizresize: 'vizresize' }, true);
		ss.initEnum($tab_ApiToolbarPosition, $asm, { top: 'top', bottom: 'bottom' }, true);
		ss.initClass($tab_CrossDomainMessagingOptions, $asm, {
			get_router: function CrossDomainMessagingOptions$get_Router() {
				return this.$router;
			},
			get_handler: function CrossDomainMessagingOptions$get_Handler() {
				return this.$handler;
			},
			sendCommand: function(T) {
				return function CrossDomainMessagingOptions$SendCommand(commandParameters, returnHandler) {
					this.$router.sendCommand(T).call(this.$router, this.$handler, commandParameters, returnHandler);
				};
			}
		});
		ss.initClass($tab_TableauEvent, $asm, {
			getViz: function TableauEvent$GetViz() {
				return this.$viz;
			},
			getEventName: function TableauEvent$GetEventName() {
				return this.$eventName;
			}
		});
		ss.initClass($tab_CustomViewEvent, $asm, {
			getCustomViewAsync: function CustomViewEvent$GetCustomViewAsync() {
				var deferred = new tab._Deferred();
				var customView = null;
				if (ss.isValue(this.$context.get__customViewImpl())) {
					customView = this.$context.get__customViewImpl().get_$customView();
				}
				deferred.resolve(customView);
				return deferred.get_promise();
			}
		}, $tab_TableauEvent);
		ss.initClass($tab_DataValue, $asm, {}, Object);
		ss.initClass($tab_WorksheetEvent, $asm, {
			getWorksheet: function WorksheetEvent$GetWorksheet() {
				return this.$worksheetImpl.get_worksheet();
			}
		}, $tab_TableauEvent);
		ss.initClass($tab_FilterEvent, $asm, {
			getFieldName: function FilterEvent$GetFieldName() {
				return this.$filterCaption;
			},
			getFilterAsync: function FilterEvent$GetFilterAsync() {
				return this.$context.get__worksheetImpl().$getFilterAsync(this.$context.get__filterFieldName(), null, null);
			}
		}, $tab_WorksheetEvent);
		ss.initClass($tab_FirstVizSizeKnownEvent, $asm, {
			getVizSize: function FirstVizSizeKnownEvent$GetVizSize() {
				return this.$vizSize;
			}
		}, $tab_TableauEvent);
		ss.initClass($tab_JsonUtil, $asm, {});
		ss.initClass($tab_MarksEvent, $asm, {
			getMarksAsync: function MarksEvent$GetMarksAsync() {
				var worksheetImpl = this.$context.get__worksheetImpl();
				if (ss.isValue(worksheetImpl.get_selectedMarks())) {
					var deferred = new tab._Deferred();
					return deferred.resolve(worksheetImpl.get_selectedMarks()._toApiCollection());
				}
				return worksheetImpl.$getSelectedMarksAsync();
			}
		}, $tab_WorksheetEvent);
		ss.initClass($tab_ParameterEvent, $asm, {
			getParameterName: function ParameterEvent$GetParameterName() {
				return this.$context.get__parameterName();
			},
			getParameterAsync: function ParameterEvent$GetParameterAsync() {
				return this.$context.get__workbookImpl().$getSingleParameterAsync(this.$context.get__parameterName());
			}
		}, $tab_TableauEvent);
		ss.initClass($tab_Point, $asm, {}, Object);
		ss.initClass($tab_SheetSize, $asm, {}, Object);
		ss.initClass($tab_SheetSizeFactory, $asm, {});
		ss.initClass($tab_Size, $asm, {}, Object);
		ss.initClass($tab_StoryPointInfoImplUtil, $asm, {});
		ss.initClass($tab_StoryPointSwitchEvent, $asm, {
			getOldStoryPointInfo: function StoryPointSwitchEvent$GetOldStoryPointInfo() {
				return this.$oldStoryPointInfo;
			},
			getNewStoryPoint: function StoryPointSwitchEvent$GetNewStoryPoint() {
				return this.$newStoryPoint;
			}
		}, $tab_TableauEvent);
		ss.initClass($tab_TabSwitchEvent, $asm, {
			getOldSheetName: function TabSwitchEvent$GetOldSheetName() {
				return this.$oldName;
			},
			getNewSheetName: function TabSwitchEvent$GetNewSheetName() {
				return this.$newName;
			}
		}, $tab_TableauEvent);
		ss.initClass($tab_VizImpl, $asm, {
			add_customViewsListLoad: function VizImpl$add_CustomViewsListLoad(value) {
				this.$1$CustomViewsListLoadField = ss.delegateCombine(this.$1$CustomViewsListLoadField, value);
			},
			remove_customViewsListLoad: function VizImpl$remove_CustomViewsListLoad(value) {
				this.$1$CustomViewsListLoadField = ss.delegateRemove(this.$1$CustomViewsListLoadField, value);
			},
			add_stateReadyForQuery: function VizImpl$add_StateReadyForQuery(value) {
				this.$1$StateReadyForQueryField = ss.delegateCombine(this.$1$StateReadyForQueryField, value);
			},
			remove_stateReadyForQuery: function VizImpl$remove_StateReadyForQuery(value) {
				this.$1$StateReadyForQueryField = ss.delegateRemove(this.$1$StateReadyForQueryField, value);
			},
			add_$marksSelection: function VizImpl$add_MarksSelection(value) {
				this.$1$MarksSelectionField = ss.delegateCombine(this.$1$MarksSelectionField, value);
			},
			remove_$marksSelection: function VizImpl$remove_MarksSelection(value) {
				this.$1$MarksSelectionField = ss.delegateRemove(this.$1$MarksSelectionField, value);
			},
			add_$filterChange: function VizImpl$add_FilterChange(value) {
				this.$1$FilterChangeField = ss.delegateCombine(this.$1$FilterChangeField, value);
			},
			remove_$filterChange: function VizImpl$remove_FilterChange(value) {
				this.$1$FilterChangeField = ss.delegateRemove(this.$1$FilterChangeField, value);
			},
			add_$parameterValueChange: function VizImpl$add_ParameterValueChange(value) {
				this.$1$ParameterValueChangeField = ss.delegateCombine(this.$1$ParameterValueChangeField, value);
			},
			remove_$parameterValueChange: function VizImpl$remove_ParameterValueChange(value) {
				this.$1$ParameterValueChangeField = ss.delegateRemove(this.$1$ParameterValueChangeField, value);
			},
			add_$customViewLoad: function VizImpl$add_CustomViewLoad(value) {
				this.$1$CustomViewLoadField = ss.delegateCombine(this.$1$CustomViewLoadField, value);
			},
			remove_$customViewLoad: function VizImpl$remove_CustomViewLoad(value) {
				this.$1$CustomViewLoadField = ss.delegateRemove(this.$1$CustomViewLoadField, value);
			},
			add_$customViewSave: function VizImpl$add_CustomViewSave(value) {
				this.$1$CustomViewSaveField = ss.delegateCombine(this.$1$CustomViewSaveField, value);
			},
			remove_$customViewSave: function VizImpl$remove_CustomViewSave(value) {
				this.$1$CustomViewSaveField = ss.delegateRemove(this.$1$CustomViewSaveField, value);
			},
			add_$customViewRemove: function VizImpl$add_CustomViewRemove(value) {
				this.$1$CustomViewRemoveField = ss.delegateCombine(this.$1$CustomViewRemoveField, value);
			},
			remove_$customViewRemove: function VizImpl$remove_CustomViewRemove(value) {
				this.$1$CustomViewRemoveField = ss.delegateRemove(this.$1$CustomViewRemoveField, value);
			},
			add_$customViewSetDefault: function VizImpl$add_CustomViewSetDefault(value) {
				this.$1$CustomViewSetDefaultField = ss.delegateCombine(this.$1$CustomViewSetDefaultField, value);
			},
			remove_$customViewSetDefault: function VizImpl$remove_CustomViewSetDefault(value) {
				this.$1$CustomViewSetDefaultField = ss.delegateRemove(this.$1$CustomViewSetDefaultField, value);
			},
			add_$tabSwitch: function VizImpl$add_TabSwitch(value) {
				this.$1$TabSwitchField = ss.delegateCombine(this.$1$TabSwitchField, value);
			},
			remove_$tabSwitch: function VizImpl$remove_TabSwitch(value) {
				this.$1$TabSwitchField = ss.delegateRemove(this.$1$TabSwitchField, value);
			},
			add_$storyPointSwitch: function VizImpl$add_StoryPointSwitch(value) {
				this.$1$StoryPointSwitchField = ss.delegateCombine(this.$1$StoryPointSwitchField, value);
			},
			remove_$storyPointSwitch: function VizImpl$remove_StoryPointSwitch(value) {
				this.$1$StoryPointSwitchField = ss.delegateRemove(this.$1$StoryPointSwitchField, value);
			},
			add_$vizResize: function VizImpl$add_VizResize(value) {
				this.$1$VizResizeField = ss.delegateCombine(this.$1$VizResizeField, value);
			},
			remove_$vizResize: function VizImpl$remove_VizResize(value) {
				this.$1$VizResizeField = ss.delegateRemove(this.$1$VizResizeField, value);
			},
			get_handlerId: function VizImpl$get_HandlerId() {
				return this.$parameters.handlerId;
			},
			set_handlerId: function VizImpl$set_HandlerId(value) {
				this.$parameters.handlerId = value;
			},
			get_iframe: function VizImpl$get_Iframe() {
				return this.$iframe;
			},
			get_instanceId: function VizImpl$get_InstanceId() {
				return this.$instanceId;
			},
			set_instanceId: function VizImpl$set_InstanceId(value) {
				this.$instanceId = value;
			},
			get_$viz: function VizImpl$get_Viz() {
				return this.$viz;
			},
			get_$areTabsHidden: function VizImpl$get_AreTabsHidden() {
				return this.$areTabsHidden;
			},
			get_$isToolbarHidden: function VizImpl$get_IsToolbarHidden() {
				return this.$isToolbarHidden;
			},
			get_$isHidden: function VizImpl$get_IsHidden() {
				return this.$iframe.style.display === 'none';
			},
			get_$parentElement: function VizImpl$get_ParentElement() {
				return this.$parameters.parentElement;
			},
			get_$url: function VizImpl$get_Url() {
				return this.$parameters.get_baseUrl();
			},
			get_$workbook: function VizImpl$get_Workbook() {
				return this.$workbookImpl.get_workbook();
			},
			get__workbookImpl: function VizImpl$get_WorkbookImpl() {
				return this.$workbookImpl;
			},
			get_$areAutomaticUpdatesPaused: function VizImpl$get_AreAutomaticUpdatesPaused() {
				return this.$areAutomaticUpdatesPaused;
			},
			get_$vizSize: function VizImpl$get_VizSize() {
				return this.$vizSize;
			},
			getCurrentUrlAsync: function VizImpl$GetCurrentUrlAsync() {
				var deferred = new tab._Deferred();
				var returnHandler = new (ss.makeGenericType($tab_CommandReturnHandler$1, [String]))('api.GetCurrentUrlCommand', 0, function(result) {
					deferred.resolve(result);
				}, function(remoteError, message) {
					deferred.reject($tab__TableauException.createInternalError(message));
				});
				this._sendCommand(String).call(this, null, returnHandler);
				return deferred.get_promise();
			},
			handleVizListening: function VizImpl$HandleVizListening() {
				this.$enableVisibleRectCommunication();
			},
			handleVizLoad: function VizImpl$HandleVizLoad() {
				if (ss.isNullOrUndefined(this.$workbookImpl)) {
					this.$workbookImpl = new $tab__WorkbookImpl(this, this.$messagingOptions, ss.mkdel(this, function() {
						this.$onWorkbookInteractive(null);
					}));
				}
				else if (!this.$initializingWorkbookImpl) {
					this.$workbookImpl._update(ss.mkdel(this, function() {
						this.$onWorkbookInteractive(null);
					}));
				}
			},
			$calculateFrameSize: function VizImpl$CalculateFrameSize(availableSize) {
				var chromeHeight = this.$vizSize.chromeHeight;
				var sheetSize = this.$vizSize.sheetSize;
				var width = 0;
				var height = 0;
				if (sheetSize.behavior === 'exactly') {
					width = sheetSize.maxSize.width;
					height = sheetSize.maxSize.height + chromeHeight;
				}
				else {
					var minWidth;
					var maxWidth;
					var minHeight;
					var maxHeight;
					switch (sheetSize.behavior) {
						case 'range': {
							minWidth = sheetSize.minSize.width;
							maxWidth = sheetSize.maxSize.width;
							minHeight = sheetSize.minSize.height + chromeHeight;
							maxHeight = sheetSize.maxSize.height + chromeHeight;
							width = Math.max(minWidth, Math.min(maxWidth, availableSize.width));
							height = Math.max(minHeight, Math.min(maxHeight, availableSize.height));
							break;
						}
						case 'atleast': {
							minWidth = sheetSize.minSize.width;
							minHeight = sheetSize.minSize.height + chromeHeight;
							width = Math.max(minWidth, availableSize.width);
							height = Math.max(minHeight, availableSize.height);
							break;
						}
						case 'atmost': {
							maxWidth = sheetSize.maxSize.width;
							maxHeight = sheetSize.maxSize.height + chromeHeight;
							width = Math.min(maxWidth, availableSize.width);
							height = Math.min(maxHeight, availableSize.height);
							break;
						}
						case 'automatic': {
							width = availableSize.width;
							height = Math.max(availableSize.height, chromeHeight);
							break;
						}
						default: {
							throw $tab__TableauException.createInternalError('Unknown SheetSizeBehavior for viz: ' + sheetSize.behavior.toString());
						}
					}
				}
				return $tab_Size.$ctor(width, height);
			},
			$getNewFrameSize: function VizImpl$GetNewFrameSize() {
				var availableSize;
				if (ss.isValue(this.$initialAvailableSize)) {
					availableSize = this.$initialAvailableSize;
					this.$initialAvailableSize = null;
				}
				else {
					availableSize = $tab__Utility.computeContentSize(this.get_$parentElement());
				}
				this.$raiseVizResizeEvent(availableSize);
				return this.$calculateFrameSize(availableSize);
			},
			$refreshSize: function VizImpl$RefreshSize() {
				if (!ss.isValue(this.$vizSize)) {
					return;
				}
				var frameSize = this.$getNewFrameSize();
				this.$setFrameSize(frameSize.width + 'px', frameSize.height + 'px');
				var resizeAttempts = 10;
				for (var i = 0; i < resizeAttempts; i++) {
					var newFrameSize = this.$getNewFrameSize();
					if (ss.referenceEquals(JSON.stringify(frameSize), JSON.stringify(newFrameSize))) {
						return;
					}
					frameSize = newFrameSize;
					this.$setFrameSize(frameSize.width + 'px', frameSize.height + 'px');
				}
				throw $tab__TableauException.create('maxVizResizeAttempts', 'Viz resize limit hit. The calculated iframe size did not stabilize after ' + resizeAttempts + ' resizes.');
			},
			handleEventNotification: function VizImpl$HandleEventNotification(eventName, eventParameters) {
				var notification = $tab__ApiServerNotification.deserialize(eventParameters);
				switch (eventName) {
					case 'api.FirstVizSizeKnownEvent': {
						this.$handleFirstVizSizeKnownEvent(notification);
						break;
					}
					case 'api.VizInteractiveEvent': {
						this.$handleVizInteractiveEvent(notification);
						break;
					}
					case 'api.MarksSelectionChangedEvent': {
						this.$handleMarksSelectionChangedEvent(notification);
						break;
					}
					case 'api.FilterChangedEvent': {
						this.$handleFilterChangedEvent(notification);
						break;
					}
					case 'api.ParameterChangedEvent': {
						this.$handleParameterChangedEvent(notification);
						break;
					}
					case 'api.CustomViewsListLoadedEvent': {
						this.$handleCustomViewsListLoadedEvent(notification);
						break;
					}
					case 'api.CustomViewUpdatedEvent': {
						this.$handleCustomViewUpdatedEvent(notification);
						break;
					}
					case 'api.CustomViewRemovedEvent': {
						this.$handleCustomViewRemovedEvent();
						break;
					}
					case 'api.CustomViewSetDefaultEvent': {
						this.$handleCustomViewSetDefaultEvent(notification);
						break;
					}
					case 'api.TabSwitchEvent': {
						this.$handleTabSwitchEvent(notification);
						break;
					}
					case 'api.StorytellingStateChangedEvent': {
						this.$handleStorytellingStateChangedEvent(notification);
						break;
					}
				}
			},
			addEventListener: function VizImpl$AddEventListener(eventName, handler) {
				var normalizedEventName = {};
				if (!$tab_$PublicEnums.$tryNormalizeEnum($tab_ApiTableauEventName).call(null, eventName, normalizedEventName)) {
					throw $tab__TableauException.createUnsupportedEventName(eventName.toString());
				}
				switch (normalizedEventName.$) {
					case 'marksselection': {
						this.add_$marksSelection(ss.cast(handler, Function));
						break;
					}
					case 'parametervaluechange': {
						this.add_$parameterValueChange(ss.cast(handler, Function));
						break;
					}
					case 'filterchange': {
						this.add_$filterChange(ss.cast(handler, Function));
						break;
					}
					case 'customviewload': {
						this.add_$customViewLoad(ss.cast(handler, Function));
						break;
					}
					case 'customviewsave': {
						this.add_$customViewSave(ss.cast(handler, Function));
						break;
					}
					case 'customviewremove': {
						this.add_$customViewRemove(ss.cast(handler, Function));
						break;
					}
					case 'customviewsetdefault': {
						this.add_$customViewSetDefault(ss.cast(handler, Function));
						break;
					}
					case 'tabswitch': {
						this.add_$tabSwitch(ss.cast(handler, Function));
						break;
					}
					case 'storypointswitch': {
						this.add_$storyPointSwitch(ss.cast(handler, Function));
						break;
					}
					case 'vizresize': {
						this.add_$vizResize(ss.cast(handler, Function));
						break;
					}
				}
			},
			removeEventListener: function VizImpl$RemoveEventListener(eventName, handler) {
				var normalizedEventName = {};
				if (!$tab_$PublicEnums.$tryNormalizeEnum($tab_ApiTableauEventName).call(null, eventName, normalizedEventName)) {
					throw $tab__TableauException.createUnsupportedEventName(eventName.toString());
				}
				switch (normalizedEventName.$) {
					case 'marksselection': {
						this.remove_$marksSelection(ss.cast(handler, Function));
						break;
					}
					case 'parametervaluechange': {
						this.remove_$parameterValueChange(ss.cast(handler, Function));
						break;
					}
					case 'filterchange': {
						this.remove_$filterChange(ss.cast(handler, Function));
						break;
					}
					case 'customviewload': {
						this.remove_$customViewLoad(ss.cast(handler, Function));
						break;
					}
					case 'customviewsave': {
						this.remove_$customViewSave(ss.cast(handler, Function));
						break;
					}
					case 'customviewremove': {
						this.remove_$customViewRemove(ss.cast(handler, Function));
						break;
					}
					case 'customviewsetdefault': {
						this.remove_$customViewSetDefault(ss.cast(handler, Function));
						break;
					}
					case 'tabswitch': {
						this.remove_$tabSwitch(ss.cast(handler, Function));
						break;
					}
					case 'storypointswitch': {
						this.remove_$storyPointSwitch(ss.cast(handler, Function));
						break;
					}
					case 'vizresize': {
						this.remove_$vizResize(ss.cast(handler, Function));
						break;
					}
				}
			},
			$dispose: function VizImpl$Dispose() {
				if (ss.isValue(this.$iframe)) {
					this.$iframe.parentNode.removeChild(this.$iframe);
					this.$iframe = null;
				}
				$tab__VizManagerImpl.$unregisterViz(this.$viz);
				this.$messagingOptions.get_router().unregisterHandler(this);
				this.$removeWindowResizeHandler();
			},
			$show: function VizImpl$Show() {
				this.$iframe.style.display = 'block';
				this.$iframe.style.visibility = 'visible';
			},
			$hide: function VizImpl$Hide() {
				this.$iframe.style.display = 'none';
			},
			$makeInvisible: function VizImpl$MakeInvisible() {
				this.$iframe.style.visibility = 'hidden';
			},
			$showExportImageDialog: function VizImpl$ShowExportImageDialog() {
				this.$invokeCommand('showExportImageDialog');
			},
			$showExportDataDialog: function VizImpl$ShowExportDataDialog(sheetOrInfoOrName) {
				var sheetName = this.$verifyOperationAllowedOnActiveSheetOrSheetWithinActiveDashboard(sheetOrInfoOrName);
				this.$invokeCommand('showExportDataDialog', sheetName);
			},
			$showExportCrossTabDialog: function VizImpl$ShowExportCrossTabDialog(sheetOrInfoOrName) {
				var sheetName = this.$verifyOperationAllowedOnActiveSheetOrSheetWithinActiveDashboard(sheetOrInfoOrName);
				this.$invokeCommand('showExportCrosstabDialog', sheetName);
			},
			$showExportPDFDialog: function VizImpl$ShowExportPDFDialog() {
				this.$invokeCommand('showExportPDFDialog');
			},
			$revertAllAsync: function VizImpl$RevertAllAsync() {
				var deferred = new tab._Deferred();
				var returnHandler = new (ss.makeGenericType($tab_CommandReturnHandler$1, [Object]))('api.RevertAllCommand', 1, function(result) {
					deferred.resolve();
				}, function(remoteError, message) {
					deferred.reject($tab__TableauException.createServerError(message));
				});
				this._sendCommand(Object).call(this, null, returnHandler);
				return deferred.get_promise();
			},
			$refreshDataAsync: function VizImpl$RefreshDataAsync() {
				var deferred = new tab._Deferred();
				var returnHandler = new (ss.makeGenericType($tab_CommandReturnHandler$1, [Object]))('api.RefreshDataCommand', 1, function(result) {
					deferred.resolve();
				}, function(remoteError, message) {
					deferred.reject($tab__TableauException.createServerError(message));
				});
				this._sendCommand(Object).call(this, null, returnHandler);
				return deferred.get_promise();
			},
			$showShareDialog: function VizImpl$ShowShareDialog() {
				this.$invokeCommand('showShareDialog');
			},
			$showDownloadWorkbookDialog: function VizImpl$ShowDownloadWorkbookDialog() {
				if (this.get__workbookImpl().get_isDownloadAllowed()) {
					this.$invokeCommand('showDownloadWorkbookDialog');
				}
				else {
					throw $tab__TableauException.create('downloadWorkbookNotAllowed', 'Download workbook is not allowed');
				}
			},
			$pauseAutomaticUpdatesAsync: function VizImpl$PauseAutomaticUpdatesAsync() {
				return this.$invokeAutomaticUpdatesCommandAsync('pauseAutomaticUpdates');
			},
			$resumeAutomaticUpdatesAsync: function VizImpl$ResumeAutomaticUpdatesAsync() {
				return this.$invokeAutomaticUpdatesCommandAsync('resumeAutomaticUpdates');
			},
			$toggleAutomaticUpdatesAsync: function VizImpl$ToggleAutomaticUpdatesAsync() {
				return this.$invokeAutomaticUpdatesCommandAsync('toggleAutomaticUpdates');
			},
			$setFrameSizeAndUpdate: function VizImpl$SetFrameSizeAndUpdate(width, height) {
				this.$raiseVizResizeEvent($tab_Size.$ctor(-1, -1));
				this.$setFrameSize(width, height);
				this.$workbookImpl._updateActiveSheetAsync();
			},
			$setAreAutomaticUpdatesPaused: function VizImpl$SetAreAutomaticUpdatesPaused(value) {
				this.$areAutomaticUpdatesPaused = value;
			},
			$contentRootElement: function VizImpl$ContentRootElement() {
				return this.$parameters.parentElement;
			},
			$create: function VizImpl$Create() {
				try {
					$tab__VizManagerImpl.$registerViz(this.$viz);
				}
				catch ($t1) {
					var e = ss.Exception.wrap($t1);
					this.$dispose();
					throw e;
				}
				if (!this.$parameters.fixedSize) {
					this.$initialAvailableSize = $tab__Utility.computeContentSize(this.get_$parentElement());
					if (this.$initialAvailableSize.width === 0 || this.$initialAvailableSize.height === 0) {
						this.$initialAvailableSize = $tab_Size.$ctor(800, 600);
					}
					this.$iframe = this.$createIframe();
					this.$makeInvisible();
				}
				else {
					this.$iframe = this.$createIframe();
					this.$show();
				}
				if (!$tab__Utility.hasWindowPostMessage()) {
					if ($tab__Utility.isIE()) {
						this.$iframe['onreadystatechange'] = this.$getOnCheckForDoneDelegate();
					}
					else {
						this.$iframe.onload = this.$getOnCheckForDoneDelegate();
					}
				}
				this.$isToolbarHidden = !this.$parameters.toolbar;
				this.$areTabsHidden = !this.$parameters.tabs;
				this.$messagingOptions.get_router().registerHandler(this);
				this.$iframe.src = this.$parameters.get_url();
			},
			$sendVisibleRect: function VizImpl$SendVisibleRect() {
				try {
					if (!$tab__Utility.hasWindowPostMessage() || ss.isNullOrUndefined(this.$iframe) || !ss.isValue(this.$iframe.contentWindow)) {
						return;
					}
				}
				catch ($t1) {
					return;
				}
				var visibleRect = $tab__Utility.visibleContentRectInDocumentCoordinates(this.get_iframe());
				var iframeContentRect = $tab__Utility.contentRectInDocumentCoordinates(this.get_iframe());
				var param = [];
				param.push('layoutInfoResp'.toString());
				param.push(visibleRect.left - iframeContentRect.left);
				param.push(visibleRect.top - iframeContentRect.top);
				param.push(visibleRect.width);
				param.push(visibleRect.height);
				this.$iframe.contentWindow.postMessage(param.join(','), '*');
			},
			$enableVisibleRectCommunication: function VizImpl$EnableVisibleRectCommunication() {
				if (!$tab__Utility.hasWindowPostMessage() || ss.isNullOrUndefined(this.$iframe) || !ss.isValue(this.$iframe.contentWindow)) {
					return;
				}
				this.$iframe.contentWindow.postMessage('tableau.enableVisibleRectCommunication'.toString(), '*');
			},
			_sendCommand: function(T) {
				return function VizImpl$SendCommand(commandParameters, returnHandler) {
					this.$messagingOptions.sendCommand(T).call(this.$messagingOptions, commandParameters, returnHandler);
				};
			},
			$raiseParameterValueChange: function VizImpl$RaiseParameterValueChange(parameterName) {
				if (!ss.staticEquals(this.$1$ParameterValueChangeField, null)) {
					this.$1$ParameterValueChangeField(new $tab_ParameterEvent('parametervaluechange', this.$viz, parameterName));
				}
			},
			$raiseCustomViewLoad: function VizImpl$RaiseCustomViewLoad(customView) {
				this.get__workbookImpl()._update(ss.mkdel(this, function() {
					if (!ss.staticEquals(this.$1$CustomViewLoadField, null)) {
						this.$1$CustomViewLoadField(new $tab_CustomViewEvent('customviewload', this.$viz, (ss.isValue(customView) ? customView._impl : null)));
					}
				}));
			},
			$raiseCustomViewSave: function VizImpl$RaiseCustomViewSave(customView) {
				this.get__workbookImpl()._update(ss.mkdel(this, function() {
					if (!ss.staticEquals(this.$1$CustomViewSaveField, null)) {
						this.$1$CustomViewSaveField(new $tab_CustomViewEvent('customviewsave', this.$viz, customView._impl));
					}
				}));
			},
			$raiseCustomViewRemove: function VizImpl$RaiseCustomViewRemove(customView) {
				if (!ss.staticEquals(this.$1$CustomViewRemoveField, null)) {
					this.$1$CustomViewRemoveField(new $tab_CustomViewEvent('customviewremove', this.$viz, customView._impl));
				}
			},
			$raiseCustomViewSetDefault: function VizImpl$RaiseCustomViewSetDefault(customView) {
				if (!ss.staticEquals(this.$1$CustomViewSetDefaultField, null)) {
					this.$1$CustomViewSetDefaultField(new $tab_CustomViewEvent('customviewsetdefault', this.$viz, customView._impl));
				}
			},
			$raiseTabSwitch: function VizImpl$RaiseTabSwitch(oldSheetName, newSheetName) {
				if (!ss.staticEquals(this.$1$TabSwitchField, null)) {
					this.$1$TabSwitchField(new $tab_TabSwitchEvent('tabswitch', this.$viz, oldSheetName, newSheetName));
				}
			},
			raiseStoryPointSwitch: function VizImpl$RaiseStoryPointSwitch(oldStoryPointInfo, newStoryPoint) {
				if (!ss.staticEquals(this.$1$StoryPointSwitchField, null)) {
					this.$1$StoryPointSwitchField(new $tab_StoryPointSwitchEvent('storypointswitch', this.$viz, oldStoryPointInfo, newStoryPoint));
				}
			},
			$raiseStateReadyForQuery: function VizImpl$RaiseStateReadyForQuery() {
				if (!ss.staticEquals(this.$1$StateReadyForQueryField, null)) {
					this.$1$StateReadyForQueryField(this);
				}
			},
			$raiseCustomViewsListLoad: function VizImpl$RaiseCustomViewsListLoad() {
				if (!ss.staticEquals(this.$1$CustomViewsListLoadField, null)) {
					this.$1$CustomViewsListLoadField(this);
				}
			},
			$raiseVizResizeEvent: function VizImpl$RaiseVizResizeEvent(availableSize) {
				if (!ss.staticEquals(this.$1$VizResizeField, null)) {
					this.$1$VizResizeField(new $tab_VizResizeEvent('vizresize', this.$viz, availableSize));
				}
			},
			$setFrameSize: function VizImpl$SetFrameSize(width, height) {
				this.$parameters.width = width;
				this.$parameters.height = height;
				this.$iframe.style.width = this.$parameters.width;
				this.$iframe.style.height = this.$parameters.height;
			},
			$verifyOperationAllowedOnActiveSheetOrSheetWithinActiveDashboard: function VizImpl$VerifyOperationAllowedOnActiveSheetOrSheetWithinActiveDashboard(sheetOrInfoOrName) {
				if (ss.isNullOrUndefined(sheetOrInfoOrName)) {
					return null;
				}
				var sheetImpl = this.$workbookImpl.$findActiveSheetOrSheetWithinActiveDashboard(sheetOrInfoOrName);
				if (ss.isNullOrUndefined(sheetImpl)) {
					throw $tab__TableauException.createNotActiveSheet();
				}
				return sheetImpl.get_name();
			},
			$invokeAutomaticUpdatesCommandAsync: function VizImpl$InvokeAutomaticUpdatesCommandAsync(command) {
				if (command !== 'pauseAutomaticUpdates' && command !== 'resumeAutomaticUpdates' && command !== 'toggleAutomaticUpdates') {
					throw $tab__TableauException.createInternalError(null);
				}
				var param = {};
				param['api.invokeCommandName'] = command;
				var deferred = new tab._Deferred();
				var returnHandler = new (ss.makeGenericType($tab_CommandReturnHandler$1, [Object]))('api.InvokeCommandCommand', 0, ss.mkdel(this, function(result) {
					if (ss.isValue(result) && ss.isValue(result.isAutoUpdate)) {
						this.$areAutomaticUpdatesPaused = !result.isAutoUpdate;
					}
					deferred.resolve(this.$areAutomaticUpdatesPaused);
				}), function(remoteError, message) {
					deferred.reject($tab__TableauException.createServerError(message));
				});
				this._sendCommand(Object).call(this, param, returnHandler);
				return deferred.get_promise();
			},
			$invokeCommand: function VizImpl$InvokeCommand(command, sheetName) {
				if (command !== 'showExportImageDialog' && command !== 'showExportDataDialog' && command !== 'showExportCrosstabDialog' && command !== 'showExportPDFDialog' && command !== 'showShareDialog' && command !== 'showDownloadWorkbookDialog') {
					throw $tab__TableauException.createInternalError(null);
				}
				var param = {};
				param['api.invokeCommandName'] = command;
				if (ss.isValue(sheetName)) {
					param['api.invokeCommandParam'] = sheetName;
				}
				var returnHandler = new (ss.makeGenericType($tab_CommandReturnHandler$1, [Object]))('api.InvokeCommandCommand', 0, null, null);
				this._sendCommand(Object).call(this, param, returnHandler);
			},
			$handleFirstVizSizeKnownEvent: function VizImpl$HandleFirstVizSizeKnownEvent(notification) {
				var size = JSON.parse(ss.cast(notification.get_data(), String));
				this.$handleInitialVizSize(size);
			},
			$handleVizInteractiveEvent: function VizImpl$HandleVizInteractiveEvent(notification) {
				if (ss.isValue(this.$workbookImpl) && ss.referenceEquals(this.$workbookImpl.get_name(), notification.get_workbookName())) {
					this.$onWorkbookInteractive(null);
				}
				else {
					this.$raiseStateReadyForQuery();
				}
			},
			$handleMarksSelectionChangedEvent: function VizImpl$HandleMarksSelectionChangedEvent(notification) {
				if (ss.staticEquals(this.$1$MarksSelectionField, null) || !ss.referenceEquals(this.$workbookImpl.get_name(), notification.get_workbookName())) {
					return;
				}
				var worksheetImpl = null;
				var activeSheetImpl = this.$workbookImpl.get_activeSheetImpl();
				if (activeSheetImpl.get_isStory()) {
					activeSheetImpl = ss.cast(activeSheetImpl, $tab__StoryImpl).get_activeStoryPointImpl().get_containedSheetImpl();
				}
				if (ss.referenceEquals(activeSheetImpl.get_name(), notification.get_worksheetName())) {
					worksheetImpl = ss.cast(activeSheetImpl, $tab__WorksheetImpl);
				}
				else if (activeSheetImpl.get_isDashboard()) {
					var dashboardImpl = ss.cast(activeSheetImpl, $tab__DashboardImpl);
					worksheetImpl = dashboardImpl.get_worksheets()._get(notification.get_worksheetName())._impl;
				}
				if (ss.isValue(worksheetImpl)) {
					worksheetImpl.set_selectedMarks(null);
					this.$1$MarksSelectionField(new $tab_MarksEvent('marksselection', this.$viz, worksheetImpl));
				}
			},
			$handleFilterChangedEvent: function VizImpl$HandleFilterChangedEvent(notification) {
				if (!ss.staticEquals(this.$1$FilterChangeField, null)) {
					if (ss.referenceEquals(this.$workbookImpl.get_name(), notification.get_workbookName())) {
						var worksheetImpl = null;
						var activeSheetImpl = this.$workbookImpl.get_activeSheetImpl();
						if (ss.referenceEquals(activeSheetImpl.get_name(), notification.get_worksheetName())) {
							worksheetImpl = ss.cast(activeSheetImpl, $tab__WorksheetImpl);
						}
						else if (activeSheetImpl.get_isDashboard()) {
							var db = ss.cast(activeSheetImpl, $tab__DashboardImpl);
							worksheetImpl = db.get_worksheets()._get(notification.get_worksheetName())._impl;
						}
						if (ss.isValue(worksheetImpl)) {
							var results = ss.cast(JSON.parse(ss.cast(notification.get_data(), String)), Array);
							var filterFieldName = results[0];
							var filterCaption = results[1];
							this.$1$FilterChangeField(new $tab_FilterEvent('filterchange', this.$viz, worksheetImpl, filterFieldName, filterCaption));
						}
					}
				}
			},
			$handleParameterChangedEvent: function VizImpl$HandleParameterChangedEvent(notification) {
				if (!ss.staticEquals(this.$1$ParameterValueChangeField, null)) {
					if (ss.referenceEquals(this.$workbookImpl.get_name(), notification.get_workbookName())) {
						this.$workbookImpl.set_$lastChangedParameterImpl(null);
						var parameterName = ss.cast(notification.get_data(), String);
						this.$raiseParameterValueChange(parameterName);
					}
				}
			},
			$handleCustomViewsListLoadedEvent: function VizImpl$HandleCustomViewsListLoadedEvent(notification) {
				var info = JSON.parse(ss.cast(notification.get_data(), String));
				var process = ss.mkdel(this, function() {
					$tab__CustomViewImpl._processCustomViews(this.$workbookImpl, this.$messagingOptions, info);
				});
				var raiseEvents = ss.mkdel(this, function() {
					this.$raiseCustomViewsListLoad();
					if (!ss.staticEquals(this.$1$CustomViewLoadField, null) && !info.customViewLoaded) {
						this.$raiseCustomViewLoad(this.$workbookImpl.get_activeCustomView());
					}
				});
				if (ss.isNullOrUndefined(this.$workbookImpl)) {
					this.$initializingWorkbookImpl = true;
					this.$workbookImpl = new $tab__WorkbookImpl(this, this.$messagingOptions, ss.mkdel(this, function() {
						process();
						this.$onWorkbookInteractive(raiseEvents);
						this.$initializingWorkbookImpl = false;
					}));
				}
				else {
					process();
					this.$ensureCalledAfterFirstInteractive(raiseEvents);
				}
			},
			$handleCustomViewUpdatedEvent: function VizImpl$HandleCustomViewUpdatedEvent(notification) {
				var info = JSON.parse(ss.cast(notification.get_data(), String));
				if (ss.isNullOrUndefined(this.$workbookImpl)) {
					this.$workbookImpl = new $tab__WorkbookImpl(this, this.$messagingOptions, null);
				}
				if (ss.isValue(this.$workbookImpl)) {
					$tab__CustomViewImpl._processCustomViewUpdate(this.$workbookImpl, this.$messagingOptions, info, true);
				}
				if (!ss.staticEquals(this.$1$CustomViewSaveField, null)) {
					var updated = this.$workbookImpl.get_$updatedCustomViews()._toApiCollection();
					for (var i = 0, len = updated.length; i < len; i++) {
						this.$raiseCustomViewSave(updated[i]);
					}
				}
			},
			$handleCustomViewRemovedEvent: function VizImpl$HandleCustomViewRemovedEvent() {
				if (!ss.staticEquals(this.$1$CustomViewRemoveField, null)) {
					var removed = this.$workbookImpl.get_$removedCustomViews()._toApiCollection();
					for (var i = 0, len = removed.length; i < len; i++) {
						this.$raiseCustomViewRemove(removed[i]);
					}
				}
			},
			$handleCustomViewSetDefaultEvent: function VizImpl$HandleCustomViewSetDefaultEvent(notification) {
				var info = JSON.parse(ss.cast(notification.get_data(), String));
				if (ss.isValue(this.$workbookImpl)) {
					$tab__CustomViewImpl._processCustomViews(this.$workbookImpl, this.$messagingOptions, info);
				}
				if (!ss.staticEquals(this.$1$CustomViewSetDefaultField, null) && ss.isValue(info.defaultCustomViewId)) {
					var views = this.$workbookImpl.get_$customViews();
					for (var i = 0; i < views.get__length(); i++) {
						var view = views.get_item(i);
						if (view.getDefault()) {
							this.$raiseCustomViewSetDefault(view);
							break;
						}
					}
				}
			},
			$handleTabSwitchEvent: function VizImpl$HandleTabSwitchEvent(notification) {
				this.$workbookImpl._update(ss.mkdel(this, function() {
					if (ss.isValue(this.$workbookTabSwitchHandler)) {
						this.$workbookTabSwitchHandler();
					}
					if (ss.referenceEquals(this.$workbookImpl.get_name(), notification.get_workbookName())) {
						var oldSheetName = notification.get_worksheetName();
						var currSheetName = ss.cast(notification.get_data(), String);
						this.$raiseTabSwitch(oldSheetName, currSheetName);
					}
					this.$onWorkbookInteractive(null);
				}));
			},
			$handleStorytellingStateChangedEvent: function VizImpl$HandleStorytellingStateChangedEvent(notification) {
				var storyImpl = ss.cast(this.$workbookImpl.get_activeSheetImpl(), $tab__StoryImpl);
				if (storyImpl.get_sheetType() === 'story') {
					storyImpl.update(JSON.parse(ss.cast(notification.get_data(), String)));
				}
			},
			$onWorkbookInteractive: function VizImpl$OnWorkbookInteractive(actionAfterFirstInteractive) {
				if (!this.$onFirstInteractiveAlreadyCalled) {
					var callback = this.$onFirstInteractiveCallback;
					window.setTimeout(ss.mkdel(this, function() {
						if (!ss.staticEquals(callback, null)) {
							callback(new $tab_TableauEvent('firstinteractive', this.$viz));
						}
						if (!ss.staticEquals(actionAfterFirstInteractive, null)) {
							actionAfterFirstInteractive();
						}
					}), 0);
					this.$onFirstInteractiveAlreadyCalled = true;
				}
				this.$raiseStateReadyForQuery();
			},
			$ensureCalledAfterFirstInteractive: function VizImpl$EnsureCalledAfterFirstInteractive(action) {
				var start = new Date();
				var poll = null;
				poll = ss.mkdel(this, function() {
					var now = new Date();
					if (this.$onFirstInteractiveAlreadyCalled) {
						action();
					}
					else if (now - start > 300000) {
						throw $tab__TableauException.createInternalError('Timed out while waiting for the viz to become interactive');
					}
					else {
						window.setTimeout(poll, 10);
					}
				});
				poll();
			},
			$checkForDone: function VizImpl$CheckForDone() {
				if ($tab__Utility.isIE()) {
					if (this.$iframe['readyState'] === 'complete') {
						this.handleVizLoad();
					}
				}
				else {
					this.handleVizLoad();
				}
			},
			$onCheckForDone: function VizImpl$OnCheckForDone() {
				window.setTimeout(ss.mkdel(this, this.$checkForDone), 3000);
			},
			$createIframe: function VizImpl$CreateIframe() {
				if (ss.isNullOrUndefined(this.$contentRootElement())) {
					return null;
				}
				var $t1 = document.createElement('IFrame');
				var ifr = ss.cast($t1, ss.isValue($t1) && (ss.isInstanceOfType($t1, Element) && $t1.tagName === 'IFRAME'));
				ifr.frameBorder = '0';
				ifr.setAttribute('allowTransparency', 'true');
				ifr.marginHeight = '0';
				ifr.marginWidth = '0';
				ifr.style.display = 'block';
				if (this.$parameters.fixedSize) {
					ifr.style.width = this.$parameters.width;
					ifr.style.height = this.$parameters.height;
				}
				else {
					ifr.style.width = '1px';
					ifr.style.height = '1px';
					ifr.setAttribute('scrolling', 'no');
				}
				if ($tab__Utility.isSafari()) {
					ifr.addEventListener('mousewheel', ss.mkdel(this, this.$onIframeMouseWheel), false);
				}
				this.$contentRootElement().appendChild(ifr);
				return ifr;
			},
			$onIframeMouseWheel: function VizImpl$OnIframeMouseWheel(e) {
			},
			$getOnCheckForDoneDelegate: function VizImpl$GetOnCheckForDoneDelegate() {
				return ss.mkdel(this, function(e) {
					this.$onCheckForDone();
				});
			},
			$handleInitialVizSize: function VizImpl$HandleInitialVizSize(vizAndChromeSize) {
				var sheetSize = $tab_SheetSizeFactory.fromSizeConstraints(vizAndChromeSize.sizeConstraints);
				this.$vizSize = $tab_VizSize.$ctor(sheetSize, vizAndChromeSize.chromeHeight);
				if (ss.isValue(this.$onFirstVizSizeKnownCallback)) {
					this.$onFirstVizSizeKnownCallback(new $tab_FirstVizSizeKnownEvent('firstvizsizeknown', this.$viz, this.$vizSize));
				}
				if (this.$parameters.fixedSize) {
					return;
				}
				this.$refreshSize();
				this.$addWindowResizeHandler();
				this.$show();
			},
			$removeWindowResizeHandler: function VizImpl$RemoveWindowResizeHandler() {
				if (ss.isNullOrUndefined(this.$windowResizeHandler)) {
					return;
				}
				if ($tab__Utility.hasWindowAddEventListener()) {
					window.removeEventListener('resize', this.$windowResizeHandler, false);
				}
				else {
					window.self.detachEvent('onresize', this.$windowResizeHandler);
				}
				this.$windowResizeHandler = null;
			},
			$addWindowResizeHandler: function VizImpl$AddWindowResizeHandler() {
				if (ss.isValue(this.$windowResizeHandler)) {
					return;
				}
				this.$windowResizeHandler = ss.mkdel(this, function() {
					this.$refreshSize();
				});
				if ($tab__Utility.hasWindowAddEventListener()) {
					window.addEventListener('resize', this.$windowResizeHandler, false);
				}
				else {
					window.self.attachEvent('onresize', this.$windowResizeHandler);
				}
			}
		}, null, [$tab_ICrossDomainMessageHandler]);
		ss.initClass($tab_VizResizeEvent, $asm, {
			getAvailableSize: function VizResizeEvent$GetAvailableSize() {
				return this.$availableSize;
			}
		}, $tab_TableauEvent);
		ss.initClass($tab_VizSize, $asm, {}, Object);
		ss.initClass($tableauSoftware_Filter, $asm, {
			getFilterType: function Filter$GetFilterType() {
				return this.$type;
			},
			getFieldName: function Filter$GetFieldName() {
				return this.$caption;
			},
			getWorksheet: function Filter$GetWorksheet() {
				return this.$worksheetImpl.get_worksheet();
			},
			getFieldAsync: function Filter$GetFieldAsync() {
				var deferred = new tab._Deferred();
				if (ss.isNullOrUndefined(this.$field)) {
					var rejected = function(e) {
						deferred.reject(e);
						return null;
					};
					var fulfilled = ss.mkdel(this, function(value) {
						this.$field = new $tableauSoftware_Field(value, this.$caption, this.$fieldRole, this.$fieldAggregation);
						deferred.resolve(this.$field);
						return null;
					});
					this.$worksheetImpl.$getDataSourceAsync(this.$dataSourceName).then(fulfilled, rejected);
				}
				else {
					window.setTimeout(ss.mkdel(this, function() {
						deferred.resolve(this.$field);
					}), 0);
				}
				return deferred.get_promise();
			},
			_update: function Filter$Update(pm) {
				this.$initializeFromJson(pm);
				this._updateFromJson(pm);
			},
			_addFieldParams: function Filter$AddFieldParams(param) {
			},
			_updateFromJson: null,
			$initializeFromJson: function Filter$InitializeFromJson(pm) {
				this.$caption = pm.caption;
				this.$type = $tab_ApiEnumConverter.convertFilterType(pm.filterType);
				this.$field = null;
				this.$dataSourceName = pm.dataSourceName;
				this.$fieldRole = $tab_ApiEnumConverter.convertFieldRole(ss.coalesce(pm.fieldRole, 'unknown'));
				this.$fieldAggregation = $tab_ApiEnumConverter.convertFieldAggregation(ss.coalesce(pm.fieldAggregation, 'NONE'));
			}
		});
		ss.initClass($tableauSoftware_CategoricalFilter, $asm, {
			getIsExcludeMode: function CategoricalFilter$GetIsExcludeMode() {
				return this.$isExclude;
			},
			getAppliedValues: function CategoricalFilter$GetAppliedValues() {
				return this.$appliedValues;
			},
			_updateFromJson: function CategoricalFilter$UpdateFromJson(pm) {
				this.$initializeFromJson$1(pm);
			},
			$initializeFromJson$1: function CategoricalFilter$InitializeFromJson(pm) {
				this.$isExclude = pm.isExclude;
				if (ss.isValue(pm.appliedValues)) {
					this.$appliedValues = [];
					for (var $t1 = 0; $t1 < pm.appliedValues.length; $t1++) {
						var v = pm.appliedValues[$t1];
						this.$appliedValues.push($tab__Utility.getDataValue(v));
					}
				}
			}
		}, $tableauSoftware_Filter);
		ss.initClass($tableauSoftware_CustomView, $asm, {
			getWorkbook: function CustomView$GetWorkbook() {
				return this._impl.get_$workbook();
			},
			getUrl: function CustomView$GetUrl() {
				return this._impl.get_$url();
			},
			getName: function CustomView$GetName() {
				return this._impl.get_$name();
			},
			setName: function CustomView$SetName(value) {
				this._impl.set_$name(value);
			},
			getOwnerName: function CustomView$GetOwnerName() {
				return this._impl.get_$ownerName();
			},
			getAdvertised: function CustomView$GetAdvertised() {
				return this._impl.get_$advertised();
			},
			setAdvertised: function CustomView$SetAdvertised(value) {
				this._impl.set_$advertised(value);
			},
			getDefault: function CustomView$GetDefault() {
				return this._impl.get_$isDefault();
			},
			saveAsync: function CustomView$SaveAsync() {
				return this._impl.$saveAsync();
			}
		});
		ss.initClass($tableauSoftware_Sheet, $asm, {
			getName: function Sheet$GetName() {
				return this._impl.get_name();
			},
			getIndex: function Sheet$GetIndex() {
				return this._impl.get_index();
			},
			getWorkbook: function Sheet$GetWorkbook() {
				return this._impl.get_workbookImpl().get_workbook();
			},
			getSize: function Sheet$GetSize() {
				return this._impl.get_size();
			},
			getIsHidden: function Sheet$GetIsHidden() {
				return this._impl.get_isHidden();
			},
			getIsActive: function Sheet$GetIsActive() {
				return this._impl.get_isActive();
			},
			getSheetType: function Sheet$GetSheetType() {
				return this._impl.get_sheetType();
			},
			getUrl: function Sheet$GetUrl() {
				return this._impl.get_url();
			},
			changeSizeAsync: function Sheet$ChangeSizeAsync(size) {
				return this._impl.changeSizeAsync(size);
			}
		});
		ss.initClass($tableauSoftware_Dashboard, $asm, {
			getParentStoryPoint: function Dashboard$GetParentStoryPoint() {
				return this._impl.get_parentStoryPoint();
			},
			getObjects: function Dashboard$GetObjects() {
				return this._impl.get_objects()._toApiCollection();
			},
			getWorksheets: function Dashboard$GetWorksheets() {
				return this._impl.get_worksheets()._toApiCollection();
			}
		}, $tableauSoftware_Sheet);
		ss.initClass($tableauSoftware_DashboardObject, $asm, {
			getObjectType: function DashboardObject$GetObjectType() {
				return this.$zoneInfo.objectType;
			},
			getDashboard: function DashboardObject$GetDashboard() {
				return this.$dashboard;
			},
			getWorksheet: function DashboardObject$GetWorksheet() {
				return this.$worksheet;
			},
			getPosition: function DashboardObject$GetPosition() {
				return this.$zoneInfo.position;
			},
			getSize: function DashboardObject$GetSize() {
				return this.$zoneInfo.size;
			}
		});
		ss.initClass($tableauSoftware_DataSource, $asm, {
			getName: function DataSource$GetName() {
				return this.$impl.get_name();
			},
			getFields: function DataSource$GetFields() {
				return this.$impl.get_fields()._toApiCollection();
			},
			getIsPrimary: function DataSource$GetIsPrimary() {
				return this.$impl.get_isPrimary();
			}
		});
		ss.initClass($tableauSoftware_Field, $asm, {
			getDataSource: function Field$GetDataSource() {
				return this.$dataSource;
			},
			getName: function Field$GetName() {
				return this.$name;
			},
			getRole: function Field$GetRole() {
				return this.$fieldRoleType;
			},
			getAggregation: function Field$GetAggregation() {
				return this.$fieldAggrType;
			}
		});
		ss.initClass($tableauSoftware_HierarchicalFilter, $asm, {
			_addFieldParams: function HierarchicalFilter$AddFieldParams(param) {
				param['api.filterHierarchicalLevels'] = this.$levels;
			},
			_updateFromJson: function HierarchicalFilter$UpdateFromJson(pm) {
				this.$initializeFromJson$1(pm);
			},
			$initializeFromJson$1: function HierarchicalFilter$InitializeFromJson(pm) {
				this.$levels = pm.levels;
			}
		}, $tableauSoftware_Filter);
		ss.initClass($tableauSoftware_Mark, $asm, {
			getPairs: function Mark$GetPairs() {
				return this.$impl.get_$clonedPairs();
			}
		});
		ss.initClass($tableauSoftware_Pair, $asm, {});
		ss.initClass($tableauSoftware_Parameter, $asm, {
			getName: function Parameter$GetName() {
				return this._impl.get_$name();
			},
			getCurrentValue: function Parameter$GetCurrentValue() {
				return this._impl.get_$currentValue();
			},
			getDataType: function Parameter$GetDataType() {
				return this._impl.get_$dataType();
			},
			getAllowableValuesType: function Parameter$GetAllowableValuesType() {
				return this._impl.get_$allowableValuesType();
			},
			getAllowableValues: function Parameter$GetAllowableValues() {
				return this._impl.get_$allowableValues();
			},
			getMinValue: function Parameter$GetMinValue() {
				return this._impl.get_$minValue();
			},
			getMaxValue: function Parameter$GetMaxValue() {
				return this._impl.get_$maxValue();
			},
			getStepSize: function Parameter$GetStepSize() {
				return this._impl.get_$stepSize();
			},
			getDateStepPeriod: function Parameter$GetDateStepPeriod() {
				return this._impl.get_$dateStepPeriod();
			}
		});
		ss.initClass($tableauSoftware_QuantitativeFilter, $asm, {
			getMin: function QuantitativeFilter$GetMin() {
				return this.$min;
			},
			getMax: function QuantitativeFilter$GetMax() {
				return this.$max;
			},
			getIncludeNullValues: function QuantitativeFilter$GetIncludeNullValues() {
				return this.$includeNullValues;
			},
			getDomainMin: function QuantitativeFilter$GetDomainMin() {
				return this.$domainMin;
			},
			getDomainMax: function QuantitativeFilter$GetDomainMax() {
				return this.$domainMax;
			},
			_updateFromJson: function QuantitativeFilter$UpdateFromJson(pm) {
				this.$initializeFromJson$1(pm);
			},
			$initializeFromJson$1: function QuantitativeFilter$InitializeFromJson(pm) {
				this.$domainMin = $tab__Utility.getDataValue(pm.domainMinValue);
				this.$domainMax = $tab__Utility.getDataValue(pm.domainMaxValue);
				this.$min = $tab__Utility.getDataValue(pm.minValue);
				this.$max = $tab__Utility.getDataValue(pm.maxValue);
				this.$includeNullValues = pm.includeNullValues;
			}
		}, $tableauSoftware_Filter);
		ss.initClass($tableauSoftware_RelativeDateFilter, $asm, {
			getPeriod: function RelativeDateFilter$GetPeriod() {
				return this.$periodType;
			},
			getRange: function RelativeDateFilter$GetRange() {
				return this.$rangeType;
			},
			getRangeN: function RelativeDateFilter$GetRangeN() {
				return this.$rangeN;
			},
			_updateFromJson: function RelativeDateFilter$UpdateFromJson(pm) {
				this.$initializeFromJson$1(pm);
			},
			$initializeFromJson$1: function RelativeDateFilter$InitializeFromJson(pm) {
				if (ss.isValue(pm.periodType)) {
					this.$periodType = $tab_ApiEnumConverter.convertPeriodType(ss.unbox(pm.periodType));
				}
				if (ss.isValue(pm.rangeType)) {
					this.$rangeType = $tab_ApiEnumConverter.convertDateRange(ss.unbox(pm.rangeType));
				}
				if (ss.isValue(pm.rangeN)) {
					this.$rangeN = ss.unbox(pm.rangeN);
				}
			}
		}, $tableauSoftware_Filter);
		ss.initClass($tableauSoftware_SheetInfo, $asm, {
			getName: function ApiSheetInfo$GetName() {
				return this.$impl.name;
			},
			getSheetType: function ApiSheetInfo$GetSheetType() {
				return this.$impl.sheetType;
			},
			getSize: function ApiSheetInfo$GetSize() {
				return this.$impl.size;
			},
			getIndex: function ApiSheetInfo$GetIndex() {
				return this.$impl.index;
			},
			getUrl: function ApiSheetInfo$GetUrl() {
				return this.$impl.url;
			},
			getIsActive: function ApiSheetInfo$GetIsActive() {
				return this.$impl.isActive;
			},
			getIsHidden: function ApiSheetInfo$GetIsHidden() {
				return this.$impl.isHidden;
			},
			getWorkbook: function ApiSheetInfo$GetWorkbook() {
				return this.$impl.workbook;
			}
		});
		ss.initClass($tableauSoftware_Story, $asm, {
			getActiveStoryPoint: function Story$GetActiveStoryPoint() {
				return this._impl.get_activeStoryPointImpl().get_storyPoint();
			},
			getStoryPointsInfo: function Story$GetStoryPointsInfo() {
				return this._impl.get_storyPointsInfo();
			},
			activatePreviousStoryPointAsync: function Story$ActivatePreviousStoryPointAsync() {
				return this._impl.activatePreviousStoryPointAsync();
			},
			activateNextStoryPointAsync: function Story$ActivateNextStoryPointAsync() {
				return this._impl.activateNextStoryPointAsync();
			},
			activateStoryPointAsync: function Story$ActivateStoryPointAsync(index) {
				return this._impl.activateStoryPointAsync(index);
			},
			revertStoryPointAsync: function Story$RevertStoryPointAsync(index) {
				return this._impl.revertStoryPointAsync(index);
			}
		}, $tableauSoftware_Sheet);
		ss.initClass($tableauSoftware_StoryPoint, $asm, {
			getCaption: function StoryPoint$GetCaption() {
				return this.$impl.get_caption();
			},
			getContainedSheet: function StoryPoint$GetContainedSheet() {
				return (ss.isValue(this.$impl.get_containedSheetImpl()) ? this.$impl.get_containedSheetImpl().get_sheet() : null);
			},
			getIndex: function StoryPoint$GetIndex() {
				return this.$impl.get_index();
			},
			getIsActive: function StoryPoint$GetIsActive() {
				return this.$impl.get_isActive();
			},
			getIsUpdated: function StoryPoint$GetIsUpdated() {
				return this.$impl.get_isUpdated();
			},
			getParentStory: function StoryPoint$GetParentStory() {
				return this.$impl.get_parentStoryImpl().get_story();
			}
		});
		ss.initClass($tableauSoftware_StoryPointInfo, $asm, {
			getCaption: function StoryPointInfo$GetCaption() {
				return this._impl.caption;
			},
			getIndex: function StoryPointInfo$GetIndex() {
				return this._impl.index;
			},
			getIsActive: function StoryPointInfo$GetIsActive() {
				return this._impl.isActive;
			},
			getIsUpdated: function StoryPointInfo$GetIsUpdated() {
				return this._impl.isUpdated;
			},
			getParentStory: function StoryPointInfo$GetParentStory() {
				return this._impl.parentStoryImpl.get_story();
			}
		});
		ss.initClass($tableauSoftware_Version, $asm, {
			getMajor: function Version$GetMajor() {
				return this.$major;
			},
			getMinor: function Version$GetMinor() {
				return this.$minor;
			},
			getPatch: function Version$GetPatch() {
				return this.$patch;
			},
			getMetadata: function Version$GetMetadata() {
				return this.$metadata;
			},
			toString: function Version$ToString() {
				var version = this.$major + '.' + this.$minor + '.' + this.$patch;
				if (ss.isValue(this.$metadata) && this.$metadata.length > 0) {
					version += '-' + this.$metadata;
				}
				return version;
			}
		});
		ss.initClass($tableauSoftware_Viz, $asm, {
			getAreTabsHidden: function Viz$GetAreTabsHidden() {
				return this._impl.get_$areTabsHidden();
			},
			getIsToolbarHidden: function Viz$GetIsToolbarHidden() {
				return this._impl.get_$isToolbarHidden();
			},
			getIsHidden: function Viz$GetIsHidden() {
				return this._impl.get_$isHidden();
			},
			getInstanceId: function Viz$GetInstanceId() {
				return this._impl.get_instanceId();
			},
			getParentElement: function Viz$GetParentElement() {
				return this._impl.get_$parentElement();
			},
			getUrl: function Viz$GetUrl() {
				return this._impl.get_$url();
			},
			getVizSize: function Viz$GetVizSize() {
				return this._impl.get_$vizSize();
			},
			getWorkbook: function Viz$GetWorkbook() {
				return this._impl.get_$workbook();
			},
			getAreAutomaticUpdatesPaused: function Viz$GetAreAutomaticUpdatesPaused() {
				return this._impl.get_$areAutomaticUpdatesPaused();
			},
			getCurrentUrlAsync: function Viz$GetCurrentUrlAsync() {
				return this._impl.getCurrentUrlAsync();
			},
			addEventListener: function Viz$AddEventListener(eventName, handler) {
				this._impl.addEventListener(eventName, handler);
			},
			removeEventListener: function Viz$RemoveEventListener(eventName, handler) {
				this._impl.removeEventListener(eventName, handler);
			},
			dispose: function Viz$Dispose() {
				this._impl.$dispose();
			},
			show: function Viz$Show() {
				this._impl.$show();
			},
			hide: function Viz$Hide() {
				this._impl.$hide();
			},
			showExportDataDialog: function Viz$ShowExportDataDialog(worksheetWithinDashboard) {
				this._impl.$showExportDataDialog(worksheetWithinDashboard);
			},
			showExportCrossTabDialog: function Viz$ShowExportCrossTabDialog(worksheetWithinDashboard) {
				this._impl.$showExportCrossTabDialog(worksheetWithinDashboard);
			},
			showExportImageDialog: function Viz$ShowExportImageDialog() {
				this._impl.$showExportImageDialog();
			},
			showExportPDFDialog: function Viz$ShowExportPDFDialog() {
				this._impl.$showExportPDFDialog();
			},
			revertAllAsync: function Viz$RevertAllAsync() {
				return this._impl.$revertAllAsync();
			},
			refreshDataAsync: function Viz$RefreshDataAsync() {
				return this._impl.$refreshDataAsync();
			},
			showShareDialog: function Viz$ShowShareDialog() {
				this._impl.$showShareDialog();
			},
			showDownloadWorkbookDialog: function Viz$ShowDownloadWorkbookDialog() {
				this._impl.$showDownloadWorkbookDialog();
			},
			pauseAutomaticUpdatesAsync: function Viz$PauseAutomaticUpdatesAsync() {
				return this._impl.$pauseAutomaticUpdatesAsync();
			},
			resumeAutomaticUpdatesAsync: function Viz$ResumeAutomaticUpdatesAsync() {
				return this._impl.$resumeAutomaticUpdatesAsync();
			},
			toggleAutomaticUpdatesAsync: function Viz$ToggleAutomaticUpdatesAsync() {
				return this._impl.$toggleAutomaticUpdatesAsync();
			},
			refreshSize: function Viz$RefreshSize() {
				this._impl.$refreshSize();
			},
			setFrameSize: function Viz$SetFrameSize(width, height) {
				var widthString = width;
				var heightString = height;
				if ($tab__Utility.isNumber(width)) {
					widthString = width.toString() + 'px';
				}
				if ($tab__Utility.isNumber(height)) {
					heightString = height.toString() + 'px';
				}
				this._impl.$setFrameSizeAndUpdate(widthString, heightString);
			}
		});
		ss.initClass($tableauSoftware_VizManager, $asm, {});
		ss.initClass($tableauSoftware_Workbook, $asm, {
			getViz: function Workbook$GetViz() {
				return this.$workbookImpl.get_viz();
			},
			getPublishedSheetsInfo: function Workbook$GetPublishedSheetsInfo() {
				return this.$workbookImpl.get_publishedSheets()._toApiCollection();
			},
			getName: function Workbook$GetName() {
				return this.$workbookImpl.get_name();
			},
			getActiveSheet: function Workbook$GetActiveSheet() {
				return this.$workbookImpl.get_activeSheetImpl().get_sheet();
			},
			getActiveCustomView: function Workbook$GetActiveCustomView() {
				return this.$workbookImpl.get_activeCustomView();
			},
			activateSheetAsync: function Workbook$ActivateSheetAsync(sheetNameOrIndex) {
				return this.$workbookImpl._setActiveSheetAsync(sheetNameOrIndex);
			},
			revertAllAsync: function Workbook$RevertAllAsync() {
				return this.$workbookImpl._revertAllAsync();
			},
			getCustomViewsAsync: function Workbook$GetCustomViewsAsync() {
				return this.$workbookImpl.$getCustomViewsAsync();
			},
			showCustomViewAsync: function Workbook$ShowCustomViewAsync(customViewName) {
				return this.$workbookImpl.$showCustomViewAsync(customViewName);
			},
			removeCustomViewAsync: function Workbook$RemoveCustomViewAsync(customViewName) {
				return this.$workbookImpl.$removeCustomViewAsync(customViewName);
			},
			rememberCustomViewAsync: function Workbook$RememberCustomViewAsync(customViewName) {
				return this.$workbookImpl.$rememberCustomViewAsync(customViewName);
			},
			setActiveCustomViewAsDefaultAsync: function Workbook$SetActiveCustomViewAsDefaultAsync() {
				return this.$workbookImpl.$setActiveCustomViewAsDefaultAsync();
			},
			getParametersAsync: function Workbook$GetParametersAsync() {
				return this.$workbookImpl.$getParametersAsync();
			},
			changeParameterValueAsync: function Workbook$ChangeParameterValueAsync(parameterName, value) {
				return this.$workbookImpl.$changeParameterValueAsync(parameterName, value);
			}
		});
		ss.initClass($tableauSoftware_Worksheet, $asm, {
			getParentDashboard: function Worksheet$GetParentDashboard() {
				return this._impl.get_parentDashboard();
			},
			getParentStoryPoint: function Worksheet$GetParentStoryPoint() {
				return this._impl.get_parentStoryPoint();
			},
			getDataSourcesAsync: function Worksheet$GetDataSourcesAsync() {
				return this._impl.$getDataSourcesAsync();
			},
			getFilterAsync: function Worksheet$GetFilterAsync(fieldName, options) {
				return this._impl.$getFilterAsync(null, fieldName, options);
			},
			getFiltersAsync: function Worksheet$GetFiltersAsync(options) {
				return this._impl.$getFiltersAsync(options);
			},
			applyFilterAsync: function Worksheet$ApplyFilterAsync(fieldName, values, updateType, options) {
				return this._impl.$applyFilterAsync(fieldName, values, updateType, options);
			},
			clearFilterAsync: function Worksheet$ClearFilterAsync(fieldName) {
				return this._impl.$clearFilterAsync(fieldName);
			},
			applyRangeFilterAsync: function Worksheet$ApplyRangeFilterAsync(fieldName, options) {
				return this._impl.$applyRangeFilterAsync(fieldName, options);
			},
			applyRelativeDateFilterAsync: function Worksheet$ApplyRelativeDateFilterAsync(fieldName, options) {
				return this._impl.$applyRelativeDateFilterAsync(fieldName, options);
			},
			applyHierarchicalFilterAsync: function Worksheet$ApplyHierarchicalFilterAsync(fieldName, values, updateType, options) {
				return this._impl.$applyHierarchicalFilterAsync(fieldName, values, updateType, options);
			},
			clearSelectedMarksAsync: function Worksheet$ClearSelectedMarksAsync() {
				return this._impl.$clearSelectedMarksAsync();
			},
			selectMarksAsync: function Worksheet$SelectMarksAsync(fieldNameOrFieldValuesMap, valueOrUpdateType, updateType) {
				return this._impl.$selectMarksAsync(fieldNameOrFieldValuesMap, valueOrUpdateType, updateType);
			},
			getSelectedMarksAsync: function Worksheet$GetSelectedMarksAsync() {
				return this._impl.$getSelectedMarksAsync();
			}
		}, $tableauSoftware_Sheet);
		(function() {
			$tab__ApiCommand.crossDomainEventNotificationId = 'xdomainSourceId';
			$tab__ApiCommand.lastRequestMessage = null;
			$tab__ApiCommand.lastResponseMessage = null;
			$tab__ApiCommand.lastClientInfoResponseMessage = null;
			$tab__ApiCommand.$nextCommandId = 0;
		})();
		(function() {
			$tab__jQueryShim.$arrayType = 'array';
			$tab__jQueryShim.$booleanType = 'boolean';
			$tab__jQueryShim.$dateType = 'date';
			$tab__jQueryShim.$functionType = 'function';
			$tab__jQueryShim.$numberType = 'number';
			$tab__jQueryShim.$objectType = 'object';
			$tab__jQueryShim.$regExpType = 'regexp';
			$tab__jQueryShim.$stringType = 'string';
			$tab__jQueryShim.$class2type = ss.mkdict(['[object Boolean]', $tab__jQueryShim.$booleanType, '[object Number]', $tab__jQueryShim.$numberType, '[object String]', $tab__jQueryShim.$stringType, '[object Function]', $tab__jQueryShim.$functionType, '[object Array]', $tab__jQueryShim.$arrayType, '[object Date]', $tab__jQueryShim.$dateType, '[object RegExp]', $tab__jQueryShim.$regExpType, '[object Object]', $tab__jQueryShim.$objectType]);
			$tab__jQueryShim.$trim = ss.cast(String.prototype['trim'], Function);
			$tab__jQueryShim.$toString = ss.cast(Object.prototype['toString'], Function);
			$tab__jQueryShim.$trimLeft = new RegExp('^[\\s\\xA0]+');
			$tab__jQueryShim.$trimRight = new RegExp('[\\s\\xA0]+$');
			$tab__jQueryShim.$rvalidchars = new RegExp('^[\\],:{}\\s]*$');
			$tab__jQueryShim.$rvalidescape = new RegExp('\\\\(?:["\\\\\\/bfnrt]|u[0-9a-fA-F]{4})', 'g');
			$tab__jQueryShim.$rvalidtokens = new RegExp('"[^"\\\\\\n\\r]*"|true|false|null|-?\\d+(?:\\.\\d*)?(?:[eE][+\\-]?\\d+)?', 'g');
			$tab__jQueryShim.$rvalidbraces = new RegExp('(?:^|:|,)(?:\\s*\\[)+', 'g');
		})();
		(function() {
			$tab_JsonUtil.$defaultIndentStr = '\t';
		})();
		(function() {
			$tab__VizManagerImpl.$vizs = [];
		})();
		(function() {
			var ns = global.tableauSoftware;
			ns.DashboardObjectType = { BLANK: 'blank', WORKSHEET: 'worksheet', QUICK_FILTER: 'quickFilter', PARAMETER_CONTROL: 'parameterControl', PAGE_FILTER: 'pageFilter', LEGEND: 'legend', TITLE: 'title', TEXT: 'text', IMAGE: 'image', WEB_PAGE: 'webPage' };
			ns.DateRangeType = { LAST: 'last', LASTN: 'lastn', NEXT: 'next', NEXTN: 'nextn', CURR: 'curr', TODATE: 'todate' };
			ns.ErrorCode = { INTERNAL_ERROR: 'internalError', SERVER_ERROR: 'serverError', INVALID_AGGREGATION_FIELD_NAME: 'invalidAggregationFieldName', INVALID_PARAMETER: 'invalidParameter', INVALID_URL: 'invalidUrl', STALE_DATA_REFERENCE: 'staleDataReference', VIZ_ALREADY_IN_MANAGER: 'vizAlreadyInManager', NO_URL_OR_PARENT_ELEMENT_NOT_FOUND: 'noUrlOrParentElementNotFound', INVALID_FILTER_FIELDNAME: 'invalidFilterFieldName', INVALID_FILTER_FIELDVALUE: 'invalidFilterFieldValue', INVALID_FILTER_FIELDNAME_OR_VALUE: 'invalidFilterFieldNameOrValue', FILTER_CANNOT_BE_PERFORMED: 'filterCannotBePerformed', NOT_ACTIVE_SHEET: 'notActiveSheet', INVALID_CUSTOM_VIEW_NAME: 'invalidCustomViewName', MISSING_RANGEN_FOR_RELATIVE_DATE_FILTERS: 'missingRangeNForRelativeDateFilters', MISSING_MAX_SIZE: 'missingMaxSize', MISSING_MIN_SIZE: 'missingMinSize', MISSING_MINMAX_SIZE: 'missingMinMaxSize', INVALID_SIZE: 'invalidSize', INVALID_SIZE_BEHAVIOR_ON_WORKSHEET: 'invalidSizeBehaviorOnWorksheet', SHEET_NOT_IN_WORKBOOK: 'sheetNotInWorkbook', INDEX_OUT_OF_RANGE: 'indexOutOfRange', DOWNLOAD_WORKBOOK_NOT_ALLOWED: 'downloadWorkbookNotAllowed', NULL_OR_EMPTY_PARAMETER: 'nullOrEmptyParameter', BROWSER_NOT_CAPABLE: 'browserNotCapable', UNSUPPORTED_EVENT_NAME: 'unsupportedEventName', INVALID_DATE_PARAMETER: 'invalidDateParameter', INVALID_SELECTION_FIELDNAME: 'invalidSelectionFieldName', INVALID_SELECTION_VALUE: 'invalidSelectionValue', INVALID_SELECTION_DATE: 'invalidSelectionDate', NO_URL_FOR_HIDDEN_WORKSHEET: 'noUrlForHiddenWorksheet', MAX_VIZ_RESIZE_ATTEMPTS: 'maxVizResizeAttempts' };
			ns.FieldAggregationType = { SUM: 'SUM', AVG: 'AVG', MIN: 'MIN', MAX: 'MAX', STDEV: 'STDEV', STDEVP: 'STDEVP', VAR: 'VAR', VARP: 'VARP', COUNT: 'COUNT', COUNTD: 'COUNTD', MEDIAN: 'MEDIAN', ATTR: 'ATTR', NONE: 'NONE', PERCENTILE: 'PERCENTILE', YEAR: 'YEAR', QTR: 'QTR', MONTH: 'MONTH', DAY: 'DAY', HOUR: 'HOUR', MINUTE: 'MINUTE', SECOND: 'SECOND', WEEK: 'WEEK', WEEKDAY: 'WEEKDAY', MONTHYEAR: 'MONTHYEAR', MDY: 'MDY', END: 'END', TRUNC_YEAR: 'TRUNC_YEAR', TRUNC_QTR: 'TRUNC_QTR', TRUNC_MONTH: 'TRUNC_MONTH', TRUNC_WEEK: 'TRUNC_WEEK', TRUNC_DAY: 'TRUNC_DAY', TRUNC_HOUR: 'TRUNC_HOUR', TRUNC_MINUTE: 'TRUNC_MINUTE', TRUNC_SECOND: 'TRUNC_SECOND', QUART1: 'QUART1', QUART3: 'QUART3', SKEWNESS: 'SKEWNESS', KURTOSIS: 'KURTOSIS', INOUT: 'INOUT', SUM_XSQR: 'SUM_XSQR', USER: 'USER' };
			ns.FieldRoleType = { DIMENSION: 'dimension', MEASURE: 'measure', UNKNOWN: 'unknown' };
			ns.FilterUpdateType = { ALL: 'all', REPLACE: 'replace', ADD: 'add', REMOVE: 'remove' };
			ns.FilterType = { CATEGORICAL: 'categorical', QUANTITATIVE: 'quantitative', HIERARCHICAL: 'hierarchical', RELATIVEDATE: 'relativedate' };
			ns.NullOption = { NULL_VALUES: 'nullValues', NON_NULL_VALUES: 'nonNullValues', ALL_VALUES: 'allValues' };
			ns.ParameterAllowableValuesType = { ALL: 'all', LIST: 'list', RANGE: 'range' };
			ns.ParameterDataType = { FLOAT: 'float', INTEGER: 'integer', STRING: 'string', BOOLEAN: 'boolean', DATE: 'date', DATETIME: 'datetime' };
			ns.PeriodType = { YEAR: 'year', QUARTER: 'quarter', MONTH: 'month', WEEK: 'week', DAY: 'day', HOUR: 'hour', MINUTE: 'minute', SECOND: 'second' };
			ns.SelectionUpdateType = { REPLACE: 'replace', ADD: 'add', REMOVE: 'remove' };
			ns.SheetSizeBehavior = { AUTOMATIC: 'automatic', EXACTLY: 'exactly', RANGE: 'range', ATLEAST: 'atleast', ATMOST: 'atmost' };
			ns.SheetType = { WORKSHEET: 'worksheet', DASHBOARD: 'dashboard', STORY: 'story' };
			ns.TableauEventName = { CUSTOM_VIEW_LOAD: 'customviewload', CUSTOM_VIEW_REMOVE: 'customviewremove', CUSTOM_VIEW_SAVE: 'customviewsave', CUSTOM_VIEW_SET_DEFAULT: 'customviewsetdefault', FILTER_CHANGE: 'filterchange', FIRST_INTERACTIVE: 'firstinteractive', FIRST_VIZ_SIZE_KNOWN: 'firstvizsizeknown', MARKS_SELECTION: 'marksselection', PARAMETER_VALUE_CHANGE: 'parametervaluechange', STORY_POINT_SWITCH: 'storypointswitch', TAB_SWITCH: 'tabswitch', VIZ_RESIZE: 'vizresize' };
			ns.ToolbarPosition = { TOP: 'top', BOTTOM: 'bottom' };
		})();
		(function() {
			$tab__ApiObjectRegistry.$creationRegistry = null;
			$tab__ApiObjectRegistry.$singletonInstanceRegistry = null;
		})();
		(function() {
			$tab__SheetImpl.noZoneId = 4294967295;
		})();
		(function() {
			$tab__WorksheetImpl.$regexHierarchicalFieldName = new RegExp('\\[[^\\]]+\\]\\.', 'g');
		})();
		(function() {
			$tableauSoftware_Version.$currentVersion = new $tableauSoftware_Version(2, 0, 3, 'null');
		})();
	})();
	
	tableauSoftware = global.tableauSoftware;
	tableauSoftware.Promise = tab._PromiseImpl;
	tab._Deferred = tab._DeferredImpl;
	tab._Collection = tab._CollectionImpl;
	
	tab._ApiBootstrap.initialize();
	})();
	module.exports = global.tableauSoftware;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(19)
	  , toLength  = __webpack_require__(10)
	  , toIndex   = __webpack_require__(45);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(3)
	  , $export           = __webpack_require__(1)
	  , redefine          = __webpack_require__(17)
	  , redefineAll       = __webpack_require__(43)
	  , meta              = __webpack_require__(35)
	  , forOf             = __webpack_require__(49)
	  , anInstance        = __webpack_require__(38)
	  , isObject          = __webpack_require__(5)
	  , fails             = __webpack_require__(4)
	  , $iterDetect       = __webpack_require__(64)
	  , setToStringTag    = __webpack_require__(51)
	  , inheritIfRequired = __webpack_require__(82);
	
	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  var fixMethod = function(KEY){
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a){
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance             = new C
	      // early implementations not supports chaining
	      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
	      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
	      // most early implementations doesn't supports iterables, most modern - not close it correctly
	      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
	      // for early implementations -0 and +0 not the same
	      , BUGGY_ZERO = !IS_WEAK && fails(function(){
	        // V8 ~ Chromium 42- fails only with 5+ elements
	        var $instance = new C()
	          , index     = 5;
	        while(index--)$instance[ADDER](index, index);
	        return !$instance.has(-0);
	      });
	    if(!ACCEPT_ITERABLES){ 
	      C = wrapper(function(target, iterable){
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base, target, C);
	        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if(IS_WEAK && proto.clear)delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hide     = __webpack_require__(16)
	  , redefine = __webpack_require__(17)
	  , fails    = __webpack_require__(4)
	  , defined  = __webpack_require__(23)
	  , wks      = __webpack_require__(6);
	
	module.exports = function(KEY, length, exec){
	  var SYMBOL   = wks(KEY)
	    , fns      = exec(defined, SYMBOL, ''[KEY])
	    , strfn    = fns[0]
	    , rxfn     = fns[1];
	  if(fails(function(){
	    var O = {};
	    O[SYMBOL] = function(){ return 7; };
	    return ''[KEY](O) != 7;
	  })){
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function(string, arg){ return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function(string){ return rxfn.call(string, this); }
	    );
	  }
	};

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(2);
	module.exports = function(){
	  var that   = anObject(this)
	    , result = '';
	  if(that.global)     result += 'g';
	  if(that.ignoreCase) result += 'i';
	  if(that.multiline)  result += 'm';
	  if(that.unicode)    result += 'u';
	  if(that.sticky)     result += 'y';
	  return result;
	};

/***/ },
/* 62 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(5)
	  , cof      = __webpack_require__(22)
	  , MATCH    = __webpack_require__(6)('match');
	module.exports = function(it){
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(6)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(39)|| !__webpack_require__(4)(function(){
	  var K = Math.random();
	  // In FF throws only define methods
	  __defineSetter__.call(null, K, function(){ /* empty */});
	  delete __webpack_require__(3)[K];
	});

/***/ },
/* 66 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(3)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(3)
	  , hide   = __webpack_require__(16)
	  , uid    = __webpack_require__(46)
	  , TYPED  = uid('typed_array')
	  , VIEW   = uid('view')
	  , ABV    = !!(global.ArrayBuffer && global.DataView)
	  , CONSTR = ABV
	  , i = 0, l = 9, Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while(i < l){
	  if(Typed = global[TypedArrayConstructors[i++]]){
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV:    ABV,
	  CONSTR: CONSTR,
	  TYPED:  TYPED,
	  VIEW:   VIEW
	};

/***/ },
/* 69 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (target) {
	  for (var i = 1, j = arguments.length; i < j; i++) {
	    var source = arguments[i] || {};
	    for (var prop in source) {
	      if (source.hasOwnProperty(prop)) {
	        var value = source[prop];
	        if (value !== undefined) {
	          target[prop] = value;
	        }
	      }
	    }
	  }
	
	  return target;
	};
	
	;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(13);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function type(rule, value, callback, source, options) {
	  var ruleType = rule.type;
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value, ruleType) && !rule.required) {
	      return callback();
	    }
	    _rule2["default"].required(rule, value, source, errors, options, ruleType);
	    if (!(0, _util.isEmptyValue)(value, ruleType)) {
	      _rule2["default"].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports["default"] = type;
	module.exports = exports['default'];

/***/ },
/* 71 */,
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(73)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 73 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 74 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 75 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(12)
	  , toIndex  = __webpack_require__(45)
	  , toLength = __webpack_require__(10);
	module.exports = function fill(value /*, start = 0, end = @length */){
	  var O      = toObject(this)
	    , length = toLength(O.length)
	    , aLen   = arguments.length
	    , index  = toIndex(aLen > 1 ? arguments[1] : undefined, length)
	    , end    = aLen > 2 ? arguments[2] : undefined
	    , endPos = end === undefined ? length : toIndex(end, length);
	  while(endPos > index)O[index++] = value;
	  return O;
	};

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(8)
	  , createDesc      = __webpack_require__(36);
	
	module.exports = function(object, index, value){
	  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(5)
	  , document = __webpack_require__(3).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 79 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(6)('match');
	module.exports = function(KEY){
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch(e){
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch(f){ /* empty */ }
	  } return true;
	};

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(3).document && document.documentElement;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var isObject       = __webpack_require__(5)
	  , setPrototypeOf = __webpack_require__(90).set;
	module.exports = function(that, target, C){
	  var P, S = target.constructor;
	  if(S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf){
	    setPrototypeOf(that, P);
	  } return that;
	};

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(50)
	  , ITERATOR   = __webpack_require__(6)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(22);
	module.exports = Array.isArray || function isArray(arg){
	  return cof(arg) == 'Array';
	};

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create         = __webpack_require__(40)
	  , descriptor     = __webpack_require__(36)
	  , setToStringTag = __webpack_require__(51)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(16)(IteratorPrototype, __webpack_require__(6)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(39)
	  , $export        = __webpack_require__(1)
	  , redefine       = __webpack_require__(17)
	  , hide           = __webpack_require__(16)
	  , has            = __webpack_require__(14)
	  , Iterators      = __webpack_require__(50)
	  , $iterCreate    = __webpack_require__(85)
	  , setToStringTag = __webpack_require__(51)
	  , getPrototypeOf = __webpack_require__(21)
	  , ITERATOR       = __webpack_require__(6)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },
/* 87 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x){
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;

/***/ },
/* 88 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x){
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(3)
	  , macrotask = __webpack_require__(97).set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__(22)(process) == 'process';
	
	module.exports = function(){
	  var head, last, notify;
	
	  var flush = function(){
	    var parent, fn;
	    if(isNode && (parent = process.domain))parent.exit();
	    while(head){
	      fn   = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch(e){
	        if(head)notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if(parent)parent.enter();
	  };
	
	  // Node.js
	  if(isNode){
	    notify = function(){
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver
	  } else if(Observer){
	    var toggle = true
	      , node   = document.createTextNode('');
	    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	    notify = function(){
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if(Promise && Promise.resolve){
	    var promise = Promise.resolve();
	    notify = function(){
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function(){
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function(fn){
	    var task = {fn: fn, next: undefined};
	    if(last)last.next = task;
	    if(!head){
	      head = task;
	      notify();
	    } last = task;
	  };
	};

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(5)
	  , anObject = __webpack_require__(2);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(30)(Function.call, __webpack_require__(20).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(67)('keys')
	  , uid    = __webpack_require__(46);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__(2)
	  , aFunction = __webpack_require__(15)
	  , SPECIES   = __webpack_require__(6)('species');
	module.exports = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(37)
	  , defined   = __webpack_require__(23);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(63)
	  , defined  = __webpack_require__(23);
	
	module.exports = function(that, searchString, NAME){
	  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(37)
	  , defined   = __webpack_require__(23);
	
	module.exports = function repeat(count){
	  var str = String(defined(this))
	    , res = ''
	    , n   = toInteger(count);
	  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
	  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
	  return res;
	};

/***/ },
/* 96 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	var ctx                = __webpack_require__(30)
	  , invoke             = __webpack_require__(62)
	  , html               = __webpack_require__(81)
	  , cel                = __webpack_require__(78)
	  , global             = __webpack_require__(3)
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__(22)(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global         = __webpack_require__(3)
	  , DESCRIPTORS    = __webpack_require__(7)
	  , LIBRARY        = __webpack_require__(39)
	  , $typed         = __webpack_require__(68)
	  , hide           = __webpack_require__(16)
	  , redefineAll    = __webpack_require__(43)
	  , fails          = __webpack_require__(4)
	  , anInstance     = __webpack_require__(38)
	  , toInteger      = __webpack_require__(37)
	  , toLength       = __webpack_require__(10)
	  , gOPN           = __webpack_require__(41).f
	  , dP             = __webpack_require__(8).f
	  , arrayFill      = __webpack_require__(76)
	  , setToStringTag = __webpack_require__(51)
	  , ARRAY_BUFFER   = 'ArrayBuffer'
	  , DATA_VIEW      = 'DataView'
	  , PROTOTYPE      = 'prototype'
	  , WRONG_LENGTH   = 'Wrong length!'
	  , WRONG_INDEX    = 'Wrong index!'
	  , $ArrayBuffer   = global[ARRAY_BUFFER]
	  , $DataView      = global[DATA_VIEW]
	  , Math           = global.Math
	  , RangeError     = global.RangeError
	  , Infinity       = global.Infinity
	  , BaseBuffer     = $ArrayBuffer
	  , abs            = Math.abs
	  , pow            = Math.pow
	  , floor          = Math.floor
	  , log            = Math.log
	  , LN2            = Math.LN2
	  , BUFFER         = 'buffer'
	  , BYTE_LENGTH    = 'byteLength'
	  , BYTE_OFFSET    = 'byteOffset'
	  , $BUFFER        = DESCRIPTORS ? '_b' : BUFFER
	  , $LENGTH        = DESCRIPTORS ? '_l' : BYTE_LENGTH
	  , $OFFSET        = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	var packIEEE754 = function(value, mLen, nBytes){
	  var buffer = Array(nBytes)
	    , eLen   = nBytes * 8 - mLen - 1
	    , eMax   = (1 << eLen) - 1
	    , eBias  = eMax >> 1
	    , rt     = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0
	    , i      = 0
	    , s      = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0
	    , e, m, c;
	  value = abs(value)
	  if(value != value || value === Infinity){
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if(value * (c = pow(2, -e)) < 1){
	      e--;
	      c *= 2;
	    }
	    if(e + eBias >= 1){
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if(value * c >= 2){
	      e++;
	      c /= 2;
	    }
	    if(e + eBias >= eMax){
	      m = 0;
	      e = eMax;
	    } else if(e + eBias >= 1){
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	};
	var unpackIEEE754 = function(buffer, mLen, nBytes){
	  var eLen  = nBytes * 8 - mLen - 1
	    , eMax  = (1 << eLen) - 1
	    , eBias = eMax >> 1
	    , nBits = eLen - 7
	    , i     = nBytes - 1
	    , s     = buffer[i--]
	    , e     = s & 127
	    , m;
	  s >>= 7;
	  for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if(e === 0){
	    e = 1 - eBias;
	  } else if(e === eMax){
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	};
	
	var unpackI32 = function(bytes){
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	};
	var packI8 = function(it){
	  return [it & 0xff];
	};
	var packI16 = function(it){
	  return [it & 0xff, it >> 8 & 0xff];
	};
	var packI32 = function(it){
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	};
	var packF64 = function(it){
	  return packIEEE754(it, 52, 8);
	};
	var packF32 = function(it){
	  return packIEEE754(it, 23, 4);
	};
	
	var addGetter = function(C, key, internal){
	  dP(C[PROTOTYPE], key, {get: function(){ return this[internal]; }});
	};
	
	var get = function(view, bytes, index, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	};
	var set = function(view, bytes, index, conversion, value, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = conversion(+value);
	  for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	};
	
	var validateArrayBufferArguments = function(that, length){
	  anInstance(that, $ArrayBuffer, ARRAY_BUFFER);
	  var numberLength = +length
	    , byteLength   = toLength(numberLength);
	  if(numberLength != byteLength)throw RangeError(WRONG_LENGTH);
	  return byteLength;
	};
	
	if(!$typed.ABV){
	  $ArrayBuffer = function ArrayBuffer(length){
	    var byteLength = validateArrayBufferArguments(this, length);
	    this._b       = arrayFill.call(Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength){
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH]
	      , offset       = toInteger(byteOffset);
	    if(offset < 0 || offset > bufferLength)throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if(offset + byteLength > bufferLength)throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if(DESCRIPTORS){
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset){
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset){
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /*, littleEndian */){
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if(!fails(function(){
	    new $ArrayBuffer;     // eslint-disable-line no-new
	  }) || !fails(function(){
	    new $ArrayBuffer(.5); // eslint-disable-line no-new
	  })){
	    $ArrayBuffer = function ArrayBuffer(length){
	      return new BaseBuffer(validateArrayBufferArguments(this, length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for(var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j; ){
	      if(!((key = keys[j++]) in $ArrayBuffer))hide($ArrayBuffer, key, BaseBuffer[key]);
	    };
	    if(!LIBRARY)ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2))
	    , $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if(view.getInt8(0) || !view.getInt8(1))redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var global         = __webpack_require__(3)
	  , core           = __webpack_require__(29)
	  , LIBRARY        = __webpack_require__(39)
	  , wksExt         = __webpack_require__(137)
	  , defineProperty = __webpack_require__(8).f;
	module.exports = function(name){
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
	};

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(54)
	  , ITERATOR  = __webpack_require__(6)('iterator')
	  , Iterators = __webpack_require__(50);
	module.exports = __webpack_require__(29).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(48)
	  , step             = __webpack_require__(125)
	  , Iterators        = __webpack_require__(50)
	  , toIObject        = __webpack_require__(19);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(86)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(133);
	
	
	/***/ },
	
	/***/ 13:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(53);
	
	/***/ },
	
	/***/ 133:
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _input = __webpack_require__(134);
	
		var _input2 = _interopRequireDefault(_input);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_input2.default.install = function (Vue) {
		  Vue.component(_input2.default.name, _input2.default);
		};
	
		exports.default = _input2.default;
	
	/***/ },
	
	/***/ 134:
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(135)
	
		/* template */
		var __vue_template__ = __webpack_require__(138)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	
	/***/ 135:
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _emitter = __webpack_require__(13);
	
		var _emitter2 = _interopRequireDefault(_emitter);
	
		var _calcTextareaHeight = __webpack_require__(136);
	
		var _calcTextareaHeight2 = _interopRequireDefault(_calcTextareaHeight);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  name: 'ElInput',
	
		  componentName: 'ElInput',
	
		  mixins: [_emitter2.default],
	
		  data: function data() {
		    return {
		      currentValue: this.value,
		      textareaStyle: {}
		    };
		  },
	
	
		  props: {
		    value: [String, Number],
		    placeholder: String,
		    size: String,
		    resize: String,
		    readonly: Boolean,
		    autofocus: Boolean,
		    icon: String,
		    disabled: Boolean,
		    type: {
		      type: String,
		      default: 'text'
		    },
		    name: String,
		    autosize: {
		      type: [Boolean, Object],
		      default: false
		    },
		    rows: {
		      type: Number,
		      default: 2
		    },
		    autoComplete: {
		      type: String,
		      default: 'off'
		    },
		    form: String,
		    maxlength: Number,
		    minlength: Number,
		    max: {},
		    min: {},
		    validateEvent: {
		      type: Boolean,
		      default: true
		    },
		    onIconClick: Function
		  },
	
		  computed: {
		    validating: function validating() {
		      return this.$parent.validateState === 'validating';
		    }
		  },
	
		  watch: {
		    'value': function value(val, oldValue) {
		      this.setCurrentValue(val);
		    }
		  },
	
		  methods: {
		    handleBlur: function handleBlur(event) {
		      this.$emit('blur', event);
		      if (this.validateEvent) {
		        this.dispatch('ElFormItem', 'el.form.blur', [this.currentValue]);
		      }
		    },
		    inputSelect: function inputSelect() {
		      this.$refs.input.select();
		    },
		    resizeTextarea: function resizeTextarea() {
		      if (this.$isServer) return;
		      var autosize = this.autosize,
		          type = this.type;
	
		      if (!autosize || type !== 'textarea') return;
		      var minRows = autosize.minRows;
		      var maxRows = autosize.maxRows;
	
		      var options = {
		        resize: this.resize
		      };
		      this.textareaStyle = (0, _calcTextareaHeight2.default)(this.$refs.textarea, minRows, maxRows, options);
		    },
		    handleFocus: function handleFocus(event) {
		      this.$emit('focus', event);
		    },
		    handleInput: function handleInput(event) {
		      this.setCurrentValue(event.target.value);
		    },
		    handleIconClick: function handleIconClick(event) {
		      if (this.onIconClick) {
		        this.onIconClick(event);
		      }
		      this.$emit('click', event);
		    },
		    setCurrentValue: function setCurrentValue(value) {
		      var _this = this;
	
		      if (value === this.currentValue) return;
		      this.$nextTick(function (_) {
		        _this.resizeTextarea();
		      });
		      this.currentValue = value;
		      this.$emit('input', value);
		      this.$emit('change', value);
		      if (this.validateEvent) {
		        this.dispatch('ElFormItem', 'el.form.change', [value]);
		      }
		    }
		  },
	
		  created: function created() {
		    this.$on('inputSelect', this.inputSelect);
		  },
		  mounted: function mounted() {
		    this.resizeTextarea();
		  }
		};
	
	/***/ },
	
	/***/ 136:
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.default = calcTextareaHeight;
	
		var _merge = __webpack_require__(137);
	
		var _merge2 = _interopRequireDefault(_merge);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var hiddenTextarea = void 0;
	
		var HIDDEN_STYLE = '\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n';
	
		var CONTEXT_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];
	
		function calculateNodeStyling(node) {
		  var style = window.getComputedStyle(node);
	
		  var boxSizing = style.getPropertyValue('box-sizing');
	
		  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
	
		  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
	
		  var contextStyle = CONTEXT_STYLE.map(function (name) {
		    return name + ':' + style.getPropertyValue(name);
		  }).join(';');
	
		  return { contextStyle: contextStyle, paddingSize: paddingSize, borderSize: borderSize, boxSizing: boxSizing };
		}
	
		function calcTextareaHeight(targetNode) {
		  var minRows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
		  var maxRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
		  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
		  if (!hiddenTextarea) {
		    hiddenTextarea = document.createElement('textarea');
		    document.body.appendChild(hiddenTextarea);
		  }
	
		  var _calculateNodeStyling = calculateNodeStyling(targetNode),
		      paddingSize = _calculateNodeStyling.paddingSize,
		      borderSize = _calculateNodeStyling.borderSize,
		      boxSizing = _calculateNodeStyling.boxSizing,
		      contextStyle = _calculateNodeStyling.contextStyle;
	
		  hiddenTextarea.setAttribute('style', contextStyle + ';' + HIDDEN_STYLE);
		  hiddenTextarea.value = targetNode.value || targetNode.placeholder || '';
	
		  var height = hiddenTextarea.scrollHeight;
	
		  if (boxSizing === 'border-box') {
		    height = height + borderSize;
		  } else if (boxSizing === 'content-box') {
		    height = height - paddingSize;
		  }
	
		  hiddenTextarea.value = '';
		  var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
	
		  if (minRows !== null) {
		    var minHeight = singleRowHeight * minRows;
		    if (boxSizing === 'border-box') {
		      minHeight = minHeight + paddingSize + borderSize;
		    }
		    height = Math.max(minHeight, height);
		  }
		  if (maxRows !== null) {
		    var maxHeight = singleRowHeight * maxRows;
		    if (boxSizing === 'border-box') {
		      maxHeight = maxHeight + paddingSize + borderSize;
		    }
		    height = Math.min(maxHeight, height);
		  }
	
		  return (0, _merge2.default)({ height: height + 'px' }, options);
		};
	
	/***/ },
	
	/***/ 137:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(69);
	
	/***/ },
	
	/***/ 138:
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    class: [
		      _vm.type === 'textarea' ? 'el-textarea' : 'el-input',
		      _vm.size ? 'el-input--' + _vm.size : '', {
		        'is-disabled': _vm.disabled,
		        'el-input-group': _vm.$slots.prepend || _vm.$slots.append,
		        'el-input-group--append': _vm.$slots.append,
		        'el-input-group--prepend': _vm.$slots.prepend
		      }
		    ]
		  }, [(_vm.type !== 'textarea') ? [(_vm.$slots.prepend) ? _c('div', {
		    staticClass: "el-input-group__prepend"
		  }, [_vm._t("prepend")], 2) : _vm._e(), _vm._t("icon", [(_vm.icon) ? _c('i', {
		    staticClass: "el-input__icon",
		    class: [
		      'el-icon-' + _vm.icon,
		      _vm.onIconClick ? 'is-clickable' : ''
		    ],
		    on: {
		      "click": _vm.handleIconClick
		    }
		  }) : _vm._e()]), (_vm.type !== 'textarea') ? _c('input', {
		    ref: "input",
		    staticClass: "el-input__inner",
		    attrs: {
		      "type": _vm.type,
		      "name": _vm.name,
		      "placeholder": _vm.placeholder,
		      "disabled": _vm.disabled,
		      "readonly": _vm.readonly,
		      "maxlength": _vm.maxlength,
		      "minlength": _vm.minlength,
		      "autocomplete": _vm.autoComplete,
		      "autofocus": _vm.autofocus,
		      "min": _vm.min,
		      "max": _vm.max,
		      "form": _vm.form
		    },
		    domProps: {
		      "value": _vm.currentValue
		    },
		    on: {
		      "input": _vm.handleInput,
		      "focus": _vm.handleFocus,
		      "blur": _vm.handleBlur
		    }
		  }) : _vm._e(), (_vm.validating) ? _c('i', {
		    staticClass: "el-input__icon el-icon-loading"
		  }) : _vm._e(), (_vm.$slots.append) ? _c('div', {
		    staticClass: "el-input-group__append"
		  }, [_vm._t("append")], 2) : _vm._e()] : _c('textarea', {
		    ref: "textarea",
		    staticClass: "el-textarea__inner",
		    style: (_vm.textareaStyle),
		    attrs: {
		      "name": _vm.name,
		      "placeholder": _vm.placeholder,
		      "disabled": _vm.disabled,
		      "readonly": _vm.readonly,
		      "rows": _vm.rows,
		      "form": _vm.form,
		      "autofocus": _vm.autofocus,
		      "maxlength": _vm.maxlength,
		      "minlength": _vm.minlength
		    },
		    domProps: {
		      "value": _vm.currentValue
		    },
		    on: {
		      "input": _vm.handleInput,
		      "focus": _vm.handleFocus,
		      "blur": _vm.handleBlur
		    }
		  })], 2)
		},staticRenderFns: []}
	
	/***/ }
	
	/******/ });

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.i18n = exports.use = exports.t = undefined;
	
	var _zhCN = __webpack_require__(413);
	
	var _zhCN2 = _interopRequireDefault(_zhCN);
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _deepmerge = __webpack_require__(404);
	
	var _deepmerge2 = _interopRequireDefault(_deepmerge);
	
	var _format = __webpack_require__(411);
	
	var _format2 = _interopRequireDefault(_format);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var format = (0, _format2.default)(_vue2.default);
	var lang = _zhCN2.default;
	var merged = false;
	var i18nHandler = function i18nHandler() {
	  var vuei18n = Object.getPrototypeOf(this || _vue2.default).$t;
	  if (typeof vuei18n === 'function') {
	    if (!merged) {
	      merged = true;
	      _vue2.default.locale(_vue2.default.config.lang, (0, _deepmerge2.default)(lang, _vue2.default.locale(_vue2.default.config.lang) || {}, { clone: true }));
	    }
	    return vuei18n.apply(this, arguments);
	  }
	};
	
	var t = exports.t = function t(path, options) {
	  var value = i18nHandler.apply(this, arguments);
	  if (value !== null && value !== undefined) return value;
	
	  var array = path.split('.');
	  var current = lang;
	
	  for (var i = 0, j = array.length; i < j; i++) {
	    var property = array[i];
	    value = current[property];
	    if (i === j - 1) return format(value, options);
	    if (!value) return '';
	    current = value;
	  }
	  return '';
	};
	
	var use = exports.use = function use(l) {
	  lang = l || lang;
	};
	
	var i18n = exports.i18n = function i18n(fn) {
	  i18nHandler = fn || i18nHandler;
	};
	
	exports.default = { use: use, t: t, i18n: i18n };

/***/ },
/* 104 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	* Modified from https://github.com/sdecima/javascript-detect-element-resize
	*
	* version: 0.5.3
	**/
	var isServer = typeof window === 'undefined';
	
	/* istanbul ignore next */
	var requestFrame = function () {
	  if (isServer) return;
	  var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function (fn) {
	    return window.setTimeout(fn, 20);
	  };
	  return function (fn) {
	    return raf(fn);
	  };
	}();
	
	/* istanbul ignore next */
	var cancelFrame = function () {
	  if (isServer) return;
	  var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.clearTimeout;
	  return function (id) {
	    return cancel(id);
	  };
	}();
	
	/* istanbul ignore next */
	var resetTrigger = function resetTrigger(element) {
	  var trigger = element.__resizeTrigger__;
	  var expand = trigger.firstElementChild;
	  var contract = trigger.lastElementChild;
	  var expandChild = expand.firstElementChild;
	
	  contract.scrollLeft = contract.scrollWidth;
	  contract.scrollTop = contract.scrollHeight;
	  expandChild.style.width = expand.offsetWidth + 1 + 'px';
	  expandChild.style.height = expand.offsetHeight + 1 + 'px';
	  expand.scrollLeft = expand.scrollWidth;
	  expand.scrollTop = expand.scrollHeight;
	};
	
	/* istanbul ignore next */
	var checkTriggers = function checkTriggers(element) {
	  return element.offsetWidth !== element.__resizeLast__.width || element.offsetHeight !== element.__resizeLast__.height;
	};
	
	/* istanbul ignore next */
	var scrollListener = function scrollListener(event) {
	  var _this = this;
	
	  resetTrigger(this);
	  if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
	  this.__resizeRAF__ = requestFrame(function () {
	    if (checkTriggers(_this)) {
	      _this.__resizeLast__.width = _this.offsetWidth;
	      _this.__resizeLast__.height = _this.offsetHeight;
	      _this.__resizeListeners__.forEach(function (fn) {
	        fn.call(_this, event);
	      });
	    }
	  });
	};
	
	/* Detect CSS Animations support to detect element display/re-attach */
	var attachEvent = isServer ? {} : document.attachEvent;
	var DOM_PREFIXES = 'Webkit Moz O ms'.split(' ');
	var START_EVENTS = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' ');
	var RESIZE_ANIMATION_NAME = 'resizeanim';
	var animation = false;
	var keyFramePrefix = '';
	var animationStartEvent = 'animationstart';
	
	/* istanbul ignore next */
	if (!attachEvent && !isServer) {
	  var testElement = document.createElement('fakeelement');
	  if (testElement.style.animationName !== undefined) {
	    animation = true;
	  }
	
	  if (animation === false) {
	    var prefix = '';
	    for (var i = 0; i < DOM_PREFIXES.length; i++) {
	      if (testElement.style[DOM_PREFIXES[i] + 'AnimationName'] !== undefined) {
	        prefix = DOM_PREFIXES[i];
	        keyFramePrefix = '-' + prefix.toLowerCase() + '-';
	        animationStartEvent = START_EVENTS[i];
	        animation = true;
	        break;
	      }
	    }
	  }
	}
	
	var stylesCreated = false;
	/* istanbul ignore next */
	var createStyles = function createStyles() {
	  if (!stylesCreated && !isServer) {
	    var animationKeyframes = '@' + keyFramePrefix + 'keyframes ' + RESIZE_ANIMATION_NAME + ' { from { opacity: 0; } to { opacity: 0; } } ';
	    var animationStyle = keyFramePrefix + 'animation: 1ms ' + RESIZE_ANIMATION_NAME + ';';
	
	    // opacity: 0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
	    var css = animationKeyframes + '\n      .resize-triggers { ' + animationStyle + ' visibility: hidden; opacity: 0; }\n      .resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; }\n      .resize-triggers > div { background: #eee; overflow: auto; }\n      .contract-trigger:before { width: 200%; height: 200%; }';
	
	    var head = document.head || document.getElementsByTagName('head')[0];
	    var style = document.createElement('style');
	
	    style.type = 'text/css';
	    if (style.styleSheet) {
	      style.styleSheet.cssText = css;
	    } else {
	      style.appendChild(document.createTextNode(css));
	    }
	
	    head.appendChild(style);
	    stylesCreated = true;
	  }
	};
	
	/* istanbul ignore next */
	var addResizeListener = exports.addResizeListener = function addResizeListener(element, fn) {
	  if (isServer) return;
	  if (attachEvent) {
	    element.attachEvent('onresize', fn);
	  } else {
	    if (!element.__resizeTrigger__) {
	      if (getComputedStyle(element).position === 'static') {
	        element.style.position = 'relative';
	      }
	      createStyles();
	      element.__resizeLast__ = {};
	      element.__resizeListeners__ = [];
	
	      var resizeTrigger = element.__resizeTrigger__ = document.createElement('div');
	      resizeTrigger.className = 'resize-triggers';
	      resizeTrigger.innerHTML = '<div class="expand-trigger"><div></div></div><div class="contract-trigger"></div>';
	      element.appendChild(resizeTrigger);
	
	      resetTrigger(element);
	      element.addEventListener('scroll', scrollListener, true);
	
	      /* Listen for a css animation to detect element display/re-attach */
	      if (animationStartEvent) {
	        resizeTrigger.addEventListener(animationStartEvent, function (event) {
	          if (event.animationName === RESIZE_ANIMATION_NAME) {
	            resetTrigger(element);
	          }
	        });
	      }
	    }
	    element.__resizeListeners__.push(fn);
	  }
	};
	
	/* istanbul ignore next */
	var removeResizeListener = exports.removeResizeListener = function removeResizeListener(element, fn) {
	  if (attachEvent) {
	    element.detachEvent('onresize', fn);
	  } else {
	    element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
	    if (!element.__resizeListeners__.length) {
	      element.removeEventListener('scroll', scrollListener);
	      element.__resizeTrigger__ = !element.removeChild(element.__resizeTrigger__);
	    }
	  }
	};

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _popup = __webpack_require__(147);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopperJS = _vue2.default.prototype.$isServer ? function () {} : __webpack_require__(420);
	var stop = function stop(e) {
	  return e.stopPropagation();
	};
	
	/**
	 * @param {HTMLElement} [reference=$refs.reference] - The reference element used to position the popper.
	 * @param {HTMLElement} [popper=$refs.popper] - The HTML element used as popper, or a configuration used to generate the popper.
	 * @param {String} [placement=button] - Placement of the popper accepted values: top(-start, -end), right(-start, -end), bottom(-start, -right), left(-start, -end)
	 * @param {Number} [offset=0] - Amount of pixels the popper will be shifted (can be negative).
	 * @param {Boolean} [visible=false] Visibility of the popup element.
	 * @param {Boolean} [visible-arrow=false] Visibility of the arrow, no style.
	 */
	exports.default = {
	  props: {
	    placement: {
	      type: String,
	      default: 'bottom'
	    },
	    boundariesPadding: {
	      type: Number,
	      default: 5
	    },
	    reference: {},
	    popper: {},
	    offset: {
	      default: 0
	    },
	    value: Boolean,
	    visibleArrow: Boolean,
	    transition: String,
	    appendToBody: {
	      type: Boolean,
	      default: true
	    },
	    options: {
	      type: Object,
	      default: function _default() {
	        return {
	          gpuAcceleration: false
	        };
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      showPopper: false,
	      currentPlacement: ''
	    };
	  },
	
	
	  watch: {
	    value: {
	      immediate: true,
	      handler: function handler(val) {
	        this.showPopper = val;
	        this.$emit('input', val);
	      }
	    },
	
	    showPopper: function showPopper(val) {
	      val ? this.updatePopper() : this.destroyPopper();
	      this.$emit('input', val);
	    }
	  },
	
	  methods: {
	    createPopper: function createPopper() {
	      var _this = this;
	
	      if (this.$isServer) return;
	      this.currentPlacement = this.currentPlacement || this.placement;
	      if (!/^(top|bottom|left|right)(-start|-end)?$/g.test(this.currentPlacement)) {
	        return;
	      }
	
	      var options = this.options;
	      var popper = this.popperElm = this.popperElm || this.popper || this.$refs.popper;
	      var reference = this.referenceElm = this.referenceElm || this.reference || this.$refs.reference;
	
	      if (!reference && this.$slots.reference && this.$slots.reference[0]) {
	        reference = this.referenceElm = this.$slots.reference[0].elm;
	      }
	      if (!popper || !reference) return;
	      if (this.visibleArrow) this.appendArrow(popper);
	      if (this.appendToBody) document.body.appendChild(this.popperElm);
	      if (this.popperJS && this.popperJS.destroy) {
	        this.popperJS.destroy();
	      }
	
	      options.placement = this.currentPlacement;
	      options.offset = this.offset;
	      this.popperJS = new PopperJS(reference, popper, options);
	      this.popperJS.onCreate(function (_) {
	        _this.$emit('created', _this);
	        _this.resetTransformOrigin();
	        _this.$nextTick(_this.updatePopper);
	      });
	      this.popperJS._popper.style.zIndex = _popup.PopupManager.nextZIndex();
	      this.popperElm.addEventListener('click', stop);
	    },
	    updatePopper: function updatePopper() {
	      this.popperJS ? this.popperJS.update() : this.createPopper();
	    },
	    doDestroy: function doDestroy() {
	      /* istanbul ignore if */
	      if (this.showPopper || !this.popperJS) return;
	      this.popperJS.destroy();
	      this.popperJS = null;
	    },
	    destroyPopper: function destroyPopper() {
	      if (this.popperJS) {
	        this.resetTransformOrigin();
	      }
	    },
	    resetTransformOrigin: function resetTransformOrigin() {
	      var placementMap = { top: 'bottom', bottom: 'top', left: 'right', right: 'left' };
	      var placement = this.popperJS._popper.getAttribute('x-placement').split('-')[0];
	      var origin = placementMap[placement];
	      this.popperJS._popper.style.transformOrigin = ['top', 'bottom'].indexOf(placement) > -1 ? 'center ' + origin : origin + ' center';
	    },
	    appendArrow: function appendArrow(element) {
	      var hash = void 0;
	      if (this.appended) {
	        return;
	      }
	
	      this.appended = true;
	
	      for (var item in element.attributes) {
	        if (/^_v-/.test(element.attributes[item].name)) {
	          hash = element.attributes[item].name;
	          break;
	        }
	      }
	
	      var arrow = document.createElement('div');
	
	      if (hash) {
	        arrow.setAttribute(hash, '');
	      }
	      arrow.setAttribute('x-arrow', '');
	      arrow.className = 'popper__arrow';
	      element.appendChild(arrow);
	    }
	  },
	
	  beforeDestroy: function beforeDestroy() {
	    this.doDestroy();
	    if (this.popperElm && this.popperElm.parentNode === document.body) {
	      this.popperElm.removeEventListener('click', stop);
	      document.body.removeChild(this.popperElm);
	    }
	  },
	
	
	  // call destroy in keep-alive mode
	  deactivated: function deactivated() {
	    this.$options.beforeDestroy[0].call(this);
	  }
	};

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(9);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj["default"] = obj; return newObj; } }
	
	/**
	 *  Rule for validating required fields.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function required(rule, value, source, errors, options, type) {
	  if (rule.required && (!source.hasOwnProperty(rule.field) || util.isEmptyValue(value, type))) {
	    errors.push(util.format(options.messages.required, rule.fullField));
	  }
	}
	
	exports["default"] = required;
	module.exports = exports['default'];

/***/ },
/* 107 */,
/* 108 */,
/* 109 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 110 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(201);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 112 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(111)
	  , defined = __webpack_require__(110);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(22);
	module.exports = function(it, msg){
	  if(typeof it != 'number' && cof(it) != 'Number')throw TypeError(msg);
	  return +it;
	};

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(12)
	  , toIndex  = __webpack_require__(45)
	  , toLength = __webpack_require__(10);
	
	module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
	  var O     = toObject(this)
	    , len   = toLength(O.length)
	    , to    = toIndex(target, len)
	    , from  = toIndex(start, len)
	    , end   = arguments.length > 2 ? arguments[2] : undefined
	    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
	    , inc   = 1;
	  if(from < to && to < from + count){
	    inc  = -1;
	    from += count - 1;
	    to   += count - 1;
	  }
	  while(count-- > 0){
	    if(from in O)O[to] = O[from];
	    else delete O[to];
	    to   += inc;
	    from += inc;
	  } return O;
	};

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(49);
	
	module.exports = function(iter, ITERATOR){
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(15)
	  , toObject  = __webpack_require__(12)
	  , IObject   = __webpack_require__(55)
	  , toLength  = __webpack_require__(10);
	
	module.exports = function(that, callbackfn, aLen, memo, isRight){
	  aFunction(callbackfn);
	  var O      = toObject(that)
	    , self   = IObject(O)
	    , length = toLength(O.length)
	    , index  = isRight ? length - 1 : 0
	    , i      = isRight ? -1 : 1;
	  if(aLen < 2)for(;;){
	    if(index in self){
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if(isRight ? index < 0 : length <= index){
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for(;isRight ? index >= 0 : length > index; index += i)if(index in self){
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction  = __webpack_require__(15)
	  , isObject   = __webpack_require__(5)
	  , invoke     = __webpack_require__(62)
	  , arraySlice = [].slice
	  , factories  = {};
	
	var construct = function(F, len, args){
	  if(!(len in factories)){
	    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /*, args... */){
	  var fn       = aFunction(this)
	    , partArgs = arraySlice.call(arguments, 1);
	  var bound = function(/* args... */){
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if(isObject(fn.prototype))bound.prototype = fn.prototype;
	  return bound;
	};

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var dP          = __webpack_require__(8).f
	  , create      = __webpack_require__(40)
	  , redefineAll = __webpack_require__(43)
	  , ctx         = __webpack_require__(30)
	  , anInstance  = __webpack_require__(38)
	  , defined     = __webpack_require__(23)
	  , forOf       = __webpack_require__(49)
	  , $iterDefine = __webpack_require__(86)
	  , step        = __webpack_require__(125)
	  , setSpecies  = __webpack_require__(44)
	  , DESCRIPTORS = __webpack_require__(7)
	  , fastKey     = __webpack_require__(35).fastKey
	  , SIZE        = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        anInstance(this, C, 'forEach');
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(DESCRIPTORS)dP(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(54)
	  , from    = __webpack_require__(116);
	module.exports = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll       = __webpack_require__(43)
	  , getWeak           = __webpack_require__(35).getWeak
	  , anObject          = __webpack_require__(2)
	  , isObject          = __webpack_require__(5)
	  , anInstance        = __webpack_require__(38)
	  , forOf             = __webpack_require__(49)
	  , createArrayMethod = __webpack_require__(26)
	  , $has              = __webpack_require__(14)
	  , arrayFind         = createArrayMethod(5)
	  , arrayFindIndex    = createArrayMethod(6)
	  , id                = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function(that){
	  return that._l || (that._l = new UncaughtFrozenStore);
	};
	var UncaughtFrozenStore = function(){
	  this.a = [];
	};
	var findUncaughtFrozen = function(store, key){
	  return arrayFind(store.a, function(it){
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function(key){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)return entry[1];
	  },
	  has: function(key){
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function(key, value){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function(key){
	    var index = arrayFindIndex(this.a, function(it){
	      return it[0] === key;
	    });
	    if(~index)this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this)['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var data = getWeak(anObject(key), true);
	    if(data === true)uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(7) && !__webpack_require__(4)(function(){
	  return Object.defineProperty(__webpack_require__(78)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(5)
	  , floor    = Math.floor;
	module.exports = function isInteger(it){
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(2);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ },
/* 125 */
/***/ function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ },
/* 126 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x){
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(42)
	  , gOPS     = __webpack_require__(66)
	  , pIE      = __webpack_require__(56)
	  , toObject = __webpack_require__(12)
	  , IObject  = __webpack_require__(55)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(4)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	var dP       = __webpack_require__(8)
	  , anObject = __webpack_require__(2)
	  , getKeys  = __webpack_require__(42);
	
	module.exports = __webpack_require__(7) ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(19)
	  , gOPN      = __webpack_require__(41).f
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return gOPN(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(14)
	  , toIObject    = __webpack_require__(19)
	  , arrayIndexOf = __webpack_require__(58)(false)
	  , IE_PROTO     = __webpack_require__(91)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(42)
	  , toIObject = __webpack_require__(19)
	  , isEnum    = __webpack_require__(56).f;
	module.exports = function(isEntries){
	  return function(it){
	    var O      = toIObject(it)
	      , keys   = getKeys(O)
	      , length = keys.length
	      , i      = 0
	      , result = []
	      , key;
	    while(length > i)if(isEnum.call(O, key = keys[i++])){
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN     = __webpack_require__(41)
	  , gOPS     = __webpack_require__(66)
	  , anObject = __webpack_require__(2)
	  , Reflect  = __webpack_require__(3).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
	  var keys       = gOPN.f(anObject(it))
	    , getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(3).parseFloat
	  , $trim       = __webpack_require__(52).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(96) + '-0') !== -Infinity ? function parseFloat(str){
	  var string = $trim(String(str), 3)
	    , result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(3).parseInt
	  , $trim     = __webpack_require__(52).trim
	  , ws        = __webpack_require__(96)
	  , hex       = /^[\-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix){
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;

/***/ },
/* 135 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(10)
	  , repeat   = __webpack_require__(95)
	  , defined  = __webpack_require__(23);
	
	module.exports = function(that, maxLength, fillString, left){
	  var S            = String(defined(that))
	    , stringLength = S.length
	    , fillStr      = fillString === undefined ? ' ' : String(fillString)
	    , intMaxLength = toLength(maxLength);
	  if(intMaxLength <= stringLength || fillStr == '')return S;
	  var fillLen = intMaxLength - stringLength
	    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(6);

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(119);
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(59)('Map', function(get){
	  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if(__webpack_require__(7) && /./g.flags != 'g')__webpack_require__(8).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(61)
	});

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(119);
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(59)('Set', function(get){
	  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value){
	    return strong.def(this, value = value === 0 ? 0 : value, value);
	  }
	}, strong);

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var each         = __webpack_require__(26)(0)
	  , redefine     = __webpack_require__(17)
	  , meta         = __webpack_require__(35)
	  , assign       = __webpack_require__(127)
	  , weak         = __webpack_require__(121)
	  , isObject     = __webpack_require__(5)
	  , getWeak      = meta.getWeak
	  , isExtensible = Object.isExtensible
	  , uncaughtFrozenStore = weak.ufstore
	  , tmp          = {}
	  , InternalMap;
	
	var wrapper = function(get){
	  return function WeakMap(){
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key){
	    if(isObject(key)){
	      var data = getWeak(key);
	      if(data === true)return uncaughtFrozenStore(this).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value){
	    return weak.def(this, key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(59)('WeakMap', wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
	  InternalMap = weak.getConstructor(wrapper);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function(key){
	    var proto  = $WeakMap.prototype
	      , method = proto[key];
	    redefine(proto, key, function(a, b){
	      // store frozen objects on internal weakmap shim
	      if(isObject(a) && !isExtensible(a)){
	        if(!this._f)this._f = new InternalMap;
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-collection/ Version 1.0.4. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	var nest = function() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) {
	      if (sortValues != null) array.sort(sortValues);
	      return rollup != null ? rollup(array) : array;
	    }
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map$$1, depth) {
	    if (++depth > keys.length) return map$$1;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map$$1.entries();
	    else array = [], map$$1.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	};
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map();
	}
	
	function setMap(map$$1, key, value) {
	  map$$1.set(key, value);
	}
	
	function Set() {}
	
	var proto = map.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	var keys = function(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	};
	
	var values = function(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	};
	
	var entries = function(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	};
	
	exports.nest = nest;
	exports.set = set;
	exports.map = map;
	exports.keys = keys;
	exports.values = values;
	exports.entries = entries;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _locale = __webpack_require__(103);
	
	exports.default = {
	  methods: {
	    t: function t() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _locale.t.apply(this, args);
	    }
	  }
	};

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(228);
	
	
	/***/ },
	
	/***/ 45:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(104);
	
	/***/ },
	
	/***/ 74:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(11);
	
	/***/ },
	
	/***/ 90:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(47);
	
	/***/ },
	
	/***/ 228:
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _main = __webpack_require__(229);
	
		var _main2 = _interopRequireDefault(_main);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_main2.default.install = function (Vue) {
		  Vue.component(_main2.default.name, _main2.default);
		};
	
		exports.default = _main2.default;
	
	/***/ },
	
	/***/ 229:
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _resizeEvent = __webpack_require__(45);
	
		var _scrollbarWidth = __webpack_require__(230);
	
		var _scrollbarWidth2 = _interopRequireDefault(_scrollbarWidth);
	
		var _util = __webpack_require__(231);
	
		var util = _interopRequireWildcard(_util);
	
		var _bar = __webpack_require__(232);
	
		var _bar2 = _interopRequireDefault(_bar);
	
		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		// reference https://github.com/noeldelgado/gemini-scrollbar/blob/master/index.js
	
		exports.default = {
		  name: 'ElScrollbar',
	
		  components: { Bar: _bar2.default },
	
		  props: {
		    native: Boolean,
		    wrapStyle: {},
		    wrapClass: {},
		    viewClass: {},
		    viewStyle: {},
		    noresize: Boolean, // 如果 container 尺寸不会发生变化，最好设置它可以优化性能
		    tag: {
		      type: String,
		      default: 'div'
		    }
		  },
	
		  data: function data() {
		    return {
		      sizeWidth: '0',
		      sizeHeight: '0',
		      moveX: 0,
		      moveY: 0
		    };
		  },
	
	
		  computed: {
		    wrap: function wrap() {
		      return this.$refs.wrap;
		    }
		  },
	
		  render: function render(h) {
		    var gutter = (0, _scrollbarWidth2.default)();
		    var style = this.wrapStyle;
	
		    if (gutter) {
		      var gutterWith = '-' + gutter + 'px';
	
		      if (Array.isArray(this.wrapStyle)) {
		        style = util.toObject(this.wrapStyle);
		        style.marginRight = style.marginBottom = gutterWith;
		      } else if (typeof this.wrapStyle === 'string') {
		        style += 'margin-bottom: ' + gutterWith + '; margin-right: ' + gutterWith + ';';
		      }
		    }
		    var view = h(this.tag, {
		      class: ['el-scrollbar__view', this.viewClass],
		      style: this.viewStyle,
		      ref: 'resize'
		    }, this.$slots.default);
		    var wrap = h(
		      'div',
		      {
		        ref: 'wrap',
		        style: style,
		        on: {
		          'scroll': this.handleScroll
		        },
	
		        'class': [this.wrapClass, 'el-scrollbar__wrap el-scrollbar__wrap--hidden-default'] },
		      [[view]]
		    );
		    var nodes = void 0;
	
		    if (!this.native) {
		      nodes = [wrap, h(
		        _bar2.default,
		        {
		          attrs: {
		            move: this.moveX,
		            size: this.sizeWidth }
		        },
		        []
		      ), h(
		        _bar2.default,
		        {
		          attrs: {
		            vertical: true,
		            move: this.moveY,
		            size: this.sizeHeight }
		        },
		        []
		      )];
		    } else {
		      nodes = [h(
		        'div',
		        {
		          ref: 'wrap',
		          'class': [this.wrapClass, 'el-scrollbar__wrap'],
		          style: style },
		        [[view]]
		      )];
		    }
		    return h('div', { class: 'el-scrollbar' }, nodes);
		  },
	
	
		  methods: {
		    handleScroll: function handleScroll() {
		      var wrap = this.wrap;
	
		      this.moveY = wrap.scrollTop * 100 / wrap.clientHeight;
		      this.moveX = wrap.scrollLeft * 100 / wrap.clientWidth;
		    },
		    update: function update() {
		      var heightPercentage = void 0,
		          widthPercentage = void 0;
		      var wrap = this.wrap;
	
		      heightPercentage = wrap.clientHeight * 100 / wrap.scrollHeight;
		      widthPercentage = wrap.clientWidth * 100 / wrap.scrollWidth;
	
		      this.sizeHeight = heightPercentage < 100 ? heightPercentage + '%' : '';
		      this.sizeWidth = widthPercentage < 100 ? widthPercentage + '%' : '';
		    }
		  },
	
		  mounted: function mounted() {
		    if (this.native) return;
		    this.$nextTick(this.update);
		    !this.noresize && (0, _resizeEvent.addResizeListener)(this.$refs.resize, this.update);
		  },
		  destroyed: function destroyed() {
		    if (this.native) return;
		    !this.noresize && (0, _resizeEvent.removeResizeListener)(this.$refs.resize, this.update);
		  }
		};
	
	/***/ },
	
	/***/ 230:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(148);
	
	/***/ },
	
	/***/ 231:
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.toObject = exports.BAR_MAP = undefined;
		exports.renderThumbStyle = renderThumbStyle;
	
		var _vue = __webpack_require__(74);
	
		var _vue2 = _interopRequireDefault(_vue);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var BAR_MAP = exports.BAR_MAP = {
		  vertical: {
		    offset: 'offsetHeight',
		    scroll: 'scrollTop',
		    scrollSize: 'scrollHeight',
		    size: 'height',
		    key: 'vertical',
		    axis: 'Y',
		    client: 'clientY',
		    direction: 'top'
		  },
		  horizontal: {
		    offset: 'offsetWidth',
		    scroll: 'scrollLeft',
		    scrollSize: 'scrollWidth',
		    size: 'width',
		    key: 'horizontal',
		    axis: 'X',
		    client: 'clientX',
		    direction: 'left'
		  }
		};
	
		function renderThumbStyle(_ref) {
		  var move = _ref.move,
		      size = _ref.size,
		      bar = _ref.bar;
	
		  var style = {};
		  var translate = 'translate' + bar.axis + '(' + move + '%)';
	
		  style[bar.size] = size;
		  style.transform = translate;
		  style.msTransform = translate;
		  style.webkitTransform = translate;
	
		  return style;
		};
	
		var toObject = exports.toObject = _vue2.default.util.toObject;
	
	/***/ },
	
	/***/ 232:
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _dom = __webpack_require__(90);
	
		var _util = __webpack_require__(231);
	
		/* istanbul ignore next */
		exports.default = {
		  name: 'Bar',
	
		  props: {
		    vertical: Boolean,
		    size: String,
		    move: Number
		  },
	
		  computed: {
		    bar: function bar() {
		      return _util.BAR_MAP[this.vertical ? 'vertical' : 'horizontal'];
		    },
		    wrap: function wrap() {
		      return this.$parent.wrap;
		    }
		  },
	
		  render: function render(h) {
		    var size = this.size,
		        move = this.move,
		        bar = this.bar;
	
	
		    return h(
		      'div',
		      {
		        'class': ['el-scrollbar__bar', 'is-' + bar.key],
		        on: {
		          'mousedown': this.clickTrackHandler
		        }
		      },
		      [h(
		        'div',
		        {
		          ref: 'thumb',
		          'class': 'el-scrollbar__thumb',
		          on: {
		            'mousedown': this.clickThumbHandler
		          },
	
		          style: (0, _util.renderThumbStyle)({ size: size, move: move, bar: bar }) },
		        []
		      )]
		    );
		  },
	
	
		  methods: {
		    clickThumbHandler: function clickThumbHandler(e) {
		      this.startDrag(e);
		      this[this.bar.axis] = e.currentTarget[this.bar.offset] - (e[this.bar.client] - e.currentTarget.getBoundingClientRect()[this.bar.direction]);
		    },
		    clickTrackHandler: function clickTrackHandler(e) {
		      var offset = Math.abs(e.target.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]);
		      var thumbHalf = this.$refs.thumb[this.bar.offset] / 2;
		      var thumbPositionPercentage = (offset - thumbHalf) * 100 / this.$el[this.bar.offset];
	
		      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
		    },
		    startDrag: function startDrag(e) {
		      e.stopImmediatePropagation();
		      this.cursorDown = true;
	
		      (0, _dom.on)(document, 'mousemove', this.mouseMoveDocumentHandler);
		      (0, _dom.on)(document, 'mouseup', this.mouseUpDocumentHandler);
		      document.onselectstart = function () {
		        return false;
		      };
		    },
		    mouseMoveDocumentHandler: function mouseMoveDocumentHandler(e) {
		      if (this.cursorDown === false) return;
		      var prevPage = this[this.bar.axis];
	
		      if (!prevPage) return;
	
		      var offset = (this.$el.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]) * -1;
		      var thumbClickPosition = this.$refs.thumb[this.bar.offset] - prevPage;
		      var thumbPositionPercentage = (offset - thumbClickPosition) * 100 / this.$el[this.bar.offset];
	
		      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
		    },
		    mouseUpDocumentHandler: function mouseUpDocumentHandler(e) {
		      this.cursorDown = false;
		      this[this.bar.axis] = 0;
		      (0, _dom.off)(document, 'mousemove', this.mouseMoveDocumentHandler);
		      document.onselectstart = null;
		    }
		  },
	
		  destroyed: function destroyed() {
		    (0, _dom.off)(document, 'mouseup', this.mouseUpDocumentHandler);
		  }
		};
	
	/***/ }
	
	/******/ });

/***/ },
/* 145 */
/***/ function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(294);
	
	
	/***/ },
	
	/***/ 294:
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _tag = __webpack_require__(295);
	
		var _tag2 = _interopRequireDefault(_tag);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_tag2.default.install = function (Vue) {
		  Vue.component(_tag2.default.name, _tag2.default);
		};
	
		exports.default = _tag2.default;
	
	/***/ },
	
	/***/ 295:
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(296)
	
		/* template */
		var __vue_template__ = __webpack_require__(297)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	
	/***/ 296:
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  name: 'ElTag',
		  props: {
		    text: String,
		    closable: Boolean,
		    type: String,
		    hit: Boolean,
		    closeTransition: Boolean,
		    color: String
		  },
		  methods: {
		    handleClose: function handleClose(event) {
		      this.$emit('close', event);
		    }
		  }
		};
	
	/***/ },
	
	/***/ 297:
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('transition', {
		    attrs: {
		      "name": _vm.closeTransition ? '' : 'el-zoom-in-center'
		    }
		  }, [_c('span', {
		    staticClass: "el-tag",
		    class: [_vm.type ? 'el-tag--' + _vm.type : '', {
		      'is-hit': _vm.hit
		    }],
		    style: ({
		      backgroundColor: _vm.color
		    })
		  }, [_vm._t("default"), (_vm.closable) ? _c('i', {
		    staticClass: "el-tag__close el-icon-close",
		    on: {
		      "click": _vm.handleClose
		    }
		  }) : _vm._e()], 2)])
		},staticRenderFns: []}
	
	/***/ }
	
	/******/ });

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _dom = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nodeList = [];
	var ctx = '@@clickoutsideContext';
	
	!_vue2.default.prototype.$isServer && (0, _dom.on)(document, 'click', function (e) {
	  nodeList.forEach(function (node) {
	    return node[ctx].documentHandler(e);
	  });
	});
	/**
	 * v-clickoutside
	 * @desc 点击元素外面才会触发的事件
	 * @example
	 * ```vue
	 * <div v-element-clickoutside="handleClose">
	 * ```
	 */
	exports.default = {
	  bind: function bind(el, binding, vnode) {
	    var id = nodeList.push(el) - 1;
	    var documentHandler = function documentHandler(e) {
	      if (!vnode.context || el.contains(e.target) || vnode.context.popperElm && vnode.context.popperElm.contains(e.target)) return;
	
	      if (binding.expression && el[ctx].methodName && vnode.context[el[ctx].methodName]) {
	        vnode.context[el[ctx].methodName]();
	      } else {
	        el[ctx].bindingFn && el[ctx].bindingFn();
	      }
	    };
	    el[ctx] = {
	      id: id,
	      documentHandler: documentHandler,
	      methodName: binding.expression,
	      bindingFn: binding.value
	    };
	  },
	  update: function update(el, binding) {
	    el[ctx].methodName = binding.expression;
	    el[ctx].bindingFn = binding.value;
	  },
	  unbind: function unbind(el) {
	    var len = nodeList.length;
	
	    for (var i = 0; i < len; i++) {
	      if (nodeList[i][ctx].id === el[ctx].id) {
	        nodeList.splice(i, 1);
	        break;
	      }
	    }
	  }
	};

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.PopupManager = undefined;
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _merge = __webpack_require__(69);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _popupManager = __webpack_require__(421);
	
	var _popupManager2 = _interopRequireDefault(_popupManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var idSeed = 1;
	var transitions = [];
	
	var hookTransition = function hookTransition(transition) {
	  if (transitions.indexOf(transition) !== -1) return;
	
	  var getVueInstance = function getVueInstance(element) {
	    var instance = element.__vue__;
	    if (!instance) {
	      var textNode = element.previousSibling;
	      if (textNode.__vue__) {
	        instance = textNode.__vue__;
	      }
	    }
	    return instance;
	  };
	
	  _vue2.default.transition(transition, {
	    afterEnter: function afterEnter(el) {
	      var instance = getVueInstance(el);
	
	      if (instance) {
	        instance.doAfterOpen && instance.doAfterOpen();
	      }
	    },
	    afterLeave: function afterLeave(el) {
	      var instance = getVueInstance(el);
	
	      if (instance) {
	        instance.doAfterClose && instance.doAfterClose();
	      }
	    }
	  });
	};
	
	var scrollBarWidth = void 0;
	var getScrollBarWidth = function getScrollBarWidth() {
	  if (_vue2.default.prototype.$isServer) return;
	  if (scrollBarWidth !== undefined) return scrollBarWidth;
	
	  var outer = document.createElement('div');
	  outer.style.visibility = 'hidden';
	  outer.style.width = '100px';
	  outer.style.position = 'absolute';
	  outer.style.top = '-9999px';
	  document.body.appendChild(outer);
	
	  var widthNoScroll = outer.offsetWidth;
	  outer.style.overflow = 'scroll';
	
	  var inner = document.createElement('div');
	  inner.style.width = '100%';
	  outer.appendChild(inner);
	
	  var widthWithScroll = inner.offsetWidth;
	  outer.parentNode.removeChild(outer);
	
	  return widthNoScroll - widthWithScroll;
	};
	
	var getDOM = function getDOM(dom) {
	  if (dom.nodeType === 3) {
	    dom = dom.nextElementSibling || dom.nextSibling;
	    getDOM(dom);
	  }
	  return dom;
	};
	
	exports.default = {
	  props: {
	    value: {
	      type: Boolean,
	      default: false
	    },
	    transition: {
	      type: String,
	      default: ''
	    },
	    openDelay: {},
	    closeDelay: {},
	    zIndex: {},
	    modal: {
	      type: Boolean,
	      default: false
	    },
	    modalFade: {
	      type: Boolean,
	      default: true
	    },
	    modalClass: {},
	    lockScroll: {
	      type: Boolean,
	      default: true
	    },
	    closeOnPressEscape: {
	      type: Boolean,
	      default: false
	    },
	    closeOnClickModal: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  created: function created() {
	    if (this.transition) {
	      hookTransition(this.transition);
	    }
	  },
	  beforeMount: function beforeMount() {
	    this._popupId = 'popup-' + idSeed++;
	    _popupManager2.default.register(this._popupId, this);
	  },
	  beforeDestroy: function beforeDestroy() {
	    _popupManager2.default.deregister(this._popupId);
	    _popupManager2.default.closeModal(this._popupId);
	    if (this.modal && this.bodyOverflow !== null && this.bodyOverflow !== 'hidden') {
	      document.body.style.overflow = this.bodyOverflow;
	      document.body.style.paddingRight = this.bodyPaddingRight;
	    }
	    this.bodyOverflow = null;
	    this.bodyPaddingRight = null;
	  },
	  data: function data() {
	    return {
	      opened: false,
	      bodyOverflow: null,
	      bodyPaddingRight: null,
	      rendered: false
	    };
	  },
	
	
	  watch: {
	    value: function value(val) {
	      var _this = this;
	
	      if (val) {
	        if (this._opening) return;
	        if (!this.rendered) {
	          this.rendered = true;
	          _vue2.default.nextTick(function () {
	            _this.open();
	          });
	        } else {
	          this.open();
	        }
	      } else {
	        this.close();
	      }
	    }
	  },
	
	  methods: {
	    open: function open(options) {
	      var _this2 = this;
	
	      if (!this.rendered) {
	        this.rendered = true;
	        this.$emit('input', true);
	      }
	
	      var props = (0, _merge2.default)({}, this, options);
	
	      if (this._closeTimer) {
	        clearTimeout(this._closeTimer);
	        this._closeTimer = null;
	      }
	      clearTimeout(this._openTimer);
	
	      var openDelay = Number(props.openDelay);
	      if (openDelay > 0) {
	        this._openTimer = setTimeout(function () {
	          _this2._openTimer = null;
	          _this2.doOpen(props);
	        }, openDelay);
	      } else {
	        this.doOpen(props);
	      }
	    },
	    doOpen: function doOpen(props) {
	      if (this.$isServer) return;
	      if (this.willOpen && !this.willOpen()) return;
	      if (this.opened) return;
	
	      this._opening = true;
	
	      // 使用 vue-popup 的组件，如果需要和父组件通信显示的状态，应该使用 value，它是一个 prop，
	      // 这样在父组件中用 v-model 即可；否则可以使用 visible，它是一个 data
	      this.visible = true;
	      this.$emit('input', true);
	
	      var dom = getDOM(this.$el);
	
	      var modal = props.modal;
	
	      var zIndex = props.zIndex;
	      if (zIndex) {
	        _popupManager2.default.zIndex = zIndex;
	      }
	
	      if (modal) {
	        if (this._closing) {
	          _popupManager2.default.closeModal(this._popupId);
	          this._closing = false;
	        }
	        _popupManager2.default.openModal(this._popupId, _popupManager2.default.nextZIndex(), dom, props.modalClass, props.modalFade);
	        if (props.lockScroll) {
	          if (!this.bodyOverflow) {
	            this.bodyPaddingRight = document.body.style.paddingRight;
	            this.bodyOverflow = document.body.style.overflow;
	          }
	          scrollBarWidth = getScrollBarWidth();
	          var bodyHasOverflow = document.documentElement.clientHeight < document.body.scrollHeight;
	          if (scrollBarWidth > 0 && bodyHasOverflow) {
	            document.body.style.paddingRight = scrollBarWidth + 'px';
	          }
	          document.body.style.overflow = 'hidden';
	        }
	      }
	
	      if (getComputedStyle(dom).position === 'static') {
	        dom.style.position = 'absolute';
	      }
	
	      dom.style.zIndex = _popupManager2.default.nextZIndex();
	      this.opened = true;
	
	      this.onOpen && this.onOpen();
	
	      if (!this.transition) {
	        this.doAfterOpen();
	      }
	    },
	    doAfterOpen: function doAfterOpen() {
	      this._opening = false;
	    },
	    close: function close() {
	      var _this3 = this;
	
	      if (this.willClose && !this.willClose()) return;
	
	      if (this._openTimer !== null) {
	        clearTimeout(this._openTimer);
	        this._openTimer = null;
	      }
	      clearTimeout(this._closeTimer);
	
	      var closeDelay = Number(this.closeDelay);
	
	      if (closeDelay > 0) {
	        this._closeTimer = setTimeout(function () {
	          _this3._closeTimer = null;
	          _this3.doClose();
	        }, closeDelay);
	      } else {
	        this.doClose();
	      }
	    },
	    doClose: function doClose() {
	      var _this4 = this;
	
	      this.visible = false;
	      this.$emit('input', false);
	      this._closing = true;
	
	      this.onClose && this.onClose();
	
	      if (this.lockScroll) {
	        setTimeout(function () {
	          if (_this4.modal && _this4.bodyOverflow !== 'hidden') {
	            document.body.style.overflow = _this4.bodyOverflow;
	            document.body.style.paddingRight = _this4.bodyPaddingRight;
	          }
	          _this4.bodyOverflow = null;
	          _this4.bodyPaddingRight = null;
	        }, 200);
	      }
	
	      this.opened = false;
	
	      if (!this.transition) {
	        this.doAfterClose();
	      }
	    },
	    doAfterClose: function doAfterClose() {
	      _popupManager2.default.closeModal(this._popupId);
	      this._closing = false;
	    }
	  }
	};
	exports.PopupManager = _popupManager2.default;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function () {
	  if (_vue2.default.prototype.$isServer) return 0;
	  if (scrollBarWidth !== undefined) return scrollBarWidth;
	
	  var outer = document.createElement('div');
	  outer.className = 'el-scrollbar__wrap';
	  outer.style.visibility = 'hidden';
	  outer.style.width = '100px';
	  outer.style.position = 'absolute';
	  outer.style.top = '-9999px';
	  document.body.appendChild(outer);
	
	  var widthNoScroll = outer.offsetWidth;
	  outer.style.overflow = 'scroll';
	
	  var inner = document.createElement('div');
	  inner.style.width = '100%';
	  outer.appendChild(inner);
	
	  var widthWithScroll = inner.offsetWidth;
	  outer.parentNode.removeChild(outer);
	
	  return widthNoScroll - widthWithScroll;
	};
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scrollBarWidth = void 0;
	
	;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * VERSION: 1.20.5
	 * DATE: 2018-05-21
	 * UPDATES AND DOCS AT: http://greensock.com
	 * 
	 * Includes all of the following: TweenLite, TweenMax, TimelineLite, TimelineMax, EasePack, CSSPlugin, RoundPropsPlugin, BezierPlugin, AttrPlugin, DirectionalRotationPlugin
	 *
	 * @license Copyright (c) 2008-2018, GreenSock. All rights reserved.
	 * This work is subject to the terms at http://greensock.com/standard-license or for
	 * Club GreenSock members, the software agreement that was issued with your membership.
	 * 
	 * @author: Jack Doyle, jack@greensock.com
	 **/
	var _gsScope = (typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window; //helps ensure compatibility with AMD/RequireJS and CommonJS/Node
	(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push( function() {
	
		"use strict";
	
		_gsScope._gsDefine("TweenMax", ["core.Animation","core.SimpleTimeline","TweenLite"], function(Animation, SimpleTimeline, TweenLite) {
	
			var _slice = function(a) { //don't use [].slice because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
					var b = [],
						l = a.length,
						i;
					for (i = 0; i !== l; b.push(a[i++]));
					return b;
				},
				_applyCycle = function(vars, targets, i) {
					var alt = vars.cycle,
						p, val;
					for (p in alt) {
						val = alt[p];
						vars[p] = (typeof(val) === "function") ? val(i, targets[i]) : val[i % val.length];
					}
					delete vars.cycle;
				},
				TweenMax = function(target, duration, vars) {
					TweenLite.call(this, target, duration, vars);
					this._cycle = 0;
					this._yoyo = (this.vars.yoyo === true || !!this.vars.yoyoEase);
					this._repeat = this.vars.repeat || 0;
					this._repeatDelay = this.vars.repeatDelay || 0;
					if (this._repeat) {
						this._uncache(true); //ensures that if there is any repeat, the totalDuration will get recalculated to accurately report it.
					}
					this.render = TweenMax.prototype.render; //speed optimization (avoid prototype lookup on this "hot" method)
				},
				_tinyNum = 0.0000000001,
				TweenLiteInternals = TweenLite._internals,
				_isSelector = TweenLiteInternals.isSelector,
				_isArray = TweenLiteInternals.isArray,
				p = TweenMax.prototype = TweenLite.to({}, 0.1, {}),
				_blankArray = [];
	
			TweenMax.version = "1.20.5";
			p.constructor = TweenMax;
			p.kill()._gc = false;
			TweenMax.killTweensOf = TweenMax.killDelayedCallsTo = TweenLite.killTweensOf;
			TweenMax.getTweensOf = TweenLite.getTweensOf;
			TweenMax.lagSmoothing = TweenLite.lagSmoothing;
			TweenMax.ticker = TweenLite.ticker;
			TweenMax.render = TweenLite.render;
	
			p.invalidate = function() {
				this._yoyo = (this.vars.yoyo === true || !!this.vars.yoyoEase);
				this._repeat = this.vars.repeat || 0;
				this._repeatDelay = this.vars.repeatDelay || 0;
				this._yoyoEase = null;
				this._uncache(true);
				return TweenLite.prototype.invalidate.call(this);
			};
			
			p.updateTo = function(vars, resetDuration) {
				var curRatio = this.ratio,
					immediate = this.vars.immediateRender || vars.immediateRender,
					p;
				if (resetDuration && this._startTime < this._timeline._time) {
					this._startTime = this._timeline._time;
					this._uncache(false);
					if (this._gc) {
						this._enabled(true, false);
					} else {
						this._timeline.insert(this, this._startTime - this._delay); //ensures that any necessary re-sequencing of Animations in the timeline occurs to make sure the rendering order is correct.
					}
				}
				for (p in vars) {
					this.vars[p] = vars[p];
				}
				if (this._initted || immediate) {
					if (resetDuration) {
						this._initted = false;
						if (immediate) {
							this.render(0, true, true);
						}
					} else {
						if (this._gc) {
							this._enabled(true, false);
						}
						if (this._notifyPluginsOfEnabled && this._firstPT) {
							TweenLite._onPluginEvent("_onDisable", this); //in case a plugin like MotionBlur must perform some cleanup tasks
						}
						if (this._time / this._duration > 0.998) { //if the tween has finished (or come extremely close to finishing), we just need to rewind it to 0 and then render it again at the end which forces it to re-initialize (parsing the new vars). We allow tweens that are close to finishing (but haven't quite finished) to work this way too because otherwise, the values are so small when determining where to project the starting values that binary math issues creep in and can make the tween appear to render incorrectly when run backwards. 
							var prevTime = this._totalTime;
							this.render(0, true, false);
							this._initted = false;
							this.render(prevTime, true, false);
						} else {
							this._initted = false;
							this._init();
							if (this._time > 0 || immediate) {
								var inv = 1 / (1 - curRatio),
									pt = this._firstPT, endValue;
								while (pt) {
									endValue = pt.s + pt.c;
									pt.c *= inv;
									pt.s = endValue - pt.c;
									pt = pt._next;
								}
							}
						}
					}
				}
				return this;
			};
					
			p.render = function(time, suppressEvents, force) {
				if (!this._initted) if (this._duration === 0 && this.vars.repeat) { //zero duration tweens that render immediately have render() called from TweenLite's constructor, before TweenMax's constructor has finished setting _repeat, _repeatDelay, and _yoyo which are critical in determining totalDuration() so we need to call invalidate() which is a low-kb way to get those set properly.
					this.invalidate();
				}
				var totalDur = (!this._dirty) ? this._totalDuration : this.totalDuration(),
					prevTime = this._time,
					prevTotalTime = this._totalTime, 
					prevCycle = this._cycle,
					duration = this._duration,
					prevRawPrevTime = this._rawPrevTime,
					isComplete, callback, pt, cycleDuration, r, type, pow, rawPrevTime, yoyoEase;
				if (time >= totalDur - 0.0000001 && time >= 0) { //to work around occasional floating point math artifacts.
					this._totalTime = totalDur;
					this._cycle = this._repeat;
					if (this._yoyo && (this._cycle & 1) !== 0) {
						this._time = 0;
						this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
					} else {
						this._time = duration;
						this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1;
					}
					if (!this._reversed) {
						isComplete = true;
						callback = "onComplete";
						force = (force || this._timeline.autoRemoveChildren); //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
					}
					if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
						if (this._startTime === this._timeline._duration) { //if a zero-duration tween is at the VERY end of a timeline and that timeline renders at its end, it will typically add a tiny bit of cushion to the render time to prevent rounding errors from getting in the way of tweens rendering their VERY end. If we then reverse() that timeline, the zero-duration tween will trigger its onReverseComplete even though technically the playhead didn't pass over it again. It's a very specific edge case we must accommodate.
							time = 0;
						}
						if (prevRawPrevTime < 0 || (time <= 0 && time >= -0.0000001) || (prevRawPrevTime === _tinyNum && this.data !== "isPause")) if (prevRawPrevTime !== time) { //note: when this.data is "isPause", it's a callback added by addPause() on a timeline that we should not be triggered when LEAVING its exact start time. In other words, tl.addPause(1).play(1) shouldn't pause.
							force = true;
							if (prevRawPrevTime > _tinyNum) {
								callback = "onReverseComplete";
							}
						}
						this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					}
					
				} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
					this._totalTime = this._time = this._cycle = 0;
					this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
					if (prevTotalTime !== 0 || (duration === 0 && prevRawPrevTime > 0)) {
						callback = "onReverseComplete";
						isComplete = this._reversed;
					}
					if (time < 0) {
						this._active = false;
						if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
							if (prevRawPrevTime >= 0) {
								force = true;
							}
							this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
						}
					}
					if (!this._initted) { //if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
						force = true;
					}
				} else {
					this._totalTime = this._time = time;
					if (this._repeat !== 0) {
						cycleDuration = duration + this._repeatDelay;
						this._cycle = (this._totalTime / cycleDuration) >> 0; //originally _totalTime % cycleDuration but floating point errors caused problems, so I normalized it. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
						if (this._cycle !== 0) if (this._cycle === this._totalTime / cycleDuration && prevTotalTime <= time) {
							this._cycle--; //otherwise when rendered exactly at the end time, it will act as though it is repeating (at the beginning)
						}
						this._time = this._totalTime - (this._cycle * cycleDuration);
						if (this._yoyo) if ((this._cycle & 1) !== 0) {
							this._time = duration - this._time;
							yoyoEase = this._yoyoEase || this.vars.yoyoEase; //note: we don't set this._yoyoEase in _init() like we do other properties because it's TweenMax-specific and doing it here allows us to optimize performance (most tweens don't have a yoyoEase). Note that we also must skip the this.ratio calculation further down right after we _init() in this function, because we're doing it here.
							if (yoyoEase) {
								if (!this._yoyoEase) {
									if (yoyoEase === true && !this._initted) { //if it's not initted and yoyoEase is true, this._ease won't have been populated yet so we must discern it here.
										yoyoEase = this.vars.ease;
										this._yoyoEase = yoyoEase = !yoyoEase ? TweenLite.defaultEase : (yoyoEase instanceof Ease) ? yoyoEase : (typeof(yoyoEase) === "function") ? new Ease(yoyoEase, this.vars.easeParams) : Ease.map[yoyoEase] || TweenLite.defaultEase;
									} else {
										this._yoyoEase = yoyoEase = (yoyoEase === true) ? this._ease : (yoyoEase instanceof Ease) ? yoyoEase : Ease.map[yoyoEase];
									}
								}
								this.ratio = yoyoEase ? 1 - yoyoEase.getRatio((duration - this._time) / duration) : 0;
							}
						}
						if (this._time > duration) {
							this._time = duration;
						} else if (this._time < 0) {
							this._time = 0;
						}
					}
					if (this._easeType && !yoyoEase) {
						r = this._time / duration;
						type = this._easeType;
						pow = this._easePower;
						if (type === 1 || (type === 3 && r >= 0.5)) {
							r = 1 - r;
						}
						if (type === 3) {
							r *= 2;
						}
						if (pow === 1) {
							r *= r;
						} else if (pow === 2) {
							r *= r * r;
						} else if (pow === 3) {
							r *= r * r * r;
						} else if (pow === 4) {
							r *= r * r * r * r;
						}
	
						if (type === 1) {
							this.ratio = 1 - r;
						} else if (type === 2) {
							this.ratio = r;
						} else if (this._time / duration < 0.5) {
							this.ratio = r / 2;
						} else {
							this.ratio = 1 - (r / 2);
						}
	
					} else if (!yoyoEase) {
						this.ratio = this._ease.getRatio(this._time / duration);
					}
					
				}
					
				if (prevTime === this._time && !force && prevCycle === this._cycle) {
					if (prevTotalTime !== this._totalTime) if (this._onUpdate) if (!suppressEvents) { //so that onUpdate fires even during the repeatDelay - as long as the totalTime changed, we should trigger onUpdate.
						this._callback("onUpdate");
					}
					return;
				} else if (!this._initted) {
					this._init();
					if (!this._initted || this._gc) { //immediateRender tweens typically won't initialize until the playhead advances (_time is greater than 0) in order to ensure that overwriting occurs properly. Also, if all of the tweening properties have been overwritten (which would cause _gc to be true, as set in _init()), we shouldn't continue otherwise an onStart callback could be called for example.
						return;
					} else if (!force && this._firstPT && ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration))) { //we stick it in the queue for rendering at the very end of the tick - this is a performance optimization because browsers invalidate styles and force a recalculation if you read, write, and then read style data (so it's better to read/read/read/write/write/write than read/write/read/write/read/write). The down side, of course, is that usually you WANT things to render immediately because you may have code running right after that which depends on the change. Like imagine running TweenLite.set(...) and then immediately after that, creating a nother tween that animates the same property to another value; the starting values of that 2nd tween wouldn't be accurate if lazy is true.
						this._time = prevTime;
						this._totalTime = prevTotalTime;
						this._rawPrevTime = prevRawPrevTime;
						this._cycle = prevCycle;
						TweenLiteInternals.lazyTweens.push(this);
						this._lazy = [time, suppressEvents];
						return;
					}
					//_ease is initially set to defaultEase, so now that init() has run, _ease is set properly and we need to recalculate the ratio. Overall this is faster than using conditional logic earlier in the method to avoid having to set ratio twice because we only init() once but renderTime() gets called VERY frequently.
					if (this._time && !isComplete && !yoyoEase) {
						this.ratio = this._ease.getRatio(this._time / duration);
					} else if (isComplete && this._ease._calcEnd && !yoyoEase) {
						this.ratio = this._ease.getRatio((this._time === 0) ? 0 : 1);
					}
				}
				if (this._lazy !== false) {
					this._lazy = false;
				}
	
				if (!this._active) if (!this._paused && this._time !== prevTime && time >= 0) {
					this._active = true; //so that if the user renders a tween (as opposed to the timeline rendering it), the timeline is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the tween already finished but the user manually re-renders it as halfway done.
				}
				if (prevTotalTime === 0) {
					if (this._initted === 2 && time > 0) {
						//this.invalidate();
						this._init(); //will just apply overwriting since _initted of (2) means it was a from() tween that had immediateRender:true
					}
					if (this._startAt) {
						if (time >= 0) {
							this._startAt.render(time, true, force);
						} else if (!callback) {
							callback = "_dummyGS"; //if no callback is defined, use a dummy value just so that the condition at the end evaluates as true because _startAt should render AFTER the normal render loop when the time is negative. We could handle this in a more intuitive way, of course, but the render loop is the MOST important thing to optimize, so this technique allows us to avoid adding extra conditional logic in a high-frequency area.
						}
					}
					if (this.vars.onStart) if (this._totalTime !== 0 || duration === 0) if (!suppressEvents) {
						this._callback("onStart");
					}
				}
				
				pt = this._firstPT;
				while (pt) {
					if (pt.f) {
						pt.t[pt.p](pt.c * this.ratio + pt.s);
					} else {
						pt.t[pt.p] = pt.c * this.ratio + pt.s;
					}
					pt = pt._next;
				}
				
				if (this._onUpdate) {
					if (time < 0) if (this._startAt && this._startTime) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
						this._startAt.render(time, true, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
					}
					if (!suppressEvents) if (this._totalTime !== prevTotalTime || callback) {
						this._callback("onUpdate");
					}
				}
				if (this._cycle !== prevCycle) if (!suppressEvents) if (!this._gc) if (this.vars.onRepeat) {
					this._callback("onRepeat");
				}
				if (callback) if (!this._gc || force) { //check gc because there's a chance that kill() could be called in an onUpdate
					if (time < 0 && this._startAt && !this._onUpdate && this._startTime) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
						this._startAt.render(time, true, force);
					}
					if (isComplete) {
						if (this._timeline.autoRemoveChildren) {
							this._enabled(false, false);
						}
						this._active = false;
					}
					if (!suppressEvents && this.vars[callback]) {
						this._callback(callback);
					}
					if (duration === 0 && this._rawPrevTime === _tinyNum && rawPrevTime !== _tinyNum) { //the onComplete or onReverseComplete could trigger movement of the playhead and for zero-duration tweens (which must discern direction) that land directly back on their start time, we don't want to fire again on the next render. Think of several addPause()'s in a timeline that forces the playhead to a certain spot, but what if it's already paused and another tween is tweening the "time" of the timeline? Each time it moves [forward] past that spot, it would move back, and since suppressEvents is true, it'd reset _rawPrevTime to _tinyNum so that when it begins again, the callback would fire (so ultimately it could bounce back and forth during that tween). Again, this is a very uncommon scenario, but possible nonetheless.
						this._rawPrevTime = 0;
					}
				}
			};
			
	//---- STATIC FUNCTIONS -----------------------------------------------------------------------------------------------------------
			
			TweenMax.to = function(target, duration, vars) {
				return new TweenMax(target, duration, vars);
			};
			
			TweenMax.from = function(target, duration, vars) {
				vars.runBackwards = true;
				vars.immediateRender = (vars.immediateRender != false);
				return new TweenMax(target, duration, vars);
			};
			
			TweenMax.fromTo = function(target, duration, fromVars, toVars) {
				toVars.startAt = fromVars;
				toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
				return new TweenMax(target, duration, toVars);
			};
			
			TweenMax.staggerTo = TweenMax.allTo = function(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				stagger = stagger || 0;
				var delay = 0,
					a = [],
					finalComplete = function() {
						if (vars.onComplete) {
							vars.onComplete.apply(vars.onCompleteScope || this, arguments);
						}
						onCompleteAll.apply(onCompleteAllScope || vars.callbackScope || this, onCompleteAllParams || _blankArray);
					},
					cycle = vars.cycle,
					fromCycle = (vars.startAt && vars.startAt.cycle),
					l, copy, i, p;
				if (!_isArray(targets)) {
					if (typeof(targets) === "string") {
						targets = TweenLite.selector(targets) || targets;
					}
					if (_isSelector(targets)) {
						targets = _slice(targets);
					}
				}
				targets = targets || [];
				if (stagger < 0) {
					targets = _slice(targets);
					targets.reverse();
					stagger *= -1;
				}
				l = targets.length - 1;
				for (i = 0; i <= l; i++) {
					copy = {};
					for (p in vars) {
						copy[p] = vars[p];
					}
					if (cycle) {
						_applyCycle(copy, targets, i);
						if (copy.duration != null) {
							duration = copy.duration;
							delete copy.duration;
						}
					}
					if (fromCycle) {
						fromCycle = copy.startAt = {};
						for (p in vars.startAt) {
							fromCycle[p] = vars.startAt[p];
						}
						_applyCycle(copy.startAt, targets, i);
					}
					copy.delay = delay + (copy.delay || 0);
					if (i === l && onCompleteAll) {
						copy.onComplete = finalComplete;
					}
					a[i] = new TweenMax(targets[i], duration, copy);
					delay += stagger;
				}
				return a;
			};
			
			TweenMax.staggerFrom = TweenMax.allFrom = function(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				vars.runBackwards = true;
				vars.immediateRender = (vars.immediateRender != false);
				return TweenMax.staggerTo(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
			};
			
			TweenMax.staggerFromTo = TweenMax.allFromTo = function(targets, duration, fromVars, toVars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				toVars.startAt = fromVars;
				toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
				return TweenMax.staggerTo(targets, duration, toVars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
			};
					
			TweenMax.delayedCall = function(delay, callback, params, scope, useFrames) {
				return new TweenMax(callback, 0, {delay:delay, onComplete:callback, onCompleteParams:params, callbackScope:scope, onReverseComplete:callback, onReverseCompleteParams:params, immediateRender:false, useFrames:useFrames, overwrite:0});
			};
			
			TweenMax.set = function(target, vars) {
				return new TweenMax(target, 0, vars);
			};
			
			TweenMax.isTweening = function(target) {
				return (TweenLite.getTweensOf(target, true).length > 0);
			};
			
			var _getChildrenOf = function(timeline, includeTimelines) {
					var a = [],
						cnt = 0,
						tween = timeline._first;
					while (tween) {
						if (tween instanceof TweenLite) {
							a[cnt++] = tween;
						} else {
							if (includeTimelines) {
								a[cnt++] = tween;
							}
							a = a.concat(_getChildrenOf(tween, includeTimelines));
							cnt = a.length;
						}
						tween = tween._next;
					}
					return a;
				}, 
				getAllTweens = TweenMax.getAllTweens = function(includeTimelines) {
					return _getChildrenOf(Animation._rootTimeline, includeTimelines).concat( _getChildrenOf(Animation._rootFramesTimeline, includeTimelines) );
				};
			
			TweenMax.killAll = function(complete, tweens, delayedCalls, timelines) {
				if (tweens == null) {
					tweens = true;
				}
				if (delayedCalls == null) {
					delayedCalls = true;
				}
				var a = getAllTweens((timelines != false)),
					l = a.length,
					allTrue = (tweens && delayedCalls && timelines),
					isDC, tween, i;
				for (i = 0; i < l; i++) {
					tween = a[i];
					if (allTrue || (tween instanceof SimpleTimeline) || ((isDC = (tween.target === tween.vars.onComplete)) && delayedCalls) || (tweens && !isDC)) {
						if (complete) {
							tween.totalTime(tween._reversed ? 0 : tween.totalDuration());
						} else {
							tween._enabled(false, false);
						}
					}
				}
			};
			
			TweenMax.killChildTweensOf = function(parent, complete) {
				if (parent == null) {
					return;
				}
				var tl = TweenLiteInternals.tweenLookup,
					a, curParent, p, i, l;
				if (typeof(parent) === "string") {
					parent = TweenLite.selector(parent) || parent;
				}
				if (_isSelector(parent)) {
					parent = _slice(parent);
				}
				if (_isArray(parent)) {
					i = parent.length;
					while (--i > -1) {
						TweenMax.killChildTweensOf(parent[i], complete);
					}
					return;
				}
				a = [];
				for (p in tl) {
					curParent = tl[p].target.parentNode;
					while (curParent) {
						if (curParent === parent) {
							a = a.concat(tl[p].tweens);
						}
						curParent = curParent.parentNode;
					}
				}
				l = a.length;
				for (i = 0; i < l; i++) {
					if (complete) {
						a[i].totalTime(a[i].totalDuration());
					}
					a[i]._enabled(false, false);
				}
			};
	
			var _changePause = function(pause, tweens, delayedCalls, timelines) {
				tweens = (tweens !== false);
				delayedCalls = (delayedCalls !== false);
				timelines = (timelines !== false);
				var a = getAllTweens(timelines),
					allTrue = (tweens && delayedCalls && timelines),
					i = a.length,
					isDC, tween;
				while (--i > -1) {
					tween = a[i];
					if (allTrue || (tween instanceof SimpleTimeline) || ((isDC = (tween.target === tween.vars.onComplete)) && delayedCalls) || (tweens && !isDC)) {
						tween.paused(pause);
					}
				}
			};
			
			TweenMax.pauseAll = function(tweens, delayedCalls, timelines) {
				_changePause(true, tweens, delayedCalls, timelines);
			};
			
			TweenMax.resumeAll = function(tweens, delayedCalls, timelines) {
				_changePause(false, tweens, delayedCalls, timelines);
			};
	
			TweenMax.globalTimeScale = function(value) {
				var tl = Animation._rootTimeline,
					t = TweenLite.ticker.time;
				if (!arguments.length) {
					return tl._timeScale;
				}
				value = value || _tinyNum; //can't allow zero because it'll throw the math off
				tl._startTime = t - ((t - tl._startTime) * tl._timeScale / value);
				tl = Animation._rootFramesTimeline;
				t = TweenLite.ticker.frame;
				tl._startTime = t - ((t - tl._startTime) * tl._timeScale / value);
				tl._timeScale = Animation._rootTimeline._timeScale = value;
				return value;
			};
			
		
	//---- GETTERS / SETTERS ----------------------------------------------------------------------------------------------------------
			
			p.progress = function(value, suppressEvents) {
				return (!arguments.length) ? this._time / this.duration() : this.totalTime( this.duration() * ((this._yoyo && (this._cycle & 1) !== 0) ? 1 - value : value) + (this._cycle * (this._duration + this._repeatDelay)), suppressEvents);
			};
			
			p.totalProgress = function(value, suppressEvents) {
				return (!arguments.length) ? this._totalTime / this.totalDuration() : this.totalTime( this.totalDuration() * value, suppressEvents);
			};
			
			p.time = function(value, suppressEvents) {
				if (!arguments.length) {
					return this._time;
				}
				if (this._dirty) {
					this.totalDuration();
				}
				if (value > this._duration) {
					value = this._duration;
				}
				if (this._yoyo && (this._cycle & 1) !== 0) {
					value = (this._duration - value) + (this._cycle * (this._duration + this._repeatDelay));
				} else if (this._repeat !== 0) {
					value += this._cycle * (this._duration + this._repeatDelay);
				}
				return this.totalTime(value, suppressEvents);
			};
	
			p.duration = function(value) {
				if (!arguments.length) {
					return this._duration; //don't set _dirty = false because there could be repeats that haven't been factored into the _totalDuration yet. Otherwise, if you create a repeated TweenMax and then immediately check its duration(), it would cache the value and the totalDuration would not be correct, thus repeats wouldn't take effect.
				}
				return Animation.prototype.duration.call(this, value);
			};
	
			p.totalDuration = function(value) {
				if (!arguments.length) {
					if (this._dirty) {
						//instead of Infinity, we use 999999999999 so that we can accommodate reverses
						this._totalDuration = (this._repeat === -1) ? 999999999999 : this._duration * (this._repeat + 1) + (this._repeatDelay * this._repeat);
						this._dirty = false;
					}
					return this._totalDuration;
				}
				return (this._repeat === -1) ? this : this.duration( (value - (this._repeat * this._repeatDelay)) / (this._repeat + 1) );
			};
			
			p.repeat = function(value) {
				if (!arguments.length) {
					return this._repeat;
				}
				this._repeat = value;
				return this._uncache(true);
			};
			
			p.repeatDelay = function(value) {
				if (!arguments.length) {
					return this._repeatDelay;
				}
				this._repeatDelay = value;
				return this._uncache(true);
			};
			
			p.yoyo = function(value) {
				if (!arguments.length) {
					return this._yoyo;
				}
				this._yoyo = value;
				return this;
			};
			
			
			return TweenMax;
			
		}, true);
	
	
	
	
	
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * TimelineLite
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine("TimelineLite", ["core.Animation","core.SimpleTimeline","TweenLite"], function(Animation, SimpleTimeline, TweenLite) {
	
			var TimelineLite = function(vars) {
					SimpleTimeline.call(this, vars);
					this._labels = {};
					this.autoRemoveChildren = (this.vars.autoRemoveChildren === true);
					this.smoothChildTiming = (this.vars.smoothChildTiming === true);
					this._sortChildren = true;
					this._onUpdate = this.vars.onUpdate;
					var v = this.vars,
						val, p;
					for (p in v) {
						val = v[p];
						if (_isArray(val)) if (val.join("").indexOf("{self}") !== -1) {
							v[p] = this._swapSelfInParams(val);
						}
					}
					if (_isArray(v.tweens)) {
						this.add(v.tweens, 0, v.align, v.stagger);
					}
				},
				_tinyNum = 0.0000000001,
				TweenLiteInternals = TweenLite._internals,
				_internals = TimelineLite._internals = {},
				_isSelector = TweenLiteInternals.isSelector,
				_isArray = TweenLiteInternals.isArray,
				_lazyTweens = TweenLiteInternals.lazyTweens,
				_lazyRender = TweenLiteInternals.lazyRender,
				_globals = _gsScope._gsDefine.globals,
				_copy = function(vars) {
					var copy = {}, p;
					for (p in vars) {
						copy[p] = vars[p];
					}
					return copy;
				},
				_applyCycle = function(vars, targets, i) {
					var alt = vars.cycle,
						p, val;
					for (p in alt) {
						val = alt[p];
						vars[p] = (typeof(val) === "function") ? val(i, targets[i]) : val[i % val.length];
					}
					delete vars.cycle;
				},
				_pauseCallback = _internals.pauseCallback = function() {},
				_slice = function(a) { //don't use [].slice because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
					var b = [],
						l = a.length,
						i;
					for (i = 0; i !== l; b.push(a[i++]));
					return b;
				},
				p = TimelineLite.prototype = new SimpleTimeline();
	
			TimelineLite.version = "1.20.4";
			p.constructor = TimelineLite;
			p.kill()._gc = p._forcingPlayhead = p._hasPause = false;
	
			/* might use later...
			//translates a local time inside an animation to the corresponding time on the root/global timeline, factoring in all nesting and timeScales.
			function localToGlobal(time, animation) {
				while (animation) {
					time = (time / animation._timeScale) + animation._startTime;
					animation = animation.timeline;
				}
				return time;
			}
	
			//translates the supplied time on the root/global timeline into the corresponding local time inside a particular animation, factoring in all nesting and timeScales
			function globalToLocal(time, animation) {
				var scale = 1;
				time -= localToGlobal(0, animation);
				while (animation) {
					scale *= animation._timeScale;
					animation = animation.timeline;
				}
				return time * scale;
			}
			*/
	
			p.to = function(target, duration, vars, position) {
				var Engine = (vars.repeat && _globals.TweenMax) || TweenLite;
				return duration ? this.add( new Engine(target, duration, vars), position) : this.set(target, vars, position);
			};
	
			p.from = function(target, duration, vars, position) {
				return this.add( ((vars.repeat && _globals.TweenMax) || TweenLite).from(target, duration, vars), position);
			};
	
			p.fromTo = function(target, duration, fromVars, toVars, position) {
				var Engine = (toVars.repeat && _globals.TweenMax) || TweenLite;
				return duration ? this.add( Engine.fromTo(target, duration, fromVars, toVars), position) : this.set(target, toVars, position);
			};
	
			p.staggerTo = function(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				var tl = new TimelineLite({onComplete:onCompleteAll, onCompleteParams:onCompleteAllParams, callbackScope:onCompleteAllScope, smoothChildTiming:this.smoothChildTiming}),
					cycle = vars.cycle,
					copy, i;
				if (typeof(targets) === "string") {
					targets = TweenLite.selector(targets) || targets;
				}
				targets = targets || [];
				if (_isSelector(targets)) { //senses if the targets object is a selector. If it is, we should translate it into an array.
					targets = _slice(targets);
				}
				stagger = stagger || 0;
				if (stagger < 0) {
					targets = _slice(targets);
					targets.reverse();
					stagger *= -1;
				}
				for (i = 0; i < targets.length; i++) {
					copy = _copy(vars);
					if (copy.startAt) {
						copy.startAt = _copy(copy.startAt);
						if (copy.startAt.cycle) {
							_applyCycle(copy.startAt, targets, i);
						}
					}
					if (cycle) {
						_applyCycle(copy, targets, i);
						if (copy.duration != null) {
							duration = copy.duration;
							delete copy.duration;
						}
					}
					tl.to(targets[i], duration, copy, i * stagger);
				}
				return this.add(tl, position);
			};
	
			p.staggerFrom = function(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				vars.immediateRender = (vars.immediateRender != false);
				vars.runBackwards = true;
				return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
			};
	
			p.staggerFromTo = function(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				toVars.startAt = fromVars;
				toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
				return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
			};
	
			p.call = function(callback, params, scope, position) {
				return this.add( TweenLite.delayedCall(0, callback, params, scope), position);
			};
	
			p.set = function(target, vars, position) {
				position = this._parseTimeOrLabel(position, 0, true);
				if (vars.immediateRender == null) {
					vars.immediateRender = (position === this._time && !this._paused);
				}
				return this.add( new TweenLite(target, 0, vars), position);
			};
	
			TimelineLite.exportRoot = function(vars, ignoreDelayedCalls) {
				vars = vars || {};
				if (vars.smoothChildTiming == null) {
					vars.smoothChildTiming = true;
				}
				var tl = new TimelineLite(vars),
					root = tl._timeline,
					hasNegativeStart, time,	tween, next;
				if (ignoreDelayedCalls == null) {
					ignoreDelayedCalls = true;
				}
				root._remove(tl, true);
				tl._startTime = 0;
				tl._rawPrevTime = tl._time = tl._totalTime = root._time;
				tween = root._first;
				while (tween) {
					next = tween._next;
					if (!ignoreDelayedCalls || !(tween instanceof TweenLite && tween.target === tween.vars.onComplete)) {
						time = tween._startTime - tween._delay;
						if (time < 0) {
							hasNegativeStart = 1;
						}
						tl.add(tween, time);
					}
					tween = next;
				}
				root.add(tl, 0);
				if (hasNegativeStart) { //calling totalDuration() will force the adjustment necessary to shift the children forward so none of them start before zero, and moves the timeline backwards the same amount, so the playhead is still aligned where it should be globally, but the timeline doesn't have illegal children that start before zero.
					tl.totalDuration();
				}
				return tl;
			};
	
			p.add = function(value, position, align, stagger) {
				var curTime, l, i, child, tl, beforeRawTime;
				if (typeof(position) !== "number") {
					position = this._parseTimeOrLabel(position, 0, true, value);
				}
				if (!(value instanceof Animation)) {
					if ((value instanceof Array) || (value && value.push && _isArray(value))) {
						align = align || "normal";
						stagger = stagger || 0;
						curTime = position;
						l = value.length;
						for (i = 0; i < l; i++) {
							if (_isArray(child = value[i])) {
								child = new TimelineLite({tweens:child});
							}
							this.add(child, curTime);
							if (typeof(child) !== "string" && typeof(child) !== "function") {
								if (align === "sequence") {
									curTime = child._startTime + (child.totalDuration() / child._timeScale);
								} else if (align === "start") {
									child._startTime -= child.delay();
								}
							}
							curTime += stagger;
						}
						return this._uncache(true);
					} else if (typeof(value) === "string") {
						return this.addLabel(value, position);
					} else if (typeof(value) === "function") {
						value = TweenLite.delayedCall(0, value);
					} else {
						throw("Cannot add " + value + " into the timeline; it is not a tween, timeline, function, or string.");
					}
				}
	
				SimpleTimeline.prototype.add.call(this, value, position);
	
				if (value._time) { //in case, for example, the _startTime is moved on a tween that has already rendered. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning.
					value.render((this.rawTime() - value._startTime) * value._timeScale, false, false);
				}
	
				//if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
				if (this._gc || this._time === this._duration) if (!this._paused) if (this._duration < this.duration()) {
					//in case any of the ancestors had completed but should now be enabled...
					tl = this;
					beforeRawTime = (tl.rawTime() > value._startTime); //if the tween is placed on the timeline so that it starts BEFORE the current rawTime, we should align the playhead (move the timeline). This is because sometimes users will create a timeline, let it finish, and much later append a tween and expect it to run instead of jumping to its end state. While technically one could argue that it should jump to its end state, that's not what users intuitively expect.
					while (tl._timeline) {
						if (beforeRawTime && tl._timeline.smoothChildTiming) {
							tl.totalTime(tl._totalTime, true); //moves the timeline (shifts its startTime) if necessary, and also enables it.
						} else if (tl._gc) {
							tl._enabled(true, false);
						}
						tl = tl._timeline;
					}
				}
	
				return this;
			};
	
			p.remove = function(value) {
				if (value instanceof Animation) {
					this._remove(value, false);
					var tl = value._timeline = value.vars.useFrames ? Animation._rootFramesTimeline : Animation._rootTimeline; //now that it's removed, default it to the root timeline so that if it gets played again, it doesn't jump back into this timeline.
					value._startTime = (value._paused ? value._pauseTime : tl._time) - ((!value._reversed ? value._totalTime : value.totalDuration() - value._totalTime) / value._timeScale); //ensure that if it gets played again, the timing is correct.
					return this;
				} else if (value instanceof Array || (value && value.push && _isArray(value))) {
					var i = value.length;
					while (--i > -1) {
						this.remove(value[i]);
					}
					return this;
				} else if (typeof(value) === "string") {
					return this.removeLabel(value);
				}
				return this.kill(null, value);
			};
	
			p._remove = function(tween, skipDisable) {
				SimpleTimeline.prototype._remove.call(this, tween, skipDisable);
				var last = this._last;
				if (!last) {
					this._time = this._totalTime = this._duration = this._totalDuration = 0;
				} else if (this._time > this.duration()) {
					this._time = this._duration;
					this._totalTime = this._totalDuration;
				}
				return this;
			};
	
			p.append = function(value, offsetOrLabel) {
				return this.add(value, this._parseTimeOrLabel(null, offsetOrLabel, true, value));
			};
	
			p.insert = p.insertMultiple = function(value, position, align, stagger) {
				return this.add(value, position || 0, align, stagger);
			};
	
			p.appendMultiple = function(tweens, offsetOrLabel, align, stagger) {
				return this.add(tweens, this._parseTimeOrLabel(null, offsetOrLabel, true, tweens), align, stagger);
			};
	
			p.addLabel = function(label, position) {
				this._labels[label] = this._parseTimeOrLabel(position);
				return this;
			};
	
			p.addPause = function(position, callback, params, scope) {
				var t = TweenLite.delayedCall(0, _pauseCallback, params, scope || this);
				t.vars.onComplete = t.vars.onReverseComplete = callback;
				t.data = "isPause";
				this._hasPause = true;
				return this.add(t, position);
			};
	
			p.removeLabel = function(label) {
				delete this._labels[label];
				return this;
			};
	
			p.getLabelTime = function(label) {
				return (this._labels[label] != null) ? this._labels[label] : -1;
			};
	
			p._parseTimeOrLabel = function(timeOrLabel, offsetOrLabel, appendIfAbsent, ignore) {
				var clippedDuration, i;
				//if we're about to add a tween/timeline (or an array of them) that's already a child of this timeline, we should remove it first so that it doesn't contaminate the duration().
				if (ignore instanceof Animation && ignore.timeline === this) {
					this.remove(ignore);
				} else if (ignore && ((ignore instanceof Array) || (ignore.push && _isArray(ignore)))) {
					i = ignore.length;
					while (--i > -1) {
						if (ignore[i] instanceof Animation && ignore[i].timeline === this) {
							this.remove(ignore[i]);
						}
					}
				}
				clippedDuration = (typeof(timeOrLabel) === "number" && !offsetOrLabel) ? 0 : (this.duration() > 99999999999) ? this.recent().endTime(false) : this._duration; //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
				if (typeof(offsetOrLabel) === "string") {
					return this._parseTimeOrLabel(offsetOrLabel, (appendIfAbsent && typeof(timeOrLabel) === "number" && this._labels[offsetOrLabel] == null) ? timeOrLabel - clippedDuration : 0, appendIfAbsent);
				}
				offsetOrLabel = offsetOrLabel || 0;
				if (typeof(timeOrLabel) === "string" && (isNaN(timeOrLabel) || this._labels[timeOrLabel] != null)) { //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
					i = timeOrLabel.indexOf("=");
					if (i === -1) {
						if (this._labels[timeOrLabel] == null) {
							return appendIfAbsent ? (this._labels[timeOrLabel] = clippedDuration + offsetOrLabel) : offsetOrLabel;
						}
						return this._labels[timeOrLabel] + offsetOrLabel;
					}
					offsetOrLabel = parseInt(timeOrLabel.charAt(i-1) + "1", 10) * Number(timeOrLabel.substr(i+1));
					timeOrLabel = (i > 1) ? this._parseTimeOrLabel(timeOrLabel.substr(0, i-1), 0, appendIfAbsent) : clippedDuration;
				} else if (timeOrLabel == null) {
					timeOrLabel = clippedDuration;
				}
				return Number(timeOrLabel) + offsetOrLabel;
			};
	
			p.seek = function(position, suppressEvents) {
				return this.totalTime((typeof(position) === "number") ? position : this._parseTimeOrLabel(position), (suppressEvents !== false));
			};
	
			p.stop = function() {
				return this.paused(true);
			};
	
			p.gotoAndPlay = function(position, suppressEvents) {
				return this.play(position, suppressEvents);
			};
	
			p.gotoAndStop = function(position, suppressEvents) {
				return this.pause(position, suppressEvents);
			};
	
			p.render = function(time, suppressEvents, force) {
				if (this._gc) {
					this._enabled(true, false);
				}
				var prevTime = this._time,
					totalDur = (!this._dirty) ? this._totalDuration : this.totalDuration(),
					prevStart = this._startTime,
					prevTimeScale = this._timeScale,
					prevPaused = this._paused,
					tween, isComplete, next, callback, internalForce, pauseTween, curTime;
				if (prevTime !== this._time) { //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
					time += this._time - prevTime;
				}
				if (time >= totalDur - 0.0000001 && time >= 0) { //to work around occasional floating point math artifacts.
					this._totalTime = this._time = totalDur;
					if (!this._reversed) if (!this._hasPausedChild()) {
						isComplete = true;
						callback = "onComplete";
						internalForce = !!this._timeline.autoRemoveChildren; //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
						if (this._duration === 0) if ((time <= 0 && time >= -0.0000001) || this._rawPrevTime < 0 || this._rawPrevTime === _tinyNum) if (this._rawPrevTime !== time && this._first) {
							internalForce = true;
							if (this._rawPrevTime > _tinyNum) {
								callback = "onReverseComplete";
							}
						}
					}
					this._rawPrevTime = (this._duration || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					time = totalDur + 0.0001; //to avoid occasional floating point rounding errors - sometimes child tweens/timelines were not being fully completed (their progress might be 0.999999999999998 instead of 1 because when _time - tween._startTime is performed, floating point errors would return a value that was SLIGHTLY off). Try (999999999999.7 - 999999999999) * 1 = 0.699951171875 instead of 0.7.
	
				} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
					this._totalTime = this._time = 0;
					if (prevTime !== 0 || (this._duration === 0 && this._rawPrevTime !== _tinyNum && (this._rawPrevTime > 0 || (time < 0 && this._rawPrevTime >= 0)))) {
						callback = "onReverseComplete";
						isComplete = this._reversed;
					}
					if (time < 0) {
						this._active = false;
						if (this._timeline.autoRemoveChildren && this._reversed) { //ensures proper GC if a timeline is resumed after it's finished reversing.
							internalForce = isComplete = true;
							callback = "onReverseComplete";
						} else if (this._rawPrevTime >= 0 && this._first) { //when going back beyond the start, force a render so that zero-duration tweens that sit at the very beginning render their start values properly. Otherwise, if the parent timeline's playhead lands exactly at this timeline's startTime, and then moves backwards, the zero-duration tweens at the beginning would still be at their end state.
							internalForce = true;
						}
						this._rawPrevTime = time;
					} else {
						this._rawPrevTime = (this._duration || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
						if (time === 0 && isComplete) { //if there's a zero-duration tween at the very beginning of a timeline and the playhead lands EXACTLY at time 0, that tween will correctly render its end values, but we need to keep the timeline alive for one more render so that the beginning values render properly as the parent's playhead keeps moving beyond the begining. Imagine obj.x starts at 0 and then we do tl.set(obj, {x:100}).to(obj, 1, {x:200}) and then later we tl.reverse()...the goal is to have obj.x revert to 0. If the playhead happens to land on exactly 0, without this chunk of code, it'd complete the timeline and remove it from the rendering queue (not good).
							tween = this._first;
							while (tween && tween._startTime === 0) {
								if (!tween._duration) {
									isComplete = false;
								}
								tween = tween._next;
							}
						}
						time = 0; //to avoid occasional floating point rounding errors (could cause problems especially with zero-duration tweens at the very beginning of the timeline)
						if (!this._initted) {
							internalForce = true;
						}
					}
	
				} else {
	
					if (this._hasPause && !this._forcingPlayhead && !suppressEvents) {
						if (time >= prevTime) {
							tween = this._first;
							while (tween && tween._startTime <= time && !pauseTween) {
								if (!tween._duration) if (tween.data === "isPause" && !tween.ratio && !(tween._startTime === 0 && this._rawPrevTime === 0)) {
									pauseTween = tween;
								}
								tween = tween._next;
							}
						} else {
							tween = this._last;
							while (tween && tween._startTime >= time && !pauseTween) {
								if (!tween._duration) if (tween.data === "isPause" && tween._rawPrevTime > 0) {
									pauseTween = tween;
								}
								tween = tween._prev;
							}
						}
						if (pauseTween) {
							this._time = time = pauseTween._startTime;
							this._totalTime = time + (this._cycle * (this._totalDuration + this._repeatDelay));
						}
					}
	
					this._totalTime = this._time = this._rawPrevTime = time;
				}
				if ((this._time === prevTime || !this._first) && !force && !internalForce && !pauseTween) {
					return;
				} else if (!this._initted) {
					this._initted = true;
				}
	
				if (!this._active) if (!this._paused && this._time !== prevTime && time > 0) {
					this._active = true;  //so that if the user renders the timeline (as opposed to the parent timeline rendering it), it is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the timeline already finished but the user manually re-renders it as halfway done, for example.
				}
	
				if (prevTime === 0) if (this.vars.onStart) if (this._time !== 0 || !this._duration) if (!suppressEvents) {
					this._callback("onStart");
				}
	
				curTime = this._time;
				if (curTime >= prevTime) {
					tween = this._first;
					while (tween) {
						next = tween._next; //record it here because the value could change after rendering...
						if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
							break;
						} else if (tween._active || (tween._startTime <= curTime && !tween._paused && !tween._gc)) {
							if (pauseTween === tween) {
								this.pause();
							}
							if (!tween._reversed) {
								tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
							} else {
								tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
							}
						}
						tween = next;
					}
				} else {
					tween = this._last;
					while (tween) {
						next = tween._prev; //record it here because the value could change after rendering...
						if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
							break;
						} else if (tween._active || (tween._startTime <= prevTime && !tween._paused && !tween._gc)) {
							if (pauseTween === tween) {
								pauseTween = tween._prev; //the linked list is organized by _startTime, thus it's possible that a tween could start BEFORE the pause and end after it, in which case it would be positioned before the pause tween in the linked list, but we should render it before we pause() the timeline and cease rendering. This is only a concern when going in reverse.
								while (pauseTween && pauseTween.endTime() > this._time) {
									pauseTween.render( (pauseTween._reversed ? pauseTween.totalDuration() - ((time - pauseTween._startTime) * pauseTween._timeScale) : (time - pauseTween._startTime) * pauseTween._timeScale), suppressEvents, force);
									pauseTween = pauseTween._prev;
								}
								pauseTween = null;
								this.pause();
							}
							if (!tween._reversed) {
								tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
							} else {
								tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
							}
						}
						tween = next;
					}
				}
	
				if (this._onUpdate) if (!suppressEvents) {
					if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
						_lazyRender();
					}
					this._callback("onUpdate");
				}
	
				if (callback) if (!this._gc) if (prevStart === this._startTime || prevTimeScale !== this._timeScale) if (this._time === 0 || totalDur >= this.totalDuration()) { //if one of the tweens that was rendered altered this timeline's startTime (like if an onComplete reversed the timeline), it probably isn't complete. If it is, don't worry, because whatever call altered the startTime would complete if it was necessary at the new time. The only exception is the timeScale property. Also check _gc because there's a chance that kill() could be called in an onUpdate
					if (isComplete) {
						if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onComplete on a timeline that reports/checks tweened values.
							_lazyRender();
						}
						if (this._timeline.autoRemoveChildren) {
							this._enabled(false, false);
						}
						this._active = false;
					}
					if (!suppressEvents && this.vars[callback]) {
						this._callback(callback);
					}
				}
			};
	
			p._hasPausedChild = function() {
				var tween = this._first;
				while (tween) {
					if (tween._paused || ((tween instanceof TimelineLite) && tween._hasPausedChild())) {
						return true;
					}
					tween = tween._next;
				}
				return false;
			};
	
			p.getChildren = function(nested, tweens, timelines, ignoreBeforeTime) {
				ignoreBeforeTime = ignoreBeforeTime || -9999999999;
				var a = [],
					tween = this._first,
					cnt = 0;
				while (tween) {
					if (tween._startTime < ignoreBeforeTime) {
						//do nothing
					} else if (tween instanceof TweenLite) {
						if (tweens !== false) {
							a[cnt++] = tween;
						}
					} else {
						if (timelines !== false) {
							a[cnt++] = tween;
						}
						if (nested !== false) {
							a = a.concat(tween.getChildren(true, tweens, timelines));
							cnt = a.length;
						}
					}
					tween = tween._next;
				}
				return a;
			};
	
			p.getTweensOf = function(target, nested) {
				var disabled = this._gc,
					a = [],
					cnt = 0,
					tweens, i;
				if (disabled) {
					this._enabled(true, true); //getTweensOf() filters out disabled tweens, and we have to mark them as _gc = true when the timeline completes in order to allow clean garbage collection, so temporarily re-enable the timeline here.
				}
				tweens = TweenLite.getTweensOf(target);
				i = tweens.length;
				while (--i > -1) {
					if (tweens[i].timeline === this || (nested && this._contains(tweens[i]))) {
						a[cnt++] = tweens[i];
					}
				}
				if (disabled) {
					this._enabled(false, true);
				}
				return a;
			};
	
			p.recent = function() {
				return this._recent;
			};
	
			p._contains = function(tween) {
				var tl = tween.timeline;
				while (tl) {
					if (tl === this) {
						return true;
					}
					tl = tl.timeline;
				}
				return false;
			};
	
			p.shiftChildren = function(amount, adjustLabels, ignoreBeforeTime) {
				ignoreBeforeTime = ignoreBeforeTime || 0;
				var tween = this._first,
					labels = this._labels,
					p;
				while (tween) {
					if (tween._startTime >= ignoreBeforeTime) {
						tween._startTime += amount;
					}
					tween = tween._next;
				}
				if (adjustLabels) {
					for (p in labels) {
						if (labels[p] >= ignoreBeforeTime) {
							labels[p] += amount;
						}
					}
				}
				return this._uncache(true);
			};
	
			p._kill = function(vars, target) {
				if (!vars && !target) {
					return this._enabled(false, false);
				}
				var tweens = (!target) ? this.getChildren(true, true, false) : this.getTweensOf(target),
					i = tweens.length,
					changed = false;
				while (--i > -1) {
					if (tweens[i]._kill(vars, target)) {
						changed = true;
					}
				}
				return changed;
			};
	
			p.clear = function(labels) {
				var tweens = this.getChildren(false, true, true),
					i = tweens.length;
				this._time = this._totalTime = 0;
				while (--i > -1) {
					tweens[i]._enabled(false, false);
				}
				if (labels !== false) {
					this._labels = {};
				}
				return this._uncache(true);
			};
	
			p.invalidate = function() {
				var tween = this._first;
				while (tween) {
					tween.invalidate();
					tween = tween._next;
				}
				return Animation.prototype.invalidate.call(this);;
			};
	
			p._enabled = function(enabled, ignoreTimeline) {
				if (enabled === this._gc) {
					var tween = this._first;
					while (tween) {
						tween._enabled(enabled, true);
						tween = tween._next;
					}
				}
				return SimpleTimeline.prototype._enabled.call(this, enabled, ignoreTimeline);
			};
	
			p.totalTime = function(time, suppressEvents, uncapped) {
				this._forcingPlayhead = true;
				var val = Animation.prototype.totalTime.apply(this, arguments);
				this._forcingPlayhead = false;
				return val;
			};
	
			p.duration = function(value) {
				if (!arguments.length) {
					if (this._dirty) {
						this.totalDuration(); //just triggers recalculation
					}
					return this._duration;
				}
				if (this.duration() !== 0 && value !== 0) {
					this.timeScale(this._duration / value);
				}
				return this;
			};
	
			p.totalDuration = function(value) {
				if (!arguments.length) {
					if (this._dirty) {
						var max = 0,
							tween = this._last,
							prevStart = 999999999999,
							prev, end;
						while (tween) {
							prev = tween._prev; //record it here in case the tween changes position in the sequence...
							if (tween._dirty) {
								tween.totalDuration(); //could change the tween._startTime, so make sure the tween's cache is clean before analyzing it.
							}
							if (tween._startTime > prevStart && this._sortChildren && !tween._paused && !this._calculatingDuration) { //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
								this._calculatingDuration = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add(), like _parseTimeOrLabel().
								this.add(tween, tween._startTime - tween._delay);
								this._calculatingDuration = 0;
							} else {
								prevStart = tween._startTime;
							}
							if (tween._startTime < 0 && !tween._paused) { //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
								max -= tween._startTime;
								if (this._timeline.smoothChildTiming) {
									this._startTime += tween._startTime / this._timeScale;
									this._time -= tween._startTime;
									this._totalTime -= tween._startTime;
									this._rawPrevTime -= tween._startTime;
								}
								this.shiftChildren(-tween._startTime, false, -9999999999);
								prevStart = 0;
							}
							end = tween._startTime + (tween._totalDuration / tween._timeScale);
							if (end > max) {
								max = end;
							}
							tween = prev;
						}
						this._duration = this._totalDuration = max;
						this._dirty = false;
					}
					return this._totalDuration;
				}
				return (value && this.totalDuration()) ? this.timeScale(this._totalDuration / value) : this;
			};
	
			p.paused = function(value) {
				if (!value) { //if there's a pause directly at the spot from where we're unpausing, skip it.
					var tween = this._first,
						time = this._time;
					while (tween) {
						if (tween._startTime === time && tween.data === "isPause") {
							tween._rawPrevTime = 0; //remember, _rawPrevTime is how zero-duration tweens/callbacks sense directionality and determine whether or not to fire. If _rawPrevTime is the same as _startTime on the next render, it won't fire.
						}
						tween = tween._next;
					}
				}
				return Animation.prototype.paused.apply(this, arguments);
			};
	
			p.usesFrames = function() {
				var tl = this._timeline;
				while (tl._timeline) {
					tl = tl._timeline;
				}
				return (tl === Animation._rootFramesTimeline);
			};
	
			p.rawTime = function(wrapRepeats) {
				return (wrapRepeats && (this._paused || (this._repeat && this.time() > 0 && this.totalProgress() < 1))) ? this._totalTime % (this._duration + this._repeatDelay) : this._paused ? this._totalTime : (this._timeline.rawTime(wrapRepeats) - this._startTime) * this._timeScale;
			};
	
			return TimelineLite;
	
		}, true);
	
	
	
	
	
	
	
	
		
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * TimelineMax
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine("TimelineMax", ["TimelineLite","TweenLite","easing.Ease"], function(TimelineLite, TweenLite, Ease) {
	
			var TimelineMax = function(vars) {
					TimelineLite.call(this, vars);
					this._repeat = this.vars.repeat || 0;
					this._repeatDelay = this.vars.repeatDelay || 0;
					this._cycle = 0;
					this._yoyo = (this.vars.yoyo === true);
					this._dirty = true;
				},
				_tinyNum = 0.0000000001,
				TweenLiteInternals = TweenLite._internals,
				_lazyTweens = TweenLiteInternals.lazyTweens,
				_lazyRender = TweenLiteInternals.lazyRender,
				_globals = _gsScope._gsDefine.globals,
				_easeNone = new Ease(null, null, 1, 0),
				p = TimelineMax.prototype = new TimelineLite();
	
			p.constructor = TimelineMax;
			p.kill()._gc = false;
			TimelineMax.version = "1.20.4";
	
			p.invalidate = function() {
				this._yoyo = (this.vars.yoyo === true);
				this._repeat = this.vars.repeat || 0;
				this._repeatDelay = this.vars.repeatDelay || 0;
				this._uncache(true);
				return TimelineLite.prototype.invalidate.call(this);
			};
	
			p.addCallback = function(callback, position, params, scope) {
				return this.add( TweenLite.delayedCall(0, callback, params, scope), position);
			};
	
			p.removeCallback = function(callback, position) {
				if (callback) {
					if (position == null) {
						this._kill(null, callback);
					} else {
						var a = this.getTweensOf(callback, false),
							i = a.length,
							time = this._parseTimeOrLabel(position);
						while (--i > -1) {
							if (a[i]._startTime === time) {
								a[i]._enabled(false, false);
							}
						}
					}
				}
				return this;
			};
	
			p.removePause = function(position) {
				return this.removeCallback(TimelineLite._internals.pauseCallback, position);
			};
	
			p.tweenTo = function(position, vars) {
				vars = vars || {};
				var copy = {ease:_easeNone, useFrames:this.usesFrames(), immediateRender:false, lazy:false},
					Engine = (vars.repeat && _globals.TweenMax) || TweenLite,
					duration, p, t;
				for (p in vars) {
					copy[p] = vars[p];
				}
				copy.time = this._parseTimeOrLabel(position);
				duration = (Math.abs(Number(copy.time) - this._time) / this._timeScale) || 0.001;
				t = new Engine(this, duration, copy);
				copy.onStart = function() {
					t.target.paused(true);
					if (t.vars.time !== t.target.time() && duration === t.duration() && !t.isFromTo) { //don't make the duration zero - if it's supposed to be zero, don't worry because it's already initting the tween and will complete immediately, effectively making the duration zero anyway. If we make duration zero, the tween won't run at all.
						t.duration( Math.abs( t.vars.time - t.target.time()) / t.target._timeScale ).render(t.time(), true, true); //render() right away to ensure that things look right, especially in the case of .tweenTo(0).
					}
					if (vars.onStart) { //in case the user had an onStart in the vars - we don't want to overwrite it.
						vars.onStart.apply(vars.onStartScope || vars.callbackScope || t, vars.onStartParams || []); //don't use t._callback("onStart") or it'll point to the copy.onStart and we'll get a recursion error.
					}
				};
				return t;
			};
	
			p.tweenFromTo = function(fromPosition, toPosition, vars) {
				vars = vars || {};
				fromPosition = this._parseTimeOrLabel(fromPosition);
				vars.startAt = {onComplete:this.seek, onCompleteParams:[fromPosition], callbackScope:this};
				vars.immediateRender = (vars.immediateRender !== false);
				var t = this.tweenTo(toPosition, vars);
				t.isFromTo = 1; //to ensure we don't mess with the duration in the onStart (we've got the start and end values here, so lock it in)
				return t.duration((Math.abs( t.vars.time - fromPosition) / this._timeScale) || 0.001);
			};
	
			p.render = function(time, suppressEvents, force) {
				if (this._gc) {
					this._enabled(true, false);
				}
				var prevTime = this._time,
					totalDur = (!this._dirty) ? this._totalDuration : this.totalDuration(),
					dur = this._duration,
					prevTotalTime = this._totalTime,
					prevStart = this._startTime,
					prevTimeScale = this._timeScale,
					prevRawPrevTime = this._rawPrevTime,
					prevPaused = this._paused,
					prevCycle = this._cycle,
					tween, isComplete, next, callback, internalForce, cycleDuration, pauseTween, curTime;
				if (prevTime !== this._time) { //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
					time += this._time - prevTime;
				}
				if (time >= totalDur - 0.0000001 && time >= 0) { //to work around occasional floating point math artifacts.
					if (!this._locked) {
						this._totalTime = totalDur;
						this._cycle = this._repeat;
					}
					if (!this._reversed) if (!this._hasPausedChild()) {
						isComplete = true;
						callback = "onComplete";
						internalForce = !!this._timeline.autoRemoveChildren; //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
						if (this._duration === 0) if ((time <= 0 && time >= -0.0000001) || prevRawPrevTime < 0 || prevRawPrevTime === _tinyNum) if (prevRawPrevTime !== time && this._first) {
							internalForce = true;
							if (prevRawPrevTime > _tinyNum) {
								callback = "onReverseComplete";
							}
						}
					}
					this._rawPrevTime = (this._duration || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					if (this._yoyo && (this._cycle & 1) !== 0) {
						this._time = time = 0;
					} else {
						this._time = dur;
						time = dur + 0.0001; //to avoid occasional floating point rounding errors - sometimes child tweens/timelines were not being fully completed (their progress might be 0.999999999999998 instead of 1 because when _time - tween._startTime is performed, floating point errors would return a value that was SLIGHTLY off). Try (999999999999.7 - 999999999999) * 1 = 0.699951171875 instead of 0.7. We cannot do less then 0.0001 because the same issue can occur when the duration is extremely large like 999999999999 in which case adding 0.00000001, for example, causes it to act like nothing was added.
					}
	
				} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
					if (!this._locked) {
						this._totalTime = this._cycle = 0;
					}
					this._time = 0;
					if (prevTime !== 0 || (dur === 0 && prevRawPrevTime !== _tinyNum && (prevRawPrevTime > 0 || (time < 0 && prevRawPrevTime >= 0)) && !this._locked)) { //edge case for checking time < 0 && prevRawPrevTime >= 0: a zero-duration fromTo() tween inside a zero-duration timeline (yeah, very rare)
						callback = "onReverseComplete";
						isComplete = this._reversed;
					}
					if (time < 0) {
						this._active = false;
						if (this._timeline.autoRemoveChildren && this._reversed) {
							internalForce = isComplete = true;
							callback = "onReverseComplete";
						} else if (prevRawPrevTime >= 0 && this._first) { //when going back beyond the start, force a render so that zero-duration tweens that sit at the very beginning render their start values properly. Otherwise, if the parent timeline's playhead lands exactly at this timeline's startTime, and then moves backwards, the zero-duration tweens at the beginning would still be at their end state.
							internalForce = true;
						}
						this._rawPrevTime = time;
					} else {
						this._rawPrevTime = (dur || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
						if (time === 0 && isComplete) { //if there's a zero-duration tween at the very beginning of a timeline and the playhead lands EXACTLY at time 0, that tween will correctly render its end values, but we need to keep the timeline alive for one more render so that the beginning values render properly as the parent's playhead keeps moving beyond the begining. Imagine obj.x starts at 0 and then we do tl.set(obj, {x:100}).to(obj, 1, {x:200}) and then later we tl.reverse()...the goal is to have obj.x revert to 0. If the playhead happens to land on exactly 0, without this chunk of code, it'd complete the timeline and remove it from the rendering queue (not good).
							tween = this._first;
							while (tween && tween._startTime === 0) {
								if (!tween._duration) {
									isComplete = false;
								}
								tween = tween._next;
							}
						}
						time = 0; //to avoid occasional floating point rounding errors (could cause problems especially with zero-duration tweens at the very beginning of the timeline)
						if (!this._initted) {
							internalForce = true;
						}
					}
	
				} else {
					if (dur === 0 && prevRawPrevTime < 0) { //without this, zero-duration repeating timelines (like with a simple callback nested at the very beginning and a repeatDelay) wouldn't render the first time through.
						internalForce = true;
					}
					this._time = this._rawPrevTime = time;
					if (!this._locked) {
						this._totalTime = time;
						if (this._repeat !== 0) {
							cycleDuration = dur + this._repeatDelay;
							this._cycle = (this._totalTime / cycleDuration) >> 0; //originally _totalTime % cycleDuration but floating point errors caused problems, so I normalized it. (4 % 0.8 should be 0 but it gets reported as 0.79999999!)
							if (this._cycle !== 0) if (this._cycle === this._totalTime / cycleDuration && prevTotalTime <= time) {
								this._cycle--; //otherwise when rendered exactly at the end time, it will act as though it is repeating (at the beginning)
							}
							this._time = this._totalTime - (this._cycle * cycleDuration);
							if (this._yoyo) if ((this._cycle & 1) !== 0) {
								this._time = dur - this._time;
							}
							if (this._time > dur) {
								this._time = dur;
								time = dur + 0.0001; //to avoid occasional floating point rounding error
							} else if (this._time < 0) {
								this._time = time = 0;
							} else {
								time = this._time;
							}
						}
					}
	
					if (this._hasPause && !this._forcingPlayhead && !suppressEvents) {
						time = this._time;
						if (time >= prevTime || (this._repeat && prevCycle !== this._cycle)) {
							tween = this._first;
							while (tween && tween._startTime <= time && !pauseTween) {
								if (!tween._duration) if (tween.data === "isPause" && !tween.ratio && !(tween._startTime === 0 && this._rawPrevTime === 0)) {
									pauseTween = tween;
								}
								tween = tween._next;
							}
						} else {
							tween = this._last;
							while (tween && tween._startTime >= time && !pauseTween) {
								if (!tween._duration) if (tween.data === "isPause" && tween._rawPrevTime > 0) {
									pauseTween = tween;
								}
								tween = tween._prev;
							}
						}
						if (pauseTween && pauseTween._startTime < dur) {
							this._time = time = pauseTween._startTime;
							this._totalTime = time + (this._cycle * (this._totalDuration + this._repeatDelay));
						}
					}
	
				}
	
				if (this._cycle !== prevCycle) if (!this._locked) {
					/*
					make sure children at the end/beginning of the timeline are rendered properly. If, for example,
					a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
					would get transated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
					could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
					we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
					ensure that zero-duration tweens at the very beginning or end of the TimelineMax work.
					*/
					var backwards = (this._yoyo && (prevCycle & 1) !== 0),
						wrap = (backwards === (this._yoyo && (this._cycle & 1) !== 0)),
						recTotalTime = this._totalTime,
						recCycle = this._cycle,
						recRawPrevTime = this._rawPrevTime,
						recTime = this._time;
	
					this._totalTime = prevCycle * dur;
					if (this._cycle < prevCycle) {
						backwards = !backwards;
					} else {
						this._totalTime += dur;
					}
					this._time = prevTime; //temporarily revert _time so that render() renders the children in the correct order. Without this, tweens won't rewind correctly. We could arhictect things in a "cleaner" way by splitting out the rendering queue into a separate method but for performance reasons, we kept it all inside this method.
	
					this._rawPrevTime = (dur === 0) ? prevRawPrevTime - 0.0001 : prevRawPrevTime;
					this._cycle = prevCycle;
					this._locked = true; //prevents changes to totalTime and skips repeat/yoyo behavior when we recursively call render()
					prevTime = (backwards) ? 0 : dur;
					this.render(prevTime, suppressEvents, (dur === 0));
					if (!suppressEvents) if (!this._gc) {
						if (this.vars.onRepeat) {
							this._cycle = recCycle; //in case the onRepeat alters the playhead or invalidates(), we shouldn't stay locked or use the previous cycle.
							this._locked = false;
							this._callback("onRepeat");
						}
					}
					if (prevTime !== this._time) { //in case there's a callback like onComplete in a nested tween/timeline that changes the playhead position, like via seek(), we should just abort.
						return;
					}
					if (wrap) {
						this._cycle = prevCycle; //if there's an onRepeat, we reverted this above, so make sure it's set properly again. We also unlocked in that scenario, so reset that too.
						this._locked = true;
						prevTime = (backwards) ? dur + 0.0001 : -0.0001;
						this.render(prevTime, true, false);
					}
					this._locked = false;
					if (this._paused && !prevPaused) { //if the render() triggered callback that paused this timeline, we should abort (very rare, but possible)
						return;
					}
					this._time = recTime;
					this._totalTime = recTotalTime;
					this._cycle = recCycle;
					this._rawPrevTime = recRawPrevTime;
				}
	
				if ((this._time === prevTime || !this._first) && !force && !internalForce && !pauseTween) {
					if (prevTotalTime !== this._totalTime) if (this._onUpdate) if (!suppressEvents) { //so that onUpdate fires even during the repeatDelay - as long as the totalTime changed, we should trigger onUpdate.
						this._callback("onUpdate");
					}
					return;
				} else if (!this._initted) {
					this._initted = true;
				}
	
				if (!this._active) if (!this._paused && this._totalTime !== prevTotalTime && time > 0) {
					this._active = true;  //so that if the user renders the timeline (as opposed to the parent timeline rendering it), it is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the timeline already finished but the user manually re-renders it as halfway done, for example.
				}
	
				if (prevTotalTime === 0) if (this.vars.onStart) if (this._totalTime !== 0 || !this._totalDuration) if (!suppressEvents) {
					this._callback("onStart");
				}
	
				curTime = this._time;
				if (curTime >= prevTime) {
					tween = this._first;
					while (tween) {
						next = tween._next; //record it here because the value could change after rendering...
						if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
							break;
						} else if (tween._active || (tween._startTime <= this._time && !tween._paused && !tween._gc)) {
							if (pauseTween === tween) {
								this.pause();
							}
							if (!tween._reversed) {
								tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
							} else {
								tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
							}
						}
						tween = next;
					}
				} else {
					tween = this._last;
					while (tween) {
						next = tween._prev; //record it here because the value could change after rendering...
						if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
							break;
						} else if (tween._active || (tween._startTime <= prevTime && !tween._paused && !tween._gc)) {
							if (pauseTween === tween) {
								pauseTween = tween._prev; //the linked list is organized by _startTime, thus it's possible that a tween could start BEFORE the pause and end after it, in which case it would be positioned before the pause tween in the linked list, but we should render it before we pause() the timeline and cease rendering. This is only a concern when going in reverse.
								while (pauseTween && pauseTween.endTime() > this._time) {
									pauseTween.render( (pauseTween._reversed ? pauseTween.totalDuration() - ((time - pauseTween._startTime) * pauseTween._timeScale) : (time - pauseTween._startTime) * pauseTween._timeScale), suppressEvents, force);
									pauseTween = pauseTween._prev;
								}
								pauseTween = null;
								this.pause();
							}
							if (!tween._reversed) {
								tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
							} else {
								tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
							}
						}
						tween = next;
					}
				}
	
				if (this._onUpdate) if (!suppressEvents) {
					if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
						_lazyRender();
					}
					this._callback("onUpdate");
				}
				if (callback) if (!this._locked) if (!this._gc) if (prevStart === this._startTime || prevTimeScale !== this._timeScale) if (this._time === 0 || totalDur >= this.totalDuration()) { //if one of the tweens that was rendered altered this timeline's startTime (like if an onComplete reversed the timeline), it probably isn't complete. If it is, don't worry, because whatever call altered the startTime would complete if it was necessary at the new time. The only exception is the timeScale property. Also check _gc because there's a chance that kill() could be called in an onUpdate
					if (isComplete) {
						if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onComplete on a timeline that reports/checks tweened values.
							_lazyRender();
						}
						if (this._timeline.autoRemoveChildren) {
							this._enabled(false, false);
						}
						this._active = false;
					}
					if (!suppressEvents && this.vars[callback]) {
						this._callback(callback);
					}
				}
			};
	
			p.getActive = function(nested, tweens, timelines) {
				if (nested == null) {
					nested = true;
				}
				if (tweens == null) {
					tweens = true;
				}
				if (timelines == null) {
					timelines = false;
				}
				var a = [],
					all = this.getChildren(nested, tweens, timelines),
					cnt = 0,
					l = all.length,
					i, tween;
				for (i = 0; i < l; i++) {
					tween = all[i];
					if (tween.isActive()) {
						a[cnt++] = tween;
					}
				}
				return a;
			};
	
	
			p.getLabelAfter = function(time) {
				if (!time) if (time !== 0) { //faster than isNan()
					time = this._time;
				}
				var labels = this.getLabelsArray(),
					l = labels.length,
					i;
				for (i = 0; i < l; i++) {
					if (labels[i].time > time) {
						return labels[i].name;
					}
				}
				return null;
			};
	
			p.getLabelBefore = function(time) {
				if (time == null) {
					time = this._time;
				}
				var labels = this.getLabelsArray(),
					i = labels.length;
				while (--i > -1) {
					if (labels[i].time < time) {
						return labels[i].name;
					}
				}
				return null;
			};
	
			p.getLabelsArray = function() {
				var a = [],
					cnt = 0,
					p;
				for (p in this._labels) {
					a[cnt++] = {time:this._labels[p], name:p};
				}
				a.sort(function(a,b) {
					return a.time - b.time;
				});
				return a;
			};
	
			p.invalidate = function() {
				this._locked = false; //unlock and set cycle in case invalidate() is called from inside an onRepeat
				return TimelineLite.prototype.invalidate.call(this);
			};
	
	
	//---- GETTERS / SETTERS -------------------------------------------------------------------------------------------------------
	
			p.progress = function(value, suppressEvents) {
				return (!arguments.length) ? (this._time / this.duration()) || 0 : this.totalTime( this.duration() * ((this._yoyo && (this._cycle & 1) !== 0) ? 1 - value : value) + (this._cycle * (this._duration + this._repeatDelay)), suppressEvents);
			};
	
			p.totalProgress = function(value, suppressEvents) {
				return (!arguments.length) ? (this._totalTime / this.totalDuration()) || 0 : this.totalTime( this.totalDuration() * value, suppressEvents);
			};
	
			p.totalDuration = function(value) {
				if (!arguments.length) {
					if (this._dirty) {
						TimelineLite.prototype.totalDuration.call(this); //just forces refresh
						//Instead of Infinity, we use 999999999999 so that we can accommodate reverses.
						this._totalDuration = (this._repeat === -1) ? 999999999999 : this._duration * (this._repeat + 1) + (this._repeatDelay * this._repeat);
					}
					return this._totalDuration;
				}
				return (this._repeat === -1 || !value) ? this : this.timeScale( this.totalDuration() / value );
			};
	
			p.time = function(value, suppressEvents) {
				if (!arguments.length) {
					return this._time;
				}
				if (this._dirty) {
					this.totalDuration();
				}
				if (value > this._duration) {
					value = this._duration;
				}
				if (this._yoyo && (this._cycle & 1) !== 0) {
					value = (this._duration - value) + (this._cycle * (this._duration + this._repeatDelay));
				} else if (this._repeat !== 0) {
					value += this._cycle * (this._duration + this._repeatDelay);
				}
				return this.totalTime(value, suppressEvents);
			};
	
			p.repeat = function(value) {
				if (!arguments.length) {
					return this._repeat;
				}
				this._repeat = value;
				return this._uncache(true);
			};
	
			p.repeatDelay = function(value) {
				if (!arguments.length) {
					return this._repeatDelay;
				}
				this._repeatDelay = value;
				return this._uncache(true);
			};
	
			p.yoyo = function(value) {
				if (!arguments.length) {
					return this._yoyo;
				}
				this._yoyo = value;
				return this;
			};
	
			p.currentLabel = function(value) {
				if (!arguments.length) {
					return this.getLabelBefore(this._time + 0.00000001);
				}
				return this.seek(value, true);
			};
	
			return TimelineMax;
	
		}, true);
		
	
	
	
	
		
		
		
		
		
	
		
	/*
	 * ----------------------------------------------------------------
	 * BezierPlugin
	 * ----------------------------------------------------------------
	 */
		(function() {
	
			var _RAD2DEG = 180 / Math.PI,
				_r1 = [],
				_r2 = [],
				_r3 = [],
				_corProps = {},
				_globals = _gsScope._gsDefine.globals,
				Segment = function(a, b, c, d) {
					if (c === d) { //if c and d match, the final autoRotate value could lock at -90 degrees, so differentiate them slightly.
						c = d - (d - b) / 1000000;
					}
					if (a === b) { //if a and b match, the starting autoRotate value could lock at -90 degrees, so differentiate them slightly.
						b = a + (c - a) / 1000000;
					}
					this.a = a;
					this.b = b;
					this.c = c;
					this.d = d;
					this.da = d - a;
					this.ca = c - a;
					this.ba = b - a;
				},
				_correlate = ",x,y,z,left,top,right,bottom,marginTop,marginLeft,marginRight,marginBottom,paddingLeft,paddingTop,paddingRight,paddingBottom,backgroundPosition,backgroundPosition_y,",
				cubicToQuadratic = function(a, b, c, d) {
					var q1 = {a:a},
						q2 = {},
						q3 = {},
						q4 = {c:d},
						mab = (a + b) / 2,
						mbc = (b + c) / 2,
						mcd = (c + d) / 2,
						mabc = (mab + mbc) / 2,
						mbcd = (mbc + mcd) / 2,
						m8 = (mbcd - mabc) / 8;
					q1.b = mab + (a - mab) / 4;
					q2.b = mabc + m8;
					q1.c = q2.a = (q1.b + q2.b) / 2;
					q2.c = q3.a = (mabc + mbcd) / 2;
					q3.b = mbcd - m8;
					q4.b = mcd + (d - mcd) / 4;
					q3.c = q4.a = (q3.b + q4.b) / 2;
					return [q1, q2, q3, q4];
				},
				_calculateControlPoints = function(a, curviness, quad, basic, correlate) {
					var l = a.length - 1,
						ii = 0,
						cp1 = a[0].a,
						i, p1, p2, p3, seg, m1, m2, mm, cp2, qb, r1, r2, tl;
					for (i = 0; i < l; i++) {
						seg = a[ii];
						p1 = seg.a;
						p2 = seg.d;
						p3 = a[ii+1].d;
	
						if (correlate) {
							r1 = _r1[i];
							r2 = _r2[i];
							tl = ((r2 + r1) * curviness * 0.25) / (basic ? 0.5 : _r3[i] || 0.5);
							m1 = p2 - (p2 - p1) * (basic ? curviness * 0.5 : (r1 !== 0 ? tl / r1 : 0));
							m2 = p2 + (p3 - p2) * (basic ? curviness * 0.5 : (r2 !== 0 ? tl / r2 : 0));
							mm = p2 - (m1 + (((m2 - m1) * ((r1 * 3 / (r1 + r2)) + 0.5) / 4) || 0));
						} else {
							m1 = p2 - (p2 - p1) * curviness * 0.5;
							m2 = p2 + (p3 - p2) * curviness * 0.5;
							mm = p2 - (m1 + m2) / 2;
						}
						m1 += mm;
						m2 += mm;
	
						seg.c = cp2 = m1;
						if (i !== 0) {
							seg.b = cp1;
						} else {
							seg.b = cp1 = seg.a + (seg.c - seg.a) * 0.6; //instead of placing b on a exactly, we move it inline with c so that if the user specifies an ease like Back.easeIn or Elastic.easeIn which goes BEYOND the beginning, it will do so smoothly.
						}
	
						seg.da = p2 - p1;
						seg.ca = cp2 - p1;
						seg.ba = cp1 - p1;
	
						if (quad) {
							qb = cubicToQuadratic(p1, cp1, cp2, p2);
							a.splice(ii, 1, qb[0], qb[1], qb[2], qb[3]);
							ii += 4;
						} else {
							ii++;
						}
	
						cp1 = m2;
					}
					seg = a[ii];
					seg.b = cp1;
					seg.c = cp1 + (seg.d - cp1) * 0.4; //instead of placing c on d exactly, we move it inline with b so that if the user specifies an ease like Back.easeOut or Elastic.easeOut which goes BEYOND the end, it will do so smoothly.
					seg.da = seg.d - seg.a;
					seg.ca = seg.c - seg.a;
					seg.ba = cp1 - seg.a;
					if (quad) {
						qb = cubicToQuadratic(seg.a, cp1, seg.c, seg.d);
						a.splice(ii, 1, qb[0], qb[1], qb[2], qb[3]);
					}
				},
				_parseAnchors = function(values, p, correlate, prepend) {
					var a = [],
						l, i, p1, p2, p3, tmp;
					if (prepend) {
						values = [prepend].concat(values);
						i = values.length;
						while (--i > -1) {
							if (typeof( (tmp = values[i][p]) ) === "string") if (tmp.charAt(1) === "=") {
								values[i][p] = prepend[p] + Number(tmp.charAt(0) + tmp.substr(2)); //accommodate relative values. Do it inline instead of breaking it out into a function for speed reasons
							}
						}
					}
					l = values.length - 2;
					if (l < 0) {
						a[0] = new Segment(values[0][p], 0, 0, values[0][p]);
						return a;
					}
					for (i = 0; i < l; i++) {
						p1 = values[i][p];
						p2 = values[i+1][p];
						a[i] = new Segment(p1, 0, 0, p2);
						if (correlate) {
							p3 = values[i+2][p];
							_r1[i] = (_r1[i] || 0) + (p2 - p1) * (p2 - p1);
							_r2[i] = (_r2[i] || 0) + (p3 - p2) * (p3 - p2);
						}
					}
					a[i] = new Segment(values[i][p], 0, 0, values[i+1][p]);
					return a;
				},
				bezierThrough = function(values, curviness, quadratic, basic, correlate, prepend) {
					var obj = {},
						props = [],
						first = prepend || values[0],
						i, p, a, j, r, l, seamless, last;
					correlate = (typeof(correlate) === "string") ? ","+correlate+"," : _correlate;
					if (curviness == null) {
						curviness = 1;
					}
					for (p in values[0]) {
						props.push(p);
					}
					//check to see if the last and first values are identical (well, within 0.05). If so, make seamless by appending the second element to the very end of the values array and the 2nd-to-last element to the very beginning (we'll remove those segments later)
					if (values.length > 1) {
						last = values[values.length - 1];
						seamless = true;
						i = props.length;
						while (--i > -1) {
							p = props[i];
							if (Math.abs(first[p] - last[p]) > 0.05) { //build in a tolerance of +/-0.05 to accommodate rounding errors.
								seamless = false;
								break;
							}
						}
						if (seamless) {
							values = values.concat(); //duplicate the array to avoid contaminating the original which the user may be reusing for other tweens
							if (prepend) {
								values.unshift(prepend);
							}
							values.push(values[1]);
							prepend = values[values.length - 3];
						}
					}
					_r1.length = _r2.length = _r3.length = 0;
					i = props.length;
					while (--i > -1) {
						p = props[i];
						_corProps[p] = (correlate.indexOf(","+p+",") !== -1);
						obj[p] = _parseAnchors(values, p, _corProps[p], prepend);
					}
					i = _r1.length;
					while (--i > -1) {
						_r1[i] = Math.sqrt(_r1[i]);
						_r2[i] = Math.sqrt(_r2[i]);
					}
					if (!basic) {
						i = props.length;
						while (--i > -1) {
							if (_corProps[p]) {
								a = obj[props[i]];
								l = a.length - 1;
								for (j = 0; j < l; j++) {
									r = (a[j+1].da / _r2[j] + a[j].da / _r1[j]) || 0;
									_r3[j] = (_r3[j] || 0) + r * r;
								}
							}
						}
						i = _r3.length;
						while (--i > -1) {
							_r3[i] = Math.sqrt(_r3[i]);
						}
					}
					i = props.length;
					j = quadratic ? 4 : 1;
					while (--i > -1) {
						p = props[i];
						a = obj[p];
						_calculateControlPoints(a, curviness, quadratic, basic, _corProps[p]); //this method requires that _parseAnchors() and _setSegmentRatios() ran first so that _r1, _r2, and _r3 values are populated for all properties
						if (seamless) {
							a.splice(0, j);
							a.splice(a.length - j, j);
						}
					}
					return obj;
				},
				_parseBezierData = function(values, type, prepend) {
					type = type || "soft";
					var obj = {},
						inc = (type === "cubic") ? 3 : 2,
						soft = (type === "soft"),
						props = [],
						a, b, c, d, cur, i, j, l, p, cnt, tmp;
					if (soft && prepend) {
						values = [prepend].concat(values);
					}
					if (values == null || values.length < inc + 1) { throw "invalid Bezier data"; }
					for (p in values[0]) {
						props.push(p);
					}
					i = props.length;
					while (--i > -1) {
						p = props[i];
						obj[p] = cur = [];
						cnt = 0;
						l = values.length;
						for (j = 0; j < l; j++) {
							a = (prepend == null) ? values[j][p] : (typeof( (tmp = values[j][p]) ) === "string" && tmp.charAt(1) === "=") ? prepend[p] + Number(tmp.charAt(0) + tmp.substr(2)) : Number(tmp);
							if (soft) if (j > 1) if (j < l - 1) {
								cur[cnt++] = (a + cur[cnt-2]) / 2;
							}
							cur[cnt++] = a;
						}
						l = cnt - inc + 1;
						cnt = 0;
						for (j = 0; j < l; j += inc) {
							a = cur[j];
							b = cur[j+1];
							c = cur[j+2];
							d = (inc === 2) ? 0 : cur[j+3];
							cur[cnt++] = tmp = (inc === 3) ? new Segment(a, b, c, d) : new Segment(a, (2 * b + a) / 3, (2 * b + c) / 3, c);
						}
						cur.length = cnt;
					}
					return obj;
				},
				_addCubicLengths = function(a, steps, resolution) {
					var inc = 1 / resolution,
						j = a.length,
						d, d1, s, da, ca, ba, p, i, inv, bez, index;
					while (--j > -1) {
						bez = a[j];
						s = bez.a;
						da = bez.d - s;
						ca = bez.c - s;
						ba = bez.b - s;
						d = d1 = 0;
						for (i = 1; i <= resolution; i++) {
							p = inc * i;
							inv = 1 - p;
							d = d1 - (d1 = (p * p * da + 3 * inv * (p * ca + inv * ba)) * p);
							index = j * resolution + i - 1;
							steps[index] = (steps[index] || 0) + d * d;
						}
					}
				},
				_parseLengthData = function(obj, resolution) {
					resolution = resolution >> 0 || 6;
					var a = [],
						lengths = [],
						d = 0,
						total = 0,
						threshold = resolution - 1,
						segments = [],
						curLS = [], //current length segments array
						p, i, l, index;
					for (p in obj) {
						_addCubicLengths(obj[p], a, resolution);
					}
					l = a.length;
					for (i = 0; i < l; i++) {
						d += Math.sqrt(a[i]);
						index = i % resolution;
						curLS[index] = d;
						if (index === threshold) {
							total += d;
							index = (i / resolution) >> 0;
							segments[index] = curLS;
							lengths[index] = total;
							d = 0;
							curLS = [];
						}
					}
					return {length:total, lengths:lengths, segments:segments};
				},
	
	
	
				BezierPlugin = _gsScope._gsDefine.plugin({
						propName: "bezier",
						priority: -1,
						version: "1.3.8",
						API: 2,
						global:true,
	
						//gets called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
						init: function(target, vars, tween) {
							this._target = target;
							if (vars instanceof Array) {
								vars = {values:vars};
							}
							this._func = {};
							this._mod = {};
							this._props = [];
							this._timeRes = (vars.timeResolution == null) ? 6 : parseInt(vars.timeResolution, 10);
							var values = vars.values || [],
								first = {},
								second = values[0],
								autoRotate = vars.autoRotate || tween.vars.orientToBezier,
								p, isFunc, i, j, prepend;
	
							this._autoRotate = autoRotate ? (autoRotate instanceof Array) ? autoRotate : [["x","y","rotation",((autoRotate === true) ? 0 : Number(autoRotate) || 0)]] : null;
							for (p in second) {
								this._props.push(p);
							}
	
							i = this._props.length;
							while (--i > -1) {
								p = this._props[i];
	
								this._overwriteProps.push(p);
								isFunc = this._func[p] = (typeof(target[p]) === "function");
								first[p] = (!isFunc) ? parseFloat(target[p]) : target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ]();
								if (!prepend) if (first[p] !== values[0][p]) {
									prepend = first;
								}
							}
							this._beziers = (vars.type !== "cubic" && vars.type !== "quadratic" && vars.type !== "soft") ? bezierThrough(values, isNaN(vars.curviness) ? 1 : vars.curviness, false, (vars.type === "thruBasic"), vars.correlate, prepend) : _parseBezierData(values, vars.type, first);
							this._segCount = this._beziers[p].length;
	
							if (this._timeRes) {
								var ld = _parseLengthData(this._beziers, this._timeRes);
								this._length = ld.length;
								this._lengths = ld.lengths;
								this._segments = ld.segments;
								this._l1 = this._li = this._s1 = this._si = 0;
								this._l2 = this._lengths[0];
								this._curSeg = this._segments[0];
								this._s2 = this._curSeg[0];
								this._prec = 1 / this._curSeg.length;
							}
	
							if ((autoRotate = this._autoRotate)) {
								this._initialRotations = [];
								if (!(autoRotate[0] instanceof Array)) {
									this._autoRotate = autoRotate = [autoRotate];
								}
								i = autoRotate.length;
								while (--i > -1) {
									for (j = 0; j < 3; j++) {
										p = autoRotate[i][j];
										this._func[p] = (typeof(target[p]) === "function") ? target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ] : false;
									}
									p = autoRotate[i][2];
									this._initialRotations[i] = (this._func[p] ? this._func[p].call(this._target) : this._target[p]) || 0;
									this._overwriteProps.push(p);
								}
							}
							this._startRatio = tween.vars.runBackwards ? 1 : 0; //we determine the starting ratio when the tween inits which is always 0 unless the tween has runBackwards:true (indicating it's a from() tween) in which case it's 1.
							return true;
						},
	
						//called each time the values should be updated, and the ratio gets passed as the only parameter (typically it's a value between 0 and 1, but it can exceed those when using an ease like Elastic.easeOut or Back.easeOut, etc.)
						set: function(v) {
							var segments = this._segCount,
								func = this._func,
								target = this._target,
								notStart = (v !== this._startRatio),
								curIndex, inv, i, p, b, t, val, l, lengths, curSeg;
							if (!this._timeRes) {
								curIndex = (v < 0) ? 0 : (v >= 1) ? segments - 1 : (segments * v) >> 0;
								t = (v - (curIndex * (1 / segments))) * segments;
							} else {
								lengths = this._lengths;
								curSeg = this._curSeg;
								v *= this._length;
								i = this._li;
								//find the appropriate segment (if the currently cached one isn't correct)
								if (v > this._l2 && i < segments - 1) {
									l = segments - 1;
									while (i < l && (this._l2 = lengths[++i]) <= v) {	}
									this._l1 = lengths[i-1];
									this._li = i;
									this._curSeg = curSeg = this._segments[i];
									this._s2 = curSeg[(this._s1 = this._si = 0)];
								} else if (v < this._l1 && i > 0) {
									while (i > 0 && (this._l1 = lengths[--i]) >= v) { }
									if (i === 0 && v < this._l1) {
										this._l1 = 0;
									} else {
										i++;
									}
									this._l2 = lengths[i];
									this._li = i;
									this._curSeg = curSeg = this._segments[i];
									this._s1 = curSeg[(this._si = curSeg.length - 1) - 1] || 0;
									this._s2 = curSeg[this._si];
								}
								curIndex = i;
								//now find the appropriate sub-segment (we split it into the number of pieces that was defined by "precision" and measured each one)
								v -= this._l1;
								i = this._si;
								if (v > this._s2 && i < curSeg.length - 1) {
									l = curSeg.length - 1;
									while (i < l && (this._s2 = curSeg[++i]) <= v) {	}
									this._s1 = curSeg[i-1];
									this._si = i;
								} else if (v < this._s1 && i > 0) {
									while (i > 0 && (this._s1 = curSeg[--i]) >= v) {	}
									if (i === 0 && v < this._s1) {
										this._s1 = 0;
									} else {
										i++;
									}
									this._s2 = curSeg[i];
									this._si = i;
								}
								t = ((i + (v - this._s1) / (this._s2 - this._s1)) * this._prec) || 0;
							}
							inv = 1 - t;
	
							i = this._props.length;
							while (--i > -1) {
								p = this._props[i];
								b = this._beziers[p][curIndex];
								val = (t * t * b.da + 3 * inv * (t * b.ca + inv * b.ba)) * t + b.a;
								if (this._mod[p]) {
									val = this._mod[p](val, target);
								}
								if (func[p]) {
									target[p](val);
								} else {
									target[p] = val;
								}
							}
	
							if (this._autoRotate) {
								var ar = this._autoRotate,
									b2, x1, y1, x2, y2, add, conv;
								i = ar.length;
								while (--i > -1) {
									p = ar[i][2];
									add = ar[i][3] || 0;
									conv = (ar[i][4] === true) ? 1 : _RAD2DEG;
									b = this._beziers[ar[i][0]];
									b2 = this._beziers[ar[i][1]];
	
									if (b && b2) { //in case one of the properties got overwritten.
										b = b[curIndex];
										b2 = b2[curIndex];
	
										x1 = b.a + (b.b - b.a) * t;
										x2 = b.b + (b.c - b.b) * t;
										x1 += (x2 - x1) * t;
										x2 += ((b.c + (b.d - b.c) * t) - x2) * t;
	
										y1 = b2.a + (b2.b - b2.a) * t;
										y2 = b2.b + (b2.c - b2.b) * t;
										y1 += (y2 - y1) * t;
										y2 += ((b2.c + (b2.d - b2.c) * t) - y2) * t;
	
										val = notStart ? Math.atan2(y2 - y1, x2 - x1) * conv + add : this._initialRotations[i];
	
										if (this._mod[p]) {
											val = this._mod[p](val, target); //for modProps
										}
	
										if (func[p]) {
											target[p](val);
										} else {
											target[p] = val;
										}
									}
								}
							}
						}
				}),
				p = BezierPlugin.prototype;
	
	
			BezierPlugin.bezierThrough = bezierThrough;
			BezierPlugin.cubicToQuadratic = cubicToQuadratic;
			BezierPlugin._autoCSS = true; //indicates that this plugin can be inserted into the "css" object using the autoCSS feature of TweenLite
			BezierPlugin.quadraticToCubic = function(a, b, c) {
				return new Segment(a, (2 * b + a) / 3, (2 * b + c) / 3, c);
			};
	
			BezierPlugin._cssRegister = function() {
				var CSSPlugin = _globals.CSSPlugin;
				if (!CSSPlugin) {
					return;
				}
				var _internals = CSSPlugin._internals,
					_parseToProxy = _internals._parseToProxy,
					_setPluginRatio = _internals._setPluginRatio,
					CSSPropTween = _internals.CSSPropTween;
				_internals._registerComplexSpecialProp("bezier", {parser:function(t, e, prop, cssp, pt, plugin) {
					if (e instanceof Array) {
						e = {values:e};
					}
					plugin = new BezierPlugin();
					var values = e.values,
						l = values.length - 1,
						pluginValues = [],
						v = {},
						i, p, data;
					if (l < 0) {
						return pt;
					}
					for (i = 0; i <= l; i++) {
						data = _parseToProxy(t, values[i], cssp, pt, plugin, (l !== i));
						pluginValues[i] = data.end;
					}
					for (p in e) {
						v[p] = e[p]; //duplicate the vars object because we need to alter some things which would cause problems if the user plans to reuse the same vars object for another tween.
					}
					v.values = pluginValues;
					pt = new CSSPropTween(t, "bezier", 0, 0, data.pt, 2);
					pt.data = data;
					pt.plugin = plugin;
					pt.setRatio = _setPluginRatio;
					if (v.autoRotate === 0) {
						v.autoRotate = true;
					}
					if (v.autoRotate && !(v.autoRotate instanceof Array)) {
						i = (v.autoRotate === true) ? 0 : Number(v.autoRotate);
						v.autoRotate = (data.end.left != null) ? [["left","top","rotation",i,false]] : (data.end.x != null) ? [["x","y","rotation",i,false]] : false;
					}
					if (v.autoRotate) {
						if (!cssp._transform) {
							cssp._enableTransforms(false);
						}
						data.autoRotate = cssp._target._gsTransform;
						data.proxy.rotation = data.autoRotate.rotation || 0;
						cssp._overwriteProps.push("rotation");
					}
					plugin._onInitTween(data.proxy, v, cssp._tween);
					return pt;
				}});
			};
	
			p._mod = function(lookup) {
				var op = this._overwriteProps,
					i = op.length,
					val;
				while (--i > -1) {
					val = lookup[op[i]];
					if (val && typeof(val) === "function") {
						this._mod[op[i]] = val;
					}
				}
			};
	
			p._kill = function(lookup) {
				var a = this._props,
					p, i;
				for (p in this._beziers) {
					if (p in lookup) {
						delete this._beziers[p];
						delete this._func[p];
						i = a.length;
						while (--i > -1) {
							if (a[i] === p) {
								a.splice(i, 1);
							}
						}
					}
				}
				a = this._autoRotate;
				if (a) {
					i = a.length;
					while (--i > -1) {
						if (lookup[a[i][2]]) {
							a.splice(i, 1);
						}
					}
				}
				return this._super._kill.call(this, lookup);
			};
	
		}());
	
	
	
	
	
	
		
		
		
		
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * CSSPlugin
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine("plugins.CSSPlugin", ["plugins.TweenPlugin","TweenLite"], function(TweenPlugin, TweenLite) {
	
			/** @constructor **/
			var CSSPlugin = function() {
					TweenPlugin.call(this, "css");
					this._overwriteProps.length = 0;
					this.setRatio = CSSPlugin.prototype.setRatio; //speed optimization (avoid prototype lookup on this "hot" method)
				},
				_globals = _gsScope._gsDefine.globals,
				_hasPriority, //turns true whenever a CSSPropTween instance is created that has a priority other than 0. This helps us discern whether or not we should spend the time organizing the linked list or not after a CSSPlugin's _onInitTween() method is called.
				_suffixMap, //we set this in _onInitTween() each time as a way to have a persistent variable we can use in other methods like _parse() without having to pass it around as a parameter and we keep _parse() decoupled from a particular CSSPlugin instance
				_cs, //computed style (we store this in a shared variable to conserve memory and make minification tighter
				_overwriteProps, //alias to the currently instantiating CSSPlugin's _overwriteProps array. We use this closure in order to avoid having to pass a reference around from method to method and aid in minification.
				_specialProps = {},
				p = CSSPlugin.prototype = new TweenPlugin("css");
	
			p.constructor = CSSPlugin;
			CSSPlugin.version = "1.20.5";
			CSSPlugin.API = 2;
			CSSPlugin.defaultTransformPerspective = 0;
			CSSPlugin.defaultSkewType = "compensated";
			CSSPlugin.defaultSmoothOrigin = true;
			p = "px"; //we'll reuse the "p" variable to keep file size down
			CSSPlugin.suffixMap = {top:p, right:p, bottom:p, left:p, width:p, height:p, fontSize:p, padding:p, margin:p, perspective:p, lineHeight:""};
	
	
			var _numExp = /(?:\-|\.|\b)(\d|\.|e\-)+/g,
				_relNumExp = /(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g,
				_valuesExp = /(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi, //finds all the values that begin with numbers or += or -= and then a number. Includes suffixes. We use this to split complex values apart like "1px 5px 20px rgb(255,102,51)"
				_NaNExp = /(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g, //also allows scientific notation and doesn't kill the leading -/+ in -= and +=
				_suffixExp = /(?:\d|\-|\+|=|#|\.)*/g,
				_opacityExp = /opacity *= *([^)]*)/i,
				_opacityValExp = /opacity:([^;]*)/i,
				_alphaFilterExp = /alpha\(opacity *=.+?\)/i,
				_rgbhslExp = /^(rgb|hsl)/,
				_capsExp = /([A-Z])/g,
				_camelExp = /-([a-z])/gi,
				_urlExp = /(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi, //for pulling out urls from url(...) or url("...") strings (some browsers wrap urls in quotes, some don't when reporting things like backgroundImage)
				_camelFunc = function(s, g) { return g.toUpperCase(); },
				_horizExp = /(?:Left|Right|Width)/i,
				_ieGetMatrixExp = /(M11|M12|M21|M22)=[\d\-\.e]+/gi,
				_ieSetMatrixExp = /progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i,
				_commasOutsideParenExp = /,(?=[^\)]*(?:\(|$))/gi, //finds any commas that are not within parenthesis
				_complexExp = /[\s,\(]/i, //for testing a string to find if it has a space, comma, or open parenthesis (clues that it's a complex value)
				_DEG2RAD = Math.PI / 180,
				_RAD2DEG = 180 / Math.PI,
				_forcePT = {},
				_dummyElement = {style:{}},
				_doc = _gsScope.document || {createElement: function() {return _dummyElement;}},
				_createElement = function(type, ns) {
					return _doc.createElementNS ? _doc.createElementNS(ns || "http://www.w3.org/1999/xhtml", type) : _doc.createElement(type);
				},
				_tempDiv = _createElement("div"),
				_tempImg = _createElement("img"),
				_internals = CSSPlugin._internals = {_specialProps:_specialProps}, //provides a hook to a few internal methods that we need to access from inside other plugins
				_agent = (_gsScope.navigator || {}).userAgent || "",
				_autoRound,
				_reqSafariFix, //we won't apply the Safari transform fix until we actually come across a tween that affects a transform property (to maintain best performance).
	
				_isSafari,
				_isFirefox, //Firefox has a bug that causes 3D transformed elements to randomly disappear unless a repaint is forced after each update on each element.
				_isSafariLT6, //Safari (and Android 4 which uses a flavor of Safari) has a bug that prevents changes to "top" and "left" properties from rendering properly if changed on the same frame as a transform UNLESS we set the element's WebkitBackfaceVisibility to hidden (weird, I know). Doing this for Android 3 and earlier seems to actually cause other problems, though (fun!)
				_ieVers,
				_supportsOpacity = (function() { //we set _isSafari, _ieVers, _isFirefox, and _supportsOpacity all in one function here to reduce file size slightly, especially in the minified version.
					var i = _agent.indexOf("Android"),
						a = _createElement("a");
					_isSafari = (_agent.indexOf("Safari") !== -1 && _agent.indexOf("Chrome") === -1 && (i === -1 || parseFloat(_agent.substr(i+8, 2)) > 3));
					_isSafariLT6 = (_isSafari && (parseFloat(_agent.substr(_agent.indexOf("Version/")+8, 2)) < 6));
					_isFirefox = (_agent.indexOf("Firefox") !== -1);
					if ((/MSIE ([0-9]{1,}[\.0-9]{0,})/).exec(_agent) || (/Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/).exec(_agent)) {
						_ieVers = parseFloat( RegExp.$1 );
					}
					if (!a) {
						return false;
					}
					a.style.cssText = "top:1px;opacity:.55;";
					return /^0.55/.test(a.style.opacity);
				}()),
				_getIEOpacity = function(v) {
					return (_opacityExp.test( ((typeof(v) === "string") ? v : (v.currentStyle ? v.currentStyle.filter : v.style.filter) || "") ) ? ( parseFloat( RegExp.$1 ) / 100 ) : 1);
				},
				_log = function(s) {//for logging messages, but in a way that won't throw errors in old versions of IE.
					if (_gsScope.console) {
						console.log(s);
					}
				},
				_target, //when initting a CSSPlugin, we set this variable so that we can access it from within many other functions without having to pass it around as params
				_index, //when initting a CSSPlugin, we set this variable so that we can access it from within many other functions without having to pass it around as params
	
				_prefixCSS = "", //the non-camelCase vendor prefix like "-o-", "-moz-", "-ms-", or "-webkit-"
				_prefix = "", //camelCase vendor prefix like "O", "ms", "Webkit", or "Moz".
	
				// @private feed in a camelCase property name like "transform" and it will check to see if it is valid as-is or if it needs a vendor prefix. It returns the corrected camelCase property name (i.e. "WebkitTransform" or "MozTransform" or "transform" or null if no such property is found, like if the browser is IE8 or before, "transform" won't be found at all)
				_checkPropPrefix = function(p, e) {
					e = e || _tempDiv;
					var s = e.style,
						a, i;
					if (s[p] !== undefined) {
						return p;
					}
					p = p.charAt(0).toUpperCase() + p.substr(1);
					a = ["O","Moz","ms","Ms","Webkit"];
					i = 5;
					while (--i > -1 && s[a[i]+p] === undefined) { }
					if (i >= 0) {
						_prefix = (i === 3) ? "ms" : a[i];
						_prefixCSS = "-" + _prefix.toLowerCase() + "-";
						return _prefix + p;
					}
					return null;
				},
	
				_getComputedStyle = (typeof(window) !== "undefined" ? window : _doc.defaultView || {getComputedStyle:function() {}}).getComputedStyle,
	
				/**
				 * @private Returns the css style for a particular property of an element. For example, to get whatever the current "left" css value for an element with an ID of "myElement", you could do:
				 * var currentLeft = CSSPlugin.getStyle( document.getElementById("myElement"), "left");
				 *
				 * @param {!Object} t Target element whose style property you want to query
				 * @param {!string} p Property name (like "left" or "top" or "marginTop", etc.)
				 * @param {Object=} cs Computed style object. This just provides a way to speed processing if you're going to get several properties on the same element in quick succession - you can reuse the result of the getComputedStyle() call.
				 * @param {boolean=} calc If true, the value will not be read directly from the element's "style" property (if it exists there), but instead the getComputedStyle() result will be used. This can be useful when you want to ensure that the browser itself is interpreting the value.
				 * @param {string=} dflt Default value that should be returned in the place of null, "none", "auto" or "auto auto".
				 * @return {?string} The current property value
				 */
				_getStyle = CSSPlugin.getStyle = function(t, p, cs, calc, dflt) {
					var rv;
					if (!_supportsOpacity) if (p === "opacity") { //several versions of IE don't use the standard "opacity" property - they use things like filter:alpha(opacity=50), so we parse that here.
						return _getIEOpacity(t);
					}
					if (!calc && t.style[p]) {
						rv = t.style[p];
					} else if ((cs = cs || _getComputedStyle(t))) {
						rv = cs[p] || cs.getPropertyValue(p) || cs.getPropertyValue(p.replace(_capsExp, "-$1").toLowerCase());
					} else if (t.currentStyle) {
						rv = t.currentStyle[p];
					}
					return (dflt != null && (!rv || rv === "none" || rv === "auto" || rv === "auto auto")) ? dflt : rv;
				},
	
				/**
				 * @private Pass the target element, the property name, the numeric value, and the suffix (like "%", "em", "px", etc.) and it will spit back the equivalent pixel number.
				 * @param {!Object} t Target element
				 * @param {!string} p Property name (like "left", "top", "marginLeft", etc.)
				 * @param {!number} v Value
				 * @param {string=} sfx Suffix (like "px" or "%" or "em")
				 * @param {boolean=} recurse If true, the call is a recursive one. In some browsers (like IE7/8), occasionally the value isn't accurately reported initially, but if we run the function again it will take effect.
				 * @return {number} value in pixels
				 */
				_convertToPixels = _internals.convertToPixels = function(t, p, v, sfx, recurse) {
					if (sfx === "px" || (!sfx && p !== "lineHeight")) { return v; }
					if (sfx === "auto" || !v) { return 0; }
					var horiz = _horizExp.test(p),
						node = t,
						style = _tempDiv.style,
						neg = (v < 0),
						precise = (v === 1),
						pix, cache, time;
					if (neg) {
						v = -v;
					}
					if (precise) {
						v *= 100;
					}
					if (p === "lineHeight" && !sfx) { //special case of when a simple lineHeight (without a unit) is used. Set it to the value, read back the computed value, and then revert.
						cache = _getComputedStyle(t).lineHeight;
						t.style.lineHeight = v;
						pix = parseFloat(_getComputedStyle(t).lineHeight);
						t.style.lineHeight = cache;
					} else if (sfx === "%" && p.indexOf("border") !== -1) {
						pix = (v / 100) * (horiz ? t.clientWidth : t.clientHeight);
					} else {
						style.cssText = "border:0 solid red;position:" + _getStyle(t, "position") + ";line-height:0;";
						if (sfx === "%" || !node.appendChild || sfx.charAt(0) === "v" || sfx === "rem") {
							node = t.parentNode || _doc.body;
							if (_getStyle(node, "display").indexOf("flex") !== -1) { //Edge and IE11 have a bug that causes offsetWidth to report as 0 if the container has display:flex and the child is position:relative. Switching to position: absolute solves it.
								style.position = "absolute";
							}
							cache = node._gsCache;
							time = TweenLite.ticker.frame;
							if (cache && horiz && cache.time === time) { //performance optimization: we record the width of elements along with the ticker frame so that we can quickly get it again on the same tick (seems relatively safe to assume it wouldn't change on the same tick)
								return cache.width * v / 100;
							}
							style[(horiz ? "width" : "height")] = v + sfx;
						} else {
							style[(horiz ? "borderLeftWidth" : "borderTopWidth")] = v + sfx;
						}
						node.appendChild(_tempDiv);
						pix = parseFloat(_tempDiv[(horiz ? "offsetWidth" : "offsetHeight")]);
						node.removeChild(_tempDiv);
						if (horiz && sfx === "%" && CSSPlugin.cacheWidths !== false) {
							cache = node._gsCache = node._gsCache || {};
							cache.time = time;
							cache.width = pix / v * 100;
						}
						if (pix === 0 && !recurse) {
							pix = _convertToPixels(t, p, v, sfx, true);
						}
					}
					if (precise) {
						pix /= 100;
					}
					return neg ? -pix : pix;
				},
				_calculateOffset = _internals.calculateOffset = function(t, p, cs) { //for figuring out "top" or "left" in px when it's "auto". We need to factor in margin with the offsetLeft/offsetTop
					if (_getStyle(t, "position", cs) !== "absolute") { return 0; }
					var dim = ((p === "left") ? "Left" : "Top"),
						v = _getStyle(t, "margin" + dim, cs);
					return t["offset" + dim] - (_convertToPixels(t, p, parseFloat(v), v.replace(_suffixExp, "")) || 0);
				},
	
				// @private returns at object containing ALL of the style properties in camelCase and their associated values.
				_getAllStyles = function(t, cs) {
					var s = {},
						i, tr, p;
					if ((cs = cs || _getComputedStyle(t, null))) {
						if ((i = cs.length)) {
							while (--i > -1) {
								p = cs[i];
								if (p.indexOf("-transform") === -1 || _transformPropCSS === p) { //Some webkit browsers duplicate transform values, one non-prefixed and one prefixed ("transform" and "WebkitTransform"), so we must weed out the extra one here.
									s[p.replace(_camelExp, _camelFunc)] = cs.getPropertyValue(p);
								}
							}
						} else { //some browsers behave differently - cs.length is always 0, so we must do a for...in loop.
							for (i in cs) {
								if (i.indexOf("Transform") === -1 || _transformProp === i) { //Some webkit browsers duplicate transform values, one non-prefixed and one prefixed ("transform" and "WebkitTransform"), so we must weed out the extra one here.
									s[i] = cs[i];
								}
							}
						}
					} else if ((cs = t.currentStyle || t.style)) {
						for (i in cs) {
							if (typeof(i) === "string" && s[i] === undefined) {
								s[i.replace(_camelExp, _camelFunc)] = cs[i];
							}
						}
					}
					if (!_supportsOpacity) {
						s.opacity = _getIEOpacity(t);
					}
					tr = _getTransform(t, cs, false);
					s.rotation = tr.rotation;
					s.skewX = tr.skewX;
					s.scaleX = tr.scaleX;
					s.scaleY = tr.scaleY;
					s.x = tr.x;
					s.y = tr.y;
					if (_supports3D) {
						s.z = tr.z;
						s.rotationX = tr.rotationX;
						s.rotationY = tr.rotationY;
						s.scaleZ = tr.scaleZ;
					}
					if (s.filters) {
						delete s.filters;
					}
					return s;
				},
	
				// @private analyzes two style objects (as returned by _getAllStyles()) and only looks for differences between them that contain tweenable values (like a number or color). It returns an object with a "difs" property which refers to an object containing only those isolated properties and values for tweening, and a "firstMPT" property which refers to the first MiniPropTween instance in a linked list that recorded all the starting values of the different properties so that we can revert to them at the end or beginning of the tween - we don't want the cascading to get messed up. The forceLookup parameter is an optional generic object with properties that should be forced into the results - this is necessary for className tweens that are overwriting others because imagine a scenario where a rollover/rollout adds/removes a class and the user swipes the mouse over the target SUPER fast, thus nothing actually changed yet and the subsequent comparison of the properties would indicate they match (especially when px rounding is taken into consideration), thus no tweening is necessary even though it SHOULD tween and remove those properties after the tween (otherwise the inline styles will contaminate things). See the className SpecialProp code for details.
				_cssDif = function(t, s1, s2, vars, forceLookup) {
					var difs = {},
						style = t.style,
						val, p, mpt;
					for (p in s2) {
						if (p !== "cssText") if (p !== "length") if (isNaN(p)) if (s1[p] !== (val = s2[p]) || (forceLookup && forceLookup[p])) if (p.indexOf("Origin") === -1) if (typeof(val) === "number" || typeof(val) === "string") {
							difs[p] = (val === "auto" && (p === "left" || p === "top")) ? _calculateOffset(t, p) : ((val === "" || val === "auto" || val === "none") && typeof(s1[p]) === "string" && s1[p].replace(_NaNExp, "") !== "") ? 0 : val; //if the ending value is defaulting ("" or "auto"), we check the starting value and if it can be parsed into a number (a string which could have a suffix too, like 700px), then we swap in 0 for "" or "auto" so that things actually tween.
							if (style[p] !== undefined) { //for className tweens, we must remember which properties already existed inline - the ones that didn't should be removed when the tween isn't in progress because they were only introduced to facilitate the transition between classes.
								mpt = new MiniPropTween(style, p, style[p], mpt);
							}
						}
					}
					if (vars) {
						for (p in vars) { //copy properties (except className)
							if (p !== "className") {
								difs[p] = vars[p];
							}
						}
					}
					return {difs:difs, firstMPT:mpt};
				},
				_dimensions = {width:["Left","Right"], height:["Top","Bottom"]},
				_margins = ["marginLeft","marginRight","marginTop","marginBottom"],
	
				/**
				 * @private Gets the width or height of an element
				 * @param {!Object} t Target element
				 * @param {!string} p Property name ("width" or "height")
				 * @param {Object=} cs Computed style object (if one exists). Just a speed optimization.
				 * @return {number} Dimension (in pixels)
				 */
				_getDimension = function(t, p, cs) {
					if ((t.nodeName + "").toLowerCase() === "svg") { //Chrome no longer supports offsetWidth/offsetHeight on SVG elements.
						return (cs || _getComputedStyle(t))[p] || 0;
					} else if (t.getCTM && _isSVG(t)) {
						return t.getBBox()[p] || 0;
					}
					var v = parseFloat((p === "width") ? t.offsetWidth : t.offsetHeight),
						a = _dimensions[p],
						i = a.length;
					cs = cs || _getComputedStyle(t, null);
					while (--i > -1) {
						v -= parseFloat( _getStyle(t, "padding" + a[i], cs, true) ) || 0;
						v -= parseFloat( _getStyle(t, "border" + a[i] + "Width", cs, true) ) || 0;
					}
					return v;
				},
	
				// @private Parses position-related complex strings like "top left" or "50px 10px" or "70% 20%", etc. which are used for things like transformOrigin or backgroundPosition. Optionally decorates a supplied object (recObj) with the following properties: "ox" (offsetX), "oy" (offsetY), "oxp" (if true, "ox" is a percentage not a pixel value), and "oxy" (if true, "oy" is a percentage not a pixel value)
				_parsePosition = function(v, recObj) {
					if (v === "contain" || v === "auto" || v === "auto auto") { //note: Firefox uses "auto auto" as default whereas Chrome uses "auto".
						return v + " ";
					}
					if (v == null || v === "") {
						v = "0 0";
					}
					var a = v.split(" "),
						x = (v.indexOf("left") !== -1) ? "0%" : (v.indexOf("right") !== -1) ? "100%" : a[0],
						y = (v.indexOf("top") !== -1) ? "0%" : (v.indexOf("bottom") !== -1) ? "100%" : a[1],
						i;
					if (a.length > 3 && !recObj) { //multiple positions
						a = v.split(", ").join(",").split(",");
						v = [];
						for (i = 0; i < a.length; i++) {
							v.push(_parsePosition(a[i]));
						}
						return v.join(",");
					}
					if (y == null) {
						y = (x === "center") ? "50%" : "0";
					} else if (y === "center") {
						y = "50%";
					}
					if (x === "center" || (isNaN(parseFloat(x)) && (x + "").indexOf("=") === -1)) { //remember, the user could flip-flop the values and say "bottom center" or "center bottom", etc. "center" is ambiguous because it could be used to describe horizontal or vertical, hence the isNaN(). If there's an "=" sign in the value, it's relative.
						x = "50%";
					}
					v = x + " " + y + ((a.length > 2) ? " " + a[2] : "");
					if (recObj) {
						recObj.oxp = (x.indexOf("%") !== -1);
						recObj.oyp = (y.indexOf("%") !== -1);
						recObj.oxr = (x.charAt(1) === "=");
						recObj.oyr = (y.charAt(1) === "=");
						recObj.ox = parseFloat(x.replace(_NaNExp, ""));
						recObj.oy = parseFloat(y.replace(_NaNExp, ""));
						recObj.v = v;
					}
					return recObj || v;
				},
	
				/**
				 * @private Takes an ending value (typically a string, but can be a number) and a starting value and returns the change between the two, looking for relative value indicators like += and -= and it also ignores suffixes (but make sure the ending value starts with a number or +=/-= and that the starting value is a NUMBER!)
				 * @param {(number|string)} e End value which is typically a string, but could be a number
				 * @param {(number|string)} b Beginning value which is typically a string but could be a number
				 * @return {number} Amount of change between the beginning and ending values (relative values that have a "+=" or "-=" are recognized)
				 */
				_parseChange = function(e, b) {
					if (typeof(e) === "function") {
						e = e(_index, _target);
					}
					return (typeof(e) === "string" && e.charAt(1) === "=") ? parseInt(e.charAt(0) + "1", 10) * parseFloat(e.substr(2)) : (parseFloat(e) - parseFloat(b)) || 0;
				},
	
				/**
				 * @private Takes a value and a default number, checks if the value is relative, null, or numeric and spits back a normalized number accordingly. Primarily used in the _parseTransform() function.
				 * @param {Object} v Value to be parsed
				 * @param {!number} d Default value (which is also used for relative calculations if "+=" or "-=" is found in the first parameter)
				 * @return {number} Parsed value
				 */
				_parseVal = function(v, d) {
					if (typeof(v) === "function") {
						v = v(_index, _target);
					}
					return (v == null) ? d : (typeof(v) === "string" && v.charAt(1) === "=") ? parseInt(v.charAt(0) + "1", 10) * parseFloat(v.substr(2)) + d : parseFloat(v) || 0;
				},
	
				/**
				 * @private Translates strings like "40deg" or "40" or 40rad" or "+=40deg" or "270_short" or "-90_cw" or "+=45_ccw" to a numeric radian angle. Of course a starting/default value must be fed in too so that relative values can be calculated properly.
				 * @param {Object} v Value to be parsed
				 * @param {!number} d Default value (which is also used for relative calculations if "+=" or "-=" is found in the first parameter)
				 * @param {string=} p property name for directionalEnd (optional - only used when the parsed value is directional ("_short", "_cw", or "_ccw" suffix). We need a way to store the uncompensated value so that at the end of the tween, we set it to exactly what was requested with no directional compensation). Property name would be "rotation", "rotationX", or "rotationY"
				 * @param {Object=} directionalEnd An object that will store the raw end values for directional angles ("_short", "_cw", or "_ccw" suffix). We need a way to store the uncompensated value so that at the end of the tween, we set it to exactly what was requested with no directional compensation.
				 * @return {number} parsed angle in radians
				 */
				_parseAngle = function(v, d, p, directionalEnd) {
					var min = 0.000001,
						cap, split, dif, result, isRelative;
					if (typeof(v) === "function") {
						v = v(_index, _target);
					}
					if (v == null) {
						result = d;
					} else if (typeof(v) === "number") {
						result = v;
					} else {
						cap = 360;
						split = v.split("_");
						isRelative = (v.charAt(1) === "=");
						dif = (isRelative ? parseInt(v.charAt(0) + "1", 10) * parseFloat(split[0].substr(2)) : parseFloat(split[0])) * ((v.indexOf("rad") === -1) ? 1 : _RAD2DEG) - (isRelative ? 0 : d);
						if (split.length) {
							if (directionalEnd) {
								directionalEnd[p] = d + dif;
							}
							if (v.indexOf("short") !== -1) {
								dif = dif % cap;
								if (dif !== dif % (cap / 2)) {
									dif = (dif < 0) ? dif + cap : dif - cap;
								}
							}
							if (v.indexOf("_cw") !== -1 && dif < 0) {
								dif = ((dif + cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
							} else if (v.indexOf("ccw") !== -1 && dif > 0) {
								dif = ((dif - cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
							}
						}
						result = d + dif;
					}
					if (result < min && result > -min) {
						result = 0;
					}
					return result;
				},
	
				_colorLookup = {aqua:[0,255,255],
					lime:[0,255,0],
					silver:[192,192,192],
					black:[0,0,0],
					maroon:[128,0,0],
					teal:[0,128,128],
					blue:[0,0,255],
					navy:[0,0,128],
					white:[255,255,255],
					fuchsia:[255,0,255],
					olive:[128,128,0],
					yellow:[255,255,0],
					orange:[255,165,0],
					gray:[128,128,128],
					purple:[128,0,128],
					green:[0,128,0],
					red:[255,0,0],
					pink:[255,192,203],
					cyan:[0,255,255],
					transparent:[255,255,255,0]},
	
				_hue = function(h, m1, m2) {
					h = (h < 0) ? h + 1 : (h > 1) ? h - 1 : h;
					return ((((h * 6 < 1) ? m1 + (m2 - m1) * h * 6 : (h < 0.5) ? m2 : (h * 3 < 2) ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * 255) + 0.5) | 0;
				},
	
				/**
				 * @private Parses a color (like #9F0, #FF9900, rgb(255,51,153) or hsl(108, 50%, 10%)) into an array with 3 elements for red, green, and blue or if toHSL parameter is true, it will populate the array with hue, saturation, and lightness values. If a relative value is found in an hsl() or hsla() string, it will preserve those relative prefixes and all the values in the array will be strings instead of numbers (in all other cases it will be populated with numbers).
				 * @param {(string|number)} v The value the should be parsed which could be a string like #9F0 or rgb(255,102,51) or rgba(255,0,0,0.5) or it could be a number like 0xFF00CC or even a named color like red, blue, purple, etc.
				 * @param {(boolean)} toHSL If true, an hsl() or hsla() value will be returned instead of rgb() or rgba()
				 * @return {Array.<number>} An array containing red, green, and blue (and optionally alpha) in that order, or if the toHSL parameter was true, the array will contain hue, saturation and lightness (and optionally alpha) in that order. Always numbers unless there's a relative prefix found in an hsl() or hsla() string and toHSL is true.
				 */
				_parseColor = CSSPlugin.parseColor = function(v, toHSL) {
					var a, r, g, b, h, s, l, max, min, d, wasHSL;
					if (!v) {
						a = _colorLookup.black;
					} else if (typeof(v) === "number") {
						a = [v >> 16, (v >> 8) & 255, v & 255];
					} else {
						if (v.charAt(v.length - 1) === ",") { //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
							v = v.substr(0, v.length - 1);
						}
						if (_colorLookup[v]) {
							a = _colorLookup[v];
						} else if (v.charAt(0) === "#") {
							if (v.length === 4) { //for shorthand like #9F0
								r = v.charAt(1);
								g = v.charAt(2);
								b = v.charAt(3);
								v = "#" + r + r + g + g + b + b;
							}
							v = parseInt(v.substr(1), 16);
							a = [v >> 16, (v >> 8) & 255, v & 255];
						} else if (v.substr(0, 3) === "hsl") {
							a = wasHSL = v.match(_numExp);
							if (!toHSL) {
								h = (Number(a[0]) % 360) / 360;
								s = Number(a[1]) / 100;
								l = Number(a[2]) / 100;
								g = (l <= 0.5) ? l * (s + 1) : l + s - l * s;
								r = l * 2 - g;
								if (a.length > 3) {
									a[3] = Number(a[3]);
								}
								a[0] = _hue(h + 1 / 3, r, g);
								a[1] = _hue(h, r, g);
								a[2] = _hue(h - 1 / 3, r, g);
							} else if (v.indexOf("=") !== -1) { //if relative values are found, just return the raw strings with the relative prefixes in place.
								return v.match(_relNumExp);
							}
						} else {
							a = v.match(_numExp) || _colorLookup.transparent;
						}
						a[0] = Number(a[0]);
						a[1] = Number(a[1]);
						a[2] = Number(a[2]);
						if (a.length > 3) {
							a[3] = Number(a[3]);
						}
					}
					if (toHSL && !wasHSL) {
						r = a[0] / 255;
						g = a[1] / 255;
						b = a[2] / 255;
						max = Math.max(r, g, b);
						min = Math.min(r, g, b);
						l = (max + min) / 2;
						if (max === min) {
							h = s = 0;
						} else {
							d = max - min;
							s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
							h = (max === r) ? (g - b) / d + (g < b ? 6 : 0) : (max === g) ? (b - r) / d + 2 : (r - g) / d + 4;
							h *= 60;
						}
						a[0] = (h + 0.5) | 0;
						a[1] = (s * 100 + 0.5) | 0;
						a[2] = (l * 100 + 0.5) | 0;
					}
					return a;
				},
				_formatColors = function(s, toHSL) {
					var colors = s.match(_colorExp) || [],
						charIndex = 0,
						parsed = "",
						i, color, temp;
					if (!colors.length) {
						return s;
					}
					for (i = 0; i < colors.length; i++) {
						color = colors[i];
						temp = s.substr(charIndex, s.indexOf(color, charIndex)-charIndex);
						charIndex += temp.length + color.length;
						color = _parseColor(color, toHSL);
						if (color.length === 3) {
							color.push(1);
						}
						parsed += temp + (toHSL ? "hsla(" + color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : "rgba(" + color.join(",")) + ")";
					}
					return parsed + s.substr(charIndex);
				},
				_colorExp = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b"; //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.
	
			for (p in _colorLookup) {
				_colorExp += "|" + p + "\\b";
			}
			_colorExp = new RegExp(_colorExp+")", "gi");
	
			CSSPlugin.colorStringFilter = function(a) {
				var combined = a[0] + " " + a[1],
					toHSL;
				if (_colorExp.test(combined)) {
					toHSL = (combined.indexOf("hsl(") !== -1 || combined.indexOf("hsla(") !== -1);
					a[0] = _formatColors(a[0], toHSL);
					a[1] = _formatColors(a[1], toHSL);
				}
				_colorExp.lastIndex = 0;
			};
	
			if (!TweenLite.defaultStringFilter) {
				TweenLite.defaultStringFilter = CSSPlugin.colorStringFilter;
			}
	
			/**
			 * @private Returns a formatter function that handles taking a string (or number in some cases) and returning a consistently formatted one in terms of delimiters, quantity of values, etc. For example, we may get boxShadow values defined as "0px red" or "0px 0px 10px rgb(255,0,0)" or "0px 0px 20px 20px #F00" and we need to ensure that what we get back is described with 4 numbers and a color. This allows us to feed it into the _parseComplex() method and split the values up appropriately. The neat thing about this _getFormatter() function is that the dflt defines a pattern as well as a default, so for example, _getFormatter("0px 0px 0px 0px #777", true) not only sets the default as 0px for all distances and #777 for the color, but also sets the pattern such that 4 numbers and a color will always get returned.
			 * @param {!string} dflt The default value and pattern to follow. So "0px 0px 0px 0px #777" will ensure that 4 numbers and a color will always get returned.
			 * @param {boolean=} clr If true, the values should be searched for color-related data. For example, boxShadow values typically contain a color whereas borderRadius don't.
			 * @param {boolean=} collapsible If true, the value is a top/left/right/bottom style one that acts like margin or padding, where if only one value is received, it's used for all 4; if 2 are received, the first is duplicated for 3rd (bottom) and the 2nd is duplicated for the 4th spot (left), etc.
			 * @return {Function} formatter function
			 */
			var _getFormatter = function(dflt, clr, collapsible, multi) {
					if (dflt == null) {
						return function(v) {return v;};
					}
					var dColor = clr ? (dflt.match(_colorExp) || [""])[0] : "",
						dVals = dflt.split(dColor).join("").match(_valuesExp) || [],
						pfx = dflt.substr(0, dflt.indexOf(dVals[0])),
						sfx = (dflt.charAt(dflt.length - 1) === ")") ? ")" : "",
						delim = (dflt.indexOf(" ") !== -1) ? " " : ",",
						numVals = dVals.length,
						dSfx = (numVals > 0) ? dVals[0].replace(_numExp, "") : "",
						formatter;
					if (!numVals) {
						return function(v) {return v;};
					}
					if (clr) {
						formatter = function(v) {
							var color, vals, i, a;
							if (typeof(v) === "number") {
								v += dSfx;
							} else if (multi && _commasOutsideParenExp.test(v)) {
								a = v.replace(_commasOutsideParenExp, "|").split("|");
								for (i = 0; i < a.length; i++) {
									a[i] = formatter(a[i]);
								}
								return a.join(",");
							}
							color = (v.match(_colorExp) || [dColor])[0];
							vals = v.split(color).join("").match(_valuesExp) || [];
							i = vals.length;
							if (numVals > i--) {
								while (++i < numVals) {
									vals[i] = collapsible ? vals[(((i - 1) / 2) | 0)] : dVals[i];
								}
							}
							return pfx + vals.join(delim) + delim + color + sfx + (v.indexOf("inset") !== -1 ? " inset" : "");
						};
						return formatter;
	
					}
					formatter = function(v) {
						var vals, a, i;
						if (typeof(v) === "number") {
							v += dSfx;
						} else if (multi && _commasOutsideParenExp.test(v)) {
							a = v.replace(_commasOutsideParenExp, "|").split("|");
							for (i = 0; i < a.length; i++) {
								a[i] = formatter(a[i]);
							}
							return a.join(",");
						}
						vals = v.match(_valuesExp) || [];
						i = vals.length;
						if (numVals > i--) {
							while (++i < numVals) {
								vals[i] = collapsible ? vals[(((i - 1) / 2) | 0)] : dVals[i];
							}
						}
						return pfx + vals.join(delim) + sfx;
					};
					return formatter;
				},
	
				/**
				 * @private returns a formatter function that's used for edge-related values like marginTop, marginLeft, paddingBottom, paddingRight, etc. Just pass a comma-delimited list of property names related to the edges.
				 * @param {!string} props a comma-delimited list of property names in order from top to left, like "marginTop,marginRight,marginBottom,marginLeft"
				 * @return {Function} a formatter function
				 */
				_getEdgeParser = function(props) {
					props = props.split(",");
					return function(t, e, p, cssp, pt, plugin, vars) {
						var a = (e + "").split(" "),
							i;
						vars = {};
						for (i = 0; i < 4; i++) {
							vars[props[i]] = a[i] = a[i] || a[(((i - 1) / 2) >> 0)];
						}
						return cssp.parse(t, vars, pt, plugin);
					};
				},
	
				// @private used when other plugins must tween values first, like BezierPlugin or ThrowPropsPlugin, etc. That plugin's setRatio() gets called first so that the values are updated, and then we loop through the MiniPropTweens which handle copying the values into their appropriate slots so that they can then be applied correctly in the main CSSPlugin setRatio() method. Remember, we typically create a proxy object that has a bunch of uniquely-named properties that we feed to the sub-plugin and it does its magic normally, and then we must interpret those values and apply them to the css because often numbers must get combined/concatenated, suffixes added, etc. to work with css, like boxShadow could have 4 values plus a color.
				_setPluginRatio = _internals._setPluginRatio = function(v) {
					this.plugin.setRatio(v);
					var d = this.data,
						proxy = d.proxy,
						mpt = d.firstMPT,
						min = 0.000001,
						val, pt, i, str, p;
					while (mpt) {
						val = proxy[mpt.v];
						if (mpt.r) {
							val = mpt.r(val);
						} else if (val < min && val > -min) {
							val = 0;
						}
						mpt.t[mpt.p] = val;
						mpt = mpt._next;
					}
					if (d.autoRotate) {
						d.autoRotate.rotation = d.mod ? d.mod.call(this._tween, proxy.rotation, this.t, this._tween) : proxy.rotation; //special case for ModifyPlugin to hook into an auto-rotating bezier
					}
					//at the end, we must set the CSSPropTween's "e" (end) value dynamically here because that's what is used in the final setRatio() method. Same for "b" at the beginning.
					if (v === 1 || v === 0) {
						mpt = d.firstMPT;
						p = (v === 1) ? "e" : "b";
						while (mpt) {
							pt = mpt.t;
							if (!pt.type) {
								pt[p] = pt.s + pt.xs0;
							} else if (pt.type === 1) {
								str = pt.xs0 + pt.s + pt.xs1;
								for (i = 1; i < pt.l; i++) {
									str += pt["xn"+i] + pt["xs"+(i+1)];
								}
								pt[p] = str;
							}
							mpt = mpt._next;
						}
					}
				},
	
				/**
				 * @private @constructor Used by a few SpecialProps to hold important values for proxies. For example, _parseToProxy() creates a MiniPropTween instance for each property that must get tweened on the proxy, and we record the original property name as well as the unique one we create for the proxy, plus whether or not the value needs to be rounded plus the original value.
				 * @param {!Object} t target object whose property we're tweening (often a CSSPropTween)
				 * @param {!string} p property name
				 * @param {(number|string|object)} v value
				 * @param {MiniPropTween=} next next MiniPropTween in the linked list
				 * @param {boolean=} r if true, the tweened value should be rounded to the nearest integer
				 */
				MiniPropTween = function(t, p, v, next, r) {
					this.t = t;
					this.p = p;
					this.v = v;
					this.r = r;
					if (next) {
						next._prev = this;
						this._next = next;
					}
				},
	
				/**
				 * @private Most other plugins (like BezierPlugin and ThrowPropsPlugin and others) can only tween numeric values, but CSSPlugin must accommodate special values that have a bunch of extra data (like a suffix or strings between numeric values, etc.). For example, boxShadow has values like "10px 10px 20px 30px rgb(255,0,0)" which would utterly confuse other plugins. This method allows us to split that data apart and grab only the numeric data and attach it to uniquely-named properties of a generic proxy object ({}) so that we can feed that to virtually any plugin to have the numbers tweened. However, we must also keep track of which properties from the proxy go with which CSSPropTween values and instances. So we create a linked list of MiniPropTweens. Each one records a target (the original CSSPropTween), property (like "s" or "xn1" or "xn2") that we're tweening and the unique property name that was used for the proxy (like "boxShadow_xn1" and "boxShadow_xn2") and whether or not they need to be rounded. That way, in the _setPluginRatio() method we can simply copy the values over from the proxy to the CSSPropTween instance(s). Then, when the main CSSPlugin setRatio() method runs and applies the CSSPropTween values accordingly, they're updated nicely. So the external plugin tweens the numbers, _setPluginRatio() copies them over, and setRatio() acts normally, applying css-specific values to the element.
				 * This method returns an object that has the following properties:
				 *  - proxy: a generic object containing the starting values for all the properties that will be tweened by the external plugin.  This is what we feed to the external _onInitTween() as the target
				 *  - end: a generic object containing the ending values for all the properties that will be tweened by the external plugin. This is what we feed to the external plugin's _onInitTween() as the destination values
				 *  - firstMPT: the first MiniPropTween in the linked list
				 *  - pt: the first CSSPropTween in the linked list that was created when parsing. If shallow is true, this linked list will NOT attach to the one passed into the _parseToProxy() as the "pt" (4th) parameter.
				 * @param {!Object} t target object to be tweened
				 * @param {!(Object|string)} vars the object containing the information about the tweening values (typically the end/destination values) that should be parsed
				 * @param {!CSSPlugin} cssp The CSSPlugin instance
				 * @param {CSSPropTween=} pt the next CSSPropTween in the linked list
				 * @param {TweenPlugin=} plugin the external TweenPlugin instance that will be handling tweening the numeric values
				 * @param {boolean=} shallow if true, the resulting linked list from the parse will NOT be attached to the CSSPropTween that was passed in as the "pt" (4th) parameter.
				 * @return An object containing the following properties: proxy, end, firstMPT, and pt (see above for descriptions)
				 */
				_parseToProxy = _internals._parseToProxy = function(t, vars, cssp, pt, plugin, shallow) {
					var bpt = pt,
						start = {},
						end = {},
						transform = cssp._transform,
						oldForce = _forcePT,
						i, p, xp, mpt, firstPT;
					cssp._transform = null;
					_forcePT = vars;
					pt = firstPT = cssp.parse(t, vars, pt, plugin);
					_forcePT = oldForce;
					//break off from the linked list so the new ones are isolated.
					if (shallow) {
						cssp._transform = transform;
						if (bpt) {
							bpt._prev = null;
							if (bpt._prev) {
								bpt._prev._next = null;
							}
						}
					}
					while (pt && pt !== bpt) {
						if (pt.type <= 1) {
							p = pt.p;
							end[p] = pt.s + pt.c;
							start[p] = pt.s;
							if (!shallow) {
								mpt = new MiniPropTween(pt, "s", p, mpt, pt.r);
								pt.c = 0;
							}
							if (pt.type === 1) {
								i = pt.l;
								while (--i > 0) {
									xp = "xn" + i;
									p = pt.p + "_" + xp;
									end[p] = pt.data[xp];
									start[p] = pt[xp];
									if (!shallow) {
										mpt = new MiniPropTween(pt, xp, p, mpt, pt.rxp[xp]);
									}
								}
							}
						}
						pt = pt._next;
					}
					return {proxy:start, end:end, firstMPT:mpt, pt:firstPT};
				},
	
	
	
				/**
				 * @constructor Each property that is tweened has at least one CSSPropTween associated with it. These instances store important information like the target, property, starting value, amount of change, etc. They can also optionally have a number of "extra" strings and numeric values named xs1, xn1, xs2, xn2, xs3, xn3, etc. where "s" indicates string and "n" indicates number. These can be pieced together in a complex-value tween (type:1) that has alternating types of data like a string, number, string, number, etc. For example, boxShadow could be "5px 5px 8px rgb(102, 102, 51)". In that value, there are 6 numbers that may need to tween and then pieced back together into a string again with spaces, suffixes, etc. xs0 is special in that it stores the suffix for standard (type:0) tweens, -OR- the first string (prefix) in a complex-value (type:1) CSSPropTween -OR- it can be the non-tweening value in a type:-1 CSSPropTween. We do this to conserve memory.
				 * CSSPropTweens have the following optional properties as well (not defined through the constructor):
				 *  - l: Length in terms of the number of extra properties that the CSSPropTween has (default: 0). For example, for a boxShadow we may need to tween 5 numbers in which case l would be 5; Keep in mind that the start/end values for the first number that's tweened are always stored in the s and c properties to conserve memory. All additional values thereafter are stored in xn1, xn2, etc.
				 *  - xfirst: The first instance of any sub-CSSPropTweens that are tweening properties of this instance. For example, we may split up a boxShadow tween so that there's a main CSSPropTween of type:1 that has various xs* and xn* values associated with the h-shadow, v-shadow, blur, color, etc. Then we spawn a CSSPropTween for each of those that has a higher priority and runs BEFORE the main CSSPropTween so that the values are all set by the time it needs to re-assemble them. The xfirst gives us an easy way to identify the first one in that chain which typically ends at the main one (because they're all prepende to the linked list)
				 *  - plugin: The TweenPlugin instance that will handle the tweening of any complex values. For example, sometimes we don't want to use normal subtweens (like xfirst refers to) to tween the values - we might want ThrowPropsPlugin or BezierPlugin some other plugin to do the actual tweening, so we create a plugin instance and store a reference here. We need this reference so that if we get a request to round values or disable a tween, we can pass along that request.
				 *  - data: Arbitrary data that needs to be stored with the CSSPropTween. Typically if we're going to have a plugin handle the tweening of a complex-value tween, we create a generic object that stores the END values that we're tweening to and the CSSPropTween's xs1, xs2, etc. have the starting values. We store that object as data. That way, we can simply pass that object to the plugin and use the CSSPropTween as the target.
				 *  - setRatio: Only used for type:2 tweens that require custom functionality. In this case, we call the CSSPropTween's setRatio() method and pass the ratio each time the tween updates. This isn't quite as efficient as doing things directly in the CSSPlugin's setRatio() method, but it's very convenient and flexible.
				 * @param {!Object} t Target object whose property will be tweened. Often a DOM element, but not always. It could be anything.
				 * @param {string} p Property to tween (name). For example, to tween element.width, p would be "width".
				 * @param {number} s Starting numeric value
				 * @param {number} c Change in numeric value over the course of the entire tween. For example, if element.width starts at 5 and should end at 100, c would be 95.
				 * @param {CSSPropTween=} next The next CSSPropTween in the linked list. If one is defined, we will define its _prev as the new instance, and the new instance's _next will be pointed at it.
				 * @param {number=} type The type of CSSPropTween where -1 = a non-tweening value, 0 = a standard simple tween, 1 = a complex value (like one that has multiple numbers in a comma- or space-delimited string like border:"1px solid red"), and 2 = one that uses a custom setRatio function that does all of the work of applying the values on each update.
				 * @param {string=} n Name of the property that should be used for overwriting purposes which is typically the same as p but not always. For example, we may need to create a subtween for the 2nd part of a "clip:rect(...)" tween in which case "p" might be xs1 but "n" is still "clip"
				 * @param {boolean=} r If true, the value(s) should be rounded
				 * @param {number=} pr Priority in the linked list order. Higher priority CSSPropTweens will be updated before lower priority ones. The default priority is 0.
				 * @param {string=} b Beginning value. We store this to ensure that it is EXACTLY what it was when the tween began without any risk of interpretation issues.
				 * @param {string=} e Ending value. We store this to ensure that it is EXACTLY what the user defined at the end of the tween without any risk of interpretation issues.
				 */
				CSSPropTween = _internals.CSSPropTween = function(t, p, s, c, next, type, n, r, pr, b, e) {
					this.t = t; //target
					this.p = p; //property
					this.s = s; //starting value
					this.c = c; //change value
					this.n = n || p; //name that this CSSPropTween should be associated to (usually the same as p, but not always - n is what overwriting looks at)
					if (!(t instanceof CSSPropTween)) {
						_overwriteProps.push(this.n);
					}
					this.r = !r ? r : (typeof(r) === "function") ? r : Math.round; //round (boolean)
					this.type = type || 0; //0 = normal tween, -1 = non-tweening (in which case xs0 will be applied to the target's property, like tp.t[tp.p] = tp.xs0), 1 = complex-value SpecialProp, 2 = custom setRatio() that does all the work
					if (pr) {
						this.pr = pr;
						_hasPriority = true;
					}
					this.b = (b === undefined) ? s : b;
					this.e = (e === undefined) ? s + c : e;
					if (next) {
						this._next = next;
						next._prev = this;
					}
				},
	
				_addNonTweeningNumericPT = function(target, prop, start, end, next, overwriteProp) { //cleans up some code redundancies and helps minification. Just a fast way to add a NUMERIC non-tweening CSSPropTween
					var pt = new CSSPropTween(target, prop, start, end - start, next, -1, overwriteProp);
					pt.b = start;
					pt.e = pt.xs0 = end;
					return pt;
				},
	
				/**
				 * Takes a target, the beginning value and ending value (as strings) and parses them into a CSSPropTween (possibly with child CSSPropTweens) that accommodates multiple numbers, colors, comma-delimited values, etc. For example:
				 * sp.parseComplex(element, "boxShadow", "5px 10px 20px rgb(255,102,51)", "0px 0px 0px red", true, "0px 0px 0px rgb(0,0,0,0)", pt);
				 * It will walk through the beginning and ending values (which should be in the same format with the same number and type of values) and figure out which parts are numbers, what strings separate the numeric/tweenable values, and then create the CSSPropTweens accordingly. If a plugin is defined, no child CSSPropTweens will be created. Instead, the ending values will be stored in the "data" property of the returned CSSPropTween like: {s:-5, xn1:-10, xn2:-20, xn3:255, xn4:0, xn5:0} so that it can be fed to any other plugin and it'll be plain numeric tweens but the recomposition of the complex value will be handled inside CSSPlugin's setRatio().
				 * If a setRatio is defined, the type of the CSSPropTween will be set to 2 and recomposition of the values will be the responsibility of that method.
				 *
				 * @param {!Object} t Target whose property will be tweened
				 * @param {!string} p Property that will be tweened (its name, like "left" or "backgroundColor" or "boxShadow")
				 * @param {string} b Beginning value
				 * @param {string} e Ending value
				 * @param {boolean} clrs If true, the value could contain a color value like "rgb(255,0,0)" or "#F00" or "red". The default is false, so no colors will be recognized (a performance optimization)
				 * @param {(string|number|Object)} dflt The default beginning value that should be used if no valid beginning value is defined or if the number of values inside the complex beginning and ending values don't match
				 * @param {?CSSPropTween} pt CSSPropTween instance that is the current head of the linked list (we'll prepend to this).
				 * @param {number=} pr Priority in the linked list order. Higher priority properties will be updated before lower priority ones. The default priority is 0.
				 * @param {TweenPlugin=} plugin If a plugin should handle the tweening of extra properties, pass the plugin instance here. If one is defined, then NO subtweens will be created for any extra properties (the properties will be created - just not additional CSSPropTween instances to tween them) because the plugin is expected to do so. However, the end values WILL be populated in the "data" property, like {s:100, xn1:50, xn2:300}
				 * @param {function(number)=} setRatio If values should be set in a custom function instead of being pieced together in a type:1 (complex-value) CSSPropTween, define that custom function here.
				 * @return {CSSPropTween} The first CSSPropTween in the linked list which includes the new one(s) added by the parseComplex() call.
				 */
				_parseComplex = CSSPlugin.parseComplex = function(t, p, b, e, clrs, dflt, pt, pr, plugin, setRatio) {
					//DEBUG: _log("parseComplex: "+p+", b: "+b+", e: "+e);
					b = b || dflt || "";
					if (typeof(e) === "function") {
						e = e(_index, _target);
					}
					pt = new CSSPropTween(t, p, 0, 0, pt, (setRatio ? 2 : 1), null, false, pr, b, e);
					e += ""; //ensures it's a string
					if (clrs && _colorExp.test(e + b)) { //if colors are found, normalize the formatting to rgba() or hsla().
						e = [b, e];
						CSSPlugin.colorStringFilter(e);
						b = e[0];
						e = e[1];
					}
					var ba = b.split(", ").join(",").split(" "), //beginning array
						ea = e.split(", ").join(",").split(" "), //ending array
						l = ba.length,
						autoRound = (_autoRound !== false),
						i, xi, ni, bv, ev, bnums, enums, bn, hasAlpha, temp, cv, str, useHSL;
					if (e.indexOf(",") !== -1 || b.indexOf(",") !== -1) {
						if ((e + b).indexOf("rgb") !== -1 || (e + b).indexOf("hsl") !== -1) { //keep rgb(), rgba(), hsl(), and hsla() values together! (remember, we're splitting on spaces)
							ba = ba.join(" ").replace(_commasOutsideParenExp, ", ").split(" ");
							ea = ea.join(" ").replace(_commasOutsideParenExp, ", ").split(" ");
						} else {
							ba = ba.join(" ").split(",").join(", ").split(" ");
							ea = ea.join(" ").split(",").join(", ").split(" ");
						}
						l = ba.length;
					}
					if (l !== ea.length) {
						//DEBUG: _log("mismatched formatting detected on " + p + " (" + b + " vs " + e + ")");
						ba = (dflt || "").split(" ");
						l = ba.length;
					}
					pt.plugin = plugin;
					pt.setRatio = setRatio;
					_colorExp.lastIndex = 0;
					for (i = 0; i < l; i++) {
						bv = ba[i];
						ev = ea[i] + "";
						bn = parseFloat(bv);
						//if the value begins with a number (most common). It's fine if it has a suffix like px
						if (bn || bn === 0) {
							pt.appendXtra("", bn, _parseChange(ev, bn), ev.replace(_relNumExp, ""), (autoRound && ev.indexOf("px") !== -1) ? Math.round : false, true);
	
						//if the value is a color
						} else if (clrs && _colorExp.test(bv)) {
							str = ev.indexOf(")") + 1;
							str = ")" + (str ? ev.substr(str) : ""); //if there's a comma or ) at the end, retain it.
							useHSL = (ev.indexOf("hsl") !== -1 && _supportsOpacity);
							temp = ev; //original string value so we can look for any prefix later.
							bv = _parseColor(bv, useHSL);
							ev = _parseColor(ev, useHSL);
							hasAlpha = (bv.length + ev.length > 6);
							if (hasAlpha && !_supportsOpacity && ev[3] === 0) { //older versions of IE don't support rgba(), so if the destination alpha is 0, just use "transparent" for the end color
								pt["xs" + pt.l] += pt.l ? " transparent" : "transparent";
								pt.e = pt.e.split(ea[i]).join("transparent");
							} else {
								if (!_supportsOpacity) { //old versions of IE don't support rgba().
									hasAlpha = false;
								}
								if (useHSL) {
									pt.appendXtra(temp.substr(0, temp.indexOf("hsl")) + (hasAlpha ? "hsla(" : "hsl("), bv[0], _parseChange(ev[0], bv[0]), ",", false, true)
										.appendXtra("", bv[1], _parseChange(ev[1], bv[1]), "%,", false)
										.appendXtra("", bv[2], _parseChange(ev[2], bv[2]), (hasAlpha ? "%," : "%" + str), false);
								} else {
									pt.appendXtra(temp.substr(0, temp.indexOf("rgb")) + (hasAlpha ? "rgba(" : "rgb("), bv[0], ev[0] - bv[0], ",", Math.round, true)
										.appendXtra("", bv[1], ev[1] - bv[1], ",", Math.round)
										.appendXtra("", bv[2], ev[2] - bv[2], (hasAlpha ? "," : str), Math.round);
								}
	
								if (hasAlpha) {
									bv = (bv.length < 4) ? 1 : bv[3];
									pt.appendXtra("", bv, ((ev.length < 4) ? 1 : ev[3]) - bv, str, false);
								}
							}
							_colorExp.lastIndex = 0; //otherwise the test() on the RegExp could move the lastIndex and taint future results.
	
						} else {
							bnums = bv.match(_numExp); //gets each group of numbers in the beginning value string and drops them into an array
	
							//if no number is found, treat it as a non-tweening value and just append the string to the current xs.
							if (!bnums) {
								pt["xs" + pt.l] += (pt.l || pt["xs" + pt.l]) ? " " + ev : ev;
	
							//loop through all the numbers that are found and construct the extra values on the pt.
							} else {
								enums = ev.match(_relNumExp); //get each group of numbers in the end value string and drop them into an array. We allow relative values too, like +=50 or -=.5
								if (!enums || enums.length !== bnums.length) {
									//DEBUG: _log("mismatched formatting detected on " + p + " (" + b + " vs " + e + ")");
									return pt;
								}
								ni = 0;
								for (xi = 0; xi < bnums.length; xi++) {
									cv = bnums[xi];
									temp = bv.indexOf(cv, ni);
									pt.appendXtra(bv.substr(ni, temp - ni), Number(cv), _parseChange(enums[xi], cv), "", (autoRound && bv.substr(temp + cv.length, 2) === "px") ? Math.round : false, (xi === 0));
									ni = temp + cv.length;
								}
								pt["xs" + pt.l] += bv.substr(ni);
							}
						}
					}
					//if there are relative values ("+=" or "-=" prefix), we need to adjust the ending value to eliminate the prefixes and combine the values properly.
					if (e.indexOf("=") !== -1) if (pt.data) {
						str = pt.xs0 + pt.data.s;
						for (i = 1; i < pt.l; i++) {
							str += pt["xs" + i] + pt.data["xn" + i];
						}
						pt.e = str + pt["xs" + i];
					}
					if (!pt.l) {
						pt.type = -1;
						pt.xs0 = pt.e;
					}
					return pt.xfirst || pt;
				},
				i = 9;
	
	
			p = CSSPropTween.prototype;
			p.l = p.pr = 0; //length (number of extra properties like xn1, xn2, xn3, etc.
			while (--i > 0) {
				p["xn" + i] = 0;
				p["xs" + i] = "";
			}
			p.xs0 = "";
			p._next = p._prev = p.xfirst = p.data = p.plugin = p.setRatio = p.rxp = null;
	
	
			/**
			 * Appends and extra tweening value to a CSSPropTween and automatically manages any prefix and suffix strings. The first extra value is stored in the s and c of the main CSSPropTween instance, but thereafter any extras are stored in the xn1, xn2, xn3, etc. The prefixes and suffixes are stored in the xs0, xs1, xs2, etc. properties. For example, if I walk through a clip value like "rect(10px, 5px, 0px, 20px)", the values would be stored like this:
			 * xs0:"rect(", s:10, xs1:"px, ", xn1:5, xs2:"px, ", xn2:0, xs3:"px, ", xn3:20, xn4:"px)"
			 * And they'd all get joined together when the CSSPlugin renders (in the setRatio() method).
			 * @param {string=} pfx Prefix (if any)
			 * @param {!number} s Starting value
			 * @param {!number} c Change in numeric value over the course of the entire tween. For example, if the start is 5 and the end is 100, the change would be 95.
			 * @param {string=} sfx Suffix (if any)
			 * @param {boolean=} r Round (if true).
			 * @param {boolean=} pad If true, this extra value should be separated by the previous one by a space. If there is no previous extra and pad is true, it will automatically drop the space.
			 * @return {CSSPropTween} returns itself so that multiple methods can be chained together.
			 */
			p.appendXtra = function(pfx, s, c, sfx, r, pad) {
				var pt = this,
					l = pt.l;
				pt["xs" + l] += (pad && (l || pt["xs" + l])) ? " " + pfx : pfx || "";
				if (!c) if (l !== 0 && !pt.plugin) { //typically we'll combine non-changing values right into the xs to optimize performance, but we don't combine them when there's a plugin that will be tweening the values because it may depend on the values being split apart, like for a bezier, if a value doesn't change between the first and second iteration but then it does on the 3rd, we'll run into trouble because there's no xn slot for that value!
					pt["xs" + l] += s + (sfx || "");
					return pt;
				}
				pt.l++;
				pt.type = pt.setRatio ? 2 : 1;
				pt["xs" + pt.l] = sfx || "";
				if (l > 0) {
					pt.data["xn" + l] = s + c;
					pt.rxp["xn" + l] = r; //round extra property (we need to tap into this in the _parseToProxy() method)
					pt["xn" + l] = s;
					if (!pt.plugin) {
						pt.xfirst = new CSSPropTween(pt, "xn" + l, s, c, pt.xfirst || pt, 0, pt.n, r, pt.pr);
						pt.xfirst.xs0 = 0; //just to ensure that the property stays numeric which helps modern browsers speed up processing. Remember, in the setRatio() method, we do pt.t[pt.p] = val + pt.xs0 so if pt.xs0 is "" (the default), it'll cast the end value as a string. When a property is a number sometimes and a string sometimes, it prevents the compiler from locking in the data type, slowing things down slightly.
					}
					return pt;
				}
				pt.data = {s:s + c};
				pt.rxp = {};
				pt.s = s;
				pt.c = c;
				pt.r = r;
				return pt;
			};
	
			/**
			 * @constructor A SpecialProp is basically a css property that needs to be treated in a non-standard way, like if it may contain a complex value like boxShadow:"5px 10px 15px rgb(255, 102, 51)" or if it is associated with another plugin like ThrowPropsPlugin or BezierPlugin. Every SpecialProp is associated with a particular property name like "boxShadow" or "throwProps" or "bezier" and it will intercept those values in the vars object that's passed to the CSSPlugin and handle them accordingly.
			 * @param {!string} p Property name (like "boxShadow" or "throwProps")
			 * @param {Object=} options An object containing any of the following configuration options:
			 *                      - defaultValue: the default value
			 *                      - parser: A function that should be called when the associated property name is found in the vars. This function should return a CSSPropTween instance and it should ensure that it is properly inserted into the linked list. It will receive 4 paramters: 1) The target, 2) The value defined in the vars, 3) The CSSPlugin instance (whose _firstPT should be used for the linked list), and 4) A computed style object if one was calculated (this is a speed optimization that allows retrieval of starting values quicker)
			 *                      - formatter: a function that formats any value received for this special property (for example, boxShadow could take "5px 5px red" and format it to "5px 5px 0px 0px red" so that both the beginning and ending values have a common order and quantity of values.)
			 *                      - prefix: if true, we'll determine whether or not this property requires a vendor prefix (like Webkit or Moz or ms or O)
			 *                      - color: set this to true if the value for this SpecialProp may contain color-related values like rgb(), rgba(), etc.
			 *                      - priority: priority in the linked list order. Higher priority SpecialProps will be updated before lower priority ones. The default priority is 0.
			 *                      - multi: if true, the formatter should accommodate a comma-delimited list of values, like boxShadow could have multiple boxShadows listed out.
			 *                      - collapsible: if true, the formatter should treat the value like it's a top/right/bottom/left value that could be collapsed, like "5px" would apply to all, "5px, 10px" would use 5px for top/bottom and 10px for right/left, etc.
			 *                      - keyword: a special keyword that can [optionally] be found inside the value (like "inset" for boxShadow). This allows us to validate beginning/ending values to make sure they match (if the keyword is found in one, it'll be added to the other for consistency by default).
			 */
			var SpecialProp = function(p, options) {
					options = options || {};
					this.p = options.prefix ? _checkPropPrefix(p) || p : p;
					_specialProps[p] = _specialProps[this.p] = this;
					this.format = options.formatter || _getFormatter(options.defaultValue, options.color, options.collapsible, options.multi);
					if (options.parser) {
						this.parse = options.parser;
					}
					this.clrs = options.color;
					this.multi = options.multi;
					this.keyword = options.keyword;
					this.dflt = options.defaultValue;
					this.pr = options.priority || 0;
				},
	
				//shortcut for creating a new SpecialProp that can accept multiple properties as a comma-delimited list (helps minification). dflt can be an array for multiple values (we don't do a comma-delimited list because the default value may contain commas, like rect(0px,0px,0px,0px)). We attach this method to the SpecialProp class/object instead of using a private _createSpecialProp() method so that we can tap into it externally if necessary, like from another plugin.
				_registerComplexSpecialProp = _internals._registerComplexSpecialProp = function(p, options, defaults) {
					if (typeof(options) !== "object") {
						options = {parser:defaults}; //to make backwards compatible with older versions of BezierPlugin and ThrowPropsPlugin
					}
					var a = p.split(","),
						d = options.defaultValue,
						i, temp;
					defaults = defaults || [d];
					for (i = 0; i < a.length; i++) {
						options.prefix = (i === 0 && options.prefix);
						options.defaultValue = defaults[i] || d;
						temp = new SpecialProp(a[i], options);
					}
				},
	
				//creates a placeholder special prop for a plugin so that the property gets caught the first time a tween of it is attempted, and at that time it makes the plugin register itself, thus taking over for all future tweens of that property. This allows us to not mandate that things load in a particular order and it also allows us to log() an error that informs the user when they attempt to tween an external plugin-related property without loading its .js file.
				_registerPluginProp = _internals._registerPluginProp = function(p) {
					if (!_specialProps[p]) {
						var pluginName = p.charAt(0).toUpperCase() + p.substr(1) + "Plugin";
						_registerComplexSpecialProp(p, {parser:function(t, e, p, cssp, pt, plugin, vars) {
							var pluginClass = _globals.com.greensock.plugins[pluginName];
							if (!pluginClass) {
								_log("Error: " + pluginName + " js file not loaded.");
								return pt;
							}
							pluginClass._cssRegister();
							return _specialProps[p].parse(t, e, p, cssp, pt, plugin, vars);
						}});
					}
				};
	
	
			p = SpecialProp.prototype;
	
			/**
			 * Alias for _parseComplex() that automatically plugs in certain values for this SpecialProp, like its property name, whether or not colors should be sensed, the default value, and priority. It also looks for any keyword that the SpecialProp defines (like "inset" for boxShadow) and ensures that the beginning and ending values have the same number of values for SpecialProps where multi is true (like boxShadow and textShadow can have a comma-delimited list)
			 * @param {!Object} t target element
			 * @param {(string|number|object)} b beginning value
			 * @param {(string|number|object)} e ending (destination) value
			 * @param {CSSPropTween=} pt next CSSPropTween in the linked list
			 * @param {TweenPlugin=} plugin If another plugin will be tweening the complex value, that TweenPlugin instance goes here.
			 * @param {function=} setRatio If a custom setRatio() method should be used to handle this complex value, that goes here.
			 * @return {CSSPropTween=} First CSSPropTween in the linked list
			 */
			p.parseComplex = function(t, b, e, pt, plugin, setRatio) {
				var kwd = this.keyword,
					i, ba, ea, l, bi, ei;
				//if this SpecialProp's value can contain a comma-delimited list of values (like boxShadow or textShadow), we must parse them in a special way, and look for a keyword (like "inset" for boxShadow) and ensure that the beginning and ending BOTH have it if the end defines it as such. We also must ensure that there are an equal number of values specified (we can't tween 1 boxShadow to 3 for example)
				if (this.multi) if (_commasOutsideParenExp.test(e) || _commasOutsideParenExp.test(b)) {
					ba = b.replace(_commasOutsideParenExp, "|").split("|");
					ea = e.replace(_commasOutsideParenExp, "|").split("|");
				} else if (kwd) {
					ba = [b];
					ea = [e];
				}
				if (ea) {
					l = (ea.length > ba.length) ? ea.length : ba.length;
					for (i = 0; i < l; i++) {
						b = ba[i] = ba[i] || this.dflt;
						e = ea[i] = ea[i] || this.dflt;
						if (kwd) {
							bi = b.indexOf(kwd);
							ei = e.indexOf(kwd);
							if (bi !== ei) {
								if (ei === -1) { //if the keyword isn't in the end value, remove it from the beginning one.
									ba[i] = ba[i].split(kwd).join("");
								} else if (bi === -1) { //if the keyword isn't in the beginning, add it.
									ba[i] += " " + kwd;
								}
							}
						}
					}
					b = ba.join(", ");
					e = ea.join(", ");
				}
				return _parseComplex(t, this.p, b, e, this.clrs, this.dflt, pt, this.pr, plugin, setRatio);
			};
	
			/**
			 * Accepts a target and end value and spits back a CSSPropTween that has been inserted into the CSSPlugin's linked list and conforms with all the conventions we use internally, like type:-1, 0, 1, or 2, setting up any extra property tweens, priority, etc. For example, if we have a boxShadow SpecialProp and call:
			 * this._firstPT = sp.parse(element, "5px 10px 20px rgb(2550,102,51)", "boxShadow", this);
			 * It should figure out the starting value of the element's boxShadow, compare it to the provided end value and create all the necessary CSSPropTweens of the appropriate types to tween the boxShadow. The CSSPropTween that gets spit back should already be inserted into the linked list (the 4th parameter is the current head, so prepend to that).
			 * @param {!Object} t Target object whose property is being tweened
			 * @param {Object} e End value as provided in the vars object (typically a string, but not always - like a throwProps would be an object).
			 * @param {!string} p Property name
			 * @param {!CSSPlugin} cssp The CSSPlugin instance that should be associated with this tween.
			 * @param {?CSSPropTween} pt The CSSPropTween that is the current head of the linked list (we'll prepend to it)
			 * @param {TweenPlugin=} plugin If a plugin will be used to tween the parsed value, this is the plugin instance.
			 * @param {Object=} vars Original vars object that contains the data for parsing.
			 * @return {CSSPropTween} The first CSSPropTween in the linked list which includes the new one(s) added by the parse() call.
			 */
			p.parse = function(t, e, p, cssp, pt, plugin, vars) {
				return this.parseComplex(t.style, this.format(_getStyle(t, this.p, _cs, false, this.dflt)), this.format(e), pt, plugin);
			};
	
			/**
			 * Registers a special property that should be intercepted from any "css" objects defined in tweens. This allows you to handle them however you want without CSSPlugin doing it for you. The 2nd parameter should be a function that accepts 3 parameters:
			 *  1) Target object whose property should be tweened (typically a DOM element)
			 *  2) The end/destination value (could be a string, number, object, or whatever you want)
			 *  3) The tween instance (you probably don't need to worry about this, but it can be useful for looking up information like the duration)
			 *
			 * Then, your function should return a function which will be called each time the tween gets rendered, passing a numeric "ratio" parameter to your function that indicates the change factor (usually between 0 and 1). For example:
			 *
			 * CSSPlugin.registerSpecialProp("myCustomProp", function(target, value, tween) {
			 *      var start = target.style.width;
			 *      return function(ratio) {
			 *              target.style.width = (start + value * ratio) + "px";
			 *              console.log("set width to " + target.style.width);
			 *          }
			 * }, 0);
			 *
			 * Then, when I do this tween, it will trigger my special property:
			 *
			 * TweenLite.to(element, 1, {css:{myCustomProp:100}});
			 *
			 * In the example, of course, we're just changing the width, but you can do anything you want.
			 *
			 * @param {!string} name Property name (or comma-delimited list of property names) that should be intercepted and handled by your function. For example, if I define "myCustomProp", then it would handle that portion of the following tween: TweenLite.to(element, 1, {css:{myCustomProp:100}})
			 * @param {!function(Object, Object, Object, string):function(number)} onInitTween The function that will be called when a tween of this special property is performed. The function will receive 4 parameters: 1) Target object that should be tweened, 2) Value that was passed to the tween, 3) The tween instance itself (rarely used), and 4) The property name that's being tweened. Your function should return a function that should be called on every update of the tween. That function will receive a single parameter that is a "change factor" value (typically between 0 and 1) indicating the amount of change as a ratio. You can use this to determine how to set the values appropriately in your function.
			 * @param {number=} priority Priority that helps the engine determine the order in which to set the properties (default: 0). Higher priority properties will be updated before lower priority ones.
			 */
			CSSPlugin.registerSpecialProp = function(name, onInitTween, priority) {
				_registerComplexSpecialProp(name, {parser:function(t, e, p, cssp, pt, plugin, vars) {
					var rv = new CSSPropTween(t, p, 0, 0, pt, 2, p, false, priority);
					rv.plugin = plugin;
					rv.setRatio = onInitTween(t, e, cssp._tween, p);
					return rv;
				}, priority:priority});
			};
	
	
	
	
	
	
			//transform-related methods and properties
			CSSPlugin.useSVGTransformAttr = true; //Safari and Firefox both have some rendering bugs when applying CSS transforms to SVG elements, so default to using the "transform" attribute instead (users can override this).
			var _transformProps = ("scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent").split(","),
				_transformProp = _checkPropPrefix("transform"), //the Javascript (camelCase) transform property, like msTransform, WebkitTransform, MozTransform, or OTransform.
				_transformPropCSS = _prefixCSS + "transform",
				_transformOriginProp = _checkPropPrefix("transformOrigin"),
				_supports3D = (_checkPropPrefix("perspective") !== null),
				Transform = _internals.Transform = function() {
					this.perspective = parseFloat(CSSPlugin.defaultTransformPerspective) || 0;
					this.force3D = (CSSPlugin.defaultForce3D === false || !_supports3D) ? false : CSSPlugin.defaultForce3D || "auto";
				},
				_SVGElement = _gsScope.SVGElement,
				_useSVGTransformAttr,
				//Some browsers (like Firefox and IE) don't honor transform-origin properly in SVG elements, so we need to manually adjust the matrix accordingly. We feature detect here rather than always doing the conversion for certain browsers because they may fix the problem at some point in the future.
	
				_createSVG = function(type, container, attributes) {
					var element = _doc.createElementNS("http://www.w3.org/2000/svg", type),
						reg = /([a-z])([A-Z])/g,
						p;
					for (p in attributes) {
						element.setAttributeNS(null, p.replace(reg, "$1-$2").toLowerCase(), attributes[p]);
					}
					container.appendChild(element);
					return element;
				},
				_docElement = _doc.documentElement || {},
				_forceSVGTransformAttr = (function() {
					//IE and Android stock don't support CSS transforms on SVG elements, so we must write them to the "transform" attribute. We populate this variable in the _parseTransform() method, and only if/when we come across an SVG element
					var force = _ieVers || (/Android/i.test(_agent) && !_gsScope.chrome),
						svg, rect, width;
					if (_doc.createElementNS && !force) { //IE8 and earlier doesn't support SVG anyway
						svg = _createSVG("svg", _docElement);
						rect = _createSVG("rect", svg, {width:100, height:50, x:100});
						width = rect.getBoundingClientRect().width;
						rect.style[_transformOriginProp] = "50% 50%";
						rect.style[_transformProp] = "scaleX(0.5)";
						force = (width === rect.getBoundingClientRect().width && !(_isFirefox && _supports3D)); //note: Firefox fails the test even though it does support CSS transforms in 3D. Since we can't push 3D stuff into the transform attribute, we force Firefox to pass the test here (as long as it does truly support 3D).
						_docElement.removeChild(svg);
					}
					return force;
				})(),
				_parseSVGOrigin = function(e, local, decoratee, absolute, smoothOrigin, skipRecord) {
					var tm = e._gsTransform,
						m = _getMatrix(e, true),
						v, x, y, xOrigin, yOrigin, a, b, c, d, tx, ty, determinant, xOriginOld, yOriginOld;
					if (tm) {
						xOriginOld = tm.xOrigin; //record the original values before we alter them.
						yOriginOld = tm.yOrigin;
					}
					if (!absolute || (v = absolute.split(" ")).length < 2) {
						b = e.getBBox();
						if (b.x === 0 && b.y === 0 && b.width + b.height === 0) { //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
							b = {x: parseFloat(e.hasAttribute("x") ? e.getAttribute("x") : e.hasAttribute("cx") ? e.getAttribute("cx") : 0) || 0, y: parseFloat(e.hasAttribute("y") ? e.getAttribute("y") : e.hasAttribute("cy") ? e.getAttribute("cy") : 0) || 0, width:0, height:0};
						}
						local = _parsePosition(local).split(" ");
						v = [(local[0].indexOf("%") !== -1 ? parseFloat(local[0]) / 100 * b.width : parseFloat(local[0])) + b.x,
							 (local[1].indexOf("%") !== -1 ? parseFloat(local[1]) / 100 * b.height : parseFloat(local[1])) + b.y];
					}
					decoratee.xOrigin = xOrigin = parseFloat(v[0]);
					decoratee.yOrigin = yOrigin = parseFloat(v[1]);
					if (absolute && m !== _identity2DMatrix) { //if svgOrigin is being set, we must invert the matrix and determine where the absolute point is, factoring in the current transforms. Otherwise, the svgOrigin would be based on the element's non-transformed position on the canvas.
						a = m[0];
						b = m[1];
						c = m[2];
						d = m[3];
						tx = m[4];
						ty = m[5];
						determinant = (a * d - b * c);
						if (determinant) { //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
							x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + ((c * ty - d * tx) / determinant);
							y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - ((a * ty - b * tx) / determinant);
							xOrigin = decoratee.xOrigin = v[0] = x;
							yOrigin = decoratee.yOrigin = v[1] = y;
						}
					}
					if (tm) { //avoid jump when transformOrigin is changed - adjust the x/y values accordingly
						if (skipRecord) {
							decoratee.xOffset = tm.xOffset;
							decoratee.yOffset = tm.yOffset;
							tm = decoratee;
						}
						if (smoothOrigin || (smoothOrigin !== false && CSSPlugin.defaultSmoothOrigin !== false)) {
							x = xOrigin - xOriginOld;
							y = yOrigin - yOriginOld;
							//originally, we simply adjusted the x and y values, but that would cause problems if, for example, you created a rotational tween part-way through an x/y tween. Managing the offset in a separate variable gives us ultimate flexibility.
							//tm.x -= x - (x * m[0] + y * m[2]);
							//tm.y -= y - (x * m[1] + y * m[3]);
							tm.xOffset += (x * m[0] + y * m[2]) - x;
							tm.yOffset += (x * m[1] + y * m[3]) - y;
						} else {
							tm.xOffset = tm.yOffset = 0;
						}
					}
					if (!skipRecord) {
						e.setAttribute("data-svg-origin", v.join(" "));
					}
				},
				_getBBoxHack = function(swapIfPossible) { //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
					var svg = _createElement("svg", (this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns")) || "http://www.w3.org/2000/svg"),
						oldParent = this.parentNode,
						oldSibling = this.nextSibling,
						oldCSS = this.style.cssText,
						bbox;
					_docElement.appendChild(svg);
					svg.appendChild(this);
					this.style.display = "block";
					if (swapIfPossible) {
						try {
							bbox = this.getBBox();
							this._originalGetBBox = this.getBBox;
							this.getBBox = _getBBoxHack;
						} catch (e) { }
					} else if (this._originalGetBBox) {
						bbox = this._originalGetBBox();
					}
					if (oldSibling) {
						oldParent.insertBefore(this, oldSibling);
					} else {
						oldParent.appendChild(this);
					}
					_docElement.removeChild(svg);
					this.style.cssText = oldCSS;
					return bbox;
				},
				_getBBox = function(e) {
					try {
						return e.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
					} catch (error) {
						return _getBBoxHack.call(e, true);
					}
				},
				_isSVG = function(e) { //reports if the element is an SVG on which getBBox() actually works
					return !!(_SVGElement && e.getCTM && (!e.parentNode || e.ownerSVGElement) && _getBBox(e));
				},
				_identity2DMatrix = [1,0,0,1,0,0],
				_getMatrix = function(e, force2D) {
					var tm = e._gsTransform || new Transform(),
						rnd = 100000,
						style = e.style,
						isDefault, s, m, n, dec, none;
					if (_transformProp) {
						s = _getStyle(e, _transformPropCSS, null, true);
					} else if (e.currentStyle) {
						//for older versions of IE, we need to interpret the filter portion that is in the format: progid:DXImageTransform.Microsoft.Matrix(M11=6.123233995736766e-17, M12=-1, M21=1, M22=6.123233995736766e-17, sizingMethod='auto expand') Notice that we need to swap b and c compared to a normal matrix.
						s = e.currentStyle.filter.match(_ieGetMatrixExp);
						s = (s && s.length === 4) ? [s[0].substr(4), Number(s[2].substr(4)), Number(s[1].substr(4)), s[3].substr(4), (tm.x || 0), (tm.y || 0)].join(",") : "";
					}
					isDefault = (!s || s === "none" || s === "matrix(1, 0, 0, 1, 0, 0)");
					if (_transformProp && ((none = (!_getComputedStyle(e) || _getComputedStyle(e).display === "none")) || !e.parentNode)) { //note: Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
						if (none) { //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
							n = style.display;
							style.display = "block";
						}
						if (!e.parentNode) {
							dec = 1; //flag
							_docElement.appendChild(e);
						}
						s = _getStyle(e, _transformPropCSS, null, true);
						isDefault = (!s || s === "none" || s === "matrix(1, 0, 0, 1, 0, 0)");
						if (n) {
							style.display = n;
						} else if (none) {
							_removeProp(style, "display");
						}
						if (dec) {
							_docElement.removeChild(e);
						}
					}
					if (tm.svg || (e.getCTM && _isSVG(e))) {
						if (isDefault && (style[_transformProp] + "").indexOf("matrix") !== -1) { //some browsers (like Chrome 40) don't correctly report transforms that are applied inline on an SVG element (they don't get included in the computed style), so we double-check here and accept matrix values
							s = style[_transformProp];
							isDefault = 0;
						}
						m = e.getAttribute("transform");
						if (isDefault && m) {
							m = e.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
							s = "matrix(" + m.a + "," + m.b + "," + m.c + "," + m.d + "," + m.e + "," + m.f + ")";
							isDefault = 0;
						}
					}
					if (isDefault) {
						return _identity2DMatrix;
					}
					//split the matrix values out into an array (m for matrix)
					m = (s || "").match(_numExp) || [];
					i = m.length;
					while (--i > -1) {
						n = Number(m[i]);
						m[i] = (dec = n - (n |= 0)) ? ((dec * rnd + (dec < 0 ? -0.5 : 0.5)) | 0) / rnd + n : n; //convert strings to Numbers and round to 5 decimal places to avoid issues with tiny numbers. Roughly 20x faster than Number.toFixed(). We also must make sure to round before dividing so that values like 0.9999999999 become 1 to avoid glitches in browser rendering and interpretation of flipped/rotated 3D matrices. And don't just multiply the number by rnd, floor it, and then divide by rnd because the bitwise operations max out at a 32-bit signed integer, thus it could get clipped at a relatively low value (like 22,000.00000 for example).
					}
					return (force2D && m.length > 6) ? [m[0], m[1], m[4], m[5], m[12], m[13]] : m;
				},
	
				/**
				 * Parses the transform values for an element, returning an object with x, y, z, scaleX, scaleY, scaleZ, rotation, rotationX, rotationY, skewX, and skewY properties. Note: by default (for performance reasons), all skewing is combined into skewX and rotation but skewY still has a place in the transform object so that we can record how much of the skew is attributed to skewX vs skewY. Remember, a skewY of 10 looks the same as a rotation of 10 and skewX of -10.
				 * @param {!Object} t target element
				 * @param {Object=} cs computed style object (optional)
				 * @param {boolean=} rec if true, the transform values will be recorded to the target element's _gsTransform object, like target._gsTransform = {x:0, y:0, z:0, scaleX:1...}
				 * @param {boolean=} parse if true, we'll ignore any _gsTransform values that already exist on the element, and force a reparsing of the css (calculated style)
				 * @return {object} object containing all of the transform properties/values like {x:0, y:0, z:0, scaleX:1...}
				 */
				_getTransform = _internals.getTransform = function(t, cs, rec, parse) {
					if (t._gsTransform && rec && !parse) {
						return t._gsTransform; //if the element already has a _gsTransform, use that. Note: some browsers don't accurately return the calculated style for the transform (particularly for SVG), so it's almost always safest to just use the values we've already applied rather than re-parsing things.
					}
					var tm = rec ? t._gsTransform || new Transform() : new Transform(),
						invX = (tm.scaleX < 0), //in order to interpret things properly, we need to know if the user applied a negative scaleX previously so that we can adjust the rotation and skewX accordingly. Otherwise, if we always interpret a flipped matrix as affecting scaleY and the user only wants to tween the scaleX on multiple sequential tweens, it would keep the negative scaleY without that being the user's intent.
						min = 0.00002,
						rnd = 100000,
						zOrigin = _supports3D ? parseFloat(_getStyle(t, _transformOriginProp, cs, false, "0 0 0").split(" ")[2]) || tm.zOrigin  || 0 : 0,
						defaultTransformPerspective = parseFloat(CSSPlugin.defaultTransformPerspective) || 0,
						m, i, scaleX, scaleY, rotation, skewX;
	
					tm.svg = !!(t.getCTM && _isSVG(t));
					if (tm.svg) {
						_parseSVGOrigin(t, _getStyle(t, _transformOriginProp, cs, false, "50% 50%") + "", tm, t.getAttribute("data-svg-origin"));
						_useSVGTransformAttr = CSSPlugin.useSVGTransformAttr || _forceSVGTransformAttr;
					}
					m = _getMatrix(t);
					if (m !== _identity2DMatrix) {
	
						if (m.length === 16) {
							//we'll only look at these position-related 6 variables first because if x/y/z all match, it's relatively safe to assume we don't need to re-parse everything which risks losing important rotational information (like rotationX:180 plus rotationY:180 would look the same as rotation:180 - there's no way to know for sure which direction was taken based solely on the matrix3d() values)
							var a11 = m[0], a21 = m[1], a31 = m[2], a41 = m[3],
								a12 = m[4], a22 = m[5], a32 = m[6], a42 = m[7],
								a13 = m[8], a23 = m[9], a33 = m[10],
								a14 = m[12], a24 = m[13], a34 = m[14],
								a43 = m[11],
								angle = Math.atan2(a32, a33),
								t1, t2, t3, t4, cos, sin;
							//we manually compensate for non-zero z component of transformOrigin to work around bugs in Safari
							if (tm.zOrigin) {
								a34 = -tm.zOrigin;
								a14 = a13*a34-m[12];
								a24 = a23*a34-m[13];
								a34 = a33*a34+tm.zOrigin-m[14];
							}
							//note for possible future consolidation: rotationX: Math.atan2(a32, a33), rotationY: Math.atan2(-a31, Math.sqrt(a33 * a33 + a32 * a32)), rotation: Math.atan2(a21, a11), skew: Math.atan2(a12, a22). However, it doesn't seem to be quite as reliable as the full-on backwards rotation procedure.
							tm.rotationX = angle * _RAD2DEG;
							//rotationX
							if (angle) {
								cos = Math.cos(-angle);
								sin = Math.sin(-angle);
								t1 = a12*cos+a13*sin;
								t2 = a22*cos+a23*sin;
								t3 = a32*cos+a33*sin;
								a13 = a12*-sin+a13*cos;
								a23 = a22*-sin+a23*cos;
								a33 = a32*-sin+a33*cos;
								a43 = a42*-sin+a43*cos;
								a12 = t1;
								a22 = t2;
								a32 = t3;
							}
							//rotationY
							angle = Math.atan2(-a31, a33);
							tm.rotationY = angle * _RAD2DEG;
							if (angle) {
								cos = Math.cos(-angle);
								sin = Math.sin(-angle);
								t1 = a11*cos-a13*sin;
								t2 = a21*cos-a23*sin;
								t3 = a31*cos-a33*sin;
								a23 = a21*sin+a23*cos;
								a33 = a31*sin+a33*cos;
								a43 = a41*sin+a43*cos;
								a11 = t1;
								a21 = t2;
								a31 = t3;
							}
							//rotationZ
							angle = Math.atan2(a21, a11);
							tm.rotation = angle * _RAD2DEG;
							if (angle) {
								cos = Math.cos(angle);
								sin = Math.sin(angle);
								t1 = a11*cos+a21*sin;
								t2 = a12*cos+a22*sin;
								t3 = a13*cos+a23*sin;
								a21 = a21*cos-a11*sin;
								a22 = a22*cos-a12*sin;
								a23 = a23*cos-a13*sin;
								a11 = t1;
								a12 = t2;
								a13 = t3;
							}
	
							if (tm.rotationX && Math.abs(tm.rotationX) + Math.abs(tm.rotation) > 359.9) { //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
								tm.rotationX = tm.rotation = 0;
								tm.rotationY = 180 - tm.rotationY;
							}
	
							//skewX
							angle = Math.atan2(a12, a22);
	
							//scales
							tm.scaleX = ((Math.sqrt(a11 * a11 + a21 * a21 + a31 * a31) * rnd + 0.5) | 0) / rnd;
							tm.scaleY = ((Math.sqrt(a22 * a22 + a32 * a32) * rnd + 0.5) | 0) / rnd;
							tm.scaleZ = ((Math.sqrt(a13 * a13 + a23 * a23 + a33 * a33) * rnd + 0.5) | 0) / rnd;
							a11 /= tm.scaleX;
							a12 /= tm.scaleY;
							a21 /= tm.scaleX;
							a22 /= tm.scaleY;
							if (Math.abs(angle) > min) {
								tm.skewX = angle * _RAD2DEG;
								a12 = 0; //unskews
								if (tm.skewType !== "simple") {
									tm.scaleY *= 1 / Math.cos(angle); //by default, we compensate the scale based on the skew so that the element maintains a similar proportion when skewed, so we have to alter the scaleY here accordingly to match the default (non-adjusted) skewing that CSS does (stretching more and more as it skews).
								}
	
							} else {
								tm.skewX = 0;
							}
	
							/* //for testing purposes
							var transform = "matrix3d(",
								comma = ",",
								zero = "0";
							a13 /= tm.scaleZ;
							a23 /= tm.scaleZ;
							a31 /= tm.scaleX;
							a32 /= tm.scaleY;
							a33 /= tm.scaleZ;
							transform += ((a11 < min && a11 > -min) ? zero : a11) + comma + ((a21 < min && a21 > -min) ? zero : a21) + comma + ((a31 < min && a31 > -min) ? zero : a31);
							transform += comma + ((a41 < min && a41 > -min) ? zero : a41) + comma + ((a12 < min && a12 > -min) ? zero : a12) + comma + ((a22 < min && a22 > -min) ? zero : a22);
							transform += comma + ((a32 < min && a32 > -min) ? zero : a32) + comma + ((a42 < min && a42 > -min) ? zero : a42) + comma + ((a13 < min && a13 > -min) ? zero : a13);
							transform += comma + ((a23 < min && a23 > -min) ? zero : a23) + comma + ((a33 < min && a33 > -min) ? zero : a33) + comma + ((a43 < min && a43 > -min) ? zero : a43) + comma;
							transform += a14 + comma + a24 + comma + a34 + comma + (tm.perspective ? (1 + (-a34 / tm.perspective)) : 1) + ")";
							console.log(transform);
							document.querySelector(".test").style[_transformProp] = transform;
							*/
	
							tm.perspective = a43 ? 1 / ((a43 < 0) ? -a43 : a43) : 0;
							tm.x = a14;
							tm.y = a24;
							tm.z = a34;
							if (tm.svg) {
								tm.x -= tm.xOrigin - (tm.xOrigin * a11 - tm.yOrigin * a12);
								tm.y -= tm.yOrigin - (tm.yOrigin * a21 - tm.xOrigin * a22);
							}
	
						} else if ((!_supports3D || parse || !m.length || tm.x !== m[4] || tm.y !== m[5] || (!tm.rotationX && !tm.rotationY))) { //sometimes a 6-element matrix is returned even when we performed 3D transforms, like if rotationX and rotationY are 180. In cases like this, we still need to honor the 3D transforms. If we just rely on the 2D info, it could affect how the data is interpreted, like scaleY might get set to -1 or rotation could get offset by 180 degrees. For example, do a TweenLite.to(element, 1, {css:{rotationX:180, rotationY:180}}) and then later, TweenLite.to(element, 1, {css:{rotationX:0}}) and without this conditional logic in place, it'd jump to a state of being unrotated when the 2nd tween starts. Then again, we need to honor the fact that the user COULD alter the transforms outside of CSSPlugin, like by manually applying new css, so we try to sense that by looking at x and y because if those changed, we know the changes were made outside CSSPlugin and we force a reinterpretation of the matrix values. Also, in Webkit browsers, if the element's "display" is "none", its calculated style value will always return empty, so if we've already recorded the values in the _gsTransform object, we'll just rely on those.
							var k = (m.length >= 6),
								a = k ? m[0] : 1,
								b = m[1] || 0,
								c = m[2] || 0,
								d = k ? m[3] : 1;
							tm.x = m[4] || 0;
							tm.y = m[5] || 0;
							scaleX = Math.sqrt(a * a + b * b);
							scaleY = Math.sqrt(d * d + c * c);
							rotation = (a || b) ? Math.atan2(b, a) * _RAD2DEG : tm.rotation || 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
							skewX = (c || d) ? Math.atan2(c, d) * _RAD2DEG + rotation : tm.skewX || 0;
							tm.scaleX = scaleX;
							tm.scaleY = scaleY;
							tm.rotation = rotation;
							tm.skewX = skewX;
							if (_supports3D) {
								tm.rotationX = tm.rotationY = tm.z = 0;
								tm.perspective = defaultTransformPerspective;
								tm.scaleZ = 1;
							}
							if (tm.svg) {
								tm.x -= tm.xOrigin - (tm.xOrigin * a + tm.yOrigin * c);
								tm.y -= tm.yOrigin - (tm.xOrigin * b + tm.yOrigin * d);
							}
						}
						if (Math.abs(tm.skewX) > 90 && Math.abs(tm.skewX) < 270) {
							if (invX) {
								tm.scaleX *= -1;
								tm.skewX += (tm.rotation <= 0) ? 180 : -180;
								tm.rotation += (tm.rotation <= 0) ? 180 : -180;
							} else {
								tm.scaleY *= -1;
								tm.skewX += (tm.skewX <= 0) ? 180 : -180;
							}
						}
						tm.zOrigin = zOrigin;
						//some browsers have a hard time with very small values like 2.4492935982947064e-16 (notice the "e-" towards the end) and would render the object slightly off. So we round to 0 in these cases. The conditional logic here is faster than calling Math.abs(). Also, browsers tend to render a SLIGHTLY rotated object in a fuzzy way, so we need to snap to exactly 0 when appropriate.
						for (i in tm) {
							if (tm[i] < min) if (tm[i] > -min) {
								tm[i] = 0;
							}
						}
					}
					//DEBUG: _log("parsed rotation of " + t.getAttribute("id")+": "+(tm.rotationX)+", "+(tm.rotationY)+", "+(tm.rotation)+", scale: "+tm.scaleX+", "+tm.scaleY+", "+tm.scaleZ+", position: "+tm.x+", "+tm.y+", "+tm.z+", perspective: "+tm.perspective+ ", origin: "+ tm.xOrigin+ ","+ tm.yOrigin);
					if (rec) {
						t._gsTransform = tm; //record to the object's _gsTransform which we use so that tweens can control individual properties independently (we need all the properties to accurately recompose the matrix in the setRatio() method)
						if (tm.svg) { //if we're supposed to apply transforms to the SVG element's "transform" attribute, make sure there aren't any CSS transforms applied or they'll override the attribute ones. Also clear the transform attribute if we're using CSS, just to be clean.
							if (_useSVGTransformAttr && t.style[_transformProp]) {
								TweenLite.delayedCall(0.001, function(){ //if we apply this right away (before anything has rendered), we risk there being no transforms for a brief moment and it also interferes with adjusting the transformOrigin in a tween with immediateRender:true (it'd try reading the matrix and it wouldn't have the appropriate data in place because we just removed it).
									_removeProp(t.style, _transformProp);
								});
							} else if (!_useSVGTransformAttr && t.getAttribute("transform")) {
								TweenLite.delayedCall(0.001, function(){
									t.removeAttribute("transform");
								});
							}
						}
					}
					return tm;
				},
	
				//for setting 2D transforms in IE6, IE7, and IE8 (must use a "filter" to emulate the behavior of modern day browser transforms)
				_setIETransformRatio = function(v) {
					var t = this.data, //refers to the element's _gsTransform object
						ang = -t.rotation * _DEG2RAD,
						skew = ang + t.skewX * _DEG2RAD,
						rnd = 100000,
						a = ((Math.cos(ang) * t.scaleX * rnd) | 0) / rnd,
						b = ((Math.sin(ang) * t.scaleX * rnd) | 0) / rnd,
						c = ((Math.sin(skew) * -t.scaleY * rnd) | 0) / rnd,
						d = ((Math.cos(skew) * t.scaleY * rnd) | 0) / rnd,
						style = this.t.style,
						cs = this.t.currentStyle,
						filters, val;
					if (!cs) {
						return;
					}
					val = b; //just for swapping the variables an inverting them (reused "val" to avoid creating another variable in memory). IE's filter matrix uses a non-standard matrix configuration (angle goes the opposite way, and b and c are reversed and inverted)
					b = -c;
					c = -val;
					filters = cs.filter;
					style.filter = ""; //remove filters so that we can accurately measure offsetWidth/offsetHeight
					var w = this.t.offsetWidth,
						h = this.t.offsetHeight,
						clip = (cs.position !== "absolute"),
						m = "progid:DXImageTransform.Microsoft.Matrix(M11=" + a + ", M12=" + b + ", M21=" + c + ", M22=" + d,
						ox = t.x + (w * t.xPercent / 100),
						oy = t.y + (h * t.yPercent / 100),
						dx, dy;
	
					//if transformOrigin is being used, adjust the offset x and y
					if (t.ox != null) {
						dx = ((t.oxp) ? w * t.ox * 0.01 : t.ox) - w / 2;
						dy = ((t.oyp) ? h * t.oy * 0.01 : t.oy) - h / 2;
						ox += dx - (dx * a + dy * b);
						oy += dy - (dx * c + dy * d);
					}
	
					if (!clip) {
						m += ", sizingMethod='auto expand')";
					} else {
						dx = (w / 2);
						dy = (h / 2);
						//translate to ensure that transformations occur around the correct origin (default is center).
						m += ", Dx=" + (dx - (dx * a + dy * b) + ox) + ", Dy=" + (dy - (dx * c + dy * d) + oy) + ")";
					}
					if (filters.indexOf("DXImageTransform.Microsoft.Matrix(") !== -1) {
						style.filter = filters.replace(_ieSetMatrixExp, m);
					} else {
						style.filter = m + " " + filters; //we must always put the transform/matrix FIRST (before alpha(opacity=xx)) to avoid an IE bug that slices part of the object when rotation is applied with alpha.
					}
	
					//at the end or beginning of the tween, if the matrix is normal (1, 0, 0, 1) and opacity is 100 (or doesn't exist), remove the filter to improve browser performance.
					if (v === 0 || v === 1) if (a === 1) if (b === 0) if (c === 0) if (d === 1) if (!clip || m.indexOf("Dx=0, Dy=0") !== -1) if (!_opacityExp.test(filters) || parseFloat(RegExp.$1) === 100) if (filters.indexOf("gradient(" && filters.indexOf("Alpha")) === -1) {
						style.removeAttribute("filter");
					}
	
					//we must set the margins AFTER applying the filter in order to avoid some bugs in IE8 that could (in rare scenarios) cause them to be ignored intermittently (vibration).
					if (!clip) {
						var mult = (_ieVers < 8) ? 1 : -1, //in Internet Explorer 7 and before, the box model is broken, causing the browser to treat the width/height of the actual rotated filtered image as the width/height of the box itself, but Microsoft corrected that in IE8. We must use a negative offset in IE8 on the right/bottom
							marg, prop, dif;
						dx = t.ieOffsetX || 0;
						dy = t.ieOffsetY || 0;
						t.ieOffsetX = Math.round((w - ((a < 0 ? -a : a) * w + (b < 0 ? -b : b) * h)) / 2 + ox);
						t.ieOffsetY = Math.round((h - ((d < 0 ? -d : d) * h + (c < 0 ? -c : c) * w)) / 2 + oy);
						for (i = 0; i < 4; i++) {
							prop = _margins[i];
							marg = cs[prop];
							//we need to get the current margin in case it is being tweened separately (we want to respect that tween's changes)
							val = (marg.indexOf("px") !== -1) ? parseFloat(marg) : _convertToPixels(this.t, prop, parseFloat(marg), marg.replace(_suffixExp, "")) || 0;
							if (val !== t[prop]) {
								dif = (i < 2) ? -t.ieOffsetX : -t.ieOffsetY; //if another tween is controlling a margin, we cannot only apply the difference in the ieOffsets, so we essentially zero-out the dx and dy here in that case. We record the margin(s) later so that we can keep comparing them, making this code very flexible.
							} else {
								dif = (i < 2) ? dx - t.ieOffsetX : dy - t.ieOffsetY;
							}
							style[prop] = (t[prop] = Math.round( val - dif * ((i === 0 || i === 2) ? 1 : mult) )) + "px";
						}
					}
				},
	
				/* translates a super small decimal to a string WITHOUT scientific notation
				_safeDecimal = function(n) {
					var s = (n < 0 ? -n : n) + "",
						a = s.split("e-");
					return (n < 0 ? "-0." : "0.") + new Array(parseInt(a[1], 10) || 0).join("0") + a[0].split(".").join("");
				},
				*/
	
				_setTransformRatio = _internals.set3DTransformRatio = _internals.setTransformRatio = function(v) {
					var t = this.data, //refers to the element's _gsTransform object
						style = this.t.style,
						angle = t.rotation,
						rotationX = t.rotationX,
						rotationY = t.rotationY,
						sx = t.scaleX,
						sy = t.scaleY,
						sz = t.scaleZ,
						x = t.x,
						y = t.y,
						z = t.z,
						isSVG = t.svg,
						perspective = t.perspective,
						force3D = t.force3D,
						skewY = t.skewY,
						skewX = t.skewX,
						t1,	a11, a12, a13, a21, a22, a23, a31, a32, a33, a41, a42, a43,
						zOrigin, min, cos, sin, t2, transform, comma, zero, skew, rnd;
					if (skewY) { //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
						skewX += skewY;
						angle += skewY;
					}
	
					//check to see if we should render as 2D (and SVGs must use 2D when _useSVGTransformAttr is true)
					if (((((v === 1 || v === 0) && force3D === "auto" && (this.tween._totalTime === this.tween._totalDuration || !this.tween._totalTime)) || !force3D) && !z && !perspective && !rotationY && !rotationX && sz === 1) || (_useSVGTransformAttr && isSVG) || !_supports3D) { //on the final render (which could be 0 for a from tween), if there are no 3D aspects, render in 2D to free up memory and improve performance especially on mobile devices. Check the tween's totalTime/totalDuration too in order to make sure it doesn't happen between repeats if it's a repeating tween.
	
						//2D
						if (angle || skewX || isSVG) {
							angle *= _DEG2RAD;
							skew = skewX * _DEG2RAD;
							rnd = 100000;
							a11 = Math.cos(angle) * sx;
							a21 = Math.sin(angle) * sx;
							a12 = Math.sin(angle - skew) * -sy;
							a22 = Math.cos(angle - skew) * sy;
							if (skew && t.skewType === "simple") { //by default, we compensate skewing on the other axis to make it look more natural, but you can set the skewType to "simple" to use the uncompensated skewing that CSS does
								t1 = Math.tan(skew - skewY * _DEG2RAD);
								t1 = Math.sqrt(1 + t1 * t1);
								a12 *= t1;
								a22 *= t1;
								if (skewY) {
									t1 = Math.tan(skewY * _DEG2RAD);
									t1 = Math.sqrt(1 + t1 * t1);
									a11 *= t1;
									a21 *= t1;
								}
							}
							if (isSVG) {
								x += t.xOrigin - (t.xOrigin * a11 + t.yOrigin * a12) + t.xOffset;
								y += t.yOrigin - (t.xOrigin * a21 + t.yOrigin * a22) + t.yOffset;
								if (_useSVGTransformAttr && (t.xPercent || t.yPercent)) { //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the matrix to simulate it.
									min = this.t.getBBox();
									x += t.xPercent * 0.01 * min.width;
									y += t.yPercent * 0.01 * min.height;
								}
								min = 0.000001;
								if (x < min) if (x > -min) {
									x = 0;
								}
								if (y < min) if (y > -min) {
									y = 0;
								}
							}
							transform = (((a11 * rnd) | 0) / rnd) + "," + (((a21 * rnd) | 0) / rnd) + "," + (((a12 * rnd) | 0) / rnd) + "," + (((a22 * rnd) | 0) / rnd) + "," + x + "," + y + ")";
							if (isSVG && _useSVGTransformAttr) {
								this.t.setAttribute("transform", "matrix(" + transform);
							} else {
								//some browsers have a hard time with very small values like 2.4492935982947064e-16 (notice the "e-" towards the end) and would render the object slightly off. So we round to 5 decimal places.
								style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix(" : "matrix(") + transform;
							}
						} else {
							style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix(" : "matrix(") + sx + ",0,0," + sy + "," + x + "," + y + ")";
						}
						return;
	
					}
					if (_isFirefox) { //Firefox has a bug (at least in v25) that causes it to render the transparent part of 32-bit PNG images as black when displayed inside an iframe and the 3D scale is very small and doesn't change sufficiently enough between renders (like if you use a Power4.easeInOut to scale from 0 to 1 where the beginning values only change a tiny amount to begin the tween before accelerating). In this case, we force the scale to be 0.00002 instead which is visually the same but works around the Firefox issue.
						min = 0.0001;
						if (sx < min && sx > -min) {
							sx = sz = 0.00002;
						}
						if (sy < min && sy > -min) {
							sy = sz = 0.00002;
						}
						if (perspective && !t.z && !t.rotationX && !t.rotationY) { //Firefox has a bug that causes elements to have an odd super-thin, broken/dotted black border on elements that have a perspective set but aren't utilizing 3D space (no rotationX, rotationY, or z).
							perspective = 0;
						}
					}
					if (angle || skewX) {
						angle *= _DEG2RAD;
						cos = a11 = Math.cos(angle);
						sin = a21 = Math.sin(angle);
						if (skewX) {
							angle -= skewX * _DEG2RAD;
							cos = Math.cos(angle);
							sin = Math.sin(angle);
							if (t.skewType === "simple") { //by default, we compensate skewing on the other axis to make it look more natural, but you can set the skewType to "simple" to use the uncompensated skewing that CSS does
								t1 = Math.tan((skewX - skewY) * _DEG2RAD);
								t1 = Math.sqrt(1 + t1 * t1);
								cos *= t1;
								sin *= t1;
								if (t.skewY) {
									t1 = Math.tan(skewY * _DEG2RAD);
									t1 = Math.sqrt(1 + t1 * t1);
									a11 *= t1;
									a21 *= t1;
								}
							}
						}
						a12 = -sin;
						a22 = cos;
	
					} else if (!rotationY && !rotationX && sz === 1 && !perspective && !isSVG) { //if we're only translating and/or 2D scaling, this is faster...
						style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) translate3d(" : "translate3d(") + x + "px," + y + "px," + z +"px)" + ((sx !== 1 || sy !== 1) ? " scale(" + sx + "," + sy + ")" : "");
						return;
					} else {
						a11 = a22 = 1;
						a12 = a21 = 0;
					}
					// KEY  INDEX   AFFECTS a[row][column]
					// a11  0       rotation, rotationY, scaleX
					// a21  1       rotation, rotationY, scaleX
					// a31  2       rotationY, scaleX
					// a41  3       rotationY, scaleX
					// a12  4       rotation, skewX, rotationX, scaleY
					// a22  5       rotation, skewX, rotationX, scaleY
					// a32  6       rotationX, scaleY
					// a42  7       rotationX, scaleY
					// a13  8       rotationY, rotationX, scaleZ
					// a23  9       rotationY, rotationX, scaleZ
					// a33  10      rotationY, rotationX, scaleZ
					// a43  11      rotationY, rotationX, perspective, scaleZ
					// a14  12      x, zOrigin, svgOrigin
					// a24  13      y, zOrigin, svgOrigin
					// a34  14      z, zOrigin
					// a44  15
					// rotation: Math.atan2(a21, a11)
					// rotationY: Math.atan2(a13, a33) (or Math.atan2(a13, a11))
					// rotationX: Math.atan2(a32, a33)
					a33 = 1;
					a13 = a23 = a31 = a32 = a41 = a42 = 0;
					a43 = (perspective) ? -1 / perspective : 0;
					zOrigin = t.zOrigin;
					min = 0.000001; //threshold below which browsers use scientific notation which won't work.
					comma = ",";
					zero = "0";
					angle = rotationY * _DEG2RAD;
					if (angle) {
						cos = Math.cos(angle);
						sin = Math.sin(angle);
						a31 = -sin;
						a41 = a43*-sin;
						a13 = a11*sin;
						a23 = a21*sin;
						a33 = cos;
						a43 *= cos;
						a11 *= cos;
						a21 *= cos;
					}
					angle = rotationX * _DEG2RAD;
					if (angle) {
						cos = Math.cos(angle);
						sin = Math.sin(angle);
						t1 = a12*cos+a13*sin;
						t2 = a22*cos+a23*sin;
						a32 = a33*sin;
						a42 = a43*sin;
						a13 = a12*-sin+a13*cos;
						a23 = a22*-sin+a23*cos;
						a33 = a33*cos;
						a43 = a43*cos;
						a12 = t1;
						a22 = t2;
					}
					if (sz !== 1) {
						a13*=sz;
						a23*=sz;
						a33*=sz;
						a43*=sz;
					}
					if (sy !== 1) {
						a12*=sy;
						a22*=sy;
						a32*=sy;
						a42*=sy;
					}
					if (sx !== 1) {
						a11*=sx;
						a21*=sx;
						a31*=sx;
						a41*=sx;
					}
	
					if (zOrigin || isSVG) {
						if (zOrigin) {
							x += a13*-zOrigin;
							y += a23*-zOrigin;
							z += a33*-zOrigin+zOrigin;
						}
						if (isSVG) { //due to bugs in some browsers, we need to manage the transform-origin of SVG manually
							x += t.xOrigin - (t.xOrigin * a11 + t.yOrigin * a12) + t.xOffset;
							y += t.yOrigin - (t.xOrigin * a21 + t.yOrigin * a22) + t.yOffset;
						}
						if (x < min && x > -min) {
							x = zero;
						}
						if (y < min && y > -min) {
							y = zero;
						}
						if (z < min && z > -min) {
							z = 0; //don't use string because we calculate perspective later and need the number.
						}
					}
	
					//optimized way of concatenating all the values into a string. If we do it all in one shot, it's slower because of the way browsers have to create temp strings and the way it affects memory. If we do it piece-by-piece with +=, it's a bit slower too. We found that doing it in these sized chunks works best overall:
					transform = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix3d(" : "matrix3d(");
					transform += ((a11 < min && a11 > -min) ? zero : a11) + comma + ((a21 < min && a21 > -min) ? zero : a21) + comma + ((a31 < min && a31 > -min) ? zero : a31);
					transform += comma + ((a41 < min && a41 > -min) ? zero : a41) + comma + ((a12 < min && a12 > -min) ? zero : a12) + comma + ((a22 < min && a22 > -min) ? zero : a22);
					if (rotationX || rotationY || sz !== 1) { //performance optimization (often there's no rotationX or rotationY, so we can skip these calculations)
						transform += comma + ((a32 < min && a32 > -min) ? zero : a32) + comma + ((a42 < min && a42 > -min) ? zero : a42) + comma + ((a13 < min && a13 > -min) ? zero : a13);
						transform += comma + ((a23 < min && a23 > -min) ? zero : a23) + comma + ((a33 < min && a33 > -min) ? zero : a33) + comma + ((a43 < min && a43 > -min) ? zero : a43) + comma;
					} else {
						transform += ",0,0,0,0,1,0,";
					}
					transform += x + comma + y + comma + z + comma + (perspective ? (1 + (-z / perspective)) : 1) + ")";
	
					style[_transformProp] = transform;
				};
	
			p = Transform.prototype;
			p.x = p.y = p.z = p.skewX = p.skewY = p.rotation = p.rotationX = p.rotationY = p.zOrigin = p.xPercent = p.yPercent = p.xOffset = p.yOffset = 0;
			p.scaleX = p.scaleY = p.scaleZ = 1;
	
			_registerComplexSpecialProp("transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin", {parser:function(t, e, parsingProp, cssp, pt, plugin, vars) {
				if (cssp._lastParsedTransform === vars) { return pt; } //only need to parse the transform once, and only if the browser supports it.
				cssp._lastParsedTransform = vars;
				var scaleFunc = (vars.scale && typeof(vars.scale) === "function") ? vars.scale : 0, //if there's a function-based "scale" value, swap in the resulting numeric value temporarily. Otherwise, if it's called for both scaleX and scaleY independently, they may not match (like if the function uses Math.random()).
					swapFunc;
				if (typeof(vars[parsingProp]) === "function") { //whatever property triggers the initial parsing might be a function-based value in which case it already got called in parse(), thus we don't want to call it again in here. The most efficient way to avoid this is to temporarily swap the value directly into the vars object, and then after we do all our parsing in this function, we'll swap it back again.
					swapFunc = vars[parsingProp];
					vars[parsingProp] = e;
				}
				if (scaleFunc) {
					vars.scale = scaleFunc(_index, t);
				}
				var originalGSTransform = t._gsTransform,
					style = t.style,
					min = 0.000001,
					i = _transformProps.length,
					v = vars,
					endRotations = {},
					transformOriginString = "transformOrigin",
					m1 = _getTransform(t, _cs, true, v.parseTransform),
					orig = v.transform && ((typeof(v.transform) === "function") ? v.transform(_index, _target) : v.transform),
					m2, copy, has3D, hasChange, dr, x, y, matrix, p;
				m1.skewType = v.skewType || m1.skewType || CSSPlugin.defaultSkewType;
				cssp._transform = m1;
				if (orig && typeof(orig) === "string" && _transformProp) { //for values like transform:"rotate(60deg) scale(0.5, 0.8)"
					copy = _tempDiv.style; //don't use the original target because it might be SVG in which case some browsers don't report computed style correctly.
					copy[_transformProp] = orig;
					copy.display = "block"; //if display is "none", the browser often refuses to report the transform properties correctly.
					copy.position = "absolute";
					if (orig.indexOf("%") !== -1) { //%-based translations will fail unless we set the width/height to match the original target...
						copy.width = _getStyle(t, "width");
						copy.height = _getStyle(t, "height");
					}
					_doc.body.appendChild(_tempDiv);
					m2 = _getTransform(_tempDiv, null, false);
					if (m1.skewType === "simple") { //the default _getTransform() reports the skewX/scaleY as if skewType is "compensated", thus we need to adjust that here if skewType is "simple".
						m2.scaleY *= Math.cos(m2.skewX * _DEG2RAD);
					}
					if (m1.svg) { //if it's an SVG element, x/y part of the matrix will be affected by whatever we use as the origin and the offsets, so compensate here...
						x = m1.xOrigin;
						y = m1.yOrigin;
						m2.x -= m1.xOffset;
						m2.y -= m1.yOffset;
						if (v.transformOrigin || v.svgOrigin) { //if this tween is altering the origin, we must factor that in here. The actual work of recording the transformOrigin values and setting up the PropTween is done later (still inside this function) so we cannot leave the changes intact here - we only want to update the x/y accordingly.
							orig = {};
							_parseSVGOrigin(t, _parsePosition(v.transformOrigin), orig, v.svgOrigin, v.smoothOrigin, true);
							x = orig.xOrigin;
							y = orig.yOrigin;
							m2.x -= orig.xOffset - m1.xOffset;
							m2.y -= orig.yOffset - m1.yOffset;
						}
						if (x || y) {
							matrix = _getMatrix(_tempDiv, true);
							m2.x -= x - (x * matrix[0] + y * matrix[2]);
							m2.y -= y - (x * matrix[1] + y * matrix[3]);
						}
					}
					_doc.body.removeChild(_tempDiv);
					if (!m2.perspective) {
						m2.perspective = m1.perspective; //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
					}
					if (v.xPercent != null) {
						m2.xPercent = _parseVal(v.xPercent, m1.xPercent);
					}
					if (v.yPercent != null) {
						m2.yPercent = _parseVal(v.yPercent, m1.yPercent);
					}
				} else if (typeof(v) === "object") { //for values like scaleX, scaleY, rotation, x, y, skewX, and skewY or transform:{...} (object)
					m2 = {scaleX:_parseVal((v.scaleX != null) ? v.scaleX : v.scale, m1.scaleX),
						scaleY:_parseVal((v.scaleY != null) ? v.scaleY : v.scale, m1.scaleY),
						scaleZ:_parseVal(v.scaleZ, m1.scaleZ),
						x:_parseVal(v.x, m1.x),
						y:_parseVal(v.y, m1.y),
						z:_parseVal(v.z, m1.z),
						xPercent:_parseVal(v.xPercent, m1.xPercent),
						yPercent:_parseVal(v.yPercent, m1.yPercent),
						perspective:_parseVal(v.transformPerspective, m1.perspective)};
					dr = v.directionalRotation;
					if (dr != null) {
						if (typeof(dr) === "object") {
							for (copy in dr) {
								v[copy] = dr[copy];
							}
						} else {
							v.rotation = dr;
						}
					}
					if (typeof(v.x) === "string" && v.x.indexOf("%") !== -1) {
						m2.x = 0;
						m2.xPercent = _parseVal(v.x, m1.xPercent);
					}
					if (typeof(v.y) === "string" && v.y.indexOf("%") !== -1) {
						m2.y = 0;
						m2.yPercent = _parseVal(v.y, m1.yPercent);
					}
	
					m2.rotation = _parseAngle(("rotation" in v) ? v.rotation : ("shortRotation" in v) ? v.shortRotation + "_short" : ("rotationZ" in v) ? v.rotationZ : m1.rotation, m1.rotation, "rotation", endRotations);
					if (_supports3D) {
						m2.rotationX = _parseAngle(("rotationX" in v) ? v.rotationX : ("shortRotationX" in v) ? v.shortRotationX + "_short" : m1.rotationX || 0, m1.rotationX, "rotationX", endRotations);
						m2.rotationY = _parseAngle(("rotationY" in v) ? v.rotationY : ("shortRotationY" in v) ? v.shortRotationY + "_short" : m1.rotationY || 0, m1.rotationY, "rotationY", endRotations);
					}
					m2.skewX = _parseAngle(v.skewX, m1.skewX);
					m2.skewY = _parseAngle(v.skewY, m1.skewY);
				}
				if (_supports3D && v.force3D != null) {
					m1.force3D = v.force3D;
					hasChange = true;
				}
	
				has3D = (m1.force3D || m1.z || m1.rotationX || m1.rotationY || m2.z || m2.rotationX || m2.rotationY || m2.perspective);
				if (!has3D && v.scale != null) {
					m2.scaleZ = 1; //no need to tween scaleZ.
				}
	
				while (--i > -1) {
					p = _transformProps[i];
					orig = m2[p] - m1[p];
					if (orig > min || orig < -min || v[p] != null || _forcePT[p] != null) {
						hasChange = true;
						pt = new CSSPropTween(m1, p, m1[p], orig, pt);
						if (p in endRotations) {
							pt.e = endRotations[p]; //directional rotations typically have compensated values during the tween, but we need to make sure they end at exactly what the user requested
						}
						pt.xs0 = 0; //ensures the value stays numeric in setRatio()
						pt.plugin = plugin;
						cssp._overwriteProps.push(pt.n);
					}
				}
	
				orig = v.transformOrigin;
				if (m1.svg && (orig || v.svgOrigin)) {
					x = m1.xOffset; //when we change the origin, in order to prevent things from jumping we adjust the x/y so we must record those here so that we can create PropTweens for them and flip them at the same time as the origin
					y = m1.yOffset;
					_parseSVGOrigin(t, _parsePosition(orig), m2, v.svgOrigin, v.smoothOrigin);
					pt = _addNonTweeningNumericPT(m1, "xOrigin", (originalGSTransform ? m1 : m2).xOrigin, m2.xOrigin, pt, transformOriginString); //note: if there wasn't a transformOrigin defined yet, just start with the destination one; it's wasteful otherwise, and it causes problems with fromTo() tweens. For example, TweenLite.to("#wheel", 3, {rotation:180, transformOrigin:"50% 50%", delay:1}); TweenLite.fromTo("#wheel", 3, {scale:0.5, transformOrigin:"50% 50%"}, {scale:1, delay:2}); would cause a jump when the from values revert at the beginning of the 2nd tween.
					pt = _addNonTweeningNumericPT(m1, "yOrigin", (originalGSTransform ? m1 : m2).yOrigin, m2.yOrigin, pt, transformOriginString);
					if (x !== m1.xOffset || y !== m1.yOffset) {
						pt = _addNonTweeningNumericPT(m1, "xOffset", (originalGSTransform ? x : m1.xOffset), m1.xOffset, pt, transformOriginString);
						pt = _addNonTweeningNumericPT(m1, "yOffset", (originalGSTransform ? y : m1.yOffset), m1.yOffset, pt, transformOriginString);
					}
					orig = "0px 0px"; //certain browsers (like firefox) completely botch transform-origin, so we must remove it to prevent it from contaminating transforms. We manage it ourselves with xOrigin and yOrigin
				}
				if (orig || (_supports3D && has3D && m1.zOrigin)) { //if anything 3D is happening and there's a transformOrigin with a z component that's non-zero, we must ensure that the transformOrigin's z-component is set to 0 so that we can manually do those calculations to get around Safari bugs. Even if the user didn't specifically define a "transformOrigin" in this particular tween (maybe they did it via css directly).
					if (_transformProp) {
						hasChange = true;
						p = _transformOriginProp;
						orig = (orig || _getStyle(t, p, _cs, false, "50% 50%")) + ""; //cast as string to avoid errors
						pt = new CSSPropTween(style, p, 0, 0, pt, -1, transformOriginString);
						pt.b = style[p];
						pt.plugin = plugin;
						if (_supports3D) {
							copy = m1.zOrigin;
							orig = orig.split(" ");
							m1.zOrigin = ((orig.length > 2 && !(copy !== 0 && orig[2] === "0px")) ? parseFloat(orig[2]) : copy) || 0; //Safari doesn't handle the z part of transformOrigin correctly, so we'll manually handle it in the _set3DTransformRatio() method.
							pt.xs0 = pt.e = orig[0] + " " + (orig[1] || "50%") + " 0px"; //we must define a z value of 0px specifically otherwise iOS 5 Safari will stick with the old one (if one was defined)!
							pt = new CSSPropTween(m1, "zOrigin", 0, 0, pt, -1, pt.n); //we must create a CSSPropTween for the _gsTransform.zOrigin so that it gets reset properly at the beginning if the tween runs backward (as opposed to just setting m1.zOrigin here)
							pt.b = copy;
							pt.xs0 = pt.e = m1.zOrigin;
						} else {
							pt.xs0 = pt.e = orig;
						}
	
						//for older versions of IE (6-8), we need to manually calculate things inside the setRatio() function. We record origin x and y (ox and oy) and whether or not the values are percentages (oxp and oyp).
					} else {
						_parsePosition(orig + "", m1);
					}
				}
				if (hasChange) {
					cssp._transformType = (!(m1.svg && _useSVGTransformAttr) && (has3D || this._transformType === 3)) ? 3 : 2; //quicker than calling cssp._enableTransforms();
				}
				if (swapFunc) {
					vars[parsingProp] = swapFunc;
				}
				if (scaleFunc) {
					vars.scale = scaleFunc;
				}
				return pt;
			}, prefix:true});
	
			_registerComplexSpecialProp("boxShadow", {defaultValue:"0px 0px 0px 0px #999", prefix:true, color:true, multi:true, keyword:"inset"});
	
			_registerComplexSpecialProp("borderRadius", {defaultValue:"0px", parser:function(t, e, p, cssp, pt, plugin) {
				e = this.format(e);
				var props = ["borderTopLeftRadius","borderTopRightRadius","borderBottomRightRadius","borderBottomLeftRadius"],
					style = t.style,
					ea1, i, es2, bs2, bs, es, bn, en, w, h, esfx, bsfx, rel, hn, vn, em;
				w = parseFloat(t.offsetWidth);
				h = parseFloat(t.offsetHeight);
				ea1 = e.split(" ");
				for (i = 0; i < props.length; i++) { //if we're dealing with percentages, we must convert things separately for the horizontal and vertical axis!
					if (this.p.indexOf("border")) { //older browsers used a prefix
						props[i] = _checkPropPrefix(props[i]);
					}
					bs = bs2 = _getStyle(t, props[i], _cs, false, "0px");
					if (bs.indexOf(" ") !== -1) {
						bs2 = bs.split(" ");
						bs = bs2[0];
						bs2 = bs2[1];
					}
					es = es2 = ea1[i];
					bn = parseFloat(bs);
					bsfx = bs.substr((bn + "").length);
					rel = (es.charAt(1) === "=");
					if (rel) {
						en = parseInt(es.charAt(0)+"1", 10);
						es = es.substr(2);
						en *= parseFloat(es);
						esfx = es.substr((en + "").length - (en < 0 ? 1 : 0)) || "";
					} else {
						en = parseFloat(es);
						esfx = es.substr((en + "").length);
					}
					if (esfx === "") {
						esfx = _suffixMap[p] || bsfx;
					}
					if (esfx !== bsfx) {
						hn = _convertToPixels(t, "borderLeft", bn, bsfx); //horizontal number (we use a bogus "borderLeft" property just because the _convertToPixels() method searches for the keywords "Left", "Right", "Top", and "Bottom" to determine of it's a horizontal or vertical property, and we need "border" in the name so that it knows it should measure relative to the element itself, not its parent.
						vn = _convertToPixels(t, "borderTop", bn, bsfx); //vertical number
						if (esfx === "%") {
							bs = (hn / w * 100) + "%";
							bs2 = (vn / h * 100) + "%";
						} else if (esfx === "em") {
							em = _convertToPixels(t, "borderLeft", 1, "em");
							bs = (hn / em) + "em";
							bs2 = (vn / em) + "em";
						} else {
							bs = hn + "px";
							bs2 = vn + "px";
						}
						if (rel) {
							es = (parseFloat(bs) + en) + esfx;
							es2 = (parseFloat(bs2) + en) + esfx;
						}
					}
					pt = _parseComplex(style, props[i], bs + " " + bs2, es + " " + es2, false, "0px", pt);
				}
				return pt;
			}, prefix:true, formatter:_getFormatter("0px 0px 0px 0px", false, true)});
			_registerComplexSpecialProp("borderBottomLeftRadius,borderBottomRightRadius,borderTopLeftRadius,borderTopRightRadius", {defaultValue:"0px", parser:function(t, e, p, cssp, pt, plugin) {
				return _parseComplex(t.style, p, this.format(_getStyle(t, p, _cs, false, "0px 0px")), this.format(e), false, "0px", pt);
			}, prefix:true, formatter:_getFormatter("0px 0px", false, true)});
			_registerComplexSpecialProp("backgroundPosition", {defaultValue:"0 0", parser:function(t, e, p, cssp, pt, plugin) {
				var bp = "background-position",
					cs = (_cs || _getComputedStyle(t, null)),
					bs = this.format( ((cs) ? _ieVers ? cs.getPropertyValue(bp + "-x") + " " + cs.getPropertyValue(bp + "-y") : cs.getPropertyValue(bp) : t.currentStyle.backgroundPositionX + " " + t.currentStyle.backgroundPositionY) || "0 0"), //Internet Explorer doesn't report background-position correctly - we must query background-position-x and background-position-y and combine them (even in IE10). Before IE9, we must do the same with the currentStyle object and use camelCase
					es = this.format(e),
					ba, ea, i, pct, overlap, src;
				if ((bs.indexOf("%") !== -1) !== (es.indexOf("%") !== -1) && es.split(",").length < 2) {
					src = _getStyle(t, "backgroundImage").replace(_urlExp, "");
					if (src && src !== "none") {
						ba = bs.split(" ");
						ea = es.split(" ");
						_tempImg.setAttribute("src", src); //set the temp IMG's src to the background-image so that we can measure its width/height
						i = 2;
						while (--i > -1) {
							bs = ba[i];
							pct = (bs.indexOf("%") !== -1);
							if (pct !== (ea[i].indexOf("%") !== -1)) {
								overlap = (i === 0) ? t.offsetWidth - _tempImg.width : t.offsetHeight - _tempImg.height;
								ba[i] = pct ? (parseFloat(bs) / 100 * overlap) + "px" : (parseFloat(bs) / overlap * 100) + "%";
							}
						}
						bs = ba.join(" ");
					}
				}
				return this.parseComplex(t.style, bs, es, pt, plugin);
			}, formatter:_parsePosition});
			_registerComplexSpecialProp("backgroundSize", {defaultValue:"0 0", formatter:function(v) {
				v += ""; //ensure it's a string
				return (v.substr(0,2) === "co") ? v : _parsePosition(v.indexOf(" ") === -1 ? v + " " + v : v); //if set to something like "100% 100%", Safari typically reports the computed style as just "100%" (no 2nd value), but we should ensure that there are two values, so copy the first one. Otherwise, it'd be interpreted as "100% 0" (wrong). Also remember that it could be "cover" or "contain" which we can't tween but should be able to set.
			}});
			_registerComplexSpecialProp("perspective", {defaultValue:"0px", prefix:true});
			_registerComplexSpecialProp("perspectiveOrigin", {defaultValue:"50% 50%", prefix:true});
			_registerComplexSpecialProp("transformStyle", {prefix:true});
			_registerComplexSpecialProp("backfaceVisibility", {prefix:true});
			_registerComplexSpecialProp("userSelect", {prefix:true});
			_registerComplexSpecialProp("margin", {parser:_getEdgeParser("marginTop,marginRight,marginBottom,marginLeft")});
			_registerComplexSpecialProp("padding", {parser:_getEdgeParser("paddingTop,paddingRight,paddingBottom,paddingLeft")});
			_registerComplexSpecialProp("clip", {defaultValue:"rect(0px,0px,0px,0px)", parser:function(t, e, p, cssp, pt, plugin){
				var b, cs, delim;
				if (_ieVers < 9) { //IE8 and earlier don't report a "clip" value in the currentStyle - instead, the values are split apart into clipTop, clipRight, clipBottom, and clipLeft. Also, in IE7 and earlier, the values inside rect() are space-delimited, not comma-delimited.
					cs = t.currentStyle;
					delim = _ieVers < 8 ? " " : ",";
					b = "rect(" + cs.clipTop + delim + cs.clipRight + delim + cs.clipBottom + delim + cs.clipLeft + ")";
					e = this.format(e).split(",").join(delim);
				} else {
					b = this.format(_getStyle(t, this.p, _cs, false, this.dflt));
					e = this.format(e);
				}
				return this.parseComplex(t.style, b, e, pt, plugin);
			}});
			_registerComplexSpecialProp("textShadow", {defaultValue:"0px 0px 0px #999", color:true, multi:true});
			_registerComplexSpecialProp("autoRound,strictUnits", {parser:function(t, e, p, cssp, pt) {return pt;}}); //just so that we can ignore these properties (not tween them)
			_registerComplexSpecialProp("border", {defaultValue:"0px solid #000", parser:function(t, e, p, cssp, pt, plugin) {
				var bw = _getStyle(t, "borderTopWidth", _cs, false, "0px"),
					end = this.format(e).split(" "),
					esfx = end[0].replace(_suffixExp, "");
				if (esfx !== "px") { //if we're animating to a non-px value, we need to convert the beginning width to that unit.
					bw = (parseFloat(bw) / _convertToPixels(t, "borderTopWidth", 1, esfx)) + esfx;
				}
				return this.parseComplex(t.style, this.format(bw + " " + _getStyle(t, "borderTopStyle", _cs, false, "solid") + " " + _getStyle(t, "borderTopColor", _cs, false, "#000")), end.join(" "), pt, plugin);
				}, color:true, formatter:function(v) {
					var a = v.split(" ");
					return a[0] + " " + (a[1] || "solid") + " " + (v.match(_colorExp) || ["#000"])[0];
				}});
			_registerComplexSpecialProp("borderWidth", {parser:_getEdgeParser("borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth")}); //Firefox doesn't pick up on borderWidth set in style sheets (only inline).
			_registerComplexSpecialProp("float,cssFloat,styleFloat", {parser:function(t, e, p, cssp, pt, plugin) {
				var s = t.style,
					prop = ("cssFloat" in s) ? "cssFloat" : "styleFloat";
				return new CSSPropTween(s, prop, 0, 0, pt, -1, p, false, 0, s[prop], e);
			}});
	
			//opacity-related
			var _setIEOpacityRatio = function(v) {
					var t = this.t, //refers to the element's style property
						filters = t.filter || _getStyle(this.data, "filter") || "",
						val = (this.s + this.c * v) | 0,
						skip;
					if (val === 100) { //for older versions of IE that need to use a filter to apply opacity, we should remove the filter if opacity hits 1 in order to improve performance, but make sure there isn't a transform (matrix) or gradient in the filters.
						if (filters.indexOf("atrix(") === -1 && filters.indexOf("radient(") === -1 && filters.indexOf("oader(") === -1) {
							t.removeAttribute("filter");
							skip = (!_getStyle(this.data, "filter")); //if a class is applied that has an alpha filter, it will take effect (we don't want that), so re-apply our alpha filter in that case. We must first remove it and then check.
						} else {
							t.filter = filters.replace(_alphaFilterExp, "");
							skip = true;
						}
					}
					if (!skip) {
						if (this.xn1) {
							t.filter = filters = filters || ("alpha(opacity=" + val + ")"); //works around bug in IE7/8 that prevents changes to "visibility" from being applied properly if the filter is changed to a different alpha on the same frame.
						}
						if (filters.indexOf("pacity") === -1) { //only used if browser doesn't support the standard opacity style property (IE 7 and 8). We omit the "O" to avoid case-sensitivity issues
							if (val !== 0 || !this.xn1) { //bugs in IE7/8 won't render the filter properly if opacity is ADDED on the same frame/render as "visibility" changes (this.xn1 is 1 if this tween is an "autoAlpha" tween)
								t.filter = filters + " alpha(opacity=" + val + ")"; //we round the value because otherwise, bugs in IE7/8 can prevent "visibility" changes from being applied properly.
							}
						} else {
							t.filter = filters.replace(_opacityExp, "opacity=" + val);
						}
					}
				};
			_registerComplexSpecialProp("opacity,alpha,autoAlpha", {defaultValue:"1", parser:function(t, e, p, cssp, pt, plugin) {
				var b = parseFloat(_getStyle(t, "opacity", _cs, false, "1")),
					style = t.style,
					isAutoAlpha = (p === "autoAlpha");
				if (typeof(e) === "string" && e.charAt(1) === "=") {
					e = ((e.charAt(0) === "-") ? -1 : 1) * parseFloat(e.substr(2)) + b;
				}
				if (isAutoAlpha && b === 1 && _getStyle(t, "visibility", _cs) === "hidden" && e !== 0) { //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
					b = 0;
				}
				if (_supportsOpacity) {
					pt = new CSSPropTween(style, "opacity", b, e - b, pt);
				} else {
					pt = new CSSPropTween(style, "opacity", b * 100, (e - b) * 100, pt);
					pt.xn1 = isAutoAlpha ? 1 : 0; //we need to record whether or not this is an autoAlpha so that in the setRatio(), we know to duplicate the setting of the alpha in order to work around a bug in IE7 and IE8 that prevents changes to "visibility" from taking effect if the filter is changed to a different alpha(opacity) at the same time. Setting it to the SAME value first, then the new value works around the IE7/8 bug.
					style.zoom = 1; //helps correct an IE issue.
					pt.type = 2;
					pt.b = "alpha(opacity=" + pt.s + ")";
					pt.e = "alpha(opacity=" + (pt.s + pt.c) + ")";
					pt.data = t;
					pt.plugin = plugin;
					pt.setRatio = _setIEOpacityRatio;
				}
				if (isAutoAlpha) { //we have to create the "visibility" PropTween after the opacity one in the linked list so that they run in the order that works properly in IE8 and earlier
					pt = new CSSPropTween(style, "visibility", 0, 0, pt, -1, null, false, 0, ((b !== 0) ? "inherit" : "hidden"), ((e === 0) ? "hidden" : "inherit"));
					pt.xs0 = "inherit";
					cssp._overwriteProps.push(pt.n);
					cssp._overwriteProps.push(p);
				}
				return pt;
			}});
	
	
			var _removeProp = function(s, p) {
					if (p) {
						if (s.removeProperty) {
							if (p.substr(0,2) === "ms" || p.substr(0,6) === "webkit") { //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
								p = "-" + p;
							}
							s.removeProperty(p.replace(_capsExp, "-$1").toLowerCase());
						} else { //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
							s.removeAttribute(p);
						}
					}
				},
				_setClassNameRatio = function(v) {
					this.t._gsClassPT = this;
					if (v === 1 || v === 0) {
						this.t.setAttribute("class", (v === 0) ? this.b : this.e);
						var mpt = this.data, //first MiniPropTween
							s = this.t.style;
						while (mpt) {
							if (!mpt.v) {
								_removeProp(s, mpt.p);
							} else {
								s[mpt.p] = mpt.v;
							}
							mpt = mpt._next;
						}
						if (v === 1 && this.t._gsClassPT === this) {
							this.t._gsClassPT = null;
						}
					} else if (this.t.getAttribute("class") !== this.e) {
						this.t.setAttribute("class", this.e);
					}
				};
			_registerComplexSpecialProp("className", {parser:function(t, e, p, cssp, pt, plugin, vars) {
				var b = t.getAttribute("class") || "", //don't use t.className because it doesn't work consistently on SVG elements; getAttribute("class") and setAttribute("class", value") is more reliable.
					cssText = t.style.cssText,
					difData, bs, cnpt, cnptLookup, mpt;
				pt = cssp._classNamePT = new CSSPropTween(t, p, 0, 0, pt, 2);
				pt.setRatio = _setClassNameRatio;
				pt.pr = -11;
				_hasPriority = true;
				pt.b = b;
				bs = _getAllStyles(t, _cs);
				//if there's a className tween already operating on the target, force it to its end so that the necessary inline styles are removed and the class name is applied before we determine the end state (we don't want inline styles interfering that were there just for class-specific values)
				cnpt = t._gsClassPT;
				if (cnpt) {
					cnptLookup = {};
					mpt = cnpt.data; //first MiniPropTween which stores the inline styles - we need to force these so that the inline styles don't contaminate things. Otherwise, there's a small chance that a tween could start and the inline values match the destination values and they never get cleaned.
					while (mpt) {
						cnptLookup[mpt.p] = 1;
						mpt = mpt._next;
					}
					cnpt.setRatio(1);
				}
				t._gsClassPT = pt;
				pt.e = (e.charAt(1) !== "=") ? e : b.replace(new RegExp("(?:\\s|^)" + e.substr(2) + "(?![\\w-])"), "") + ((e.charAt(0) === "+") ? " " + e.substr(2) : "");
				t.setAttribute("class", pt.e);
				difData = _cssDif(t, bs, _getAllStyles(t), vars, cnptLookup);
				t.setAttribute("class", b);
				pt.data = difData.firstMPT;
				t.style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
				pt = pt.xfirst = cssp.parse(t, difData.difs, pt, plugin); //we record the CSSPropTween as the xfirst so that we can handle overwriting propertly (if "className" gets overwritten, we must kill all the properties associated with the className part of the tween, so we can loop through from xfirst to the pt itself)
				return pt;
			}});
	
	
			var _setClearPropsRatio = function(v) {
				if (v === 1 || v === 0) if (this.data._totalTime === this.data._totalDuration && this.data.data !== "isFromStart") { //this.data refers to the tween. Only clear at the END of the tween (remember, from() tweens make the ratio go from 1 to 0, so we can't just check that and if the tween is the zero-duration one that's created internally to render the starting values in a from() tween, ignore that because otherwise, for example, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in).
					var s = this.t.style,
						transformParse = _specialProps.transform.parse,
						a, p, i, clearTransform, transform;
					if (this.e === "all") {
						s.cssText = "";
						clearTransform = true;
					} else {
						a = this.e.split(" ").join("").split(",");
						i = a.length;
						while (--i > -1) {
							p = a[i];
							if (_specialProps[p]) {
								if (_specialProps[p].parse === transformParse) {
									clearTransform = true;
								} else {
									p = (p === "transformOrigin") ? _transformOriginProp : _specialProps[p].p; //ensures that special properties use the proper browser-specific property name, like "scaleX" might be "-webkit-transform" or "boxShadow" might be "-moz-box-shadow"
								}
							}
							_removeProp(s, p);
						}
					}
					if (clearTransform) {
						_removeProp(s, _transformProp);
						transform = this.t._gsTransform;
						if (transform) {
							if (transform.svg) {
								this.t.removeAttribute("data-svg-origin");
								this.t.removeAttribute("transform");
							}
							delete this.t._gsTransform;
						}
					}
	
				}
			};
			_registerComplexSpecialProp("clearProps", {parser:function(t, e, p, cssp, pt) {
				pt = new CSSPropTween(t, p, 0, 0, pt, 2);
				pt.setRatio = _setClearPropsRatio;
				pt.e = e;
				pt.pr = -10;
				pt.data = cssp._tween;
				_hasPriority = true;
				return pt;
			}});
	
			p = "bezier,throwProps,physicsProps,physics2D".split(",");
			i = p.length;
			while (i--) {
				_registerPluginProp(p[i]);
			}
	
	
	
	
	
	
	
	
			p = CSSPlugin.prototype;
			p._firstPT = p._lastParsedTransform = p._transform = null;
	
			//gets called when the tween renders for the first time. This kicks everything off, recording start/end values, etc.
			p._onInitTween = function(target, vars, tween, index) {
				if (!target.nodeType) { //css is only for dom elements
					return false;
				}
				this._target = _target = target;
				this._tween = tween;
				this._vars = vars;
				_index = index;
				_autoRound = vars.autoRound;
				_hasPriority = false;
				_suffixMap = vars.suffixMap || CSSPlugin.suffixMap;
				_cs = _getComputedStyle(target, "");
				_overwriteProps = this._overwriteProps;
				var style = target.style,
					v, pt, pt2, first, last, next, zIndex, tpt, threeD;
				if (_reqSafariFix) if (style.zIndex === "") {
					v = _getStyle(target, "zIndex", _cs);
					if (v === "auto" || v === "") {
						//corrects a bug in [non-Android] Safari that prevents it from repainting elements in their new positions if they don't have a zIndex set. We also can't just apply this inside _parseTransform() because anything that's moved in any way (like using "left" or "top" instead of transforms like "x" and "y") can be affected, so it is best to ensure that anything that's tweening has a z-index. Setting "WebkitPerspective" to a non-zero value worked too except that on iOS Safari things would flicker randomly. Plus zIndex is less memory-intensive.
						this._addLazySet(style, "zIndex", 0);
					}
				}
	
				if (typeof(vars) === "string") {
					first = style.cssText;
					v = _getAllStyles(target, _cs);
					style.cssText = first + ";" + vars;
					v = _cssDif(target, v, _getAllStyles(target)).difs;
					if (!_supportsOpacity && _opacityValExp.test(vars)) {
						v.opacity = parseFloat( RegExp.$1 );
					}
					vars = v;
					style.cssText = first;
				}
	
				if (vars.className) { //className tweens will combine any differences they find in the css with the vars that are passed in, so {className:"myClass", scale:0.5, left:20} would work.
					this._firstPT = pt = _specialProps.className.parse(target, vars.className, "className", this, null, null, vars);
				} else {
					this._firstPT = pt = this.parse(target, vars, null);
				}
	
				if (this._transformType) {
					threeD = (this._transformType === 3);
					if (!_transformProp) {
						style.zoom = 1; //helps correct an IE issue.
					} else if (_isSafari) {
						_reqSafariFix = true;
						//if zIndex isn't set, iOS Safari doesn't repaint things correctly sometimes (seemingly at random).
						if (style.zIndex === "") {
							zIndex = _getStyle(target, "zIndex", _cs);
							if (zIndex === "auto" || zIndex === "") {
								this._addLazySet(style, "zIndex", 0);
							}
						}
						//Setting WebkitBackfaceVisibility corrects 3 bugs:
						// 1) [non-Android] Safari skips rendering changes to "top" and "left" that are made on the same frame/render as a transform update.
						// 2) iOS Safari sometimes neglects to repaint elements in their new positions. Setting "WebkitPerspective" to a non-zero value worked too except that on iOS Safari things would flicker randomly.
						// 3) Safari sometimes displayed odd artifacts when tweening the transform (or WebkitTransform) property, like ghosts of the edges of the element remained. Definitely a browser bug.
						//Note: we allow the user to override the auto-setting by defining WebkitBackfaceVisibility in the vars of the tween.
						if (_isSafariLT6) {
							this._addLazySet(style, "WebkitBackfaceVisibility", this._vars.WebkitBackfaceVisibility || (threeD ? "visible" : "hidden"));
						}
					}
					pt2 = pt;
					while (pt2 && pt2._next) {
						pt2 = pt2._next;
					}
					tpt = new CSSPropTween(target, "transform", 0, 0, null, 2);
					this._linkCSSP(tpt, null, pt2);
					tpt.setRatio = _transformProp ? _setTransformRatio : _setIETransformRatio;
					tpt.data = this._transform || _getTransform(target, _cs, true);
					tpt.tween = tween;
					tpt.pr = -1; //ensures that the transforms get applied after the components are updated.
					_overwriteProps.pop(); //we don't want to force the overwrite of all "transform" tweens of the target - we only care about individual transform properties like scaleX, rotation, etc. The CSSPropTween constructor automatically adds the property to _overwriteProps which is why we need to pop() here.
				}
	
				if (_hasPriority) {
					//reorders the linked list in order of pr (priority)
					while (pt) {
						next = pt._next;
						pt2 = first;
						while (pt2 && pt2.pr > pt.pr) {
							pt2 = pt2._next;
						}
						if ((pt._prev = pt2 ? pt2._prev : last)) {
							pt._prev._next = pt;
						} else {
							first = pt;
						}
						if ((pt._next = pt2)) {
							pt2._prev = pt;
						} else {
							last = pt;
						}
						pt = next;
					}
					this._firstPT = first;
				}
				return true;
			};
	
	
			p.parse = function(target, vars, pt, plugin) {
				var style = target.style,
					p, sp, bn, en, bs, es, bsfx, esfx, isStr, rel;
				for (p in vars) {
					es = vars[p]; //ending value string
					if (typeof(es) === "function") {
						es = es(_index, _target);
					}
					sp = _specialProps[p]; //SpecialProp lookup.
					if (sp) {
						pt = sp.parse(target, es, p, this, pt, plugin, vars);
					} else if (p.substr(0,2) === "--") { //for tweening CSS variables (which always start with "--"). To maximize performance and simplicity, we bypass CSSPlugin altogether and just add a normal property tween to the tween instance itself.
						this._tween._propLookup[p] = this._addTween.call(this._tween, target.style, "setProperty", _getComputedStyle(target).getPropertyValue(p) + "", es + "", p, false, p);
						continue;
					} else {
						bs = _getStyle(target, p, _cs) + "";
						isStr = (typeof(es) === "string");
						if (p === "color" || p === "fill" || p === "stroke" || p.indexOf("Color") !== -1 || (isStr && _rgbhslExp.test(es))) { //Opera uses background: to define color sometimes in addition to backgroundColor:
							if (!isStr) {
								es = _parseColor(es);
								es = ((es.length > 3) ? "rgba(" : "rgb(") + es.join(",") + ")";
							}
							pt = _parseComplex(style, p, bs, es, true, "transparent", pt, 0, plugin);
	
						} else if (isStr && _complexExp.test(es)) {
							pt = _parseComplex(style, p, bs, es, true, null, pt, 0, plugin);
	
						} else {
							bn = parseFloat(bs);
							bsfx = (bn || bn === 0) ? bs.substr((bn + "").length) : ""; //remember, bs could be non-numeric like "normal" for fontWeight, so we should default to a blank suffix in that case.
	
							if (bs === "" || bs === "auto") {
								if (p === "width" || p === "height") {
									bn = _getDimension(target, p, _cs);
									bsfx = "px";
								} else if (p === "left" || p === "top") {
									bn = _calculateOffset(target, p, _cs);
									bsfx = "px";
								} else {
									bn = (p !== "opacity") ? 0 : 1;
									bsfx = "";
								}
							}
	
							rel = (isStr && es.charAt(1) === "=");
							if (rel) {
								en = parseInt(es.charAt(0) + "1", 10);
								es = es.substr(2);
								en *= parseFloat(es);
								esfx = es.replace(_suffixExp, "");
							} else {
								en = parseFloat(es);
								esfx = isStr ? es.replace(_suffixExp, "") : "";
							}
	
							if (esfx === "") {
								esfx = (p in _suffixMap) ? _suffixMap[p] : bsfx; //populate the end suffix, prioritizing the map, then if none is found, use the beginning suffix.
							}
	
							es = (en || en === 0) ? (rel ? en + bn : en) + esfx : vars[p]; //ensures that any += or -= prefixes are taken care of. Record the end value before normalizing the suffix because we always want to end the tween on exactly what they intended even if it doesn't match the beginning value's suffix.
							//if the beginning/ending suffixes don't match, normalize them...
							if (bsfx !== esfx) if (esfx !== "" || p === "lineHeight") if (en || en === 0) if (bn) { //note: if the beginning value (bn) is 0, we don't need to convert units!
								bn = _convertToPixels(target, p, bn, bsfx);
								if (esfx === "%") {
									bn /= _convertToPixels(target, p, 100, "%") / 100;
									if (vars.strictUnits !== true) { //some browsers report only "px" values instead of allowing "%" with getComputedStyle(), so we assume that if we're tweening to a %, we should start there too unless strictUnits:true is defined. This approach is particularly useful for responsive designs that use from() tweens.
										bs = bn + "%";
									}
	
								} else if (esfx === "em" || esfx === "rem" || esfx === "vw" || esfx === "vh") {
									bn /= _convertToPixels(target, p, 1, esfx);
	
								//otherwise convert to pixels.
								} else if (esfx !== "px") {
									en = _convertToPixels(target, p, en, esfx);
									esfx = "px"; //we don't use bsfx after this, so we don't need to set it to px too.
								}
								if (rel) if (en || en === 0) {
									es = (en + bn) + esfx; //the changes we made affect relative calculations, so adjust the end value here.
								}
							}
	
							if (rel) {
								en += bn;
							}
	
							if ((bn || bn === 0) && (en || en === 0)) { //faster than isNaN(). Also, previously we required en !== bn but that doesn't really gain much performance and it prevents _parseToProxy() from working properly if beginning and ending values match but need to get tweened by an external plugin anyway. For example, a bezier tween where the target starts at left:0 and has these points: [{left:50},{left:0}] wouldn't work properly because when parsing the last point, it'd match the first (current) one and a non-tweening CSSPropTween would be recorded when we actually need a normal tween (type:0) so that things get updated during the tween properly.
								pt = new CSSPropTween(style, p, bn, en - bn, pt, 0, p, (_autoRound !== false && (esfx === "px" || p === "zIndex")), 0, bs, es);
								pt.xs0 = esfx;
								//DEBUG: _log("tween "+p+" from "+pt.b+" ("+bn+esfx+") to "+pt.e+" with suffix: "+pt.xs0);
							} else if (style[p] === undefined || !es && (es + "" === "NaN" || es == null)) {
								_log("invalid " + p + " tween value: " + vars[p]);
							} else {
								pt = new CSSPropTween(style, p, en || bn || 0, 0, pt, -1, p, false, 0, bs, es);
								pt.xs0 = (es === "none" && (p === "display" || p.indexOf("Style") !== -1)) ? bs : es; //intermediate value should typically be set immediately (end value) except for "display" or things like borderTopStyle, borderBottomStyle, etc. which should use the beginning value during the tween.
								//DEBUG: _log("non-tweening value "+p+": "+pt.xs0);
							}
						}
					}
					if (plugin) if (pt && !pt.plugin) {
						pt.plugin = plugin;
					}
				}
				return pt;
			};
	
	
			//gets called every time the tween updates, passing the new ratio (typically a value between 0 and 1, but not always (for example, if an Elastic.easeOut is used, the value can jump above 1 mid-tween). It will always start and 0 and end at 1.
			p.setRatio = function(v) {
				var pt = this._firstPT,
					min = 0.000001,
					val, str, i;
				//at the end of the tween, we set the values to exactly what we received in order to make sure non-tweening values (like "position" or "float" or whatever) are set and so that if the beginning/ending suffixes (units) didn't match and we normalized to px, the value that the user passed in is used here. We check to see if the tween is at its beginning in case it's a from() tween in which case the ratio will actually go from 1 to 0 over the course of the tween (backwards).
				if (v === 1 && (this._tween._time === this._tween._duration || this._tween._time === 0)) {
					while (pt) {
						if (pt.type !== 2) {
							if (pt.r && pt.type !== -1) {
								val = pt.r(pt.s + pt.c);
								if (!pt.type) {
									pt.t[pt.p] = val + pt.xs0;
								} else if (pt.type === 1) { //complex value (one that typically has multiple numbers inside a string, like "rect(5px,10px,20px,25px)"
									i = pt.l;
									str = pt.xs0 + val + pt.xs1;
									for (i = 1; i < pt.l; i++) {
										str += pt["xn"+i] + pt["xs"+(i+1)];
									}
									pt.t[pt.p] = str;
								}
							} else {
								pt.t[pt.p] = pt.e;
							}
						} else {
							pt.setRatio(v);
						}
						pt = pt._next;
					}
	
				} else if (v || !(this._tween._time === this._tween._duration || this._tween._time === 0) || this._tween._rawPrevTime === -0.000001) {
					while (pt) {
						val = pt.c * v + pt.s;
						if (pt.r) {
							val = pt.r(val);
						} else if (val < min) if (val > -min) {
							val = 0;
						}
						if (!pt.type) {
							pt.t[pt.p] = val + pt.xs0;
						} else if (pt.type === 1) { //complex value (one that typically has multiple numbers inside a string, like "rect(5px,10px,20px,25px)"
							i = pt.l;
							if (i === 2) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2;
							} else if (i === 3) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3;
							} else if (i === 4) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3 + pt.xn3 + pt.xs4;
							} else if (i === 5) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3 + pt.xn3 + pt.xs4 + pt.xn4 + pt.xs5;
							} else {
								str = pt.xs0 + val + pt.xs1;
								for (i = 1; i < pt.l; i++) {
									str += pt["xn"+i] + pt["xs"+(i+1)];
								}
								pt.t[pt.p] = str;
							}
	
						} else if (pt.type === -1) { //non-tweening value
							pt.t[pt.p] = pt.xs0;
	
						} else if (pt.setRatio) { //custom setRatio() for things like SpecialProps, external plugins, etc.
							pt.setRatio(v);
						}
						pt = pt._next;
					}
	
				//if the tween is reversed all the way back to the beginning, we need to restore the original values which may have different units (like % instead of px or em or whatever).
				} else {
					while (pt) {
						if (pt.type !== 2) {
							pt.t[pt.p] = pt.b;
						} else {
							pt.setRatio(v);
						}
						pt = pt._next;
					}
				}
			};
	
			/**
			 * @private
			 * Forces rendering of the target's transforms (rotation, scale, etc.) whenever the CSSPlugin's setRatio() is called.
			 * Basically, this tells the CSSPlugin to create a CSSPropTween (type 2) after instantiation that runs last in the linked
			 * list and calls the appropriate (3D or 2D) rendering function. We separate this into its own method so that we can call
			 * it from other plugins like BezierPlugin if, for example, it needs to apply an autoRotation and this CSSPlugin
			 * doesn't have any transform-related properties of its own. You can call this method as many times as you
			 * want and it won't create duplicate CSSPropTweens.
			 *
			 * @param {boolean} threeD if true, it should apply 3D tweens (otherwise, just 2D ones are fine and typically faster)
			 */
			p._enableTransforms = function(threeD) {
				this._transform = this._transform || _getTransform(this._target, _cs, true); //ensures that the element has a _gsTransform property with the appropriate values.
				this._transformType = (!(this._transform.svg && _useSVGTransformAttr) && (threeD || this._transformType === 3)) ? 3 : 2;
			};
	
			var lazySet = function(v) {
				this.t[this.p] = this.e;
				this.data._linkCSSP(this, this._next, null, true); //we purposefully keep this._next even though it'd make sense to null it, but this is a performance optimization, as this happens during the while (pt) {} loop in setRatio() at the bottom of which it sets pt = pt._next, so if we null it, the linked list will be broken in that loop.
			};
			/** @private Gives us a way to set a value on the first render (and only the first render). **/
			p._addLazySet = function(t, p, v) {
				var pt = this._firstPT = new CSSPropTween(t, p, 0, 0, this._firstPT, 2);
				pt.e = v;
				pt.setRatio = lazySet;
				pt.data = this;
			};
	
			/** @private **/
			p._linkCSSP = function(pt, next, prev, remove) {
				if (pt) {
					if (next) {
						next._prev = pt;
					}
					if (pt._next) {
						pt._next._prev = pt._prev;
					}
					if (pt._prev) {
						pt._prev._next = pt._next;
					} else if (this._firstPT === pt) {
						this._firstPT = pt._next;
						remove = true; //just to prevent resetting this._firstPT 5 lines down in case pt._next is null. (optimized for speed)
					}
					if (prev) {
						prev._next = pt;
					} else if (!remove && this._firstPT === null) {
						this._firstPT = pt;
					}
					pt._next = next;
					pt._prev = prev;
				}
				return pt;
			};
	
			p._mod = function(lookup) {
				var pt = this._firstPT;
				while (pt) {
					if (typeof(lookup[pt.p]) === "function") { //only gets called by RoundPropsPlugin (ModifyPlugin manages all the rendering internally for CSSPlugin properties that need modification). Remember, we handle rounding a bit differently in this plugin for performance reasons, leveraging "r" as an indicator that the value should be rounded internally.
						pt.r = lookup[pt.p];
					}
					pt = pt._next;
				}
			};
	
			//we need to make sure that if alpha or autoAlpha is killed, opacity is too. And autoAlpha affects the "visibility" property.
			p._kill = function(lookup) {
				var copy = lookup,
					pt, p, xfirst;
				if (lookup.autoAlpha || lookup.alpha) {
					copy = {};
					for (p in lookup) { //copy the lookup so that we're not changing the original which may be passed elsewhere.
						copy[p] = lookup[p];
					}
					copy.opacity = 1;
					if (copy.autoAlpha) {
						copy.visibility = 1;
					}
				}
				if (lookup.className && (pt = this._classNamePT)) { //for className tweens, we need to kill any associated CSSPropTweens too; a linked list starts at the className's "xfirst".
					xfirst = pt.xfirst;
					if (xfirst && xfirst._prev) {
						this._linkCSSP(xfirst._prev, pt._next, xfirst._prev._prev); //break off the prev
					} else if (xfirst === this._firstPT) {
						this._firstPT = pt._next;
					}
					if (pt._next) {
						this._linkCSSP(pt._next, pt._next._next, xfirst._prev);
					}
					this._classNamePT = null;
				}
				pt = this._firstPT;
				while (pt) {
					if (pt.plugin && pt.plugin !== p && pt.plugin._kill) { //for plugins that are registered with CSSPlugin, we should notify them of the kill.
						pt.plugin._kill(lookup);
						p = pt.plugin;
					}
					pt = pt._next;
				}
				return TweenPlugin.prototype._kill.call(this, copy);
			};
	
	
	
			//used by cascadeTo() for gathering all the style properties of each child element into an array for comparison.
			var _getChildStyles = function(e, props, targets) {
					var children, i, child, type;
					if (e.slice) {
						i = e.length;
						while (--i > -1) {
							_getChildStyles(e[i], props, targets);
						}
						return;
					}
					children = e.childNodes;
					i = children.length;
					while (--i > -1) {
						child = children[i];
						type = child.type;
						if (child.style) {
							props.push(_getAllStyles(child));
							if (targets) {
								targets.push(child);
							}
						}
						if ((type === 1 || type === 9 || type === 11) && child.childNodes.length) {
							_getChildStyles(child, props, targets);
						}
					}
				};
	
			/**
			 * Typically only useful for className tweens that may affect child elements, this method creates a TweenLite
			 * and then compares the style properties of all the target's child elements at the tween's start and end, and
			 * if any are different, it also creates tweens for those and returns an array containing ALL of the resulting
			 * tweens (so that you can easily add() them to a TimelineLite, for example). The reason this functionality is
			 * wrapped into a separate static method of CSSPlugin instead of being integrated into all regular className tweens
			 * is because it creates entirely new tweens that may have completely different targets than the original tween,
			 * so if they were all lumped into the original tween instance, it would be inconsistent with the rest of the API
			 * and it would create other problems. For example:
			 *  - If I create a tween of elementA, that tween instance may suddenly change its target to include 50 other elements (unintuitive if I specifically defined the target I wanted)
			 *  - We can't just create new independent tweens because otherwise, what happens if the original/parent tween is reversed or pause or dropped into a TimelineLite for tight control? You'd expect that tween's behavior to affect all the others.
			 *  - Analyzing every style property of every child before and after the tween is an expensive operation when there are many children, so this behavior shouldn't be imposed on all className tweens by default, especially since it's probably rare that this extra functionality is needed.
			 *
			 * @param {Object} target object to be tweened
			 * @param {number} Duration in seconds (or frames for frames-based tweens)
			 * @param {Object} Object containing the end values, like {className:"newClass", ease:Linear.easeNone}
			 * @return {Array} An array of TweenLite instances
			 */
			CSSPlugin.cascadeTo = function(target, duration, vars) {
				var tween = TweenLite.to(target, duration, vars),
					results = [tween],
					b = [],
					e = [],
					targets = [],
					_reservedProps = TweenLite._internals.reservedProps,
					i, difs, p, from;
				target = tween._targets || tween.target;
				_getChildStyles(target, b, targets);
				tween.render(duration, true, true);
				_getChildStyles(target, e);
				tween.render(0, true, true);
				tween._enabled(true);
				i = targets.length;
				while (--i > -1) {
					difs = _cssDif(targets[i], b[i], e[i]);
					if (difs.firstMPT) {
						difs = difs.difs;
						for (p in vars) {
							if (_reservedProps[p]) {
								difs[p] = vars[p];
							}
						}
						from = {};
						for (p in difs) {
							from[p] = b[i][p];
						}
						results.push(TweenLite.fromTo(targets[i], duration, from, difs));
					}
				}
				return results;
			};
	
			TweenPlugin.activate([CSSPlugin]);
			return CSSPlugin;
	
		}, true);
	
		
		
		
		
		
		
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * RoundPropsPlugin
	 * ----------------------------------------------------------------
	 */
		(function() {
	
			var RoundPropsPlugin = _gsScope._gsDefine.plugin({
					propName: "roundProps",
					version: "1.7.0",
					priority: -1,
					API: 2,
	
					//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
					init: function(target, value, tween) {
						this._tween = tween;
						return true;
					}
	
				}),
				_getRoundFunc = function(v) { //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
					var p = v < 1 ? Math.pow(10, (v + "").length - 2) : 1; //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed()
					return function(n) {
						return ((Math.round(n / v) * v * p) | 0) / p;
					};
				},
				_roundLinkedList = function(node, mod) {
					while (node) {
						if (!node.f && !node.blob) {
							node.m = mod || Math.round;
						}
						node = node._next;
					}
				},
				p = RoundPropsPlugin.prototype;
	
			p._onInitAllProps = function() {
				var tween = this._tween,
					rp = tween.vars.roundProps,
					lookup = {},
					rpt = tween._propLookup.roundProps,
					pt, next, i, p;
				if (typeof(rp) === "object" && !rp.push) {
					for (p in rp) {
						lookup[p] = _getRoundFunc(rp[p]);
					}
				} else {
					if (typeof(rp) === "string") {
						rp = rp.split(",");
					}
					i = rp.length;
					while (--i > -1) {
						lookup[rp[i]] = Math.round;
					}
				}
	
				for (p in lookup) {
					pt = tween._firstPT;
					while (pt) {
						next = pt._next; //record here, because it may get removed
						if (pt.pg) {
							pt.t._mod(lookup);
						} else if (pt.n === p) {
							if (pt.f === 2 && pt.t) { //a blob (text containing multiple numeric values)
								_roundLinkedList(pt.t._firstPT, lookup[p]);
							} else {
								this._add(pt.t, p, pt.s, pt.c, lookup[p]);
								//remove from linked list
								if (next) {
									next._prev = pt._prev;
								}
								if (pt._prev) {
									pt._prev._next = next;
								} else if (tween._firstPT === pt) {
									tween._firstPT = next;
								}
								pt._next = pt._prev = null;
								tween._propLookup[p] = rpt;
							}
						}
						pt = next;
					}
				}
				return false;
			};
	
			p._add = function(target, p, s, c, mod) {
				this._addTween(target, p, s, s + c, p, mod || Math.round);
				this._overwriteProps.push(p);
			};
	
		}());
	
	
	
	
	
	
	
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * AttrPlugin
	 * ----------------------------------------------------------------
	 */
	
		(function() {
	
			_gsScope._gsDefine.plugin({
				propName: "attr",
				API: 2,
				version: "0.6.1",
	
				//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
				init: function(target, value, tween, index) {
					var p, end;
					if (typeof(target.setAttribute) !== "function") {
						return false;
					}
					for (p in value) {
						end = value[p];
						if (typeof(end) === "function") {
							end = end(index, target);
						}
						this._addTween(target, "setAttribute", target.getAttribute(p) + "", end + "", p, false, p);
						this._overwriteProps.push(p);
					}
					return true;
				}
	
			});
	
		}());
	
	
	
	
	
	
	
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * DirectionalRotationPlugin
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine.plugin({
			propName: "directionalRotation",
			version: "0.3.1",
			API: 2,
	
			//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
			init: function(target, value, tween, index) {
				if (typeof(value) !== "object") {
					value = {rotation:value};
				}
				this.finals = {};
				var cap = (value.useRadians === true) ? Math.PI * 2 : 360,
					min = 0.000001,
					p, v, start, end, dif, split;
				for (p in value) {
					if (p !== "useRadians") {
						end = value[p];
						if (typeof(end) === "function") {
							end = end(index, target);
						}
						split = (end + "").split("_");
						v = split[0];
						start = parseFloat( (typeof(target[p]) !== "function") ? target[p] : target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ]() );
						end = this.finals[p] = (typeof(v) === "string" && v.charAt(1) === "=") ? start + parseInt(v.charAt(0) + "1", 10) * Number(v.substr(2)) : Number(v) || 0;
						dif = end - start;
						if (split.length) {
							v = split.join("_");
							if (v.indexOf("short") !== -1) {
								dif = dif % cap;
								if (dif !== dif % (cap / 2)) {
									dif = (dif < 0) ? dif + cap : dif - cap;
								}
							}
							if (v.indexOf("_cw") !== -1 && dif < 0) {
								dif = ((dif + cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
							} else if (v.indexOf("ccw") !== -1 && dif > 0) {
								dif = ((dif - cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
							}
						}
						if (dif > min || dif < -min) {
							this._addTween(target, p, start, start + dif, p);
							this._overwriteProps.push(p);
						}
					}
				}
				return true;
			},
	
			//called each time the values should be updated, and the ratio gets passed as the only parameter (typically it's a value between 0 and 1, but it can exceed those when using an ease like Elastic.easeOut or Back.easeOut, etc.)
			set: function(ratio) {
				var pt;
				if (ratio !== 1) {
					this._super.setRatio.call(this, ratio);
				} else {
					pt = this._firstPT;
					while (pt) {
						if (pt.f) {
							pt.t[pt.p](this.finals[pt.p]);
						} else {
							pt.t[pt.p] = this.finals[pt.p];
						}
						pt = pt._next;
					}
				}
			}
	
		})._autoCSS = true;
	
	
	
	
	
	
	
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * EasePack
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine("easing.Back", ["easing.Ease"], function(Ease) {
			
			var w = (_gsScope.GreenSockGlobals || _gsScope),
				gs = w.com.greensock,
				_2PI = Math.PI * 2,
				_HALF_PI = Math.PI / 2,
				_class = gs._class,
				_create = function(n, f) {
					var C = _class("easing." + n, function(){}, true),
						p = C.prototype = new Ease();
					p.constructor = C;
					p.getRatio = f;
					return C;
				},
				_easeReg = Ease.register || function(){}, //put an empty function in place just as a safety measure in case someone loads an OLD version of TweenLite.js where Ease.register doesn't exist.
				_wrap = function(name, EaseOut, EaseIn, EaseInOut, aliases) {
					var C = _class("easing."+name, {
						easeOut:new EaseOut(),
						easeIn:new EaseIn(),
						easeInOut:new EaseInOut()
					}, true);
					_easeReg(C, name);
					return C;
				},
				EasePoint = function(time, value, next) {
					this.t = time;
					this.v = value;
					if (next) {
						this.next = next;
						next.prev = this;
						this.c = next.v - value;
						this.gap = next.t - time;
					}
				},
	
				//Back
				_createBack = function(n, f) {
					var C = _class("easing." + n, function(overshoot) {
							this._p1 = (overshoot || overshoot === 0) ? overshoot : 1.70158;
							this._p2 = this._p1 * 1.525;
						}, true),
						p = C.prototype = new Ease();
					p.constructor = C;
					p.getRatio = f;
					p.config = function(overshoot) {
						return new C(overshoot);
					};
					return C;
				},
	
				Back = _wrap("Back",
					_createBack("BackOut", function(p) {
						return ((p = p - 1) * p * ((this._p1 + 1) * p + this._p1) + 1);
					}),
					_createBack("BackIn", function(p) {
						return p * p * ((this._p1 + 1) * p - this._p1);
					}),
					_createBack("BackInOut", function(p) {
						return ((p *= 2) < 1) ? 0.5 * p * p * ((this._p2 + 1) * p - this._p2) : 0.5 * ((p -= 2) * p * ((this._p2 + 1) * p + this._p2) + 2);
					})
				),
	
	
				//SlowMo
				SlowMo = _class("easing.SlowMo", function(linearRatio, power, yoyoMode) {
					power = (power || power === 0) ? power : 0.7;
					if (linearRatio == null) {
						linearRatio = 0.7;
					} else if (linearRatio > 1) {
						linearRatio = 1;
					}
					this._p = (linearRatio !== 1) ? power : 0;
					this._p1 = (1 - linearRatio) / 2;
					this._p2 = linearRatio;
					this._p3 = this._p1 + this._p2;
					this._calcEnd = (yoyoMode === true);
				}, true),
				p = SlowMo.prototype = new Ease(),
				SteppedEase, ExpoScaleEase, RoughEase, _createElastic;
	
			p.constructor = SlowMo;
			p.getRatio = function(p) {
				var r = p + (0.5 - p) * this._p;
				if (p < this._p1) {
					return this._calcEnd ? 1 - ((p = 1 - (p / this._p1)) * p) : r - ((p = 1 - (p / this._p1)) * p * p * p * r);
				} else if (p > this._p3) {
					return this._calcEnd ? (p === 1 ? 0 : 1 - (p = (p - this._p3) / this._p1) * p) : r + ((p - r) * (p = (p - this._p3) / this._p1) * p * p * p); //added p === 1 ? 0 to avoid floating point rounding errors from affecting the final value, like 1 - 0.7 = 0.30000000000000004 instead of 0.3
				}
				return this._calcEnd ? 1 : r;
			};
			SlowMo.ease = new SlowMo(0.7, 0.7);
	
			p.config = SlowMo.config = function(linearRatio, power, yoyoMode) {
				return new SlowMo(linearRatio, power, yoyoMode);
			};
	
	
			//SteppedEase
			SteppedEase = _class("easing.SteppedEase", function(steps, immediateStart) {
					steps = steps || 1;
					this._p1 = 1 / steps;
					this._p2 = steps + (immediateStart ? 0 : 1);
					this._p3 = immediateStart ? 1 : 0;
				}, true);
			p = SteppedEase.prototype = new Ease();
			p.constructor = SteppedEase;
			p.getRatio = function(p) {
				if (p < 0) {
					p = 0;
				} else if (p >= 1) {
					p = 0.999999999;
				}
				return (((this._p2 * p) | 0) + this._p3) * this._p1;
			};
			p.config = SteppedEase.config = function(steps, immediateStart) {
				return new SteppedEase(steps, immediateStart);
			};
	
			//ExpoScaleEase
			ExpoScaleEase = _class("easing.ExpoScaleEase", function(start, end, ease) {
				this._p1 = Math.log(end / start);
				this._p2 = end - start;
				this._p3 = start;
				this._ease = ease;
			}, true);
			p = ExpoScaleEase.prototype = new Ease();
			p.constructor = ExpoScaleEase;
			p.getRatio = function(p) {
				if (this._ease) {
					p = this._ease.getRatio(p);
				}
				return (this._p3 * Math.exp(this._p1 * p) - this._p3) / this._p2;
			};
			p.config = ExpoScaleEase.config = function(start, end, ease) {
				return new ExpoScaleEase(start, end, ease);
			};
	
	
			//RoughEase
			RoughEase = _class("easing.RoughEase", function(vars) {
				vars = vars || {};
				var taper = vars.taper || "none",
					a = [],
					cnt = 0,
					points = (vars.points || 20) | 0,
					i = points,
					randomize = (vars.randomize !== false),
					clamp = (vars.clamp === true),
					template = (vars.template instanceof Ease) ? vars.template : null,
					strength = (typeof(vars.strength) === "number") ? vars.strength * 0.4 : 0.4,
					x, y, bump, invX, obj, pnt;
				while (--i > -1) {
					x = randomize ? Math.random() : (1 / points) * i;
					y = template ? template.getRatio(x) : x;
					if (taper === "none") {
						bump = strength;
					} else if (taper === "out") {
						invX = 1 - x;
						bump = invX * invX * strength;
					} else if (taper === "in") {
						bump = x * x * strength;
					} else if (x < 0.5) {  //"both" (start)
						invX = x * 2;
						bump = invX * invX * 0.5 * strength;
					} else {				//"both" (end)
						invX = (1 - x) * 2;
						bump = invX * invX * 0.5 * strength;
					}
					if (randomize) {
						y += (Math.random() * bump) - (bump * 0.5);
					} else if (i % 2) {
						y += bump * 0.5;
					} else {
						y -= bump * 0.5;
					}
					if (clamp) {
						if (y > 1) {
							y = 1;
						} else if (y < 0) {
							y = 0;
						}
					}
					a[cnt++] = {x:x, y:y};
				}
				a.sort(function(a, b) {
					return a.x - b.x;
				});
	
				pnt = new EasePoint(1, 1, null);
				i = points;
				while (--i > -1) {
					obj = a[i];
					pnt = new EasePoint(obj.x, obj.y, pnt);
				}
	
				this._prev = new EasePoint(0, 0, (pnt.t !== 0) ? pnt : pnt.next);
			}, true);
			p = RoughEase.prototype = new Ease();
			p.constructor = RoughEase;
			p.getRatio = function(p) {
				var pnt = this._prev;
				if (p > pnt.t) {
					while (pnt.next && p >= pnt.t) {
						pnt = pnt.next;
					}
					pnt = pnt.prev;
				} else {
					while (pnt.prev && p <= pnt.t) {
						pnt = pnt.prev;
					}
				}
				this._prev = pnt;
				return (pnt.v + ((p - pnt.t) / pnt.gap) * pnt.c);
			};
			p.config = function(vars) {
				return new RoughEase(vars);
			};
			RoughEase.ease = new RoughEase();
	
	
			//Bounce
			_wrap("Bounce",
				_create("BounceOut", function(p) {
					if (p < 1 / 2.75) {
						return 7.5625 * p * p;
					} else if (p < 2 / 2.75) {
						return 7.5625 * (p -= 1.5 / 2.75) * p + 0.75;
					} else if (p < 2.5 / 2.75) {
						return 7.5625 * (p -= 2.25 / 2.75) * p + 0.9375;
					}
					return 7.5625 * (p -= 2.625 / 2.75) * p + 0.984375;
				}),
				_create("BounceIn", function(p) {
					if ((p = 1 - p) < 1 / 2.75) {
						return 1 - (7.5625 * p * p);
					} else if (p < 2 / 2.75) {
						return 1 - (7.5625 * (p -= 1.5 / 2.75) * p + 0.75);
					} else if (p < 2.5 / 2.75) {
						return 1 - (7.5625 * (p -= 2.25 / 2.75) * p + 0.9375);
					}
					return 1 - (7.5625 * (p -= 2.625 / 2.75) * p + 0.984375);
				}),
				_create("BounceInOut", function(p) {
					var invert = (p < 0.5);
					if (invert) {
						p = 1 - (p * 2);
					} else {
						p = (p * 2) - 1;
					}
					if (p < 1 / 2.75) {
						p = 7.5625 * p * p;
					} else if (p < 2 / 2.75) {
						p = 7.5625 * (p -= 1.5 / 2.75) * p + 0.75;
					} else if (p < 2.5 / 2.75) {
						p = 7.5625 * (p -= 2.25 / 2.75) * p + 0.9375;
					} else {
						p = 7.5625 * (p -= 2.625 / 2.75) * p + 0.984375;
					}
					return invert ? (1 - p) * 0.5 : p * 0.5 + 0.5;
				})
			);
	
	
			//CIRC
			_wrap("Circ",
				_create("CircOut", function(p) {
					return Math.sqrt(1 - (p = p - 1) * p);
				}),
				_create("CircIn", function(p) {
					return -(Math.sqrt(1 - (p * p)) - 1);
				}),
				_create("CircInOut", function(p) {
					return ((p*=2) < 1) ? -0.5 * (Math.sqrt(1 - p * p) - 1) : 0.5 * (Math.sqrt(1 - (p -= 2) * p) + 1);
				})
			);
	
	
			//Elastic
			_createElastic = function(n, f, def) {
				var C = _class("easing." + n, function(amplitude, period) {
						this._p1 = (amplitude >= 1) ? amplitude : 1; //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
						this._p2 = (period || def) / (amplitude < 1 ? amplitude : 1);
						this._p3 = this._p2 / _2PI * (Math.asin(1 / this._p1) || 0);
						this._p2 = _2PI / this._p2; //precalculate to optimize
					}, true),
					p = C.prototype = new Ease();
				p.constructor = C;
				p.getRatio = f;
				p.config = function(amplitude, period) {
					return new C(amplitude, period);
				};
				return C;
			};
			_wrap("Elastic",
				_createElastic("ElasticOut", function(p) {
					return this._p1 * Math.pow(2, -10 * p) * Math.sin( (p - this._p3) * this._p2 ) + 1;
				}, 0.3),
				_createElastic("ElasticIn", function(p) {
					return -(this._p1 * Math.pow(2, 10 * (p -= 1)) * Math.sin( (p - this._p3) * this._p2 ));
				}, 0.3),
				_createElastic("ElasticInOut", function(p) {
					return ((p *= 2) < 1) ? -0.5 * (this._p1 * Math.pow(2, 10 * (p -= 1)) * Math.sin( (p - this._p3) * this._p2)) : this._p1 * Math.pow(2, -10 *(p -= 1)) * Math.sin( (p - this._p3) * this._p2 ) * 0.5 + 1;
				}, 0.45)
			);
	
	
			//Expo
			_wrap("Expo",
				_create("ExpoOut", function(p) {
					return 1 - Math.pow(2, -10 * p);
				}),
				_create("ExpoIn", function(p) {
					return Math.pow(2, 10 * (p - 1)) - 0.001;
				}),
				_create("ExpoInOut", function(p) {
					return ((p *= 2) < 1) ? 0.5 * Math.pow(2, 10 * (p - 1)) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
				})
			);
	
	
			//Sine
			_wrap("Sine",
				_create("SineOut", function(p) {
					return Math.sin(p * _HALF_PI);
				}),
				_create("SineIn", function(p) {
					return -Math.cos(p * _HALF_PI) + 1;
				}),
				_create("SineInOut", function(p) {
					return -0.5 * (Math.cos(Math.PI * p) - 1);
				})
			);
	
			_class("easing.EaseLookup", {
					find:function(s) {
						return Ease.map[s];
					}
				}, true);
	
			//register the non-standard eases
			_easeReg(w.SlowMo, "SlowMo", "ease,");
			_easeReg(RoughEase, "RoughEase", "ease,");
			_easeReg(SteppedEase, "SteppedEase", "ease,");
	
			return Back;
			
		}, true);
	
	
	});
	
	if (_gsScope._gsDefine) { _gsScope._gsQueue.pop()(); } //necessary in case TweenLite was already loaded separately.
	
	
	
	
	
	
	
	
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * Base classes like TweenLite, SimpleTimeline, Ease, Ticker, etc.
	 * ----------------------------------------------------------------
	 */
	(function(window, moduleName) {
	
			"use strict";
			var _exports = {},
				_doc = window.document,
				_globals = window.GreenSockGlobals = window.GreenSockGlobals || window;
			if (_globals.TweenLite) {
				return _globals.TweenLite; //in case the core set of classes is already loaded, don't instantiate twice.
			}
			var _namespace = function(ns) {
					var a = ns.split("."),
						p = _globals, i;
					for (i = 0; i < a.length; i++) {
						p[a[i]] = p = p[a[i]] || {};
					}
					return p;
				},
				gs = _namespace("com.greensock"),
				_tinyNum = 0.0000000001,
				_slice = function(a) { //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
					var b = [],
						l = a.length,
						i;
					for (i = 0; i !== l; b.push(a[i++])) {}
					return b;
				},
				_emptyFunc = function() {},
				_isArray = (function() { //works around issues in iframe environments where the Array global isn't shared, thus if the object originates in a different window/iframe, "(obj instanceof Array)" will evaluate false. We added some speed optimizations to avoid Object.prototype.toString.call() unless it's absolutely necessary because it's VERY slow (like 20x slower)
					var toString = Object.prototype.toString,
						array = toString.call([]);
					return function(obj) {
						return obj != null && (obj instanceof Array || (typeof(obj) === "object" && !!obj.push && toString.call(obj) === array));
					};
				}()),
				a, i, p, _ticker, _tickerActive,
				_defLookup = {},
	
				/**
				 * @constructor
				 * Defines a GreenSock class, optionally with an array of dependencies that must be instantiated first and passed into the definition.
				 * This allows users to load GreenSock JS files in any order even if they have interdependencies (like CSSPlugin extends TweenPlugin which is
				 * inside TweenLite.js, but if CSSPlugin is loaded first, it should wait to run its code until TweenLite.js loads and instantiates TweenPlugin
				 * and then pass TweenPlugin to CSSPlugin's definition). This is all done automatically and internally.
				 *
				 * Every definition will be added to a "com.greensock" global object (typically window, but if a window.GreenSockGlobals object is found,
				 * it will go there as of v1.7). For example, TweenLite will be found at window.com.greensock.TweenLite and since it's a global class that should be available anywhere,
				 * it is ALSO referenced at window.TweenLite. However some classes aren't considered global, like the base com.greensock.core.Animation class, so
				 * those will only be at the package like window.com.greensock.core.Animation. Again, if you define a GreenSockGlobals object on the window, everything
				 * gets tucked neatly inside there instead of on the window directly. This allows you to do advanced things like load multiple versions of GreenSock
				 * files and put them into distinct objects (imagine a banner ad uses a newer version but the main site uses an older one). In that case, you could
				 * sandbox the banner one like:
				 *
				 * <script>
				 *     var gs = window.GreenSockGlobals = {}; //the newer version we're about to load could now be referenced in a "gs" object, like gs.TweenLite.to(...). Use whatever alias you want as long as it's unique, "gs" or "banner" or whatever.
				 * </script>
				 * <script src="js/greensock/v1.7/TweenMax.js"></script>
				 * <script>
				 *     window.GreenSockGlobals = window._gsQueue = window._gsDefine = null; //reset it back to null (along with the special _gsQueue variable) so that the next load of TweenMax affects the window and we can reference things directly like TweenLite.to(...)
				 * </script>
				 * <script src="js/greensock/v1.6/TweenMax.js"></script>
				 * <script>
				 *     gs.TweenLite.to(...); //would use v1.7
				 *     TweenLite.to(...); //would use v1.6
				 * </script>
				 *
				 * @param {!string} ns The namespace of the class definition, leaving off "com.greensock." as that's assumed. For example, "TweenLite" or "plugins.CSSPlugin" or "easing.Back".
				 * @param {!Array.<string>} dependencies An array of dependencies (described as their namespaces minus "com.greensock." prefix). For example ["TweenLite","plugins.TweenPlugin","core.Animation"]
				 * @param {!function():Object} func The function that should be called and passed the resolved dependencies which will return the actual class for this definition.
				 * @param {boolean=} global If true, the class will be added to the global scope (typically window unless you define a window.GreenSockGlobals object)
				 */
				Definition = function(ns, dependencies, func, global) {
					this.sc = (_defLookup[ns]) ? _defLookup[ns].sc : []; //subclasses
					_defLookup[ns] = this;
					this.gsClass = null;
					this.func = func;
					var _classes = [];
					this.check = function(init) {
						var i = dependencies.length,
							missing = i,
							cur, a, n, cl;
						while (--i > -1) {
							if ((cur = _defLookup[dependencies[i]] || new Definition(dependencies[i], [])).gsClass) {
								_classes[i] = cur.gsClass;
								missing--;
							} else if (init) {
								cur.sc.push(this);
							}
						}
						if (missing === 0 && func) {
							a = ("com.greensock." + ns).split(".");
							n = a.pop();
							cl = _namespace(a.join("."))[n] = this.gsClass = func.apply(func, _classes);
	
							//exports to multiple environments
							if (global) {
								_globals[n] = _exports[n] = cl; //provides a way to avoid global namespace pollution. By default, the main classes like TweenLite, Power1, Strong, etc. are added to window unless a GreenSockGlobals is defined. So if you want to have things added to a custom object instead, just do something like window.GreenSockGlobals = {} before loading any GreenSock files. You can even set up an alias like window.GreenSockGlobals = windows.gs = {} so that you can access everything like gs.TweenLite. Also remember that ALL classes are added to the window.com.greensock object (in their respective packages, like com.greensock.easing.Power1, com.greensock.TweenLite, etc.)
								if (typeof(module) !== "undefined" && module.exports) { //node
									if (ns === moduleName) {
										module.exports = _exports[moduleName] = cl;
										for (i in _exports) {
											cl[i] = _exports[i];
										}
									} else if (_exports[moduleName]) {
										_exports[moduleName][n] = cl;
									}
								} else if (true){ //AMD
									!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() { return cl; }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
								}
							}
							for (i = 0; i < this.sc.length; i++) {
								this.sc[i].check();
							}
						}
					};
					this.check(true);
				},
	
				//used to create Definition instances (which basically registers a class that has dependencies).
				_gsDefine = window._gsDefine = function(ns, dependencies, func, global) {
					return new Definition(ns, dependencies, func, global);
				},
	
				//a quick way to create a class that doesn't have any dependencies. Returns the class, but first registers it in the GreenSock namespace so that other classes can grab it (other classes might be dependent on the class).
				_class = gs._class = function(ns, func, global) {
					func = func || function() {};
					_gsDefine(ns, [], function(){ return func; }, global);
					return func;
				};
	
			_gsDefine.globals = _globals;
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * Ease
	 * ----------------------------------------------------------------
	 */
			var _baseParams = [0, 0, 1, 1],
				Ease = _class("easing.Ease", function(func, extraParams, type, power) {
					this._func = func;
					this._type = type || 0;
					this._power = power || 0;
					this._params = extraParams ? _baseParams.concat(extraParams) : _baseParams;
				}, true),
				_easeMap = Ease.map = {},
				_easeReg = Ease.register = function(ease, names, types, create) {
					var na = names.split(","),
						i = na.length,
						ta = (types || "easeIn,easeOut,easeInOut").split(","),
						e, name, j, type;
					while (--i > -1) {
						name = na[i];
						e = create ? _class("easing."+name, null, true) : gs.easing[name] || {};
						j = ta.length;
						while (--j > -1) {
							type = ta[j];
							_easeMap[name + "." + type] = _easeMap[type + name] = e[type] = ease.getRatio ? ease : ease[type] || new ease();
						}
					}
				};
	
			p = Ease.prototype;
			p._calcEnd = false;
			p.getRatio = function(p) {
				if (this._func) {
					this._params[0] = p;
					return this._func.apply(null, this._params);
				}
				var t = this._type,
					pw = this._power,
					r = (t === 1) ? 1 - p : (t === 2) ? p : (p < 0.5) ? p * 2 : (1 - p) * 2;
				if (pw === 1) {
					r *= r;
				} else if (pw === 2) {
					r *= r * r;
				} else if (pw === 3) {
					r *= r * r * r;
				} else if (pw === 4) {
					r *= r * r * r * r;
				}
				return (t === 1) ? 1 - r : (t === 2) ? r : (p < 0.5) ? r / 2 : 1 - (r / 2);
			};
	
			//create all the standard eases like Linear, Quad, Cubic, Quart, Quint, Strong, Power0, Power1, Power2, Power3, and Power4 (each with easeIn, easeOut, and easeInOut)
			a = ["Linear","Quad","Cubic","Quart","Quint,Strong"];
			i = a.length;
			while (--i > -1) {
				p = a[i]+",Power"+i;
				_easeReg(new Ease(null,null,1,i), p, "easeOut", true);
				_easeReg(new Ease(null,null,2,i), p, "easeIn" + ((i === 0) ? ",easeNone" : ""));
				_easeReg(new Ease(null,null,3,i), p, "easeInOut");
			}
			_easeMap.linear = gs.easing.Linear.easeIn;
			_easeMap.swing = gs.easing.Quad.easeInOut; //for jQuery folks
	
	
	/*
	 * ----------------------------------------------------------------
	 * EventDispatcher
	 * ----------------------------------------------------------------
	 */
			var EventDispatcher = _class("events.EventDispatcher", function(target) {
				this._listeners = {};
				this._eventTarget = target || this;
			});
			p = EventDispatcher.prototype;
	
			p.addEventListener = function(type, callback, scope, useParam, priority) {
				priority = priority || 0;
				var list = this._listeners[type],
					index = 0,
					listener, i;
				if (this === _ticker && !_tickerActive) {
					_ticker.wake();
				}
				if (list == null) {
					this._listeners[type] = list = [];
				}
				i = list.length;
				while (--i > -1) {
					listener = list[i];
					if (listener.c === callback && listener.s === scope) {
						list.splice(i, 1);
					} else if (index === 0 && listener.pr < priority) {
						index = i + 1;
					}
				}
				list.splice(index, 0, {c:callback, s:scope, up:useParam, pr:priority});
			};
	
			p.removeEventListener = function(type, callback) {
				var list = this._listeners[type], i;
				if (list) {
					i = list.length;
					while (--i > -1) {
						if (list[i].c === callback) {
							list.splice(i, 1);
							return;
						}
					}
				}
			};
	
			p.dispatchEvent = function(type) {
				var list = this._listeners[type],
					i, t, listener;
				if (list) {
					i = list.length;
					if (i > 1) {
						list = list.slice(0); //in case addEventListener() is called from within a listener/callback (otherwise the index could change, resulting in a skip)
					}
					t = this._eventTarget;
					while (--i > -1) {
						listener = list[i];
						if (listener) {
							if (listener.up) {
								listener.c.call(listener.s || t, {type:type, target:t});
							} else {
								listener.c.call(listener.s || t);
							}
						}
					}
				}
			};
	
	
	/*
	 * ----------------------------------------------------------------
	 * Ticker
	 * ----------------------------------------------------------------
	 */
	 		var _reqAnimFrame = window.requestAnimationFrame,
				_cancelAnimFrame = window.cancelAnimationFrame,
				_getTime = Date.now || function() {return new Date().getTime();},
				_lastUpdate = _getTime();
	
			//now try to determine the requestAnimationFrame and cancelAnimationFrame functions and if none are found, we'll use a setTimeout()/clearTimeout() polyfill.
			a = ["ms","moz","webkit","o"];
			i = a.length;
			while (--i > -1 && !_reqAnimFrame) {
				_reqAnimFrame = window[a[i] + "RequestAnimationFrame"];
				_cancelAnimFrame = window[a[i] + "CancelAnimationFrame"] || window[a[i] + "CancelRequestAnimationFrame"];
			}
	
			_class("Ticker", function(fps, useRAF) {
				var _self = this,
					_startTime = _getTime(),
					_useRAF = (useRAF !== false && _reqAnimFrame) ? "auto" : false,
					_lagThreshold = 500,
					_adjustedLag = 33,
					_tickWord = "tick", //helps reduce gc burden
					_fps, _req, _id, _gap, _nextTime,
					_tick = function(manual) {
						var elapsed = _getTime() - _lastUpdate,
							overlap, dispatch;
						if (elapsed > _lagThreshold) {
							_startTime += elapsed - _adjustedLag;
						}
						_lastUpdate += elapsed;
						_self.time = (_lastUpdate - _startTime) / 1000;
						overlap = _self.time - _nextTime;
						if (!_fps || overlap > 0 || manual === true) {
							_self.frame++;
							_nextTime += overlap + (overlap >= _gap ? 0.004 : _gap - overlap);
							dispatch = true;
						}
						if (manual !== true) { //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
							_id = _req(_tick);
						}
						if (dispatch) {
							_self.dispatchEvent(_tickWord);
						}
					};
	
				EventDispatcher.call(_self);
				_self.time = _self.frame = 0;
				_self.tick = function() {
					_tick(true);
				};
	
				_self.lagSmoothing = function(threshold, adjustedLag) {
					if (!arguments.length) { //if lagSmoothing() is called with no arguments, treat it like a getter that returns a boolean indicating if it's enabled or not. This is purposely undocumented and is for internal use.
						return (_lagThreshold < 1 / _tinyNum);
					}
					_lagThreshold = threshold || (1 / _tinyNum); //zero should be interpreted as basically unlimited
					_adjustedLag = Math.min(adjustedLag, _lagThreshold, 0);
				};
	
				_self.sleep = function() {
					if (_id == null) {
						return;
					}
					if (!_useRAF || !_cancelAnimFrame) {
						clearTimeout(_id);
					} else {
						_cancelAnimFrame(_id);
					}
					_req = _emptyFunc;
					_id = null;
					if (_self === _ticker) {
						_tickerActive = false;
					}
				};
	
				_self.wake = function(seamless) {
					if (_id !== null) {
						_self.sleep();
					} else if (seamless) {
						_startTime += -_lastUpdate + (_lastUpdate = _getTime());
					} else if (_self.frame > 10) { //don't trigger lagSmoothing if we're just waking up, and make sure that at least 10 frames have elapsed because of the iOS bug that we work around below with the 1.5-second setTimout().
						_lastUpdate = _getTime() - _lagThreshold + 5;
					}
					_req = (_fps === 0) ? _emptyFunc : (!_useRAF || !_reqAnimFrame) ? function(f) { return setTimeout(f, ((_nextTime - _self.time) * 1000 + 1) | 0); } : _reqAnimFrame;
					if (_self === _ticker) {
						_tickerActive = true;
					}
					_tick(2);
				};
	
				_self.fps = function(value) {
					if (!arguments.length) {
						return _fps;
					}
					_fps = value;
					_gap = 1 / (_fps || 60);
					_nextTime = this.time + _gap;
					_self.wake();
				};
	
				_self.useRAF = function(value) {
					if (!arguments.length) {
						return _useRAF;
					}
					_self.sleep();
					_useRAF = value;
					_self.fps(_fps);
				};
				_self.fps(fps);
	
				//a bug in iOS 6 Safari occasionally prevents the requestAnimationFrame from working initially, so we use a 1.5-second timeout that automatically falls back to setTimeout() if it senses this condition.
				setTimeout(function() {
					if (_useRAF === "auto" && _self.frame < 5 && (_doc || {}).visibilityState !== "hidden") {
						_self.useRAF(false);
					}
				}, 1500);
			});
	
			p = gs.Ticker.prototype = new gs.events.EventDispatcher();
			p.constructor = gs.Ticker;
	
	
	/*
	 * ----------------------------------------------------------------
	 * Animation
	 * ----------------------------------------------------------------
	 */
			var Animation = _class("core.Animation", function(duration, vars) {
					this.vars = vars = vars || {};
					this._duration = this._totalDuration = duration || 0;
					this._delay = Number(vars.delay) || 0;
					this._timeScale = 1;
					this._active = (vars.immediateRender === true);
					this.data = vars.data;
					this._reversed = (vars.reversed === true);
	
					if (!_rootTimeline) {
						return;
					}
					if (!_tickerActive) { //some browsers (like iOS 6 Safari) shut down JavaScript execution when the tab is disabled and they [occasionally] neglect to start up requestAnimationFrame again when returning - this code ensures that the engine starts up again properly.
						_ticker.wake();
					}
	
					var tl = this.vars.useFrames ? _rootFramesTimeline : _rootTimeline;
					tl.add(this, tl._time);
	
					if (this.vars.paused) {
						this.paused(true);
					}
				});
	
			_ticker = Animation.ticker = new gs.Ticker();
			p = Animation.prototype;
			p._dirty = p._gc = p._initted = p._paused = false;
			p._totalTime = p._time = 0;
			p._rawPrevTime = -1;
			p._next = p._last = p._onUpdate = p._timeline = p.timeline = null;
			p._paused = false;
	
	
			//some browsers (like iOS) occasionally drop the requestAnimationFrame event when the user switches to a different tab and then comes back again, so we use a 2-second setTimeout() to sense if/when that condition occurs and then wake() the ticker.
			var _checkTimeout = function() {
					if (_tickerActive && _getTime() - _lastUpdate > 2000 && ((_doc || {}).visibilityState !== "hidden" || !_ticker.lagSmoothing())) { //note: if the tab is hidden, we should still wake if lagSmoothing has been disabled.
						_ticker.wake();
					}
					var t = setTimeout(_checkTimeout, 2000);
					if (t.unref) {
						// allows a node process to exit even if the timeout’s callback hasn't been invoked. Without it, the node process could hang as this function is called every two seconds.
						t.unref();
					}
				};
			_checkTimeout();
	
	
			p.play = function(from, suppressEvents) {
				if (from != null) {
					this.seek(from, suppressEvents);
				}
				return this.reversed(false).paused(false);
			};
	
			p.pause = function(atTime, suppressEvents) {
				if (atTime != null) {
					this.seek(atTime, suppressEvents);
				}
				return this.paused(true);
			};
	
			p.resume = function(from, suppressEvents) {
				if (from != null) {
					this.seek(from, suppressEvents);
				}
				return this.paused(false);
			};
	
			p.seek = function(time, suppressEvents) {
				return this.totalTime(Number(time), suppressEvents !== false);
			};
	
			p.restart = function(includeDelay, suppressEvents) {
				return this.reversed(false).paused(false).totalTime(includeDelay ? -this._delay : 0, (suppressEvents !== false), true);
			};
	
			p.reverse = function(from, suppressEvents) {
				if (from != null) {
					this.seek((from || this.totalDuration()), suppressEvents);
				}
				return this.reversed(true).paused(false);
			};
	
			p.render = function(time, suppressEvents, force) {
				//stub - we override this method in subclasses.
			};
	
			p.invalidate = function() {
				this._time = this._totalTime = 0;
				this._initted = this._gc = false;
				this._rawPrevTime = -1;
				if (this._gc || !this.timeline) {
					this._enabled(true);
				}
				return this;
			};
	
			p.isActive = function() {
				var tl = this._timeline, //the 2 root timelines won't have a _timeline; they're always active.
					startTime = this._startTime,
					rawTime;
				return (!tl || (!this._gc && !this._paused && tl.isActive() && (rawTime = tl.rawTime(true)) >= startTime && rawTime < startTime + this.totalDuration() / this._timeScale - 0.0000001));
			};
	
			p._enabled = function (enabled, ignoreTimeline) {
				if (!_tickerActive) {
					_ticker.wake();
				}
				this._gc = !enabled;
				this._active = this.isActive();
				if (ignoreTimeline !== true) {
					if (enabled && !this.timeline) {
						this._timeline.add(this, this._startTime - this._delay);
					} else if (!enabled && this.timeline) {
						this._timeline._remove(this, true);
					}
				}
				return false;
			};
	
	
			p._kill = function(vars, target) {
				return this._enabled(false, false);
			};
	
			p.kill = function(vars, target) {
				this._kill(vars, target);
				return this;
			};
	
			p._uncache = function(includeSelf) {
				var tween = includeSelf ? this : this.timeline;
				while (tween) {
					tween._dirty = true;
					tween = tween.timeline;
				}
				return this;
			};
	
			p._swapSelfInParams = function(params) {
				var i = params.length,
					copy = params.concat();
				while (--i > -1) {
					if (params[i] === "{self}") {
						copy[i] = this;
					}
				}
				return copy;
			};
	
			p._callback = function(type) {
				var v = this.vars,
					callback = v[type],
					params = v[type + "Params"],
					scope = v[type + "Scope"] || v.callbackScope || this,
					l = params ? params.length : 0;
				switch (l) { //speed optimization; call() is faster than apply() so use it when there are only a few parameters (which is by far most common). Previously we simply did var v = this.vars; v[type].apply(v[type + "Scope"] || v.callbackScope || this, v[type + "Params"] || _blankArray);
					case 0: callback.call(scope); break;
					case 1: callback.call(scope, params[0]); break;
					case 2: callback.call(scope, params[0], params[1]); break;
					default: callback.apply(scope, params);
				}
			};
	
	//----Animation getters/setters --------------------------------------------------------
	
			p.eventCallback = function(type, callback, params, scope) {
				if ((type || "").substr(0,2) === "on") {
					var v = this.vars;
					if (arguments.length === 1) {
						return v[type];
					}
					if (callback == null) {
						delete v[type];
					} else {
						v[type] = callback;
						v[type + "Params"] = (_isArray(params) && params.join("").indexOf("{self}") !== -1) ? this._swapSelfInParams(params) : params;
						v[type + "Scope"] = scope;
					}
					if (type === "onUpdate") {
						this._onUpdate = callback;
					}
				}
				return this;
			};
	
			p.delay = function(value) {
				if (!arguments.length) {
					return this._delay;
				}
				if (this._timeline.smoothChildTiming) {
					this.startTime( this._startTime + value - this._delay );
				}
				this._delay = value;
				return this;
			};
	
			p.duration = function(value) {
				if (!arguments.length) {
					this._dirty = false;
					return this._duration;
				}
				this._duration = this._totalDuration = value;
				this._uncache(true); //true in case it's a TweenMax or TimelineMax that has a repeat - we'll need to refresh the totalDuration.
				if (this._timeline.smoothChildTiming) if (this._time > 0) if (this._time < this._duration) if (value !== 0) {
					this.totalTime(this._totalTime * (value / this._duration), true);
				}
				return this;
			};
	
			p.totalDuration = function(value) {
				this._dirty = false;
				return (!arguments.length) ? this._totalDuration : this.duration(value);
			};
	
			p.time = function(value, suppressEvents) {
				if (!arguments.length) {
					return this._time;
				}
				if (this._dirty) {
					this.totalDuration();
				}
				return this.totalTime((value > this._duration) ? this._duration : value, suppressEvents);
			};
	
			p.totalTime = function(time, suppressEvents, uncapped) {
				if (!_tickerActive) {
					_ticker.wake();
				}
				if (!arguments.length) {
					return this._totalTime;
				}
				if (this._timeline) {
					if (time < 0 && !uncapped) {
						time += this.totalDuration();
					}
					if (this._timeline.smoothChildTiming) {
						if (this._dirty) {
							this.totalDuration();
						}
						var totalDuration = this._totalDuration,
							tl = this._timeline;
						if (time > totalDuration && !uncapped) {
							time = totalDuration;
						}
						this._startTime = (this._paused ? this._pauseTime : tl._time) - ((!this._reversed ? time : totalDuration - time) / this._timeScale);
						if (!tl._dirty) { //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
							this._uncache(false);
						}
						//in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The startTime of that child would get pushed out, but one of the ancestors may have completed.
						if (tl._timeline) {
							while (tl._timeline) {
								if (tl._timeline._time !== (tl._startTime + tl._totalTime) / tl._timeScale) {
									tl.totalTime(tl._totalTime, true);
								}
								tl = tl._timeline;
							}
						}
					}
					if (this._gc) {
						this._enabled(true, false);
					}
					if (this._totalTime !== time || this._duration === 0) {
						if (_lazyTweens.length) {
							_lazyRender();
						}
						this.render(time, suppressEvents, false);
						if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
							_lazyRender();
						}
					}
				}
				return this;
			};
	
			p.progress = p.totalProgress = function(value, suppressEvents) {
				var duration = this.duration();
				return (!arguments.length) ? (duration ? this._time / duration : this.ratio) : this.totalTime(duration * value, suppressEvents);
			};
	
			p.startTime = function(value) {
				if (!arguments.length) {
					return this._startTime;
				}
				if (value !== this._startTime) {
					this._startTime = value;
					if (this.timeline) if (this.timeline._sortChildren) {
						this.timeline.add(this, value - this._delay); //ensures that any necessary re-sequencing of Animations in the timeline occurs to make sure the rendering order is correct.
					}
				}
				return this;
			};
	
			p.endTime = function(includeRepeats) {
				return this._startTime + ((includeRepeats != false) ? this.totalDuration() : this.duration()) / this._timeScale;
			};
	
			p.timeScale = function(value) {
				if (!arguments.length) {
					return this._timeScale;
				}
				var pauseTime, t;
				value = value || _tinyNum; //can't allow zero because it'll throw the math off
				if (this._timeline && this._timeline.smoothChildTiming) {
					pauseTime = this._pauseTime;
					t = (pauseTime || pauseTime === 0) ? pauseTime : this._timeline.totalTime();
					this._startTime = t - ((t - this._startTime) * this._timeScale / value);
				}
				this._timeScale = value;
				t = this.timeline;
				while (t && t.timeline) { //must update the duration/totalDuration of all ancestor timelines immediately in case in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
					t._dirty = true;
					t.totalDuration();
					t = t.timeline;
				}
				return this;
			};
	
			p.reversed = function(value) {
				if (!arguments.length) {
					return this._reversed;
				}
				if (value != this._reversed) {
					this._reversed = value;
					this.totalTime(((this._timeline && !this._timeline.smoothChildTiming) ? this.totalDuration() - this._totalTime : this._totalTime), true);
				}
				return this;
			};
	
			p.paused = function(value) {
				if (!arguments.length) {
					return this._paused;
				}
				var tl = this._timeline,
					raw, elapsed;
				if (value != this._paused) if (tl) {
					if (!_tickerActive && !value) {
						_ticker.wake();
					}
					raw = tl.rawTime();
					elapsed = raw - this._pauseTime;
					if (!value && tl.smoothChildTiming) {
						this._startTime += elapsed;
						this._uncache(false);
					}
					this._pauseTime = value ? raw : null;
					this._paused = value;
					this._active = this.isActive();
					if (!value && elapsed !== 0 && this._initted && this.duration()) {
						raw = tl.smoothChildTiming ? this._totalTime : (raw - this._startTime) / this._timeScale;
						this.render(raw, (raw === this._totalTime), true); //in case the target's properties changed via some other tween or manual update by the user, we should force a render.
					}
				}
				if (this._gc && !value) {
					this._enabled(true, false);
				}
				return this;
			};
	
	
	/*
	 * ----------------------------------------------------------------
	 * SimpleTimeline
	 * ----------------------------------------------------------------
	 */
			var SimpleTimeline = _class("core.SimpleTimeline", function(vars) {
				Animation.call(this, 0, vars);
				this.autoRemoveChildren = this.smoothChildTiming = true;
			});
	
			p = SimpleTimeline.prototype = new Animation();
			p.constructor = SimpleTimeline;
			p.kill()._gc = false;
			p._first = p._last = p._recent = null;
			p._sortChildren = false;
	
			p.add = p.insert = function(child, position, align, stagger) {
				var prevTween, st;
				child._startTime = Number(position || 0) + child._delay;
				if (child._paused) if (this !== child._timeline) { //we only adjust the _pauseTime if it wasn't in this timeline already. Remember, sometimes a tween will be inserted again into the same timeline when its startTime is changed so that the tweens in the TimelineLite/Max are re-ordered properly in the linked list (so everything renders in the proper order).
					child._pauseTime = this.rawTime() - (child._timeline.rawTime() - child._pauseTime);
				}
				if (child.timeline) {
					child.timeline._remove(child, true); //removes from existing timeline so that it can be properly added to this one.
				}
				child.timeline = child._timeline = this;
				if (child._gc) {
					child._enabled(true, true);
				}
				prevTween = this._last;
				if (this._sortChildren) {
					st = child._startTime;
					while (prevTween && prevTween._startTime > st) {
						prevTween = prevTween._prev;
					}
				}
				if (prevTween) {
					child._next = prevTween._next;
					prevTween._next = child;
				} else {
					child._next = this._first;
					this._first = child;
				}
				if (child._next) {
					child._next._prev = child;
				} else {
					this._last = child;
				}
				child._prev = prevTween;
				this._recent = child;
				if (this._timeline) {
					this._uncache(true);
				}
				return this;
			};
	
			p._remove = function(tween, skipDisable) {
				if (tween.timeline === this) {
					if (!skipDisable) {
						tween._enabled(false, true);
					}
	
					if (tween._prev) {
						tween._prev._next = tween._next;
					} else if (this._first === tween) {
						this._first = tween._next;
					}
					if (tween._next) {
						tween._next._prev = tween._prev;
					} else if (this._last === tween) {
						this._last = tween._prev;
					}
					tween._next = tween._prev = tween.timeline = null;
					if (tween === this._recent) {
						this._recent = this._last;
					}
	
					if (this._timeline) {
						this._uncache(true);
					}
				}
				return this;
			};
	
			p.render = function(time, suppressEvents, force) {
				var tween = this._first,
					next;
				this._totalTime = this._time = this._rawPrevTime = time;
				while (tween) {
					next = tween._next; //record it here because the value could change after rendering...
					if (tween._active || (time >= tween._startTime && !tween._paused && !tween._gc)) {
						if (!tween._reversed) {
							tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
						} else {
							tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
						}
					}
					tween = next;
				}
			};
	
			p.rawTime = function() {
				if (!_tickerActive) {
					_ticker.wake();
				}
				return this._totalTime;
			};
	
	/*
	 * ----------------------------------------------------------------
	 * TweenLite
	 * ----------------------------------------------------------------
	 */
			var TweenLite = _class("TweenLite", function(target, duration, vars) {
					Animation.call(this, duration, vars);
					this.render = TweenLite.prototype.render; //speed optimization (avoid prototype lookup on this "hot" method)
	
					if (target == null) {
						throw "Cannot tween a null target.";
					}
	
					this.target = target = (typeof(target) !== "string") ? target : TweenLite.selector(target) || target;
	
					var isSelector = (target.jquery || (target.length && target !== window && target[0] && (target[0] === window || (target[0].nodeType && target[0].style && !target.nodeType)))),
						overwrite = this.vars.overwrite,
						i, targ, targets;
	
					this._overwrite = overwrite = (overwrite == null) ? _overwriteLookup[TweenLite.defaultOverwrite] : (typeof(overwrite) === "number") ? overwrite >> 0 : _overwriteLookup[overwrite];
	
					if ((isSelector || target instanceof Array || (target.push && _isArray(target))) && typeof(target[0]) !== "number") {
						this._targets = targets = _slice(target);  //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
						this._propLookup = [];
						this._siblings = [];
						for (i = 0; i < targets.length; i++) {
							targ = targets[i];
							if (!targ) {
								targets.splice(i--, 1);
								continue;
							} else if (typeof(targ) === "string") {
								targ = targets[i--] = TweenLite.selector(targ); //in case it's an array of strings
								if (typeof(targ) === "string") {
									targets.splice(i+1, 1); //to avoid an endless loop (can't imagine why the selector would return a string, but just in case)
								}
								continue;
							} else if (targ.length && targ !== window && targ[0] && (targ[0] === window || (targ[0].nodeType && targ[0].style && !targ.nodeType))) { //in case the user is passing in an array of selector objects (like jQuery objects), we need to check one more level and pull things out if necessary. Also note that <select> elements pass all the criteria regarding length and the first child having style, so we must also check to ensure the target isn't an HTML node itself.
								targets.splice(i--, 1);
								this._targets = targets = targets.concat(_slice(targ));
								continue;
							}
							this._siblings[i] = _register(targ, this, false);
							if (overwrite === 1) if (this._siblings[i].length > 1) {
								_applyOverwrite(targ, this, null, 1, this._siblings[i]);
							}
						}
	
					} else {
						this._propLookup = {};
						this._siblings = _register(target, this, false);
						if (overwrite === 1) if (this._siblings.length > 1) {
							_applyOverwrite(target, this, null, 1, this._siblings);
						}
					}
					if (this.vars.immediateRender || (duration === 0 && this._delay === 0 && this.vars.immediateRender !== false)) {
						this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
						this.render(Math.min(0, -this._delay)); //in case delay is negative
					}
				}, true),
				_isSelector = function(v) {
					return (v && v.length && v !== window && v[0] && (v[0] === window || (v[0].nodeType && v[0].style && !v.nodeType))); //we cannot check "nodeType" if the target is window from within an iframe, otherwise it will trigger a security error in some browsers like Firefox.
				},
				_autoCSS = function(vars, target) {
					var css = {},
						p;
					for (p in vars) {
						if (!_reservedProps[p] && (!(p in target) || p === "transform" || p === "x" || p === "y" || p === "width" || p === "height" || p === "className" || p === "border") && (!_plugins[p] || (_plugins[p] && _plugins[p]._autoCSS))) { //note: <img> elements contain read-only "x" and "y" properties. We should also prioritize editing css width/height rather than the element's properties.
							css[p] = vars[p];
							delete vars[p];
						}
					}
					vars.css = css;
				};
	
			p = TweenLite.prototype = new Animation();
			p.constructor = TweenLite;
			p.kill()._gc = false;
	
	//----TweenLite defaults, overwrite management, and root updates ----------------------------------------------------
	
			p.ratio = 0;
			p._firstPT = p._targets = p._overwrittenProps = p._startAt = null;
			p._notifyPluginsOfEnabled = p._lazy = false;
	
			TweenLite.version = "1.20.5";
			TweenLite.defaultEase = p._ease = new Ease(null, null, 1, 1);
			TweenLite.defaultOverwrite = "auto";
			TweenLite.ticker = _ticker;
			TweenLite.autoSleep = 120;
			TweenLite.lagSmoothing = function(threshold, adjustedLag) {
				_ticker.lagSmoothing(threshold, adjustedLag);
			};
	
			TweenLite.selector = window.$ || window.jQuery || function(e) {
				var selector = window.$ || window.jQuery;
				if (selector) {
					TweenLite.selector = selector;
					return selector(e);
				}
				if (!_doc) { //in some dev environments (like Angular 6), GSAP gets loaded before the document is defined! So re-query it here if/when necessary.
					_doc = window.document;
				}
				return (!_doc) ? e : (_doc.querySelectorAll ? _doc.querySelectorAll(e) : _doc.getElementById((e.charAt(0) === "#") ? e.substr(1) : e));
			};
	
			var _lazyTweens = [],
				_lazyLookup = {},
				_numbersExp = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
				_relExp = /[\+-]=-?[\.\d]/,
				//_nonNumbersExp = /(?:([\-+](?!(\d|=)))|[^\d\-+=e]|(e(?![\-+][\d])))+/ig,
				_setRatio = function(v) {
					var pt = this._firstPT,
						min = 0.000001,
						val;
					while (pt) {
						val = !pt.blob ? pt.c * v + pt.s : (v === 1 && this.end != null) ? this.end : v ? this.join("") : this.start;
						if (pt.m) {
							val = pt.m.call(this._tween, val, this._target || pt.t, this._tween);
						} else if (val < min) if (val > -min && !pt.blob) { //prevents issues with converting very small numbers to strings in the browser
							val = 0;
						}
						if (!pt.f) {
							pt.t[pt.p] = val;
						} else if (pt.fp) {
							pt.t[pt.p](pt.fp, val);
						} else {
							pt.t[pt.p](val);
						}
						pt = pt._next;
					}
				},
				//compares two strings (start/end), finds the numbers that are different and spits back an array representing the whole value but with the changing values isolated as elements. For example, "rgb(0,0,0)" and "rgb(100,50,0)" would become ["rgb(", 0, ",", 50, ",0)"]. Notice it merges the parts that are identical (performance optimization). The array also has a linked list of PropTweens attached starting with _firstPT that contain the tweening data (t, p, s, c, f, etc.). It also stores the starting value as a "start" property so that we can revert to it if/when necessary, like when a tween rewinds fully. If the quantity of numbers differs between the start and end, it will always prioritize the end value(s). The pt parameter is optional - it's for a PropTween that will be appended to the end of the linked list and is typically for actually setting the value after all of the elements have been updated (with array.join("")).
				_blobDif = function(start, end, filter, pt) {
					var a = [],
						charIndex = 0,
						s = "",
						color = 0,
						startNums, endNums, num, i, l, nonNumbers, currentNum;
					a.start = start;
					a.end = end;
					start = a[0] = start + ""; //ensure values are strings
					end = a[1] = end + "";
					if (filter) {
						filter(a); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
						start = a[0];
						end = a[1];
					}
					a.length = 0;
					startNums = start.match(_numbersExp) || [];
					endNums = end.match(_numbersExp) || [];
					if (pt) {
						pt._next = null;
						pt.blob = 1;
						a._firstPT = a._applyPT = pt; //apply last in the linked list (which means inserting it first)
					}
					l = endNums.length;
					for (i = 0; i < l; i++) {
						currentNum = endNums[i];
						nonNumbers = end.substr(charIndex, end.indexOf(currentNum, charIndex)-charIndex);
						s += (nonNumbers || !i) ? nonNumbers : ","; //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
						charIndex += nonNumbers.length;
						if (color) { //sense rgba() values and round them.
							color = (color + 1) % 5;
						} else if (nonNumbers.substr(-5) === "rgba(") {
							color = 1;
						}
						if (currentNum === startNums[i] || startNums.length <= i) {
							s += currentNum;
						} else {
							if (s) {
								a.push(s);
								s = "";
							}
							num = parseFloat(startNums[i]);
							a.push(num);
							a._firstPT = {_next: a._firstPT, t:a, p: a.length-1, s:num, c:((currentNum.charAt(1) === "=") ? parseInt(currentNum.charAt(0) + "1", 10) * parseFloat(currentNum.substr(2)) : (parseFloat(currentNum) - num)) || 0, f:0, m:(color && color < 4) ? Math.round : 0};
							//note: we don't set _prev because we'll never need to remove individual PropTweens from this list.
						}
						charIndex += currentNum.length;
					}
					s += end.substr(charIndex);
					if (s) {
						a.push(s);
					}
					a.setRatio = _setRatio;
					if (_relExp.test(end)) { //if the end string contains relative values, delete it so that on the final render (in _setRatio()), we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
						a.end = null;
					}
					return a;
				},
				//note: "funcParam" is only necessary for function-based getters/setters that require an extra parameter like getAttribute("width") and setAttribute("width", value). In this example, funcParam would be "width". Used by AttrPlugin for example.
				_addPropTween = function(target, prop, start, end, overwriteProp, mod, funcParam, stringFilter, index) {
					if (typeof(end) === "function") {
						end = end(index || 0, target);
					}
					var type = typeof(target[prop]),
						getterName = (type !== "function") ? "" : ((prop.indexOf("set") || typeof(target["get" + prop.substr(3)]) !== "function") ? prop : "get" + prop.substr(3)),
						s = (start !== "get") ? start : !getterName ? target[prop] : funcParam ? target[getterName](funcParam) : target[getterName](),
						isRelative = (typeof(end) === "string" && end.charAt(1) === "="),
						pt = {t:target, p:prop, s:s, f:(type === "function"), pg:0, n:overwriteProp || prop, m:(!mod ? 0 : (typeof(mod) === "function") ? mod : Math.round), pr:0, c:isRelative ? parseInt(end.charAt(0) + "1", 10) * parseFloat(end.substr(2)) : (parseFloat(end) - s) || 0},
						blob;
	
					if (typeof(s) !== "number" || (typeof(end) !== "number" && !isRelative)) {
						if (funcParam || isNaN(s) || (!isRelative && isNaN(end)) || typeof(s) === "boolean" || typeof(end) === "boolean") {
							//a blob (string that has multiple numbers in it)
							pt.fp = funcParam;
							blob = _blobDif(s, (isRelative ? (parseFloat(pt.s) + pt.c) + (pt.s + "").replace(/[0-9\-\.]/g, "") : end), stringFilter || TweenLite.defaultStringFilter, pt);
							pt = {t: blob, p: "setRatio", s: 0, c: 1, f: 2, pg: 0, n: overwriteProp || prop, pr: 0, m: 0}; //"2" indicates it's a Blob property tween. Needed for RoundPropsPlugin for example.
						} else {
							pt.s = parseFloat(s);
							if (!isRelative) {
								pt.c = (parseFloat(end) - pt.s) || 0;
							}
						}
					}
					if (pt.c) { //only add it to the linked list if there's a change.
						if ((pt._next = this._firstPT)) {
							pt._next._prev = pt;
						}
						this._firstPT = pt;
						return pt;
					}
				},
				_internals = TweenLite._internals = {isArray:_isArray, isSelector:_isSelector, lazyTweens:_lazyTweens, blobDif:_blobDif}, //gives us a way to expose certain private values to other GreenSock classes without contaminating tha main TweenLite object.
				_plugins = TweenLite._plugins = {},
				_tweenLookup = _internals.tweenLookup = {},
				_tweenLookupNum = 0,
				_reservedProps = _internals.reservedProps = {ease:1, delay:1, overwrite:1, onComplete:1, onCompleteParams:1, onCompleteScope:1, useFrames:1, runBackwards:1, startAt:1, onUpdate:1, onUpdateParams:1, onUpdateScope:1, onStart:1, onStartParams:1, onStartScope:1, onReverseComplete:1, onReverseCompleteParams:1, onReverseCompleteScope:1, onRepeat:1, onRepeatParams:1, onRepeatScope:1, easeParams:1, yoyo:1, immediateRender:1, repeat:1, repeatDelay:1, data:1, paused:1, reversed:1, autoCSS:1, lazy:1, onOverwrite:1, callbackScope:1, stringFilter:1, id:1, yoyoEase:1},
				_overwriteLookup = {none:0, all:1, auto:2, concurrent:3, allOnStart:4, preexisting:5, "true":1, "false":0},
				_rootFramesTimeline = Animation._rootFramesTimeline = new SimpleTimeline(),
				_rootTimeline = Animation._rootTimeline = new SimpleTimeline(),
				_nextGCFrame = 30,
				_lazyRender = _internals.lazyRender = function() {
					var i = _lazyTweens.length,
						tween;
					_lazyLookup = {};
					while (--i > -1) {
						tween = _lazyTweens[i];
						if (tween && tween._lazy !== false) {
							tween.render(tween._lazy[0], tween._lazy[1], true);
							tween._lazy = false;
						}
					}
					_lazyTweens.length = 0;
				};
	
			_rootTimeline._startTime = _ticker.time;
			_rootFramesTimeline._startTime = _ticker.frame;
			_rootTimeline._active = _rootFramesTimeline._active = true;
			setTimeout(_lazyRender, 1); //on some mobile devices, there isn't a "tick" before code runs which means any lazy renders wouldn't run before the next official "tick".
	
			Animation._updateRoot = TweenLite.render = function() {
					var i, a, p;
					if (_lazyTweens.length) { //if code is run outside of the requestAnimationFrame loop, there may be tweens queued AFTER the engine refreshed, so we need to ensure any pending renders occur before we refresh again.
						_lazyRender();
					}
					_rootTimeline.render((_ticker.time - _rootTimeline._startTime) * _rootTimeline._timeScale, false, false);
					_rootFramesTimeline.render((_ticker.frame - _rootFramesTimeline._startTime) * _rootFramesTimeline._timeScale, false, false);
					if (_lazyTweens.length) {
						_lazyRender();
					}
					if (_ticker.frame >= _nextGCFrame) { //dump garbage every 120 frames or whatever the user sets TweenLite.autoSleep to
						_nextGCFrame = _ticker.frame + (parseInt(TweenLite.autoSleep, 10) || 120);
						for (p in _tweenLookup) {
							a = _tweenLookup[p].tweens;
							i = a.length;
							while (--i > -1) {
								if (a[i]._gc) {
									a.splice(i, 1);
								}
							}
							if (a.length === 0) {
								delete _tweenLookup[p];
							}
						}
						//if there are no more tweens in the root timelines, or if they're all paused, make the _timer sleep to reduce load on the CPU slightly
						p = _rootTimeline._first;
						if (!p || p._paused) if (TweenLite.autoSleep && !_rootFramesTimeline._first && _ticker._listeners.tick.length === 1) {
							while (p && p._paused) {
								p = p._next;
							}
							if (!p) {
								_ticker.sleep();
							}
						}
					}
				};
	
			_ticker.addEventListener("tick", Animation._updateRoot);
	
			var _register = function(target, tween, scrub) {
					var id = target._gsTweenID, a, i;
					if (!_tweenLookup[id || (target._gsTweenID = id = "t" + (_tweenLookupNum++))]) {
						_tweenLookup[id] = {target:target, tweens:[]};
					}
					if (tween) {
						a = _tweenLookup[id].tweens;
						a[(i = a.length)] = tween;
						if (scrub) {
							while (--i > -1) {
								if (a[i] === tween) {
									a.splice(i, 1);
								}
							}
						}
					}
					return _tweenLookup[id].tweens;
				},
				_onOverwrite = function(overwrittenTween, overwritingTween, target, killedProps) {
					var func = overwrittenTween.vars.onOverwrite, r1, r2;
					if (func) {
						r1 = func(overwrittenTween, overwritingTween, target, killedProps);
					}
					func = TweenLite.onOverwrite;
					if (func) {
						r2 = func(overwrittenTween, overwritingTween, target, killedProps);
					}
					return (r1 !== false && r2 !== false);
				},
				_applyOverwrite = function(target, tween, props, mode, siblings) {
					var i, changed, curTween, l;
					if (mode === 1 || mode >= 4) {
						l = siblings.length;
						for (i = 0; i < l; i++) {
							if ((curTween = siblings[i]) !== tween) {
								if (!curTween._gc) {
									if (curTween._kill(null, target, tween)) {
										changed = true;
									}
								}
							} else if (mode === 5) {
								break;
							}
						}
						return changed;
					}
					//NOTE: Add 0.0000000001 to overcome floating point errors that can cause the startTime to be VERY slightly off (when a tween's time() is set for example)
					var startTime = tween._startTime + _tinyNum,
						overlaps = [],
						oCount = 0,
						zeroDur = (tween._duration === 0),
						globalStart;
					i = siblings.length;
					while (--i > -1) {
						if ((curTween = siblings[i]) === tween || curTween._gc || curTween._paused) {
							//ignore
						} else if (curTween._timeline !== tween._timeline) {
							globalStart = globalStart || _checkOverlap(tween, 0, zeroDur);
							if (_checkOverlap(curTween, globalStart, zeroDur) === 0) {
								overlaps[oCount++] = curTween;
							}
						} else if (curTween._startTime <= startTime) if (curTween._startTime + curTween.totalDuration() / curTween._timeScale > startTime) if (!((zeroDur || !curTween._initted) && startTime - curTween._startTime <= 0.0000000002)) {
							overlaps[oCount++] = curTween;
						}
					}
	
					i = oCount;
					while (--i > -1) {
						curTween = overlaps[i];
						if (mode === 2) if (curTween._kill(props, target, tween)) {
							changed = true;
						}
						if (mode !== 2 || (!curTween._firstPT && curTween._initted)) {
							if (mode !== 2 && !_onOverwrite(curTween, tween)) {
								continue;
							}
							if (curTween._enabled(false, false)) { //if all property tweens have been overwritten, kill the tween.
								changed = true;
							}
						}
					}
					return changed;
				},
				_checkOverlap = function(tween, reference, zeroDur) {
					var tl = tween._timeline,
						ts = tl._timeScale,
						t = tween._startTime;
					while (tl._timeline) {
						t += tl._startTime;
						ts *= tl._timeScale;
						if (tl._paused) {
							return -100;
						}
						tl = tl._timeline;
					}
					t /= ts;
					return (t > reference) ? t - reference : ((zeroDur && t === reference) || (!tween._initted && t - reference < 2 * _tinyNum)) ? _tinyNum : ((t += tween.totalDuration() / tween._timeScale / ts) > reference + _tinyNum) ? 0 : t - reference - _tinyNum;
				};
	
	
	//---- TweenLite instance methods -----------------------------------------------------------------------------
	
			p._init = function() {
				var v = this.vars,
					op = this._overwrittenProps,
					dur = this._duration,
					immediate = !!v.immediateRender,
					ease = v.ease,
					i, initPlugins, pt, p, startVars, l;
				if (v.startAt) {
					if (this._startAt) {
						this._startAt.render(-1, true); //if we've run a startAt previously (when the tween instantiated), we should revert it so that the values re-instantiate correctly particularly for relative tweens. Without this, a TweenLite.fromTo(obj, 1, {x:"+=100"}, {x:"-=100"}), for example, would actually jump to +=200 because the startAt would run twice, doubling the relative change.
						this._startAt.kill();
					}
					startVars = {};
					for (p in v.startAt) { //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, 1, from, to).fromTo(e, 1, to, from);
						startVars[p] = v.startAt[p];
					}
					startVars.data = "isStart";
					startVars.overwrite = false;
					startVars.immediateRender = true;
					startVars.lazy = (immediate && v.lazy !== false);
					startVars.startAt = startVars.delay = null; //no nesting of startAt objects allowed (otherwise it could cause an infinite loop).
					startVars.onUpdate = v.onUpdate;
					startVars.onUpdateParams = v.onUpdateParams;
					startVars.onUpdateScope = v.onUpdateScope || v.callbackScope || this;
					this._startAt = TweenLite.to(this.target || {}, 0, startVars);
					if (immediate) {
						if (this._time > 0) {
							this._startAt = null; //tweens that render immediately (like most from() and fromTo() tweens) shouldn't revert when their parent timeline's playhead goes backward past the startTime because the initial render could have happened anytime and it shouldn't be directly correlated to this tween's startTime. Imagine setting up a complex animation where the beginning states of various objects are rendered immediately but the tween doesn't happen for quite some time - if we revert to the starting values as soon as the playhead goes backward past the tween's startTime, it will throw things off visually. Reversion should only happen in TimelineLite/Max instances where immediateRender was false (which is the default in the convenience methods like from()).
						} else if (dur !== 0) {
							return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a TimelineLite or TimelineMax, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
						}
					}
				} else if (v.runBackwards && dur !== 0) {
					//from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
					if (this._startAt) {
						this._startAt.render(-1, true);
						this._startAt.kill();
						this._startAt = null;
					} else {
						if (this._time !== 0) { //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
							immediate = false;
						}
						pt = {};
						for (p in v) { //copy props into a new object and skip any reserved props, otherwise onComplete or onUpdate or onStart could fire. We should, however, permit autoCSS to go through.
							if (!_reservedProps[p] || p === "autoCSS") {
								pt[p] = v[p];
							}
						}
						pt.overwrite = 0;
						pt.data = "isFromStart"; //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
						pt.lazy = (immediate && v.lazy !== false);
						pt.immediateRender = immediate; //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
						this._startAt = TweenLite.to(this.target, 0, pt);
						if (!immediate) {
							this._startAt._init(); //ensures that the initial values are recorded
							this._startAt._enabled(false); //no need to have the tween render on the next cycle. Disable it because we'll always manually control the renders of the _startAt tween.
							if (this.vars.immediateRender) {
								this._startAt = null;
							}
						} else if (this._time === 0) {
							return;
						}
					}
				}
				this._ease = ease = (!ease) ? TweenLite.defaultEase : (ease instanceof Ease) ? ease : (typeof(ease) === "function") ? new Ease(ease, v.easeParams) : _easeMap[ease] || TweenLite.defaultEase;
				if (v.easeParams instanceof Array && ease.config) {
					this._ease = ease.config.apply(ease, v.easeParams);
				}
				this._easeType = this._ease._type;
				this._easePower = this._ease._power;
				this._firstPT = null;
	
				if (this._targets) {
					l = this._targets.length;
					for (i = 0; i < l; i++) {
						if ( this._initProps( this._targets[i], (this._propLookup[i] = {}), this._siblings[i], (op ? op[i] : null), i) ) {
							initPlugins = true;
						}
					}
				} else {
					initPlugins = this._initProps(this.target, this._propLookup, this._siblings, op, 0);
				}
	
				if (initPlugins) {
					TweenLite._onPluginEvent("_onInitAllProps", this); //reorders the array in order of priority. Uses a static TweenPlugin method in order to minimize file size in TweenLite
				}
				if (op) if (!this._firstPT) if (typeof(this.target) !== "function") { //if all tweening properties have been overwritten, kill the tween. If the target is a function, it's probably a delayedCall so let it live.
					this._enabled(false, false);
				}
				if (v.runBackwards) {
					pt = this._firstPT;
					while (pt) {
						pt.s += pt.c;
						pt.c = -pt.c;
						pt = pt._next;
					}
				}
				this._onUpdate = v.onUpdate;
				this._initted = true;
			};
	
			p._initProps = function(target, propLookup, siblings, overwrittenProps, index) {
				var p, i, initPlugins, plugin, pt, v;
				if (target == null) {
					return false;
				}
	
				if (_lazyLookup[target._gsTweenID]) {
					_lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
				}
	
				if (!this.vars.css) if (target.style) if (target !== window && target.nodeType) if (_plugins.css) if (this.vars.autoCSS !== false) { //it's so common to use TweenLite/Max to animate the css of DOM elements, we assume that if the target is a DOM element, that's what is intended (a convenience so that users don't have to wrap things in css:{}, although we still recommend it for a slight performance boost and better specificity). Note: we cannot check "nodeType" on the window inside an iframe.
					_autoCSS(this.vars, target);
				}
				for (p in this.vars) {
					v = this.vars[p];
					if (_reservedProps[p]) {
						if (v) if ((v instanceof Array) || (v.push && _isArray(v))) if (v.join("").indexOf("{self}") !== -1) {
							this.vars[p] = v = this._swapSelfInParams(v, this);
						}
	
					} else if (_plugins[p] && (plugin = new _plugins[p]())._onInitTween(target, this.vars[p], this, index)) {
	
						//t - target 		[object]
						//p - property 		[string]
						//s - start			[number]
						//c - change		[number]
						//f - isFunction	[boolean]
						//n - name			[string]
						//pg - isPlugin 	[boolean]
						//pr - priority		[number]
						//m - mod           [function | 0]
						this._firstPT = pt = {_next:this._firstPT, t:plugin, p:"setRatio", s:0, c:1, f:1, n:p, pg:1, pr:plugin._priority, m:0};
						i = plugin._overwriteProps.length;
						while (--i > -1) {
							propLookup[plugin._overwriteProps[i]] = this._firstPT;
						}
						if (plugin._priority || plugin._onInitAllProps) {
							initPlugins = true;
						}
						if (plugin._onDisable || plugin._onEnable) {
							this._notifyPluginsOfEnabled = true;
						}
						if (pt._next) {
							pt._next._prev = pt;
						}
	
					} else {
						propLookup[p] = _addPropTween.call(this, target, p, "get", v, p, 0, null, this.vars.stringFilter, index);
					}
				}
	
				if (overwrittenProps) if (this._kill(overwrittenProps, target)) { //another tween may have tried to overwrite properties of this tween before init() was called (like if two tweens start at the same time, the one created second will run first)
					return this._initProps(target, propLookup, siblings, overwrittenProps, index);
				}
				if (this._overwrite > 1) if (this._firstPT) if (siblings.length > 1) if (_applyOverwrite(target, this, propLookup, this._overwrite, siblings)) {
					this._kill(propLookup, target);
					return this._initProps(target, propLookup, siblings, overwrittenProps, index);
				}
				if (this._firstPT) if ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration)) { //zero duration tweens don't lazy render by default; everything else does.
					_lazyLookup[target._gsTweenID] = true;
				}
				return initPlugins;
			};
	
			p.render = function(time, suppressEvents, force) {
				var prevTime = this._time,
					duration = this._duration,
					prevRawPrevTime = this._rawPrevTime,
					isComplete, callback, pt, rawPrevTime;
				if (time >= duration - 0.0000001 && time >= 0) { //to work around occasional floating point math artifacts.
					this._totalTime = this._time = duration;
					this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1;
					if (!this._reversed ) {
						isComplete = true;
						callback = "onComplete";
						force = (force || this._timeline.autoRemoveChildren); //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
					}
					if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
						if (this._startTime === this._timeline._duration) { //if a zero-duration tween is at the VERY end of a timeline and that timeline renders at its end, it will typically add a tiny bit of cushion to the render time to prevent rounding errors from getting in the way of tweens rendering their VERY end. If we then reverse() that timeline, the zero-duration tween will trigger its onReverseComplete even though technically the playhead didn't pass over it again. It's a very specific edge case we must accommodate.
							time = 0;
						}
						if (prevRawPrevTime < 0 || (time <= 0 && time >= -0.0000001) || (prevRawPrevTime === _tinyNum && this.data !== "isPause")) if (prevRawPrevTime !== time) { //note: when this.data is "isPause", it's a callback added by addPause() on a timeline that we should not be triggered when LEAVING its exact start time. In other words, tl.addPause(1).play(1) shouldn't pause.
							force = true;
							if (prevRawPrevTime > _tinyNum) {
								callback = "onReverseComplete";
							}
						}
						this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					}
	
				} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
					this._totalTime = this._time = 0;
					this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
					if (prevTime !== 0 || (duration === 0 && prevRawPrevTime > 0)) {
						callback = "onReverseComplete";
						isComplete = this._reversed;
					}
					if (time < 0) {
						this._active = false;
						if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
							if (prevRawPrevTime >= 0 && !(prevRawPrevTime === _tinyNum && this.data === "isPause")) {
								force = true;
							}
							this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
						}
					}
					if (!this._initted || (this._startAt && this._startAt.progress())) { //if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately. Also, we check progress() because if startAt has already rendered at its end, we should force a render at its beginning. Otherwise, if you put the playhead directly on top of where a fromTo({immediateRender:false}) starts, and then move it backwards, the from() won't revert its values.
						force = true;
					}
				} else {
					this._totalTime = this._time = time;
	
					if (this._easeType) {
						var r = time / duration, type = this._easeType, pow = this._easePower;
						if (type === 1 || (type === 3 && r >= 0.5)) {
							r = 1 - r;
						}
						if (type === 3) {
							r *= 2;
						}
						if (pow === 1) {
							r *= r;
						} else if (pow === 2) {
							r *= r * r;
						} else if (pow === 3) {
							r *= r * r * r;
						} else if (pow === 4) {
							r *= r * r * r * r;
						}
	
						if (type === 1) {
							this.ratio = 1 - r;
						} else if (type === 2) {
							this.ratio = r;
						} else if (time / duration < 0.5) {
							this.ratio = r / 2;
						} else {
							this.ratio = 1 - (r / 2);
						}
	
					} else {
						this.ratio = this._ease.getRatio(time / duration);
					}
				}
	
				if (this._time === prevTime && !force) {
					return;
				} else if (!this._initted) {
					this._init();
					if (!this._initted || this._gc) { //immediateRender tweens typically won't initialize until the playhead advances (_time is greater than 0) in order to ensure that overwriting occurs properly. Also, if all of the tweening properties have been overwritten (which would cause _gc to be true, as set in _init()), we shouldn't continue otherwise an onStart callback could be called for example.
						return;
					} else if (!force && this._firstPT && ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration))) {
						this._time = this._totalTime = prevTime;
						this._rawPrevTime = prevRawPrevTime;
						_lazyTweens.push(this);
						this._lazy = [time, suppressEvents];
						return;
					}
					//_ease is initially set to defaultEase, so now that init() has run, _ease is set properly and we need to recalculate the ratio. Overall this is faster than using conditional logic earlier in the method to avoid having to set ratio twice because we only init() once but renderTime() gets called VERY frequently.
					if (this._time && !isComplete) {
						this.ratio = this._ease.getRatio(this._time / duration);
					} else if (isComplete && this._ease._calcEnd) {
						this.ratio = this._ease.getRatio((this._time === 0) ? 0 : 1);
					}
				}
				if (this._lazy !== false) { //in case a lazy render is pending, we should flush it because the new render is occurring now (imagine a lazy tween instantiating and then immediately the user calls tween.seek(tween.duration()), skipping to the end - the end render would be forced, and then if we didn't flush the lazy render, it'd fire AFTER the seek(), rendering it at the wrong time.
					this._lazy = false;
				}
				if (!this._active) if (!this._paused && this._time !== prevTime && time >= 0) {
					this._active = true;  //so that if the user renders a tween (as opposed to the timeline rendering it), the timeline is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the tween already finished but the user manually re-renders it as halfway done.
				}
				if (prevTime === 0) {
					if (this._startAt) {
						if (time >= 0) {
							this._startAt.render(time, true, force);
						} else if (!callback) {
							callback = "_dummyGS"; //if no callback is defined, use a dummy value just so that the condition at the end evaluates as true because _startAt should render AFTER the normal render loop when the time is negative. We could handle this in a more intuitive way, of course, but the render loop is the MOST important thing to optimize, so this technique allows us to avoid adding extra conditional logic in a high-frequency area.
						}
					}
					if (this.vars.onStart) if (this._time !== 0 || duration === 0) if (!suppressEvents) {
						this._callback("onStart");
					}
				}
				pt = this._firstPT;
				while (pt) {
					if (pt.f) {
						pt.t[pt.p](pt.c * this.ratio + pt.s);
					} else {
						pt.t[pt.p] = pt.c * this.ratio + pt.s;
					}
					pt = pt._next;
				}
	
				if (this._onUpdate) {
					if (time < 0) if (this._startAt && time !== -0.0001) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
						this._startAt.render(time, true, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
					}
					if (!suppressEvents) if (this._time !== prevTime || isComplete || force) {
						this._callback("onUpdate");
					}
				}
				if (callback) if (!this._gc || force) { //check _gc because there's a chance that kill() could be called in an onUpdate
					if (time < 0 && this._startAt && !this._onUpdate && time !== -0.0001) { //-0.0001 is a special value that we use when looping back to the beginning of a repeated TimelineMax, in which case we shouldn't render the _startAt values.
						this._startAt.render(time, true, force);
					}
					if (isComplete) {
						if (this._timeline.autoRemoveChildren) {
							this._enabled(false, false);
						}
						this._active = false;
					}
					if (!suppressEvents && this.vars[callback]) {
						this._callback(callback);
					}
					if (duration === 0 && this._rawPrevTime === _tinyNum && rawPrevTime !== _tinyNum) { //the onComplete or onReverseComplete could trigger movement of the playhead and for zero-duration tweens (which must discern direction) that land directly back on their start time, we don't want to fire again on the next render. Think of several addPause()'s in a timeline that forces the playhead to a certain spot, but what if it's already paused and another tween is tweening the "time" of the timeline? Each time it moves [forward] past that spot, it would move back, and since suppressEvents is true, it'd reset _rawPrevTime to _tinyNum so that when it begins again, the callback would fire (so ultimately it could bounce back and forth during that tween). Again, this is a very uncommon scenario, but possible nonetheless.
						this._rawPrevTime = 0;
					}
				}
			};
	
			p._kill = function(vars, target, overwritingTween) {
				if (vars === "all") {
					vars = null;
				}
				if (vars == null) if (target == null || target === this.target) {
					this._lazy = false;
					return this._enabled(false, false);
				}
				target = (typeof(target) !== "string") ? (target || this._targets || this.target) : TweenLite.selector(target) || target;
				var simultaneousOverwrite = (overwritingTween && this._time && overwritingTween._startTime === this._startTime && this._timeline === overwritingTween._timeline),
					i, overwrittenProps, p, pt, propLookup, changed, killProps, record, killed;
				if ((_isArray(target) || _isSelector(target)) && typeof(target[0]) !== "number") {
					i = target.length;
					while (--i > -1) {
						if (this._kill(vars, target[i], overwritingTween)) {
							changed = true;
						}
					}
				} else {
					if (this._targets) {
						i = this._targets.length;
						while (--i > -1) {
							if (target === this._targets[i]) {
								propLookup = this._propLookup[i] || {};
								this._overwrittenProps = this._overwrittenProps || [];
								overwrittenProps = this._overwrittenProps[i] = vars ? this._overwrittenProps[i] || {} : "all";
								break;
							}
						}
					} else if (target !== this.target) {
						return false;
					} else {
						propLookup = this._propLookup;
						overwrittenProps = this._overwrittenProps = vars ? this._overwrittenProps || {} : "all";
					}
	
					if (propLookup) {
						killProps = vars || propLookup;
						record = (vars !== overwrittenProps && overwrittenProps !== "all" && vars !== propLookup && (typeof(vars) !== "object" || !vars._tempKill)); //_tempKill is a super-secret way to delete a particular tweening property but NOT have it remembered as an official overwritten property (like in BezierPlugin)
						if (overwritingTween && (TweenLite.onOverwrite || this.vars.onOverwrite)) {
							for (p in killProps) {
								if (propLookup[p]) {
									if (!killed) {
										killed = [];
									}
									killed.push(p);
								}
							}
							if ((killed || !vars) && !_onOverwrite(this, overwritingTween, target, killed)) { //if the onOverwrite returned false, that means the user wants to override the overwriting (cancel it).
								return false;
							}
						}
	
						for (p in killProps) {
							if ((pt = propLookup[p])) {
								if (simultaneousOverwrite) { //if another tween overwrites this one and they both start at exactly the same time, yet this tween has already rendered once (for example, at 0.001) because it's first in the queue, we should revert the values to where they were at 0 so that the starting values aren't contaminated on the overwriting tween.
									if (pt.f) {
										pt.t[pt.p](pt.s);
									} else {
										pt.t[pt.p] = pt.s;
									}
									changed = true;
								}
								if (pt.pg && pt.t._kill(killProps)) {
									changed = true; //some plugins need to be notified so they can perform cleanup tasks first
								}
								if (!pt.pg || pt.t._overwriteProps.length === 0) {
									if (pt._prev) {
										pt._prev._next = pt._next;
									} else if (pt === this._firstPT) {
										this._firstPT = pt._next;
									}
									if (pt._next) {
										pt._next._prev = pt._prev;
									}
									pt._next = pt._prev = null;
								}
								delete propLookup[p];
							}
							if (record) {
								overwrittenProps[p] = 1;
							}
						}
						if (!this._firstPT && this._initted) { //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
							this._enabled(false, false);
						}
					}
				}
				return changed;
			};
	
			p.invalidate = function() {
				if (this._notifyPluginsOfEnabled) {
					TweenLite._onPluginEvent("_onDisable", this);
				}
				this._firstPT = this._overwrittenProps = this._startAt = this._onUpdate = null;
				this._notifyPluginsOfEnabled = this._active = this._lazy = false;
				this._propLookup = (this._targets) ? {} : [];
				Animation.prototype.invalidate.call(this);
				if (this.vars.immediateRender) {
					this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
					this.render(Math.min(0, -this._delay)); //in case delay is negative.
				}
				return this;
			};
	
			p._enabled = function(enabled, ignoreTimeline) {
				if (!_tickerActive) {
					_ticker.wake();
				}
				if (enabled && this._gc) {
					var targets = this._targets,
						i;
					if (targets) {
						i = targets.length;
						while (--i > -1) {
							this._siblings[i] = _register(targets[i], this, true);
						}
					} else {
						this._siblings = _register(this.target, this, true);
					}
				}
				Animation.prototype._enabled.call(this, enabled, ignoreTimeline);
				if (this._notifyPluginsOfEnabled) if (this._firstPT) {
					return TweenLite._onPluginEvent((enabled ? "_onEnable" : "_onDisable"), this);
				}
				return false;
			};
	
	
	//----TweenLite static methods -----------------------------------------------------
	
			TweenLite.to = function(target, duration, vars) {
				return new TweenLite(target, duration, vars);
			};
	
			TweenLite.from = function(target, duration, vars) {
				vars.runBackwards = true;
				vars.immediateRender = (vars.immediateRender != false);
				return new TweenLite(target, duration, vars);
			};
	
			TweenLite.fromTo = function(target, duration, fromVars, toVars) {
				toVars.startAt = fromVars;
				toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
				return new TweenLite(target, duration, toVars);
			};
	
			TweenLite.delayedCall = function(delay, callback, params, scope, useFrames) {
				return new TweenLite(callback, 0, {delay:delay, onComplete:callback, onCompleteParams:params, callbackScope:scope, onReverseComplete:callback, onReverseCompleteParams:params, immediateRender:false, lazy:false, useFrames:useFrames, overwrite:0});
			};
	
			TweenLite.set = function(target, vars) {
				return new TweenLite(target, 0, vars);
			};
	
			TweenLite.getTweensOf = function(target, onlyActive) {
				if (target == null) { return []; }
				target = (typeof(target) !== "string") ? target : TweenLite.selector(target) || target;
				var i, a, j, t;
				if ((_isArray(target) || _isSelector(target)) && typeof(target[0]) !== "number") {
					i = target.length;
					a = [];
					while (--i > -1) {
						a = a.concat(TweenLite.getTweensOf(target[i], onlyActive));
					}
					i = a.length;
					//now get rid of any duplicates (tweens of arrays of objects could cause duplicates)
					while (--i > -1) {
						t = a[i];
						j = i;
						while (--j > -1) {
							if (t === a[j]) {
								a.splice(i, 1);
							}
						}
					}
				} else if (target._gsTweenID) {
					a = _register(target).concat();
					i = a.length;
					while (--i > -1) {
						if (a[i]._gc || (onlyActive && !a[i].isActive())) {
							a.splice(i, 1);
						}
					}
				}
				return a || [];
			};
	
			TweenLite.killTweensOf = TweenLite.killDelayedCallsTo = function(target, onlyActive, vars) {
				if (typeof(onlyActive) === "object") {
					vars = onlyActive; //for backwards compatibility (before "onlyActive" parameter was inserted)
					onlyActive = false;
				}
				var a = TweenLite.getTweensOf(target, onlyActive),
					i = a.length;
				while (--i > -1) {
					a[i]._kill(vars, target);
				}
			};
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * TweenPlugin   (could easily be split out as a separate file/class, but included for ease of use (so that people don't need to include another script call before loading plugins which is easy to forget)
	 * ----------------------------------------------------------------
	 */
			var TweenPlugin = _class("plugins.TweenPlugin", function(props, priority) {
						this._overwriteProps = (props || "").split(",");
						this._propName = this._overwriteProps[0];
						this._priority = priority || 0;
						this._super = TweenPlugin.prototype;
					}, true);
	
			p = TweenPlugin.prototype;
			TweenPlugin.version = "1.19.0";
			TweenPlugin.API = 2;
			p._firstPT = null;
			p._addTween = _addPropTween;
			p.setRatio = _setRatio;
	
			p._kill = function(lookup) {
				var a = this._overwriteProps,
					pt = this._firstPT,
					i;
				if (lookup[this._propName] != null) {
					this._overwriteProps = [];
				} else {
					i = a.length;
					while (--i > -1) {
						if (lookup[a[i]] != null) {
							a.splice(i, 1);
						}
					}
				}
				while (pt) {
					if (lookup[pt.n] != null) {
						if (pt._next) {
							pt._next._prev = pt._prev;
						}
						if (pt._prev) {
							pt._prev._next = pt._next;
							pt._prev = null;
						} else if (this._firstPT === pt) {
							this._firstPT = pt._next;
						}
					}
					pt = pt._next;
				}
				return false;
			};
	
			p._mod = p._roundProps = function(lookup) {
				var pt = this._firstPT,
					val;
				while (pt) {
					val = lookup[this._propName] || (pt.n != null && lookup[ pt.n.split(this._propName + "_").join("") ]);
					if (val && typeof(val) === "function") { //some properties that are very plugin-specific add a prefix named after the _propName plus an underscore, so we need to ignore that extra stuff here.
						if (pt.f === 2) {
							pt.t._applyPT.m = val;
						} else {
							pt.m = val;
						}
					}
					pt = pt._next;
				}
			};
	
			TweenLite._onPluginEvent = function(type, tween) {
				var pt = tween._firstPT,
					changed, pt2, first, last, next;
				if (type === "_onInitAllProps") {
					//sorts the PropTween linked list in order of priority because some plugins need to render earlier/later than others, like MotionBlurPlugin applies its effects after all x/y/alpha tweens have rendered on each frame.
					while (pt) {
						next = pt._next;
						pt2 = first;
						while (pt2 && pt2.pr > pt.pr) {
							pt2 = pt2._next;
						}
						if ((pt._prev = pt2 ? pt2._prev : last)) {
							pt._prev._next = pt;
						} else {
							first = pt;
						}
						if ((pt._next = pt2)) {
							pt2._prev = pt;
						} else {
							last = pt;
						}
						pt = next;
					}
					pt = tween._firstPT = first;
				}
				while (pt) {
					if (pt.pg) if (typeof(pt.t[type]) === "function") if (pt.t[type]()) {
						changed = true;
					}
					pt = pt._next;
				}
				return changed;
			};
	
			TweenPlugin.activate = function(plugins) {
				var i = plugins.length;
				while (--i > -1) {
					if (plugins[i].API === TweenPlugin.API) {
						_plugins[(new plugins[i]())._propName] = plugins[i];
					}
				}
				return true;
			};
	
			//provides a more concise way to define plugins that have no dependencies besides TweenPlugin and TweenLite, wrapping common boilerplate stuff into one function (added in 1.9.0). You don't NEED to use this to define a plugin - the old way still works and can be useful in certain (rare) situations.
			_gsDefine.plugin = function(config) {
				if (!config || !config.propName || !config.init || !config.API) { throw "illegal plugin definition."; }
				var propName = config.propName,
					priority = config.priority || 0,
					overwriteProps = config.overwriteProps,
					map = {init:"_onInitTween", set:"setRatio", kill:"_kill", round:"_mod", mod:"_mod", initAll:"_onInitAllProps"},
					Plugin = _class("plugins." + propName.charAt(0).toUpperCase() + propName.substr(1) + "Plugin",
						function() {
							TweenPlugin.call(this, propName, priority);
							this._overwriteProps = overwriteProps || [];
						}, (config.global === true)),
					p = Plugin.prototype = new TweenPlugin(propName),
					prop;
				p.constructor = Plugin;
				Plugin.API = config.API;
				for (prop in map) {
					if (typeof(config[prop]) === "function") {
						p[map[prop]] = config[prop];
					}
				}
				Plugin.version = config.version;
				TweenPlugin.activate([Plugin]);
				return Plugin;
			};
	
	
			//now run through all the dependencies discovered and if any are missing, log that to the console as a warning. This is why it's best to have TweenLite load last - it can check all the dependencies for you.
			a = window._gsQueue;
			if (a) {
				for (i = 0; i < a.length; i++) {
					a[i]();
				}
				for (p in _defLookup) {
					if (!_defLookup[p].func) {
						window.console.log("GSAP encountered missing dependency: " + p);
					}
				}
			}
	
			_tickerActive = false; //ensures that the first official animation forces a ticker.tick() to update the time when it is instantiated
	
	})((typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window, "TweenMax");
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable no-undefined */
	
	var throttle = __webpack_require__(151);
	
	/**
	 * Debounce execution of a function. Debouncing, unlike throttling,
	 * guarantees that a function is only executed a single time, either at the
	 * very beginning of a series of calls, or at the very end.
	 *
	 * @param  {Number}   delay         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
	 * @param  {Boolean}  atBegin       Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
	 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
	 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
	 * @param  {Function} callback      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
	 *                                  to `callback` when the debounced-function is executed.
	 *
	 * @return {Function} A new, debounced function.
	 */
	module.exports = function ( delay, atBegin, callback ) {
		return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
	};


/***/ },
/* 151 */
/***/ function(module, exports) {

	/* eslint-disable no-undefined,no-param-reassign,no-shadow */
	
	/**
	 * Throttle execution of a function. Especially useful for rate limiting
	 * execution of handlers on events like resize and scroll.
	 *
	 * @param  {Number}    delay          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
	 * @param  {Boolean}   noTrailing     Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
	 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
	 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
	 *                                    the internal counter is reset)
	 * @param  {Function}  callback       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
	 *                                    to `callback` when the throttled-function is executed.
	 * @param  {Boolean}   debounceMode   If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
	 *                                    schedule `callback` to execute after `delay` ms.
	 *
	 * @return {Function}  A new, throttled, function.
	 */
	module.exports = function ( delay, noTrailing, callback, debounceMode ) {
	
		// After wrapper has stopped being called, this timeout ensures that
		// `callback` is executed at the proper times in `throttle` and `end`
		// debounce modes.
		var timeoutID;
	
		// Keep track of the last time `callback` was executed.
		var lastExec = 0;
	
		// `noTrailing` defaults to falsy.
		if ( typeof noTrailing !== 'boolean' ) {
			debounceMode = callback;
			callback = noTrailing;
			noTrailing = undefined;
		}
	
		// The `wrapper` function encapsulates all of the throttling / debouncing
		// functionality and when executed will limit the rate at which `callback`
		// is executed.
		function wrapper () {
	
			var self = this;
			var elapsed = Number(new Date()) - lastExec;
			var args = arguments;
	
			// Execute `callback` and update the `lastExec` timestamp.
			function exec () {
				lastExec = Number(new Date());
				callback.apply(self, args);
			}
	
			// If `debounceMode` is true (at begin) this is used to clear the flag
			// to allow future `callback` executions.
			function clear () {
				timeoutID = undefined;
			}
	
			if ( debounceMode && !timeoutID ) {
				// Since `wrapper` is being called for the first time and
				// `debounceMode` is true (at begin), execute `callback`.
				exec();
			}
	
			// Clear any existing timeout.
			if ( timeoutID ) {
				clearTimeout(timeoutID);
			}
	
			if ( debounceMode === undefined && elapsed > delay ) {
				// In throttle mode, if `delay` time has been exceeded, execute
				// `callback`.
				exec();
	
			} else if ( noTrailing !== true ) {
				// In trailing throttle mode, since `delay` time has not been
				// exceeded, schedule `callback` to execute `delay` ms after most
				// recent execution.
				//
				// If `debounceMode` is true (at begin), schedule `clear` to execute
				// after `delay` ms.
				//
				// If `debounceMode` is false (at end), schedule `callback` to
				// execute after `delay` ms.
				timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
			}
	
		}
	
		// Return the wrapper function.
		return wrapper;
	
	};


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	!function(n,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):n["v-click-outside"]=t()}(this,function(){"use strict";var n={instances:[],events:"ontouchstart"in window||navigator.msMaxTouchPoints>0?["touchstart","click"]:["click"]};n.onEvent=function(t){n.instances.forEach(function(n){var e=n.el,i=n.fn,o=n.mod;"touchstart"===t.type&&o.notouch||t.target===e||e.contains(t.target)||i&&i(t)})},n.bind=function(t,e){n.instances.push({el:t,fn:e.value,mod:e.modifiers}),1===n.instances.length&&n.events.forEach(function(t){return document.addEventListener(t,n.onEvent)})},n.update=function(t,e){if("function"!=typeof e.value)throw new Error("Argument must be a function");n.instances.find(function(n){return n.el===t}).fn=e.value},n.unbind=function(t){var e=n.instances.findIndex(function(n){return n.el===t});e>=0&&n.instances.splice(e,1),0===n.instances.length&&n.events.forEach(function(t){return document.removeEventListener(t,n.onEvent)})};var t="undefined"!=typeof window?n:{};return{install:function(n){n.directive("click-outside",t)},directive:t}});


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _util = __webpack_require__(9);
	
	var _validator = __webpack_require__(165);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _messages2 = __webpack_require__(154);
	
	var _rule = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 *  Encapsulates a validation schema.
	 *
	 *  @param descriptor An object declaring validation rules
	 *  for this schema.
	 */
	function Schema(descriptor) {
	  this.rules = null;
	  this._messages = _messages2.messages;
	  this.define(descriptor);
	}
	
	Schema.prototype = {
	  messages: function messages(_messages) {
	    if (_messages) {
	      this._messages = (0, _util.deepMerge)((0, _messages2.newMessages)(), _messages);
	    }
	    return this._messages;
	  },
	  define: function define(rules) {
	    if (!rules) {
	      throw new Error('Cannot configure a schema with no rules');
	    }
	    if ((typeof rules === 'undefined' ? 'undefined' : _typeof(rules)) !== 'object' || Array.isArray(rules)) {
	      throw new Error('Rules must be an object');
	    }
	    this.rules = {};
	    var z = void 0;
	    var item = void 0;
	    for (z in rules) {
	      if (rules.hasOwnProperty(z)) {
	        item = rules[z];
	        this.rules[z] = Array.isArray(item) ? item : [item];
	      }
	    }
	  },
	  validate: function validate(source_) {
	    var _this = this;
	
	    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var oc = arguments[2];
	
	    var source = source_;
	    var options = o;
	    var callback = oc;
	    if (typeof options === 'function') {
	      callback = options;
	      options = {};
	    }
	    if (!this.rules || Object.keys(this.rules).length === 0) {
	      if (callback) {
	        callback();
	      }
	      return;
	    }
	    function complete(results) {
	      var i = void 0;
	      var field = void 0;
	      var errors = [];
	      var fields = {};
	
	      function add(e) {
	        if (Array.isArray(e)) {
	          errors = errors.concat.apply(errors, e);
	        } else {
	          errors.push(e);
	        }
	      }
	
	      for (i = 0; i < results.length; i++) {
	        add(results[i]);
	      }
	      if (!errors.length) {
	        errors = null;
	        fields = null;
	      } else {
	        for (i = 0; i < errors.length; i++) {
	          field = errors[i].field;
	          fields[field] = fields[field] || [];
	          fields[field].push(errors[i]);
	        }
	      }
	      callback(errors, fields);
	    }
	
	    if (options.messages) {
	      var messages = this.messages();
	      if (messages === _messages2.messages) {
	        messages = (0, _messages2.newMessages)();
	      }
	      (0, _util.deepMerge)(messages, options.messages);
	      options.messages = messages;
	    } else {
	      options.messages = this.messages();
	    }
	
	    options.error = _rule.error;
	    var arr = void 0;
	    var value = void 0;
	    var series = {};
	    var keys = options.keys || Object.keys(this.rules);
	    keys.forEach(function (z) {
	      arr = _this.rules[z];
	      value = source[z];
	      arr.forEach(function (r) {
	        var rule = r;
	        if (typeof rule.transform === 'function') {
	          if (source === source_) {
	            source = _extends({}, source);
	          }
	          value = source[z] = rule.transform(value);
	        }
	        if (typeof rule === 'function') {
	          rule = {
	            validator: rule
	          };
	        } else {
	          rule = _extends({}, rule);
	        }
	        rule.validator = _this.getValidationMethod(rule);
	        rule.field = z;
	        rule.fullField = rule.fullField || z;
	        rule.type = _this.getType(rule);
	        if (!rule.validator) {
	          return;
	        }
	        series[z] = series[z] || [];
	        series[z].push({
	          rule: rule,
	          value: value,
	          source: source,
	          field: z
	        });
	      });
	    });
	    var errorFields = {};
	    (0, _util.asyncMap)(series, options, function (data, doIt) {
	      var rule = data.rule;
	      var deep = (rule.type === 'object' || rule.type === 'array') && (_typeof(rule.fields) === 'object' || _typeof(rule.defaultField) === 'object');
	      deep = deep && (rule.required || !rule.required && data.value);
	      rule.field = data.field;
	      function addFullfield(key, schema) {
	        return _extends({}, schema, {
	          fullField: rule.fullField + '.' + key
	        });
	      }
	
	      function cb() {
	        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	        var errors = e;
	        if (!Array.isArray(errors)) {
	          errors = [errors];
	        }
	        if (errors.length) {
	          (0, _util.warning)('async-validator:', errors);
	        }
	        if (errors.length && rule.message) {
	          errors = [].concat(rule.message);
	        }
	
	        errors = errors.map((0, _util.complementError)(rule));
	
	        if ((options.first || options.fieldFirst) && errors.length) {
	          errorFields[rule.field] = 1;
	          return doIt(errors);
	        }
	        if (!deep) {
	          doIt(errors);
	        } else {
	          // if rule is required but the target object
	          // does not exist fail at the rule level and don't
	          // go deeper
	          if (rule.required && !data.value) {
	            if (rule.message) {
	              errors = [].concat(rule.message).map((0, _util.complementError)(rule));
	            } else {
	              errors = [options.error(rule, (0, _util.format)(options.messages.required, rule.field))];
	            }
	            return doIt(errors);
	          }
	
	          var fieldsSchema = {};
	          if (rule.defaultField) {
	            for (var k in data.value) {
	              if (data.value.hasOwnProperty(k)) {
	                fieldsSchema[k] = rule.defaultField;
	              }
	            }
	          }
	          fieldsSchema = _extends({}, fieldsSchema, data.rule.fields);
	          for (var f in fieldsSchema) {
	            if (fieldsSchema.hasOwnProperty(f)) {
	              var fieldSchema = Array.isArray(fieldsSchema[f]) ? fieldsSchema[f] : [fieldsSchema[f]];
	              fieldsSchema[f] = fieldSchema.map(addFullfield.bind(null, f));
	            }
	          }
	          var schema = new Schema(fieldsSchema);
	          schema.messages(options.messages);
	          if (data.rule.options) {
	            data.rule.options.messages = options.messages;
	            data.rule.options.error = options.error;
	          }
	          schema.validate(data.value, data.rule.options || options, function (errs) {
	            doIt(errs && errs.length ? errors.concat(errs) : errs);
	          });
	        }
	      }
	
	      rule.validator(rule, data.value, cb, data.source, options);
	    }, function (results) {
	      complete(results);
	    });
	  },
	  getType: function getType(rule) {
	    if (rule.type === undefined && rule.pattern instanceof RegExp) {
	      rule.type = 'pattern';
	    }
	    if (typeof rule.validator !== 'function' && rule.type && !_validator2["default"].hasOwnProperty(rule.type)) {
	      throw new Error((0, _util.format)('Unknown rule type %s', rule.type));
	    }
	    return rule.type || 'string';
	  },
	  getValidationMethod: function getValidationMethod(rule) {
	    if (typeof rule.validator === 'function') {
	      return rule.validator;
	    }
	    var keys = Object.keys(rule);
	    var messageIndex = keys.indexOf('message');
	    if (messageIndex !== -1) {
	      keys.splice(messageIndex, 1);
	    }
	    if (keys.length === 1 && keys[0] === 'required') {
	      return _validator2["default"].required;
	    }
	    return _validator2["default"][this.getType(rule)] || false;
	  }
	};
	
	Schema.register = function register(type, validator) {
	  if (typeof validator !== 'function') {
	    throw new Error('Cannot register a validator by type, validator is not a function');
	  }
	  _validator2["default"][type] = validator;
	};
	
	Schema.messages = _messages2.messages;
	
	exports["default"] = Schema;
	module.exports = exports['default'];

/***/ },
/* 154 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.newMessages = newMessages;
	function newMessages() {
	  return {
	    "default": 'Validation error on field %s',
	    required: '%s is required',
	    "enum": '%s must be one of %s',
	    whitespace: '%s cannot be empty',
	    date: {
	      format: '%s date %s is invalid for format %s',
	      parse: '%s date could not be parsed, %s is invalid ',
	      invalid: '%s date %s is invalid'
	    },
	    types: {
	      string: '%s is not a %s',
	      method: '%s is not a %s (function)',
	      array: '%s is not an %s',
	      object: '%s is not an %s',
	      number: '%s is not a %s',
	      date: '%s is not a %s',
	      "boolean": '%s is not a %s',
	      integer: '%s is not an %s',
	      "float": '%s is not a %s',
	      regexp: '%s is not a valid %s',
	      email: '%s is not a valid %s',
	      url: '%s is not a valid %s',
	      hex: '%s is not a valid %s'
	    },
	    string: {
	      len: '%s must be exactly %s characters',
	      min: '%s must be at least %s characters',
	      max: '%s cannot be longer than %s characters',
	      range: '%s must be between %s and %s characters'
	    },
	    number: {
	      len: '%s must equal %s',
	      min: '%s cannot be less than %s',
	      max: '%s cannot be greater than %s',
	      range: '%s must be between %s and %s'
	    },
	    array: {
	      len: '%s must be exactly %s in length',
	      min: '%s cannot be less than %s in length',
	      max: '%s cannot be greater than %s in length',
	      range: '%s must be between %s and %s in length'
	    },
	    pattern: {
	      mismatch: '%s value %s does not match pattern %s'
	    },
	    clone: function clone() {
	      var cloned = JSON.parse(JSON.stringify(this));
	      cloned.clone = this.clone;
	      return cloned;
	    }
	  };
	}
	
	var messages = exports.messages = newMessages();

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(9);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj["default"] = obj; return newObj; } }
	
	var ENUM = 'enum';
	
	/**
	 *  Rule for validating a value exists in an enumerable list.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function enumerable(rule, value, source, errors, options) {
	  rule[ENUM] = Array.isArray(rule[ENUM]) ? rule[ENUM] : [];
	  if (rule[ENUM].indexOf(value) === -1) {
	    errors.push(util.format(options.messages[ENUM], rule.fullField, rule[ENUM].join(', ')));
	  }
	}
	
	exports["default"] = enumerable;
	module.exports = exports['default'];

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(9);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj["default"] = obj; return newObj; } }
	
	/**
	 *  Rule for validating a regular expression pattern.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function pattern(rule, value, source, errors, options) {
	  if (rule.pattern instanceof RegExp) {
	    if (!rule.pattern.test(value)) {
	      errors.push(util.format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
	    }
	  }
	}
	
	exports["default"] = pattern;
	module.exports = exports['default'];

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(9);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj["default"] = obj; return newObj; } }
	
	/**
	 *  Rule for validating minimum and maximum allowed values.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function range(rule, value, source, errors, options) {
	  var len = typeof rule.len === 'number';
	  var min = typeof rule.min === 'number';
	  var max = typeof rule.max === 'number';
	  var val = value;
	  var key = null;
	  var num = typeof value === 'number';
	  var str = typeof value === 'string';
	  var arr = Array.isArray(value);
	  if (num) {
	    key = 'number';
	  } else if (str) {
	    key = 'string';
	  } else if (arr) {
	    key = 'array';
	  }
	  // if the value is not of a supported type for range validation
	  // the validation rule rule should use the
	  // type property to also test for a particular type
	  if (!key) {
	    return false;
	  }
	  if (str || arr) {
	    val = value.length;
	  }
	  if (len) {
	    if (val !== rule.len) {
	      errors.push(util.format(options.messages[key].len, rule.fullField, rule.len));
	    }
	  } else if (min && !max && val < rule.min) {
	    errors.push(util.format(options.messages[key].min, rule.fullField, rule.min));
	  } else if (max && !min && val > rule.max) {
	    errors.push(util.format(options.messages[key].max, rule.fullField, rule.max));
	  } else if (min && max && (val < rule.min || val > rule.max)) {
	    errors.push(util.format(options.messages[key].range, rule.fullField, rule.min, rule.max));
	  }
	}
	
	exports["default"] = range;
	module.exports = exports['default'];

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _util = __webpack_require__(9);
	
	var util = _interopRequireWildcard(_util);
	
	var _required = __webpack_require__(106);
	
	var _required2 = _interopRequireDefault(_required);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj["default"] = obj; return newObj; } }
	
	/* eslint max-len:0 */
	
	var pattern = {
	  email: /^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/,
	  url: new RegExp('^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i'),
	  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
	};
	
	var types = {
	  integer: function integer(value) {
	    return types.number(value) && parseInt(value, 10) === value;
	  },
	  "float": function float(value) {
	    return types.number(value) && !types.integer(value);
	  },
	  array: function array(value) {
	    return Array.isArray(value);
	  },
	  regexp: function regexp(value) {
	    if (value instanceof RegExp) {
	      return true;
	    }
	    try {
	      return !!new RegExp(value);
	    } catch (e) {
	      return false;
	    }
	  },
	  date: function date(value) {
	    return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function';
	  },
	  number: function number(value) {
	    if (isNaN(value)) {
	      return false;
	    }
	    return typeof value === 'number';
	  },
	  object: function object(value) {
	    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && !types.array(value);
	  },
	  method: function method(value) {
	    return typeof value === 'function';
	  },
	  email: function email(value) {
	    return typeof value === 'string' && !!value.match(pattern.email);
	  },
	  url: function url(value) {
	    return typeof value === 'string' && !!value.match(pattern.url);
	  },
	  hex: function hex(value) {
	    return typeof value === 'string' && !!value.match(pattern.hex);
	  }
	};
	
	/**
	 *  Rule for validating the type of a value.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function type(rule, value, source, errors, options) {
	  if (rule.required && value === undefined) {
	    (0, _required2["default"])(rule, value, source, errors, options);
	    return;
	  }
	  var custom = ['integer', 'float', 'array', 'regexp', 'object', 'method', 'email', 'number', 'date', 'url', 'hex'];
	  var ruleType = rule.type;
	  if (custom.indexOf(ruleType) > -1) {
	    if (!types[ruleType](value)) {
	      errors.push(util.format(options.messages.types[ruleType], rule.fullField, rule.type));
	    }
	    // straight typeof check
	  } else if (ruleType && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== rule.type) {
	    errors.push(util.format(options.messages.types[ruleType], rule.fullField, rule.type));
	  }
	}
	
	exports["default"] = type;
	module.exports = exports['default'];

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(9);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj["default"] = obj; return newObj; } }
	
	/**
	 *  Rule for validating whitespace.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function whitespace(rule, value, source, errors, options) {
	  if (/^\s+$/.test(value) || value === '') {
	    errors.push(util.format(options.messages.whitespace, rule.fullField));
	  }
	}
	
	exports["default"] = whitespace;
	module.exports = exports['default'];

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(13);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 *  Validates an array.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function array(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value, 'array') && !rule.required) {
	      return callback();
	    }
	    _rule2["default"].required(rule, value, source, errors, options, 'array');
	    if (!(0, _util.isEmptyValue)(value, 'array')) {
	      _rule2["default"].type(rule, value, source, errors, options);
	      _rule2["default"].range(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports["default"] = array;
	module.exports = exports['default'];

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(9);
	
	var _rule = __webpack_require__(13);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 *  Validates a boolean.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function boolean(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2["default"].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2["default"].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports["default"] = boolean;
	module.exports = exports['default'];

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(13);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function date(rule, value, callback, source, options) {
	  // console.log('integer rule called %j', rule);
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  // console.log('validate on %s value', value);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2["default"].required(rule, value, source, errors, options);
	    if (!(0, _util.isEmptyValue)(value)) {
	      _rule2["default"].type(rule, value, source, errors, options);
	      if (value) {
	        _rule2["default"].range(rule, value.getTime(), source, errors, options);
	      }
	    }
	  }
	  callback(errors);
	}
	
	exports["default"] = date;
	module.exports = exports['default'];

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(13);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var ENUM = 'enum';
	
	/**
	 *  Validates an enumerable list.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function enumerable(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2["default"].required(rule, value, source, errors, options);
	    if (value) {
	      _rule2["default"][ENUM](rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports["default"] = enumerable;
	module.exports = exports['default'];

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(13);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 *  Validates a number is a floating point number.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function floatFn(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2["default"].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2["default"].type(rule, value, source, errors, options);
	      _rule2["default"].range(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports["default"] = floatFn;
	module.exports = exports['default'];

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  string: __webpack_require__(173),
	  method: __webpack_require__(167),
	  number: __webpack_require__(168),
	  "boolean": __webpack_require__(161),
	  regexp: __webpack_require__(171),
	  integer: __webpack_require__(166),
	  "float": __webpack_require__(164),
	  array: __webpack_require__(160),
	  object: __webpack_require__(169),
	  "enum": __webpack_require__(163),
	  pattern: __webpack_require__(170),
	  email: __webpack_require__(70),
	  url: __webpack_require__(70),
	  date: __webpack_require__(162),
	  hex: __webpack_require__(70),
	  required: __webpack_require__(172)
	};

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(13);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 *  Validates a number is an integer.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function integer(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2["default"].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2["default"].type(rule, value, source, errors, options);
	      _rule2["default"].range(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports["default"] = integer;
	module.exports = exports['default'];

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(13);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 *  Validates a function.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function method(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2["default"].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2["default"].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports["default"] = method;
	module.exports = exports['default'];

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(13);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 *  Validates a number.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function number(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2["default"].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2["default"].type(rule, value, source, errors, options);
	      _rule2["default"].range(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports["default"] = number;
	module.exports = exports['default'];

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(13);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 *  Validates an object.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function object(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2["default"].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2["default"].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports["default"] = object;
	module.exports = exports['default'];

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(13);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 *  Validates a regular expression pattern.
	 *
	 *  Performs validation when a rule only contains
	 *  a pattern property but is not declared as a string type.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function pattern(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) {
	      return callback();
	    }
	    _rule2["default"].required(rule, value, source, errors, options);
	    if (!(0, _util.isEmptyValue)(value, 'string')) {
	      _rule2["default"].pattern(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports["default"] = pattern;
	module.exports = exports['default'];

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(13);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 *  Validates the regular expression type.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function regexp(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2["default"].required(rule, value, source, errors, options);
	    if (!(0, _util.isEmptyValue)(value)) {
	      _rule2["default"].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports["default"] = regexp;
	module.exports = exports['default'];

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _rule = __webpack_require__(13);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function required(rule, value, callback, source, options) {
	  var errors = [];
	  var type = Array.isArray(value) ? 'array' : typeof value === 'undefined' ? 'undefined' : _typeof(value);
	  _rule2["default"].required(rule, value, source, errors, options, type);
	  callback(errors);
	}
	
	exports["default"] = required;
	module.exports = exports['default'];

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(13);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 *  Performs validation for string types.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function string(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) {
	      return callback();
	    }
	    _rule2["default"].required(rule, value, source, errors, options, 'string');
	    if (!(0, _util.isEmptyValue)(value, 'string')) {
	      _rule2["default"].type(rule, value, source, errors, options);
	      _rule2["default"].range(rule, value, source, errors, options);
	      _rule2["default"].pattern(rule, value, source, errors, options);
	      if (rule.whitespace === true) {
	        _rule2["default"].whitespace(rule, value, source, errors, options);
	      }
	    }
	  }
	  callback(errors);
	}
	
	exports["default"] = string;
	module.exports = exports['default'];

/***/ },
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(403);
	
	__webpack_require__(446);
	
	__webpack_require__(196);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(197), __esModule: true };

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(232);
	module.exports = __webpack_require__(29).RegExp.escape;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(223);
	module.exports = __webpack_require__(109).Object.assign;

/***/ },
/* 198 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(75);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(113)
	  , toLength  = __webpack_require__(219)
	  , toIndex   = __webpack_require__(218);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 201 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(198);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(75)
	  , document = __webpack_require__(74).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 204 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(74)
	  , core      = __webpack_require__(109)
	  , ctx       = __webpack_require__(202)
	  , hide      = __webpack_require__(207)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE]
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(a, b, c){
	        if(this instanceof C){
	          switch(arguments.length){
	            case 0: return new C;
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if(IS_PROTO){
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 206 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(210)
	  , createDesc = __webpack_require__(215);
	module.exports = __webpack_require__(72) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(72) && !__webpack_require__(73)(function(){
	  return Object.defineProperty(__webpack_require__(203)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(213)
	  , gOPS     = __webpack_require__(211)
	  , pIE      = __webpack_require__(214)
	  , toObject = __webpack_require__(220)
	  , IObject  = __webpack_require__(111)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(73)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(199)
	  , IE8_DOM_DEFINE = __webpack_require__(208)
	  , toPrimitive    = __webpack_require__(221)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(72) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 211 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(206)
	  , toIObject    = __webpack_require__(113)
	  , arrayIndexOf = __webpack_require__(200)(false)
	  , IE_PROTO     = __webpack_require__(216)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(212)
	  , enumBugKeys = __webpack_require__(204);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },
/* 214 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ },
/* 215 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(217)('keys')
	  , uid    = __webpack_require__(222);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(74)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(112)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(112)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(110);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(75);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 222 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(205);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(209)});

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(5)
	  , isArray  = __webpack_require__(84)
	  , SPECIES  = __webpack_require__(6)('species');
	
	module.exports = function(original){
	  var C;
	  if(isArray(original)){
	    C = original.constructor;
	    // cross-realm fallback
	    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
	    if(isObject(C)){
	      C = C[SPECIES];
	      if(C === null)C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(224);
	
	module.exports = function(original, length){
	  return new (speciesConstructor(original))(length);
	};

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject    = __webpack_require__(2)
	  , toPrimitive = __webpack_require__(28)
	  , NUMBER      = 'number';
	
	module.exports = function(hint){
	  if(hint !== 'string' && hint !== NUMBER && hint !== 'default')throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(42)
	  , gOPS    = __webpack_require__(66)
	  , pIE     = __webpack_require__(56);
	module.exports = function(it){
	  var result     = getKeys(it)
	    , getSymbols = gOPS.f;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = pIE.f
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
	  } return result;
	};

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(42)
	  , toIObject = __webpack_require__(19);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var path      = __webpack_require__(230)
	  , invoke    = __webpack_require__(62)
	  , aFunction = __webpack_require__(15);
	module.exports = function(/* ...pargs */){
	  var fn     = aFunction(this)
	    , length = arguments.length
	    , pargs  = Array(length)
	    , i      = 0
	    , _      = path._
	    , holder = false;
	  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
	  return function(/* ...args */){
	    var that = this
	      , aLen = arguments.length
	      , j = 0, k = 0, args;
	    if(!holder && !aLen)return invoke(fn, pargs, that);
	    args = pargs.slice();
	    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = arguments[k++];
	    while(aLen > k)args.push(arguments[k++]);
	    return invoke(fn, args, that);
	  };
	};

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(3);

/***/ },
/* 231 */
/***/ function(module, exports) {

	module.exports = function(regExp, replace){
	  var replacer = replace === Object(replace) ? function(part){
	    return replace[part];
	  } : replace;
	  return function(it){
	    return String(it).replace(regExp, replacer);
	  };
	};

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(1)
	  , $re     = __webpack_require__(231)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Array', {copyWithin: __webpack_require__(115)});
	
	__webpack_require__(48)('copyWithin');

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $every  = __webpack_require__(26)(4);
	
	$export($export.P + $export.F * !__webpack_require__(24)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */){
	    return $every(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Array', {fill: __webpack_require__(76)});
	
	__webpack_require__(48)('fill');

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $filter = __webpack_require__(26)(2);
	
	$export($export.P + $export.F * !__webpack_require__(24)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */){
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(1)
	  , $find   = __webpack_require__(26)(6)
	  , KEY     = 'findIndex'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(48)(KEY);

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(1)
	  , $find   = __webpack_require__(26)(5)
	  , KEY     = 'find'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(48)(KEY);

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export  = __webpack_require__(1)
	  , $forEach = __webpack_require__(26)(0)
	  , STRICT   = __webpack_require__(24)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */){
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx            = __webpack_require__(30)
	  , $export        = __webpack_require__(1)
	  , toObject       = __webpack_require__(12)
	  , call           = __webpack_require__(124)
	  , isArrayIter    = __webpack_require__(83)
	  , toLength       = __webpack_require__(10)
	  , createProperty = __webpack_require__(77)
	  , getIterFn      = __webpack_require__(100);
	
	$export($export.S + $export.F * !__webpack_require__(64)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(1)
	  , $indexOf      = __webpack_require__(58)(false)
	  , $native       = [].indexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(24)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /*, fromIndex = 0 */){
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Array', {isArray: __webpack_require__(84)});

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export   = __webpack_require__(1)
	  , toIObject = __webpack_require__(19)
	  , arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(55) != Object || !__webpack_require__(24)(arrayJoin)), 'Array', {
	  join: function join(separator){
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(1)
	  , toIObject     = __webpack_require__(19)
	  , toInteger     = __webpack_require__(37)
	  , toLength      = __webpack_require__(10)
	  , $native       = [].lastIndexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(24)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /*, fromIndex = @[*-1] */){
	    // convert -0 to +0
	    if(NEGATIVE_ZERO)return $native.apply(this, arguments) || 0;
	    var O      = toIObject(this)
	      , length = toLength(O.length)
	      , index  = length - 1;
	    if(arguments.length > 1)index = Math.min(index, toInteger(arguments[1]));
	    if(index < 0)index = length + index;
	    for(;index >= 0; index--)if(index in O)if(O[index] === searchElement)return index || 0;
	    return -1;
	  }
	});

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $map    = __webpack_require__(26)(1);
	
	$export($export.P + $export.F * !__webpack_require__(24)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */){
	    return $map(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export        = __webpack_require__(1)
	  , createProperty = __webpack_require__(77);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(4)(function(){
	  function F(){}
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */){
	    var index  = 0
	      , aLen   = arguments.length
	      , result = new (typeof this == 'function' ? this : Array)(aLen);
	    while(aLen > index)createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $reduce = __webpack_require__(117);
	
	$export($export.P + $export.F * !__webpack_require__(24)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $reduce = __webpack_require__(117);
	
	$export($export.P + $export.F * !__webpack_require__(24)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export    = __webpack_require__(1)
	  , html       = __webpack_require__(81)
	  , cof        = __webpack_require__(22)
	  , toIndex    = __webpack_require__(45)
	  , toLength   = __webpack_require__(10)
	  , arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(4)(function(){
	  if(html)arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end){
	    var len   = toLength(this.length)
	      , klass = cof(this);
	    end = end === undefined ? len : end;
	    if(klass == 'Array')return arraySlice.call(this, begin, end);
	    var start  = toIndex(begin, len)
	      , upTo   = toIndex(end, len)
	      , size   = toLength(upTo - start)
	      , cloned = Array(size)
	      , i      = 0;
	    for(; i < size; i++)cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $some   = __webpack_require__(26)(3);
	
	$export($export.P + $export.F * !__webpack_require__(24)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */){
	    return $some(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export   = __webpack_require__(1)
	  , aFunction = __webpack_require__(15)
	  , toObject  = __webpack_require__(12)
	  , fails     = __webpack_require__(4)
	  , $sort     = [].sort
	  , test      = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function(){
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function(){
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(24)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn){
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(44)('Array');

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Date', {now: function(){ return new Date().getTime(); }});

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(1)
	  , fails   = __webpack_require__(4)
	  , getTime = Date.prototype.getTime;
	
	var lz = function(num){
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (fails(function(){
	  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
	}) || !fails(function(){
	  new Date(NaN).toISOString();
	})), 'Date', {
	  toISOString: function toISOString(){
	    if(!isFinite(getTime.call(this)))throw RangeError('Invalid time value');
	    var d = this
	      , y = d.getUTCFullYear()
	      , m = d.getUTCMilliseconds()
	      , s = y < 0 ? '-' : y > 9999 ? '+' : '';
	    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	      '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	      'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	      ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	  }
	});

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export     = __webpack_require__(1)
	  , toObject    = __webpack_require__(12)
	  , toPrimitive = __webpack_require__(28);
	
	$export($export.P + $export.F * __webpack_require__(4)(function(){
	  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({toISOString: function(){ return 1; }}) !== 1;
	}), 'Date', {
	  toJSON: function toJSON(key){
	    var O  = toObject(this)
	      , pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(6)('toPrimitive')
	  , proto        = Date.prototype;
	
	if(!(TO_PRIMITIVE in proto))__webpack_require__(16)(proto, TO_PRIMITIVE, __webpack_require__(226));

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	var DateProto    = Date.prototype
	  , INVALID_DATE = 'Invalid Date'
	  , TO_STRING    = 'toString'
	  , $toString    = DateProto[TO_STRING]
	  , getTime      = DateProto.getTime;
	if(new Date(NaN) + '' != INVALID_DATE){
	  __webpack_require__(17)(DateProto, TO_STRING, function toString(){
	    var value = getTime.call(this);
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Function', {bind: __webpack_require__(118)});

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject       = __webpack_require__(5)
	  , getPrototypeOf = __webpack_require__(21)
	  , HAS_INSTANCE   = __webpack_require__(6)('hasInstance')
	  , FunctionProto  = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if(!(HAS_INSTANCE in FunctionProto))__webpack_require__(8).f(FunctionProto, HAS_INSTANCE, {value: function(O){
	  if(typeof this != 'function' || !isObject(O))return false;
	  if(!isObject(this.prototype))return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while(O = getPrototypeOf(O))if(this.prototype === O)return true;
	  return false;
	}});

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(8).f
	  , createDesc = __webpack_require__(36)
	  , has        = __webpack_require__(14)
	  , FProto     = Function.prototype
	  , nameRE     = /^\s*function ([^ (]*)/
	  , NAME       = 'name';
	
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(7) && dP(FProto, NAME, {
	  configurable: true,
	  get: function(){
	    try {
	      var that = this
	        , name = ('' + that).match(nameRE)[1];
	      has(that, NAME) || !isExtensible(that) || dP(that, NAME, createDesc(5, name));
	      return name;
	    } catch(e){
	      return '';
	    }
	  }
	});

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(1)
	  , log1p   = __webpack_require__(126)
	  , sqrt    = Math.sqrt
	  , $acosh  = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x){
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(1)
	  , $asinh  = Math.asinh;
	
	function asinh(x){
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0 
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(1)
	  , $atanh  = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0 
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x){
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(1)
	  , sign    = __webpack_require__(88);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x){
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x){
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(1)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x){
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(1)
	  , $expm1  = __webpack_require__(87);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export   = __webpack_require__(1)
	  , sign      = __webpack_require__(88)
	  , pow       = Math.pow
	  , EPSILON   = pow(2, -52)
	  , EPSILON32 = pow(2, -23)
	  , MAX32     = pow(2, 127) * (2 - EPSILON32)
	  , MIN32     = pow(2, -126);
	
	var roundTiesToEven = function(n){
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	
	$export($export.S, 'Math', {
	  fround: function fround(x){
	    var $abs  = Math.abs(x)
	      , $sign = sign(x)
	      , a, result;
	    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	    a = (1 + EPSILON32 / EPSILON) * $abs;
	    result = a - (a - $abs);
	    if(result > MAX32 || result != result)return $sign * Infinity;
	    return $sign * result;
	  }
	});

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(1)
	  , abs     = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
	    var sum  = 0
	      , i    = 0
	      , aLen = arguments.length
	      , larg = 0
	      , arg, div;
	    while(i < aLen){
	      arg = abs(arguments[i++]);
	      if(larg < arg){
	        div  = larg / arg;
	        sum  = sum * div * div + 1;
	        larg = arg;
	      } else if(arg > 0){
	        div  = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(1)
	  , $imul   = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(4)(function(){
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y){
	    var UINT16 = 0xffff
	      , xn = +x
	      , yn = +y
	      , xl = UINT16 & xn
	      , yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  log10: function log10(x){
	    return Math.log(x) / Math.LN10;
	  }
	});

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {log1p: __webpack_require__(126)});

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  log2: function log2(x){
	    return Math.log(x) / Math.LN2;
	  }
	});

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {sign: __webpack_require__(88)});

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(1)
	  , expm1   = __webpack_require__(87)
	  , exp     = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(4)(function(){
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x){
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(1)
	  , expm1   = __webpack_require__(87)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x){
	    var a = expm1(x = +x)
	      , b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it){
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(3)
	  , has               = __webpack_require__(14)
	  , cof               = __webpack_require__(22)
	  , inheritIfRequired = __webpack_require__(82)
	  , toPrimitive       = __webpack_require__(28)
	  , fails             = __webpack_require__(4)
	  , gOPN              = __webpack_require__(41).f
	  , gOPD              = __webpack_require__(20).f
	  , dP                = __webpack_require__(8).f
	  , $trim             = __webpack_require__(52).trim
	  , NUMBER            = 'Number'
	  , $Number           = global[NUMBER]
	  , Base              = $Number
	  , proto             = $Number.prototype
	  // Opera ~12 has broken Object#toString
	  , BROKEN_COF        = cof(__webpack_require__(40)(proto)) == NUMBER
	  , TRIM              = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function(argument){
	  var it = toPrimitive(argument, false);
	  if(typeof it == 'string' && it.length > 2){
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0)
	      , third, radix, maxCode;
	    if(first === 43 || first === 45){
	      third = it.charCodeAt(2);
	      if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if(first === 48){
	      switch(it.charCodeAt(1)){
	        case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default : return +it;
	      }
	      for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if(code < 48 || code > maxCode)return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
	  $Number = function Number(value){
	    var it = arguments.length < 1 ? 0 : value
	      , that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for(var keys = __webpack_require__(7) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++){
	    if(has(Base, key = keys[j]) && !has($Number, key)){
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(17)(global, NUMBER, $Number);
	}

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export   = __webpack_require__(1)
	  , _isFinite = __webpack_require__(3).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it){
	    return typeof it == 'number' && _isFinite(it);
	  }
	});

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {isInteger: __webpack_require__(123)});

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number){
	    return number != number;
	  }
	});

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export   = __webpack_require__(1)
	  , isInteger = __webpack_require__(123)
	  , abs       = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number){
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(1)
	  , $parseFloat = __webpack_require__(133);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', {parseFloat: $parseFloat});

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(1)
	  , $parseInt = __webpack_require__(134);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', {parseInt: $parseInt});

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(1)
	  , toInteger    = __webpack_require__(37)
	  , aNumberValue = __webpack_require__(114)
	  , repeat       = __webpack_require__(95)
	  , $toFixed     = 1..toFixed
	  , floor        = Math.floor
	  , data         = [0, 0, 0, 0, 0, 0]
	  , ERROR        = 'Number.toFixed: incorrect invocation!'
	  , ZERO         = '0';
	
	var multiply = function(n, c){
	  var i  = -1
	    , c2 = c;
	  while(++i < 6){
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function(n){
	  var i = 6
	    , c = 0;
	  while(--i >= 0){
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function(){
	  var i = 6
	    , s = '';
	  while(--i >= 0){
	    if(s !== '' || i === 0 || data[i] !== 0){
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function(x, n, acc){
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function(x){
	  var n  = 0
	    , x2 = x;
	  while(x2 >= 4096){
	    n += 12;
	    x2 /= 4096;
	  }
	  while(x2 >= 2){
	    n  += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128..toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(4)(function(){
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits){
	    var x = aNumberValue(this, ERROR)
	      , f = toInteger(fractionDigits)
	      , s = ''
	      , m = ZERO
	      , e, z, j, k;
	    if(f < 0 || f > 20)throw RangeError(ERROR);
	    if(x != x)return 'NaN';
	    if(x <= -1e21 || x >= 1e21)return String(x);
	    if(x < 0){
	      s = '-';
	      x = -x;
	    }
	    if(x > 1e-21){
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if(e > 0){
	        multiply(0, z);
	        j = f;
	        while(j >= 7){
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while(j >= 23){
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if(f > 0){
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(1)
	  , $fails       = __webpack_require__(4)
	  , aNumberValue = __webpack_require__(114)
	  , $toPrecision = 1..toPrecision;
	
	$export($export.P + $export.F * ($fails(function(){
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function(){
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision){
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision); 
	  }
	});

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(1);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(127)});

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1)
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', {create: __webpack_require__(40)});

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(7), 'Object', {defineProperties: __webpack_require__(128)});

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(7), 'Object', {defineProperty: __webpack_require__(8).f});

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(5)
	  , meta     = __webpack_require__(35).onFreeze;
	
	__webpack_require__(27)('freeze', function($freeze){
	  return function freeze(it){
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject                 = __webpack_require__(19)
	  , $getOwnPropertyDescriptor = __webpack_require__(20).f;
	
	__webpack_require__(27)('getOwnPropertyDescriptor', function(){
	  return function getOwnPropertyDescriptor(it, key){
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(27)('getOwnPropertyNames', function(){
	  return __webpack_require__(129).f;
	});

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject        = __webpack_require__(12)
	  , $getPrototypeOf = __webpack_require__(21);
	
	__webpack_require__(27)('getPrototypeOf', function(){
	  return function getPrototypeOf(it){
	    return $getPrototypeOf(toObject(it));
	  };
	});

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(5);
	
	__webpack_require__(27)('isExtensible', function($isExtensible){
	  return function isExtensible(it){
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(5);
	
	__webpack_require__(27)('isFrozen', function($isFrozen){
	  return function isFrozen(it){
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(5);
	
	__webpack_require__(27)('isSealed', function($isSealed){
	  return function isSealed(it){
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(1);
	$export($export.S, 'Object', {is: __webpack_require__(135)});

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(12)
	  , $keys    = __webpack_require__(42);
	
	__webpack_require__(27)('keys', function(){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(5)
	  , meta     = __webpack_require__(35).onFreeze;
	
	__webpack_require__(27)('preventExtensions', function($preventExtensions){
	  return function preventExtensions(it){
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(5)
	  , meta     = __webpack_require__(35).onFreeze;
	
	__webpack_require__(27)('seal', function($seal){
	  return function seal(it){
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(1);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(90).set});

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(54)
	  , test    = {};
	test[__webpack_require__(6)('toStringTag')] = 'z';
	if(test + '' != '[object z]'){
	  __webpack_require__(17)(Object.prototype, 'toString', function toString(){
	    return '[object ' + classof(this) + ']';
	  }, true);
	}

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(1)
	  , $parseFloat = __webpack_require__(133);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), {parseFloat: $parseFloat});

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(1)
	  , $parseInt = __webpack_require__(134);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), {parseInt: $parseInt});

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY            = __webpack_require__(39)
	  , global             = __webpack_require__(3)
	  , ctx                = __webpack_require__(30)
	  , classof            = __webpack_require__(54)
	  , $export            = __webpack_require__(1)
	  , isObject           = __webpack_require__(5)
	  , aFunction          = __webpack_require__(15)
	  , anInstance         = __webpack_require__(38)
	  , forOf              = __webpack_require__(49)
	  , speciesConstructor = __webpack_require__(92)
	  , task               = __webpack_require__(97).set
	  , microtask          = __webpack_require__(89)()
	  , PROMISE            = 'Promise'
	  , TypeError          = global.TypeError
	  , process            = global.process
	  , $Promise           = global[PROMISE]
	  , process            = global.process
	  , isNode             = classof(process) == 'process'
	  , empty              = function(){ /* empty */ }
	  , Internal, GenericPromiseCapability, Wrapper;
	
	var USE_NATIVE = !!function(){
	  try {
	    // correct subclassing with @@species support
	    var promise     = $Promise.resolve(1)
	      , FakePromise = (promise.constructor = {})[__webpack_require__(6)('species')] = function(exec){ exec(empty, empty); };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch(e){ /* empty */ }
	}();
	
	// helpers
	var sameConstructor = function(a, b){
	  // with library wrapper special case
	  return a === b || a === $Promise && b === Wrapper;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var newPromiseCapability = function(C){
	  return sameConstructor($Promise, C)
	    ? new PromiseCapability(C)
	    : new GenericPromiseCapability(C);
	};
	var PromiseCapability = GenericPromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject  = aFunction(reject);
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(promise, isReject){
	  if(promise._n)return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function(){
	    var value = promise._v
	      , ok    = promise._s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , domain  = reaction.domain
	        , result, then;
	      try {
	        if(handler){
	          if(!ok){
	            if(promise._h == 2)onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if(handler === true)result = value;
	          else {
	            if(domain)domain.enter();
	            result = handler(value);
	            if(domain)domain.exit();
	          }
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if(isReject && !promise._h)onUnhandled(promise);
	  });
	};
	var onUnhandled = function(promise){
	  task.call(global, function(){
	    var value = promise._v
	      , abrupt, handler, console;
	    if(isUnhandled(promise)){
	      abrupt = perform(function(){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if(abrupt)throw abrupt.error;
	  });
	};
	var isUnhandled = function(promise){
	  if(promise._h == 1)return false;
	  var chain = promise._a || promise._c
	    , i     = 0
	    , reaction;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var onHandleUnhandled = function(promise){
	  task.call(global, function(){
	    var handler;
	    if(isNode){
	      process.emit('rejectionHandled', promise);
	    } else if(handler = global.onrejectionhandled){
	      handler({promise: promise, reason: promise._v});
	    }
	  });
	};
	var $reject = function(value){
	  var promise = this;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if(!promise._a)promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function(value){
	  var promise = this
	    , then;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if(promise === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      microtask(function(){
	        var wrapper = {_w: promise, _d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch(e){
	    $reject.call({_w: promise, _d: false}, e); // wrap
	  }
	};
	
	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor){
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch(err){
	      $reject.call(this, err);
	    }
	  };
	  Internal = function Promise(executor){
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(43)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail   = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if(this._a)this._a.push(reaction);
	      if(this._s)notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	  PromiseCapability = function(){
	    var promise  = new Internal;
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject  = ctx($reject, promise, 1);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
	__webpack_require__(51)($Promise, PROMISE);
	__webpack_require__(44)(PROMISE);
	Wrapper = __webpack_require__(29)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = newPromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
	    var capability = newPromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(64)(function(iter){
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      var values    = []
	        , index     = 0
	        , remaining = 1;
	      forOf(iterable, false, function(promise){
	        var $index        = index++
	          , alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled  = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export   = __webpack_require__(1)
	  , aFunction = __webpack_require__(15)
	  , anObject  = __webpack_require__(2)
	  , rApply    = (__webpack_require__(3).Reflect || {}).apply
	  , fApply    = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(4)(function(){
	  rApply(function(){});
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList){
	    var T = aFunction(target)
	      , L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export    = __webpack_require__(1)
	  , create     = __webpack_require__(40)
	  , aFunction  = __webpack_require__(15)
	  , anObject   = __webpack_require__(2)
	  , isObject   = __webpack_require__(5)
	  , fails      = __webpack_require__(4)
	  , bind       = __webpack_require__(118)
	  , rConstruct = (__webpack_require__(3).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function(){
	  function F(){}
	  return !(rConstruct(function(){}, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function(){
	  rConstruct(function(){});
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /*, newTarget*/){
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if(ARGS_BUG && !NEW_TARGET_BUG)return rConstruct(Target, args, newTarget);
	    if(Target == newTarget){
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch(args.length){
	        case 0: return new Target;
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args));
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto    = newTarget.prototype
	      , instance = create(isObject(proto) ? proto : Object.prototype)
	      , result   = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP          = __webpack_require__(8)
	  , $export     = __webpack_require__(1)
	  , anObject    = __webpack_require__(2)
	  , toPrimitive = __webpack_require__(28);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(4)(function(){
	  Reflect.defineProperty(dP.f({}, 1, {value: 1}), 1, {value: 2});
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes){
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export  = __webpack_require__(1)
	  , gOPD     = __webpack_require__(20).f
	  , anObject = __webpack_require__(2);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey){
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export  = __webpack_require__(1)
	  , anObject = __webpack_require__(2);
	var Enumerate = function(iterated){
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = []       // keys
	    , key;
	  for(key in iterated)keys.push(key);
	};
	__webpack_require__(85)(Enumerate, 'Object', function(){
	  var that = this
	    , keys = that._k
	    , key;
	  do {
	    if(that._i >= keys.length)return {value: undefined, done: true};
	  } while(!((key = keys[that._i++]) in that._t));
	  return {value: key, done: false};
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target){
	    return new Enumerate(target);
	  }
	});

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD     = __webpack_require__(20)
	  , $export  = __webpack_require__(1)
	  , anObject = __webpack_require__(2);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export  = __webpack_require__(1)
	  , getProto = __webpack_require__(21)
	  , anObject = __webpack_require__(2);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target){
	    return getProto(anObject(target));
	  }
	});

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD           = __webpack_require__(20)
	  , getPrototypeOf = __webpack_require__(21)
	  , has            = __webpack_require__(14)
	  , $export        = __webpack_require__(1)
	  , isObject       = __webpack_require__(5)
	  , anObject       = __webpack_require__(2);
	
	function get(target, propertyKey/*, receiver*/){
	  var receiver = arguments.length < 3 ? target : arguments[2]
	    , desc, proto;
	  if(anObject(target) === receiver)return target[propertyKey];
	  if(desc = gOPD.f(target, propertyKey))return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if(isObject(proto = getPrototypeOf(target)))return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', {get: get});

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey){
	    return propertyKey in target;
	  }
	});

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export       = __webpack_require__(1)
	  , anObject      = __webpack_require__(2)
	  , $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target){
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Reflect', {ownKeys: __webpack_require__(132)});

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export            = __webpack_require__(1)
	  , anObject           = __webpack_require__(2)
	  , $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target){
	    anObject(target);
	    try {
	      if($preventExtensions)$preventExtensions(target);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export  = __webpack_require__(1)
	  , setProto = __webpack_require__(90);
	
	if(setProto)$export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto){
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP             = __webpack_require__(8)
	  , gOPD           = __webpack_require__(20)
	  , getPrototypeOf = __webpack_require__(21)
	  , has            = __webpack_require__(14)
	  , $export        = __webpack_require__(1)
	  , createDesc     = __webpack_require__(36)
	  , anObject       = __webpack_require__(2)
	  , isObject       = __webpack_require__(5);
	
	function set(target, propertyKey, V/*, receiver*/){
	  var receiver = arguments.length < 4 ? target : arguments[3]
	    , ownDesc  = gOPD.f(anObject(target), propertyKey)
	    , existingDescriptor, proto;
	  if(!ownDesc){
	    if(isObject(proto = getPrototypeOf(target))){
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if(has(ownDesc, 'value')){
	    if(ownDesc.writable === false || !isObject(receiver))return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', {set: set});

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	var global            = __webpack_require__(3)
	  , inheritIfRequired = __webpack_require__(82)
	  , dP                = __webpack_require__(8).f
	  , gOPN              = __webpack_require__(41).f
	  , isRegExp          = __webpack_require__(63)
	  , $flags            = __webpack_require__(61)
	  , $RegExp           = global.RegExp
	  , Base              = $RegExp
	  , proto             = $RegExp.prototype
	  , re1               = /a/g
	  , re2               = /a/g
	  // "new" creates a new object, old webkit buggy here
	  , CORRECT_NEW       = new $RegExp(re1) !== re1;
	
	if(__webpack_require__(7) && (!CORRECT_NEW || __webpack_require__(4)(function(){
	  re2[__webpack_require__(6)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))){
	  $RegExp = function RegExp(p, f){
	    var tiRE = this instanceof $RegExp
	      , piRE = isRegExp(p)
	      , fiU  = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function(key){
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function(){ return Base[key]; },
	      set: function(it){ Base[key] = it; }
	    });
	  };
	  for(var keys = gOPN(Base), i = 0; keys.length > i; )proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(17)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(44)('RegExp');

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(60)('match', 1, function(defined, MATCH, $match){
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(60)('replace', 2, function(defined, REPLACE, $replace){
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue){
	    'use strict';
	    var O  = defined(this)
	      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(60)('search', 1, function(defined, SEARCH, $search){
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(60)('split', 2, function(defined, SPLIT, $split){
	  'use strict';
	  var isRegExp   = __webpack_require__(63)
	    , _split     = $split
	    , $push      = [].push
	    , $SPLIT     = 'split'
	    , LENGTH     = 'length'
	    , LAST_INDEX = 'lastIndex';
	  if(
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ){
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function(separator, limit){
	      var string = String(this);
	      if(separator === undefined && limit === 0)return [];
	      // If `separator` is not a regex, use native split
	      if(!isRegExp(separator))return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if(!NPCG)separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while(match = separatorCopy.exec(string)){
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if(lastIndex > lastLastIndex){
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          if(!NPCG && match[LENGTH] > 1)match[0].replace(separator2, function(){
	            for(i = 1; i < arguments[LENGTH] - 2; i++)if(arguments[i] === undefined)match[i] = undefined;
	          });
	          if(match[LENGTH] > 1 && match.index < string[LENGTH])$push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if(output[LENGTH] >= splitLimit)break;
	        }
	        if(separatorCopy[LAST_INDEX] === match.index)separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if(lastLastIndex === string[LENGTH]){
	        if(lastLength || !separatorCopy.test(''))output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if('0'[$SPLIT](undefined, 0)[LENGTH]){
	    $split = function(separator, limit){
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit){
	    var O  = defined(this)
	      , fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(139);
	var anObject    = __webpack_require__(2)
	  , $flags      = __webpack_require__(61)
	  , DESCRIPTORS = __webpack_require__(7)
	  , TO_STRING   = 'toString'
	  , $toString   = /./[TO_STRING];
	
	var define = function(fn){
	  __webpack_require__(17)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if(__webpack_require__(4)(function(){ return $toString.call({source: 'a', flags: 'b'}) != '/a/b'; })){
	  define(function toString(){
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if($toString.name != TO_STRING){
	  define(function toString(){
	    return $toString.call(this);
	  });
	}

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(18)('anchor', function(createHTML){
	  return function anchor(name){
	    return createHTML(this, 'a', 'name', name);
	  }
	});

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(18)('big', function(createHTML){
	  return function big(){
	    return createHTML(this, 'big', '', '');
	  }
	});

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(18)('blink', function(createHTML){
	  return function blink(){
	    return createHTML(this, 'blink', '', '');
	  }
	});

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(18)('bold', function(createHTML){
	  return function bold(){
	    return createHTML(this, 'b', '', '');
	  }
	});

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $at     = __webpack_require__(93)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export   = __webpack_require__(1)
	  , toLength  = __webpack_require__(10)
	  , context   = __webpack_require__(94)
	  , ENDS_WITH = 'endsWith'
	  , $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(80)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /*, endPosition = @length */){
	    var that = context(this, searchString, ENDS_WITH)
	      , endPosition = arguments.length > 1 ? arguments[1] : undefined
	      , len    = toLength(that.length)
	      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
	      , search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(18)('fixed', function(createHTML){
	  return function fixed(){
	    return createHTML(this, 'tt', '', '');
	  }
	});

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(18)('fontcolor', function(createHTML){
	  return function fontcolor(color){
	    return createHTML(this, 'font', 'color', color);
	  }
	});

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(18)('fontsize', function(createHTML){
	  return function fontsize(size){
	    return createHTML(this, 'font', 'size', size);
	  }
	});

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	var $export        = __webpack_require__(1)
	  , toIndex        = __webpack_require__(45)
	  , fromCharCode   = String.fromCharCode
	  , $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
	    var res  = []
	      , aLen = arguments.length
	      , i    = 0
	      , code;
	    while(aLen > i){
	      code = +arguments[i++];
	      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export  = __webpack_require__(1)
	  , context  = __webpack_require__(94)
	  , INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(80)(INCLUDES), 'String', {
	  includes: function includes(searchString /*, position = 0 */){
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(18)('italics', function(createHTML){
	  return function italics(){
	    return createHTML(this, 'i', '', '');
	  }
	});

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(93)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(86)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(18)('link', function(createHTML){
	  return function link(url){
	    return createHTML(this, 'a', 'href', url);
	  }
	});

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(1)
	  , toIObject = __webpack_require__(19)
	  , toLength  = __webpack_require__(10);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite){
	    var tpl  = toIObject(callSite.raw)
	      , len  = toLength(tpl.length)
	      , aLen = arguments.length
	      , res  = []
	      , i    = 0;
	    while(len > i){
	      res.push(String(tpl[i++]));
	      if(i < aLen)res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(95)
	});

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(18)('small', function(createHTML){
	  return function small(){
	    return createHTML(this, 'small', '', '');
	  }
	});

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export     = __webpack_require__(1)
	  , toLength    = __webpack_require__(10)
	  , context     = __webpack_require__(94)
	  , STARTS_WITH = 'startsWith'
	  , $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(80)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /*, position = 0 */){
	    var that   = context(this, searchString, STARTS_WITH)
	      , index  = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length))
	      , search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(18)('strike', function(createHTML){
	  return function strike(){
	    return createHTML(this, 'strike', '', '');
	  }
	});

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(18)('sub', function(createHTML){
	  return function sub(){
	    return createHTML(this, 'sub', '', '');
	  }
	});

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(18)('sup', function(createHTML){
	  return function sup(){
	    return createHTML(this, 'sup', '', '');
	  }
	});

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(52)('trim', function($trim){
	  return function trim(){
	    return $trim(this, 3);
	  };
	});

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global         = __webpack_require__(3)
	  , has            = __webpack_require__(14)
	  , DESCRIPTORS    = __webpack_require__(7)
	  , $export        = __webpack_require__(1)
	  , redefine       = __webpack_require__(17)
	  , META           = __webpack_require__(35).KEY
	  , $fails         = __webpack_require__(4)
	  , shared         = __webpack_require__(67)
	  , setToStringTag = __webpack_require__(51)
	  , uid            = __webpack_require__(46)
	  , wks            = __webpack_require__(6)
	  , wksExt         = __webpack_require__(137)
	  , wksDefine      = __webpack_require__(99)
	  , keyOf          = __webpack_require__(228)
	  , enumKeys       = __webpack_require__(227)
	  , isArray        = __webpack_require__(84)
	  , anObject       = __webpack_require__(2)
	  , toIObject      = __webpack_require__(19)
	  , toPrimitive    = __webpack_require__(28)
	  , createDesc     = __webpack_require__(36)
	  , _create        = __webpack_require__(40)
	  , gOPNExt        = __webpack_require__(129)
	  , $GOPD          = __webpack_require__(20)
	  , $DP            = __webpack_require__(8)
	  , $keys          = __webpack_require__(42)
	  , gOPD           = $GOPD.f
	  , dP             = $DP.f
	  , gOPN           = gOPNExt.f
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , PROTOTYPE      = 'prototype'
	  , HIDDEN         = wks('_hidden')
	  , TO_PRIMITIVE   = wks('toPrimitive')
	  , isEnum         = {}.propertyIsEnumerable
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , OPSymbols      = shared('op-symbols')
	  , ObjectProto    = Object[PROTOTYPE]
	  , USE_NATIVE     = typeof $Symbol == 'function'
	  , QObject        = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(dP({}, 'a', {
	    get: function(){ return dP(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = gOPD(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  dP(it, key, D);
	  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
	  return typeof it == 'symbol';
	} : function(it){
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if(has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  it  = toIObject(it);
	  key = toPrimitive(key, true);
	  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
	  var D = gOPD(it, key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = gOPN(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var IS_OP  = it === ObjectProto
	    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function(value){
	      if(this === ObjectProto)$set.call(OPSymbols, value);
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f   = $defineProperty;
	  __webpack_require__(41).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(56).f  = $propertyIsEnumerable;
	  __webpack_require__(66).f = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(39)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function(name){
	    return wrap(wks(name));
	  }
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});
	
	for(var symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);
	
	for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    if(isSymbol(key))return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it){
	    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	    var args = [it]
	      , i    = 1
	      , replacer, $replacer;
	    while(arguments.length > i)args.push(arguments[i++]);
	    replacer = args[1];
	    if(typeof replacer == 'function')$replacer = replacer;
	    if($replacer || !isArray(replacer))replacer = function(key, value){
	      if($replacer)value = $replacer.call(this, key, value);
	      if(!isSymbol(value))return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(16)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(1)
	  , $typed       = __webpack_require__(68)
	  , buffer       = __webpack_require__(98)
	  , anObject     = __webpack_require__(2)
	  , toIndex      = __webpack_require__(45)
	  , toLength     = __webpack_require__(10)
	  , isObject     = __webpack_require__(5)
	  , ArrayBuffer  = __webpack_require__(3).ArrayBuffer
	  , speciesConstructor = __webpack_require__(92)
	  , $ArrayBuffer = buffer.ArrayBuffer
	  , $DataView    = buffer.DataView
	  , $isView      = $typed.ABV && ArrayBuffer.isView
	  , $slice       = $ArrayBuffer.prototype.slice
	  , VIEW         = $typed.VIEW
	  , ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), {ArrayBuffer: $ArrayBuffer});
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it){
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(4)(function(){
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end){
	    if($slice !== undefined && end === undefined)return $slice.call(anObject(this), start); // FF fix
	    var len    = anObject(this).byteLength
	      , first  = toIndex(start, len)
	      , final  = toIndex(end === undefined ? len : end, len)
	      , result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first))
	      , viewS  = new $DataView(this)
	      , viewT  = new $DataView(result)
	      , index  = 0;
	    while(first < final){
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(44)(ARRAY_BUFFER);

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	$export($export.G + $export.W + $export.F * !__webpack_require__(68).ABV, {
	  DataView: __webpack_require__(98).DataView
	});

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(32)('Float32', 4, function(init){
	  return function Float32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(32)('Float64', 8, function(init){
	  return function Float64Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(32)('Int16', 2, function(init){
	  return function Int16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(32)('Int32', 4, function(init){
	  return function Int32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(32)('Int8', 1, function(init){
	  return function Int8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(32)('Uint16', 2, function(init){
	  return function Uint16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(32)('Uint32', 4, function(init){
	  return function Uint32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(32)('Uint8', 1, function(init){
	  return function Uint8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(32)('Uint8', 1, function(init){
	  return function Uint8ClampedArray(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	}, true);

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(121);
	
	// 23.4 WeakSet Objects
	__webpack_require__(59)('WeakSet', function(get){
	  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value){
	    return weak.def(this, value, true);
	  }
	}, weak, false, true);

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export   = __webpack_require__(1)
	  , $includes = __webpack_require__(58)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /*, fromIndex = 0 */){
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(48)('includes');

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export   = __webpack_require__(1)
	  , microtask = __webpack_require__(89)()
	  , process   = __webpack_require__(3).process
	  , isNode    = __webpack_require__(22)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn){
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(1)
	  , cof     = __webpack_require__(22);
	
	$export($export.S, 'Error', {
	  isError: function isError(it){
	    return cof(it) === 'Error';
	  }
	});

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(1);
	
	$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(120)('Map')});

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >> 16
	      , v1 = $v >> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >>> 16
	      , v1 = $v >>> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(1)
	  , toObject        = __webpack_require__(12)
	  , aFunction       = __webpack_require__(15)
	  , $defineProperty = __webpack_require__(8);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(7) && $export($export.P + __webpack_require__(65), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter){
	    $defineProperty.f(toObject(this), P, {get: aFunction(getter), enumerable: true, configurable: true});
	  }
	});

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(1)
	  , toObject        = __webpack_require__(12)
	  , aFunction       = __webpack_require__(15)
	  , $defineProperty = __webpack_require__(8);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(7) && $export($export.P + __webpack_require__(65), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter){
	    $defineProperty.f(toObject(this), P, {set: aFunction(setter), enumerable: true, configurable: true});
	  }
	});

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export  = __webpack_require__(1)
	  , $entries = __webpack_require__(131)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it){
	    return $entries(it);
	  }
	});

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export        = __webpack_require__(1)
	  , ownKeys        = __webpack_require__(132)
	  , toIObject      = __webpack_require__(19)
	  , gOPD           = __webpack_require__(20)
	  , createProperty = __webpack_require__(77);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
	    var O       = toIObject(object)
	      , getDesc = gOPD.f
	      , keys    = ownKeys(O)
	      , result  = {}
	      , i       = 0
	      , key;
	    while(keys.length > i)createProperty(result, key = keys[i++], getDesc(O, key));
	    return result;
	  }
	});

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(1)
	  , toObject                 = __webpack_require__(12)
	  , toPrimitive              = __webpack_require__(28)
	  , getPrototypeOf           = __webpack_require__(21)
	  , getOwnPropertyDescriptor = __webpack_require__(20).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(7) && $export($export.P + __webpack_require__(65), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.get;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(1)
	  , toObject                 = __webpack_require__(12)
	  , toPrimitive              = __webpack_require__(28)
	  , getPrototypeOf           = __webpack_require__(21)
	  , getOwnPropertyDescriptor = __webpack_require__(20).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(7) && $export($export.P + __webpack_require__(65), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.set;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(1)
	  , $values = __webpack_require__(131)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it){
	    return $values(it);
	  }
	});

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export     = __webpack_require__(1)
	  , global      = __webpack_require__(3)
	  , core        = __webpack_require__(29)
	  , microtask   = __webpack_require__(89)()
	  , OBSERVABLE  = __webpack_require__(6)('observable')
	  , aFunction   = __webpack_require__(15)
	  , anObject    = __webpack_require__(2)
	  , anInstance  = __webpack_require__(38)
	  , redefineAll = __webpack_require__(43)
	  , hide        = __webpack_require__(16)
	  , forOf       = __webpack_require__(49)
	  , RETURN      = forOf.RETURN;
	
	var getMethod = function(fn){
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function(subscription){
	  var cleanup = subscription._c;
	  if(cleanup){
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function(subscription){
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function(subscription){
	  if(!subscriptionClosed(subscription)){
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function(observer, subscriber){
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup      = subscriber(observer)
	      , subscription = cleanup;
	    if(cleanup != null){
	      if(typeof cleanup.unsubscribe === 'function')cleanup = function(){ subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch(e){
	    observer.error(e);
	    return;
	  } if(subscriptionClosed(this))cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe(){ closeSubscription(this); }
	});
	
	var SubscriptionObserver = function(subscription){
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if(m)return m.call(observer, value);
	      } catch(e){
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value){
	    var subscription = this._s;
	    if(subscriptionClosed(subscription))throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if(!m)throw value;
	      value = m.call(observer, value);
	    } catch(e){
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch(e){
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber){
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer){
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn){
	    var that = this;
	    return new (core.Promise || global.Promise)(function(resolve, reject){
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next : function(value){
	          try {
	            return fn(value);
	          } catch(e){
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x){
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if(method){
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function(observer){
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          try {
	            if(forOf(x, false, function(it){
	              observer.next(it);
	              if(done)return RETURN;
	            }) === RETURN)return;
	          } catch(e){
	            if(done)throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  },
	  of: function of(){
	    for(var i = 0, l = arguments.length, items = Array(l); i < l;)items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          for(var i = 0; i < items.length; ++i){
	            observer.next(items[i]);
	            if(done)return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function(){ return this; });
	
	$export($export.G, {Observable: $Observable});
	
	__webpack_require__(44)('Observable');

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(31)
	  , anObject                  = __webpack_require__(2)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey){
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	}});

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(31)
	  , anObject               = __webpack_require__(2)
	  , toMetaKey              = metadata.key
	  , getOrCreateMetadataMap = metadata.map
	  , store                  = metadata.store;
	
	metadata.exp({deleteMetadata: function deleteMetadata(metadataKey, target /*, targetKey */){
	  var targetKey   = arguments.length < 3 ? undefined : toMetaKey(arguments[2])
	    , metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if(metadataMap === undefined || !metadataMap['delete'](metadataKey))return false;
	  if(metadataMap.size)return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	}});

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	var Set                     = __webpack_require__(140)
	  , from                    = __webpack_require__(116)
	  , metadata                = __webpack_require__(31)
	  , anObject                = __webpack_require__(2)
	  , getPrototypeOf          = __webpack_require__(21)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	var ordinaryMetadataKeys = function(O, P){
	  var oKeys  = ordinaryOwnMetadataKeys(O, P)
	    , parent = getPrototypeOf(O);
	  if(parent === null)return oKeys;
	  var pKeys  = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({getMetadataKeys: function getMetadataKeys(target /*, targetKey */){
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(31)
	  , anObject               = __webpack_require__(2)
	  , getPrototypeOf         = __webpack_require__(21)
	  , ordinaryHasOwnMetadata = metadata.has
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	var ordinaryGetMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({getMetadata: function getMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                = __webpack_require__(31)
	  , anObject                = __webpack_require__(2)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	metadata.exp({getOwnMetadataKeys: function getOwnMetadataKeys(target /*, targetKey */){
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(31)
	  , anObject               = __webpack_require__(2)
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	metadata.exp({getOwnMetadata: function getOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(31)
	  , anObject               = __webpack_require__(2)
	  , getPrototypeOf         = __webpack_require__(21)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	var ordinaryHasMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({hasMetadata: function hasMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(31)
	  , anObject               = __webpack_require__(2)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	metadata.exp({hasOwnMetadata: function hasOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(31)
	  , anObject                  = __webpack_require__(2)
	  , aFunction                 = __webpack_require__(15)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({metadata: function metadata(metadataKey, metadataValue){
	  return function decorator(target, targetKey){
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	}});

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(1);
	
	$export($export.P + $export.R, 'Set', {toJSON: __webpack_require__(120)('Set')});

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(1)
	  , $at     = __webpack_require__(93)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export     = __webpack_require__(1)
	  , defined     = __webpack_require__(23)
	  , toLength    = __webpack_require__(10)
	  , isRegExp    = __webpack_require__(63)
	  , getFlags    = __webpack_require__(61)
	  , RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function(regexp, string){
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(85)($RegExpStringIterator, 'RegExp String', function next(){
	  var match = this._r.exec(this._s);
	  return {value: match, done: match === null};
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp){
	    defined(this);
	    if(!isRegExp(regexp))throw TypeError(regexp + ' is not a regexp!');
	    var S     = String(this)
	      , flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp)
	      , rx    = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(1)
	  , $pad    = __webpack_require__(136);
	
	$export($export.P, 'String', {
	  padEnd: function padEnd(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(1)
	  , $pad    = __webpack_require__(136);
	
	$export($export.P, 'String', {
	  padStart: function padStart(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(52)('trimLeft', function($trim){
	  return function trimLeft(){
	    return $trim(this, 1);
	  };
	}, 'trimStart');

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(52)('trimRight', function($trim){
	  return function trimRight(){
	    return $trim(this, 2);
	  };
	}, 'trimEnd');

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(99)('asyncIterator');

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(99)('observable');

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-global
	var $export = __webpack_require__(1);
	
	$export($export.S, 'System', {global: __webpack_require__(3)});

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators    = __webpack_require__(101)
	  , redefine      = __webpack_require__(17)
	  , global        = __webpack_require__(3)
	  , hide          = __webpack_require__(16)
	  , Iterators     = __webpack_require__(50)
	  , wks           = __webpack_require__(6)
	  , ITERATOR      = wks('iterator')
	  , TO_STRING_TAG = wks('toStringTag')
	  , ArrayValues   = Iterators.Array;
	
	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype
	    , key;
	  if(proto){
	    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);
	    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);
	  }
	}

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1)
	  , $task   = __webpack_require__(97);
	$export($export.G + $export.B, {
	  setImmediate:   $task.set,
	  clearImmediate: $task.clear
	});

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global     = __webpack_require__(3)
	  , $export    = __webpack_require__(1)
	  , invoke     = __webpack_require__(62)
	  , partial    = __webpack_require__(229)
	  , navigator  = global.navigator
	  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	var wrap = function(set){
	  return MSIE ? function(fn, time /*, ...args */){
	    return set(invoke(
	      partial,
	      [].slice.call(arguments, 2),
	      typeof fn == 'function' ? fn : Function(fn)
	    ), time);
	  } : set;
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout:  wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(352);
	__webpack_require__(291);
	__webpack_require__(293);
	__webpack_require__(292);
	__webpack_require__(295);
	__webpack_require__(297);
	__webpack_require__(302);
	__webpack_require__(296);
	__webpack_require__(294);
	__webpack_require__(304);
	__webpack_require__(303);
	__webpack_require__(299);
	__webpack_require__(300);
	__webpack_require__(298);
	__webpack_require__(290);
	__webpack_require__(301);
	__webpack_require__(305);
	__webpack_require__(306);
	__webpack_require__(258);
	__webpack_require__(260);
	__webpack_require__(259);
	__webpack_require__(308);
	__webpack_require__(307);
	__webpack_require__(278);
	__webpack_require__(288);
	__webpack_require__(289);
	__webpack_require__(279);
	__webpack_require__(280);
	__webpack_require__(281);
	__webpack_require__(282);
	__webpack_require__(283);
	__webpack_require__(284);
	__webpack_require__(285);
	__webpack_require__(286);
	__webpack_require__(287);
	__webpack_require__(261);
	__webpack_require__(262);
	__webpack_require__(263);
	__webpack_require__(264);
	__webpack_require__(265);
	__webpack_require__(266);
	__webpack_require__(267);
	__webpack_require__(268);
	__webpack_require__(269);
	__webpack_require__(270);
	__webpack_require__(271);
	__webpack_require__(272);
	__webpack_require__(273);
	__webpack_require__(274);
	__webpack_require__(275);
	__webpack_require__(276);
	__webpack_require__(277);
	__webpack_require__(339);
	__webpack_require__(344);
	__webpack_require__(351);
	__webpack_require__(342);
	__webpack_require__(334);
	__webpack_require__(335);
	__webpack_require__(340);
	__webpack_require__(345);
	__webpack_require__(347);
	__webpack_require__(330);
	__webpack_require__(331);
	__webpack_require__(332);
	__webpack_require__(333);
	__webpack_require__(336);
	__webpack_require__(337);
	__webpack_require__(338);
	__webpack_require__(341);
	__webpack_require__(343);
	__webpack_require__(346);
	__webpack_require__(348);
	__webpack_require__(349);
	__webpack_require__(350);
	__webpack_require__(253);
	__webpack_require__(255);
	__webpack_require__(254);
	__webpack_require__(257);
	__webpack_require__(256);
	__webpack_require__(242);
	__webpack_require__(240);
	__webpack_require__(246);
	__webpack_require__(243);
	__webpack_require__(249);
	__webpack_require__(251);
	__webpack_require__(239);
	__webpack_require__(245);
	__webpack_require__(236);
	__webpack_require__(250);
	__webpack_require__(234);
	__webpack_require__(248);
	__webpack_require__(247);
	__webpack_require__(241);
	__webpack_require__(244);
	__webpack_require__(233);
	__webpack_require__(235);
	__webpack_require__(238);
	__webpack_require__(237);
	__webpack_require__(252);
	__webpack_require__(101);
	__webpack_require__(324);
	__webpack_require__(329);
	__webpack_require__(139);
	__webpack_require__(325);
	__webpack_require__(326);
	__webpack_require__(327);
	__webpack_require__(328);
	__webpack_require__(309);
	__webpack_require__(138);
	__webpack_require__(140);
	__webpack_require__(141);
	__webpack_require__(364);
	__webpack_require__(353);
	__webpack_require__(354);
	__webpack_require__(359);
	__webpack_require__(362);
	__webpack_require__(363);
	__webpack_require__(357);
	__webpack_require__(360);
	__webpack_require__(358);
	__webpack_require__(361);
	__webpack_require__(355);
	__webpack_require__(356);
	__webpack_require__(310);
	__webpack_require__(311);
	__webpack_require__(312);
	__webpack_require__(313);
	__webpack_require__(314);
	__webpack_require__(317);
	__webpack_require__(315);
	__webpack_require__(316);
	__webpack_require__(318);
	__webpack_require__(319);
	__webpack_require__(320);
	__webpack_require__(321);
	__webpack_require__(323);
	__webpack_require__(322);
	__webpack_require__(365);
	__webpack_require__(391);
	__webpack_require__(394);
	__webpack_require__(393);
	__webpack_require__(395);
	__webpack_require__(396);
	__webpack_require__(392);
	__webpack_require__(397);
	__webpack_require__(398);
	__webpack_require__(376);
	__webpack_require__(379);
	__webpack_require__(375);
	__webpack_require__(373);
	__webpack_require__(374);
	__webpack_require__(377);
	__webpack_require__(378);
	__webpack_require__(368);
	__webpack_require__(390);
	__webpack_require__(399);
	__webpack_require__(367);
	__webpack_require__(369);
	__webpack_require__(371);
	__webpack_require__(370);
	__webpack_require__(372);
	__webpack_require__(381);
	__webpack_require__(382);
	__webpack_require__(384);
	__webpack_require__(383);
	__webpack_require__(386);
	__webpack_require__(385);
	__webpack_require__(387);
	__webpack_require__(388);
	__webpack_require__(389);
	__webpack_require__(366);
	__webpack_require__(380);
	__webpack_require__(402);
	__webpack_require__(401);
	__webpack_require__(400);
	module.exports = __webpack_require__(29);

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        module.exports = factory();
	    } else {
	        root.deepmerge = factory();
	    }
	}(this, function () {
	
	function isMergeableObject(val) {
	    var nonNullObject = val && typeof val === 'object'
	
	    return nonNullObject
	        && Object.prototype.toString.call(val) !== '[object RegExp]'
	        && Object.prototype.toString.call(val) !== '[object Date]'
	}
	
	function emptyTarget(val) {
	    return Array.isArray(val) ? [] : {}
	}
	
	function cloneIfNecessary(value, optionsArgument) {
	    var clone = optionsArgument && optionsArgument.clone === true
	    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
	}
	
	function defaultArrayMerge(target, source, optionsArgument) {
	    var destination = target.slice()
	    source.forEach(function(e, i) {
	        if (typeof destination[i] === 'undefined') {
	            destination[i] = cloneIfNecessary(e, optionsArgument)
	        } else if (isMergeableObject(e)) {
	            destination[i] = deepmerge(target[i], e, optionsArgument)
	        } else if (target.indexOf(e) === -1) {
	            destination.push(cloneIfNecessary(e, optionsArgument))
	        }
	    })
	    return destination
	}
	
	function mergeObject(target, source, optionsArgument) {
	    var destination = {}
	    if (isMergeableObject(target)) {
	        Object.keys(target).forEach(function (key) {
	            destination[key] = cloneIfNecessary(target[key], optionsArgument)
	        })
	    }
	    Object.keys(source).forEach(function (key) {
	        if (!isMergeableObject(source[key]) || !target[key]) {
	            destination[key] = cloneIfNecessary(source[key], optionsArgument)
	        } else {
	            destination[key] = deepmerge(target[key], source[key], optionsArgument)
	        }
	    })
	    return destination
	}
	
	function deepmerge(target, source, optionsArgument) {
	    var array = Array.isArray(source);
	    var options = optionsArgument || { arrayMerge: defaultArrayMerge }
	    var arrayMerge = options.arrayMerge || defaultArrayMerge
	
	    if (array) {
	        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument)
	    } else {
	        return mergeObject(target, source, optionsArgument)
	    }
	}
	
	deepmerge.all = function deepmergeAll(array, optionsArgument) {
	    if (!Array.isArray(array) || array.length < 2) {
	        throw new Error('first argument should be an array with at least two elements')
	    }
	
	    // we are sure there are at least 2 values, so it is safe to have no initial value
	    return array.reduce(function(prev, next) {
	        return deepmerge(prev, next, optionsArgument)
	    })
	}
	
	return deepmerge
	
	}));


/***/ },
/* 405 */
/***/ function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(32);
	
	
	/***/ },
	
	/***/ 32:
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _buttonGroup = __webpack_require__(33);
	
		var _buttonGroup2 = _interopRequireDefault(_buttonGroup);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_buttonGroup2.default.install = function (Vue) {
		  Vue.component(_buttonGroup2.default.name, _buttonGroup2.default);
		};
	
		exports.default = _buttonGroup2.default;
	
	/***/ },
	
	/***/ 33:
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(34)
	
		/* template */
		var __vue_template__ = __webpack_require__(35)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	
	/***/ 34:
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		//
		//
		//
		//
		//
	
		/**
		 * button
		 * @module components/basic/menu
		 * @desc 用于按钮组
		 * @param {string} label - 名称
		 */
		exports.default = {
		  name: 'ElButtonGroup'
		};
	
	/***/ },
	
	/***/ 35:
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    staticClass: "el-button-group"
		  }, [_vm._t("default")], 2)
		},staticRenderFns: []}
	
	/***/ }
	
	/******/ });

/***/ },
/* 406 */
/***/ function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(28);
	
	
	/***/ },
	
	/***/ 28:
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _button = __webpack_require__(29);
	
		var _button2 = _interopRequireDefault(_button);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_button2.default.install = function (Vue) {
		  Vue.component(_button2.default.name, _button2.default);
		};
	
		exports.default = _button2.default;
	
	/***/ },
	
	/***/ 29:
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(30)
	
		/* template */
		var __vue_template__ = __webpack_require__(31)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	
	/***/ 30:
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  name: 'ElButton',
	
		  props: {
		    type: {
		      type: String,
		      default: 'default'
		    },
		    size: String,
		    icon: {
		      type: String,
		      default: ''
		    },
		    nativeType: {
		      type: String,
		      default: 'button'
		    },
		    loading: Boolean,
		    disabled: Boolean,
		    plain: Boolean,
		    autofocus: Boolean
		  },
	
		  methods: {
		    handleClick: function handleClick(evt) {
		      this.$emit('click', evt);
		    }
		  }
		};
	
	/***/ },
	
	/***/ 31:
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('button', {
		    staticClass: "el-button",
		    class: [
		      _vm.type ? 'el-button--' + _vm.type : '',
		      _vm.size ? 'el-button--' + _vm.size : '', {
		        'is-disabled': _vm.disabled,
		        'is-loading': _vm.loading,
		        'is-plain': _vm.plain
		      }
		    ],
		    attrs: {
		      "disabled": _vm.disabled,
		      "autofocus": _vm.autofocus,
		      "type": _vm.nativeType
		    },
		    on: {
		      "click": _vm.handleClick
		    }
		  }, [(_vm.loading) ? _c('i', {
		    staticClass: "el-icon-loading"
		  }) : _vm._e(), (_vm.icon && !_vm.loading) ? _c('i', {
		    class: 'el-icon-' + _vm.icon
		  }) : _vm._e(), (_vm.$slots.default) ? _c('span', [_vm._t("default")], 2) : _vm._e()])
		},staticRenderFns: []}
	
	/***/ }
	
	/******/ });

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(55);
	
	
	/***/ },
	
	/***/ 13:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(53);
	
	/***/ },
	
	/***/ 55:
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _checkboxGroup = __webpack_require__(56);
	
		var _checkboxGroup2 = _interopRequireDefault(_checkboxGroup);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_checkboxGroup2.default.install = function (Vue) {
		  Vue.component(_checkboxGroup2.default.name, _checkboxGroup2.default);
		};
	
		exports.default = _checkboxGroup2.default;
	
	/***/ },
	
	/***/ 56:
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(57)
	
		/* template */
		var __vue_template__ = __webpack_require__(58)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	
	/***/ 57:
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _emitter = __webpack_require__(13);
	
		var _emitter2 = _interopRequireDefault(_emitter);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  name: 'ElCheckboxGroup',
	
		  componentName: 'ElCheckboxGroup',
	
		  mixins: [_emitter2.default],
	
		  props: {
		    value: {}
		  },
	
		  watch: {
		    value: function value(_value) {
		      this.dispatch('ElFormItem', 'el.form.change', [_value]);
		    }
		  }
		};
	
	/***/ },
	
	/***/ 58:
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    staticClass: "el-checkbox-group"
		  }, [_vm._t("default")], 2)
		},staticRenderFns: []}
	
	/***/ }
	
	/******/ });

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(51);
	
	
	/***/ },
	
	/***/ 13:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(53);
	
	/***/ },
	
	/***/ 51:
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _checkbox = __webpack_require__(52);
	
		var _checkbox2 = _interopRequireDefault(_checkbox);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_checkbox2.default.install = function (Vue) {
		  Vue.component(_checkbox2.default.name, _checkbox2.default);
		};
	
		exports.default = _checkbox2.default;
	
	/***/ },
	
	/***/ 52:
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(53)
	
		/* template */
		var __vue_template__ = __webpack_require__(54)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	
	/***/ 53:
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _emitter = __webpack_require__(13);
	
		var _emitter2 = _interopRequireDefault(_emitter);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  name: 'ElCheckbox',
	
		  mixins: [_emitter2.default],
	
		  componentName: 'ElCheckbox',
	
		  data: function data() {
		    return {
		      selfModel: false,
		      focus: false
		    };
		  },
	
	
		  computed: {
		    model: {
		      get: function get() {
		        return this.isGroup ? this.store : this.value !== undefined ? this.value : this.selfModel;
		      },
		      set: function set(val) {
		        if (this.isGroup) {
		          this.dispatch('ElCheckboxGroup', 'input', [val]);
		        } else if (this.value !== undefined) {
		          this.$emit('input', val);
		        } else {
		          this.selfModel = val;
		        }
		      }
		    },
	
		    isChecked: function isChecked() {
		      if ({}.toString.call(this.model) === '[object Boolean]') {
		        return this.model;
		      } else if (Array.isArray(this.model)) {
		        return this.model.indexOf(this.label) > -1;
		      } else if (this.model !== null && this.model !== undefined) {
		        return this.model === this.trueLabel;
		      }
		    },
		    isGroup: function isGroup() {
		      var parent = this.$parent;
		      while (parent) {
		        if (parent.$options.componentName !== 'ElCheckboxGroup') {
		          parent = parent.$parent;
		        } else {
		          this._checkboxGroup = parent;
		          return true;
		        }
		      }
		      return false;
		    },
		    store: function store() {
		      return this._checkboxGroup ? this._checkboxGroup.value : this.value;
		    }
		  },
	
		  props: {
		    value: {},
		    label: {},
		    indeterminate: Boolean,
		    disabled: Boolean,
		    checked: Boolean,
		    name: String,
		    trueLabel: [String, Number],
		    falseLabel: [String, Number]
		  },
	
		  methods: {
		    addToStore: function addToStore() {
		      if (Array.isArray(this.model) && this.model.indexOf(this.label) === -1) {
		        this.model.push(this.label);
		      } else {
		        this.model = this.trueLabel || true;
		      }
		    },
		    handleChange: function handleChange(ev) {
		      var _this = this;
	
		      this.$emit('change', ev);
		      if (this.isGroup) {
		        this.$nextTick(function (_) {
		          _this.dispatch('ElCheckboxGroup', 'change', [_this._checkboxGroup.value]);
		        });
		      }
		    }
		  },
	
		  created: function created() {
		    this.checked && this.addToStore();
		  }
		}; //
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
	/***/ },
	
	/***/ 54:
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('label', {
		    staticClass: "el-checkbox"
		  }, [_c('span', {
		    staticClass: "el-checkbox__input",
		    class: {
		      'is-disabled': _vm.disabled,
		      'is-checked': _vm.isChecked,
		      'is-indeterminate': _vm.indeterminate,
		      'is-focus': _vm.focus
		    }
		  }, [_c('span', {
		    staticClass: "el-checkbox__inner"
		  }), (_vm.trueLabel || _vm.falseLabel) ? _c('input', {
		    directives: [{
		      name: "model",
		      rawName: "v-model",
		      value: (_vm.model),
		      expression: "model"
		    }],
		    staticClass: "el-checkbox__original",
		    attrs: {
		      "type": "checkbox",
		      "name": _vm.name,
		      "disabled": _vm.disabled,
		      "true-value": _vm.trueLabel,
		      "false-value": _vm.falseLabel
		    },
		    domProps: {
		      "checked": Array.isArray(_vm.model) ? _vm._i(_vm.model, null) > -1 : _vm._q(_vm.model, _vm.trueLabel)
		    },
		    on: {
		      "change": [function($event) {
		        var $$a = _vm.model,
		          $$el = $event.target,
		          $$c = $$el.checked ? (_vm.trueLabel) : (_vm.falseLabel);
		        if (Array.isArray($$a)) {
		          var $$v = null,
		            $$i = _vm._i($$a, $$v);
		          if ($$c) {
		            $$i < 0 && (_vm.model = $$a.concat($$v))
		          } else {
		            $$i > -1 && (_vm.model = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
		          }
		        } else {
		          _vm.model = $$c
		        }
		      }, _vm.handleChange],
		      "focus": function($event) {
		        _vm.focus = true
		      },
		      "blur": function($event) {
		        _vm.focus = false
		      }
		    }
		  }) : _c('input', {
		    directives: [{
		      name: "model",
		      rawName: "v-model",
		      value: (_vm.model),
		      expression: "model"
		    }],
		    staticClass: "el-checkbox__original",
		    attrs: {
		      "type": "checkbox",
		      "disabled": _vm.disabled,
		      "name": _vm.name
		    },
		    domProps: {
		      "value": _vm.label,
		      "checked": Array.isArray(_vm.model) ? _vm._i(_vm.model, _vm.label) > -1 : (_vm.model)
		    },
		    on: {
		      "change": [function($event) {
		        var $$a = _vm.model,
		          $$el = $event.target,
		          $$c = $$el.checked ? (true) : (false);
		        if (Array.isArray($$a)) {
		          var $$v = _vm.label,
		            $$i = _vm._i($$a, $$v);
		          if ($$c) {
		            $$i < 0 && (_vm.model = $$a.concat($$v))
		          } else {
		            $$i > -1 && (_vm.model = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
		          }
		        } else {
		          _vm.model = $$c
		        }
		      }, _vm.handleChange],
		      "focus": function($event) {
		        _vm.focus = true
		      },
		      "blur": function($event) {
		        _vm.focus = false
		      }
		    }
		  })]), (_vm.$slots.default || _vm.label) ? _c('span', {
		    staticClass: "el-checkbox__label"
		  }, [_vm._t("default"), (!_vm.$slots.default) ? [_vm._v(_vm._s(_vm.label))] : _vm._e()], 2) : _vm._e()])
		},staticRenderFns: []}
	
	/***/ }
	
	/******/ });

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(1);
	
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _pagination = __webpack_require__(2);
	
		var _pagination2 = _interopRequireDefault(_pagination);
	
		var _dialog = __webpack_require__(10);
	
		var _dialog2 = _interopRequireDefault(_dialog);
	
		var _autocomplete = __webpack_require__(15);
	
		var _autocomplete2 = _interopRequireDefault(_autocomplete);
	
		var _dropdown = __webpack_require__(26);
	
		var _dropdown2 = _interopRequireDefault(_dropdown);
	
		var _dropdownMenu = __webpack_require__(31);
	
		var _dropdownMenu2 = _interopRequireDefault(_dropdownMenu);
	
		var _dropdownItem = __webpack_require__(35);
	
		var _dropdownItem2 = _interopRequireDefault(_dropdownItem);
	
		var _menu = __webpack_require__(39);
	
		var _menu2 = _interopRequireDefault(_menu);
	
		var _submenu = __webpack_require__(43);
	
		var _submenu2 = _interopRequireDefault(_submenu);
	
		var _menuItem = __webpack_require__(49);
	
		var _menuItem2 = _interopRequireDefault(_menuItem);
	
		var _menuItemGroup = __webpack_require__(53);
	
		var _menuItemGroup2 = _interopRequireDefault(_menuItemGroup);
	
		var _input = __webpack_require__(57);
	
		var _input2 = _interopRequireDefault(_input);
	
		var _inputNumber = __webpack_require__(63);
	
		var _inputNumber2 = _interopRequireDefault(_inputNumber);
	
		var _radio = __webpack_require__(68);
	
		var _radio2 = _interopRequireDefault(_radio);
	
		var _radioGroup = __webpack_require__(72);
	
		var _radioGroup2 = _interopRequireDefault(_radioGroup);
	
		var _radioButton = __webpack_require__(76);
	
		var _radioButton2 = _interopRequireDefault(_radioButton);
	
		var _checkbox = __webpack_require__(80);
	
		var _checkbox2 = _interopRequireDefault(_checkbox);
	
		var _checkboxGroup = __webpack_require__(84);
	
		var _checkboxGroup2 = _interopRequireDefault(_checkboxGroup);
	
		var _switch = __webpack_require__(88);
	
		var _switch2 = _interopRequireDefault(_switch);
	
		var _select = __webpack_require__(92);
	
		var _select2 = _interopRequireDefault(_select);
	
		var _option = __webpack_require__(107);
	
		var _option2 = _interopRequireDefault(_option);
	
		var _optionGroup = __webpack_require__(108);
	
		var _optionGroup2 = _interopRequireDefault(_optionGroup);
	
		var _button = __webpack_require__(112);
	
		var _button2 = _interopRequireDefault(_button);
	
		var _buttonGroup = __webpack_require__(116);
	
		var _buttonGroup2 = _interopRequireDefault(_buttonGroup);
	
		var _table = __webpack_require__(120);
	
		var _table2 = _interopRequireDefault(_table);
	
		var _tableColumn = __webpack_require__(138);
	
		var _tableColumn2 = _interopRequireDefault(_tableColumn);
	
		var _datePicker = __webpack_require__(140);
	
		var _datePicker2 = _interopRequireDefault(_datePicker);
	
		var _timeSelect = __webpack_require__(168);
	
		var _timeSelect2 = _interopRequireDefault(_timeSelect);
	
		var _timePicker = __webpack_require__(173);
	
		var _timePicker2 = _interopRequireDefault(_timePicker);
	
		var _popover = __webpack_require__(178);
	
		var _popover2 = _interopRequireDefault(_popover);
	
		var _tooltip = __webpack_require__(183);
	
		var _tooltip2 = _interopRequireDefault(_tooltip);
	
		var _messageBox = __webpack_require__(187);
	
		var _messageBox2 = _interopRequireDefault(_messageBox);
	
		var _breadcrumb = __webpack_require__(192);
	
		var _breadcrumb2 = _interopRequireDefault(_breadcrumb);
	
		var _breadcrumbItem = __webpack_require__(196);
	
		var _breadcrumbItem2 = _interopRequireDefault(_breadcrumbItem);
	
		var _form = __webpack_require__(200);
	
		var _form2 = _interopRequireDefault(_form);
	
		var _formItem = __webpack_require__(204);
	
		var _formItem2 = _interopRequireDefault(_formItem);
	
		var _tabs = __webpack_require__(209);
	
		var _tabs2 = _interopRequireDefault(_tabs);
	
		var _tabPane = __webpack_require__(215);
	
		var _tabPane2 = _interopRequireDefault(_tabPane);
	
		var _tag = __webpack_require__(219);
	
		var _tag2 = _interopRequireDefault(_tag);
	
		var _tree = __webpack_require__(223);
	
		var _tree2 = _interopRequireDefault(_tree);
	
		var _alert = __webpack_require__(233);
	
		var _alert2 = _interopRequireDefault(_alert);
	
		var _notification = __webpack_require__(237);
	
		var _notification2 = _interopRequireDefault(_notification);
	
		var _slider = __webpack_require__(243);
	
		var _slider2 = _interopRequireDefault(_slider);
	
		var _loading = __webpack_require__(249);
	
		var _loading2 = _interopRequireDefault(_loading);
	
		var _icon = __webpack_require__(255);
	
		var _icon2 = _interopRequireDefault(_icon);
	
		var _row = __webpack_require__(259);
	
		var _row2 = _interopRequireDefault(_row);
	
		var _col = __webpack_require__(263);
	
		var _col2 = _interopRequireDefault(_col);
	
		var _upload = __webpack_require__(265);
	
		var _upload2 = _interopRequireDefault(_upload);
	
		var _progress = __webpack_require__(281);
	
		var _progress2 = _interopRequireDefault(_progress);
	
		var _spinner = __webpack_require__(285);
	
		var _spinner2 = _interopRequireDefault(_spinner);
	
		var _message = __webpack_require__(289);
	
		var _message2 = _interopRequireDefault(_message);
	
		var _badge = __webpack_require__(299);
	
		var _badge2 = _interopRequireDefault(_badge);
	
		var _card = __webpack_require__(303);
	
		var _card2 = _interopRequireDefault(_card);
	
		var _rate = __webpack_require__(307);
	
		var _rate2 = _interopRequireDefault(_rate);
	
		var _steps = __webpack_require__(311);
	
		var _steps2 = _interopRequireDefault(_steps);
	
		var _step = __webpack_require__(315);
	
		var _step2 = _interopRequireDefault(_step);
	
		var _carousel = __webpack_require__(319);
	
		var _carousel2 = _interopRequireDefault(_carousel);
	
		var _scrollbar = __webpack_require__(323);
	
		var _scrollbar2 = _interopRequireDefault(_scrollbar);
	
		var _carouselItem = __webpack_require__(327);
	
		var _carouselItem2 = _interopRequireDefault(_carouselItem);
	
		var _collapse = __webpack_require__(331);
	
		var _collapse2 = _interopRequireDefault(_collapse);
	
		var _collapseItem = __webpack_require__(335);
	
		var _collapseItem2 = _interopRequireDefault(_collapseItem);
	
		var _locale = __webpack_require__(105);
	
		var _locale2 = _interopRequireDefault(_locale);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var components = [_pagination2.default, _dialog2.default, _autocomplete2.default, _dropdown2.default, _dropdownMenu2.default, _dropdownItem2.default, _menu2.default, _submenu2.default, _menuItem2.default, _menuItemGroup2.default, _input2.default, _inputNumber2.default, _radio2.default, _radioGroup2.default, _radioButton2.default, _checkbox2.default, _checkboxGroup2.default, _switch2.default, _select2.default, _option2.default, _optionGroup2.default, _button2.default, _buttonGroup2.default, _table2.default, _tableColumn2.default, _datePicker2.default, _timeSelect2.default, _timePicker2.default, _popover2.default, _tooltip2.default, _breadcrumb2.default, _breadcrumbItem2.default, _form2.default, _formItem2.default, _tabs2.default, _tabPane2.default, _tag2.default, _tree2.default, _alert2.default, _slider2.default, _icon2.default, _row2.default, _col2.default, _upload2.default, _progress2.default, _spinner2.default, _badge2.default, _card2.default, _rate2.default, _steps2.default, _step2.default, _carousel2.default, _scrollbar2.default, _carouselItem2.default, _collapse2.default, _collapseItem2.default]; /* Automatic generated by './build/bin/build-entry.js' */
	
		var install = function install(Vue) {
		  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		  /* istanbul ignore if */
		  if (install.installed) return;
		  _locale2.default.use(opts.locale);
		  _locale2.default.i18n(opts.i18n);
	
		  components.map(function (component) {
		    Vue.component(component.name, component);
		  });
	
		  Vue.use(_loading2.default.directive);
	
		  Vue.prototype.$loading = _loading2.default.service;
		  Vue.prototype.$msgbox = _messageBox2.default;
		  Vue.prototype.$alert = _messageBox2.default.alert;
		  Vue.prototype.$confirm = _messageBox2.default.confirm;
		  Vue.prototype.$prompt = _messageBox2.default.prompt;
		  Vue.prototype.$notify = _notification2.default;
		  Vue.prototype.$message = _message2.default;
		};
	
		/* istanbul ignore if */
		if (typeof window !== 'undefined' && window.Vue) {
		  install(window.Vue);
		};
	
		module.exports = {
		  version: '1.1.6',
		  locale: _locale2.default.use,
		  i18n: _locale2.default.i18n,
		  install: install,
		  Loading: _loading2.default,
		  Pagination: _pagination2.default,
		  Dialog: _dialog2.default,
		  Autocomplete: _autocomplete2.default,
		  Dropdown: _dropdown2.default,
		  DropdownMenu: _dropdownMenu2.default,
		  DropdownItem: _dropdownItem2.default,
		  Menu: _menu2.default,
		  Submenu: _submenu2.default,
		  MenuItem: _menuItem2.default,
		  MenuItemGroup: _menuItemGroup2.default,
		  Input: _input2.default,
		  InputNumber: _inputNumber2.default,
		  Radio: _radio2.default,
		  RadioGroup: _radioGroup2.default,
		  RadioButton: _radioButton2.default,
		  Checkbox: _checkbox2.default,
		  CheckboxGroup: _checkboxGroup2.default,
		  Switch: _switch2.default,
		  Select: _select2.default,
		  Option: _option2.default,
		  OptionGroup: _optionGroup2.default,
		  Button: _button2.default,
		  ButtonGroup: _buttonGroup2.default,
		  Table: _table2.default,
		  TableColumn: _tableColumn2.default,
		  DatePicker: _datePicker2.default,
		  TimeSelect: _timeSelect2.default,
		  TimePicker: _timePicker2.default,
		  Popover: _popover2.default,
		  Tooltip: _tooltip2.default,
		  MessageBox: _messageBox2.default,
		  Breadcrumb: _breadcrumb2.default,
		  BreadcrumbItem: _breadcrumbItem2.default,
		  Form: _form2.default,
		  FormItem: _formItem2.default,
		  Tabs: _tabs2.default,
		  TabPane: _tabPane2.default,
		  Tag: _tag2.default,
		  Tree: _tree2.default,
		  Alert: _alert2.default,
		  Notification: _notification2.default,
		  Slider: _slider2.default,
		  Icon: _icon2.default,
		  Row: _row2.default,
		  Col: _col2.default,
		  Upload: _upload2.default,
		  Progress: _progress2.default,
		  Spinner: _spinner2.default,
		  Message: _message2.default,
		  Badge: _badge2.default,
		  Card: _card2.default,
		  Rate: _rate2.default,
		  Steps: _steps2.default,
		  Step: _step2.default,
		  Carousel: _carousel2.default,
		  Scrollbar: _scrollbar2.default,
		  CarouselItem: _carouselItem2.default,
		  Collapse: _collapse2.default,
		  CollapseItem: _collapseItem2.default
		};
	
	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _pagination = __webpack_require__(3);
	
		var _pagination2 = _interopRequireDefault(_pagination);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_pagination2.default.install = function (Vue) {
		  Vue.component(_pagination2.default.name, _pagination2.default);
		};
	
		exports.default = _pagination2.default;
	
	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _pager = __webpack_require__(4);
	
		var _pager2 = _interopRequireDefault(_pager);
	
		var _select = __webpack_require__(7);
	
		var _select2 = _interopRequireDefault(_select);
	
		var _option = __webpack_require__(8);
	
		var _option2 = _interopRequireDefault(_option);
	
		var _locale = __webpack_require__(9);
	
		var _locale2 = _interopRequireDefault(_locale);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  name: 'ElPagination',
	
		  props: {
		    pageSize: {
		      type: Number,
		      default: 10
		    },
	
		    small: Boolean,
	
		    total: Number,
	
		    pageCount: Number,
	
		    currentPage: {
		      type: Number,
		      default: 1
		    },
	
		    layout: {
		      default: 'prev, pager, next, jumper, ->, total'
		    },
	
		    pageSizes: {
		      type: Array,
		      default: function _default() {
		        return [10, 20, 30, 40, 50, 100];
		      }
		    }
		  },
	
		  data: function data() {
		    return {
		      internalCurrentPage: 1,
		      internalPageSize: 0
		    };
		  },
		  render: function render(h) {
		    var template = h(
		      'div',
		      { 'class': 'el-pagination' },
		      []
		    );
		    var layout = this.layout || '';
		    if (!layout) return;
		    var TEMPLATE_MAP = {
		      prev: h(
		        'prev',
		        null,
		        []
		      ),
		      jumper: h(
		        'jumper',
		        null,
		        []
		      ),
		      pager: h(
		        'pager',
		        {
		          attrs: { currentPage: this.internalCurrentPage, pageCount: this.internalPageCount },
		          on: {
		            'change': this.handleCurrentChange
		          }
		        },
		        []
		      ),
		      next: h(
		        'next',
		        null,
		        []
		      ),
		      sizes: h(
		        'sizes',
		        {
		          attrs: { pageSizes: this.pageSizes }
		        },
		        []
		      ),
		      slot: h(
		        'my-slot',
		        null,
		        []
		      ),
		      total: h(
		        'total',
		        null,
		        []
		      )
		    };
		    var components = layout.split(',').map(function (item) {
		      return item.trim();
		    });
		    var rightWrapper = h(
		      'div',
		      { 'class': 'el-pagination__rightwrapper' },
		      []
		    );
		    var haveRightWrapper = false;
	
		    if (this.small) {
		      template.data.class += ' el-pagination--small';
		    }
	
		    components.forEach(function (compo) {
		      if (compo === '->') {
		        haveRightWrapper = true;
		        return;
		      }
	
		      if (!haveRightWrapper) {
		        template.children.push(TEMPLATE_MAP[compo]);
		      } else {
		        rightWrapper.children.push(TEMPLATE_MAP[compo]);
		      }
		    });
	
		    if (haveRightWrapper) {
		      template.children.push(rightWrapper);
		    }
	
		    return template;
		  },
	
	
		  components: {
		    MySlot: {
		      render: function render(h) {
		        return this.$parent.$slots.default ? this.$parent.$slots.default[0] : '';
		      }
		    },
		    Prev: {
		      render: function render(h) {
		        return h(
		          'button',
		          {
		            attrs: {
		              type: 'button'
		            },
		            'class': ['btn-prev', { disabled: this.$parent.internalCurrentPage <= 1 }],
		            on: {
		              'click': this.$parent.prev
		            }
		          },
		          [h(
		            'i',
		            { 'class': 'el-icon el-icon-arrow-left' },
		            []
		          )]
		        );
		      }
		    },
	
		    Next: {
		      render: function render(h) {
		        return h(
		          'button',
		          {
		            attrs: {
		              type: 'button'
		            },
		            'class': ['btn-next', { disabled: this.$parent.internalCurrentPage === this.$parent.internalPageCount || this.$parent.internalPageCount === 0 }],
		            on: {
		              'click': this.$parent.next
		            }
		          },
		          [h(
		            'i',
		            { 'class': 'el-icon el-icon-arrow-right' },
		            []
		          )]
		        );
		      }
		    },
	
		    Sizes: {
		      mixins: [_locale2.default],
	
		      props: {
		        pageSizes: Array
		      },
	
		      watch: {
		        pageSizes: {
		          immediate: true,
		          handler: function handler(value) {
		            if (Array.isArray(value)) {
		              this.$parent.internalPageSize = value.indexOf(this.$parent.pageSize) > -1 ? this.$parent.pageSize : this.pageSizes[0];
		            }
		          }
		        }
		      },
	
		      render: function render(h) {
		        var _this = this;
	
		        return h(
		          'span',
		          { 'class': 'el-pagination__sizes' },
		          [h(
		            'el-select',
		            {
		              attrs: {
		                value: this.$parent.internalPageSize
		              },
		              on: {
		                'input': this.handleChange
		              }
		            },
		            [this.pageSizes.map(function (item) {
		              return h(
		                'el-option',
		                {
		                  attrs: {
		                    value: item,
		                    label: item + ' ' + _this.t('el.pagination.pagesize') }
		                },
		                []
		              );
		            })]
		          )]
		        );
		      },
	
	
		      components: {
		        ElSelect: _select2.default,
		        ElOption: _option2.default
		      },
	
		      methods: {
		        handleChange: function handleChange(val) {
		          if (val !== this.$parent.internalPageSize) {
		            this.$parent.internalPageSize = val = parseInt(val, 10);
		            this.$parent.$emit('size-change', val);
		          }
		        }
		      }
		    },
	
		    Jumper: {
		      mixins: [_locale2.default],
	
		      data: function data() {
		        return {
		          oldValue: null
		        };
		      },
	
	
		      methods: {
		        handleFocus: function handleFocus(event) {
		          this.oldValue = event.target.value;
		        },
		        handleChange: function handleChange(_ref) {
		          var target = _ref.target;
	
		          this.$parent.internalCurrentPage = this.$parent.getValidCurrentPage(target.value);
		          this.oldValue = null;
		        }
		      },
	
		      render: function render(h) {
		        return h(
		          'span',
		          { 'class': 'el-pagination__jump' },
		          [this.t('el.pagination.goto'), h(
		            'input',
		            {
		              'class': 'el-pagination__editor',
		              attrs: { type: 'number',
		                min: 1,
		                max: this.internalPageCount,
	
		                number: true },
		              domProps: {
		                'value': this.$parent.internalCurrentPage
		              },
		              on: {
		                'change': this.handleChange,
		                'focus': this.handleFocus
		              },
	
		              style: { width: '30px' } },
		            []
		          ), this.t('el.pagination.pageClassifier')]
		        );
		      }
		    },
	
		    Total: {
		      mixins: [_locale2.default],
	
		      render: function render(h) {
		        return typeof this.$parent.total === 'number' ? h(
		          'span',
		          { 'class': 'el-pagination__total' },
		          [this.t('el.pagination.total', { total: this.$parent.total })]
		        ) : '';
		      }
		    },
	
		    Pager: _pager2.default
		  },
	
		  methods: {
		    handleCurrentChange: function handleCurrentChange(val) {
		      this.internalCurrentPage = this.getValidCurrentPage(val);
		    },
		    prev: function prev() {
		      var newVal = this.internalCurrentPage - 1;
		      this.internalCurrentPage = this.getValidCurrentPage(newVal);
		    },
		    next: function next() {
		      var newVal = this.internalCurrentPage + 1;
		      this.internalCurrentPage = this.getValidCurrentPage(newVal);
		    },
		    getValidCurrentPage: function getValidCurrentPage(value) {
		      value = parseInt(value, 10);
	
		      var havePageCount = typeof this.internalPageCount === 'number';
	
		      var resetValue = void 0;
		      if (!havePageCount) {
		        if (isNaN(value) || value < 1) resetValue = 1;
		      } else {
		        if (value < 1) {
		          resetValue = 1;
		        } else if (value > this.internalPageCount) {
		          resetValue = this.internalPageCount;
		        }
		      }
	
		      if (resetValue === undefined && isNaN(value)) {
		        resetValue = 1;
		      } else if (resetValue === 0) {
		        resetValue = 1;
		      }
	
		      return resetValue === undefined ? value : resetValue;
		    }
		  },
	
		  computed: {
		    internalPageCount: function internalPageCount() {
		      if (typeof this.total === 'number') {
		        return Math.ceil(this.total / this.internalPageSize);
		      } else if (typeof this.pageCount === 'number') {
		        return this.pageCount;
		      }
		      return null;
		    }
		  },
	
		  watch: {
		    currentPage: {
		      immediate: true,
		      handler: function handler(val) {
		        this.internalCurrentPage = val;
		      }
		    },
	
		    pageSize: {
		      immediate: true,
		      handler: function handler(val) {
		        this.internalPageSize = val;
		      }
		    },
	
		    internalCurrentPage: function internalCurrentPage(newVal, oldVal) {
		      var _this2 = this;
	
		      newVal = parseInt(newVal, 10);
	
		      /* istanbul ignore if */
		      if (isNaN(newVal)) {
		        newVal = oldVal || 1;
		      } else {
		        newVal = this.getValidCurrentPage(newVal);
		      }
	
		      if (newVal !== undefined) {
		        this.$nextTick(function () {
		          _this2.internalCurrentPage = newVal;
		          if (oldVal !== newVal) {
		            _this2.$emit('current-change', _this2.internalCurrentPage);
		          }
		        });
		      } else {
		        this.$emit('current-change', this.internalCurrentPage);
		      }
		    },
		    internalPageCount: function internalPageCount(newVal) {
		      /* istanbul ignore if */
		      var oldPage = this.internalCurrentPage;
		      if (newVal > 0 && oldPage === 0) {
		        this.internalCurrentPage = 1;
		      } else if (oldPage > newVal) {
		        this.internalCurrentPage = newVal === 0 ? 1 : newVal;
		      }
		    }
		  }
		};
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(5)
	
		/* template */
		var __vue_template__ = __webpack_require__(6)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  name: 'ElPager',
	
		  props: {
		    currentPage: Number,
	
		    pageCount: Number
		  },
	
		  watch: {
		    showPrevMore: function showPrevMore(val) {
		      if (!val) this.quickprevIconClass = 'el-icon-more';
		    },
		    showNextMore: function showNextMore(val) {
		      if (!val) this.quicknextIconClass = 'el-icon-more';
		    }
		  },
	
		  methods: {
		    onPagerClick: function onPagerClick(event) {
		      var target = event.target;
		      if (target.tagName === 'UL') {
		        return;
		      }
	
		      var newPage = Number(event.target.textContent);
		      var pageCount = this.pageCount;
		      var currentPage = this.currentPage;
	
		      if (target.className.indexOf('more') !== -1) {
		        if (target.className.indexOf('quickprev') !== -1) {
		          newPage = currentPage - 5;
		        } else if (target.className.indexOf('quicknext') !== -1) {
		          newPage = currentPage + 5;
		        }
		      }
	
		      /* istanbul ignore if */
		      if (!isNaN(newPage)) {
		        if (newPage < 1) {
		          newPage = 1;
		        }
	
		        if (newPage > pageCount) {
		          newPage = pageCount;
		        }
		      }
	
		      if (newPage !== currentPage) {
		        this.$emit('change', newPage);
		      }
		    }
		  },
	
		  computed: {
		    pagers: function pagers() {
		      var pagerCount = 7;
	
		      var currentPage = Number(this.currentPage);
		      var pageCount = Number(this.pageCount);
	
		      var showPrevMore = false;
		      var showNextMore = false;
	
		      if (pageCount > pagerCount) {
		        if (currentPage > pagerCount - 2) {
		          showPrevMore = true;
		        }
	
		        if (currentPage < pageCount - 2) {
		          showNextMore = true;
		        }
		      }
	
		      var array = [];
	
		      if (showPrevMore && !showNextMore) {
		        var startPage = pageCount - (pagerCount - 2);
		        for (var i = startPage; i < pageCount; i++) {
		          array.push(i);
		        }
		      } else if (!showPrevMore && showNextMore) {
		        for (var _i = 2; _i < pagerCount; _i++) {
		          array.push(_i);
		        }
		      } else if (showPrevMore && showNextMore) {
		        var offset = Math.floor(pagerCount / 2) - 1;
		        for (var _i2 = currentPage - offset; _i2 <= currentPage + offset; _i2++) {
		          array.push(_i2);
		        }
		      } else {
		        for (var _i3 = 2; _i3 < pageCount; _i3++) {
		          array.push(_i3);
		        }
		      }
	
		      this.showPrevMore = showPrevMore;
		      this.showNextMore = showNextMore;
	
		      return array;
		    }
		  },
	
		  data: function data() {
		    return {
		      current: null,
		      showPrevMore: false,
		      showNextMore: false,
		      quicknextIconClass: 'el-icon-more',
		      quickprevIconClass: 'el-icon-more'
		    };
		  }
		};
	
	/***/ },
	/* 6 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('ul', {
		    staticClass: "el-pager",
		    on: {
		      "click": _vm.onPagerClick
		    }
		  }, [(_vm.pageCount > 0) ? _c('li', {
		    staticClass: "number",
		    class: {
		      active: _vm.currentPage === 1
		    }
		  }, [_vm._v("1")]) : _vm._e(), (_vm.showPrevMore) ? _c('li', {
		    staticClass: "el-icon more btn-quickprev",
		    class: [_vm.quickprevIconClass],
		    on: {
		      "mouseenter": function($event) {
		        _vm.quickprevIconClass = 'el-icon-d-arrow-left'
		      },
		      "mouseleave": function($event) {
		        _vm.quickprevIconClass = 'el-icon-more'
		      }
		    }
		  }) : _vm._e(), _vm._l((_vm.pagers), function(pager) {
		    return _c('li', {
		      staticClass: "number",
		      class: {
		        active: _vm.currentPage === pager
		      }
		    }, [_vm._v(_vm._s(pager))])
		  }), (_vm.showNextMore) ? _c('li', {
		    staticClass: "el-icon more btn-quicknext",
		    class: [_vm.quicknextIconClass],
		    on: {
		      "mouseenter": function($event) {
		        _vm.quicknextIconClass = 'el-icon-d-arrow-right'
		      },
		      "mouseleave": function($event) {
		        _vm.quicknextIconClass = 'el-icon-more'
		      }
		    }
		  }) : _vm._e(), (_vm.pageCount > 1) ? _c('li', {
		    staticClass: "number",
		    class: {
		      active: _vm.currentPage === _vm.pageCount
		    }
		  }, [_vm._v(_vm._s(_vm.pageCount))]) : _vm._e()], 2)
		},staticRenderFns: []}
	
	/***/ },
	/* 7 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(416);
	
	/***/ },
	/* 8 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(414);
	
	/***/ },
	/* 9 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(143);
	
	/***/ },
	/* 10 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _component = __webpack_require__(11);
	
		var _component2 = _interopRequireDefault(_component);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_component2.default.install = function (Vue) {
		  Vue.component(_component2.default.name, _component2.default);
		};
	
		exports.default = _component2.default;
	
	/***/ },
	/* 11 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(12)
	
		/* template */
		var __vue_template__ = __webpack_require__(14)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 12 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _popup = __webpack_require__(13);
	
		var _popup2 = _interopRequireDefault(_popup);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  name: 'ElDialog',
	
		  mixins: [_popup2.default],
	
		  props: {
		    title: {
		      type: String,
		      default: ''
		    },
	
		    modal: {
		      type: Boolean,
		      default: true
		    },
	
		    lockScroll: {
		      type: Boolean,
		      default: true
		    },
	
		    closeOnClickModal: {
		      type: Boolean,
		      default: true
		    },
	
		    closeOnPressEscape: {
		      type: Boolean,
		      default: true
		    },
	
		    showClose: {
		      type: Boolean,
		      default: true
		    },
	
		    size: {
		      type: String,
		      default: 'small'
		    },
	
		    customClass: {
		      type: String,
		      default: ''
		    },
	
		    top: {
		      type: String,
		      default: '15%'
		    }
		  },
		  data: function data() {
		    return {
		      visible: false
		    };
		  },
	
	
		  watch: {
		    value: function value(val) {
		      this.visible = val;
		    },
		    visible: function visible(val) {
		      var _this = this;
	
		      this.$emit('input', val);
		      if (val) {
		        this.$emit('open');
		        this.$nextTick(function () {
		          _this.$refs.dialog.scrollTop = 0;
		        });
		      } else {
		        this.$emit('close');
		      }
		    }
		  },
	
		  computed: {
		    sizeClass: function sizeClass() {
		      return 'el-dialog--' + this.size;
		    },
		    style: function style() {
		      return this.size === 'full' ? {} : { 'margin-bottom': '50px', 'top': this.top };
		    }
		  },
	
		  methods: {
		    handleWrapperClick: function handleWrapperClick() {
		      if (this.closeOnClickModal) {
		        this.close();
		      }
		    }
		  },
	
		  mounted: function mounted() {
		    if (this.value) {
		      this.rendered = true;
		      this.open();
		    }
		  }
		}; //
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
	/***/ },
	/* 13 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(147);
	
	/***/ },
	/* 14 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('transition', {
		    attrs: {
		      "name": "dialog-fade"
		    }
		  }, [_c('div', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.visible),
		      expression: "visible"
		    }],
		    staticClass: "el-dialog__wrapper",
		    on: {
		      "click": function($event) {
		        if ($event.target !== $event.currentTarget) { return; }
		        _vm.handleWrapperClick($event)
		      }
		    }
		  }, [_c('div', {
		    ref: "dialog",
		    staticClass: "el-dialog",
		    class: [_vm.sizeClass, _vm.customClass],
		    style: (_vm.style)
		  }, [_c('div', {
		    staticClass: "el-dialog__header"
		  }, [_c('span', {
		    staticClass: "el-dialog__title"
		  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
		    staticClass: "el-dialog__headerbtn"
		  }, [(_vm.showClose) ? _c('i', {
		    staticClass: "el-dialog__close el-icon el-icon-close",
		    on: {
		      "click": function($event) {
		        _vm.close()
		      }
		    }
		  }) : _vm._e()])]), (_vm.rendered) ? _c('div', {
		    staticClass: "el-dialog__body"
		  }, [_vm._t("default")], 2) : _vm._e(), (_vm.$slots.footer) ? _c('div', {
		    staticClass: "el-dialog__footer"
		  }, [_vm._t("footer")], 2) : _vm._e()])])])
		},staticRenderFns: []}
	
	/***/ },
	/* 15 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _autocomplete = __webpack_require__(16);
	
		var _autocomplete2 = _interopRequireDefault(_autocomplete);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_autocomplete2.default.install = function (Vue) {
		  Vue.component(_autocomplete2.default.name, _autocomplete2.default);
		};
	
		exports.default = _autocomplete2.default;
	
	/***/ },
	/* 16 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(17)
	
		/* template */
		var __vue_template__ = __webpack_require__(25)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 17 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _input = __webpack_require__(18);
	
		var _input2 = _interopRequireDefault(_input);
	
		var _clickoutside = __webpack_require__(19);
	
		var _clickoutside2 = _interopRequireDefault(_clickoutside);
	
		var _autocompleteSuggestions = __webpack_require__(20);
	
		var _autocompleteSuggestions2 = _interopRequireDefault(_autocompleteSuggestions);
	
		var _emitter = __webpack_require__(23);
	
		var _emitter2 = _interopRequireDefault(_emitter);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  name: 'ElAutocomplete',
	
		  mixins: [_emitter2.default],
	
		  componentName: 'ElAutocomplete',
	
		  components: {
		    ElInput: _input2.default,
		    ElAutocompleteSuggestions: _autocompleteSuggestions2.default
		  },
	
		  directives: { Clickoutside: _clickoutside2.default },
	
		  props: {
		    popperClass: String,
		    placeholder: String,
		    disabled: Boolean,
		    name: String,
		    size: String,
		    value: String,
		    autofocus: Boolean,
		    fetchSuggestions: Function,
		    triggerOnFocus: {
		      type: Boolean,
		      default: true
		    },
		    customItem: String
		  },
		  data: function data() {
		    return {
		      isFocus: false,
		      suggestions: [],
		      loading: false,
		      highlightedIndex: -1
		    };
		  },
	
		  computed: {
		    suggestionVisible: function suggestionVisible() {
		      var suggestions = this.suggestions;
		      var isValidData = Array.isArray(suggestions) && suggestions.length > 0;
		      return (isValidData || this.loading) && this.isFocus;
		    }
		  },
		  watch: {
		    suggestionVisible: function suggestionVisible(val) {
		      this.broadcast('ElAutocompleteSuggestions', 'visible', [val, this.$refs.input.$refs.input.offsetWidth]);
		    }
		  },
		  methods: {
		    getData: function getData(queryString) {
		      var _this = this;
	
		      this.loading = true;
		      this.fetchSuggestions(queryString, function (suggestions) {
		        _this.loading = false;
		        if (Array.isArray(suggestions)) {
		          _this.suggestions = suggestions;
		        } else {
		          console.error('autocomplete suggestions must be an array');
		        }
		      });
		    },
		    handleChange: function handleChange(value) {
		      this.$emit('input', value);
		      this.getData(value);
		    },
		    handleFocus: function handleFocus() {
		      this.isFocus = true;
		      if (this.triggerOnFocus) {
		        this.getData(this.value);
		      }
		    },
		    handleBlur: function handleBlur() {
		      var _this2 = this;
	
		      // 因为 blur 事件处理优先于 select 事件执行
		      setTimeout(function (_) {
		        _this2.isFocus = false;
		      }, 100);
		    },
		    handleKeyEnter: function handleKeyEnter() {
		      if (this.suggestionVisible) {
		        this.select(this.suggestions[this.highlightedIndex]);
		      }
		    },
		    handleClickoutside: function handleClickoutside() {
		      this.isFocus = false;
		    },
		    select: function select(item) {
		      var _this3 = this;
	
		      this.$emit('input', item.value);
		      this.$emit('select', item);
		      this.$nextTick(function (_) {
		        _this3.suggestions = [];
		      });
		    },
		    highlight: function highlight(index) {
		      if (!this.suggestionVisible || this.loading) {
		        return;
		      }
		      if (index < 0) {
		        index = 0;
		      } else if (index >= this.suggestions.length) {
		        index = this.suggestions.length - 1;
		      }
		      var elSuggestions = this.$refs.suggestions.$el;
	
		      var elSelect = elSuggestions.children[index];
		      var scrollTop = elSuggestions.scrollTop;
		      var offsetTop = elSelect.offsetTop;
	
		      if (offsetTop + elSelect.scrollHeight > scrollTop + elSuggestions.clientHeight) {
		        elSuggestions.scrollTop += elSelect.scrollHeight;
		      }
		      if (offsetTop < scrollTop) {
		        elSuggestions.scrollTop -= elSelect.scrollHeight;
		      }
	
		      this.highlightedIndex = index;
		    }
		  },
		  mounted: function mounted() {
		    var _this4 = this;
	
		    this.$on('item-click', function (item) {
		      _this4.select(item);
		    });
		  },
		  beforeDestroy: function beforeDestroy() {
		    this.$refs.suggestions.$destroy();
		  }
		};
	
	/***/ },
	/* 18 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(102);
	
	/***/ },
	/* 19 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(146);
	
	/***/ },
	/* 20 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(21)
	
		/* template */
		var __vue_template__ = __webpack_require__(24)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 21 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _vuePopper = __webpack_require__(22);
	
		var _vuePopper2 = _interopRequireDefault(_vuePopper);
	
		var _emitter = __webpack_require__(23);
	
		var _emitter2 = _interopRequireDefault(_emitter);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  mixins: [_vuePopper2.default, _emitter2.default],
	
		  componentName: 'ElAutocompleteSuggestions',
	
		  data: function data() {
		    return {
		      parent: this.$parent,
		      dropdownWidth: ''
		    };
		  },
	
	
		  props: {
		    suggestions: Array,
		    options: {
		      default: function _default() {
		        return {
		          forceAbsolute: true,
		          gpuAcceleration: false
		        };
		      }
		    }
		  },
	
		  methods: {
		    select: function select(item) {
		      this.dispatch('ElAutocomplete', 'item-click', item);
		    }
		  },
	
		  mounted: function mounted() {
		    this.popperElm = this.$el;
		    this.referenceElm = this.$parent.$refs.input.$refs.input;
		  },
		  created: function created() {
		    var _this = this;
	
		    this.$on('visible', function (val, inputWidth) {
		      _this.dropdownWidth = inputWidth + 'px';
		      _this.showPopper = val;
		    });
		  }
		};
	
	/***/ },
	/* 22 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(105);
	
	/***/ },
	/* 23 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(53);
	
	/***/ },
	/* 24 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('transition', {
		    attrs: {
		      "name": "el-zoom-in-top"
		    },
		    on: {
		      "after-leave": _vm.doDestroy
		    }
		  }, [_c('ul', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.showPopper),
		      expression: "showPopper"
		    }],
		    staticClass: "el-autocomplete__suggestions",
		    class: {
		      'is-loading': _vm.parent.loading
		    },
		    style: ({
		      width: _vm.dropdownWidth
		    })
		  }, [(_vm.parent.loading) ? _c('li', [_c('i', {
		    staticClass: "el-icon-loading"
		  })]) : _vm._l((_vm.suggestions), function(item, index) {
		    return [(!_vm.parent.customItem) ? _c('li', {
		      class: {
		        'highlighted': _vm.parent.highlightedIndex === index
		      },
		      on: {
		        "click": function($event) {
		          _vm.select(item)
		        }
		      }
		    }, [_vm._v("\n        " + _vm._s(item.value) + "\n      ")]) : _c(_vm.parent.customItem, {
		      tag: "component",
		      class: {
		        'highlighted': _vm.parent.highlightedIndex === index
		      },
		      attrs: {
		        "item": item,
		        "index": index
		      },
		      on: {
		        "click": function($event) {
		          _vm.select(item)
		        }
		      }
		    })]
		  })], 2)])
		},staticRenderFns: []}
	
	/***/ },
	/* 25 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    directives: [{
		      name: "clickoutside",
		      rawName: "v-clickoutside",
		      value: (_vm.handleClickoutside),
		      expression: "handleClickoutside"
		    }],
		    staticClass: "el-autocomplete"
		  }, [_c('el-input', {
		    ref: "input",
		    attrs: {
		      "value": _vm.value,
		      "disabled": _vm.disabled,
		      "placeholder": _vm.placeholder,
		      "name": _vm.name,
		      "size": _vm.size
		    },
		    on: {
		      "change": _vm.handleChange,
		      "focus": _vm.handleFocus,
		      "blur": _vm.handleBlur
		    },
		    nativeOn: {
		      "keydown": [function($event) {
		        if (_vm._k($event.keyCode, "up", 38)) { return; }
		        _vm.highlight(_vm.highlightedIndex - 1)
		      }, function($event) {
		        if (_vm._k($event.keyCode, "down", 40)) { return; }
		        _vm.highlight(_vm.highlightedIndex + 1)
		      }, function($event) {
		        if (_vm._k($event.keyCode, "enter", 13)) { return; }
		        $event.stopPropagation();
		        _vm.handleKeyEnter($event)
		      }]
		    }
		  }, [(_vm.$slots.prepend) ? _c('template', {
		    slot: "prepend"
		  }, [_vm._t("prepend")], 2) : _vm._e(), (_vm.$slots.append) ? _c('template', {
		    slot: "append"
		  }, [_vm._t("append")], 2) : _vm._e()], 2), _c('el-autocomplete-suggestions', {
		    ref: "suggestions",
		    class: [_vm.popperClass ? _vm.popperClass : ''],
		    attrs: {
		      "suggestions": _vm.suggestions
		    }
		  })], 1)
		},staticRenderFns: []}
	
	/***/ },
	/* 26 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _dropdown = __webpack_require__(27);
	
		var _dropdown2 = _interopRequireDefault(_dropdown);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_dropdown2.default.install = function (Vue) {
		  Vue.component(_dropdown2.default.name, _dropdown2.default);
		};
	
		exports.default = _dropdown2.default;
	
	/***/ },
	/* 27 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(28)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 28 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _clickoutside = __webpack_require__(19);
	
		var _clickoutside2 = _interopRequireDefault(_clickoutside);
	
		var _emitter = __webpack_require__(23);
	
		var _emitter2 = _interopRequireDefault(_emitter);
	
		var _button = __webpack_require__(29);
	
		var _button2 = _interopRequireDefault(_button);
	
		var _buttonGroup = __webpack_require__(30);
	
		var _buttonGroup2 = _interopRequireDefault(_buttonGroup);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  name: 'ElDropdown',
	
		  componentName: 'ElDropdown',
	
		  mixins: [_emitter2.default],
	
		  directives: { Clickoutside: _clickoutside2.default },
	
		  components: {
		    ElButton: _button2.default,
		    ElButtonGroup: _buttonGroup2.default
		  },
	
		  props: {
		    trigger: {
		      type: String,
		      default: 'hover'
		    },
		    menuAlign: {
		      type: String,
		      default: 'end'
		    },
		    type: String,
		    size: String,
		    splitButton: Boolean,
		    hideOnClick: {
		      type: Boolean,
		      default: true
		    }
		  },
	
		  data: function data() {
		    return {
		      timeout: null,
		      visible: false
		    };
		  },
		  mounted: function mounted() {
		    this.$on('menu-item-click', this.handleMenuItemClick);
		    this.initEvent();
		  },
	
	
		  watch: {
		    visible: function visible(val) {
		      this.broadcast('ElDropdownMenu', 'visible', val);
		    }
		  },
	
		  methods: {
		    show: function show() {
		      var _this = this;
	
		      clearTimeout(this.timeout);
		      this.timeout = setTimeout(function () {
		        _this.visible = true;
		      }, 250);
		    },
		    hide: function hide() {
		      var _this2 = this;
	
		      clearTimeout(this.timeout);
		      this.timeout = setTimeout(function () {
		        _this2.visible = false;
		      }, 150);
		    },
		    handleClick: function handleClick() {
		      this.visible = !this.visible;
		    },
		    initEvent: function initEvent() {
		      var trigger = this.trigger,
		          show = this.show,
		          hide = this.hide,
		          handleClick = this.handleClick,
		          splitButton = this.splitButton;
	
		      var triggerElm = splitButton ? this.$refs.trigger.$el : this.$slots.default[0].elm;
	
		      if (trigger === 'hover') {
		        triggerElm.addEventListener('mouseenter', show);
		        triggerElm.addEventListener('mouseleave', hide);
	
		        var dropdownElm = this.$slots.dropdown[0].elm;
	
		        dropdownElm.addEventListener('mouseenter', show);
		        dropdownElm.addEventListener('mouseleave', hide);
		      } else if (trigger === 'click') {
		        triggerElm.addEventListener('click', handleClick);
		      }
		    },
		    handleMenuItemClick: function handleMenuItemClick(command, instance) {
		      if (this.hideOnClick) {
		        this.visible = false;
		      }
		      this.$emit('command', command, instance);
		    }
		  },
	
		  render: function render(h) {
		    var _this3 = this;
	
		    var hide = this.hide,
		        splitButton = this.splitButton,
		        type = this.type,
		        size = this.size;
	
	
		    var handleClick = function handleClick(_) {
		      _this3.$emit('click');
		    };
	
		    var triggerElm = !splitButton ? this.$slots.default : h(
		      'el-button-group',
		      null,
		      [h(
		        'el-button',
		        {
		          attrs: { type: type, size: size },
		          nativeOn: {
		            'click': handleClick
		          }
		        },
		        [this.$slots.default]
		      ), h(
		        'el-button',
		        { ref: 'trigger', attrs: { type: type, size: size },
		          'class': 'el-dropdown__caret-button' },
		        [h(
		          'i',
		          { 'class': 'el-dropdown__icon el-icon-caret-bottom' },
		          []
		        )]
		      )]
		    );
	
		    return h(
		      'div',
		      { 'class': 'el-dropdown', directives: [{
		          name: 'clickoutside',
		          value: hide
		        }]
		      },
		      [triggerElm, this.$slots.dropdown]
		    );
		  }
		};
	
	/***/ },
	/* 29 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(406);
	
	/***/ },
	/* 30 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(405);
	
	/***/ },
	/* 31 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _dropdownMenu = __webpack_require__(32);
	
		var _dropdownMenu2 = _interopRequireDefault(_dropdownMenu);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_dropdownMenu2.default.install = function (Vue) {
		  Vue.component(_dropdownMenu2.default.name, _dropdownMenu2.default);
		};
	
		exports.default = _dropdownMenu2.default;
	
	/***/ },
	/* 32 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(33)
	
		/* template */
		var __vue_template__ = __webpack_require__(34)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 33 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _vuePopper = __webpack_require__(22);
	
		var _vuePopper2 = _interopRequireDefault(_vuePopper);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  name: 'ElDropdownMenu',
	
		  componentName: 'ElDropdownMenu',
	
		  mixins: [_vuePopper2.default],
	
		  created: function created() {
		    var _this = this;
	
		    this.$on('visible', function (val) {
		      _this.showPopper = val;
		    });
		  },
		  mounted: function mounted() {
		    this.$parent.popperElm = this.popperElm = this.$el;
		    this.referenceElm = this.$parent.$el;
		  },
	
	
		  watch: {
		    '$parent.menuAlign': {
		      immediate: true,
		      handler: function handler(val) {
		        this.currentPlacement = 'bottom-' + val;
		      }
		    }
		  }
		}; //
		//
		//
		//
		//
		//
		//
	
	/***/ },
	/* 34 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('transition', {
		    attrs: {
		      "name": "el-zoom-in-top"
		    },
		    on: {
		      "after-leave": _vm.doDestroy
		    }
		  }, [_c('ul', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.showPopper),
		      expression: "showPopper"
		    }],
		    staticClass: "el-dropdown-menu"
		  }, [_vm._t("default")], 2)])
		},staticRenderFns: []}
	
	/***/ },
	/* 35 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _dropdownItem = __webpack_require__(36);
	
		var _dropdownItem2 = _interopRequireDefault(_dropdownItem);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_dropdownItem2.default.install = function (Vue) {
		  Vue.component(_dropdownItem2.default.name, _dropdownItem2.default);
		};
	
		exports.default = _dropdownItem2.default;
	
	/***/ },
	/* 36 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(37)
	
		/* template */
		var __vue_template__ = __webpack_require__(38)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 37 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _emitter = __webpack_require__(23);
	
		var _emitter2 = _interopRequireDefault(_emitter);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  name: 'ElDropdownItem',
	
		  mixins: [_emitter2.default],
	
		  props: {
		    command: String,
		    disabled: Boolean,
		    divided: Boolean
		  },
	
		  methods: {
		    handleClick: function handleClick(e) {
		      this.dispatch('ElDropdown', 'menu-item-click', [this.command, this]);
		    }
		  }
		}; //
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
	/***/ },
	/* 38 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('li', {
		    staticClass: "el-dropdown-menu__item",
		    class: {
		      'is-disabled': _vm.disabled,
		      'el-dropdown-menu__item--divided': _vm.divided
		    },
		    on: {
		      "click": _vm.handleClick
		    }
		  }, [_vm._t("default")], 2)
		},staticRenderFns: []}
	
	/***/ },
	/* 39 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _menu = __webpack_require__(40);
	
		var _menu2 = _interopRequireDefault(_menu);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_menu2.default.install = function (Vue) {
		  Vue.component(_menu2.default.name, _menu2.default);
		};
	
		exports.default = _menu2.default;
	
	/***/ },
	/* 40 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(41)
	
		/* template */
		var __vue_template__ = __webpack_require__(42)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 41 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _emitter = __webpack_require__(23);
	
		var _emitter2 = _interopRequireDefault(_emitter);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  name: 'ElMenu',
	
		  componentName: 'ElMenu',
	
		  mixins: [_emitter2.default],
	
		  props: {
		    mode: {
		      type: String,
		      default: 'vertical'
		    },
		    defaultActive: {
		      type: String,
		      default: ''
		    },
		    defaultOpeneds: Array,
		    theme: {
		      type: String,
		      default: 'light'
		    },
		    uniqueOpened: Boolean,
		    router: Boolean,
		    menuTrigger: {
		      type: String,
		      default: 'hover'
		    }
		  },
		  data: function data() {
		    return {
		      activedIndex: this.defaultActive,
		      openedMenus: this.defaultOpeneds ? this.defaultOpeneds.slice(0) : [],
		      items: {},
		      submenus: {}
		    };
		  },
	
		  watch: {
		    defaultActive: function defaultActive(value) {
		      var item = this.items[value];
		      if (!item) return;
	
		      this.activedIndex = item.index;
		      this.initOpenedMenu();
		    },
		    defaultOpeneds: function defaultOpeneds(value) {
		      this.openedMenus = value;
		    }
		  },
		  methods: {
		    addItem: function addItem(item) {
		      this.$set(this.items, item.index, item);
		    },
		    removeItem: function removeItem(item) {
		      delete this.items[item.index];
		    },
		    addSubmenu: function addSubmenu(item) {
		      this.$set(this.submenus, item.index, item);
		    },
		    removeSubmenu: function removeSubmenu(item) {
		      delete this.submenus[item.index];
		    },
		    openMenu: function openMenu(index, indexPath) {
		      var openedMenus = this.openedMenus;
		      if (openedMenus.indexOf(index) !== -1) return;
		      // 将不在该菜单路径下的其余菜单收起
		      if (this.uniqueOpened) {
		        this.openedMenus = openedMenus.filter(function (index) {
		          return indexPath.indexOf(index) !== -1;
		        });
		      }
		      this.openedMenus.push(index);
		    },
		    closeMenu: function closeMenu(index, indexPath) {
		      this.openedMenus.splice(this.openedMenus.indexOf(index), 1);
		    },
		    handleSubmenuClick: function handleSubmenuClick(submenu) {
		      var index = submenu.index,
		          indexPath = submenu.indexPath;
	
		      var isOpened = this.openedMenus.indexOf(index) !== -1;
	
		      if (isOpened) {
		        this.closeMenu(index, indexPath);
		        this.$emit('close', index, indexPath);
		      } else {
		        this.openMenu(index, indexPath);
		        this.$emit('open', index, indexPath);
		      }
		    },
		    handleItemClick: function handleItemClick(item) {
		      var index = item.index,
		          indexPath = item.indexPath;
	
		      this.activedIndex = item.index;
		      this.$emit('select', index, indexPath, item);
	
		      if (this.mode === 'horizontal') {
		        this.openedMenus = [];
		      }
	
		      if (this.router) {
		        this.routeToItem(item);
		      }
		    },
	
		    // 初始化展开菜单
		    initOpenedMenu: function initOpenedMenu() {
		      var _this = this;
	
		      var index = this.activedIndex;
		      var activeItem = this.items[index];
		      if (!activeItem || this.mode === 'horizontal') return;
	
		      var indexPath = activeItem.indexPath;
	
		      // 展开该菜单项的路径上所有子菜单
		      indexPath.forEach(function (index) {
		        var submenu = _this.submenus[index];
		        submenu && _this.openMenu(index, submenu.indexPath);
		      });
		    },
		    routeToItem: function routeToItem(item) {
		      var route = item.route || item.index;
		      try {
		        this.$router.push(route);
		      } catch (e) {
		        console.error(e);
		      }
		    }
		  },
		  mounted: function mounted() {
		    this.initOpenedMenu();
		    this.$on('item-click', this.handleItemClick);
		    this.$on('submenu-click', this.handleSubmenuClick);
		  }
		}; //
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
	/***/ },
	/* 42 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('ul', {
		    staticClass: "el-menu",
		    class: {
		      'el-menu--horizontal': _vm.mode === 'horizontal',
		        'el-menu--dark': _vm.theme === 'dark'
		    }
		  }, [_vm._t("default")], 2)
		},staticRenderFns: []}
	
	/***/ },
	/* 43 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _submenu = __webpack_require__(44);
	
		var _submenu2 = _interopRequireDefault(_submenu);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_submenu2.default.install = function (Vue) {
		  Vue.component(_submenu2.default.name, _submenu2.default);
		};
	
		exports.default = _submenu2.default;
	
	/***/ },
	/* 44 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(45)
	
		/* template */
		var __vue_template__ = __webpack_require__(48)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 45 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _menuMixin = __webpack_require__(46);
	
		var _menuMixin2 = _interopRequireDefault(_menuMixin);
	
		var _emitter = __webpack_require__(23);
	
		var _emitter2 = _interopRequireDefault(_emitter);
	
		var _collapseTransition = __webpack_require__(47);
	
		var _collapseTransition2 = _interopRequireDefault(_collapseTransition);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		module.exports = {
		  name: 'ElSubmenu',
	
		  componentName: 'ElSubmenu',
	
		  mixins: [_menuMixin2.default, _emitter2.default],
	
		  components: {
		    CollapseTransition: _collapseTransition2.default
		  },
	
		  props: {
		    index: {
		      type: String,
		      required: true
		    }
		  },
		  data: function data() {
		    return {
		      timeout: null,
		      items: {},
		      submenus: {}
		    };
		  },
	
		  computed: {
		    opened: function opened() {
		      return this.rootMenu.openedMenus.indexOf(this.index) > -1;
		    },
	
		    active: {
		      cache: false,
		      get: function get() {
		        var isActive = false;
		        var submenus = this.submenus;
		        var items = this.items;
	
		        Object.keys(items).forEach(function (index) {
		          if (items[index].active) {
		            isActive = true;
		          }
		        });
	
		        Object.keys(submenus).forEach(function (index) {
		          if (submenus[index].active) {
		            isActive = true;
		          }
		        });
	
		        return isActive;
		      }
		    }
		  },
		  methods: {
		    addItem: function addItem(item) {
		      this.$set(this.items, item.index, item);
		    },
		    removeItem: function removeItem(item) {
		      delete this.items[item.index];
		    },
		    addSubmenu: function addSubmenu(item) {
		      this.$set(this.submenus, item.index, item);
		    },
		    removeSubmenu: function removeSubmenu(item) {
		      delete this.submenus[item.index];
		    },
		    handleClick: function handleClick() {
		      this.dispatch('ElMenu', 'submenu-click', this);
		    },
		    handleMouseenter: function handleMouseenter() {
		      var _this = this;
	
		      clearTimeout(this.timeout);
		      this.timeout = setTimeout(function () {
		        _this.rootMenu.openMenu(_this.index, _this.indexPath);
		      }, 300);
		    },
		    handleMouseleave: function handleMouseleave() {
		      var _this2 = this;
	
		      clearTimeout(this.timeout);
		      this.timeout = setTimeout(function () {
		        _this2.rootMenu.closeMenu(_this2.index, _this2.indexPath);
		      }, 300);
		    },
		    initEvents: function initEvents() {
		      var rootMenu = this.rootMenu,
		          handleMouseenter = this.handleMouseenter,
		          handleMouseleave = this.handleMouseleave,
		          handleClick = this.handleClick;
	
		      var triggerElm = void 0;
	
		      if (rootMenu.mode === 'horizontal' && rootMenu.menuTrigger === 'hover') {
		        triggerElm = this.$el;
		        triggerElm.addEventListener('mouseenter', handleMouseenter);
		        triggerElm.addEventListener('mouseleave', handleMouseleave);
		      } else {
		        triggerElm = this.$refs['submenu-title'];
		        triggerElm.addEventListener('click', handleClick);
		      }
		    }
		  },
		  created: function created() {
		    this.parentMenu.addSubmenu(this);
		    this.rootMenu.addSubmenu(this);
		  },
		  beforeDestroy: function beforeDestroy() {
		    this.parentMenu.removeSubmenu(this);
		    this.rootMenu.removeSubmenu(this);
		  },
		  mounted: function mounted() {
		    this.initEvents();
		  }
		}; //
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
	/***/ },
	/* 46 */
	/***/ function(module, exports) {
	
		'use strict';
	
		module.exports = {
		  computed: {
		    indexPath: function indexPath() {
		      var path = [this.index];
		      var parent = this.$parent;
		      while (parent.$options.componentName !== 'ElMenu') {
		        if (parent.index) {
		          path.unshift(parent.index);
		        }
		        parent = parent.$parent;
		      }
		      return path;
		    },
		    rootMenu: function rootMenu() {
		      var parent = this.$parent;
		      while (parent && parent.$options.componentName !== 'ElMenu') {
		        parent = parent.$parent;
		      }
		      return parent;
		    },
		    parentMenu: function parentMenu() {
		      var parent = this.$parent;
		      while (parent && ['ElMenu', 'ElSubmenu'].indexOf(parent.$options.componentName) === -1) {
		        parent = parent.$parent;
		      }
		      return parent;
		    },
		    paddingStyle: function paddingStyle() {
		      if (this.rootMenu.mode !== 'vertical') return {};
	
		      var padding = 20;
		      var parent = this.$parent;
		      while (parent && parent.$options.componentName !== 'ElMenu') {
		        if (parent.$options.componentName === 'ElSubmenu') {
		          padding += 20;
		        }
		        parent = parent.$parent;
		      }
		      return { paddingLeft: padding + 'px' };
		    }
		  }
		};
	
	/***/ },
	/* 47 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(418);
	
	/***/ },
	/* 48 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('li', {
		    class: {
		      'el-submenu': true,
		      'is-active': _vm.active,
		      'is-opened': _vm.opened
		    }
		  }, [_c('div', {
		    ref: "submenu-title",
		    staticClass: "el-submenu__title",
		    style: (_vm.paddingStyle)
		  }, [_vm._t("title"), _c('i', {
		    class: {
		      'el-submenu__icon-arrow': true,
		      'el-icon-arrow-down': _vm.rootMenu.mode === 'vertical',
		        'el-icon-caret-bottom': _vm.rootMenu.mode === 'horizontal'
		    }
		  })], 2), (_vm.rootMenu.mode === 'horizontal') ? [_c('transition', {
		    attrs: {
		      "name": "el-zoom-in-top"
		    }
		  }, [_c('ul', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.opened),
		      expression: "opened"
		    }],
		    staticClass: "el-menu"
		  }, [_vm._t("default")], 2)])] : _c('collapse-transition', [_c('ul', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.opened),
		      expression: "opened"
		    }],
		    staticClass: "el-menu"
		  }, [_vm._t("default")], 2)])], 2)
		},staticRenderFns: []}
	
	/***/ },
	/* 49 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _menuItem = __webpack_require__(50);
	
		var _menuItem2 = _interopRequireDefault(_menuItem);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_menuItem2.default.install = function (Vue) {
		  Vue.component(_menuItem2.default.name, _menuItem2.default);
		};
	
		exports.default = _menuItem2.default;
	
	/***/ },
	/* 50 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(51)
	
		/* template */
		var __vue_template__ = __webpack_require__(52)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 51 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _menuMixin = __webpack_require__(46);
	
		var _menuMixin2 = _interopRequireDefault(_menuMixin);
	
		var _emitter = __webpack_require__(23);
	
		var _emitter2 = _interopRequireDefault(_emitter);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		module.exports = {
		  name: 'ElMenuItem',
	
		  componentName: 'ElMenuItem',
	
		  mixins: [_menuMixin2.default, _emitter2.default],
	
		  props: {
		    index: {
		      type: String,
		      required: true
		    },
		    route: {
		      type: Object,
		      required: false
		    },
		    disabled: {
		      type: Boolean,
		      required: false
		    }
		  },
		  computed: {
		    active: function active() {
		      return this.index === this.rootMenu.activedIndex;
		    }
		  },
		  methods: {
		    handleClick: function handleClick() {
		      this.dispatch('ElMenu', 'item-click', this);
		    }
		  },
		  created: function created() {
		    this.parentMenu.addItem(this);
		    this.rootMenu.addItem(this);
		  },
		  beforeDestroy: function beforeDestroy() {
		    this.parentMenu.removeItem(this);
		    this.rootMenu.removeItem(this);
		  }
		};
	
	/***/ },
	/* 52 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('li', {
		    staticClass: "el-menu-item",
		    class: {
		      'is-active': _vm.active,
		      'is-disabled': _vm.disabled
		    },
		    style: (_vm.paddingStyle),
		    on: {
		      "click": _vm.handleClick
		    }
		  }, [_vm._t("default")], 2)
		},staticRenderFns: []}
	
	/***/ },
	/* 53 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _menuItemGroup = __webpack_require__(54);
	
		var _menuItemGroup2 = _interopRequireDefault(_menuItemGroup);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_menuItemGroup2.default.install = function (Vue) {
		  Vue.component(_menuItemGroup2.default.name, _menuItemGroup2.default);
		};
	
		exports.default = _menuItemGroup2.default;
	
	/***/ },
	/* 54 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(55)
	
		/* template */
		var __vue_template__ = __webpack_require__(56)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 55 */
	/***/ function(module, exports) {
	
		'use strict';
	
		module.exports = {
		  name: 'ElMenuItemGroup',
	
		  componentName: 'ElMenuItemGroup',
	
		  props: {
		    title: {
		      type: String
		    }
		  },
		  data: function data() {
		    return {
		      paddingLeft: 20
		    };
		  },
	
		  computed: {
		    levelPadding: function levelPadding() {
		      var padding = 10;
		      var parent = this.$parent;
		      while (parent && parent.$options.componentName !== 'ElMenu') {
		        if (parent.$options.componentName === 'ElSubmenu') {
		          padding += 20;
		        }
		        parent = parent.$parent;
		      }
		      padding === 10 && (padding = 20);
		      return padding;
		    }
		  }
		};
	
	/***/ },
	/* 56 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('li', {
		    staticClass: "el-menu-item-group"
		  }, [_c('div', {
		    staticClass: "el-menu-item-group__title",
		    style: ({
		      paddingLeft: _vm.levelPadding + 'px'
		    })
		  }, [(!_vm.$slots.title) ? [_vm._v(_vm._s(_vm.title))] : _vm._t("title")], 2), _c('ul', [_vm._t("default")], 2)])
		},staticRenderFns: []}
	
	/***/ },
	/* 57 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _input = __webpack_require__(58);
	
		var _input2 = _interopRequireDefault(_input);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_input2.default.install = function (Vue) {
		  Vue.component(_input2.default.name, _input2.default);
		};
	
		exports.default = _input2.default;
	
	/***/ },
	/* 58 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(59)
	
		/* template */
		var __vue_template__ = __webpack_require__(62)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 59 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _emitter = __webpack_require__(23);
	
		var _emitter2 = _interopRequireDefault(_emitter);
	
		var _calcTextareaHeight = __webpack_require__(60);
	
		var _calcTextareaHeight2 = _interopRequireDefault(_calcTextareaHeight);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  name: 'ElInput',
	
		  componentName: 'ElInput',
	
		  mixins: [_emitter2.default],
	
		  data: function data() {
		    return {
		      currentValue: this.value,
		      textareaStyle: {}
		    };
		  },
	
	
		  props: {
		    value: [String, Number],
		    placeholder: String,
		    size: String,
		    resize: String,
		    readonly: Boolean,
		    autofocus: Boolean,
		    icon: String,
		    disabled: Boolean,
		    type: {
		      type: String,
		      default: 'text'
		    },
		    name: String,
		    autosize: {
		      type: [Boolean, Object],
		      default: false
		    },
		    rows: {
		      type: Number,
		      default: 2
		    },
		    autoComplete: {
		      type: String,
		      default: 'off'
		    },
		    form: String,
		    maxlength: Number,
		    minlength: Number,
		    max: {},
		    min: {},
		    validateEvent: {
		      type: Boolean,
		      default: true
		    },
		    onIconClick: Function
		  },
	
		  computed: {
		    validating: function validating() {
		      return this.$parent.validateState === 'validating';
		    }
		  },
	
		  watch: {
		    'value': function value(val, oldValue) {
		      this.setCurrentValue(val);
		    }
		  },
	
		  methods: {
		    handleBlur: function handleBlur(event) {
		      this.$emit('blur', event);
		      if (this.validateEvent) {
		        this.dispatch('ElFormItem', 'el.form.blur', [this.currentValue]);
		      }
		    },
		    inputSelect: function inputSelect() {
		      this.$refs.input.select();
		    },
		    resizeTextarea: function resizeTextarea() {
		      if (this.$isServer) return;
		      var autosize = this.autosize,
		          type = this.type;
	
		      if (!autosize || type !== 'textarea') return;
		      var minRows = autosize.minRows;
		      var maxRows = autosize.maxRows;
	
		      var options = {
		        resize: this.resize
		      };
		      this.textareaStyle = (0, _calcTextareaHeight2.default)(this.$refs.textarea, minRows, maxRows, options);
		    },
		    handleFocus: function handleFocus(event) {
		      this.$emit('focus', event);
		    },
		    handleInput: function handleInput(event) {
		      this.setCurrentValue(event.target.value);
		    },
		    handleIconClick: function handleIconClick(event) {
		      if (this.onIconClick) {
		        this.onIconClick(event);
		      }
		      this.$emit('click', event);
		    },
		    setCurrentValue: function setCurrentValue(value) {
		      var _this = this;
	
		      if (value === this.currentValue) return;
		      this.$nextTick(function (_) {
		        _this.resizeTextarea();
		      });
		      this.currentValue = value;
		      this.$emit('input', value);
		      this.$emit('change', value);
		      if (this.validateEvent) {
		        this.dispatch('ElFormItem', 'el.form.change', [value]);
		      }
		    }
		  },
	
		  created: function created() {
		    this.$on('inputSelect', this.inputSelect);
		  },
		  mounted: function mounted() {
		    this.resizeTextarea();
		  }
		};
	
	/***/ },
	/* 60 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.default = calcTextareaHeight;
	
		var _merge = __webpack_require__(61);
	
		var _merge2 = _interopRequireDefault(_merge);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var hiddenTextarea = void 0;
	
		var HIDDEN_STYLE = '\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n';
	
		var CONTEXT_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];
	
		function calculateNodeStyling(node) {
		  var style = window.getComputedStyle(node);
	
		  var boxSizing = style.getPropertyValue('box-sizing');
	
		  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
	
		  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
	
		  var contextStyle = CONTEXT_STYLE.map(function (name) {
		    return name + ':' + style.getPropertyValue(name);
		  }).join(';');
	
		  return { contextStyle: contextStyle, paddingSize: paddingSize, borderSize: borderSize, boxSizing: boxSizing };
		}
	
		function calcTextareaHeight(targetNode) {
		  var minRows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
		  var maxRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
		  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
		  if (!hiddenTextarea) {
		    hiddenTextarea = document.createElement('textarea');
		    document.body.appendChild(hiddenTextarea);
		  }
	
		  var _calculateNodeStyling = calculateNodeStyling(targetNode),
		      paddingSize = _calculateNodeStyling.paddingSize,
		      borderSize = _calculateNodeStyling.borderSize,
		      boxSizing = _calculateNodeStyling.boxSizing,
		      contextStyle = _calculateNodeStyling.contextStyle;
	
		  hiddenTextarea.setAttribute('style', contextStyle + ';' + HIDDEN_STYLE);
		  hiddenTextarea.value = targetNode.value || targetNode.placeholder || '';
	
		  var height = hiddenTextarea.scrollHeight;
	
		  if (boxSizing === 'border-box') {
		    height = height + borderSize;
		  } else if (boxSizing === 'content-box') {
		    height = height - paddingSize;
		  }
	
		  hiddenTextarea.value = '';
		  var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
	
		  if (minRows !== null) {
		    var minHeight = singleRowHeight * minRows;
		    if (boxSizing === 'border-box') {
		      minHeight = minHeight + paddingSize + borderSize;
		    }
		    height = Math.max(minHeight, height);
		  }
		  if (maxRows !== null) {
		    var maxHeight = singleRowHeight * maxRows;
		    if (boxSizing === 'border-box') {
		      maxHeight = maxHeight + paddingSize + borderSize;
		    }
		    height = Math.min(maxHeight, height);
		  }
	
		  return (0, _merge2.default)({ height: height + 'px' }, options);
		};
	
	/***/ },
	/* 61 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(69);
	
	/***/ },
	/* 62 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    class: [
		      _vm.type === 'textarea' ? 'el-textarea' : 'el-input',
		      _vm.size ? 'el-input--' + _vm.size : '', {
		        'is-disabled': _vm.disabled,
		        'el-input-group': _vm.$slots.prepend || _vm.$slots.append,
		        'el-input-group--append': _vm.$slots.append,
		        'el-input-group--prepend': _vm.$slots.prepend
		      }
		    ]
		  }, [(_vm.type !== 'textarea') ? [(_vm.$slots.prepend) ? _c('div', {
		    staticClass: "el-input-group__prepend"
		  }, [_vm._t("prepend")], 2) : _vm._e(), _vm._t("icon", [(_vm.icon) ? _c('i', {
		    staticClass: "el-input__icon",
		    class: [
		      'el-icon-' + _vm.icon,
		      _vm.onIconClick ? 'is-clickable' : ''
		    ],
		    on: {
		      "click": _vm.handleIconClick
		    }
		  }) : _vm._e()]), (_vm.type !== 'textarea') ? _c('input', {
		    ref: "input",
		    staticClass: "el-input__inner",
		    attrs: {
		      "type": _vm.type,
		      "name": _vm.name,
		      "placeholder": _vm.placeholder,
		      "disabled": _vm.disabled,
		      "readonly": _vm.readonly,
		      "maxlength": _vm.maxlength,
		      "minlength": _vm.minlength,
		      "autocomplete": _vm.autoComplete,
		      "autofocus": _vm.autofocus,
		      "min": _vm.min,
		      "max": _vm.max,
		      "form": _vm.form
		    },
		    domProps: {
		      "value": _vm.currentValue
		    },
		    on: {
		      "input": _vm.handleInput,
		      "focus": _vm.handleFocus,
		      "blur": _vm.handleBlur
		    }
		  }) : _vm._e(), (_vm.validating) ? _c('i', {
		    staticClass: "el-input__icon el-icon-loading"
		  }) : _vm._e(), (_vm.$slots.append) ? _c('div', {
		    staticClass: "el-input-group__append"
		  }, [_vm._t("append")], 2) : _vm._e()] : _c('textarea', {
		    ref: "textarea",
		    staticClass: "el-textarea__inner",
		    style: (_vm.textareaStyle),
		    attrs: {
		      "name": _vm.name,
		      "placeholder": _vm.placeholder,
		      "disabled": _vm.disabled,
		      "readonly": _vm.readonly,
		      "rows": _vm.rows,
		      "form": _vm.form,
		      "autofocus": _vm.autofocus,
		      "maxlength": _vm.maxlength,
		      "minlength": _vm.minlength
		    },
		    domProps: {
		      "value": _vm.currentValue
		    },
		    on: {
		      "input": _vm.handleInput,
		      "focus": _vm.handleFocus,
		      "blur": _vm.handleBlur
		    }
		  })], 2)
		},staticRenderFns: []}
	
	/***/ },
	/* 63 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _inputNumber = __webpack_require__(64);
	
		var _inputNumber2 = _interopRequireDefault(_inputNumber);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_inputNumber2.default.install = function (Vue) {
		  Vue.component(_inputNumber2.default.name, _inputNumber2.default);
		};
	
		exports.default = _inputNumber2.default;
	
	/***/ },
	/* 64 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(65)
	
		/* template */
		var __vue_template__ = __webpack_require__(67)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 65 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _input = __webpack_require__(18);
	
		var _input2 = _interopRequireDefault(_input);
	
		var _dom = __webpack_require__(66);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  name: 'ElInputNumber',
		  directives: {
		    repeatClick: {
		      bind: function bind(el, binding, vnode) {
		        var interval = null;
		        var startTime = void 0;
		        var handler = function handler() {
		          return vnode.context[binding.expression].apply();
		        };
		        var clear = function clear() {
		          if (new Date() - startTime < 100) {
		            handler();
		          }
		          clearInterval(interval);
		          interval = null;
		        };
	
		        (0, _dom.on)(el, 'mousedown', function () {
		          startTime = new Date();
		          (0, _dom.once)(document, 'mouseup', clear);
		          interval = setInterval(handler, 100);
		        });
		      }
		    }
		  },
		  components: {
		    ElInput: _input2.default
		  },
		  props: {
		    step: {
		      type: Number,
		      default: 1
		    },
		    max: {
		      type: Number,
		      default: Infinity
		    },
		    min: {
		      type: Number,
		      default: -Infinity
		    },
		    value: {
		      default: 0
		    },
		    disabled: Boolean,
		    size: String,
		    controls: {
		      type: Boolean,
		      default: true
		    }
		  },
		  data: function data() {
		    return {
		      currentValue: 0
		    };
		  },
	
		  watch: {
		    value: {
		      immediate: true,
		      handler: function handler(value) {
		        var newVal = Number(value);
		        if (isNaN(newVal)) return;
		        if (newVal >= this.max) newVal = this.max;
		        if (newVal <= this.min) newVal = this.min;
		        this.currentValue = newVal;
		        this.$emit('input', newVal);
		      }
		    }
		  },
		  computed: {
		    minDisabled: function minDisabled() {
		      return this._decrease(this.value, this.step) < this.min;
		    },
		    maxDisabled: function maxDisabled() {
		      return this._increase(this.value, this.step) > this.max;
		    },
		    precision: function precision() {
		      var value = this.value,
		          step = this.step,
		          getPrecision = this.getPrecision;
	
		      return Math.max(getPrecision(value), getPrecision(step));
		    }
		  },
		  methods: {
		    toPrecision: function toPrecision(num, precision) {
		      if (precision === undefined) precision = this.precision;
		      return parseFloat(parseFloat(Number(num).toFixed(precision)));
		    },
		    getPrecision: function getPrecision(value) {
		      var valueString = value.toString();
		      var dotPosition = valueString.indexOf('.');
		      var precision = 0;
		      if (dotPosition !== -1) {
		        precision = valueString.length - dotPosition - 1;
		      }
		      return precision;
		    },
		    _increase: function _increase(val, step) {
		      if (typeof val !== 'number') return this.currentValue;
	
		      var precisionFactor = Math.pow(10, this.precision);
	
		      return this.toPrecision((precisionFactor * val + precisionFactor * step) / precisionFactor);
		    },
		    _decrease: function _decrease(val, step) {
		      if (typeof val !== 'number') return this.currentValue;
	
		      var precisionFactor = Math.pow(10, this.precision);
	
		      return this.toPrecision((precisionFactor * val - precisionFactor * step) / precisionFactor);
		    },
		    increase: function increase() {
		      if (this.disabled || this.maxDisabled) return;
		      var value = this.value || 0;
		      var newVal = this._increase(value, this.step);
		      if (newVal > this.max) return;
		      this.setCurrentValue(newVal);
		    },
		    decrease: function decrease() {
		      if (this.disabled || this.minDisabled) return;
		      var value = this.value || 0;
		      var newVal = this._decrease(value, this.step);
		      if (newVal < this.min) return;
		      this.setCurrentValue(newVal);
		    },
		    handleBlur: function handleBlur() {
		      this.$refs.input.setCurrentValue(this.currentValue);
		    },
		    setCurrentValue: function setCurrentValue(newVal) {
		      var oldVal = this.currentValue;
		      if (newVal >= this.max) newVal = this.max;
		      if (newVal <= this.min) newVal = this.min;
		      if (oldVal === newVal) return;
		      this.$emit('change', newVal, oldVal);
		      this.$emit('input', newVal);
		      this.currentValue = newVal;
		    },
		    handleInput: function handleInput(value) {
		      var newVal = Number(value);
		      if (!isNaN(newVal)) {
		        this.setCurrentValue(newVal);
		      }
		    }
		  }
		};
	
	/***/ },
	/* 66 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(47);
	
	/***/ },
	/* 67 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    staticClass: "el-input-number",
		    class: [
		      _vm.size ? 'el-input-number--' + _vm.size : '', {
		        'is-disabled': _vm.disabled
		      }, {
		        'is-without-controls': !_vm.controls
		      }
		    ]
		  }, [(_vm.controls) ? _c('span', {
		    directives: [{
		      name: "repeat-click",
		      rawName: "v-repeat-click",
		      value: (_vm.decrease),
		      expression: "decrease"
		    }],
		    staticClass: "el-input-number__decrease el-icon-minus",
		    class: {
		      'is-disabled': _vm.minDisabled
		    }
		  }) : _vm._e(), (_vm.controls) ? _c('span', {
		    directives: [{
		      name: "repeat-click",
		      rawName: "v-repeat-click",
		      value: (_vm.increase),
		      expression: "increase"
		    }],
		    staticClass: "el-input-number__increase el-icon-plus",
		    class: {
		      'is-disabled': _vm.maxDisabled
		    }
		  }) : _vm._e(), _c('el-input', {
		    ref: "input",
		    attrs: {
		      "value": _vm.currentValue,
		      "disabled": _vm.disabled,
		      "size": _vm.size,
		      "max": _vm.max,
		      "min": _vm.min
		    },
		    on: {
		      "blur": _vm.handleBlur,
		      "input": _vm.handleInput
		    },
		    nativeOn: {
		      "keydown": [function($event) {
		        if (_vm._k($event.keyCode, "up", 38)) { return; }
		        $event.preventDefault();
		        _vm.increase($event)
		      }, function($event) {
		        if (_vm._k($event.keyCode, "down", 40)) { return; }
		        $event.preventDefault();
		        _vm.decrease($event)
		      }]
		    }
		  }, [(_vm.$slots.prepend) ? _c('template', {
		    slot: "prepend"
		  }, [_vm._t("prepend")], 2) : _vm._e(), (_vm.$slots.append) ? _c('template', {
		    slot: "append"
		  }, [_vm._t("append")], 2) : _vm._e()], 2)], 1)
		},staticRenderFns: []}
	
	/***/ },
	/* 68 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _radio = __webpack_require__(69);
	
		var _radio2 = _interopRequireDefault(_radio);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_radio2.default.install = function (Vue) {
		  Vue.component('el-radio', _radio2.default);
		};
	
		exports.default = _radio2.default;
	
	/***/ },
	/* 69 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(70)
	
		/* template */
		var __vue_template__ = __webpack_require__(71)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 70 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _emitter = __webpack_require__(23);
	
		var _emitter2 = _interopRequireDefault(_emitter);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  name: 'ElRadio',
	
		  mixins: [_emitter2.default],
	
		  componentName: 'ElRadio',
	
		  props: {
		    value: {},
		    label: {},
		    disabled: Boolean,
		    name: String
		  },
	
		  data: function data() {
		    return {
		      focus: false
		    };
		  },
	
	
		  computed: {
		    isGroup: function isGroup() {
		      var parent = this.$parent;
		      while (parent) {
		        if (parent.$options.componentName !== 'ElRadioGroup') {
		          parent = parent.$parent;
		        } else {
		          this._radioGroup = parent;
		          return true;
		        }
		      }
		      return false;
		    },
	
	
		    model: {
		      get: function get() {
		        return this.isGroup ? this._radioGroup.value : this.value;
		      },
		      set: function set(val) {
		        if (this.isGroup) {
		          this.dispatch('ElRadioGroup', 'input', [val]);
		        } else {
		          this.$emit('input', val);
		        }
		      }
		    },
	
		    isDisabled: function isDisabled() {
		      return this.isGroup ? this._radioGroup.disabled || this.disabled : this.disabled;
		    }
		  }
		}; //
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
	/***/ },
	/* 71 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('label', {
		    staticClass: "el-radio"
		  }, [_c('span', {
		    staticClass: "el-radio__input",
		    class: {
		      'is-disabled': _vm.isDisabled,
		      'is-checked': _vm.model === _vm.label,
		        'is-focus': _vm.focus
		    }
		  }, [_c('span', {
		    staticClass: "el-radio__inner"
		  }), _c('input', {
		    directives: [{
		      name: "model",
		      rawName: "v-model",
		      value: (_vm.model),
		      expression: "model"
		    }],
		    staticClass: "el-radio__original",
		    attrs: {
		      "type": "radio",
		      "name": _vm.name,
		      "disabled": _vm.isDisabled
		    },
		    domProps: {
		      "value": _vm.label,
		      "checked": _vm._q(_vm.model, _vm.label)
		    },
		    on: {
		      "focus": function($event) {
		        _vm.focus = true
		      },
		      "blur": function($event) {
		        _vm.focus = false
		      },
		      "change": function($event) {
		        _vm.model = _vm.label
		      }
		    }
		  })]), _c('span', {
		    staticClass: "el-radio__label"
		  }, [_vm._t("default"), (!_vm.$slots.default) ? [_vm._v(_vm._s(_vm.label))] : _vm._e()], 2)])
		},staticRenderFns: []}
	
	/***/ },
	/* 72 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _radioGroup = __webpack_require__(73);
	
		var _radioGroup2 = _interopRequireDefault(_radioGroup);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_radioGroup2.default.install = function (Vue) {
		  Vue.component(_radioGroup2.default.name, _radioGroup2.default);
		};
	
		exports.default = _radioGroup2.default;
	
	/***/ },
	/* 73 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(74)
	
		/* template */
		var __vue_template__ = __webpack_require__(75)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 74 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _emitter = __webpack_require__(23);
	
		var _emitter2 = _interopRequireDefault(_emitter);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  name: 'ElRadioGroup',
	
		  componentName: 'ElRadioGroup',
	
		  mixins: [_emitter2.default],
	
		  props: {
		    value: [String, Number],
		    size: String,
		    fill: String,
		    textColor: String,
		    disabled: Boolean
		  },
		  watch: {
		    value: function value(_value) {
		      this.$emit('change', _value);
		      this.dispatch('ElFormItem', 'el.form.change', [this.value]);
		    }
		  }
		}; //
		//
		//
		//
		//
	
	/***/ },
	/* 75 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    staticClass: "el-radio-group"
		  }, [_vm._t("default")], 2)
		},staticRenderFns: []}
	
	/***/ },
	/* 76 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _radioButton = __webpack_require__(77);
	
		var _radioButton2 = _interopRequireDefault(_radioButton);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_radioButton2.default.install = function (Vue) {
		  Vue.component(_radioButton2.default.name, _radioButton2.default);
		};
	
		exports.default = _radioButton2.default;
	
	/***/ },
	/* 77 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(78)
	
		/* template */
		var __vue_template__ = __webpack_require__(79)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 78 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  name: 'ElRadioButton',
	
		  props: {
		    label: {},
		    disabled: Boolean,
		    name: String
		  },
		  computed: {
		    value: {
		      get: function get() {
		        return this._radioGroup.value;
		      },
		      set: function set(value) {
		        this._radioGroup.$emit('input', value);
		      }
		    },
		    _radioGroup: function _radioGroup() {
		      var parent = this.$parent;
		      while (parent) {
		        if (parent.$options.componentName !== 'ElRadioGroup') {
		          parent = parent.$parent;
		        } else {
		          return parent;
		        }
		      }
		      return false;
		    },
		    activeStyle: function activeStyle() {
		      return {
		        backgroundColor: this._radioGroup.fill || '',
		        borderColor: this._radioGroup.fill || '',
		        color: this._radioGroup.textColor || ''
		      };
		    },
		    size: function size() {
		      return this._radioGroup.size;
		    },
		    isDisabled: function isDisabled() {
		      return this.disabled || this._radioGroup.disabled;
		    }
		  }
		};
	
	/***/ },
	/* 79 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('label', {
		    staticClass: "el-radio-button",
		    class: [
		      _vm.size ? 'el-radio-button--' + _vm.size : '', {
		        'is-active': _vm.value === _vm.label
		      }, {
		        'is-disabled': _vm.isDisabled
		      }
		    ]
		  }, [_c('input', {
		    directives: [{
		      name: "model",
		      rawName: "v-model",
		      value: (_vm.value),
		      expression: "value"
		    }],
		    staticClass: "el-radio-button__orig-radio",
		    attrs: {
		      "type": "radio",
		      "name": _vm.name,
		      "disabled": _vm.isDisabled
		    },
		    domProps: {
		      "value": _vm.label,
		      "checked": _vm._q(_vm.value, _vm.label)
		    },
		    on: {
		      "change": function($event) {
		        _vm.value = _vm.label
		      }
		    }
		  }), _c('span', {
		    staticClass: "el-radio-button__inner",
		    style: (_vm.value === _vm.label ? _vm.activeStyle : null)
		  }, [_vm._t("default"), (!_vm.$slots.default) ? [_vm._v(_vm._s(_vm.label))] : _vm._e()], 2)])
		},staticRenderFns: []}
	
	/***/ },
	/* 80 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _checkbox = __webpack_require__(81);
	
		var _checkbox2 = _interopRequireDefault(_checkbox);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_checkbox2.default.install = function (Vue) {
		  Vue.component(_checkbox2.default.name, _checkbox2.default);
		};
	
		exports.default = _checkbox2.default;
	
	/***/ },
	/* 81 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(82)
	
		/* template */
		var __vue_template__ = __webpack_require__(83)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 82 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _emitter = __webpack_require__(23);
	
		var _emitter2 = _interopRequireDefault(_emitter);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  name: 'ElCheckbox',
	
		  mixins: [_emitter2.default],
	
		  componentName: 'ElCheckbox',
	
		  data: function data() {
		    return {
		      selfModel: false,
		      focus: false
		    };
		  },
	
	
		  computed: {
		    model: {
		      get: function get() {
		        return this.isGroup ? this.store : this.value !== undefined ? this.value : this.selfModel;
		      },
		      set: function set(val) {
		        if (this.isGroup) {
		          this.dispatch('ElCheckboxGroup', 'input', [val]);
		        } else if (this.value !== undefined) {
		          this.$emit('input', val);
		        } else {
		          this.selfModel = val;
		        }
		      }
		    },
	
		    isChecked: function isChecked() {
		      if ({}.toString.call(this.model) === '[object Boolean]') {
		        return this.model;
		      } else if (Array.isArray(this.model)) {
		        return this.model.indexOf(this.label) > -1;
		      } else if (this.model !== null && this.model !== undefined) {
		        return this.model === this.trueLabel;
		      }
		    },
		    isGroup: function isGroup() {
		      var parent = this.$parent;
		      while (parent) {
		        if (parent.$options.componentName !== 'ElCheckboxGroup') {
		          parent = parent.$parent;
		        } else {
		          this._checkboxGroup = parent;
		          return true;
		        }
		      }
		      return false;
		    },
		    store: function store() {
		      return this._checkboxGroup ? this._checkboxGroup.value : this.value;
		    }
		  },
	
		  props: {
		    value: {},
		    label: {},
		    indeterminate: Boolean,
		    disabled: Boolean,
		    checked: Boolean,
		    name: String,
		    trueLabel: [String, Number],
		    falseLabel: [String, Number]
		  },
	
		  methods: {
		    addToStore: function addToStore() {
		      if (Array.isArray(this.model) && this.model.indexOf(this.label) === -1) {
		        this.model.push(this.label);
		      } else {
		        this.model = this.trueLabel || true;
		      }
		    },
		    handleChange: function handleChange(ev) {
		      var _this = this;
	
		      this.$emit('change', ev);
		      if (this.isGroup) {
		        this.$nextTick(function (_) {
		          _this.dispatch('ElCheckboxGroup', 'change', [_this._checkboxGroup.value]);
		        });
		      }
		    }
		  },
	
		  created: function created() {
		    this.checked && this.addToStore();
		  }
		}; //
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
	/***/ },
	/* 83 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('label', {
		    staticClass: "el-checkbox"
		  }, [_c('span', {
		    staticClass: "el-checkbox__input",
		    class: {
		      'is-disabled': _vm.disabled,
		      'is-checked': _vm.isChecked,
		      'is-indeterminate': _vm.indeterminate,
		      'is-focus': _vm.focus
		    }
		  }, [_c('span', {
		    staticClass: "el-checkbox__inner"
		  }), (_vm.trueLabel || _vm.falseLabel) ? _c('input', {
		    directives: [{
		      name: "model",
		      rawName: "v-model",
		      value: (_vm.model),
		      expression: "model"
		    }],
		    staticClass: "el-checkbox__original",
		    attrs: {
		      "type": "checkbox",
		      "name": _vm.name,
		      "disabled": _vm.disabled,
		      "true-value": _vm.trueLabel,
		      "false-value": _vm.falseLabel
		    },
		    domProps: {
		      "checked": Array.isArray(_vm.model) ? _vm._i(_vm.model, null) > -1 : _vm._q(_vm.model, _vm.trueLabel)
		    },
		    on: {
		      "change": [function($event) {
		        var $$a = _vm.model,
		          $$el = $event.target,
		          $$c = $$el.checked ? (_vm.trueLabel) : (_vm.falseLabel);
		        if (Array.isArray($$a)) {
		          var $$v = null,
		            $$i = _vm._i($$a, $$v);
		          if ($$c) {
		            $$i < 0 && (_vm.model = $$a.concat($$v))
		          } else {
		            $$i > -1 && (_vm.model = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
		          }
		        } else {
		          _vm.model = $$c
		        }
		      }, _vm.handleChange],
		      "focus": function($event) {
		        _vm.focus = true
		      },
		      "blur": function($event) {
		        _vm.focus = false
		      }
		    }
		  }) : _c('input', {
		    directives: [{
		      name: "model",
		      rawName: "v-model",
		      value: (_vm.model),
		      expression: "model"
		    }],
		    staticClass: "el-checkbox__original",
		    attrs: {
		      "type": "checkbox",
		      "disabled": _vm.disabled,
		      "name": _vm.name
		    },
		    domProps: {
		      "value": _vm.label,
		      "checked": Array.isArray(_vm.model) ? _vm._i(_vm.model, _vm.label) > -1 : (_vm.model)
		    },
		    on: {
		      "change": [function($event) {
		        var $$a = _vm.model,
		          $$el = $event.target,
		          $$c = $$el.checked ? (true) : (false);
		        if (Array.isArray($$a)) {
		          var $$v = _vm.label,
		            $$i = _vm._i($$a, $$v);
		          if ($$c) {
		            $$i < 0 && (_vm.model = $$a.concat($$v))
		          } else {
		            $$i > -1 && (_vm.model = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
		          }
		        } else {
		          _vm.model = $$c
		        }
		      }, _vm.handleChange],
		      "focus": function($event) {
		        _vm.focus = true
		      },
		      "blur": function($event) {
		        _vm.focus = false
		      }
		    }
		  })]), (_vm.$slots.default || _vm.label) ? _c('span', {
		    staticClass: "el-checkbox__label"
		  }, [_vm._t("default"), (!_vm.$slots.default) ? [_vm._v(_vm._s(_vm.label))] : _vm._e()], 2) : _vm._e()])
		},staticRenderFns: []}
	
	/***/ },
	/* 84 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _checkboxGroup = __webpack_require__(85);
	
		var _checkboxGroup2 = _interopRequireDefault(_checkboxGroup);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_checkboxGroup2.default.install = function (Vue) {
		  Vue.component(_checkboxGroup2.default.name, _checkboxGroup2.default);
		};
	
		exports.default = _checkboxGroup2.default;
	
	/***/ },
	/* 85 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(86)
	
		/* template */
		var __vue_template__ = __webpack_require__(87)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 86 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _emitter = __webpack_require__(23);
	
		var _emitter2 = _interopRequireDefault(_emitter);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  name: 'ElCheckboxGroup',
	
		  componentName: 'ElCheckboxGroup',
	
		  mixins: [_emitter2.default],
	
		  props: {
		    value: {}
		  },
	
		  watch: {
		    value: function value(_value) {
		      this.dispatch('ElFormItem', 'el.form.change', [_value]);
		    }
		  }
		};
	
	/***/ },
	/* 87 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    staticClass: "el-checkbox-group"
		  }, [_vm._t("default")], 2)
		},staticRenderFns: []}
	
	/***/ },
	/* 88 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _component = __webpack_require__(89);
	
		var _component2 = _interopRequireDefault(_component);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_component2.default.install = function (Vue) {
		  Vue.component(_component2.default.name, _component2.default);
		};
	
		exports.default = _component2.default;
	
	/***/ },
	/* 89 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(90)
	
		/* template */
		var __vue_template__ = __webpack_require__(91)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 90 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  name: 'ElSwitch',
		  props: {
		    value: {
		      type: Boolean,
		      default: true
		    },
		    disabled: {
		      type: Boolean,
		      default: false
		    },
		    width: {
		      type: Number,
		      default: 0
		    },
		    onIconClass: {
		      type: String,
		      default: ''
		    },
		    offIconClass: {
		      type: String,
		      default: ''
		    },
		    onText: {
		      type: String,
		      default: 'ON'
		    },
		    offText: {
		      type: String,
		      default: 'OFF'
		    },
		    onColor: {
		      type: String,
		      default: ''
		    },
		    offColor: {
		      type: String,
		      default: ''
		    },
		    name: {
		      type: String,
		      default: ''
		    }
		  },
		  data: function data() {
		    return {
		      coreWidth: this.width,
		      buttonStyle: {
		        transform: ''
		      }
		    };
		  },
	
		  computed: {
		    hasText: function hasText() {
		      /* istanbul ignore next */
		      return this.onText || this.offText;
		    },
	
		    _value: {
		      get: function get() {
		        return this.value;
		      },
		      set: function set(val) {
		        this.$emit('input', val);
		      }
		    }
		  },
		  watch: {
		    value: function value() {
		      if (this.onColor || this.offColor) {
		        this.setBackgroundColor();
		      }
		      this.handleButtonTransform();
		    }
		  },
		  methods: {
		    handleChange: function handleChange(event) {
		      this.$emit('change', event.currentTarget.checked);
		    },
		    handleButtonTransform: function handleButtonTransform() {
		      this.buttonStyle.transform = this.value ? 'translate(' + (this.coreWidth - 20) + 'px, 2px)' : 'translate(2px, 2px)';
		    },
		    setBackgroundColor: function setBackgroundColor() {
		      var newColor = this.value ? this.onColor : this.offColor;
		      this.$refs.core.style.borderColor = newColor;
		      this.$refs.core.style.backgroundColor = newColor;
		    }
		  },
		  mounted: function mounted() {
		    /* istanbul ignore if */
		    if (this.width === 0) {
		      this.coreWidth = this.hasText ? 58 : 46;
		    }
		    this.handleButtonTransform();
		    if (this.onColor || this.offColor) {
		      this.setBackgroundColor();
		    }
		  }
		};
	
	/***/ },
	/* 91 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('label', {
		    staticClass: "el-switch",
		    class: {
		      'is-disabled': _vm.disabled, 'el-switch--wide': _vm.hasText
		    }
		  }, [_c('div', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.disabled),
		      expression: "disabled"
		    }],
		    staticClass: "el-switch__mask"
		  }), _c('input', {
		    directives: [{
		      name: "model",
		      rawName: "v-model",
		      value: (_vm._value),
		      expression: "_value"
		    }],
		    staticClass: "el-switch__input",
		    attrs: {
		      "type": "checkbox",
		      "name": _vm.name,
		      "disabled": _vm.disabled
		    },
		    domProps: {
		      "checked": Array.isArray(_vm._value) ? _vm._i(_vm._value, null) > -1 : (_vm._value)
		    },
		    on: {
		      "change": [function($event) {
		        var $$a = _vm._value,
		          $$el = $event.target,
		          $$c = $$el.checked ? (true) : (false);
		        if (Array.isArray($$a)) {
		          var $$v = null,
		            $$i = _vm._i($$a, $$v);
		          if ($$c) {
		            $$i < 0 && (_vm._value = $$a.concat($$v))
		          } else {
		            $$i > -1 && (_vm._value = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
		          }
		        } else {
		          _vm._value = $$c
		        }
		      }, _vm.handleChange]
		    }
		  }), _c('span', {
		    ref: "core",
		    staticClass: "el-switch__core",
		    style: ({
		      'width': _vm.coreWidth + 'px'
		    })
		  }, [_c('span', {
		    staticClass: "el-switch__button",
		    style: (_vm.buttonStyle)
		  })]), _c('transition', {
		    attrs: {
		      "name": "label-fade"
		    }
		  }, [_c('div', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.value),
		      expression: "value"
		    }],
		    staticClass: "el-switch__label el-switch__label--left",
		    style: ({
		      'width': _vm.coreWidth + 'px'
		    })
		  }, [(_vm.onIconClass) ? _c('i', {
		    class: [_vm.onIconClass]
		  }) : _vm._e(), (!_vm.onIconClass && _vm.onText) ? _c('span', [_vm._v(_vm._s(_vm.onText))]) : _vm._e()])]), _c('transition', {
		    attrs: {
		      "name": "label-fade"
		    }
		  }, [_c('div', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (!_vm.value),
		      expression: "!value"
		    }],
		    staticClass: "el-switch__label el-switch__label--right",
		    style: ({
		      'width': _vm.coreWidth + 'px'
		    })
		  }, [(_vm.offIconClass) ? _c('i', {
		    class: [_vm.offIconClass]
		  }) : _vm._e(), (!_vm.offIconClass && _vm.offText) ? _c('span', [_vm._v(_vm._s(_vm.offText))]) : _vm._e()])])], 1)
		},staticRenderFns: []}
	
	/***/ },
	/* 92 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _select = __webpack_require__(93);
	
		var _select2 = _interopRequireDefault(_select);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_select2.default.install = function (Vue) {
		  Vue.component(_select2.default.name, _select2.default);
		};
	
		exports.default = _select2.default;
	
	/***/ },
	/* 93 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(94)
	
		/* template */
		var __vue_template__ = __webpack_require__(106)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 94 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _emitter = __webpack_require__(23);
	
		var _emitter2 = _interopRequireDefault(_emitter);
	
		var _locale = __webpack_require__(9);
	
		var _locale2 = _interopRequireDefault(_locale);
	
		var _input = __webpack_require__(18);
	
		var _input2 = _interopRequireDefault(_input);
	
		var _selectDropdown = __webpack_require__(95);
	
		var _selectDropdown2 = _interopRequireDefault(_selectDropdown);
	
		var _option = __webpack_require__(98);
	
		var _option2 = _interopRequireDefault(_option);
	
		var _tag = __webpack_require__(101);
	
		var _tag2 = _interopRequireDefault(_tag);
	
		var _scrollbar = __webpack_require__(102);
	
		var _scrollbar2 = _interopRequireDefault(_scrollbar);
	
		var _debounce = __webpack_require__(103);
	
		var _debounce2 = _interopRequireDefault(_debounce);
	
		var _clickoutside = __webpack_require__(19);
	
		var _clickoutside2 = _interopRequireDefault(_clickoutside);
	
		var _dom = __webpack_require__(66);
	
		var _resizeEvent = __webpack_require__(104);
	
		var _locale3 = __webpack_require__(105);
	
		var _merge = __webpack_require__(61);
	
		var _merge2 = _interopRequireDefault(_merge);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var sizeMap = {
		  'large': 42,
		  'small': 30,
		  'mini': 22
		}; //
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  mixins: [_emitter2.default, _locale2.default],
	
		  name: 'ElSelect',
	
		  componentName: 'ElSelect',
	
		  computed: {
		    iconClass: function iconClass() {
		      var criteria = this.clearable && !this.disabled && this.inputHovering && !this.multiple && this.value !== undefined && this.value !== '';
		      return criteria ? 'circle-close is-show-close' : this.remote && this.filterable ? '' : 'caret-top';
		    },
		    debounce: function debounce() {
		      return this.remote ? 300 : 0;
		    },
		    emptyText: function emptyText() {
		      if (this.loading) {
		        return this.loadingText || this.t('el.select.loading');
		      } else {
		        if (this.remote && this.query === '' && this.options.length === 0) return false;
		        if (this.filterable && this.options.length > 0 && this.filteredOptionsCount === 0) {
		          return this.noMatchText || this.t('el.select.noMatch');
		        }
		        if (this.options.length === 0) {
		          return this.noDataText || this.t('el.select.noData');
		        }
		      }
		      return null;
		    },
		    showNewOption: function showNewOption() {
		      var _this = this;
	
		      var hasExistingOption = this.options.filter(function (option) {
		        return !option.created;
		      }).some(function (option) {
		        return option.currentLabel === _this.query;
		      });
		      return this.filterable && this.allowCreate && this.query !== '' && !hasExistingOption;
		    }
		  },
	
		  components: {
		    ElInput: _input2.default,
		    ElSelectMenu: _selectDropdown2.default,
		    ElOption: _option2.default,
		    ElTag: _tag2.default,
		    ElScrollbar: _scrollbar2.default
		  },
	
		  directives: { Clickoutside: _clickoutside2.default },
	
		  props: {
		    name: String,
		    value: {},
		    size: String,
		    disabled: Boolean,
		    clearable: Boolean,
		    filterable: Boolean,
		    allowCreate: Boolean,
		    loading: Boolean,
		    popperClass: String,
		    remote: Boolean,
		    loadingText: String,
		    noMatchText: String,
		    noDataText: String,
		    remoteMethod: Function,
		    filterMethod: Function,
		    multiple: Boolean,
		    multipleLimit: {
		      type: Number,
		      default: 0
		    },
		    placeholder: {
		      type: String,
		      default: function _default() {
		        return (0, _locale3.t)('el.select.placeholder');
		      }
		    }
		  },
	
		  data: function data() {
		    return {
		      options: [],
		      cachedOptions: [],
		      createdOption: null,
		      createdSelected: false,
		      selected: this.multiple ? [] : {},
		      isSelect: true,
		      inputLength: 20,
		      inputWidth: 0,
		      cachedPlaceHolder: '',
		      optionsCount: 0,
		      filteredOptionsCount: 0,
		      dropdownUl: null,
		      visible: false,
		      selectedLabel: '',
		      hoverIndex: -1,
		      query: '',
		      bottomOverflowBeforeHidden: 0,
		      topOverflowBeforeHidden: 0,
		      optionsAllDisabled: false,
		      inputHovering: false,
		      currentPlaceholder: ''
		    };
		  },
	
	
		  watch: {
		    placeholder: function placeholder(val) {
		      this.currentPlaceholder = val;
		    },
		    value: function value(val) {
		      if (this.multiple) {
		        this.resetInputHeight();
		        if (val.length > 0 || this.$refs.input && this.query !== '') {
		          this.currentPlaceholder = '';
		        } else {
		          this.currentPlaceholder = this.cachedPlaceHolder;
		        }
		      }
		      this.setSelected();
		      if (this.filterable && !this.multiple) {
		        this.inputLength = 20;
		      }
		      this.$emit('change', val);
		      this.dispatch('ElFormItem', 'el.form.change', val);
		    },
		    query: function query(val) {
		      var _this2 = this;
	
		      this.$nextTick(function () {
		        if (_this2.visible) _this2.broadcast('ElSelectDropdown', 'updatePopper');
		      });
		      this.hoverIndex = -1;
		      if (this.multiple && this.filterable) {
		        this.resetInputHeight();
		      }
		      if (this.remote && typeof this.remoteMethod === 'function') {
		        this.hoverIndex = -1;
		        this.remoteMethod(val);
		        this.broadcast('ElOption', 'resetIndex');
		      } else if (typeof this.filterMethod === 'function') {
		        this.filterMethod(val);
		        this.broadcast('ElOptionGroup', 'queryChange');
		      } else {
		        this.filteredOptionsCount = this.optionsCount;
		        this.broadcast('ElOption', 'queryChange', val);
		        this.broadcast('ElOptionGroup', 'queryChange');
		      }
		    },
		    visible: function visible(val) {
		      var _this3 = this;
	
		      if (!val) {
		        this.$refs.reference.$el.querySelector('input').blur();
		        this.handleIconHide();
		        this.broadcast('ElSelectDropdown', 'destroyPopper');
		        if (this.$refs.input) {
		          this.$refs.input.blur();
		        }
		        this.query = '';
		        this.selectedLabel = '';
		        this.inputLength = 20;
		        this.resetHoverIndex();
		        this.$nextTick(function () {
		          if (_this3.$refs.input && _this3.$refs.input.value === '' && _this3.selected.length === 0) {
		            _this3.currentPlaceholder = _this3.cachedPlaceHolder;
		          }
		        });
		        if (!this.multiple) {
		          this.getOverflows();
		          if (this.selected) {
		            if (this.filterable && this.allowCreate && this.createdSelected && this.createdOption) {
		              this.selectedLabel = this.createdOption.currentLabel;
		            } else {
		              this.selectedLabel = this.selected.currentLabel;
		            }
		            if (this.filterable) this.query = this.selectedLabel;
		          }
		        }
		      } else {
		        this.handleIconShow();
		        this.broadcast('ElSelectDropdown', 'updatePopper');
		        if (this.filterable) {
		          this.query = this.selectedLabel;
		          if (this.multiple) {
		            this.$refs.input.focus();
		          } else {
		            if (!this.remote) {
		              this.broadcast('ElOption', 'queryChange', '');
		            }
		            this.broadcast('ElInput', 'inputSelect');
		          }
		        }
		        if (!this.dropdownUl) {
		          this.dropdownUl = this.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
		        }
		        if (!this.multiple && this.dropdownUl) {
		          this.setOverflow();
		        }
		      }
		      this.$emit('visible-change', val);
		    },
		    options: function options(val) {
		      if (this.$isServer) return;
		      this.optionsAllDisabled = val.length === val.filter(function (item) {
		        return item.disabled === true;
		      }).length;
		      if (this.multiple) {
		        this.resetInputHeight();
		      }
		      var inputs = this.$el.querySelectorAll('input');
		      if ([].indexOf.call(inputs, document.activeElement) === -1) {
		        this.setSelected();
		      }
		    }
		  },
	
		  methods: {
		    handleIconHide: function handleIconHide() {
		      var icon = this.$el.querySelector('.el-input__icon');
		      if (icon) {
		        (0, _dom.removeClass)(icon, 'is-reverse');
		      }
		    },
		    handleIconShow: function handleIconShow() {
		      var icon = this.$el.querySelector('.el-input__icon');
		      if (icon && !(0, _dom.hasClass)(icon, 'el-icon-circle-close')) {
		        (0, _dom.addClass)(icon, 'is-reverse');
		      }
		    },
		    getOverflows: function getOverflows() {
		      if (this.dropdownUl && this.selected && this.selected.$el) {
		        var selectedRect = this.selected.$el.getBoundingClientRect();
		        var popperRect = this.$refs.popper.$el.getBoundingClientRect();
		        this.bottomOverflowBeforeHidden = selectedRect.bottom - popperRect.bottom;
		        this.topOverflowBeforeHidden = selectedRect.top - popperRect.top;
		      }
		    },
		    setOverflow: function setOverflow() {
		      var _this4 = this;
	
		      if (this.bottomOverflowBeforeHidden > 0) {
		        this.$nextTick(function () {
		          _this4.dropdownUl.scrollTop += _this4.bottomOverflowBeforeHidden;
		        });
		      } else if (this.topOverflowBeforeHidden < 0) {
		        this.$nextTick(function () {
		          _this4.dropdownUl.scrollTop += _this4.topOverflowBeforeHidden;
		        });
		      }
		    },
		    getOption: function getOption(value) {
		      var option = void 0;
		      for (var i = this.cachedOptions.length - 1; i >= 0; i--) {
		        var cachedOption = this.cachedOptions[i];
		        if (cachedOption.value === value) {
		          option = cachedOption;
		          break;
		        }
		      }
		      if (option) return option;
		      var label = typeof value === 'string' || typeof value === 'number' ? value : '';
		      var newOption = {
		        value: value,
		        currentLabel: label
		      };
		      if (this.multiple) {
		        newOption.hitState = false;
		      }
		      return newOption;
		    },
		    setSelected: function setSelected() {
		      var _this5 = this;
	
		      if (!this.multiple) {
		        var option = this.getOption(this.value);
		        if (option.created) {
		          this.createdOption = (0, _merge2.default)({}, option);
		          this.createdSelected = true;
		        } else {
		          this.createdSelected = false;
		        }
		        this.selectedLabel = option.currentLabel;
		        this.selected = option;
		        if (this.filterable) this.query = this.selectedLabel;
		        return;
		      }
		      var result = [];
		      if (Array.isArray(this.value)) {
		        this.value.forEach(function (value) {
		          result.push(_this5.getOption(value));
		        });
		      }
		      this.selected = result;
		      this.$nextTick(function () {
		        _this5.resetInputHeight();
		      });
		    },
		    handleFocus: function handleFocus() {
		      this.visible = true;
		    },
		    handleIconClick: function handleIconClick(event) {
		      if (this.iconClass.indexOf('circle-close') > -1) {
		        this.deleteSelected(event);
		      } else {
		        this.toggleMenu();
		      }
		    },
		    handleMouseDown: function handleMouseDown(event) {
		      if (event.target.tagName !== 'INPUT') return;
		      if (this.visible) {
		        this.handleClose();
		        event.preventDefault();
		      }
		    },
		    doDestroy: function doDestroy() {
		      this.$refs.popper.doDestroy();
		    },
		    handleClose: function handleClose() {
		      this.visible = false;
		    },
		    toggleLastOptionHitState: function toggleLastOptionHitState(hit) {
		      if (!Array.isArray(this.selected)) return;
		      var option = this.selected[this.selected.length - 1];
		      if (!option) return;
	
		      if (hit === true || hit === false) {
		        option.hitState = hit;
		        return hit;
		      }
	
		      option.hitState = !option.hitState;
		      return option.hitState;
		    },
		    deletePrevTag: function deletePrevTag(e) {
		      if (e.target.value.length <= 0 && !this.toggleLastOptionHitState()) {
		        this.value.pop();
		      }
		    },
		    managePlaceholder: function managePlaceholder() {
		      if (this.currentPlaceholder !== '') {
		        this.currentPlaceholder = this.$refs.input.value ? '' : this.cachedPlaceHolder;
		      }
		    },
		    resetInputState: function resetInputState(e) {
		      if (e.keyCode !== 8) this.toggleLastOptionHitState(false);
		      this.inputLength = this.$refs.input.value.length * 15 + 20;
		      this.resetInputHeight();
		    },
		    resetInputHeight: function resetInputHeight() {
		      var _this6 = this;
	
		      this.$nextTick(function () {
		        var inputChildNodes = _this6.$refs.reference.$el.childNodes;
		        var input = [].filter.call(inputChildNodes, function (item) {
		          return item.tagName === 'INPUT';
		        })[0];
		        input.style.height = Math.max(_this6.$refs.tags.clientHeight + 6, sizeMap[_this6.size] || 36) + 'px';
		        if (_this6.visible && _this6.emptyText !== false) {
		          _this6.broadcast('ElSelectDropdown', 'updatePopper');
		        }
		      });
		    },
		    resetHoverIndex: function resetHoverIndex() {
		      var _this7 = this;
	
		      setTimeout(function () {
		        if (!_this7.multiple) {
		          _this7.hoverIndex = _this7.options.indexOf(_this7.selected);
		        } else {
		          if (_this7.selected.length > 0) {
		            _this7.hoverIndex = Math.min.apply(null, _this7.selected.map(function (item) {
		              return _this7.options.indexOf(item);
		            }));
		          } else {
		            _this7.hoverIndex = -1;
		          }
		        }
		      }, 300);
		    },
		    handleOptionSelect: function handleOptionSelect(option) {
		      if (!this.multiple) {
		        this.$emit('input', option.value);
		        this.visible = false;
		      } else {
		        var optionIndex = -1;
		        this.value.forEach(function (item, index) {
		          if (item === option.value) {
		            optionIndex = index;
		          }
		        });
		        if (optionIndex > -1) {
		          this.value.splice(optionIndex, 1);
		        } else if (this.multipleLimit <= 0 || this.value.length < this.multipleLimit) {
		          this.value.push(option.value);
		        }
		        if (option.created) {
		          this.query = '';
		          this.inputLength = 20;
		        }
		        if (this.filterable) this.$refs.input.focus();
		      }
		    },
		    toggleMenu: function toggleMenu() {
		      if (this.filterable && this.query === '' && this.visible) {
		        return;
		      }
		      if (!this.disabled) {
		        this.visible = !this.visible;
		      }
		    },
		    navigateOptions: function navigateOptions(direction) {
		      if (!this.visible) {
		        this.visible = true;
		        return;
		      }
		      if (this.options.length === 0 || this.filteredOptionsCount === 0) return;
		      if (!this.optionsAllDisabled) {
		        if (direction === 'next') {
		          this.hoverIndex++;
		          if (this.hoverIndex === this.options.length) {
		            this.hoverIndex = 0;
		          }
		          this.resetScrollTop();
		          if (this.options[this.hoverIndex].disabled === true || this.options[this.hoverIndex].groupDisabled === true || !this.options[this.hoverIndex].visible) {
		            this.navigateOptions('next');
		          }
		        }
		        if (direction === 'prev') {
		          this.hoverIndex--;
		          if (this.hoverIndex < 0) {
		            this.hoverIndex = this.options.length - 1;
		          }
		          this.resetScrollTop();
		          if (this.options[this.hoverIndex].disabled === true || this.options[this.hoverIndex].groupDisabled === true || !this.options[this.hoverIndex].visible) {
		            this.navigateOptions('prev');
		          }
		        }
		      }
		    },
		    resetScrollTop: function resetScrollTop() {
		      var bottomOverflowDistance = this.options[this.hoverIndex].$el.getBoundingClientRect().bottom - this.$refs.popper.$el.getBoundingClientRect().bottom;
		      var topOverflowDistance = this.options[this.hoverIndex].$el.getBoundingClientRect().top - this.$refs.popper.$el.getBoundingClientRect().top;
		      if (bottomOverflowDistance > 0) {
		        this.dropdownUl.scrollTop += bottomOverflowDistance;
		      }
		      if (topOverflowDistance < 0) {
		        this.dropdownUl.scrollTop += topOverflowDistance;
		      }
		    },
		    selectOption: function selectOption() {
		      if (this.options[this.hoverIndex]) {
		        this.handleOptionSelect(this.options[this.hoverIndex]);
		      }
		    },
		    deleteSelected: function deleteSelected(event) {
		      event.stopPropagation();
		      this.$emit('input', '');
		      this.visible = false;
		    },
		    deleteTag: function deleteTag(event, tag) {
		      var index = this.selected.indexOf(tag);
		      if (index > -1 && !this.disabled) {
		        this.value.splice(index, 1);
		      }
		      event.stopPropagation();
		    },
		    onInputChange: function onInputChange() {
		      if (this.filterable) {
		        this.query = this.selectedLabel;
		      }
		    },
		    onOptionDestroy: function onOptionDestroy(option) {
		      this.optionsCount--;
		      this.filteredOptionsCount--;
		      var index = this.options.indexOf(option);
		      if (index > -1) {
		        this.options.splice(index, 1);
		      }
		      this.broadcast('ElOption', 'resetIndex');
		    },
		    resetInputWidth: function resetInputWidth() {
		      this.inputWidth = this.$refs.reference.$el.getBoundingClientRect().width;
		    },
		    handleResize: function handleResize() {
		      this.resetInputWidth();
		      if (this.multiple) this.resetInputHeight();
		    }
		  },
	
		  created: function created() {
		    var _this8 = this;
	
		    this.cachedPlaceHolder = this.currentPlaceholder = this.placeholder;
		    if (this.multiple && !Array.isArray(this.value)) {
		      this.$emit('input', []);
		    }
		    if (!this.multiple && Array.isArray(this.value)) {
		      this.$emit('input', '');
		    }
		    this.setSelected();
	
		    this.debouncedOnInputChange = (0, _debounce2.default)(this.debounce, function () {
		      _this8.onInputChange();
		    });
	
		    this.$on('handleOptionClick', this.handleOptionSelect);
		    this.$on('onOptionDestroy', this.onOptionDestroy);
		    this.$on('setSelected', this.setSelected);
		  },
		  mounted: function mounted() {
		    var _this9 = this;
	
		    if (this.multiple && Array.isArray(this.value) && this.value.length > 0) {
		      this.currentPlaceholder = '';
		    }
		    (0, _resizeEvent.addResizeListener)(this.$el, this.handleResize);
		    if (this.remote && this.multiple) {
		      this.resetInputHeight();
		    }
		    this.$nextTick(function () {
		      if (_this9.$refs.reference.$el) {
		        _this9.inputWidth = _this9.$refs.reference.$el.getBoundingClientRect().width;
		      }
		    });
		  },
		  destroyed: function destroyed() {
		    if (this.handleResize) (0, _resizeEvent.removeResizeListener)(this.$el, this.handleResize);
		  }
		};
	
	/***/ },
	/* 95 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(96)
	
		/* template */
		var __vue_template__ = __webpack_require__(97)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 96 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _vuePopper = __webpack_require__(22);
	
		var _vuePopper2 = _interopRequireDefault(_vuePopper);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  name: 'ElSelectDropdown',
	
		  componentName: 'ElSelectDropdown',
	
		  mixins: [_vuePopper2.default],
	
		  props: {
		    placement: {
		      default: 'bottom-start'
		    },
	
		    boundariesPadding: {
		      default: 0
		    },
	
		    options: {
		      default: function _default() {
		        return {
		          forceAbsolute: true,
		          gpuAcceleration: false
		        };
		      }
		    }
		  },
	
		  data: function data() {
		    return {
		      minWidth: ''
		    };
		  },
	
	
		  computed: {
		    popperClass: function popperClass() {
		      return this.$parent.popperClass;
		    }
		  },
	
		  watch: {
		    '$parent.inputWidth': function $parentInputWidth() {
		      this.minWidth = this.$parent.$el.getBoundingClientRect().width + 'px';
		    }
		  },
	
		  mounted: function mounted() {
		    this.referenceElm = this.$parent.$refs.reference.$el;
		    this.$parent.popperElm = this.popperElm = this.$el;
		    this.$on('updatePopper', this.updatePopper);
		    this.$on('destroyPopper', this.destroyPopper);
		  }
		}; //
		//
		//
		//
		//
		//
		//
		//
		//
	
	/***/ },
	/* 97 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    staticClass: "el-select-dropdown",
		    class: [{
		      'is-multiple': _vm.$parent.multiple
		    }, _vm.popperClass],
		    style: ({
		      minWidth: _vm.minWidth
		    })
		  }, [_vm._t("default")], 2)
		},staticRenderFns: []}
	
	/***/ },
	/* 98 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(99)
	
		/* template */
		var __vue_template__ = __webpack_require__(100)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 99 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _emitter = __webpack_require__(23);
	
		var _emitter2 = _interopRequireDefault(_emitter);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  mixins: [_emitter2.default],
	
		  name: 'ElOption',
	
		  componentName: 'ElOption',
	
		  props: {
		    value: {
		      required: true
		    },
		    label: [String, Number],
		    selected: {
		      type: Boolean,
		      default: false
		    },
		    created: Boolean,
		    disabled: {
		      type: Boolean,
		      default: false
		    }
		  },
	
		  data: function data() {
		    return {
		      index: -1,
		      groupDisabled: false,
		      visible: true,
		      hitState: false
		    };
		  },
	
	
		  computed: {
		    currentLabel: function currentLabel() {
		      return this.label || (typeof this.value === 'string' || typeof this.value === 'number' ? this.value : '');
		    },
		    currentValue: function currentValue() {
		      return this.value || this.label || '';
		    },
		    parent: function parent() {
		      var result = this.$parent;
		      while (!result.isSelect) {
		        result = result.$parent;
		      }
		      return result;
		    },
		    itemSelected: function itemSelected() {
		      if (!this.parent.multiple) {
		        return this.value === this.parent.value;
		      } else {
		        return this.parent.value.indexOf(this.value) > -1;
		      }
		    },
		    limitReached: function limitReached() {
		      if (this.parent.multiple) {
		        return !this.itemSelected && this.parent.value.length >= this.parent.multipleLimit && this.parent.multipleLimit > 0;
		      } else {
		        return false;
		      }
		    }
		  },
	
		  watch: {
		    currentLabel: function currentLabel() {
		      if (!this.created) this.dispatch('ElSelect', 'setSelected');
		    },
		    value: function value() {
		      if (!this.created) this.dispatch('ElSelect', 'setSelected');
		    }
		  },
	
		  methods: {
		    handleGroupDisabled: function handleGroupDisabled(val) {
		      this.groupDisabled = val;
		    },
		    hoverItem: function hoverItem() {
		      if (!this.disabled && !this.groupDisabled) {
		        this.parent.hoverIndex = this.parent.options.indexOf(this);
		      }
		    },
		    selectOptionClick: function selectOptionClick() {
		      if (this.disabled !== true && this.groupDisabled !== true) {
		        this.dispatch('ElSelect', 'handleOptionClick', this);
		      }
		    },
		    queryChange: function queryChange(query) {
		      // query 里如果有正则中的特殊字符，需要先将这些字符转义
		      var parsedQuery = String(query).replace(/(\^|\(|\)|\[|\]|\$|\*|\+|\.|\?|\\|\{|\}|\|)/g, '\\$1');
		      this.visible = new RegExp(parsedQuery, 'i').test(this.currentLabel) || this.created;
		      if (!this.visible) {
		        this.parent.filteredOptionsCount--;
		      }
		    },
		    resetIndex: function resetIndex() {
		      var _this = this;
	
		      this.$nextTick(function () {
		        _this.index = _this.parent.options.indexOf(_this);
		      });
		    }
		  },
	
		  created: function created() {
		    this.parent.options.push(this);
		    this.parent.cachedOptions.push(this);
		    this.parent.optionsCount++;
		    this.parent.filteredOptionsCount++;
		    this.index = this.parent.options.indexOf(this);
	
		    this.$on('queryChange', this.queryChange);
		    this.$on('handleGroupDisabled', this.handleGroupDisabled);
		    this.$on('resetIndex', this.resetIndex);
		  },
		  beforeDestroy: function beforeDestroy() {
		    this.dispatch('ElSelect', 'onOptionDestroy', this);
		  }
		}; //
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
	/***/ },
	/* 100 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('li', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.visible),
		      expression: "visible"
		    }],
		    staticClass: "el-select-dropdown__item",
		    class: {
		      'selected': _vm.itemSelected,
		      'is-disabled': _vm.disabled || _vm.groupDisabled || _vm.limitReached,
		        'hover': _vm.parent.hoverIndex === _vm.index
		    },
		    on: {
		      "mouseenter": _vm.hoverItem,
		      "click": function($event) {
		        $event.stopPropagation();
		        _vm.selectOptionClick($event)
		      }
		    }
		  }, [_vm._t("default", [_c('span', [_vm._v(_vm._s(_vm.currentLabel))])])], 2)
		},staticRenderFns: []}
	
	/***/ },
	/* 101 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(145);
	
	/***/ },
	/* 102 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(144);
	
	/***/ },
	/* 103 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(150);
	
	/***/ },
	/* 104 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(104);
	
	/***/ },
	/* 105 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(103);
	
	/***/ },
	/* 106 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    directives: [{
		      name: "clickoutside",
		      rawName: "v-clickoutside",
		      value: (_vm.handleClose),
		      expression: "handleClose"
		    }],
		    staticClass: "el-select"
		  }, [(_vm.multiple) ? _c('div', {
		    ref: "tags",
		    staticClass: "el-select__tags",
		    style: ({
		      'max-width': _vm.inputWidth - 32 + 'px'
		    }),
		    on: {
		      "click": function($event) {
		        $event.stopPropagation();
		        _vm.toggleMenu($event)
		      }
		    }
		  }, [_c('transition-group', {
		    on: {
		      "after-leave": _vm.resetInputHeight
		    }
		  }, _vm._l((_vm.selected), function(item) {
		    return _c('el-tag', {
		      key: item.value,
		      attrs: {
		        "closable": "",
		        "hit": item.hitState,
		        "type": "primary",
		        "close-transition": ""
		      },
		      on: {
		        "close": function($event) {
		          _vm.deleteTag($event, item)
		        }
		      }
		    }, [_vm._v("\n        " + _vm._s(item.currentLabel) + "\n      ")])
		  })), (_vm.filterable) ? _c('input', {
		    directives: [{
		      name: "model",
		      rawName: "v-model",
		      value: (_vm.query),
		      expression: "query"
		    }],
		    ref: "input",
		    staticClass: "el-select__input",
		    class: ("is-" + _vm.size),
		    style: ({
		      width: _vm.inputLength + 'px',
		      'max-width': _vm.inputWidth - 42 + 'px'
		    }),
		    attrs: {
		      "type": "text",
		      "disabled": _vm.disabled,
		      "debounce": _vm.remote ? 300 : 0
		    },
		    domProps: {
		      "value": _vm._s(_vm.query)
		    },
		    on: {
		      "focus": function($event) {
		        _vm.visible = true
		      },
		      "keyup": _vm.managePlaceholder,
		      "keydown": [_vm.resetInputState, function($event) {
		        if (_vm._k($event.keyCode, "down", 40)) { return; }
		        $event.preventDefault();
		        _vm.navigateOptions('next')
		      }, function($event) {
		        if (_vm._k($event.keyCode, "up", 38)) { return; }
		        $event.preventDefault();
		        _vm.navigateOptions('prev')
		      }, function($event) {
		        if (_vm._k($event.keyCode, "enter", 13)) { return; }
		        $event.preventDefault();
		        _vm.selectOption($event)
		      }, function($event) {
		        if (_vm._k($event.keyCode, "esc", 27)) { return; }
		        $event.preventDefault();
		        _vm.visible = false
		      }, function($event) {
		        if (_vm._k($event.keyCode, "delete", [8, 46])) { return; }
		        _vm.deletePrevTag($event)
		      }],
		      "input": function($event) {
		        if ($event.target.composing) { return; }
		        _vm.query = $event.target.value
		      }
		    }
		  }) : _vm._e()], 1) : _vm._e(), _c('el-input', {
		    directives: [{
		      name: "model",
		      rawName: "v-model",
		      value: (_vm.selectedLabel),
		      expression: "selectedLabel"
		    }],
		    ref: "reference",
		    attrs: {
		      "type": "text",
		      "placeholder": _vm.currentPlaceholder,
		      "name": _vm.name,
		      "size": _vm.size,
		      "disabled": _vm.disabled,
		      "readonly": !_vm.filterable || _vm.multiple,
		      "validate-event": false,
		      "icon": _vm.iconClass
		    },
		    domProps: {
		      "value": (_vm.selectedLabel)
		    },
		    on: {
		      "focus": _vm.handleFocus,
		      "click": _vm.handleIconClick,
		      "input": function($event) {
		        _vm.selectedLabel = $event
		      }
		    },
		    nativeOn: {
		      "mousedown": function($event) {
		        _vm.handleMouseDown($event)
		      },
		      "keyup": function($event) {
		        _vm.debouncedOnInputChange($event)
		      },
		      "keydown": [function($event) {
		        if (_vm._k($event.keyCode, "down", 40)) { return; }
		        $event.preventDefault();
		        _vm.navigateOptions('next')
		      }, function($event) {
		        if (_vm._k($event.keyCode, "up", 38)) { return; }
		        $event.preventDefault();
		        _vm.navigateOptions('prev')
		      }, function($event) {
		        if (_vm._k($event.keyCode, "enter", 13)) { return; }
		        $event.preventDefault();
		        _vm.selectOption($event)
		      }, function($event) {
		        if (_vm._k($event.keyCode, "esc", 27)) { return; }
		        $event.preventDefault();
		        _vm.visible = false
		      }, function($event) {
		        if (_vm._k($event.keyCode, "tab", 9)) { return; }
		        _vm.visible = false
		      }],
		      "mouseenter": function($event) {
		        _vm.inputHovering = true
		      },
		      "mouseleave": function($event) {
		        _vm.inputHovering = false
		      }
		    }
		  }), _c('transition', {
		    attrs: {
		      "name": "el-zoom-in-top"
		    },
		    on: {
		      "after-leave": _vm.doDestroy
		    }
		  }, [_c('el-select-menu', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.visible && _vm.emptyText !== false),
		      expression: "visible && emptyText !== false"
		    }],
		    ref: "popper"
		  }, [_c('el-scrollbar', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.options.length > 0 && !_vm.loading),
		      expression: "options.length > 0 && !loading"
		    }],
		    class: {
		      'is-empty': !_vm.allowCreate && _vm.filteredOptionsCount === 0
		    },
		    attrs: {
		      "tag": "ul",
		      "wrap-class": "el-select-dropdown__wrap",
		      "view-class": "el-select-dropdown__list"
		    }
		  }, [(_vm.showNewOption) ? _c('el-option', {
		    attrs: {
		      "value": _vm.query,
		      "created": ""
		    }
		  }) : _vm._e(), _vm._t("default")], 2), (_vm.emptyText && !_vm.allowCreate) ? _c('p', {
		    staticClass: "el-select-dropdown__empty"
		  }, [_vm._v(_vm._s(_vm.emptyText))]) : _vm._e()], 1)], 1)], 1)
		},staticRenderFns: []}
	
	/***/ },
	/* 107 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _option = __webpack_require__(98);
	
		var _option2 = _interopRequireDefault(_option);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_option2.default.install = function (Vue) {
		  Vue.component(_option2.default.name, _option2.default);
		};
	
		exports.default = _option2.default;
	
	/***/ },
	/* 108 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _optionGroup = __webpack_require__(109);
	
		var _optionGroup2 = _interopRequireDefault(_optionGroup);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_optionGroup2.default.install = function (Vue) {
		  Vue.component(_optionGroup2.default.name, _optionGroup2.default);
		};
	
		exports.default = _optionGroup2.default;
	
	/***/ },
	/* 109 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(110)
	
		/* template */
		var __vue_template__ = __webpack_require__(111)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 110 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _emitter = __webpack_require__(23);
	
		var _emitter2 = _interopRequireDefault(_emitter);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  mixins: [_emitter2.default],
	
		  name: 'ElOptionGroup',
	
		  componentName: 'ElOptionGroup',
	
		  props: {
		    label: String,
		    disabled: {
		      type: Boolean,
		      default: false
		    }
		  },
	
		  data: function data() {
		    return {
		      visible: true
		    };
		  },
	
	
		  watch: {
		    disabled: function disabled(val) {
		      this.broadcast('ElOption', 'handleGroupDisabled', val);
		    }
		  },
	
		  methods: {
		    queryChange: function queryChange() {
		      this.visible = this.$children && Array.isArray(this.$children) && this.$children.some(function (option) {
		        return option.visible === true;
		      });
		    }
		  },
	
		  created: function created() {
		    this.$on('queryChange', this.queryChange);
		  },
		  mounted: function mounted() {
		    if (this.disabled) {
		      this.broadcast('ElOption', 'handleGroupDisabled', this.disabled);
		    }
		  }
		}; //
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
	/***/ },
	/* 111 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('ul', {
		    staticClass: "el-select-group__wrap"
		  }, [_c('li', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.visible),
		      expression: "visible"
		    }],
		    staticClass: "el-select-group__title"
		  }, [_vm._v(_vm._s(_vm.label))]), _c('li', [_c('ul', {
		    staticClass: "el-select-group"
		  }, [_vm._t("default")], 2)])])
		},staticRenderFns: []}
	
	/***/ },
	/* 112 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _button = __webpack_require__(113);
	
		var _button2 = _interopRequireDefault(_button);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_button2.default.install = function (Vue) {
		  Vue.component(_button2.default.name, _button2.default);
		};
	
		exports.default = _button2.default;
	
	/***/ },
	/* 113 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(114)
	
		/* template */
		var __vue_template__ = __webpack_require__(115)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 114 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  name: 'ElButton',
	
		  props: {
		    type: {
		      type: String,
		      default: 'default'
		    },
		    size: String,
		    icon: {
		      type: String,
		      default: ''
		    },
		    nativeType: {
		      type: String,
		      default: 'button'
		    },
		    loading: Boolean,
		    disabled: Boolean,
		    plain: Boolean,
		    autofocus: Boolean
		  },
	
		  methods: {
		    handleClick: function handleClick(evt) {
		      this.$emit('click', evt);
		    }
		  }
		};
	
	/***/ },
	/* 115 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('button', {
		    staticClass: "el-button",
		    class: [
		      _vm.type ? 'el-button--' + _vm.type : '',
		      _vm.size ? 'el-button--' + _vm.size : '', {
		        'is-disabled': _vm.disabled,
		        'is-loading': _vm.loading,
		        'is-plain': _vm.plain
		      }
		    ],
		    attrs: {
		      "disabled": _vm.disabled,
		      "autofocus": _vm.autofocus,
		      "type": _vm.nativeType
		    },
		    on: {
		      "click": _vm.handleClick
		    }
		  }, [(_vm.loading) ? _c('i', {
		    staticClass: "el-icon-loading"
		  }) : _vm._e(), (_vm.icon && !_vm.loading) ? _c('i', {
		    class: 'el-icon-' + _vm.icon
		  }) : _vm._e(), (_vm.$slots.default) ? _c('span', [_vm._t("default")], 2) : _vm._e()])
		},staticRenderFns: []}
	
	/***/ },
	/* 116 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _buttonGroup = __webpack_require__(117);
	
		var _buttonGroup2 = _interopRequireDefault(_buttonGroup);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_buttonGroup2.default.install = function (Vue) {
		  Vue.component(_buttonGroup2.default.name, _buttonGroup2.default);
		};
	
		exports.default = _buttonGroup2.default;
	
	/***/ },
	/* 117 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(118)
	
		/* template */
		var __vue_template__ = __webpack_require__(119)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 118 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		//
		//
		//
		//
		//
	
		/**
		 * button
		 * @module components/basic/menu
		 * @desc 用于按钮组
		 * @param {string} label - 名称
		 */
		exports.default = {
		  name: 'ElButtonGroup'
		};
	
	/***/ },
	/* 119 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    staticClass: "el-button-group"
		  }, [_vm._t("default")], 2)
		},staticRenderFns: []}
	
	/***/ },
	/* 120 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _table = __webpack_require__(121);
	
		var _table2 = _interopRequireDefault(_table);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_table2.default.install = function (Vue) {
		  Vue.component(_table2.default.name, _table2.default);
		};
	
		exports.default = _table2.default;
	
	/***/ },
	/* 121 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(122)
	
		/* template */
		var __vue_template__ = __webpack_require__(137)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 122 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _checkbox = __webpack_require__(123);
	
		var _checkbox2 = _interopRequireDefault(_checkbox);
	
		var _throttle = __webpack_require__(124);
	
		var _throttle2 = _interopRequireDefault(_throttle);
	
		var _debounce = __webpack_require__(103);
	
		var _debounce2 = _interopRequireDefault(_debounce);
	
		var _resizeEvent = __webpack_require__(104);
	
		var _locale = __webpack_require__(9);
	
		var _locale2 = _interopRequireDefault(_locale);
	
		var _tableStore = __webpack_require__(125);
	
		var _tableStore2 = _interopRequireDefault(_tableStore);
	
		var _tableLayout = __webpack_require__(128);
	
		var _tableLayout2 = _interopRequireDefault(_tableLayout);
	
		var _tableBody = __webpack_require__(130);
	
		var _tableBody2 = _interopRequireDefault(_tableBody);
	
		var _tableHeader = __webpack_require__(131);
	
		var _tableHeader2 = _interopRequireDefault(_tableHeader);
	
		var _util = __webpack_require__(127);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		var tableIdSeed = 1;
	
		exports.default = {
		  name: 'ElTable',
	
		  mixins: [_locale2.default],
	
		  props: {
		    data: {
		      type: Array,
		      default: function _default() {
		        return [];
		      }
		    },
	
		    width: [String, Number],
	
		    height: [String, Number],
	
		    maxHeight: [String, Number],
	
		    fit: {
		      type: Boolean,
		      default: true
		    },
	
		    stripe: Boolean,
	
		    border: Boolean,
	
		    rowKey: [String, Function],
	
		    context: {},
	
		    showHeader: {
		      type: Boolean,
		      default: true
		    },
	
		    rowClassName: [String, Function],
	
		    rowStyle: [Object, Function],
	
		    highlightCurrentRow: Boolean,
	
		    currentRowKey: [String, Number],
	
		    emptyText: String,
	
		    expandRowKeys: Array,
	
		    defaultExpandAll: Boolean,
	
		    defaultSort: Object
		  },
	
		  components: {
		    TableHeader: _tableHeader2.default,
		    TableBody: _tableBody2.default,
		    ElCheckbox: _checkbox2.default
		  },
	
		  methods: {
		    toggleRowSelection: function toggleRowSelection(row, selected) {
		      this.store.toggleRowSelection(row, selected);
		      this.store.updateAllSelected();
		    },
		    clearSelection: function clearSelection() {
		      this.store.clearSelection();
		    },
		    handleMouseLeave: function handleMouseLeave() {
		      this.store.commit('setHoverRow', null);
		      if (this.hoverState) this.hoverState = null;
		    },
		    updateScrollY: function updateScrollY() {
		      this.layout.updateScrollY();
		    },
		    bindEvents: function bindEvents() {
		      var _this = this;
	
		      var headerWrapper = this.$refs.headerWrapper;
	
		      var refs = this.$refs;
		      this.bodyWrapper.addEventListener('scroll', function () {
		        if (headerWrapper) headerWrapper.scrollLeft = this.scrollLeft;
		        if (refs.fixedBodyWrapper) refs.fixedBodyWrapper.scrollTop = this.scrollTop;
		        if (refs.rightFixedBodyWrapper) refs.rightFixedBodyWrapper.scrollTop = this.scrollTop;
		      });
	
		      if (headerWrapper) {
		        (0, _util.mousewheel)(headerWrapper, (0, _throttle2.default)(16, function (event) {
		          var deltaX = event.deltaX;
	
		          if (deltaX > 0) {
		            _this.bodyWrapper.scrollLeft += 10;
		          } else {
		            _this.bodyWrapper.scrollLeft -= 10;
		          }
		        }));
		      }
	
		      if (this.fit) {
		        this.windowResizeListener = (0, _throttle2.default)(50, function () {
		          if (_this.$ready) _this.doLayout();
		        });
		        (0, _resizeEvent.addResizeListener)(this.$el, this.windowResizeListener);
		      }
		    },
		    doLayout: function doLayout() {
		      var _this2 = this;
	
		      this.store.updateColumns();
		      this.layout.update();
		      this.updateScrollY();
		      this.$nextTick(function () {
		        if (_this2.height) {
		          _this2.layout.setHeight(_this2.height);
		        } else if (_this2.maxHeight) {
		          _this2.layout.setMaxHeight(_this2.maxHeight);
		        } else if (_this2.shouldUpdateHeight) {
		          _this2.layout.updateHeight();
		        }
		      });
		    }
		  },
	
		  created: function created() {
		    var _this3 = this;
	
		    this.tableId = 'el-table_' + tableIdSeed + '_';
		    this.debouncedLayout = (0, _debounce2.default)(50, function () {
		      return _this3.doLayout();
		    });
		  },
	
	
		  computed: {
		    bodyWrapper: function bodyWrapper() {
		      return this.$refs.bodyWrapper;
		    },
		    shouldUpdateHeight: function shouldUpdateHeight() {
		      return typeof this.height === 'number' || this.fixedColumns.length > 0 || this.rightFixedColumns.length > 0;
		    },
		    selection: function selection() {
		      return this.store.selection;
		    },
		    columns: function columns() {
		      return this.store.states.columns;
		    },
		    tableData: function tableData() {
		      return this.store.states.data;
		    },
		    fixedColumns: function fixedColumns() {
		      return this.store.states.fixedColumns;
		    },
		    rightFixedColumns: function rightFixedColumns() {
		      return this.store.states.rightFixedColumns;
		    },
		    bodyHeight: function bodyHeight() {
		      var style = {};
	
		      if (this.height) {
		        style = {
		          height: this.layout.bodyHeight ? this.layout.bodyHeight + 'px' : ''
		        };
		      } else if (this.maxHeight) {
		        style = {
		          'max-height': (this.showHeader ? this.maxHeight - this.layout.headerHeight : this.maxHeight) + 'px'
		        };
		      }
	
		      return style;
		    },
		    bodyWidth: function bodyWidth() {
		      var _layout = this.layout,
		          bodyWidth = _layout.bodyWidth,
		          scrollY = _layout.scrollY,
		          gutterWidth = _layout.gutterWidth;
	
		      return bodyWidth ? bodyWidth - (scrollY ? gutterWidth : 0) + 'px' : '';
		    },
		    fixedBodyHeight: function fixedBodyHeight() {
		      var style = {};
	
		      if (this.height) {
		        style = {
		          height: this.layout.fixedBodyHeight ? this.layout.fixedBodyHeight + 'px' : ''
		        };
		      } else if (this.maxHeight) {
		        var maxHeight = this.layout.scrollX ? this.maxHeight - this.layout.gutterWidth : this.maxHeight;
	
		        if (this.showHeader) {
		          maxHeight -= this.layout.headerHeight;
		        }
	
		        style = {
		          'max-height': maxHeight + 'px'
		        };
		      }
	
		      return style;
		    },
		    fixedHeight: function fixedHeight() {
		      var style = {};
	
		      if (this.maxHeight) {
		        style = {
		          bottom: this.layout.scrollX && this.data.length ? this.layout.gutterWidth + 'px' : ''
		        };
		      } else {
		        style = {
		          height: this.layout.viewportHeight ? this.layout.viewportHeight + 'px' : ''
		        };
		      }
	
		      return style;
		    }
		  },
	
		  watch: {
		    height: function height(value) {
		      this.layout.setHeight(value);
		    },
		    currentRowKey: function currentRowKey(newVal) {
		      this.store.setCurrentRowKey(newVal);
		    },
	
	
		    data: {
		      immediate: true,
		      handler: function handler(val) {
		        this.store.commit('setData', val);
		      }
		    },
	
		    expandRowKeys: function expandRowKeys(newVal) {
		      this.store.setExpandRowKeys(newVal);
		    }
		  },
	
		  destroyed: function destroyed() {
		    if (this.windowResizeListener) (0, _resizeEvent.removeResizeListener)(this.$el, this.windowResizeListener);
		  },
		  mounted: function mounted() {
		    this.bindEvents();
		    this.doLayout();
	
		    this.$ready = true;
		  },
		  data: function data() {
		    var store = new _tableStore2.default(this, {
		      rowKey: this.rowKey,
		      defaultExpandAll: this.defaultExpandAll
		    });
		    var layout = new _tableLayout2.default({
		      store: store,
		      table: this,
		      fit: this.fit,
		      showHeader: this.showHeader
		    });
		    return {
		      store: store,
		      layout: layout,
		      renderExpanded: null,
		      resizeProxyVisible: false
		    };
		  }
		};
	
	/***/ },
	/* 123 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(408);
	
	/***/ },
	/* 124 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(151);
	
	/***/ },
	/* 125 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _vue = __webpack_require__(126);
	
		var _vue2 = _interopRequireDefault(_vue);
	
		var _debounce = __webpack_require__(103);
	
		var _debounce2 = _interopRequireDefault(_debounce);
	
		var _util = __webpack_require__(127);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var sortData = function sortData(data, states) {
		  var sortingColumn = states.sortingColumn;
		  if (!sortingColumn || typeof sortingColumn.sortable === 'string') {
		    return data;
		  }
		  return (0, _util.orderBy)(data, states.sortProp, states.sortOrder, sortingColumn.sortMethod);
		};
	
		var getKeysMap = function getKeysMap(array, rowKey) {
		  var arrayMap = {};
		  (array || []).forEach(function (row, index) {
		    arrayMap[(0, _util.getRowIdentity)(row, rowKey)] = { row: row, index: index };
		  });
		  return arrayMap;
		};
	
		var toggleRowSelection = function toggleRowSelection(states, row, selected) {
		  var changed = false;
		  var selection = states.selection;
		  var index = selection.indexOf(row);
		  if (typeof selected === 'undefined') {
		    if (index === -1) {
		      selection.push(row);
		      changed = true;
		    } else {
		      selection.splice(index, 1);
		      changed = true;
		    }
		  } else {
		    if (selected && index === -1) {
		      selection.push(row);
		      changed = true;
		    } else if (!selected && index > -1) {
		      selection.splice(index, 1);
		      changed = true;
		    }
		  }
	
		  return changed;
		};
	
		var TableStore = function TableStore(table) {
		  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		  if (!table) {
		    throw new Error('Table is required.');
		  }
		  this.table = table;
	
		  this.states = {
		    rowKey: null,
		    _columns: [],
		    originColumns: [],
		    columns: [],
		    fixedColumns: [],
		    rightFixedColumns: [],
		    isComplex: false,
		    _data: null,
		    filteredData: null,
		    data: null,
		    sortingColumn: null,
		    sortProp: null,
		    sortOrder: null,
		    isAllSelected: false,
		    selection: [],
		    reserveSelection: false,
		    selectable: null,
		    currentRow: null,
		    hoverRow: null,
		    filters: {},
		    expandRows: [],
		    defaultExpandAll: false
		  };
	
		  for (var prop in initialState) {
		    if (initialState.hasOwnProperty(prop) && this.states.hasOwnProperty(prop)) {
		      this.states[prop] = initialState[prop];
		    }
		  }
		};
	
		TableStore.prototype.mutations = {
		  setData: function setData(states, data) {
		    var _this = this;
	
		    var dataInstanceChanged = states._data !== data;
		    states._data = data;
		    states.data = sortData(data || [], states);
	
		    states.data.forEach(function (item) {
		      if (!item.$extra) {
		        Object.defineProperty(item, '$extra', {
		          value: {},
		          enumerable: false
		        });
		      }
		    });
	
		    this.updateCurrentRow();
	
		    if (!states.reserveSelection) {
		      if (dataInstanceChanged) {
		        this.clearSelection();
		      } else {
		        this.cleanSelection();
		      }
		      this.updateAllSelected();
		    } else {
		      (function () {
		        var rowKey = states.rowKey;
		        if (rowKey) {
		          (function () {
		            var selection = states.selection;
		            var selectedMap = getKeysMap(selection, rowKey);
	
		            states.data.forEach(function (row) {
		              var rowId = (0, _util.getRowIdentity)(row, rowKey);
		              var rowInfo = selectedMap[rowId];
		              if (rowInfo) {
		                selection[rowInfo.index] = row;
		              }
		            });
	
		            _this.updateAllSelected();
		          })();
		        } else {
		          console.warn('WARN: rowKey is required when reserve-selection is enabled.');
		        }
		      })();
		    }
	
		    var defaultExpandAll = states.defaultExpandAll;
		    if (defaultExpandAll) {
		      this.states.expandRows = (states.data || []).slice(0);
		    }
	
		    _vue2.default.nextTick(function () {
		      return _this.table.updateScrollY();
		    });
		  },
		  changeSortCondition: function changeSortCondition(states) {
		    var _this2 = this;
	
		    states.data = sortData(states.filteredData || states._data || [], states);
	
		    this.table.$emit('sort-change', {
		      column: this.states.sortingColumn,
		      prop: this.states.sortProp,
		      order: this.states.sortOrder
		    });
	
		    _vue2.default.nextTick(function () {
		      return _this2.table.updateScrollY();
		    });
		  },
		  filterChange: function filterChange(states, options) {
		    var _this3 = this;
	
		    var column = options.column,
		        values = options.values;
	
		    if (values && !Array.isArray(values)) {
		      values = [values];
		    }
	
		    var prop = column.property;
		    if (prop) {
		      states.filters[column.id] = values;
		    }
	
		    var data = states._data;
		    var filters = states.filters;
	
		    Object.keys(filters).forEach(function (columnId) {
		      var values = filters[columnId];
		      if (!values || values.length === 0) return;
		      var column = (0, _util.getColumnById)(_this3.states, columnId);
		      if (column && column.filterMethod) {
		        data = data.filter(function (row) {
		          return values.some(function (value) {
		            return column.filterMethod.call(null, value, row);
		          });
		        });
		      }
		    });
	
		    states.filteredData = data;
		    states.data = sortData(data, states);
	
		    this.table.$emit('filter-change', filters);
	
		    _vue2.default.nextTick(function () {
		      return _this3.table.updateScrollY();
		    });
		  },
		  insertColumn: function insertColumn(states, column, index, parent) {
		    var array = states._columns;
		    if (parent) {
		      array = parent.children;
		      if (!array) array = parent.children = [];
		    }
	
		    if (typeof index !== 'undefined') {
		      array.splice(index, 0, column);
		    } else {
		      array.push(column);
		    }
	
		    if (column.type === 'selection') {
		      states.selectable = column.selectable;
		      states.reserveSelection = column.reserveSelection;
		    }
	
		    this.scheduleLayout();
		  },
		  removeColumn: function removeColumn(states, column) {
		    var _columns = states._columns;
		    if (_columns) {
		      _columns.splice(_columns.indexOf(column), 1);
		    }
	
		    this.scheduleLayout();
		  },
		  setHoverRow: function setHoverRow(states, row) {
		    states.hoverRow = row;
		  },
		  setCurrentRow: function setCurrentRow(states, row) {
		    var oldCurrentRow = states.currentRow;
		    states.currentRow = row;
	
		    if (oldCurrentRow !== row) {
		      this.table.$emit('current-change', row, oldCurrentRow);
		    }
		  },
		  rowSelectedChanged: function rowSelectedChanged(states, row) {
		    var changed = toggleRowSelection(states, row);
		    var selection = states.selection;
	
		    if (changed) {
		      var table = this.table;
		      table.$emit('selection-change', selection);
		      table.$emit('select', selection, row);
		    }
	
		    this.updateAllSelected();
		  },
	
	
		  toggleRowExpanded: function toggleRowExpanded(states, row, expanded) {
		    var expandRows = states.expandRows;
		    if (typeof expanded !== 'undefined') {
		      var index = expandRows.indexOf(row);
		      if (expanded) {
		        if (index === -1) expandRows.push(row);
		      } else {
		        if (index !== -1) expandRows.splice(index, 1);
		      }
		    } else {
		      var _index = expandRows.indexOf(row);
		      if (_index === -1) {
		        expandRows.push(row);
		      } else {
		        expandRows.splice(_index, 1);
		      }
		    }
		    this.table.$emit('expand', row, expandRows.indexOf(row) !== -1);
		  },
	
		  toggleAllSelection: (0, _debounce2.default)(10, function (states) {
		    var data = states.data || [];
		    var value = !states.isAllSelected;
		    var selection = this.states.selection;
		    var selectionChanged = false;
	
		    data.forEach(function (item, index) {
		      if (states.selectable) {
		        if (states.selectable.call(null, item, index) && toggleRowSelection(states, item, value)) {
		          selectionChanged = true;
		        }
		      } else {
		        if (toggleRowSelection(states, item, value)) {
		          selectionChanged = true;
		        }
		      }
		    });
	
		    var table = this.table;
		    if (selectionChanged) {
		      table.$emit('selection-change', selection);
		    }
		    table.$emit('select-all', selection);
		    states.isAllSelected = value;
		  })
		};
	
		var doFlattenColumns = function doFlattenColumns(columns) {
		  var result = [];
		  columns.forEach(function (column) {
		    if (column.children) {
		      result.push.apply(result, doFlattenColumns(column.children));
		    } else {
		      result.push(column);
		    }
		  });
		  return result;
		};
	
		TableStore.prototype.updateColumns = function () {
		  var states = this.states;
		  var _columns = states._columns || [];
		  states.fixedColumns = _columns.filter(function (column) {
		    return column.fixed === true || column.fixed === 'left';
		  });
		  states.rightFixedColumns = _columns.filter(function (column) {
		    return column.fixed === 'right';
		  });
	
		  if (states.fixedColumns.length > 0 && _columns[0] && _columns[0].type === 'selection' && !_columns[0].fixed) {
		    _columns[0].fixed = true;
		    states.fixedColumns.unshift(_columns[0]);
		  }
		  states.originColumns = [].concat(states.fixedColumns).concat(_columns.filter(function (column) {
		    return !column.fixed;
		  })).concat(states.rightFixedColumns);
		  states.columns = doFlattenColumns(states.originColumns);
		  states.isComplex = states.fixedColumns.length > 0 || states.rightFixedColumns.length > 0;
		};
	
		TableStore.prototype.isSelected = function (row) {
		  return (this.states.selection || []).indexOf(row) > -1;
		};
	
		TableStore.prototype.clearSelection = function () {
		  var states = this.states;
		  states.isAllSelected = false;
		  var oldSelection = states.selection;
		  states.selection = [];
		  if (oldSelection.length > 0) {
		    this.table.$emit('selection-change', states.selection);
		  }
		};
	
		TableStore.prototype.setExpandRowKeys = function (rowKeys) {
		  var expandRows = [];
		  var data = this.states.data;
		  var rowKey = this.states.rowKey;
		  if (!rowKey) throw new Error('[Table] prop row-key should not be empty.');
		  var keysMap = getKeysMap(data, rowKey);
		  rowKeys.forEach(function (key) {
		    var info = keysMap[key];
		    if (info) {
		      expandRows.push(info.row);
		    }
		  });
	
		  this.states.expandRows = expandRows;
		};
	
		TableStore.prototype.toggleRowSelection = function (row, selected) {
		  var changed = toggleRowSelection(this.states, row, selected);
		  if (changed) {
		    this.table.$emit('selection-change', this.states.selection);
		  }
		};
	
		TableStore.prototype.cleanSelection = function () {
		  var selection = this.states.selection || [];
		  var data = this.states.data;
		  var rowKey = this.states.rowKey;
		  var deleted = void 0;
		  if (rowKey) {
		    deleted = [];
		    var selectedMap = getKeysMap(selection, rowKey);
		    var dataMap = getKeysMap(data, rowKey);
		    for (var key in selectedMap) {
		      if (selectedMap.hasOwnProperty(key) && !dataMap[key]) {
		        deleted.push(selectedMap[key].row);
		      }
		    }
		  } else {
		    deleted = selection.filter(function (item) {
		      return data.indexOf(item) === -1;
		    });
		  }
	
		  deleted.forEach(function (deletedItem) {
		    selection.splice(selection.indexOf(deletedItem), 1);
		  });
	
		  if (deleted.length) {
		    this.table.$emit('selection-change', selection);
		  }
		};
	
		TableStore.prototype.updateAllSelected = function () {
		  var states = this.states;
		  var selection = states.selection,
		      rowKey = states.rowKey,
		      selectable = states.selectable,
		      data = states.data;
	
		  if (!data || data.length === 0) {
		    states.isAllSelected = false;
		    return;
		  }
	
		  var selectedMap = void 0;
		  if (rowKey) {
		    selectedMap = getKeysMap(states.selection, rowKey);
		  }
	
		  var isSelected = function isSelected(row) {
		    if (selectedMap) {
		      return !!selectedMap[(0, _util.getRowIdentity)(row, rowKey)];
		    } else {
		      return selection.indexOf(row) !== -1;
		    }
		  };
	
		  var isAllSelected = true;
		  var selectedCount = 0;
		  for (var i = 0, j = data.length; i < j; i++) {
		    var item = data[i];
		    if (selectable) {
		      var isRowSelectable = selectable.call(null, item, i);
		      if (isRowSelectable) {
		        if (!isSelected(item)) {
		          isAllSelected = false;
		          break;
		        } else {
		          selectedCount++;
		        }
		      }
		    } else {
		      if (!isSelected(item)) {
		        isAllSelected = false;
		        break;
		      } else {
		        selectedCount++;
		      }
		    }
		  }
	
		  if (selectedCount === 0) isAllSelected = false;
	
		  states.isAllSelected = isAllSelected;
		};
	
		TableStore.prototype.scheduleLayout = function () {
		  this.table.debouncedLayout();
		};
	
		TableStore.prototype.setCurrentRowKey = function (key) {
		  var states = this.states;
		  var rowKey = states.rowKey;
		  if (!rowKey) throw new Error('[Table] row-key should not be empty.');
		  var data = states.data || [];
		  var keysMap = getKeysMap(data, rowKey);
		  var info = keysMap[key];
		  if (info) {
		    states.currentRow = info.row;
		  }
		};
	
		TableStore.prototype.updateCurrentRow = function () {
		  var states = this.states;
		  var table = this.table;
		  var data = states.data || [];
		  var oldCurrentRow = states.currentRow;
	
		  if (data.indexOf(oldCurrentRow) === -1) {
		    states.currentRow = null;
	
		    if (states.currentRow !== oldCurrentRow) {
		      table.$emit('current-change', null, oldCurrentRow);
		    }
		  }
		};
	
		TableStore.prototype.commit = function (name) {
		  var mutations = this.mutations;
		  if (mutations[name]) {
		    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		      args[_key - 1] = arguments[_key];
		    }
	
		    mutations[name].apply(this, [this.states].concat(args));
		  } else {
		    throw new Error('Action not found: ' + name);
		  }
		};
	
		exports.default = TableStore;
	
	/***/ },
	/* 126 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(11);
	
	/***/ },
	/* 127 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		var getCell = exports.getCell = function getCell(event) {
		  var cell = event.target;
	
		  while (cell && cell.tagName.toUpperCase() !== 'HTML') {
		    if (cell.tagName.toUpperCase() === 'TD') {
		      return cell;
		    }
		    cell = cell.parentNode;
		  }
	
		  return null;
		};
	
		var getValueByPath = exports.getValueByPath = function getValueByPath(object, prop) {
		  prop = prop || '';
		  var paths = prop.split('.');
		  var current = object;
		  var result = null;
		  for (var i = 0, j = paths.length; i < j; i++) {
		    var path = paths[i];
		    if (!current) break;
	
		    if (i === j - 1) {
		      result = current[path];
		      break;
		    }
		    current = current[path];
		  }
		  return result;
		};
	
		var isObject = function isObject(obj) {
		  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
		};
	
		var orderBy = exports.orderBy = function orderBy(array, sortKey, reverse, sortMethod) {
		  if (typeof reverse === 'string') {
		    reverse = reverse === 'descending' ? -1 : 1;
		  }
		  if (!sortKey) {
		    return array;
		  }
		  var order = reverse && reverse < 0 ? -1 : 1;
	
		  // sort on a copy to avoid mutating original array
		  return array.slice().sort(sortMethod ? function (a, b) {
		    return sortMethod(a, b) ? order : -order;
		  } : function (a, b) {
		    if (sortKey !== '$key') {
		      if (isObject(a) && '$value' in a) a = a.$value;
		      if (isObject(b) && '$value' in b) b = b.$value;
		    }
		    a = isObject(a) ? getValueByPath(a, sortKey) : a;
		    b = isObject(b) ? getValueByPath(b, sortKey) : b;
		    return a === b ? 0 : a > b ? order : -order;
		  });
		};
	
		var getColumnById = exports.getColumnById = function getColumnById(table, columnId) {
		  var column = null;
		  table.columns.forEach(function (item) {
		    if (item.id === columnId) {
		      column = item;
		    }
		  });
		  return column;
		};
	
		var getColumnByCell = exports.getColumnByCell = function getColumnByCell(table, cell) {
		  var matches = (cell.className || '').match(/el-table_[^\s]+/gm);
		  if (matches) {
		    return getColumnById(table, matches[0]);
		  }
		  return null;
		};
	
		var isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
	
		var mousewheel = exports.mousewheel = function mousewheel(element, callback) {
		  if (element && element.addEventListener) {
		    element.addEventListener(isFirefox ? 'DOMMouseScroll' : 'mousewheel', callback);
		  }
		};
	
		var getRowIdentity = exports.getRowIdentity = function getRowIdentity(row, rowKey) {
		  if (!row) throw new Error('row is required when get row identity');
		  if (typeof rowKey === 'string') {
		    return row[rowKey];
		  } else if (typeof rowKey === 'function') {
		    return rowKey.call(null, row);
		  }
		};
	
	/***/ },
	/* 128 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _scrollbarWidth = __webpack_require__(129);
	
		var _scrollbarWidth2 = _interopRequireDefault(_scrollbarWidth);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var TableLayout = function () {
		  function TableLayout(options) {
		    _classCallCheck(this, TableLayout);
	
		    this.table = null;
		    this.store = null;
		    this.columns = null;
		    this.fit = true;
		    this.showHeader = true;
	
		    this.height = null;
		    this.scrollX = false;
		    this.scrollY = false;
		    this.bodyWidth = null;
		    this.fixedWidth = null;
		    this.rightFixedWidth = null;
		    this.tableHeight = null;
		    this.headerHeight = 44; // Table Header Height
		    this.viewportHeight = null; // Table Height - Scroll Bar Height
		    this.bodyHeight = null; // Table Height - Table Header Height
		    this.fixedBodyHeight = null; // Table Height - Table Header Height - Scroll Bar Height
		    this.gutterWidth = (0, _scrollbarWidth2.default)();
	
		    for (var name in options) {
		      if (options.hasOwnProperty(name)) {
		        this[name] = options[name];
		      }
		    }
	
		    if (!this.table) {
		      throw new Error('table is required for Table Layout');
		    }
		    if (!this.store) {
		      throw new Error('store is required for Table Layout');
		    }
		  }
	
		  TableLayout.prototype.updateScrollY = function updateScrollY() {
		    var height = this.height;
		    if (typeof height !== 'string' && typeof height !== 'number') return;
		    var bodyWrapper = this.table.bodyWrapper;
		    if (this.table.$el && bodyWrapper) {
		      var body = bodyWrapper.querySelector('.el-table__body');
		      this.scrollY = body.offsetHeight > bodyWrapper.offsetHeight;
		    }
		  };
	
		  TableLayout.prototype.setHeight = function setHeight(value) {
		    var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'height';
	
		    var el = this.table.$el;
		    if (typeof value === 'string' && /^\d+$/.test(value)) {
		      value = Number(value);
		    }
	
		    this.height = value;
	
		    if (!el) return;
		    if (typeof value === 'number') {
		      el.style[prop] = value + 'px';
	
		      this.updateHeight();
		    } else if (typeof value === 'string') {
		      this.updateHeight();
		    }
		  };
	
		  TableLayout.prototype.setMaxHeight = function setMaxHeight(value) {
		    return this.setHeight(value, 'max-height');
		  };
	
		  TableLayout.prototype.updateHeight = function updateHeight() {
		    var height = this.tableHeight = this.table.$el.clientHeight;
		    var noData = !this.table.data || this.table.data.length === 0;
		    var headerWrapper = this.table.$refs.headerWrapper;
	
		    if (this.showHeader && !headerWrapper) return;
		    if (!this.showHeader) {
		      this.headerHeight = 0;
		      if (this.height !== null && (!isNaN(this.height) || typeof this.height === 'string')) {
		        this.bodyHeight = height;
		      }
		      this.fixedBodyHeight = this.scrollX ? height - this.gutterWidth : height;
		    } else {
		      var headerHeight = this.headerHeight = headerWrapper.offsetHeight;
		      var bodyHeight = height - headerHeight;
		      if (this.height !== null && (!isNaN(this.height) || typeof this.height === 'string')) {
		        this.bodyHeight = bodyHeight;
		      }
		      this.fixedBodyHeight = this.scrollX ? bodyHeight - this.gutterWidth : bodyHeight;
		    }
		    this.viewportHeight = this.scrollX ? height - (noData ? 0 : this.gutterWidth) : height;
		  };
	
		  TableLayout.prototype.update = function update() {
		    var fit = this.fit;
		    var columns = this.table.columns;
		    var bodyWidth = this.table.$el.clientWidth;
		    var bodyMinWidth = 0;
	
		    var flattenColumns = [];
		    columns.forEach(function (column) {
		      if (column.isColumnGroup) {
		        flattenColumns.push.apply(flattenColumns, column.columns);
		      } else {
		        flattenColumns.push(column);
		      }
		    });
	
		    var flexColumns = flattenColumns.filter(function (column) {
		      return typeof column.width !== 'number';
		    });
	
		    if (flexColumns.length > 0 && fit) {
		      flattenColumns.forEach(function (column) {
		        bodyMinWidth += column.width || column.minWidth || 80;
		      });
	
		      if (bodyMinWidth < bodyWidth - this.gutterWidth) {
		        // DON'T HAVE SCROLL BAR
		        this.scrollX = false;
	
		        var totalFlexWidth = bodyWidth - this.gutterWidth - bodyMinWidth;
	
		        if (flexColumns.length === 1) {
		          flexColumns[0].realWidth = (flexColumns[0].minWidth || 80) + totalFlexWidth;
		        } else {
		          (function () {
		            var allColumnsWidth = flexColumns.reduce(function (prev, column) {
		              return prev + (column.minWidth || 80);
		            }, 0);
		            var flexWidthPerPixel = totalFlexWidth / allColumnsWidth;
		            var noneFirstWidth = 0;
	
		            flexColumns.forEach(function (column, index) {
		              if (index === 0) return;
		              var flexWidth = Math.floor((column.minWidth || 80) * flexWidthPerPixel);
		              noneFirstWidth += flexWidth;
		              column.realWidth = (column.minWidth || 80) + flexWidth;
		            });
	
		            flexColumns[0].realWidth = (flexColumns[0].minWidth || 80) + totalFlexWidth - noneFirstWidth;
		          })();
		        }
		      } else {
		        // HAVE HORIZONTAL SCROLL BAR
		        this.scrollX = true;
		        flexColumns.forEach(function (column) {
		          column.realWidth = column.minWidth;
		        });
		      }
	
		      this.bodyWidth = Math.max(bodyMinWidth, bodyWidth);
		    } else {
		      flattenColumns.forEach(function (column) {
		        if (!column.width && !column.minWidth) {
		          column.realWidth = 80;
		        } else {
		          column.realWidth = column.width || column.minWidth;
		        }
	
		        bodyMinWidth += column.realWidth;
		      });
		      this.scrollX = bodyMinWidth > bodyWidth;
	
		      this.bodyWidth = bodyMinWidth;
		    }
	
		    var fixedColumns = this.store.states.fixedColumns;
	
		    if (fixedColumns.length > 0) {
		      var fixedWidth = 0;
		      fixedColumns.forEach(function (column) {
		        fixedWidth += column.realWidth;
		      });
	
		      this.fixedWidth = fixedWidth;
		    }
	
		    var rightFixedColumns = this.store.states.rightFixedColumns;
		    if (rightFixedColumns.length > 0) {
		      var rightFixedWidth = 0;
		      rightFixedColumns.forEach(function (column) {
		        rightFixedWidth += column.realWidth;
		      });
	
		      this.rightFixedWidth = rightFixedWidth;
		    }
		  };
	
		  return TableLayout;
		}();
	
		exports.default = TableLayout;
	
	/***/ },
	/* 129 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(148);
	
	/***/ },
	/* 130 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _util = __webpack_require__(127);
	
		var _checkbox = __webpack_require__(123);
	
		var _checkbox2 = _interopRequireDefault(_checkbox);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  components: {
		    ElCheckbox: _checkbox2.default
		  },
	
		  props: {
		    store: {
		      required: true
		    },
		    context: {},
		    layout: {
		      required: true
		    },
		    rowClassName: [String, Function],
		    rowStyle: [Object, Function],
		    fixed: String,
		    highlight: Boolean
		  },
	
		  render: function render(h) {
		    var _this = this;
	
		    var columnsHidden = this.columns.map(function (column, index) {
		      return _this.isColumnHidden(index);
		    });
		    return h(
		      'table',
		      {
		        'class': 'el-table__body',
		        attrs: { cellspacing: '0',
		          cellpadding: '0',
		          border: '0' }
		      },
		      [h(
		        'colgroup',
		        null,
		        [this._l(this.columns, function (column) {
		          return h(
		            'col',
		            {
		              attrs: {
		                name: column.id,
		                width: column.realWidth || column.width
		              }
		            },
		            []
		          );
		        })]
		      ), h(
		        'tbody',
		        null,
		        [this._l(this.data, function (row, $index) {
		          return [h(
		            'tr',
		            {
		              style: _this.rowStyle ? _this.getRowStyle(row, $index) : null,
		              key: _this.table.rowKey ? _this.getKeyOfRow(row, $index) : $index,
		              on: {
		                'dblclick': function dblclick($event) {
		                  return _this.handleDoubleClick($event, row);
		                },
		                'click': function click($event) {
		                  return _this.handleClick($event, row);
		                },
		                'contextmenu': function contextmenu($event) {
		                  return _this.handleContextMenu($event, row);
		                },
		                'mouseenter': function mouseenter(_) {
		                  return _this.handleMouseEnter($index);
		                },
		                'mouseleave': function mouseleave(_) {
		                  return _this.handleMouseLeave();
		                }
		              },
	
		              'class': [_this.getRowClass(row, $index)] },
		            [_this._l(_this.columns, function (column, cellIndex) {
		              return h(
		                'td',
		                {
		                  'class': [column.id, column.align, column.className || '', columnsHidden[cellIndex] ? 'is-hidden' : ''],
		                  on: {
		                    'mouseenter': function mouseenter($event) {
		                      return _this.handleCellMouseEnter($event, row);
		                    },
		                    'mouseleave': _this.handleCellMouseLeave
		                  }
		                },
		                [column.renderCell.call(_this._renderProxy, h, { row: row, column: column, $index: $index, store: _this.store, _self: _this.context || _this.table.$vnode.context })]
		              );
		            }), !_this.fixed && _this.layout.scrollY && _this.layout.gutterWidth ? h(
		              'td',
		              { 'class': 'gutter' },
		              []
		            ) : '']
		          ), _this.store.states.expandRows.indexOf(row) > -1 ? h(
		            'tr',
		            null,
		            [h(
		              'td',
		              {
		                attrs: { colspan: _this.columns.length },
		                'class': 'el-table__expanded-cell' },
		              [_this.table.renderExpanded ? _this.table.renderExpanded(h, { row: row, $index: $index, store: _this.store }) : '']
		            )]
		          ) : ''];
		        })]
		      )]
		    );
		  },
	
	
		  watch: {
		    'store.states.hoverRow': function storeStatesHoverRow(newVal, oldVal) {
		      if (!this.store.states.isComplex) return;
		      var el = this.$el;
		      if (!el) return;
		      var rows = el.querySelectorAll('tbody > tr');
		      var oldRow = rows[oldVal];
		      var newRow = rows[newVal];
		      if (oldRow) {
		        oldRow.classList.remove('hover-row');
		      }
		      if (newRow) {
		        newRow.classList.add('hover-row');
		      }
		    },
		    'store.states.currentRow': function storeStatesCurrentRow(newVal, oldVal) {
		      if (!this.highlight) return;
		      var el = this.$el;
		      if (!el) return;
		      var data = this.store.states.data;
		      var rows = el.querySelectorAll('tbody > tr');
		      var oldRow = rows[data.indexOf(oldVal)];
		      var newRow = rows[data.indexOf(newVal)];
		      if (oldRow) {
		        oldRow.classList.remove('current-row');
		      } else if (rows) {
		        [].forEach.call(rows, function (row) {
		          return row.classList.remove('current-row');
		        });
		      }
		      if (newRow) {
		        newRow.classList.add('current-row');
		      }
		    }
		  },
	
		  computed: {
		    table: function table() {
		      return this.$parent;
		    },
		    data: function data() {
		      return this.store.states.data;
		    },
		    columnsCount: function columnsCount() {
		      return this.store.states.columns.length;
		    },
		    leftFixedCount: function leftFixedCount() {
		      return this.store.states.fixedColumns.length;
		    },
		    rightFixedCount: function rightFixedCount() {
		      return this.store.states.rightFixedColumns.length;
		    },
		    columns: function columns() {
		      return this.store.states.columns;
		    }
		  },
	
		  data: function data() {
		    return {
		      tooltipDisabled: true
		    };
		  },
	
	
		  methods: {
		    getKeyOfRow: function getKeyOfRow(row, index) {
		      var rowKey = this.table.rowKey;
		      if (rowKey) {
		        return (0, _util.getRowIdentity)(row, rowKey);
		      }
		      return index;
		    },
		    isColumnHidden: function isColumnHidden(index) {
		      if (this.fixed === true || this.fixed === 'left') {
		        return index >= this.leftFixedCount;
		      } else if (this.fixed === 'right') {
		        return index < this.columnsCount - this.rightFixedCount;
		      } else {
		        return index < this.leftFixedCount || index >= this.columnsCount - this.rightFixedCount;
		      }
		    },
		    getRowStyle: function getRowStyle(row, index) {
		      var rowStyle = this.rowStyle;
		      if (typeof rowStyle === 'function') {
		        return rowStyle.call(null, row, index);
		      }
		      return rowStyle;
		    },
		    getRowClass: function getRowClass(row, index) {
		      var classes = [];
	
		      var rowClassName = this.rowClassName;
		      if (typeof rowClassName === 'string') {
		        classes.push(rowClassName);
		      } else if (typeof rowClassName === 'function') {
		        classes.push(rowClassName.call(null, row, index) || '');
		      }
	
		      return classes.join(' ');
		    },
		    handleCellMouseEnter: function handleCellMouseEnter(event, row) {
		      var table = this.table;
		      var cell = (0, _util.getCell)(event);
	
		      if (cell) {
		        var column = (0, _util.getColumnByCell)(table, cell);
		        var hoverState = table.hoverState = { cell: cell, column: column, row: row };
		        table.$emit('cell-mouse-enter', hoverState.row, hoverState.column, hoverState.cell, event);
		      }
	
		      // 判断是否text-overflow, 如果是就显示tooltip
		      var cellChild = event.target.querySelector('.cell');
	
		      this.tooltipDisabled = cellChild.scrollWidth <= cellChild.offsetWidth;
		    },
		    handleCellMouseLeave: function handleCellMouseLeave(event) {
		      var cell = (0, _util.getCell)(event);
		      if (!cell) return;
	
		      var oldHoverState = this.table.hoverState;
		      this.table.$emit('cell-mouse-leave', oldHoverState.row, oldHoverState.column, oldHoverState.cell, event);
		    },
		    handleMouseEnter: function handleMouseEnter(index) {
		      this.store.commit('setHoverRow', index);
		    },
		    handleMouseLeave: function handleMouseLeave() {
		      this.store.commit('setHoverRow', null);
		    },
		    handleContextMenu: function handleContextMenu(event, row) {
		      var table = this.table;
		      table.$emit('row-contextmenu', row, event);
		    },
		    handleDoubleClick: function handleDoubleClick(event, row) {
		      var table = this.table;
		      table.$emit('row-dblclick', row, event);
		    },
		    handleClick: function handleClick(event, row) {
		      var table = this.table;
		      var cell = (0, _util.getCell)(event);
		      var column = void 0;
		      if (cell) {
		        column = (0, _util.getColumnByCell)(table, cell);
		        if (column) {
		          table.$emit('cell-click', row, column, cell, event);
		        }
		      }
	
		      this.store.commit('setCurrentRow', row);
	
		      table.$emit('row-click', row, event, column);
		    },
		    handleExpandClick: function handleExpandClick(row) {
		      this.store.commit('toggleRowExpanded', row);
		    }
		  }
		};
	
	/***/ },
	/* 131 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _checkbox = __webpack_require__(123);
	
		var _checkbox2 = _interopRequireDefault(_checkbox);
	
		var _tag = __webpack_require__(101);
	
		var _tag2 = _interopRequireDefault(_tag);
	
		var _vue = __webpack_require__(126);
	
		var _vue2 = _interopRequireDefault(_vue);
	
		var _filterPanel = __webpack_require__(132);
	
		var _filterPanel2 = _interopRequireDefault(_filterPanel);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var getAllColumns = function getAllColumns(columns) {
		  var result = [];
		  columns.forEach(function (column) {
		    if (column.children) {
		      result.push(column);
		      result.push.apply(result, getAllColumns(column.children));
		    } else {
		      result.push(column);
		    }
		  });
		  return result;
		};
	
		var convertToRows = function convertToRows(originColumns) {
		  var maxLevel = 1;
		  var traverse = function traverse(column, parent) {
		    if (parent) {
		      column.level = parent.level + 1;
		      if (maxLevel < column.level) {
		        maxLevel = column.level;
		      }
		    }
		    if (column.children) {
		      (function () {
		        var childrenMax = 1;
		        var colSpan = 0;
		        column.children.forEach(function (subColumn) {
		          var temp = traverse(subColumn, column);
		          if (temp > childrenMax) {
		            childrenMax = temp;
		          }
		          colSpan += subColumn.colSpan;
		        });
		        column.colSpan = colSpan;
		      })();
		    } else {
		      column.colSpan = 1;
		    }
		  };
	
		  originColumns.forEach(function (column) {
		    column.level = 1;
		    traverse(column);
		  });
	
		  var rows = [];
		  for (var i = 0; i < maxLevel; i++) {
		    rows.push([]);
		  }
	
		  var allColumns = getAllColumns(originColumns);
	
		  allColumns.forEach(function (column) {
		    if (!column.children) {
		      column.rowSpan = maxLevel - column.level + 1;
		    } else {
		      column.rowSpan = 1;
		    }
		    rows[column.level - 1].push(column);
		  });
	
		  return rows;
		};
	
		exports.default = {
		  name: 'ElTableHeader',
	
		  render: function render(h) {
		    var _this = this;
	
		    var originColumns = this.store.states.originColumns;
		    var columnRows = convertToRows(originColumns, this.columns);
	
		    return h(
		      'table',
		      {
		        'class': 'el-table__header',
		        attrs: { cellspacing: '0',
		          cellpadding: '0',
		          border: '0' }
		      },
		      [h(
		        'colgroup',
		        null,
		        [this._l(this.columns, function (column) {
		          return h(
		            'col',
		            {
		              attrs: {
		                name: column.id,
		                width: column.realWidth || column.width
		              }
		            },
		            []
		          );
		        }), !this.fixed && this.layout.gutterWidth ? h(
		          'col',
		          {
		            attrs: { name: 'gutter', width: this.layout.scrollY ? this.layout.gutterWidth : '' }
		          },
		          []
		        ) : '']
		      ), h(
		        'thead',
		        null,
		        [this._l(columnRows, function (columns, rowIndex) {
		          return h(
		            'tr',
		            null,
		            [_this._l(columns, function (column, cellIndex) {
		              return h(
		                'th',
		                {
		                  attrs: {
		                    colspan: column.colSpan,
		                    rowspan: column.rowSpan
		                  },
		                  on: {
		                    'mousemove': function mousemove($event) {
		                      return _this.handleMouseMove($event, column);
		                    },
		                    'mouseout': _this.handleMouseOut,
		                    'mousedown': function mousedown($event) {
		                      return _this.handleMouseDown($event, column);
		                    },
		                    'click': function click($event) {
		                      return _this.handleHeaderClick($event, column);
		                    }
		                  },
	
		                  'class': [column.id, column.order, column.headerAlign, column.className || '', rowIndex === 0 && _this.isCellHidden(cellIndex) ? 'is-hidden' : '', !column.children ? 'is-leaf' : ''] },
		                [h(
		                  'div',
		                  { 'class': ['cell', column.filteredValue && column.filteredValue.length > 0 ? 'highlight' : ''] },
		                  [column.renderHeader ? column.renderHeader.call(_this._renderProxy, h, { column: column, $index: cellIndex, store: _this.store, _self: _this.$parent.$vnode.context }) : column.label, column.sortable ? h(
		                    'span',
		                    { 'class': 'caret-wrapper', on: {
		                        'click': function click($event) {
		                          return _this.handleSortClick($event, column);
		                        }
		                      }
		                    },
		                    [h(
		                      'i',
		                      { 'class': 'sort-caret ascending' },
		                      []
		                    ), h(
		                      'i',
		                      { 'class': 'sort-caret descending' },
		                      []
		                    )]
		                  ) : '', column.filterable ? h(
		                    'span',
		                    { 'class': 'el-table__column-filter-trigger', on: {
		                        'click': function click($event) {
		                          return _this.handleFilterClick($event, column);
		                        }
		                      }
		                    },
		                    [h(
		                      'i',
		                      { 'class': ['el-icon-arrow-down', column.filterOpened ? 'el-icon-arrow-up' : ''] },
		                      []
		                    )]
		                  ) : '']
		                )]
		              );
		            }), !_this.fixed && _this.layout.gutterWidth ? h(
		              'th',
		              { 'class': 'gutter', style: { width: _this.layout.scrollY ? _this.layout.gutterWidth + 'px' : '0' } },
		              []
		            ) : '']
		          );
		        })]
		      )]
		    );
		  },
	
	
		  props: {
		    fixed: String,
		    store: {
		      required: true
		    },
		    layout: {
		      required: true
		    },
		    border: Boolean,
		    defaultSort: {
		      type: Object,
		      default: function _default() {
		        return {
		          prop: '',
		          order: ''
		        };
		      }
		    }
		  },
	
		  components: {
		    ElCheckbox: _checkbox2.default,
		    ElTag: _tag2.default
		  },
	
		  computed: {
		    isAllSelected: function isAllSelected() {
		      return this.store.states.isAllSelected;
		    },
		    columnsCount: function columnsCount() {
		      return this.store.states.columns.length;
		    },
		    leftFixedCount: function leftFixedCount() {
		      return this.store.states.fixedColumns.length;
		    },
		    rightFixedCount: function rightFixedCount() {
		      return this.store.states.rightFixedColumns.length;
		    },
		    columns: function columns() {
		      return this.store.states.columns;
		    }
		  },
	
		  created: function created() {
		    this.filterPanels = {};
		  },
		  mounted: function mounted() {
		    var _this2 = this;
	
		    if (this.defaultSort.prop) {
		      (function () {
		        var states = _this2.store.states;
		        states.sortProp = _this2.defaultSort.prop;
		        states.sortOrder = _this2.defaultSort.order || 'ascending';
		        _this2.$nextTick(function (_) {
		          for (var i = 0, length = _this2.columns.length; i < length; i++) {
		            var column = _this2.columns[i];
		            if (column.property === states.sortProp) {
		              column.order = states.sortOrder;
		              states.sortingColumn = column;
		              break;
		            }
		          }
	
		          if (states.sortingColumn) {
		            _this2.store.commit('changeSortCondition');
		          }
		        });
		      })();
		    }
		  },
		  beforeDestroy: function beforeDestroy() {
		    var panels = this.filterPanels;
		    for (var prop in panels) {
		      if (panels.hasOwnProperty(prop) && panels[prop]) {
		        panels[prop].$destroy(true);
		      }
		    }
		  },
	
	
		  methods: {
		    isCellHidden: function isCellHidden(index) {
		      if (this.fixed === true || this.fixed === 'left') {
		        return index >= this.leftFixedCount;
		      } else if (this.fixed === 'right') {
		        return index < this.columnsCount - this.rightFixedCount;
		      } else {
		        return index < this.leftFixedCount || index >= this.columnsCount - this.rightFixedCount;
		      }
		    },
		    toggleAllSelection: function toggleAllSelection() {
		      this.store.commit('toggleAllSelection');
		    },
		    handleFilterClick: function handleFilterClick(event, column) {
		      event.stopPropagation();
		      var target = event.target;
		      var cell = target.parentNode;
		      var table = this.$parent;
	
		      var filterPanel = this.filterPanels[column.id];
	
		      if (filterPanel && column.filterOpened) {
		        filterPanel.showPopper = false;
		        return;
		      }
	
		      if (!filterPanel) {
		        filterPanel = new _vue2.default(_filterPanel2.default);
		        this.filterPanels[column.id] = filterPanel;
	
		        filterPanel.table = table;
		        filterPanel.cell = cell;
		        filterPanel.column = column;
		        !this.$isServer && filterPanel.$mount(document.createElement('div'));
		      }
	
		      setTimeout(function () {
		        filterPanel.showPopper = true;
		      }, 16);
		    },
		    handleHeaderClick: function handleHeaderClick(event, column) {
		      if (!column.filters && column.sortable) {
		        this.handleSortClick(event, column);
		      } else if (column.filters && !column.sortable) {
		        this.handleFilterClick(event, column);
		      }
	
		      this.$parent.$emit('header-click', column, event);
		    },
		    handleMouseDown: function handleMouseDown(event, column) {
		      var _this3 = this;
	
		      if (this.$isServer) return;
		      if (column.children && column.children.length > 0) return;
		      /* istanbul ignore if */
		      if (this.draggingColumn && this.border) {
		        (function () {
		          _this3.dragging = true;
	
		          _this3.$parent.resizeProxyVisible = true;
	
		          var tableEl = _this3.$parent.$el;
		          var tableLeft = tableEl.getBoundingClientRect().left;
		          var columnEl = _this3.$el.querySelector('th.' + column.id);
		          var columnRect = columnEl.getBoundingClientRect();
		          var minLeft = columnRect.left - tableLeft + 30;
	
		          columnEl.classList.add('noclick');
	
		          _this3.dragState = {
		            startMouseLeft: event.clientX,
		            startLeft: columnRect.right - tableLeft,
		            startColumnLeft: columnRect.left - tableLeft,
		            tableLeft: tableLeft
		          };
	
		          var resizeProxy = _this3.$parent.$refs.resizeProxy;
		          resizeProxy.style.left = _this3.dragState.startLeft + 'px';
	
		          document.onselectstart = function () {
		            return false;
		          };
		          document.ondragstart = function () {
		            return false;
		          };
	
		          var handleMouseMove = function handleMouseMove(event) {
		            var deltaLeft = event.clientX - _this3.dragState.startMouseLeft;
		            var proxyLeft = _this3.dragState.startLeft + deltaLeft;
	
		            resizeProxy.style.left = Math.max(minLeft, proxyLeft) + 'px';
		          };
	
		          var handleMouseUp = function handleMouseUp() {
		            if (_this3.dragging) {
		              var finalLeft = parseInt(resizeProxy.style.left, 10);
		              var columnWidth = finalLeft - _this3.dragState.startColumnLeft;
		              column.width = column.realWidth = columnWidth;
	
		              _this3.store.scheduleLayout();
	
		              document.body.style.cursor = '';
		              _this3.dragging = false;
		              _this3.draggingColumn = null;
		              _this3.dragState = {};
	
		              _this3.$parent.resizeProxyVisible = false;
		            }
	
		            document.removeEventListener('mousemove', handleMouseMove);
		            document.removeEventListener('mouseup', handleMouseUp);
		            document.onselectstart = null;
		            document.ondragstart = null;
	
		            setTimeout(function () {
		              columnEl.classList.remove('noclick');
		            }, 0);
		          };
	
		          document.addEventListener('mousemove', handleMouseMove);
		          document.addEventListener('mouseup', handleMouseUp);
		        })();
		      }
		    },
		    handleMouseMove: function handleMouseMove(event, column) {
		      if (column.children && column.children.length > 0) return;
		      var target = event.target;
		      while (target && target.tagName !== 'TH') {
		        target = target.parentNode;
		      }
	
		      if (!column || !column.resizable) return;
	
		      if (!this.dragging && this.border) {
		        var rect = target.getBoundingClientRect();
	
		        var bodyStyle = document.body.style;
		        if (rect.width > 12 && rect.right - event.pageX < 8) {
		          bodyStyle.cursor = 'col-resize';
		          this.draggingColumn = column;
		        } else if (!this.dragging) {
		          bodyStyle.cursor = '';
		          this.draggingColumn = null;
		        }
		      }
		    },
		    handleMouseOut: function handleMouseOut() {
		      if (this.$isServer) return;
		      document.body.style.cursor = '';
		    },
		    toggleOrder: function toggleOrder(order) {
		      return !order ? 'ascending' : order === 'ascending' ? 'descending' : null;
		    },
		    handleSortClick: function handleSortClick(event, column) {
		      event.stopPropagation();
		      var order = this.toggleOrder(column.order);
	
		      var target = event.target;
		      while (target && target.tagName !== 'TH') {
		        target = target.parentNode;
		      }
	
		      if (target && target.tagName === 'TH') {
		        if (target.classList.contains('noclick')) {
		          target.classList.remove('noclick');
		          return;
		        }
		      }
	
		      if (!column.sortable) return;
	
		      var states = this.store.states;
		      var sortProp = states.sortProp;
		      var sortOrder = void 0;
		      var sortingColumn = states.sortingColumn;
	
		      if (sortingColumn !== column) {
		        if (sortingColumn) {
		          sortingColumn.order = null;
		        }
		        states.sortingColumn = column;
		        sortProp = column.property;
		      }
	
		      if (!order) {
		        sortOrder = column.order = null;
		        states.sortingColumn = null;
		        sortProp = null;
		      } else {
		        sortOrder = column.order = order;
		      }
	
		      states.sortProp = sortProp;
		      states.sortOrder = sortOrder;
	
		      this.store.commit('changeSortCondition');
		    }
		  },
	
		  data: function data() {
		    return {
		      draggingColumn: null,
		      dragging: false,
		      dragState: {}
		    };
		  }
		};
	
	/***/ },
	/* 132 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(133)
	
		/* template */
		var __vue_template__ = __webpack_require__(136)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 133 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _vuePopper = __webpack_require__(22);
	
		var _vuePopper2 = _interopRequireDefault(_vuePopper);
	
		var _locale = __webpack_require__(9);
	
		var _locale2 = _interopRequireDefault(_locale);
	
		var _clickoutside = __webpack_require__(19);
	
		var _clickoutside2 = _interopRequireDefault(_clickoutside);
	
		var _dropdown = __webpack_require__(134);
	
		var _dropdown2 = _interopRequireDefault(_dropdown);
	
		var _checkbox = __webpack_require__(123);
	
		var _checkbox2 = _interopRequireDefault(_checkbox);
	
		var _checkboxGroup = __webpack_require__(135);
	
		var _checkboxGroup2 = _interopRequireDefault(_checkboxGroup);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  name: 'ElTableFilterPanel',
	
		  mixins: [_vuePopper2.default, _locale2.default],
	
		  directives: {
		    Clickoutside: _clickoutside2.default
		  },
	
		  components: {
		    ElCheckbox: _checkbox2.default,
		    ElCheckboxGroup: _checkboxGroup2.default
		  },
	
		  props: {
		    placement: {
		      type: String,
		      default: 'bottom-end'
		    }
		  },
	
		  customRender: function customRender(h) {
		    return h(
		      'div',
		      { 'class': 'el-table-filter' },
		      [h(
		        'div',
		        { 'class': 'el-table-filter__content' },
		        []
		      ), h(
		        'div',
		        { 'class': 'el-table-filter__bottom' },
		        [h(
		          'button',
		          {
		            on: {
		              'click': this.handleConfirm
		            }
		          },
		          [this.t('el.table.confirmFilter')]
		        ), h(
		          'button',
		          {
		            on: {
		              'click': this.handleReset
		            }
		          },
		          [this.t('el.table.resetFilter')]
		        )]
		      )]
		    );
		  },
	
	
		  methods: {
		    isActive: function isActive(filter) {
		      return filter.value === this.filterValue;
		    },
		    handleOutsideClick: function handleOutsideClick() {
		      this.showPopper = false;
		    },
		    handleConfirm: function handleConfirm() {
		      this.confirmFilter(this.filteredValue);
		      this.handleOutsideClick();
		    },
		    handleReset: function handleReset() {
		      this.filteredValue = [];
		      this.confirmFilter(this.filteredValue);
		      this.handleOutsideClick();
		    },
		    handleSelect: function handleSelect(filterValue) {
		      this.filterValue = filterValue;
	
		      if (typeof filterValue !== 'undefined' && filterValue !== null) {
		        this.confirmFilter(this.filteredValue);
		      } else {
		        this.confirmFilter([]);
		      }
	
		      this.handleOutsideClick();
		    },
		    confirmFilter: function confirmFilter(filteredValue) {
		      this.table.store.commit('filterChange', {
		        column: this.column,
		        values: filteredValue
		      });
		    }
		  },
	
		  data: function data() {
		    return {
		      table: null,
		      cell: null,
		      column: null
		    };
		  },
	
	
		  computed: {
		    filters: function filters() {
		      return this.column && this.column.filters;
		    },
	
	
		    filterValue: {
		      get: function get() {
		        return (this.column.filteredValue || [])[0];
		      },
		      set: function set(value) {
		        if (this.filteredValue) {
		          if (typeof value !== 'undefined' && value !== null) {
		            this.filteredValue.splice(0, 1, value);
		          } else {
		            this.filteredValue.splice(0, 1);
		          }
		        }
		      }
		    },
	
		    filteredValue: {
		      get: function get() {
		        if (this.column) {
		          return this.column.filteredValue || [];
		        }
		        return [];
		      },
		      set: function set(value) {
		        if (this.column) {
		          this.column.filteredValue = value;
		        }
		      }
		    },
	
		    multiple: function multiple() {
		      if (this.column) {
		        return this.column.filterMultiple;
		      }
		      return true;
		    }
		  },
	
		  mounted: function mounted() {
		    var _this = this;
	
		    this.popperElm = this.$el;
		    this.referenceElm = this.cell;
		    this.table.bodyWrapper.addEventListener('scroll', function () {
		      _this.updatePopper();
		    });
	
		    this.$watch('showPopper', function (value) {
		      if (_this.column) _this.column.filterOpened = value;
		      if (value) {
		        _dropdown2.default.open(_this);
		      } else {
		        _dropdown2.default.close(_this);
		      }
		    });
		  }
		};
	
	/***/ },
	/* 134 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _vue = __webpack_require__(126);
	
		var _vue2 = _interopRequireDefault(_vue);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var dropdowns = [];
	
		!_vue2.default.prototype.$isServer && document.addEventListener('click', function (event) {
		  dropdowns.forEach(function (dropdown) {
		    var target = event.target;
		    if (!dropdown || !dropdown.$el) return;
		    if (target === dropdown.$el || dropdown.$el.contains(target)) {
		      return;
		    }
		    dropdown.handleOutsideClick && dropdown.handleOutsideClick(event);
		  });
		});
	
		exports.default = {
		  open: function open(instance) {
		    if (instance) {
		      dropdowns.push(instance);
		    }
		  },
		  close: function close(instance) {
		    var index = dropdowns.indexOf(instance);
		    if (index !== -1) {
		      dropdowns.splice(instance, 1);
		    }
		  }
		};
	
	/***/ },
	/* 135 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(407);
	
	/***/ },
	/* 136 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('transition', {
		    attrs: {
		      "name": "el-zoom-in-top"
		    }
		  }, [(_vm.multiple) ? _c('div', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.showPopper),
		      expression: "showPopper"
		    }],
		    staticClass: "el-table-filter"
		  }, [_c('div', {
		    staticClass: "el-table-filter__content"
		  }, [_c('el-checkbox-group', {
		    directives: [{
		      name: "model",
		      rawName: "v-model",
		      value: (_vm.filteredValue),
		      expression: "filteredValue"
		    }],
		    staticClass: "el-table-filter__checkbox-group",
		    domProps: {
		      "value": (_vm.filteredValue)
		    },
		    on: {
		      "input": function($event) {
		        _vm.filteredValue = $event
		      }
		    }
		  }, _vm._l((_vm.filters), function(filter) {
		    return _c('el-checkbox', {
		      attrs: {
		        "label": filter.value
		      }
		    }, [_vm._v(_vm._s(filter.text))])
		  }))], 1), _c('div', {
		    staticClass: "el-table-filter__bottom"
		  }, [_c('button', {
		    class: {
		      'is-disabled': _vm.filteredValue.length === 0
		    },
		    attrs: {
		      "disabled": _vm.filteredValue.length === 0
		    },
		    on: {
		      "click": _vm.handleConfirm
		    }
		  }, [_vm._v(_vm._s(_vm.t('el.table.confirmFilter')))]), _c('button', {
		    on: {
		      "click": _vm.handleReset
		    }
		  }, [_vm._v(_vm._s(_vm.t('el.table.resetFilter')))])])]) : _c('div', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.showPopper),
		      expression: "showPopper"
		    }],
		    staticClass: "el-table-filter"
		  }, [_c('ul', {
		    staticClass: "el-table-filter__list"
		  }, [_c('li', {
		    staticClass: "el-table-filter__list-item",
		    class: {
		      'is-active': !_vm.filterValue
		    },
		    on: {
		      "click": function($event) {
		        _vm.handleSelect(null)
		      }
		    }
		  }, [_vm._v(_vm._s(_vm.t('el.table.clearFilter')))]), _vm._l((_vm.filters), function(filter) {
		    return _c('li', {
		      staticClass: "el-table-filter__list-item",
		      class: {
		        'is-active': _vm.isActive(filter)
		      },
		      attrs: {
		        "label": filter.value
		      },
		      on: {
		        "click": function($event) {
		          _vm.handleSelect(filter.value)
		        }
		      }
		    }, [_vm._v(_vm._s(filter.text))])
		  })], 2)])])
		},staticRenderFns: []}
	
	/***/ },
	/* 137 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    staticClass: "el-table",
		    class: {
		      'el-table--fit': _vm.fit,
		      'el-table--striped': _vm.stripe,
		      'el-table--border': _vm.border,
		      'el-table--fluid-height': _vm.maxHeight,
		      'el-table--enable-row-hover': !_vm.store.states.isComplex,
		        'el-table--enable-row-transition': true || (_vm.store.states.data || []).length !== 0 && (_vm.store.states.data || []).length < 100
		    },
		    on: {
		      "mouseleave": function($event) {
		        _vm.handleMouseLeave($event)
		      }
		    }
		  }, [_c('div', {
		    ref: "hiddenColumns",
		    staticClass: "hidden-columns"
		  }, [_vm._t("default")], 2), (_vm.showHeader) ? _c('div', {
		    ref: "headerWrapper",
		    staticClass: "el-table__header-wrapper"
		  }, [_c('table-header', {
		    style: ({
		      width: _vm.layout.bodyWidth ? _vm.layout.bodyWidth + 'px' : ''
		    }),
		    attrs: {
		      "store": _vm.store,
		      "layout": _vm.layout,
		      "border": _vm.border,
		      "default-sort": _vm.defaultSort
		    }
		  })], 1) : _vm._e(), _c('div', {
		    ref: "bodyWrapper",
		    staticClass: "el-table__body-wrapper",
		    style: ([_vm.bodyHeight])
		  }, [_c('table-body', {
		    style: ({
		      width: _vm.bodyWidth
		    }),
		    attrs: {
		      "context": _vm.context,
		      "store": _vm.store,
		      "layout": _vm.layout,
		      "row-class-name": _vm.rowClassName,
		      "row-style": _vm.rowStyle,
		      "highlight": _vm.highlightCurrentRow
		    }
		  }), (!_vm.data || _vm.data.length === 0) ? _c('div', {
		    staticClass: "el-table__empty-block",
		    style: ({
		      width: _vm.bodyWidth
		    })
		  }, [_c('span', {
		    staticClass: "el-table__empty-text"
		  }, [_vm._t("empty", [_vm._v(_vm._s(_vm.emptyText || _vm.t('el.table.emptyText')))])], 2)]) : _vm._e()], 1), (_vm.fixedColumns.length > 0) ? _c('div', {
		    ref: "fixedWrapper",
		    staticClass: "el-table__fixed",
		    style: ([{
		        width: _vm.layout.fixedWidth ? _vm.layout.fixedWidth + 'px' : ''
		      },
		      _vm.fixedHeight
		    ])
		  }, [(_vm.showHeader) ? _c('div', {
		    ref: "fixedHeaderWrapper",
		    staticClass: "el-table__fixed-header-wrapper"
		  }, [_c('table-header', {
		    style: ({
		      width: _vm.layout.fixedWidth ? _vm.layout.fixedWidth + 'px' : ''
		    }),
		    attrs: {
		      "fixed": "left",
		      "border": _vm.border,
		      "store": _vm.store,
		      "layout": _vm.layout
		    }
		  })], 1) : _vm._e(), _c('div', {
		    ref: "fixedBodyWrapper",
		    staticClass: "el-table__fixed-body-wrapper",
		    style: ([{
		        top: _vm.layout.headerHeight + 'px'
		      },
		      _vm.fixedBodyHeight
		    ])
		  }, [_c('table-body', {
		    style: ({
		      width: _vm.layout.fixedWidth ? _vm.layout.fixedWidth + 'px' : ''
		    }),
		    attrs: {
		      "fixed": "left",
		      "store": _vm.store,
		      "layout": _vm.layout,
		      "highlight": _vm.highlightCurrentRow,
		      "row-class-name": _vm.rowClassName,
		      "row-style": _vm.rowStyle
		    }
		  })], 1)]) : _vm._e(), (_vm.rightFixedColumns.length > 0) ? _c('div', {
		    ref: "rightFixedWrapper",
		    staticClass: "el-table__fixed-right",
		    style: ([{
		        width: _vm.layout.rightFixedWidth ? _vm.layout.rightFixedWidth + 'px' : ''
		      }, {
		        right: _vm.layout.scrollY ? (_vm.border ? _vm.layout.gutterWidth : (_vm.layout.gutterWidth || 1)) + 'px' : ''
		      },
		      _vm.fixedHeight
		    ])
		  }, [(_vm.showHeader) ? _c('div', {
		    ref: "rightFixedHeaderWrapper",
		    staticClass: "el-table__fixed-header-wrapper"
		  }, [_c('table-header', {
		    style: ({
		      width: _vm.layout.rightFixedWidth ? _vm.layout.rightFixedWidth + 'px' : ''
		    }),
		    attrs: {
		      "fixed": "right",
		      "border": _vm.border,
		      "store": _vm.store,
		      "layout": _vm.layout
		    }
		  })], 1) : _vm._e(), _c('div', {
		    ref: "rightFixedBodyWrapper",
		    staticClass: "el-table__fixed-body-wrapper",
		    style: ([{
		        top: _vm.layout.headerHeight + 'px'
		      },
		      _vm.fixedBodyHeight
		    ])
		  }, [_c('table-body', {
		    style: ({
		      width: _vm.layout.rightFixedWidth ? _vm.layout.rightFixedWidth + 'px' : ''
		    }),
		    attrs: {
		      "fixed": "right",
		      "store": _vm.store,
		      "layout": _vm.layout,
		      "row-class-name": _vm.rowClassName,
		      "row-style": _vm.rowStyle,
		      "highlight": _vm.highlightCurrentRow
		    }
		  })], 1)]) : _vm._e(), (_vm.rightFixedColumns.length > 0) ? _c('div', {
		    staticClass: "el-table__fixed-right-patch",
		    style: ({
		      width: _vm.layout.scrollY ? _vm.layout.gutterWidth + 'px' : '0',
		      height: _vm.layout.headerHeight + 'px'
		    })
		  }) : _vm._e(), _c('div', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.resizeProxyVisible),
		      expression: "resizeProxyVisible"
		    }],
		    ref: "resizeProxy",
		    staticClass: "el-table__column-resize-proxy"
		  })])
		},staticRenderFns: []}
	
	/***/ },
	/* 138 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _tableColumn = __webpack_require__(139);
	
		var _tableColumn2 = _interopRequireDefault(_tableColumn);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_tableColumn2.default.install = function (Vue) {
		  Vue.component(_tableColumn2.default.name, _tableColumn2.default);
		};
	
		exports.default = _tableColumn2.default;
	
	/***/ },
	/* 139 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _checkbox = __webpack_require__(123);
	
		var _checkbox2 = _interopRequireDefault(_checkbox);
	
		var _tag = __webpack_require__(101);
	
		var _tag2 = _interopRequireDefault(_tag);
	
		var _merge = __webpack_require__(61);
	
		var _merge2 = _interopRequireDefault(_merge);
	
		var _util = __webpack_require__(127);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }
	
		var columnIdSeed = 1;
	
		var defaults = {
		  default: {
		    order: ''
		  },
		  selection: {
		    width: 48,
		    minWidth: 48,
		    realWidth: 48,
		    order: '',
		    className: 'el-table-column--selection'
		  },
		  expand: {
		    width: 48,
		    minWidth: 48,
		    realWidth: 48,
		    order: ''
		  },
		  index: {
		    width: 48,
		    minWidth: 48,
		    realWidth: 48,
		    order: ''
		  }
		};
	
		var forced = {
		  selection: {
		    renderHeader: function renderHeader(h) {
		      return h(
		        'el-checkbox',
		        {
		          nativeOn: {
		            'click': this.toggleAllSelection
		          },
		          domProps: {
		            'value': this.isAllSelected
		          }
		        },
		        []
		      );
		    },
		    renderCell: function renderCell(h, _ref) {
		      var row = _ref.row,
		          column = _ref.column,
		          store = _ref.store,
		          $index = _ref.$index;
	
		      return h(
		        'el-checkbox',
		        {
		          domProps: {
		            'value': store.isSelected(row)
		          },
		          attrs: {
		            disabled: column.selectable ? !column.selectable.call(null, row, $index) : false
		          },
		          on: {
		            'input': function input() {
		              store.commit('rowSelectedChanged', row);
		            }
		          }
		        },
		        []
		      );
		    },
		    sortable: false,
		    resizable: false
		  },
		  index: {
		    renderHeader: function renderHeader(h, _ref2) {
		      var column = _ref2.column;
	
		      return column.label || '#';
		    },
		    renderCell: function renderCell(h, _ref3) {
		      var $index = _ref3.$index;
	
		      return h(
		        'div',
		        null,
		        [$index + 1]
		      );
		    },
		    sortable: false
		  },
		  expand: {
		    renderHeader: function renderHeader(h, _ref4) {
		      _objectDestructuringEmpty(_ref4);
	
		      return '';
		    },
		    renderCell: function renderCell(h, _ref5, proxy) {
		      var row = _ref5.row,
		          store = _ref5.store;
	
		      var expanded = store.states.expandRows.indexOf(row) > -1;
		      return h(
		        'div',
		        { 'class': 'el-table__expand-icon ' + (expanded ? 'el-table__expand-icon--expanded' : ''),
		          on: {
		            'click': function click() {
		              return proxy.handleExpandClick(row);
		            }
		          }
		        },
		        [h(
		          'i',
		          { 'class': 'el-icon el-icon-arrow-right' },
		          []
		        )]
		      );
		    },
		    sortable: false,
		    resizable: false,
		    className: 'el-table__expand-column'
		  }
		};
	
		var getDefaultColumn = function getDefaultColumn(type, options) {
		  var column = {};
	
		  (0, _merge2.default)(column, defaults[type || 'default']);
	
		  for (var name in options) {
		    if (options.hasOwnProperty(name)) {
		      var value = options[name];
		      if (typeof value !== 'undefined') {
		        column[name] = value;
		      }
		    }
		  }
	
		  if (!column.minWidth) {
		    column.minWidth = 80;
		  }
	
		  column.realWidth = column.width || column.minWidth;
	
		  return column;
		};
	
		var DEFAULT_RENDER_CELL = function DEFAULT_RENDER_CELL(h, _ref6) {
		  var row = _ref6.row,
		      column = _ref6.column;
	
		  var property = column.property;
		  if (column && column.formatter) {
		    return column.formatter(row, column);
		  }
	
		  if (property && property.indexOf('.') === -1) {
		    return row[property];
		  }
	
		  return (0, _util.getValueByPath)(row, property);
		};
	
		exports.default = {
		  name: 'ElTableColumn',
	
		  props: {
		    type: {
		      type: String,
		      default: 'default'
		    },
		    label: String,
		    className: String,
		    property: String,
		    prop: String,
		    width: {},
		    minWidth: {},
		    renderHeader: Function,
		    sortable: {
		      type: [String, Boolean],
		      default: false
		    },
		    sortMethod: Function,
		    resizable: {
		      type: Boolean,
		      default: true
		    },
		    context: {},
		    columnKey: String,
		    align: String,
		    headerAlign: String,
		    showTooltipWhenOverflow: Boolean,
		    showOverflowTooltip: Boolean,
		    fixed: [Boolean, String],
		    formatter: Function,
		    selectable: Function,
		    reserveSelection: Boolean,
		    filterMethod: Function,
		    filteredValue: Array,
		    filters: Array,
		    filterMultiple: {
		      type: Boolean,
		      default: true
		    }
		  },
	
		  data: function data() {
		    return {
		      isSubColumn: false,
		      columns: []
		    };
		  },
		  beforeCreate: function beforeCreate() {
		    this.row = {};
		    this.column = {};
		    this.$index = 0;
		  },
	
	
		  components: {
		    ElCheckbox: _checkbox2.default,
		    ElTag: _tag2.default
		  },
	
		  computed: {
		    owner: function owner() {
		      var parent = this.$parent;
		      while (parent && !parent.tableId) {
		        parent = parent.$parent;
		      }
		      return parent;
		    }
		  },
	
		  created: function created() {
		    var _this = this;
	
		    this.customRender = this.$options.render;
		    this.$options.render = function (h) {
		      return h('div', _this.$slots.default);
		    };
	
		    var columnId = this.columnId = this.columnKey || (this.$parent.tableId || this.$parent.columnId + '_') + 'column_' + columnIdSeed++;
	
		    var parent = this.$parent;
		    var owner = this.owner;
		    this.isSubColumn = owner !== parent;
	
		    var type = this.type;
	
		    var width = this.width;
		    if (width !== undefined) {
		      width = parseInt(width, 10);
		      if (isNaN(width)) {
		        width = null;
		      }
		    }
	
		    var minWidth = this.minWidth;
		    if (minWidth !== undefined) {
		      minWidth = parseInt(minWidth, 10);
		      if (isNaN(minWidth)) {
		        minWidth = 80;
		      }
		    }
	
		    var isColumnGroup = false;
	
		    var column = getDefaultColumn(type, {
		      id: columnId,
		      label: this.label,
		      className: this.className,
		      property: this.prop || this.property,
		      type: type,
		      renderCell: null,
		      renderHeader: this.renderHeader,
		      minWidth: minWidth,
		      width: width,
		      isColumnGroup: isColumnGroup,
		      context: this.context,
		      align: this.align ? 'is-' + this.align : null,
		      headerAlign: this.headerAlign ? 'is-' + this.headerAlign : this.align ? 'is-' + this.align : null,
		      sortable: this.sortable === '' ? true : this.sortable,
		      sortMethod: this.sortMethod,
		      resizable: this.resizable,
		      showOverflowTooltip: this.showOverflowTooltip || this.showTooltipWhenOverflow,
		      formatter: this.formatter,
		      selectable: this.selectable,
		      reserveSelection: this.reserveSelection,
		      fixed: this.fixed === '' ? true : this.fixed,
		      filterMethod: this.filterMethod,
		      filters: this.filters,
		      filterable: this.filters || this.filterMethod,
		      filterMultiple: this.filterMultiple,
		      filterOpened: false,
		      filteredValue: this.filteredValue || []
		    });
	
		    (0, _merge2.default)(column, forced[type] || {});
	
		    this.columnConfig = column;
	
		    var renderCell = column.renderCell;
		    var _self = this;
	
		    if (type === 'expand') {
		      owner.renderExpanded = function (h, data) {
		        return _self.$scopedSlots.default ? _self.$scopedSlots.default(data) : _self.$slots.default;
		      };
	
		      column.renderCell = function (h, data) {
		        return h(
		          'div',
		          { 'class': 'cell' },
		          [renderCell(h, data, this._renderProxy)]
		        );
		      };
	
		      return;
		    }
	
		    column.renderCell = function (h, data) {
		      // 未来版本移除
		      if (_self.$vnode.data.inlineTemplate) {
		        renderCell = function renderCell() {
		          data._self = _self.context || data._self;
		          if (Object.prototype.toString.call(data._self) === '[object Object]') {
		            for (var prop in data._self) {
		              if (!data.hasOwnProperty(prop)) {
		                data[prop] = data._self[prop];
		              }
		            }
		          }
		          // 静态内容会缓存到 _staticTrees 内，不改的话获取的静态数据就不是内部 context
		          data._staticTrees = _self._staticTrees;
		          data.$options.staticRenderFns = _self.$options.staticRenderFns;
		          return _self.customRender.call(data);
		        };
		      } else if (_self.$scopedSlots.default) {
		        renderCell = function renderCell() {
		          return _self.$scopedSlots.default(data);
		        };
		      }
	
		      if (!renderCell) {
		        renderCell = DEFAULT_RENDER_CELL;
		      }
	
		      return _self.showOverflowTooltip || _self.showTooltipWhenOverflow ? h(
		        'el-tooltip',
		        {
		          attrs: {
		            effect: this.effect,
		            placement: 'top',
		            disabled: this.tooltipDisabled }
		        },
		        [h(
		          'div',
		          { 'class': 'cell' },
		          [renderCell(h, data)]
		        ), h(
		          'span',
		          { slot: 'content' },
		          [renderCell(h, data)]
		        )]
		      ) : h(
		        'div',
		        { 'class': 'cell' },
		        [renderCell(h, data)]
		      );
		    };
		  },
		  destroyed: function destroyed() {
		    if (!this.$parent) return;
		    this.owner.store.commit('removeColumn', this.columnConfig);
		  },
	
	
		  watch: {
		    label: function label(newVal) {
		      if (this.columnConfig) {
		        this.columnConfig.label = newVal;
		      }
		    },
		    prop: function prop(newVal) {
		      if (this.columnConfig) {
		        this.columnConfig.property = newVal;
		      }
		    },
		    property: function property(newVal) {
		      if (this.columnConfig) {
		        this.columnConfig.property = newVal;
		      }
		    },
		    filters: function filters(newVal) {
		      if (this.columnConfig) {
		        this.columnConfig.filters = newVal;
		      }
		    },
		    filterMultiple: function filterMultiple(newVal) {
		      if (this.columnConfig) {
		        this.columnConfig.filterMultiple = newVal;
		      }
		    },
		    align: function align(newVal) {
		      if (this.columnConfig) {
		        this.columnConfig.align = newVal ? 'is-' + newVal : null;
	
		        if (!this.headerAlign) {
		          this.columnConfig.headerAlign = newVal ? 'is-' + newVal : null;
		        }
		      }
		    },
		    headerAlign: function headerAlign(newVal) {
		      if (this.columnConfig) {
		        this.columnConfig.headerAlign = 'is-' + (newVal ? newVal : this.align);
		      }
		    },
		    width: function width(newVal) {
		      if (this.columnConfig) {
		        this.columnConfig.width = newVal;
		        this.owner.store.scheduleLayout();
		      }
		    },
		    minWidth: function minWidth(newVal) {
		      if (this.columnConfig) {
		        this.columnConfig.minWidth = newVal;
		        this.owner.store.scheduleLayout();
		      }
		    },
		    fixed: function fixed(newVal) {
		      if (this.columnConfig) {
		        this.columnConfig.fixed = newVal;
		        this.owner.store.scheduleLayout();
		      }
		    }
		  },
	
		  mounted: function mounted() {
		    var owner = this.owner;
		    var parent = this.$parent;
		    var columnIndex = void 0;
	
		    if (!this.isSubColumn) {
		      columnIndex = [].indexOf.call(parent.$refs.hiddenColumns.children, this.$el);
		    } else {
		      columnIndex = [].indexOf.call(parent.$el.children, this.$el);
		    }
	
		    owner.store.commit('insertColumn', this.columnConfig, columnIndex, this.isSubColumn ? parent.columnConfig : null);
		  }
		};
	
	/***/ },
	/* 140 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _datePicker = __webpack_require__(141);
	
		var _datePicker2 = _interopRequireDefault(_datePicker);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_datePicker2.default.install = function install(Vue) {
		  Vue.component(_datePicker2.default.name, _datePicker2.default);
		};
	
		exports.default = _datePicker2.default;
	
	/***/ },
	/* 141 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _picker = __webpack_require__(142);
	
		var _picker2 = _interopRequireDefault(_picker);
	
		var _date = __webpack_require__(147);
	
		var _date2 = _interopRequireDefault(_date);
	
		var _dateRange = __webpack_require__(165);
	
		var _dateRange2 = _interopRequireDefault(_dateRange);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var getPanel = function getPanel(type) {
		  if (type === 'daterange' || type === 'datetimerange') {
		    return _dateRange2.default;
		  }
		  return _date2.default;
		};
	
		exports.default = {
		  mixins: [_picker2.default],
	
		  name: 'ElDatePicker',
	
		  props: {
		    type: {
		      type: String,
		      default: 'date'
		    }
		  },
	
		  created: function created() {
		    this.panel = getPanel(this.type);
		  }
		};
	
	/***/ },
	/* 142 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(143)
	
		/* template */
		var __vue_template__ = __webpack_require__(146)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 143 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _vue = __webpack_require__(126);
	
		var _vue2 = _interopRequireDefault(_vue);
	
		var _clickoutside = __webpack_require__(19);
	
		var _clickoutside2 = _interopRequireDefault(_clickoutside);
	
		var _util = __webpack_require__(144);
	
		var _vuePopper = __webpack_require__(22);
	
		var _vuePopper2 = _interopRequireDefault(_vuePopper);
	
		var _emitter = __webpack_require__(23);
	
		var _emitter2 = _interopRequireDefault(_emitter);
	
		var _input = __webpack_require__(18);
	
		var _input2 = _interopRequireDefault(_input);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		var NewPopper = {
		  props: {
		    appendToBody: _vuePopper2.default.props.appendToBody,
		    offset: _vuePopper2.default.props.offset,
		    boundariesPadding: _vuePopper2.default.props.boundariesPadding
		  },
		  methods: _vuePopper2.default.methods,
		  data: _vuePopper2.default.data,
		  beforeDestroy: _vuePopper2.default.beforeDestroy
		};
	
		var RANGE_SEPARATOR = ' - ';
		var DEFAULT_FORMATS = {
		  date: 'yyyy-MM-dd',
		  month: 'yyyy-MM',
		  datetime: 'yyyy-MM-dd HH:mm:ss',
		  time: 'HH:mm:ss',
		  timerange: 'HH:mm:ss',
		  daterange: 'yyyy-MM-dd',
		  datetimerange: 'yyyy-MM-dd HH:mm:ss',
		  year: 'yyyy'
		};
		var HAVE_TRIGGER_TYPES = ['date', 'datetime', 'time', 'time-select', 'week', 'month', 'year', 'daterange', 'timerange', 'datetimerange'];
		var DATE_FORMATTER = function DATE_FORMATTER(value, format) {
		  return (0, _util.formatDate)(value, format);
		};
		var DATE_PARSER = function DATE_PARSER(text, format) {
		  return (0, _util.parseDate)(text, format);
		};
		var RANGE_FORMATTER = function RANGE_FORMATTER(value, format) {
		  if (Array.isArray(value) && value.length === 2) {
		    var start = value[0];
		    var end = value[1];
	
		    if (start && end) {
		      return (0, _util.formatDate)(start, format) + RANGE_SEPARATOR + (0, _util.formatDate)(end, format);
		    }
		  }
		  return '';
		};
		var RANGE_PARSER = function RANGE_PARSER(text, format) {
		  var array = text.split(RANGE_SEPARATOR);
		  if (array.length === 2) {
		    var range1 = array[0];
		    var range2 = array[1];
	
		    return [(0, _util.parseDate)(range1, format), (0, _util.parseDate)(range2, format)];
		  }
		  return [];
		};
		var TYPE_VALUE_RESOLVER_MAP = {
		  default: {
		    formatter: function formatter(value) {
		      if (!value) return '';
		      return '' + value;
		    },
		    parser: function parser(text) {
		      if (text === undefined || text === '') return null;
		      return text;
		    }
		  },
		  week: {
		    formatter: function formatter(value) {
		      if (value instanceof Date) {
		        var weekNumber = (0, _util.getWeekNumber)(value);
		        return value.getFullYear() + 'w' + (weekNumber > 9 ? weekNumber : '0' + weekNumber);
		      }
		      return value;
		    },
		    parser: function parser(text) {
		      var array = (text || '').split('w');
		      if (array.length === 2) {
		        var year = Number(array[0]);
		        var month = Number(array[1]);
	
		        if (!isNaN(year) && !isNaN(month) && month < 54) {
		          return text;
		        }
		      }
		      return null;
		    }
		  },
		  date: {
		    formatter: DATE_FORMATTER,
		    parser: DATE_PARSER
		  },
		  datetime: {
		    formatter: DATE_FORMATTER,
		    parser: DATE_PARSER
		  },
		  daterange: {
		    formatter: RANGE_FORMATTER,
		    parser: RANGE_PARSER
		  },
		  datetimerange: {
		    formatter: RANGE_FORMATTER,
		    parser: RANGE_PARSER
		  },
		  timerange: {
		    formatter: RANGE_FORMATTER,
		    parser: RANGE_PARSER
		  },
		  time: {
		    formatter: DATE_FORMATTER,
		    parser: DATE_PARSER
		  },
		  month: {
		    formatter: DATE_FORMATTER,
		    parser: DATE_PARSER
		  },
		  year: {
		    formatter: DATE_FORMATTER,
		    parser: DATE_PARSER
		  },
		  number: {
		    formatter: function formatter(value) {
		      if (!value) return '';
		      return '' + value;
		    },
		    parser: function parser(text) {
		      var result = Number(text);
	
		      if (!isNaN(text)) {
		        return result;
		      } else {
		        return null;
		      }
		    }
		  }
		};
		var PLACEMENT_MAP = {
		  left: 'bottom-start',
		  center: 'bottom-center',
		  right: 'bottom-end'
		};
	
		exports.default = {
		  mixins: [_emitter2.default, NewPopper],
	
		  props: {
		    size: String,
		    format: String,
		    readonly: Boolean,
		    placeholder: String,
		    disabled: Boolean,
		    clearable: {
		      type: Boolean,
		      default: true
		    },
		    popperClass: String,
		    editable: {
		      type: Boolean,
		      default: true
		    },
		    align: {
		      type: String,
		      default: 'left'
		    },
		    value: {},
		    rangeSeparator: {
		      default: ' - '
		    },
		    pickerOptions: {}
		  },
	
		  components: { ElInput: _input2.default },
	
		  directives: { Clickoutside: _clickoutside2.default },
	
		  data: function data() {
		    return {
		      pickerVisible: false,
		      showClose: false,
		      currentValue: ''
		    };
		  },
	
	
		  watch: {
		    pickerVisible: function pickerVisible(val) {
		      if (this.readonly || this.disabled) return;
		      val ? this.showPicker() : this.hidePicker();
		    },
		    currentValue: function currentValue(val) {
		      if (val) return;
		      if (this.picker && typeof this.picker.handleClear === 'function') {
		        this.picker.handleClear();
		      } else {
		        this.$emit('input');
		      }
		    },
	
		    value: {
		      immediate: true,
		      handler: function handler(val) {
		        this.currentValue = (0, _util.isDate)(val) ? new Date(val) : val;
		      }
		    },
		    displayValue: function displayValue(val) {
		      this.$emit('change', val);
		    }
		  },
	
		  computed: {
		    reference: function reference() {
		      return this.$refs.reference.$el;
		    },
		    refInput: function refInput() {
		      if (this.reference) return this.reference.querySelector('input');
		      return {};
		    },
		    valueIsEmpty: function valueIsEmpty() {
		      var val = this.currentValue;
		      if (Array.isArray(val)) {
		        for (var i = 0, len = val.length; i < len; i++) {
		          if (val[i]) {
		            return false;
		          }
		        }
		      } else {
		        if (val) {
		          return false;
		        }
		      }
		      return true;
		    },
		    triggerClass: function triggerClass() {
		      return this.type.indexOf('time') !== -1 ? 'el-icon-time' : 'el-icon-date';
		    },
		    selectionMode: function selectionMode() {
		      if (this.type === 'week') {
		        return 'week';
		      } else if (this.type === 'month') {
		        return 'month';
		      } else if (this.type === 'year') {
		        return 'year';
		      }
	
		      return 'day';
		    },
		    haveTrigger: function haveTrigger() {
		      if (typeof this.showTrigger !== 'undefined') {
		        return this.showTrigger;
		      }
		      return HAVE_TRIGGER_TYPES.indexOf(this.type) !== -1;
		    },
	
	
		    displayValue: {
		      get: function get() {
		        var value = this.currentValue;
		        if (!value) return;
		        var formatter = (TYPE_VALUE_RESOLVER_MAP[this.type] || TYPE_VALUE_RESOLVER_MAP['default']).formatter;
		        var format = DEFAULT_FORMATS[this.type];
	
		        return formatter(value, this.format || format);
		      },
		      set: function set(value) {
		        if (value) {
		          var type = this.type;
		          var parser = (TYPE_VALUE_RESOLVER_MAP[type] || TYPE_VALUE_RESOLVER_MAP['default']).parser;
		          var parsedValue = parser(value, this.format || DEFAULT_FORMATS[type]);
	
		          if (parsedValue && this.picker) {
		            this.picker.value = parsedValue;
		          }
		        } else {
		          this.picker.value = value;
		        }
		        this.$forceUpdate();
		      }
		    }
		  },
	
		  created: function created() {
		    RANGE_SEPARATOR = this.rangeSeparator;
		    // vue-popper
		    this.options = {
		      boundariesPadding: 0,
		      gpuAcceleration: false
		    };
		    this.placement = PLACEMENT_MAP[this.align] || PLACEMENT_MAP.left;
		  },
	
	
		  methods: {
		    handleMouseEnterIcon: function handleMouseEnterIcon() {
		      if (this.readonly || this.disabled) return;
		      if (!this.valueIsEmpty && this.clearable) {
		        this.showClose = true;
		      }
		    },
		    handleClickIcon: function handleClickIcon() {
		      if (this.readonly || this.disabled) return;
		      if (this.showClose) {
		        this.currentValue = '';
		        this.showClose = false;
		      } else {
		        this.pickerVisible = !this.pickerVisible;
		      }
		    },
		    dateChanged: function dateChanged(dateA, dateB) {
		      if (Array.isArray(dateA)) {
		        var len = dateA.length;
		        if (!dateB) return true;
		        while (len--) {
		          if (!(0, _util.equalDate)(dateA[len], dateB[len])) return true;
		        }
		      } else {
		        if (!(0, _util.equalDate)(dateA, dateB)) return true;
		      }
	
		      return false;
		    },
		    handleClose: function handleClose() {
		      this.pickerVisible = false;
		    },
		    handleFocus: function handleFocus() {
		      var type = this.type;
	
		      if (HAVE_TRIGGER_TYPES.indexOf(type) !== -1 && !this.pickerVisible) {
		        this.pickerVisible = true;
		      }
		      this.$emit('focus', this);
		    },
		    handleBlur: function handleBlur() {
		      this.$emit('blur', this);
		      this.dispatch('ElFormItem', 'el.form.blur');
		    },
		    handleKeydown: function handleKeydown(event) {
		      var keyCode = event.keyCode;
	
		      // tab
		      if (keyCode === 9) {
		        this.pickerVisible = false;
		      }
		    },
		    hidePicker: function hidePicker() {
		      if (this.picker) {
		        this.picker.resetView && this.picker.resetView();
		        this.pickerVisible = this.picker.visible = false;
		        this.destroyPopper();
		      }
		    },
		    showPicker: function showPicker() {
		      var _this = this;
	
		      if (this.$isServer) return;
		      if (!this.picker) {
		        (function () {
		          _this.panel.defaultValue = _this.currentValue;
		          _this.picker = new _vue2.default(_this.panel).$mount(document.createElement('div'));
		          _this.picker.popperClass = _this.popperClass;
		          _this.popperElm = _this.picker.$el;
		          _this.picker.width = _this.reference.getBoundingClientRect().width;
		          _this.picker.showTime = _this.type === 'datetime' || _this.type === 'datetimerange';
		          _this.picker.selectionMode = _this.selectionMode;
		          if (_this.format) {
		            _this.picker.format = _this.format;
		          }
	
		          var updateOptions = function updateOptions() {
		            var options = _this.pickerOptions;
	
		            if (options && options.selectableRange) {
		              (function () {
		                var ranges = options.selectableRange;
		                var parser = TYPE_VALUE_RESOLVER_MAP.datetimerange.parser;
		                var format = DEFAULT_FORMATS.timerange;
	
		                ranges = Array.isArray(ranges) ? ranges : [ranges];
		                _this.picker.selectableRange = ranges.map(function (range) {
		                  return parser(range, format);
		                });
		              })();
		            }
	
		            for (var option in options) {
		              if (options.hasOwnProperty(option) &&
		              // 忽略 time-picker 的该配置项
		              option !== 'selectableRange') {
		                _this.picker[option] = options[option];
		              }
		            }
		          };
		          updateOptions();
		          _this.$watch('pickerOptions', function () {
		            return updateOptions();
		          }, { deep: true });
	
		          _this.$el.appendChild(_this.picker.$el);
		          _this.pickerVisible = _this.picker.visible = true;
		          _this.picker.resetView && _this.picker.resetView();
	
		          _this.picker.$on('dodestroy', _this.doDestroy);
		          _this.picker.$on('pick', function (date) {
		            var visible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
		            if (_this.dateChanged(date, _this.value)) _this.$emit('input', date);
		            _this.pickerVisible = _this.picker.visible = visible;
		            _this.picker.resetView && _this.picker.resetView();
		          });
	
		          _this.picker.$on('select-range', function (start, end) {
		            _this.refInput.setSelectionRange(start, end);
		            _this.refInput.focus();
		          });
		        })();
		      } else {
		        this.pickerVisible = this.picker.visible = true;
		      }
	
		      this.updatePopper();
	
		      if (this.currentValue instanceof Date) {
		        this.picker.date = new Date(this.currentValue.getTime());
		      } else {
		        this.picker.value = this.currentValue;
		      }
		      this.picker.resetView && this.picker.resetView();
	
		      this.$nextTick(function () {
		        _this.picker.ajustScrollTop && _this.picker.ajustScrollTop();
		      });
		    }
		  }
		};
	
	/***/ },
	/* 144 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.limitRange = exports.getRangeHours = exports.nextMonth = exports.prevMonth = exports.getWeekNumber = exports.getStartDateOfMonth = exports.DAY_DURATION = exports.getFirstDayOfMonth = exports.getDayCountOfMonth = exports.parseDate = exports.formatDate = exports.isDate = exports.toDate = exports.equalDate = undefined;
	
		var _date = __webpack_require__(145);
	
		var _date2 = _interopRequireDefault(_date);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var newArray = function newArray(start, end) {
		  var result = [];
		  for (var i = start; i <= end; i++) {
		    result.push(i);
		  }
		  return result;
		};
	
		var equalDate = exports.equalDate = function equalDate(dateA, dateB) {
		  return dateA === dateB || new Date(dateA).getTime() === new Date(dateB).getTime();
		};
	
		var toDate = exports.toDate = function toDate(date) {
		  return isDate(date) ? new Date(date) : null;
		};
	
		var isDate = exports.isDate = function isDate(date) {
		  if (date === null || date === undefined) return false;
		  if (isNaN(new Date(date).getTime())) return false;
		  return true;
		};
	
		var formatDate = exports.formatDate = function formatDate(date, format) {
		  date = toDate(date);
		  if (!date) return '';
		  return _date2.default.format(date, format || 'yyyy-MM-dd');
		};
	
		var parseDate = exports.parseDate = function parseDate(string, format) {
		  return _date2.default.parse(string, format || 'yyyy-MM-dd');
		};
	
		var getDayCountOfMonth = exports.getDayCountOfMonth = function getDayCountOfMonth(year, month) {
		  if (month === 3 || month === 5 || month === 8 || month === 10) {
		    return 30;
		  }
	
		  if (month === 1) {
		    if (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0) {
		      return 29;
		    } else {
		      return 28;
		    }
		  }
	
		  return 31;
		};
	
		var getFirstDayOfMonth = exports.getFirstDayOfMonth = function getFirstDayOfMonth(date) {
		  var temp = new Date(date.getTime());
		  temp.setDate(1);
		  return temp.getDay();
		};
	
		var DAY_DURATION = exports.DAY_DURATION = 86400000;
	
		var getStartDateOfMonth = exports.getStartDateOfMonth = function getStartDateOfMonth(year, month) {
		  var result = new Date(year, month, 1);
		  var day = result.getDay();
	
		  if (day === 0) {
		    result.setTime(result.getTime() - DAY_DURATION * 7);
		  } else {
		    result.setTime(result.getTime() - DAY_DURATION * day);
		  }
	
		  return result;
		};
	
		var getWeekNumber = exports.getWeekNumber = function getWeekNumber(src) {
		  var date = new Date(src.getTime());
		  date.setHours(0, 0, 0, 0);
		  // Thursday in current week decides the year.
		  date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
		  // January 4 is always in week 1.
		  var week1 = new Date(date.getFullYear(), 0, 4);
		  // Adjust to Thursday in week 1 and count number of weeks from date to week 1.
		  return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
		};
	
		var prevMonth = exports.prevMonth = function prevMonth(src) {
		  var year = src.getFullYear();
		  var month = src.getMonth();
		  var date = src.getDate();
	
		  var newYear = month === 0 ? year - 1 : year;
		  var newMonth = month === 0 ? 11 : month - 1;
	
		  var newMonthDayCount = getDayCountOfMonth(newYear, newMonth);
		  if (newMonthDayCount < date) {
		    src.setDate(newMonthDayCount);
		  }
	
		  src.setMonth(newMonth);
		  src.setFullYear(newYear);
	
		  return new Date(src.getTime());
		};
	
		var nextMonth = exports.nextMonth = function nextMonth(src) {
		  var year = src.getFullYear();
		  var month = src.getMonth();
		  var date = src.getDate();
	
		  var newYear = month === 11 ? year + 1 : year;
		  var newMonth = month === 11 ? 0 : month + 1;
	
		  var newMonthDayCount = getDayCountOfMonth(newYear, newMonth);
		  if (newMonthDayCount < date) {
		    src.setDate(newMonthDayCount);
		  }
	
		  src.setMonth(newMonth);
		  src.setFullYear(newYear);
	
		  return new Date(src.getTime());
		};
	
		var getRangeHours = exports.getRangeHours = function getRangeHours(ranges) {
		  var hours = [];
		  var disabledHours = [];
	
		  (ranges || []).forEach(function (range) {
		    var value = range.map(function (date) {
		      return date.getHours();
		    });
	
		    disabledHours = disabledHours.concat(newArray(value[0], value[1]));
		  });
	
		  if (disabledHours.length) {
		    for (var i = 0; i < 24; i++) {
		      hours[i] = disabledHours.indexOf(i) === -1;
		    }
		  } else {
		    for (var _i = 0; _i < 24; _i++) {
		      hours[_i] = false;
		    }
		  }
	
		  return hours;
		};
	
		var limitRange = exports.limitRange = function limitRange(date, ranges) {
		  if (!ranges || !ranges.length) return date;
	
		  var len = ranges.length;
		  var format = 'HH:mm:ss';
	
		  date = _date2.default.parse(_date2.default.format(date, format), format);
		  for (var i = 0; i < len; i++) {
		    var range = ranges[i];
		    if (date >= range[0] && date <= range[1]) {
		      return date;
		    }
		  }
	
		  var maxDate = ranges[0][0];
		  var minDate = ranges[0][0];
	
		  ranges.forEach(function (range) {
		    minDate = new Date(Math.min(range[0], minDate));
		    maxDate = new Date(Math.max(range[1], maxDate));
		  });
	
		  return date < minDate ? minDate : maxDate;
		};
	
	/***/ },
	/* 145 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(419);
	
	/***/ },
	/* 146 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('el-input', {
		    directives: [{
		      name: "clickoutside",
		      rawName: "v-clickoutside",
		      value: (_vm.handleClose),
		      expression: "handleClose"
		    }],
		    ref: "reference",
		    staticClass: "el-date-editor",
		    class: 'el-date-editor--' + _vm.type,
		    attrs: {
		      "readonly": !_vm.editable || _vm.readonly,
		      "disabled": _vm.disabled,
		      "size": _vm.size,
		      "placeholder": _vm.placeholder,
		      "value": _vm.displayValue
		    },
		    on: {
		      "focus": _vm.handleFocus,
		      "blur": _vm.handleBlur
		    },
		    nativeOn: {
		      "keydown": function($event) {
		        _vm.handleKeydown($event)
		      },
		      "change": function($event) {
		        _vm.displayValue = $event.target.value
		      }
		    }
		  }, [(_vm.haveTrigger) ? _c('i', {
		    staticClass: "el-input__icon",
		    class: [_vm.showClose ? 'el-icon-close' : _vm.triggerClass],
		    on: {
		      "click": _vm.handleClickIcon,
		      "mouseenter": _vm.handleMouseEnterIcon,
		      "mouseleave": function($event) {
		        _vm.showClose = false
		      }
		    },
		    slot: "icon"
		  }) : _vm._e()])
		},staticRenderFns: []}
	
	/***/ },
	/* 147 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(148)
	
		/* template */
		var __vue_template__ = __webpack_require__(164)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 148 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _util = __webpack_require__(144);
	
		var _locale = __webpack_require__(9);
	
		var _locale2 = _interopRequireDefault(_locale);
	
		var _input = __webpack_require__(18);
	
		var _input2 = _interopRequireDefault(_input);
	
		var _time = __webpack_require__(149);
	
		var _time2 = _interopRequireDefault(_time);
	
		var _yearTable = __webpack_require__(155);
	
		var _yearTable2 = _interopRequireDefault(_yearTable);
	
		var _monthTable = __webpack_require__(158);
	
		var _monthTable2 = _interopRequireDefault(_monthTable);
	
		var _dateTable = __webpack_require__(161);
	
		var _dateTable2 = _interopRequireDefault(_dateTable);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  mixins: [_locale2.default],
	
		  watch: {
		    showTime: function showTime(val) {
		      var _this = this;
	
		      /* istanbul ignore if */
		      if (!val) return;
		      this.$nextTick(function (_) {
		        var inputElm = _this.$refs.input.$el;
		        if (inputElm) {
		          _this.pickerWidth = inputElm.getBoundingClientRect().width + 10;
		        }
		      });
		    },
		    value: function value(newVal) {
		      if (!newVal) return;
		      newVal = new Date(newVal);
		      if (!isNaN(newVal)) {
		        if (typeof this.disabledDate === 'function' && this.disabledDate(new Date(newVal))) {
		          return;
		        }
		        this.date = newVal;
		        this.year = newVal.getFullYear();
		        this.month = newVal.getMonth();
		        this.$emit('pick', newVal, true);
		      }
		    },
		    timePickerVisible: function timePickerVisible(val) {
		      var _this2 = this;
	
		      if (val) this.$nextTick(function () {
		        return _this2.$refs.timepicker.ajustScrollTop();
		      });
		    },
		    selectionMode: function selectionMode(newVal) {
		      if (newVal === 'month') {
		        /* istanbul ignore next */
		        if (this.currentView !== 'year' || this.currentView !== 'month') {
		          this.currentView = 'month';
		        }
		      }
		    },
		    date: function date(newVal) {
		      /* istanbul ignore next */
		      if (!this.year) {
		        this.year = newVal.getFullYear();
		        this.month = newVal.getMonth();
		      }
		    }
		  },
	
		  methods: {
		    handleClear: function handleClear() {
		      this.date = new Date();
		      this.$emit('pick');
		    },
		    resetDate: function resetDate() {
		      this.date = new Date(this.date);
		    },
		    showMonthPicker: function showMonthPicker() {
		      this.currentView = 'month';
		    },
		    showYearPicker: function showYearPicker() {
		      this.currentView = 'year';
		    },
	
	
		    // XXX: 没用到
		    // handleLabelClick() {
		    //   if (this.currentView === 'date') {
		    //     this.showMonthPicker();
		    //   } else if (this.currentView === 'month') {
		    //     this.showYearPicker();
		    //   }
		    // },
	
		    prevMonth: function prevMonth() {
		      this.month--;
		      if (this.month < 0) {
		        this.month = 11;
		        this.year--;
		      }
		    },
		    nextMonth: function nextMonth() {
		      this.month++;
		      if (this.month > 11) {
		        this.month = 0;
		        this.year++;
		      }
		    },
		    nextYear: function nextYear() {
		      if (this.currentView === 'year') {
		        this.$refs.yearTable.nextTenYear();
		      } else {
		        this.year++;
		        this.date.setFullYear(this.year);
		        this.resetDate();
		      }
		    },
		    prevYear: function prevYear() {
		      if (this.currentView === 'year') {
		        this.$refs.yearTable.prevTenYear();
		      } else {
		        this.year--;
		        this.date.setFullYear(this.year);
		        this.resetDate();
		      }
		    },
		    handleShortcutClick: function handleShortcutClick(shortcut) {
		      if (shortcut.onClick) {
		        shortcut.onClick(this);
		      }
		    },
		    handleTimePick: function handleTimePick(picker, visible, first) {
		      if (picker) {
		        var oldDate = new Date(this.date.getTime());
		        var hour = picker.getHours();
		        var minute = picker.getMinutes();
		        var second = picker.getSeconds();
		        oldDate.setHours(hour);
		        oldDate.setMinutes(minute);
		        oldDate.setSeconds(second);
		        this.date = new Date(oldDate.getTime());
		      }
	
		      if (!first) {
		        this.timePickerVisible = visible;
		      }
		    },
		    handleMonthPick: function handleMonthPick(month) {
		      this.month = month;
		      var selectionMode = this.selectionMode;
		      if (selectionMode !== 'month') {
		        this.date.setMonth(month);
		        this.currentView = 'date';
		        this.resetDate();
		      } else {
		        this.date.setMonth(month);
		        this.year && this.date.setFullYear(this.year);
		        this.resetDate();
		        var value = new Date(this.date.getFullYear(), month, 1);
		        this.$emit('pick', value);
		      }
		    },
		    handleDatePick: function handleDatePick(value) {
		      if (this.selectionMode === 'day') {
		        if (!this.showTime) {
		          this.$emit('pick', new Date(value.getTime()));
		        }
		        this.date.setFullYear(value.getFullYear());
		        this.date.setMonth(value.getMonth());
		        this.date.setDate(value.getDate());
		      } else if (this.selectionMode === 'week') {
		        var date = (0, _util.formatDate)(value.date, this.format || 'yyyywWW');
		        var week = this.week = value.week;
	
		        date = /WW/.test(date) ? date.replace(/WW/, week < 10 ? '0' + week : week) : date.replace(/W/, week);
	
		        this.$emit('pick', date);
		      }
	
		      this.resetDate();
		    },
		    handleYearPick: function handleYearPick(year) {
		      var close = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
		      this.year = year;
		      if (!close) return;
	
		      this.date.setFullYear(year);
		      if (this.selectionMode === 'year') {
		        this.$emit('pick', new Date(year));
		      } else {
		        this.currentView = 'month';
		      }
	
		      this.resetDate();
		    },
		    changeToNow: function changeToNow() {
		      this.date.setTime(+new Date());
		      this.$emit('pick', new Date(this.date.getTime()));
		      this.resetDate();
		    },
		    confirm: function confirm() {
		      this.$emit('pick', this.date);
		    },
		    resetView: function resetView() {
		      if (this.selectionMode === 'month') {
		        this.currentView = 'month';
		      } else if (this.selectionMode === 'year') {
		        this.currentView = 'year';
		      } else {
		        this.currentView = 'date';
		      }
	
		      if (this.selectionMode !== 'week') {
		        this.year = this.date.getFullYear();
		        this.month = this.date.getMonth();
		      }
		    }
		  },
	
		  components: {
		    TimePicker: _time2.default, YearTable: _yearTable2.default, MonthTable: _monthTable2.default, DateTable: _dateTable2.default, ElInput: _input2.default
		  },
	
		  mounted: function mounted() {
		    if (this.selectionMode === 'month') {
		      this.currentView = 'month';
		    }
	
		    if (this.date && !this.year) {
		      this.year = this.date.getFullYear();
		      this.month = this.date.getMonth();
		    }
		  },
		  data: function data() {
		    return {
		      popperClass: '',
		      pickerWidth: 0,
		      date: new Date(),
		      value: '',
		      showTime: false,
		      selectionMode: 'day',
		      shortcuts: '',
		      visible: false,
		      currentView: 'date',
		      disabledDate: '',
		      firstDayOfWeek: 7,
		      year: null,
		      month: null,
		      week: null,
		      showWeekNumber: false,
		      timePickerVisible: false,
		      width: 0
		    };
		  },
	
	
		  computed: {
		    footerVisible: function footerVisible() {
		      return this.showTime;
		    },
	
	
		    visibleTime: {
		      get: function get() {
		        return (0, _util.formatDate)(this.date, 'HH:mm:ss');
		      },
		      set: function set(val) {
		        if (val) {
		          var date = (0, _util.parseDate)(val, 'HH:mm:ss');
		          if (date) {
		            date.setFullYear(this.date.getFullYear());
		            date.setMonth(this.date.getMonth());
		            date.setDate(this.date.getDate());
		            this.date = date;
		            this.$refs.timepicker.value = date;
		            this.timePickerVisible = false;
		          }
		        }
		      }
		    },
	
		    visibleDate: {
		      get: function get() {
		        return (0, _util.formatDate)(this.date);
		      },
		      set: function set(val) {
		        var date = (0, _util.parseDate)(val, 'yyyy-MM-dd');
		        if (date) {
		          date.setHours(this.date.getHours());
		          date.setMinutes(this.date.getMinutes());
		          date.setSeconds(this.date.getSeconds());
		          this.date = date;
		          this.resetView();
		        }
		      }
		    },
	
		    yearLabel: function yearLabel() {
		      var year = this.year;
		      if (!year) return '';
		      var yearTranslation = this.t('el.datepicker.year');
		      if (this.currentView === 'year') {
		        var startYear = Math.floor(year / 10) * 10;
		        if (yearTranslation) {
		          return startYear + ' ' + yearTranslation + ' - ' + (startYear + 9) + ' ' + yearTranslation;
		        }
		        return startYear + ' - ' + (startYear + 9);
		      }
		      return this.year + ' ' + yearTranslation;
		    }
		  }
		}; //
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
	/***/ },
	/* 149 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(150)
	
		/* template */
		var __vue_template__ = __webpack_require__(154)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 150 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _util = __webpack_require__(144);
	
		var _locale = __webpack_require__(9);
	
		var _locale2 = _interopRequireDefault(_locale);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  mixins: [_locale2.default],
	
		  components: {
		    TimeSpinner: __webpack_require__(151)
		  },
	
		  props: {
		    pickerWidth: {},
		    date: {
		      default: function _default() {
		        return new Date();
		      }
		    },
		    visible: Boolean
		  },
	
		  watch: {
		    visible: function visible(val) {
		      this.currentVisible = val;
		    },
		    pickerWidth: function pickerWidth(val) {
		      this.width = val;
		    },
		    value: function value(newVal) {
		      var _this = this;
	
		      var date = void 0;
		      if (newVal instanceof Date) {
		        date = (0, _util.limitRange)(newVal, this.selectableRange);
		      } else if (!newVal) {
		        date = new Date();
		      }
	
		      this.handleChange({
		        hours: date.getHours(),
		        minutes: date.getMinutes(),
		        seconds: date.getSeconds()
		      });
		      this.$nextTick(function (_) {
		        return _this.ajustScrollTop();
		      });
		    },
		    selectableRange: function selectableRange(val) {
		      this.$refs.spinner.selectableRange = val;
		    }
		  },
	
		  data: function data() {
		    return {
		      popperClass: '',
		      format: 'HH:mm:ss',
		      value: '',
		      hours: 0,
		      minutes: 0,
		      seconds: 0,
		      selectableRange: [],
		      currentDate: this.$options.defaultValue || this.date || new Date(),
		      currentVisible: this.visible || false,
		      width: this.pickerWidth || 0
		    };
		  },
	
	
		  computed: {
		    showSeconds: function showSeconds() {
		      return (this.format || '').indexOf('ss') !== -1;
		    }
		  },
	
		  methods: {
		    handleClear: function handleClear() {
		      this.$emit('pick');
		    },
		    handleCancel: function handleCancel() {
		      this.$emit('pick');
		    },
		    handleChange: function handleChange(date) {
		      if (date.hours !== undefined) {
		        this.currentDate.setHours(date.hours);
		        this.hours = this.currentDate.getHours();
		      }
		      if (date.minutes !== undefined) {
		        this.currentDate.setMinutes(date.minutes);
		        this.minutes = this.currentDate.getMinutes();
		      }
		      if (date.seconds !== undefined) {
		        this.currentDate.setSeconds(date.seconds);
		        this.seconds = this.currentDate.getSeconds();
		      }
	
		      this.handleConfirm(true);
		    },
		    setSelectionRange: function setSelectionRange(start, end) {
		      this.$emit('select-range', start, end);
		    },
		    handleConfirm: function handleConfirm() {
		      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
		      var first = arguments[1];
	
		      if (first) return;
		      var date = new Date((0, _util.limitRange)(this.currentDate, this.selectableRange));
		      this.$emit('pick', date, visible, first);
		    },
		    ajustScrollTop: function ajustScrollTop() {
		      return this.$refs.spinner.ajustScrollTop();
		    }
		  },
	
		  created: function created() {
		    this.hours = this.currentDate.getHours();
		    this.minutes = this.currentDate.getMinutes();
		    this.seconds = this.currentDate.getSeconds();
		  },
		  mounted: function mounted() {
		    var _this2 = this;
	
		    this.$nextTick(function () {
		      return _this2.handleConfirm(true, true);
		    });
		  }
		};
	
	/***/ },
	/* 151 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(152)
	
		/* template */
		var __vue_template__ = __webpack_require__(153)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 152 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _util = __webpack_require__(144);
	
		var _scrollbar = __webpack_require__(102);
	
		var _scrollbar2 = _interopRequireDefault(_scrollbar);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  components: { ElScrollbar: _scrollbar2.default },
	
		  props: {
		    hours: {
		      type: Number,
		      default: 0
		    },
	
		    minutes: {
		      type: Number,
		      default: 0
		    },
	
		    seconds: {
		      type: Number,
		      default: 0
		    },
	
		    showSeconds: {
		      type: Boolean,
		      default: true
		    }
		  },
	
		  watch: {
		    hoursPrivate: function hoursPrivate(newVal, oldVal) {
		      if (!(newVal >= 0 && newVal <= 23)) {
		        this.hoursPrivate = oldVal;
		      }
		      this.hourEl.scrollTop = Math.max(0, (this.hoursPrivate - 2.5) * 32 + 80);
		      this.$emit('change', { hours: newVal });
		    },
		    minutesPrivate: function minutesPrivate(newVal, oldVal) {
		      if (!(newVal >= 0 && newVal <= 59)) {
		        this.minutesPrivate = oldVal;
		      }
		      this.minuteEl.scrollTop = Math.max(0, (this.minutesPrivate - 2.5) * 32 + 80);
		      this.$emit('change', { minutes: newVal });
		    },
		    secondsPrivate: function secondsPrivate(newVal, oldVal) {
		      if (!(newVal >= 0 && newVal <= 59)) {
		        this.secondsPrivate = oldVal;
		      }
		      this.secondEl.scrollTop = Math.max(0, (this.secondsPrivate - 2.5) * 32 + 80);
		      this.$emit('change', { seconds: newVal });
		    }
		  },
	
		  computed: {
		    hoursList: function hoursList() {
		      return (0, _util.getRangeHours)(this.selectableRange);
		    },
		    hourEl: function hourEl() {
		      return this.$refs.hour.wrap;
		    },
		    minuteEl: function minuteEl() {
		      return this.$refs.minute.wrap;
		    },
		    secondEl: function secondEl() {
		      return this.$refs.second.wrap;
		    }
		  },
	
		  data: function data() {
		    return {
		      hoursPrivate: 0,
		      minutesPrivate: 0,
		      secondsPrivate: 0,
		      selectableRange: []
		    };
		  },
	
	
		  methods: {
		    handleClick: function handleClick(type, value, disabled) {
		      if (value.disabled) {
		        return;
		      }
	
		      this[type + 'Private'] = value.value >= 0 ? value.value : value;
	
		      this.emitSelectRange(type);
		    },
		    emitSelectRange: function emitSelectRange(type) {
		      if (type === 'hours') {
		        this.$emit('select-range', 0, 2);
		      } else if (type === 'minutes') {
		        this.$emit('select-range', 3, 5);
		      } else if (type === 'seconds') {
		        this.$emit('select-range', 6, 8);
		      }
		    },
		    handleScroll: function handleScroll(type) {
		      var ajust = {};
	
		      ajust[type + 's'] = Math.min(Math.floor((this[type + 'El'].scrollTop - 80) / 32 + 3), 59);
		      this.$emit('change', ajust);
		    },
		    ajustScrollTop: function ajustScrollTop() {
		      this.hourEl.scrollTop = Math.max(0, (this.hours - 2.5) * 32 + 80);
		      this.minuteEl.scrollTop = Math.max(0, (this.minutes - 2.5) * 32 + 80);
		      this.secondEl.scrollTop = Math.max(0, (this.seconds - 2.5) * 32 + 80);
		    }
		  }
		};
	
	/***/ },
	/* 153 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    staticClass: "el-time-spinner",
		    class: {
		      'has-seconds': _vm.showSeconds
		    }
		  }, [_c('el-scrollbar', {
		    ref: "hour",
		    staticClass: "el-time-spinner__wrapper",
		    attrs: {
		      "wrap-style": "max-height: inherit;",
		      "view-class": "el-time-spinner__list",
		      "noresize": "",
		      "tag": "ul"
		    },
		    nativeOn: {
		      "mouseenter": function($event) {
		        _vm.emitSelectRange('hours')
		      },
		      "mousewheel": function($event) {
		        _vm.handleScroll('hour')
		      }
		    }
		  }, _vm._l((_vm.hoursList), function(disabled, hour) {
		    return _c('li', {
		      staticClass: "el-time-spinner__item",
		      class: {
		        'active': hour === _vm.hours, 'disabled': disabled
		      },
		      attrs: {
		        "track-by": "hour"
		      },
		      domProps: {
		        "textContent": _vm._s(hour)
		      },
		      on: {
		        "click": function($event) {
		          _vm.handleClick('hours', {
		            value: hour,
		            disabled: disabled
		          }, true)
		        }
		      }
		    })
		  })), _c('el-scrollbar', {
		    ref: "minute",
		    staticClass: "el-time-spinner__wrapper",
		    attrs: {
		      "wrap-style": "max-height: inherit;",
		      "view-class": "el-time-spinner__list",
		      "noresize": "",
		      "tag": "ul"
		    },
		    nativeOn: {
		      "mouseenter": function($event) {
		        _vm.emitSelectRange('minutes')
		      },
		      "mousewheel": function($event) {
		        _vm.handleScroll('minute')
		      }
		    }
		  }, _vm._l((60), function(minute, key) {
		    return _c('li', {
		      staticClass: "el-time-spinner__item",
		      class: {
		        'active': key === _vm.minutes
		      },
		      domProps: {
		        "textContent": _vm._s(key)
		      },
		      on: {
		        "click": function($event) {
		          _vm.handleClick('minutes', key, true)
		        }
		      }
		    })
		  })), _c('el-scrollbar', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.showSeconds),
		      expression: "showSeconds"
		    }],
		    ref: "second",
		    staticClass: "el-time-spinner__wrapper",
		    attrs: {
		      "wrap-style": "max-height: inherit;",
		      "view-class": "el-time-spinner__list",
		      "noresize": "",
		      "tag": "ul"
		    },
		    nativeOn: {
		      "mouseenter": function($event) {
		        _vm.emitSelectRange('seconds')
		      },
		      "mousewheel": function($event) {
		        _vm.handleScroll('second')
		      }
		    }
		  }, _vm._l((60), function(second, key) {
		    return _c('li', {
		      staticClass: "el-time-spinner__item",
		      class: {
		        'active': key === _vm.seconds
		      },
		      domProps: {
		        "textContent": _vm._s(key)
		      },
		      on: {
		        "click": function($event) {
		          _vm.handleClick('seconds', key, true)
		        }
		      }
		    })
		  }))], 1)
		},staticRenderFns: []}
	
	/***/ },
	/* 154 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('transition', {
		    attrs: {
		      "name": "el-zoom-in-top"
		    },
		    on: {
		      "after-leave": function($event) {
		        _vm.$emit('dodestroy')
		      }
		    }
		  }, [_c('div', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.currentVisible),
		      expression: "currentVisible"
		    }],
		    staticClass: "el-time-panel",
		    class: _vm.popperClass,
		    style: ({
		      width: _vm.width + 'px'
		    })
		  }, [_c('div', {
		    staticClass: "el-time-panel__content",
		    class: {
		      'has-seconds': _vm.showSeconds
		    }
		  }, [_c('time-spinner', {
		    ref: "spinner",
		    attrs: {
		      "show-seconds": _vm.showSeconds,
		      "hours": _vm.hours,
		      "minutes": _vm.minutes,
		      "seconds": _vm.seconds
		    },
		    on: {
		      "change": _vm.handleChange,
		      "select-range": _vm.setSelectionRange
		    }
		  })], 1), _c('div', {
		    staticClass: "el-time-panel__footer"
		  }, [_c('button', {
		    staticClass: "el-time-panel__btn cancel",
		    attrs: {
		      "type": "button"
		    },
		    on: {
		      "click": _vm.handleCancel
		    }
		  }, [_vm._v(_vm._s(_vm.t('el.datepicker.cancel')))]), _c('button', {
		    staticClass: "el-time-panel__btn confirm",
		    attrs: {
		      "type": "button"
		    },
		    on: {
		      "click": function($event) {
		        _vm.handleConfirm()
		      }
		    }
		  }, [_vm._v(_vm._s(_vm.t('el.datepicker.confirm')))])])])])
		},staticRenderFns: []}
	
	/***/ },
	/* 155 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(156)
	
		/* template */
		var __vue_template__ = __webpack_require__(157)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 156 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _dom = __webpack_require__(66);
	
		exports.default = {
		  props: {
		    disabledDate: {},
		    date: {},
		    year: {}
		  },
	
		  computed: {
		    startYear: function startYear() {
		      return Math.floor(this.year / 10) * 10;
		    }
		  },
	
		  methods: {
		    getCellStyle: function getCellStyle(year) {
		      var style = {};
		      var date = new Date(this.date);
	
		      date.setFullYear(year);
		      style.disabled = typeof this.disabledDate === 'function' && this.disabledDate(date);
		      style.current = Number(this.year) === year;
	
		      return style;
		    },
		    nextTenYear: function nextTenYear() {
		      this.$emit('pick', Number(this.year) + 10, false);
		    },
		    prevTenYear: function prevTenYear() {
		      this.$emit('pick', Number(this.year) - 10, false);
		    },
		    handleYearTableClick: function handleYearTableClick(event) {
		      var target = event.target;
		      if (target.tagName === 'A') {
		        if ((0, _dom.hasClass)(target.parentNode, 'disabled')) return;
		        var year = target.textContent || target.innerText;
		        this.$emit('pick', year);
		      }
		    }
		  }
		}; //
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
	/***/ },
	/* 157 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('table', {
		    staticClass: "el-year-table",
		    on: {
		      "click": _vm.handleYearTableClick
		    }
		  }, [_c('tbody', [_c('tr', [_c('td', {
		    staticClass: "available",
		    class: _vm.getCellStyle(_vm.startYear + 0)
		  }, [_c('a', {
		    staticClass: "cell"
		  }, [_vm._v(_vm._s(_vm.startYear))])]), _c('td', {
		    staticClass: "available",
		    class: _vm.getCellStyle(_vm.startYear + 1)
		  }, [_c('a', {
		    staticClass: "cell"
		  }, [_vm._v(_vm._s(_vm.startYear + 1))])]), _c('td', {
		    staticClass: "available",
		    class: _vm.getCellStyle(_vm.startYear + 2)
		  }, [_c('a', {
		    staticClass: "cell"
		  }, [_vm._v(_vm._s(_vm.startYear + 2))])]), _c('td', {
		    staticClass: "available",
		    class: _vm.getCellStyle(_vm.startYear + 3)
		  }, [_c('a', {
		    staticClass: "cell"
		  }, [_vm._v(_vm._s(_vm.startYear + 3))])])]), _c('tr', [_c('td', {
		    staticClass: "available",
		    class: _vm.getCellStyle(_vm.startYear + 4)
		  }, [_c('a', {
		    staticClass: "cell"
		  }, [_vm._v(_vm._s(_vm.startYear + 4))])]), _c('td', {
		    staticClass: "available",
		    class: _vm.getCellStyle(_vm.startYear + 5)
		  }, [_c('a', {
		    staticClass: "cell"
		  }, [_vm._v(_vm._s(_vm.startYear + 5))])]), _c('td', {
		    staticClass: "available",
		    class: _vm.getCellStyle(_vm.startYear + 6)
		  }, [_c('a', {
		    staticClass: "cell"
		  }, [_vm._v(_vm._s(_vm.startYear + 6))])]), _c('td', {
		    staticClass: "available",
		    class: _vm.getCellStyle(_vm.startYear + 7)
		  }, [_c('a', {
		    staticClass: "cell"
		  }, [_vm._v(_vm._s(_vm.startYear + 7))])])]), _c('tr', [_c('td', {
		    staticClass: "available",
		    class: _vm.getCellStyle(_vm.startYear + 8)
		  }, [_c('a', {
		    staticClass: "cell"
		  }, [_vm._v(_vm._s(_vm.startYear + 8))])]), _c('td', {
		    staticClass: "available",
		    class: _vm.getCellStyle(_vm.startYear + 9)
		  }, [_c('a', {
		    staticClass: "cell"
		  }, [_vm._v(_vm._s(_vm.startYear + 9))])]), _c('td'), _c('td')])])])
		},staticRenderFns: []}
	
	/***/ },
	/* 158 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(159)
	
		/* template */
		var __vue_template__ = __webpack_require__(160)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 159 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _locale = __webpack_require__(9);
	
		var _locale2 = _interopRequireDefault(_locale);
	
		var _dom = __webpack_require__(66);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  props: {
		    disabledDate: {},
		    date: {},
		    month: {
		      type: Number
		    }
		  },
		  mixins: [_locale2.default],
		  methods: {
		    getCellStyle: function getCellStyle(month) {
		      var style = {};
		      var date = new Date(this.date);
	
		      date.setMonth(month);
		      style.disabled = typeof this.disabledDate === 'function' && this.disabledDate(date);
		      style.current = this.month === month;
	
		      return style;
		    },
		    handleMonthTableClick: function handleMonthTableClick(event) {
		      var target = event.target;
		      if (target.tagName !== 'A') return;
		      if ((0, _dom.hasClass)(target.parentNode, 'disabled')) return;
		      var column = target.parentNode.cellIndex;
		      var row = target.parentNode.parentNode.rowIndex;
		      var month = row * 4 + column;
	
		      this.$emit('pick', month);
		    }
		  }
		};
	
	/***/ },
	/* 160 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('table', {
		    staticClass: "el-month-table",
		    on: {
		      "click": _vm.handleMonthTableClick
		    }
		  }, [_c('tbody', [_c('tr', [_c('td', {
		    class: _vm.getCellStyle(0)
		  }, [_c('a', {
		    staticClass: "cell"
		  }, [_vm._v(_vm._s(_vm.t('el.datepicker.months.jan')))])]), _c('td', {
		    class: _vm.getCellStyle(1)
		  }, [_c('a', {
		    staticClass: "cell"
		  }, [_vm._v(_vm._s(_vm.t('el.datepicker.months.feb')))])]), _c('td', {
		    class: _vm.getCellStyle(2)
		  }, [_c('a', {
		    staticClass: "cell"
		  }, [_vm._v(_vm._s(_vm.t('el.datepicker.months.mar')))])]), _c('td', {
		    class: _vm.getCellStyle(3)
		  }, [_c('a', {
		    staticClass: "cell"
		  }, [_vm._v(_vm._s(_vm.t('el.datepicker.months.apr')))])])]), _c('tr', [_c('td', {
		    class: _vm.getCellStyle(4)
		  }, [_c('a', {
		    staticClass: "cell"
		  }, [_vm._v(_vm._s(_vm.t('el.datepicker.months.may')))])]), _c('td', {
		    class: _vm.getCellStyle(5)
		  }, [_c('a', {
		    staticClass: "cell"
		  }, [_vm._v(_vm._s(_vm.t('el.datepicker.months.jun')))])]), _c('td', {
		    class: _vm.getCellStyle(6)
		  }, [_c('a', {
		    staticClass: "cell"
		  }, [_vm._v(_vm._s(_vm.t('el.datepicker.months.jul')))])]), _c('td', {
		    class: _vm.getCellStyle(7)
		  }, [_c('a', {
		    staticClass: "cell"
		  }, [_vm._v(_vm._s(_vm.t('el.datepicker.months.aug')))])])]), _c('tr', [_c('td', {
		    class: _vm.getCellStyle(8)
		  }, [_c('a', {
		    staticClass: "cell"
		  }, [_vm._v(_vm._s(_vm.t('el.datepicker.months.sep')))])]), _c('td', {
		    class: _vm.getCellStyle(9)
		  }, [_c('a', {
		    staticClass: "cell"
		  }, [_vm._v(_vm._s(_vm.t('el.datepicker.months.oct')))])]), _c('td', {
		    class: _vm.getCellStyle(10)
		  }, [_c('a', {
		    staticClass: "cell"
		  }, [_vm._v(_vm._s(_vm.t('el.datepicker.months.nov')))])]), _c('td', {
		    class: _vm.getCellStyle(11)
		  }, [_c('a', {
		    staticClass: "cell"
		  }, [_vm._v(_vm._s(_vm.t('el.datepicker.months.dec')))])])])])])
		},staticRenderFns: []}
	
	/***/ },
	/* 161 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(162)
	
		/* template */
		var __vue_template__ = __webpack_require__(163)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 162 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _util = __webpack_require__(144);
	
		var _dom = __webpack_require__(66);
	
		var _locale = __webpack_require__(9);
	
		var _locale2 = _interopRequireDefault(_locale);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var _WEEKS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat']; //
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		var clearHours = function clearHours(time) {
		  var cloneDate = new Date(time);
		  cloneDate.setHours(0, 0, 0, 0);
		  return cloneDate.getTime();
		};
	
		exports.default = {
		  mixins: [_locale2.default],
	
		  props: {
		    firstDayOfWeek: {
		      default: 7,
		      type: Number,
		      validator: function validator(val) {
		        return val >= 1 && val <= 7;
		      }
		    },
	
		    date: {},
	
		    year: {},
	
		    month: {},
	
		    week: {},
	
		    selectionMode: {
		      default: 'day'
		    },
	
		    showWeekNumber: {
		      type: Boolean,
		      default: false
		    },
	
		    disabledDate: {},
	
		    minDate: {},
	
		    maxDate: {},
	
		    rangeState: {
		      default: function _default() {
		        return {
		          endDate: null,
		          selecting: false,
		          row: null,
		          column: null
		        };
		      }
		    },
	
		    value: {}
		  },
	
		  computed: {
		    offsetDay: function offsetDay() {
		      var week = this.firstDayOfWeek;
		      // 周日为界限，左右偏移的天数，3217654 例如周一就是 -1，目的是调整前两行日期的位置
		      return week > 3 ? 7 - week : -week;
		    },
		    WEEKS: function WEEKS() {
		      var week = this.firstDayOfWeek;
		      return _WEEKS.concat(_WEEKS).slice(week, week + 7);
		    },
		    monthDate: function monthDate() {
		      return this.date.getDate();
		    },
		    startDate: function startDate() {
		      return (0, _util.getStartDateOfMonth)(this.year, this.month);
		    },
		    rows: function rows() {
		      var date = new Date(this.year, this.month, 1);
		      var day = (0, _util.getFirstDayOfMonth)(date); // day of first day
		      var dateCountOfMonth = (0, _util.getDayCountOfMonth)(date.getFullYear(), date.getMonth());
		      var dateCountOfLastMonth = (0, _util.getDayCountOfMonth)(date.getFullYear(), date.getMonth() === 0 ? 11 : date.getMonth() - 1);
	
		      day = day === 0 ? 7 : day;
	
		      var offset = this.offsetDay;
		      var rows = this.tableRows;
		      var count = 1;
		      var firstDayPosition = void 0;
	
		      var startDate = this.startDate;
		      var disabledDate = this.disabledDate;
		      var now = clearHours(new Date());
	
		      for (var i = 0; i < 6; i++) {
		        var row = rows[i];
	
		        if (this.showWeekNumber) {
		          if (!row[0]) {
		            row[0] = { type: 'week', text: (0, _util.getWeekNumber)(new Date(startDate.getTime() + _util.DAY_DURATION * (i * 7 + 1))) };
		          }
		        }
	
		        for (var j = 0; j < 7; j++) {
		          var cell = row[this.showWeekNumber ? j + 1 : j];
		          if (!cell) {
		            cell = { row: i, column: j, type: 'normal', inRange: false, start: false, end: false };
		          }
	
		          cell.type = 'normal';
	
		          var index = i * 7 + j;
		          var time = startDate.getTime() + _util.DAY_DURATION * (index - offset);
		          cell.inRange = time >= clearHours(this.minDate) && time <= clearHours(this.maxDate);
		          cell.start = this.minDate && time === clearHours(this.minDate);
		          cell.end = this.maxDate && time === clearHours(this.maxDate);
		          var isToday = time === now;
	
		          if (isToday) {
		            cell.type = 'today';
		          }
	
		          if (i >= 0 && i <= 1) {
		            if (j + i * 7 >= day + offset) {
		              cell.text = count++;
		              if (count === 2) {
		                firstDayPosition = i * 7 + j;
		              }
		            } else {
		              cell.text = dateCountOfLastMonth - (day + offset - j % 7) + 1 + i * 7;
		              cell.type = 'prev-month';
		            }
		          } else {
		            if (count <= dateCountOfMonth) {
		              cell.text = count++;
		              if (count === 2) {
		                firstDayPosition = i * 7 + j;
		              }
		            } else {
		              cell.text = count++ - dateCountOfMonth;
		              cell.type = 'next-month';
		            }
		          }
	
		          cell.disabled = typeof disabledDate === 'function' && disabledDate(new Date(time));
	
		          this.$set(row, this.showWeekNumber ? j + 1 : j, cell);
		        }
	
		        if (this.selectionMode === 'week') {
		          var start = this.showWeekNumber ? 1 : 0;
		          var end = this.showWeekNumber ? 7 : 6;
		          var isWeekActive = this.isWeekActive(row[start + 1]);
	
		          row[start].inRange = isWeekActive;
		          row[start].start = isWeekActive;
		          row[end].inRange = isWeekActive;
		          row[end].end = isWeekActive;
		        }
		      }
	
		      rows.firstDayPosition = firstDayPosition;
	
		      return rows;
		    }
		  },
	
		  watch: {
		    'rangeState.endDate': function rangeStateEndDate(newVal) {
		      this.markRange(newVal);
		    },
		    minDate: function minDate(newVal, oldVal) {
		      if (newVal && !oldVal) {
		        this.rangeState.selecting = true;
		        this.markRange(newVal);
		      } else if (!newVal) {
		        this.rangeState.selecting = false;
		        this.markRange(newVal);
		      } else {
		        this.markRange();
		      }
		    },
		    maxDate: function maxDate(newVal, oldVal) {
		      if (newVal && !oldVal) {
		        this.rangeState.selecting = false;
		        this.markRange(newVal);
		        this.$emit('pick', {
		          minDate: this.minDate,
		          maxDate: this.maxDate
		        });
		      }
		    }
		  },
	
		  data: function data() {
		    return {
		      tableRows: [[], [], [], [], [], []]
		    };
		  },
	
	
		  methods: {
		    getCellClasses: function getCellClasses(cell) {
		      var selectionMode = this.selectionMode;
		      var monthDate = this.monthDate;
	
		      var classes = [];
		      if ((cell.type === 'normal' || cell.type === 'today') && !cell.disabled) {
		        classes.push('available');
		        if (cell.type === 'today') {
		          classes.push('today');
		        }
		      } else {
		        classes.push(cell.type);
		      }
	
		      if (selectionMode === 'day' && (cell.type === 'normal' || cell.type === 'today') && Number(this.year) === this.date.getFullYear() && this.month === this.date.getMonth() && monthDate === Number(cell.text)) {
		        classes.push('current');
		      }
	
		      if (cell.inRange && (cell.type === 'normal' || cell.type === 'today' || this.selectionMode === 'week')) {
		        classes.push('in-range');
	
		        if (cell.start) {
		          classes.push('start-date');
		        }
	
		        if (cell.end) {
		          classes.push('end-date');
		        }
		      }
	
		      if (cell.disabled) {
		        classes.push('disabled');
		      }
	
		      return classes.join(' ');
		    },
		    getDateOfCell: function getDateOfCell(row, column) {
		      var startDate = this.startDate;
	
		      return new Date(startDate.getTime() + (row * 7 + (column - (this.showWeekNumber ? 1 : 0))) * _util.DAY_DURATION);
		    },
		    getCellByDate: function getCellByDate(date) {
		      var startDate = this.startDate;
		      var rows = this.rows;
		      var index = (date - startDate) / _util.DAY_DURATION;
		      var row = rows[Math.floor(index / 7)];
	
		      if (this.showWeekNumber) {
		        return row[index % 7 + 1];
		      } else {
		        return row[index % 7];
		      }
		    },
		    isWeekActive: function isWeekActive(cell) {
		      if (this.selectionMode !== 'week') return false;
		      var newDate = new Date(this.year, this.month, 1);
		      var year = newDate.getFullYear();
		      var month = newDate.getMonth();
	
		      if (cell.type === 'prev-month') {
		        newDate.setMonth(month === 0 ? 11 : month - 1);
		        newDate.setFullYear(month === 0 ? year - 1 : year);
		      }
	
		      if (cell.type === 'next-month') {
		        newDate.setMonth(month === 11 ? 0 : month + 1);
		        newDate.setFullYear(month === 11 ? year + 1 : year);
		      }
	
		      newDate.setDate(parseInt(cell.text, 10));
	
		      return (0, _util.getWeekNumber)(newDate) === this.week;
		    },
		    markRange: function markRange(maxDate) {
		      var startDate = this.startDate;
		      if (!maxDate) {
		        maxDate = this.maxDate;
		      }
	
		      var rows = this.rows;
		      var minDate = this.minDate;
		      for (var i = 0, k = rows.length; i < k; i++) {
		        var row = rows[i];
		        for (var j = 0, l = row.length; j < l; j++) {
		          if (this.showWeekNumber && j === 0) continue;
	
		          var cell = row[j];
		          var index = i * 7 + j + (this.showWeekNumber ? -1 : 0);
		          var time = startDate.getTime() + _util.DAY_DURATION * index;
	
		          cell.inRange = minDate && time >= clearHours(minDate) && time <= clearHours(maxDate);
		          cell.start = minDate && time === clearHours(minDate.getTime());
		          cell.end = maxDate && time === clearHours(maxDate.getTime());
		        }
		      }
		    },
		    handleMouseMove: function handleMouseMove(event) {
		      if (!this.rangeState.selecting) return;
	
		      this.$emit('changerange', {
		        minDate: this.minDate,
		        maxDate: this.maxDate,
		        rangeState: this.rangeState
		      });
	
		      var target = event.target;
		      if (target.tagName !== 'TD') return;
	
		      var column = target.cellIndex;
		      var row = target.parentNode.rowIndex - 1;
		      var _rangeState = this.rangeState,
		          oldRow = _rangeState.row,
		          oldColumn = _rangeState.column;
	
	
		      if (oldRow !== row || oldColumn !== column) {
		        this.rangeState.row = row;
		        this.rangeState.column = column;
	
		        this.rangeState.endDate = this.getDateOfCell(row, column);
		      }
		    },
		    handleClick: function handleClick(event) {
		      var target = event.target;
	
		      if (target.tagName !== 'TD') return;
		      if ((0, _dom.hasClass)(target, 'disabled') || (0, _dom.hasClass)(target, 'week')) return;
	
		      var selectionMode = this.selectionMode;
	
		      if (selectionMode === 'week') {
		        target = target.parentNode.cells[1];
		      }
	
		      var year = Number(this.year);
		      var month = Number(this.month);
	
		      var cellIndex = target.cellIndex;
		      var rowIndex = target.parentNode.rowIndex;
	
		      var cell = this.rows[rowIndex - 1][cellIndex];
		      var text = cell.text;
		      var className = target.className;
	
		      var newDate = new Date(year, month, 1);
	
		      if (className.indexOf('prev') !== -1) {
		        if (month === 0) {
		          year = year - 1;
		          month = 11;
		        } else {
		          month = month - 1;
		        }
		        newDate.setFullYear(year);
		        newDate.setMonth(month);
		      } else if (className.indexOf('next') !== -1) {
		        if (month === 11) {
		          year = year + 1;
		          month = 0;
		        } else {
		          month = month + 1;
		        }
		        newDate.setFullYear(year);
		        newDate.setMonth(month);
		      }
	
		      newDate.setDate(parseInt(text, 10));
	
		      if (this.selectionMode === 'range') {
		        if (this.minDate && this.maxDate) {
		          var minDate = new Date(newDate.getTime());
		          var maxDate = null;
	
		          this.$emit('pick', { minDate: minDate, maxDate: maxDate }, false);
		          this.rangeState.selecting = true;
		          this.markRange(this.minDate);
		        } else if (this.minDate && !this.maxDate) {
		          if (newDate >= this.minDate) {
		            var _maxDate = new Date(newDate.getTime());
		            this.rangeState.selecting = false;
	
		            this.$emit('pick', {
		              minDate: this.minDate,
		              maxDate: _maxDate
		            });
		          } else {
		            var _minDate = new Date(newDate.getTime());
	
		            this.$emit('pick', { minDate: _minDate, maxDate: this.maxDate }, false);
		          }
		        } else if (!this.minDate) {
		          var _minDate2 = new Date(newDate.getTime());
	
		          this.$emit('pick', { minDate: _minDate2, maxDate: this.maxDate }, false);
		          this.rangeState.selecting = true;
		          this.markRange(this.minDate);
		        }
		      } else if (selectionMode === 'day') {
		        this.$emit('pick', newDate);
		      } else if (selectionMode === 'week') {
		        var weekNumber = (0, _util.getWeekNumber)(newDate);
	
		        var value = newDate.getFullYear() + 'w' + weekNumber;
		        this.$emit('pick', {
		          year: newDate.getFullYear(),
		          week: weekNumber,
		          value: value,
		          date: newDate
		        });
		      }
		    }
		  }
		};
	
	/***/ },
	/* 163 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('table', {
		    staticClass: "el-date-table",
		    class: {
		      'is-week-mode': _vm.selectionMode === 'week'
		    },
		    attrs: {
		      "cellspacing": "0",
		      "cellpadding": "0"
		    },
		    on: {
		      "click": _vm.handleClick,
		      "mousemove": _vm.handleMouseMove
		    }
		  }, [_c('tbody', [_c('tr', [(_vm.showWeekNumber) ? _c('th', [_vm._v(_vm._s(_vm.t('el.datepicker.week')))]) : _vm._e(), _vm._l((_vm.WEEKS), function(week) {
		    return _c('th', [_vm._v(_vm._s(_vm.t('el.datepicker.weeks.' + week)))])
		  })], 2), _vm._l((_vm.rows), function(row) {
		    return _c('tr', {
		      staticClass: "el-date-table__row",
		      class: {
		        current: _vm.value && _vm.isWeekActive(row[1])
		      }
		    }, _vm._l((row), function(cell) {
		      return _c('td', {
		        class: _vm.getCellClasses(cell),
		        domProps: {
		          "textContent": _vm._s(cell.type === 'today' ? _vm.t('el.datepicker.today') : cell.text)
		        }
		      })
		    }))
		  })], 2)])
		},staticRenderFns: []}
	
	/***/ },
	/* 164 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('transition', {
		    attrs: {
		      "name": "el-zoom-in-top"
		    },
		    on: {
		      "after-leave": function($event) {
		        _vm.$emit('dodestroy')
		      }
		    }
		  }, [_c('div', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.visible),
		      expression: "visible"
		    }],
		    staticClass: "el-picker-panel el-date-picker",
		    class: [{
		      'has-sidebar': _vm.$slots.sidebar || _vm.shortcuts,
		      'has-time': _vm.showTime
		    }, _vm.popperClass],
		    style: ({
		      width: _vm.width + 'px'
		    })
		  }, [_c('div', {
		    staticClass: "el-picker-panel__body-wrapper"
		  }, [_vm._t("sidebar"), (_vm.shortcuts) ? _c('div', {
		    staticClass: "el-picker-panel__sidebar"
		  }, _vm._l((_vm.shortcuts), function(shortcut) {
		    return _c('button', {
		      staticClass: "el-picker-panel__shortcut",
		      attrs: {
		        "type": "button"
		      },
		      on: {
		        "click": function($event) {
		          _vm.handleShortcutClick(shortcut)
		        }
		      }
		    }, [_vm._v(_vm._s(shortcut.text))])
		  })) : _vm._e(), _c('div', {
		    staticClass: "el-picker-panel__body"
		  }, [(_vm.showTime) ? _c('div', {
		    staticClass: "el-date-picker__time-header"
		  }, [_c('span', {
		    staticClass: "el-date-picker__editor-wrap"
		  }, [_c('el-input', {
		    attrs: {
		      "placeholder": _vm.t('el.datepicker.selectDate'),
		      "value": _vm.visibleDate,
		      "size": "small"
		    },
		    nativeOn: {
		      "change": function($event) {
		        _vm.visibleDate = $event.target.value
		      }
		    }
		  })], 1), _c('span', {
		    staticClass: "el-date-picker__editor-wrap"
		  }, [_c('el-input', {
		    ref: "input",
		    attrs: {
		      "placeholder": _vm.t('el.datepicker.selectTime'),
		      "value": _vm.visibleTime,
		      "size": "small"
		    },
		    on: {
		      "focus": function($event) {
		        _vm.timePickerVisible = !_vm.timePickerVisible
		      }
		    },
		    nativeOn: {
		      "change": function($event) {
		        _vm.visibleTime = $event.target.value
		      }
		    }
		  }), _c('time-picker', {
		    ref: "timepicker",
		    attrs: {
		      "date": _vm.date,
		      "picker-width": _vm.pickerWidth,
		      "visible": _vm.timePickerVisible
		    },
		    on: {
		      "pick": _vm.handleTimePick
		    }
		  })], 1)]) : _vm._e(), _c('div', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.currentView !== 'time'),
		      expression: "currentView !== 'time'"
		    }],
		    staticClass: "el-date-picker__header"
		  }, [_c('button', {
		    staticClass: "el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left",
		    attrs: {
		      "type": "button"
		    },
		    on: {
		      "click": _vm.prevYear
		    }
		  }), _c('button', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.currentView === 'date'),
		      expression: "currentView === 'date'"
		    }],
		    staticClass: "el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-arrow-left",
		    attrs: {
		      "type": "button"
		    },
		    on: {
		      "click": _vm.prevMonth
		    }
		  }), _c('span', {
		    staticClass: "el-date-picker__header-label",
		    on: {
		      "click": _vm.showYearPicker
		    }
		  }, [_vm._v(_vm._s(_vm.yearLabel))]), _c('span', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.currentView === 'date'),
		      expression: "currentView === 'date'"
		    }],
		    staticClass: "el-date-picker__header-label",
		    class: {
		      active: _vm.currentView === 'month'
		    },
		    on: {
		      "click": _vm.showMonthPicker
		    }
		  }, [_vm._v(_vm._s(_vm.t(("el.datepicker.month" + (_vm.month + 1)))))]), _c('button', {
		    staticClass: "el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right",
		    attrs: {
		      "type": "button"
		    },
		    on: {
		      "click": _vm.nextYear
		    }
		  }), _c('button', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.currentView === 'date'),
		      expression: "currentView === 'date'"
		    }],
		    staticClass: "el-picker-panel__icon-btn el-date-picker__next-btn el-icon-arrow-right",
		    attrs: {
		      "type": "button"
		    },
		    on: {
		      "click": _vm.nextMonth
		    }
		  })]), _c('div', {
		    staticClass: "el-picker-panel__content"
		  }, [_c('date-table', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.currentView === 'date'),
		      expression: "currentView === 'date'"
		    }],
		    attrs: {
		      "year": _vm.year,
		      "month": _vm.month,
		      "date": _vm.date,
		      "value": _vm.value,
		      "week": _vm.week,
		      "selection-mode": _vm.selectionMode,
		      "first-day-of-week": _vm.firstDayOfWeek,
		      "disabled-date": _vm.disabledDate
		    },
		    on: {
		      "pick": _vm.handleDatePick
		    }
		  }), _c('year-table', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.currentView === 'year'),
		      expression: "currentView === 'year'"
		    }],
		    ref: "yearTable",
		    attrs: {
		      "year": _vm.year,
		      "date": _vm.date,
		      "disabled-date": _vm.disabledDate
		    },
		    on: {
		      "pick": _vm.handleYearPick
		    }
		  }), _c('month-table', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.currentView === 'month'),
		      expression: "currentView === 'month'"
		    }],
		    attrs: {
		      "month": _vm.month,
		      "date": _vm.date,
		      "disabled-date": _vm.disabledDate
		    },
		    on: {
		      "pick": _vm.handleMonthPick
		    }
		  })], 1)])], 2), _c('div', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.footerVisible && _vm.currentView === 'date'),
		      expression: "footerVisible && currentView === 'date'"
		    }],
		    staticClass: "el-picker-panel__footer"
		  }, [_c('a', {
		    staticClass: "el-picker-panel__link-btn",
		    attrs: {
		      "href": "JavaScript:"
		    },
		    on: {
		      "click": _vm.changeToNow
		    }
		  }, [_vm._v(_vm._s(_vm.t('el.datepicker.now')))]), _c('button', {
		    staticClass: "el-picker-panel__btn",
		    attrs: {
		      "type": "button"
		    },
		    on: {
		      "click": _vm.confirm
		    }
		  }, [_vm._v(_vm._s(_vm.t('el.datepicker.confirm')))])])])])
		},staticRenderFns: []}
	
	/***/ },
	/* 165 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(166)
	
		/* template */
		var __vue_template__ = __webpack_require__(167)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 166 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _util = __webpack_require__(144);
	
		var _locale = __webpack_require__(9);
	
		var _locale2 = _interopRequireDefault(_locale);
	
		var _time = __webpack_require__(149);
	
		var _time2 = _interopRequireDefault(_time);
	
		var _dateTable = __webpack_require__(161);
	
		var _dateTable2 = _interopRequireDefault(_dateTable);
	
		var _input = __webpack_require__(18);
	
		var _input2 = _interopRequireDefault(_input);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  mixins: [_locale2.default],
	
		  computed: {
		    btnDisabled: function btnDisabled() {
		      return !(this.minDate && this.maxDate && !this.selecting);
		    },
		    leftLabel: function leftLabel() {
		      return this.date.getFullYear() + ' ' + this.t('el.datepicker.year') + ' ' + this.t('el.datepicker.month' + (this.date.getMonth() + 1));
		    },
		    rightLabel: function rightLabel() {
		      return this.rightDate.getFullYear() + ' ' + this.t('el.datepicker.year') + ' ' + this.t('el.datepicker.month' + (this.rightDate.getMonth() + 1));
		    },
		    leftYear: function leftYear() {
		      return this.date.getFullYear();
		    },
		    leftMonth: function leftMonth() {
		      return this.date.getMonth();
		    },
		    rightYear: function rightYear() {
		      return this.rightDate.getFullYear();
		    },
		    rightMonth: function rightMonth() {
		      return this.rightDate.getMonth();
		    },
		    minVisibleDate: function minVisibleDate() {
		      return this.minDate ? (0, _util.formatDate)(this.minDate) : '';
		    },
		    maxVisibleDate: function maxVisibleDate() {
		      return this.maxDate || this.minDate ? (0, _util.formatDate)(this.maxDate || this.minDate) : '';
		    },
		    minVisibleTime: function minVisibleTime() {
		      return this.minDate ? (0, _util.formatDate)(this.minDate, 'HH:mm:ss') : '';
		    },
		    maxVisibleTime: function maxVisibleTime() {
		      return this.maxDate || this.minDate ? (0, _util.formatDate)(this.maxDate || this.minDate, 'HH:mm:ss') : '';
		    },
		    rightDate: function rightDate() {
		      var newDate = new Date(this.date);
		      var month = newDate.getMonth();
		      newDate.setDate(1);
	
		      if (month === 11) {
		        newDate.setFullYear(newDate.getFullYear() + 1);
		        newDate.setMonth(0);
		      } else {
		        newDate.setMonth(month + 1);
		      }
		      return newDate;
		    }
		  },
	
		  data: function data() {
		    return {
		      popperClass: '',
		      minPickerWidth: 0,
		      maxPickerWidth: 0,
		      date: new Date(),
		      minDate: '',
		      maxDate: '',
		      rangeState: {
		        endDate: null,
		        selecting: false,
		        row: null,
		        column: null
		      },
		      showTime: false,
		      shortcuts: '',
		      value: '',
		      visible: '',
		      disabledDate: '',
		      firstDayOfWeek: 7,
		      minTimePickerVisible: false,
		      maxTimePickerVisible: false,
		      width: 0
		    };
		  },
	
	
		  watch: {
		    showTime: function showTime(val) {
		      var _this = this;
	
		      if (!val) return;
		      this.$nextTick(function (_) {
		        var minInputElm = _this.$refs.minInput.$el;
		        var maxInputElm = _this.$refs.maxInput.$el;
		        if (minInputElm) {
		          _this.minPickerWidth = minInputElm.getBoundingClientRect().width + 10;
		        }
		        if (maxInputElm) {
		          _this.maxPickerWidth = maxInputElm.getBoundingClientRect().width + 10;
		        }
		      });
		    },
		    minDate: function minDate() {
		      var _this2 = this;
	
		      this.$nextTick(function () {
		        if (_this2.maxDate && _this2.maxDate < _this2.minDate) {
		          var format = 'HH:mm:ss';
	
		          _this2.$refs.maxTimePicker.selectableRange = [[(0, _util.parseDate)((0, _util.formatDate)(_this2.minDate, format), format), (0, _util.parseDate)('23:59:59', format)]];
		        }
		      });
		    },
		    minTimePickerVisible: function minTimePickerVisible(val) {
		      var _this3 = this;
	
		      if (val) this.$nextTick(function () {
		        return _this3.$refs.minTimePicker.ajustScrollTop();
		      });
		    },
		    maxTimePickerVisible: function maxTimePickerVisible(val) {
		      var _this4 = this;
	
		      if (val) this.$nextTick(function () {
		        return _this4.$refs.maxTimePicker.ajustScrollTop();
		      });
		    },
		    value: function value(newVal) {
		      if (!newVal) {
		        this.minDate = null;
		        this.maxDate = null;
		      } else if (Array.isArray(newVal)) {
		        this.minDate = newVal[0] ? (0, _util.toDate)(newVal[0]) : null;
		        this.maxDate = newVal[1] ? (0, _util.toDate)(newVal[1]) : null;
		        if (this.minDate) this.date = new Date(this.minDate);
		        this.handleConfirm(true);
		      }
		    }
		  },
	
		  methods: {
		    handleClear: function handleClear() {
		      this.minDate = null;
		      this.maxDate = null;
		      this.handleConfirm(false);
		    },
		    handleDateInput: function handleDateInput(event, type) {
		      var value = event.target.value;
		      var parsedValue = (0, _util.parseDate)(value, 'yyyy-MM-dd');
	
		      if (parsedValue) {
		        if (typeof this.disabledDate === 'function' && this.disabledDate(new Date(parsedValue))) {
		          return;
		        }
		        var target = new Date(type === 'min' ? this.minDate : this.maxDate);
		        if (target) {
		          target.setFullYear(parsedValue.getFullYear());
		          target.setMonth(parsedValue.getMonth());
		          target.setDate(parsedValue.getDate());
		        }
		      }
		    },
		    handleChangeRange: function handleChangeRange(val) {
		      this.minDate = val.minDate;
		      this.maxDate = val.maxDate;
		      this.rangeState = val.rangeState;
		    },
		    handleDateChange: function handleDateChange(event, type) {
		      var value = event.target.value;
		      var parsedValue = (0, _util.parseDate)(value, 'yyyy-MM-dd');
		      if (parsedValue) {
		        var target = new Date(type === 'min' ? this.minDate : this.maxDate);
		        if (target) {
		          target.setFullYear(parsedValue.getFullYear());
		          target.setMonth(parsedValue.getMonth());
		          target.setDate(parsedValue.getDate());
		        }
		        if (type === 'min') {
		          if (target < this.maxDate) {
		            this.minDate = new Date(target.getTime());
		          }
		        } else {
		          if (target > this.minDate) {
		            this.maxDate = new Date(target.getTime());
		            if (this.minDate && this.minDate > this.maxDate) {
		              this.minDate = null;
		            }
		          }
		        }
		      }
		    },
		    handleTimeChange: function handleTimeChange(event, type) {
		      var value = event.target.value;
		      var parsedValue = (0, _util.parseDate)(value, 'HH:mm:ss');
		      if (parsedValue) {
		        var target = new Date(type === 'min' ? this.minDate : this.maxDate);
		        if (target) {
		          target.setHours(parsedValue.getHours());
		          target.setMinutes(parsedValue.getMinutes());
		          target.setSeconds(parsedValue.getSeconds());
		        }
		        if (type === 'min') {
		          if (target < this.maxDate) {
		            this.minDate = new Date(target.getTime());
		          }
		        } else {
		          if (target > this.minDate) {
		            this.maxDate = new Date(target.getTime());
		          }
		        }
		        this.$refs[type + 'TimePicker'].value = target;
		        this[type + 'TimePickerVisible'] = false;
		      }
		    },
		    handleRangePick: function handleRangePick(val) {
		      var close = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
		      if (this.maxDate === val.maxDate && this.minDate === val.minDate) {
		        return;
		      }
		      this.maxDate = val.maxDate;
		      this.minDate = val.minDate;
	
		      if (!close || this.showTime) return;
		      this.handleConfirm();
		    },
		    changeToToday: function changeToToday() {
		      this.date = new Date();
		    },
		    handleShortcutClick: function handleShortcutClick(shortcut) {
		      if (shortcut.onClick) {
		        shortcut.onClick(this);
		      }
		    },
		    resetView: function resetView() {
		      this.minTimePickerVisible = false;
		      this.maxTimePickerVisible = false;
		    },
		    setTime: function setTime(date, value) {
		      var oldDate = new Date(date.getTime());
		      var hour = value.getHours();
		      var minute = value.getMinutes();
		      var second = value.getSeconds();
		      oldDate.setHours(hour);
		      oldDate.setMinutes(minute);
		      oldDate.setSeconds(second);
		      return new Date(oldDate.getTime());
		    },
		    handleMinTimePick: function handleMinTimePick(value, visible, first) {
		      this.minDate = this.minDate || new Date();
		      if (value) {
		        this.minDate = this.setTime(this.minDate, value);
		      }
	
		      if (!first) {
		        this.minTimePickerVisible = visible;
		      }
		    },
		    handleMaxTimePick: function handleMaxTimePick(value, visible, first) {
		      if (!this.maxDate) {
		        var now = new Date();
		        if (now >= this.minDate) {
		          this.maxDate = new Date();
		        }
		      }
	
		      if (this.maxDate && value) {
		        this.maxDate = this.setTime(this.maxDate, value);
		      }
	
		      if (!first) {
		        this.maxTimePickerVisible = visible;
		      }
		    },
		    prevMonth: function prevMonth() {
		      this.date = (0, _util.prevMonth)(this.date);
		    },
		    nextMonth: function nextMonth() {
		      this.date = (0, _util.nextMonth)(this.date);
		    },
		    nextYear: function nextYear() {
		      var date = this.date;
		      date.setFullYear(date.getFullYear() + 1);
		      this.resetDate();
		    },
		    prevYear: function prevYear() {
		      var date = this.date;
		      date.setFullYear(date.getFullYear() - 1);
		      this.resetDate();
		    },
		    handleConfirm: function handleConfirm() {
		      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
		      this.$emit('pick', [this.minDate, this.maxDate], visible);
		    },
		    resetDate: function resetDate() {
		      this.date = new Date(this.date);
		    }
		  },
	
		  components: { TimePicker: _time2.default, DateTable: _dateTable2.default, ElInput: _input2.default }
		}; //
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
	/***/ },
	/* 167 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('transition', {
		    attrs: {
		      "name": "el-zoom-in-top"
		    },
		    on: {
		      "after-leave": function($event) {
		        _vm.$emit('dodestroy')
		      }
		    }
		  }, [_c('div', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.visible),
		      expression: "visible"
		    }],
		    staticClass: "el-picker-panel el-date-range-picker",
		    class: [{
		      'has-sidebar': _vm.$slots.sidebar || _vm.shortcuts,
		      'has-time': _vm.showTime
		    }, _vm.popperClass],
		    style: ({
		      width: _vm.width + 'px'
		    })
		  }, [_c('div', {
		    staticClass: "el-picker-panel__body-wrapper"
		  }, [_vm._t("sidebar"), (_vm.shortcuts) ? _c('div', {
		    staticClass: "el-picker-panel__sidebar"
		  }, _vm._l((_vm.shortcuts), function(shortcut) {
		    return _c('button', {
		      staticClass: "el-picker-panel__shortcut",
		      attrs: {
		        "type": "button"
		      },
		      on: {
		        "click": function($event) {
		          _vm.handleShortcutClick(shortcut)
		        }
		      }
		    }, [_vm._v(_vm._s(shortcut.text))])
		  })) : _vm._e(), _c('div', {
		    staticClass: "el-picker-panel__body"
		  }, [(_vm.showTime) ? _c('div', {
		    staticClass: "el-date-range-picker__time-header"
		  }, [_c('span', {
		    staticClass: "el-date-range-picker__editors-wrap"
		  }, [_c('span', {
		    staticClass: "el-date-range-picker__time-picker-wrap"
		  }, [_c('el-input', {
		    ref: "minInput",
		    staticClass: "el-date-range-picker__editor",
		    attrs: {
		      "size": "small",
		      "placeholder": _vm.t('el.datepicker.startDate'),
		      "value": _vm.minVisibleDate
		    },
		    nativeOn: {
		      "input": function($event) {
		        _vm.handleDateInput($event, 'min')
		      },
		      "change": function($event) {
		        _vm.handleDateChange($event, 'min')
		      }
		    }
		  })], 1), _c('span', {
		    staticClass: "el-date-range-picker__time-picker-wrap"
		  }, [_c('el-input', {
		    staticClass: "el-date-range-picker__editor",
		    attrs: {
		      "size": "small",
		      "placeholder": _vm.t('el.datepicker.startTime'),
		      "value": _vm.minVisibleTime
		    },
		    on: {
		      "focus": function($event) {
		        _vm.minTimePickerVisible = !_vm.minTimePickerVisible
		      }
		    },
		    nativeOn: {
		      "change": function($event) {
		        _vm.handleTimeChange($event, 'min')
		      }
		    }
		  }), _c('time-picker', {
		    ref: "minTimePicker",
		    attrs: {
		      "picker-width": _vm.minPickerWidth,
		      "date": _vm.minDate,
		      "visible": _vm.minTimePickerVisible
		    },
		    on: {
		      "pick": _vm.handleMinTimePick
		    }
		  })], 1)]), _c('span', {
		    staticClass: "el-icon-arrow-right"
		  }), _c('span', {
		    staticClass: "el-date-range-picker__editors-wrap is-right"
		  }, [_c('span', {
		    staticClass: "el-date-range-picker__time-picker-wrap"
		  }, [_c('el-input', {
		    staticClass: "el-date-range-picker__editor",
		    attrs: {
		      "size": "small",
		      "placeholder": _vm.t('el.datepicker.endDate'),
		      "value": _vm.maxVisibleDate,
		      "readonly": !_vm.minDate
		    },
		    nativeOn: {
		      "input": function($event) {
		        _vm.handleDateInput($event, 'max')
		      },
		      "change": function($event) {
		        _vm.handleDateChange($event, 'max')
		      }
		    }
		  })], 1), _c('span', {
		    staticClass: "el-date-range-picker__time-picker-wrap"
		  }, [_c('el-input', {
		    ref: "maxInput",
		    staticClass: "el-date-range-picker__editor",
		    attrs: {
		      "size": "small",
		      "placeholder": _vm.t('el.datepicker.endTime'),
		      "value": _vm.maxVisibleTime,
		      "readonly": !_vm.minDate
		    },
		    on: {
		      "focus": function($event) {
		        _vm.minDate && (_vm.maxTimePickerVisible = !_vm.maxTimePickerVisible)
		      }
		    },
		    nativeOn: {
		      "change": function($event) {
		        _vm.handleTimeChange($event, 'max')
		      }
		    }
		  }), _c('time-picker', {
		    ref: "maxTimePicker",
		    attrs: {
		      "picker-width": _vm.maxPickerWidth,
		      "date": _vm.maxDate,
		      "visible": _vm.maxTimePickerVisible
		    },
		    on: {
		      "pick": _vm.handleMaxTimePick
		    }
		  })], 1)])]) : _vm._e(), _c('div', {
		    staticClass: "el-picker-panel__content el-date-range-picker__content is-left"
		  }, [_c('div', {
		    staticClass: "el-date-range-picker__header"
		  }, [_c('button', {
		    staticClass: "el-picker-panel__icon-btn el-icon-d-arrow-left",
		    attrs: {
		      "type": "button"
		    },
		    on: {
		      "click": _vm.prevYear
		    }
		  }), _c('button', {
		    staticClass: "el-picker-panel__icon-btn el-icon-arrow-left",
		    attrs: {
		      "type": "button"
		    },
		    on: {
		      "click": _vm.prevMonth
		    }
		  }), _c('div', [_vm._v(_vm._s(_vm.leftLabel))])]), _c('date-table', {
		    attrs: {
		      "selection-mode": "range",
		      "date": _vm.date,
		      "year": _vm.leftYear,
		      "month": _vm.leftMonth,
		      "min-date": _vm.minDate,
		      "max-date": _vm.maxDate,
		      "range-state": _vm.rangeState,
		      "disabled-date": _vm.disabledDate,
		      "first-day-of-week": _vm.firstDayOfWeek
		    },
		    on: {
		      "changerange": _vm.handleChangeRange,
		      "pick": _vm.handleRangePick
		    }
		  })], 1), _c('div', {
		    staticClass: "el-picker-panel__content el-date-range-picker__content is-right"
		  }, [_c('div', {
		    staticClass: "el-date-range-picker__header"
		  }, [_c('button', {
		    staticClass: "el-picker-panel__icon-btn el-icon-d-arrow-right",
		    attrs: {
		      "type": "button"
		    },
		    on: {
		      "click": _vm.nextYear
		    }
		  }), _c('button', {
		    staticClass: "el-picker-panel__icon-btn el-icon-arrow-right",
		    attrs: {
		      "type": "button"
		    },
		    on: {
		      "click": _vm.nextMonth
		    }
		  }), _c('div', [_vm._v(_vm._s(_vm.rightLabel))])]), _c('date-table', {
		    attrs: {
		      "selection-mode": "range",
		      "date": _vm.rightDate,
		      "year": _vm.rightYear,
		      "month": _vm.rightMonth,
		      "min-date": _vm.minDate,
		      "max-date": _vm.maxDate,
		      "range-state": _vm.rangeState,
		      "disabled-date": _vm.disabledDate,
		      "first-day-of-week": _vm.firstDayOfWeek
		    },
		    on: {
		      "changerange": _vm.handleChangeRange,
		      "pick": _vm.handleRangePick
		    }
		  })], 1)])], 2), (_vm.showTime) ? _c('div', {
		    staticClass: "el-picker-panel__footer"
		  }, [_c('a', {
		    staticClass: "el-picker-panel__link-btn",
		    on: {
		      "click": _vm.handleClear
		    }
		  }, [_vm._v(_vm._s(_vm.t('el.datepicker.clear')))]), _c('button', {
		    staticClass: "el-picker-panel__btn",
		    attrs: {
		      "type": "button",
		      "disabled": _vm.btnDisabled
		    },
		    on: {
		      "click": function($event) {
		        _vm.handleConfirm()
		      }
		    }
		  }, [_vm._v(_vm._s(_vm.t('el.datepicker.confirm')))])]) : _vm._e()])])
		},staticRenderFns: []}
	
	/***/ },
	/* 168 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _timeSelect = __webpack_require__(169);
	
		var _timeSelect2 = _interopRequireDefault(_timeSelect);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_timeSelect2.default.install = function (Vue) {
		  Vue.component(_timeSelect2.default.name, _timeSelect2.default);
		};
	
		exports.default = _timeSelect2.default;
	
	/***/ },
	/* 169 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _picker = __webpack_require__(142);
	
		var _picker2 = _interopRequireDefault(_picker);
	
		var _timeSelect = __webpack_require__(170);
	
		var _timeSelect2 = _interopRequireDefault(_timeSelect);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  mixins: [_picker2.default],
	
		  name: 'ElTimeSelect',
	
		  beforeCreate: function beforeCreate() {
		    this.type = 'time-select';
		    this.panel = _timeSelect2.default;
		  }
		};
	
	/***/ },
	/* 170 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(171)
	
		/* template */
		var __vue_template__ = __webpack_require__(172)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 171 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _scrollbar = __webpack_require__(102);
	
		var _scrollbar2 = _interopRequireDefault(_scrollbar);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var parseTime = function parseTime(time) {
		  var values = ('' || time).split(':');
		  if (values.length >= 2) {
		    var hours = parseInt(values[0], 10);
		    var minutes = parseInt(values[1], 10);
	
		    return {
		      hours: hours,
		      minutes: minutes
		    };
		  }
		  /* istanbul ignore next */
		  return null;
		}; //
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		var compareTime = function compareTime(time1, time2) {
		  var value1 = parseTime(time1);
		  var value2 = parseTime(time2);
	
		  var minutes1 = value1.minutes + value1.hours * 60;
		  var minutes2 = value2.minutes + value2.hours * 60;
	
		  if (minutes1 === minutes2) {
		    return 0;
		  }
	
		  return minutes1 > minutes2 ? 1 : -1;
		};
	
		var formatTime = function formatTime(time) {
		  return (time.hours < 10 ? '0' + time.hours : time.hours) + ':' + (time.minutes < 10 ? '0' + time.minutes : time.minutes);
		};
	
		var nextTime = function nextTime(time, step) {
		  var timeValue = parseTime(time);
		  var stepValue = parseTime(step);
	
		  var next = {
		    hours: timeValue.hours,
		    minutes: timeValue.minutes
		  };
	
		  next.minutes += stepValue.minutes;
		  next.hours += stepValue.hours;
	
		  next.hours += Math.floor(next.minutes / 60);
		  next.minutes = next.minutes % 60;
	
		  return formatTime(next);
		};
	
		exports.default = {
		  components: { ElScrollbar: _scrollbar2.default },
	
		  watch: {
		    value: function value(val) {
		      if (!val) return;
		      if (this.minTime && compareTime(val, this.minTime) < 0) {
		        this.$emit('pick');
		      } else if (this.maxTime && compareTime(val, this.maxTime) > 0) {
		        this.$emit('pick');
		      }
		    }
		  },
	
		  methods: {
		    handleClick: function handleClick(item) {
		      if (!item.disabled) {
		        this.$emit('pick', item.value);
		      }
		    },
		    handleClear: function handleClear() {
		      this.$emit('pick');
		    }
		  },
	
		  data: function data() {
		    return {
		      popperClass: '',
		      start: '09:00',
		      end: '18:00',
		      step: '00:30',
		      value: '',
		      visible: false,
		      minTime: '',
		      maxTime: '',
		      width: 0
		    };
		  },
	
	
		  computed: {
		    items: function items() {
		      var start = this.start;
		      var end = this.end;
		      var step = this.step;
	
		      var result = [];
	
		      if (start && end && step) {
		        var current = start;
		        while (compareTime(current, end) <= 0) {
		          result.push({
		            value: current,
		            disabled: compareTime(current, this.minTime || '-1:-1') <= 0 || compareTime(current, this.maxTime || '100:100') >= 0
		          });
		          current = nextTime(current, step);
		        }
		      }
	
		      return result;
		    }
		  }
		};
	
	/***/ },
	/* 172 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('transition', {
		    attrs: {
		      "name": "el-zoom-in-top"
		    },
		    on: {
		      "after-leave": function($event) {
		        _vm.$emit('dodestroy')
		      }
		    }
		  }, [_c('div', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.visible),
		      expression: "visible"
		    }],
		    staticClass: "el-picker-panel time-select",
		    class: _vm.popperClass,
		    style: ({
		      width: _vm.width + 'px'
		    })
		  }, [_c('el-scrollbar', {
		    attrs: {
		      "noresize": "",
		      "wrap-class": "el-picker-panel__content"
		    }
		  }, _vm._l((_vm.items), function(item) {
		    return _c('div', {
		      staticClass: "time-select-item",
		      class: {
		        selected: _vm.value === item.value, disabled: item.disabled
		      },
		      attrs: {
		        "disabled": item.disabled
		      },
		      on: {
		        "click": function($event) {
		          _vm.handleClick(item)
		        }
		      }
		    }, [_vm._v(_vm._s(item.value))])
		  }))], 1)])
		},staticRenderFns: []}
	
	/***/ },
	/* 173 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _timePicker = __webpack_require__(174);
	
		var _timePicker2 = _interopRequireDefault(_timePicker);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_timePicker2.default.install = function (Vue) {
		  Vue.component(_timePicker2.default.name, _timePicker2.default);
		};
	
		exports.default = _timePicker2.default;
	
	/***/ },
	/* 174 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _picker = __webpack_require__(142);
	
		var _picker2 = _interopRequireDefault(_picker);
	
		var _time = __webpack_require__(149);
	
		var _time2 = _interopRequireDefault(_time);
	
		var _timeRange = __webpack_require__(175);
	
		var _timeRange2 = _interopRequireDefault(_timeRange);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  mixins: [_picker2.default],
	
		  name: 'ElTimePicker',
	
		  props: {
		    isRange: Boolean
		  },
	
		  data: function data() {
		    return {
		      type: ''
		    };
		  },
		  created: function created() {
		    this.type = this.isRange ? 'timerange' : 'time';
		    this.panel = this.isRange ? _timeRange2.default : _time2.default;
		  }
		};
	
	/***/ },
	/* 175 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(176)
	
		/* template */
		var __vue_template__ = __webpack_require__(177)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 176 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _util = __webpack_require__(144);
	
		var _locale = __webpack_require__(9);
	
		var _locale2 = _interopRequireDefault(_locale);
	
		var _timeSpinner = __webpack_require__(151);
	
		var _timeSpinner2 = _interopRequireDefault(_timeSpinner);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var MIN_TIME = (0, _util.parseDate)('00:00:00', 'HH:mm:ss'); //
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		var MAX_TIME = (0, _util.parseDate)('23:59:59', 'HH:mm:ss');
		var isDisabled = function isDisabled(minTime, maxTime) {
		  var minValue = minTime.getHours() * 3600 + minTime.getMinutes() * 60 + minTime.getSeconds();
		  var maxValue = maxTime.getHours() * 3600 + maxTime.getMinutes() * 60 + maxTime.getSeconds();
	
		  return minValue > maxValue;
		};
		var clacTime = function clacTime(time) {
		  time = Array.isArray(time) ? time : [time];
		  var minTime = time[0] || new Date();
		  var date = new Date();
		  date.setHours(date.getHours() + 1);
		  var maxTime = time[1] || date;
	
		  if (minTime > maxTime) return clacTime();
		  return { minTime: minTime, maxTime: maxTime };
		};
	
		exports.default = {
		  mixins: [_locale2.default],
	
		  components: { TimeSpinner: _timeSpinner2.default },
	
		  computed: {
		    showSeconds: function showSeconds() {
		      return (this.format || '').indexOf('ss') !== -1;
		    }
		  },
	
		  props: ['value'],
	
		  data: function data() {
		    var time = clacTime(this.$options.defaultValue);
	
		    return {
		      popperClass: '',
		      minTime: time.minTime,
		      maxTime: time.maxTime,
		      btnDisabled: isDisabled(time.minTime, time.maxTime),
		      maxHours: time.maxTime.getHours(),
		      maxMinutes: time.maxTime.getMinutes(),
		      maxSeconds: time.maxTime.getSeconds(),
		      minHours: time.minTime.getHours(),
		      minMinutes: time.minTime.getMinutes(),
		      minSeconds: time.minTime.getSeconds(),
		      format: 'HH:mm:ss',
		      visible: false,
		      width: 0
		    };
		  },
	
	
		  watch: {
		    value: function value(newVal) {
		      var _this = this;
	
		      this.panelCreated();
		      this.$nextTick(function (_) {
		        return _this.ajustScrollTop();
		      });
		    }
		  },
	
		  methods: {
		    panelCreated: function panelCreated() {
		      var time = clacTime(this.value);
		      if (time.minTime === this.minTime && time.maxTime === this.maxTime) {
		        return;
		      }
	
		      this.handleMinChange({
		        hours: time.minTime.getHours(),
		        minutes: time.minTime.getMinutes(),
		        seconds: time.minTime.getSeconds()
		      });
		      this.handleMaxChange({
		        hours: time.maxTime.getHours(),
		        minutes: time.maxTime.getMinutes(),
		        seconds: time.maxTime.getSeconds()
		      });
		    },
		    handleClear: function handleClear() {
		      this.handleCancel();
		    },
		    handleCancel: function handleCancel() {
		      this.$emit('pick');
		    },
		    handleChange: function handleChange() {
		      if (this.minTime > this.maxTime) return;
		      this.$refs.minSpinner.selectableRange = [[MIN_TIME, this.maxTime]];
		      this.$refs.maxSpinner.selectableRange = [[this.minTime, MAX_TIME]];
		      this.handleConfirm(true);
		    },
		    handleMaxChange: function handleMaxChange(date) {
		      if (date.hours !== undefined) {
		        this.maxTime.setHours(date.hours);
		        this.maxHours = this.maxTime.getHours();
		      }
		      if (date.minutes !== undefined) {
		        this.maxTime.setMinutes(date.minutes);
		        this.maxMinutes = this.maxTime.getMinutes();
		      }
		      if (date.seconds !== undefined) {
		        this.maxTime.setSeconds(date.seconds);
		        this.maxSeconds = this.maxTime.getSeconds();
		      }
		      this.handleChange();
		    },
		    handleMinChange: function handleMinChange(date) {
		      if (date.hours !== undefined) {
		        this.minTime.setHours(date.hours);
		        this.minHours = this.minTime.getHours();
		      }
		      if (date.minutes !== undefined) {
		        this.minTime.setMinutes(date.minutes);
		        this.minMinutes = this.minTime.getMinutes();
		      }
		      if (date.seconds !== undefined) {
		        this.minTime.setSeconds(date.seconds);
		        this.minSeconds = this.minTime.getSeconds();
		      }
	
		      this.handleChange();
		    },
		    setMinSelectionRange: function setMinSelectionRange(start, end) {
		      this.$emit('select-range', start, end);
		    },
		    setMaxSelectionRange: function setMaxSelectionRange(start, end) {
		      this.$emit('select-range', start + 11, end + 11);
		    },
		    handleConfirm: function handleConfirm() {
		      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
		      var first = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
		      var minSelectableRange = this.$refs.minSpinner.selectableRange;
		      var maxSelectableRange = this.$refs.maxSpinner.selectableRange;
	
		      this.minTime = (0, _util.limitRange)(this.minTime, minSelectableRange);
		      this.maxTime = (0, _util.limitRange)(this.maxTime, maxSelectableRange);
	
		      if (first) return;
		      this.$emit('pick', [this.minTime, this.maxTime], visible, first);
		    },
		    ajustScrollTop: function ajustScrollTop() {
		      this.$refs.minSpinner.ajustScrollTop();
		      this.$refs.maxSpinner.ajustScrollTop();
		    }
		  },
	
		  mounted: function mounted() {
		    var _this2 = this;
	
		    this.$nextTick(function () {
		      return _this2.handleConfirm(true, true);
		    });
		  }
		};
	
	/***/ },
	/* 177 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('transition', {
		    attrs: {
		      "name": "el-zoom-in-top"
		    },
		    on: {
		      "before-enter": _vm.panelCreated,
		      "after-leave": function($event) {
		        _vm.$emit('dodestroy')
		      }
		    }
		  }, [_c('div', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.visible),
		      expression: "visible"
		    }],
		    staticClass: "el-time-range-picker el-picker-panel",
		    class: _vm.popperClass,
		    style: ({
		      width: _vm.width + 'px'
		    })
		  }, [_c('div', {
		    staticClass: "el-time-range-picker__content"
		  }, [_c('div', {
		    staticClass: "el-time-range-picker__cell"
		  }, [_c('div', {
		    staticClass: "el-time-range-picker__header"
		  }, [_vm._v(_vm._s(_vm.t('el.datepicker.startTime')))]), _c('div', {
		    staticClass: "el-time-range-picker__body el-time-panel__content",
		    class: {
		      'has-seconds': _vm.showSeconds
		    }
		  }, [_c('time-spinner', {
		    ref: "minSpinner",
		    attrs: {
		      "show-seconds": _vm.showSeconds,
		      "hours": _vm.minHours,
		      "minutes": _vm.minMinutes,
		      "seconds": _vm.minSeconds
		    },
		    on: {
		      "change": _vm.handleMinChange,
		      "select-range": _vm.setMinSelectionRange
		    }
		  })], 1)]), _c('div', {
		    staticClass: "el-time-range-picker__cell"
		  }, [_c('div', {
		    staticClass: "el-time-range-picker__header"
		  }, [_vm._v(_vm._s(_vm.t('el.datepicker.endTime')))]), _c('div', {
		    staticClass: "el-time-range-picker__body el-time-panel__content",
		    class: {
		      'has-seconds': _vm.showSeconds
		    }
		  }, [_c('time-spinner', {
		    ref: "maxSpinner",
		    attrs: {
		      "show-seconds": _vm.showSeconds,
		      "hours": _vm.maxHours,
		      "minutes": _vm.maxMinutes,
		      "seconds": _vm.maxSeconds
		    },
		    on: {
		      "change": _vm.handleMaxChange,
		      "select-range": _vm.setMaxSelectionRange
		    }
		  })], 1)])]), _c('div', {
		    staticClass: "el-time-panel__footer"
		  }, [_c('button', {
		    staticClass: "el-time-panel__btn cancel",
		    attrs: {
		      "type": "button"
		    },
		    on: {
		      "click": function($event) {
		        _vm.handleCancel()
		      }
		    }
		  }, [_vm._v(_vm._s(_vm.t('el.datepicker.cancel')))]), _c('button', {
		    staticClass: "el-time-panel__btn confirm",
		    attrs: {
		      "type": "button",
		      "disabled": _vm.btnDisabled
		    },
		    on: {
		      "click": function($event) {
		        _vm.handleConfirm()
		      }
		    }
		  }, [_vm._v(_vm._s(_vm.t('el.datepicker.confirm')))])])])])
		},staticRenderFns: []}
	
	/***/ },
	/* 178 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _main = __webpack_require__(179);
	
		var _main2 = _interopRequireDefault(_main);
	
		var _directive = __webpack_require__(182);
	
		var _directive2 = _interopRequireDefault(_directive);
	
		var _vue = __webpack_require__(126);
	
		var _vue2 = _interopRequireDefault(_vue);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		_vue2.default.directive('popover', _directive2.default);
	
		/* istanbul ignore next */
		_main2.default.install = function (Vue) {
		  Vue.directive('popover', _directive2.default);
		  Vue.component(_main2.default.name, _main2.default);
		};
		_main2.default.directive = _directive2.default;
	
		exports.default = _main2.default;
	
	/***/ },
	/* 179 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(180)
	
		/* template */
		var __vue_template__ = __webpack_require__(181)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 180 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _vuePopper = __webpack_require__(22);
	
		var _vuePopper2 = _interopRequireDefault(_vuePopper);
	
		var _dom = __webpack_require__(66);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  name: 'ElPopover',
	
		  mixins: [_vuePopper2.default],
	
		  props: {
		    trigger: {
		      type: String,
		      default: 'click',
		      validator: function validator(value) {
		        return ['click', 'focus', 'hover', 'manual'].indexOf(value) > -1;
		      }
		    },
		    title: String,
		    disabled: Boolean,
		    content: String,
		    reference: {},
		    popperClass: String,
		    width: {},
		    visibleArrow: {
		      default: true
		    },
		    transition: {
		      type: String,
		      default: 'fade-in-linear'
		    }
		  },
	
		  watch: {
		    showPopper: function showPopper(newVal, oldVal) {
		      newVal ? this.$emit('show') : this.$emit('hide');
		    }
		  },
	
		  mounted: function mounted() {
		    var _this = this;
	
		    var reference = this.reference || this.$refs.reference;
		    var popper = this.popper || this.$refs.popper;
	
		    if (!reference && this.$slots.reference && this.$slots.reference[0]) {
		      reference = this.referenceElm = this.$slots.reference[0].elm;
		    }
		    if (this.trigger === 'click') {
		      (0, _dom.on)(reference, 'click', function () {
		        _this.showPopper = !_this.showPopper;
		      });
		      (0, _dom.on)(document, 'click', this.handleDocumentClick);
		    } else if (this.trigger === 'hover') {
		      (0, _dom.on)(reference, 'mouseenter', this.handleMouseEnter);
		      (0, _dom.on)(popper, 'mouseenter', this.handleMouseEnter);
		      (0, _dom.on)(reference, 'mouseleave', this.handleMouseLeave);
		      (0, _dom.on)(popper, 'mouseleave', this.handleMouseLeave);
		    } else if (this.trigger === 'focus') {
		      var found = false;
	
		      if ([].slice.call(reference.children).length) {
		        var children = reference.childNodes;
		        var len = children.length;
		        for (var i = 0; i < len; i++) {
		          if (children[i].nodeName === 'INPUT' || children[i].nodeName === 'TEXTAREA') {
		            (0, _dom.on)(children[i], 'focus', function () {
		              _this.showPopper = true;
		            });
		            (0, _dom.on)(children[i], 'blur', function () {
		              _this.showPopper = false;
		            });
		            found = true;
		            break;
		          }
		        }
		      }
		      if (found) return;
		      if (reference.nodeName === 'INPUT' || reference.nodeName === 'TEXTAREA') {
		        (0, _dom.on)(reference, 'focus', function () {
		          _this.showPopper = true;
		        });
		        (0, _dom.on)(reference, 'blur', function () {
		          _this.showPopper = false;
		        });
		      } else {
		        (0, _dom.on)(reference, 'mousedown', function () {
		          _this.showPopper = true;
		        });
		        (0, _dom.on)(reference, 'mouseup', function () {
		          _this.showPopper = false;
		        });
		      }
		    }
		  },
	
	
		  methods: {
		    handleMouseEnter: function handleMouseEnter() {
		      this.showPopper = true;
		      clearTimeout(this._timer);
		    },
		    handleMouseLeave: function handleMouseLeave() {
		      var _this2 = this;
	
		      this._timer = setTimeout(function () {
		        _this2.showPopper = false;
		      }, 200);
		    },
		    handleDocumentClick: function handleDocumentClick(e) {
		      var reference = this.reference || this.$refs.reference;
		      var popper = this.popper || this.$refs.popper;
	
		      if (!reference && this.$slots.reference && this.$slots.reference[0]) {
		        reference = this.referenceElm = this.$slots.reference[0].elm;
		      }
		      if (!this.$el || !reference || this.$el.contains(e.target) || reference.contains(e.target) || !popper || popper.contains(e.target)) return;
		      this.showPopper = false;
		    }
		  },
	
		  destroyed: function destroyed() {
		    var reference = this.reference;
	
		    (0, _dom.off)(reference, 'mouseup');
		    (0, _dom.off)(reference, 'mousedown');
		    (0, _dom.off)(reference, 'focus');
		    (0, _dom.off)(reference, 'blur');
		    (0, _dom.off)(reference, 'mouseleave');
		    (0, _dom.off)(reference, 'mouseenter');
		    (0, _dom.off)(document, 'click', this.handleDocumentClick);
		  }
		};
	
	/***/ },
	/* 181 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('span', [_c('transition', {
		    attrs: {
		      "name": _vm.transition
		    },
		    on: {
		      "after-leave": _vm.doDestroy
		    }
		  }, [_c('div', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (!_vm.disabled && _vm.showPopper),
		      expression: "!disabled && showPopper"
		    }],
		    ref: "popper",
		    staticClass: "el-popover",
		    class: [_vm.popperClass],
		    style: ({
		      width: _vm.width + 'px'
		    })
		  }, [(_vm.title) ? _c('div', {
		    staticClass: "el-popover__title",
		    domProps: {
		      "textContent": _vm._s(_vm.title)
		    }
		  }) : _vm._e(), _vm._t("default", [_vm._v(_vm._s(_vm.content))])], 2)]), _vm._t("reference")], 2)
		},staticRenderFns: []}
	
	/***/ },
	/* 182 */
	/***/ function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.default = {
		  bind: function bind(el, binding, vnode) {
		    vnode.context.$refs[binding.arg].$refs.reference = el;
		  }
		};
	
	/***/ },
	/* 183 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _main = __webpack_require__(184);
	
		var _main2 = _interopRequireDefault(_main);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_main2.default.install = function (Vue) {
		  Vue.component(_main2.default.name, _main2.default);
		};
	
		exports.default = _main2.default;
	
	/***/ },
	/* 184 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(185)
	
		/* template */
		var __vue_template__ = __webpack_require__(186)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 185 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _vuePopper = __webpack_require__(22);
	
		var _vuePopper2 = _interopRequireDefault(_vuePopper);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  name: 'ElTooltip',
	
		  mixins: [_vuePopper2.default],
	
		  props: {
		    openDelay: {
		      type: Number,
		      default: 0
		    },
		    disabled: Boolean,
		    manual: Boolean,
		    effect: {
		      type: String,
		      default: 'dark'
		    },
		    popperClass: String,
		    content: String,
		    visibleArrow: {
		      default: true
		    },
		    transition: {
		      type: String,
		      default: 'fade-in-linear'
		    },
		    options: {
		      default: function _default() {
		        return {
		          boundariesPadding: 10,
		          gpuAcceleration: false
		        };
		      }
		    }
		  },
	
		  methods: {
		    handleShowPopper: function handleShowPopper() {
		      var _this = this;
	
		      if (this.manual) return;
		      this.timeout = setTimeout(function () {
		        _this.showPopper = true;
		      }, this.openDelay);
		    },
		    handleClosePopper: function handleClosePopper() {
		      if (this.manual) return;
		      clearTimeout(this.timeout);
		      this.showPopper = false;
		    }
		  }
		}; //
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
	/***/ },
	/* 186 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    staticClass: "el-tooltip",
		    on: {
		      "mouseenter": _vm.handleShowPopper,
		      "mouseleave": _vm.handleClosePopper
		    }
		  }, [_c('div', {
		    ref: "reference",
		    staticClass: "el-tooltip__rel"
		  }, [_vm._t("default")], 2), _c('transition', {
		    attrs: {
		      "name": _vm.transition
		    },
		    on: {
		      "after-leave": _vm.doDestroy
		    }
		  }, [_c('div', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (!_vm.disabled && _vm.showPopper),
		      expression: "!disabled && showPopper"
		    }],
		    ref: "popper",
		    staticClass: "el-tooltip__popper",
		    class: ['is-' + _vm.effect, _vm.popperClass]
		  }, [_vm._t("content", [_c('div', {
		    domProps: {
		      "textContent": _vm._s(_vm.content)
		    }
		  })])], 2)])], 1)
		},staticRenderFns: []}
	
	/***/ },
	/* 187 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _main = __webpack_require__(188);
	
		var _main2 = _interopRequireDefault(_main);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _main2.default;
	
	/***/ },
	/* 188 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.MessageBox = undefined;
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		var _vue = __webpack_require__(126);
	
		var _vue2 = _interopRequireDefault(_vue);
	
		var _main = __webpack_require__(189);
	
		var _main2 = _interopRequireDefault(_main);
	
		var _merge = __webpack_require__(61);
	
		var _merge2 = _interopRequireDefault(_merge);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var defaults = {
		  title: undefined,
		  message: '',
		  type: '',
		  showInput: false,
		  showClose: true,
		  modalFade: true,
		  lockScroll: true,
		  closeOnClickModal: true,
		  inputValue: null,
		  inputPlaceholder: '',
		  inputPattern: null,
		  inputValidator: null,
		  inputErrorMessage: '',
		  showConfirmButton: true,
		  showCancelButton: false,
		  confirmButtonPosition: 'right',
		  confirmButtonHighlight: false,
		  cancelButtonHighlight: false,
		  confirmButtonText: '',
		  cancelButtonText: '',
		  confirmButtonClass: '',
		  cancelButtonClass: '',
		  customClass: '',
		  beforeClose: null
		};
	
		var MessageBoxConstructor = _vue2.default.extend(_main2.default);
	
		var currentMsg = void 0,
		    instance = void 0;
		var msgQueue = [];
	
		var defaultCallback = function defaultCallback(action) {
		  if (currentMsg) {
		    var callback = currentMsg.callback;
		    if (typeof callback === 'function') {
		      if (instance.showInput) {
		        callback(instance.inputValue, action);
		      } else {
		        callback(action);
		      }
		    }
		    if (currentMsg.resolve) {
		      var $type = currentMsg.options.$type;
		      if ($type === 'confirm' || $type === 'prompt') {
		        if (action === 'confirm') {
		          if (instance.showInput) {
		            currentMsg.resolve({ value: instance.inputValue, action: action });
		          } else {
		            currentMsg.resolve(action);
		          }
		        } else if (action === 'cancel' && currentMsg.reject) {
		          currentMsg.reject(action);
		        }
		      } else {
		        currentMsg.resolve(action);
		      }
		    }
		  }
		};
	
		var initInstance = function initInstance() {
		  instance = new MessageBoxConstructor({
		    el: document.createElement('div')
		  });
	
		  instance.callback = defaultCallback;
		};
	
		var showNextMsg = function showNextMsg() {
		  if (!instance) {
		    initInstance();
		  }
	
		  if (!instance.value || instance.closeTimer) {
		    if (msgQueue.length > 0) {
		      (function () {
		        currentMsg = msgQueue.shift();
	
		        var options = currentMsg.options;
		        for (var prop in options) {
		          if (options.hasOwnProperty(prop)) {
		            instance[prop] = options[prop];
		          }
		        }
		        if (options.callback === undefined) {
		          instance.callback = defaultCallback;
		        }
	
		        var oldCb = instance.callback;
		        instance.callback = function (action) {
		          oldCb(action);
		          showNextMsg();
		        };
		        ['modal', 'showClose', 'closeOnClickModal', 'closeOnPressEscape'].forEach(function (prop) {
		          if (instance[prop] === undefined) {
		            instance[prop] = true;
		          }
		        });
		        document.body.appendChild(instance.$el);
	
		        _vue2.default.nextTick(function () {
		          instance.value = true;
		        });
		      })();
		    }
		  }
		};
	
		var MessageBox = function MessageBox(options, callback) {
		  if (_vue2.default.prototype.$isServer) return;
		  if (typeof options === 'string') {
		    options = {
		      message: options
		    };
		    if (arguments[1]) {
		      options.title = arguments[1];
		    }
		    if (arguments[2]) {
		      options.type = arguments[2];
		    }
		  } else if (options.callback && !callback) {
		    callback = options.callback;
		  }
	
		  if (typeof Promise !== 'undefined') {
		    return new Promise(function (resolve, reject) {
		      // eslint-disable-line
		      msgQueue.push({
		        options: (0, _merge2.default)({}, defaults, MessageBox.defaults, options),
		        callback: callback,
		        resolve: resolve,
		        reject: reject
		      });
	
		      showNextMsg();
		    });
		  } else {
		    msgQueue.push({
		      options: (0, _merge2.default)({}, defaults, MessageBox.defaults, options),
		      callback: callback
		    });
	
		    showNextMsg();
		  }
		};
	
		MessageBox.setDefaults = function (defaults) {
		  MessageBox.defaults = defaults;
		};
	
		MessageBox.alert = function (message, title, options) {
		  if ((typeof title === 'undefined' ? 'undefined' : _typeof(title)) === 'object') {
		    options = title;
		    title = '';
		  }
		  return MessageBox((0, _merge2.default)({
		    title: title,
		    message: message,
		    $type: 'alert',
		    closeOnPressEscape: false,
		    closeOnClickModal: false
		  }, options));
		};
	
		MessageBox.confirm = function (message, title, options) {
		  if ((typeof title === 'undefined' ? 'undefined' : _typeof(title)) === 'object') {
		    options = title;
		    title = '';
		  }
		  return MessageBox((0, _merge2.default)({
		    title: title,
		    message: message,
		    $type: 'confirm',
		    showCancelButton: true
		  }, options));
		};
	
		MessageBox.prompt = function (message, title, options) {
		  if ((typeof title === 'undefined' ? 'undefined' : _typeof(title)) === 'object') {
		    options = title;
		    title = '';
		  }
		  return MessageBox((0, _merge2.default)({
		    title: title,
		    message: message,
		    showCancelButton: true,
		    showInput: true,
		    $type: 'prompt'
		  }, options));
		};
	
		MessageBox.close = function () {
		  instance.value = false;
		  msgQueue = [];
		  currentMsg = null;
		};
	
		exports.default = MessageBox;
		exports.MessageBox = MessageBox;
	
	/***/ },
	/* 189 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(190)
	
		/* template */
		var __vue_template__ = __webpack_require__(191)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 190 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _popup = __webpack_require__(13);
	
		var _popup2 = _interopRequireDefault(_popup);
	
		var _locale = __webpack_require__(9);
	
		var _locale2 = _interopRequireDefault(_locale);
	
		var _input = __webpack_require__(18);
	
		var _input2 = _interopRequireDefault(_input);
	
		var _button = __webpack_require__(29);
	
		var _button2 = _interopRequireDefault(_button);
	
		var _dom = __webpack_require__(66);
	
		var _locale3 = __webpack_require__(105);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		var typeMap = {
		  success: 'circle-check',
		  info: 'information',
		  warning: 'warning',
		  error: 'circle-cross'
		};
	
		exports.default = {
		  mixins: [_popup2.default, _locale2.default],
	
		  props: {
		    modal: {
		      default: true
		    },
		    lockScroll: {
		      default: true
		    },
		    showClose: {
		      type: Boolean,
		      default: true
		    },
		    closeOnClickModal: {
		      default: true
		    },
		    closeOnPressEscape: {
		      default: true
		    }
		  },
	
		  components: {
		    ElInput: _input2.default,
		    ElButton: _button2.default
		  },
	
		  computed: {
		    typeClass: function typeClass() {
		      return this.type && typeMap[this.type] ? 'el-icon-' + typeMap[this.type] : '';
		    },
		    confirmButtonClasses: function confirmButtonClasses() {
		      return 'el-button--primary ' + this.confirmButtonClass;
		    },
		    cancelButtonClasses: function cancelButtonClasses() {
		      return '' + this.cancelButtonClass;
		    }
		  },
	
		  methods: {
		    getSafeClose: function getSafeClose() {
		      var _this = this;
	
		      var currentId = this.uid;
		      return function () {
		        _this.$nextTick(function () {
		          if (currentId === _this.uid) _this.doClose();
		        });
		      };
		    },
		    doClose: function doClose() {
		      var _this2 = this;
	
		      if (!this.value) return;
		      this.value = false;
		      this._closing = true;
	
		      this.onClose && this.onClose();
	
		      if (this.lockScroll) {
		        setTimeout(function () {
		          if (_this2.modal && _this2.bodyOverflow !== 'hidden') {
		            document.body.style.overflow = _this2.bodyOverflow;
		            document.body.style.paddingRight = _this2.bodyPaddingRight;
		          }
		          _this2.bodyOverflow = null;
		          _this2.bodyPaddingRight = null;
		        }, 200);
		      }
		      this.opened = false;
	
		      if (!this.transition) {
		        this.doAfterClose();
		      }
		      if (this.action) this.callback(this.action, this);
		    },
		    handleWrapperClick: function handleWrapperClick() {
		      if (this.closeOnClickModal) {
		        this.action = '';
		        this.doClose();
		      }
		    },
		    handleAction: function handleAction(action) {
		      if (this.$type === 'prompt' && action === 'confirm' && !this.validate()) {
		        return;
		      }
		      this.action = action;
		      if (typeof this.beforeClose === 'function') {
		        this.close = this.getSafeClose();
		        this.beforeClose(action, this, this.close);
		      } else {
		        this.doClose();
		      }
		    },
		    validate: function validate() {
		      if (this.$type === 'prompt') {
		        var inputPattern = this.inputPattern;
		        if (inputPattern && !inputPattern.test(this.inputValue || '')) {
		          this.editorErrorMessage = this.inputErrorMessage || (0, _locale3.t)('el.messagebox.error');
		          (0, _dom.addClass)(this.$refs.input.$el.querySelector('input'), 'invalid');
		          return false;
		        }
		        var inputValidator = this.inputValidator;
		        if (typeof inputValidator === 'function') {
		          var validateResult = inputValidator(this.inputValue);
		          if (validateResult === false) {
		            this.editorErrorMessage = this.inputErrorMessage || (0, _locale3.t)('el.messagebox.error');
		            (0, _dom.addClass)(this.$refs.input.$el.querySelector('input'), 'invalid');
		            return false;
		          }
		          if (typeof validateResult === 'string') {
		            this.editorErrorMessage = validateResult;
		            return false;
		          }
		        }
		      }
		      this.editorErrorMessage = '';
		      (0, _dom.removeClass)(this.$refs.input.$el.querySelector('input'), 'invalid');
		      return true;
		    }
		  },
	
		  watch: {
		    inputValue: function inputValue(val) {
		      if (this.$type === 'prompt' && val !== null) {
		        this.validate();
		      }
		    },
		    value: function value(val) {
		      var _this3 = this;
	
		      if (val) this.uid++;
		      if (this.$type === 'alert' || this.$type === 'confirm') {
		        this.$nextTick(function () {
		          _this3.$refs.confirm.$el.focus();
		        });
		      }
		      if (this.$type !== 'prompt') return;
		      if (val) {
		        setTimeout(function () {
		          if (_this3.$refs.input && _this3.$refs.input.$el) {
		            _this3.$refs.input.$el.querySelector('input').focus();
		          }
		        }, 500);
		      } else {
		        this.editorErrorMessage = '';
		        (0, _dom.removeClass)(this.$refs.input.$el.querySelector('input'), 'invalid');
		      }
		    }
		  },
	
		  data: function data() {
		    return {
		      uid: 1,
		      title: undefined,
		      message: '',
		      type: '',
		      customClass: '',
		      showInput: false,
		      inputValue: null,
		      inputPlaceholder: '',
		      inputPattern: null,
		      inputValidator: null,
		      inputErrorMessage: '',
		      showConfirmButton: true,
		      showCancelButton: false,
		      action: '',
		      confirmButtonText: '',
		      cancelButtonText: '',
		      confirmButtonLoading: false,
		      cancelButtonLoading: false,
		      confirmButtonClass: '',
		      confirmButtonDisabled: false,
		      cancelButtonClass: '',
		      editorErrorMessage: null,
		      callback: null
		    };
		  }
		};
	
	/***/ },
	/* 191 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('transition', {
		    attrs: {
		      "name": "msgbox-fade"
		    }
		  }, [_c('div', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.value),
		      expression: "value"
		    }],
		    staticClass: "el-message-box__wrapper",
		    on: {
		      "click": function($event) {
		        if ($event.target !== $event.currentTarget) { return; }
		        _vm.handleWrapperClick($event)
		      }
		    }
		  }, [_c('div', {
		    staticClass: "el-message-box",
		    class: _vm.customClass
		  }, [(_vm.title !== undefined) ? _c('div', {
		    staticClass: "el-message-box__header"
		  }, [_c('div', {
		    staticClass: "el-message-box__title"
		  }, [_vm._v(_vm._s(_vm.title || _vm.t('el.messagebox.title')))]), (_vm.showClose) ? _c('i', {
		    staticClass: "el-message-box__close el-icon-close",
		    on: {
		      "click": function($event) {
		        _vm.handleAction('cancel')
		      }
		    }
		  }) : _vm._e()]) : _vm._e(), (_vm.message !== '') ? _c('div', {
		    staticClass: "el-message-box__content"
		  }, [_c('div', {
		    staticClass: "el-message-box__status",
		    class: [_vm.typeClass]
		  }), _c('div', {
		    staticClass: "el-message-box__message",
		    style: ({
		      'margin-left': _vm.typeClass ? '50px' : '0'
		    })
		  }, [_c('p', [_vm._v(_vm._s(_vm.message))])]), _c('div', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.showInput),
		      expression: "showInput"
		    }],
		    staticClass: "el-message-box__input"
		  }, [_c('el-input', {
		    directives: [{
		      name: "model",
		      rawName: "v-model",
		      value: (_vm.inputValue),
		      expression: "inputValue"
		    }],
		    ref: "input",
		    attrs: {
		      "placeholder": _vm.inputPlaceholder
		    },
		    domProps: {
		      "value": (_vm.inputValue)
		    },
		    on: {
		      "input": function($event) {
		        _vm.inputValue = $event
		      }
		    }
		  }), _c('div', {
		    staticClass: "el-message-box__errormsg",
		    style: ({
		      visibility: !!_vm.editorErrorMessage ? 'visible' : 'hidden'
		    })
		  }, [_vm._v(_vm._s(_vm.editorErrorMessage))])], 1)]) : _vm._e(), _c('div', {
		    staticClass: "el-message-box__btns"
		  }, [_c('el-button', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.showCancelButton),
		      expression: "showCancelButton"
		    }],
		    class: [_vm.cancelButtonClasses],
		    attrs: {
		      "loading": _vm.cancelButtonLoading
		    },
		    nativeOn: {
		      "click": function($event) {
		        _vm.handleAction('cancel')
		      }
		    }
		  }, [_vm._v("\n          " + _vm._s(_vm.cancelButtonText || _vm.t('el.messagebox.cancel')) + "\n        ")]), _c('el-button', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.showConfirmButton),
		      expression: "showConfirmButton"
		    }],
		    ref: "confirm",
		    class: [_vm.confirmButtonClasses],
		    attrs: {
		      "loading": _vm.confirmButtonLoading
		    },
		    nativeOn: {
		      "click": function($event) {
		        _vm.handleAction('confirm')
		      }
		    }
		  }, [_vm._v("\n          " + _vm._s(_vm.confirmButtonText || _vm.t('el.messagebox.confirm')) + "\n        ")])], 1)])])])
		},staticRenderFns: []}
	
	/***/ },
	/* 192 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _breadcrumb = __webpack_require__(193);
	
		var _breadcrumb2 = _interopRequireDefault(_breadcrumb);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_breadcrumb2.default.install = function (Vue) {
		  Vue.component(_breadcrumb2.default.name, _breadcrumb2.default);
		};
	
		exports.default = _breadcrumb2.default;
	
	/***/ },
	/* 193 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(194)
	
		/* template */
		var __vue_template__ = __webpack_require__(195)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 194 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		//
		//
		//
		//
		//
	
		exports.default = {
		  name: 'ElBreadcrumb',
	
		  props: {
		    separator: {
		      type: String,
		      default: '/'
		    }
		  }
		};
	
	/***/ },
	/* 195 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    staticClass: "el-breadcrumb"
		  }, [_vm._t("default")], 2)
		},staticRenderFns: []}
	
	/***/ },
	/* 196 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _breadcrumbItem = __webpack_require__(197);
	
		var _breadcrumbItem2 = _interopRequireDefault(_breadcrumbItem);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_breadcrumbItem2.default.install = function (Vue) {
		  Vue.component(_breadcrumbItem2.default.name, _breadcrumbItem2.default);
		};
	
		exports.default = _breadcrumbItem2.default;
	
	/***/ },
	/* 197 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(198)
	
		/* template */
		var __vue_template__ = __webpack_require__(199)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 198 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		//
		//
		//
		//
		//
	
		exports.default = {
		  name: 'ElBreadcrumbItem',
		  props: {
		    to: {},
		    replace: Boolean
		  },
		  data: function data() {
		    return {
		      separator: ''
		    };
		  },
		  mounted: function mounted() {
		    var _this = this;
	
		    this.separator = this.$parent.separator;
		    var self = this;
		    if (this.to) {
		      var link = this.$refs.link;
		      link.addEventListener('click', function (_) {
		        var to = _this.to;
		        self.replace ? self.$router.replace(to) : self.$router.push(to);
		      });
		    }
		  }
		};
	
	/***/ },
	/* 199 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('span', {
		    staticClass: "el-breadcrumb__item"
		  }, [_c('span', {
		    ref: "link",
		    staticClass: "el-breadcrumb__item__inner"
		  }, [_vm._t("default")], 2), _c('span', {
		    staticClass: "el-breadcrumb__separator"
		  }, [_vm._v(_vm._s(_vm.separator))])])
		},staticRenderFns: []}
	
	/***/ },
	/* 200 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _form = __webpack_require__(201);
	
		var _form2 = _interopRequireDefault(_form);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_form2.default.install = function (Vue) {
		  Vue.component(_form2.default.name, _form2.default);
		};
	
		exports.default = _form2.default;
	
	/***/ },
	/* 201 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(202)
	
		/* template */
		var __vue_template__ = __webpack_require__(203)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 202 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  name: 'ElForm',
	
		  componentName: 'ElForm',
	
		  props: {
		    model: Object,
		    rules: Object,
		    labelPosition: String,
		    labelWidth: String,
		    labelSuffix: {
		      type: String,
		      default: ''
		    },
		    inline: Boolean,
		    showMessage: {
		      type: Boolean,
		      default: true
		    }
		  },
		  watch: {
		    rules: function rules() {
		      this.validate();
		    }
		  },
		  data: function data() {
		    return {
		      fields: []
		    };
		  },
		  created: function created() {
		    var _this = this;
	
		    this.$on('el.form.addField', function (field) {
		      if (field) {
		        _this.fields.push(field);
		      }
		    });
		    /* istanbul ignore next */
		    this.$on('el.form.removeField', function (field) {
		      if (field.prop) {
		        _this.fields.splice(_this.fields.indexOf(field), 1);
		      }
		    });
		  },
	
		  methods: {
		    resetFields: function resetFields() {
		      this.fields.forEach(function (field) {
		        field.resetField();
		      });
		    },
		    validate: function validate(callback) {
		      var _this2 = this;
	
		      var valid = true;
		      var count = 0;
		      this.fields.forEach(function (field, index) {
		        field.validate('', function (errors) {
		          if (errors) {
		            valid = false;
		          }
		          if (typeof callback === 'function' && ++count === _this2.fields.length) {
		            callback(valid);
		          }
		        });
		      });
		    },
		    validateField: function validateField(prop, cb) {
		      var field = this.fields.filter(function (field) {
		        return field.prop === prop;
		      })[0];
		      if (!field) {
		        throw new Error('must call validateField with valid prop string!');
		      }
	
		      field.validate('', cb);
		    }
		  }
		};
	
	/***/ },
	/* 203 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('form', {
		    staticClass: "el-form",
		    class: [
		      _vm.labelPosition ? 'el-form--label-' + _vm.labelPosition : '', {
		        'el-form--inline': _vm.inline
		      }
		    ]
		  }, [_vm._t("default")], 2)
		},staticRenderFns: []}
	
	/***/ },
	/* 204 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _formItem = __webpack_require__(205);
	
		var _formItem2 = _interopRequireDefault(_formItem);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_formItem2.default.install = function (Vue) {
		  Vue.component(_formItem2.default.name, _formItem2.default);
		};
	
		exports.default = _formItem2.default;
	
	/***/ },
	/* 205 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(206)
	
		/* template */
		var __vue_template__ = __webpack_require__(208)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 206 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _asyncValidator = __webpack_require__(207);
	
		var _asyncValidator2 = _interopRequireDefault(_asyncValidator);
	
		var _emitter = __webpack_require__(23);
	
		var _emitter2 = _interopRequireDefault(_emitter);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		function noop() {}
	
		function getPropByPath(obj, path) {
		  var tempObj = obj;
		  path = path.replace(/\[(\w+)\]/g, '.$1');
		  path = path.replace(/^\./, '');
	
		  var keyArr = path.split('.');
		  var i = 0;
	
		  for (var len = keyArr.length; i < len - 1; ++i) {
		    var key = keyArr[i];
		    if (key in tempObj) {
		      tempObj = tempObj[key];
		    } else {
		      throw new Error('please transfer a valid prop path to form item!');
		    }
		  }
		  return {
		    o: tempObj,
		    k: keyArr[i],
		    v: tempObj[keyArr[i]]
		  };
		}
	
		exports.default = {
		  name: 'ElFormItem',
	
		  componentName: 'ElFormItem',
	
		  mixins: [_emitter2.default],
	
		  props: {
		    label: String,
		    labelWidth: String,
		    prop: String,
		    required: Boolean,
		    rules: [Object, Array],
		    error: String,
		    validateStatus: String,
		    showMessage: {
		      type: Boolean,
		      default: true
		    }
		  },
		  watch: {
		    error: function error(value) {
		      this.validateMessage = value;
		      this.validateState = 'error';
		    },
		    validateStatus: function validateStatus(value) {
		      this.validateState = value;
		    }
		  },
		  computed: {
		    labelStyle: function labelStyle() {
		      var ret = {};
		      if (this.form.labelPosition === 'top') return ret;
		      var labelWidth = this.labelWidth || this.form.labelWidth;
		      if (labelWidth) {
		        ret.width = labelWidth;
		      }
		      return ret;
		    },
		    contentStyle: function contentStyle() {
		      var ret = {};
		      if (this.form.labelPosition === 'top') return ret;
		      var labelWidth = this.labelWidth || this.form.labelWidth;
		      if (labelWidth) {
		        ret.marginLeft = labelWidth;
		      }
		      return ret;
		    },
		    form: function form() {
		      var parent = this.$parent;
		      while (parent.$options.componentName !== 'ElForm') {
		        parent = parent.$parent;
		      }
		      return parent;
		    },
	
		    fieldValue: {
		      cache: false,
		      get: function get() {
		        var model = this.form.model;
		        if (!model || !this.prop) {
		          return;
		        }
	
		        var path = this.prop;
		        if (path.indexOf(':') !== -1) {
		          path = path.replace(/:/, '.');
		        }
	
		        return getPropByPath(model, path).v;
		      }
		    }
		  },
		  data: function data() {
		    return {
		      validateState: '',
		      validateMessage: '',
		      validateDisabled: false,
		      validator: {},
		      isRequired: false
		    };
		  },
	
		  methods: {
		    validate: function validate(trigger) {
		      var _this = this;
	
		      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
	
		      var rules = this.getFilteredRule(trigger);
		      if (!rules || rules.length === 0) {
		        callback();
		        return true;
		      }
	
		      this.validateState = 'validating';
	
		      var descriptor = {};
		      descriptor[this.prop] = rules;
	
		      var validator = new _asyncValidator2.default(descriptor);
		      var model = {};
	
		      model[this.prop] = this.fieldValue;
	
		      validator.validate(model, { firstFields: true }, function (errors, fields) {
		        _this.validateState = !errors ? 'success' : 'error';
		        _this.validateMessage = errors ? errors[0].message : '';
	
		        callback(_this.validateMessage);
		      });
		    },
		    resetField: function resetField() {
		      this.validateState = '';
		      this.validateMessage = '';
	
		      var model = this.form.model;
		      var value = this.fieldValue;
		      var path = this.prop;
		      if (path.indexOf(':') !== -1) {
		        path = path.replace(/:/, '.');
		      }
	
		      var prop = getPropByPath(model, path);
	
		      if (Array.isArray(value) && value.length > 0) {
		        this.validateDisabled = true;
		        prop.o[prop.k] = [];
		      } else if (value) {
		        this.validateDisabled = true;
		        prop.o[prop.k] = this.initialValue;
		      }
		    },
		    getRules: function getRules() {
		      var formRules = this.form.rules;
		      var selfRuels = this.rules;
	
		      formRules = formRules ? formRules[this.prop] : [];
	
		      return [].concat(selfRuels || formRules || []);
		    },
		    getFilteredRule: function getFilteredRule(trigger) {
		      var rules = this.getRules();
	
		      return rules.filter(function (rule) {
		        return !rule.trigger || rule.trigger.indexOf(trigger) !== -1;
		      });
		    },
		    onFieldBlur: function onFieldBlur() {
		      this.validate('blur');
		    },
		    onFieldChange: function onFieldChange() {
		      if (this.validateDisabled) {
		        this.validateDisabled = false;
		        return;
		      }
	
		      this.validate('change');
		    }
		  },
		  mounted: function mounted() {
		    var _this2 = this;
	
		    if (this.prop) {
		      this.dispatch('ElForm', 'el.form.addField', [this]);
	
		      Object.defineProperty(this, 'initialValue', {
		        value: this.fieldValue
		      });
	
		      var rules = this.getRules();
	
		      if (rules.length) {
		        rules.every(function (rule) {
		          if (rule.required) {
		            _this2.isRequired = true;
		            return false;
		          }
		        });
		        this.$on('el.form.blur', this.onFieldBlur);
		        this.$on('el.form.change', this.onFieldChange);
		      }
		    }
		  },
		  beforeDestroy: function beforeDestroy() {
		    this.dispatch('ElForm', 'el.form.removeField', [this]);
		  }
		};
	
	/***/ },
	/* 207 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(153);
	
	/***/ },
	/* 208 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    staticClass: "el-form-item",
		    class: {
		      'is-error': _vm.validateState === 'error',
		        'is-validating': _vm.validateState === 'validating',
		        'is-required': _vm.isRequired || _vm.required
		    }
		  }, [(_vm.label) ? _c('label', {
		    staticClass: "el-form-item__label",
		    style: (_vm.labelStyle),
		    attrs: {
		      "for": _vm.prop
		    }
		  }, [_vm._v("\n    " + _vm._s(_vm.label + _vm.form.labelSuffix) + "\n  ")]) : _vm._e(), _c('div', {
		    staticClass: "el-form-item__content",
		    style: (_vm.contentStyle)
		  }, [_vm._t("default"), _c('transition', {
		    attrs: {
		      "name": "el-zoom-in-top"
		    }
		  }, [(_vm.validateState === 'error' && _vm.showMessage && _vm.form.showMessage) ? _c('div', {
		    staticClass: "el-form-item__error"
		  }, [_vm._v(_vm._s(_vm.validateMessage))]) : _vm._e()])], 2)])
		},staticRenderFns: []}
	
	/***/ },
	/* 209 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _tabs = __webpack_require__(210);
	
		var _tabs2 = _interopRequireDefault(_tabs);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_tabs2.default.install = function (Vue) {
		  Vue.component(_tabs2.default.name, _tabs2.default);
		};
	
		exports.default = _tabs2.default;
	
	/***/ },
	/* 210 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(211)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 211 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _tabBar = __webpack_require__(212);
	
		var _tabBar2 = _interopRequireDefault(_tabBar);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		module.exports = {
		  name: 'ElTabs',
	
		  components: {
		    TabBar: _tabBar2.default
		  },
	
		  props: {
		    type: String,
		    activeName: String,
		    closable: {
		      type: Boolean,
		      default: false
		    },
		    value: {}
		  },
	
		  data: function data() {
		    return {
		      children: null,
		      currentName: this.value || this.activeName,
		      panes: []
		    };
		  },
	
	
		  watch: {
		    activeName: function activeName(value) {
		      this.setCurrentName(value);
		    },
		    value: function value(_value) {
		      this.setCurrentName(_value);
		    }
		  },
	
		  computed: {
		    currentTab: function currentTab() {
		      var _this = this;
	
		      var result = void 0;
		      this.panes.forEach(function (tab) {
		        if (_this.currentName === (tab.name || tab.index)) {
		          result = tab;
		        }
		      });
		      return result;
		    }
		  },
	
		  methods: {
		    handleTabRemove: function handleTabRemove(pane, event) {
		      var _this2 = this;
	
		      event.stopPropagation();
		      var panes = this.panes;
		      var currentTab = this.currentTab;
	
		      var index = panes.indexOf(pane);
	
		      if (index === -1) return;
	
		      panes.splice(index, 1);
		      pane.$destroy();
	
		      this.$emit('tab-remove', pane);
	
		      this.$nextTick(function (_) {
		        if (pane.active) {
		          var _panes = _this2.panes;
		          var nextChild = _panes[index];
		          var prevChild = _panes[index - 1];
		          var nextActiveTab = nextChild || prevChild || null;
	
		          if (nextActiveTab) {
		            _this2.setCurrentName(nextActiveTab.name || nextActiveTab.index);
		          }
		          return;
		        } else {
		          _this2.setCurrentName(currentTab.name || currentTab.index);
		        }
		      });
		    },
		    handleTabClick: function handleTabClick(tab, tabName, event) {
		      if (tab.disabled) return;
		      this.setCurrentName(tabName);
		      this.$emit('tab-click', tab, event);
		    },
		    setCurrentName: function setCurrentName(value) {
		      this.currentName = value;
		      this.$emit('input', value);
		    },
		    addPanes: function addPanes(item) {
		      this.panes.push(item);
		    },
		    removePanes: function removePanes(item) {
		      var panes = this.panes;
		      var index = panes.indexOf(item);
		      if (index > -1) {
		        panes.splice(index, 1);
		      }
		    }
		  },
		  render: function render(h) {
		    var _this3 = this;
	
		    var type = this.type,
		        handleTabRemove = this.handleTabRemove,
		        handleTabClick = this.handleTabClick,
		        currentName = this.currentName,
		        panes = this.panes;
	
	
		    var tabs = this._l(panes, function (pane, index) {
		      var tabName = pane.name || pane.index || index;
		      if (currentName === undefined && index === 0) {
		        _this3.setCurrentName(tabName);
		      }
	
		      pane.index = index;
	
		      var btnClose = pane.isClosable ? h(
		        'span',
		        { 'class': 'el-icon-close', on: {
		            'click': function click(ev) {
		              handleTabRemove(pane, ev);
		            }
		          }
		        },
		        []
		      ) : null;
	
		      var tabLabelContent = pane.$slots.label || pane.label;
		      return h(
		        'div',
		        {
		          'class': {
		            'el-tabs__item': true,
		            'is-active': pane.active,
		            'is-disabled': pane.disabled,
		            'is-closable': pane.isClosable
		          },
		          ref: 'tabs',
		          refInFor: true,
		          on: {
		            'click': function click(ev) {
		              handleTabClick(pane, tabName, ev);
		            }
		          }
		        },
		        [tabLabelContent, btnClose]
		      );
		    });
	
		    return h(
		      'div',
		      { 'class': {
		          'el-tabs': true,
		          'el-tabs--card': type === 'card',
		          'el-tabs--border-card': type === 'border-card'
		        } },
		      [h(
		        'div',
		        { 'class': 'el-tabs__header' },
		        [!type ? h(
		          'tab-bar',
		          {
		            attrs: { tabs: panes }
		          },
		          []
		        ) : null, tabs]
		      ), h(
		        'div',
		        { 'class': 'el-tabs__content' },
		        [this.$slots.default]
		      )]
		    );
		  }
		};
	
	/***/ },
	/* 212 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(213)
	
		/* template */
		var __vue_template__ = __webpack_require__(214)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 213 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		//
		//
		//
	
		exports.default = {
		  props: {
		    tabs: Array
		  },
		  computed: {
		    barStyle: {
		      cache: false,
		      get: function get() {
		        var _this = this;
	
		        if (!this.$parent.$refs.tabs) return {};
		        var style = {};
		        var offset = 0;
		        var tabWidth = 0;
	
		        this.tabs.every(function (tab, index) {
		          var $el = _this.$parent.$refs.tabs[index];
		          if (!$el) {
		            return false;
		          }
	
		          if (!tab.active) {
		            offset += $el.clientWidth;
		            return true;
		          } else {
		            tabWidth = $el.clientWidth;
		            return false;
		          }
		        });
	
		        var transform = 'translateX(' + offset + 'px)';
		        style.width = tabWidth + 'px';
		        style.transform = transform;
		        style.msTransform = transform;
		        style.webkitTransform = transform;
	
		        return style;
		      }
		    }
		  }
		};
	
	/***/ },
	/* 214 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    staticClass: "el-tabs__active-bar",
		    style: (_vm.barStyle)
		  })
		},staticRenderFns: []}
	
	/***/ },
	/* 215 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _tabPane = __webpack_require__(216);
	
		var _tabPane2 = _interopRequireDefault(_tabPane);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_tabPane2.default.install = function (Vue) {
		  Vue.component(_tabPane2.default.name, _tabPane2.default);
		};
	
		exports.default = _tabPane2.default;
	
	/***/ },
	/* 216 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(217)
	
		/* template */
		var __vue_template__ = __webpack_require__(218)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 217 */
	/***/ function(module, exports) {
	
		'use strict';
	
		//
		//
		//
		//
		//
	
		module.exports = {
		  name: 'ElTabPane',
	
		  componentName: 'ElTabPane',
	
		  props: {
		    label: String,
		    labelContent: Function,
		    name: String,
		    closable: Boolean,
		    disabled: Boolean
		  },
	
		  data: function data() {
		    return {
		      index: null
		    };
		  },
	
	
		  computed: {
		    isClosable: function isClosable() {
		      return this.closable || this.$parent.closable;
		    },
		    active: function active() {
		      return this.$parent.currentName === (this.name || this.index);
		    }
		  },
	
		  mounted: function mounted() {
		    this.$parent.addPanes(this);
		  },
		  destroyed: function destroyed() {
		    if (this.$el && this.$el.parentNode) {
		      this.$el.parentNode.removeChild(this.$el);
		    }
		    this.$parent.removePanes(this);
		  },
	
	
		  watch: {
		    label: function label() {
		      this.$parent.$forceUpdate();
		    }
		  }
		};
	
	/***/ },
	/* 218 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.active),
		      expression: "active"
		    }],
		    staticClass: "el-tab-pane"
		  }, [_vm._t("default")], 2)
		},staticRenderFns: []}
	
	/***/ },
	/* 219 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _tag = __webpack_require__(220);
	
		var _tag2 = _interopRequireDefault(_tag);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_tag2.default.install = function (Vue) {
		  Vue.component(_tag2.default.name, _tag2.default);
		};
	
		exports.default = _tag2.default;
	
	/***/ },
	/* 220 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(221)
	
		/* template */
		var __vue_template__ = __webpack_require__(222)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 221 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  name: 'ElTag',
		  props: {
		    text: String,
		    closable: Boolean,
		    type: String,
		    hit: Boolean,
		    closeTransition: Boolean,
		    color: String
		  },
		  methods: {
		    handleClose: function handleClose(event) {
		      this.$emit('close', event);
		    }
		  }
		};
	
	/***/ },
	/* 222 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('transition', {
		    attrs: {
		      "name": _vm.closeTransition ? '' : 'el-zoom-in-center'
		    }
		  }, [_c('span', {
		    staticClass: "el-tag",
		    class: [_vm.type ? 'el-tag--' + _vm.type : '', {
		      'is-hit': _vm.hit
		    }],
		    style: ({
		      backgroundColor: _vm.color
		    })
		  }, [_vm._t("default"), (_vm.closable) ? _c('i', {
		    staticClass: "el-tag__close el-icon-close",
		    on: {
		      "click": _vm.handleClose
		    }
		  }) : _vm._e()], 2)])
		},staticRenderFns: []}
	
	/***/ },
	/* 223 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _tree = __webpack_require__(224);
	
		var _tree2 = _interopRequireDefault(_tree);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_tree2.default.install = function (Vue) {
		  Vue.component(_tree2.default.name, _tree2.default);
		};
	
		exports.default = _tree2.default;
	
	/***/ },
	/* 224 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(225)
	
		/* template */
		var __vue_template__ = __webpack_require__(232)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 225 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _treeStore = __webpack_require__(226);
	
		var _treeStore2 = _interopRequireDefault(_treeStore);
	
		var _locale = __webpack_require__(105);
	
		var _emitter = __webpack_require__(23);
	
		var _emitter2 = _interopRequireDefault(_emitter);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  name: 'ElTree',
	
		  mixins: [_emitter2.default],
	
		  components: {
		    ElTreeNode: __webpack_require__(229)
		  },
	
		  data: function data() {
		    return {
		      store: null,
		      root: null,
		      currentNode: null
		    };
		  },
	
	
		  props: {
		    data: {
		      type: Array
		    },
		    emptyText: {
		      type: String,
		      default: function _default() {
		        return (0, _locale.t)('el.tree.emptyText');
		      }
		    },
		    nodeKey: String,
		    checkStrictly: Boolean,
		    defaultExpandAll: Boolean,
		    expandOnClickNode: {
		      type: Boolean,
		      default: true
		    },
		    autoExpandParent: {
		      type: Boolean,
		      default: true
		    },
		    defaultCheckedKeys: Array,
		    defaultExpandedKeys: Array,
		    renderContent: Function,
		    showCheckbox: {
		      type: Boolean,
		      default: false
		    },
		    props: {
		      default: function _default() {
		        return {
		          children: 'children',
		          label: 'label',
		          icon: 'icon'
		        };
		      }
		    },
		    lazy: {
		      type: Boolean,
		      default: false
		    },
		    highlightCurrent: Boolean,
		    currentNodeKey: [String, Number],
		    load: Function,
		    filterNodeMethod: Function,
		    accordion: Boolean
		  },
	
		  computed: {
		    children: {
		      set: function set(value) {
		        this.data = value;
		      },
		      get: function get() {
		        return this.data;
		      }
		    }
		  },
	
		  watch: {
		    defaultCheckedKeys: function defaultCheckedKeys(newVal) {
		      this.store.defaultCheckedKeys = newVal;
		      this.store.setDefaultCheckedKey(newVal);
		    },
		    defaultExpandedKeys: function defaultExpandedKeys(newVal) {
		      this.store.defaultExpandedKeys = newVal;
		      this.store.setDefaultExpandedKeys(newVal);
		    },
		    currentNodeKey: function currentNodeKey(newVal) {
		      this.store.setCurrentNodeKey(newVal);
		    },
		    data: function data(newVal) {
		      this.store.setData(newVal);
		    }
		  },
	
		  methods: {
		    filter: function filter(value) {
		      if (!this.filterNodeMethod) throw new Error('[Tree] filterNodeMethod is required when filter');
		      this.store.filter(value);
		    },
		    getNodeKey: function getNodeKey(node, index) {
		      var nodeKey = this.nodeKey;
		      if (nodeKey && node) {
		        return node.data[nodeKey];
		      }
		      return index;
		    },
		    getCheckedNodes: function getCheckedNodes(leafOnly) {
		      return this.store.getCheckedNodes(leafOnly);
		    },
		    getCheckedKeys: function getCheckedKeys(leafOnly) {
		      return this.store.getCheckedKeys(leafOnly);
		    },
		    setCheckedNodes: function setCheckedNodes(nodes, leafOnly) {
		      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in setCheckedNodes');
		      this.store.setCheckedNodes(nodes, leafOnly);
		    },
		    setCheckedKeys: function setCheckedKeys(keys, leafOnly) {
		      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in setCheckedNodes');
		      this.store.setCheckedKeys(keys, leafOnly);
		    },
		    setChecked: function setChecked(data, checked, deep) {
		      this.store.setChecked(data, checked, deep);
		    },
		    handleNodeExpand: function handleNodeExpand(nodeData, node, instance) {
		      this.broadcast('ElTreeNode', 'tree-node-expand', node);
		    }
		  },
	
		  created: function created() {
		    this.isTree = true;
	
		    this.store = new _treeStore2.default({
		      key: this.nodeKey,
		      data: this.data,
		      lazy: this.lazy,
		      props: this.props,
		      load: this.load,
		      currentNodeKey: this.currentNodeKey,
		      checkStrictly: this.checkStrictly,
		      defaultCheckedKeys: this.defaultCheckedKeys,
		      defaultExpandedKeys: this.defaultExpandedKeys,
		      autoExpandParent: this.autoExpandParent,
		      defaultExpandAll: this.defaultExpandAll,
		      filterNodeMethod: this.filterNodeMethod
		    });
	
		    this.root = this.store.root;
		  }
		}; //
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
	/***/ },
	/* 226 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		var _node = __webpack_require__(227);
	
		var _node2 = _interopRequireDefault(_node);
	
		var _util = __webpack_require__(228);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var TreeStore = function () {
		  function TreeStore(options) {
		    var _this = this;
	
		    _classCallCheck(this, TreeStore);
	
		    this.currentNode = null;
		    this.currentNodeKey = null;
	
		    for (var option in options) {
		      if (options.hasOwnProperty(option)) {
		        this[option] = options[option];
		      }
		    }
	
		    this.nodesMap = {};
	
		    this.root = new _node2.default({
		      data: this.data,
		      store: this
		    });
	
		    if (this.lazy && this.load) {
		      var loadFn = this.load;
		      loadFn(this.root, function (data) {
		        _this.root.doCreateChildren(data);
		        _this._initDefaultCheckedNodes();
		      });
		    } else {
		      this._initDefaultCheckedNodes();
		    }
		  }
	
		  TreeStore.prototype.filter = function filter(value) {
		    var filterNodeMethod = this.filterNodeMethod;
		    var traverse = function traverse(node) {
		      var childNodes = node.root ? node.root.childNodes : node.childNodes;
	
		      childNodes.forEach(function (child) {
		        child.visible = filterNodeMethod.call(child, value, child.data, child);
	
		        traverse(child);
		      });
	
		      if (!node.visible && childNodes.length) {
		        var allHidden = true;
	
		        childNodes.forEach(function (child) {
		          if (child.visible) allHidden = false;
		        });
	
		        if (node.root) {
		          node.root.visible = allHidden === false;
		        } else {
		          node.visible = allHidden === false;
		        }
		      }
	
		      if (node.visible && !node.isLeaf) node.expand();
		    };
	
		    traverse(this);
		  };
	
		  TreeStore.prototype.setData = function setData(newVal) {
		    var instanceChanged = newVal !== this.root.data;
		    this.root.setData(newVal);
		    if (instanceChanged) {
		      this._initDefaultCheckedNodes();
		    }
		  };
	
		  TreeStore.prototype.getNode = function getNode(data) {
		    var key = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== 'object' ? data : (0, _util.getNodeKey)(this.key, data);
		    return this.nodesMap[key];
		  };
	
		  TreeStore.prototype.insertBefore = function insertBefore(data, refData) {
		    var refNode = this.getNode(refData);
		    refNode.parent.insertBefore({ data: data }, refNode);
		  };
	
		  TreeStore.prototype.insertAfter = function insertAfter(data, refData) {
		    var refNode = this.getNode(refData);
		    refNode.parent.insertAfter({ data: data }, refNode);
		  };
	
		  TreeStore.prototype.remove = function remove(data) {
		    var node = this.getNode(data);
		    if (node) {
		      node.parent.removeChild(node);
		    }
		  };
	
		  TreeStore.prototype.append = function append(data, parentData) {
		    var parentNode = parentData ? this.getNode(parentData) : this.root;
	
		    if (parentNode) {
		      parentNode.insertChild({ data: data });
		    }
		  };
	
		  TreeStore.prototype._initDefaultCheckedNodes = function _initDefaultCheckedNodes() {
		    var _this2 = this;
	
		    var defaultCheckedKeys = this.defaultCheckedKeys || [];
		    var nodesMap = this.nodesMap;
	
		    defaultCheckedKeys.forEach(function (checkedKey) {
		      var node = nodesMap[checkedKey];
	
		      if (node) {
		        node.setChecked(true, !_this2.checkStrictly);
		      }
		    });
		  };
	
		  TreeStore.prototype._initDefaultCheckedNode = function _initDefaultCheckedNode(node) {
		    var defaultCheckedKeys = this.defaultCheckedKeys || [];
	
		    if (defaultCheckedKeys.indexOf(node.key) !== -1) {
		      node.setChecked(true, !this.checkStrictly);
		    }
		  };
	
		  TreeStore.prototype.setDefaultCheckedKey = function setDefaultCheckedKey(newVal) {
		    if (newVal !== this.defaultCheckedKeys) {
		      this.defaultCheckedKeys = newVal;
		      this._initDefaultCheckedNodes();
		    }
		  };
	
		  TreeStore.prototype.registerNode = function registerNode(node) {
		    var key = this.key;
		    if (!key || !node || !node.data) return;
	
		    var nodeKey = node.key;
		    if (nodeKey) this.nodesMap[node.key] = node;
		  };
	
		  TreeStore.prototype.deregisterNode = function deregisterNode(node) {
		    var key = this.key;
		    if (!key || !node || !node.data) return;
	
		    delete this.nodesMap[node.key];
		  };
	
		  TreeStore.prototype.getCheckedNodes = function getCheckedNodes(leafOnly) {
		    var checkedNodes = [];
		    var traverse = function traverse(node) {
		      var childNodes = node.root ? node.root.childNodes : node.childNodes;
	
		      childNodes.forEach(function (child) {
		        if (!leafOnly && child.checked || leafOnly && child.isLeaf && child.checked) {
		          checkedNodes.push(child.data);
		        }
	
		        traverse(child);
		      });
		    };
	
		    traverse(this);
	
		    return checkedNodes;
		  };
	
		  TreeStore.prototype.getCheckedKeys = function getCheckedKeys(leafOnly) {
		    var key = this.key;
		    var allNodes = this._getAllNodes();
		    var keys = [];
		    allNodes.forEach(function (node) {
		      if (!leafOnly || leafOnly && node.isLeaf) {
		        if (node.checked) {
		          keys.push((node.data || {})[key]);
		        }
		      }
		    });
		    return keys;
		  };
	
		  TreeStore.prototype._getAllNodes = function _getAllNodes() {
		    var allNodes = [];
		    var nodesMap = this.nodesMap;
		    for (var nodeKey in nodesMap) {
		      if (nodesMap.hasOwnProperty(nodeKey)) {
		        allNodes.push(nodesMap[nodeKey]);
		      }
		    }
	
		    return allNodes;
		  };
	
		  TreeStore.prototype._setCheckedKeys = function _setCheckedKeys(key, leafOnly, checkedKeys) {
		    var _this3 = this;
	
		    var allNodes = this._getAllNodes();
	
		    allNodes.sort(function (a, b) {
		      return a.level > b.level ? -1 : 1;
		    });
		    allNodes.forEach(function (node) {
		      if (!leafOnly || leafOnly && node.isLeaf) {
		        node.setChecked(!!checkedKeys[(node.data || {})[key]], !_this3.checkStrictly);
		      }
		    });
		  };
	
		  TreeStore.prototype.setCheckedNodes = function setCheckedNodes(array) {
		    var leafOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
		    var key = this.key;
		    var checkedKeys = {};
		    array.forEach(function (item) {
		      checkedKeys[(item || {})[key]] = true;
		    });
	
		    this._setCheckedKeys(key, leafOnly, checkedKeys);
		  };
	
		  TreeStore.prototype.setCheckedKeys = function setCheckedKeys(keys) {
		    var leafOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
		    this.defaultCheckedKeys = keys;
		    var key = this.key;
		    var checkedKeys = {};
		    keys.forEach(function (key) {
		      checkedKeys[key] = true;
		    });
	
		    this._setCheckedKeys(key, leafOnly, checkedKeys);
		  };
	
		  TreeStore.prototype.setDefaultExpandedKeys = function setDefaultExpandedKeys(keys) {
		    var _this4 = this;
	
		    keys = keys || [];
		    this.defaultExpandedKeys = keys;
	
		    keys.forEach(function (key) {
		      var node = _this4.getNode(key);
		      if (node) node.expand(null, _this4.autoExpandParent);
		    });
		  };
	
		  TreeStore.prototype.setChecked = function setChecked(data, checked, deep) {
		    var node = this.getNode(data);
	
		    if (node) {
		      node.setChecked(!!checked, deep);
		    }
		  };
	
		  TreeStore.prototype.getCurrentNode = function getCurrentNode() {
		    return this.currentNode;
		  };
	
		  TreeStore.prototype.setCurrentNode = function setCurrentNode(node) {
		    this.currentNode = node;
		  };
	
		  TreeStore.prototype.setCurrentNodeKey = function setCurrentNodeKey(key) {
		    var node = this.getNode(key);
		    if (node) {
		      this.currentNode = node;
		    }
		  };
	
		  return TreeStore;
		}();
	
		exports.default = TreeStore;
		;
	
	/***/ },
	/* 227 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _merge = __webpack_require__(61);
	
		var _merge2 = _interopRequireDefault(_merge);
	
		var _util = __webpack_require__(228);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var reInitChecked = function reInitChecked(node) {
		  var siblings = node.childNodes;
	
		  var all = true;
		  var none = true;
	
		  for (var i = 0, j = siblings.length; i < j; i++) {
		    var sibling = siblings[i];
		    if (sibling.checked !== true || sibling.indeterminate) {
		      all = false;
		    }
		    if (sibling.checked !== false || sibling.indeterminate) {
		      none = false;
		    }
		  }
	
		  if (all) {
		    node.setChecked(true);
		  } else if (!all && !none) {
		    node.setChecked('half');
		  } else if (none) {
		    node.setChecked(false);
		  }
		};
	
		var getPropertyFromData = function getPropertyFromData(node, prop) {
		  var props = node.store.props;
		  var data = node.data || {};
		  var config = props[prop];
	
		  if (typeof config === 'function') {
		    return config(data, node);
		  } else if (typeof config === 'string') {
		    return data[config];
		  } else if (typeof config === 'undefined') {
		    return '';
		  }
		};
	
		var nodeIdSeed = 0;
	
		var Node = function () {
		  function Node(options) {
		    _classCallCheck(this, Node);
	
		    this.id = nodeIdSeed++;
		    this.text = null;
		    this.checked = false;
		    this.indeterminate = false;
		    this.data = null;
		    this.expanded = false;
		    this.parent = null;
		    this.visible = true;
	
		    for (var name in options) {
		      if (options.hasOwnProperty(name)) {
		        this[name] = options[name];
		      }
		    }
	
		    // internal
		    this.level = 0;
		    this.loaded = false;
		    this.childNodes = [];
		    this.loading = false;
	
		    if (this.parent) {
		      this.level = this.parent.level + 1;
		    }
	
		    var store = this.store;
		    if (!store) {
		      throw new Error('[Node]store is required!');
		    }
		    store.registerNode(this);
	
		    var props = store.props;
		    if (props && typeof props.isLeaf !== 'undefined') {
		      var isLeaf = getPropertyFromData(this, 'isLeaf');
		      if (typeof isLeaf === 'boolean') {
		        this.isLeafByUser = isLeaf;
		      }
		    }
	
		    if (store.lazy !== true && this.data) {
		      this.setData(this.data);
	
		      if (store.defaultExpandAll) {
		        this.expanded = true;
		      }
		    } else if (this.level > 0 && store.lazy && store.defaultExpandAll) {
		      this.expand();
		    }
	
		    if (!this.data) return;
		    var defaultExpandedKeys = store.defaultExpandedKeys;
		    var key = store.key;
		    if (key && defaultExpandedKeys && defaultExpandedKeys.indexOf(this.key) !== -1) {
		      this.expand(null, store.autoExpandParent);
		    }
	
		    if (key && store.currentNodeKey && this.key === store.currentNodeKey) {
		      store.currentNode = this;
		    }
	
		    if (store.lazy) {
		      store._initDefaultCheckedNode(this);
		    }
	
		    this.updateLeafState();
		  }
	
		  Node.prototype.setData = function setData(data) {
		    if (!Array.isArray(data)) {
		      (0, _util.markNodeData)(this, data);
		    }
	
		    this.data = data;
		    this.childNodes = [];
	
		    var children = void 0;
		    if (this.level === 0 && this.data instanceof Array) {
		      children = this.data;
		    } else {
		      children = getPropertyFromData(this, 'children') || [];
		    }
	
		    for (var i = 0, j = children.length; i < j; i++) {
		      this.insertChild({ data: children[i] });
		    }
		  };
	
		  Node.prototype.insertChild = function insertChild(child, index) {
		    if (!child) throw new Error('insertChild error: child is required.');
	
		    if (!(child instanceof Node)) {
		      (0, _merge2.default)(child, {
		        parent: this,
		        store: this.store
		      });
		      child = new Node(child);
		    }
	
		    child.level = this.level + 1;
	
		    if (typeof index === 'undefined' || index < 0) {
		      this.childNodes.push(child);
		    } else {
		      this.childNodes.splice(index, 0, child);
		    }
	
		    this.updateLeafState();
		  };
	
		  Node.prototype.insertBefore = function insertBefore(child, ref) {
		    var index = void 0;
		    if (ref) {
		      index = this.childNodes.indexOf(ref);
		    }
		    this.insertChild(child, index);
		  };
	
		  Node.prototype.insertAfter = function insertAfter(child, ref) {
		    var index = void 0;
		    if (ref) {
		      index = this.childNodes.indexOf(ref);
		      if (index !== -1) index += 1;
		    }
		    this.insertChild(child, index);
		  };
	
		  Node.prototype.removeChild = function removeChild(child) {
		    var index = this.childNodes.indexOf(child);
	
		    if (index > -1) {
		      this.store && this.store.deregisterNode(child);
		      child.parent = null;
		      this.childNodes.splice(index, 1);
		    }
	
		    this.updateLeafState();
		  };
	
		  Node.prototype.removeChildByData = function removeChildByData(data) {
		    var targetNode = null;
		    this.childNodes.forEach(function (node) {
		      if (node.data === data) {
		        targetNode = node;
		      }
		    });
	
		    if (targetNode) {
		      this.removeChild(targetNode);
		    }
		  };
	
		  Node.prototype.expand = function expand(callback, expandParent) {
		    var _this = this;
	
		    var done = function done() {
		      if (expandParent) {
		        var parent = _this.parent;
		        while (parent.level > 0) {
		          parent.expanded = true;
		          parent = parent.parent;
		        }
		      }
		      _this.expanded = true;
		      if (callback) callback();
		    };
	
		    if (this.shouldLoadData()) {
		      this.loadData(function (data) {
		        if (data instanceof Array) {
		          done();
		        }
		      });
		    } else {
		      done();
		    }
		  };
	
		  Node.prototype.doCreateChildren = function doCreateChildren(array) {
		    var _this2 = this;
	
		    var defaultProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		    array.forEach(function (item) {
		      _this2.insertChild((0, _merge2.default)({ data: item }, defaultProps));
		    });
		  };
	
		  Node.prototype.collapse = function collapse() {
		    this.expanded = false;
		  };
	
		  Node.prototype.shouldLoadData = function shouldLoadData() {
		    return this.store.lazy === true && this.store.load && !this.loaded;
		  };
	
		  Node.prototype.updateLeafState = function updateLeafState() {
		    if (this.store.lazy === true && this.loaded !== true && typeof this.isLeafByUser !== 'undefined') {
		      this.isLeaf = this.isLeafByUser;
		      return;
		    }
		    var childNodes = this.childNodes;
		    if (!this.store.lazy || this.store.lazy === true && this.loaded === true) {
		      this.isLeaf = !childNodes || childNodes.length === 0;
		      return;
		    }
		    this.isLeaf = false;
		  };
	
		  Node.prototype.setChecked = function setChecked(value, deep) {
		    var _this3 = this;
	
		    this.indeterminate = value === 'half';
		    this.checked = value === true;
	
		    var handleDescendants = function handleDescendants() {
		      if (deep) {
		        var childNodes = _this3.childNodes;
		        for (var i = 0, j = childNodes.length; i < j; i++) {
		          var child = childNodes[i];
		          child.setChecked(value !== false, deep);
		        }
		      }
		    };
	
		    if (!this.store.checkStrictly && this.shouldLoadData()) {
		      // Only work on lazy load data.
		      this.loadData(function () {
		        handleDescendants();
		      }, {
		        checked: value !== false
		      });
		    } else {
		      handleDescendants();
		    }
	
		    var parent = this.parent;
		    if (!parent || parent.level === 0) return;
	
		    if (!this.store.checkStrictly) {
		      reInitChecked(parent);
		    }
		  };
	
		  Node.prototype.getChildren = function getChildren() {
		    // this is data
		    var data = this.data;
		    if (!data) return null;
	
		    var props = this.store.props;
		    var children = 'children';
		    if (props) {
		      children = props.children || 'children';
		    }
	
		    if (data[children] === undefined) {
		      data[children] = null;
		    }
	
		    return data[children];
		  };
	
		  Node.prototype.updateChildren = function updateChildren() {
		    var _this4 = this;
	
		    var newData = this.getChildren() || [];
		    var oldData = this.childNodes.map(function (node) {
		      return node.data;
		    });
	
		    var newDataMap = {};
		    var newNodes = [];
	
		    newData.forEach(function (item, index) {
		      if (item[_util.NODE_KEY]) {
		        newDataMap[item[_util.NODE_KEY]] = { index: index, data: item };
		      } else {
		        newNodes.push({ index: index, data: item });
		      }
		    });
	
		    oldData.forEach(function (item) {
		      if (!newDataMap[item[_util.NODE_KEY]]) _this4.removeChildByData(item);
		    });
	
		    newNodes.forEach(function (_ref) {
		      var index = _ref.index,
		          data = _ref.data;
	
		      _this4.insertChild({ data: data }, index);
		    });
	
		    this.updateLeafState();
		  };
	
		  Node.prototype.loadData = function loadData(callback) {
		    var _this5 = this;
	
		    var defaultProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		    if (this.store.lazy === true && this.store.load && !this.loaded && !this.loading) {
		      this.loading = true;
	
		      var resolve = function resolve(children) {
		        _this5.loaded = true;
		        _this5.loading = false;
		        _this5.childNodes = [];
	
		        _this5.doCreateChildren(children, defaultProps);
	
		        _this5.updateLeafState();
		        if (callback) {
		          callback.call(_this5, children);
		        }
		      };
	
		      this.store.load(this, resolve);
		    } else {
		      if (callback) {
		        callback.call(this);
		      }
		    }
		  };
	
		  _createClass(Node, [{
		    key: 'label',
		    get: function get() {
		      return getPropertyFromData(this, 'label');
		    }
		  }, {
		    key: 'icon',
		    get: function get() {
		      return getPropertyFromData(this, 'icon');
		    }
		  }, {
		    key: 'key',
		    get: function get() {
		      var nodeKey = this.store.key;
		      if (this.data) return this.data[nodeKey];
		      return null;
		    }
		  }]);
	
		  return Node;
		}();
	
		exports.default = Node;
	
	/***/ },
	/* 228 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		var NODE_KEY = exports.NODE_KEY = '$treeNodeId';
	
		var markNodeData = exports.markNodeData = function markNodeData(node, data) {
		  if (data[NODE_KEY]) return;
		  Object.defineProperty(data, NODE_KEY, {
		    value: node.id,
		    enumerable: false,
		    configurable: false,
		    writable: false
		  });
		};
	
		var getNodeKey = exports.getNodeKey = function getNodeKey(key, data) {
		  if (!key) return data[NODE_KEY];
		  return data[key];
		};
	
	/***/ },
	/* 229 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(230)
	
		/* template */
		var __vue_template__ = __webpack_require__(231)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 230 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _collapseTransition = __webpack_require__(47);
	
		var _collapseTransition2 = _interopRequireDefault(_collapseTransition);
	
		var _checkbox = __webpack_require__(123);
	
		var _checkbox2 = _interopRequireDefault(_checkbox);
	
		var _emitter = __webpack_require__(23);
	
		var _emitter2 = _interopRequireDefault(_emitter);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  name: 'ElTreeNode',
	
		  componentName: 'ElTreeNode',
	
		  mixins: [_emitter2.default],
	
		  props: {
		    node: {
		      default: function _default() {
		        return {};
		      }
		    },
		    props: {},
		    renderContent: Function
		  },
	
		  components: {
		    ElCheckbox: _checkbox2.default,
		    CollapseTransition: _collapseTransition2.default,
		    NodeContent: {
		      props: {
		        node: {
		          required: true
		        }
		      },
		      render: function render(h) {
		        var parent = this.$parent;
		        var node = this.node;
		        var data = node.data;
		        var store = node.store;
		        return parent.renderContent ? parent.renderContent.call(parent._renderProxy, h, { _self: parent.tree.$vnode.context, node: node, data: data, store: store }) : h(
		          'span',
		          { 'class': 'el-tree-node__label' },
		          [this.node.label]
		        );
		      }
		    }
		  },
	
		  data: function data() {
		    return {
		      tree: null,
		      expanded: false,
		      childNodeRendered: false,
		      showCheckbox: false,
		      oldChecked: null,
		      oldIndeterminate: null
		    };
		  },
	
	
		  watch: {
		    'node.indeterminate': function nodeIndeterminate(val) {
		      this.handleSelectChange(this.node.checked, val);
		    },
		    'node.checked': function nodeChecked(val) {
		      this.handleSelectChange(val, this.node.indeterminate);
		    },
		    'node.expanded': function nodeExpanded(val) {
		      this.expanded = val;
		      if (val) {
		        this.childNodeRendered = true;
		      }
		    }
		  },
	
		  methods: {
		    getNodeKey: function getNodeKey(node, index) {
		      var nodeKey = this.tree.nodeKey;
		      if (nodeKey && node) {
		        return node.data[nodeKey];
		      }
		      return index;
		    },
		    handleSelectChange: function handleSelectChange(checked, indeterminate) {
		      if (this.oldChecked !== checked && this.oldIndeterminate !== indeterminate) {
		        this.tree.$emit('check-change', this.node.data, checked, indeterminate);
		      }
		      this.oldChecked = checked;
		      this.indeterminate = indeterminate;
		    },
		    handleClick: function handleClick() {
		      var store = this.tree.store;
		      store.setCurrentNode(this.node);
		      this.tree.$emit('current-change', store.currentNode ? store.currentNode.data : null, store.currentNode);
		      this.tree.currentNode = this;
		      if (this.tree.expandOnClickNode) {
		        this.handleExpandIconClick();
		      }
		      this.tree.$emit('node-click', this.node.data, this.node, this);
		    },
		    handleExpandIconClick: function handleExpandIconClick() {
		      if (this.expanded) {
		        this.node.collapse();
		      } else {
		        this.node.expand();
		        this.$emit('node-expand', this.node.data, this.node, this);
		      }
		    },
		    handleUserClick: function handleUserClick() {
		      if (this.node.indeterminate) {
		        this.node.setChecked(this.node.checked, !this.tree.checkStrictly);
		      }
		    },
		    handleCheckChange: function handleCheckChange(ev) {
		      if (!this.node.indeterminate) {
		        this.node.setChecked(ev.target.checked, !this.tree.checkStrictly);
		      }
		    },
		    handleChildNodeExpand: function handleChildNodeExpand(node) {
		      this.broadcast('ElTreeNode', 'tree-node-expand', node);
		    }
		  },
	
		  created: function created() {
		    var _this = this;
	
		    var parent = this.$parent;
	
		    if (parent.isTree) {
		      this.tree = parent;
		    } else {
		      this.tree = parent.tree;
		    }
	
		    var tree = this.tree;
		    if (!tree) {
		      console.warn('Can not find node\'s tree.');
		    }
	
		    var props = tree.props || {};
		    var childrenKey = props['children'] || 'children';
	
		    this.$watch('node.data.' + childrenKey, function () {
		      _this.node.updateChildren();
		    });
	
		    this.showCheckbox = tree.showCheckbox;
	
		    if (this.node.expanded) {
		      this.expanded = true;
		      this.childNodeRendered = true;
		    }
	
		    if (this.tree.accordion) {
		      this.$on('tree-node-expand', function (node) {
		        if (_this.node !== node) {
		          _this.node.collapse();
		        }
		      });
		    }
		  }
		}; //
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
	/***/ },
	/* 231 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.node.visible),
		      expression: "node.visible"
		    }],
		    staticClass: "el-tree-node",
		    class: {
		      'is-expanded': _vm.childNodeRendered && _vm.expanded,
		        'is-current': _vm.tree.store.currentNode === _vm.node,
		        'is-hidden': !_vm.node.visible
		    },
		    on: {
		      "click": function($event) {
		        $event.stopPropagation();
		        _vm.handleClick($event)
		      }
		    }
		  }, [_c('div', {
		    staticClass: "el-tree-node__content",
		    style: ({
		      'padding-left': (_vm.node.level - 1) * 16 + 'px'
		    })
		  }, [_c('span', {
		    staticClass: "el-tree-node__expand-icon",
		    class: {
		      'is-leaf': _vm.node.isLeaf, expanded: !_vm.node.isLeaf && _vm.expanded
		    },
		    on: {
		      "click": function($event) {
		        $event.stopPropagation();
		        _vm.handleExpandIconClick($event)
		      }
		    }
		  }), (_vm.showCheckbox) ? _c('el-checkbox', {
		    directives: [{
		      name: "model",
		      rawName: "v-model",
		      value: (_vm.node.checked),
		      expression: "node.checked"
		    }],
		    attrs: {
		      "indeterminate": _vm.node.indeterminate
		    },
		    domProps: {
		      "value": (_vm.node.checked)
		    },
		    on: {
		      "change": _vm.handleCheckChange,
		      "input": function($event) {
		        _vm.node.checked = $event
		      }
		    },
		    nativeOn: {
		      "click": function($event) {
		        $event.stopPropagation();
		        _vm.handleUserClick($event)
		      }
		    }
		  }) : _vm._e(), (_vm.node.loading) ? _c('span', {
		    staticClass: "el-tree-node__loading-icon el-icon-loading"
		  }) : _vm._e(), _c('node-content', {
		    attrs: {
		      "node": _vm.node
		    }
		  })], 1), _c('collapse-transition', [_c('div', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.expanded),
		      expression: "expanded"
		    }],
		    staticClass: "el-tree-node__children"
		  }, _vm._l((_vm.node.childNodes), function(child) {
		    return _c('el-tree-node', {
		      key: _vm.getNodeKey(child),
		      attrs: {
		        "render-content": _vm.renderContent,
		        "node": child
		      },
		      on: {
		        "node-expand": function($event) {
		          _vm.handleChildNodeExpand(child)
		        }
		      }
		    })
		  }))])], 1)
		},staticRenderFns: []}
	
	/***/ },
	/* 232 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    staticClass: "el-tree",
		    class: {
		      'el-tree--highlight-current': _vm.highlightCurrent
		    }
		  }, [_vm._l((_vm.root.childNodes), function(child) {
		    return _c('el-tree-node', {
		      key: _vm.getNodeKey(child),
		      attrs: {
		        "node": child,
		        "props": _vm.props,
		        "render-content": _vm.renderContent
		      },
		      on: {
		        "node-expand": _vm.handleNodeExpand
		      }
		    })
		  }), (!_vm.root.childNodes || _vm.root.childNodes.length === 0) ? _c('div', {
		    staticClass: "el-tree__empty-block"
		  }, [_c('span', {
		    staticClass: "el-tree__empty-text"
		  }, [_vm._v(_vm._s(_vm.emptyText))])]) : _vm._e()], 2)
		},staticRenderFns: []}
	
	/***/ },
	/* 233 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _main = __webpack_require__(234);
	
		var _main2 = _interopRequireDefault(_main);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_main2.default.install = function (Vue) {
		  Vue.component(_main2.default.name, _main2.default);
		};
	
		exports.default = _main2.default;
	
	/***/ },
	/* 234 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(235)
	
		/* template */
		var __vue_template__ = __webpack_require__(236)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 235 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		var TYPE_CLASSES_MAP = {
		  'success': 'el-icon-circle-check',
		  'warning': 'el-icon-warning',
		  'error': 'el-icon-circle-cross'
		};
		exports.default = {
		  name: 'ElAlert',
	
		  props: {
		    title: {
		      type: String,
		      default: '',
		      required: true
		    },
		    description: {
		      type: String,
		      default: ''
		    },
		    type: {
		      type: String,
		      default: 'info'
		    },
		    closable: {
		      type: Boolean,
		      default: true
		    },
		    closeText: {
		      type: String,
		      default: ''
		    },
		    showIcon: {
		      type: Boolean,
		      default: false
		    }
		  },
	
		  data: function data() {
		    return {
		      visible: true
		    };
		  },
	
	
		  methods: {
		    close: function close() {
		      this.visible = false;
		      this.$emit('close');
		    }
		  },
	
		  computed: {
		    typeClass: function typeClass() {
		      return 'el-alert--' + this.type;
		    },
		    iconClass: function iconClass() {
		      return TYPE_CLASSES_MAP[this.type] || 'el-icon-information';
		    },
		    isBigIcon: function isBigIcon() {
		      return this.description ? 'is-big' : '';
		    },
		    isBoldTitle: function isBoldTitle() {
		      return this.description ? 'is-bold' : '';
		    }
		  }
		};
	
	/***/ },
	/* 236 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('transition', {
		    attrs: {
		      "name": "el-alert-fade"
		    }
		  }, [_c('div', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.visible),
		      expression: "visible"
		    }],
		    staticClass: "el-alert",
		    class: [_vm.typeClass]
		  }, [(_vm.showIcon) ? _c('i', {
		    staticClass: "el-alert__icon",
		    class: [_vm.iconClass, _vm.isBigIcon]
		  }) : _vm._e(), _c('div', {
		    staticClass: "el-alert__content"
		  }, [(_vm.title) ? _c('span', {
		    staticClass: "el-alert__title",
		    class: [_vm.isBoldTitle]
		  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._t("default", [(_vm.description) ? _c('p', {
		    staticClass: "el-alert__description"
		  }, [_vm._v(_vm._s(_vm.description))]) : _vm._e()]), _c('i', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.closable),
		      expression: "closable"
		    }],
		    staticClass: "el-alert__closebtn",
		    class: {
		      'is-customed': _vm.closeText !== '', 'el-icon-close': _vm.closeText === ''
		    },
		    on: {
		      "click": function($event) {
		        _vm.close()
		      }
		    }
		  }, [_vm._v(_vm._s(_vm.closeText))])], 2)])])
		},staticRenderFns: []}
	
	/***/ },
	/* 237 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _main = __webpack_require__(238);
	
		var _main2 = _interopRequireDefault(_main);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _main2.default;
	
	/***/ },
	/* 238 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _vue = __webpack_require__(126);
	
		var _vue2 = _interopRequireDefault(_vue);
	
		var _popup = __webpack_require__(13);
	
		var _vdom = __webpack_require__(239);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var NotificationConstructor = _vue2.default.extend(__webpack_require__(240));
	
		var instance = void 0;
		var instances = [];
		var seed = 1;
	
		var Notification = function Notification(options) {
		  if (_vue2.default.prototype.$isServer) return;
		  options = options || {};
		  var userOnClose = options.onClose;
		  var id = 'notification_' + seed++;
	
		  options.onClose = function () {
		    Notification.close(id, userOnClose);
		  };
	
		  instance = new NotificationConstructor({
		    data: options
		  });
	
		  if ((0, _vdom.isVNode)(options.message)) {
		    instance.$slots.default = [options.message];
		    options.message = '';
		  }
		  instance.id = id;
		  instance.vm = instance.$mount();
		  document.body.appendChild(instance.vm.$el);
		  instance.vm.visible = true;
		  instance.dom = instance.vm.$el;
		  instance.dom.style.zIndex = _popup.PopupManager.nextZIndex();
	
		  var offset = options.offset || 0;
		  var topDist = offset;
		  for (var i = 0, len = instances.length; i < len; i++) {
		    topDist += instances[i].$el.offsetHeight + 16;
		  }
		  topDist += 16;
		  instance.top = topDist;
		  instances.push(instance);
		  return instance.vm;
		};
	
		['success', 'warning', 'info', 'error'].forEach(function (type) {
		  Notification[type] = function (options) {
		    if (typeof options === 'string' || (0, _vdom.isVNode)(options)) {
		      options = {
		        message: options
		      };
		    }
		    options.type = type;
		    return Notification(options);
		  };
		});
	
		Notification.close = function (id, userOnClose) {
		  var index = void 0;
		  var removedHeight = void 0;
		  for (var i = 0, len = instances.length; i < len; i++) {
		    if (id === instances[i].id) {
		      if (typeof userOnClose === 'function') {
		        userOnClose(instances[i]);
		      }
		      index = i;
		      removedHeight = instances[i].dom.offsetHeight;
		      instances.splice(i, 1);
		      break;
		    }
		  }
	
		  if (len > 1) {
		    for (i = index; i < len - 1; i++) {
		      instances[i].dom.style.top = parseInt(instances[i].dom.style.top, 10) - removedHeight - 16 + 'px';
		    }
		  }
		};
	
		exports.default = Notification;
	
	/***/ },
	/* 239 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(422);
	
	/***/ },
	/* 240 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(241)
	
		/* template */
		var __vue_template__ = __webpack_require__(242)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 241 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		var typeMap = {
		  success: 'circle-check',
		  info: 'information',
		  warning: 'warning',
		  error: 'circle-cross'
		};
	
		exports.default = {
		  data: function data() {
		    return {
		      visible: false,
		      title: '',
		      message: '',
		      duration: 4500,
		      type: '',
		      customClass: '',
		      iconClass: '',
		      onClose: null,
		      closed: false,
		      top: null,
		      timer: null
		    };
		  },
	
	
		  computed: {
		    typeClass: function typeClass() {
		      return this.type && typeMap[this.type] ? 'el-icon-' + typeMap[this.type] : '';
		    }
		  },
	
		  watch: {
		    closed: function closed(newVal) {
		      if (newVal) {
		        this.visible = false;
		        this.$el.addEventListener('transitionend', this.destroyElement);
		      }
		    }
		  },
	
		  methods: {
		    destroyElement: function destroyElement() {
		      this.$el.removeEventListener('transitionend', this.destroyElement);
		      this.$destroy(true);
		      this.$el.parentNode.removeChild(this.$el);
		    },
		    close: function close() {
		      this.closed = true;
		      if (typeof this.onClose === 'function') {
		        this.onClose();
		      }
		    },
		    clearTimer: function clearTimer() {
		      clearTimeout(this.timer);
		    },
		    startTimer: function startTimer() {
		      var _this = this;
	
		      if (this.duration > 0) {
		        this.timer = setTimeout(function () {
		          if (!_this.closed) {
		            _this.close();
		          }
		        }, this.duration);
		      }
		    }
		  },
	
		  mounted: function mounted() {
		    var _this2 = this;
	
		    if (this.duration > 0) {
		      this.timer = setTimeout(function () {
		        if (!_this2.closed) {
		          _this2.close();
		        }
		      }, this.duration);
		    }
		  }
		};
	
	/***/ },
	/* 242 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('transition', {
		    attrs: {
		      "name": "el-notification-fade"
		    }
		  }, [_c('div', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.visible),
		      expression: "visible"
		    }],
		    staticClass: "el-notification",
		    class: _vm.customClass,
		    style: ({
		      top: _vm.top ? _vm.top + 'px' : 'auto'
		    }),
		    on: {
		      "mouseenter": function($event) {
		        _vm.clearTimer()
		      },
		      "mouseleave": function($event) {
		        _vm.startTimer()
		      }
		    }
		  }, [(_vm.type || _vm.iconClass) ? _c('i', {
		    staticClass: "el-notification__icon",
		    class: [_vm.typeClass, _vm.iconClass]
		  }) : _vm._e(), _c('div', {
		    staticClass: "el-notification__group",
		    class: {
		      'is-with-icon': _vm.typeClass || _vm.iconClass
		    }
		  }, [_c('h2', {
		    staticClass: "el-notification__title",
		    domProps: {
		      "textContent": _vm._s(_vm.title)
		    }
		  }), _c('div', {
		    staticClass: "el-notification__content"
		  }, [_vm._t("default", [_vm._v(_vm._s(_vm.message))])], 2), _c('div', {
		    staticClass: "el-notification__closeBtn el-icon-close",
		    on: {
		      "click": _vm.close
		    }
		  })])])])
		},staticRenderFns: []}
	
	/***/ },
	/* 243 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _main = __webpack_require__(244);
	
		var _main2 = _interopRequireDefault(_main);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_main2.default.install = function (Vue) {
		  Vue.component(_main2.default.name, _main2.default);
		};
	
		exports.default = _main2.default;
	
	/***/ },
	/* 244 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(245)
	
		/* template */
		var __vue_template__ = __webpack_require__(248)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 245 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _inputNumber = __webpack_require__(246);
	
		var _inputNumber2 = _interopRequireDefault(_inputNumber);
	
		var _tooltip = __webpack_require__(247);
	
		var _tooltip2 = _interopRequireDefault(_tooltip);
	
		var _dom = __webpack_require__(66);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  name: 'ElSlider',
	
		  props: {
		    min: {
		      type: Number,
		      default: 0
		    },
		    max: {
		      type: Number,
		      default: 100
		    },
		    step: {
		      type: Number,
		      default: 1
		    },
		    defaultValue: {
		      type: Number,
		      default: 0
		    },
		    value: {
		      type: Number,
		      default: 0
		    },
		    showInput: {
		      type: Boolean,
		      default: false
		    },
		    showInputControls: {
		      type: Boolean,
		      default: true
		    },
		    showStops: {
		      type: Boolean,
		      default: false
		    },
		    disabled: {
		      type: Boolean,
		      default: false
		    }
		  },
	
		  components: {
		    ElInputNumber: _inputNumber2.default,
		    ElTooltip: _tooltip2.default
		  },
	
		  data: function data() {
		    return {
		      precision: 0,
		      inputValue: null,
		      timeout: null,
		      hovering: false,
		      dragging: false,
		      startX: 0,
		      currentX: 0,
		      startPos: 0,
		      newPos: null,
		      oldValue: this.value,
		      currentPosition: (this.value - this.min) / (this.max - this.min) * 100 + '%'
		    };
		  },
	
	
		  watch: {
		    inputValue: function inputValue(val) {
		      this.$emit('input', Number(val));
		    },
		    value: function value(val) {
		      var _this = this;
	
		      this.$nextTick(function () {
		        _this.updatePopper();
		      });
		      if (typeof val !== 'number' || isNaN(val) || val < this.min) {
		        this.$emit('input', this.min);
		        return;
		      }
		      if (val > this.max) {
		        this.$emit('input', this.max);
		        return;
		      }
		      this.inputValue = val;
		      this.setPosition((val - this.min) * 100 / (this.max - this.min));
		    }
		  },
	
		  methods: {
		    handleMouseEnter: function handleMouseEnter() {
		      this.hovering = true;
		      this.$refs.tooltip.showPopper = true;
		    },
		    handleMouseLeave: function handleMouseLeave() {
		      this.hovering = false;
		      this.$refs.tooltip.showPopper = false;
		    },
		    updatePopper: function updatePopper() {
		      this.$refs.tooltip.updatePopper();
		    },
		    setPosition: function setPosition(newPos) {
		      if (newPos < 0) {
		        newPos = 0;
		      } else if (newPos > 100) {
		        newPos = 100;
		      }
	
		      var lengthPerStep = 100 / ((this.max - this.min) / this.step);
		      var steps = Math.round(newPos / lengthPerStep);
		      var value = steps * lengthPerStep * (this.max - this.min) * 0.01 + this.min;
		      value = parseFloat(value.toFixed(this.precision));
		      this.$emit('input', value);
		      this.currentPosition = (this.value - this.min) / (this.max - this.min) * 100 + '%';
		      if (!this.dragging) {
		        if (this.value !== this.oldValue) {
		          this.$emit('change', this.value);
		          this.oldValue = this.value;
		        }
		      }
		    },
		    onSliderClick: function onSliderClick(event) {
		      if (this.disabled || this.dragging) return;
		      var sliderOffsetLeft = this.$refs.slider.getBoundingClientRect().left;
		      this.setPosition((event.clientX - sliderOffsetLeft) / this.$sliderWidth * 100);
		    },
		    onInputChange: function onInputChange() {
		      if (this.value === '') {
		        return;
		      }
		      if (!isNaN(this.value)) {
		        this.setPosition((this.value - this.min) * 100 / (this.max - this.min));
		      }
		    },
		    onDragStart: function onDragStart(event) {
		      this.dragging = true;
		      this.startX = event.clientX;
		      this.startPos = parseInt(this.currentPosition, 10);
		    },
		    onDragging: function onDragging(event) {
		      if (this.dragging) {
		        this.$refs.tooltip.showPopper = true;
		        this.currentX = event.clientX;
		        var diff = (this.currentX - this.startX) / this.$sliderWidth * 100;
		        this.newPos = this.startPos + diff;
		        this.setPosition(this.newPos);
		      }
		    },
		    onDragEnd: function onDragEnd() {
		      var _this2 = this;
	
		      if (this.dragging) {
		        /*
		         * 防止在 mouseup 后立即触发 click，导致滑块有几率产生一小段位移
		         * 不使用 preventDefault 是因为 mouseup 和 click 没有注册在同一个 DOM 上
		         */
		        setTimeout(function () {
		          _this2.dragging = false;
		          _this2.$refs.tooltip.showPopper = false;
		          _this2.setPosition(_this2.newPos);
		        }, 0);
		        window.removeEventListener('mousemove', this.onDragging);
		        window.removeEventListener('mouseup', this.onDragEnd);
		        window.removeEventListener('contextmenu', this.onDragEnd);
		      }
		    },
		    onButtonDown: function onButtonDown(event) {
		      if (this.disabled) return;
		      this.onDragStart(event);
		      window.addEventListener('mousemove', this.onDragging);
		      window.addEventListener('mouseup', this.onDragEnd);
		      window.addEventListener('contextmenu', this.onDragEnd);
		    }
		  },
	
		  computed: {
		    $sliderWidth: function $sliderWidth() {
		      return parseInt((0, _dom.getStyle)(this.$refs.slider, 'width'), 10);
		    },
		    stops: function stops() {
		      var stopCount = (this.max - this.value) / this.step;
		      var currentLeft = parseFloat(this.currentPosition);
		      var stepWidth = 100 * this.step / (this.max - this.min);
		      var result = [];
		      for (var i = 1; i < stopCount; i++) {
		        result.push(currentLeft + i * stepWidth);
		      }
		      return result;
		    }
		  },
	
		  created: function created() {
		    if (typeof this.value !== 'number' || isNaN(this.value) || this.value < this.min) {
		      this.$emit('input', this.min);
		    } else if (this.value > this.max) {
		      this.$emit('input', this.max);
		    }
		    var precisions = [this.min, this.max, this.step].map(function (item) {
		      var decimal = ('' + item).split('.')[1];
		      return decimal ? decimal.length : 0;
		    });
		    this.precision = Math.max.apply(null, precisions);
		    this.inputValue = this.inputValue || this.value;
		  }
		}; //
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
	/***/ },
	/* 246 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(410);
	
	/***/ },
	/* 247 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(417);
	
	/***/ },
	/* 248 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    staticClass: "el-slider"
		  }, [(_vm.showInput) ? _c('el-input-number', {
		    directives: [{
		      name: "model",
		      rawName: "v-model",
		      value: (_vm.inputValue),
		      expression: "inputValue"
		    }],
		    ref: "input",
		    staticClass: "el-slider__input",
		    attrs: {
		      "step": _vm.step,
		      "disabled": _vm.disabled,
		      "controls": _vm.showInputControls,
		      "min": _vm.min,
		      "max": _vm.max,
		      "size": "small"
		    },
		    domProps: {
		      "value": (_vm.inputValue)
		    },
		    on: {
		      "input": function($event) {
		        _vm.inputValue = $event
		      }
		    },
		    nativeOn: {
		      "keyup": function($event) {
		        _vm.onInputChange($event)
		      }
		    }
		  }) : _vm._e(), _c('div', {
		    ref: "slider",
		    staticClass: "el-slider__runway",
		    class: {
		      'show-input': _vm.showInput, 'disabled': _vm.disabled
		    },
		    on: {
		      "click": _vm.onSliderClick
		    }
		  }, [_c('div', {
		    staticClass: "el-slider__bar",
		    style: ({
		      width: _vm.currentPosition
		    })
		  }), _c('div', {
		    ref: "button",
		    staticClass: "el-slider__button-wrapper",
		    class: {
		      'hover': _vm.hovering, 'dragging': _vm.dragging
		    },
		    style: ({
		      left: _vm.currentPosition
		    }),
		    on: {
		      "mouseenter": _vm.handleMouseEnter,
		      "mouseleave": _vm.handleMouseLeave,
		      "mousedown": _vm.onButtonDown
		    }
		  }, [_c('el-tooltip', {
		    ref: "tooltip",
		    attrs: {
		      "placement": "top"
		    }
		  }, [_c('span', {
		    slot: "content"
		  }, [_vm._v(_vm._s(_vm.value))]), _c('div', {
		    staticClass: "el-slider__button",
		    class: {
		      'hover': _vm.hovering, 'dragging': _vm.dragging
		    }
		  })])], 1), _vm._l((_vm.stops), function(item) {
		    return (_vm.showStops) ? _c('div', {
		      staticClass: "el-slider__stop",
		      style: ({
		        'left': item + '%'
		      })
		    }) : _vm._e()
		  })], 2)], 1)
		},staticRenderFns: []}
	
	/***/ },
	/* 249 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _directive = __webpack_require__(250);
	
		var _directive2 = _interopRequireDefault(_directive);
	
		var _index = __webpack_require__(254);
	
		var _index2 = _interopRequireDefault(_index);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  install: function install(Vue) {
		    Vue.use(_directive2.default);
		    Vue.prototype.$loading = _index2.default;
		  },
	
		  directive: _directive2.default,
		  service: _index2.default
		};
	
	/***/ },
	/* 250 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _vue = __webpack_require__(126);
	
		var _vue2 = _interopRequireDefault(_vue);
	
		var _dom = __webpack_require__(66);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var Mask = _vue2.default.extend(__webpack_require__(251));
	
		exports.install = function (Vue) {
		  if (Vue.prototype.$isServer) return;
		  var toggleLoading = function toggleLoading(el, binding) {
		    if (binding.value) {
		      Vue.nextTick(function () {
		        if (binding.modifiers.fullscreen) {
		          el.originalPosition = document.body.style.position;
		          el.originalOverflow = document.body.style.overflow;
	
		          (0, _dom.addClass)(el.mask, 'is-fullscreen');
		          insertDom(document.body, el, binding);
		        } else {
		          (0, _dom.removeClass)(el.mask, 'is-fullscreen');
	
		          if (binding.modifiers.body) {
		            el.originalPosition = document.body.style.position;
	
		            ['top', 'left'].forEach(function (property) {
		              var scroll = property === 'top' ? 'scrollTop' : 'scrollLeft';
		              el.maskStyle[property] = el.getBoundingClientRect()[property] + document.body[scroll] + document.documentElement[scroll] + 'px';
		            });
		            ['height', 'width'].forEach(function (property) {
		              el.maskStyle[property] = el.getBoundingClientRect()[property] + 'px';
		            });
	
		            insertDom(document.body, el, binding);
		          } else {
		            el.originalPosition = el.style.position;
		            insertDom(el, el, binding);
		          }
		        }
		      });
		    } else {
		      if (el.domVisible) {
		        el.instance.$on('after-leave', function (_) {
		          el.domVisible = false;
		          if (binding.modifiers.fullscreen && el.originalOverflow !== 'hidden') {
		            document.body.style.overflow = el.originalOverflow;
		          }
		          if (binding.modifiers.fullscreen || binding.modifiers.body) {
		            document.body.style.position = el.originalPosition;
		          } else {
		            el.style.position = el.originalPosition;
		          }
		        });
		        el.instance.visible = false;
		      }
		    }
		  };
		  var insertDom = function insertDom(parent, el, binding) {
		    if (!el.domVisible) {
		      Object.keys(el.maskStyle).forEach(function (property) {
		        el.mask.style[property] = el.maskStyle[property];
		      });
	
		      if (el.originalPosition !== 'absolute') {
		        parent.style.position = 'relative';
		      }
		      if (binding.modifiers.fullscreen && binding.modifiers.lock) {
		        parent.style.overflow = 'hidden';
		      }
		      el.domVisible = true;
	
		      parent.appendChild(el.mask);
		      Vue.nextTick(function () {
		        el.instance.visible = true;
		      });
		      el.domInserted = true;
		    }
		  };
	
		  Vue.directive('loading', {
		    bind: function bind(el, binding) {
		      var mask = new Mask({
		        el: document.createElement('div'),
		        data: {
		          text: el.getAttribute('element-loading-text'),
		          fullscreen: !!binding.modifiers.fullscreen
		        }
		      });
		      el.instance = mask;
		      el.mask = mask.$el;
		      el.maskStyle = {};
	
		      toggleLoading(el, binding);
		    },
	
		    update: function update(el, binding) {
		      if (binding.oldValue !== binding.value) {
		        toggleLoading(el, binding);
		      }
		    },
	
		    unbind: function unbind(el, binding) {
		      if (el.domInserted) {
		        if (binding.modifiers.fullscreen || binding.modifiers.body) {
		          document.body.removeChild(el.mask);
		        } else {
		          el.mask && el.mask.parentNode && el.mask.parentNode.removeChild(el.mask);
		        }
		      }
		    }
		  });
		};
	
	/***/ },
	/* 251 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(252)
	
		/* template */
		var __vue_template__ = __webpack_require__(253)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 252 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  data: function data() {
		    return {
		      text: null,
		      fullscreen: true,
		      visible: false,
		      customClass: ''
		    };
		  },
	
	
		  methods: {
		    handleAfterLeave: function handleAfterLeave() {
		      this.$emit('after-leave');
		    }
		  }
		};
	
	/***/ },
	/* 253 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('transition', {
		    attrs: {
		      "name": "el-loading-fade"
		    },
		    on: {
		      "after-leave": _vm.handleAfterLeave
		    }
		  }, [_c('div', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.visible),
		      expression: "visible"
		    }],
		    staticClass: "el-loading-mask",
		    class: [_vm.customClass, {
		      'is-fullscreen': _vm.fullscreen
		    }]
		  }, [_c('div', {
		    staticClass: "el-loading-spinner"
		  }, [_c('svg', {
		    staticClass: "circular",
		    attrs: {
		      "viewBox": "25 25 50 50"
		    }
		  }, [_c('circle', {
		    staticClass: "path",
		    attrs: {
		      "cx": "50",
		      "cy": "50",
		      "r": "20",
		      "fill": "none"
		    }
		  })]), (_vm.text) ? _c('p', {
		    staticClass: "el-loading-text"
		  }, [_vm._v(_vm._s(_vm.text))]) : _vm._e()])])])
		},staticRenderFns: []}
	
	/***/ },
	/* 254 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _vue = __webpack_require__(126);
	
		var _vue2 = _interopRequireDefault(_vue);
	
		var _loading = __webpack_require__(251);
	
		var _loading2 = _interopRequireDefault(_loading);
	
		var _merge = __webpack_require__(61);
	
		var _merge2 = _interopRequireDefault(_merge);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var LoadingConstructor = _vue2.default.extend(_loading2.default);
	
		var defaults = {
		  text: null,
		  fullscreen: true,
		  body: false,
		  lock: false,
		  customClass: ''
		};
	
		var fullscreenLoading = void 0;
	
		LoadingConstructor.prototype.originalPosition = '';
		LoadingConstructor.prototype.originalOverflow = '';
	
		LoadingConstructor.prototype.close = function () {
		  var _this = this;
	
		  if (this.fullscreen && this.originalOverflow !== 'hidden') {
		    document.body.style.overflow = this.originalOverflow;
		  }
		  if (this.fullscreen || this.body) {
		    document.body.style.position = this.originalPosition;
		  } else {
		    this.target.style.position = this.originalPosition;
		  }
		  if (this.fullscreen) {
		    fullscreenLoading = undefined;
		  }
		  this.$on('after-leave', function (_) {
		    _this.$el && _this.$el.parentNode && _this.$el.parentNode.removeChild(_this.$el);
		    _this.$destroy();
		  });
		  this.visible = false;
		};
	
		var addStyle = function addStyle(options, parent, instance) {
		  var maskStyle = {};
		  if (options.fullscreen) {
		    instance.originalPosition = document.body.style.position;
		    instance.originalOverflow = document.body.style.overflow;
		  } else if (options.body) {
		    instance.originalPosition = document.body.style.position;
		    ['top', 'left'].forEach(function (property) {
		      var scroll = property === 'top' ? 'scrollTop' : 'scrollLeft';
		      maskStyle[property] = options.target.getBoundingClientRect()[property] + document.body[scroll] + document.documentElement[scroll] + 'px';
		    });
		    ['height', 'width'].forEach(function (property) {
		      maskStyle[property] = options.target.getBoundingClientRect()[property] + 'px';
		    });
		  } else {
		    instance.originalPosition = parent.style.position;
		  }
		  Object.keys(maskStyle).forEach(function (property) {
		    instance.$el.style[property] = maskStyle[property];
		  });
		};
	
		var Loading = function Loading() {
		  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
		  if (_vue2.default.prototype.$isServer) return;
		  options = (0, _merge2.default)({}, defaults, options);
		  if (typeof options.target === 'string') {
		    options.target = document.querySelector(options.target);
		  }
		  options.target = options.target || document.body;
		  if (options.target !== document.body) {
		    options.fullscreen = false;
		  } else {
		    options.body = true;
		  }
		  if (options.fullscreen && fullscreenLoading) {
		    return fullscreenLoading;
		  }
	
		  var parent = options.body ? document.body : options.target;
		  var instance = new LoadingConstructor({
		    el: document.createElement('div'),
		    data: options
		  });
	
		  addStyle(options, parent, instance);
		  if (instance.originalPosition !== 'absolute') {
		    parent.style.position = 'relative';
		  }
		  if (options.fullscreen && options.lock) {
		    parent.style.overflow = 'hidden';
		  }
		  parent.appendChild(instance.$el);
		  _vue2.default.nextTick(function () {
		    instance.visible = true;
		  });
		  if (options.fullscreen) {
		    fullscreenLoading = instance;
		  }
		  return instance;
		};
	
		exports.default = Loading;
	
	/***/ },
	/* 255 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _icon = __webpack_require__(256);
	
		var _icon2 = _interopRequireDefault(_icon);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_icon2.default.install = function (Vue) {
		  Vue.component(_icon2.default.name, _icon2.default);
		};
	
		exports.default = _icon2.default;
	
	/***/ },
	/* 256 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(257)
	
		/* template */
		var __vue_template__ = __webpack_require__(258)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 257 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		//
		//
		//
		//
	
		exports.default = {
		  name: 'ElIcon',
	
		  props: {
		    name: String
		  }
		};
	
	/***/ },
	/* 258 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('i', {
		    class: 'el-icon-' + _vm.name
		  })
		},staticRenderFns: []}
	
	/***/ },
	/* 259 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _row = __webpack_require__(260);
	
		var _row2 = _interopRequireDefault(_row);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_row2.default.install = function (Vue) {
		  Vue.component(_row2.default.name, _row2.default);
		};
	
		exports.default = _row2.default;
	
	/***/ },
	/* 260 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(261)
	
		/* template */
		var __vue_template__ = __webpack_require__(262)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 261 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  name: 'ElRow',
	
		  props: {
		    gutter: Number,
		    type: String,
		    justify: {
		      type: String,
		      default: 'start'
		    },
		    align: {
		      type: String,
		      default: 'top'
		    }
		  },
	
		  computed: {
		    style: function style() {
		      var ret = {};
	
		      if (this.gutter) {
		        ret.marginLeft = '-' + this.gutter / 2 + 'px';
		        ret.marginRight = ret.marginLeft;
		      }
	
		      return ret;
		    }
		  }
		};
	
	/***/ },
	/* 262 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    staticClass: "el-row",
		    class: [
		      _vm.justify !== 'start' ? 'is-justify-' + _vm.justify : '',
		      _vm.align !== 'top' ? 'is-align-' + _vm.align : '', {
		        'el-row--flex': _vm.type === 'flex'
		      }
		    ],
		    style: (_vm.style)
		  }, [_vm._t("default")], 2)
		},staticRenderFns: []}
	
	/***/ },
	/* 263 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _col = __webpack_require__(264);
	
		var _col2 = _interopRequireDefault(_col);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_col2.default.install = function (Vue) {
		  Vue.component(_col2.default.name, _col2.default);
		};
	
		exports.default = _col2.default;
	
	/***/ },
	/* 264 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		exports.default = {
		  name: 'ElCol',
	
		  props: {
		    span: {
		      type: Number,
		      default: 24
		    },
		    offset: Number,
		    pull: Number,
		    push: Number,
		    xs: [Number, Object],
		    sm: [Number, Object],
		    md: [Number, Object],
		    lg: [Number, Object]
		  },
	
		  computed: {
		    gutter: function gutter() {
		      return this.$parent.gutter;
		    },
		    style: function style() {
		      var ret = {};
	
		      if (this.gutter) {
		        ret.paddingLeft = this.gutter / 2 + 'px';
		        ret.paddingRight = ret.paddingLeft;
		      }
	
		      return ret;
		    }
		  },
		  render: function render(h) {
		    var _this = this;
	
		    var style = this.style;
	
		    var classList = [];
	
		    ['span', 'offset', 'pull', 'push'].forEach(function (prop) {
		      if (_this[prop]) {
		        classList.push(prop !== 'span' ? 'el-col-' + prop + '-' + _this[prop] : 'el-col-' + _this[prop]);
		      }
		    });
	
		    ['xs', 'sm', 'md', 'lg'].forEach(function (size) {
		      if (typeof _this[size] === 'number') {
		        classList.push('el-col-' + size + '-' + _this[size]);
		      } else if (_typeof(_this[size]) === 'object') {
		        (function () {
		          var props = _this[size];
		          Object.keys(props).forEach(function (prop) {
		            classList.push(prop !== 'span' ? 'el-col-' + size + '-' + prop + '-' + props[prop] : 'el-col-' + size + '-' + props[prop]);
		          });
		        })();
		      }
		    });
	
		    return h(
		      'div',
		      {
		        'class': ['el-col', classList],
		        style: style },
		      [this.$slots.default]
		    );
		  }
		};
	
	/***/ },
	/* 265 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _src = __webpack_require__(266);
	
		var _src2 = _interopRequireDefault(_src);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_src2.default.install = function (Vue) {
		  Vue.component(_src2.default.name, _src2.default);
		};
	
		exports.default = _src2.default;
	
	/***/ },
	/* 266 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(267)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 267 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _uploadList = __webpack_require__(268);
	
		var _uploadList2 = _interopRequireDefault(_uploadList);
	
		var _upload = __webpack_require__(272);
	
		var _upload2 = _interopRequireDefault(_upload);
	
		var _iframeUpload = __webpack_require__(279);
	
		var _iframeUpload2 = _interopRequireDefault(_iframeUpload);
	
		var _progress = __webpack_require__(270);
	
		var _progress2 = _interopRequireDefault(_progress);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function noop() {}
	
		exports.default = {
		  name: 'ElUpload',
	
		  components: {
		    ElProgress: _progress2.default,
		    UploadList: _uploadList2.default,
		    Upload: _upload2.default,
		    IframeUpload: _iframeUpload2.default
		  },
	
		  props: {
		    action: {
		      type: String,
		      required: true
		    },
		    headers: {
		      type: Object,
		      default: function _default() {
		        return {};
		      }
		    },
		    data: Object,
		    multiple: Boolean,
		    name: {
		      type: String,
		      default: 'file'
		    },
		    withCredentials: Boolean,
		    thumbnailMode: Boolean,
		    showUploadList: {
		      type: Boolean,
		      default: true
		    },
		    accept: String,
		    type: {
		      type: String,
		      default: 'select'
		    },
		    beforeUpload: Function,
		    onRemove: {
		      type: Function,
		      default: noop
		    },
		    onChange: {
		      type: Function,
		      default: noop
		    },
		    onPreview: {
		      type: Function,
		      default: noop
		    },
		    onSuccess: {
		      type: Function,
		      default: noop
		    },
		    onProgress: {
		      type: Function,
		      default: noop
		    },
		    onError: {
		      type: Function,
		      default: noop
		    },
		    defaultFileList: {
		      type: Array,
		      default: function _default() {
		        return [];
		      }
		    }
		  },
	
		  data: function data() {
		    return {
		      fileList: [],
		      dragOver: false,
		      draging: false,
		      tempIndex: 1
		    };
		  },
	
	
		  watch: {
		    defaultFileList: {
		      immediate: true,
		      handler: function handler(fileList) {
		        var _this = this;
	
		        this.fileList = fileList.map(function (item) {
		          item.status = 'finished';
		          item.percentage = 100;
		          item.uid = Date.now() + _this.tempIndex++;
		          return item;
		        });
		      }
		    }
		  },
	
		  methods: {
		    handleStart: function handleStart(file) {
		      file.uid = Date.now() + this.tempIndex++;
		      var _file = {
		        status: 'uploading',
		        name: file.name,
		        size: file.size,
		        percentage: 0,
		        uid: file.uid,
		        showProgress: true
		      };
	
		      try {
		        _file.url = URL.createObjectURL(file);
		      } catch (err) {
		        console.error(err);
		        return;
		      }
	
		      this.fileList.push(_file);
		    },
		    handleProgress: function handleProgress(ev, file) {
		      var _file = this.getFile(file);
		      this.onProgress(ev, _file, this.fileList);
		      _file.percentage = ev.percent || 0;
		    },
		    handleSuccess: function handleSuccess(res, file) {
		      var _file = this.getFile(file);
	
		      if (_file) {
		        _file.status = 'finished';
		        _file.response = res;
	
		        this.onSuccess(res, _file, this.fileList);
	
		        setTimeout(function () {
		          _file.showProgress = false;
		        }, 1000);
		      }
		    },
		    handleError: function handleError(err, response, file) {
		      var _file = this.getFile(file);
		      var fileList = this.fileList;
	
		      _file.status = 'fail';
	
		      fileList.splice(fileList.indexOf(_file), 1);
	
		      this.onError(err, response, file);
		    },
		    handleRemove: function handleRemove(file) {
		      var fileList = this.fileList;
		      fileList.splice(fileList.indexOf(file), 1);
		      this.onRemove(file, fileList);
		    },
		    getFile: function getFile(file) {
		      var fileList = this.fileList;
		      var target;
		      fileList.every(function (item) {
		        target = file.uid === item.uid ? item : null;
		        return !target;
		      });
		      return target;
		    },
		    handlePreview: function handlePreview(file) {
		      if (file.status === 'finished') {
		        this.onPreview(file);
		      }
		    },
		    clearFiles: function clearFiles() {
		      this.fileList = [];
		    }
		  },
	
		  render: function render(h) {
		    var uploadList;
	
		    if (this.showUploadList && !this.thumbnailMode && this.fileList.length) {
		      uploadList = h(
		        _uploadList2.default,
		        {
		          attrs: {
		            files: this.fileList
		          },
		          on: {
		            'remove': this.handleRemove,
		            'preview': this.handlePreview
		          }
		        },
		        []
		      );
		    }
	
		    var props = {
		      props: {
		        type: this.type,
		        action: this.action,
		        multiple: this.multiple,
		        'before-upload': this.beforeUpload,
		        'with-credentials': this.withCredentials,
		        headers: this.headers,
		        name: this.name,
		        data: this.data,
		        accept: this.thumbnailMode ? 'image/gif, image/png, image/jpeg, image/bmp, image/webp' : this.accept,
		        'on-start': this.handleStart,
		        'on-progress': this.handleProgress,
		        'on-success': this.handleSuccess,
		        'on-error': this.handleError,
		        'on-preview': this.handlePreview,
		        'on-remove': this.handleRemove
		      },
		      ref: 'upload-inner'
		    };
	
		    var uploadComponent = typeof FormData !== 'undefined' || this.$isServer ? h(
		      'upload',
		      props,
		      [this.$slots.default]
		    ) : h(
		      'iframeUpload',
		      props,
		      [this.$slots.default]
		    );
	
		    if (this.type === 'select') {
		      return h(
		        'div',
		        { 'class': 'el-upload' },
		        [uploadList, uploadComponent, this.$slots.tip]
		      );
		    }
	
		    if (this.type === 'drag') {
		      return h(
		        'div',
		        { 'class': 'el-upload' },
		        [uploadComponent, this.$slots.tip, uploadList]
		      );
		    }
		  }
		};
	
	/***/ },
	/* 268 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(269)
	
		/* template */
		var __vue_template__ = __webpack_require__(271)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 269 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _locale = __webpack_require__(9);
	
		var _locale2 = _interopRequireDefault(_locale);
	
		var _progress = __webpack_require__(270);
	
		var _progress2 = _interopRequireDefault(_progress);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  mixins: [_locale2.default],
	
		  components: { ElProgress: _progress2.default },
	
		  props: {
		    files: {
		      type: Array,
		      default: function _default() {
		        return [];
		      }
		    }
		  },
		  methods: {
		    parsePercentage: function parsePercentage(val) {
		      return parseInt(val, 10);
		    }
		  }
		};
	
	/***/ },
	/* 270 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(415);
	
	/***/ },
	/* 271 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('transition-group', {
		    staticClass: "el-upload__files",
		    attrs: {
		      "tag": "ul",
		      "name": "list"
		    }
		  }, _vm._l((_vm.files), function(file) {
		    return _c('li', {
		      key: file,
		      staticClass: "el-upload__file",
		      class: {
		        'is-finished': file.status === 'finished'
		      },
		      on: {
		        "click": function($event) {
		          _vm.$emit('clickFile', file)
		        }
		      }
		    }, [_c('a', {
		      staticClass: "el-upload__file__name",
		      on: {
		        "click": function($event) {
		          _vm.$emit('preview', file)
		        }
		      }
		    }, [_c('i', {
		      staticClass: "el-icon-document"
		    }), _vm._v(_vm._s(file.name) + "\n    ")]), _c('span', {
		      directives: [{
		        name: "show",
		        rawName: "v-show",
		        value: (file.status === 'finished'),
		        expression: "file.status === 'finished'"
		      }],
		      staticClass: "el-upload__btn-delete",
		      on: {
		        "click": function($event) {
		          _vm.$emit('remove', file)
		        }
		      }
		    }, [_vm._v(_vm._s(_vm.t('el.upload.delete')))]), (file.showProgress) ? _c('el-progress', {
		      attrs: {
		        "stroke-width": 2,
		        "percentage": _vm.parsePercentage(file.percentage),
		        "status": file.status === 'finished' && file.showProgress ? 'success' : ''
		      }
		    }) : _vm._e()], 1)
		  }))
		},staticRenderFns: []}
	
	/***/ },
	/* 272 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(273)
	
		/* template */
		var __vue_template__ = __webpack_require__(278)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 273 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _ajax = __webpack_require__(274);
	
		var _ajax2 = _interopRequireDefault(_ajax);
	
		var _cover = __webpack_require__(275);
	
		var _cover2 = _interopRequireDefault(_cover);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  components: {
		    Cover: _cover2.default
		  },
		  props: {
		    type: String,
		    action: {
		      type: String,
		      required: true
		    },
		    name: {
		      type: String,
		      default: 'file'
		    },
		    data: Object,
		    headers: Object,
		    withCredentials: Boolean,
		    multiple: Boolean,
		    accept: String,
		    onStart: Function,
		    onProgress: Function,
		    onSuccess: Function,
		    onError: Function,
		    beforeUpload: Function,
		    onPreview: {
		      type: Function,
		      default: function _default() {}
		    },
		    onRemove: {
		      type: Function,
		      default: function _default() {}
		    }
		  },
	
		  data: function data() {
		    return {
		      dragOver: false,
		      mouseover: false
		    };
		  },
	
	
		  computed: {
		    lastestFile: function lastestFile() {
		      var fileList = this.$parent.fileList;
		      return fileList[fileList.length - 1];
		    },
		    showCover: function showCover() {
		      var file = this.lastestFile;
		      return this.thumbnailMode && file && file.status !== 'fail';
		    },
		    thumbnailMode: function thumbnailMode() {
		      return this.$parent.thumbnailMode;
		    }
		  },
	
		  methods: {
		    isImage: function isImage(str) {
		      return str.indexOf('image') !== -1;
		    },
		    handleChange: function handleChange(ev) {
		      var files = ev.target.files;
	
		      if (!files) {
		        return;
		      }
		      this.uploadFiles(files);
		      this.$refs.input.value = null;
		    },
		    uploadFiles: function uploadFiles(files) {
		      var _this = this;
	
		      var postFiles = Array.prototype.slice.call(files);
		      if (!this.multiple) {
		        postFiles = postFiles.slice(0, 1);
		      }
	
		      if (postFiles.length === 0) {
		        return;
		      }
	
		      postFiles.forEach(function (file) {
		        var isImage = _this.isImage(file.type);
	
		        if (_this.thumbnailMode && !isImage) {
		          return;
		        } else {
		          _this.upload(file);
		        }
		      });
		    },
		    upload: function upload(file) {
		      var _this2 = this;
	
		      if (!this.beforeUpload) {
		        return this.post(file);
		      }
	
		      var before = this.beforeUpload(file);
		      if (before && before.then) {
		        before.then(function (processedFile) {
		          if (Object.prototype.toString.call(processedFile) === '[object File]') {
		            _this2.post(processedFile);
		          } else {
		            _this2.post(file);
		          }
		        }, function () {
		          // this.$emit('cancel', file);
		        });
		      } else if (before !== false) {
		        this.post(file);
		      } else {
		        // this.$emit('cancel', file);
		      }
		    },
		    post: function post(file) {
		      var _this3 = this;
	
		      this.onStart(file);
		      var formData = new FormData();
		      formData.append(this.name, file);
	
		      (0, _ajax2.default)({
		        headers: this.headers,
		        withCredentials: this.withCredentials,
		        file: file,
		        data: this.data,
		        filename: this.name,
		        action: this.action,
		        onProgress: function onProgress(e) {
		          _this3.onProgress(e, file);
		        },
		        onSuccess: function onSuccess(res) {
		          _this3.onSuccess(res, file);
		        },
		        onError: function onError(err, response) {
		          _this3.onError(err, response, file);
		        }
		      });
		    },
		    onDrop: function onDrop(e) {
		      this.dragOver = false;
		      this.uploadFiles(e.dataTransfer.files);
		    },
		    handleClick: function handleClick() {
		      this.$refs.input.click();
		    }
		  }
		};
	
	/***/ },
	/* 274 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.default = upload;
		function getError(action, option, xhr) {
		  var msg = 'fail to post ' + action + ' ' + xhr.status + '\'';
		  var err = new Error(msg);
		  err.status = xhr.status;
		  err.method = 'post';
		  err.url = action;
		  return err;
		}
	
		function getBody(xhr) {
		  var text = xhr.responseText || xhr.response;
		  if (!text) {
		    return text;
		  }
	
		  try {
		    return JSON.parse(text);
		  } catch (e) {
		    return text;
		  }
		}
	
		function upload(option) {
		  if (typeof XMLHttpRequest === 'undefined') {
		    return;
		  }
	
		  var xhr = new XMLHttpRequest();
		  var action = option.action;
	
		  if (xhr.upload) {
		    xhr.upload.onprogress = function progress(e) {
		      if (e.total > 0) {
		        e.percent = e.loaded / e.total * 100;
		      }
		      option.onProgress(e);
		    };
		  }
	
		  var formData = new FormData();
	
		  if (option.data) {
		    Object.keys(option.data).map(function (key) {
		      formData.append(key, option.data[key]);
		    });
		  }
	
		  formData.append(option.filename, option.file);
	
		  xhr.onerror = function error(e) {
		    option.onError(e);
		  };
	
		  xhr.onload = function onload() {
		    if (xhr.status < 200 || xhr.status >= 300) {
		      return option.onError(getError(action, option, xhr), getBody(xhr));
		    }
	
		    option.onSuccess(getBody(xhr));
		  };
	
		  xhr.open('post', action, true);
	
		  if (option.withCredentials && 'withCredentials' in xhr) {
		    xhr.withCredentials = true;
		  }
	
		  var headers = option.headers || {};
	
		  // if (headers['X-Requested-With'] !== null) {
		  //   xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
		  // }
	
		  for (var item in headers) {
		    if (headers.hasOwnProperty(item) && headers[item] !== null) {
		      xhr.setRequestHeader(item, headers[item]);
		    }
		  }
		  xhr.send(formData);
		}
	
	/***/ },
	/* 275 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(276)
	
		/* template */
		var __vue_template__ = __webpack_require__(277)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 276 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _locale = __webpack_require__(9);
	
		var _locale2 = _interopRequireDefault(_locale);
	
		var _progress = __webpack_require__(270);
	
		var _progress2 = _interopRequireDefault(_progress);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  mixins: [_locale2.default],
	
		  components: { ElProgress: _progress2.default },
	
		  props: {
		    image: {},
		    onPreview: {
		      type: Function,
		      default: function _default() {}
		    },
		    onRemove: {
		      type: Function,
		      default: function _default() {}
		    }
		  },
		  data: function data() {
		    return {
		      mouseover: false
		    };
		  }
		};
	
	/***/ },
	/* 277 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return (_vm.image) ? _c('div', {
		    staticClass: "el-dragger__cover",
		    on: {
		      "click": function($event) {
		        $event.stopPropagation();
		      }
		    }
		  }, [_c('transition', {
		    attrs: {
		      "name": "el-fade-in"
		    }
		  }, [(_vm.image.status === 'uploading') ? _c('el-progress', {
		    staticClass: "el-dragger__cover__progress",
		    attrs: {
		      "percentage": _vm.image.percentage,
		      "show-text": false,
		      "status": _vm.image.status === 'finished' ? 'success' : ''
		    }
		  }) : _vm._e()], 1), (_vm.image.status === 'finished') ? _c('div', {
		    staticClass: "el-dragger__cover__content",
		    on: {
		      "mouseenter": function($event) {
		        _vm.mouseover = true
		      },
		      "mouseleave": function($event) {
		        _vm.mouseover = false
		      }
		    }
		  }, [_c('img', {
		    attrs: {
		      "src": _vm.image.url
		    }
		  }), _c('transition', {
		    attrs: {
		      "name": "el-fade-in"
		    }
		  }, [_c('div', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.mouseover),
		      expression: "mouseover"
		    }],
		    staticClass: "el-dragger__cover__interact"
		  }, [_c('div', {
		    staticClass: "el-draggeer__cover__btns"
		  }, [_c('span', {
		    staticClass: "btn",
		    on: {
		      "click": function($event) {
		        _vm.$parent.handleClick()
		      }
		    }
		  }, [_c('i', {
		    staticClass: "el-icon-upload2"
		  }), _c('span', [_vm._v(_vm._s(_vm.t('el.upload.continue')))])]), _c('span', {
		    staticClass: "btn",
		    on: {
		      "click": function($event) {
		        _vm.onPreview(_vm.image)
		      }
		    }
		  }, [_c('i', {
		    staticClass: "el-icon-view"
		  }), _c('span', [_vm._v(_vm._s(_vm.t('el.upload.preview')))])]), _c('span', {
		    staticClass: "btn",
		    on: {
		      "click": function($event) {
		        _vm.onRemove(_vm.image)
		      }
		    }
		  }, [_c('i', {
		    staticClass: "el-icon-delete2"
		  }), _c('span', [_vm._v(_vm._s(_vm.t('el.upload.delete')))])])])])]), _c('transition', {
		    attrs: {
		      "name": "el-zoom-in-bottom"
		    }
		  }, [_c('h4', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.mouseover),
		      expression: "mouseover"
		    }],
		    staticClass: "el-dragger__cover__title"
		  }, [_vm._v(_vm._s(_vm.image.name))])])], 1) : _vm._e()], 1) : _vm._e()
		},staticRenderFns: []}
	
	/***/ },
	/* 278 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    staticClass: "el-upload__inner",
		    class: {
		      'el-dragger': _vm.type === 'drag',
		        'is-dragOver': _vm.dragOver,
		        'is-showCover': _vm.showCover
		    },
		    on: {
		      "click": _vm.handleClick,
		      "drop": function($event) {
		        $event.preventDefault();
		        _vm.onDrop($event)
		      },
		      "dragover": function($event) {
		        $event.preventDefault();
		        _vm.dragOver = true
		      },
		      "dragleave": function($event) {
		        $event.preventDefault();
		        _vm.dragOver = false
		      }
		    }
		  }, [(!_vm.showCover) ? _vm._t("default") : _c('cover', {
		    attrs: {
		      "image": _vm.lastestFile,
		      "on-preview": _vm.onPreview,
		      "on-remove": _vm.onRemove
		    }
		  }), _c('input', {
		    ref: "input",
		    staticClass: "el-upload__input",
		    attrs: {
		      "type": "file",
		      "multiple": _vm.multiple,
		      "accept": _vm.accept
		    },
		    on: {
		      "change": _vm.handleChange
		    }
		  })], 2)
		},staticRenderFns: []}
	
	/***/ },
	/* 279 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(280)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 280 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _cover = __webpack_require__(275);
	
		var _cover2 = _interopRequireDefault(_cover);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  components: {
		    Cover: _cover2.default
		  },
		  props: {
		    type: String,
		    data: {},
		    action: {
		      type: String,
		      required: true
		    },
		    name: {
		      type: String,
		      default: 'file'
		    },
		    withCredentials: Boolean,
		    accept: String,
		    onStart: Function,
		    onProgress: Function,
		    onSuccess: Function,
		    onError: Function,
		    beforeUpload: Function,
		    onPreview: {
		      type: Function,
		      default: function _default() {}
		    },
		    onRemove: {
		      type: Function,
		      default: function _default() {}
		    }
		  },
	
		  data: function data() {
		    return {
		      dragOver: false,
		      mouseover: false,
		      domain: '',
		      file: null,
		      disabled: false
		    };
		  },
	
	
		  computed: {
		    lastestFile: function lastestFile() {
		      var fileList = this.$parent.fileList;
		      return fileList[fileList.length - 1];
		    },
		    showCover: function showCover() {
		      var file = this.lastestFile;
		      return this.thumbnailMode && file && file.status !== 'fail';
		    },
		    thumbnailMode: function thumbnailMode() {
		      return this.$parent.thumbnailMode;
		    }
		  },
	
		  methods: {
		    isImage: function isImage(str) {
		      return str.indexOf('image') !== -1;
		    },
		    handleClick: function handleClick() {
		      if (!this.disabled) {
		        this.$refs.input.click();
		      }
		    },
		    handleChange: function handleChange(ev) {
		      var file = ev.target.files[0];
		      this.file = file;
		      this.onStart(file);
	
		      var formNode = this.getFormNode();
		      var dataSpan = this.getFormDataNode();
		      var data = this.data;
		      if (typeof data === 'function') {
		        data = data(file);
		      }
		      var inputs = [];
		      for (var key in data) {
		        if (data.hasOwnProperty(key)) {
		          inputs.push('<input name="' + key + '" value="' + data[key] + '"/>');
		        }
		      }
		      dataSpan.innerHTML = inputs.join('');
		      formNode.submit();
		      dataSpan.innerHTML = '';
		      this.disabled = true;
		    },
		    getFormNode: function getFormNode() {
		      return this.$refs.form;
		    },
		    getFormDataNode: function getFormDataNode() {
		      return this.$refs.data;
		    },
		    onDrop: function onDrop(e) {
		      e.preventDefault();
		      this.dragOver = false;
		      this.uploadFiles(e.dataTransfer.files);
		    },
		    handleDragover: function handleDragover(e) {
		      e.preventDefault();
		      this.onDrop = true;
		    },
		    handleDragleave: function handleDragleave(e) {
		      e.preventDefault();
		      this.onDrop = false;
		    },
		    onload: function onload(e) {
		      this.disabled = false;
		    }
		  },
	
		  mounted: function mounted() {
		    var _this = this;
	
		    !this.$isServer && window.addEventListener('message', function (event) {
		      var targetOrigin = new URL(_this.action).origin;
		      if (event.origin !== targetOrigin) {
		        return false;
		      }
		      var response = event.data;
		      if (response.result === 'success') {
		        _this.onSuccess(response, _this.file);
		      } else if (response.result === 'failed') {
		        _this.onSuccess(response, _this.file);
		      }
		    }, false);
		  },
		  render: function render(h) {
		    var cover = h(
		      'cover',
		      {
		        attrs: { image: this.lastestFile },
		        on: {
		          'preview': this.onPreview,
		          'remove': this.onRemove
		        }
		      },
		      []
		    );
		    var frameName = 'frame-' + Date.now();
		    return h(
		      'div',
		      {
		        'class': {
		          'el-upload__inner': true,
		          'el-dragger': this.type === 'drag',
		          'is-dragOver': this.dragOver,
		          'is-showCover': this.showCover
		        },
		        on: {
		          'click': this.handleClick
		        },
		        nativeOn: {
		          'drop': this.onDrop,
		          'dragover': this.handleDragover,
		          'dragleave': this.handleDragleave
		        }
		      },
		      [h(
		        'iframe',
		        {
		          on: {
		            'load': this.onload
		          },
	
		          ref: 'iframe',
		          attrs: { name: frameName
		          }
		        },
		        []
		      ), h(
		        'form',
		        { ref: 'form', attrs: { action: this.action, target: frameName, enctype: 'multipart/form-data', method: 'POST' }
		        },
		        [h(
		          'input',
		          {
		            'class': 'el-upload__input',
		            attrs: { type: 'file',
	
		              name: 'file',
	
		              accept: this.accept },
		            ref: 'input', on: {
		              'change': this.handleChange
		            }
		          },
		          []
		        ), h(
		          'input',
		          {
		            attrs: { type: 'hidden', name: 'documentDomain', value: this.$isServer ? '' : document.domain }
		          },
		          []
		        ), h(
		          'span',
		          { ref: 'data' },
		          []
		        )]
		      ), !this.showCover ? this.$slots.default : cover]
		    );
		  }
		};
	
	/***/ },
	/* 281 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _progress = __webpack_require__(282);
	
		var _progress2 = _interopRequireDefault(_progress);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_progress2.default.install = function (Vue) {
		  Vue.component(_progress2.default.name, _progress2.default);
		};
	
		exports.default = _progress2.default;
	
	/***/ },
	/* 282 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(283)
	
		/* template */
		var __vue_template__ = __webpack_require__(284)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 283 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  name: 'ElProgress',
		  props: {
		    type: {
		      type: String,
		      default: 'line',
		      validator: function validator(val) {
		        return ['line', 'circle'].indexOf(val) > -1;
		      }
		    },
		    percentage: {
		      type: Number,
		      default: 0,
		      required: true,
		      validator: function validator(val) {
		        return val >= 0 && val <= 100;
		      }
		    },
		    status: {
		      type: String
		    },
		    strokeWidth: {
		      type: Number,
		      default: 6
		    },
		    textInside: {
		      type: Boolean,
		      default: false
		    },
		    width: {
		      type: Number,
		      default: 126
		    },
		    showText: {
		      type: Boolean,
		      default: true
		    }
		  },
		  computed: {
		    barStyle: function barStyle() {
		      var style = {};
		      style.width = this.percentage + '%';
		      return style;
		    },
		    relativeStrokeWidth: function relativeStrokeWidth() {
		      return (this.strokeWidth / this.width * 100).toFixed(1);
		    },
		    trackPath: function trackPath() {
		      var radius = parseInt(50 - parseFloat(this.relativeStrokeWidth) / 2, 10);
	
		      return 'M 50 50 m 0 -' + radius + ' a ' + radius + ' ' + radius + ' 0 1 1 0 ' + radius * 2 + ' a ' + radius + ' ' + radius + ' 0 1 1 0 -' + radius * 2;
		    },
		    perimeter: function perimeter() {
		      var radius = 50 - parseFloat(this.relativeStrokeWidth) / 2;
		      return 2 * Math.PI * radius;
		    },
		    circlePathStyle: function circlePathStyle() {
		      var perimeter = this.perimeter;
		      return {
		        strokeDasharray: perimeter + 'px,' + perimeter + 'px',
		        strokeDashoffset: (1 - this.percentage / 100) * perimeter + 'px',
		        transition: 'stroke-dashoffset 0.6s ease 0s, stroke 0.6s ease'
		      };
		    },
		    stroke: function stroke() {
		      var ret;
		      switch (this.status) {
		        case 'success':
		          ret = '#13ce66';
		          break;
		        case 'exception':
		          ret = '#ff4949';
		          break;
		        default:
		          ret = '#20a0ff';
		      }
		      return ret;
		    },
		    iconClass: function iconClass() {
		      if (this.type === 'line') {
		        return this.status === 'success' ? 'el-icon-circle-check' : 'el-icon-circle-cross';
		      } else {
		        return this.status === 'success' ? 'el-icon-check' : 'el-icon-close';
		      }
		    },
		    progressTextSize: function progressTextSize() {
		      return this.type === 'line' ? 12 + this.strokeWidth * 0.4 : this.width * 0.111111 + 2;
		    }
		  }
		};
	
	/***/ },
	/* 284 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    staticClass: "el-progress",
		    class: [
		      'el-progress--' + _vm.type,
		      _vm.status ? 'is-' + _vm.status : '', {
		        'el-progress--without-text': !_vm.showText,
		        'el-progress--text-inside': _vm.textInside,
		      }
		    ]
		  }, [(_vm.type === 'line') ? _c('div', {
		    staticClass: "el-progress-bar"
		  }, [_c('div', {
		    staticClass: "el-progress-bar__outer",
		    style: ({
		      height: _vm.strokeWidth + 'px'
		    })
		  }, [_c('div', {
		    staticClass: "el-progress-bar__inner",
		    style: (_vm.barStyle)
		  }, [(_vm.showText && _vm.textInside) ? _c('div', {
		    staticClass: "el-progress-bar__innerText"
		  }, [_vm._v(_vm._s(_vm.percentage) + "%")]) : _vm._e()])])]) : _c('div', {
		    staticClass: "el-progress-circle",
		    style: ({
		      height: _vm.width + 'px',
		      width: _vm.width + 'px'
		    })
		  }, [_c('svg', {
		    attrs: {
		      "viewBox": "0 0 100 100"
		    }
		  }, [_c('path', {
		    staticClass: "el-progress-circle__track",
		    attrs: {
		      "d": _vm.trackPath,
		      "stroke": "#e5e9f2",
		      "stroke-width": _vm.relativeStrokeWidth,
		      "fill": "none"
		    }
		  }), _c('path', {
		    staticClass: "el-progress-circle__path",
		    style: (_vm.circlePathStyle),
		    attrs: {
		      "d": _vm.trackPath,
		      "stroke-linecap": "round",
		      "stroke": _vm.stroke,
		      "stroke-width": _vm.relativeStrokeWidth,
		      "fill": "none"
		    }
		  })])]), (_vm.showText && !_vm.textInside) ? _c('div', {
		    staticClass: "el-progress__text",
		    style: ({
		      fontSize: _vm.progressTextSize + 'px'
		    })
		  }, [(!_vm.status) ? [_vm._v(_vm._s(_vm.percentage) + "%")] : _c('i', {
		    class: _vm.iconClass
		  })], 2) : _vm._e()])
		},staticRenderFns: []}
	
	/***/ },
	/* 285 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _spinner = __webpack_require__(286);
	
		var _spinner2 = _interopRequireDefault(_spinner);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_spinner2.default.install = function (Vue) {
		  Vue.component(_spinner2.default.name, _spinner2.default);
		};
	
		exports.default = _spinner2.default;
	
	/***/ },
	/* 286 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(287)
	
		/* template */
		var __vue_template__ = __webpack_require__(288)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 287 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  name: 'ElSpinner',
		  props: {
		    type: String,
		    radius: {
		      type: Number,
		      default: 100
		    },
		    strokeWidth: {
		      type: Number,
		      default: 5
		    },
		    strokeColor: {
		      type: String,
		      default: '#efefef'
		    }
		  }
		};
	
	/***/ },
	/* 288 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('span', {
		    staticClass: "el-spinner"
		  }, [_c('svg', {
		    staticClass: "el-spinner-inner",
		    style: ({
		      width: _vm.radius / 2 + 'px',
		      height: _vm.radius / 2 + 'px'
		    }),
		    attrs: {
		      "viewBox": "0 0 50 50"
		    }
		  }, [_c('circle', {
		    staticClass: "path",
		    attrs: {
		      "cx": "25",
		      "cy": "25",
		      "r": "20",
		      "fill": "none",
		      "stroke": _vm.strokeColor,
		      "stroke-width": _vm.strokeWidth
		    }
		  })])])
		},staticRenderFns: []}
	
	/***/ },
	/* 289 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _main = __webpack_require__(290);
	
		var _main2 = _interopRequireDefault(_main);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = _main2.default;
	
	/***/ },
	/* 290 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _vue = __webpack_require__(126);
	
		var _vue2 = _interopRequireDefault(_vue);
	
		var _popup = __webpack_require__(13);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var MessageConstructor = _vue2.default.extend(__webpack_require__(291));
	
		var instance = void 0;
		var instances = [];
		var seed = 1;
	
		var Message = function Message(options) {
		  if (_vue2.default.prototype.$isServer) return;
		  options = options || {};
		  if (typeof options === 'string') {
		    options = {
		      message: options
		    };
		  }
		  var userOnClose = options.onClose;
		  var id = 'message_' + seed++;
	
		  options.onClose = function () {
		    Message.close(id, userOnClose);
		  };
	
		  instance = new MessageConstructor({
		    data: options
		  });
		  instance.id = id;
		  instance.vm = instance.$mount();
		  document.body.appendChild(instance.vm.$el);
		  instance.vm.visible = true;
		  instance.dom = instance.vm.$el;
		  instance.dom.style.zIndex = _popup.PopupManager.nextZIndex();
		  instances.push(instance);
		  return instance.vm;
		};
	
		['success', 'warning', 'info', 'error'].forEach(function (type) {
		  Message[type] = function (options) {
		    if (typeof options === 'string') {
		      options = {
		        message: options
		      };
		    }
		    options.type = type;
		    return Message(options);
		  };
		});
	
		Message.close = function (id, userOnClose) {
		  for (var i = 0, len = instances.length; i < len; i++) {
		    if (id === instances[i].id) {
		      if (typeof userOnClose === 'function') {
		        userOnClose(instances[i]);
		      }
		      instances.splice(i, 1);
		      break;
		    }
		  }
		};
	
		exports.default = Message;
	
	/***/ },
	/* 291 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(292)
	
		/* template */
		var __vue_template__ = __webpack_require__(298)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 292 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  data: function data() {
		    return {
		      visible: false,
		      message: '',
		      duration: 3000,
		      type: 'info',
		      iconClass: '',
		      customClass: '',
		      onClose: null,
		      showClose: false,
		      closed: false,
		      timer: null
		    };
		  },
	
	
		  computed: {
		    typeImg: function typeImg() {
		      return __webpack_require__(293)("./" + this.type + '.svg');
		    }
		  },
	
		  watch: {
		    closed: function closed(newVal) {
		      if (newVal) {
		        this.visible = false;
		        this.$el.addEventListener('transitionend', this.destroyElement);
		      }
		    }
		  },
	
		  methods: {
		    destroyElement: function destroyElement() {
		      this.$el.removeEventListener('transitionend', this.destroyElement);
		      this.$destroy(true);
		      this.$el.parentNode.removeChild(this.$el);
		    },
		    close: function close() {
		      this.closed = true;
		      if (typeof this.onClose === 'function') {
		        this.onClose(this);
		      }
		    },
		    clearTimer: function clearTimer() {
		      clearTimeout(this.timer);
		    },
		    startTimer: function startTimer() {
		      var _this = this;
	
		      if (this.duration > 0) {
		        this.timer = setTimeout(function () {
		          if (!_this.closed) {
		            _this.close();
		          }
		        }, this.duration);
		      }
		    }
		  },
	
		  mounted: function mounted() {
		    this.startTimer();
		  }
		};
	
	/***/ },
	/* 293 */
	/***/ function(module, exports, __webpack_require__) {
	
		var map = {
			"./error.svg": 294,
			"./info.svg": 295,
			"./success.svg": 296,
			"./warning.svg": 297
		};
		function webpackContext(req) {
			return __webpack_require__(webpackContextResolve(req));
		};
		function webpackContextResolve(req) {
			return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
		};
		webpackContext.keys = function webpackContextKeys() {
			return Object.keys(map);
		};
		webpackContext.resolve = webpackContextResolve;
		module.exports = webpackContext;
		webpackContext.id = 293;
	
	
	/***/ },
	/* 294 */
	/***/ function(module, exports) {
	
		module.exports = "data:image/svg+xml;base64,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"
	
	/***/ },
	/* 295 */
	/***/ function(module, exports) {
	
		module.exports = "data:image/svg+xml;base64,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"
	
	/***/ },
	/* 296 */
	/***/ function(module, exports) {
	
		module.exports = "data:image/svg+xml;base64,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"
	
	/***/ },
	/* 297 */
	/***/ function(module, exports) {
	
		module.exports = "data:image/svg+xml;base64,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"
	
	/***/ },
	/* 298 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('transition', {
		    attrs: {
		      "name": "el-message-fade"
		    }
		  }, [_c('div', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.visible),
		      expression: "visible"
		    }],
		    staticClass: "el-message",
		    class: _vm.customClass,
		    on: {
		      "mouseenter": _vm.clearTimer,
		      "mouseleave": _vm.startTimer
		    }
		  }, [(!_vm.iconClass) ? _c('img', {
		    staticClass: "el-message__img",
		    attrs: {
		      "src": _vm.typeImg,
		      "alt": ""
		    }
		  }) : _vm._e(), _c('div', {
		    staticClass: "el-message__group",
		    class: {
		      'is-with-icon': _vm.iconClass
		    }
		  }, [(_vm.iconClass) ? _c('i', {
		    staticClass: "el-message__icon",
		    class: _vm.iconClass
		  }) : _vm._e(), _c('p', [_vm._v(_vm._s(_vm.message))]), (_vm.showClose) ? _c('div', {
		    staticClass: "el-message__closeBtn el-icon-close",
		    on: {
		      "click": _vm.close
		    }
		  }) : _vm._e()])])])
		},staticRenderFns: []}
	
	/***/ },
	/* 299 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _main = __webpack_require__(300);
	
		var _main2 = _interopRequireDefault(_main);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_main2.default.install = function (Vue) {
		  Vue.component(_main2.default.name, _main2.default);
		};
	
		exports.default = _main2.default;
	
	/***/ },
	/* 300 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(301)
	
		/* template */
		var __vue_template__ = __webpack_require__(302)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 301 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  name: 'ElBadge',
	
		  props: {
		    value: {},
		    max: Number,
		    isDot: Boolean,
		    hidden: Boolean
		  },
	
		  computed: {
		    content: function content() {
		      if (this.isDot) return;
	
		      var value = this.value;
		      var max = this.max;
	
		      if (typeof value === 'number' && typeof max === 'number') {
		        return max < value ? max + '+' : value;
		      }
	
		      return value;
		    }
		  }
		};
	
	/***/ },
	/* 302 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    staticClass: "el-badge"
		  }, [_vm._t("default"), _c('transition', {
		    attrs: {
		      "name": "el-zoom-in-center"
		    }
		  }, [_c('sup', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (!_vm.hidden),
		      expression: "!hidden"
		    }],
		    staticClass: "el-badge__content",
		    class: {
		      'is-fixed': _vm.$slots.default, 'is-dot': _vm.isDot
		    },
		    domProps: {
		      "textContent": _vm._s(_vm.content)
		    }
		  })])], 2)
		},staticRenderFns: []}
	
	/***/ },
	/* 303 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _main = __webpack_require__(304);
	
		var _main2 = _interopRequireDefault(_main);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_main2.default.install = function (Vue) {
		  Vue.component(_main2.default.name, _main2.default);
		};
	
		exports.default = _main2.default;
	
	/***/ },
	/* 304 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(305)
	
		/* template */
		var __vue_template__ = __webpack_require__(306)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 305 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  name: 'ElCard',
	
		  props: ['header', 'bodyStyle']
		};
	
	/***/ },
	/* 306 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    staticClass: "el-card"
		  }, [(_vm.$slots.header || _vm.header) ? _c('div', {
		    staticClass: "el-card__header"
		  }, [_vm._t("header", [_vm._v(_vm._s(_vm.header))])], 2) : _vm._e(), _c('div', {
		    staticClass: "el-card__body",
		    style: (_vm.bodyStyle)
		  }, [_vm._t("default")], 2)])
		},staticRenderFns: []}
	
	/***/ },
	/* 307 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _main = __webpack_require__(308);
	
		var _main2 = _interopRequireDefault(_main);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_main2.default.install = function (Vue) {
		  Vue.component(_main2.default.name, _main2.default);
		};
	
		exports.default = _main2.default;
	
	/***/ },
	/* 308 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(309)
	
		/* template */
		var __vue_template__ = __webpack_require__(310)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 309 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _dom = __webpack_require__(66);
	
		exports.default = {
		  name: 'ElRate',
	
		  data: function data() {
		    return {
		      classMap: {},
		      colorMap: {},
		      pointerAtLeftHalf: false,
		      currentValue: this.value,
		      hoverIndex: -1
		    };
		  },
	
	
		  props: {
		    value: {
		      type: Number,
		      default: 0
		    },
		    lowThreshold: {
		      type: Number,
		      default: 2
		    },
		    highThreshold: {
		      type: Number,
		      default: 4
		    },
		    max: {
		      type: Number,
		      default: 5
		    },
		    colors: {
		      type: Array,
		      default: function _default() {
		        return ['#F7BA2A', '#F7BA2A', '#F7BA2A'];
		      }
		    },
		    voidColor: {
		      type: String,
		      default: '#C6D1DE'
		    },
		    disabledVoidColor: {
		      type: String,
		      default: '#EFF2F7'
		    },
		    iconClasses: {
		      type: Array,
		      default: function _default() {
		        return ['el-icon-star-on', 'el-icon-star-on', 'el-icon-star-on'];
		      }
		    },
		    voidIconClass: {
		      type: String,
		      default: 'el-icon-star-off'
		    },
		    disabledVoidIconClass: {
		      type: String,
		      default: 'el-icon-star-on'
		    },
		    disabled: {
		      type: Boolean,
		      default: false
		    },
		    allowHalf: {
		      type: Boolean,
		      default: false
		    },
		    showText: {
		      type: Boolean,
		      default: false
		    },
		    textColor: {
		      type: String,
		      default: '1f2d3d'
		    },
		    texts: {
		      type: Array,
		      default: function _default() {
		        return ['极差', '失望', '一般', '满意', '惊喜'];
		      }
		    },
		    textTemplate: {
		      type: String,
		      default: '{value}'
		    }
		  },
	
		  computed: {
		    text: function text() {
		      var result = '';
		      if (this.disabled) {
		        result = this.textTemplate.replace(/\{\s*value\s*\}/, this.value);
		      } else {
		        result = this.texts[Math.ceil(this.currentValue) - 1];
		      }
		      return result;
		    },
		    decimalStyle: function decimalStyle() {
		      var width = '';
		      if (this.disabled) {
		        width = (this.valueDecimal < 50 ? 0 : 50) + '%';
		      }
		      if (this.allowHalf) {
		        width = '50%';
		      }
		      return {
		        color: this.activeColor,
		        width: width
		      };
		    },
		    valueDecimal: function valueDecimal() {
		      return this.value * 100 - Math.floor(this.value) * 100;
		    },
		    decimalIconClass: function decimalIconClass() {
		      return this.getValueFromMap(this.value, this.classMap);
		    },
		    voidClass: function voidClass() {
		      return this.disabled ? this.classMap.disabledVoidClass : this.classMap.voidClass;
		    },
		    activeClass: function activeClass() {
		      return this.getValueFromMap(this.currentValue, this.classMap);
		    },
		    activeColor: function activeColor() {
		      return this.getValueFromMap(this.currentValue, this.colorMap);
		    },
		    classes: function classes() {
		      var result = [];
		      var i = 0;
		      var threshold = this.currentValue;
		      if (this.allowHalf && this.currentValue !== Math.floor(this.currentValue)) {
		        threshold--;
		      }
		      for (; i < threshold; i++) {
		        result.push(this.activeClass);
		      }
		      for (; i < this.max; i++) {
		        result.push(this.voidClass);
		      }
		      return result;
		    }
		  },
	
		  watch: {
		    value: function value(val) {
		      this.$emit('change', val);
		      this.currentValue = val;
		    }
		  },
	
		  methods: {
		    getValueFromMap: function getValueFromMap(value, map) {
		      var result = '';
		      if (value <= this.lowThreshold) {
		        result = map.lowColor || map.lowClass;
		      } else if (value >= this.highThreshold) {
		        result = map.highColor || map.highClass;
		      } else {
		        result = map.mediumColor || map.mediumClass;
		      }
		      return result;
		    },
		    showDecimalIcon: function showDecimalIcon(item) {
		      var showWhenDisabled = this.disabled && this.valueDecimal > 0 && item - 1 < this.value && item > this.value;
		      /* istanbul ignore next */
		      var showWhenAllowHalf = this.allowHalf && this.pointerAtLeftHalf && (item - 0.5).toFixed(1) === this.currentValue.toFixed(1);
		      return showWhenDisabled || showWhenAllowHalf;
		    },
		    getIconStyle: function getIconStyle(item) {
		      var voidColor = this.disabled ? this.colorMap.disabledVoidColor : this.colorMap.voidColor;
		      return {
		        color: item <= this.currentValue ? this.activeColor : voidColor
		      };
		    },
		    selectValue: function selectValue(value) {
		      if (this.disabled) {
		        return;
		      }
		      if (this.allowHalf && this.pointerAtLeftHalf) {
		        this.$emit('input', this.currentValue);
		      } else {
		        this.$emit('input', value);
		      }
		    },
		    setCurrentValue: function setCurrentValue(value, event) {
		      if (this.disabled) {
		        return;
		      }
		      /* istanbul ignore if */
		      if (this.allowHalf) {
		        var target = event.target;
		        if ((0, _dom.hasClass)(target, 'el-rate__item')) {
		          target = target.querySelector('.el-rate__icon');
		        }
		        if ((0, _dom.hasClass)(target, 'el-rate__decimal')) {
		          target = target.parentNode;
		        }
		        this.pointerAtLeftHalf = event.offsetX * 2 <= target.clientWidth;
		        this.currentValue = this.pointerAtLeftHalf ? value - 0.5 : value;
		      } else {
		        this.currentValue = value;
		      }
		      this.hoverIndex = value;
		    },
		    resetCurrentValue: function resetCurrentValue() {
		      if (this.disabled) {
		        return;
		      }
		      if (this.allowHalf) {
		        this.pointerAtLeftHalf = this.value !== Math.floor(this.value);
		      }
		      this.currentValue = this.value;
		      this.hoverIndex = -1;
		    }
		  },
	
		  created: function created() {
		    if (!this.value) {
		      this.$emit('input', 0);
		    }
		    this.classMap = {
		      lowClass: this.iconClasses[0],
		      mediumClass: this.iconClasses[1],
		      highClass: this.iconClasses[2],
		      voidClass: this.voidIconClass,
		      disabledVoidClass: this.disabledVoidIconClass
		    };
		    this.colorMap = {
		      lowColor: this.colors[0],
		      mediumColor: this.colors[1],
		      highColor: this.colors[2],
		      voidColor: this.voidColor,
		      disabledVoidColor: this.disabledVoidColor
		    };
		  }
		}; //
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
	/***/ },
	/* 310 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    staticClass: "el-rate"
		  }, [_vm._l((_vm.max), function(item) {
		    return _c('span', {
		      staticClass: "el-rate__item",
		      style: ({
		        cursor: _vm.disabled ? 'auto' : 'pointer'
		      }),
		      on: {
		        "mousemove": function($event) {
		          _vm.setCurrentValue(item, $event)
		        },
		        "mouseleave": _vm.resetCurrentValue,
		        "click": function($event) {
		          _vm.selectValue(item)
		        }
		      }
		    }, [_c('i', {
		      staticClass: "el-rate__icon",
		      class: [_vm.classes[item - 1], {
		        'hover': _vm.hoverIndex === item
		      }],
		      style: (_vm.getIconStyle(item))
		    }, [(_vm.showDecimalIcon(item)) ? _c('i', {
		      staticClass: "el-rate__decimal",
		      class: _vm.decimalIconClass,
		      style: (_vm.decimalStyle)
		    }) : _vm._e()])])
		  }), (_vm.showText) ? _c('span', {
		    staticClass: "el-rate__text",
		    style: ({
		      color: _vm.textColor
		    })
		  }, [_vm._v(_vm._s(_vm.text))]) : _vm._e()], 2)
		},staticRenderFns: []}
	
	/***/ },
	/* 311 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _steps = __webpack_require__(312);
	
		var _steps2 = _interopRequireDefault(_steps);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_steps2.default.install = function (Vue) {
		  Vue.component(_steps2.default.name, _steps2.default);
		};
	
		exports.default = _steps2.default;
	
	/***/ },
	/* 312 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(313)
	
		/* template */
		var __vue_template__ = __webpack_require__(314)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 313 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  name: 'ElSteps',
	
		  props: {
		    space: Number,
		    active: Number,
		    direction: {
		      type: String,
		      default: 'horizontal'
		    },
		    alignCenter: Boolean,
		    center: Boolean,
		    finishStatus: {
		      type: String,
		      default: 'finish'
		    },
		    processStatus: {
		      type: String,
		      default: 'process'
		    }
		  },
	
		  data: function data() {
		    return {
		      steps: [],
		      stepOffset: 0
		    };
		  },
	
	
		  watch: {
		    active: function active(newVal, oldVal) {
		      this.$emit('change', newVal, oldVal);
		    }
		  },
	
		  mounted: function mounted() {
		    this.steps.forEach(function (child, index) {
		      child.index = index;
		    });
		  }
		};
	
	/***/ },
	/* 314 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    staticClass: "el-steps",
		    class: ['is-' + _vm.direction, _vm.center ? 'is-center' : '']
		  }, [_vm._t("default")], 2)
		},staticRenderFns: []}
	
	/***/ },
	/* 315 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _step = __webpack_require__(316);
	
		var _step2 = _interopRequireDefault(_step);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_step2.default.install = function (Vue) {
		  Vue.component(_step2.default.name, _step2.default);
		};
	
		exports.default = _step2.default;
	
	/***/ },
	/* 316 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(317)
	
		/* template */
		var __vue_template__ = __webpack_require__(318)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 317 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  name: 'ElStep',
	
		  props: {
		    title: String,
		    icon: String,
		    description: String,
		    status: {
		      type: String,
		      default: 'wait'
		    }
		  },
	
		  data: function data() {
		    return {
		      index: -1,
		      style: {},
		      lineStyle: {},
		      mainOffset: 0,
		      isLast: false,
		      currentStatus: this.status
		    };
		  },
		  created: function created() {
		    this.$parent.steps.push(this);
		  },
	
	
		  methods: {
		    updateStatus: function updateStatus(val) {
		      var prevChild = this.$parent.$children[this.index - 1];
	
		      if (val > this.index) {
		        this.currentStatus = this.$parent.finishStatus;
		      } else if (val === this.index) {
		        this.currentStatus = this.$parent.processStatus;
		      } else {
		        this.currentStatus = 'wait';
		      }
	
		      if (prevChild) prevChild.calcProgress(this.currentStatus);
		    },
		    calcProgress: function calcProgress(status) {
		      var step = 100;
		      var style = {};
	
		      style.transitionDelay = 150 * this.index + 'ms';
		      if (status === this.$parent.processStatus) {
		        step = 50;
		      } else if (status === 'wait') {
		        step = 0;
		        style.transitionDelay = -150 * this.index + 'ms';
		      }
	
		      this.$parent.direction === 'vertical' ? style.height = step + '%' : style.width = step + '%';
	
		      this.lineStyle = style;
		    },
		    adjustPosition: function adjustPosition() {
		      this.style = {};
		      this.$parent.stepOffset = this.$el.getBoundingClientRect().width / (this.$parent.steps.length - 1);
		    }
		  },
	
		  mounted: function mounted() {
		    var _this = this;
	
		    var parent = this.$parent;
		    var isCenter = parent.center;
		    var len = parent.steps.length;
		    var isLast = this.isLast = parent.steps[parent.steps.length - 1] === this;
		    var space = parent.space ? parent.space + 'px' : 100 / (isCenter ? len - 1 : len) + '%';
	
		    if (parent.direction === 'horizontal') {
		      this.style = { width: space };
		      if (parent.alignCenter) {
		        this.mainOffset = -this.$refs.title.getBoundingClientRect().width / 2 + 16 + 'px';
		      }
		      isCenter && isLast && this.adjustPosition();
		    } else {
		      if (!isLast) {
		        this.style = { height: space };
		      }
		    }
	
		    var unwatch = this.$watch('index', function (val) {
		      _this.$watch('$parent.active', _this.updateStatus, { immediate: true });
		      unwatch();
		    });
		  }
		};
	
	/***/ },
	/* 318 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    staticClass: "el-step",
		    class: ['is-' + _vm.$parent.direction],
		    style: ([_vm.style, _vm.isLast ? '' : {
		      marginRight: -_vm.$parent.stepOffset + 'px'
		    }])
		  }, [_c('div', {
		    staticClass: "el-step__head",
		    class: ['is-' + _vm.currentStatus, {
		      'is-text': !_vm.icon
		    }]
		  }, [_c('div', {
		    staticClass: "el-step__line",
		    class: ['is-' + _vm.$parent.direction, {
		      'is-icon': _vm.icon
		    }],
		    style: (_vm.isLast ? '' : {
		      marginRight: _vm.$parent.stepOffset + 'px'
		    })
		  }, [_c('i', {
		    staticClass: "el-step__line-inner",
		    style: (_vm.lineStyle)
		  })]), _c('span', {
		    staticClass: "el-step__icon"
		  }, [(_vm.currentStatus !== 'success' && _vm.currentStatus !== 'error') ? _vm._t("icon", [(_vm.icon) ? _c('i', {
		    class: ['el-icon-' + _vm.icon]
		  }) : _c('div', [_vm._v(_vm._s(_vm.index + 1))])]) : _c('i', {
		    class: ['el-icon-' + (_vm.currentStatus === 'success' ? 'check' : 'close')]
		  })], 2)]), _c('div', {
		    staticClass: "el-step__main",
		    style: ({
		      marginLeft: _vm.mainOffset
		    })
		  }, [_c('div', {
		    ref: "title",
		    staticClass: "el-step__title",
		    class: ['is-' + _vm.currentStatus]
		  }, [_vm._t("title", [_vm._v(_vm._s(_vm.title))])], 2), _c('div', {
		    staticClass: "el-step__description",
		    class: ['is-' + _vm.currentStatus]
		  }, [_vm._t("description", [_vm._v(_vm._s(_vm.description))])], 2)])])
		},staticRenderFns: []}
	
	/***/ },
	/* 319 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _main = __webpack_require__(320);
	
		var _main2 = _interopRequireDefault(_main);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_main2.default.install = function (Vue) {
		  Vue.component(_main2.default.name, _main2.default);
		};
	
		exports.default = _main2.default;
	
	/***/ },
	/* 320 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(321)
	
		/* template */
		var __vue_template__ = __webpack_require__(322)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 321 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _throttle = __webpack_require__(124);
	
		var _throttle2 = _interopRequireDefault(_throttle);
	
		var _debounce = __webpack_require__(103);
	
		var _debounce2 = _interopRequireDefault(_debounce);
	
		var _resizeEvent = __webpack_require__(104);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  name: 'ElCarousel',
	
		  props: {
		    initialIndex: {
		      type: Number,
		      default: 0
		    },
		    height: String,
		    trigger: {
		      type: String,
		      default: 'hover'
		    },
		    autoplay: {
		      type: Boolean,
		      default: true
		    },
		    interval: {
		      type: Number,
		      default: 3000
		    },
		    indicatorPosition: String,
		    indicator: {
		      type: Boolean,
		      default: true
		    },
		    arrow: {
		      type: String,
		      default: 'hover'
		    },
		    type: String
		  },
	
		  data: function data() {
		    return {
		      items: [],
		      activeIndex: -1,
		      containerWidth: 0,
		      timer: null,
		      hover: false
		    };
		  },
	
	
		  watch: {
		    activeIndex: function activeIndex(val, oldVal) {
		      this.resetItemPosition();
		      this.$emit('change', val, oldVal);
		    }
		  },
	
		  methods: {
		    handleMouseEnter: function handleMouseEnter() {
		      this.hover = true;
		      this.pauseTimer();
		    },
		    handleMouseLeave: function handleMouseLeave() {
		      this.hover = false;
		      this.startTimer();
		    },
		    itemInStage: function itemInStage(item, index) {
		      var length = this.items.length;
		      if (index === length - 1 && item.inStage && this.items[0].active || item.inStage && this.items[index + 1] && this.items[index + 1].active) {
		        return 'left';
		      } else if (index === 0 && item.inStage && this.items[length - 1].active || item.inStage && this.items[index - 1] && this.items[index - 1].active) {
		        return 'right';
		      }
		      return false;
		    },
		    handleButtonEnter: function handleButtonEnter(arrow) {
		      var _this = this;
	
		      this.items.forEach(function (item, index) {
		        if (arrow === _this.itemInStage(item, index)) {
		          item.hover = true;
		        }
		      });
		    },
		    handleButtonLeave: function handleButtonLeave() {
		      this.items.forEach(function (item) {
		        item.hover = false;
		      });
		    },
		    handleItemChange: function handleItemChange() {
		      var _this2 = this;
	
		      (0, _debounce2.default)(100, function () {
		        _this2.updateItems();
		      });
		    },
		    updateItems: function updateItems() {
		      this.items = this.$children.filter(function (child) {
		        return child.$options.name === 'ElCarouselItem';
		      });
		    },
		    resetItemPosition: function resetItemPosition() {
		      var _this3 = this;
	
		      this.items.forEach(function (item, index) {
		        item.translateItem(index, _this3.activeIndex);
		      });
		    },
		    playSlides: function playSlides() {
		      if (this.activeIndex < this.items.length - 1) {
		        this.activeIndex++;
		      } else {
		        this.activeIndex = 0;
		      }
		    },
		    pauseTimer: function pauseTimer() {
		      clearInterval(this.timer);
		    },
		    startTimer: function startTimer() {
		      if (this.interval <= 0 || !this.autoplay) return;
		      this.timer = setInterval(this.playSlides, this.interval);
		    },
		    setActiveItem: function setActiveItem(index) {
		      if (typeof index === 'string') {
		        var filteredItems = this.items.filter(function (item) {
		          return item.name === index;
		        });
		        if (filteredItems.length > 0) {
		          index = this.items.indexOf(filteredItems[0]);
		        }
		      }
		      index = Number(index);
		      if (isNaN(index) || index !== Math.floor(index)) {
		        ("production") !== 'production' && console.warn('[Element Warn][Carousel]index must be an integer.');
		        return;
		      }
		      var length = this.items.length;
		      if (index < 0) {
		        this.activeIndex = length - 1;
		      } else if (index >= length) {
		        this.activeIndex = 0;
		      } else {
		        this.activeIndex = index;
		      }
		    },
		    prev: function prev() {
		      this.setActiveItem(this.activeIndex - 1);
		    },
		    next: function next() {
		      this.setActiveItem(this.activeIndex + 1);
		    },
		    handleIndicatorClick: function handleIndicatorClick(index) {
		      this.activeIndex = index;
		    },
		    handleIndicatorHover: function handleIndicatorHover(index) {
		      if (this.trigger === 'hover' && index !== this.activeIndex) {
		        this.activeIndex = index;
		      }
		    }
		  },
	
		  created: function created() {
		    var _this4 = this;
	
		    this.throttledArrowClick = (0, _throttle2.default)(300, true, function (index) {
		      _this4.setActiveItem(index);
		    });
		    this.throttledIndicatorHover = (0, _throttle2.default)(300, function (index) {
		      _this4.handleIndicatorHover(index);
		    });
		  },
		  mounted: function mounted() {
		    var _this5 = this;
	
		    this.updateItems();
		    this.$nextTick(function () {
		      (0, _resizeEvent.addResizeListener)(_this5.$el, _this5.resetItemPosition);
		      if (_this5.initialIndex < _this5.items.length && _this5.initialIndex >= 0) {
		        _this5.activeIndex = _this5.initialIndex;
		      }
		      _this5.startTimer();
		    });
		  },
		  beforeDestroy: function beforeDestroy() {
		    if (this.$el) (0, _resizeEvent.removeResizeListener)(this.$el, this.resetItemPosition);
		  }
		}; //
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
	/***/ },
	/* 322 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    staticClass: "el-carousel",
		    class: {
		      'el-carousel--card': _vm.type === 'card'
		    },
		    on: {
		      "mouseenter": function($event) {
		        $event.stopPropagation();
		        _vm.handleMouseEnter($event)
		      },
		      "mouseleave": function($event) {
		        $event.stopPropagation();
		        _vm.handleMouseLeave($event)
		      }
		    }
		  }, [_c('div', {
		    staticClass: "el-carousel__container",
		    style: ({
		      height: _vm.height
		    })
		  }, [_c('transition', {
		    attrs: {
		      "name": "carousel-arrow-left"
		    }
		  }, [(_vm.arrow !== 'never') ? _c('button', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.arrow === 'always' || _vm.hover),
		      expression: "arrow === 'always' || hover"
		    }],
		    staticClass: "el-carousel__arrow el-carousel__arrow--left",
		    on: {
		      "mouseenter": function($event) {
		        _vm.handleButtonEnter('left')
		      },
		      "mouseleave": _vm.handleButtonLeave,
		      "click": function($event) {
		        $event.stopPropagation();
		        _vm.throttledArrowClick(_vm.activeIndex - 1)
		      }
		    }
		  }, [_c('i', {
		    staticClass: "el-icon-arrow-left"
		  })]) : _vm._e()]), _c('transition', {
		    attrs: {
		      "name": "carousel-arrow-right"
		    }
		  }, [(_vm.arrow !== 'never') ? _c('button', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.arrow === 'always' || _vm.hover),
		      expression: "arrow === 'always' || hover"
		    }],
		    staticClass: "el-carousel__arrow el-carousel__arrow--right",
		    on: {
		      "mouseenter": function($event) {
		        _vm.handleButtonEnter('right')
		      },
		      "mouseleave": _vm.handleButtonLeave,
		      "click": function($event) {
		        $event.stopPropagation();
		        _vm.throttledArrowClick(_vm.activeIndex + 1)
		      }
		    }
		  }, [_c('i', {
		    staticClass: "el-icon-arrow-right"
		  })]) : _vm._e()]), _vm._t("default")], 2), (_vm.indicatorPosition !== 'none') ? _c('ul', {
		    staticClass: "el-carousel__indicators",
		    class: {
		      'el-carousel__indicators--outside': _vm.indicatorPosition === 'outside' || _vm.type === 'card'
		    }
		  }, _vm._l((_vm.items), function(item, index) {
		    return _c('li', {
		      staticClass: "el-carousel__indicator",
		      class: {
		        'is-active': index === _vm.activeIndex
		      },
		      on: {
		        "mouseenter": function($event) {
		          _vm.throttledIndicatorHover(index)
		        },
		        "click": function($event) {
		          $event.stopPropagation();
		          _vm.handleIndicatorClick(index)
		        }
		      }
		    }, [_c('button', {
		      staticClass: "el-carousel__button"
		    })])
		  })) : _vm._e()])
		},staticRenderFns: []}
	
	/***/ },
	/* 323 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _main = __webpack_require__(324);
	
		var _main2 = _interopRequireDefault(_main);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_main2.default.install = function (Vue) {
		  Vue.component(_main2.default.name, _main2.default);
		};
	
		exports.default = _main2.default;
	
	/***/ },
	/* 324 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _resizeEvent = __webpack_require__(104);
	
		var _scrollbarWidth = __webpack_require__(129);
	
		var _scrollbarWidth2 = _interopRequireDefault(_scrollbarWidth);
	
		var _util = __webpack_require__(325);
	
		var util = _interopRequireWildcard(_util);
	
		var _bar = __webpack_require__(326);
	
		var _bar2 = _interopRequireDefault(_bar);
	
		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		// reference https://github.com/noeldelgado/gemini-scrollbar/blob/master/index.js
	
		exports.default = {
		  name: 'ElScrollbar',
	
		  components: { Bar: _bar2.default },
	
		  props: {
		    native: Boolean,
		    wrapStyle: {},
		    wrapClass: {},
		    viewClass: {},
		    viewStyle: {},
		    noresize: Boolean, // 如果 container 尺寸不会发生变化，最好设置它可以优化性能
		    tag: {
		      type: String,
		      default: 'div'
		    }
		  },
	
		  data: function data() {
		    return {
		      sizeWidth: '0',
		      sizeHeight: '0',
		      moveX: 0,
		      moveY: 0
		    };
		  },
	
	
		  computed: {
		    wrap: function wrap() {
		      return this.$refs.wrap;
		    }
		  },
	
		  render: function render(h) {
		    var gutter = (0, _scrollbarWidth2.default)();
		    var style = this.wrapStyle;
	
		    if (gutter) {
		      var gutterWith = '-' + gutter + 'px';
	
		      if (Array.isArray(this.wrapStyle)) {
		        style = util.toObject(this.wrapStyle);
		        style.marginRight = style.marginBottom = gutterWith;
		      } else if (typeof this.wrapStyle === 'string') {
		        style += 'margin-bottom: ' + gutterWith + '; margin-right: ' + gutterWith + ';';
		      }
		    }
		    var view = h(this.tag, {
		      class: ['el-scrollbar__view', this.viewClass],
		      style: this.viewStyle,
		      ref: 'resize'
		    }, this.$slots.default);
		    var wrap = h(
		      'div',
		      {
		        ref: 'wrap',
		        style: style,
		        on: {
		          'scroll': this.handleScroll
		        },
	
		        'class': [this.wrapClass, 'el-scrollbar__wrap el-scrollbar__wrap--hidden-default'] },
		      [[view]]
		    );
		    var nodes = void 0;
	
		    if (!this.native) {
		      nodes = [wrap, h(
		        _bar2.default,
		        {
		          attrs: {
		            move: this.moveX,
		            size: this.sizeWidth }
		        },
		        []
		      ), h(
		        _bar2.default,
		        {
		          attrs: {
		            vertical: true,
		            move: this.moveY,
		            size: this.sizeHeight }
		        },
		        []
		      )];
		    } else {
		      nodes = [h(
		        'div',
		        {
		          ref: 'wrap',
		          'class': [this.wrapClass, 'el-scrollbar__wrap'],
		          style: style },
		        [[view]]
		      )];
		    }
		    return h('div', { class: 'el-scrollbar' }, nodes);
		  },
	
	
		  methods: {
		    handleScroll: function handleScroll() {
		      var wrap = this.wrap;
	
		      this.moveY = wrap.scrollTop * 100 / wrap.clientHeight;
		      this.moveX = wrap.scrollLeft * 100 / wrap.clientWidth;
		    },
		    update: function update() {
		      var heightPercentage = void 0,
		          widthPercentage = void 0;
		      var wrap = this.wrap;
	
		      heightPercentage = wrap.clientHeight * 100 / wrap.scrollHeight;
		      widthPercentage = wrap.clientWidth * 100 / wrap.scrollWidth;
	
		      this.sizeHeight = heightPercentage < 100 ? heightPercentage + '%' : '';
		      this.sizeWidth = widthPercentage < 100 ? widthPercentage + '%' : '';
		    }
		  },
	
		  mounted: function mounted() {
		    if (this.native) return;
		    this.$nextTick(this.update);
		    !this.noresize && (0, _resizeEvent.addResizeListener)(this.$refs.resize, this.update);
		  },
		  destroyed: function destroyed() {
		    if (this.native) return;
		    !this.noresize && (0, _resizeEvent.removeResizeListener)(this.$refs.resize, this.update);
		  }
		};
	
	/***/ },
	/* 325 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.toObject = exports.BAR_MAP = undefined;
		exports.renderThumbStyle = renderThumbStyle;
	
		var _vue = __webpack_require__(126);
	
		var _vue2 = _interopRequireDefault(_vue);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var BAR_MAP = exports.BAR_MAP = {
		  vertical: {
		    offset: 'offsetHeight',
		    scroll: 'scrollTop',
		    scrollSize: 'scrollHeight',
		    size: 'height',
		    key: 'vertical',
		    axis: 'Y',
		    client: 'clientY',
		    direction: 'top'
		  },
		  horizontal: {
		    offset: 'offsetWidth',
		    scroll: 'scrollLeft',
		    scrollSize: 'scrollWidth',
		    size: 'width',
		    key: 'horizontal',
		    axis: 'X',
		    client: 'clientX',
		    direction: 'left'
		  }
		};
	
		function renderThumbStyle(_ref) {
		  var move = _ref.move,
		      size = _ref.size,
		      bar = _ref.bar;
	
		  var style = {};
		  var translate = 'translate' + bar.axis + '(' + move + '%)';
	
		  style[bar.size] = size;
		  style.transform = translate;
		  style.msTransform = translate;
		  style.webkitTransform = translate;
	
		  return style;
		};
	
		var toObject = exports.toObject = _vue2.default.util.toObject;
	
	/***/ },
	/* 326 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _dom = __webpack_require__(66);
	
		var _util = __webpack_require__(325);
	
		/* istanbul ignore next */
		exports.default = {
		  name: 'Bar',
	
		  props: {
		    vertical: Boolean,
		    size: String,
		    move: Number
		  },
	
		  computed: {
		    bar: function bar() {
		      return _util.BAR_MAP[this.vertical ? 'vertical' : 'horizontal'];
		    },
		    wrap: function wrap() {
		      return this.$parent.wrap;
		    }
		  },
	
		  render: function render(h) {
		    var size = this.size,
		        move = this.move,
		        bar = this.bar;
	
	
		    return h(
		      'div',
		      {
		        'class': ['el-scrollbar__bar', 'is-' + bar.key],
		        on: {
		          'mousedown': this.clickTrackHandler
		        }
		      },
		      [h(
		        'div',
		        {
		          ref: 'thumb',
		          'class': 'el-scrollbar__thumb',
		          on: {
		            'mousedown': this.clickThumbHandler
		          },
	
		          style: (0, _util.renderThumbStyle)({ size: size, move: move, bar: bar }) },
		        []
		      )]
		    );
		  },
	
	
		  methods: {
		    clickThumbHandler: function clickThumbHandler(e) {
		      this.startDrag(e);
		      this[this.bar.axis] = e.currentTarget[this.bar.offset] - (e[this.bar.client] - e.currentTarget.getBoundingClientRect()[this.bar.direction]);
		    },
		    clickTrackHandler: function clickTrackHandler(e) {
		      var offset = Math.abs(e.target.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]);
		      var thumbHalf = this.$refs.thumb[this.bar.offset] / 2;
		      var thumbPositionPercentage = (offset - thumbHalf) * 100 / this.$el[this.bar.offset];
	
		      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
		    },
		    startDrag: function startDrag(e) {
		      e.stopImmediatePropagation();
		      this.cursorDown = true;
	
		      (0, _dom.on)(document, 'mousemove', this.mouseMoveDocumentHandler);
		      (0, _dom.on)(document, 'mouseup', this.mouseUpDocumentHandler);
		      document.onselectstart = function () {
		        return false;
		      };
		    },
		    mouseMoveDocumentHandler: function mouseMoveDocumentHandler(e) {
		      if (this.cursorDown === false) return;
		      var prevPage = this[this.bar.axis];
	
		      if (!prevPage) return;
	
		      var offset = (this.$el.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]) * -1;
		      var thumbClickPosition = this.$refs.thumb[this.bar.offset] - prevPage;
		      var thumbPositionPercentage = (offset - thumbClickPosition) * 100 / this.$el[this.bar.offset];
	
		      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
		    },
		    mouseUpDocumentHandler: function mouseUpDocumentHandler(e) {
		      this.cursorDown = false;
		      this[this.bar.axis] = 0;
		      (0, _dom.off)(document, 'mousemove', this.mouseMoveDocumentHandler);
		      document.onselectstart = null;
		    }
		  },
	
		  destroyed: function destroyed() {
		    (0, _dom.off)(document, 'mouseup', this.mouseUpDocumentHandler);
		  }
		};
	
	/***/ },
	/* 327 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _item = __webpack_require__(328);
	
		var _item2 = _interopRequireDefault(_item);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_item2.default.install = function (Vue) {
		  Vue.component(_item2.default.name, _item2.default);
		};
	
		exports.default = _item2.default;
	
	/***/ },
	/* 328 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(329)
	
		/* template */
		var __vue_template__ = __webpack_require__(330)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 329 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		var CARD_SCALE = 0.83;
		exports.default = {
		  name: 'ElCarouselItem',
	
		  props: {
		    name: String
		  },
	
		  data: function data() {
		    return {
		      hover: false,
		      translate: 0,
		      scale: 1,
		      active: false,
		      ready: false,
		      inStage: false
		    };
		  },
	
	
		  methods: {
		    processIndex: function processIndex(index, activeIndex, length) {
		      if (activeIndex === 0 && index === length - 1) {
		        return -1;
		      } else if (activeIndex === length - 1 && index === 0) {
		        return length;
		      } else if (index < activeIndex - 1 && activeIndex - index >= length / 2) {
		        return length + 1;
		      } else if (index > activeIndex + 1 && index - activeIndex >= length / 2) {
		        return -2;
		      }
		      return index;
		    },
		    calculateTranslate: function calculateTranslate(index, activeIndex, parentWidth) {
		      if (this.inStage) {
		        return parentWidth * ((2 - CARD_SCALE) * (index - activeIndex) + 1) / 4;
		      } else if (index < activeIndex) {
		        return -(1 + CARD_SCALE) * parentWidth / 4;
		      } else {
		        return (3 + CARD_SCALE) * parentWidth / 4;
		      }
		    },
		    translateItem: function translateItem(index, activeIndex) {
		      var parentWidth = this.$parent.$el.offsetWidth;
		      var length = this.$parent.items.length;
	
		      if (this.$parent.type === 'card') {
		        if (index !== activeIndex && length > 2) {
		          index = this.processIndex(index, activeIndex, length);
		        }
		        this.inStage = Math.round(Math.abs(index - activeIndex)) <= 1;
		        this.active = index === activeIndex;
		        this.translate = this.calculateTranslate(index, activeIndex, parentWidth);
		        this.scale = this.active ? 1 : CARD_SCALE;
		      } else {
		        this.active = index === activeIndex;
		        this.translate = parentWidth * (index - activeIndex);
		      }
		      this.ready = true;
		    },
		    handleItemClick: function handleItemClick() {
		      var parent = this.$parent;
		      if (parent && parent.type === 'card') {
		        var index = parent.items.indexOf(this);
		        parent.setActiveItem(index);
		      }
		    }
		  },
	
		  created: function created() {
		    this.$parent && this.$parent.handleItemChange();
		  },
		  destroyed: function destroyed() {
		    this.$parent && this.$parent.handleItemChange();
		  }
		};
	
	/***/ },
	/* 330 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.ready),
		      expression: "ready"
		    }],
		    staticClass: "el-carousel__item",
		    class: {
		      'is-active': _vm.active,
		      'el-carousel__item--card': _vm.$parent.type === 'card',
		        'is-in-stage': _vm.inStage,
		        'is-hover': _vm.hover
		    },
		    style: ({
		      msTransform: ("translateX(" + _vm.translate + "px) scale(" + _vm.scale + ")"),
		      webkitTransform: ("translateX(" + _vm.translate + "px) scale(" + _vm.scale + ")"),
		      transform: ("translateX(" + _vm.translate + "px) scale(" + _vm.scale + ")")
		    }),
		    on: {
		      "click": _vm.handleItemClick
		    }
		  }, [(_vm.$parent.type === 'card') ? _c('div', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (!_vm.active),
		      expression: "!active"
		    }],
		    staticClass: "el-carousel__mask"
		  }) : _vm._e(), _vm._t("default")], 2)
		},staticRenderFns: []}
	
	/***/ },
	/* 331 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _collapse = __webpack_require__(332);
	
		var _collapse2 = _interopRequireDefault(_collapse);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_collapse2.default.install = function (Vue) {
		  Vue.component(_collapse2.default.name, _collapse2.default);
		};
	
		exports.default = _collapse2.default;
	
	/***/ },
	/* 332 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(333)
	
		/* template */
		var __vue_template__ = __webpack_require__(334)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 333 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		//
		//
		//
		//
		//
	
		exports.default = {
		  name: 'ElCollapse',
	
		  componentName: 'ElCollapse',
	
		  props: {
		    accordion: Boolean,
		    value: {
		      type: [Array, String, Number],
		      default: function _default() {
		        return [];
		      }
		    }
		  },
	
		  data: function data() {
		    return {
		      activeNames: [].concat(this.value)
		    };
		  },
	
	
		  watch: {
		    value: function value(_value) {
		      this.activeNames = [].concat(_value);
		    }
		  },
	
		  methods: {
		    setActiveNames: function setActiveNames(activeNames) {
		      activeNames = [].concat(activeNames);
		      var value = this.accordion ? activeNames[0] : activeNames;
		      this.activeNames = activeNames;
		      this.$emit('input', value);
		      this.$emit('change', value);
		    },
		    handleItemClick: function handleItemClick(item) {
		      if (this.accordion) {
		        this.setActiveNames(this.activeNames[0] && this.activeNames[0] === item.name ? '' : item.name);
		      } else {
		        var activeNames = this.activeNames.slice(0);
		        var index = activeNames.indexOf(item.name);
	
		        if (index > -1) {
		          activeNames.splice(index, 1);
		        } else {
		          activeNames.push(item.name);
		        }
		        this.setActiveNames(activeNames);
		      }
		    }
		  },
	
		  created: function created() {
		    this.$on('item-click', this.handleItemClick);
		  }
		};
	
	/***/ },
	/* 334 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    staticClass: "el-collapse"
		  }, [_vm._t("default")], 2)
		},staticRenderFns: []}
	
	/***/ },
	/* 335 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _collapseItem = __webpack_require__(336);
	
		var _collapseItem2 = _interopRequireDefault(_collapseItem);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_collapseItem2.default.install = function (Vue) {
		  Vue.component(_collapseItem2.default.name, _collapseItem2.default);
		};
	
		exports.default = _collapseItem2.default;
	
	/***/ },
	/* 336 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(337)
	
		/* template */
		var __vue_template__ = __webpack_require__(338)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	/* 337 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _emitter = __webpack_require__(23);
	
		var _emitter2 = _interopRequireDefault(_emitter);
	
		var _collapseTransition = __webpack_require__(47);
	
		var _collapseTransition2 = _interopRequireDefault(_collapseTransition);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  name: 'ElCollapseItem',
	
		  componentName: 'ElCollapseItem',
	
		  mixins: [_emitter2.default],
	
		  components: {
		    CollapseTransition: _collapseTransition2.default
		  },
	
		  data: function data() {
		    return {
		      contentWrapStyle: {
		        height: 'auto',
		        display: 'block'
		      },
		      contentHeight: 0
		    };
		  },
	
	
		  props: {
		    title: String,
		    name: {
		      type: [String, Number],
		      default: function _default() {
		        return this._uid;
		      }
		    }
		  },
	
		  computed: {
		    isActive: function isActive() {
		      return this.$parent.activeNames.indexOf(this.name) > -1;
		    }
		  },
	
		  watch: {
		    'isActive': function isActive(value) {}
		  },
	
		  methods: {
		    handleHeaderClick: function handleHeaderClick() {
		      this.dispatch('ElCollapse', 'item-click', this);
		    }
		  },
	
		  mounted: function mounted() {}
		};
	
	/***/ },
	/* 338 */
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    staticClass: "el-collapse-item",
		    class: {
		      'is-active': _vm.isActive
		    }
		  }, [_c('div', {
		    staticClass: "el-collapse-item__header",
		    on: {
		      "click": _vm.handleHeaderClick
		    }
		  }, [_c('i', {
		    staticClass: "el-collapse-item__header__arrow el-icon-arrow-right"
		  }), _vm._t("title", [_vm._v(_vm._s(_vm.title))])], 2), _c('collapse-transition', [_c('div', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.isActive),
		      expression: "isActive"
		    }],
		    staticClass: "el-collapse-item__wrap"
		  }, [_c('div', {
		    staticClass: "el-collapse-item__content"
		  }, [_vm._t("default")], 2)])])], 1)
		},staticRenderFns: []}
	
	/***/ }
	/******/ ]);

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(139);
	
	
	/***/ },
	
	/***/ 8:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(102);
	
	/***/ },
	
	/***/ 90:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(47);
	
	/***/ },
	
	/***/ 139:
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _inputNumber = __webpack_require__(140);
	
		var _inputNumber2 = _interopRequireDefault(_inputNumber);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_inputNumber2.default.install = function (Vue) {
		  Vue.component(_inputNumber2.default.name, _inputNumber2.default);
		};
	
		exports.default = _inputNumber2.default;
	
	/***/ },
	
	/***/ 140:
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(141)
	
		/* template */
		var __vue_template__ = __webpack_require__(142)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	
	/***/ 141:
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _input = __webpack_require__(8);
	
		var _input2 = _interopRequireDefault(_input);
	
		var _dom = __webpack_require__(90);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  name: 'ElInputNumber',
		  directives: {
		    repeatClick: {
		      bind: function bind(el, binding, vnode) {
		        var interval = null;
		        var startTime = void 0;
		        var handler = function handler() {
		          return vnode.context[binding.expression].apply();
		        };
		        var clear = function clear() {
		          if (new Date() - startTime < 100) {
		            handler();
		          }
		          clearInterval(interval);
		          interval = null;
		        };
	
		        (0, _dom.on)(el, 'mousedown', function () {
		          startTime = new Date();
		          (0, _dom.once)(document, 'mouseup', clear);
		          interval = setInterval(handler, 100);
		        });
		      }
		    }
		  },
		  components: {
		    ElInput: _input2.default
		  },
		  props: {
		    step: {
		      type: Number,
		      default: 1
		    },
		    max: {
		      type: Number,
		      default: Infinity
		    },
		    min: {
		      type: Number,
		      default: -Infinity
		    },
		    value: {
		      default: 0
		    },
		    disabled: Boolean,
		    size: String,
		    controls: {
		      type: Boolean,
		      default: true
		    }
		  },
		  data: function data() {
		    return {
		      currentValue: 0
		    };
		  },
	
		  watch: {
		    value: {
		      immediate: true,
		      handler: function handler(value) {
		        var newVal = Number(value);
		        if (isNaN(newVal)) return;
		        if (newVal >= this.max) newVal = this.max;
		        if (newVal <= this.min) newVal = this.min;
		        this.currentValue = newVal;
		        this.$emit('input', newVal);
		      }
		    }
		  },
		  computed: {
		    minDisabled: function minDisabled() {
		      return this._decrease(this.value, this.step) < this.min;
		    },
		    maxDisabled: function maxDisabled() {
		      return this._increase(this.value, this.step) > this.max;
		    },
		    precision: function precision() {
		      var value = this.value,
		          step = this.step,
		          getPrecision = this.getPrecision;
	
		      return Math.max(getPrecision(value), getPrecision(step));
		    }
		  },
		  methods: {
		    toPrecision: function toPrecision(num, precision) {
		      if (precision === undefined) precision = this.precision;
		      return parseFloat(parseFloat(Number(num).toFixed(precision)));
		    },
		    getPrecision: function getPrecision(value) {
		      var valueString = value.toString();
		      var dotPosition = valueString.indexOf('.');
		      var precision = 0;
		      if (dotPosition !== -1) {
		        precision = valueString.length - dotPosition - 1;
		      }
		      return precision;
		    },
		    _increase: function _increase(val, step) {
		      if (typeof val !== 'number') return this.currentValue;
	
		      var precisionFactor = Math.pow(10, this.precision);
	
		      return this.toPrecision((precisionFactor * val + precisionFactor * step) / precisionFactor);
		    },
		    _decrease: function _decrease(val, step) {
		      if (typeof val !== 'number') return this.currentValue;
	
		      var precisionFactor = Math.pow(10, this.precision);
	
		      return this.toPrecision((precisionFactor * val - precisionFactor * step) / precisionFactor);
		    },
		    increase: function increase() {
		      if (this.disabled || this.maxDisabled) return;
		      var value = this.value || 0;
		      var newVal = this._increase(value, this.step);
		      if (newVal > this.max) return;
		      this.setCurrentValue(newVal);
		    },
		    decrease: function decrease() {
		      if (this.disabled || this.minDisabled) return;
		      var value = this.value || 0;
		      var newVal = this._decrease(value, this.step);
		      if (newVal < this.min) return;
		      this.setCurrentValue(newVal);
		    },
		    handleBlur: function handleBlur() {
		      this.$refs.input.setCurrentValue(this.currentValue);
		    },
		    setCurrentValue: function setCurrentValue(newVal) {
		      var oldVal = this.currentValue;
		      if (newVal >= this.max) newVal = this.max;
		      if (newVal <= this.min) newVal = this.min;
		      if (oldVal === newVal) return;
		      this.$emit('change', newVal, oldVal);
		      this.$emit('input', newVal);
		      this.currentValue = newVal;
		    },
		    handleInput: function handleInput(value) {
		      var newVal = Number(value);
		      if (!isNaN(newVal)) {
		        this.setCurrentValue(newVal);
		      }
		    }
		  }
		};
	
	/***/ },
	
	/***/ 142:
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    staticClass: "el-input-number",
		    class: [
		      _vm.size ? 'el-input-number--' + _vm.size : '', {
		        'is-disabled': _vm.disabled
		      }, {
		        'is-without-controls': !_vm.controls
		      }
		    ]
		  }, [(_vm.controls) ? _c('span', {
		    directives: [{
		      name: "repeat-click",
		      rawName: "v-repeat-click",
		      value: (_vm.decrease),
		      expression: "decrease"
		    }],
		    staticClass: "el-input-number__decrease el-icon-minus",
		    class: {
		      'is-disabled': _vm.minDisabled
		    }
		  }) : _vm._e(), (_vm.controls) ? _c('span', {
		    directives: [{
		      name: "repeat-click",
		      rawName: "v-repeat-click",
		      value: (_vm.increase),
		      expression: "increase"
		    }],
		    staticClass: "el-input-number__increase el-icon-plus",
		    class: {
		      'is-disabled': _vm.maxDisabled
		    }
		  }) : _vm._e(), _c('el-input', {
		    ref: "input",
		    attrs: {
		      "value": _vm.currentValue,
		      "disabled": _vm.disabled,
		      "size": _vm.size,
		      "max": _vm.max,
		      "min": _vm.min
		    },
		    on: {
		      "blur": _vm.handleBlur,
		      "input": _vm.handleInput
		    },
		    nativeOn: {
		      "keydown": [function($event) {
		        if (_vm._k($event.keyCode, "up", 38)) { return; }
		        $event.preventDefault();
		        _vm.increase($event)
		      }, function($event) {
		        if (_vm._k($event.keyCode, "down", 40)) { return; }
		        $event.preventDefault();
		        _vm.decrease($event)
		      }]
		    }
		  }, [(_vm.$slots.prepend) ? _c('template', {
		    slot: "prepend"
		  }, [_vm._t("prepend")], 2) : _vm._e(), (_vm.$slots.append) ? _c('template', {
		    slot: "append"
		  }, [_vm._t("append")], 2) : _vm._e()], 2)], 1)
		},staticRenderFns: []}
	
	/***/ }
	
	/******/ });

/***/ },
/* 411 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = function (Vue) {
	  var hasOwn = Vue.util.hasOwn;
	
	  /**
	   * template
	   *
	   * @param {String} string
	   * @param {Array} ...args
	   * @return {String}
	   */
	
	  function template(string) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    if (args.length === 1 && _typeof(args[0]) === 'object') {
	      args = args[0];
	    }
	
	    if (!args || !args.hasOwnProperty) {
	      args = {};
	    }
	
	    return string.replace(RE_NARGS, function (match, prefix, i, index) {
	      var result = void 0;
	
	      if (string[index - 1] === '{' && string[index + match.length] === '}') {
	        return i;
	      } else {
	        result = hasOwn(args, i) ? args[i] : null;
	        if (result === null || result === undefined) {
	          return '';
	        }
	
	        return result;
	      }
	    });
	  }
	
	  return template;
	};
	
	/**
	 *  String format template
	 *  - Inspired:
	 *    https://github.com/Matt-Esch/string-template/index.js
	 */
	
	var RE_NARGS = /(%|)\{([0-9a-zA-Z_]+)\}/g;

/***/ },
/* 412 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  el: {
	    datepicker: {
	      now: 'Now',
	      today: 'Today',
	      cancel: 'Cancel',
	      clear: 'Clear',
	      confirm: 'OK',
	      selectDate: 'Select date',
	      selectTime: 'Select time',
	      startDate: 'Start Date',
	      startTime: 'Start Time',
	      endDate: 'End Date',
	      endTime: 'End Time',
	      year: '',
	      month1: 'January',
	      month2: 'February',
	      month3: 'March',
	      month4: 'April',
	      month5: 'May',
	      month6: 'June',
	      month7: 'July',
	      month8: 'August',
	      month9: 'September',
	      month10: 'October',
	      month11: 'November',
	      month12: 'December',
	      // week: 'week',
	      weeks: {
	        sun: 'Sun',
	        mon: 'Mon',
	        tue: 'Tue',
	        wed: 'Wed',
	        thu: 'Thu',
	        fri: 'Fri',
	        sat: 'Sat'
	      },
	      months: {
	        jan: 'Jan',
	        feb: 'Feb',
	        mar: 'Mar',
	        apr: 'Apr',
	        may: 'May',
	        jun: 'Jun',
	        jul: 'Jul',
	        aug: 'Aug',
	        sep: 'Sep',
	        oct: 'Oct',
	        nov: 'Nov',
	        dec: 'Dec'
	      }
	    },
	    select: {
	      loading: 'Loading',
	      noMatch: 'No matching data',
	      noData: 'No data',
	      placeholder: 'Select'
	    },
	    pagination: {
	      goto: 'Go to',
	      pagesize: '/page',
	      total: 'Total {total}',
	      pageClassifier: ''
	    },
	    messagebox: {
	      title: 'Message',
	      confirm: 'OK',
	      cancel: 'Cancel',
	      error: 'Illegal input'
	    },
	    upload: {
	      delete: 'Delete',
	      preview: 'Preview',
	      continue: 'Continue'
	    },
	    table: {
	      emptyText: 'No Data',
	      confirmFilter: 'Confirm',
	      resetFilter: 'Reset',
	      clearFilter: 'All'
	    },
	    tree: {
	      emptyText: 'No Data'
	    }
	  }
	};

/***/ },
/* 413 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  el: {
	    datepicker: {
	      now: '此刻',
	      today: '今天',
	      cancel: '取消',
	      clear: '清空',
	      confirm: '确定',
	      selectDate: '选择日期',
	      selectTime: '选择时间',
	      startDate: '开始日期',
	      startTime: '开始时间',
	      endDate: '结束日期',
	      endTime: '结束时间',
	      year: '年',
	      month1: '1 月',
	      month2: '2 月',
	      month3: '3 月',
	      month4: '4 月',
	      month5: '5 月',
	      month6: '6 月',
	      month7: '7 月',
	      month8: '8 月',
	      month9: '9 月',
	      month10: '10 月',
	      month11: '11 月',
	      month12: '12 月',
	      // week: '周次',
	      weeks: {
	        sun: '日',
	        mon: '一',
	        tue: '二',
	        wed: '三',
	        thu: '四',
	        fri: '五',
	        sat: '六'
	      },
	      months: {
	        jan: '一月',
	        feb: '二月',
	        mar: '三月',
	        apr: '四月',
	        may: '五月',
	        jun: '六月',
	        jul: '七月',
	        aug: '八月',
	        sep: '九月',
	        oct: '十月',
	        nov: '十一月',
	        dec: '十二月'
	      }
	    },
	    select: {
	      loading: '加载中',
	      noMatch: '无匹配数据',
	      noData: '无数据',
	      placeholder: '请选择'
	    },
	    pagination: {
	      goto: '前往',
	      pagesize: '条/页',
	      total: '共 {total} 条',
	      pageClassifier: '页'
	    },
	    messagebox: {
	      title: '提示',
	      confirm: '确定',
	      cancel: '取消',
	      error: '输入的数据不合法!'
	    },
	    upload: {
	      delete: '删除',
	      preview: '查看图片',
	      continue: '继续上传'
	    },
	    table: {
	      emptyText: '暂无数据',
	      confirmFilter: '筛选',
	      resetFilter: '重置',
	      clearFilter: '全部'
	    },
	    tree: {
	      emptyText: '暂无数据'
	    }
	  }
	};

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(184);
	
	
	/***/ },
	
	/***/ 13:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(53);
	
	/***/ },
	
	/***/ 184:
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _option = __webpack_require__(185);
	
		var _option2 = _interopRequireDefault(_option);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_option2.default.install = function (Vue) {
		  Vue.component(_option2.default.name, _option2.default);
		};
	
		exports.default = _option2.default;
	
	/***/ },
	
	/***/ 185:
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(186)
	
		/* template */
		var __vue_template__ = __webpack_require__(187)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	
	/***/ 186:
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _emitter = __webpack_require__(13);
	
		var _emitter2 = _interopRequireDefault(_emitter);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  mixins: [_emitter2.default],
	
		  name: 'ElOption',
	
		  componentName: 'ElOption',
	
		  props: {
		    value: {
		      required: true
		    },
		    label: [String, Number],
		    selected: {
		      type: Boolean,
		      default: false
		    },
		    created: Boolean,
		    disabled: {
		      type: Boolean,
		      default: false
		    }
		  },
	
		  data: function data() {
		    return {
		      index: -1,
		      groupDisabled: false,
		      visible: true,
		      hitState: false
		    };
		  },
	
	
		  computed: {
		    currentLabel: function currentLabel() {
		      return this.label || (typeof this.value === 'string' || typeof this.value === 'number' ? this.value : '');
		    },
		    currentValue: function currentValue() {
		      return this.value || this.label || '';
		    },
		    parent: function parent() {
		      var result = this.$parent;
		      while (!result.isSelect) {
		        result = result.$parent;
		      }
		      return result;
		    },
		    itemSelected: function itemSelected() {
		      if (!this.parent.multiple) {
		        return this.value === this.parent.value;
		      } else {
		        return this.parent.value.indexOf(this.value) > -1;
		      }
		    },
		    limitReached: function limitReached() {
		      if (this.parent.multiple) {
		        return !this.itemSelected && this.parent.value.length >= this.parent.multipleLimit && this.parent.multipleLimit > 0;
		      } else {
		        return false;
		      }
		    }
		  },
	
		  watch: {
		    currentLabel: function currentLabel() {
		      if (!this.created) this.dispatch('ElSelect', 'setSelected');
		    },
		    value: function value() {
		      if (!this.created) this.dispatch('ElSelect', 'setSelected');
		    }
		  },
	
		  methods: {
		    handleGroupDisabled: function handleGroupDisabled(val) {
		      this.groupDisabled = val;
		    },
		    hoverItem: function hoverItem() {
		      if (!this.disabled && !this.groupDisabled) {
		        this.parent.hoverIndex = this.parent.options.indexOf(this);
		      }
		    },
		    selectOptionClick: function selectOptionClick() {
		      if (this.disabled !== true && this.groupDisabled !== true) {
		        this.dispatch('ElSelect', 'handleOptionClick', this);
		      }
		    },
		    queryChange: function queryChange(query) {
		      // query 里如果有正则中的特殊字符，需要先将这些字符转义
		      var parsedQuery = String(query).replace(/(\^|\(|\)|\[|\]|\$|\*|\+|\.|\?|\\|\{|\}|\|)/g, '\\$1');
		      this.visible = new RegExp(parsedQuery, 'i').test(this.currentLabel) || this.created;
		      if (!this.visible) {
		        this.parent.filteredOptionsCount--;
		      }
		    },
		    resetIndex: function resetIndex() {
		      var _this = this;
	
		      this.$nextTick(function () {
		        _this.index = _this.parent.options.indexOf(_this);
		      });
		    }
		  },
	
		  created: function created() {
		    this.parent.options.push(this);
		    this.parent.cachedOptions.push(this);
		    this.parent.optionsCount++;
		    this.parent.filteredOptionsCount++;
		    this.index = this.parent.options.indexOf(this);
	
		    this.$on('queryChange', this.queryChange);
		    this.$on('handleGroupDisabled', this.handleGroupDisabled);
		    this.$on('resetIndex', this.resetIndex);
		  },
		  beforeDestroy: function beforeDestroy() {
		    this.dispatch('ElSelect', 'onOptionDestroy', this);
		  }
		}; //
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
	/***/ },
	
	/***/ 187:
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('li', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.visible),
		      expression: "visible"
		    }],
		    staticClass: "el-select-dropdown__item",
		    class: {
		      'selected': _vm.itemSelected,
		      'is-disabled': _vm.disabled || _vm.groupDisabled || _vm.limitReached,
		        'hover': _vm.parent.hoverIndex === _vm.index
		    },
		    on: {
		      "mouseenter": _vm.hoverItem,
		      "click": function($event) {
		        $event.stopPropagation();
		        _vm.selectOptionClick($event)
		      }
		    }
		  }, [_vm._t("default", [_c('span', [_vm._v(_vm._s(_vm.currentLabel))])])], 2)
		},staticRenderFns: []}
	
	/***/ }
	
	/******/ });

/***/ },
/* 415 */
/***/ function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(204);
	
	
	/***/ },
	
	/***/ 204:
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _progress = __webpack_require__(205);
	
		var _progress2 = _interopRequireDefault(_progress);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_progress2.default.install = function (Vue) {
		  Vue.component(_progress2.default.name, _progress2.default);
		};
	
		exports.default = _progress2.default;
	
	/***/ },
	
	/***/ 205:
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(206)
	
		/* template */
		var __vue_template__ = __webpack_require__(207)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	
	/***/ 206:
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  name: 'ElProgress',
		  props: {
		    type: {
		      type: String,
		      default: 'line',
		      validator: function validator(val) {
		        return ['line', 'circle'].indexOf(val) > -1;
		      }
		    },
		    percentage: {
		      type: Number,
		      default: 0,
		      required: true,
		      validator: function validator(val) {
		        return val >= 0 && val <= 100;
		      }
		    },
		    status: {
		      type: String
		    },
		    strokeWidth: {
		      type: Number,
		      default: 6
		    },
		    textInside: {
		      type: Boolean,
		      default: false
		    },
		    width: {
		      type: Number,
		      default: 126
		    },
		    showText: {
		      type: Boolean,
		      default: true
		    }
		  },
		  computed: {
		    barStyle: function barStyle() {
		      var style = {};
		      style.width = this.percentage + '%';
		      return style;
		    },
		    relativeStrokeWidth: function relativeStrokeWidth() {
		      return (this.strokeWidth / this.width * 100).toFixed(1);
		    },
		    trackPath: function trackPath() {
		      var radius = parseInt(50 - parseFloat(this.relativeStrokeWidth) / 2, 10);
	
		      return 'M 50 50 m 0 -' + radius + ' a ' + radius + ' ' + radius + ' 0 1 1 0 ' + radius * 2 + ' a ' + radius + ' ' + radius + ' 0 1 1 0 -' + radius * 2;
		    },
		    perimeter: function perimeter() {
		      var radius = 50 - parseFloat(this.relativeStrokeWidth) / 2;
		      return 2 * Math.PI * radius;
		    },
		    circlePathStyle: function circlePathStyle() {
		      var perimeter = this.perimeter;
		      return {
		        strokeDasharray: perimeter + 'px,' + perimeter + 'px',
		        strokeDashoffset: (1 - this.percentage / 100) * perimeter + 'px',
		        transition: 'stroke-dashoffset 0.6s ease 0s, stroke 0.6s ease'
		      };
		    },
		    stroke: function stroke() {
		      var ret;
		      switch (this.status) {
		        case 'success':
		          ret = '#13ce66';
		          break;
		        case 'exception':
		          ret = '#ff4949';
		          break;
		        default:
		          ret = '#20a0ff';
		      }
		      return ret;
		    },
		    iconClass: function iconClass() {
		      if (this.type === 'line') {
		        return this.status === 'success' ? 'el-icon-circle-check' : 'el-icon-circle-cross';
		      } else {
		        return this.status === 'success' ? 'el-icon-check' : 'el-icon-close';
		      }
		    },
		    progressTextSize: function progressTextSize() {
		      return this.type === 'line' ? 12 + this.strokeWidth * 0.4 : this.width * 0.111111 + 2;
		    }
		  }
		};
	
	/***/ },
	
	/***/ 207:
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    staticClass: "el-progress",
		    class: [
		      'el-progress--' + _vm.type,
		      _vm.status ? 'is-' + _vm.status : '', {
		        'el-progress--without-text': !_vm.showText,
		        'el-progress--text-inside': _vm.textInside,
		      }
		    ]
		  }, [(_vm.type === 'line') ? _c('div', {
		    staticClass: "el-progress-bar"
		  }, [_c('div', {
		    staticClass: "el-progress-bar__outer",
		    style: ({
		      height: _vm.strokeWidth + 'px'
		    })
		  }, [_c('div', {
		    staticClass: "el-progress-bar__inner",
		    style: (_vm.barStyle)
		  }, [(_vm.showText && _vm.textInside) ? _c('div', {
		    staticClass: "el-progress-bar__innerText"
		  }, [_vm._v(_vm._s(_vm.percentage) + "%")]) : _vm._e()])])]) : _c('div', {
		    staticClass: "el-progress-circle",
		    style: ({
		      height: _vm.width + 'px',
		      width: _vm.width + 'px'
		    })
		  }, [_c('svg', {
		    attrs: {
		      "viewBox": "0 0 100 100"
		    }
		  }, [_c('path', {
		    staticClass: "el-progress-circle__track",
		    attrs: {
		      "d": _vm.trackPath,
		      "stroke": "#e5e9f2",
		      "stroke-width": _vm.relativeStrokeWidth,
		      "fill": "none"
		    }
		  }), _c('path', {
		    staticClass: "el-progress-circle__path",
		    style: (_vm.circlePathStyle),
		    attrs: {
		      "d": _vm.trackPath,
		      "stroke-linecap": "round",
		      "stroke": _vm.stroke,
		      "stroke-width": _vm.relativeStrokeWidth,
		      "fill": "none"
		    }
		  })])]), (_vm.showText && !_vm.textInside) ? _c('div', {
		    staticClass: "el-progress__text",
		    style: ({
		      fontSize: _vm.progressTextSize + 'px'
		    })
		  }, [(!_vm.status) ? [_vm._v(_vm._s(_vm.percentage) + "%")] : _c('i', {
		    class: _vm.iconClass
		  })], 2) : _vm._e()])
		},staticRenderFns: []}
	
	/***/ }
	
	/******/ });

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(233);
	
	
	/***/ },
	
	/***/ 8:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(102);
	
	/***/ },
	
	/***/ 9:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(146);
	
	/***/ },
	
	/***/ 12:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(105);
	
	/***/ },
	
	/***/ 13:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(53);
	
	/***/ },
	
	/***/ 44:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(150);
	
	/***/ },
	
	/***/ 45:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(104);
	
	/***/ },
	
	/***/ 80:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(143);
	
	/***/ },
	
	/***/ 85:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(144);
	
	/***/ },
	
	/***/ 90:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(47);
	
	/***/ },
	
	/***/ 137:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(69);
	
	/***/ },
	
	/***/ 176:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(103);
	
	/***/ },
	
	/***/ 185:
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(186)
	
		/* template */
		var __vue_template__ = __webpack_require__(187)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	
	/***/ 186:
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _emitter = __webpack_require__(13);
	
		var _emitter2 = _interopRequireDefault(_emitter);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  mixins: [_emitter2.default],
	
		  name: 'ElOption',
	
		  componentName: 'ElOption',
	
		  props: {
		    value: {
		      required: true
		    },
		    label: [String, Number],
		    selected: {
		      type: Boolean,
		      default: false
		    },
		    created: Boolean,
		    disabled: {
		      type: Boolean,
		      default: false
		    }
		  },
	
		  data: function data() {
		    return {
		      index: -1,
		      groupDisabled: false,
		      visible: true,
		      hitState: false
		    };
		  },
	
	
		  computed: {
		    currentLabel: function currentLabel() {
		      return this.label || (typeof this.value === 'string' || typeof this.value === 'number' ? this.value : '');
		    },
		    currentValue: function currentValue() {
		      return this.value || this.label || '';
		    },
		    parent: function parent() {
		      var result = this.$parent;
		      while (!result.isSelect) {
		        result = result.$parent;
		      }
		      return result;
		    },
		    itemSelected: function itemSelected() {
		      if (!this.parent.multiple) {
		        return this.value === this.parent.value;
		      } else {
		        return this.parent.value.indexOf(this.value) > -1;
		      }
		    },
		    limitReached: function limitReached() {
		      if (this.parent.multiple) {
		        return !this.itemSelected && this.parent.value.length >= this.parent.multipleLimit && this.parent.multipleLimit > 0;
		      } else {
		        return false;
		      }
		    }
		  },
	
		  watch: {
		    currentLabel: function currentLabel() {
		      if (!this.created) this.dispatch('ElSelect', 'setSelected');
		    },
		    value: function value() {
		      if (!this.created) this.dispatch('ElSelect', 'setSelected');
		    }
		  },
	
		  methods: {
		    handleGroupDisabled: function handleGroupDisabled(val) {
		      this.groupDisabled = val;
		    },
		    hoverItem: function hoverItem() {
		      if (!this.disabled && !this.groupDisabled) {
		        this.parent.hoverIndex = this.parent.options.indexOf(this);
		      }
		    },
		    selectOptionClick: function selectOptionClick() {
		      if (this.disabled !== true && this.groupDisabled !== true) {
		        this.dispatch('ElSelect', 'handleOptionClick', this);
		      }
		    },
		    queryChange: function queryChange(query) {
		      // query 里如果有正则中的特殊字符，需要先将这些字符转义
		      var parsedQuery = String(query).replace(/(\^|\(|\)|\[|\]|\$|\*|\+|\.|\?|\\|\{|\}|\|)/g, '\\$1');
		      this.visible = new RegExp(parsedQuery, 'i').test(this.currentLabel) || this.created;
		      if (!this.visible) {
		        this.parent.filteredOptionsCount--;
		      }
		    },
		    resetIndex: function resetIndex() {
		      var _this = this;
	
		      this.$nextTick(function () {
		        _this.index = _this.parent.options.indexOf(_this);
		      });
		    }
		  },
	
		  created: function created() {
		    this.parent.options.push(this);
		    this.parent.cachedOptions.push(this);
		    this.parent.optionsCount++;
		    this.parent.filteredOptionsCount++;
		    this.index = this.parent.options.indexOf(this);
	
		    this.$on('queryChange', this.queryChange);
		    this.$on('handleGroupDisabled', this.handleGroupDisabled);
		    this.$on('resetIndex', this.resetIndex);
		  },
		  beforeDestroy: function beforeDestroy() {
		    this.dispatch('ElSelect', 'onOptionDestroy', this);
		  }
		}; //
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
	/***/ },
	
	/***/ 187:
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('li', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.visible),
		      expression: "visible"
		    }],
		    staticClass: "el-select-dropdown__item",
		    class: {
		      'selected': _vm.itemSelected,
		      'is-disabled': _vm.disabled || _vm.groupDisabled || _vm.limitReached,
		        'hover': _vm.parent.hoverIndex === _vm.index
		    },
		    on: {
		      "mouseenter": _vm.hoverItem,
		      "click": function($event) {
		        $event.stopPropagation();
		        _vm.selectOptionClick($event)
		      }
		    }
		  }, [_vm._t("default", [_c('span', [_vm._v(_vm._s(_vm.currentLabel))])])], 2)
		},staticRenderFns: []}
	
	/***/ },
	
	/***/ 233:
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _select = __webpack_require__(234);
	
		var _select2 = _interopRequireDefault(_select);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_select2.default.install = function (Vue) {
		  Vue.component(_select2.default.name, _select2.default);
		};
	
		exports.default = _select2.default;
	
	/***/ },
	
	/***/ 234:
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(235)
	
		/* template */
		var __vue_template__ = __webpack_require__(240)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	
	/***/ 235:
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _emitter = __webpack_require__(13);
	
		var _emitter2 = _interopRequireDefault(_emitter);
	
		var _locale = __webpack_require__(80);
	
		var _locale2 = _interopRequireDefault(_locale);
	
		var _input = __webpack_require__(8);
	
		var _input2 = _interopRequireDefault(_input);
	
		var _selectDropdown = __webpack_require__(236);
	
		var _selectDropdown2 = _interopRequireDefault(_selectDropdown);
	
		var _option = __webpack_require__(185);
	
		var _option2 = _interopRequireDefault(_option);
	
		var _tag = __webpack_require__(239);
	
		var _tag2 = _interopRequireDefault(_tag);
	
		var _scrollbar = __webpack_require__(85);
	
		var _scrollbar2 = _interopRequireDefault(_scrollbar);
	
		var _debounce = __webpack_require__(44);
	
		var _debounce2 = _interopRequireDefault(_debounce);
	
		var _clickoutside = __webpack_require__(9);
	
		var _clickoutside2 = _interopRequireDefault(_clickoutside);
	
		var _dom = __webpack_require__(90);
	
		var _resizeEvent = __webpack_require__(45);
	
		var _locale3 = __webpack_require__(176);
	
		var _merge = __webpack_require__(137);
	
		var _merge2 = _interopRequireDefault(_merge);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var sizeMap = {
		  'large': 42,
		  'small': 30,
		  'mini': 22
		}; //
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
		exports.default = {
		  mixins: [_emitter2.default, _locale2.default],
	
		  name: 'ElSelect',
	
		  componentName: 'ElSelect',
	
		  computed: {
		    iconClass: function iconClass() {
		      var criteria = this.clearable && !this.disabled && this.inputHovering && !this.multiple && this.value !== undefined && this.value !== '';
		      return criteria ? 'circle-close is-show-close' : this.remote && this.filterable ? '' : 'caret-top';
		    },
		    debounce: function debounce() {
		      return this.remote ? 300 : 0;
		    },
		    emptyText: function emptyText() {
		      if (this.loading) {
		        return this.loadingText || this.t('el.select.loading');
		      } else {
		        if (this.remote && this.query === '' && this.options.length === 0) return false;
		        if (this.filterable && this.options.length > 0 && this.filteredOptionsCount === 0) {
		          return this.noMatchText || this.t('el.select.noMatch');
		        }
		        if (this.options.length === 0) {
		          return this.noDataText || this.t('el.select.noData');
		        }
		      }
		      return null;
		    },
		    showNewOption: function showNewOption() {
		      var _this = this;
	
		      var hasExistingOption = this.options.filter(function (option) {
		        return !option.created;
		      }).some(function (option) {
		        return option.currentLabel === _this.query;
		      });
		      return this.filterable && this.allowCreate && this.query !== '' && !hasExistingOption;
		    }
		  },
	
		  components: {
		    ElInput: _input2.default,
		    ElSelectMenu: _selectDropdown2.default,
		    ElOption: _option2.default,
		    ElTag: _tag2.default,
		    ElScrollbar: _scrollbar2.default
		  },
	
		  directives: { Clickoutside: _clickoutside2.default },
	
		  props: {
		    name: String,
		    value: {},
		    size: String,
		    disabled: Boolean,
		    clearable: Boolean,
		    filterable: Boolean,
		    allowCreate: Boolean,
		    loading: Boolean,
		    popperClass: String,
		    remote: Boolean,
		    loadingText: String,
		    noMatchText: String,
		    noDataText: String,
		    remoteMethod: Function,
		    filterMethod: Function,
		    multiple: Boolean,
		    multipleLimit: {
		      type: Number,
		      default: 0
		    },
		    placeholder: {
		      type: String,
		      default: function _default() {
		        return (0, _locale3.t)('el.select.placeholder');
		      }
		    }
		  },
	
		  data: function data() {
		    return {
		      options: [],
		      cachedOptions: [],
		      createdOption: null,
		      createdSelected: false,
		      selected: this.multiple ? [] : {},
		      isSelect: true,
		      inputLength: 20,
		      inputWidth: 0,
		      cachedPlaceHolder: '',
		      optionsCount: 0,
		      filteredOptionsCount: 0,
		      dropdownUl: null,
		      visible: false,
		      selectedLabel: '',
		      hoverIndex: -1,
		      query: '',
		      bottomOverflowBeforeHidden: 0,
		      topOverflowBeforeHidden: 0,
		      optionsAllDisabled: false,
		      inputHovering: false,
		      currentPlaceholder: ''
		    };
		  },
	
	
		  watch: {
		    placeholder: function placeholder(val) {
		      this.currentPlaceholder = val;
		    },
		    value: function value(val) {
		      if (this.multiple) {
		        this.resetInputHeight();
		        if (val.length > 0 || this.$refs.input && this.query !== '') {
		          this.currentPlaceholder = '';
		        } else {
		          this.currentPlaceholder = this.cachedPlaceHolder;
		        }
		      }
		      this.setSelected();
		      if (this.filterable && !this.multiple) {
		        this.inputLength = 20;
		      }
		      this.$emit('change', val);
		      this.dispatch('ElFormItem', 'el.form.change', val);
		    },
		    query: function query(val) {
		      var _this2 = this;
	
		      this.$nextTick(function () {
		        if (_this2.visible) _this2.broadcast('ElSelectDropdown', 'updatePopper');
		      });
		      this.hoverIndex = -1;
		      if (this.multiple && this.filterable) {
		        this.resetInputHeight();
		      }
		      if (this.remote && typeof this.remoteMethod === 'function') {
		        this.hoverIndex = -1;
		        this.remoteMethod(val);
		        this.broadcast('ElOption', 'resetIndex');
		      } else if (typeof this.filterMethod === 'function') {
		        this.filterMethod(val);
		        this.broadcast('ElOptionGroup', 'queryChange');
		      } else {
		        this.filteredOptionsCount = this.optionsCount;
		        this.broadcast('ElOption', 'queryChange', val);
		        this.broadcast('ElOptionGroup', 'queryChange');
		      }
		    },
		    visible: function visible(val) {
		      var _this3 = this;
	
		      if (!val) {
		        this.$refs.reference.$el.querySelector('input').blur();
		        this.handleIconHide();
		        this.broadcast('ElSelectDropdown', 'destroyPopper');
		        if (this.$refs.input) {
		          this.$refs.input.blur();
		        }
		        this.query = '';
		        this.selectedLabel = '';
		        this.inputLength = 20;
		        this.resetHoverIndex();
		        this.$nextTick(function () {
		          if (_this3.$refs.input && _this3.$refs.input.value === '' && _this3.selected.length === 0) {
		            _this3.currentPlaceholder = _this3.cachedPlaceHolder;
		          }
		        });
		        if (!this.multiple) {
		          this.getOverflows();
		          if (this.selected) {
		            if (this.filterable && this.allowCreate && this.createdSelected && this.createdOption) {
		              this.selectedLabel = this.createdOption.currentLabel;
		            } else {
		              this.selectedLabel = this.selected.currentLabel;
		            }
		            if (this.filterable) this.query = this.selectedLabel;
		          }
		        }
		      } else {
		        this.handleIconShow();
		        this.broadcast('ElSelectDropdown', 'updatePopper');
		        if (this.filterable) {
		          this.query = this.selectedLabel;
		          if (this.multiple) {
		            this.$refs.input.focus();
		          } else {
		            if (!this.remote) {
		              this.broadcast('ElOption', 'queryChange', '');
		            }
		            this.broadcast('ElInput', 'inputSelect');
		          }
		        }
		        if (!this.dropdownUl) {
		          this.dropdownUl = this.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
		        }
		        if (!this.multiple && this.dropdownUl) {
		          this.setOverflow();
		        }
		      }
		      this.$emit('visible-change', val);
		    },
		    options: function options(val) {
		      if (this.$isServer) return;
		      this.optionsAllDisabled = val.length === val.filter(function (item) {
		        return item.disabled === true;
		      }).length;
		      if (this.multiple) {
		        this.resetInputHeight();
		      }
		      var inputs = this.$el.querySelectorAll('input');
		      if ([].indexOf.call(inputs, document.activeElement) === -1) {
		        this.setSelected();
		      }
		    }
		  },
	
		  methods: {
		    handleIconHide: function handleIconHide() {
		      var icon = this.$el.querySelector('.el-input__icon');
		      if (icon) {
		        (0, _dom.removeClass)(icon, 'is-reverse');
		      }
		    },
		    handleIconShow: function handleIconShow() {
		      var icon = this.$el.querySelector('.el-input__icon');
		      if (icon && !(0, _dom.hasClass)(icon, 'el-icon-circle-close')) {
		        (0, _dom.addClass)(icon, 'is-reverse');
		      }
		    },
		    getOverflows: function getOverflows() {
		      if (this.dropdownUl && this.selected && this.selected.$el) {
		        var selectedRect = this.selected.$el.getBoundingClientRect();
		        var popperRect = this.$refs.popper.$el.getBoundingClientRect();
		        this.bottomOverflowBeforeHidden = selectedRect.bottom - popperRect.bottom;
		        this.topOverflowBeforeHidden = selectedRect.top - popperRect.top;
		      }
		    },
		    setOverflow: function setOverflow() {
		      var _this4 = this;
	
		      if (this.bottomOverflowBeforeHidden > 0) {
		        this.$nextTick(function () {
		          _this4.dropdownUl.scrollTop += _this4.bottomOverflowBeforeHidden;
		        });
		      } else if (this.topOverflowBeforeHidden < 0) {
		        this.$nextTick(function () {
		          _this4.dropdownUl.scrollTop += _this4.topOverflowBeforeHidden;
		        });
		      }
		    },
		    getOption: function getOption(value) {
		      var option = void 0;
		      for (var i = this.cachedOptions.length - 1; i >= 0; i--) {
		        var cachedOption = this.cachedOptions[i];
		        if (cachedOption.value === value) {
		          option = cachedOption;
		          break;
		        }
		      }
		      if (option) return option;
		      var label = typeof value === 'string' || typeof value === 'number' ? value : '';
		      var newOption = {
		        value: value,
		        currentLabel: label
		      };
		      if (this.multiple) {
		        newOption.hitState = false;
		      }
		      return newOption;
		    },
		    setSelected: function setSelected() {
		      var _this5 = this;
	
		      if (!this.multiple) {
		        var option = this.getOption(this.value);
		        if (option.created) {
		          this.createdOption = (0, _merge2.default)({}, option);
		          this.createdSelected = true;
		        } else {
		          this.createdSelected = false;
		        }
		        this.selectedLabel = option.currentLabel;
		        this.selected = option;
		        if (this.filterable) this.query = this.selectedLabel;
		        return;
		      }
		      var result = [];
		      if (Array.isArray(this.value)) {
		        this.value.forEach(function (value) {
		          result.push(_this5.getOption(value));
		        });
		      }
		      this.selected = result;
		      this.$nextTick(function () {
		        _this5.resetInputHeight();
		      });
		    },
		    handleFocus: function handleFocus() {
		      this.visible = true;
		    },
		    handleIconClick: function handleIconClick(event) {
		      if (this.iconClass.indexOf('circle-close') > -1) {
		        this.deleteSelected(event);
		      } else {
		        this.toggleMenu();
		      }
		    },
		    handleMouseDown: function handleMouseDown(event) {
		      if (event.target.tagName !== 'INPUT') return;
		      if (this.visible) {
		        this.handleClose();
		        event.preventDefault();
		      }
		    },
		    doDestroy: function doDestroy() {
		      this.$refs.popper.doDestroy();
		    },
		    handleClose: function handleClose() {
		      this.visible = false;
		    },
		    toggleLastOptionHitState: function toggleLastOptionHitState(hit) {
		      if (!Array.isArray(this.selected)) return;
		      var option = this.selected[this.selected.length - 1];
		      if (!option) return;
	
		      if (hit === true || hit === false) {
		        option.hitState = hit;
		        return hit;
		      }
	
		      option.hitState = !option.hitState;
		      return option.hitState;
		    },
		    deletePrevTag: function deletePrevTag(e) {
		      if (e.target.value.length <= 0 && !this.toggleLastOptionHitState()) {
		        this.value.pop();
		      }
		    },
		    managePlaceholder: function managePlaceholder() {
		      if (this.currentPlaceholder !== '') {
		        this.currentPlaceholder = this.$refs.input.value ? '' : this.cachedPlaceHolder;
		      }
		    },
		    resetInputState: function resetInputState(e) {
		      if (e.keyCode !== 8) this.toggleLastOptionHitState(false);
		      this.inputLength = this.$refs.input.value.length * 15 + 20;
		      this.resetInputHeight();
		    },
		    resetInputHeight: function resetInputHeight() {
		      var _this6 = this;
	
		      this.$nextTick(function () {
		        var inputChildNodes = _this6.$refs.reference.$el.childNodes;
		        var input = [].filter.call(inputChildNodes, function (item) {
		          return item.tagName === 'INPUT';
		        })[0];
		        input.style.height = Math.max(_this6.$refs.tags.clientHeight + 6, sizeMap[_this6.size] || 36) + 'px';
		        if (_this6.visible && _this6.emptyText !== false) {
		          _this6.broadcast('ElSelectDropdown', 'updatePopper');
		        }
		      });
		    },
		    resetHoverIndex: function resetHoverIndex() {
		      var _this7 = this;
	
		      setTimeout(function () {
		        if (!_this7.multiple) {
		          _this7.hoverIndex = _this7.options.indexOf(_this7.selected);
		        } else {
		          if (_this7.selected.length > 0) {
		            _this7.hoverIndex = Math.min.apply(null, _this7.selected.map(function (item) {
		              return _this7.options.indexOf(item);
		            }));
		          } else {
		            _this7.hoverIndex = -1;
		          }
		        }
		      }, 300);
		    },
		    handleOptionSelect: function handleOptionSelect(option) {
		      if (!this.multiple) {
		        this.$emit('input', option.value);
		        this.visible = false;
		      } else {
		        var optionIndex = -1;
		        this.value.forEach(function (item, index) {
		          if (item === option.value) {
		            optionIndex = index;
		          }
		        });
		        if (optionIndex > -1) {
		          this.value.splice(optionIndex, 1);
		        } else if (this.multipleLimit <= 0 || this.value.length < this.multipleLimit) {
		          this.value.push(option.value);
		        }
		        if (option.created) {
		          this.query = '';
		          this.inputLength = 20;
		        }
		        if (this.filterable) this.$refs.input.focus();
		      }
		    },
		    toggleMenu: function toggleMenu() {
		      if (this.filterable && this.query === '' && this.visible) {
		        return;
		      }
		      if (!this.disabled) {
		        this.visible = !this.visible;
		      }
		    },
		    navigateOptions: function navigateOptions(direction) {
		      if (!this.visible) {
		        this.visible = true;
		        return;
		      }
		      if (this.options.length === 0 || this.filteredOptionsCount === 0) return;
		      if (!this.optionsAllDisabled) {
		        if (direction === 'next') {
		          this.hoverIndex++;
		          if (this.hoverIndex === this.options.length) {
		            this.hoverIndex = 0;
		          }
		          this.resetScrollTop();
		          if (this.options[this.hoverIndex].disabled === true || this.options[this.hoverIndex].groupDisabled === true || !this.options[this.hoverIndex].visible) {
		            this.navigateOptions('next');
		          }
		        }
		        if (direction === 'prev') {
		          this.hoverIndex--;
		          if (this.hoverIndex < 0) {
		            this.hoverIndex = this.options.length - 1;
		          }
		          this.resetScrollTop();
		          if (this.options[this.hoverIndex].disabled === true || this.options[this.hoverIndex].groupDisabled === true || !this.options[this.hoverIndex].visible) {
		            this.navigateOptions('prev');
		          }
		        }
		      }
		    },
		    resetScrollTop: function resetScrollTop() {
		      var bottomOverflowDistance = this.options[this.hoverIndex].$el.getBoundingClientRect().bottom - this.$refs.popper.$el.getBoundingClientRect().bottom;
		      var topOverflowDistance = this.options[this.hoverIndex].$el.getBoundingClientRect().top - this.$refs.popper.$el.getBoundingClientRect().top;
		      if (bottomOverflowDistance > 0) {
		        this.dropdownUl.scrollTop += bottomOverflowDistance;
		      }
		      if (topOverflowDistance < 0) {
		        this.dropdownUl.scrollTop += topOverflowDistance;
		      }
		    },
		    selectOption: function selectOption() {
		      if (this.options[this.hoverIndex]) {
		        this.handleOptionSelect(this.options[this.hoverIndex]);
		      }
		    },
		    deleteSelected: function deleteSelected(event) {
		      event.stopPropagation();
		      this.$emit('input', '');
		      this.visible = false;
		    },
		    deleteTag: function deleteTag(event, tag) {
		      var index = this.selected.indexOf(tag);
		      if (index > -1 && !this.disabled) {
		        this.value.splice(index, 1);
		      }
		      event.stopPropagation();
		    },
		    onInputChange: function onInputChange() {
		      if (this.filterable) {
		        this.query = this.selectedLabel;
		      }
		    },
		    onOptionDestroy: function onOptionDestroy(option) {
		      this.optionsCount--;
		      this.filteredOptionsCount--;
		      var index = this.options.indexOf(option);
		      if (index > -1) {
		        this.options.splice(index, 1);
		      }
		      this.broadcast('ElOption', 'resetIndex');
		    },
		    resetInputWidth: function resetInputWidth() {
		      this.inputWidth = this.$refs.reference.$el.getBoundingClientRect().width;
		    },
		    handleResize: function handleResize() {
		      this.resetInputWidth();
		      if (this.multiple) this.resetInputHeight();
		    }
		  },
	
		  created: function created() {
		    var _this8 = this;
	
		    this.cachedPlaceHolder = this.currentPlaceholder = this.placeholder;
		    if (this.multiple && !Array.isArray(this.value)) {
		      this.$emit('input', []);
		    }
		    if (!this.multiple && Array.isArray(this.value)) {
		      this.$emit('input', '');
		    }
		    this.setSelected();
	
		    this.debouncedOnInputChange = (0, _debounce2.default)(this.debounce, function () {
		      _this8.onInputChange();
		    });
	
		    this.$on('handleOptionClick', this.handleOptionSelect);
		    this.$on('onOptionDestroy', this.onOptionDestroy);
		    this.$on('setSelected', this.setSelected);
		  },
		  mounted: function mounted() {
		    var _this9 = this;
	
		    if (this.multiple && Array.isArray(this.value) && this.value.length > 0) {
		      this.currentPlaceholder = '';
		    }
		    (0, _resizeEvent.addResizeListener)(this.$el, this.handleResize);
		    if (this.remote && this.multiple) {
		      this.resetInputHeight();
		    }
		    this.$nextTick(function () {
		      if (_this9.$refs.reference.$el) {
		        _this9.inputWidth = _this9.$refs.reference.$el.getBoundingClientRect().width;
		      }
		    });
		  },
		  destroyed: function destroyed() {
		    if (this.handleResize) (0, _resizeEvent.removeResizeListener)(this.$el, this.handleResize);
		  }
		};
	
	/***/ },
	
	/***/ 236:
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(237)
	
		/* template */
		var __vue_template__ = __webpack_require__(238)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	
	/***/ 237:
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _vuePopper = __webpack_require__(12);
	
		var _vuePopper2 = _interopRequireDefault(_vuePopper);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  name: 'ElSelectDropdown',
	
		  componentName: 'ElSelectDropdown',
	
		  mixins: [_vuePopper2.default],
	
		  props: {
		    placement: {
		      default: 'bottom-start'
		    },
	
		    boundariesPadding: {
		      default: 0
		    },
	
		    options: {
		      default: function _default() {
		        return {
		          forceAbsolute: true,
		          gpuAcceleration: false
		        };
		      }
		    }
		  },
	
		  data: function data() {
		    return {
		      minWidth: ''
		    };
		  },
	
	
		  computed: {
		    popperClass: function popperClass() {
		      return this.$parent.popperClass;
		    }
		  },
	
		  watch: {
		    '$parent.inputWidth': function $parentInputWidth() {
		      this.minWidth = this.$parent.$el.getBoundingClientRect().width + 'px';
		    }
		  },
	
		  mounted: function mounted() {
		    this.referenceElm = this.$parent.$refs.reference.$el;
		    this.$parent.popperElm = this.popperElm = this.$el;
		    this.$on('updatePopper', this.updatePopper);
		    this.$on('destroyPopper', this.destroyPopper);
		  }
		}; //
		//
		//
		//
		//
		//
		//
		//
		//
	
	/***/ },
	
	/***/ 238:
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    staticClass: "el-select-dropdown",
		    class: [{
		      'is-multiple': _vm.$parent.multiple
		    }, _vm.popperClass],
		    style: ({
		      minWidth: _vm.minWidth
		    })
		  }, [_vm._t("default")], 2)
		},staticRenderFns: []}
	
	/***/ },
	
	/***/ 239:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(145);
	
	/***/ },
	
	/***/ 240:
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    directives: [{
		      name: "clickoutside",
		      rawName: "v-clickoutside",
		      value: (_vm.handleClose),
		      expression: "handleClose"
		    }],
		    staticClass: "el-select"
		  }, [(_vm.multiple) ? _c('div', {
		    ref: "tags",
		    staticClass: "el-select__tags",
		    style: ({
		      'max-width': _vm.inputWidth - 32 + 'px'
		    }),
		    on: {
		      "click": function($event) {
		        $event.stopPropagation();
		        _vm.toggleMenu($event)
		      }
		    }
		  }, [_c('transition-group', {
		    on: {
		      "after-leave": _vm.resetInputHeight
		    }
		  }, _vm._l((_vm.selected), function(item) {
		    return _c('el-tag', {
		      key: item.value,
		      attrs: {
		        "closable": "",
		        "hit": item.hitState,
		        "type": "primary",
		        "close-transition": ""
		      },
		      on: {
		        "close": function($event) {
		          _vm.deleteTag($event, item)
		        }
		      }
		    }, [_vm._v("\n        " + _vm._s(item.currentLabel) + "\n      ")])
		  })), (_vm.filterable) ? _c('input', {
		    directives: [{
		      name: "model",
		      rawName: "v-model",
		      value: (_vm.query),
		      expression: "query"
		    }],
		    ref: "input",
		    staticClass: "el-select__input",
		    class: ("is-" + _vm.size),
		    style: ({
		      width: _vm.inputLength + 'px',
		      'max-width': _vm.inputWidth - 42 + 'px'
		    }),
		    attrs: {
		      "type": "text",
		      "disabled": _vm.disabled,
		      "debounce": _vm.remote ? 300 : 0
		    },
		    domProps: {
		      "value": _vm._s(_vm.query)
		    },
		    on: {
		      "focus": function($event) {
		        _vm.visible = true
		      },
		      "keyup": _vm.managePlaceholder,
		      "keydown": [_vm.resetInputState, function($event) {
		        if (_vm._k($event.keyCode, "down", 40)) { return; }
		        $event.preventDefault();
		        _vm.navigateOptions('next')
		      }, function($event) {
		        if (_vm._k($event.keyCode, "up", 38)) { return; }
		        $event.preventDefault();
		        _vm.navigateOptions('prev')
		      }, function($event) {
		        if (_vm._k($event.keyCode, "enter", 13)) { return; }
		        $event.preventDefault();
		        _vm.selectOption($event)
		      }, function($event) {
		        if (_vm._k($event.keyCode, "esc", 27)) { return; }
		        $event.preventDefault();
		        _vm.visible = false
		      }, function($event) {
		        if (_vm._k($event.keyCode, "delete", [8, 46])) { return; }
		        _vm.deletePrevTag($event)
		      }],
		      "input": function($event) {
		        if ($event.target.composing) { return; }
		        _vm.query = $event.target.value
		      }
		    }
		  }) : _vm._e()], 1) : _vm._e(), _c('el-input', {
		    directives: [{
		      name: "model",
		      rawName: "v-model",
		      value: (_vm.selectedLabel),
		      expression: "selectedLabel"
		    }],
		    ref: "reference",
		    attrs: {
		      "type": "text",
		      "placeholder": _vm.currentPlaceholder,
		      "name": _vm.name,
		      "size": _vm.size,
		      "disabled": _vm.disabled,
		      "readonly": !_vm.filterable || _vm.multiple,
		      "validate-event": false,
		      "icon": _vm.iconClass
		    },
		    domProps: {
		      "value": (_vm.selectedLabel)
		    },
		    on: {
		      "focus": _vm.handleFocus,
		      "click": _vm.handleIconClick,
		      "input": function($event) {
		        _vm.selectedLabel = $event
		      }
		    },
		    nativeOn: {
		      "mousedown": function($event) {
		        _vm.handleMouseDown($event)
		      },
		      "keyup": function($event) {
		        _vm.debouncedOnInputChange($event)
		      },
		      "keydown": [function($event) {
		        if (_vm._k($event.keyCode, "down", 40)) { return; }
		        $event.preventDefault();
		        _vm.navigateOptions('next')
		      }, function($event) {
		        if (_vm._k($event.keyCode, "up", 38)) { return; }
		        $event.preventDefault();
		        _vm.navigateOptions('prev')
		      }, function($event) {
		        if (_vm._k($event.keyCode, "enter", 13)) { return; }
		        $event.preventDefault();
		        _vm.selectOption($event)
		      }, function($event) {
		        if (_vm._k($event.keyCode, "esc", 27)) { return; }
		        $event.preventDefault();
		        _vm.visible = false
		      }, function($event) {
		        if (_vm._k($event.keyCode, "tab", 9)) { return; }
		        _vm.visible = false
		      }],
		      "mouseenter": function($event) {
		        _vm.inputHovering = true
		      },
		      "mouseleave": function($event) {
		        _vm.inputHovering = false
		      }
		    }
		  }), _c('transition', {
		    attrs: {
		      "name": "el-zoom-in-top"
		    },
		    on: {
		      "after-leave": _vm.doDestroy
		    }
		  }, [_c('el-select-menu', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.visible && _vm.emptyText !== false),
		      expression: "visible && emptyText !== false"
		    }],
		    ref: "popper"
		  }, [_c('el-scrollbar', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (_vm.options.length > 0 && !_vm.loading),
		      expression: "options.length > 0 && !loading"
		    }],
		    class: {
		      'is-empty': !_vm.allowCreate && _vm.filteredOptionsCount === 0
		    },
		    attrs: {
		      "tag": "ul",
		      "wrap-class": "el-select-dropdown__wrap",
		      "view-class": "el-select-dropdown__list"
		    }
		  }, [(_vm.showNewOption) ? _c('el-option', {
		    attrs: {
		      "value": _vm.query,
		      "created": ""
		    }
		  }) : _vm._e(), _vm._t("default")], 2), (_vm.emptyText && !_vm.allowCreate) ? _c('p', {
		    staticClass: "el-select-dropdown__empty"
		  }, [_vm._v(_vm._s(_vm.emptyText))]) : _vm._e()], 1)], 1)], 1)
		},staticRenderFns: []}
	
	/***/ }
	
	/******/ });

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(308);
	
	
	/***/ },
	
	/***/ 12:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(105);
	
	/***/ },
	
	/***/ 308:
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _main = __webpack_require__(309);
	
		var _main2 = _interopRequireDefault(_main);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* istanbul ignore next */
		_main2.default.install = function (Vue) {
		  Vue.component(_main2.default.name, _main2.default);
		};
	
		exports.default = _main2.default;
	
	/***/ },
	
	/***/ 309:
	/***/ function(module, exports, __webpack_require__) {
	
		var __vue_exports__, __vue_options__
		var __vue_styles__ = {}
	
		/* script */
		__vue_exports__ = __webpack_require__(310)
	
		/* template */
		var __vue_template__ = __webpack_require__(311)
		__vue_options__ = __vue_exports__ = __vue_exports__ || {}
		if (
		  typeof __vue_exports__.default === "object" ||
		  typeof __vue_exports__.default === "function"
		) {
		__vue_options__ = __vue_exports__ = __vue_exports__.default
		}
		if (typeof __vue_options__ === "function") {
		  __vue_options__ = __vue_options__.options
		}
	
		__vue_options__.render = __vue_template__.render
		__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
		module.exports = __vue_exports__
	
	
	/***/ },
	
	/***/ 310:
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _vuePopper = __webpack_require__(12);
	
		var _vuePopper2 = _interopRequireDefault(_vuePopper);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = {
		  name: 'ElTooltip',
	
		  mixins: [_vuePopper2.default],
	
		  props: {
		    openDelay: {
		      type: Number,
		      default: 0
		    },
		    disabled: Boolean,
		    manual: Boolean,
		    effect: {
		      type: String,
		      default: 'dark'
		    },
		    popperClass: String,
		    content: String,
		    visibleArrow: {
		      default: true
		    },
		    transition: {
		      type: String,
		      default: 'fade-in-linear'
		    },
		    options: {
		      default: function _default() {
		        return {
		          boundariesPadding: 10,
		          gpuAcceleration: false
		        };
		      }
		    }
		  },
	
		  methods: {
		    handleShowPopper: function handleShowPopper() {
		      var _this = this;
	
		      if (this.manual) return;
		      this.timeout = setTimeout(function () {
		        _this.showPopper = true;
		      }, this.openDelay);
		    },
		    handleClosePopper: function handleClosePopper() {
		      if (this.manual) return;
		      clearTimeout(this.timeout);
		      this.showPopper = false;
		    }
		  }
		}; //
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
		//
	
	/***/ },
	
	/***/ 311:
	/***/ function(module, exports) {
	
		module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
		  return _c('div', {
		    staticClass: "el-tooltip",
		    on: {
		      "mouseenter": _vm.handleShowPopper,
		      "mouseleave": _vm.handleClosePopper
		    }
		  }, [_c('div', {
		    ref: "reference",
		    staticClass: "el-tooltip__rel"
		  }, [_vm._t("default")], 2), _c('transition', {
		    attrs: {
		      "name": _vm.transition
		    },
		    on: {
		      "after-leave": _vm.doDestroy
		    }
		  }, [_c('div', {
		    directives: [{
		      name: "show",
		      rawName: "v-show",
		      value: (!_vm.disabled && _vm.showPopper),
		      expression: "!disabled && showPopper"
		    }],
		    ref: "popper",
		    staticClass: "el-tooltip__popper",
		    class: ['is-' + _vm.effect, _vm.popperClass]
		  }, [_vm._t("content", [_c('div', {
		    domProps: {
		      "textContent": _vm._s(_vm.content)
		    }
		  })])], 2)])], 1)
		},staticRenderFns: []}
	
	/***/ }
	
	/******/ });

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _dom = __webpack_require__(47);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Transition = function () {
	  function Transition() {
	    _classCallCheck(this, Transition);
	  }
	
	  Transition.prototype.beforeEnter = function beforeEnter(el) {
	    (0, _dom.addClass)(el, 'collapse-transition');
	    if (!el.dataset) el.dataset = {};
	
	    el.dataset.oldPaddingTop = el.style.paddingTop;
	    el.dataset.oldPaddingBottom = el.style.paddingBottom;
	
	    el.style.height = '0';
	    el.style.paddingTop = 0;
	    el.style.paddingBottom = 0;
	  };
	
	  Transition.prototype.enter = function enter(el) {
	    el.dataset.oldOverflow = el.style.overflow;
	    if (el.scrollHeight !== 0) {
	      el.style.height = el.scrollHeight + 'px';
	      el.style.paddingTop = el.dataset.oldPaddingTop;
	      el.style.paddingBottom = el.dataset.oldPaddingBottom;
	    } else {
	      el.style.height = '';
	      el.style.paddingTop = el.dataset.oldPaddingTop;
	      el.style.paddingBottom = el.dataset.oldPaddingBottom;
	    }
	
	    el.style.overflow = 'hidden';
	  };
	
	  Transition.prototype.afterEnter = function afterEnter(el) {
	    // for safari: remove class then reset height is necessary
	    (0, _dom.removeClass)(el, 'collapse-transition');
	    el.style.height = '';
	    el.style.overflow = el.dataset.oldOverflow;
	  };
	
	  Transition.prototype.beforeLeave = function beforeLeave(el) {
	    if (!el.dataset) el.dataset = {};
	    el.dataset.oldPaddingTop = el.style.paddingTop;
	    el.dataset.oldPaddingBottom = el.style.paddingBottom;
	    el.dataset.oldOverflow = el.style.overflow;
	
	    el.style.height = el.scrollHeight + 'px';
	    el.style.overflow = 'hidden';
	  };
	
	  Transition.prototype.leave = function leave(el) {
	    if (el.scrollHeight !== 0) {
	      // for safari: add class after set height, or it will jump to zero height suddenly, weired
	      (0, _dom.addClass)(el, 'collapse-transition');
	      el.style.height = 0;
	      el.style.paddingTop = 0;
	      el.style.paddingBottom = 0;
	    }
	  };
	
	  Transition.prototype.afterLeave = function afterLeave(el) {
	    (0, _dom.removeClass)(el, 'collapse-transition');
	    el.style.height = '';
	    el.style.overflow = el.dataset.oldOverflow;
	    el.style.paddingTop = el.dataset.oldPaddingTop;
	    el.style.paddingBottom = el.dataset.oldPaddingBottom;
	  };
	
	  return Transition;
	}();
	
	exports.default = {
	  functional: true,
	  render: function render(h, _ref) {
	    var children = _ref.children;
	
	    var data = {
	      on: new Transition()
	    };
	
	    return h('transition', data, children);
	  }
	};

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/*eslint-disable*/
	// 把 YYYY-MM-DD 改成了 yyyy-MM-dd
	(function (main) {
	  'use strict';
	
	  /**
	   * Parse or format dates
	   * @class fecha
	   */
	
	  var fecha = {};
	  var token = /d{1,4}|M{1,4}|yy(?:yy)?|S{1,3}|Do|ZZ|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g;
	  var twoDigits = /\d\d?/;
	  var threeDigits = /\d{3}/;
	  var fourDigits = /\d{4}/;
	  var word = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	  var noop = function noop() {};
	
	  function shorten(arr, sLen) {
	    var newArr = [];
	    for (var i = 0, len = arr.length; i < len; i++) {
	      newArr.push(arr[i].substr(0, sLen));
	    }
	    return newArr;
	  }
	
	  function monthUpdate(arrName) {
	    return function (d, v, i18n) {
	      var index = i18n[arrName].indexOf(v.charAt(0).toUpperCase() + v.substr(1).toLowerCase());
	      if (~index) {
	        d.month = index;
	      }
	    };
	  }
	
	  function pad(val, len) {
	    val = String(val);
	    len = len || 2;
	    while (val.length < len) {
	      val = '0' + val;
	    }
	    return val;
	  }
	
	  var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	  var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	  var monthNamesShort = shorten(monthNames, 3);
	  var dayNamesShort = shorten(dayNames, 3);
	  fecha.i18n = {
	    dayNamesShort: dayNamesShort,
	    dayNames: dayNames,
	    monthNamesShort: monthNamesShort,
	    monthNames: monthNames,
	    amPm: ['am', 'pm'],
	    DoFn: function DoFn(D) {
	      return D + ['th', 'st', 'nd', 'rd'][D % 10 > 3 ? 0 : (D - D % 10 !== 10) * D % 10];
	    }
	  };
	
	  var formatFlags = {
	    D: function D(dateObj) {
	      return dateObj.getDay();
	    },
	    DD: function DD(dateObj) {
	      return pad(dateObj.getDay());
	    },
	    Do: function Do(dateObj, i18n) {
	      return i18n.DoFn(dateObj.getDate());
	    },
	    d: function d(dateObj) {
	      return dateObj.getDate();
	    },
	    dd: function dd(dateObj) {
	      return pad(dateObj.getDate());
	    },
	    ddd: function ddd(dateObj, i18n) {
	      return i18n.dayNamesShort[dateObj.getDay()];
	    },
	    dddd: function dddd(dateObj, i18n) {
	      return i18n.dayNames[dateObj.getDay()];
	    },
	    M: function M(dateObj) {
	      return dateObj.getMonth() + 1;
	    },
	    MM: function MM(dateObj) {
	      return pad(dateObj.getMonth() + 1);
	    },
	    MMM: function MMM(dateObj, i18n) {
	      return i18n.monthNamesShort[dateObj.getMonth()];
	    },
	    MMMM: function MMMM(dateObj, i18n) {
	      return i18n.monthNames[dateObj.getMonth()];
	    },
	    yy: function yy(dateObj) {
	      return String(dateObj.getFullYear()).substr(2);
	    },
	    yyyy: function yyyy(dateObj) {
	      return dateObj.getFullYear();
	    },
	    h: function h(dateObj) {
	      return dateObj.getHours() % 12 || 12;
	    },
	    hh: function hh(dateObj) {
	      return pad(dateObj.getHours() % 12 || 12);
	    },
	    H: function H(dateObj) {
	      return dateObj.getHours();
	    },
	    HH: function HH(dateObj) {
	      return pad(dateObj.getHours());
	    },
	    m: function m(dateObj) {
	      return dateObj.getMinutes();
	    },
	    mm: function mm(dateObj) {
	      return pad(dateObj.getMinutes());
	    },
	    s: function s(dateObj) {
	      return dateObj.getSeconds();
	    },
	    ss: function ss(dateObj) {
	      return pad(dateObj.getSeconds());
	    },
	    S: function S(dateObj) {
	      return Math.round(dateObj.getMilliseconds() / 100);
	    },
	    SS: function SS(dateObj) {
	      return pad(Math.round(dateObj.getMilliseconds() / 10), 2);
	    },
	    SSS: function SSS(dateObj) {
	      return pad(dateObj.getMilliseconds(), 3);
	    },
	    a: function a(dateObj, i18n) {
	      return dateObj.getHours() < 12 ? i18n.amPm[0] : i18n.amPm[1];
	    },
	    A: function A(dateObj, i18n) {
	      return dateObj.getHours() < 12 ? i18n.amPm[0].toUpperCase() : i18n.amPm[1].toUpperCase();
	    },
	    ZZ: function ZZ(dateObj) {
	      var o = dateObj.getTimezoneOffset();
	      return (o > 0 ? '-' : '+') + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4);
	    }
	  };
	
	  var parseFlags = {
	    d: [twoDigits, function (d, v) {
	      d.day = v;
	    }],
	    M: [twoDigits, function (d, v) {
	      d.month = v - 1;
	    }],
	    yy: [twoDigits, function (d, v) {
	      var da = new Date(),
	          cent = +('' + da.getFullYear()).substr(0, 2);
	      d.year = '' + (v > 68 ? cent - 1 : cent) + v;
	    }],
	    h: [twoDigits, function (d, v) {
	      d.hour = v;
	    }],
	    m: [twoDigits, function (d, v) {
	      d.minute = v;
	    }],
	    s: [twoDigits, function (d, v) {
	      d.second = v;
	    }],
	    yyyy: [fourDigits, function (d, v) {
	      d.year = v;
	    }],
	    S: [/\d/, function (d, v) {
	      d.millisecond = v * 100;
	    }],
	    SS: [/\d{2}/, function (d, v) {
	      d.millisecond = v * 10;
	    }],
	    SSS: [threeDigits, function (d, v) {
	      d.millisecond = v;
	    }],
	    D: [twoDigits, noop],
	    ddd: [word, noop],
	    MMM: [word, monthUpdate('monthNamesShort')],
	    MMMM: [word, monthUpdate('monthNames')],
	    a: [word, function (d, v, i18n) {
	      var val = v.toLowerCase();
	      if (val === i18n.amPm[0]) {
	        d.isPm = false;
	      } else if (val === i18n.amPm[1]) {
	        d.isPm = true;
	      }
	    }],
	    ZZ: [/[\+\-]\d\d:?\d\d/, function (d, v) {
	      var parts = (v + '').match(/([\+\-]|\d\d)/gi),
	          minutes;
	
	      if (parts) {
	        minutes = +(parts[1] * 60) + parseInt(parts[2], 10);
	        d.timezoneOffset = parts[0] === '+' ? minutes : -minutes;
	      }
	    }]
	  };
	  parseFlags.DD = parseFlags.D;
	  parseFlags.dddd = parseFlags.ddd;
	  parseFlags.Do = parseFlags.dd = parseFlags.d;
	  parseFlags.mm = parseFlags.m;
	  parseFlags.hh = parseFlags.H = parseFlags.HH = parseFlags.h;
	  parseFlags.MM = parseFlags.M;
	  parseFlags.ss = parseFlags.s;
	  parseFlags.A = parseFlags.a;
	
	  // Some common format strings
	  fecha.masks = {
	    'default': 'ddd MMM dd yyyy HH:mm:ss',
	    shortDate: 'M/D/yy',
	    mediumDate: 'MMM d, yyyy',
	    longDate: 'MMMM d, yyyy',
	    fullDate: 'dddd, MMMM d, yyyy',
	    shortTime: 'HH:mm',
	    mediumTime: 'HH:mm:ss',
	    longTime: 'HH:mm:ss.SSS'
	  };
	
	  /***
	   * Format a date
	   * @method format
	   * @param {Date|number} dateObj
	   * @param {string} mask Format of the date, i.e. 'mm-dd-yy' or 'shortDate'
	   */
	  fecha.format = function (dateObj, mask, i18nSettings) {
	    var i18n = i18nSettings || fecha.i18n;
	
	    if (typeof dateObj === 'number') {
	      dateObj = new Date(dateObj);
	    }
	
	    if (Object.prototype.toString.call(dateObj) !== '[object Date]' || isNaN(dateObj.getTime())) {
	      throw new Error('Invalid Date in fecha.format');
	    }
	
	    mask = fecha.masks[mask] || mask || fecha.masks['default'];
	
	    return mask.replace(token, function ($0) {
	      return $0 in formatFlags ? formatFlags[$0](dateObj, i18n) : $0.slice(1, $0.length - 1);
	    });
	  };
	
	  /**
	   * Parse a date string into an object, changes - into /
	   * @method parse
	   * @param {string} dateStr Date string
	   * @param {string} format Date parse format
	   * @returns {Date|boolean}
	   */
	  fecha.parse = function (dateStr, format, i18nSettings) {
	    var i18n = i18nSettings || fecha.i18n;
	
	    if (typeof format !== 'string') {
	      throw new Error('Invalid format in fecha.parse');
	    }
	
	    format = fecha.masks[format] || format;
	
	    // Avoid regular expression denial of service, fail early for really long strings
	    // https://www.owasp.org/index.php/Regular_expression_Denial_of_Service_-_ReDoS
	    if (dateStr.length > 1000) {
	      return false;
	    }
	
	    var isValid = true;
	    var dateInfo = {};
	    format.replace(token, function ($0) {
	      if (parseFlags[$0]) {
	        var info = parseFlags[$0];
	        var index = dateStr.search(info[0]);
	        if (!~index) {
	          isValid = false;
	        } else {
	          dateStr.replace(info[0], function (result) {
	            info[1](dateInfo, result, i18n);
	            dateStr = dateStr.substr(index + result.length);
	            return result;
	          });
	        }
	      }
	
	      return parseFlags[$0] ? '' : $0.slice(1, $0.length - 1);
	    });
	
	    if (!isValid) {
	      return false;
	    }
	
	    var today = new Date();
	    if (dateInfo.isPm === true && dateInfo.hour != null && +dateInfo.hour !== 12) {
	      dateInfo.hour = +dateInfo.hour + 12;
	    } else if (dateInfo.isPm === false && +dateInfo.hour === 12) {
	      dateInfo.hour = 0;
	    }
	
	    var date;
	    if (dateInfo.timezoneOffset != null) {
	      dateInfo.minute = +(dateInfo.minute || 0) - +dateInfo.timezoneOffset;
	      date = new Date(Date.UTC(dateInfo.year || today.getFullYear(), dateInfo.month || 0, dateInfo.day || 1, dateInfo.hour || 0, dateInfo.minute || 0, dateInfo.second || 0, dateInfo.millisecond || 0));
	    } else {
	      date = new Date(dateInfo.year || today.getFullYear(), dateInfo.month || 0, dateInfo.day || 1, dateInfo.hour || 0, dateInfo.minute || 0, dateInfo.second || 0, dateInfo.millisecond || 0);
	    }
	    return date;
	  };
	
	  /* istanbul ignore next */
	  if (typeof module !== 'undefined' && module.exports) {
	    module.exports = fecha;
	  } else if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return fecha;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    main.fecha = fecha;
	  }
	})(undefined);

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version {{version}}
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	
	//
	// Cross module loader
	// Supported: Node, AMD, Browser globals
	//
	;(function (root, factory) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
	        // Node. Does not work with strict CommonJS, but
	        // only CommonJS-like environments that support module.exports,
	        // like Node.
	        module.exports = factory();
	    } else {
	        // Browser globals (root is window)
	        root.Popper = factory();
	    }
	})(undefined, function () {
	
	    'use strict';
	
	    var root = window;
	
	    // default options
	    var DEFAULTS = {
	        // placement of the popper
	        placement: 'bottom',
	
	        gpuAcceleration: true,
	
	        // shift popper from its origin by the given amount of pixels (can be negative)
	        offset: 0,
	
	        // the element which will act as boundary of the popper
	        boundariesElement: 'viewport',
	
	        // amount of pixel used to define a minimum distance between the boundaries and the popper
	        boundariesPadding: 5,
	
	        // popper will try to prevent overflow following this order,
	        // by default, then, it could overflow on the left and on top of the boundariesElement
	        preventOverflowOrder: ['left', 'right', 'top', 'bottom'],
	
	        // the behavior used by flip to change the placement of the popper
	        flipBehavior: 'flip',
	
	        arrowElement: '[x-arrow]',
	
	        // list of functions used to modify the offsets before they are applied to the popper
	        modifiers: ['shift', 'offset', 'preventOverflow', 'keepTogether', 'arrow', 'flip', 'applyStyle'],
	
	        modifiersIgnored: [],
	
	        forceAbsolute: false
	    };
	
	    /**
	     * Create a new Popper.js instance
	     * @constructor Popper
	     * @param {HTMLElement} reference - The reference element used to position the popper
	     * @param {HTMLElement|Object} popper
	     *      The HTML element used as popper, or a configuration used to generate the popper.
	     * @param {String} [popper.tagName='div'] The tag name of the generated popper.
	     * @param {Array} [popper.classNames=['popper']] Array of classes to apply to the generated popper.
	     * @param {Array} [popper.attributes] Array of attributes to apply, specify `attr:value` to assign a value to it.
	     * @param {HTMLElement|String} [popper.parent=window.document.body] The parent element, given as HTMLElement or as query string.
	     * @param {String} [popper.content=''] The content of the popper, it can be text, html, or node; if it is not text, set `contentType` to `html` or `node`.
	     * @param {String} [popper.contentType='text'] If `html`, the `content` will be parsed as HTML. If `node`, it will be appended as-is.
	     * @param {String} [popper.arrowTagName='div'] Same as `popper.tagName` but for the arrow element.
	     * @param {Array} [popper.arrowClassNames='popper__arrow'] Same as `popper.classNames` but for the arrow element.
	     * @param {String} [popper.arrowAttributes=['x-arrow']] Same as `popper.attributes` but for the arrow element.
	     * @param {Object} options
	     * @param {String} [options.placement=bottom]
	     *      Placement of the popper accepted values: `top(-start, -end), right(-start, -end), bottom(-start, -right),
	     *      left(-start, -end)`
	     *
	     * @param {HTMLElement|String} [options.arrowElement='[x-arrow]']
	     *      The DOM Node used as arrow for the popper, or a CSS selector used to get the DOM node. It must be child of
	     *      its parent Popper. Popper.js will apply to the given element the style required to align the arrow with its
	     *      reference element.
	     *      By default, it will look for a child node of the popper with the `x-arrow` attribute.
	     *
	     * @param {Boolean} [options.gpuAcceleration=true]
	     *      When this property is set to true, the popper position will be applied using CSS3 translate3d, allowing the
	     *      browser to use the GPU to accelerate the rendering.
	     *      If set to false, the popper will be placed using `top` and `left` properties, not using the GPU.
	     *
	     * @param {Number} [options.offset=0]
	     *      Amount of pixels the popper will be shifted (can be negative).
	     *
	     * @param {String|Element} [options.boundariesElement='viewport']
	     *      The element which will define the boundaries of the popper position, the popper will never be placed outside
	     *      of the defined boundaries (except if `keepTogether` is enabled)
	     *
	     * @param {Number} [options.boundariesPadding=5]
	     *      Additional padding for the boundaries
	     *
	     * @param {Array} [options.preventOverflowOrder=['left', 'right', 'top', 'bottom']]
	     *      Order used when Popper.js tries to avoid overflows from the boundaries, they will be checked in order,
	     *      this means that the last ones will never overflow
	     *
	     * @param {String|Array} [options.flipBehavior='flip']
	     *      The behavior used by the `flip` modifier to change the placement of the popper when the latter is trying to
	     *      overlap its reference element. Defining `flip` as value, the placement will be flipped on
	     *      its axis (`right - left`, `top - bottom`).
	     *      You can even pass an array of placements (eg: `['right', 'left', 'top']` ) to manually specify
	     *      how alter the placement when a flip is needed. (eg. in the above example, it would first flip from right to left,
	     *      then, if even in its new placement, the popper is overlapping its reference element, it will be moved to top)
	     *
	     * @param {Array} [options.modifiers=[ 'shift', 'offset', 'preventOverflow', 'keepTogether', 'arrow', 'flip', 'applyStyle']]
	     *      List of functions used to modify the data before they are applied to the popper, add your custom functions
	     *      to this array to edit the offsets and placement.
	     *      The function should reflect the @params and @returns of preventOverflow
	     *
	     * @param {Array} [options.modifiersIgnored=[]]
	     *      Put here any built-in modifier name you want to exclude from the modifiers list
	     *      The function should reflect the @params and @returns of preventOverflow
	     *
	     * @param {Boolean} [options.removeOnDestroy=false]
	     *      Set to true if you want to automatically remove the popper when you call the `destroy` method.
	     */
	    function Popper(reference, popper, options) {
	        this._reference = reference.jquery ? reference[0] : reference;
	        this.state = {};
	
	        // if the popper variable is a configuration object, parse it to generate an HTMLElement
	        // generate a default popper if is not defined
	        var isNotDefined = typeof popper === 'undefined' || popper === null;
	        var isConfig = popper && Object.prototype.toString.call(popper) === '[object Object]';
	        if (isNotDefined || isConfig) {
	            this._popper = this.parse(isConfig ? popper : {});
	        }
	        // otherwise, use the given HTMLElement as popper
	        else {
	                this._popper = popper.jquery ? popper[0] : popper;
	            }
	
	        // with {} we create a new object with the options inside it
	        this._options = Object.assign({}, DEFAULTS, options);
	
	        // refactoring modifiers' list
	        this._options.modifiers = this._options.modifiers.map(function (modifier) {
	            // remove ignored modifiers
	            if (this._options.modifiersIgnored.indexOf(modifier) !== -1) return;
	
	            // set the x-placement attribute before everything else because it could be used to add margins to the popper
	            // margins needs to be calculated to get the correct popper offsets
	            if (modifier === 'applyStyle') {
	                this._popper.setAttribute('x-placement', this._options.placement);
	            }
	
	            // return predefined modifier identified by string or keep the custom one
	            return this.modifiers[modifier] || modifier;
	        }.bind(this));
	
	        // make sure to apply the popper position before any computation
	        this.state.position = this._getPosition(this._popper, this._reference);
	        setStyle(this._popper, { position: this.state.position });
	
	        // fire the first update to position the popper in the right place
	        this.update();
	
	        // setup event listeners, they will take care of update the position in specific situations
	        this._setupEventListeners();
	        return this;
	    }
	
	    //
	    // Methods
	    //
	    /**
	     * Destroy the popper
	     * @method
	     * @memberof Popper
	     */
	    Popper.prototype.destroy = function () {
	        this._popper.removeAttribute('x-placement');
	        this._popper.style.left = '';
	        this._popper.style.position = '';
	        this._popper.style.top = '';
	        this._popper.style[getSupportedPropertyName('transform')] = '';
	        this._removeEventListeners();
	
	        // remove the popper if user explicity asked for the deletion on destroy
	        if (this._options.removeOnDestroy) {
	            this._popper.remove();
	        }
	        return this;
	    };
	
	    /**
	     * Updates the position of the popper, computing the new offsets and applying the new style
	     * @method
	     * @memberof Popper
	     */
	    Popper.prototype.update = function () {
	        var data = { instance: this, styles: {} };
	
	        // store placement inside the data object, modifiers will be able to edit `placement` if needed
	        // and refer to _originalPlacement to know the original value
	        data.placement = this._options.placement;
	        data._originalPlacement = this._options.placement;
	
	        // compute the popper and reference offsets and put them inside data.offsets
	        data.offsets = this._getOffsets(this._popper, this._reference, data.placement);
	
	        // get boundaries
	        data.boundaries = this._getBoundaries(data, this._options.boundariesPadding, this._options.boundariesElement);
	
	        data = this.runModifiers(data, this._options.modifiers);
	
	        if (typeof this.state.updateCallback === 'function') {
	            this.state.updateCallback(data);
	        }
	    };
	
	    /**
	     * If a function is passed, it will be executed after the initialization of popper with as first argument the Popper instance.
	     * @method
	     * @memberof Popper
	     * @param {Function} callback
	     */
	    Popper.prototype.onCreate = function (callback) {
	        // the createCallbacks return as first argument the popper instance
	        callback(this);
	        return this;
	    };
	
	    /**
	     * If a function is passed, it will be executed after each update of popper with as first argument the set of coordinates and informations
	     * used to style popper and its arrow.
	     * NOTE: it doesn't get fired on the first call of the `Popper.update()` method inside the `Popper` constructor!
	     * @method
	     * @memberof Popper
	     * @param {Function} callback
	     */
	    Popper.prototype.onUpdate = function (callback) {
	        this.state.updateCallback = callback;
	        return this;
	    };
	
	    /**
	     * Helper used to generate poppers from a configuration file
	     * @method
	     * @memberof Popper
	     * @param config {Object} configuration
	     * @returns {HTMLElement} popper
	     */
	    Popper.prototype.parse = function (config) {
	        var defaultConfig = {
	            tagName: 'div',
	            classNames: ['popper'],
	            attributes: [],
	            parent: root.document.body,
	            content: '',
	            contentType: 'text',
	            arrowTagName: 'div',
	            arrowClassNames: ['popper__arrow'],
	            arrowAttributes: ['x-arrow']
	        };
	        config = Object.assign({}, defaultConfig, config);
	
	        var d = root.document;
	
	        var popper = d.createElement(config.tagName);
	        addClassNames(popper, config.classNames);
	        addAttributes(popper, config.attributes);
	        if (config.contentType === 'node') {
	            popper.appendChild(config.content.jquery ? config.content[0] : config.content);
	        } else if (config.contentType === 'html') {
	            popper.innerHTML = config.content;
	        } else {
	            popper.textContent = config.content;
	        }
	
	        if (config.arrowTagName) {
	            var arrow = d.createElement(config.arrowTagName);
	            addClassNames(arrow, config.arrowClassNames);
	            addAttributes(arrow, config.arrowAttributes);
	            popper.appendChild(arrow);
	        }
	
	        var parent = config.parent.jquery ? config.parent[0] : config.parent;
	
	        // if the given parent is a string, use it to match an element
	        // if more than one element is matched, the first one will be used as parent
	        // if no elements are matched, the script will throw an error
	        if (typeof parent === 'string') {
	            parent = d.querySelectorAll(config.parent);
	            if (parent.length > 1) {
	                console.warn('WARNING: the given `parent` query(' + config.parent + ') matched more than one element, the first one will be used');
	            }
	            if (parent.length === 0) {
	                throw 'ERROR: the given `parent` doesn\'t exists!';
	            }
	            parent = parent[0];
	        }
	        // if the given parent is a DOM nodes list or an array of nodes with more than one element,
	        // the first one will be used as parent
	        if (parent.length > 1 && parent instanceof Element === false) {
	            console.warn('WARNING: you have passed as parent a list of elements, the first one will be used');
	            parent = parent[0];
	        }
	
	        // append the generated popper to its parent
	        parent.appendChild(popper);
	
	        return popper;
	
	        /**
	         * Adds class names to the given element
	         * @function
	         * @ignore
	         * @param {HTMLElement} target
	         * @param {Array} classes
	         */
	        function addClassNames(element, classNames) {
	            classNames.forEach(function (className) {
	                element.classList.add(className);
	            });
	        }
	
	        /**
	         * Adds attributes to the given element
	         * @function
	         * @ignore
	         * @param {HTMLElement} target
	         * @param {Array} attributes
	         * @example
	         * addAttributes(element, [ 'data-info:foobar' ]);
	         */
	        function addAttributes(element, attributes) {
	            attributes.forEach(function (attribute) {
	                element.setAttribute(attribute.split(':')[0], attribute.split(':')[1] || '');
	            });
	        }
	    };
	
	    /**
	     * Helper used to get the position which will be applied to the popper
	     * @method
	     * @memberof Popper
	     * @param config {HTMLElement} popper element
	     * @param reference {HTMLElement} reference element
	     * @returns {String} position
	     */
	    Popper.prototype._getPosition = function (popper, reference) {
	        var container = getOffsetParent(reference);
	
	        if (this._options.forceAbsolute) {
	            return 'absolute';
	        }
	
	        // Decide if the popper will be fixed
	        // If the reference element is inside a fixed context, the popper will be fixed as well to allow them to scroll together
	        var isParentFixed = isFixed(reference, container);
	        return isParentFixed ? 'fixed' : 'absolute';
	    };
	
	    /**
	     * Get offsets to the popper
	     * @method
	     * @memberof Popper
	     * @access private
	     * @param {Element} popper - the popper element
	     * @param {Element} reference - the reference element (the popper will be relative to this)
	     * @returns {Object} An object containing the offsets which will be applied to the popper
	     */
	    Popper.prototype._getOffsets = function (popper, reference, placement) {
	        placement = placement.split('-')[0];
	        var popperOffsets = {};
	
	        popperOffsets.position = this.state.position;
	        var isParentFixed = popperOffsets.position === 'fixed';
	
	        //
	        // Get reference element position
	        //
	        var referenceOffsets = getOffsetRectRelativeToCustomParent(reference, getOffsetParent(popper), isParentFixed);
	
	        //
	        // Get popper sizes
	        //
	        var popperRect = getOuterSizes(popper);
	
	        //
	        // Compute offsets of popper
	        //
	
	        // depending by the popper placement we have to compute its offsets slightly differently
	        if (['right', 'left'].indexOf(placement) !== -1) {
	            popperOffsets.top = referenceOffsets.top + referenceOffsets.height / 2 - popperRect.height / 2;
	            if (placement === 'left') {
	                popperOffsets.left = referenceOffsets.left - popperRect.width;
	            } else {
	                popperOffsets.left = referenceOffsets.right;
	            }
	        } else {
	            popperOffsets.left = referenceOffsets.left + referenceOffsets.width / 2 - popperRect.width / 2;
	            if (placement === 'top') {
	                popperOffsets.top = referenceOffsets.top - popperRect.height;
	            } else {
	                popperOffsets.top = referenceOffsets.bottom;
	            }
	        }
	
	        // Add width and height to our offsets object
	        popperOffsets.width = popperRect.width;
	        popperOffsets.height = popperRect.height;
	
	        return {
	            popper: popperOffsets,
	            reference: referenceOffsets
	        };
	    };
	
	    /**
	     * Setup needed event listeners used to update the popper position
	     * @method
	     * @memberof Popper
	     * @access private
	     */
	    Popper.prototype._setupEventListeners = function () {
	        // NOTE: 1 DOM access here
	        this.state.updateBound = this.update.bind(this);
	        root.addEventListener('resize', this.state.updateBound);
	        // if the boundariesElement is window we don't need to listen for the scroll event
	        if (this._options.boundariesElement !== 'window') {
	            var target = getScrollParent(this._reference);
	            // here it could be both `body` or `documentElement` thanks to Firefox, we then check both
	            if (target === root.document.body || target === root.document.documentElement) {
	                target = root;
	            }
	            target.addEventListener('scroll', this.state.updateBound);
	        }
	    };
	
	    /**
	     * Remove event listeners used to update the popper position
	     * @method
	     * @memberof Popper
	     * @access private
	     */
	    Popper.prototype._removeEventListeners = function () {
	        // NOTE: 1 DOM access here
	        root.removeEventListener('resize', this.state.updateBound);
	        if (this._options.boundariesElement !== 'window') {
	            var target = getScrollParent(this._reference);
	            // here it could be both `body` or `documentElement` thanks to Firefox, we then check both
	            if (target === root.document.body || target === root.document.documentElement) {
	                target = root;
	            }
	            target.removeEventListener('scroll', this.state.updateBound);
	        }
	        this.state.updateBound = null;
	    };
	
	    /**
	     * Computed the boundaries limits and return them
	     * @method
	     * @memberof Popper
	     * @access private
	     * @param {Object} data - Object containing the property "offsets" generated by `_getOffsets`
	     * @param {Number} padding - Boundaries padding
	     * @param {Element} boundariesElement - Element used to define the boundaries
	     * @returns {Object} Coordinates of the boundaries
	     */
	    Popper.prototype._getBoundaries = function (data, padding, boundariesElement) {
	        // NOTE: 1 DOM access here
	        var boundaries = {};
	        var width, height;
	        if (boundariesElement === 'window') {
	            var body = root.document.body,
	                html = root.document.documentElement;
	
	            height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
	            width = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
	
	            boundaries = {
	                top: 0,
	                right: width,
	                bottom: height,
	                left: 0
	            };
	        } else if (boundariesElement === 'viewport') {
	            var offsetParent = getOffsetParent(this._popper);
	            var scrollParent = getScrollParent(this._popper);
	            var offsetParentRect = getOffsetRect(offsetParent);
	
	            // if the popper is fixed we don't have to substract scrolling from the boundaries
	            var scrollTop = data.offsets.popper.position === 'fixed' ? 0 : scrollParent.scrollTop;
	            var scrollLeft = data.offsets.popper.position === 'fixed' ? 0 : scrollParent.scrollLeft;
	
	            boundaries = {
	                top: 0 - (offsetParentRect.top - scrollTop),
	                right: root.document.documentElement.clientWidth - (offsetParentRect.left - scrollLeft),
	                bottom: root.document.documentElement.clientHeight - (offsetParentRect.top - scrollTop),
	                left: 0 - (offsetParentRect.left - scrollLeft)
	            };
	        } else {
	            if (getOffsetParent(this._popper) === boundariesElement) {
	                boundaries = {
	                    top: 0,
	                    left: 0,
	                    right: boundariesElement.clientWidth,
	                    bottom: boundariesElement.clientHeight
	                };
	            } else {
	                boundaries = getOffsetRect(boundariesElement);
	            }
	        }
	        boundaries.left += padding;
	        boundaries.right -= padding;
	        boundaries.top = boundaries.top + padding;
	        boundaries.bottom = boundaries.bottom - padding;
	        return boundaries;
	    };
	
	    /**
	     * Loop trough the list of modifiers and run them in order, each of them will then edit the data object
	     * @method
	     * @memberof Popper
	     * @access public
	     * @param {Object} data
	     * @param {Array} modifiers
	     * @param {Function} ends
	     */
	    Popper.prototype.runModifiers = function (data, modifiers, ends) {
	        var modifiersToRun = modifiers.slice();
	        if (ends !== undefined) {
	            modifiersToRun = this._options.modifiers.slice(0, getArrayKeyIndex(this._options.modifiers, ends));
	        }
	
	        modifiersToRun.forEach(function (modifier) {
	            if (isFunction(modifier)) {
	                data = modifier.call(this, data);
	            }
	        }.bind(this));
	
	        return data;
	    };
	
	    /**
	     * Helper used to know if the given modifier depends from another one.
	     * @method
	     * @memberof Popper
	     * @param {String} requesting - name of requesting modifier
	     * @param {String} requested - name of requested modifier
	     * @returns {Boolean}
	     */
	    Popper.prototype.isModifierRequired = function (requesting, requested) {
	        var index = getArrayKeyIndex(this._options.modifiers, requesting);
	        return !!this._options.modifiers.slice(0, index).filter(function (modifier) {
	            return modifier === requested;
	        }).length;
	    };
	
	    //
	    // Modifiers
	    //
	
	    /**
	     * Modifiers list
	     * @namespace Popper.modifiers
	     * @memberof Popper
	     * @type {Object}
	     */
	    Popper.prototype.modifiers = {};
	
	    /**
	     * Apply the computed styles to the popper element
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by `update` method
	     * @returns {Object} The same data object
	     */
	    Popper.prototype.modifiers.applyStyle = function (data) {
	        // apply the final offsets to the popper
	        // NOTE: 1 DOM access here
	        var styles = {
	            position: data.offsets.popper.position
	        };
	
	        // round top and left to avoid blurry text
	        var left = Math.round(data.offsets.popper.left);
	        var top = Math.round(data.offsets.popper.top);
	
	        // if gpuAcceleration is set to true and transform is supported, we use `translate3d` to apply the position to the popper
	        // we automatically use the supported prefixed version if needed
	        var prefixedProperty;
	        if (this._options.gpuAcceleration && (prefixedProperty = getSupportedPropertyName('transform'))) {
	            styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	            styles.top = 0;
	            styles.left = 0;
	        }
	        // othwerise, we use the standard `left` and `top` properties
	        else {
	                styles.left = left;
	                styles.top = top;
	            }
	
	        // any property present in `data.styles` will be applied to the popper,
	        // in this way we can make the 3rd party modifiers add custom styles to it
	        // Be aware, modifiers could override the properties defined in the previous
	        // lines of this modifier!
	        Object.assign(styles, data.styles);
	
	        setStyle(this._popper, styles);
	
	        // set an attribute which will be useful to style the tooltip (use it to properly position its arrow)
	        // NOTE: 1 DOM access here
	        this._popper.setAttribute('x-placement', data.placement);
	
	        // if the arrow modifier is required and the arrow style has been computed, apply the arrow style
	        if (this.isModifierRequired(this.modifiers.applyStyle, this.modifiers.arrow) && data.offsets.arrow) {
	            setStyle(data.arrowElement, data.offsets.arrow);
	        }
	
	        return data;
	    };
	
	    /**
	     * Modifier used to shift the popper on the start or end of its reference element side
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by `update` method
	     * @returns {Object} The data object, properly modified
	     */
	    Popper.prototype.modifiers.shift = function (data) {
	        var placement = data.placement;
	        var basePlacement = placement.split('-')[0];
	        var shiftVariation = placement.split('-')[1];
	
	        // if shift shiftVariation is specified, run the modifier
	        if (shiftVariation) {
	            var reference = data.offsets.reference;
	            var popper = getPopperClientRect(data.offsets.popper);
	
	            var shiftOffsets = {
	                y: {
	                    start: { top: reference.top },
	                    end: { top: reference.top + reference.height - popper.height }
	                },
	                x: {
	                    start: { left: reference.left },
	                    end: { left: reference.left + reference.width - popper.width }
	                }
	            };
	
	            var axis = ['bottom', 'top'].indexOf(basePlacement) !== -1 ? 'x' : 'y';
	
	            data.offsets.popper = Object.assign(popper, shiftOffsets[axis][shiftVariation]);
	        }
	
	        return data;
	    };
	
	    /**
	     * Modifier used to make sure the popper does not overflows from it's boundaries
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by `update` method
	     * @returns {Object} The data object, properly modified
	     */
	    Popper.prototype.modifiers.preventOverflow = function (data) {
	        var order = this._options.preventOverflowOrder;
	        var popper = getPopperClientRect(data.offsets.popper);
	
	        var check = {
	            left: function left() {
	                var left = popper.left;
	                if (popper.left < data.boundaries.left) {
	                    left = Math.max(popper.left, data.boundaries.left);
	                }
	                return { left: left };
	            },
	            right: function right() {
	                var left = popper.left;
	                if (popper.right > data.boundaries.right) {
	                    left = Math.min(popper.left, data.boundaries.right - popper.width);
	                }
	                return { left: left };
	            },
	            top: function top() {
	                var top = popper.top;
	                if (popper.top < data.boundaries.top) {
	                    top = Math.max(popper.top, data.boundaries.top);
	                }
	                return { top: top };
	            },
	            bottom: function bottom() {
	                var top = popper.top;
	                if (popper.bottom > data.boundaries.bottom) {
	                    top = Math.min(popper.top, data.boundaries.bottom - popper.height);
	                }
	                return { top: top };
	            }
	        };
	
	        order.forEach(function (direction) {
	            data.offsets.popper = Object.assign(popper, check[direction]());
	        });
	
	        return data;
	    };
	
	    /**
	     * Modifier used to make sure the popper is always near its reference
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by _update method
	     * @returns {Object} The data object, properly modified
	     */
	    Popper.prototype.modifiers.keepTogether = function (data) {
	        var popper = getPopperClientRect(data.offsets.popper);
	        var reference = data.offsets.reference;
	        var f = Math.floor;
	
	        if (popper.right < f(reference.left)) {
	            data.offsets.popper.left = f(reference.left) - popper.width;
	        }
	        if (popper.left > f(reference.right)) {
	            data.offsets.popper.left = f(reference.right);
	        }
	        if (popper.bottom < f(reference.top)) {
	            data.offsets.popper.top = f(reference.top) - popper.height;
	        }
	        if (popper.top > f(reference.bottom)) {
	            data.offsets.popper.top = f(reference.bottom);
	        }
	
	        return data;
	    };
	
	    /**
	     * Modifier used to flip the placement of the popper when the latter is starting overlapping its reference element.
	     * Requires the `preventOverflow` modifier before it in order to work.
	     * **NOTE:** This modifier will run all its previous modifiers everytime it tries to flip the popper!
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by _update method
	     * @returns {Object} The data object, properly modified
	     */
	    Popper.prototype.modifiers.flip = function (data) {
	        // check if preventOverflow is in the list of modifiers before the flip modifier.
	        // otherwise flip would not work as expected.
	        if (!this.isModifierRequired(this.modifiers.flip, this.modifiers.preventOverflow)) {
	            console.warn('WARNING: preventOverflow modifier is required by flip modifier in order to work, be sure to include it before flip!');
	            return data;
	        }
	
	        if (data.flipped && data.placement === data._originalPlacement) {
	            // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	            return data;
	        }
	
	        var placement = data.placement.split('-')[0];
	        var placementOpposite = getOppositePlacement(placement);
	        var variation = data.placement.split('-')[1] || '';
	
	        var flipOrder = [];
	        if (this._options.flipBehavior === 'flip') {
	            flipOrder = [placement, placementOpposite];
	        } else {
	            flipOrder = this._options.flipBehavior;
	        }
	
	        flipOrder.forEach(function (step, index) {
	            if (placement !== step || flipOrder.length === index + 1) {
	                return;
	            }
	
	            placement = data.placement.split('-')[0];
	            placementOpposite = getOppositePlacement(placement);
	
	            var popperOffsets = getPopperClientRect(data.offsets.popper);
	
	            // this boolean is used to distinguish right and bottom from top and left
	            // they need different computations to get flipped
	            var a = ['right', 'bottom'].indexOf(placement) !== -1;
	
	            // using Math.floor because the reference offsets may contain decimals we are not going to consider here
	            if (a && Math.floor(data.offsets.reference[placement]) > Math.floor(popperOffsets[placementOpposite]) || !a && Math.floor(data.offsets.reference[placement]) < Math.floor(popperOffsets[placementOpposite])) {
	                // we'll use this boolean to detect any flip loop
	                data.flipped = true;
	                data.placement = flipOrder[index + 1];
	                if (variation) {
	                    data.placement += '-' + variation;
	                }
	                data.offsets.popper = this._getOffsets(this._popper, this._reference, data.placement).popper;
	
	                data = this.runModifiers(data, this._options.modifiers, this._flip);
	            }
	        }.bind(this));
	        return data;
	    };
	
	    /**
	     * Modifier used to add an offset to the popper, useful if you more granularity positioning your popper.
	     * The offsets will shift the popper on the side of its reference element.
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by _update method
	     * @returns {Object} The data object, properly modified
	     */
	    Popper.prototype.modifiers.offset = function (data) {
	        var offset = this._options.offset;
	        var popper = data.offsets.popper;
	
	        if (data.placement.indexOf('left') !== -1) {
	            popper.top -= offset;
	        } else if (data.placement.indexOf('right') !== -1) {
	            popper.top += offset;
	        } else if (data.placement.indexOf('top') !== -1) {
	            popper.left -= offset;
	        } else if (data.placement.indexOf('bottom') !== -1) {
	            popper.left += offset;
	        }
	        return data;
	    };
	
	    /**
	     * Modifier used to move the arrows on the edge of the popper to make sure them are always between the popper and the reference element
	     * It will use the CSS outer size of the arrow element to know how many pixels of conjuction are needed
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by _update method
	     * @returns {Object} The data object, properly modified
	     */
	    Popper.prototype.modifiers.arrow = function (data) {
	        var arrow = this._options.arrowElement;
	
	        // if the arrowElement is a string, suppose it's a CSS selector
	        if (typeof arrow === 'string') {
	            arrow = this._popper.querySelector(arrow);
	        }
	
	        // if arrow element is not found, don't run the modifier
	        if (!arrow) {
	            return data;
	        }
	
	        // the arrow element must be child of its popper
	        if (!this._popper.contains(arrow)) {
	            console.warn('WARNING: `arrowElement` must be child of its popper element!');
	            return data;
	        }
	
	        // arrow depends on keepTogether in order to work
	        if (!this.isModifierRequired(this.modifiers.arrow, this.modifiers.keepTogether)) {
	            console.warn('WARNING: keepTogether modifier is required by arrow modifier in order to work, be sure to include it before arrow!');
	            return data;
	        }
	
	        var arrowStyle = {};
	        var placement = data.placement.split('-')[0];
	        var popper = getPopperClientRect(data.offsets.popper);
	        var reference = data.offsets.reference;
	        var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	        var len = isVertical ? 'height' : 'width';
	        var side = isVertical ? 'top' : 'left';
	        var altSide = isVertical ? 'left' : 'top';
	        var opSide = isVertical ? 'bottom' : 'right';
	        var arrowSize = getOuterSizes(arrow)[len];
	
	        //
	        // extends keepTogether behavior making sure the popper and its reference have enough pixels in conjuction
	        //
	
	        // top/left side
	        if (reference[opSide] - arrowSize < popper[side]) {
	            data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowSize);
	        }
	        // bottom/right side
	        if (reference[side] + arrowSize > popper[opSide]) {
	            data.offsets.popper[side] += reference[side] + arrowSize - popper[opSide];
	        }
	
	        // compute center of the popper
	        var center = reference[side] + reference[len] / 2 - arrowSize / 2;
	
	        var sideValue = center - popper[side];
	
	        // prevent arrow from being placed not contiguously to its popper
	        sideValue = Math.max(Math.min(popper[len] - arrowSize, sideValue), 0);
	        arrowStyle[side] = sideValue;
	        arrowStyle[altSide] = ''; // make sure to remove any old style from the arrow
	
	        data.offsets.arrow = arrowStyle;
	        data.arrowElement = arrow;
	
	        return data;
	    };
	
	    //
	    // Helpers
	    //
	
	    /**
	     * Get the outer sizes of the given element (offset size + margins)
	     * @function
	     * @ignore
	     * @argument {Element} element
	     * @returns {Object} object containing width and height properties
	     */
	    function getOuterSizes(element) {
	        // NOTE: 1 DOM access here
	        var _display = element.style.display,
	            _visibility = element.style.visibility;
	        element.style.display = 'block';element.style.visibility = 'hidden';
	        var calcWidthToForceRepaint = element.offsetWidth;
	
	        // original method
	        var styles = root.getComputedStyle(element);
	        var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
	        var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
	        var result = { width: element.offsetWidth + y, height: element.offsetHeight + x };
	
	        // reset element styles
	        element.style.display = _display;element.style.visibility = _visibility;
	        return result;
	    }
	
	    /**
	     * Get the opposite placement of the given one/
	     * @function
	     * @ignore
	     * @argument {String} placement
	     * @returns {String} flipped placement
	     */
	    function getOppositePlacement(placement) {
	        var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	        return placement.replace(/left|right|bottom|top/g, function (matched) {
	            return hash[matched];
	        });
	    }
	
	    /**
	     * Given the popper offsets, generate an output similar to getBoundingClientRect
	     * @function
	     * @ignore
	     * @argument {Object} popperOffsets
	     * @returns {Object} ClientRect like output
	     */
	    function getPopperClientRect(popperOffsets) {
	        var offsets = Object.assign({}, popperOffsets);
	        offsets.right = offsets.left + offsets.width;
	        offsets.bottom = offsets.top + offsets.height;
	        return offsets;
	    }
	
	    /**
	     * Given an array and the key to find, returns its index
	     * @function
	     * @ignore
	     * @argument {Array} arr
	     * @argument keyToFind
	     * @returns index or null
	     */
	    function getArrayKeyIndex(arr, keyToFind) {
	        var i = 0,
	            key;
	        for (key in arr) {
	            if (arr[key] === keyToFind) {
	                return i;
	            }
	            i++;
	        }
	        return null;
	    }
	
	    /**
	     * Get CSS computed property of the given element
	     * @function
	     * @ignore
	     * @argument {Eement} element
	     * @argument {String} property
	     */
	    function getStyleComputedProperty(element, property) {
	        // NOTE: 1 DOM access here
	        var css = root.getComputedStyle(element, null);
	        return css[property];
	    }
	
	    /**
	     * Returns the offset parent of the given element
	     * @function
	     * @ignore
	     * @argument {Element} element
	     * @returns {Element} offset parent
	     */
	    function getOffsetParent(element) {
	        // NOTE: 1 DOM access here
	        var offsetParent = element.offsetParent;
	        return offsetParent === root.document.body || !offsetParent ? root.document.documentElement : offsetParent;
	    }
	
	    /**
	     * Returns the scrolling parent of the given element
	     * @function
	     * @ignore
	     * @argument {Element} element
	     * @returns {Element} offset parent
	     */
	    function getScrollParent(element) {
	        var parent = element.parentNode;
	
	        if (!parent) {
	            return element;
	        }
	
	        if (parent === root.document) {
	            // Firefox puts the scrollTOp value on `documentElement` instead of `body`, we then check which of them is
	            // greater than 0 and return the proper element
	            if (root.document.body.scrollTop) {
	                return root.document.body;
	            } else {
	                return root.document.documentElement;
	            }
	        }
	
	        // Firefox want us to check `-x` and `-y` variations as well
	        if (['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow')) !== -1 || ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-x')) !== -1 || ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-y')) !== -1) {
	            // If the detected scrollParent is body, we perform an additional check on its parentNode
	            // in this way we'll get body if the browser is Chrome-ish, or documentElement otherwise
	            // fixes issue #65
	            return parent;
	        }
	        return getScrollParent(element.parentNode);
	    }
	
	    /**
	     * Check if the given element is fixed or is inside a fixed parent
	     * @function
	     * @ignore
	     * @argument {Element} element
	     * @argument {Element} customContainer
	     * @returns {Boolean} answer to "isFixed?"
	     */
	    function isFixed(element) {
	        if (element === root.document.body) {
	            return false;
	        }
	        if (getStyleComputedProperty(element, 'position') === 'fixed') {
	            return true;
	        }
	        return element.parentNode ? isFixed(element.parentNode) : element;
	    }
	
	    /**
	     * Set the style to the given popper
	     * @function
	     * @ignore
	     * @argument {Element} element - Element to apply the style to
	     * @argument {Object} styles - Object with a list of properties and values which will be applied to the element
	     */
	    function setStyle(element, styles) {
	        function is_numeric(n) {
	            return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	        }
	        Object.keys(styles).forEach(function (prop) {
	            var unit = '';
	            // add unit if the value is numeric and is one of the following
	            if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && is_numeric(styles[prop])) {
	                unit = 'px';
	            }
	            element.style[prop] = styles[prop] + unit;
	        });
	    }
	
	    /**
	     * Check if the given variable is a function
	     * @function
	     * @ignore
	     * @argument {*} functionToCheck - variable to check
	     * @returns {Boolean} answer to: is a function?
	     */
	    function isFunction(functionToCheck) {
	        var getType = {};
	        return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	    }
	
	    /**
	     * Get the position of the given element, relative to its offset parent
	     * @function
	     * @ignore
	     * @param {Element} element
	     * @return {Object} position - Coordinates of the element and its `scrollTop`
	     */
	    function getOffsetRect(element) {
	        var elementRect = {
	            width: element.offsetWidth,
	            height: element.offsetHeight,
	            left: element.offsetLeft,
	            top: element.offsetTop
	        };
	
	        elementRect.right = elementRect.left + elementRect.width;
	        elementRect.bottom = elementRect.top + elementRect.height;
	
	        // position
	        return elementRect;
	    }
	
	    /**
	     * Get bounding client rect of given element
	     * @function
	     * @ignore
	     * @param {HTMLElement} element
	     * @return {Object} client rect
	     */
	    function getBoundingClientRect(element) {
	        var rect = element.getBoundingClientRect();
	
	        // whether the IE version is lower than 11
	        var isIE = navigator.userAgent.indexOf("MSIE") != -1;
	
	        // fix ie document bounding top always 0 bug
	        var rectTop = isIE && element.tagName === 'HTML' ? -element.scrollTop : rect.top;
	
	        return {
	            left: rect.left,
	            top: rectTop,
	            right: rect.right,
	            bottom: rect.bottom,
	            width: rect.right - rect.left,
	            height: rect.bottom - rectTop
	        };
	    }
	
	    /**
	     * Given an element and one of its parents, return the offset
	     * @function
	     * @ignore
	     * @param {HTMLElement} element
	     * @param {HTMLElement} parent
	     * @return {Object} rect
	     */
	    function getOffsetRectRelativeToCustomParent(element, parent, fixed) {
	        var elementRect = getBoundingClientRect(element);
	        var parentRect = getBoundingClientRect(parent);
	
	        if (fixed) {
	            var scrollParent = getScrollParent(parent);
	            parentRect.top += scrollParent.scrollTop;
	            parentRect.bottom += scrollParent.scrollTop;
	            parentRect.left += scrollParent.scrollLeft;
	            parentRect.right += scrollParent.scrollLeft;
	        }
	
	        var rect = {
	            top: elementRect.top - parentRect.top,
	            left: elementRect.left - parentRect.left,
	            bottom: elementRect.top - parentRect.top + elementRect.height,
	            right: elementRect.left - parentRect.left + elementRect.width,
	            width: elementRect.width,
	            height: elementRect.height
	        };
	        return rect;
	    }
	
	    /**
	     * Get the prefixed supported property name
	     * @function
	     * @ignore
	     * @argument {String} property (camelCase)
	     * @returns {String} prefixed property (camelCase)
	     */
	    function getSupportedPropertyName(property) {
	        var prefixes = ['', 'ms', 'webkit', 'moz', 'o'];
	
	        for (var i = 0; i < prefixes.length; i++) {
	            var toCheck = prefixes[i] ? prefixes[i] + property.charAt(0).toUpperCase() + property.slice(1) : property;
	            if (typeof root.document.body.style[toCheck] !== 'undefined') {
	                return toCheck;
	            }
	        }
	        return null;
	    }
	
	    /**
	     * The Object.assign() method is used to copy the values of all enumerable own properties from one or more source
	     * objects to a target object. It will return the target object.
	     * This polyfill doesn't support symbol properties, since ES5 doesn't have symbols anyway
	     * Source: https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	     * @function
	     * @ignore
	     */
	    if (!Object.assign) {
	        Object.defineProperty(Object, 'assign', {
	            enumerable: false,
	            configurable: true,
	            writable: true,
	            value: function value(target) {
	                if (target === undefined || target === null) {
	                    throw new TypeError('Cannot convert first argument to object');
	                }
	
	                var to = Object(target);
	                for (var i = 1; i < arguments.length; i++) {
	                    var nextSource = arguments[i];
	                    if (nextSource === undefined || nextSource === null) {
	                        continue;
	                    }
	                    nextSource = Object(nextSource);
	
	                    var keysArray = Object.keys(nextSource);
	                    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
	                        var nextKey = keysArray[nextIndex];
	                        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
	                        if (desc !== undefined && desc.enumerable) {
	                            to[nextKey] = nextSource[nextKey];
	                        }
	                    }
	                }
	                return to;
	            }
	        });
	    }
	
	    return Popper;
	});

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _dom = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasModal = false;
	
	var getModal = function getModal() {
	  if (_vue2.default.prototype.$isServer) return;
	  var modalDom = PopupManager.modalDom;
	  if (modalDom) {
	    hasModal = true;
	  } else {
	    hasModal = false;
	    modalDom = document.createElement('div');
	    PopupManager.modalDom = modalDom;
	
	    modalDom.addEventListener('touchmove', function (event) {
	      event.preventDefault();
	      event.stopPropagation();
	    });
	
	    modalDom.addEventListener('click', function () {
	      PopupManager.doOnModalClick && PopupManager.doOnModalClick();
	    });
	  }
	
	  return modalDom;
	};
	
	var instances = {};
	
	var PopupManager = {
	  zIndex: 2000,
	
	  modalFade: true,
	
	  getInstance: function getInstance(id) {
	    return instances[id];
	  },
	
	  register: function register(id, instance) {
	    if (id && instance) {
	      instances[id] = instance;
	    }
	  },
	
	  deregister: function deregister(id) {
	    if (id) {
	      instances[id] = null;
	      delete instances[id];
	    }
	  },
	
	  nextZIndex: function nextZIndex() {
	    return PopupManager.zIndex++;
	  },
	
	  modalStack: [],
	
	  doOnModalClick: function doOnModalClick() {
	    var topItem = PopupManager.modalStack[PopupManager.modalStack.length - 1];
	    if (!topItem) return;
	
	    var instance = PopupManager.getInstance(topItem.id);
	    if (instance && instance.closeOnClickModal) {
	      instance.close();
	    }
	  },
	
	  openModal: function openModal(id, zIndex, dom, modalClass, modalFade) {
	    if (_vue2.default.prototype.$isServer) return;
	    if (!id || zIndex === undefined) return;
	    this.modalFade = modalFade;
	
	    var modalStack = this.modalStack;
	
	    for (var i = 0, j = modalStack.length; i < j; i++) {
	      var item = modalStack[i];
	      if (item.id === id) {
	        return;
	      }
	    }
	
	    var modalDom = getModal();
	
	    (0, _dom.addClass)(modalDom, 'v-modal');
	    if (this.modalFade && !hasModal) {
	      (0, _dom.addClass)(modalDom, 'v-modal-enter');
	    }
	    if (modalClass) {
	      var classArr = modalClass.trim().split(/\s+/);
	      classArr.forEach(function (item) {
	        return (0, _dom.addClass)(modalDom, item);
	      });
	    }
	    setTimeout(function () {
	      (0, _dom.removeClass)(modalDom, 'v-modal-enter');
	    }, 200);
	
	    if (dom && dom.parentNode && dom.parentNode.nodeType !== 11) {
	      dom.parentNode.appendChild(modalDom);
	    } else {
	      document.body.appendChild(modalDom);
	    }
	
	    if (zIndex) {
	      modalDom.style.zIndex = zIndex;
	    }
	    modalDom.style.display = '';
	
	    this.modalStack.push({ id: id, zIndex: zIndex, modalClass: modalClass });
	  },
	
	  closeModal: function closeModal(id) {
	    var modalStack = this.modalStack;
	    var modalDom = getModal();
	
	    if (modalStack.length > 0) {
	      var topItem = modalStack[modalStack.length - 1];
	      if (topItem.id === id) {
	        if (topItem.modalClass) {
	          var classArr = topItem.modalClass.trim().split(/\s+/);
	          classArr.forEach(function (item) {
	            return (0, _dom.removeClass)(modalDom, item);
	          });
	        }
	
	        modalStack.pop();
	        if (modalStack.length > 0) {
	          modalDom.style.zIndex = modalStack[modalStack.length - 1].zIndex;
	        }
	      } else {
	        for (var i = modalStack.length - 1; i >= 0; i--) {
	          if (modalStack[i].id === id) {
	            modalStack.splice(i, 1);
	            break;
	          }
	        }
	      }
	    }
	
	    if (modalStack.length === 0) {
	      if (this.modalFade) {
	        (0, _dom.addClass)(modalDom, 'v-modal-leave');
	      }
	      setTimeout(function () {
	        if (modalStack.length === 0) {
	          if (modalDom.parentNode) modalDom.parentNode.removeChild(modalDom);
	          modalDom.style.display = 'none';
	          PopupManager.modalDom = undefined;
	        }
	        (0, _dom.removeClass)(modalDom, 'v-modal-leave');
	      }, 200);
	    }
	  }
	};
	!_vue2.default.prototype.$isServer && window.addEventListener('keydown', function (event) {
	  if (event.keyCode === 27) {
	    // ESC
	    if (PopupManager.modalStack.length > 0) {
	      var topItem = PopupManager.modalStack[PopupManager.modalStack.length - 1];
	      if (!topItem) return;
	      var instance = PopupManager.getInstance(topItem.id);
	      if (instance.closeOnPressEscape) {
	        instance.close();
	      }
	    }
	  }
	});
	
	exports.default = PopupManager;

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.isVNode = isVNode;
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isVNode(node) {
	  if (!node || (typeof node === 'undefined' ? 'undefined' : _typeof(node)) !== 'object') return false;
	  return _vue2.default.util.hasOwn(node, 'tag') && _vue2.default.util.hasOwn(node, 'componentOptions');
	};

/***/ },
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 *  Copyright (c) 2014-2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Immutable = factory());
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step !== 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      if (o !== o || o === Infinity) {
	        return 0;
	      }
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
	      return emptyMap().withMutations(function(map ) {
	        for (var i = 0; i < keyValues.length; i += 2) {
	          if (i + 1 >= keyValues.length) {
	            throw new Error('Missing value for key: ' + keyValues[i]);
	          }
	          map.set(keyValues[i], keyValues[i + 1]);
	        }
	      });
	    };
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      if (end === Infinity) {
	        end = originalSize;
	      } else {
	        end = end | 0;
	      }
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      if (this._map && !this._map.has(k)) {
	        var defaultVal = this._defaultValues[k];
	        if (v === defaultVal) {
	          return this;
	        }
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findEntry: function(predicate, context, notSetValue) {
	      var found = notSetValue;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    findLastEntry: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toKeyedSeq().reverse().findKey(predicate, context);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.toKeyedSeq().reverse().keyOf(searchValue);
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.lastKeyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var entry = this.findLastEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    keySeq: function() {
	      return Range(0, this.size);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : String(value);
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	!function(t,e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var n=e();for(var r in n)("object"==typeof exports?exports:t)[r]=n[r]}}(this,function(){return function(t){function e(r){if(n[r])return n[r].exports;var i=n[r]={exports:{},id:r,loaded:!1};return t[r].call(i.exports,i,i.exports,e),i.loaded=!0,i.exports}var n={};return e.m=t,e.c=n,e.p="",e(0)}([function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=e.Log=n(1),i=e.OidcClient=n(2),s=e.OidcClientSettings=n(3),o=e.WebStorageStateStore=n(4),a=e.InMemoryWebStorage=n(26),u=e.UserManager=n(27),h=e.AccessTokenEvents=n(36),c=e.MetadataService=n(7),f=e.CordovaPopupNavigator=n(43),l=e.CordovaIFrameNavigator=n(45),d=e.CheckSessionIFrame=n(41),p=e.TokenRevocationClient=n(42);e.default={Log:r,OidcClient:i,OidcClientSettings:s,WebStorageStateStore:o,InMemoryWebStorage:a,UserManager:u,AccessTokenEvents:h,MetadataService:c,CordovaPopupNavigator:f,CordovaIFrameNavigator:l,CheckSessionIFrame:d,TokenRevocationClient:p}},function(t,e){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i={info:function(){},warn:function(){},error:function(){}},s=0,o=1,a=2,u=3,h=void 0,c=void 0,f=function(){function t(){n(this,t)}return t.reset=function(){c=u,h=i},t.info=function(){if(c>=u){for(var t=arguments.length,e=Array(t),n=0;n<t;n++)e[n]=arguments[n];h.info.apply(h,Array.from(e))}},t.warn=function(){if(c>=a){for(var t=arguments.length,e=Array(t),n=0;n<t;n++)e[n]=arguments[n];h.warn.apply(h,Array.from(e))}},t.error=function(){if(c>=o){for(var t=arguments.length,e=Array(t),n=0;n<t;n++)e[n]=arguments[n];h.error.apply(h,Array.from(e))}},r(t,null,[{key:"NONE",get:function(){return s}},{key:"ERROR",get:function(){return o}},{key:"WARN",get:function(){return a}},{key:"INFO",get:function(){return u}},{key:"level",get:function(){return c},set:function(t){if(!(s<=t&&t<=u))throw new Error("Invalid log level");c=t}},{key:"logger",get:function(){return h},set:function(t){if(!(t.info&&t.warn&&t.error))throw new Error("Invalid logger");h=t}}]),t}();e.default=f,f.reset(),t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=n(1),a=r(o),u=n(3),h=r(u),c=n(10),f=r(c),l=n(18),d=r(l),p=n(23),g=r(p),y=n(24),v=r(y),m=n(25),S=r(m),b=n(20),w=r(b),E=n(21),x=r(E),A=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};i(this,t),e instanceof h.default?this._settings=e:this._settings=new h.default(e)}return t.prototype.createSigninRequest=function(){var t=this,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=e.response_type,r=e.scope,i=e.redirect_uri,s=e.data,o=e.state,u=e.prompt,h=e.display,c=e.max_age,f=e.ui_locales,l=e.id_token_hint,p=e.login_hint,g=e.acr_values,y=e.resource,v=arguments[1];a.default.info("OidcClient.createSigninRequest");var m=this._settings.client_id;n=n||this._settings.response_type,r=r||this._settings.scope,i=i||this._settings.redirect_uri,u=u||this._settings.prompt,h=h||this._settings.display,c=c||this._settings.max_age,f=f||this._settings.ui_locales,g=g||this._settings.acr_values,y=y||this._settings.resource;var S=this._settings.authority;return this._metadataService.getAuthorizationEndpoint().then(function(e){a.default.info("Received authorization endpoint",e);var b=new d.default({url:e,client_id:m,redirect_uri:i,response_type:n,scope:r,data:s||o,authority:S,prompt:u,display:h,max_age:c,ui_locales:f,id_token_hint:l,login_hint:p,acr_values:g,resource:y}),w=b.state;return v=v||t._stateStore,v.set(w.id,w.toStorageString()).then(function(){return b})})},t.prototype.processSigninResponse=function(t,e){var n=this;a.default.info("OidcClient.processSigninResponse");var r=new g.default(t);return r.state?(e=e||this._stateStore,e.remove(r.state).then(function(t){if(!t)throw a.default.error("No matching state found in storage"),new Error("No matching state found in storage");var e=w.default.fromStorageString(t);return a.default.info("Received state from storage; validating response"),n._validator.validateSigninResponse(e,r)})):(a.default.error("No state in response"),Promise.reject(new Error("No state in response")))},t.prototype.createSignoutRequest=function(){var t=this,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=e.id_token_hint,r=e.data,i=e.state,s=e.post_logout_redirect_uri,o=arguments[1];return a.default.info("OidcClient.createSignoutRequest"),s=s||this._settings.post_logout_redirect_uri,this._metadataService.getEndSessionEndpoint().then(function(e){if(!e)throw a.default.error("No end session endpoint url returned"),new Error("no end session endpoint");a.default.info("Received end session endpoint",e);var u=new v.default({url:e,id_token_hint:n,post_logout_redirect_uri:s,data:r||i}),h=u.state;return h&&(a.default.info("Signout request has state to persist"),o=o||t._stateStore,o.set(h.id,h.toStorageString())),u})},t.prototype.processSignoutResponse=function(t,e){var n=this;a.default.info("OidcClient.processSignoutResponse");var r=new S.default(t);if(!r.state)return a.default.info("No state in response"),r.error?(a.default.warn("Response was error",r.error),Promise.reject(new f.default(r))):Promise.resolve(r);var i=r.state;return e=e||this._stateStore,e.remove(i).then(function(t){if(!t)throw a.default.error("No matching state found in storage"),new Error("No matching state found in storage");var e=x.default.fromStorageString(t);return a.default.info("Received state from storage; validating response"),n._validator.validateSignoutResponse(e,r)})},t.prototype.clearStaleState=function(t){return a.default.info("OidcClient.clearStaleState"),t=t||this._stateStore,x.default.clearStaleState(t,this.settings.staleStateAge)},s(t,[{key:"_stateStore",get:function(){return this.settings.stateStore}},{key:"_validator",get:function(){return this.settings.validator}},{key:"_metadataService",get:function(){return this.settings.metadataService}},{key:"settings",get:function(){return this._settings}},{key:"metadataService",get:function(){return this._metadataService}}]),t}();e.default=A,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=n(1),a=r(o),u=n(4),h=r(u),c=n(6),f=r(c),l=n(7),d=r(l),p=".well-known/openid-configuration",g="id_token",y="openid",v=60,m=300,S=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=e.authority,r=e.metadataUrl,s=e.metadata,o=e.signingKeys,a=e.client_id,u=e.client_secret,c=e.response_type,l=void 0===c?g:c,p=e.scope,S=void 0===p?y:p,b=e.redirect_uri,w=e.post_logout_redirect_uri,E=e.prompt,x=e.display,A=e.max_age,_=e.ui_locales,F=e.acr_values,P=e.resource,O=e.filterProtocolClaims,C=void 0===O||O,T=e.loadUserInfo,D=void 0===T||T,H=e.staleStateAge,j=void 0===H?v:H,R=e.clockSkew,I=void 0===R?m:R,k=e.stateStore,B=void 0===k?new h.default:k,N=e.ResponseValidatorCtor,V=void 0===N?f.default:N,M=e.MetadataServiceCtor,K=void 0===M?d.default:M;i(this,t),this._authority=n,this._metadataUrl=r,this._metadata=s,this._signingKeys=o,this._client_id=a,this._client_secret=u,this._response_type=l,this._scope=S,this._redirect_uri=b,this._post_logout_redirect_uri=w,this._prompt=E,this._display=x,this._max_age=A,this._ui_locales=_,this._acr_values=F,this._resource=P,this._filterProtocolClaims=!!C,this._loadUserInfo=!!D,this._staleStateAge=j,this._clockSkew=I,this._stateStore=B,this._validator=new V(this),this._metadataService=new K(this)}return s(t,[{key:"client_id",get:function(){return this._client_id},set:function(t){if(this._client_id)throw a.default.error("client_id has already been assigned."),new Error("client_id has already been assigned.");this._client_id=t}},{key:"client_secret",get:function(){return this._client_secret}},{key:"response_type",get:function(){return this._response_type}},{key:"scope",get:function(){return this._scope}},{key:"redirect_uri",get:function(){return this._redirect_uri}},{key:"post_logout_redirect_uri",get:function(){return this._post_logout_redirect_uri}},{key:"prompt",get:function(){return this._prompt}},{key:"display",get:function(){return this._display}},{key:"max_age",get:function(){return this._max_age}},{key:"ui_locales",get:function(){return this._ui_locales}},{key:"acr_values",get:function(){return this._acr_values}},{key:"resource",get:function(){return this._resource}},{key:"authority",get:function(){return this._authority},set:function(t){if(this._authority)throw a.default.error("authority has already been assigned."),new Error("authority has already been assigned.");this._authority=t}},{key:"metadataUrl",get:function(){return this._metadataUrl||(this._metadataUrl=this.authority,this._metadataUrl&&this._metadataUrl.indexOf(p)<0&&("/"!==this._metadataUrl[this._metadataUrl.length-1]&&(this._metadataUrl+="/"),this._metadataUrl+=p)),this._metadataUrl}},{key:"metadata",get:function(){return this._metadata},set:function(t){this._metadata=t}},{key:"signingKeys",get:function(){return this._signingKeys},set:function(t){this._signingKeys=t}},{key:"filterProtocolClaims",get:function(){return this._filterProtocolClaims}},{key:"loadUserInfo",get:function(){return this._loadUserInfo}},{key:"staleStateAge",get:function(){return this._staleStateAge}},{key:"clockSkew",get:function(){return this._clockSkew}},{key:"stateStore",get:function(){return this._stateStore}},{key:"validator",get:function(){return this._validator}},{key:"metadataService",get:function(){return this._metadataService}}]),t}();e.default=S,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(1),o=r(s),a=n(5),u=r(a),h=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=e.prefix,r=void 0===n?"oidc.":n,s=e.store,o=void 0===s?u.default.localStorage:s;i(this,t),this._store=o,this._prefix=r}return t.prototype.set=function(t,e){return o.default.info("WebStorageStateStore.set",t),t=this._prefix+t,this._store.setItem(t,e),Promise.resolve()},t.prototype.get=function(t){o.default.info("WebStorageStateStore.get",t),t=this._prefix+t;var e=this._store.getItem(t);return Promise.resolve(e)},t.prototype.remove=function(t){o.default.info("WebStorageStateStore.remove",t),t=this._prefix+t;var e=this._store.getItem(t);return this._store.removeItem(t),Promise.resolve(e)},t.prototype.getAllKeys=function(){o.default.info("WebStorageStateStore.getAllKeys");for(var t=[],e=0;e<this._store.length;e++){var n=this._store.key(e);0===n.indexOf(this._prefix)&&t.push(n.substr(this._prefix.length))}return Promise.resolve(t)},t}();e.default=h,t.exports=e.default},function(t,e){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i={setInterval:function(t){function e(e,n){return t.apply(this,arguments)}return e.toString=function(){return t.toString()},e}(function(t,e){return setInterval(t,e)}),clearInterval:function(t){function e(e){return t.apply(this,arguments)}return e.toString=function(){return t.toString()},e}(function(t){return clearInterval(t)})},s=!1,o=function(){function t(){n(this,t)}return t._testing=function(){s=!0},r(t,null,[{key:"location",get:function(){if(!s)return location}},{key:"localStorage",get:function(){if(!s)return localStorage}},{key:"sessionStorage",get:function(){if(!s)return sessionStorage}},{key:"XMLHttpRequest",get:function(){if(!s)return XMLHttpRequest}},{key:"timer",get:function(){if(!s)return i}}]),t}();e.default=o,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(1),o=r(s),a=n(7),u=r(a),h=n(9),c=r(h),f=n(10),l=r(f),d=n(11),p=r(d),g=["nonce","at_hash","iat","nbf","exp","aud","iss","c_hash"],y=function(){function t(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:u.default,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:c.default,s=arguments.length>3&&void 0!==arguments[3]?arguments[3]:p.default;if(i(this,t),!e)throw o.default.error("No settings passed to ResponseValidator"),new Error("settings");this._settings=e,this._metadataService=new n(this._settings),this._userInfoService=new r(this._settings),this._joseUtil=s}return t.prototype.validateSigninResponse=function(t,e){var n=this;return o.default.info("ResponseValidator.validateSigninResponse"),this._processSigninParams(t,e).then(function(e){return o.default.info("state processed"),n._validateTokens(t,e).then(function(t){return o.default.info("tokens validated"),n._processClaims(t).then(function(t){return o.default.info("claims processed"),t})})})},t.prototype.validateSignoutResponse=function(t,e){return o.default.info("ResponseValidator.validateSignoutResponse"),t.id!==e.state?(o.default.error("State does not match"),Promise.reject(new Error("State does not match"))):(o.default.info("state validated"),e.state=t.data,e.error?(o.default.warn("Response was error",e.error),Promise.reject(new l.default(e))):Promise.resolve(e))},t.prototype._processSigninParams=function(t,e){if(o.default.info("ResponseValidator._processSigninParams"),t.id!==e.state)return o.default.error("State does not match"),Promise.reject(new Error("State does not match"));if(!t.client_id)return o.default.error("No client_id on state"),Promise.reject(new Error("No client_id on state"));if(!t.authority)return o.default.error("No authority on state"),Promise.reject(new Error("No authority on state"));if(this._settings.authority){if(this._settings.authority&&this._settings.authority!==t.authority)return o.default.error("authority mismatch on settings vs. signin state"),Promise.reject(new Error("authority mismatch on settings vs. signin state"))}else this._settings.authority=t.authority;if(this._settings.client_id){if(this._settings.client_id&&this._settings.client_id!==t.client_id)return o.default.error("client_id mismatch on settings vs. signin state"),Promise.reject(new Error("client_id mismatch on settings vs. signin state"))}else this._settings.client_id=t.client_id;return o.default.info("state validated"),e.state=t.data,e.error?(o.default.warn("Response was error",e.error),Promise.reject(new l.default(e))):t.nonce&&!e.id_token?(o.default.error("Expecting id_token in response"),Promise.reject(new Error("No id_token in response"))):!t.nonce&&e.id_token?(o.default.error("Not expecting id_token in response"),Promise.reject(new Error("Unexpected id_token in response"))):Promise.resolve(e)},t.prototype._processClaims=function(t){var e=this;if(o.default.info("ResponseValidator._processClaims"),t.isOpenIdConnect){if(o.default.info("response is OIDC, processing claims"),t.profile=this._filterProtocolClaims(t.profile),this._settings.loadUserInfo&&t.access_token)return o.default.info("loading user info"),this._userInfoService.getClaims(t.access_token).then(function(n){return t.profile=e._mergeClaims(t.profile,n),o.default.info("user info claims received, updated profile:",t.profile),t});o.default.info("not loading user info")}else o.default.info("response is not OIDC, not processing claims");return Promise.resolve(t)},t.prototype._mergeClaims=function(t,e){var n=Object.assign({},t);for(var r in e){var i=e[r];Array.isArray(i)||(i=[i]);var s=!0,o=!1,a=void 0;try{for(var u,h=i[Symbol.iterator]();!(s=(u=h.next()).done);s=!0){var c=u.value;n[r]?Array.isArray(n[r])?n[r].indexOf(c)<0&&n[r].push(c):n[r]!==c&&(n[r]=[n[r],c]):n[r]=c}}catch(t){o=!0,a=t}finally{try{!s&&h.return&&h.return()}finally{if(o)throw a}}}return n},t.prototype._filterProtocolClaims=function(t){o.default.info("ResponseValidator._filterProtocolClaims, incoming claims:",t);var e=Object.assign({},t);return this._settings._filterProtocolClaims?(g.forEach(function(t){delete e[t]}),o.default.info("protocol claims filtered",e)):o.default.info("protocol claims not filtered"),e},t.prototype._validateTokens=function(t,e){return o.default.info("ResponseValidator._validateTokens"),e.id_token?e.access_token?(o.default.info("Validating id_token and access_token"),this._validateIdTokenAndAccessToken(t,e)):(o.default.info("Validating id_token"),this._validateIdToken(t,e)):(o.default.info("No id_token to validate"),Promise.resolve(e))},t.prototype._validateIdTokenAndAccessToken=function(t,e){var n=this;return o.default.info("ResponseValidator._validateIdTokenAndAccessToken"),this._validateIdToken(t,e).then(function(t){return n._validateAccessToken(t)})},t.prototype._validateIdToken=function(t,e){var n=this;if(o.default.info("ResponseValidator._validateIdToken"),!t.nonce)return o.default.error("No nonce on state"),Promise.reject(new Error("No nonce on state"));var r=this._joseUtil.parseJwt(e.id_token);if(!r||!r.header||!r.payload)return o.default.error("Failed to parse id_token",r),Promise.reject(new Error("Failed to parse id_token"));if(t.nonce!==r.payload.nonce)return o.default.error("Invalid nonce in id_token"),Promise.reject(new Error("Invalid nonce in id_token"));var i=r.header.kid;return this._metadataService.getIssuer().then(function(s){return o.default.info("Received issuer"),n._metadataService.getSigningKeys().then(function(a){if(!a)return o.default.error("No signing keys from metadata"),Promise.reject(new Error("No signing keys from metadata"));if(o.default.info("Received signing keys"),!i){if(a.length>1)return o.default.error("No kid found in id_token"),Promise.reject(new Error("No kid found in id_token"));i=a[0].kid}var u=a.filter(function(t){return t.kid===i})[0];if(!u)return o.default.error("No key matching kid found in signing keys"),Promise.reject(new Error("No key matching kid found in signing keys"));var h=t.client_id,c=n._settings.clockSkew;return o.default.info("Validaing JWT; using clock skew (in seconds) of: ",c),n._joseUtil.validateJwt(e.id_token,u,s,h,c).then(function(){return o.default.info("JWT validation successful"),e.profile=r.payload,e})})})},t.prototype._validateAccessToken=function(t){if(o.default.info("ResponseValidator._validateAccessToken"),!t.profile)return o.default.error("No profile loaded from id_token"),Promise.reject(new Error("No profile loaded from id_token"));if(!t.profile.at_hash)return o.default.error("No at_hash in id_token"),Promise.reject(new Error("No at_hash in id_token"));if(!t.id_token)return o.default.error("No id_token"),Promise.reject(new Error("No id_token"));var e=this._joseUtil.parseJwt(t.id_token);if(!e||!e.header)return o.default.error("Failed to parse id_token",e),Promise.reject(new Error("Failed to parse id_token"));var n=e.header.alg;if(!n||5!==n.length)return o.default.error("Unsupported alg:",n),Promise.reject(new Error("Unsupported alg: "+n));var r=n.substr(2,3);if(!r)return o.default.error("Unsupported alg:",n,r),Promise.reject(new Error("Unsupported alg: "+n));if(r=parseInt(r),256!==r&&384!==r&&512!==r)return o.default.error("Unsupported alg:",n,r),Promise.reject(new Error("Unsupported alg: "+n));var i="sha"+r,s=this._joseUtil.hashString(t.access_token,i);if(!s)return o.default.error("access_token hash failed:",i),Promise.reject(new Error("Failed to validate at_hash"));var a=s.substr(0,s.length/2),u=this._joseUtil.hexToBase64Url(a);return u!==t.profile.at_hash?(o.default.error("Failed to validate at_hash",u,t.profile.at_hash),Promise.reject(new Error("Failed to validate at_hash"))):Promise.resolve(t)},t}();e.default=y,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(1),o=r(s),a=n(8),u=r(a),h=function(){function t(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:u.default;if(i(this,t),!e)throw o.default.error("No settings passed to MetadataService"),new Error("settings");this._settings=e,this._jsonService=new n}return t.prototype.getMetadata=function(){var t=this;return o.default.info("MetadataService.getMetadata"),this._settings.metadata?(o.default.info("Returning metadata from settings"),Promise.resolve(this._settings.metadata)):this._settings.metadataUrl?(o.default.info("getting metadata from",this._settings.metadataUrl),this._jsonService.getJson(this._settings.metadataUrl).then(function(e){return o.default.info("json received"),t._settings.metadata=e,e})):(o.default.error("No metadataUrl configured on settings"),Promise.reject(new Error("No metadataUrl configured on settings")))},t.prototype.getIssuer=function(){return o.default.info("MetadataService.getIssuer"),this._getMetadataProperty("issuer")},t.prototype.getAuthorizationEndpoint=function(){return o.default.info("MetadataService.getAuthorizationEndpoint"),this._getMetadataProperty("authorization_endpoint")},t.prototype.getUserInfoEndpoint=function(){return o.default.info("MetadataService.getUserInfoEndpoint"),this._getMetadataProperty("userinfo_endpoint")},t.prototype.getCheckSessionIframe=function(){return o.default.info("MetadataService.getCheckSessionIframe"),this._getMetadataProperty("check_session_iframe",!0)},t.prototype.getEndSessionEndpoint=function(){return o.default.info("MetadataService.getEndSessionEndpoint"),this._getMetadataProperty("end_session_endpoint",!0)},t.prototype.getRevocationEndpoint=function(){return o.default.info("MetadataService.getRevocationEndpoint"),this._getMetadataProperty("revocation_endpoint",!0)},t.prototype._getMetadataProperty=function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1];return o.default.info("MetadataService._getMetadataProperty",t),this.getMetadata().then(function(n){if(o.default.info("metadata recieved"),void 0===n[t]){if(e===!0)return void o.default.warn("Metadata does not contain optional property "+t);throw o.default.error("Metadata does not contain property "+t),new Error("Metadata does not contain property "+t)}return n[t]})},t.prototype.getSigningKeys=function(){var t=this;return o.default.info("MetadataService.getSigningKeys"),this._settings.signingKeys?(o.default.info("Returning signingKeys from settings"),Promise.resolve(this._settings.signingKeys)):this._getMetadataProperty("jwks_uri").then(function(e){return o.default.info("jwks_uri received",e),t._jsonService.getJson(e).then(function(e){if(o.default.info("key set received",e),!e.keys)throw o.default.error("Missing keys on keyset"),new Error("Missing keys on keyset");var n=t._filterSigningKeys(e.keys);return o.default.info("filtered keys",n),t._settings.signingKeys=n,t._settings.signingKeys})})},t.prototype._filterSigningKeys=function(t){return o.default.info("MetadataService._filterSigningKeys",t),t.filter(function(t){return"sig"===t.use})},t}();e.default=h,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(1),o=r(s),a=n(5),u=r(a),h=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:u.default.XMLHttpRequest;i(this,t),this._XMLHttpRequest=e}return t.prototype.getJson=function(t,e){var n=this;if(o.default.info("JsonService.getJson",t),!t)throw o.default.error("No url passed"),new Error("url");return new Promise(function(r,i){var s=new n._XMLHttpRequest;s.open("GET",t),s.onload=function(){o.default.info("HTTP response received, status",s.status),200===s.status?r(JSON.parse(s.responseText)):i(Error(s.statusText+" ("+s.status+")"))},s.onerror=function(){o.default.error("network error"),i(Error("Network Error"))},e&&(o.default.info("token passed, setting Authorization header"),s.setRequestHeader("Authorization","Bearer "+e)),s.send()})},t}();e.default=h,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(8),o=r(s),a=n(7),u=r(a),h=n(1),c=r(h),f=function(){function t(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:o.default,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:u.default;if(i(this,t),!e)throw c.default.error("No settings passed to UserInfoService"),new Error("settings");this._settings=e,this._jsonService=new n,this._metadataService=new r(this._settings)}return t.prototype.getClaims=function(t){var e=this;return c.default.info("UserInfoService.getClaims"),t?this._metadataService.getUserInfoEndpoint().then(function(n){return c.default.info("received userinfo url",n),e._jsonService.getJson(n,t).then(function(t){return c.default.info("claims received",t),t})}):(c.default.error("No token passed"),Promise.reject(new Error("A token is required")))},t}();e.default=f,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function s(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=n(1),u=r(a),h=function(t){function e(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=n.error,o=n.error_description,a=n.error_uri,h=n.state;if(i(this,e),!r)throw u.default.error("No error passed to ErrorResponse"),new Error("error");var c=s(this,t.call(this,o||r));return c.name="ErrorResponse",c.error=r,c.error_description=o,c.error_uri=a,c.state=h,c}return o(e,t),e}(Error);e.default=h,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(12),o=n(1),a=r(o),u=["RS256","RS384","RS512","PS256","PS384","PS512","ES256","ES384","ES512"],h=function(){function t(){i(this,t)}return t.parseJwt=function(t){a.default.info("JoseUtil.parseJwt");try{var e=s.jws.JWS.parse(t);return{header:e.headerObj,payload:e.payloadObj}}catch(t){a.default.error(t)}},t.validateJwt=function(e,n,r,i,o,u){a.default.info("JoseUtil.validateJwt");try{if("RSA"===n.kty)if(n.e&&n.n)n=s.KEYUTIL.getKey(n);else{if(!n.x5c||!n.x5c.length)return a.default.error("RSA key missing key material",n),Promise.reject(new Error("RSA key missing key material"));n=s.KEYUTIL.getKey(s.X509.getPublicKeyFromCertPEM(n.x5c[0]))}else{if("EC"!==n.kty)return a.default.error("Unsupported key type",n&&n.kty),Promise.reject(new Error("Unsupported key type: "+n&&n.kty));if(!(n.crv&&n.x&&n.y))return a.default.error("EC key missing key material",n),Promise.reject(new Error("EC key missing key material"));n=s.KEYUTIL.getKey(n)}return t._validateJwt(e,n,r,i,o,u)}catch(t){return a.default.error(t&&t.message||t),Promise.reject("JWT validation failed")}},t._validateJwt=function(e,n,r,i,o,h){a.default.info("JoseUtil._validateJwt"),o||(o=0),h||(h=parseInt(Date.now()/1e3));var c=t.parseJwt(e).payload;if(c.iss!==r)return a.default.error("Invalid issuer in token",c.iss),Promise.reject(new Error("Invalid issuer in token: "+c.iss));var f=c.aud===i||Array.isArray(c.aud)&&c.aud.indexOf(i)>=0;if(!f)return a.default.error("Invalid audience in token",c.aud),Promise.reject(new Error("Invalid audience in token: "+c.aud));var l=h+o,d=h-o;if(l<c.iat)return a.default.error("iat is in the future",c.iat),Promise.reject(new Error("iat is in the future: "+c.iat));if(l<c.nbf)return a.default.error("nbf is in the future",c.nbf),Promise.reject(new Error("nbf is in the future: "+c.nbf));if(c.exp<d)return a.default.error("exp is in the past",c.exp),Promise.reject(new Error("exp is in the past:"+c.exp));try{if(!s.jws.JWS.verify(e,n,u))return a.default.error("signature validation failed"),Promise.reject(new Error("signature validation failed"))}catch(t){return a.default.error(t&&t.message||t),Promise.reject(new Error("signature validation failed"))}return Promise.resolve()},t.hashString=function(t,e){a.default.info("JoseUtil.hashString",t,e);try{return s.crypto.Util.hashString(t,e)}catch(t){a.default.error(t)}},t.hexToBase64Url=function(t){a.default.info("JoseUtil.hexToBase64Url",t);try{return(0,s.hextob64u)(t)}catch(t){a.default.error(t)}},t}();e.default=h,t.exports=e.default},function(t,e,n){(function(t){function r(t){var e,n,r="";for(e=0;e+3<=t.length;e+=3)n=parseInt(t.substring(e,e+3),16),r+=ur.charAt(n>>6)+ur.charAt(63&n);if(e+1==t.length?(n=parseInt(t.substring(e,e+1),16),r+=ur.charAt(n<<2)):e+2==t.length&&(n=parseInt(t.substring(e,e+2),16),r+=ur.charAt(n>>2)+ur.charAt((3&n)<<4)),hr)for(;(3&r.length)>0;)r+=hr;return r}function i(t){var e,n,r,i="",s=0;for(e=0;e<t.length&&t.charAt(e)!=hr;++e)r=ur.indexOf(t.charAt(e)),r<0||(0==s?(i+=f(r>>2),n=3&r,s=1):1==s?(i+=f(n<<2|r>>4),n=15&r,s=2):2==s?(i+=f(n),i+=f(r>>2),n=3&r,s=3):(i+=f(n<<2|r>>4),i+=f(15&r),s=0));return 1==s&&(i+=f(n<<2)),i}function s(t){var e,n=i(t),r=new Array;for(e=0;2*e<n.length;++e)r[e]=parseInt(n.substring(2*e,2*e+2),16);return r}function o(t,e,n){null!=t&&("number"==typeof t?this.fromNumber(t,e,n):null==e&&"string"!=typeof t?this.fromString(t,256):this.fromString(t,e))}function a(){return new o(null)}function u(t,e,n,r,i,s){for(;--s>=0;){var o=e*this[t++]+n[r]+i;i=Math.floor(o/67108864),n[r++]=67108863&o}return i}function h(t,e,n,r,i,s){for(var o=32767&e,a=e>>15;--s>=0;){var u=32767&this[t],h=this[t++]>>15,c=a*u+h*o;u=o*u+((32767&c)<<15)+n[r]+(1073741823&i),i=(u>>>30)+(c>>>15)+a*h+(i>>>30),n[r++]=1073741823&u}return i}function c(t,e,n,r,i,s){for(var o=16383&e,a=e>>14;--s>=0;){var u=16383&this[t],h=this[t++]>>14,c=a*u+h*o;u=o*u+((16383&c)<<14)+n[r]+i,i=(u>>28)+(c>>14)+a*h,n[r++]=268435455&u}return i}function f(t){return gr.charAt(t)}function l(t,e){var n=yr[t.charCodeAt(e)];return null==n?-1:n}function d(t){for(var e=this.t-1;e>=0;--e)t[e]=this[e];t.t=this.t,t.s=this.s}function p(t){this.t=1,this.s=t<0?-1:0,t>0?this[0]=t:t<-1?this[0]=t+this.DV:this.t=0}function g(t){var e=a();return e.fromInt(t),e}function y(t,e){var n;if(16==e)n=4;else if(8==e)n=3;else if(256==e)n=8;else if(2==e)n=1;else if(32==e)n=5;else{
	if(4!=e)return void this.fromRadix(t,e);n=2}this.t=0,this.s=0;for(var r=t.length,i=!1,s=0;--r>=0;){var a=8==n?255&t[r]:l(t,r);a<0?"-"==t.charAt(r)&&(i=!0):(i=!1,0==s?this[this.t++]=a:s+n>this.DB?(this[this.t-1]|=(a&(1<<this.DB-s)-1)<<s,this[this.t++]=a>>this.DB-s):this[this.t-1]|=a<<s,s+=n,s>=this.DB&&(s-=this.DB))}8==n&&0!=(128&t[0])&&(this.s=-1,s>0&&(this[this.t-1]|=(1<<this.DB-s)-1<<s)),this.clamp(),i&&o.ZERO.subTo(this,this)}function v(){for(var t=this.s&this.DM;this.t>0&&this[this.t-1]==t;)--this.t}function m(t){if(this.s<0)return"-"+this.negate().toString(t);var e;if(16==t)e=4;else if(8==t)e=3;else if(2==t)e=1;else if(32==t)e=5;else{if(4!=t)return this.toRadix(t);e=2}var n,r=(1<<e)-1,i=!1,s="",o=this.t,a=this.DB-o*this.DB%e;if(o-- >0)for(a<this.DB&&(n=this[o]>>a)>0&&(i=!0,s=f(n));o>=0;)a<e?(n=(this[o]&(1<<a)-1)<<e-a,n|=this[--o]>>(a+=this.DB-e)):(n=this[o]>>(a-=e)&r,a<=0&&(a+=this.DB,--o)),n>0&&(i=!0),i&&(s+=f(n));return i?s:"0"}function S(){var t=a();return o.ZERO.subTo(this,t),t}function b(){return this.s<0?this.negate():this}function w(t){var e=this.s-t.s;if(0!=e)return e;var n=this.t;if(e=n-t.t,0!=e)return this.s<0?-e:e;for(;--n>=0;)if(0!=(e=this[n]-t[n]))return e;return 0}function E(t){var e,n=1;return 0!=(e=t>>>16)&&(t=e,n+=16),0!=(e=t>>8)&&(t=e,n+=8),0!=(e=t>>4)&&(t=e,n+=4),0!=(e=t>>2)&&(t=e,n+=2),0!=(e=t>>1)&&(t=e,n+=1),n}function x(){return this.t<=0?0:this.DB*(this.t-1)+E(this[this.t-1]^this.s&this.DM)}function A(t,e){var n;for(n=this.t-1;n>=0;--n)e[n+t]=this[n];for(n=t-1;n>=0;--n)e[n]=0;e.t=this.t+t,e.s=this.s}function _(t,e){for(var n=t;n<this.t;++n)e[n-t]=this[n];e.t=Math.max(this.t-t,0),e.s=this.s}function F(t,e){var n,r=t%this.DB,i=this.DB-r,s=(1<<i)-1,o=Math.floor(t/this.DB),a=this.s<<r&this.DM;for(n=this.t-1;n>=0;--n)e[n+o+1]=this[n]>>i|a,a=(this[n]&s)<<r;for(n=o-1;n>=0;--n)e[n]=0;e[o]=a,e.t=this.t+o+1,e.s=this.s,e.clamp()}function P(t,e){e.s=this.s;var n=Math.floor(t/this.DB);if(n>=this.t)return void(e.t=0);var r=t%this.DB,i=this.DB-r,s=(1<<r)-1;e[0]=this[n]>>r;for(var o=n+1;o<this.t;++o)e[o-n-1]|=(this[o]&s)<<i,e[o-n]=this[o]>>r;r>0&&(e[this.t-n-1]|=(this.s&s)<<i),e.t=this.t-n,e.clamp()}function O(t,e){for(var n=0,r=0,i=Math.min(t.t,this.t);n<i;)r+=this[n]-t[n],e[n++]=r&this.DM,r>>=this.DB;if(t.t<this.t){for(r-=t.s;n<this.t;)r+=this[n],e[n++]=r&this.DM,r>>=this.DB;r+=this.s}else{for(r+=this.s;n<t.t;)r-=t[n],e[n++]=r&this.DM,r>>=this.DB;r-=t.s}e.s=r<0?-1:0,r<-1?e[n++]=this.DV+r:r>0&&(e[n++]=r),e.t=n,e.clamp()}function C(t,e){var n=this.abs(),r=t.abs(),i=n.t;for(e.t=i+r.t;--i>=0;)e[i]=0;for(i=0;i<r.t;++i)e[i+n.t]=n.am(0,r[i],e,i,0,n.t);e.s=0,e.clamp(),this.s!=t.s&&o.ZERO.subTo(e,e)}function T(t){for(var e=this.abs(),n=t.t=2*e.t;--n>=0;)t[n]=0;for(n=0;n<e.t-1;++n){var r=e.am(n,e[n],t,2*n,0,1);(t[n+e.t]+=e.am(n+1,2*e[n],t,2*n+1,r,e.t-n-1))>=e.DV&&(t[n+e.t]-=e.DV,t[n+e.t+1]=1)}t.t>0&&(t[t.t-1]+=e.am(n,e[n],t,2*n,0,1)),t.s=0,t.clamp()}function D(t,e,n){var r=t.abs();if(!(r.t<=0)){var i=this.abs();if(i.t<r.t)return null!=e&&e.fromInt(0),void(null!=n&&this.copyTo(n));null==n&&(n=a());var s=a(),u=this.s,h=t.s,c=this.DB-E(r[r.t-1]);c>0?(r.lShiftTo(c,s),i.lShiftTo(c,n)):(r.copyTo(s),i.copyTo(n));var f=s.t,l=s[f-1];if(0!=l){var d=l*(1<<this.F1)+(f>1?s[f-2]>>this.F2:0),p=this.FV/d,g=(1<<this.F1)/d,y=1<<this.F2,v=n.t,m=v-f,S=null==e?a():e;for(s.dlShiftTo(m,S),n.compareTo(S)>=0&&(n[n.t++]=1,n.subTo(S,n)),o.ONE.dlShiftTo(f,S),S.subTo(s,s);s.t<f;)s[s.t++]=0;for(;--m>=0;){var b=n[--v]==l?this.DM:Math.floor(n[v]*p+(n[v-1]+y)*g);if((n[v]+=s.am(0,b,n,m,0,f))<b)for(s.dlShiftTo(m,S),n.subTo(S,n);n[v]<--b;)n.subTo(S,n)}null!=e&&(n.drShiftTo(f,e),u!=h&&o.ZERO.subTo(e,e)),n.t=f,n.clamp(),c>0&&n.rShiftTo(c,n),u<0&&o.ZERO.subTo(n,n)}}}function H(t){var e=a();return this.abs().divRemTo(t,null,e),this.s<0&&e.compareTo(o.ZERO)>0&&t.subTo(e,e),e}function j(t){this.m=t}function R(t){return t.s<0||t.compareTo(this.m)>=0?t.mod(this.m):t}function I(t){return t}function k(t){t.divRemTo(this.m,null,t)}function B(t,e,n){t.multiplyTo(e,n),this.reduce(n)}function N(t,e){t.squareTo(e),this.reduce(e)}function V(){if(this.t<1)return 0;var t=this[0];if(0==(1&t))return 0;var e=3&t;return e=e*(2-(15&t)*e)&15,e=e*(2-(255&t)*e)&255,e=e*(2-((65535&t)*e&65535))&65535,e=e*(2-t*e%this.DV)%this.DV,e>0?this.DV-e:-e}function M(t){this.m=t,this.mp=t.invDigit(),this.mpl=32767&this.mp,this.mph=this.mp>>15,this.um=(1<<t.DB-15)-1,this.mt2=2*t.t}function K(t){var e=a();return t.abs().dlShiftTo(this.m.t,e),e.divRemTo(this.m,null,e),t.s<0&&e.compareTo(o.ZERO)>0&&this.m.subTo(e,e),e}function L(t){var e=a();return t.copyTo(e),this.reduce(e),e}function U(t){for(;t.t<=this.mt2;)t[t.t++]=0;for(var e=0;e<this.m.t;++e){var n=32767&t[e],r=n*this.mpl+((n*this.mph+(t[e]>>15)*this.mpl&this.um)<<15)&t.DM;for(n=e+this.m.t,t[n]+=this.m.am(0,r,t,e,0,this.m.t);t[n]>=t.DV;)t[n]-=t.DV,t[++n]++}t.clamp(),t.drShiftTo(this.m.t,t),t.compareTo(this.m)>=0&&t.subTo(this.m,t)}function q(t,e){t.squareTo(e),this.reduce(e)}function W(t,e,n){t.multiplyTo(e,n),this.reduce(n)}function J(){return 0==(this.t>0?1&this[0]:this.s)}function z(t,e){if(t>4294967295||t<1)return o.ONE;var n=a(),r=a(),i=e.convert(this),s=E(t)-1;for(i.copyTo(n);--s>=0;)if(e.sqrTo(n,r),(t&1<<s)>0)e.mulTo(r,i,n);else{var u=n;n=r,r=u}return e.revert(n)}function Y(t,e){var n;return n=t<256||e.isEven()?new j(e):new M(e),this.exp(t,n)}/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
		 */
	function G(){var t=a();return this.copyTo(t),t}function X(){if(this.s<0){if(1==this.t)return this[0]-this.DV;if(0==this.t)return-1}else{if(1==this.t)return this[0];if(0==this.t)return 0}return(this[1]&(1<<32-this.DB)-1)<<this.DB|this[0]}function $(){return 0==this.t?this.s:this[0]<<24>>24}function Z(){return 0==this.t?this.s:this[0]<<16>>16}function Q(t){return Math.floor(Math.LN2*this.DB/Math.log(t))}function tt(){return this.s<0?-1:this.t<=0||1==this.t&&this[0]<=0?0:1}function et(t){if(null==t&&(t=10),0==this.signum()||t<2||t>36)return"0";var e=this.chunkSize(t),n=Math.pow(t,e),r=g(n),i=a(),s=a(),o="";for(this.divRemTo(r,i,s);i.signum()>0;)o=(n+s.intValue()).toString(t).substr(1)+o,i.divRemTo(r,i,s);return s.intValue().toString(t)+o}function nt(t,e){this.fromInt(0),null==e&&(e=10);for(var n=this.chunkSize(e),r=Math.pow(e,n),i=!1,s=0,a=0,u=0;u<t.length;++u){var h=l(t,u);h<0?"-"==t.charAt(u)&&0==this.signum()&&(i=!0):(a=e*a+h,++s>=n&&(this.dMultiply(r),this.dAddOffset(a,0),s=0,a=0))}s>0&&(this.dMultiply(Math.pow(e,s)),this.dAddOffset(a,0)),i&&o.ZERO.subTo(this,this)}function rt(t,e,n){if("number"==typeof e)if(t<2)this.fromInt(1);else for(this.fromNumber(t,n),this.testBit(t-1)||this.bitwiseTo(o.ONE.shiftLeft(t-1),ft,this),this.isEven()&&this.dAddOffset(1,0);!this.isProbablePrime(e);)this.dAddOffset(2,0),this.bitLength()>t&&this.subTo(o.ONE.shiftLeft(t-1),this);else{var r=new Array,i=7&t;r.length=(t>>3)+1,e.nextBytes(r),i>0?r[0]&=(1<<i)-1:r[0]=0,this.fromString(r,256)}}function it(){var t=this.t,e=new Array;e[0]=this.s;var n,r=this.DB-t*this.DB%8,i=0;if(t-- >0)for(r<this.DB&&(n=this[t]>>r)!=(this.s&this.DM)>>r&&(e[i++]=n|this.s<<this.DB-r);t>=0;)r<8?(n=(this[t]&(1<<r)-1)<<8-r,n|=this[--t]>>(r+=this.DB-8)):(n=this[t]>>(r-=8)&255,r<=0&&(r+=this.DB,--t)),0!=(128&n)&&(n|=-256),0==i&&(128&this.s)!=(128&n)&&++i,(i>0||n!=this.s)&&(e[i++]=n);return e}function st(t){return 0==this.compareTo(t)}function ot(t){return this.compareTo(t)<0?this:t}function at(t){return this.compareTo(t)>0?this:t}function ut(t,e,n){var r,i,s=Math.min(t.t,this.t);for(r=0;r<s;++r)n[r]=e(this[r],t[r]);if(t.t<this.t){for(i=t.s&this.DM,r=s;r<this.t;++r)n[r]=e(this[r],i);n.t=this.t}else{for(i=this.s&this.DM,r=s;r<t.t;++r)n[r]=e(i,t[r]);n.t=t.t}n.s=e(this.s,t.s),n.clamp()}function ht(t,e){return t&e}function ct(t){var e=a();return this.bitwiseTo(t,ht,e),e}function ft(t,e){return t|e}function lt(t){var e=a();return this.bitwiseTo(t,ft,e),e}function dt(t,e){return t^e}function pt(t){var e=a();return this.bitwiseTo(t,dt,e),e}function gt(t,e){return t&~e}function yt(t){var e=a();return this.bitwiseTo(t,gt,e),e}function vt(){for(var t=a(),e=0;e<this.t;++e)t[e]=this.DM&~this[e];return t.t=this.t,t.s=~this.s,t}function mt(t){var e=a();return t<0?this.rShiftTo(-t,e):this.lShiftTo(t,e),e}function St(t){var e=a();return t<0?this.lShiftTo(-t,e):this.rShiftTo(t,e),e}function bt(t){if(0==t)return-1;var e=0;return 0==(65535&t)&&(t>>=16,e+=16),0==(255&t)&&(t>>=8,e+=8),0==(15&t)&&(t>>=4,e+=4),0==(3&t)&&(t>>=2,e+=2),0==(1&t)&&++e,e}function wt(){for(var t=0;t<this.t;++t)if(0!=this[t])return t*this.DB+bt(this[t]);return this.s<0?this.t*this.DB:-1}function Et(t){for(var e=0;0!=t;)t&=t-1,++e;return e}function xt(){for(var t=0,e=this.s&this.DM,n=0;n<this.t;++n)t+=Et(this[n]^e);return t}function At(t){var e=Math.floor(t/this.DB);return e>=this.t?0!=this.s:0!=(this[e]&1<<t%this.DB)}function _t(t,e){var n=o.ONE.shiftLeft(t);return this.bitwiseTo(n,e,n),n}function Ft(t){return this.changeBit(t,ft)}function Pt(t){return this.changeBit(t,gt)}function Ot(t){return this.changeBit(t,dt)}function Ct(t,e){for(var n=0,r=0,i=Math.min(t.t,this.t);n<i;)r+=this[n]+t[n],e[n++]=r&this.DM,r>>=this.DB;if(t.t<this.t){for(r+=t.s;n<this.t;)r+=this[n],e[n++]=r&this.DM,r>>=this.DB;r+=this.s}else{for(r+=this.s;n<t.t;)r+=t[n],e[n++]=r&this.DM,r>>=this.DB;r+=t.s}e.s=r<0?-1:0,r>0?e[n++]=r:r<-1&&(e[n++]=this.DV+r),e.t=n,e.clamp()}function Tt(t){var e=a();return this.addTo(t,e),e}function Dt(t){var e=a();return this.subTo(t,e),e}function Ht(t){var e=a();return this.multiplyTo(t,e),e}function jt(){var t=a();return this.squareTo(t),t}function Rt(t){var e=a();return this.divRemTo(t,e,null),e}function It(t){var e=a();return this.divRemTo(t,null,e),e}function kt(t){var e=a(),n=a();return this.divRemTo(t,e,n),new Array(e,n)}function Bt(t){this[this.t]=this.am(0,t-1,this,0,0,this.t),++this.t,this.clamp()}function Nt(t,e){if(0!=t){for(;this.t<=e;)this[this.t++]=0;for(this[e]+=t;this[e]>=this.DV;)this[e]-=this.DV,++e>=this.t&&(this[this.t++]=0),++this[e]}}function Vt(){}function Mt(t){return t}function Kt(t,e,n){t.multiplyTo(e,n)}function Lt(t,e){t.squareTo(e)}function Ut(t){return this.exp(t,new Vt)}function qt(t,e,n){var r=Math.min(this.t+t.t,e);for(n.s=0,n.t=r;r>0;)n[--r]=0;var i;for(i=n.t-this.t;r<i;++r)n[r+this.t]=this.am(0,t[r],n,r,0,this.t);for(i=Math.min(t.t,e);r<i;++r)this.am(0,t[r],n,r,0,e-r);n.clamp()}function Wt(t,e,n){--e;var r=n.t=this.t+t.t-e;for(n.s=0;--r>=0;)n[r]=0;for(r=Math.max(e-this.t,0);r<t.t;++r)n[this.t+r-e]=this.am(e-r,t[r],n,0,0,this.t+r-e);n.clamp(),n.drShiftTo(1,n)}function Jt(t){this.r2=a(),this.q3=a(),o.ONE.dlShiftTo(2*t.t,this.r2),this.mu=this.r2.divide(t),this.m=t}function zt(t){if(t.s<0||t.t>2*this.m.t)return t.mod(this.m);if(t.compareTo(this.m)<0)return t;var e=a();return t.copyTo(e),this.reduce(e),e}function Yt(t){return t}function Gt(t){for(t.drShiftTo(this.m.t-1,this.r2),t.t>this.m.t+1&&(t.t=this.m.t+1,t.clamp()),this.mu.multiplyUpperTo(this.r2,this.m.t+1,this.q3),this.m.multiplyLowerTo(this.q3,this.m.t+1,this.r2);t.compareTo(this.r2)<0;)t.dAddOffset(1,this.m.t+1);for(t.subTo(this.r2,t);t.compareTo(this.m)>=0;)t.subTo(this.m,t)}function Xt(t,e){t.squareTo(e),this.reduce(e)}function $t(t,e,n){t.multiplyTo(e,n),this.reduce(n)}function Zt(t,e){var n,r,i=t.bitLength(),s=g(1);if(i<=0)return s;n=i<18?1:i<48?3:i<144?4:i<768?5:6,r=i<8?new j(e):e.isEven()?new Jt(e):new M(e);var o=new Array,u=3,h=n-1,c=(1<<n)-1;if(o[1]=r.convert(this),n>1){var f=a();for(r.sqrTo(o[1],f);u<=c;)o[u]=a(),r.mulTo(f,o[u-2],o[u]),u+=2}var l,d,p=t.t-1,y=!0,v=a();for(i=E(t[p])-1;p>=0;){for(i>=h?l=t[p]>>i-h&c:(l=(t[p]&(1<<i+1)-1)<<h-i,p>0&&(l|=t[p-1]>>this.DB+i-h)),u=n;0==(1&l);)l>>=1,--u;if((i-=u)<0&&(i+=this.DB,--p),y)o[l].copyTo(s),y=!1;else{for(;u>1;)r.sqrTo(s,v),r.sqrTo(v,s),u-=2;u>0?r.sqrTo(s,v):(d=s,s=v,v=d),r.mulTo(v,o[l],s)}for(;p>=0&&0==(t[p]&1<<i);)r.sqrTo(s,v),d=s,s=v,v=d,--i<0&&(i=this.DB-1,--p)}return r.revert(s)}function Qt(t){var e=this.s<0?this.negate():this.clone(),n=t.s<0?t.negate():t.clone();if(e.compareTo(n)<0){var r=e;e=n,n=r}var i=e.getLowestSetBit(),s=n.getLowestSetBit();if(s<0)return e;for(i<s&&(s=i),s>0&&(e.rShiftTo(s,e),n.rShiftTo(s,n));e.signum()>0;)(i=e.getLowestSetBit())>0&&e.rShiftTo(i,e),(i=n.getLowestSetBit())>0&&n.rShiftTo(i,n),e.compareTo(n)>=0?(e.subTo(n,e),e.rShiftTo(1,e)):(n.subTo(e,n),n.rShiftTo(1,n));return s>0&&n.lShiftTo(s,n),n}function te(t){if(t<=0)return 0;var e=this.DV%t,n=this.s<0?t-1:0;if(this.t>0)if(0==e)n=this[0]%t;else for(var r=this.t-1;r>=0;--r)n=(e*n+this[r])%t;return n}function ee(t){var e=t.isEven();if(this.isEven()&&e||0==t.signum())return o.ZERO;for(var n=t.clone(),r=this.clone(),i=g(1),s=g(0),a=g(0),u=g(1);0!=n.signum();){for(;n.isEven();)n.rShiftTo(1,n),e?(i.isEven()&&s.isEven()||(i.addTo(this,i),s.subTo(t,s)),i.rShiftTo(1,i)):s.isEven()||s.subTo(t,s),s.rShiftTo(1,s);for(;r.isEven();)r.rShiftTo(1,r),e?(a.isEven()&&u.isEven()||(a.addTo(this,a),u.subTo(t,u)),a.rShiftTo(1,a)):u.isEven()||u.subTo(t,u),u.rShiftTo(1,u);n.compareTo(r)>=0?(n.subTo(r,n),e&&i.subTo(a,i),s.subTo(u,s)):(r.subTo(n,r),e&&a.subTo(i,a),u.subTo(s,u))}return 0!=r.compareTo(o.ONE)?o.ZERO:u.compareTo(t)>=0?u.subtract(t):u.signum()<0?(u.addTo(t,u),u.signum()<0?u.add(t):u):u}function ne(t){var e,n=this.abs();if(1==n.t&&n[0]<=vr[vr.length-1]){for(e=0;e<vr.length;++e)if(n[0]==vr[e])return!0;return!1}if(n.isEven())return!1;for(e=1;e<vr.length;){for(var r=vr[e],i=e+1;i<vr.length&&r<mr;)r*=vr[i++];for(r=n.modInt(r);e<i;)if(r%vr[e++]==0)return!1}return n.millerRabin(t)}function re(t){var e=this.subtract(o.ONE),n=e.getLowestSetBit();if(n<=0)return!1;var r=e.shiftRight(n);t=t+1>>1,t>vr.length&&(t=vr.length);for(var i=a(),s=0;s<t;++s){i.fromInt(vr[Math.floor(Math.random()*vr.length)]);var u=i.modPow(r,this);if(0!=u.compareTo(o.ONE)&&0!=u.compareTo(e)){for(var h=1;h++<n&&0!=u.compareTo(e);)if(u=u.modPowInt(2,this),0==u.compareTo(o.ONE))return!1;if(0!=u.compareTo(e))return!1}}return!0}/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
		 */
	function ie(){this.i=0,this.j=0,this.S=new Array}function se(t){var e,n,r;for(e=0;e<256;++e)this.S[e]=e;for(n=0,e=0;e<256;++e)n=n+this.S[e]+t[e%t.length]&255,r=this.S[e],this.S[e]=this.S[n],this.S[n]=r;this.i=0,this.j=0}function oe(){var t;return this.i=this.i+1&255,this.j=this.j+this.S[this.i]&255,t=this.S[this.i],this.S[this.i]=this.S[this.j],this.S[this.j]=t,this.S[t+this.S[this.i]&255]}function ae(){return new ie}function ue(t){br[wr++]^=255&t,br[wr++]^=t>>8&255,br[wr++]^=t>>16&255,br[wr++]^=t>>24&255,wr>=Er&&(wr-=Er)}function he(){ue((new Date).getTime())}function ce(){if(null==Sr){for(he(),Sr=ae(),Sr.init(br),wr=0;wr<br.length;++wr)br[wr]=0;wr=0}return Sr.next()}function fe(t){var e;for(e=0;e<t.length;++e)t[e]=ce()}function le(){}/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
		 */
	function de(t,e){return new o(t,e)}function pe(t,e){if(e<t.length+11)return alert("Message too long for RSA"),null;for(var n=new Array,r=t.length-1;r>=0&&e>0;){var i=t.charCodeAt(r--);i<128?n[--e]=i:i>127&&i<2048?(n[--e]=63&i|128,n[--e]=i>>6|192):(n[--e]=63&i|128,n[--e]=i>>6&63|128,n[--e]=i>>12|224)}n[--e]=0;for(var s=new le,a=new Array;e>2;){for(a[0]=0;0==a[0];)s.nextBytes(a);n[--e]=a[0]}return n[--e]=2,n[--e]=0,new o(n)}function ge(t,e,n){for(var r="",i=0;r.length<e;)r+=n(String.fromCharCode.apply(String,t.concat([(4278190080&i)>>24,(16711680&i)>>16,(65280&i)>>8,255&i]))),i+=1;return r}function ye(t,e,n){if(t.length+2*Fr+2>e)throw"Message too long for RSA";var r,i="";for(r=0;r<e-t.length-2*Fr-2;r+=1)i+="\0";var s=rstr_sha1("")+i+""+t,a=new Array(Fr);(new le).nextBytes(a);var u=ge(a,s.length,n||rstr_sha1),h=[];for(r=0;r<s.length;r+=1)h[r]=s.charCodeAt(r)^u.charCodeAt(r);var c=ge(h,a.length,rstr_sha1),f=[0];for(r=0;r<a.length;r+=1)f[r+1]=a[r]^c.charCodeAt(r);return new o(f.concat(h))}function ve(){this.n=null,this.e=0,this.d=null,this.p=null,this.q=null,this.dmp1=null,this.dmq1=null,this.coeff=null}function me(t,e){this.isPublic=!0,"string"!=typeof t?(this.n=t,this.e=e):null!=t&&null!=e&&t.length>0&&e.length>0?(this.n=de(t,16),this.e=parseInt(e,16)):alert("Invalid RSA public key")}function Se(t){return t.modPowInt(this.e,this.n)}function be(t){var e=pe(t,this.n.bitLength()+7>>3);if(null==e)return null;var n=this.doPublic(e);if(null==n)return null;var r=n.toString(16);return 0==(1&r.length)?r:"0"+r}function we(t,e){var n=ye(t,this.n.bitLength()+7>>3,e);if(null==n)return null;var r=this.doPublic(n);if(null==r)return null;var i=r.toString(16);return 0==(1&i.length)?i:"0"+i}/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
		 */
	function Ee(t,e){for(var n=t.toByteArray(),r=0;r<n.length&&0==n[r];)++r;if(n.length-r!=e-1||2!=n[r])return null;for(++r;0!=n[r];)if(++r>=n.length)return null;for(var i="";++r<n.length;){var s=255&n[r];s<128?i+=String.fromCharCode(s):s>191&&s<224?(i+=String.fromCharCode((31&s)<<6|63&n[r+1]),++r):(i+=String.fromCharCode((15&s)<<12|(63&n[r+1])<<6|63&n[r+2]),r+=2)}return i}function xe(t,e,n){for(var r="",i=0;r.length<e;)r+=n(t+String.fromCharCode.apply(String,[(4278190080&i)>>24,(16711680&i)>>16,(65280&i)>>8,255&i])),i+=1;return r}function Ae(t,e,n){t=t.toByteArray();var r;for(r=0;r<t.length;r+=1)t[r]&=255;for(;t.length<e;)t.unshift(0);if(t=String.fromCharCode.apply(String,t),t.length<2*Fr+2)throw"Cipher too short";var r,i=t.substr(1,Fr),s=t.substr(Fr+1),o=xe(s,Fr,n||rstr_sha1),a=[];for(r=0;r<i.length;r+=1)a[r]=i.charCodeAt(r)^o.charCodeAt(r);var u=xe(String.fromCharCode.apply(String,a),t.length-Fr,rstr_sha1),h=[];for(r=0;r<s.length;r+=1)h[r]=s.charCodeAt(r)^u.charCodeAt(r);if(h=String.fromCharCode.apply(String,h),h.substr(0,Fr)!==rstr_sha1(""))throw"Hash mismatch";h=h.substr(Fr);var c=h.indexOf(""),f=c!=-1?h.substr(0,c).lastIndexOf("\0"):-1;if(f+1!=c)throw"Malformed data";return h.substr(c+1)}function _e(t,e,n){this.isPrivate=!0,"string"!=typeof t?(this.n=t,this.e=e,this.d=n):null!=t&&null!=e&&t.length>0&&e.length>0?(this.n=de(t,16),this.e=parseInt(e,16),this.d=de(n,16)):alert("Invalid RSA private key")}function Fe(t,e,n,r,i,s,o,a){if(this.isPrivate=!0,null==t)throw"RSASetPrivateEx N == null";if(null==e)throw"RSASetPrivateEx E == null";if(0==t.length)throw"RSASetPrivateEx N.length == 0";if(0==e.length)throw"RSASetPrivateEx E.length == 0";null!=t&&null!=e&&t.length>0&&e.length>0?(this.n=de(t,16),this.e=parseInt(e,16),this.d=de(n,16),this.p=de(r,16),this.q=de(i,16),this.dmp1=de(s,16),this.dmq1=de(o,16),this.coeff=de(a,16)):alert("Invalid RSA private key in RSASetPrivateEx")}function Pe(t,e){var n=new le,r=t>>1;this.e=parseInt(e,16);for(var i=new o(e,16);;){for(;this.p=new o(t-r,1,n),0!=this.p.subtract(o.ONE).gcd(i).compareTo(o.ONE)||!this.p.isProbablePrime(10););for(;this.q=new o(r,1,n),0!=this.q.subtract(o.ONE).gcd(i).compareTo(o.ONE)||!this.q.isProbablePrime(10););if(this.p.compareTo(this.q)<=0){var s=this.p;this.p=this.q,this.q=s}var a=this.p.subtract(o.ONE),u=this.q.subtract(o.ONE),h=a.multiply(u);if(0==h.gcd(i).compareTo(o.ONE)){this.n=this.p.multiply(this.q),this.d=i.modInverse(h),this.dmp1=this.d.mod(a),this.dmq1=this.d.mod(u),this.coeff=this.q.modInverse(this.p);break}}}function Oe(t){if(null==this.p||null==this.q)return t.modPow(this.d,this.n);for(var e=t.mod(this.p).modPow(this.dmp1,this.p),n=t.mod(this.q).modPow(this.dmq1,this.q);e.compareTo(n)<0;)e=e.add(this.p);return e.subtract(n).multiply(this.coeff).mod(this.p).multiply(this.q).add(n)}function Ce(t){var e=de(t,16),n=this.doPrivate(e);return null==n?null:Ee(n,this.n.bitLength()+7>>3)}function Te(t,e){var n=de(t,16),r=this.doPrivate(n);return null==r?null:Ae(r,this.n.bitLength()+7>>3,e)}/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
		 */
	function De(t,e){this.x=e,this.q=t}function He(t){return t==this||this.q.equals(t.q)&&this.x.equals(t.x)}function je(){return this.x}function Re(){return new De(this.q,this.x.negate().mod(this.q))}function Ie(t){return new De(this.q,this.x.add(t.toBigInteger()).mod(this.q))}function ke(t){return new De(this.q,this.x.subtract(t.toBigInteger()).mod(this.q))}function Be(t){return new De(this.q,this.x.multiply(t.toBigInteger()).mod(this.q))}function Ne(){return new De(this.q,this.x.square().mod(this.q))}function Ve(t){return new De(this.q,this.x.multiply(t.toBigInteger().modInverse(this.q)).mod(this.q))}function Me(t,e,n,r){this.curve=t,this.x=e,this.y=n,null==r?this.z=o.ONE:this.z=r,this.zinv=null}function Ke(){return null==this.zinv&&(this.zinv=this.z.modInverse(this.curve.q)),this.curve.fromBigInteger(this.x.toBigInteger().multiply(this.zinv).mod(this.curve.q))}function Le(){return null==this.zinv&&(this.zinv=this.z.modInverse(this.curve.q)),this.curve.fromBigInteger(this.y.toBigInteger().multiply(this.zinv).mod(this.curve.q))}function Ue(t){if(t==this)return!0;if(this.isInfinity())return t.isInfinity();if(t.isInfinity())return this.isInfinity();var e,n;return e=t.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(t.z)).mod(this.curve.q),!!e.equals(o.ZERO)&&(n=t.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(t.z)).mod(this.curve.q),n.equals(o.ZERO))}function qe(){return null==this.x&&null==this.y||this.z.equals(o.ZERO)&&!this.y.toBigInteger().equals(o.ZERO)}function We(){return new Me(this.curve,this.x,this.y.negate(),this.z)}function Je(t){if(this.isInfinity())return t;if(t.isInfinity())return this;var e=t.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(t.z)).mod(this.curve.q),n=t.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(t.z)).mod(this.curve.q);if(o.ZERO.equals(n))return o.ZERO.equals(e)?this.twice():this.curve.getInfinity();var r=new o("3"),i=this.x.toBigInteger(),s=this.y.toBigInteger(),a=(t.x.toBigInteger(),t.y.toBigInteger(),n.square()),u=a.multiply(n),h=i.multiply(a),c=e.square().multiply(this.z),f=c.subtract(h.shiftLeft(1)).multiply(t.z).subtract(u).multiply(n).mod(this.curve.q),l=h.multiply(r).multiply(e).subtract(s.multiply(u)).subtract(c.multiply(e)).multiply(t.z).add(e.multiply(u)).mod(this.curve.q),d=u.multiply(this.z).multiply(t.z).mod(this.curve.q);return new Me(this.curve,this.curve.fromBigInteger(f),this.curve.fromBigInteger(l),d)}function ze(){if(this.isInfinity())return this;if(0==this.y.toBigInteger().signum())return this.curve.getInfinity();var t=new o("3"),e=this.x.toBigInteger(),n=this.y.toBigInteger(),r=n.multiply(this.z),i=r.multiply(n).mod(this.curve.q),s=this.curve.a.toBigInteger(),a=e.square().multiply(t);o.ZERO.equals(s)||(a=a.add(this.z.square().multiply(s))),a=a.mod(this.curve.q);var u=a.square().subtract(e.shiftLeft(3).multiply(i)).shiftLeft(1).multiply(r).mod(this.curve.q),h=a.multiply(t).multiply(e).subtract(i.shiftLeft(1)).shiftLeft(2).multiply(i).subtract(a.square().multiply(a)).mod(this.curve.q),c=r.square().multiply(r).shiftLeft(3).mod(this.curve.q);return new Me(this.curve,this.curve.fromBigInteger(u),this.curve.fromBigInteger(h),c)}function Ye(t){if(this.isInfinity())return this;if(0==t.signum())return this.curve.getInfinity();var e,n=t,r=n.multiply(new o("3")),i=this.negate(),s=this;for(e=r.bitLength()-2;e>0;--e){s=s.twice();var a=r.testBit(e),u=n.testBit(e);a!=u&&(s=s.add(a?this:i))}return s}function Ge(t,e,n){var r;r=t.bitLength()>n.bitLength()?t.bitLength()-1:n.bitLength()-1;for(var i=this.curve.getInfinity(),s=this.add(e);r>=0;)i=i.twice(),t.testBit(r)?i=n.testBit(r)?i.add(s):i.add(this):n.testBit(r)&&(i=i.add(e)),--r;return i}function Xe(t,e,n){this.q=t,this.a=this.fromBigInteger(e),this.b=this.fromBigInteger(n),this.infinity=new Me(this,null,null)}function $e(){return this.q}function Ze(){return this.a}function Qe(){return this.b}function tn(t){return t==this||this.q.equals(t.q)&&this.a.equals(t.a)&&this.b.equals(t.b)}function en(){return this.infinity}function nn(t){return new De(this.q,t)}function rn(t){switch(parseInt(t.substr(0,2),16)){case 0:return this.infinity;case 2:case 3:return null;case 4:case 6:case 7:var e=(t.length-2)/2,n=t.substr(2,e),r=t.substr(e+2,e);return new Me(this,this.fromBigInteger(new o(n,16)),this.fromBigInteger(new o(r,16)));default:return null}}function sn(t){for(var e=new Array,n=0;n<t.length;n++)e[n]=t.charCodeAt(n);return e}function on(t){for(var e="",n=0;n<t.length;n++)e+=String.fromCharCode(t[n]);return e}function an(t){for(var e="",n=0;n<t.length;n++){var r=t[n].toString(16);1==r.length&&(r="0"+r),e+=r}return e}function un(t){return an(sn(t))}function hn(t){return r(un(t))}function cn(t){return ln(r(un(t)))}function fn(t){return on(s(dn(t)))}function ln(t){return t=t.replace(/\=/g,""),t=t.replace(/\+/g,"-"),t=t.replace(/\//g,"_")}function dn(t){return t.length%4==2?t+="==":t.length%4==3&&(t+="="),t=t.replace(/-/g,"+"),t=t.replace(/_/g,"/")}function pn(t){return t.length%2==1&&(t="0"+t),ln(r(t))}function gn(t){return i(dn(t))}function yn(t){return r(xn(_n(t)))}function vn(t){return decodeURIComponent(An(i(t)))}function mn(t){return xn(_n(t))}function Sn(t){return decodeURIComponent(An(t))}function bn(t){for(var e="",n=0;n<t.length-1;n+=2)e+=String.fromCharCode(parseInt(t.substr(n,2),16));return e}function wn(t){for(var e="",n=0;n<t.length;n++)e+=("0"+t.charCodeAt(n).toString(16)).slice(-2);return e}function En(t){return r(t)}function xn(t){return t.replace(/%/g,"")}function An(t){return t.replace(/(..)/g,"%$1")}function _n(t){for(var e=encodeURIComponent(t),n="",r=0;r<e.length;r++)"%"==e[r]?(n+=e.substr(r,3),r+=2):n=n+"%"+un(e[r]);return n}function Fn(t){return t=t.replace(/\r\n/gm,"\n")}function Pn(t){return t=t.replace(/\r\n/gm,"\n"),t=t.replace(/\n/gm,"\r\n")}function On(t){t=t.replace(/^\s*\[\s*/,""),t=t.replace(/\s*\]\s*$/,""),t=t.replace(/\s*/g,"");try{var e=t.split(/,/).map(function(t,e,n){var r=parseInt(t);if(r<0||255<r)throw"integer not in range 0-255";var i=("00"+r.toString(16)).slice(-2);return i}).join("");return e}catch(t){throw"malformed integer array string: "+t}}/*! rsapem-1.1.js (c) 2012 Kenji Urushima | kjur.github.com/jsrsasign/license
		 */
	function Cn(t){var e=t;return e=e.replace("-----BEGIN RSA PRIVATE KEY-----",""),e=e.replace("-----END RSA PRIVATE KEY-----",""),e=e.replace(/[ \n]+/g,"")}function Tn(t){var e=new Array,n=Or.getStartPosOfV_AtObj(t,0),r=Or.getPosOfNextSibling_AtObj(t,n),i=Or.getPosOfNextSibling_AtObj(t,r),s=Or.getPosOfNextSibling_AtObj(t,i),o=Or.getPosOfNextSibling_AtObj(t,s),a=Or.getPosOfNextSibling_AtObj(t,o),u=Or.getPosOfNextSibling_AtObj(t,a),h=Or.getPosOfNextSibling_AtObj(t,u),c=Or.getPosOfNextSibling_AtObj(t,h);return e.push(n,r,i,s,o,a,u,h,c),e}function Dn(t){var e=Tn(t),n=Or.getHexOfV_AtObj(t,e[0]),r=Or.getHexOfV_AtObj(t,e[1]),i=Or.getHexOfV_AtObj(t,e[2]),s=Or.getHexOfV_AtObj(t,e[3]),o=Or.getHexOfV_AtObj(t,e[4]),a=Or.getHexOfV_AtObj(t,e[5]),u=Or.getHexOfV_AtObj(t,e[6]),h=Or.getHexOfV_AtObj(t,e[7]),c=Or.getHexOfV_AtObj(t,e[8]),f=new Array;return f.push(n,r,i,s,o,a,u,h,c),f}function Hn(t){var e=Dn(t);this.setPrivateEx(e[1],e[2],e[3],e[4],e[5],e[6],e[7],e[8])}function jn(t){var e=Cn(t),n=i(e),r=Dn(n);this.setPrivateEx(r[1],r[2],r[3],r[4],r[5],r[6],r[7],r[8])}function Rn(t,e){for(var n="",r=e/4-t.length,i=0;i<r;i++)n+="0";return n+t}function In(t,e){var n=function(t){return Cr.crypto.Util.hashString(t,e)},r=n(t);return this.signWithMessageHash(r,e)}function kn(t,e){var n=Cr.crypto.Util.getPaddedDigestInfoHex(t,e,this.n.bitLength()),r=de(n,16),i=this.doPrivate(r),s=i.toString(16);return Rn(s,this.n.bitLength())}function Bn(t){return In.call(this,t,"sha1")}function Nn(t){return In.call(this,t,"sha256")}function Vn(t,e,n){for(var r="",i=0;r.length<e;)r+=bn(n(wn(t+String.fromCharCode.apply(String,[(4278190080&i)>>24,(16711680&i)>>16,(65280&i)>>8,255&i])))),i+=1;return r}function Mn(t,e,n){var r=function(t){return Cr.crypto.Util.hashHex(t,e)},i=r(wn(t));return void 0===n&&(n=-1),this.signWithMessageHashPSS(i,e,n)}function Kn(t,e,n){var r,i=bn(t),s=i.length,a=this.n.bitLength()-1,u=Math.ceil(a/8),h=function(t){return Cr.crypto.Util.hashHex(t,e)};if(n===-1||void 0===n)n=s;else if(n===-2)n=u-s-2;else if(n<-2)throw"invalid salt length";if(u<s+n+2)throw"data too long";var c="";n>0&&(c=new Array(n),(new le).nextBytes(c),c=String.fromCharCode.apply(String,c));var f=bn(h(wn("\0\0\0\0\0\0\0\0"+i+c))),l=[];for(r=0;r<u-n-s-2;r+=1)l[r]=0;var d=String.fromCharCode.apply(String,l)+""+c,p=Vn(f,d.length,h),g=[];for(r=0;r<d.length;r+=1)g[r]=d.charCodeAt(r)^p.charCodeAt(r);var y=65280>>8*u-a&255;for(g[0]&=~y,r=0;r<s;r++)g.push(f.charCodeAt(r));return g.push(188),Rn(this.doPrivate(new o(g)).toString(16),this.n.bitLength())}function Ln(t,e,n){var r=new ve;r.setPublic(e,n);var i=r.doPublic(t);return i}function Un(t,e,n){var r=Ln(t,e,n),i=r.toString(16).replace(/^1f+00/,"");return i}function qn(t){for(var e in Cr.crypto.Util.DIGESTINFOHEAD){var n=Cr.crypto.Util.DIGESTINFOHEAD[e],r=n.length;if(t.substring(0,r)==n){var i=[e,t.substring(r)];return i}}return[]}function Wn(t,e,n,r){var i=Un(e,n,r),s=qn(i);if(0==s.length)return!1;var o=s[0],a=s[1],u=function(t){return Cr.crypto.Util.hashString(t,o)},h=u(t);return a==h}function Jn(t,e){var n=de(t,16),r=Wn(e,n,this.n.toString(16),this.e.toString(16));return r}function zn(t,e){e=e.replace(Ir,""),e=e.replace(/[ \n]+/g,"");var n=de(e,16);if(n.bitLength()>this.n.bitLength())return 0;var r=this.doPublic(n),i=r.toString(16).replace(/^1f+00/,""),s=qn(i);if(0==s.length)return!1;var o=s[0],a=s[1],u=function(t){return Cr.crypto.Util.hashString(t,o)},h=u(t);return a==h}function Yn(t,e){e=e.replace(Ir,""),e=e.replace(/[ \n]+/g,"");var n=de(e,16);if(n.bitLength()>this.n.bitLength())return 0;var r=this.doPublic(n),i=r.toString(16).replace(/^1f+00/,""),s=qn(i);if(0==s.length)return!1;var o=(s[0],s[1]);return o==t}function Gn(t,e,n,r){var i=function(t){return Cr.crypto.Util.hashHex(t,n)},s=i(wn(t));return void 0===r&&(r=-1),this.verifyWithMessageHashPSS(s,e,n,r)}function Xn(t,e,n,r){var i=new o(e,16);if(i.bitLength()>this.n.bitLength())return!1;var s,a=function(t){return Cr.crypto.Util.hashHex(t,n)},u=bn(t),h=u.length,c=this.n.bitLength()-1,f=Math.ceil(c/8);if(r===-1||void 0===r)r=h;else if(r===-2)r=f-h-2;else if(r<-2)throw"invalid salt length";if(f<h+r+2)throw"data too long";var l=this.doPublic(i).toByteArray();for(s=0;s<l.length;s+=1)l[s]&=255;for(;l.length<f;)l.unshift(0);if(188!==l[f-1])throw"encoded message does not end in 0xbc";l=String.fromCharCode.apply(String,l);var d=l.substr(0,f-h-1),p=l.substr(d.length,h),g=65280>>8*f-c&255;if(0!==(d.charCodeAt(0)&g))throw"bits beyond keysize not zero";var y=Vn(p,d.length,a),v=[];for(s=0;s<d.length;s+=1)v[s]=d.charCodeAt(s)^y.charCodeAt(s);v[0]&=~g;var m=f-h-r-2;for(s=0;s<m;s+=1)if(0!==v[s])throw"leftmost octets not zero";if(1!==v[m])throw"0x01 marker not found";return p===bn(a(wn("\0\0\0\0\0\0\0\0"+u+String.fromCharCode.apply(String,v.slice(-r)))))}/*! x509-1.1.9.js (c) 2012-2016 Kenji Urushima | kjur.github.com/jsrsasign/license
		 */
	function $n(){this.subjectPublicKeyRSA=null,this.subjectPublicKeyRSA_hN=null,this.subjectPublicKeyRSA_hE=null,this.hex=null,this.getSerialNumberHex=function(){return Or.getDecendantHexVByNthList(this.hex,0,[0,1])},this.getSignatureAlgorithmField=function(){var t=Or.getDecendantHexVByNthList(this.hex,0,[0,2,0]),e=Cr.asn1.ASN1Util.oidHexToInt(t),n=Cr.asn1.x509.OID.oid2name(e);return n},this.getIssuerHex=function(){return Or.getDecendantHexTLVByNthList(this.hex,0,[0,3])},this.getIssuerString=function(){return $n.hex2dn(Or.getDecendantHexTLVByNthList(this.hex,0,[0,3]))},this.getSubjectHex=function(){return Or.getDecendantHexTLVByNthList(this.hex,0,[0,5])},this.getSubjectString=function(){return $n.hex2dn(Or.getDecendantHexTLVByNthList(this.hex,0,[0,5]))},this.getNotBefore=function(){var t=Or.getDecendantHexVByNthList(this.hex,0,[0,4,0]);return t=t.replace(/(..)/g,"%$1"),t=decodeURIComponent(t)},this.getNotAfter=function(){var t=Or.getDecendantHexVByNthList(this.hex,0,[0,4,1]);return t=t.replace(/(..)/g,"%$1"),t=decodeURIComponent(t)},this.readCertPEM=function(t){var e=$n.pemToHex(t),n=$n.getPublicKeyHexArrayFromCertHex(e),r=new ve;r.setPublic(n[0],n[1]),this.subjectPublicKeyRSA=r,this.subjectPublicKeyRSA_hN=n[0],this.subjectPublicKeyRSA_hE=n[1],this.hex=e},this.readCertPEMWithoutRSAInit=function(t){var e=$n.pemToHex(t),n=$n.getPublicKeyHexArrayFromCertHex(e);this.subjectPublicKeyRSA.setPublic(n[0],n[1]),this.subjectPublicKeyRSA_hN=n[0],this.subjectPublicKeyRSA_hE=n[1],this.hex=e},this.getInfo=function(){var t="Basic Fields\n";t+="  serial number: "+this.getSerialNumberHex()+"\n",t+="  signature algorithm: "+this.getSignatureAlgorithmField()+"\n",t+="  issuer: "+this.getIssuerString()+"\n",t+="  notBefore: "+this.getNotBefore()+"\n",t+="  notAfter: "+this.getNotAfter()+"\n",t+="  subject: "+this.getSubjectString()+"\n",t+="  subject public key info: \n";var e=$n.getSubjectPublicKeyInfoPosFromCertHex(this.hex),n=Or.getHexOfTLV_AtObj(this.hex,e),r=Rr.getKey(n,null,"pkcs8pub");r instanceof ve&&(t+="    key algorithm: RSA\n",t+="    n="+r.n.toString(16).substr(0,16)+"...\n",t+="    e="+r.e.toString(16)+"\n"),t+="X509v3 Extensions:\n";for(var i=$n.getV3ExtInfoListOfCertHex(this.hex),s=0;s<i.length;s++){var o=i[s],a=Cr.asn1.x509.OID.oid2name(o.oid);""===a&&(a=o.oid);var u="";if(o.critical===!0&&(u="CRITICAL"),t+="  "+a+" "+u+":\n","basicConstraints"===a){var h=$n.getExtBasicConstraints(this.hex);void 0===h.cA?t+="    {}\n":(t+="    cA=true",void 0!==h.pathLen&&(t+=", pathLen="+h.pathLen),t+="\n")}else if("keyUsage"===a)t+="    "+$n.getExtKeyUsageString(this.hex)+"\n";else if("subjectKeyIdentifier"===a)t+="    "+$n.getExtSubjectKeyIdentifier(this.hex)+"\n";else if("authorityKeyIdentifier"===a){var c=$n.getExtAuthorityKeyIdentifier(this.hex);void 0!==c.kid&&(t+="    kid="+c.kid+"\n")}else if("extKeyUsage"===a){var f=$n.getExtExtKeyUsageName(this.hex);t+="    "+f.join(", ")+"\n"}else if("subjectAltName"===a){var l=$n.getExtSubjectAltName(this.hex);t+="    "+l.join(", ")+"\n"}else if("cRLDistributionPoints"===a){var d=$n.getExtCRLDistributionPointsURI(this.hex);t+="    "+d+"\n"}else if("authorityInfoAccess"===a){var p=$n.getExtAIAInfo(this.hex);void 0!==p.ocsp&&(t+="    ocsp: "+p.ocsp.join(",")+"\n"),void 0!==p.caissuer&&(t+="    caissuer: "+p.caissuer.join(",")+"\n")}}return t+="signature algorithm: "+$n.getSignatureAlgorithmName(this.hex)+"\n",t+="signature: "+$n.getSignatureValueHex(this.hex).substr(0,16)+"...\n"}}/*! nodeutil-1.0.0 (c) 2015 Kenji Urushima | kjur.github.com/jsrsasign/license
		 */
	function Zn(t){return n(17).readFileSync(t,"utf8")}function Qn(t){var e=n(12),r=n(17);return e.rstrtohex(r.readFileSync(t,"binary"))}function tr(t){var e=n(17);return e.readFileSync(t,"binary")}function er(t,e){var r=n(17);r.writeFileSync(t,e,"binary")}function nr(t,e){var r=n(17),i=n(12),s=i.hextorstr(e);r.writeFileSync(t,s,"binary")}var rr={};rr.userAgent=!1;var ir={};if("undefined"==typeof sr||!sr)var sr={};sr.namespace=function(){var t,e,n,r=arguments,i=null;for(t=0;t<r.length;t+=1)for(n=(""+r[t]).split("."),i=sr,e="YAHOO"==n[0]?1:0;e<n.length;e+=1)i[n[e]]=i[n[e]]||{},i=i[n[e]];return i},sr.log=function(t,e,n){var r=sr.widget.Logger;return!(!r||!r.log)&&r.log(t,e,n)},sr.register=function(t,e,n){var r,i,s,o,a,u=sr.env.modules;for(u[t]||(u[t]={versions:[],builds:[]}),r=u[t],i=n.version,s=n.build,o=sr.env.listeners,r.name=t,r.version=i,r.build=s,r.versions.push(i),r.builds.push(s),r.mainClass=e,a=0;a<o.length;a+=1)o[a](r);e?(e.VERSION=i,e.BUILD=s):sr.log("mainClass is undefined for module "+t,"warn")},sr.env=sr.env||{modules:[],listeners:[]},sr.env.getVersion=function(t){return sr.env.modules[t]||null},sr.env.parseUA=function(t){var e,n=function(t){var e=0;return parseFloat(t.replace(/\./g,function(){return 1==e++?"":"."}))},r=rr,i={ie:0,opera:0,gecko:0,webkit:0,chrome:0,mobile:null,air:0,ipad:0,iphone:0,ipod:0,ios:null,android:0,webos:0,caja:r&&r.cajaVersion,secure:!1,os:null},s=t||rr&&rr.userAgent,o=ir&&ir.location,a=o&&o.href;return i.secure=a&&0===a.toLowerCase().indexOf("https"),s&&(/windows|win32/i.test(s)?i.os="windows":/macintosh/i.test(s)?i.os="macintosh":/rhino/i.test(s)&&(i.os="rhino"),/KHTML/.test(s)&&(i.webkit=1),e=s.match(/AppleWebKit\/([^\s]*)/),e&&e[1]&&(i.webkit=n(e[1]),/ Mobile\//.test(s)?(i.mobile="Apple",e=s.match(/OS ([^\s]*)/),e&&e[1]&&(e=n(e[1].replace("_","."))),i.ios=e,i.ipad=i.ipod=i.iphone=0,e=s.match(/iPad|iPod|iPhone/),e&&e[0]&&(i[e[0].toLowerCase()]=i.ios)):(e=s.match(/NokiaN[^\/]*|Android \d\.\d|webOS\/\d\.\d/),e&&(i.mobile=e[0]),/webOS/.test(s)&&(i.mobile="WebOS",e=s.match(/webOS\/([^\s]*);/),e&&e[1]&&(i.webos=n(e[1]))),/ Android/.test(s)&&(i.mobile="Android",e=s.match(/Android ([^\s]*);/),e&&e[1]&&(i.android=n(e[1])))),e=s.match(/Chrome\/([^\s]*)/),e&&e[1]?i.chrome=n(e[1]):(e=s.match(/AdobeAIR\/([^\s]*)/),e&&(i.air=e[0]))),i.webkit||(e=s.match(/Opera[\s\/]([^\s]*)/),e&&e[1]?(i.opera=n(e[1]),e=s.match(/Version\/([^\s]*)/),e&&e[1]&&(i.opera=n(e[1])),e=s.match(/Opera Mini[^;]*/),e&&(i.mobile=e[0])):(e=s.match(/MSIE\s([^;]*)/),e&&e[1]?i.ie=n(e[1]):(e=s.match(/Gecko\/([^\s]*)/),e&&(i.gecko=1,e=s.match(/rv:([^\s\)]*)/),e&&e[1]&&(i.gecko=n(e[1]))))))),i},sr.env.ua=sr.env.parseUA(),function(){if(sr.namespace("util","widget","example"),"undefined"!=typeof YAHOO_config){var t,e=YAHOO_config.listener,n=sr.env.listeners,r=!0;if(e){for(t=0;t<n.length;t++)if(n[t]==e){r=!1;break}r&&n.push(e)}}}(),sr.lang=sr.lang||{},function(){var t=sr.lang,e=Object.prototype,n="[object Array]",r="[object Function]",i="[object Object]",s=[],o={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","/":"&#x2F;","`":"&#x60;"},a=["toString","valueOf"],u={isArray:function(t){return e.toString.apply(t)===n},isBoolean:function(t){return"boolean"==typeof t},isFunction:function(t){return"function"==typeof t||e.toString.apply(t)===r},isNull:function(t){return null===t},isNumber:function(t){return"number"==typeof t&&isFinite(t)},isObject:function(e){return e&&("object"==typeof e||t.isFunction(e))||!1},isString:function(t){return"string"==typeof t},isUndefined:function(t){return"undefined"==typeof t},_IEEnumFix:sr.env.ua.ie?function(n,r){var i,s,o;for(i=0;i<a.length;i+=1)s=a[i],o=r[s],t.isFunction(o)&&o!=e[s]&&(n[s]=o)}:function(){},escapeHTML:function(t){return t.replace(/[&<>"'\/`]/g,function(t){return o[t]})},extend:function(n,r,i){if(!r||!n)throw new Error("extend failed, please check that all dependencies are included.");var s,o=function(){};if(o.prototype=r.prototype,n.prototype=new o,n.prototype.constructor=n,n.superclass=r.prototype,r.prototype.constructor==e.constructor&&(r.prototype.constructor=r),i){for(s in i)t.hasOwnProperty(i,s)&&(n.prototype[s]=i[s]);t._IEEnumFix(n.prototype,i)}},augmentObject:function(e,n){if(!n||!e)throw new Error("Absorb failed, verify dependencies.");var r,i,s=arguments,o=s[2];if(o&&o!==!0)for(r=2;r<s.length;r+=1)e[s[r]]=n[s[r]];else{for(i in n)!o&&i in e||(e[i]=n[i]);t._IEEnumFix(e,n)}return e},augmentProto:function(e,n){if(!n||!e)throw new Error("Augment failed, verify dependencies.");var r,i=[e.prototype,n.prototype];for(r=2;r<arguments.length;r+=1)i.push(arguments[r]);return t.augmentObject.apply(this,i),e},dump:function(e,n){var r,i,s=[],o="{...}",a="f(){...}",u=", ",h=" => ";if(!t.isObject(e))return e+"";if(e instanceof Date||"nodeType"in e&&"tagName"in e)return e;if(t.isFunction(e))return a;if(n=t.isNumber(n)?n:3,t.isArray(e)){for(s.push("["),r=0,i=e.length;r<i;r+=1)t.isObject(e[r])?s.push(n>0?t.dump(e[r],n-1):o):s.push(e[r]),s.push(u);s.length>1&&s.pop(),s.push("]")}else{s.push("{");for(r in e)t.hasOwnProperty(e,r)&&(s.push(r+h),t.isObject(e[r])?s.push(n>0?t.dump(e[r],n-1):o):s.push(e[r]),s.push(u));s.length>1&&s.pop(),s.push("}")}return s.join("")},substitute:function(e,n,r,s){for(var o,a,u,h,c,f,l,d,p,g=[],y=e.length,v="dump",m=" ",S="{",b="}";(o=e.lastIndexOf(S,y),!(o<0))&&(a=e.indexOf(b,o),!(o+1>a));)l=e.substring(o+1,a),h=l,f=null,u=h.indexOf(m),u>-1&&(f=h.substring(u+1),h=h.substring(0,u)),c=n[h],r&&(c=r(h,c,f)),t.isObject(c)?t.isArray(c)?c=t.dump(c,parseInt(f,10)):(f=f||"",d=f.indexOf(v),d>-1&&(f=f.substring(4)),p=c.toString(),c=p===i||d>-1?t.dump(c,parseInt(f,10)):p):t.isString(c)||t.isNumber(c)||(c="~-"+g.length+"-~",g[g.length]=l),e=e.substring(0,o)+c+e.substring(a+1),s===!1&&(y=o-1);for(o=g.length-1;o>=0;o-=1)e=e.replace(new RegExp("~-"+o+"-~"),"{"+g[o]+"}","g");return e},trim:function(t){try{return t.replace(/^\s+|\s+$/g,"")}catch(e){return t}},merge:function(){var e,n={},r=arguments,i=r.length;for(e=0;e<i;e+=1)t.augmentObject(n,r[e],!0);return n},later:function(e,n,r,i,o){e=e||0,n=n||{};var a,u,h=r,c=i;if(t.isString(r)&&(h=n[r]),!h)throw new TypeError("method undefined");return t.isUndefined(i)||t.isArray(c)||(c=[i]),a=function(){h.apply(n,c||s)},u=o?setInterval(a,e):setTimeout(a,e),{interval:o,cancel:function(){this.interval?clearInterval(u):clearTimeout(u)}}},isValue:function(e){return t.isObject(e)||t.isString(e)||t.isNumber(e)||t.isBoolean(e)}};t.hasOwnProperty=e.hasOwnProperty?function(t,e){return t&&t.hasOwnProperty&&t.hasOwnProperty(e)}:function(e,n){return!t.isUndefined(e[n])&&e.constructor.prototype[n]!==e[n]},u.augmentObject(t,u,!0),sr.util.Lang=t,t.augment=t.augmentProto,sr.augment=t.augmentProto,sr.extend=t.extend}(),sr.register("yahoo",sr,{version:"2.9.0",build:"2800"});/*! CryptoJS v3.1.2 core-fix.js
		 * code.google.com/p/crypto-js
		 * (c) 2009-2013 by Jeff Mott. All rights reserved.
		 * code.google.com/p/crypto-js/wiki/License
		 * THIS IS FIX of 'core.js' to fix Hmac issue.
		 * https://code.google.com/p/crypto-js/issues/detail?id=84
		 * https://crypto-js.googlecode.com/svn-history/r667/branches/3.x/src/core.js
		 */
	var or=or||function(t,e){var n={},r=n.lib={},i=r.Base=function(){function t(){}return{extend:function(e){t.prototype=this;var n=new t;return e&&n.mixIn(e),n.hasOwnProperty("init")||(n.init=function(){n.$super.init.apply(this,arguments)}),n.init.prototype=n,n.$super=this,n},create:function(){var t=this.extend();return t.init.apply(t,arguments),t},init:function(){},mixIn:function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e]);t.hasOwnProperty("toString")&&(this.toString=t.toString)},clone:function(){return this.init.prototype.extend(this)}}}(),s=r.WordArray=i.extend({init:function(t,n){t=this.words=t||[],n!=e?this.sigBytes=n:this.sigBytes=4*t.length},toString:function(t){return(t||a).stringify(this)},concat:function(t){var e=this.words,n=t.words,r=this.sigBytes,i=t.sigBytes;if(this.clamp(),r%4)for(var s=0;s<i;s++){var o=n[s>>>2]>>>24-s%4*8&255;e[r+s>>>2]|=o<<24-(r+s)%4*8}else for(var s=0;s<i;s+=4)e[r+s>>>2]=n[s>>>2];return this.sigBytes+=i,this},clamp:function(){var e=this.words,n=this.sigBytes;e[n>>>2]&=4294967295<<32-n%4*8,e.length=t.ceil(n/4)},clone:function(){var t=i.clone.call(this);return t.words=this.words.slice(0),t},random:function(e){for(var n=[],r=0;r<e;r+=4)n.push(4294967296*t.random()|0);return new s.init(n,e)}}),o=n.enc={},a=o.Hex={stringify:function(t){for(var e=t.words,n=t.sigBytes,r=[],i=0;i<n;i++){var s=e[i>>>2]>>>24-i%4*8&255;r.push((s>>>4).toString(16)),r.push((15&s).toString(16))}return r.join("")},parse:function(t){for(var e=t.length,n=[],r=0;r<e;r+=2)n[r>>>3]|=parseInt(t.substr(r,2),16)<<24-r%8*4;return new s.init(n,e/2)}},u=o.Latin1={stringify:function(t){for(var e=t.words,n=t.sigBytes,r=[],i=0;i<n;i++){var s=e[i>>>2]>>>24-i%4*8&255;r.push(String.fromCharCode(s))}return r.join("")},parse:function(t){for(var e=t.length,n=[],r=0;r<e;r++)n[r>>>2]|=(255&t.charCodeAt(r))<<24-r%4*8;return new s.init(n,e)}},h=o.Utf8={stringify:function(t){try{return decodeURIComponent(escape(u.stringify(t)))}catch(t){throw new Error("Malformed UTF-8 data")}},parse:function(t){return u.parse(unescape(encodeURIComponent(t)))}},c=r.BufferedBlockAlgorithm=i.extend({reset:function(){this._data=new s.init,this._nDataBytes=0},_append:function(t){"string"==typeof t&&(t=h.parse(t)),this._data.concat(t),this._nDataBytes+=t.sigBytes},_process:function(e){var n=this._data,r=n.words,i=n.sigBytes,o=this.blockSize,a=4*o,u=i/a;u=e?t.ceil(u):t.max((0|u)-this._minBufferSize,0);var h=u*o,c=t.min(4*h,i);if(h){for(var f=0;f<h;f+=o)this._doProcessBlock(r,f);var l=r.splice(0,h);n.sigBytes-=c}return new s.init(l,c)},clone:function(){var t=i.clone.call(this);return t._data=this._data.clone(),t},_minBufferSize:0}),f=(r.Hasher=c.extend({cfg:i.extend(),init:function(t){this.cfg=this.cfg.extend(t),this.reset()},reset:function(){c.reset.call(this),this._doReset()},update:function(t){return this._append(t),this._process(),this},finalize:function(t){t&&this._append(t);var e=this._doFinalize();return e},blockSize:16,_createHelper:function(t){return function(e,n){return new t.init(n).finalize(e)}},_createHmacHelper:function(t){return function(e,n){return new f.HMAC.init(t,n).finalize(e)}}}),n.algo={});return n}(Math);!function(t){var e=or,n=e.lib,r=n.Base,i=n.WordArray,e=e.x64={};e.Word=r.extend({init:function(t,e){this.high=t,this.low=e}}),e.WordArray=r.extend({init:function(e,n){e=this.words=e||[],this.sigBytes=n!=t?n:8*e.length},toX32:function(){for(var t=this.words,e=t.length,n=[],r=0;r<e;r++){var s=t[r];n.push(s.high),n.push(s.low)}return i.create(n,this.sigBytes)},clone:function(){for(var t=r.clone.call(this),e=t.words=this.words.slice(0),n=e.length,i=0;i<n;i++)e[i]=e[i].clone();return t}})}(),or.lib.Cipher||function(t){var e=or,n=e.lib,r=n.Base,i=n.WordArray,s=n.BufferedBlockAlgorithm,o=e.enc.Base64,a=e.algo.EvpKDF,u=n.Cipher=s.extend({cfg:r.extend(),createEncryptor:function(t,e){return this.create(this._ENC_XFORM_MODE,t,e)},createDecryptor:function(t,e){return this.create(this._DEC_XFORM_MODE,t,e)},init:function(t,e,n){this.cfg=this.cfg.extend(n),this._xformMode=t,this._key=e,this.reset()},reset:function(){s.reset.call(this),this._doReset()},process:function(t){return this._append(t),this._process()},finalize:function(t){return t&&this._append(t),this._doFinalize()},keySize:4,ivSize:4,_ENC_XFORM_MODE:1,_DEC_XFORM_MODE:2,_createHelper:function(t){return{encrypt:function(e,n,r){return("string"==typeof n?p:d).encrypt(t,e,n,r)},decrypt:function(e,n,r){return("string"==typeof n?p:d).decrypt(t,e,n,r)}}}});n.StreamCipher=u.extend({_doFinalize:function(){return this._process(!0)},blockSize:1});var h=e.mode={},c=function(e,n,r){var i=this._iv;i?this._iv=t:i=this._prevBlock;for(var s=0;s<r;s++)e[n+s]^=i[s]},f=(n.BlockCipherMode=r.extend({createEncryptor:function(t,e){return this.Encryptor.create(t,e)},createDecryptor:function(t,e){return this.Decryptor.create(t,e)},init:function(t,e){this._cipher=t,this._iv=e}})).extend();f.Encryptor=f.extend({processBlock:function(t,e){var n=this._cipher,r=n.blockSize;c.call(this,t,e,r),n.encryptBlock(t,e),this._prevBlock=t.slice(e,e+r)}}),f.Decryptor=f.extend({processBlock:function(t,e){var n=this._cipher,r=n.blockSize,i=t.slice(e,e+r);n.decryptBlock(t,e),c.call(this,t,e,r),this._prevBlock=i}}),h=h.CBC=f,f=(e.pad={}).Pkcs7={pad:function(t,e){for(var n=4*e,n=n-t.sigBytes%n,r=n<<24|n<<16|n<<8|n,s=[],o=0;o<n;o+=4)s.push(r);n=i.create(s,n),t.concat(n)},unpad:function(t){t.sigBytes-=255&t.words[t.sigBytes-1>>>2]}},n.BlockCipher=u.extend({cfg:u.cfg.extend({mode:h,padding:f}),reset:function(){u.reset.call(this);var t=this.cfg,e=t.iv,t=t.mode;if(this._xformMode==this._ENC_XFORM_MODE)var n=t.createEncryptor;else n=t.createDecryptor,this._minBufferSize=1;this._mode=n.call(t,this,e&&e.words)},_doProcessBlock:function(t,e){this._mode.processBlock(t,e)},_doFinalize:function(){var t=this.cfg.padding;if(this._xformMode==this._ENC_XFORM_MODE){t.pad(this._data,this.blockSize);var e=this._process(!0)}else e=this._process(!0),t.unpad(e);return e},blockSize:4});var l=n.CipherParams=r.extend({init:function(t){this.mixIn(t)},toString:function(t){return(t||this.formatter).stringify(this)}}),h=(e.format={}).OpenSSL={stringify:function(t){var e=t.ciphertext;return t=t.salt,(t?i.create([1398893684,1701076831]).concat(t).concat(e):e).toString(o)},parse:function(t){t=o.parse(t);var e=t.words;if(1398893684==e[0]&&1701076831==e[1]){var n=i.create(e.slice(2,4));e.splice(0,4),t.sigBytes-=16}return l.create({ciphertext:t,salt:n})}},d=n.SerializableCipher=r.extend({cfg:r.extend({format:h}),encrypt:function(t,e,n,r){r=this.cfg.extend(r);var i=t.createEncryptor(n,r);return e=i.finalize(e),i=i.cfg,l.create({ciphertext:e,key:n,iv:i.iv,algorithm:t,mode:i.mode,padding:i.padding,blockSize:t.blockSize,formatter:r.format})},decrypt:function(t,e,n,r){return r=this.cfg.extend(r),e=this._parse(e,r.format),t.createDecryptor(n,r).finalize(e.ciphertext)},_parse:function(t,e){return"string"==typeof t?e.parse(t,this):t}}),e=(e.kdf={}).OpenSSL={execute:function(t,e,n,r){return r||(r=i.random(8)),t=a.create({keySize:e+n}).compute(t,r),n=i.create(t.words.slice(e),4*n),t.sigBytes=4*e,l.create({key:t,iv:n,salt:r})}},p=n.PasswordBasedCipher=d.extend({cfg:d.cfg.extend({kdf:e}),encrypt:function(t,e,n,r){return r=this.cfg.extend(r),n=r.kdf.execute(n,t.keySize,t.ivSize),r.iv=n.iv,t=d.encrypt.call(this,t,e,n.key,r),t.mixIn(n),t},decrypt:function(t,e,n,r){return r=this.cfg.extend(r),e=this._parse(e,r.format),n=r.kdf.execute(n,t.keySize,t.ivSize,e.salt),r.iv=n.iv,d.decrypt.call(this,t,e,n.key,r)}})}(),function(){for(var t=or,e=t.lib.BlockCipher,n=t.algo,r=[],i=[],s=[],o=[],a=[],u=[],h=[],c=[],f=[],l=[],d=[],p=0;256>p;p++)d[p]=128>p?p<<1:p<<1^283;for(var g=0,y=0,p=0;256>p;p++){var v=y^y<<1^y<<2^y<<3^y<<4,v=v>>>8^255&v^99;r[g]=v,i[v]=g;var m=d[g],S=d[m],b=d[S],w=257*d[v]^16843008*v;s[g]=w<<24|w>>>8,o[g]=w<<16|w>>>16,a[g]=w<<8|w>>>24,u[g]=w,w=16843009*b^65537*S^257*m^16843008*g,h[v]=w<<24|w>>>8,c[v]=w<<16|w>>>16,f[v]=w<<8|w>>>24,l[v]=w,g?(g=m^d[d[d[b^m]]],y^=d[d[y]]):g=y=1}var E=[0,1,2,4,8,16,32,64,128,27,54],n=n.AES=e.extend({_doReset:function(){for(var t=this._key,e=t.words,n=t.sigBytes/4,t=4*((this._nRounds=n+6)+1),i=this._keySchedule=[],s=0;s<t;s++)if(s<n)i[s]=e[s];else{var o=i[s-1];s%n?6<n&&4==s%n&&(o=r[o>>>24]<<24|r[o>>>16&255]<<16|r[o>>>8&255]<<8|r[255&o]):(o=o<<8|o>>>24,o=r[o>>>24]<<24|r[o>>>16&255]<<16|r[o>>>8&255]<<8|r[255&o],o^=E[s/n|0]<<24),i[s]=i[s-n]^o}for(e=this._invKeySchedule=[],n=0;n<t;n++)s=t-n,o=n%4?i[s]:i[s-4],e[n]=4>n||4>=s?o:h[r[o>>>24]]^c[r[o>>>16&255]]^f[r[o>>>8&255]]^l[r[255&o]]},encryptBlock:function(t,e){this._doCryptBlock(t,e,this._keySchedule,s,o,a,u,r)},decryptBlock:function(t,e){var n=t[e+1];t[e+1]=t[e+3],t[e+3]=n,this._doCryptBlock(t,e,this._invKeySchedule,h,c,f,l,i),n=t[e+1],t[e+1]=t[e+3],t[e+3]=n},_doCryptBlock:function(t,e,n,r,i,s,o,a){for(var u=this._nRounds,h=t[e]^n[0],c=t[e+1]^n[1],f=t[e+2]^n[2],l=t[e+3]^n[3],d=4,p=1;p<u;p++)var g=r[h>>>24]^i[c>>>16&255]^s[f>>>8&255]^o[255&l]^n[d++],y=r[c>>>24]^i[f>>>16&255]^s[l>>>8&255]^o[255&h]^n[d++],v=r[f>>>24]^i[l>>>16&255]^s[h>>>8&255]^o[255&c]^n[d++],l=r[l>>>24]^i[h>>>16&255]^s[c>>>8&255]^o[255&f]^n[d++],h=g,c=y,f=v;g=(a[h>>>24]<<24|a[c>>>16&255]<<16|a[f>>>8&255]<<8|a[255&l])^n[d++],y=(a[c>>>24]<<24|a[f>>>16&255]<<16|a[l>>>8&255]<<8|a[255&h])^n[d++],v=(a[f>>>24]<<24|a[l>>>16&255]<<16|a[h>>>8&255]<<8|a[255&c])^n[d++],l=(a[l>>>24]<<24|a[h>>>16&255]<<16|a[c>>>8&255]<<8|a[255&f])^n[d++],t[e]=g,t[e+1]=y,t[e+2]=v,t[e+3]=l},keySize:8});t.AES=e._createHelper(n)}(),function(){function t(t,e){var n=(this._lBlock>>>t^this._rBlock)&e;this._rBlock^=n,this._lBlock^=n<<t}function e(t,e){var n=(this._rBlock>>>t^this._lBlock)&e;this._lBlock^=n,this._rBlock^=n<<t}var n=or,r=n.lib,i=r.WordArray,r=r.BlockCipher,s=n.algo,o=[57,49,41,33,25,17,9,1,58,50,42,34,26,18,10,2,59,51,43,35,27,19,11,3,60,52,44,36,63,55,47,39,31,23,15,7,62,54,46,38,30,22,14,6,61,53,45,37,29,21,13,5,28,20,12,4],a=[14,17,11,24,1,5,3,28,15,6,21,10,23,19,12,4,26,8,16,7,27,20,13,2,41,52,31,37,47,55,30,40,51,45,33,48,44,49,39,56,34,53,46,42,50,36,29,32],u=[1,2,4,6,8,10,12,14,15,17,19,21,23,25,27,28],h=[{0:8421888,268435456:32768,536870912:8421378,805306368:2,1073741824:512,1342177280:8421890,1610612736:8389122,1879048192:8388608,2147483648:514,2415919104:8389120,2684354560:33280,2952790016:8421376,3221225472:32770,3489660928:8388610,3758096384:0,4026531840:33282,134217728:0,402653184:8421890,671088640:33282,939524096:32768,1207959552:8421888,1476395008:512,1744830464:8421378,2013265920:2,2281701376:8389120,2550136832:33280,2818572288:8421376,3087007744:8389122,3355443200:8388610,3623878656:32770,3892314112:514,4160749568:8388608,1:32768,268435457:2,536870913:8421888,805306369:8388608,1073741825:8421378,1342177281:33280,1610612737:512,1879048193:8389122,2147483649:8421890,2415919105:8421376,2684354561:8388610,2952790017:33282,3221225473:514,3489660929:8389120,3758096385:32770,4026531841:0,134217729:8421890,402653185:8421376,671088641:8388608,939524097:512,1207959553:32768,1476395009:8388610,1744830465:2,2013265921:33282,2281701377:32770,2550136833:8389122,2818572289:514,3087007745:8421888,3355443201:8389120,3623878657:0,3892314113:33280,4160749569:8421378},{0:1074282512,16777216:16384,33554432:524288,50331648:1074266128,67108864:1073741840,83886080:1074282496,100663296:1073758208,117440512:16,134217728:540672,150994944:1073758224,167772160:1073741824,184549376:540688,201326592:524304,218103808:0,234881024:16400,251658240:1074266112,8388608:1073758208,25165824:540688,41943040:16,58720256:1073758224,75497472:1074282512,92274688:1073741824,109051904:524288,125829120:1074266128,142606336:524304,159383552:0,176160768:16384,192937984:1074266112,209715200:1073741840,226492416:540672,243269632:1074282496,260046848:16400,268435456:0,285212672:1074266128,301989888:1073758224,318767104:1074282496,335544320:1074266112,352321536:16,369098752:540688,385875968:16384,402653184:16400,419430400:524288,436207616:524304,452984832:1073741840,469762048:540672,486539264:1073758208,503316480:1073741824,520093696:1074282512,276824064:540688,293601280:524288,310378496:1074266112,327155712:16384,343932928:1073758208,360710144:1074282512,377487360:16,394264576:1073741824,411041792:1074282496,427819008:1073741840,444596224:1073758224,461373440:524304,478150656:0,494927872:16400,511705088:1074266128,528482304:540672},{0:260,1048576:0,2097152:67109120,3145728:65796,4194304:65540,5242880:67108868,6291456:67174660,7340032:67174400,8388608:67108864,9437184:67174656,10485760:65792,11534336:67174404,12582912:67109124,13631488:65536,14680064:4,15728640:256,524288:67174656,1572864:67174404,2621440:0,3670016:67109120,4718592:67108868,5767168:65536,6815744:65540,7864320:260,8912896:4,9961472:256,11010048:67174400,12058624:65796,13107200:65792,14155776:67109124,15204352:67174660,16252928:67108864,16777216:67174656,17825792:65540,18874368:65536,19922944:67109120,20971520:256,22020096:67174660,23068672:67108868,24117248:0,25165824:67109124,26214400:67108864,27262976:4,28311552:65792,29360128:67174400,30408704:260,31457280:65796,32505856:67174404,17301504:67108864,18350080:260,19398656:67174656,20447232:0,21495808:65540,22544384:67109120,23592960:256,24641536:67174404,25690112:65536,26738688:67174660,27787264:65796,28835840:67108868,29884416:67109124,30932992:67174400,31981568:4,33030144:65792},{0:2151682048,65536:2147487808,131072:4198464,196608:2151677952,262144:0,327680:4198400,393216:2147483712,458752:4194368,524288:2147483648,589824:4194304,655360:64,720896:2147487744,786432:2151678016,851968:4160,917504:4096,983040:2151682112,32768:2147487808,98304:64,163840:2151678016,229376:2147487744,294912:4198400,360448:2151682112,425984:0,491520:2151677952,557056:4096,622592:2151682048,688128:4194304,753664:4160,819200:2147483648,884736:4194368,950272:4198464,1015808:2147483712,1048576:4194368,1114112:4198400,1179648:2147483712,1245184:0,1310720:4160,1376256:2151678016,1441792:2151682048,1507328:2147487808,1572864:2151682112,1638400:2147483648,1703936:2151677952,1769472:4198464,1835008:2147487744,1900544:4194304,1966080:64,2031616:4096,1081344:2151677952,1146880:2151682112,1212416:0,1277952:4198400,1343488:4194368,1409024:2147483648,1474560:2147487808,1540096:64,1605632:2147483712,1671168:4096,1736704:2147487744,1802240:2151678016,1867776:4160,1933312:2151682048,1998848:4194304,2064384:4198464},{0:128,4096:17039360,8192:262144,12288:536870912,16384:537133184,20480:16777344,24576:553648256,28672:262272,32768:16777216,36864:537133056,40960:536871040,45056:553910400,49152:553910272,53248:0,57344:17039488,61440:553648128,2048:17039488,6144:553648256,10240:128,14336:17039360,18432:262144,22528:537133184,26624:553910272,30720:536870912,34816:537133056,38912:0,43008:553910400,47104:16777344,51200:536871040,55296:553648128,59392:16777216,63488:262272,65536:262144,69632:128,73728:536870912,77824:553648256,81920:16777344,86016:553910272,90112:537133184,94208:16777216,98304:553910400,102400:553648128,106496:17039360,110592:537133056,114688:262272,118784:536871040,122880:0,126976:17039488,67584:553648256,71680:16777216,75776:17039360,79872:537133184,83968:536870912,88064:17039488,92160:128,96256:553910272,100352:262272,104448:553910400,108544:0,112640:553648128,116736:16777344,120832:262144,124928:537133056,129024:536871040},{0:268435464,256:8192,512:270532608,768:270540808,1024:268443648,1280:2097152,1536:2097160,1792:268435456,2048:0,2304:268443656,2560:2105344,2816:8,3072:270532616,3328:2105352,3584:8200,3840:270540800,128:270532608,384:270540808,640:8,896:2097152,1152:2105352,1408:268435464,1664:268443648,1920:8200,2176:2097160,2432:8192,2688:268443656,2944:270532616,3200:0,3456:270540800,3712:2105344,3968:268435456,4096:268443648,4352:270532616,4608:270540808,4864:8200,5120:2097152,5376:268435456,5632:268435464,5888:2105344,6144:2105352,6400:0,6656:8,6912:270532608,7168:8192,7424:268443656,7680:270540800,7936:2097160,4224:8,4480:2105344,4736:2097152,4992:268435464,5248:268443648,5504:8200,5760:270540808,6016:270532608,6272:270540800,6528:270532616,6784:8192,7040:2105352,7296:2097160,7552:0,7808:268435456,8064:268443656},{0:1048576,16:33555457,32:1024,48:1049601,64:34604033,80:0,96:1,112:34603009,128:33555456,144:1048577,160:33554433,176:34604032,192:34603008,208:1025,224:1049600,240:33554432,8:34603009,24:0,40:33555457,56:34604032,72:1048576,88:33554433,104:33554432,120:1025,136:1049601,152:33555456,168:34603008,184:1048577,200:1024,216:34604033,232:1,248:1049600,256:33554432,272:1048576,288:33555457,304:34603009,320:1048577,336:33555456,352:34604032,368:1049601,384:1025,400:34604033,416:1049600,432:1,448:0,464:34603008,480:33554433,496:1024,264:1049600,280:33555457,296:34603009,312:1,328:33554432,344:1048576,360:1025,376:34604032,392:33554433,408:34603008,424:0,440:34604033,456:1049601,472:1024,488:33555456,504:1048577},{0:134219808,1:131072,2:134217728,3:32,4:131104,5:134350880,6:134350848,7:2048,8:134348800,9:134219776,10:133120,11:134348832,12:2080,13:0,14:134217760,15:133152,2147483648:2048,2147483649:134350880,2147483650:134219808,2147483651:134217728,2147483652:134348800,2147483653:133120,2147483654:133152,2147483655:32,2147483656:134217760,2147483657:2080,2147483658:131104,2147483659:134350848,2147483660:0,2147483661:134348832,2147483662:134219776,2147483663:131072,16:133152,17:134350848,18:32,19:2048,20:134219776,21:134217760,22:134348832,23:131072,24:0,25:131104,26:134348800,27:134219808,28:134350880,29:133120,30:2080,31:134217728,2147483664:131072,2147483665:2048,2147483666:134348832,2147483667:133152,2147483668:32,2147483669:134348800,2147483670:134217728,2147483671:134219808,2147483672:134350880,2147483673:134217760,2147483674:134219776,2147483675:0,2147483676:133120,2147483677:2080,2147483678:131104,2147483679:134350848}],c=[4160749569,528482304,33030144,2064384,129024,8064,504,2147483679],f=s.DES=r.extend({_doReset:function(){for(var t=this._key.words,e=[],n=0;56>n;n++){var r=o[n]-1;e[n]=t[r>>>5]>>>31-r%32&1}for(t=this._subKeys=[],r=0;16>r;r++){for(var i=t[r]=[],s=u[r],n=0;24>n;n++)i[n/6|0]|=e[(a[n]-1+s)%28]<<31-n%6,i[4+(n/6|0)]|=e[28+(a[n+24]-1+s)%28]<<31-n%6;for(i[0]=i[0]<<1|i[0]>>>31,n=1;7>n;n++)i[n]>>>=4*(n-1)+3;i[7]=i[7]<<5|i[7]>>>27}for(e=this._invSubKeys=[],n=0;16>n;n++)e[n]=t[15-n]},encryptBlock:function(t,e){this._doCryptBlock(t,e,this._subKeys)},decryptBlock:function(t,e){this._doCryptBlock(t,e,this._invSubKeys)},_doCryptBlock:function(n,r,i){this._lBlock=n[r],this._rBlock=n[r+1],t.call(this,4,252645135),t.call(this,16,65535),e.call(this,2,858993459),e.call(this,8,16711935),t.call(this,1,1431655765);for(var s=0;16>s;s++){for(var o=i[s],a=this._lBlock,u=this._rBlock,f=0,l=0;8>l;l++)f|=h[l][((u^o[l])&c[l])>>>0];this._lBlock=u,this._rBlock=a^f}i=this._lBlock,this._lBlock=this._rBlock,this._rBlock=i,t.call(this,1,1431655765),e.call(this,8,16711935),e.call(this,2,858993459),t.call(this,16,65535),t.call(this,4,252645135),n[r]=this._lBlock,n[r+1]=this._rBlock},keySize:2,ivSize:2,blockSize:2});n.DES=r._createHelper(f),s=s.TripleDES=r.extend({_doReset:function(){var t=this._key.words;this._des1=f.createEncryptor(i.create(t.slice(0,2))),this._des2=f.createEncryptor(i.create(t.slice(2,4))),this._des3=f.createEncryptor(i.create(t.slice(4,6)))},encryptBlock:function(t,e){this._des1.encryptBlock(t,e),this._des2.decryptBlock(t,e),this._des3.encryptBlock(t,e)},decryptBlock:function(t,e){this._des3.decryptBlock(t,e),this._des2.encryptBlock(t,e),this._des1.decryptBlock(t,e)},keySize:6,ivSize:2,blockSize:2}),n.TripleDES=r._createHelper(s)}(),function(){var t=or,e=t.lib.WordArray;t.enc.Base64={stringify:function(t){var e=t.words,n=t.sigBytes,r=this._map;t.clamp(),t=[];for(var i=0;i<n;i+=3)for(var s=(e[i>>>2]>>>24-8*(i%4)&255)<<16|(e[i+1>>>2]>>>24-8*((i+1)%4)&255)<<8|e[i+2>>>2]>>>24-8*((i+2)%4)&255,o=0;4>o&&i+.75*o<n;o++)t.push(r.charAt(s>>>6*(3-o)&63));if(e=r.charAt(64))for(;t.length%4;)t.push(e);return t.join("")},parse:function(t){var n=t.length,r=this._map,i=r.charAt(64);i&&(i=t.indexOf(i),-1!=i&&(n=i));for(var i=[],s=0,o=0;o<n;o++)if(o%4){var a=r.indexOf(t.charAt(o-1))<<2*(o%4),u=r.indexOf(t.charAt(o))>>>6-2*(o%4);i[s>>>2]|=(a|u)<<24-8*(s%4),s++}return e.create(i,s)},_map:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="}}(),function(t){function e(t,e,n,r,i,s,o){return t=t+(e&n|~e&r)+i+o,(t<<s|t>>>32-s)+e}function n(t,e,n,r,i,s,o){return t=t+(e&r|n&~r)+i+o,(t<<s|t>>>32-s)+e}function r(t,e,n,r,i,s,o){return t=t+(e^n^r)+i+o,(t<<s|t>>>32-s)+e}function i(t,e,n,r,i,s,o){return t=t+(n^(e|~r))+i+o,(t<<s|t>>>32-s)+e}for(var s=or,o=s.lib,a=o.WordArray,u=o.Hasher,o=s.algo,h=[],c=0;64>c;c++)h[c]=4294967296*t.abs(t.sin(c+1))|0;o=o.MD5=u.extend({_doReset:function(){this._hash=new a.init([1732584193,4023233417,2562383102,271733878])},_doProcessBlock:function(t,s){for(var o=0;16>o;o++){var a=s+o,u=t[a];t[a]=16711935&(u<<8|u>>>24)|4278255360&(u<<24|u>>>8)}var o=this._hash.words,a=t[s+0],u=t[s+1],c=t[s+2],f=t[s+3],l=t[s+4],d=t[s+5],p=t[s+6],g=t[s+7],y=t[s+8],v=t[s+9],m=t[s+10],S=t[s+11],b=t[s+12],w=t[s+13],E=t[s+14],x=t[s+15],A=o[0],_=o[1],F=o[2],P=o[3],A=e(A,_,F,P,a,7,h[0]),P=e(P,A,_,F,u,12,h[1]),F=e(F,P,A,_,c,17,h[2]),_=e(_,F,P,A,f,22,h[3]),A=e(A,_,F,P,l,7,h[4]),P=e(P,A,_,F,d,12,h[5]),F=e(F,P,A,_,p,17,h[6]),_=e(_,F,P,A,g,22,h[7]),A=e(A,_,F,P,y,7,h[8]),P=e(P,A,_,F,v,12,h[9]),F=e(F,P,A,_,m,17,h[10]),_=e(_,F,P,A,S,22,h[11]),A=e(A,_,F,P,b,7,h[12]),P=e(P,A,_,F,w,12,h[13]),F=e(F,P,A,_,E,17,h[14]),_=e(_,F,P,A,x,22,h[15]),A=n(A,_,F,P,u,5,h[16]),P=n(P,A,_,F,p,9,h[17]),F=n(F,P,A,_,S,14,h[18]),_=n(_,F,P,A,a,20,h[19]),A=n(A,_,F,P,d,5,h[20]),P=n(P,A,_,F,m,9,h[21]),F=n(F,P,A,_,x,14,h[22]),_=n(_,F,P,A,l,20,h[23]),A=n(A,_,F,P,v,5,h[24]),P=n(P,A,_,F,E,9,h[25]),F=n(F,P,A,_,f,14,h[26]),_=n(_,F,P,A,y,20,h[27]),A=n(A,_,F,P,w,5,h[28]),P=n(P,A,_,F,c,9,h[29]),F=n(F,P,A,_,g,14,h[30]),_=n(_,F,P,A,b,20,h[31]),A=r(A,_,F,P,d,4,h[32]),P=r(P,A,_,F,y,11,h[33]),F=r(F,P,A,_,S,16,h[34]),_=r(_,F,P,A,E,23,h[35]),A=r(A,_,F,P,u,4,h[36]),P=r(P,A,_,F,l,11,h[37]),F=r(F,P,A,_,g,16,h[38]),_=r(_,F,P,A,m,23,h[39]),A=r(A,_,F,P,w,4,h[40]),P=r(P,A,_,F,a,11,h[41]),F=r(F,P,A,_,f,16,h[42]),_=r(_,F,P,A,p,23,h[43]),A=r(A,_,F,P,v,4,h[44]),P=r(P,A,_,F,b,11,h[45]),F=r(F,P,A,_,x,16,h[46]),_=r(_,F,P,A,c,23,h[47]),A=i(A,_,F,P,a,6,h[48]),P=i(P,A,_,F,g,10,h[49]),F=i(F,P,A,_,E,15,h[50]),_=i(_,F,P,A,d,21,h[51]),A=i(A,_,F,P,b,6,h[52]),P=i(P,A,_,F,f,10,h[53]),F=i(F,P,A,_,m,15,h[54]),_=i(_,F,P,A,u,21,h[55]),A=i(A,_,F,P,y,6,h[56]),P=i(P,A,_,F,x,10,h[57]),F=i(F,P,A,_,p,15,h[58]),_=i(_,F,P,A,w,21,h[59]),A=i(A,_,F,P,l,6,h[60]),P=i(P,A,_,F,S,10,h[61]),F=i(F,P,A,_,c,15,h[62]),_=i(_,F,P,A,v,21,h[63]);o[0]=o[0]+A|0,o[1]=o[1]+_|0,o[2]=o[2]+F|0,o[3]=o[3]+P|0},_doFinalize:function(){var e=this._data,n=e.words,r=8*this._nDataBytes,i=8*e.sigBytes;n[i>>>5]|=128<<24-i%32;var s=t.floor(r/4294967296);for(n[(i+64>>>9<<4)+15]=16711935&(s<<8|s>>>24)|4278255360&(s<<24|s>>>8),n[(i+64>>>9<<4)+14]=16711935&(r<<8|r>>>24)|4278255360&(r<<24|r>>>8),e.sigBytes=4*(n.length+1),this._process(),e=this._hash,n=e.words,r=0;4>r;r++)i=n[r],n[r]=16711935&(i<<8|i>>>24)|4278255360&(i<<24|i>>>8);return e},clone:function(){var t=u.clone.call(this);return t._hash=this._hash.clone(),t}}),s.MD5=u._createHelper(o),s.HmacMD5=u._createHmacHelper(o)}(Math),function(){var t=or,e=t.lib,n=e.WordArray,r=e.Hasher,i=[],e=t.algo.SHA1=r.extend({_doReset:function(){this._hash=new n.init([1732584193,4023233417,2562383102,271733878,3285377520])},_doProcessBlock:function(t,e){for(var n=this._hash.words,r=n[0],s=n[1],o=n[2],a=n[3],u=n[4],h=0;80>h;h++){if(16>h)i[h]=0|t[e+h];else{var c=i[h-3]^i[h-8]^i[h-14]^i[h-16];i[h]=c<<1|c>>>31}c=(r<<5|r>>>27)+u+i[h],c=20>h?c+((s&o|~s&a)+1518500249):40>h?c+((s^o^a)+1859775393):60>h?c+((s&o|s&a|o&a)-1894007588):c+((s^o^a)-899497514),u=a,a=o,o=s<<30|s>>>2,s=r,r=c}n[0]=n[0]+r|0,n[1]=n[1]+s|0,n[2]=n[2]+o|0,n[3]=n[3]+a|0,n[4]=n[4]+u|0},_doFinalize:function(){var t=this._data,e=t.words,n=8*this._nDataBytes,r=8*t.sigBytes;return e[r>>>5]|=128<<24-r%32,e[(r+64>>>9<<4)+14]=Math.floor(n/4294967296),e[(r+64>>>9<<4)+15]=n,t.sigBytes=4*e.length,this._process(),this._hash},clone:function(){var t=r.clone.call(this);return t._hash=this._hash.clone(),t}});t.SHA1=r._createHelper(e),t.HmacSHA1=r._createHmacHelper(e)}(),function(t){for(var e=or,n=e.lib,r=n.WordArray,i=n.Hasher,n=e.algo,s=[],o=[],a=function(t){return 4294967296*(t-(0|t))|0},u=2,h=0;64>h;){var c;t:{c=u;for(var f=t.sqrt(c),l=2;l<=f;l++)if(!(c%l)){c=!1;break t}c=!0}c&&(8>h&&(s[h]=a(t.pow(u,.5))),o[h]=a(t.pow(u,1/3)),h++),u++}var d=[],n=n.SHA256=i.extend({_doReset:function(){this._hash=new r.init(s.slice(0))},_doProcessBlock:function(t,e){for(var n=this._hash.words,r=n[0],i=n[1],s=n[2],a=n[3],u=n[4],h=n[5],c=n[6],f=n[7],l=0;64>l;l++){if(16>l)d[l]=0|t[e+l];else{var p=d[l-15],g=d[l-2];d[l]=((p<<25|p>>>7)^(p<<14|p>>>18)^p>>>3)+d[l-7]+((g<<15|g>>>17)^(g<<13|g>>>19)^g>>>10)+d[l-16]}p=f+((u<<26|u>>>6)^(u<<21|u>>>11)^(u<<7|u>>>25))+(u&h^~u&c)+o[l]+d[l],g=((r<<30|r>>>2)^(r<<19|r>>>13)^(r<<10|r>>>22))+(r&i^r&s^i&s),f=c,c=h,h=u,u=a+p|0,a=s,s=i,i=r,r=p+g|0}n[0]=n[0]+r|0,n[1]=n[1]+i|0,n[2]=n[2]+s|0,n[3]=n[3]+a|0,n[4]=n[4]+u|0,n[5]=n[5]+h|0,n[6]=n[6]+c|0,n[7]=n[7]+f|0},_doFinalize:function(){var e=this._data,n=e.words,r=8*this._nDataBytes,i=8*e.sigBytes;return n[i>>>5]|=128<<24-i%32,n[(i+64>>>9<<4)+14]=t.floor(r/4294967296),n[(i+64>>>9<<4)+15]=r,e.sigBytes=4*n.length,this._process(),this._hash},clone:function(){var t=i.clone.call(this);return t._hash=this._hash.clone(),t}});e.SHA256=i._createHelper(n),e.HmacSHA256=i._createHmacHelper(n)}(Math),function(){var t=or,e=t.lib.WordArray,n=t.algo,r=n.SHA256,n=n.SHA224=r.extend({_doReset:function(){this._hash=new e.init([3238371032,914150663,812702999,4144912697,4290775857,1750603025,1694076839,3204075428])},_doFinalize:function(){var t=r._doFinalize.call(this);return t.sigBytes-=4,t}});t.SHA224=r._createHelper(n),t.HmacSHA224=r._createHmacHelper(n)}(),function(){function t(){return i.create.apply(i,arguments)}for(var e=or,n=e.lib.Hasher,r=e.x64,i=r.Word,s=r.WordArray,r=e.algo,o=[t(1116352408,3609767458),t(1899447441,602891725),t(3049323471,3964484399),t(3921009573,2173295548),t(961987163,4081628472),t(1508970993,3053834265),t(2453635748,2937671579),t(2870763221,3664609560),t(3624381080,2734883394),t(310598401,1164996542),t(607225278,1323610764),t(1426881987,3590304994),t(1925078388,4068182383),t(2162078206,991336113),t(2614888103,633803317),t(3248222580,3479774868),t(3835390401,2666613458),t(4022224774,944711139),t(264347078,2341262773),t(604807628,2007800933),t(770255983,1495990901),t(1249150122,1856431235),t(1555081692,3175218132),t(1996064986,2198950837),t(2554220882,3999719339),t(2821834349,766784016),t(2952996808,2566594879),t(3210313671,3203337956),t(3336571891,1034457026),t(3584528711,2466948901),t(113926993,3758326383),t(338241895,168717936),t(666307205,1188179964),t(773529912,1546045734),t(1294757372,1522805485),t(1396182291,2643833823),t(1695183700,2343527390),t(1986661051,1014477480),t(2177026350,1206759142),t(2456956037,344077627),t(2730485921,1290863460),t(2820302411,3158454273),t(3259730800,3505952657),t(3345764771,106217008),t(3516065817,3606008344),t(3600352804,1432725776),t(4094571909,1467031594),t(275423344,851169720),t(430227734,3100823752),t(506948616,1363258195),t(659060556,3750685593),t(883997877,3785050280),t(958139571,3318307427),t(1322822218,3812723403),t(1537002063,2003034995),t(1747873779,3602036899),t(1955562222,1575990012),t(2024104815,1125592928),t(2227730452,2716904306),t(2361852424,442776044),t(2428436474,593698344),t(2756734187,3733110249),t(3204031479,2999351573),t(3329325298,3815920427),t(3391569614,3928383900),t(3515267271,566280711),t(3940187606,3454069534),t(4118630271,4000239992),t(116418474,1914138554),t(174292421,2731055270),t(289380356,3203993006),t(460393269,320620315),t(685471733,587496836),t(852142971,1086792851),t(1017036298,365543100),t(1126000580,2618297676),t(1288033470,3409855158),t(1501505948,4234509866),t(1607167915,987167468),t(1816402316,1246189591)],a=[],u=0;80>u;u++)a[u]=t();r=r.SHA512=n.extend({_doReset:function(){this._hash=new s.init([new i.init(1779033703,4089235720),new i.init(3144134277,2227873595),new i.init(1013904242,4271175723),new i.init(2773480762,1595750129),new i.init(1359893119,2917565137),new i.init(2600822924,725511199),new i.init(528734635,4215389547),new i.init(1541459225,327033209)])},_doProcessBlock:function(t,e){for(var n=this._hash.words,r=n[0],i=n[1],s=n[2],u=n[3],h=n[4],c=n[5],f=n[6],n=n[7],l=r.high,d=r.low,p=i.high,g=i.low,y=s.high,v=s.low,m=u.high,S=u.low,b=h.high,w=h.low,E=c.high,x=c.low,A=f.high,_=f.low,F=n.high,P=n.low,O=l,C=d,T=p,D=g,H=y,j=v,R=m,I=S,k=b,B=w,N=E,V=x,M=A,K=_,L=F,U=P,q=0;80>q;q++){var W=a[q];if(16>q)var J=W.high=0|t[e+2*q],z=W.low=0|t[e+2*q+1];else{var J=a[q-15],z=J.high,Y=J.low,J=(z>>>1|Y<<31)^(z>>>8|Y<<24)^z>>>7,Y=(Y>>>1|z<<31)^(Y>>>8|z<<24)^(Y>>>7|z<<25),G=a[q-2],z=G.high,X=G.low,G=(z>>>19|X<<13)^(z<<3|X>>>29)^z>>>6,X=(X>>>19|z<<13)^(X<<3|z>>>29)^(X>>>6|z<<26),z=a[q-7],$=z.high,Z=a[q-16],Q=Z.high,Z=Z.low,z=Y+z.low,J=J+$+(z>>>0<Y>>>0?1:0),z=z+X,J=J+G+(z>>>0<X>>>0?1:0),z=z+Z,J=J+Q+(z>>>0<Z>>>0?1:0);W.high=J,W.low=z}var $=k&N^~k&M,Z=B&V^~B&K,W=O&T^O&H^T&H,tt=C&D^C&j^D&j,Y=(O>>>28|C<<4)^(O<<30|C>>>2)^(O<<25|C>>>7),G=(C>>>28|O<<4)^(C<<30|O>>>2)^(C<<25|O>>>7),X=o[q],et=X.high,nt=X.low,X=U+((B>>>14|k<<18)^(B>>>18|k<<14)^(B<<23|k>>>9)),Q=L+((k>>>14|B<<18)^(k>>>18|B<<14)^(k<<23|B>>>9))+(X>>>0<U>>>0?1:0),X=X+Z,Q=Q+$+(X>>>0<Z>>>0?1:0),X=X+nt,Q=Q+et+(X>>>0<nt>>>0?1:0),X=X+z,Q=Q+J+(X>>>0<z>>>0?1:0),z=G+tt,W=Y+W+(z>>>0<G>>>0?1:0),L=M,U=K,M=N,K=V,N=k,V=B,B=I+X|0,k=R+Q+(B>>>0<I>>>0?1:0)|0,R=H,I=j,H=T,j=D,T=O,D=C,C=X+z|0,O=Q+W+(C>>>0<X>>>0?1:0)|0}d=r.low=d+C,r.high=l+O+(d>>>0<C>>>0?1:0),g=i.low=g+D,i.high=p+T+(g>>>0<D>>>0?1:0),v=s.low=v+j,s.high=y+H+(v>>>0<j>>>0?1:0),S=u.low=S+I,u.high=m+R+(S>>>0<I>>>0?1:0),w=h.low=w+B,h.high=b+k+(w>>>0<B>>>0?1:0),x=c.low=x+V,c.high=E+N+(x>>>0<V>>>0?1:0),_=f.low=_+K,f.high=A+M+(_>>>0<K>>>0?1:0),P=n.low=P+U,n.high=F+L+(P>>>0<U>>>0?1:0)},_doFinalize:function(){var t=this._data,e=t.words,n=8*this._nDataBytes,r=8*t.sigBytes;return e[r>>>5]|=128<<24-r%32,e[(r+128>>>10<<5)+30]=Math.floor(n/4294967296),e[(r+128>>>10<<5)+31]=n,t.sigBytes=4*e.length,this._process(),this._hash.toX32()},clone:function(){var t=n.clone.call(this);return t._hash=this._hash.clone(),t},blockSize:32}),e.SHA512=n._createHelper(r),e.HmacSHA512=n._createHmacHelper(r)}(),function(){var t=or,e=t.x64,n=e.Word,r=e.WordArray,e=t.algo,i=e.SHA512,e=e.SHA384=i.extend({_doReset:function(){this._hash=new r.init([new n.init(3418070365,3238371032),new n.init(1654270250,914150663),new n.init(2438529370,812702999),new n.init(355462360,4144912697),new n.init(1731405415,4290775857),new n.init(2394180231,1750603025),new n.init(3675008525,1694076839),new n.init(1203062813,3204075428)])},_doFinalize:function(){var t=i._doFinalize.call(this);return t.sigBytes-=16,t}});t.SHA384=i._createHelper(e),t.HmacSHA384=i._createHmacHelper(e)}(),function(){var t=or,e=t.lib,n=e.WordArray,r=e.Hasher,e=t.algo,i=n.create([0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,7,4,13,1,10,6,15,3,12,0,9,5,2,14,11,8,3,10,14,4,9,15,8,1,2,7,0,6,13,11,5,12,1,9,11,10,0,8,12,4,13,3,7,15,14,5,6,2,4,0,5,9,7,12,2,10,14,1,3,8,11,6,15,13]),s=n.create([5,14,7,0,9,2,11,4,13,6,15,8,1,10,3,12,6,11,3,7,0,13,5,10,14,15,8,12,4,9,1,2,15,5,1,3,7,14,6,9,11,8,12,2,10,0,4,13,8,6,4,1,3,11,15,0,5,12,2,13,9,7,10,14,12,15,10,4,1,5,8,7,6,2,13,14,0,3,9,11]),o=n.create([11,14,15,12,5,8,7,9,11,13,14,15,6,7,9,8,7,6,8,13,11,9,7,15,7,12,15,9,11,7,13,12,11,13,6,7,14,9,13,15,14,8,13,6,5,12,7,5,11,12,14,15,14,15,9,8,9,14,5,6,8,6,5,12,9,15,5,11,6,8,13,12,5,12,13,14,11,8,5,6]),a=n.create([8,9,9,11,13,15,15,5,7,7,8,11,14,14,12,6,9,13,15,7,12,8,9,11,7,7,12,7,6,15,13,11,9,7,15,11,8,6,6,14,12,13,5,14,13,13,7,5,15,5,8,11,14,14,6,14,6,9,12,9,12,5,15,8,8,5,12,9,12,5,14,6,8,13,6,5,15,13,11,11]),u=n.create([0,1518500249,1859775393,2400959708,2840853838]),h=n.create([1352829926,1548603684,1836072691,2053994217,0]),e=e.RIPEMD160=r.extend({_doReset:function(){this._hash=n.create([1732584193,4023233417,2562383102,271733878,3285377520])},_doProcessBlock:function(t,e){for(var n=0;16>n;n++){var r=e+n,c=t[r];
	t[r]=16711935&(c<<8|c>>>24)|4278255360&(c<<24|c>>>8)}var f,l,d,p,g,y,v,m,S,b,r=this._hash.words,c=u.words,w=h.words,E=i.words,x=s.words,A=o.words,_=a.words;y=f=r[0],v=l=r[1],m=d=r[2],S=p=r[3],b=g=r[4];for(var F,n=0;80>n;n+=1)F=f+t[e+E[n]]|0,F=16>n?F+((l^d^p)+c[0]):32>n?F+((l&d|~l&p)+c[1]):48>n?F+(((l|~d)^p)+c[2]):64>n?F+((l&p|d&~p)+c[3]):F+((l^(d|~p))+c[4]),F|=0,F=F<<A[n]|F>>>32-A[n],F=F+g|0,f=g,g=p,p=d<<10|d>>>22,d=l,l=F,F=y+t[e+x[n]]|0,F=16>n?F+((v^(m|~S))+w[0]):32>n?F+((v&S|m&~S)+w[1]):48>n?F+(((v|~m)^S)+w[2]):64>n?F+((v&m|~v&S)+w[3]):F+((v^m^S)+w[4]),F|=0,F=F<<_[n]|F>>>32-_[n],F=F+b|0,y=b,b=S,S=m<<10|m>>>22,m=v,v=F;F=r[1]+d+S|0,r[1]=r[2]+p+b|0,r[2]=r[3]+g+y|0,r[3]=r[4]+f+v|0,r[4]=r[0]+l+m|0,r[0]=F},_doFinalize:function(){var t=this._data,e=t.words,n=8*this._nDataBytes,r=8*t.sigBytes;for(e[r>>>5]|=128<<24-r%32,e[(r+64>>>9<<4)+14]=16711935&(n<<8|n>>>24)|4278255360&(n<<24|n>>>8),t.sigBytes=4*(e.length+1),this._process(),t=this._hash,e=t.words,n=0;5>n;n++)r=e[n],e[n]=16711935&(r<<8|r>>>24)|4278255360&(r<<24|r>>>8);return t},clone:function(){var t=r.clone.call(this);return t._hash=this._hash.clone(),t}});t.RIPEMD160=r._createHelper(e),t.HmacRIPEMD160=r._createHmacHelper(e)}(Math),function(){var t=or,e=t.enc.Utf8;t.algo.HMAC=t.lib.Base.extend({init:function(t,n){t=this._hasher=new t.init,"string"==typeof n&&(n=e.parse(n));var r=t.blockSize,i=4*r;n.sigBytes>i&&(n=t.finalize(n)),n.clamp();for(var s=this._oKey=n.clone(),o=this._iKey=n.clone(),a=s.words,u=o.words,h=0;h<r;h++)a[h]^=1549556828,u[h]^=909522486;s.sigBytes=o.sigBytes=i,this.reset()},reset:function(){var t=this._hasher;t.reset(),t.update(this._iKey)},update:function(t){return this._hasher.update(t),this},finalize:function(t){var e=this._hasher;return t=e.finalize(t),e.reset(),e.finalize(this._oKey.clone().concat(t))}})}(),function(){var t=or,e=t.lib,n=e.Base,r=e.WordArray,e=t.algo,i=e.HMAC,s=e.PBKDF2=n.extend({cfg:n.extend({keySize:4,hasher:e.SHA1,iterations:1}),init:function(t){this.cfg=this.cfg.extend(t)},compute:function(t,e){for(var n=this.cfg,s=i.create(n.hasher,t),o=r.create(),a=r.create([1]),u=o.words,h=a.words,c=n.keySize,n=n.iterations;u.length<c;){var f=s.update(e).finalize(a);s.reset();for(var l=f.words,d=l.length,p=f,g=1;g<n;g++){p=s.finalize(p),s.reset();for(var y=p.words,v=0;v<d;v++)l[v]^=y[v]}o.concat(f),h[0]++}return o.sigBytes=4*c,o}});t.PBKDF2=function(t,e,n){return s.create(n).compute(t,e)}}();/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
		 */
	var ar,ur="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",hr="=",cr=0xdeadbeefcafe,fr=15715070==(16777215&cr);fr&&"Microsoft Internet Explorer"==rr.appName?(o.prototype.am=h,ar=30):fr&&"Netscape"!=rr.appName?(o.prototype.am=u,ar=26):(o.prototype.am=c,ar=28),o.prototype.DB=ar,o.prototype.DM=(1<<ar)-1,o.prototype.DV=1<<ar;var lr=52;o.prototype.FV=Math.pow(2,lr),o.prototype.F1=lr-ar,o.prototype.F2=2*ar-lr;var dr,pr,gr="0123456789abcdefghijklmnopqrstuvwxyz",yr=new Array;for(dr="0".charCodeAt(0),pr=0;pr<=9;++pr)yr[dr++]=pr;for(dr="a".charCodeAt(0),pr=10;pr<36;++pr)yr[dr++]=pr;for(dr="A".charCodeAt(0),pr=10;pr<36;++pr)yr[dr++]=pr;j.prototype.convert=R,j.prototype.revert=I,j.prototype.reduce=k,j.prototype.mulTo=B,j.prototype.sqrTo=N,M.prototype.convert=K,M.prototype.revert=L,M.prototype.reduce=U,M.prototype.mulTo=W,M.prototype.sqrTo=q,o.prototype.copyTo=d,o.prototype.fromInt=p,o.prototype.fromString=y,o.prototype.clamp=v,o.prototype.dlShiftTo=A,o.prototype.drShiftTo=_,o.prototype.lShiftTo=F,o.prototype.rShiftTo=P,o.prototype.subTo=O,o.prototype.multiplyTo=C,o.prototype.squareTo=T,o.prototype.divRemTo=D,o.prototype.invDigit=V,o.prototype.isEven=J,o.prototype.exp=z,o.prototype.toString=m,o.prototype.negate=S,o.prototype.abs=b,o.prototype.compareTo=w,o.prototype.bitLength=x,o.prototype.mod=H,o.prototype.modPowInt=Y,o.ZERO=g(0),o.ONE=g(1),Vt.prototype.convert=Mt,Vt.prototype.revert=Mt,Vt.prototype.mulTo=Kt,Vt.prototype.sqrTo=Lt,Jt.prototype.convert=zt,Jt.prototype.revert=Yt,Jt.prototype.reduce=Gt,Jt.prototype.mulTo=$t,Jt.prototype.sqrTo=Xt;var vr=[2,3,5,7,11,13,17,19,23,29,31,37,41,43,47,53,59,61,67,71,73,79,83,89,97,101,103,107,109,113,127,131,137,139,149,151,157,163,167,173,179,181,191,193,197,199,211,223,227,229,233,239,241,251,257,263,269,271,277,281,283,293,307,311,313,317,331,337,347,349,353,359,367,373,379,383,389,397,401,409,419,421,431,433,439,443,449,457,461,463,467,479,487,491,499,503,509,521,523,541,547,557,563,569,571,577,587,593,599,601,607,613,617,619,631,641,643,647,653,659,661,673,677,683,691,701,709,719,727,733,739,743,751,757,761,769,773,787,797,809,811,821,823,827,829,839,853,857,859,863,877,881,883,887,907,911,919,929,937,941,947,953,967,971,977,983,991,997],mr=(1<<26)/vr[vr.length-1];o.prototype.chunkSize=Q,o.prototype.toRadix=et,o.prototype.fromRadix=nt,o.prototype.fromNumber=rt,o.prototype.bitwiseTo=ut,o.prototype.changeBit=_t,o.prototype.addTo=Ct,o.prototype.dMultiply=Bt,o.prototype.dAddOffset=Nt,o.prototype.multiplyLowerTo=qt,o.prototype.multiplyUpperTo=Wt,o.prototype.modInt=te,o.prototype.millerRabin=re,o.prototype.clone=G,o.prototype.intValue=X,o.prototype.byteValue=$,o.prototype.shortValue=Z,o.prototype.signum=tt,o.prototype.toByteArray=it,o.prototype.equals=st,o.prototype.min=ot,o.prototype.max=at,o.prototype.and=ct,o.prototype.or=lt,o.prototype.xor=pt,o.prototype.andNot=yt,o.prototype.not=vt,o.prototype.shiftLeft=mt,o.prototype.shiftRight=St,o.prototype.getLowestSetBit=wt,o.prototype.bitCount=xt,o.prototype.testBit=At,o.prototype.setBit=Ft,o.prototype.clearBit=Pt,o.prototype.flipBit=Ot,o.prototype.add=Tt,o.prototype.subtract=Dt,o.prototype.multiply=Ht,o.prototype.divide=Rt,o.prototype.remainder=It,o.prototype.divideAndRemainder=kt,o.prototype.modPow=Zt,o.prototype.modInverse=ee,o.prototype.pow=Ut,o.prototype.gcd=Qt,o.prototype.isProbablePrime=ne,o.prototype.square=jt,ie.prototype.init=se,ie.prototype.next=oe;var Sr,br,wr,Er=256;if(null==br){br=new Array,wr=0;var xr;if(ir.crypto&&ir.crypto.getRandomValues){var Ar=new Uint8Array(32);for(ir.crypto.getRandomValues(Ar),xr=0;xr<32;++xr)br[wr++]=Ar[xr]}if("Netscape"==rr.appName&&rr.appVersion<"5"&&ir.crypto){var _r=ir.crypto.random(32);for(xr=0;xr<_r.length;++xr)br[wr++]=255&_r.charCodeAt(xr)}for(;wr<Er;)xr=Math.floor(65536*Math.random()),br[wr++]=xr>>>8,br[wr++]=255&xr;wr=0,he()}le.prototype.nextBytes=fe;var Fr=20;ve.prototype.doPublic=Se,ve.prototype.setPublic=me,ve.prototype.encrypt=be,ve.prototype.encryptOAEP=we,ve.prototype.type="RSA";var Fr=20;ve.prototype.doPrivate=Oe,ve.prototype.setPrivate=_e,ve.prototype.setPrivateEx=Fe,ve.prototype.generate=Pe,ve.prototype.decrypt=Ce,ve.prototype.decryptOAEP=Te,De.prototype.equals=He,De.prototype.toBigInteger=je,De.prototype.negate=Re,De.prototype.add=Ie,De.prototype.subtract=ke,De.prototype.multiply=Be,De.prototype.square=Ne,De.prototype.divide=Ve,Me.prototype.getX=Ke,Me.prototype.getY=Le,Me.prototype.equals=Ue,Me.prototype.isInfinity=qe,Me.prototype.negate=We,Me.prototype.add=Je,Me.prototype.twice=ze,Me.prototype.multiply=Ye,Me.prototype.multiplyTwo=Ge,Xe.prototype.getQ=$e,Xe.prototype.getA=Ze,Xe.prototype.getB=Qe,Xe.prototype.equals=tn,Xe.prototype.getInfinity=en,Xe.prototype.fromBigInteger=nn,Xe.prototype.decodePointHex=rn,/*! (c) Stefan Thomas | https://github.com/bitcoinjs/bitcoinjs-lib
		 */
	De.prototype.getByteLength=function(){return Math.floor((this.toBigInteger().bitLength()+7)/8)},Me.prototype.getEncoded=function(t){var e=function(t,e){var n=t.toByteArrayUnsigned();if(e<n.length)n=n.slice(n.length-e);else for(;e>n.length;)n.unshift(0);return n},n=this.getX().toBigInteger(),r=this.getY().toBigInteger(),i=e(n,32);return t?r.isEven()?i.unshift(2):i.unshift(3):(i.unshift(4),i=i.concat(e(r,32))),i},Me.decodeFrom=function(t,e){var n=(e[0],e.length-1),r=e.slice(1,1+n/2),i=e.slice(1+n/2,1+n);r.unshift(0),i.unshift(0);var s=new o(r),a=new o(i);return new Me(t,t.fromBigInteger(s),t.fromBigInteger(a))},Me.decodeFromHex=function(t,e){var n=(e.substr(0,2),e.length-2),r=e.substr(2,n/2),i=e.substr(2+n/2,n/2),s=new o(r,16),a=new o(i,16);return new Me(t,t.fromBigInteger(s),t.fromBigInteger(a))},Me.prototype.add2D=function(t){if(this.isInfinity())return t;if(t.isInfinity())return this;if(this.x.equals(t.x))return this.y.equals(t.y)?this.twice():this.curve.getInfinity();var e=t.x.subtract(this.x),n=t.y.subtract(this.y),r=n.divide(e),i=r.square().subtract(this.x).subtract(t.x),s=r.multiply(this.x.subtract(i)).subtract(this.y);return new Me(this.curve,i,s)},Me.prototype.twice2D=function(){if(this.isInfinity())return this;if(0==this.y.toBigInteger().signum())return this.curve.getInfinity();var t=this.curve.fromBigInteger(o.valueOf(2)),e=this.curve.fromBigInteger(o.valueOf(3)),n=this.x.square().multiply(e).add(this.curve.a).divide(this.y.multiply(t)),r=n.square().subtract(this.x.multiply(t)),i=n.multiply(this.x.subtract(r)).subtract(this.y);return new Me(this.curve,r,i)},Me.prototype.multiply2D=function(t){if(this.isInfinity())return this;if(0==t.signum())return this.curve.getInfinity();var e,n=t,r=n.multiply(new o("3")),i=this.negate(),s=this;for(e=r.bitLength()-2;e>0;--e){s=s.twice();var a=r.testBit(e),u=n.testBit(e);a!=u&&(s=s.add2D(a?this:i))}return s},Me.prototype.isOnCurve=function(){var t=this.getX().toBigInteger(),e=this.getY().toBigInteger(),n=this.curve.getA().toBigInteger(),r=this.curve.getB().toBigInteger(),i=this.curve.getQ(),s=e.multiply(e).mod(i),o=t.multiply(t).multiply(t).add(n.multiply(t)).add(r).mod(i);return s.equals(o)},Me.prototype.toString=function(){return"("+this.getX().toBigInteger().toString()+","+this.getY().toBigInteger().toString()+")"},Me.prototype.validate=function(){var t=this.curve.getQ();if(this.isInfinity())throw new Error("Point is at infinity.");var e=this.getX().toBigInteger(),n=this.getY().toBigInteger();if(e.compareTo(o.ONE)<0||e.compareTo(t.subtract(o.ONE))>0)throw new Error("x coordinate out of bounds");if(n.compareTo(o.ONE)<0||n.compareTo(t.subtract(o.ONE))>0)throw new Error("y coordinate out of bounds");if(!this.isOnCurve())throw new Error("Point is not on the curve.");if(this.multiply(t).isInfinity())throw new Error("Point is not a scalar multiple of G.");return!0};/*! Mike Samuel (c) 2009 | code.google.com/p/json-sans-eval
		 */
	var Pr=function(){function t(t,e,n){return e?o[e]:String.fromCharCode(parseInt(n,16))}var e="(?:-?\\b(?:0|[1-9][0-9]*)(?:\\.[0-9]+)?(?:[eE][+-]?[0-9]+)?\\b)",n='(?:[^\\0-\\x08\\x0a-\\x1f"\\\\]|\\\\(?:["/\\\\bfnrt]|u[0-9A-Fa-f]{4}))',r='(?:"'+n+'*")',i=new RegExp("(?:false|true|null|[\\{\\}\\[\\]]|"+e+"|"+r+")","g"),s=new RegExp("\\\\(?:([^u])|u(.{4}))","g"),o={'"':'"',"/":"/","\\":"\\",b:"\b",f:"\f",n:"\n",r:"\r",t:"\t"},a=new String(""),u="\\",h=({"{":Object,"[":Array},Object.hasOwnProperty);return function(e,n){var r,o=e.match(i),c=o[0],f=!1;"{"===c?r={}:"["===c?r=[]:(r=[],f=!0);for(var l,d=[r],p=1-f,g=o.length;p<g;++p){c=o[p];var y;switch(c.charCodeAt(0)){default:y=d[0],y[l||y.length]=+c,l=void 0;break;case 34:if(c=c.substring(1,c.length-1),c.indexOf(u)!==-1&&(c=c.replace(s,t)),y=d[0],!l){if(!(y instanceof Array)){l=c||a;break}l=y.length}y[l]=c,l=void 0;break;case 91:y=d[0],d.unshift(y[l||y.length]=[]),l=void 0;break;case 93:d.shift();break;case 102:y=d[0],y[l||y.length]=!1,l=void 0;break;case 110:y=d[0],y[l||y.length]=null,l=void 0;break;case 116:y=d[0],y[l||y.length]=!0,l=void 0;break;case 123:y=d[0],d.unshift(y[l||y.length]={}),l=void 0;break;case 125:d.shift()}}if(f){if(1!==d.length)throw new Error;r=r[0]}else if(d.length)throw new Error;if(n){var v=function(t,e){var r=t[e];if(r&&"object"==typeof r){var i=null;for(var s in r)if(h.call(r,s)&&r!==t){var o=v(r,s);void 0!==o?r[s]=o:(i||(i=[]),i.push(s))}if(i)for(var a=i.length;--a>=0;)delete r[i[a]]}return n.call(t,e,r)};r=v({"":r},"")}return r}}();/*! asn1-1.0.10.js (c) 2013-2016 Kenji Urushima | kjur.github.com/jsrsasign/license
		 */
	"undefined"!=typeof Cr&&Cr||(Cr={}),"undefined"!=typeof Cr.asn1&&Cr.asn1||(Cr.asn1={}),Cr.asn1.ASN1Util=new function(){this.integerToByteHex=function(t){var e=t.toString(16);return e.length%2==1&&(e="0"+e),e},this.bigIntToMinTwosComplementsHex=function(t){var e=t.toString(16);if("-"!=e.substr(0,1))e.length%2==1?e="0"+e:e.match(/^[0-7]/)||(e="00"+e);else{var n=e.substr(1),r=n.length;r%2==1?r+=1:e.match(/^[0-7]/)||(r+=2);for(var i="",s=0;s<r;s++)i+="f";var a=new o(i,16),u=a.xor(t).add(o.ONE);e=u.toString(16).replace(/^-/,"")}return e},this.getPEMStringFromHex=function(t,e){var n=En(t),r=n.replace(/(.{64})/g,"$1\r\n");return r=r.replace(/\r\n$/,""),"-----BEGIN "+e+"-----\r\n"+r+"\r\n-----END "+e+"-----\r\n"},this.newObject=function(t){var e=Cr.asn1,n=Object.keys(t);if(1!=n.length)throw"key of param shall be only one.";var r=n[0];if(":bool:int:bitstr:octstr:null:oid:enum:utf8str:numstr:prnstr:telstr:ia5str:utctime:gentime:seq:set:tag:".indexOf(":"+r+":")==-1)throw"undefined key: "+r;if("bool"==r)return new e.DERBoolean(t[r]);if("int"==r)return new e.DERInteger(t[r]);if("bitstr"==r)return new e.DERBitString(t[r]);if("octstr"==r)return new e.DEROctetString(t[r]);if("null"==r)return new e.DERNull(t[r]);if("oid"==r)return new e.DERObjectIdentifier(t[r]);if("enum"==r)return new e.DEREnumerated(t[r]);if("utf8str"==r)return new e.DERUTF8String(t[r]);if("numstr"==r)return new e.DERNumericString(t[r]);if("prnstr"==r)return new e.DERPrintableString(t[r]);if("telstr"==r)return new e.DERTeletexString(t[r]);if("ia5str"==r)return new e.DERIA5String(t[r]);if("utctime"==r)return new e.DERUTCTime(t[r]);if("gentime"==r)return new e.DERGeneralizedTime(t[r]);if("seq"==r){for(var i=t[r],s=[],o=0;o<i.length;o++){var a=e.ASN1Util.newObject(i[o]);s.push(a)}return new e.DERSequence({array:s})}if("set"==r){for(var i=t[r],s=[],o=0;o<i.length;o++){var a=e.ASN1Util.newObject(i[o]);s.push(a)}return new e.DERSet({array:s})}if("tag"==r){var u=t[r];if("[object Array]"===Object.prototype.toString.call(u)&&3==u.length){var h=e.ASN1Util.newObject(u[2]);return new e.DERTaggedObject({tag:u[0],explicit:u[1],obj:h})}var c={};if(void 0!==u.explicit&&(c.explicit=u.explicit),void 0!==u.tag&&(c.tag=u.tag),void 0===u.obj)throw"obj shall be specified for 'tag'.";return c.obj=e.ASN1Util.newObject(u.obj),new e.DERTaggedObject(c)}},this.jsonToASN1HEX=function(t){var e=this.newObject(t);return e.getEncodedHex()}},Cr.asn1.ASN1Util.oidHexToInt=function(t){for(var e="",n=parseInt(t.substr(0,2),16),r=Math.floor(n/40),i=n%40,e=r+"."+i,s="",a=2;a<t.length;a+=2){var u=parseInt(t.substr(a,2),16),h=("00000000"+u.toString(2)).slice(-8);if(s+=h.substr(1,7),"0"==h.substr(0,1)){var c=new o(s,2);e=e+"."+c.toString(10),s=""}}return e},Cr.asn1.ASN1Util.oidIntToHex=function(t){var e=function(t){var e=t.toString(16);return 1==e.length&&(e="0"+e),e},n=function(t){var n="",r=new o(t,10),i=r.toString(2),s=7-i.length%7;7==s&&(s=0);for(var a="",u=0;u<s;u++)a+="0";i=a+i;for(var u=0;u<i.length-1;u+=7){var h=i.substr(u,7);u!=i.length-7&&(h="1"+h),n+=e(parseInt(h,2))}return n};if(!t.match(/^[0-9.]+$/))throw"malformed oid string: "+t;var r="",i=t.split("."),s=40*parseInt(i[0])+parseInt(i[1]);r+=e(s),i.splice(0,2);for(var a=0;a<i.length;a++)r+=n(i[a]);return r},Cr.asn1.ASN1Object=function(){var t="";this.getLengthHexFromValue=function(){if("undefined"==typeof this.hV||null==this.hV)throw"this.hV is null or undefined.";if(this.hV.length%2==1)throw"value hex must be even length: n="+t.length+",v="+this.hV;var e=this.hV.length/2,n=e.toString(16);if(n.length%2==1&&(n="0"+n),e<128)return n;var r=n.length/2;if(r>15)throw"ASN.1 length too long to represent by 8x: n = "+e.toString(16);var i=128+r;return i.toString(16)+n},this.getEncodedHex=function(){return(null==this.hTLV||this.isModified)&&(this.hV=this.getFreshValueHex(),this.hL=this.getLengthHexFromValue(),this.hTLV=this.hT+this.hL+this.hV,this.isModified=!1),this.hTLV},this.getValueHex=function(){return this.getEncodedHex(),this.hV},this.getFreshValueHex=function(){return""}},Cr.asn1.DERAbstractString=function(t){Cr.asn1.DERAbstractString.superclass.constructor.call(this);this.getString=function(){return this.s},this.setString=function(t){this.hTLV=null,this.isModified=!0,this.s=t,this.hV=un(this.s)},this.setStringHex=function(t){this.hTLV=null,this.isModified=!0,this.s=null,this.hV=t},this.getFreshValueHex=function(){return this.hV},"undefined"!=typeof t&&("string"==typeof t?this.setString(t):"undefined"!=typeof t.str?this.setString(t.str):"undefined"!=typeof t.hex&&this.setStringHex(t.hex))},sr.lang.extend(Cr.asn1.DERAbstractString,Cr.asn1.ASN1Object),Cr.asn1.DERAbstractTime=function(t){Cr.asn1.DERAbstractTime.superclass.constructor.call(this);this.localDateToUTC=function(t){utc=t.getTime()+6e4*t.getTimezoneOffset();var e=new Date(utc);return e},this.formatDate=function(t,e,n){var r=this.zeroPadding,i=this.localDateToUTC(t),s=String(i.getFullYear());"utc"==e&&(s=s.substr(2,2));var o=r(String(i.getMonth()+1),2),a=r(String(i.getDate()),2),u=r(String(i.getHours()),2),h=r(String(i.getMinutes()),2),c=r(String(i.getSeconds()),2),f=s+o+a+u+h+c;if(n===!0){var l=i.getMilliseconds();if(0!=l){var d=r(String(l),3);d=d.replace(/[0]+$/,""),f=f+"."+d}}return f+"Z"},this.zeroPadding=function(t,e){return t.length>=e?t:new Array(e-t.length+1).join("0")+t},this.getString=function(){return this.s},this.setString=function(t){this.hTLV=null,this.isModified=!0,this.s=t,this.hV=un(t)},this.setByDateValue=function(t,e,n,r,i,s){var o=new Date(Date.UTC(t,e-1,n,r,i,s,0));this.setByDate(o)},this.getFreshValueHex=function(){return this.hV}},sr.lang.extend(Cr.asn1.DERAbstractTime,Cr.asn1.ASN1Object),Cr.asn1.DERAbstractStructured=function(t){Cr.asn1.DERAbstractString.superclass.constructor.call(this);this.setByASN1ObjectArray=function(t){this.hTLV=null,this.isModified=!0,this.asn1Array=t},this.appendASN1Object=function(t){this.hTLV=null,this.isModified=!0,this.asn1Array.push(t)},this.asn1Array=new Array,"undefined"!=typeof t&&"undefined"!=typeof t.array&&(this.asn1Array=t.array)},sr.lang.extend(Cr.asn1.DERAbstractStructured,Cr.asn1.ASN1Object),Cr.asn1.DERBoolean=function(){Cr.asn1.DERBoolean.superclass.constructor.call(this),this.hT="01",this.hTLV="0101ff"},sr.lang.extend(Cr.asn1.DERBoolean,Cr.asn1.ASN1Object),Cr.asn1.DERInteger=function(t){Cr.asn1.DERInteger.superclass.constructor.call(this),this.hT="02",this.setByBigInteger=function(t){this.hTLV=null,this.isModified=!0,this.hV=Cr.asn1.ASN1Util.bigIntToMinTwosComplementsHex(t)},this.setByInteger=function(t){var e=new o(String(t),10);this.setByBigInteger(e)},this.setValueHex=function(t){this.hV=t},this.getFreshValueHex=function(){return this.hV},"undefined"!=typeof t&&("undefined"!=typeof t.bigint?this.setByBigInteger(t.bigint):"undefined"!=typeof t.int?this.setByInteger(t.int):"number"==typeof t?this.setByInteger(t):"undefined"!=typeof t.hex&&this.setValueHex(t.hex))},sr.lang.extend(Cr.asn1.DERInteger,Cr.asn1.ASN1Object),Cr.asn1.DERBitString=function(t){Cr.asn1.DERBitString.superclass.constructor.call(this),this.hT="03",this.setHexValueIncludingUnusedBits=function(t){this.hTLV=null,this.isModified=!0,this.hV=t},this.setUnusedBitsAndHexValue=function(t,e){if(t<0||7<t)throw"unused bits shall be from 0 to 7: u = "+t;var n="0"+t;this.hTLV=null,this.isModified=!0,this.hV=n+e},this.setByBinaryString=function(t){t=t.replace(/0+$/,"");var e=8-t.length%8;8==e&&(e=0);for(var n=0;n<=e;n++)t+="0";for(var r="",n=0;n<t.length-1;n+=8){var i=t.substr(n,8),s=parseInt(i,2).toString(16);1==s.length&&(s="0"+s),r+=s}this.hTLV=null,this.isModified=!0,this.hV="0"+e+r},this.setByBooleanArray=function(t){for(var e="",n=0;n<t.length;n++)e+=1==t[n]?"1":"0";this.setByBinaryString(e)},this.newFalseArray=function(t){for(var e=new Array(t),n=0;n<t;n++)e[n]=!1;return e},this.getFreshValueHex=function(){return this.hV},"undefined"!=typeof t&&("string"==typeof t&&t.toLowerCase().match(/^[0-9a-f]+$/)?this.setHexValueIncludingUnusedBits(t):"undefined"!=typeof t.hex?this.setHexValueIncludingUnusedBits(t.hex):"undefined"!=typeof t.bin?this.setByBinaryString(t.bin):"undefined"!=typeof t.array&&this.setByBooleanArray(t.array))},sr.lang.extend(Cr.asn1.DERBitString,Cr.asn1.ASN1Object),Cr.asn1.DEROctetString=function(t){Cr.asn1.DEROctetString.superclass.constructor.call(this,t),this.hT="04"},sr.lang.extend(Cr.asn1.DEROctetString,Cr.asn1.DERAbstractString),Cr.asn1.DERNull=function(){Cr.asn1.DERNull.superclass.constructor.call(this),this.hT="05",this.hTLV="0500"},sr.lang.extend(Cr.asn1.DERNull,Cr.asn1.ASN1Object),Cr.asn1.DERObjectIdentifier=function(t){var e=function(t){var e=t.toString(16);return 1==e.length&&(e="0"+e),e},n=function(t){var n="",r=new o(t,10),i=r.toString(2),s=7-i.length%7;7==s&&(s=0);for(var a="",u=0;u<s;u++)a+="0";i=a+i;for(var u=0;u<i.length-1;u+=7){var h=i.substr(u,7);u!=i.length-7&&(h="1"+h),n+=e(parseInt(h,2))}return n};Cr.asn1.DERObjectIdentifier.superclass.constructor.call(this),this.hT="06",this.setValueHex=function(t){this.hTLV=null,this.isModified=!0,this.s=null,this.hV=t},this.setValueOidString=function(t){if(!t.match(/^[0-9.]+$/))throw"malformed oid string: "+t;var r="",i=t.split("."),s=40*parseInt(i[0])+parseInt(i[1]);r+=e(s),i.splice(0,2);for(var o=0;o<i.length;o++)r+=n(i[o]);this.hTLV=null,this.isModified=!0,this.s=null,this.hV=r},this.setValueName=function(t){if("undefined"==typeof Cr.asn1.x509.OID.name2oidList[t])throw"DERObjectIdentifier oidName undefined: "+t;var e=Cr.asn1.x509.OID.name2oidList[t];this.setValueOidString(e)},this.getFreshValueHex=function(){return this.hV},"undefined"!=typeof t&&("string"==typeof t&&t.match(/^[0-2].[0-9.]+$/)?this.setValueOidString(t):void 0!==Cr.asn1.x509.OID.name2oidList[t]?this.setValueOidString(Cr.asn1.x509.OID.name2oidList[t]):"undefined"!=typeof t.oid?this.setValueOidString(t.oid):"undefined"!=typeof t.hex?this.setValueHex(t.hex):"undefined"!=typeof t.name&&this.setValueName(t.name))},sr.lang.extend(Cr.asn1.DERObjectIdentifier,Cr.asn1.ASN1Object),Cr.asn1.DEREnumerated=function(t){Cr.asn1.DEREnumerated.superclass.constructor.call(this),this.hT="0a",this.setByBigInteger=function(t){this.hTLV=null,this.isModified=!0,this.hV=Cr.asn1.ASN1Util.bigIntToMinTwosComplementsHex(t)},this.setByInteger=function(t){var e=new o(String(t),10);this.setByBigInteger(e)},this.setValueHex=function(t){this.hV=t},this.getFreshValueHex=function(){return this.hV},"undefined"!=typeof t&&("undefined"!=typeof t.int?this.setByInteger(t.int):"number"==typeof t?this.setByInteger(t):"undefined"!=typeof t.hex&&this.setValueHex(t.hex))},sr.lang.extend(Cr.asn1.DEREnumerated,Cr.asn1.ASN1Object),Cr.asn1.DERUTF8String=function(t){Cr.asn1.DERUTF8String.superclass.constructor.call(this,t),this.hT="0c"},sr.lang.extend(Cr.asn1.DERUTF8String,Cr.asn1.DERAbstractString),Cr.asn1.DERNumericString=function(t){Cr.asn1.DERNumericString.superclass.constructor.call(this,t),this.hT="12"},sr.lang.extend(Cr.asn1.DERNumericString,Cr.asn1.DERAbstractString),Cr.asn1.DERPrintableString=function(t){Cr.asn1.DERPrintableString.superclass.constructor.call(this,t),this.hT="13"},sr.lang.extend(Cr.asn1.DERPrintableString,Cr.asn1.DERAbstractString),Cr.asn1.DERTeletexString=function(t){Cr.asn1.DERTeletexString.superclass.constructor.call(this,t),this.hT="14"},sr.lang.extend(Cr.asn1.DERTeletexString,Cr.asn1.DERAbstractString),Cr.asn1.DERIA5String=function(t){Cr.asn1.DERIA5String.superclass.constructor.call(this,t),this.hT="16"},sr.lang.extend(Cr.asn1.DERIA5String,Cr.asn1.DERAbstractString),Cr.asn1.DERUTCTime=function(t){Cr.asn1.DERUTCTime.superclass.constructor.call(this,t),this.hT="17",this.setByDate=function(t){this.hTLV=null,this.isModified=!0,this.date=t,this.s=this.formatDate(this.date,"utc"),this.hV=un(this.s)},this.getFreshValueHex=function(){return"undefined"==typeof this.date&&"undefined"==typeof this.s&&(this.date=new Date,this.s=this.formatDate(this.date,"utc"),this.hV=un(this.s)),this.hV},void 0!==t&&(void 0!==t.str?this.setString(t.str):"string"==typeof t&&t.match(/^[0-9]{12}Z$/)?this.setString(t):void 0!==t.hex?this.setStringHex(t.hex):void 0!==t.date&&this.setByDate(t.date))},sr.lang.extend(Cr.asn1.DERUTCTime,Cr.asn1.DERAbstractTime),Cr.asn1.DERGeneralizedTime=function(t){Cr.asn1.DERGeneralizedTime.superclass.constructor.call(this,t),this.hT="18",this.withMillis=!1,this.setByDate=function(t){this.hTLV=null,this.isModified=!0,this.date=t,this.s=this.formatDate(this.date,"gen",this.withMillis),this.hV=un(this.s)},this.getFreshValueHex=function(){return void 0===this.date&&void 0===this.s&&(this.date=new Date,this.s=this.formatDate(this.date,"gen",this.withMillis),this.hV=un(this.s)),this.hV},void 0!==t&&(void 0!==t.str?this.setString(t.str):"string"==typeof t&&t.match(/^[0-9]{14}Z$/)?this.setString(t):void 0!==t.hex?this.setStringHex(t.hex):void 0!==t.date&&this.setByDate(t.date),t.millis===!0&&(this.withMillis=!0))},sr.lang.extend(Cr.asn1.DERGeneralizedTime,Cr.asn1.DERAbstractTime),Cr.asn1.DERSequence=function(t){Cr.asn1.DERSequence.superclass.constructor.call(this,t),this.hT="30",this.getFreshValueHex=function(){for(var t="",e=0;e<this.asn1Array.length;e++){var n=this.asn1Array[e];t+=n.getEncodedHex()}return this.hV=t,this.hV}},sr.lang.extend(Cr.asn1.DERSequence,Cr.asn1.DERAbstractStructured),Cr.asn1.DERSet=function(t){Cr.asn1.DERSet.superclass.constructor.call(this,t),this.hT="31",this.sortFlag=!0,this.getFreshValueHex=function(){for(var t=new Array,e=0;e<this.asn1Array.length;e++){var n=this.asn1Array[e];t.push(n.getEncodedHex())}return 1==this.sortFlag&&t.sort(),this.hV=t.join(""),this.hV},"undefined"!=typeof t&&"undefined"!=typeof t.sortflag&&0==t.sortflag&&(this.sortFlag=!1)},sr.lang.extend(Cr.asn1.DERSet,Cr.asn1.DERAbstractStructured),Cr.asn1.DERTaggedObject=function(t){Cr.asn1.DERTaggedObject.superclass.constructor.call(this),this.hT="a0",this.hV="",this.isExplicit=!0,this.asn1Object=null,this.setASN1Object=function(t,e,n){this.hT=e,this.isExplicit=t,this.asn1Object=n,this.isExplicit?(this.hV=this.asn1Object.getEncodedHex(),this.hTLV=null,this.isModified=!0):(this.hV=null,this.hTLV=n.getEncodedHex(),this.hTLV=this.hTLV.replace(/^../,e),this.isModified=!1)},this.getFreshValueHex=function(){return this.hV},"undefined"!=typeof t&&("undefined"!=typeof t.tag&&(this.hT=t.tag),"undefined"!=typeof t.explicit&&(this.isExplicit=t.explicit),"undefined"!=typeof t.obj&&(this.asn1Object=t.obj,this.setASN1Object(this.isExplicit,this.hT,this.asn1Object)))},sr.lang.extend(Cr.asn1.DERTaggedObject,Cr.asn1.ASN1Object);/*! asn1hex-1.1.6.js (c) 2012-2015 Kenji Urushima | kjur.github.com/jsrsasign/license
		 */
	var Or=new function(){this.getByteLengthOfL_AtObj=function(t,e){if("8"!=t.substring(e+2,e+3))return 1;var n=parseInt(t.substring(e+3,e+4));return 0==n?-1:0<n&&n<10?n+1:-2},this.getHexOfL_AtObj=function(t,e){var n=this.getByteLengthOfL_AtObj(t,e);return n<1?"":t.substring(e+2,e+2+2*n)},this.getIntOfL_AtObj=function(t,e){var n=this.getHexOfL_AtObj(t,e);if(""==n)return-1;var r;return r=parseInt(n.substring(0,1))<8?new o(n,16):new o(n.substring(2),16),r.intValue()},this.getStartPosOfV_AtObj=function(t,e){var n=this.getByteLengthOfL_AtObj(t,e);return n<0?n:e+2*(n+1)},this.getHexOfV_AtObj=function(t,e){var n=this.getStartPosOfV_AtObj(t,e),r=this.getIntOfL_AtObj(t,e);return t.substring(n,n+2*r)},this.getHexOfTLV_AtObj=function(t,e){var n=t.substr(e,2),r=this.getHexOfL_AtObj(t,e),i=this.getHexOfV_AtObj(t,e);return n+r+i},this.getPosOfNextSibling_AtObj=function(t,e){var n=this.getStartPosOfV_AtObj(t,e),r=this.getIntOfL_AtObj(t,e);return n+2*r},this.getPosArrayOfChildren_AtObj=function(t,e){var n=new Array,r=this.getStartPosOfV_AtObj(t,e);n.push(r);for(var i=this.getIntOfL_AtObj(t,e),s=r,o=0;;){var a=this.getPosOfNextSibling_AtObj(t,s);if(null==a||a-r>=2*i)break;if(o>=200)break;n.push(a),s=a,o++}return n},this.getNthChildIndex_AtObj=function(t,e,n){var r=this.getPosArrayOfChildren_AtObj(t,e);return r[n]},this.getDecendantIndexByNthList=function(t,e,n){if(0==n.length)return e;var r=n.shift(),i=this.getPosArrayOfChildren_AtObj(t,e);return this.getDecendantIndexByNthList(t,i[r],n)},this.getDecendantHexTLVByNthList=function(t,e,n){var r=this.getDecendantIndexByNthList(t,e,n);return this.getHexOfTLV_AtObj(t,r)},this.getDecendantHexVByNthList=function(t,e,n){var r=this.getDecendantIndexByNthList(t,e,n);return this.getHexOfV_AtObj(t,r)}};Or.getVbyList=function(t,e,n,r){var i=this.getDecendantIndexByNthList(t,e,n);if(void 0===i)throw"can't find nthList object";if(void 0!==r&&t.substr(i,2)!=r)throw"checking tag doesn't match: "+t.substr(i,2)+"!="+r;return this.getHexOfV_AtObj(t,i)},Or.hextooidstr=function(t){var e=function(t,e){return t.length>=e?t:new Array(e-t.length+1).join("0")+t},n=[],r=t.substr(0,2),i=parseInt(r,16);n[0]=new String(Math.floor(i/40)),n[1]=new String(i%40);for(var s=t.substr(2),o=[],a=0;a<s.length/2;a++)o.push(parseInt(s.substr(2*a,2),16));for(var u=[],h="",a=0;a<o.length;a++)128&o[a]?h+=e((127&o[a]).toString(2),7):(h+=e((127&o[a]).toString(2),7),u.push(new String(parseInt(h,2))),h="");var c=n.join(".");return u.length>0&&(c=c+"."+u.join(".")),c},Or.dump=function(t,e,n,r){var i=function(t,e){if(t.length<=2*e)return t;var n=t.substr(0,e)+"..(total "+t.length/2+"bytes).."+t.substr(t.length-e,e);return n};void 0===e&&(e={ommit_long_octet:32}),void 0===n&&(n=0),void 0===r&&(r="");var s=e.ommit_long_octet;if("01"==t.substr(n,2)){var o=Or.getHexOfV_AtObj(t,n);return"00"==o?r+"BOOLEAN FALSE\n":r+"BOOLEAN TRUE\n"}if("02"==t.substr(n,2)){var o=Or.getHexOfV_AtObj(t,n);return r+"INTEGER "+i(o,s)+"\n"}if("03"==t.substr(n,2)){var o=Or.getHexOfV_AtObj(t,n);return r+"BITSTRING "+i(o,s)+"\n"}if("04"==t.substr(n,2)){var o=Or.getHexOfV_AtObj(t,n);if(Or.isASN1HEX(o)){var a=r+"OCTETSTRING, encapsulates\n";return a+=Or.dump(o,e,0,r+"  ")}return r+"OCTETSTRING "+i(o,s)+"\n"}if("05"==t.substr(n,2))return r+"NULL\n";if("06"==t.substr(n,2)){var u=Or.getHexOfV_AtObj(t,n),h=Cr.asn1.ASN1Util.oidHexToInt(u),c=Cr.asn1.x509.OID.oid2name(h),f=h.replace(/\./g," ");return""!=c?r+"ObjectIdentifier "+c+" ("+f+")\n":r+"ObjectIdentifier ("+f+")\n"}if("0c"==t.substr(n,2))return r+"UTF8String '"+Sn(Or.getHexOfV_AtObj(t,n))+"'\n";if("13"==t.substr(n,2))return r+"PrintableString '"+Sn(Or.getHexOfV_AtObj(t,n))+"'\n";if("14"==t.substr(n,2))return r+"TeletexString '"+Sn(Or.getHexOfV_AtObj(t,n))+"'\n";if("16"==t.substr(n,2))return r+"IA5String '"+Sn(Or.getHexOfV_AtObj(t,n))+"'\n";if("17"==t.substr(n,2))return r+"UTCTime "+Sn(Or.getHexOfV_AtObj(t,n))+"\n";if("18"==t.substr(n,2))return r+"GeneralizedTime "+Sn(Or.getHexOfV_AtObj(t,n))+"\n";if("30"==t.substr(n,2)){if("3000"==t.substr(n,4))return r+"SEQUENCE {}\n";var a=r+"SEQUENCE\n",l=Or.getPosArrayOfChildren_AtObj(t,n),d=e;if((2==l.length||3==l.length)&&"06"==t.substr(l[0],2)&&"04"==t.substr(l[l.length-1],2)){var p=Or.getHexOfV_AtObj(t,l[0]),h=Cr.asn1.ASN1Util.oidHexToInt(p),c=Cr.asn1.x509.OID.oid2name(h),g=JSON.parse(JSON.stringify(e));g.x509ExtName=c,d=g}for(var y=0;y<l.length;y++)a+=Or.dump(t,d,l[y],r+"  ");return a}if("31"==t.substr(n,2)){for(var a=r+"SET\n",l=Or.getPosArrayOfChildren_AtObj(t,n),y=0;y<l.length;y++)a+=Or.dump(t,e,l[y],r+"  ");return a}var v=parseInt(t.substr(n,2),16);if(0!=(128&v)){var m=31&v;if(0!=(32&v)){for(var a=r+"["+m+"]\n",l=Or.getPosArrayOfChildren_AtObj(t,n),y=0;y<l.length;y++)a+=Or.dump(t,e,l[y],r+"  ");return a}var o=Or.getHexOfV_AtObj(t,n);"68747470"==o.substr(0,8)&&(o=Sn(o)),"subjectAltName"===e.x509ExtName&&2==m&&(o=Sn(o));var a=r+"["+m+"] "+o+"\n";return a}return r+"UNKNOWN("+t.substr(n,2)+") "+Or.getHexOfV_AtObj(t,n)+"\n"},Or.isASN1HEX=function(t){if(t.length%2==1)return!1;var e=Or.getIntOfL_AtObj(t,0),n=t.substr(0,2),r=Or.getHexOfL_AtObj(t,0),i=t.length-n.length-r.length;return i==2*e},/*! asn1x509-1.0.14.js (c) 2013-2015 Kenji Urushima | kjur.github.com/jsrsasign/license
		 */
	"undefined"!=typeof Cr&&Cr||(Cr={}),"undefined"!=typeof Cr.asn1&&Cr.asn1||(Cr.asn1={}),"undefined"!=typeof Cr.asn1.x509&&Cr.asn1.x509||(Cr.asn1.x509={}),Cr.asn1.x509.Certificate=function(t){Cr.asn1.x509.Certificate.superclass.constructor.call(this);this.setRsaPrvKeyByPEMandPass=function(t,e){var n=jr.getDecryptedKeyHex(t,e),r=new ve;r.readPrivateKeyFromASN1HexString(n),this.prvKey=r},this.sign=function(){this.asn1SignatureAlg=this.asn1TBSCert.asn1SignatureAlg,sig=new Cr.crypto.Signature({alg:"SHA1withRSA"}),sig.init(this.prvKey),sig.updateHex(this.asn1TBSCert.getEncodedHex()),this.hexSig=sig.sign(),this.asn1Sig=new Cr.asn1.DERBitString({hex:"00"+this.hexSig});var t=new Cr.asn1.DERSequence({array:[this.asn1TBSCert,this.asn1SignatureAlg,this.asn1Sig]});this.hTLV=t.getEncodedHex(),this.isModified=!1},this.setSignatureHex=function(t){this.asn1SignatureAlg=this.asn1TBSCert.asn1SignatureAlg,this.hexSig=t,this.asn1Sig=new Cr.asn1.DERBitString({hex:"00"+this.hexSig});var e=new Cr.asn1.DERSequence({array:[this.asn1TBSCert,this.asn1SignatureAlg,this.asn1Sig]});this.hTLV=e.getEncodedHex(),this.isModified=!1},this.getEncodedHex=function(){if(0==this.isModified&&null!=this.hTLV)return this.hTLV;throw"not signed yet"},this.getPEMString=function(){var t=this.getEncodedHex(),e=or.enc.Hex.parse(t),n=or.enc.Base64.stringify(e),r=n.replace(/(.{64})/g,"$1\r\n");return"-----BEGIN CERTIFICATE-----\r\n"+r+"\r\n-----END CERTIFICATE-----\r\n"},"undefined"!=typeof t&&("undefined"!=typeof t.tbscertobj&&(this.asn1TBSCert=t.tbscertobj),"undefined"!=typeof t.prvkeyobj?this.prvKey=t.prvkeyobj:"undefined"!=typeof t.rsaprvkey?this.prvKey=t.rsaprvkey:"undefined"!=typeof t.rsaprvpem&&"undefined"!=typeof t.rsaprvpas&&this.setRsaPrvKeyByPEMandPass(t.rsaprvpem,t.rsaprvpas))},sr.lang.extend(Cr.asn1.x509.Certificate,Cr.asn1.ASN1Object),Cr.asn1.x509.TBSCertificate=function(t){Cr.asn1.x509.TBSCertificate.superclass.constructor.call(this),this._initialize=function(){this.asn1Array=new Array,this.asn1Version=new Cr.asn1.DERTaggedObject({obj:new Cr.asn1.DERInteger({int:2})}),this.asn1SerialNumber=null,this.asn1SignatureAlg=null,this.asn1Issuer=null,this.asn1NotBefore=null,this.asn1NotAfter=null,this.asn1Subject=null,this.asn1SubjPKey=null,this.extensionsArray=new Array},this.setSerialNumberByParam=function(t){this.asn1SerialNumber=new Cr.asn1.DERInteger(t)},this.setSignatureAlgByParam=function(t){this.asn1SignatureAlg=new Cr.asn1.x509.AlgorithmIdentifier(t)},this.setIssuerByParam=function(t){this.asn1Issuer=new Cr.asn1.x509.X500Name(t)},this.setNotBeforeByParam=function(t){this.asn1NotBefore=new Cr.asn1.x509.Time(t)},this.setNotAfterByParam=function(t){this.asn1NotAfter=new Cr.asn1.x509.Time(t)},this.setSubjectByParam=function(t){this.asn1Subject=new Cr.asn1.x509.X500Name(t)},this.setSubjectPublicKeyByParam=function(t){this.asn1SubjPKey=new Cr.asn1.x509.SubjectPublicKeyInfo(t)},this.setSubjectPublicKeyByGetKey=function(t){var e=Rr.getKey(t);this.asn1SubjPKey=new Cr.asn1.x509.SubjectPublicKeyInfo(e)},this.appendExtension=function(t){this.extensionsArray.push(t)},this.appendExtensionByName=function(t,e){if("basicconstraints"==t.toLowerCase()){var n=new Cr.asn1.x509.BasicConstraints(e);this.appendExtension(n)}else if("keyusage"==t.toLowerCase()){var n=new Cr.asn1.x509.KeyUsage(e);this.appendExtension(n)}else if("crldistributionpoints"==t.toLowerCase()){var n=new Cr.asn1.x509.CRLDistributionPoints(e);this.appendExtension(n)}else if("extkeyusage"==t.toLowerCase()){var n=new Cr.asn1.x509.ExtKeyUsage(e);this.appendExtension(n)}else{if("authoritykeyidentifier"!=t.toLowerCase())throw"unsupported extension name: "+t;var n=new Cr.asn1.x509.AuthorityKeyIdentifier(e);this.appendExtension(n)}},this.getEncodedHex=function(){if(null==this.asn1NotBefore||null==this.asn1NotAfter)throw"notBefore and/or notAfter not set";var t=new Cr.asn1.DERSequence({array:[this.asn1NotBefore,this.asn1NotAfter]});if(this.asn1Array=new Array,this.asn1Array.push(this.asn1Version),this.asn1Array.push(this.asn1SerialNumber),this.asn1Array.push(this.asn1SignatureAlg),this.asn1Array.push(this.asn1Issuer),this.asn1Array.push(t),this.asn1Array.push(this.asn1Subject),this.asn1Array.push(this.asn1SubjPKey),this.extensionsArray.length>0){var e=new Cr.asn1.DERSequence({array:this.extensionsArray}),n=new Cr.asn1.DERTaggedObject({explicit:!0,tag:"a3",obj:e});this.asn1Array.push(n)}var r=new Cr.asn1.DERSequence({array:this.asn1Array});return this.hTLV=r.getEncodedHex(),this.isModified=!1,this.hTLV},this._initialize()},sr.lang.extend(Cr.asn1.x509.TBSCertificate,Cr.asn1.ASN1Object),Cr.asn1.x509.Extension=function(t){Cr.asn1.x509.Extension.superclass.constructor.call(this);this.getEncodedHex=function(){var t=new Cr.asn1.DERObjectIdentifier({oid:this.oid}),e=new Cr.asn1.DEROctetString({hex:this.getExtnValueHex()}),n=new Array;n.push(t),this.critical&&n.push(new Cr.asn1.DERBoolean),n.push(e);var r=new Cr.asn1.DERSequence({array:n});return r.getEncodedHex()},this.critical=!1,"undefined"!=typeof t&&"undefined"!=typeof t.critical&&(this.critical=t.critical)},sr.lang.extend(Cr.asn1.x509.Extension,Cr.asn1.ASN1Object),Cr.asn1.x509.KeyUsage=function(t){Cr.asn1.x509.KeyUsage.superclass.constructor.call(this,t),this.getExtnValueHex=function(){return this.asn1ExtnValue.getEncodedHex()},this.oid="2.5.29.15","undefined"!=typeof t&&"undefined"!=typeof t.bin&&(this.asn1ExtnValue=new Cr.asn1.DERBitString(t))},sr.lang.extend(Cr.asn1.x509.KeyUsage,Cr.asn1.x509.Extension),Cr.asn1.x509.BasicConstraints=function(t){Cr.asn1.x509.BasicConstraints.superclass.constructor.call(this,t);this.getExtnValueHex=function(){var t=new Array;this.cA&&t.push(new Cr.asn1.DERBoolean),this.pathLen>-1&&t.push(new Cr.asn1.DERInteger({int:this.pathLen}));var e=new Cr.asn1.DERSequence({array:t});return this.asn1ExtnValue=e,this.asn1ExtnValue.getEncodedHex()},this.oid="2.5.29.19",this.cA=!1,this.pathLen=-1,"undefined"!=typeof t&&("undefined"!=typeof t.cA&&(this.cA=t.cA),"undefined"!=typeof t.pathLen&&(this.pathLen=t.pathLen))},sr.lang.extend(Cr.asn1.x509.BasicConstraints,Cr.asn1.x509.Extension),Cr.asn1.x509.CRLDistributionPoints=function(t){Cr.asn1.x509.CRLDistributionPoints.superclass.constructor.call(this,t),this.getExtnValueHex=function(){return this.asn1ExtnValue.getEncodedHex()},this.setByDPArray=function(t){this.asn1ExtnValue=new Cr.asn1.DERSequence({array:t})},this.setByOneURI=function(t){var e=new Cr.asn1.x509.GeneralNames([{uri:t}]),n=new Cr.asn1.x509.DistributionPointName(e),r=new Cr.asn1.x509.DistributionPoint({dpobj:n});this.setByDPArray([r])},this.oid="2.5.29.31","undefined"!=typeof t&&("undefined"!=typeof t.array?this.setByDPArray(t.array):"undefined"!=typeof t.uri&&this.setByOneURI(t.uri))},sr.lang.extend(Cr.asn1.x509.CRLDistributionPoints,Cr.asn1.x509.Extension),Cr.asn1.x509.ExtKeyUsage=function(t){Cr.asn1.x509.ExtKeyUsage.superclass.constructor.call(this,t),this.setPurposeArray=function(t){this.asn1ExtnValue=new Cr.asn1.DERSequence;for(var e=0;e<t.length;e++){var n=new Cr.asn1.DERObjectIdentifier(t[e]);this.asn1ExtnValue.appendASN1Object(n)}},this.getExtnValueHex=function(){return this.asn1ExtnValue.getEncodedHex()},this.oid="2.5.29.37","undefined"!=typeof t&&"undefined"!=typeof t.array&&this.setPurposeArray(t.array)},sr.lang.extend(Cr.asn1.x509.ExtKeyUsage,Cr.asn1.x509.Extension),Cr.asn1.x509.AuthorityKeyIdentifier=function(t){Cr.asn1.x509.AuthorityKeyIdentifier.superclass.constructor.call(this,t),this.asn1KID=null,this.asn1CertIssuer=null,this.asn1CertSN=null,this.getExtnValueHex=function(){var t=new Array;this.asn1KID&&t.push(new Cr.asn1.DERTaggedObject({explicit:!1,tag:"80",obj:this.asn1KID})),this.asn1CertIssuer&&t.push(new Cr.asn1.DERTaggedObject({explicit:!1,tag:"a1",obj:this.asn1CertIssuer})),this.asn1CertSN&&t.push(new Cr.asn1.DERTaggedObject({explicit:!1,tag:"82",obj:this.asn1CertSN}));var e=new Cr.asn1.DERSequence({array:t});return this.asn1ExtnValue=e,this.asn1ExtnValue.getEncodedHex()},this.setKIDByParam=function(t){this.asn1KID=new Cr.asn1.DEROctetString(t)},this.setCertIssuerByParam=function(t){this.asn1CertIssuer=new Cr.asn1.x509.X500Name(t)},this.setCertSNByParam=function(t){this.asn1CertSN=new Cr.asn1.DERInteger(t)},this.oid="2.5.29.35","undefined"!=typeof t&&("undefined"!=typeof t.kid&&this.setKIDByParam(t.kid),"undefined"!=typeof t.issuer&&this.setCertIssuerByParam(t.issuer),"undefined"!=typeof t.sn&&this.setCertSNByParam(t.sn))},sr.lang.extend(Cr.asn1.x509.AuthorityKeyIdentifier,Cr.asn1.x509.Extension),Cr.asn1.x509.CRL=function(t){Cr.asn1.x509.CRL.superclass.constructor.call(this);this.setRsaPrvKeyByPEMandPass=function(t,e){var n=jr.getDecryptedKeyHex(t,e),r=new ve;r.readPrivateKeyFromASN1HexString(n),this.rsaPrvKey=r},this.sign=function(){this.asn1SignatureAlg=this.asn1TBSCertList.asn1SignatureAlg,sig=new Cr.crypto.Signature({alg:"SHA1withRSA",prov:"cryptojs/jsrsa"}),sig.initSign(this.rsaPrvKey),sig.updateHex(this.asn1TBSCertList.getEncodedHex()),this.hexSig=sig.sign(),this.asn1Sig=new Cr.asn1.DERBitString({hex:"00"+this.hexSig});var t=new Cr.asn1.DERSequence({array:[this.asn1TBSCertList,this.asn1SignatureAlg,this.asn1Sig]});this.hTLV=t.getEncodedHex(),this.isModified=!1},this.getEncodedHex=function(){if(0==this.isModified&&null!=this.hTLV)return this.hTLV;throw"not signed yet"},this.getPEMString=function(){var t=this.getEncodedHex(),e=or.enc.Hex.parse(t),n=or.enc.Base64.stringify(e),r=n.replace(/(.{64})/g,"$1\r\n");return"-----BEGIN X509 CRL-----\r\n"+r+"\r\n-----END X509 CRL-----\r\n"},"undefined"!=typeof t&&("undefined"!=typeof t.tbsobj&&(this.asn1TBSCertList=t.tbsobj),"undefined"!=typeof t.rsaprvkey&&(this.rsaPrvKey=t.rsaprvkey),"undefined"!=typeof t.rsaprvpem&&"undefined"!=typeof t.rsaprvpas&&this.setRsaPrvKeyByPEMandPass(t.rsaprvpem,t.rsaprvpas))},sr.lang.extend(Cr.asn1.x509.CRL,Cr.asn1.ASN1Object),Cr.asn1.x509.TBSCertList=function(t){Cr.asn1.x509.TBSCertList.superclass.constructor.call(this);this.setSignatureAlgByParam=function(t){this.asn1SignatureAlg=new Cr.asn1.x509.AlgorithmIdentifier(t)},this.setIssuerByParam=function(t){this.asn1Issuer=new Cr.asn1.x509.X500Name(t)},this.setThisUpdateByParam=function(t){this.asn1ThisUpdate=new Cr.asn1.x509.Time(t)},this.setNextUpdateByParam=function(t){this.asn1NextUpdate=new Cr.asn1.x509.Time(t)},this.addRevokedCert=function(t,e){var n={};void 0!=t&&null!=t&&(n.sn=t),void 0!=e&&null!=e&&(n.time=e);var r=new Cr.asn1.x509.CRLEntry(n);this.aRevokedCert.push(r)},this.getEncodedHex=function(){if(this.asn1Array=new Array,null!=this.asn1Version&&this.asn1Array.push(this.asn1Version),this.asn1Array.push(this.asn1SignatureAlg),this.asn1Array.push(this.asn1Issuer),this.asn1Array.push(this.asn1ThisUpdate),null!=this.asn1NextUpdate&&this.asn1Array.push(this.asn1NextUpdate),this.aRevokedCert.length>0){var t=new Cr.asn1.DERSequence({array:this.aRevokedCert});this.asn1Array.push(t)}var e=new Cr.asn1.DERSequence({array:this.asn1Array});return this.hTLV=e.getEncodedHex(),this.isModified=!1,this.hTLV},this._initialize=function(){this.asn1Version=null,this.asn1SignatureAlg=null,this.asn1Issuer=null,this.asn1ThisUpdate=null,this.asn1NextUpdate=null,this.aRevokedCert=new Array},this._initialize()},sr.lang.extend(Cr.asn1.x509.TBSCertList,Cr.asn1.ASN1Object),Cr.asn1.x509.CRLEntry=function(t){Cr.asn1.x509.CRLEntry.superclass.constructor.call(this);this.setCertSerial=function(t){this.sn=new Cr.asn1.DERInteger(t)},this.setRevocationDate=function(t){this.time=new Cr.asn1.x509.Time(t)},this.getEncodedHex=function(){var t=new Cr.asn1.DERSequence({array:[this.sn,this.time]});return this.TLV=t.getEncodedHex(),this.TLV},"undefined"!=typeof t&&("undefined"!=typeof t.time&&this.setRevocationDate(t.time),"undefined"!=typeof t.sn&&this.setCertSerial(t.sn))},sr.lang.extend(Cr.asn1.x509.CRLEntry,Cr.asn1.ASN1Object),Cr.asn1.x509.X500Name=function(t){if(Cr.asn1.x509.X500Name.superclass.constructor.call(this),this.asn1Array=new Array,this.setByString=function(t){var e=t.split("/");e.shift();for(var n=0;n<e.length;n++)this.asn1Array.push(new Cr.asn1.x509.RDN({str:e[n]}))},this.setByObject=function(t){for(var e in t)if(t.hasOwnProperty(e)){var n=new Cr.asn1.x509.RDN({str:e+"="+t[e]});this.asn1Array?this.asn1Array.push(n):this.asn1Array=[n]}},this.getEncodedHex=function(){if("string"==typeof this.hTLV)return this.hTLV;var t=new Cr.asn1.DERSequence({array:this.asn1Array});return this.hTLV=t.getEncodedHex(),this.hTLV},"undefined"!=typeof t){if("undefined"!=typeof t.str?this.setByString(t.str):"object"==typeof t&&this.setByObject(t),"undefined"!=typeof t.certissuer){var e=new $n;e.hex=$n.pemToHex(t.certissuer),this.hTLV=e.getIssuerHex()}if("undefined"!=typeof t.certsubject){var e=new $n;e.hex=$n.pemToHex(t.certsubject),this.hTLV=e.getSubjectHex()}}},sr.lang.extend(Cr.asn1.x509.X500Name,Cr.asn1.ASN1Object),Cr.asn1.x509.RDN=function(t){Cr.asn1.x509.RDN.superclass.constructor.call(this),this.asn1Array=new Array,this.addByString=function(t){this.asn1Array.push(new Cr.asn1.x509.AttributeTypeAndValue({str:t}))},this.getEncodedHex=function(){var t=new Cr.asn1.DERSet({array:this.asn1Array});return this.TLV=t.getEncodedHex(),this.TLV},"undefined"!=typeof t&&"undefined"!=typeof t.str&&this.addByString(t.str)},sr.lang.extend(Cr.asn1.x509.RDN,Cr.asn1.ASN1Object),Cr.asn1.x509.AttributeTypeAndValue=function(t){Cr.asn1.x509.AttributeTypeAndValue.superclass.constructor.call(this);var e="utf8";this.setByString=function(t){if(!t.match(/^([^=]+)=(.+)$/))throw"malformed attrTypeAndValueStr: "+t;this.setByAttrTypeAndValueStr(RegExp.$1,RegExp.$2)},this.setByAttrTypeAndValueStr=function(t,n){this.typeObj=Cr.asn1.x509.OID.atype2obj(t);var r=e;"C"==t&&(r="prn"),this.valueObj=this.getValueObj(r,n)},this.getValueObj=function(t,e){if("utf8"==t)return new Cr.asn1.DERUTF8String({str:e});if("prn"==t)return new Cr.asn1.DERPrintableString({str:e});if("tel"==t)return new Cr.asn1.DERTeletexString({str:e});if("ia5"==t)return new Cr.asn1.DERIA5String({str:e});throw"unsupported directory string type: type="+t+" value="+e},this.getEncodedHex=function(){var t=new Cr.asn1.DERSequence({array:[this.typeObj,this.valueObj]});return this.TLV=t.getEncodedHex(),this.TLV},"undefined"!=typeof t&&"undefined"!=typeof t.str&&this.setByString(t.str)},sr.lang.extend(Cr.asn1.x509.AttributeTypeAndValue,Cr.asn1.ASN1Object),Cr.asn1.x509.SubjectPublicKeyInfo=function(t){Cr.asn1.x509.SubjectPublicKeyInfo.superclass.constructor.call(this);this.setRSAKey=function(t){if(!ve.prototype.isPrototypeOf(t))throw"argument is not RSAKey instance";this.rsaKey=t;var e=new Cr.asn1.DERInteger({bigint:t.n}),n=new Cr.asn1.DERInteger({int:t.e}),r=new Cr.asn1.DERSequence({array:[e,n]}),i=r.getEncodedHex();this.asn1AlgId=new Cr.asn1.x509.AlgorithmIdentifier({name:"rsaEncryption"}),this.asn1SubjPKey=new Cr.asn1.DERBitString({hex:"00"+i})},this.setRSAPEM=function(t){if(!t.match(/-----BEGIN PUBLIC KEY-----/))throw"key not supported";var e=t;e=e.replace(/^-----[^-]+-----/,""),e=e.replace(/-----[^-]+-----\s*$/,"");var n=e.replace(/\s+/g,""),r=or.enc.Base64.parse(n),i=or.enc.Hex.stringify(r),s=Dn(i),o=s[1],a=o.substr(2),u=Dn(a),h=new ve;h.setPublic(u[0],u[1]),this.setRSAKey(h)},this.getASN1Object=function(){if(null==this.asn1AlgId||null==this.asn1SubjPKey)throw"algId and/or subjPubKey not set";var t=new Cr.asn1.DERSequence({array:[this.asn1AlgId,this.asn1SubjPKey]});return t},this.getEncodedHex=function(){var t=this.getASN1Object();return this.hTLV=t.getEncodedHex(),this.hTLV},this._setRSAKey=function(t){var e=Cr.asn1.ASN1Util.newObject({seq:[{int:{bigint:t.n}},{int:{int:t.e}}]}),n=e.getEncodedHex();this.asn1AlgId=new Cr.asn1.x509.AlgorithmIdentifier({name:"rsaEncryption"}),this.asn1SubjPKey=new Cr.asn1.DERBitString({hex:"00"+n})},this._setEC=function(t){var e=new Cr.asn1.DERObjectIdentifier({name:t.curveName});this.asn1AlgId=new Cr.asn1.x509.AlgorithmIdentifier({name:"ecPublicKey",asn1params:e}),this.asn1SubjPKey=new Cr.asn1.DERBitString({hex:"00"+t.pubKeyHex})},this._setDSA=function(t){var e=new Cr.asn1.ASN1Util.newObject({seq:[{int:{bigint:t.p}},{int:{bigint:t.q}},{int:{bigint:t.g}}]});this.asn1AlgId=new Cr.asn1.x509.AlgorithmIdentifier({name:"dsa",asn1params:e});var n=new Cr.asn1.DERInteger({bigint:t.y});this.asn1SubjPKey=new Cr.asn1.DERBitString({hex:"00"+n.getEncodedHex()})},"undefined"!=typeof t&&("undefined"!=typeof ve&&t instanceof ve?this._setRSAKey(t):"undefined"!=typeof Cr.crypto.ECDSA&&t instanceof Cr.crypto.ECDSA?this._setEC(t):"undefined"!=typeof Cr.crypto.DSA&&t instanceof Cr.crypto.DSA?this._setDSA(t):"undefined"!=typeof t.rsakey?this.setRSAKey(t.rsakey):"undefined"!=typeof t.rsapem&&this.setRSAPEM(t.rsapem))},sr.lang.extend(Cr.asn1.x509.SubjectPublicKeyInfo,Cr.asn1.ASN1Object),Cr.asn1.x509.Time=function(t){Cr.asn1.x509.Time.superclass.constructor.call(this);this.setTimeParams=function(t){this.timeParams=t},this.getEncodedHex=function(){var t=null;return t=null!=this.timeParams?"utc"==this.type?new Cr.asn1.DERUTCTime(this.timeParams):new Cr.asn1.DERGeneralizedTime(this.timeParams):"utc"==this.type?new Cr.asn1.DERUTCTime:new Cr.asn1.DERGeneralizedTime,this.TLV=t.getEncodedHex(),this.TLV},this.type="utc","undefined"!=typeof t&&("undefined"!=typeof t.type?this.type=t.type:"undefined"!=typeof t.str&&(t.str.match(/^[0-9]{12}Z$/)&&(this.type="utc"),t.str.match(/^[0-9]{14}Z$/)&&(this.type="gen")),this.timeParams=t)},sr.lang.extend(Cr.asn1.x509.Time,Cr.asn1.ASN1Object),Cr.asn1.x509.AlgorithmIdentifier=function(t){Cr.asn1.x509.AlgorithmIdentifier.superclass.constructor.call(this);this.getEncodedHex=function(){if(null==this.nameAlg&&null==this.asn1Alg)throw"algorithm not specified";null!=this.nameAlg&&null==this.asn1Alg&&(this.asn1Alg=Cr.asn1.x509.OID.name2obj(this.nameAlg));var t=[this.asn1Alg];this.paramEmpty||t.push(this.asn1Params);var e=new Cr.asn1.DERSequence({array:t});return this.hTLV=e.getEncodedHex(),this.hTLV},"undefined"!=typeof t&&("undefined"!=typeof t.name&&(this.nameAlg=t.name),"undefined"!=typeof t.asn1params&&(this.asn1Params=t.asn1params),"undefined"!=typeof t.paramempty&&(this.paramEmpty=t.paramempty)),null==this.asn1Params&&(this.asn1Params=new Cr.asn1.DERNull)},sr.lang.extend(Cr.asn1.x509.AlgorithmIdentifier,Cr.asn1.ASN1Object),Cr.asn1.x509.GeneralName=function(t){Cr.asn1.x509.GeneralName.superclass.constructor.call(this);var e={rfc822:"81",dns:"82",dn:"a4",uri:"86"};this.explicit=!1,this.setByParam=function(t){var n=null;if("undefined"!=typeof t){if("undefined"!=typeof t.rfc822&&(this.type="rfc822",n=new Cr.asn1.DERIA5String({str:t[this.type]})),"undefined"!=typeof t.dns&&(this.type="dns",n=new Cr.asn1.DERIA5String({str:t[this.type]})),"undefined"!=typeof t.uri&&(this.type="uri",n=new Cr.asn1.DERIA5String({str:t[this.type]})),"undefined"!=typeof t.certissuer){this.type="dn",this.explicit=!0;var r=t.certissuer,i=null;if(r.match(/^[0-9A-Fa-f]+$/),r.indexOf("-----BEGIN ")!=-1&&(i=$n.pemToHex(r)),null==i)throw"certissuer param not cert";var s=new $n;s.hex=i;var o=s.getIssuerHex();n=new Cr.asn1.ASN1Object,n.hTLV=o}if("undefined"!=typeof t.certsubj){this.type="dn",this.explicit=!0;var r=t.certsubj,i=null;if(r.match(/^[0-9A-Fa-f]+$/),r.indexOf("-----BEGIN ")!=-1&&(i=$n.pemToHex(r)),null==i)throw"certsubj param not cert";var s=new $n;s.hex=i;var o=s.getSubjectHex();n=new Cr.asn1.ASN1Object,n.hTLV=o}if(null==this.type)throw"unsupported type in params="+t;this.asn1Obj=new Cr.asn1.DERTaggedObject({explicit:this.explicit,tag:e[this.type],obj:n})}},this.getEncodedHex=function(){return this.asn1Obj.getEncodedHex()},"undefined"!=typeof t&&this.setByParam(t)},sr.lang.extend(Cr.asn1.x509.GeneralName,Cr.asn1.ASN1Object),Cr.asn1.x509.GeneralNames=function(t){Cr.asn1.x509.GeneralNames.superclass.constructor.call(this);this.setByParamArray=function(t){for(var e=0;e<t.length;e++){var n=new Cr.asn1.x509.GeneralName(t[e]);this.asn1Array.push(n)}},this.getEncodedHex=function(){var t=new Cr.asn1.DERSequence({array:this.asn1Array});return t.getEncodedHex()},this.asn1Array=new Array,"undefined"!=typeof t&&this.setByParamArray(t)},sr.lang.extend(Cr.asn1.x509.GeneralNames,Cr.asn1.ASN1Object),Cr.asn1.x509.DistributionPointName=function(t){Cr.asn1.x509.DistributionPointName.superclass.constructor.call(this);if(this.getEncodedHex=function(){if("full"!=this.type)throw"currently type shall be 'full': "+this.type;return this.asn1Obj=new Cr.asn1.DERTaggedObject({explicit:!1,tag:this.tag,obj:this.asn1V}),this.hTLV=this.asn1Obj.getEncodedHex(),this.hTLV},"undefined"!=typeof t){if(!Cr.asn1.x509.GeneralNames.prototype.isPrototypeOf(t))throw"This class supports GeneralNames only as argument";this.type="full",this.tag="a0",this.asn1V=t}},sr.lang.extend(Cr.asn1.x509.DistributionPointName,Cr.asn1.ASN1Object),Cr.asn1.x509.DistributionPoint=function(t){Cr.asn1.x509.DistributionPoint.superclass.constructor.call(this);this.getEncodedHex=function(){var t=new Cr.asn1.DERSequence;if(null!=this.asn1DP){var e=new Cr.asn1.DERTaggedObject({explicit:!0,tag:"a0",obj:this.asn1DP});t.appendASN1Object(e)}return this.hTLV=t.getEncodedHex(),this.hTLV},"undefined"!=typeof t&&"undefined"!=typeof t.dpobj&&(this.asn1DP=t.dpobj)},sr.lang.extend(Cr.asn1.x509.DistributionPoint,Cr.asn1.ASN1Object),Cr.asn1.x509.OID=new function(t){this.atype2oidList={C:"2.5.4.6",O:"2.5.4.10",OU:"2.5.4.11",ST:"2.5.4.8",L:"2.5.4.7",CN:"2.5.4.3",SN:"2.5.4.4",DN:"2.5.4.49",DC:"0.9.2342.19200300.100.1.25"},this.name2oidList={sha1:"1.3.14.3.2.26",sha256:"2.16.840.1.101.3.4.2.1",sha384:"2.16.840.1.101.3.4.2.2",sha512:"2.16.840.1.101.3.4.2.3",sha224:"2.16.840.1.101.3.4.2.4",md5:"1.2.840.113549.2.5",md2:"1.3.14.7.2.2.1",ripemd160:"1.3.36.3.2.1",MD2withRSA:"1.2.840.113549.1.1.2",MD4withRSA:"1.2.840.113549.1.1.3",MD5withRSA:"1.2.840.113549.1.1.4",SHA1withRSA:"1.2.840.113549.1.1.5",SHA224withRSA:"1.2.840.113549.1.1.14",SHA256withRSA:"1.2.840.113549.1.1.11",SHA384withRSA:"1.2.840.113549.1.1.12",SHA512withRSA:"1.2.840.113549.1.1.13",SHA1withECDSA:"1.2.840.10045.4.1",SHA224withECDSA:"1.2.840.10045.4.3.1",SHA256withECDSA:"1.2.840.10045.4.3.2",SHA384withECDSA:"1.2.840.10045.4.3.3",SHA512withECDSA:"1.2.840.10045.4.3.4",dsa:"1.2.840.10040.4.1",SHA1withDSA:"1.2.840.10040.4.3",SHA224withDSA:"2.16.840.1.101.3.4.3.1",SHA256withDSA:"2.16.840.1.101.3.4.3.2",rsaEncryption:"1.2.840.113549.1.1.1",countryName:"2.5.4.6",organization:"2.5.4.10",organizationalUnit:"2.5.4.11",stateOrProvinceName:"2.5.4.8",locality:"2.5.4.7",commonName:"2.5.4.3",subjectKeyIdentifier:"2.5.29.14",keyUsage:"2.5.29.15",subjectAltName:"2.5.29.17",basicConstraints:"2.5.29.19",nameConstraints:"2.5.29.30",cRLDistributionPoints:"2.5.29.31",certificatePolicies:"2.5.29.32",authorityKeyIdentifier:"2.5.29.35",policyConstraints:"2.5.29.36",extKeyUsage:"2.5.29.37",authorityInfoAccess:"1.3.6.1.5.5.7.1.1",anyExtendedKeyUsage:"2.5.29.37.0",serverAuth:"1.3.6.1.5.5.7.3.1",clientAuth:"1.3.6.1.5.5.7.3.2",codeSigning:"1.3.6.1.5.5.7.3.3",emailProtection:"1.3.6.1.5.5.7.3.4",timeStamping:"1.3.6.1.5.5.7.3.8",ocspSigning:"1.3.6.1.5.5.7.3.9",ecPublicKey:"1.2.840.10045.2.1",secp256r1:"1.2.840.10045.3.1.7",secp256k1:"1.3.132.0.10",secp384r1:"1.3.132.0.34",pkcs5PBES2:"1.2.840.113549.1.5.13",pkcs5PBKDF2:"1.2.840.113549.1.5.12","des-EDE3-CBC":"1.2.840.113549.3.7",data:"1.2.840.113549.1.7.1","signed-data":"1.2.840.113549.1.7.2","enveloped-data":"1.2.840.113549.1.7.3","digested-data":"1.2.840.113549.1.7.5","encrypted-data":"1.2.840.113549.1.7.6","authenticated-data":"1.2.840.113549.1.9.16.1.2",tstinfo:"1.2.840.113549.1.9.16.1.4"},this.objCache={},this.name2obj=function(t){if("undefined"!=typeof this.objCache[t])return this.objCache[t];if("undefined"==typeof this.name2oidList[t])throw"Name of ObjectIdentifier not defined: "+t;var e=this.name2oidList[t],n=new Cr.asn1.DERObjectIdentifier({oid:e});return this.objCache[t]=n,n},this.atype2obj=function(t){if("undefined"!=typeof this.objCache[t])return this.objCache[t];if("undefined"==typeof this.atype2oidList[t])throw"AttributeType name undefined: "+t;var e=this.atype2oidList[t],n=new Cr.asn1.DERObjectIdentifier({oid:e});return this.objCache[t]=n,n}},Cr.asn1.x509.OID.oid2name=function(t){var e=Cr.asn1.x509.OID.name2oidList;for(var n in e)if(e[n]==t)return n;return""},Cr.asn1.x509.OID.name2oid=function(t){var e=Cr.asn1.x509.OID.name2oidList;return void 0===e[t]?"":e[t]},Cr.asn1.x509.X509Util=new function(){this.getPKCS8PubKeyPEMfromRSAKey=function(t){var e=null,n=Cr.asn1.ASN1Util.bigIntToMinTwosComplementsHex(t.n),r=Cr.asn1.ASN1Util.integerToByteHex(t.e),i=new Cr.asn1.DERInteger({hex:n}),s=new Cr.asn1.DERInteger({hex:r}),o=new Cr.asn1.DERSequence({array:[i,s]}),a=o.getEncodedHex(),u=new Cr.asn1.x509.AlgorithmIdentifier({name:"rsaEncryption"}),h=new Cr.asn1.DERBitString({hex:"00"+a}),c=new Cr.asn1.DERSequence({array:[u,h]}),f=c.getEncodedHex(),e=Cr.asn1.ASN1Util.getPEMStringFromHex(f,"PUBLIC KEY");return e}},Cr.asn1.x509.X509Util.newCertPEM=function(t){var e=Cr.asn1.x509,n=new e.TBSCertificate;if(void 0===t.serial)throw"serial number undefined.";if(n.setSerialNumberByParam(t.serial),"string"!=typeof t.sigalg.name)throw"unproper signature algorithm name";if(n.setSignatureAlgByParam(t.sigalg),void 0===t.issuer)throw"issuer name undefined.";if(n.setIssuerByParam(t.issuer),void 0===t.notbefore)throw"notbefore undefined.";if(n.setNotBeforeByParam(t.notbefore),void 0===t.notafter)throw"notafter undefined.";if(n.setNotAfterByParam(t.notafter),void 0===t.subject)throw"subject name undefined.";if(n.setSubjectByParam(t.subject),void 0===t.sbjpubkey)throw"subject public key undefined.";if(n.setSubjectPublicKeyByGetKey(t.sbjpubkey),void 0!==t.ext&&void 0!==t.ext.length)for(var r=0;r<t.ext.length;r++)for(key in t.ext[r])n.appendExtensionByName(key,t.ext[r][key]);if(void 0===t.cakey&&void 0===t.sighex)throw"param cakey and sighex undefined.";var i=null,s=null;return t.cakey&&(i=Rr.getKey.apply(null,t.cakey),s=new e.Certificate({tbscertobj:n,prvkeyobj:i}),s.sign()),t.sighex&&(s=new e.Certificate({tbscertobj:n}),s.setSignatureHex(t.sighex)),s.getPEMString()},/*! asn1cms-1.0.2.js (c) 2013-2014 Kenji Urushima | kjur.github.com/jsrsasign/license
		 */
	"undefined"!=typeof Cr&&Cr||(Cr={}),"undefined"!=typeof Cr.asn1&&Cr.asn1||(Cr.asn1={}),"undefined"!=typeof Cr.asn1.cms&&Cr.asn1.cms||(Cr.asn1.cms={}),Cr.asn1.cms.Attribute=function(t){Cr.asn1.cms.Attribute.superclass.constructor.call(this);this.getEncodedHex=function(){var t,e,n;t=new Cr.asn1.DERObjectIdentifier({oid:this.attrTypeOid}),e=new Cr.asn1.DERSet({array:this.valueList});try{e.getEncodedHex()}catch(t){throw"fail valueSet.getEncodedHex in Attribute(1)/"+t}n=new Cr.asn1.DERSequence({array:[t,e]});try{this.hTLV=n.getEncodedHex()}catch(t){throw"failed seq.getEncodedHex in Attribute(2)/"+t}return this.hTLV}},sr.lang.extend(Cr.asn1.cms.Attribute,Cr.asn1.ASN1Object),Cr.asn1.cms.ContentType=function(t){Cr.asn1.cms.ContentType.superclass.constructor.call(this),this.attrTypeOid="1.2.840.113549.1.9.3";var e=null;if("undefined"!=typeof t){var e=new Cr.asn1.DERObjectIdentifier(t);this.valueList=[e]}},sr.lang.extend(Cr.asn1.cms.ContentType,Cr.asn1.cms.Attribute),Cr.asn1.cms.MessageDigest=function(t){if(Cr.asn1.cms.MessageDigest.superclass.constructor.call(this),this.attrTypeOid="1.2.840.113549.1.9.4","undefined"!=typeof t)if(t.eciObj instanceof Cr.asn1.cms.EncapsulatedContentInfo&&"string"==typeof t.hashAlg){var e=t.eciObj.eContentValueHex,n=t.hashAlg,r=Cr.crypto.Util.hashHex(e,n),i=new Cr.asn1.DEROctetString({hex:r});i.getEncodedHex(),this.valueList=[i]}else{var i=new Cr.asn1.DEROctetString(t);i.getEncodedHex(),this.valueList=[i]}},sr.lang.extend(Cr.asn1.cms.MessageDigest,Cr.asn1.cms.Attribute),Cr.asn1.cms.SigningTime=function(t){if(Cr.asn1.cms.SigningTime.superclass.constructor.call(this),this.attrTypeOid="1.2.840.113549.1.9.5","undefined"!=typeof t){var e=new Cr.asn1.x509.Time(t);try{e.getEncodedHex()}catch(t){throw"SigningTime.getEncodedHex() failed/"+t}this.valueList=[e]}},sr.lang.extend(Cr.asn1.cms.SigningTime,Cr.asn1.cms.Attribute),Cr.asn1.cms.SigningCertificate=function(t){Cr.asn1.cms.SigningCertificate.superclass.constructor.call(this),this.attrTypeOid="1.2.840.113549.1.9.16.2.12";var e=Cr.asn1,n=Cr.asn1.cms,r=Cr.crypto;this.setCerts=function(t){for(var i=[],s=0;s<t.length;s++){var o=Rr.getHexFromPEM(t[s]),a=r.Util.hashHex(o,"sha1"),u=new e.DEROctetString({hex:a});u.getEncodedHex();var h=new n.IssuerAndSerialNumber({cert:t[s]});h.getEncodedHex();var c=new e.DERSequence({array:[u,h]});c.getEncodedHex(),i.push(c)}var f=new e.DERSequence({array:i});f.getEncodedHex(),this.valueList=[f]},"undefined"!=typeof t&&"object"==typeof t.array&&this.setCerts(t.array)},sr.lang.extend(Cr.asn1.cms.SigningCertificate,Cr.asn1.cms.Attribute),Cr.asn1.cms.SigningCertificateV2=function(t){Cr.asn1.cms.SigningCertificateV2.superclass.constructor.call(this),this.attrTypeOid="1.2.840.113549.1.9.16.2.47";var e=Cr.asn1,n=Cr.asn1.x509,r=Cr.asn1.cms,i=Cr.crypto;if(this.setCerts=function(t,s){for(var o=[],a=0;a<t.length;a++){var u=Rr.getHexFromPEM(t[a]),h=[];"sha256"!=s&&h.push(new n.AlgorithmIdentifier({name:s}));var c=i.Util.hashHex(u,s),f=new e.DEROctetString({hex:c});f.getEncodedHex(),h.push(f);var l=new r.IssuerAndSerialNumber({cert:t[a]});l.getEncodedHex(),h.push(l);var d=new e.DERSequence({array:h});d.getEncodedHex(),o.push(d)}var p=new e.DERSequence({array:o});p.getEncodedHex(),this.valueList=[p]},"undefined"!=typeof t&&"object"==typeof t.array){var s="sha256";"string"==typeof t.hashAlg&&(s=t.hashAlg),this.setCerts(t.array,s)}},sr.lang.extend(Cr.asn1.cms.SigningCertificateV2,Cr.asn1.cms.Attribute),Cr.asn1.cms.IssuerAndSerialNumber=function(t){Cr.asn1.cms.IssuerAndSerialNumber.superclass.constructor.call(this);var e=Cr.asn1,n=e.x509;this.setByCertPEM=function(t){var r=Rr.getHexFromPEM(t),i=new $n;i.hex=r;var s=i.getIssuerHex();this.dIssuer=new n.X500Name,this.dIssuer.hTLV=s;var o=i.getSerialNumberHex();this.dSerial=new e.DERInteger({hex:o})},this.getEncodedHex=function(){var t=new Cr.asn1.DERSequence({array:[this.dIssuer,this.dSerial]});return this.hTLV=t.getEncodedHex(),this.hTLV},"undefined"!=typeof t&&("string"==typeof t&&t.indexOf("-----BEGIN ")!=-1&&this.setByCertPEM(t),t.issuer&&t.serial&&(t.issuer instanceof Cr.asn1.x509.X500Name?this.dIssuer=t.issuer:this.dIssuer=new Cr.asn1.x509.X500Name(t.issuer),t.serial instanceof Cr.asn1.DERInteger?this.dSerial=t.serial:this.dSerial=new Cr.asn1.DERInteger(t.serial)),"string"==typeof t.cert&&this.setByCertPEM(t.cert))},sr.lang.extend(Cr.asn1.cms.IssuerAndSerialNumber,Cr.asn1.ASN1Object),Cr.asn1.cms.AttributeList=function(t){Cr.asn1.cms.AttributeList.superclass.constructor.call(this),this.list=new Array,this.sortFlag=!0,this.add=function(t){t instanceof Cr.asn1.cms.Attribute&&this.list.push(t)},this.length=function(){return this.list.length},this.clear=function(){this.list=new Array,this.hTLV=null,this.hV=null},this.getEncodedHex=function(){if("string"==typeof this.hTLV)return this.hTLV;var t=new Cr.asn1.DERSet({array:this.list,sortflag:this.sortFlag});return this.hTLV=t.getEncodedHex(),this.hTLV},"undefined"!=typeof t&&"undefined"!=typeof t.sortflag&&0==t.sortflag&&(this.sortFlag=!1)},sr.lang.extend(Cr.asn1.cms.AttributeList,Cr.asn1.ASN1Object),Cr.asn1.cms.SignerInfo=function(t){Cr.asn1.cms.SignerInfo.superclass.constructor.call(this);var e=Cr.asn1,n=Cr.asn1.cms,r=Cr.asn1.x509;this.dCMSVersion=new e.DERInteger({int:1}),this.dSignerIdentifier=null,this.dDigestAlgorithm=null,this.dSignedAttrs=new n.AttributeList,this.dSigAlg=null,this.dSig=null,this.dUnsignedAttrs=new n.AttributeList,this.setSignerIdentifier=function(t){if("string"==typeof t&&t.indexOf("CERTIFICATE")!=-1&&t.indexOf("BEGIN")!=-1&&t.indexOf("END")!=-1){this.dSignerIdentifier=new n.IssuerAndSerialNumber({cert:t})}},this.setForContentAndHash=function(t){"undefined"!=typeof t&&(t.eciObj instanceof Cr.asn1.cms.EncapsulatedContentInfo&&(this.dSignedAttrs.add(new n.ContentType({oid:"1.2.840.113549.1.7.1"})),this.dSignedAttrs.add(new n.MessageDigest({eciObj:t.eciObj,hashAlg:t.hashAlg}))),"undefined"!=typeof t.sdObj&&t.sdObj instanceof Cr.asn1.cms.SignedData&&t.sdObj.digestAlgNameList.join(":").indexOf(t.hashAlg)==-1&&t.sdObj.digestAlgNameList.push(t.hashAlg),"string"==typeof t.hashAlg&&(this.dDigestAlgorithm=new r.AlgorithmIdentifier({name:t.hashAlg})))},this.sign=function(t,n){this.dSigAlg=new r.AlgorithmIdentifier({name:n});var i=this.dSignedAttrs.getEncodedHex(),s=Rr.getKey(t),o=new Cr.crypto.Signature({alg:n});o.init(s),o.updateHex(i);var a=o.sign();this.dSig=new e.DEROctetString({hex:a})},this.addUnsigned=function(t){this.hTLV=null,this.dUnsignedAttrs.hTLV=null,this.dUnsignedAttrs.add(t)},this.getEncodedHex=function(){if(this.dSignedAttrs instanceof Cr.asn1.cms.AttributeList&&0==this.dSignedAttrs.length())throw"SignedAttrs length = 0 (empty)";var t=new e.DERTaggedObject({obj:this.dSignedAttrs,tag:"a0",explicit:!1}),n=null;this.dUnsignedAttrs.length()>0&&(n=new e.DERTaggedObject({obj:this.dUnsignedAttrs,tag:"a1",explicit:!1}));var r=[this.dCMSVersion,this.dSignerIdentifier,this.dDigestAlgorithm,t,this.dSigAlg,this.dSig];null!=n&&r.push(n);var i=new e.DERSequence({array:r});return this.hTLV=i.getEncodedHex(),this.hTLV}},sr.lang.extend(Cr.asn1.cms.SignerInfo,Cr.asn1.ASN1Object),Cr.asn1.cms.EncapsulatedContentInfo=function(t){Cr.asn1.cms.EncapsulatedContentInfo.superclass.constructor.call(this);var e=Cr.asn1;Cr.asn1.cms,Cr.asn1.x509;this.dEContentType=new e.DERObjectIdentifier({name:"data"}),this.dEContent=null,this.isDetached=!1,this.eContentValueHex=null,this.setContentType=function(t){t.match(/^[0-2][.][0-9.]+$/)?this.dEContentType=new e.DERObjectIdentifier({oid:t}):this.dEContentType=new e.DERObjectIdentifier({name:t})},this.setContentValue=function(t){"undefined"!=typeof t&&("string"==typeof t.hex?this.eContentValueHex=t.hex:"string"==typeof t.str&&(this.eContentValueHex=mn(t.str)))},this.setContentValueHex=function(t){this.eContentValueHex=t},this.setContentValueStr=function(t){this.eContentValueHex=mn(t)},this.getEncodedHex=function(){if("string"!=typeof this.eContentValueHex)throw"eContentValue not yet set";var t=new e.DEROctetString({hex:this.eContentValueHex});this.dEContent=new e.DERTaggedObject({obj:t,tag:"a0",explicit:!0});var n=[this.dEContentType];this.isDetached||n.push(this.dEContent);var r=new e.DERSequence({array:n});return this.hTLV=r.getEncodedHex(),this.hTLV}},sr.lang.extend(Cr.asn1.cms.EncapsulatedContentInfo,Cr.asn1.ASN1Object),Cr.asn1.cms.ContentInfo=function(t){Cr.asn1.cms.ContentInfo.superclass.constructor.call(this);var e=Cr.asn1,n=(Cr.asn1.cms,Cr.asn1.x509);this.dContentType=null,this.dContent=null,this.setContentType=function(t){"string"==typeof t&&(this.dContentType=n.OID.name2obj(t))},this.getEncodedHex=function(){var t=new e.DERTaggedObject({obj:this.dContent,tag:"a0",explicit:!0}),n=new e.DERSequence({array:[this.dContentType,t]});return this.hTLV=n.getEncodedHex(),this.hTLV},"undefined"!=typeof t&&(t.type&&this.setContentType(t.type),t.obj&&t.obj instanceof e.ASN1Object&&(this.dContent=t.obj))},sr.lang.extend(Cr.asn1.cms.ContentInfo,Cr.asn1.ASN1Object),Cr.asn1.cms.SignedData=function(t){Cr.asn1.cms.SignedData.superclass.constructor.call(this);var e=Cr.asn1,n=Cr.asn1.cms,r=Cr.asn1.x509;this.dCMSVersion=new e.DERInteger({int:1}),this.dDigestAlgs=null,this.digestAlgNameList=[],this.dEncapContentInfo=new n.EncapsulatedContentInfo,this.dCerts=null,this.certificateList=[],this.crlList=[],this.signerInfoList=[new n.SignerInfo],this.addCertificatesByPEM=function(t){var n=Rr.getHexFromPEM(t),r=new e.ASN1Object;r.hTLV=n,this.certificateList.push(r)},this.getEncodedHex=function(){if("string"==typeof this.hTLV)return this.hTLV;if(null==this.dDigestAlgs){for(var t=[],n=0;n<this.digestAlgNameList.length;n++){var i=this.digestAlgNameList[n],s=new r.AlgorithmIdentifier({name:i});t.push(s)}this.dDigestAlgs=new e.DERSet({array:t})}var o=[this.dCMSVersion,this.dDigestAlgs,this.dEncapContentInfo];if(null==this.dCerts&&this.certificateList.length>0){var a=new e.DERSet({array:this.certificateList});this.dCerts=new e.DERTaggedObject({obj:a,tag:"a0",explicit:!1})}null!=this.dCerts&&o.push(this.dCerts);var u=new e.DERSet({array:this.signerInfoList});o.push(u);var h=new e.DERSequence({array:o});return this.hTLV=h.getEncodedHex(),this.hTLV},this.getContentInfo=function(){this.getEncodedHex();var t=new n.ContentInfo({type:"signed-data",obj:this});return t},this.getContentInfoEncodedHex=function(){var t=this.getContentInfo(),e=t.getEncodedHex();return e},this.getPEM=function(){var t=this.getContentInfoEncodedHex(),n=e.ASN1Util.getPEMStringFromHex(t,"CMS");return n}},sr.lang.extend(Cr.asn1.cms.SignedData,Cr.asn1.ASN1Object),Cr.asn1.cms.CMSUtil=new function(){},Cr.asn1.cms.CMSUtil.newSignedData=function(t){var e=Cr.asn1.cms,n=Cr.asn1.cades,r=new e.SignedData;if(r.dEncapContentInfo.setContentValue(t.content),"object"==typeof t.certs)for(var i=0;i<t.certs.length;i++)r.addCertificatesByPEM(t.certs[i]);r.signerInfoList=[];for(var i=0;i<t.signerInfos.length;i++){var s=t.signerInfos[i],o=new e.SignerInfo;o.setSignerIdentifier(s.signerCert),o.setForContentAndHash({sdObj:r,eciObj:r.dEncapContentInfo,hashAlg:s.hashAlg});for(attrName in s.sAttr){var a=s.sAttr[attrName];if("SigningTime"==attrName){var u=new e.SigningTime(a);o.dSignedAttrs.add(u)}if("SigningCertificate"==attrName){var u=new e.SigningCertificate(a);o.dSignedAttrs.add(u)}if("SigningCertificateV2"==attrName){var u=new e.SigningCertificateV2(a);o.dSignedAttrs.add(u)}if("SignaturePolicyIdentifier"==attrName){var u=new n.SignaturePolicyIdentifier(a);o.dSignedAttrs.add(u)}}o.sign(s.signerPrvKey,s.sigAlg),r.signerInfoList.push(o)}return r},/*! asn1tsp-1.0.1.js (c) 2014 Kenji Urushima | kjur.github.com/jsrsasign/license
		 */
	"undefined"!=typeof Cr&&Cr||(Cr={}),"undefined"!=typeof Cr.asn1&&Cr.asn1||(Cr.asn1={}),"undefined"!=typeof Cr.asn1.tsp&&Cr.asn1.tsp||(Cr.asn1.tsp={}),Cr.asn1.tsp.Accuracy=function(t){Cr.asn1.tsp.Accuracy.superclass.constructor.call(this);var e=Cr.asn1;this.seconds=null,this.millis=null,this.micros=null,this.getEncodedHex=function(){var t=null,n=null,r=null,i=[];if(null!=this.seconds&&(t=new e.DERInteger({int:this.seconds}),i.push(t)),null!=this.millis){var s=new e.DERInteger({int:this.millis});n=new e.DERTaggedObject({obj:s,tag:"80",explicit:!1}),i.push(n)}if(null!=this.micros){var o=new e.DERInteger({int:this.micros});r=new e.DERTaggedObject({obj:o,tag:"81",explicit:!1}),i.push(r)}var a=new e.DERSequence({array:i});return this.hTLV=a.getEncodedHex(),this.hTLV},"undefined"!=typeof t&&("number"==typeof t.seconds&&(this.seconds=t.seconds),"number"==typeof t.millis&&(this.millis=t.millis),"number"==typeof t.micros&&(this.micros=t.micros))},sr.lang.extend(Cr.asn1.tsp.Accuracy,Cr.asn1.ASN1Object),Cr.asn1.tsp.MessageImprint=function(t){Cr.asn1.tsp.MessageImprint.superclass.constructor.call(this);var e=Cr.asn1,n=Cr.asn1.x509;this.dHashAlg=null,this.dHashValue=null,this.getEncodedHex=function(){if("string"==typeof this.hTLV)return this.hTLV;var t=new e.DERSequence({array:[this.dHashAlg,this.dHashValue]});return t.getEncodedHex()},"undefined"!=typeof t&&("string"==typeof t.hashAlg&&(this.dHashAlg=new n.AlgorithmIdentifier({name:t.hashAlg})),"string"==typeof t.hashValue&&(this.dHashValue=new e.DEROctetString({hex:t.hashValue})))},sr.lang.extend(Cr.asn1.tsp.MessageImprint,Cr.asn1.ASN1Object),Cr.asn1.tsp.TimeStampReq=function(t){Cr.asn1.tsp.TimeStampReq.superclass.constructor.call(this);var e=Cr.asn1,n=Cr.asn1.tsp;this.dVersion=new e.DERInteger({int:1}),this.dMessageImprint=null,this.dPolicy=null,this.dNonce=null,this.certReq=!0,this.setMessageImprint=function(t){return t instanceof Cr.asn1.tsp.MessageImprint?void(this.dMessageImprint=t):void("object"==typeof t&&(this.dMessageImprint=new n.MessageImprint(t)))},this.getEncodedHex=function(){if(null==this.dMessageImprint)throw"messageImprint shall be specified";var t=[this.dVersion,this.dMessageImprint];null!=this.dPolicy&&t.push(this.dPolicy),null!=this.dNonce&&t.push(this.dNonce),this.certReq&&t.push(new e.DERBoolean);var n=new e.DERSequence({array:t});return this.hTLV=n.getEncodedHex(),this.hTLV},"undefined"!=typeof t&&("object"==typeof t.mi&&this.setMessageImprint(t.mi),"object"==typeof t.policy&&(this.dPolicy=new e.DERObjectIdentifier(t.policy)),"object"==typeof t.nonce&&(this.dNonce=new e.DERInteger(t.nonce)),"boolean"==typeof t.certreq&&(this.certReq=t.certreq))},sr.lang.extend(Cr.asn1.tsp.TimeStampReq,Cr.asn1.ASN1Object),Cr.asn1.tsp.TSTInfo=function(t){Cr.asn1.tsp.TSTInfo.superclass.constructor.call(this);var e=Cr.asn1,n=Cr.asn1.x509,r=Cr.asn1.tsp;if(this.dVersion=new e.DERInteger({int:1}),this.dPolicy=null,this.dMessageImprint=null,this.dSerialNumber=null,this.dGenTime=null,this.dAccuracy=null,this.dOrdering=null,this.dNonce=null,this.dTsa=null,this.getEncodedHex=function(){var t=[this.dVersion];if(null==this.dPolicy)throw"policy shall be specified.";if(t.push(this.dPolicy),null==this.dMessageImprint)throw"messageImprint shall be specified.";if(t.push(this.dMessageImprint),null==this.dSerialNumber)throw"serialNumber shall be specified.";if(t.push(this.dSerialNumber),null==this.dGenTime)throw"genTime shall be specified.";t.push(this.dGenTime),null!=this.dAccuracy&&t.push(this.dAccuracy),null!=this.dOrdering&&t.push(this.dOrdering),null!=this.dNonce&&t.push(this.dNonce),null!=this.dTsa&&t.push(this.dTsa);var n=new e.DERSequence({array:t});return this.hTLV=n.getEncodedHex(),this.hTLV},"undefined"!=typeof t){if("string"==typeof t.policy){if(!t.policy.match(/^[0-9.]+$/))throw"policy shall be oid like 0.1.4.134";this.dPolicy=new e.DERObjectIdentifier({oid:t.policy})}"undefined"!=typeof t.messageImprint&&(this.dMessageImprint=new r.MessageImprint(t.messageImprint)),"undefined"!=typeof t.serialNumber&&(this.dSerialNumber=new e.DERInteger(t.serialNumber)),"undefined"!=typeof t.genTime&&(this.dGenTime=new e.DERGeneralizedTime(t.genTime)),"undefind"!=typeof t.accuracy&&(this.dAccuracy=new r.Accuracy(t.accuracy)),"undefined"!=typeof t.ordering&&1==t.ordering&&(this.dOrdering=new e.DERBoolean),"undefined"!=typeof t.nonce&&(this.dNonce=new e.DERInteger(t.nonce)),"undefined"!=typeof t.tsa&&(this.dTsa=new n.X500Name(t.tsa))}},sr.lang.extend(Cr.asn1.tsp.TSTInfo,Cr.asn1.ASN1Object),Cr.asn1.tsp.TimeStampResp=function(t){Cr.asn1.tsp.TimeStampResp.superclass.constructor.call(this);var e=Cr.asn1,n=Cr.asn1.tsp;this.dStatus=null,this.dTST=null,this.getEncodedHex=function(){if(null==this.dStatus)throw"status shall be specified";var t=[this.dStatus];null!=this.dTST&&t.push(this.dTST);var n=new e.DERSequence({array:t});return this.hTLV=n.getEncodedHex(),this.hTLV},"undefined"!=typeof t&&("object"==typeof t.status&&(this.dStatus=new n.PKIStatusInfo(t.status)),"undefined"!=typeof t.tst&&t.tst instanceof Cr.asn1.ASN1Object&&(this.dTST=t.tst.getContentInfo()))},sr.lang.extend(Cr.asn1.tsp.TimeStampResp,Cr.asn1.ASN1Object),Cr.asn1.tsp.PKIStatusInfo=function(t){Cr.asn1.tsp.PKIStatusInfo.superclass.constructor.call(this);var e=Cr.asn1,n=Cr.asn1.tsp;this.dStatus=null,this.dStatusString=null,this.dFailureInfo=null,this.getEncodedHex=function(){if(null==this.dStatus)throw"status shall be specified";var t=[this.dStatus];null!=this.dStatusString&&t.push(this.dStatusString),null!=this.dFailureInfo&&t.push(this.dFailureInfo);var n=new e.DERSequence({array:t});return this.hTLV=n.getEncodedHex(),this.hTLV},"undefined"!=typeof t&&("object"==typeof t.status&&(this.dStatus=new n.PKIStatus(t.status)),"object"==typeof t.statstr&&(this.dStatusString=new n.PKIFreeText({array:t.statstr})),"object"==typeof t.failinfo&&(this.dFailureInfo=new n.PKIFailureInfo(t.failinfo)))},sr.lang.extend(Cr.asn1.tsp.PKIStatusInfo,Cr.asn1.ASN1Object),Cr.asn1.tsp.PKIStatus=function(t){Cr.asn1.tsp.PKIStatus.superclass.constructor.call(this);var e=Cr.asn1,n=Cr.asn1.tsp;if(this.getEncodedHex=function(){return this.hTLV=this.dStatus.getEncodedHex(),this.hTLV},"undefined"!=typeof t)if("undefined"!=typeof t.name){var r=n.PKIStatus.valueList;if("undefined"==typeof r[t.name])throw"name undefined: "+t.name;this.dStatus=new e.DERInteger({int:r[t.name]})}else this.dStatus=new e.DERInteger(t)},sr.lang.extend(Cr.asn1.tsp.PKIStatus,Cr.asn1.ASN1Object),Cr.asn1.tsp.PKIStatus.valueList={granted:0,grantedWithMods:1,rejection:2,waiting:3,revocationWarning:4,revocationNotification:5},Cr.asn1.tsp.PKIFreeText=function(t){Cr.asn1.tsp.PKIFreeText.superclass.constructor.call(this);var e=Cr.asn1;this.textList=[],this.getEncodedHex=function(){for(var t=[],n=0;n<this.textList.length;n++)t.push(new e.DERUTF8String({str:this.textList[n]}));var r=new e.DERSequence({array:t});return this.hTLV=r.getEncodedHex(),this.hTLV},"undefined"!=typeof t&&"object"==typeof t.array&&(this.textList=t.array)},sr.lang.extend(Cr.asn1.tsp.PKIFreeText,Cr.asn1.ASN1Object),Cr.asn1.tsp.PKIFailureInfo=function(t){Cr.asn1.tsp.PKIFailureInfo.superclass.constructor.call(this);var e=Cr.asn1,n=Cr.asn1.tsp;if(this.value=null,this.getEncodedHex=function(){if(null==this.value)throw"value shall be specified";var t=new Number(this.value).toString(2),n=new e.DERBitString;return n.setByBinaryString(t),this.hTLV=n.getEncodedHex(),this.hTLV},"undefined"!=typeof t)if("string"==typeof t.name){var r=n.PKIFailureInfo.valueList;if("undefined"==typeof r[t.name])throw"name undefined: "+t.name;this.value=r[t.name]}else"number"==typeof t.int&&(this.value=t.int)},sr.lang.extend(Cr.asn1.tsp.PKIFailureInfo,Cr.asn1.ASN1Object),Cr.asn1.tsp.PKIFailureInfo.valueList={badAlg:0,badRequest:2,badDataFormat:5,timeNotAvailable:14,unacceptedPolicy:15,unacceptedExtension:16,addInfoNotAvailable:17,systemFailure:25},Cr.asn1.tsp.AbstractTSAAdapter=function(t){this.getTSTHex=function(t,e){throw"not implemented yet"}},Cr.asn1.tsp.SimpleTSAAdapter=function(t){Cr.asn1.tsp.SimpleTSAAdapter.superclass.constructor.call(this),this.params=null,this.serial=0,this.getTSTHex=function(t,e){var n=Cr.crypto.Util.hashHex(t,e);this.params.tstInfo.messageImprint={hashAlg:e,hashValue:n},this.params.tstInfo.serialNumber={int:this.serial++};var r=Math.floor(1e9*Math.random());this.params.tstInfo.nonce={int:r};var i=Cr.asn1.tsp.TSPUtil.newTimeStampToken(this.params);return i.getContentInfoEncodedHex()},"undefined"!=typeof t&&(this.params=t)},sr.lang.extend(Cr.asn1.tsp.SimpleTSAAdapter,Cr.asn1.tsp.AbstractTSAAdapter),Cr.asn1.tsp.FixedTSAAdapter=function(t){Cr.asn1.tsp.FixedTSAAdapter.superclass.constructor.call(this),this.params=null,this.getTSTHex=function(t,e){var n=Cr.crypto.Util.hashHex(t,e);this.params.tstInfo.messageImprint={hashAlg:e,hashValue:n};var r=Cr.asn1.tsp.TSPUtil.newTimeStampToken(this.params);return r.getContentInfoEncodedHex()},"undefined"!=typeof t&&(this.params=t)},sr.lang.extend(Cr.asn1.tsp.FixedTSAAdapter,Cr.asn1.tsp.AbstractTSAAdapter),Cr.asn1.tsp.TSPUtil=new function(){},Cr.asn1.tsp.TSPUtil.newTimeStampToken=function(t){var e=Cr.asn1.cms,n=Cr.asn1.tsp,r=new e.SignedData,i=new n.TSTInfo(t.tstInfo),s=i.getEncodedHex();if(r.dEncapContentInfo.setContentValue({hex:s}),r.dEncapContentInfo.setContentType("tstinfo"),"object"==typeof t.certs)for(var o=0;o<t.certs.length;o++)r.addCertificatesByPEM(t.certs[o]);var a=r.signerInfoList[0];a.setSignerIdentifier(t.signerCert),a.setForContentAndHash({sdObj:r,eciObj:r.dEncapContentInfo,hashAlg:t.hashAlg});var u=new e.SigningCertificate({array:[t.signerCert]});return a.dSignedAttrs.add(u),a.sign(t.signerPrvKey,t.sigAlg),r},Cr.asn1.tsp.TSPUtil.parseTimeStampReq=function(t){var e={};e.certreq=!1;var n=Or.getPosArrayOfChildren_AtObj(t,0);if(n.length<2)throw"TimeStampReq must have at least 2 items";var r=Or.getHexOfTLV_AtObj(t,n[1]);e.mi=Cr.asn1.tsp.TSPUtil.parseMessageImprint(r);for(var i=2;i<n.length;i++){var s=n[i],o=t.substr(s,2);if("06"==o){var a=Or.getHexOfV_AtObj(t,s);e.policy=Or.hextooidstr(a)}"02"==o&&(e.nonce=Or.getHexOfV_AtObj(t,s)),"01"==o&&(e.certreq=!0)}return e},Cr.asn1.tsp.TSPUtil.parseMessageImprint=function(t){var e={};if("30"!=t.substr(0,2))throw"head of messageImprint hex shall be '30'";var n=(Or.getPosArrayOfChildren_AtObj(t,0),Or.getDecendantIndexByNthList(t,0,[0,0])),r=Or.getHexOfV_AtObj(t,n),i=Or.hextooidstr(r),s=Cr.asn1.x509.OID.oid2name(i);if(""==s)throw"hashAlg name undefined: "+i;var o=s,a=Or.getDecendantIndexByNthList(t,0,[1]);return e.hashAlg=o,e.hashValue=Or.getHexOfV_AtObj(t,a),e},/*! asn1cades-1.0.0.js (c) 2013-2014 Kenji Urushima | kjur.github.com/jsrsasign/license
		 */
	"undefined"!=typeof Cr&&Cr||(Cr={}),"undefined"!=typeof Cr.asn1&&Cr.asn1||(Cr.asn1={}),"undefined"!=typeof Cr.asn1.cades&&Cr.asn1.cades||(Cr.asn1.cades={}),Cr.asn1.cades.SignaturePolicyIdentifier=function(t){Cr.asn1.cades.SignaturePolicyIdentifier.superclass.constructor.call(this),this.attrTypeOid="1.2.840.113549.1.9.16.2.15";var e=Cr.asn1,n=Cr.asn1.cades;if("undefined"!=typeof t&&"string"==typeof t.oid&&"object"==typeof t.hash){var r=new e.DERObjectIdentifier({oid:t.oid}),i=new n.OtherHashAlgAndValue(t.hash),s=new e.DERSequence({array:[r,i]});this.valueList=[s]}},sr.lang.extend(Cr.asn1.cades.SignaturePolicyIdentifier,Cr.asn1.cms.Attribute),Cr.asn1.cades.OtherHashAlgAndValue=function(t){Cr.asn1.cades.OtherHashAlgAndValue.superclass.constructor.call(this);var e=Cr.asn1,n=Cr.asn1.x509;this.dAlg=null,this.dHash=null,this.getEncodedHex=function(){var t=new e.DERSequence({array:[this.dAlg,this.dHash]});return this.hTLV=t.getEncodedHex(),this.hTLV},"undefined"!=typeof t&&"string"==typeof t.alg&&"string"==typeof t.hash&&(this.dAlg=new n.AlgorithmIdentifier({name:t.alg}),this.dHash=new e.DEROctetString({hex:t.hash}))},sr.lang.extend(Cr.asn1.cades.OtherHashAlgAndValue,Cr.asn1.ASN1Object),Cr.asn1.cades.SignatureTimeStamp=function(t){Cr.asn1.cades.SignatureTimeStamp.superclass.constructor.call(this),this.attrTypeOid="1.2.840.113549.1.9.16.2.14",this.tstHex=null;var e=Cr.asn1;if("undefined"!=typeof t){if("undefined"!=typeof t.res)if("string"==typeof t.res&&t.res.match(/^[0-9A-Fa-f]+$/));else if(!(t.res instanceof Cr.asn1.ASN1Object))throw"res param shall be ASN1Object or hex string";if("undefined"!=typeof t.tst)if("string"==typeof t.tst&&t.tst.match(/^[0-9A-Fa-f]+$/)){var n=new e.ASN1Object;this.tstHex=t.tst,n.hTLV=this.tstHex,n.getEncodedHex(),this.valueList=[n]}else if(!(t.tst instanceof Cr.asn1.ASN1Object))throw"tst param shall be ASN1Object or hex string"}},sr.lang.extend(Cr.asn1.cades.SignatureTimeStamp,Cr.asn1.cms.Attribute),Cr.asn1.cades.CompleteCertificateRefs=function(t){Cr.asn1.cades.CompleteCertificateRefs.superclass.constructor.call(this),this.attrTypeOid="1.2.840.113549.1.9.16.2.21";var e=(Cr.asn1,Cr.asn1.cades);this.setByArray=function(t){this.valueList=[];for(var n=0;n<t.length;n++){var r=new e.OtherCertID(t[n]);this.valueList.push(r)}},"undefined"!=typeof t&&"object"==typeof t&&"number"==typeof t.length&&this.setByArray(t)},sr.lang.extend(Cr.asn1.cades.CompleteCertificateRefs,Cr.asn1.cms.Attribute),Cr.asn1.cades.OtherCertID=function(t){Cr.asn1.cades.OtherCertID.superclass.constructor.call(this);var e=Cr.asn1,n=Cr.asn1.cms,r=Cr.asn1.cades;this.hasIssuerSerial=!0,this.dOtherCertHash=null,this.dIssuerSerial=null,this.setByCertPEM=function(t){this.dOtherCertHash=new r.OtherHash(t),this.hasIssuerSerial&&(this.dIssuerSerial=new n.IssuerAndSerialNumber(t))},this.getEncodedHex=function(){if(null!=this.hTLV)return this.hTLV;if(null==this.dOtherCertHash)throw"otherCertHash not set";var t=[this.dOtherCertHash];null!=this.dIssuerSerial&&t.push(this.dIssuerSerial);var n=new e.DERSequence({array:t});return this.hTLV=n.getEncodedHex(),this.hTLV},"undefined"!=typeof t&&("string"==typeof t&&t.indexOf("-----BEGIN ")!=-1&&this.setByCertPEM(t),"object"==typeof t&&(t.hasis===!1&&(this.hasIssuerSerial=!1),"string"==typeof t.cert&&this.setByCertPEM(t.cert)))},sr.lang.extend(Cr.asn1.cades.OtherCertID,Cr.asn1.ASN1Object),Cr.asn1.cades.OtherHash=function(t){Cr.asn1.cades.OtherHash.superclass.constructor.call(this);var e=Cr.asn1,n=Cr.asn1.cades;if(this.alg="sha256",this.dOtherHash=null,this.setByCertPEM=function(t){if(t.indexOf("-----BEGIN ")==-1)throw"certPEM not to seem PEM format";var e=$n.pemToHex(t),r=Cr.crypto.Util.hashHex(e,this.alg);this.dOtherHash=new n.OtherHashAlgAndValue({alg:this.alg,hash:r})},this.getEncodedHex=function(){if(null==this.dOtherHash)throw"OtherHash not set";return this.dOtherHash.getEncodedHex()},"undefined"!=typeof t)if("string"==typeof t)if(t.indexOf("-----BEGIN ")!=-1)this.setByCertPEM(t);else{if(!t.match(/^[0-9A-Fa-f]+$/))throw"unsupported string value for params";this.dOtherHash=new e.DEROctetString({hex:t})}else"object"==typeof t&&("string"==typeof t.cert?("string"==typeof t.alg&&(this.alg=t.alg),this.setByCertPEM(t.cert)):this.dOtherHash=new n.OtherHashAlgAndValue(t))},sr.lang.extend(Cr.asn1.cades.OtherHash,Cr.asn1.ASN1Object),Cr.asn1.cades.CAdESUtil=new function(){},Cr.asn1.cades.CAdESUtil.addSigTS=function(t,e,n){},Cr.asn1.cades.CAdESUtil.parseSignedDataForAddingUnsigned=function(t){var e=Cr.asn1,n=Cr.asn1.cms,r=Cr.asn1.cades.CAdESUtil,i={};if("06092a864886f70d010702"!=Or.getDecendantHexTLVByNthList(t,0,[0]))throw"hex is not CMS SignedData";var s=Or.getDecendantIndexByNthList(t,0,[1,0]),o=Or.getPosArrayOfChildren_AtObj(t,s);if(o.length<4)throw"num of SignedData elem shall be 4 at least";var a=o.shift();i.version=Or.getHexOfTLV_AtObj(t,a);var u=o.shift();i.algs=Or.getHexOfTLV_AtObj(t,u);var h=o.shift();i.encapcontent=Or.getHexOfTLV_AtObj(t,h),i.certs=null,i.revs=null,i.si=[];var c=o.shift();"a0"==t.substr(c,2)&&(i.certs=Or.getHexOfTLV_AtObj(t,c),c=o.shift()),"a1"==t.substr(c,2)&&(i.revs=Or.getHexOfTLV_AtObj(t,c),c=o.shift());var f=c;if("31"!=t.substr(f,2))throw"Can't find signerInfos";for(var l=Or.getPosArrayOfChildren_AtObj(t,f),d=0;d<l.length;d++){var p=l[d],g=r.parseSignerInfoForAddingUnsigned(t,p,d);i.si[d]=g}var y=null;i.obj=new n.SignedData,y=new e.ASN1Object,y.hTLV=i.version,i.obj.dCMSVersion=y,y=new e.ASN1Object,y.hTLV=i.algs,i.obj.dDigestAlgs=y,y=new e.ASN1Object,y.hTLV=i.encapcontent,i.obj.dEncapContentInfo=y,y=new e.ASN1Object,y.hTLV=i.certs,i.obj.dCerts=y,i.obj.signerInfoList=[];for(var d=0;d<i.si.length;d++)i.obj.signerInfoList.push(i.si[d].obj);return i},Cr.asn1.cades.CAdESUtil.parseSignerInfoForAddingUnsigned=function(t,e,n){var r=Cr.asn1,i=Cr.asn1.cms,s={},o=Or.getPosArrayOfChildren_AtObj(t,e);if(6!=o.length)throw"not supported items for SignerInfo (!=6)";var a=o.shift();s.version=Or.getHexOfTLV_AtObj(t,a);var u=o.shift();s.si=Or.getHexOfTLV_AtObj(t,u);var h=o.shift();s.digalg=Or.getHexOfTLV_AtObj(t,h);var c=o.shift();s.sattrs=Or.getHexOfTLV_AtObj(t,c);var f=o.shift();s.sigalg=Or.getHexOfTLV_AtObj(t,f);var l=o.shift();s.sig=Or.getHexOfTLV_AtObj(t,l),s.sigval=Or.getHexOfV_AtObj(t,l);var d=null;return s.obj=new i.SignerInfo,d=new r.ASN1Object,d.hTLV=s.version,s.obj.dCMSVersion=d,d=new r.ASN1Object,d.hTLV=s.si,s.obj.dSignerIdentifier=d,d=new r.ASN1Object,d.hTLV=s.digalg,s.obj.dDigestAlgorithm=d,d=new r.ASN1Object,d.hTLV=s.sattrs,s.obj.dSignedAttrs=d,d=new r.ASN1Object,d.hTLV=s.sigalg,s.obj.dSigAlg=d,d=new r.ASN1Object,d.hTLV=s.sig,s.obj.dSig=d,s.obj.dUnsignedAttrs=new i.AttributeList,s},/*! asn1csr-1.0.0.js (c) 2015 Kenji Urushima | kjur.github.com/jsrsasign/license
		 */
	"undefined"!=typeof Cr.asn1.csr&&Cr.asn1.csr||(Cr.asn1.csr={}),Cr.asn1.csr.CertificationRequest=function(t){Cr.asn1.csr.CertificationRequest.superclass.constructor.call(this);this.sign=function(t,e){null==this.prvKey&&(this.prvKey=e),this.asn1SignatureAlg=new Cr.asn1.x509.AlgorithmIdentifier({name:t}),sig=new Cr.crypto.Signature({alg:t}),sig.initSign(this.prvKey),sig.updateHex(this.asn1CSRInfo.getEncodedHex()),this.hexSig=sig.sign(),this.asn1Sig=new Cr.asn1.DERBitString({hex:"00"+this.hexSig});var n=new Cr.asn1.DERSequence({array:[this.asn1CSRInfo,this.asn1SignatureAlg,this.asn1Sig]});this.hTLV=n.getEncodedHex(),this.isModified=!1},this.getPEMString=function(){var t=Cr.asn1.ASN1Util.getPEMStringFromHex(this.getEncodedHex(),"CERTIFICATE REQUEST");return t},this.getEncodedHex=function(){if(0==this.isModified&&null!=this.hTLV)return this.hTLV;throw"not signed yet"},"undefined"!=typeof t&&"undefined"!=typeof t.csrinfo&&(this.asn1CSRInfo=t.csrinfo)},sr.lang.extend(Cr.asn1.csr.CertificationRequest,Cr.asn1.ASN1Object),Cr.asn1.csr.CertificationRequestInfo=function(t){Cr.asn1.csr.CertificationRequestInfo.superclass.constructor.call(this),this._initialize=function(){this.asn1Array=new Array,this.asn1Version=new Cr.asn1.DERInteger({int:0}),this.asn1Subject=null,this.asn1SubjPKey=null,this.extensionsArray=new Array},this.setSubjectByParam=function(t){this.asn1Subject=new Cr.asn1.x509.X500Name(t)},this.setSubjectPublicKeyByGetKey=function(t){var e=Rr.getKey(t);this.asn1SubjPKey=new Cr.asn1.x509.SubjectPublicKeyInfo(e)},this.getEncodedHex=function(){this.asn1Array=new Array,this.asn1Array.push(this.asn1Version),this.asn1Array.push(this.asn1Subject),this.asn1Array.push(this.asn1SubjPKey);var t=new Cr.asn1.DERSequence({array:this.extensionsArray}),e=new Cr.asn1.DERTaggedObject({explicit:!1,tag:"a0",obj:t});this.asn1Array.push(e);var n=new Cr.asn1.DERSequence({array:this.asn1Array});return this.hTLV=n.getEncodedHex(),this.isModified=!1,this.hTLV},this._initialize()},sr.lang.extend(Cr.asn1.csr.CertificationRequestInfo,Cr.asn1.ASN1Object),Cr.asn1.csr.CSRUtil=new function(){},Cr.asn1.csr.CSRUtil.newCSRPEM=function(t){var e=Cr.asn1.csr;if(void 0===t.subject)throw"parameter subject undefined";if(void 0===t.sbjpubkey)throw"parameter sbjpubkey undefined";if(void 0===t.sigalg)throw"parameter sigalg undefined";if(void 0===t.sbjprvkey)throw"parameter sbjpubkey undefined";var n=new e.CertificationRequestInfo;n.setSubjectByParam(t.subject),n.setSubjectPublicKeyByGetKey(t.sbjpubkey);var r=new e.CertificationRequest({csrinfo:n}),i=Rr.getKey(t.sbjprvkey);r.sign(t.sigalg,i);var s=r.getPEMString();return s};/*! base64x-1.1.7 (c) 2012-2016 Kenji Urushima | kjur.github.com/jsrsasign/license
		 */
	var Cr;"undefined"!=typeof Cr&&Cr||(Cr={}),"undefined"!=typeof Cr.lang&&Cr.lang||(Cr.lang={}),Cr.lang.String=function(){};var Tr,Dr;"function"==typeof t?(Tr=function(e){return ln(new t(e,"utf8").toString("base64"))},Dr=function(e){return new t(dn(e),"base64").toString("utf8")}):(Tr=function(t){return pn(xn(_n(t)))},Dr=function(t){return decodeURIComponent(An(gn(t)))}),Cr.lang.String.isInteger=function(t){return!!t.match(/^[0-9]+$/)||!!t.match(/^-[0-9]+$/)},Cr.lang.String.isHex=function(t){return!(t.length%2!=0||!t.match(/^[0-9a-f]+$/)&&!t.match(/^[0-9A-F]+$/))},Cr.lang.String.isBase64=function(t){return t=t.replace(/\s+/g,""),!(!t.match(/^[0-9A-Za-z+\/]+={0,3}$/)||t.length%4!=0)},Cr.lang.String.isBase64URL=function(t){return!t.match(/[+\/=]/)&&(t=dn(t),Cr.lang.String.isBase64(t))},Cr.lang.String.isIntegerArray=function(t){return t=t.replace(/\s+/g,""),!!t.match(/^\[[0-9,]+\]$/)};var Hr=function(t,e){var n=t.length;t.length>e.length&&(n=e.length);for(var r=0;r<n;r++)if(t.charCodeAt(r)!=e.charCodeAt(r))return r;return t.length!=e.length?n:-1};/*! crypto-1.1.8.js (c) 2013-2016 Kenji Urushima | kjur.github.com/jsrsasign/license
		 */
	"undefined"!=typeof Cr&&Cr||(Cr={}),"undefined"!=typeof Cr.crypto&&Cr.crypto||(Cr.crypto={}),Cr.crypto.Util=new function(){this.DIGESTINFOHEAD={sha1:"3021300906052b0e03021a05000414",sha224:"302d300d06096086480165030402040500041c",sha256:"3031300d060960864801650304020105000420",sha384:"3041300d060960864801650304020205000430",sha512:"3051300d060960864801650304020305000440",md2:"3020300c06082a864886f70d020205000410",md5:"3020300c06082a864886f70d020505000410",ripemd160:"3021300906052b2403020105000414"},this.DEFAULTPROVIDER={md5:"cryptojs",sha1:"cryptojs",sha224:"cryptojs",sha256:"cryptojs",sha384:"cryptojs",sha512:"cryptojs",ripemd160:"cryptojs",hmacmd5:"cryptojs",hmacsha1:"cryptojs",hmacsha224:"cryptojs",hmacsha256:"cryptojs",hmacsha384:"cryptojs",hmacsha512:"cryptojs",hmacripemd160:"cryptojs",MD5withRSA:"cryptojs/jsrsa",SHA1withRSA:"cryptojs/jsrsa",SHA224withRSA:"cryptojs/jsrsa",SHA256withRSA:"cryptojs/jsrsa",SHA384withRSA:"cryptojs/jsrsa",SHA512withRSA:"cryptojs/jsrsa",RIPEMD160withRSA:"cryptojs/jsrsa",MD5withECDSA:"cryptojs/jsrsa",SHA1withECDSA:"cryptojs/jsrsa",SHA224withECDSA:"cryptojs/jsrsa",SHA256withECDSA:"cryptojs/jsrsa",SHA384withECDSA:"cryptojs/jsrsa",SHA512withECDSA:"cryptojs/jsrsa",RIPEMD160withECDSA:"cryptojs/jsrsa",SHA1withDSA:"cryptojs/jsrsa",SHA224withDSA:"cryptojs/jsrsa",SHA256withDSA:"cryptojs/jsrsa",MD5withRSAandMGF1:"cryptojs/jsrsa",SHA1withRSAandMGF1:"cryptojs/jsrsa",SHA224withRSAandMGF1:"cryptojs/jsrsa",SHA256withRSAandMGF1:"cryptojs/jsrsa",SHA384withRSAandMGF1:"cryptojs/jsrsa",SHA512withRSAandMGF1:"cryptojs/jsrsa",RIPEMD160withRSAandMGF1:"cryptojs/jsrsa"},this.CRYPTOJSMESSAGEDIGESTNAME={md5:or.algo.MD5,sha1:or.algo.SHA1,sha224:or.algo.SHA224,sha256:or.algo.SHA256,sha384:or.algo.SHA384,sha512:or.algo.SHA512,ripemd160:or.algo.RIPEMD160},this.getDigestInfoHex=function(t,e){if("undefined"==typeof this.DIGESTINFOHEAD[e])throw"alg not supported in Util.DIGESTINFOHEAD: "+e;return this.DIGESTINFOHEAD[e]+t},this.getPaddedDigestInfoHex=function(t,e,n){var r=this.getDigestInfoHex(t,e),i=n/4;if(r.length+22>i)throw"key is too short for SigAlg: keylen="+n+","+e;for(var s="0001",o="00"+r,a="",u=i-s.length-o.length,h=0;h<u;h+=2)a+="ff";var c=s+a+o;return c},this.hashString=function(t,e){var n=new Cr.crypto.MessageDigest({alg:e});return n.digestString(t)},this.hashHex=function(t,e){var n=new Cr.crypto.MessageDigest({alg:e});return n.digestHex(t)},this.sha1=function(t){var e=new Cr.crypto.MessageDigest({alg:"sha1",prov:"cryptojs"});return e.digestString(t)},this.sha256=function(t){var e=new Cr.crypto.MessageDigest({alg:"sha256",prov:"cryptojs"});return e.digestString(t)},this.sha256Hex=function(t){var e=new Cr.crypto.MessageDigest({alg:"sha256",prov:"cryptojs"});return e.digestHex(t)},this.sha512=function(t){var e=new Cr.crypto.MessageDigest({alg:"sha512",prov:"cryptojs"});return e.digestString(t)},this.sha512Hex=function(t){var e=new Cr.crypto.MessageDigest({alg:"sha512",prov:"cryptojs"});return e.digestHex(t)},this.md5=function(t){var e=new Cr.crypto.MessageDigest({alg:"md5",prov:"cryptojs"});return e.digestString(t)},this.ripemd160=function(t){var e=new Cr.crypto.MessageDigest({alg:"ripemd160",prov:"cryptojs"});return e.digestString(t)},this.getCryptoJSMDByName=function(t){}},Cr.crypto.MessageDigest=function(t){this.setAlgAndProvider=function(t,e){if(null!=t&&void 0===e&&(e=Cr.crypto.Util.DEFAULTPROVIDER[t]),":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(t)!=-1&&"cryptojs"==e){try{this.md=Cr.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME[t].create()}catch(e){throw"setAlgAndProvider hash alg set fail alg="+t+"/"+e}this.updateString=function(t){this.md.update(t)},this.updateHex=function(t){var e=or.enc.Hex.parse(t);this.md.update(e)},this.digest=function(){var t=this.md.finalize();return t.toString(or.enc.Hex)},this.digestString=function(t){return this.updateString(t),this.digest()},this.digestHex=function(t){return this.updateHex(t),this.digest()}}if(":sha256:".indexOf(t)!=-1&&"sjcl"==e){try{this.md=new sjcl.hash.sha256}catch(e){throw"setAlgAndProvider hash alg set fail alg="+t+"/"+e}this.updateString=function(t){this.md.update(t)},this.updateHex=function(t){var e=sjcl.codec.hex.toBits(t);this.md.update(e)},this.digest=function(){var t=this.md.finalize();return sjcl.codec.hex.fromBits(t)},this.digestString=function(t){return this.updateString(t),this.digest()},this.digestHex=function(t){return this.updateHex(t),this.digest()}}},this.updateString=function(t){throw"updateString(str) not supported for this alg/prov: "+this.algName+"/"+this.provName},this.updateHex=function(t){throw"updateHex(hex) not supported for this alg/prov: "+this.algName+"/"+this.provName},this.digest=function(){throw"digest() not supported for this alg/prov: "+this.algName+"/"+this.provName},this.digestString=function(t){throw"digestString(str) not supported for this alg/prov: "+this.algName+"/"+this.provName},this.digestHex=function(t){throw"digestHex(hex) not supported for this alg/prov: "+this.algName+"/"+this.provName},void 0!==t&&void 0!==t.alg&&(this.algName=t.alg,void 0===t.prov&&(this.provName=Cr.crypto.Util.DEFAULTPROVIDER[this.algName]),this.setAlgAndProvider(this.algName,this.provName))},Cr.crypto.Mac=function(t){this.setAlgAndProvider=function(t,e){if(t=t.toLowerCase(),null==t&&(t="hmacsha1"),t=t.toLowerCase(),"hmac"!=t.substr(0,4))throw"setAlgAndProvider unsupported HMAC alg: "+t;void 0===e&&(e=Cr.crypto.Util.DEFAULTPROVIDER[t]),this.algProv=t+"/"+e;var n=t.substr(4);if(":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(n)!=-1&&"cryptojs"==e){try{var r=Cr.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME[n];this.mac=or.algo.HMAC.create(r,this.pass)}catch(t){throw"setAlgAndProvider hash alg set fail hashAlg="+n+"/"+t}this.updateString=function(t){this.mac.update(t)},this.updateHex=function(t){var e=or.enc.Hex.parse(t);this.mac.update(e)},this.doFinal=function(){var t=this.mac.finalize();return t.toString(or.enc.Hex)},this.doFinalString=function(t){return this.updateString(t),this.doFinal()},this.doFinalHex=function(t){return this.updateHex(t),this.doFinal()}}},this.updateString=function(t){throw"updateString(str) not supported for this alg/prov: "+this.algProv},this.updateHex=function(t){throw"updateHex(hex) not supported for this alg/prov: "+this.algProv},this.doFinal=function(){throw"digest() not supported for this alg/prov: "+this.algProv},this.doFinalString=function(t){throw"digestString(str) not supported for this alg/prov: "+this.algProv},this.doFinalHex=function(t){throw"digestHex(hex) not supported for this alg/prov: "+this.algProv},this.setPassword=function(t){if("string"==typeof t){var e=t;return t.length%2!=1&&t.match(/^[0-9A-Fa-f]+$/)||(e=wn(t)),void(this.pass=or.enc.Hex.parse(e))}if("object"!=typeof t)throw"KJUR.crypto.Mac unsupported password type: "+t;var e=null;if(void 0!==t.hex){if(t.hex.length%2!=0||!t.hex.match(/^[0-9A-Fa-f]+$/))throw"Mac: wrong hex password: "+t.hex;e=t.hex}if(void 0!==t.utf8&&(e=mn(t.utf8)),void 0!==t.rstr&&(e=wn(t.rstr)),void 0!==t.b64&&(e=i(t.b64)),void 0!==t.b64u&&(e=gn(t.b64u)),null==e)throw"KJUR.crypto.Mac unsupported password type: "+t;this.pass=or.enc.Hex.parse(e)},void 0!==t&&(void 0!==t.pass&&this.setPassword(t.pass),void 0!==t.alg&&(this.algName=t.alg,void 0===t.prov&&(this.provName=Cr.crypto.Util.DEFAULTPROVIDER[this.algName]),this.setAlgAndProvider(this.algName,this.provName)))},Cr.crypto.Signature=function(t){var e=null;if(this._setAlgNames=function(){this.algName.match(/^(.+)with(.+)$/)&&(this.mdAlgName=RegExp.$1.toLowerCase(),this.pubkeyAlgName=RegExp.$2.toLowerCase())},this._zeroPaddingOfSignature=function(t,e){for(var n="",r=e/4-t.length,i=0;i<r;i++)n+="0";return n+t},this.setAlgAndProvider=function(t,e){if(this._setAlgNames(),"cryptojs/jsrsa"!=e)throw"provider not supported: "+e;if(":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(this.mdAlgName)!=-1){try{this.md=new Cr.crypto.MessageDigest({alg:this.mdAlgName})}catch(t){throw"setAlgAndProvider hash alg set fail alg="+this.mdAlgName+"/"+t}this.init=function(t,e){var n=null;try{n=void 0===e?Rr.getKey(t):Rr.getKey(t,e)}catch(t){throw"init failed:"+t}if(n.isPrivate===!0)this.prvKey=n,this.state="SIGN";else{if(n.isPublic!==!0)throw"init failed.:"+n;this.pubKey=n,this.state="VERIFY"}},this.initSign=function(t){"string"==typeof t.ecprvhex&&"string"==typeof t.eccurvename?(this.ecprvhex=t.ecprvhex,this.eccurvename=t.eccurvename):this.prvKey=t,this.state="SIGN"},this.initVerifyByPublicKey=function(t){"string"==typeof t.ecpubhex&&"string"==typeof t.eccurvename?(this.ecpubhex=t.ecpubhex,this.eccurvename=t.eccurvename):t instanceof Cr.crypto.ECDSA?this.pubKey=t:t instanceof ve&&(this.pubKey=t),this.state="VERIFY"},this.initVerifyByCertificatePEM=function(t){var e=new $n;e.readCertPEM(t),this.pubKey=e.subjectPublicKeyRSA,this.state="VERIFY"},this.updateString=function(t){this.md.updateString(t)},this.updateHex=function(t){this.md.updateHex(t)},this.sign=function(){if(this.sHashHex=this.md.digest(),"undefined"!=typeof this.ecprvhex&&"undefined"!=typeof this.eccurvename){var t=new Cr.crypto.ECDSA({curve:this.eccurvename});this.hSign=t.signHex(this.sHashHex,this.ecprvhex)}else if(this.prvKey instanceof ve&&"rsaandmgf1"==this.pubkeyAlgName)this.hSign=this.prvKey.signWithMessageHashPSS(this.sHashHex,this.mdAlgName,this.pssSaltLen);else if(this.prvKey instanceof ve&&"rsa"==this.pubkeyAlgName)this.hSign=this.prvKey.signWithMessageHash(this.sHashHex,this.mdAlgName);else if(this.prvKey instanceof Cr.crypto.ECDSA)this.hSign=this.prvKey.signWithMessageHash(this.sHashHex);else{if(!(this.prvKey instanceof Cr.crypto.DSA))throw"Signature: unsupported public key alg: "+this.pubkeyAlgName;this.hSign=this.prvKey.signWithMessageHash(this.sHashHex)}return this.hSign},this.signString=function(t){return this.updateString(t),this.sign()},this.signHex=function(t){return this.updateHex(t),this.sign()},this.verify=function(t){if(this.sHashHex=this.md.digest(),"undefined"!=typeof this.ecpubhex&&"undefined"!=typeof this.eccurvename){var e=new Cr.crypto.ECDSA({curve:this.eccurvename});return e.verifyHex(this.sHashHex,t,this.ecpubhex)}if(this.pubKey instanceof ve&&"rsaandmgf1"==this.pubkeyAlgName)return this.pubKey.verifyWithMessageHashPSS(this.sHashHex,t,this.mdAlgName,this.pssSaltLen);if(this.pubKey instanceof ve&&"rsa"==this.pubkeyAlgName)return this.pubKey.verifyWithMessageHash(this.sHashHex,t);if(this.pubKey instanceof Cr.crypto.ECDSA)return this.pubKey.verifyWithMessageHash(this.sHashHex,t);if(this.pubKey instanceof Cr.crypto.DSA)return this.pubKey.verifyWithMessageHash(this.sHashHex,t);throw"Signature: unsupported public key alg: "+this.pubkeyAlgName}}},this.init=function(t,e){throw"init(key, pass) not supported for this alg:prov="+this.algProvName},this.initVerifyByPublicKey=function(t){throw"initVerifyByPublicKey(rsaPubKeyy) not supported for this alg:prov="+this.algProvName},this.initVerifyByCertificatePEM=function(t){throw"initVerifyByCertificatePEM(certPEM) not supported for this alg:prov="+this.algProvName},this.initSign=function(t){throw"initSign(prvKey) not supported for this alg:prov="+this.algProvName},this.updateString=function(t){throw"updateString(str) not supported for this alg:prov="+this.algProvName},this.updateHex=function(t){throw"updateHex(hex) not supported for this alg:prov="+this.algProvName},this.sign=function(){throw"sign() not supported for this alg:prov="+this.algProvName},this.signString=function(t){throw"digestString(str) not supported for this alg:prov="+this.algProvName},this.signHex=function(t){throw"digestHex(hex) not supported for this alg:prov="+this.algProvName},this.verify=function(t){throw"verify(hSigVal) not supported for this alg:prov="+this.algProvName},this.initParams=t,void 0!==t&&(void 0!==t.alg&&(this.algName=t.alg,void 0===t.prov?this.provName=Cr.crypto.Util.DEFAULTPROVIDER[this.algName]:this.provName=t.prov,this.algProvName=this.algName+":"+this.provName,this.setAlgAndProvider(this.algName,this.provName),this._setAlgNames()),void 0!==t.psssaltlen&&(this.pssSaltLen=t.psssaltlen),void 0!==t.prvkeypem)){if(void 0!==t.prvkeypas)throw"both prvkeypem and prvkeypas parameters not supported";try{var e=new ve;e.readPrivateKeyFromPEMString(t.prvkeypem),this.initSign(e)}catch(t){throw"fatal error to load pem private key: "+t}}},Cr.crypto.OID=new function(){this.oidhex2name={"2a864886f70d010101":"rsaEncryption","2a8648ce3d0201":"ecPublicKey","2a8648ce380401":"dsa","2a8648ce3d030107":"secp256r1","2b8104001f":"secp192k1","2b81040021":"secp224r1","2b8104000a":"secp256k1","2b81040023":"secp521r1","2b81040022":"secp384r1","2a8648ce380403":"SHA1withDSA","608648016503040301":"SHA224withDSA","608648016503040302":"SHA256withDSA"}},/*! ecdsa-modified-1.0.5.js (c) Stephan Thomas, Kenji Urushima | github.com/bitcoinjs/bitcoinjs-lib/blob/master/LICENSE
		 */
	"undefined"!=typeof Cr&&Cr||(Cr={}),"undefined"!=typeof Cr.crypto&&Cr.crypto||(Cr.crypto={}),Cr.crypto.ECDSA=function(t){var e="secp256r1",n=new le;this.type="EC",this.getBigRandom=function(t){return new o(t.bitLength(),n).mod(t.subtract(o.ONE)).add(o.ONE)},this.setNamedCurve=function(t){this.ecparams=Cr.crypto.ECParameterDB.getByName(t),this.prvKeyHex=null,this.pubKeyHex=null,this.curveName=t},this.setPrivateKeyHex=function(t){this.isPrivate=!0,this.prvKeyHex=t},this.setPublicKeyHex=function(t){this.isPublic=!0,this.pubKeyHex=t},this.getPublicKeyXYHex=function(){var t=this.pubKeyHex;if("04"!==t.substr(0,2))throw"this method supports uncompressed format(04) only";var e=this.ecparams.keylen/4;if(t.length!==2+2*e)throw"malformed public key hex length";var n={};return n.x=t.substr(2,e),n.y=t.substr(2+e),n},this.getShortNISTPCurveName=function(){var t=this.curveName;return"secp256r1"===t||"NIST P-256"===t||"P-256"===t||"prime256v1"===t?"P-256":"secp384r1"===t||"NIST P-384"===t||"P-384"===t?"P-384":null},this.generateKeyPairHex=function(){var t=this.ecparams.n,e=this.getBigRandom(t),n=this.ecparams.G.multiply(e),r=n.getX().toBigInteger(),i=n.getY().toBigInteger(),s=this.ecparams.keylen/4,o=("0000000000"+e.toString(16)).slice(-s),a=("0000000000"+r.toString(16)).slice(-s),u=("0000000000"+i.toString(16)).slice(-s),h="04"+a+u;return this.setPrivateKeyHex(o),this.setPublicKeyHex(h),{ecprvhex:o,ecpubhex:h}},this.signWithMessageHash=function(t){return this.signHex(t,this.prvKeyHex)},this.signHex=function(t,e){var n=new o(e,16),r=this.ecparams.n,i=new o(t,16);do var s=this.getBigRandom(r),a=this.ecparams.G,u=a.multiply(s),h=u.getX().toBigInteger().mod(r);while(h.compareTo(o.ZERO)<=0);var c=s.modInverse(r).multiply(i.add(n.multiply(h))).mod(r);return Cr.crypto.ECDSA.biRSSigToASN1Sig(h,c)},this.sign=function(t,e){var n=e,r=this.ecparams.n,i=o.fromByteArrayUnsigned(t);do var s=this.getBigRandom(r),a=this.ecparams.G,u=a.multiply(s),h=u.getX().toBigInteger().mod(r);while(h.compareTo(o.ZERO)<=0);var c=s.modInverse(r).multiply(i.add(n.multiply(h))).mod(r);return this.serializeSig(h,c)},this.verifyWithMessageHash=function(t,e){return this.verifyHex(t,e,this.pubKeyHex)},this.verifyHex=function(t,e,n){var r,i,s=Cr.crypto.ECDSA.parseSigHex(e);r=s.r,i=s.s;var a;a=Me.decodeFromHex(this.ecparams.curve,n);var u=new o(t,16);return this.verifyRaw(u,r,i,a)},this.verify=function(t,e,n){var r,i;if(Bitcoin.Util.isArray(e)){var s=this.parseSig(e);r=s.r,i=s.s}else{if("object"!=typeof e||!e.r||!e.s)throw"Invalid value for signature";r=e.r,i=e.s}var a;if(n instanceof Me)a=n;else{if(!Bitcoin.Util.isArray(n))throw"Invalid format for pubkey value, must be byte array or ECPointFp";a=Me.decodeFrom(this.ecparams.curve,n)}var u=o.fromByteArrayUnsigned(t);return this.verifyRaw(u,r,i,a)},this.verifyRaw=function(t,e,n,r){var i=this.ecparams.n,s=this.ecparams.G;if(e.compareTo(o.ONE)<0||e.compareTo(i)>=0)return!1;if(n.compareTo(o.ONE)<0||n.compareTo(i)>=0)return!1;var a=n.modInverse(i),u=t.multiply(a).mod(i),h=e.multiply(a).mod(i),c=s.multiply(u).add(r.multiply(h)),f=c.getX().toBigInteger().mod(i);return f.equals(e)},this.serializeSig=function(t,e){var n=t.toByteArraySigned(),r=e.toByteArraySigned(),i=[];return i.push(2),i.push(n.length),i=i.concat(n),i.push(2),i.push(r.length),i=i.concat(r),i.unshift(i.length),i.unshift(48),i},this.parseSig=function(t){var e;if(48!=t[0])throw new Error("Signature not a valid DERSequence");if(e=2,2!=t[e])throw new Error("First element in signature must be a DERInteger");var n=t.slice(e+2,e+2+t[e+1]);if(e+=2+t[e+1],2!=t[e])throw new Error("Second element in signature must be a DERInteger");var r=t.slice(e+2,e+2+t[e+1]);e+=2+t[e+1];var i=o.fromByteArrayUnsigned(n),s=o.fromByteArrayUnsigned(r);return{r:i,s:s}},this.parseSigCompact=function(t){if(65!==t.length)throw"Signature has the wrong length";var e=t[0]-27;if(e<0||e>7)throw"Invalid signature type";var n=this.ecparams.n,r=o.fromByteArrayUnsigned(t.slice(1,33)).mod(n),i=o.fromByteArrayUnsigned(t.slice(33,65)).mod(n);return{r:r,s:i,i:e}},void 0!==t&&void 0!==t.curve&&(this.curveName=t.curve),void 0===this.curveName&&(this.curveName=e),this.setNamedCurve(this.curveName),void 0!==t&&(void 0!==t.prv&&this.setPrivateKeyHex(t.prv),void 0!==t.pub&&this.setPublicKeyHex(t.pub))},Cr.crypto.ECDSA.parseSigHex=function(t){var e=Cr.crypto.ECDSA.parseSigHexInHexRS(t),n=new o(e.r,16),r=new o(e.s,16);return{r:n,s:r}},Cr.crypto.ECDSA.parseSigHexInHexRS=function(t){if("30"!=t.substr(0,2))throw"signature is not a ASN.1 sequence";var e=Or.getPosArrayOfChildren_AtObj(t,0);if(2!=e.length)throw"number of signature ASN.1 sequence elements seem wrong";var n=e[0],r=e[1];if("02"!=t.substr(n,2))throw"1st item of sequene of signature is not ASN.1 integer";if("02"!=t.substr(r,2))throw"2nd item of sequene of signature is not ASN.1 integer";var i=Or.getHexOfV_AtObj(t,n),s=Or.getHexOfV_AtObj(t,r);return{r:i,s:s}},Cr.crypto.ECDSA.asn1SigToConcatSig=function(t){var e=Cr.crypto.ECDSA.parseSigHexInHexRS(t),n=e.r,r=e.s;if("00"==n.substr(0,2)&&n.length/2*8%128==8&&(n=n.substr(2)),"00"==r.substr(0,2)&&r.length/2*8%128==8&&(r=r.substr(2)),n.length/2*8%128!=0)throw"unknown ECDSA sig r length error";if(r.length/2*8%128!=0)throw"unknown ECDSA sig s length error";return n+r},Cr.crypto.ECDSA.concatSigToASN1Sig=function(t){if(t.length/2*8%128!=0)throw"unknown ECDSA concatinated r-s sig  length error";var e=t.substr(0,t.length/2),n=t.substr(t.length/2);return Cr.crypto.ECDSA.hexRSSigToASN1Sig(e,n)},Cr.crypto.ECDSA.hexRSSigToASN1Sig=function(t,e){var n=new o(t,16),r=new o(e,16);return Cr.crypto.ECDSA.biRSSigToASN1Sig(n,r)},Cr.crypto.ECDSA.biRSSigToASN1Sig=function(t,e){var n=new Cr.asn1.DERInteger({bigint:t}),r=new Cr.asn1.DERInteger({bigint:e}),i=new Cr.asn1.DERSequence({array:[n,r]});return i.getEncodedHex()},/*! ecparam-1.0.0.js (c) 2013 Kenji Urushima | kjur.github.com/jsrsasign/license
		 */
	"undefined"!=typeof Cr&&Cr||(Cr={}),"undefined"!=typeof Cr.crypto&&Cr.crypto||(Cr.crypto={}),Cr.crypto.ECParameterDB=new function(){function t(t){return new o(t,16)}var e={},n={};this.getByName=function(t){var r=t;if("undefined"!=typeof n[r]&&(r=n[t]),"undefined"!=typeof e[r])return e[r];throw"unregistered EC curve name: "+r},this.regist=function(r,i,s,o,a,u,h,c,f,l,d,p){e[r]={};var g=t(s),y=t(o),v=t(a),m=t(u),S=t(h),b=new Xe(g,y,v),w=b.decodePointHex("04"+c+f);e[r].name=r,e[r].keylen=i,e[r].curve=b,e[r].G=w,e[r].n=m,e[r].h=S,e[r].oid=d,e[r].info=p;for(var E=0;E<l.length;E++)n[l[E]]=r}},Cr.crypto.ECParameterDB.regist("secp128r1",128,"FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFF","FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFC","E87579C11079F43DD824993C2CEE5ED3","FFFFFFFE0000000075A30D1B9038A115","1","161FF7528B899B2D0C28607CA52C5B86","CF5AC8395BAFEB13C02DA292DDED7A83",[],"","secp128r1 : SECG curve over a 128 bit prime field"),Cr.crypto.ECParameterDB.regist("secp160k1",160,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFAC73","0","7","0100000000000000000001B8FA16DFAB9ACA16B6B3","1","3B4C382CE37AA192A4019E763036F4F5DD4D7EBB","938CF935318FDCED6BC28286531733C3F03C4FEE",[],"","secp160k1 : SECG curve over a 160 bit prime field"),Cr.crypto.ECParameterDB.regist("secp160r1",160,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFF","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFC","1C97BEFC54BD7A8B65ACF89F81D4D4ADC565FA45","0100000000000000000001F4C8F927AED3CA752257","1","4A96B5688EF573284664698968C38BB913CBFC82","23A628553168947D59DCC912042351377AC5FB32",[],"","secp160r1 : SECG curve over a 160 bit prime field"),Cr.crypto.ECParameterDB.regist("secp192k1",192,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFEE37","0","3","FFFFFFFFFFFFFFFFFFFFFFFE26F2FC170F69466A74DEFD8D","1","DB4FF10EC057E9AE26B07D0280B7F4341DA5D1B1EAE06C7D","9B2F2F6D9C5628A7844163D015BE86344082AA88D95E2F9D",[]),Cr.crypto.ECParameterDB.regist("secp192r1",192,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFF","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFC","64210519E59C80E70FA7E9AB72243049FEB8DEECC146B9B1","FFFFFFFFFFFFFFFFFFFFFFFF99DEF836146BC9B1B4D22831","1","188DA80EB03090F67CBF20EB43A18800F4FF0AFD82FF1012","07192B95FFC8DA78631011ED6B24CDD573F977A11E794811",[]),Cr.crypto.ECParameterDB.regist("secp224r1",224,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000000000000000001","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFFFFFFFFFE","B4050A850C04B3ABF54132565044B0B7D7BFD8BA270B39432355FFB4","FFFFFFFFFFFFFFFFFFFFFFFFFFFF16A2E0B8F03E13DD29455C5C2A3D","1","B70E0CBD6BB4BF7F321390B94A03C1D356C21122343280D6115C1D21","BD376388B5F723FB4C22DFE6CD4375A05A07476444D5819985007E34",[]),Cr.crypto.ECParameterDB.regist("secp256k1",256,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFC2F","0","7","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141","1","79BE667EF9DCBBAC55A06295CE870B07029BFCDB2DCE28D959F2815B16F81798","483ADA7726A3C4655DA4FBFC0E1108A8FD17B448A68554199C47D08FFB10D4B8",[]),Cr.crypto.ECParameterDB.regist("secp256r1",256,"FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFF","FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFC","5AC635D8AA3A93E7B3EBBD55769886BC651D06B0CC53B0F63BCE3C3E27D2604B","FFFFFFFF00000000FFFFFFFFFFFFFFFFBCE6FAADA7179E84F3B9CAC2FC632551","1","6B17D1F2E12C4247F8BCE6E563A440F277037D812DEB33A0F4A13945D898C296","4FE342E2FE1A7F9B8EE7EB4A7C0F9E162BCE33576B315ECECBB6406837BF51F5",["NIST P-256","P-256","prime256v1"]),Cr.crypto.ECParameterDB.regist("secp384r1",384,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFF","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFC","B3312FA7E23EE7E4988E056BE3F82D19181D9C6EFE8141120314088F5013875AC656398D8A2ED19D2A85C8EDD3EC2AEF","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC7634D81F4372DDF581A0DB248B0A77AECEC196ACCC52973","1","AA87CA22BE8B05378EB1C71EF320AD746E1D3B628BA79B9859F741E082542A385502F25DBF55296C3A545E3872760AB7","3617de4a96262c6f5d9e98bf9292dc29f8f41dbd289a147ce9da3113b5f0b8c00a60b1ce1d7e819d7a431d7c90ea0e5f",["NIST P-384","P-384"]),Cr.crypto.ECParameterDB.regist("secp521r1",521,"1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF","1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC","051953EB9618E1C9A1F929A21A0B68540EEA2DA725B99B315F3B8B489918EF109E156193951EC7E937B1652C0BD3BB1BF073573DF883D2C34F1EF451FD46B503F00","1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFA51868783BF2F966B7FCC0148F709A5D03BB5C9B8899C47AEBB6FB71E91386409","1","C6858E06B70404E9CD9E3ECB662395B4429C648139053FB521F828AF606B4D3DBAA14B5E77EFE75928FE1DC127A2FFA8DE3348B3C1856A429BF97E7E31C2E5BD66","011839296a789a3bc0045c8a5fb42c7d1bd998f54449579b446817afbd17273e662c97ee72995ef42640c550b9013fad0761353c7086a272c24088be94769fd16650",["NIST P-521","P-521"]),/*! dsa-modified-1.0.1.js (c) Recurity Labs GmbH, Kenji Urushimma | github.com/openpgpjs/openpgpjs/blob/master/LICENSE
		 */
	"undefined"!=typeof Cr&&Cr||(Cr={}),"undefined"!=typeof Cr.crypto&&Cr.crypto||(Cr.crypto={}),Cr.crypto.DSA=function(){function t(t,e,n,i,s,a){var u=Cr.crypto.Util.hashString(e,t.toLowerCase()),u=u.substr(0,s.bitLength()/4),h=new o(u,16),c=r(o.ONE.add(o.ONE),s.subtract(o.ONE)),f=n.modPow(c,i).mod(s),l=c.modInverse(s).multiply(h.add(a.multiply(f))).mod(s),d=new Array;return d[0]=f,d[1]=l,d}function e(t){var e=openpgp.config.config.prefer_hash_algorithm;switch(Math.round(t.bitLength()/8)){case 20:return 2!=e&&e>11&&10!=e&&e<8?2:e;case 28:return e>11&&e<8?11:e;case 32:return e>10&&e<8?8:e;default:return util.print_debug("DSA select hash algorithm: returning null for an unknown length of q"),null}}function n(t,e,n,r,i,s,a,u){var h=Cr.crypto.Util.hashString(r,t.toLowerCase()),h=h.substr(0,s.bitLength()/4),c=new o(h,16);if(o.ZERO.compareTo(e)>0||e.compareTo(s)>0||o.ZERO.compareTo(n)>0||n.compareTo(s)>0)return util.print_error("invalid DSA Signature"),null;var f=n.modInverse(s),l=c.multiply(f).mod(s),d=e.multiply(f).mod(s),p=a.modPow(l,i).multiply(u.modPow(d,i)).mod(i).mod(s);return 0==p.compareTo(e)}function r(t,e){if(!(e.compareTo(t)<=0)){for(var n=e.subtract(t),r=i(n.bitLength());r>n;)r=i(n.bitLength());return t.add(r)}}function i(t){if(t<0)return null;var e=Math.floor((t+7)/8),n=s(e);return t%8>0&&(n=String.fromCharCode(Math.pow(2,t%8)-1&n.charCodeAt(0))+n.substring(1)),new o(u(n),16)}function s(t){for(var e="",n=0;n<t;n++)e+=String.fromCharCode(a());return e}function a(){var t=new Uint32Array(1);return ir.crypto.getRandomValues(t),255&t[0]}function u(t){if(null==t)return"";for(var e,n=[],r=t.length,i=0;i<r;){for(e=t[i++].charCodeAt().toString(16);e.length<2;)e="0"+e;n.push(""+e)}return n.join("")}this.p=null,this.q=null,this.g=null,this.y=null,this.x=null,this.type="DSA",this.setPrivate=function(t,e,n,r,i){this.isPrivate=!0,this.p=t,this.q=e,this.g=n,this.y=r,this.x=i},this.setPublic=function(t,e,n,r){this.isPublic=!0,this.p=t,this.q=e,this.g=n,this.y=r,this.x=null},this.signWithMessageHash=function(t){var e=this.p,n=this.q,i=this.g,s=(this.y,this.x),a=(t.substr(0,n.bitLength()/4),new o(t,16)),u=r(o.ONE.add(o.ONE),n.subtract(o.ONE)),h=i.modPow(u,e).mod(n),c=u.modInverse(n).multiply(a.add(s.multiply(h))).mod(n),f=Cr.asn1.ASN1Util.jsonToASN1HEX({seq:[{int:{bigint:h}},{int:{bigint:c}}]});return f},this.verifyWithMessageHash=function(t,e){var n=this.p,r=this.q,i=this.g,s=this.y,a=this.parseASN1Signature(e),u=a[0],h=a[1],t=t.substr(0,r.bitLength()/4),c=new o(t,16);if(o.ZERO.compareTo(u)>0||u.compareTo(r)>0||o.ZERO.compareTo(h)>0||h.compareTo(r)>0)throw"invalid DSA signature";var f=h.modInverse(r),l=c.multiply(f).mod(r),d=u.multiply(f).mod(r),p=i.modPow(l,n).multiply(s.modPow(d,n)).mod(n).mod(r);return 0==p.compareTo(u)},this.parseASN1Signature=function(t){try{var e=new o(Or.getVbyList(t,0,[0],"02"),16),n=new o(Or.getVbyList(t,0,[1],"02"),16);return[e,n]}catch(t){throw"malformed DSA signature"}},this.select_hash_algorithm=e,this.sign=t,this.verify=n,this.getRandomBigIntegerInRange=r,this.getRandomBigInteger=i,this.getRandomBytes=s};/*! pkcs5pkey-1.0.6.js (c) 2013-2014 Kenji Urushima | kjur.github.com/jsrsasign/license
		 */
	var jr=function(){var t=function(t,e,r){return n(or.AES,t,e,r)},e=function(t,e,r){return n(or.TripleDES,t,e,r)},n=function(t,e,n,r){var i=or.enc.Hex.parse(e),s=or.enc.Hex.parse(n),o=or.enc.Hex.parse(r),a={};a.key=s,a.iv=o,a.ciphertext=i;var u=t.decrypt(a,s,{iv:o});return or.enc.Hex.stringify(u)},r=function(t,e,n){return o(or.AES,t,e,n)},s=function(t,e,n){return o(or.TripleDES,t,e,n)},o=function(t,e,n,r){var i=or.enc.Hex.parse(e),s=or.enc.Hex.parse(n),o=or.enc.Hex.parse(r),a=t.encrypt(i,s,{iv:o}),u=or.enc.Hex.parse(a.toString()),h=or.enc.Base64.stringify(u);return h},a={"AES-256-CBC":{proc:t,eproc:r,keylen:32,ivlen:16},"AES-192-CBC":{proc:t,eproc:r,keylen:24,ivlen:16},"AES-128-CBC":{proc:t,eproc:r,keylen:16,ivlen:16},"DES-EDE3-CBC":{proc:e,eproc:s,keylen:24,ivlen:8}},u=function(t){return a[t].proc},h=function(t){var e=or.lib.WordArray.random(t),n=or.enc.Hex.stringify(e);return n},c=function(t){var e={};t.match(new RegExp("DEK-Info: ([^,]+),([0-9A-Fa-f]+)","m"))&&(e.cipher=RegExp.$1,e.ivsalt=RegExp.$2),t.match(new RegExp("-----BEGIN ([A-Z]+) PRIVATE KEY-----"))&&(e.type=RegExp.$1);var n=-1,r=0;t.indexOf("\r\n\r\n")!=-1&&(n=t.indexOf("\r\n\r\n"),r=2),t.indexOf("\n\n")!=-1&&(n=t.indexOf("\n\n"),r=1);var i=t.indexOf("-----END");if(n!=-1&&i!=-1){var s=t.substring(n+2*r,i-r);s=s.replace(/\s+/g,""),e.data=s}return e},f=function(t,e,n){for(var r=n.substring(0,16),i=or.enc.Hex.parse(r),s=or.enc.Utf8.parse(e),o=a[t].keylen+a[t].ivlen,u="",h=null;;){var c=or.algo.MD5.create();if(null!=h&&c.update(h),c.update(s),c.update(i),h=c.finalize(),u+=or.enc.Hex.stringify(h),u.length>=2*o)break}var f={};return f.keyhex=u.substr(0,2*a[t].keylen),f.ivhex=u.substr(2*a[t].keylen,2*a[t].ivlen),f},l=function(t,e,n,r){var i=or.enc.Base64.parse(t),s=or.enc.Hex.stringify(i),o=a[e].proc,u=o(s,n,r);return u},d=function(t,e,n,r){var i=a[e].eproc,s=i(t,n,r);return s};return{version:"1.0.5",getHexFromPEM:function(t,e){var n=t;if(n.indexOf("BEGIN "+e)==-1)throw"can't find PEM header: "+e;n=n.replace("-----BEGIN "+e+"-----",""),n=n.replace("-----END "+e+"-----","");var r=n.replace(/\s+/g,""),s=i(r);return s},getDecryptedKeyHexByKeyIV:function(t,e,n,r){var i=u(e);return i(t,n,r)},parsePKCS5PEM:function(t){return c(t)},getKeyAndUnusedIvByPasscodeAndIvsalt:function(t,e,n){return f(t,e,n)},decryptKeyB64:function(t,e,n,r){return l(t,e,n,r)},getDecryptedKeyHex:function(t,e){var n=c(t),r=(n.type,n.cipher),i=n.ivsalt,s=n.data,o=f(r,e,i),a=o.keyhex,u=l(s,r,a,i);return u},getRSAKeyFromEncryptedPKCS5PEM:function(t,e){var n=this.getDecryptedKeyHex(t,e),r=new ve;return r.readPrivateKeyFromASN1HexString(n),r},getEryptedPKCS5PEMFromPrvKeyHex:function(t,e,n,r){var i="";if("undefined"!=typeof n&&null!=n||(n="AES-256-CBC"),"undefined"==typeof a[n])throw"PKCS5PKEY unsupported algorithm: "+n;if("undefined"==typeof r||null==r){var s=a[n].ivlen,o=h(s);r=o.toUpperCase()}var u=f(n,e,r),c=u.keyhex,l=d(t,n,c,r),p=l.replace(/(.{64})/g,"$1\r\n"),i="-----BEGIN RSA PRIVATE KEY-----\r\n";return i+="Proc-Type: 4,ENCRYPTED\r\n",i+="DEK-Info: "+n+","+r+"\r\n",i+="\r\n",i+=p,i+="\r\n-----END RSA PRIVATE KEY-----\r\n"},getEryptedPKCS5PEMFromRSAKey:function(t,e,n,r){var i=new Cr.asn1.DERInteger({int:0}),s=new Cr.asn1.DERInteger({bigint:t.n}),o=new Cr.asn1.DERInteger({int:t.e}),a=new Cr.asn1.DERInteger({bigint:t.d}),u=new Cr.asn1.DERInteger({bigint:t.p}),h=new Cr.asn1.DERInteger({bigint:t.q}),c=new Cr.asn1.DERInteger({bigint:t.dmp1}),f=new Cr.asn1.DERInteger({bigint:t.dmq1}),l=new Cr.asn1.DERInteger({bigint:t.coeff}),d=new Cr.asn1.DERSequence({array:[i,s,o,a,u,h,c,f,l]}),p=d.getEncodedHex();return this.getEryptedPKCS5PEMFromPrvKeyHex(p,e,n,r)},newEncryptedPKCS5PEM:function(t,e,n,r){"undefined"!=typeof e&&null!=e||(e=1024),"undefined"!=typeof n&&null!=n||(n="10001");var i=new ve;i.generate(e,n);var s=null;return s="undefined"==typeof r||null==r?this.getEncryptedPKCS5PEMFromRSAKey(pkey,t):this.getEncryptedPKCS5PEMFromRSAKey(pkey,t,r)},getRSAKeyFromPlainPKCS8PEM:function(t){if(t.match(/ENCRYPTED/))throw"pem shall be not ENCRYPTED";var e=this.getHexFromPEM(t,"PRIVATE KEY"),n=this.getRSAKeyFromPlainPKCS8Hex(e);return n},getRSAKeyFromPlainPKCS8Hex:function(t){var e=Or.getPosArrayOfChildren_AtObj(t,0);if(3!=e.length)throw"outer DERSequence shall have 3 elements: "+e.length;var n=Or.getHexOfTLV_AtObj(t,e[1]);if("300d06092a864886f70d0101010500"!=n)throw"PKCS8 AlgorithmIdentifier is not rsaEnc: "+n;var n=Or.getHexOfTLV_AtObj(t,e[1]),r=Or.getHexOfTLV_AtObj(t,e[2]),i=Or.getHexOfV_AtObj(r,0),s=new ve;return s.readPrivateKeyFromASN1HexString(i),s},parseHexOfEncryptedPKCS8:function(t){var e={},n=Or.getPosArrayOfChildren_AtObj(t,0);if(2!=n.length)throw"malformed format: SEQUENCE(0).items != 2: "+n.length;e.ciphertext=Or.getHexOfV_AtObj(t,n[1]);var r=Or.getPosArrayOfChildren_AtObj(t,n[0]);if(2!=r.length)throw"malformed format: SEQUENCE(0.0).items != 2: "+r.length;if("2a864886f70d01050d"!=Or.getHexOfV_AtObj(t,r[0]))throw"this only supports pkcs5PBES2";var i=Or.getPosArrayOfChildren_AtObj(t,r[1]);if(2!=r.length)throw"malformed format: SEQUENCE(0.0.1).items != 2: "+i.length;var s=Or.getPosArrayOfChildren_AtObj(t,i[1]);if(2!=s.length)throw"malformed format: SEQUENCE(0.0.1.1).items != 2: "+s.length;if("2a864886f70d0307"!=Or.getHexOfV_AtObj(t,s[0]))throw"this only supports TripleDES";e.encryptionSchemeAlg="TripleDES",e.encryptionSchemeIV=Or.getHexOfV_AtObj(t,s[1]);var o=Or.getPosArrayOfChildren_AtObj(t,i[0]);if(2!=o.length)throw"malformed format: SEQUENCE(0.0.1.0).items != 2: "+o.length;if("2a864886f70d01050c"!=Or.getHexOfV_AtObj(t,o[0]))throw"this only supports pkcs5PBKDF2";var a=Or.getPosArrayOfChildren_AtObj(t,o[1]);if(a.length<2)throw"malformed format: SEQUENCE(0.0.1.0.1).items < 2: "+a.length;e.pbkdf2Salt=Or.getHexOfV_AtObj(t,a[0]);var u=Or.getHexOfV_AtObj(t,a[1]);try{e.pbkdf2Iter=parseInt(u,16)}catch(t){throw"malformed format pbkdf2Iter: "+u}return e},getPBKDF2KeyHexFromParam:function(t,e){var n=or.enc.Hex.parse(t.pbkdf2Salt),r=t.pbkdf2Iter,i=or.PBKDF2(e,n,{keySize:6,iterations:r}),s=or.enc.Hex.stringify(i);return s},getPlainPKCS8HexFromEncryptedPKCS8PEM:function(t,e){var n=this.getHexFromPEM(t,"ENCRYPTED PRIVATE KEY"),r=this.parseHexOfEncryptedPKCS8(n),i=jr.getPBKDF2KeyHexFromParam(r,e),s={};s.ciphertext=or.enc.Hex.parse(r.ciphertext);var o=or.enc.Hex.parse(i),a=or.enc.Hex.parse(r.encryptionSchemeIV),u=or.TripleDES.decrypt(s,o,{iv:a}),h=or.enc.Hex.stringify(u);return h},getRSAKeyFromEncryptedPKCS8PEM:function(t,e){var n=this.getPlainPKCS8HexFromEncryptedPKCS8PEM(t,e),r=this.getRSAKeyFromPlainPKCS8Hex(n);return r},getKeyFromEncryptedPKCS8PEM:function(t,e){var n=this.getPlainPKCS8HexFromEncryptedPKCS8PEM(t,e),r=this.getKeyFromPlainPrivatePKCS8Hex(n);return r},parsePlainPrivatePKCS8Hex:function(t){var e={};if(e.algparam=null,"30"!=t.substr(0,2))throw"malformed plain PKCS8 private key(code:001)";var n=Or.getPosArrayOfChildren_AtObj(t,0);if(3!=n.length)throw"malformed plain PKCS8 private key(code:002)";if("30"!=t.substr(n[1],2))throw"malformed PKCS8 private key(code:003)";var r=Or.getPosArrayOfChildren_AtObj(t,n[1]);if(2!=r.length)throw"malformed PKCS8 private key(code:004)";if("06"!=t.substr(r[0],2))throw"malformed PKCS8 private key(code:005)";if(e.algoid=Or.getHexOfV_AtObj(t,r[0]),"06"==t.substr(r[1],2)&&(e.algparam=Or.getHexOfV_AtObj(t,r[1])),"04"!=t.substr(n[2],2))throw"malformed PKCS8 private key(code:006)";return e.keyidx=Or.getStartPosOfV_AtObj(t,n[2]),e},getKeyFromPlainPrivatePKCS8PEM:function(t){var e=this.getHexFromPEM(t,"PRIVATE KEY"),n=this.getKeyFromPlainPrivatePKCS8Hex(e);return n},getKeyFromPlainPrivatePKCS8Hex:function(t){var e=this.parsePlainPrivatePKCS8Hex(t);if("2a864886f70d010101"==e.algoid){this.parsePrivateRawRSAKeyHexAtObj(t,e);var n=e.key,r=new ve;return r.setPrivateEx(n.n,n.e,n.d,n.p,n.q,n.dp,n.dq,n.co),r}if("2a8648ce3d0201"==e.algoid){if(this.parsePrivateRawECKeyHexAtObj(t,e),void 0===Cr.crypto.OID.oidhex2name[e.algparam])throw"KJUR.crypto.OID.oidhex2name undefined: "+e.algparam;var i=Cr.crypto.OID.oidhex2name[e.algparam],r=new Cr.crypto.ECDSA({curve:i,prv:e.key});return r}throw"unsupported private key algorithm"},getRSAKeyFromPublicPKCS8PEM:function(t){var e=this.getHexFromPEM(t,"PUBLIC KEY"),n=this.getRSAKeyFromPublicPKCS8Hex(e);return n},getKeyFromPublicPKCS8PEM:function(t){var e=this.getHexFromPEM(t,"PUBLIC KEY"),n=this.getKeyFromPublicPKCS8Hex(e);return n},getKeyFromPublicPKCS8Hex:function(t){var e=this.parsePublicPKCS8Hex(t);if("2a864886f70d010101"==e.algoid){var n=this.parsePublicRawRSAKeyHex(e.key),r=new ve;return r.setPublic(n.n,n.e),r}if("2a8648ce3d0201"==e.algoid){if(void 0===Cr.crypto.OID.oidhex2name[e.algparam])throw"KJUR.crypto.OID.oidhex2name undefined: "+e.algparam;var i=Cr.crypto.OID.oidhex2name[e.algparam],r=new Cr.crypto.ECDSA({curve:i,pub:e.key});return r}throw"unsupported public key algorithm"},parsePublicRawRSAKeyHex:function(t){var e={};if("30"!=t.substr(0,2))throw"malformed RSA key(code:001)";var n=Or.getPosArrayOfChildren_AtObj(t,0);if(2!=n.length)throw"malformed RSA key(code:002)";if("02"!=t.substr(n[0],2))throw"malformed RSA key(code:003)";if(e.n=Or.getHexOfV_AtObj(t,n[0]),"02"!=t.substr(n[1],2))throw"malformed RSA key(code:004)";return e.e=Or.getHexOfV_AtObj(t,n[1]),e},parsePrivateRawRSAKeyHexAtObj:function(t,e){var n=e.keyidx;if("30"!=t.substr(n,2))throw"malformed RSA private key(code:001)";var r=Or.getPosArrayOfChildren_AtObj(t,n);if(9!=r.length)throw"malformed RSA private key(code:002)";e.key={},e.key.n=Or.getHexOfV_AtObj(t,r[1]),e.key.e=Or.getHexOfV_AtObj(t,r[2]),e.key.d=Or.getHexOfV_AtObj(t,r[3]),e.key.p=Or.getHexOfV_AtObj(t,r[4]),e.key.q=Or.getHexOfV_AtObj(t,r[5]),e.key.dp=Or.getHexOfV_AtObj(t,r[6]),e.key.dq=Or.getHexOfV_AtObj(t,r[7]),e.key.co=Or.getHexOfV_AtObj(t,r[8])},parsePrivateRawECKeyHexAtObj:function(t,e){var n=e.keyidx;if("30"!=t.substr(n,2))throw"malformed ECC private key(code:001)";var r=Or.getPosArrayOfChildren_AtObj(t,n);if(3!=r.length)throw"malformed ECC private key(code:002)";if("04"!=t.substr(r[1],2))throw"malformed ECC private key(code:003)";e.key=Or.getHexOfV_AtObj(t,r[1])},parsePublicPKCS8Hex:function(t){var e={};e.algparam=null;var n=Or.getPosArrayOfChildren_AtObj(t,0);if(2!=n.length)throw"outer DERSequence shall have 2 elements: "+n.length;var r=n[0];if("30"!=t.substr(r,2))throw"malformed PKCS8 public key(code:001)";var i=Or.getPosArrayOfChildren_AtObj(t,r);if(2!=i.length)throw"malformed PKCS8 public key(code:002)";if("06"!=t.substr(i[0],2))throw"malformed PKCS8 public key(code:003)";if(e.algoid=Or.getHexOfV_AtObj(t,i[0]),"06"==t.substr(i[1],2)&&(e.algparam=Or.getHexOfV_AtObj(t,i[1])),"03"!=t.substr(n[1],2))throw"malformed PKCS8 public key(code:004)";return e.key=Or.getHexOfV_AtObj(t,n[1]).substr(2),e},getRSAKeyFromPublicPKCS8Hex:function(t){var e=Or.getPosArrayOfChildren_AtObj(t,0);if(2!=e.length)throw"outer DERSequence shall have 2 elements: "+e.length;var n=Or.getHexOfTLV_AtObj(t,e[0]);if("300d06092a864886f70d0101010500"!=n)throw"PKCS8 AlgorithmId is not rsaEncryption";if("03"!=t.substr(e[1],2))throw"PKCS8 Public Key is not BITSTRING encapslated.";var r=Or.getStartPosOfV_AtObj(t,e[1])+2;if("30"!=t.substr(r,2))throw"PKCS8 Public Key is not SEQUENCE.";var i=Or.getPosArrayOfChildren_AtObj(t,r);if(2!=i.length)throw"inner DERSequence shall have 2 elements: "+i.length;if("02"!=t.substr(i[0],2))throw"N is not ASN.1 INTEGER";if("02"!=t.substr(i[1],2))throw"E is not ASN.1 INTEGER";var s=Or.getHexOfV_AtObj(t,i[0]),o=Or.getHexOfV_AtObj(t,i[1]),a=new ve;return a.setPublic(s,o),a}}}(),Rr=function(){var t=function(t,e,n){return r(or.AES,t,e,n)},e=function(t,e,n){return r(or.TripleDES,t,e,n)},n=function(t,e,n){return r(or.DES,t,e,n)},r=function(t,e,n,r){var i=or.enc.Hex.parse(e),s=or.enc.Hex.parse(n),o=or.enc.Hex.parse(r),a={};a.key=s,a.iv=o,a.ciphertext=i;var u=t.decrypt(a,s,{iv:o});return or.enc.Hex.stringify(u)},s=function(t,e,n){return h(or.AES,t,e,n)},a=function(t,e,n){return h(or.TripleDES,t,e,n)},u=function(t,e,n){return h(or.DES,t,e,n)},h=function(t,e,n,r){var i=or.enc.Hex.parse(e),s=or.enc.Hex.parse(n),o=or.enc.Hex.parse(r),a=t.encrypt(i,s,{iv:o}),u=or.enc.Hex.parse(a.toString()),h=or.enc.Base64.stringify(u);return h},c={"AES-256-CBC":{proc:t,eproc:s,keylen:32,ivlen:16},"AES-192-CBC":{proc:t,eproc:s,keylen:24,ivlen:16},"AES-128-CBC":{proc:t,eproc:s,keylen:16,ivlen:16},"DES-EDE3-CBC":{proc:e,eproc:a,keylen:24,ivlen:8},"DES-CBC":{proc:n,eproc:u,keylen:8,ivlen:8}},f=function(t){return c[t].proc},l=function(t){var e=or.lib.WordArray.random(t),n=or.enc.Hex.stringify(e);return n},d=function(t){var e={};t.match(new RegExp("DEK-Info: ([^,]+),([0-9A-Fa-f]+)","m"))&&(e.cipher=RegExp.$1,e.ivsalt=RegExp.$2),t.match(new RegExp("-----BEGIN ([A-Z]+) PRIVATE KEY-----"))&&(e.type=RegExp.$1);var n=-1,r=0;t.indexOf("\r\n\r\n")!=-1&&(n=t.indexOf("\r\n\r\n"),r=2),t.indexOf("\n\n")!=-1&&(n=t.indexOf("\n\n"),r=1);var i=t.indexOf("-----END");if(n!=-1&&i!=-1){var s=t.substring(n+2*r,i-r);s=s.replace(/\s+/g,""),e.data=s}return e},p=function(t,e,n){for(var r=n.substring(0,16),i=or.enc.Hex.parse(r),s=or.enc.Utf8.parse(e),o=c[t].keylen+c[t].ivlen,a="",u=null;;){var h=or.algo.MD5.create();if(null!=u&&h.update(u),h.update(s),h.update(i),u=h.finalize(),a+=or.enc.Hex.stringify(u),a.length>=2*o)break}var f={};return f.keyhex=a.substr(0,2*c[t].keylen),f.ivhex=a.substr(2*c[t].keylen,2*c[t].ivlen),f},g=function(t,e,n,r){var i=or.enc.Base64.parse(t),s=or.enc.Hex.stringify(i),o=c[e].proc,a=o(s,n,r);return a},y=function(t,e,n,r){var i=c[e].eproc,s=i(t,n,r);return s};return{version:"1.0.0",getHexFromPEM:function(t,e){var n=t;if(n.indexOf("-----BEGIN ")==-1)throw"can't find PEM header: "+e;"string"==typeof e&&""!=e?(n=n.replace("-----BEGIN "+e+"-----",""),n=n.replace("-----END "+e+"-----","")):(n=n.replace(/-----BEGIN [^-]+-----/,""),n=n.replace(/-----END [^-]+-----/,""));var r=n.replace(/\s+/g,""),s=i(r);return s},getDecryptedKeyHexByKeyIV:function(t,e,n,r){var i=f(e);return i(t,n,r)},parsePKCS5PEM:function(t){return d(t)},getKeyAndUnusedIvByPasscodeAndIvsalt:function(t,e,n){return p(t,e,n)},decryptKeyB64:function(t,e,n,r){return g(t,e,n,r)},getDecryptedKeyHex:function(t,e){var n=d(t),r=(n.type,n.cipher),i=n.ivsalt,s=n.data,o=p(r,e,i),a=o.keyhex,u=g(s,r,a,i);return u},getRSAKeyFromEncryptedPKCS5PEM:function(t,e){var n=this.getDecryptedKeyHex(t,e),r=new ve;return r.readPrivateKeyFromASN1HexString(n),r},getEncryptedPKCS5PEMFromPrvKeyHex:function(t,e,n,r,i){var s="";if("undefined"!=typeof r&&null!=r||(r="AES-256-CBC"),"undefined"==typeof c[r])throw"KEYUTIL unsupported algorithm: "+r;if("undefined"==typeof i||null==i){var o=c[r].ivlen,a=l(o);i=a.toUpperCase()}var u=p(r,n,i),h=u.keyhex,f=y(e,r,h,i),d=f.replace(/(.{64})/g,"$1\r\n"),s="-----BEGIN "+t+" PRIVATE KEY-----\r\n";return s+="Proc-Type: 4,ENCRYPTED\r\n",s+="DEK-Info: "+r+","+i+"\r\n",s+="\r\n",s+=d,s+="\r\n-----END "+t+" PRIVATE KEY-----\r\n"},getEncryptedPKCS5PEMFromRSAKey:function(t,e,n,r){var i=new Cr.asn1.DERInteger({int:0}),s=new Cr.asn1.DERInteger({bigint:t.n}),o=new Cr.asn1.DERInteger({int:t.e}),a=new Cr.asn1.DERInteger({bigint:t.d}),u=new Cr.asn1.DERInteger({bigint:t.p}),h=new Cr.asn1.DERInteger({bigint:t.q}),c=new Cr.asn1.DERInteger({bigint:t.dmp1}),f=new Cr.asn1.DERInteger({bigint:t.dmq1}),l=new Cr.asn1.DERInteger({bigint:t.coeff}),d=new Cr.asn1.DERSequence({array:[i,s,o,a,u,h,c,f,l]}),p=d.getEncodedHex();return this.getEncryptedPKCS5PEMFromPrvKeyHex("RSA",p,e,n,r)},newEncryptedPKCS5PEM:function(t,e,n,r){"undefined"!=typeof e&&null!=e||(e=1024),"undefined"!=typeof n&&null!=n||(n="10001");var i=new ve;i.generate(e,n);var s=null;return s="undefined"==typeof r||null==r?this.getEncryptedPKCS5PEMFromRSAKey(i,t):this.getEncryptedPKCS5PEMFromRSAKey(i,t,r)},getRSAKeyFromPlainPKCS8PEM:function(t){if(t.match(/ENCRYPTED/))throw"pem shall be not ENCRYPTED";var e=this.getHexFromPEM(t,"PRIVATE KEY"),n=this.getRSAKeyFromPlainPKCS8Hex(e);return n},getRSAKeyFromPlainPKCS8Hex:function(t){var e=Or.getPosArrayOfChildren_AtObj(t,0);if(3!=e.length)throw"outer DERSequence shall have 3 elements: "+e.length;var n=Or.getHexOfTLV_AtObj(t,e[1]);if("300d06092a864886f70d0101010500"!=n)throw"PKCS8 AlgorithmIdentifier is not rsaEnc: "+n;var n=Or.getHexOfTLV_AtObj(t,e[1]),r=Or.getHexOfTLV_AtObj(t,e[2]),i=Or.getHexOfV_AtObj(r,0),s=new ve;return s.readPrivateKeyFromASN1HexString(i),s},parseHexOfEncryptedPKCS8:function(t){var e={},n=Or.getPosArrayOfChildren_AtObj(t,0);if(2!=n.length)throw"malformed format: SEQUENCE(0).items != 2: "+n.length;e.ciphertext=Or.getHexOfV_AtObj(t,n[1]);var r=Or.getPosArrayOfChildren_AtObj(t,n[0]);if(2!=r.length)throw"malformed format: SEQUENCE(0.0).items != 2: "+r.length;if("2a864886f70d01050d"!=Or.getHexOfV_AtObj(t,r[0]))throw"this only supports pkcs5PBES2";var i=Or.getPosArrayOfChildren_AtObj(t,r[1]);if(2!=r.length)throw"malformed format: SEQUENCE(0.0.1).items != 2: "+i.length;var s=Or.getPosArrayOfChildren_AtObj(t,i[1]);if(2!=s.length)throw"malformed format: SEQUENCE(0.0.1.1).items != 2: "+s.length;if("2a864886f70d0307"!=Or.getHexOfV_AtObj(t,s[0]))throw"this only supports TripleDES";e.encryptionSchemeAlg="TripleDES",e.encryptionSchemeIV=Or.getHexOfV_AtObj(t,s[1]);var o=Or.getPosArrayOfChildren_AtObj(t,i[0]);if(2!=o.length)throw"malformed format: SEQUENCE(0.0.1.0).items != 2: "+o.length;if("2a864886f70d01050c"!=Or.getHexOfV_AtObj(t,o[0]))throw"this only supports pkcs5PBKDF2";var a=Or.getPosArrayOfChildren_AtObj(t,o[1]);if(a.length<2)throw"malformed format: SEQUENCE(0.0.1.0.1).items < 2: "+a.length;e.pbkdf2Salt=Or.getHexOfV_AtObj(t,a[0]);var u=Or.getHexOfV_AtObj(t,a[1]);try{e.pbkdf2Iter=parseInt(u,16)}catch(t){throw"malformed format pbkdf2Iter: "+u}return e},getPBKDF2KeyHexFromParam:function(t,e){var n=or.enc.Hex.parse(t.pbkdf2Salt),r=t.pbkdf2Iter,i=or.PBKDF2(e,n,{keySize:6,iterations:r}),s=or.enc.Hex.stringify(i);return s},getPlainPKCS8HexFromEncryptedPKCS8PEM:function(t,e){var n=this.getHexFromPEM(t,"ENCRYPTED PRIVATE KEY"),r=this.parseHexOfEncryptedPKCS8(n),i=Rr.getPBKDF2KeyHexFromParam(r,e),s={};s.ciphertext=or.enc.Hex.parse(r.ciphertext);var o=or.enc.Hex.parse(i),a=or.enc.Hex.parse(r.encryptionSchemeIV),u=or.TripleDES.decrypt(s,o,{iv:a}),h=or.enc.Hex.stringify(u);return h},getRSAKeyFromEncryptedPKCS8PEM:function(t,e){var n=this.getPlainPKCS8HexFromEncryptedPKCS8PEM(t,e),r=this.getRSAKeyFromPlainPKCS8Hex(n);return r},getKeyFromEncryptedPKCS8PEM:function(t,e){var n=this.getPlainPKCS8HexFromEncryptedPKCS8PEM(t,e),r=this.getKeyFromPlainPrivatePKCS8Hex(n);return r},parsePlainPrivatePKCS8Hex:function(t){var e={};if(e.algparam=null,"30"!=t.substr(0,2))throw"malformed plain PKCS8 private key(code:001)";var n=Or.getPosArrayOfChildren_AtObj(t,0);if(3!=n.length)throw"malformed plain PKCS8 private key(code:002)";if("30"!=t.substr(n[1],2))throw"malformed PKCS8 private key(code:003)";var r=Or.getPosArrayOfChildren_AtObj(t,n[1]);if(2!=r.length)throw"malformed PKCS8 private key(code:004)";if("06"!=t.substr(r[0],2))throw"malformed PKCS8 private key(code:005)";if(e.algoid=Or.getHexOfV_AtObj(t,r[0]),"06"==t.substr(r[1],2)&&(e.algparam=Or.getHexOfV_AtObj(t,r[1])),"04"!=t.substr(n[2],2))throw"malformed PKCS8 private key(code:006)";return e.keyidx=Or.getStartPosOfV_AtObj(t,n[2]),e},getKeyFromPlainPrivatePKCS8PEM:function(t){var e=this.getHexFromPEM(t,"PRIVATE KEY"),n=this.getKeyFromPlainPrivatePKCS8Hex(e);return n},getKeyFromPlainPrivatePKCS8Hex:function(t){var e=this.parsePlainPrivatePKCS8Hex(t);if("2a864886f70d010101"==e.algoid){this.parsePrivateRawRSAKeyHexAtObj(t,e);var n=e.key,r=new ve;return r.setPrivateEx(n.n,n.e,n.d,n.p,n.q,n.dp,n.dq,n.co),r}if("2a8648ce3d0201"==e.algoid){if(this.parsePrivateRawECKeyHexAtObj(t,e),void 0===Cr.crypto.OID.oidhex2name[e.algparam])throw"KJUR.crypto.OID.oidhex2name undefined: "+e.algparam;var i=Cr.crypto.OID.oidhex2name[e.algparam],r=new Cr.crypto.ECDSA({curve:i});return r.setPublicKeyHex(e.pubkey),r.setPrivateKeyHex(e.key),r.isPublic=!1,r}if("2a8648ce380401"==e.algoid){var s=Or.getVbyList(t,0,[1,1,0],"02"),a=Or.getVbyList(t,0,[1,1,1],"02"),u=Or.getVbyList(t,0,[1,1,2],"02"),h=Or.getVbyList(t,0,[2,0],"02"),c=new o(s,16),f=new o(a,16),l=new o(u,16),d=new o(h,16),r=new Cr.crypto.DSA;return r.setPrivate(c,f,l,null,d),r}throw"unsupported private key algorithm"},getRSAKeyFromPublicPKCS8PEM:function(t){var e=this.getHexFromPEM(t,"PUBLIC KEY"),n=this.getRSAKeyFromPublicPKCS8Hex(e);return n},getKeyFromPublicPKCS8PEM:function(t){var e=this.getHexFromPEM(t,"PUBLIC KEY"),n=this.getKeyFromPublicPKCS8Hex(e);return n},getKeyFromPublicPKCS8Hex:function(t){var e=this.parsePublicPKCS8Hex(t);if("2a864886f70d010101"==e.algoid){var n=this.parsePublicRawRSAKeyHex(e.key),r=new ve;return r.setPublic(n.n,n.e),r}if("2a8648ce3d0201"==e.algoid){if(void 0===Cr.crypto.OID.oidhex2name[e.algparam])throw"KJUR.crypto.OID.oidhex2name undefined: "+e.algparam;var i=Cr.crypto.OID.oidhex2name[e.algparam],r=new Cr.crypto.ECDSA({curve:i,pub:e.key});return r}if("2a8648ce380401"==e.algoid){var s=e.algparam,a=Or.getHexOfV_AtObj(e.key,0),r=new Cr.crypto.DSA;return r.setPublic(new o(s.p,16),new o(s.q,16),new o(s.g,16),new o(a,16)),r}throw"unsupported public key algorithm"},parsePublicRawRSAKeyHex:function(t){var e={};if("30"!=t.substr(0,2))throw"malformed RSA key(code:001)";var n=Or.getPosArrayOfChildren_AtObj(t,0);if(2!=n.length)throw"malformed RSA key(code:002)";if("02"!=t.substr(n[0],2))throw"malformed RSA key(code:003)";if(e.n=Or.getHexOfV_AtObj(t,n[0]),"02"!=t.substr(n[1],2))throw"malformed RSA key(code:004)";return e.e=Or.getHexOfV_AtObj(t,n[1]),e},parsePrivateRawRSAKeyHexAtObj:function(t,e){var n=e.keyidx;if("30"!=t.substr(n,2))throw"malformed RSA private key(code:001)";var r=Or.getPosArrayOfChildren_AtObj(t,n);if(9!=r.length)throw"malformed RSA private key(code:002)";e.key={},e.key.n=Or.getHexOfV_AtObj(t,r[1]),e.key.e=Or.getHexOfV_AtObj(t,r[2]),e.key.d=Or.getHexOfV_AtObj(t,r[3]),e.key.p=Or.getHexOfV_AtObj(t,r[4]),e.key.q=Or.getHexOfV_AtObj(t,r[5]),e.key.dp=Or.getHexOfV_AtObj(t,r[6]),e.key.dq=Or.getHexOfV_AtObj(t,r[7]),e.key.co=Or.getHexOfV_AtObj(t,r[8])},parsePrivateRawECKeyHexAtObj:function(t,e){var n=e.keyidx,r=Or.getVbyList(t,n,[1],"04"),i=Or.getVbyList(t,n,[2,0],"03").substr(2);e.key=r,e.pubkey=i},parsePublicPKCS8Hex:function(t){var e={};e.algparam=null;var n=Or.getPosArrayOfChildren_AtObj(t,0);if(2!=n.length)throw"outer DERSequence shall have 2 elements: "+n.length;var r=n[0];if("30"!=t.substr(r,2))throw"malformed PKCS8 public key(code:001)";var i=Or.getPosArrayOfChildren_AtObj(t,r);if(2!=i.length)throw"malformed PKCS8 public key(code:002)";if("06"!=t.substr(i[0],2))throw"malformed PKCS8 public key(code:003)";if(e.algoid=Or.getHexOfV_AtObj(t,i[0]),"06"==t.substr(i[1],2)?e.algparam=Or.getHexOfV_AtObj(t,i[1]):"30"==t.substr(i[1],2)&&(e.algparam={},e.algparam.p=Or.getVbyList(t,i[1],[0],"02"),e.algparam.q=Or.getVbyList(t,i[1],[1],"02"),e.algparam.g=Or.getVbyList(t,i[1],[2],"02")),"03"!=t.substr(n[1],2))throw"malformed PKCS8 public key(code:004)";return e.key=Or.getHexOfV_AtObj(t,n[1]).substr(2),e},getRSAKeyFromPublicPKCS8Hex:function(t){var e=Or.getPosArrayOfChildren_AtObj(t,0);if(2!=e.length)throw"outer DERSequence shall have 2 elements: "+e.length;var n=Or.getHexOfTLV_AtObj(t,e[0]);if("300d06092a864886f70d0101010500"!=n)throw"PKCS8 AlgorithmId is not rsaEncryption";if("03"!=t.substr(e[1],2))throw"PKCS8 Public Key is not BITSTRING encapslated.";var r=Or.getStartPosOfV_AtObj(t,e[1])+2;if("30"!=t.substr(r,2))throw"PKCS8 Public Key is not SEQUENCE.";var i=Or.getPosArrayOfChildren_AtObj(t,r);if(2!=i.length)throw"inner DERSequence shall have 2 elements: "+i.length;if("02"!=t.substr(i[0],2))throw"N is not ASN.1 INTEGER";if("02"!=t.substr(i[1],2))throw"E is not ASN.1 INTEGER";var s=Or.getHexOfV_AtObj(t,i[0]),o=Or.getHexOfV_AtObj(t,i[1]),a=new ve;return a.setPublic(s,o),a}}}();Rr.getKey=function(t,e,n){if("undefined"!=typeof ve&&t instanceof ve)return t;if("undefined"!=typeof Cr.crypto.ECDSA&&t instanceof Cr.crypto.ECDSA)return t;if("undefined"!=typeof Cr.crypto.DSA&&t instanceof Cr.crypto.DSA)return t;if(void 0!==t.curve&&void 0!==t.xy&&void 0===t.d)return new Cr.crypto.ECDSA({pub:t.xy,curve:t.curve});if(void 0!==t.curve&&void 0!==t.d)return new Cr.crypto.ECDSA({prv:t.d,curve:t.curve});if(void 0===t.kty&&void 0!==t.n&&void 0!==t.e&&void 0===t.d){var r=new ve;return r.setPublic(t.n,t.e),r}if(void 0===t.kty&&void 0!==t.n&&void 0!==t.e&&void 0!==t.d&&void 0!==t.p&&void 0!==t.q&&void 0!==t.dp&&void 0!==t.dq&&void 0!==t.co&&void 0===t.qi){var r=new ve;return r.setPrivateEx(t.n,t.e,t.d,t.p,t.q,t.dp,t.dq,t.co),r}if(void 0===t.kty&&void 0!==t.n&&void 0!==t.e&&void 0!==t.d&&void 0===t.p){var r=new ve;return r.setPrivate(t.n,t.e,t.d),r}if(void 0!==t.p&&void 0!==t.q&&void 0!==t.g&&void 0!==t.y&&void 0===t.x){var r=new Cr.crypto.DSA;return r.setPublic(t.p,t.q,t.g,t.y),r}if(void 0!==t.p&&void 0!==t.q&&void 0!==t.g&&void 0!==t.y&&void 0!==t.x){var r=new Cr.crypto.DSA;return r.setPrivate(t.p,t.q,t.g,t.y,t.x),r}if("RSA"===t.kty&&void 0!==t.n&&void 0!==t.e&&void 0===t.d){var r=new ve;return r.setPublic(gn(t.n),gn(t.e)),r}if("RSA"===t.kty&&void 0!==t.n&&void 0!==t.e&&void 0!==t.d&&void 0!==t.p&&void 0!==t.q&&void 0!==t.dp&&void 0!==t.dq&&void 0!==t.qi){var r=new ve;return r.setPrivateEx(gn(t.n),gn(t.e),gn(t.d),gn(t.p),gn(t.q),gn(t.dp),gn(t.dq),gn(t.qi)),r}if("RSA"===t.kty&&void 0!==t.n&&void 0!==t.e&&void 0!==t.d){var r=new ve;return r.setPrivate(gn(t.n),gn(t.e),gn(t.d)),r}if("EC"===t.kty&&void 0!==t.crv&&void 0!==t.x&&void 0!==t.y&&void 0===t.d){var i=new Cr.crypto.ECDSA({curve:t.crv}),s=i.ecparams.keylen/4,a=("0000000000"+gn(t.x)).slice(-s),u=("0000000000"+gn(t.y)).slice(-s),h="04"+a+u;return i.setPublicKeyHex(h),i}if("EC"===t.kty&&void 0!==t.crv&&void 0!==t.x&&void 0!==t.y&&void 0!==t.d){var i=new Cr.crypto.ECDSA({curve:t.crv}),s=i.ecparams.keylen/4,a=("0000000000"+gn(t.x)).slice(-s),u=("0000000000"+gn(t.y)).slice(-s),h="04"+a+u,c=("0000000000"+gn(t.d)).slice(-s);return i.setPublicKeyHex(h),i.setPrivateKeyHex(c),i}if(t.indexOf("-END CERTIFICATE-",0)!=-1||t.indexOf("-END X509 CERTIFICATE-",0)!=-1||t.indexOf("-END TRUSTED CERTIFICATE-",0)!=-1)return $n.getPublicKeyFromCertPEM(t);if("pkcs8pub"===n)return Rr.getKeyFromPublicPKCS8Hex(t);if(t.indexOf("-END PUBLIC KEY-")!=-1)return Rr.getKeyFromPublicPKCS8PEM(t);if("pkcs5prv"===n){var r=new ve;return r.readPrivateKeyFromASN1HexString(t),r}if("pkcs5prv"===n){var r=new ve;return r.readPrivateKeyFromASN1HexString(t),r}if(t.indexOf("-END RSA PRIVATE KEY-")!=-1&&t.indexOf("4,ENCRYPTED")==-1){var f=Rr.getHexFromPEM(t,"RSA PRIVATE KEY");return Rr.getKey(f,null,"pkcs5prv")}if(t.indexOf("-END DSA PRIVATE KEY-")!=-1&&t.indexOf("4,ENCRYPTED")==-1){var l=this.getHexFromPEM(t,"DSA PRIVATE KEY"),d=Or.getVbyList(l,0,[1],"02"),p=Or.getVbyList(l,0,[2],"02"),g=Or.getVbyList(l,0,[3],"02"),y=Or.getVbyList(l,0,[4],"02"),v=Or.getVbyList(l,0,[5],"02"),r=new Cr.crypto.DSA;return r.setPrivate(new o(d,16),new o(p,16),new o(g,16),new o(y,16),new o(v,16)),r}if(t.indexOf("-END PRIVATE KEY-")!=-1)return Rr.getKeyFromPlainPrivatePKCS8PEM(t);if(t.indexOf("-END RSA PRIVATE KEY-")!=-1&&t.indexOf("4,ENCRYPTED")!=-1)return Rr.getRSAKeyFromEncryptedPKCS5PEM(t,e);if(t.indexOf("-END EC PRIVATE KEY-")!=-1&&t.indexOf("4,ENCRYPTED")!=-1){var l=Rr.getDecryptedKeyHex(t,e),r=Or.getVbyList(l,0,[1],"04"),m=Or.getVbyList(l,0,[2,0],"06"),S=Or.getVbyList(l,0,[3,0],"03").substr(2),b="";if(void 0===Cr.crypto.OID.oidhex2name[m])throw"undefined OID(hex) in KJUR.crypto.OID: "+m;b=Cr.crypto.OID.oidhex2name[m];var i=new Cr.crypto.ECDSA({name:b});return i.setPublicKeyHex(S),i.setPrivateKeyHex(r),i.isPublic=!1,i}if(t.indexOf("-END DSA PRIVATE KEY-")!=-1&&t.indexOf("4,ENCRYPTED")!=-1){var l=Rr.getDecryptedKeyHex(t,e),d=Or.getVbyList(l,0,[1],"02"),p=Or.getVbyList(l,0,[2],"02"),g=Or.getVbyList(l,0,[3],"02"),y=Or.getVbyList(l,0,[4],"02"),v=Or.getVbyList(l,0,[5],"02"),r=new Cr.crypto.DSA;return r.setPrivate(new o(d,16),new o(p,16),new o(g,16),new o(y,16),new o(v,16)),r}if(t.indexOf("-END ENCRYPTED PRIVATE KEY-")!=-1)return Rr.getKeyFromEncryptedPKCS8PEM(t,e);throw"not supported argument"},Rr.generateKeypair=function(t,e){if("RSA"==t){var n=e,r=new ve;r.generate(n,"10001"),r.isPrivate=!0,r.isPublic=!0;var i=new ve,s=r.n.toString(16),o=r.e.toString(16);i.setPublic(s,o),i.isPrivate=!1,i.isPublic=!0;var a={};return a.prvKeyObj=r,a.pubKeyObj=i,a}if("EC"==t){var u=e,h=new Cr.crypto.ECDSA({curve:u}),c=h.generateKeyPairHex(),r=new Cr.crypto.ECDSA({curve:u});r.setPublicKeyHex(c.ecpubhex),r.setPrivateKeyHex(c.ecprvhex),r.isPrivate=!0,r.isPublic=!1;var i=new Cr.crypto.ECDSA({curve:u});i.setPublicKeyHex(c.ecpubhex),i.isPrivate=!1,i.isPublic=!0;var a={};return a.prvKeyObj=r,a.pubKeyObj=i,a}throw"unknown algorithm: "+t},Rr.getPEM=function(t,e,n,r,i){function s(t){var e=Cr.asn1.ASN1Util.newObject({seq:[{int:0},{int:{bigint:t.n}},{int:t.e},{int:{bigint:t.d}},{int:{bigint:t.p}},{int:{bigint:t.q}},{int:{bigint:t.dmp1}},{int:{bigint:t.dmq1}},{int:{bigint:t.coeff}}]});return e}function o(t){var e=Cr.asn1.ASN1Util.newObject({seq:[{int:1},{octstr:{hex:t.prvKeyHex}},{tag:["a0",!0,{oid:{name:t.curveName}}]},{tag:["a1",!0,{bitstr:{hex:"00"+t.pubKeyHex}}]}]});return e}function a(t){var e=Cr.asn1.ASN1Util.newObject({seq:[{int:0},{int:{bigint:t.p}},{int:{bigint:t.q}},{int:{bigint:t.g}},{int:{bigint:t.y}},{int:{bigint:t.x}}]});return e}var u=Cr.asn1,h=Cr.crypto;if(("undefined"!=typeof ve&&t instanceof ve||"undefined"!=typeof h.DSA&&t instanceof h.DSA||"undefined"!=typeof h.ECDSA&&t instanceof h.ECDSA)&&1==t.isPublic&&(void 0===e||"PKCS8PUB"==e)){var c=new Cr.asn1.x509.SubjectPublicKeyInfo(t),f=c.getEncodedHex();return u.ASN1Util.getPEMStringFromHex(f,"PUBLIC KEY")}if("PKCS1PRV"==e&&"undefined"!=typeof ve&&t instanceof ve&&(void 0===n||null==n)&&1==t.isPrivate){var c=s(t),f=c.getEncodedHex();return u.ASN1Util.getPEMStringFromHex(f,"RSA PRIVATE KEY")}if("PKCS1PRV"==e&&"undefined"!=typeof ve&&t instanceof Cr.crypto.ECDSA&&(void 0===n||null==n)&&1==t.isPrivate){var l=new Cr.asn1.DERObjectIdentifier({name:t.curveName}),d=l.getEncodedHex(),p=o(t),g=p.getEncodedHex(),y="";return y+=u.ASN1Util.getPEMStringFromHex(d,"EC PARAMETERS"),y+=u.ASN1Util.getPEMStringFromHex(g,"EC PRIVATE KEY")}if("PKCS1PRV"==e&&"undefined"!=typeof Cr.crypto.DSA&&t instanceof Cr.crypto.DSA&&(void 0===n||null==n)&&1==t.isPrivate){var c=a(t),f=c.getEncodedHex();return u.ASN1Util.getPEMStringFromHex(f,"DSA PRIVATE KEY")}if("PKCS5PRV"==e&&"undefined"!=typeof ve&&t instanceof ve&&void 0!==n&&null!=n&&1==t.isPrivate){var c=s(t),f=c.getEncodedHex();return void 0===r&&(r="DES-EDE3-CBC"),this.getEncryptedPKCS5PEMFromPrvKeyHex("RSA",f,n,r)}if("PKCS5PRV"==e&&"undefined"!=typeof Cr.crypto.ECDSA&&t instanceof Cr.crypto.ECDSA&&void 0!==n&&null!=n&&1==t.isPrivate){var c=o(t),f=c.getEncodedHex();return void 0===r&&(r="DES-EDE3-CBC"),this.getEncryptedPKCS5PEMFromPrvKeyHex("EC",f,n,r)}if("PKCS5PRV"==e&&"undefined"!=typeof Cr.crypto.DSA&&t instanceof Cr.crypto.DSA&&void 0!==n&&null!=n&&1==t.isPrivate){var c=a(t),f=c.getEncodedHex();return void 0===r&&(r="DES-EDE3-CBC"),this.getEncryptedPKCS5PEMFromPrvKeyHex("DSA",f,n,r)}var v=function(t,e){var n=m(t,e),r=new Cr.asn1.ASN1Util.newObject({seq:[{seq:[{oid:{name:"pkcs5PBES2"}},{seq:[{seq:[{oid:{name:"pkcs5PBKDF2"}},{seq:[{octstr:{hex:n.pbkdf2Salt}},{int:n.pbkdf2Iter}]}]},{seq:[{oid:{name:"des-EDE3-CBC"}},{octstr:{hex:n.encryptionSchemeIV}}]}]}]},{octstr:{hex:n.ciphertext}}]});return r.getEncodedHex()},m=function(t,e){var n=100,r=or.lib.WordArray.random(8),i="DES-EDE3-CBC",s=or.lib.WordArray.random(8),o=or.PBKDF2(e,r,{keySize:6,iterations:n}),a=or.enc.Hex.parse(t),u=or.TripleDES.encrypt(a,o,{iv:s})+"",h={};return h.ciphertext=u,h.pbkdf2Salt=or.enc.Hex.stringify(r),h.pbkdf2Iter=n,h.encryptionSchemeAlg=i,h.encryptionSchemeIV=or.enc.Hex.stringify(s),h};if("PKCS8PRV"==e&&"undefined"!=typeof ve&&t instanceof ve&&1==t.isPrivate){var S=s(t),b=S.getEncodedHex(),c=Cr.asn1.ASN1Util.newObject({seq:[{int:0},{seq:[{oid:{name:"rsaEncryption"}},{null:!0}]},{octstr:{hex:b}}]}),f=c.getEncodedHex();if(void 0===n||null==n)return u.ASN1Util.getPEMStringFromHex(f,"PRIVATE KEY");var g=v(f,n);return u.ASN1Util.getPEMStringFromHex(g,"ENCRYPTED PRIVATE KEY");
	}if("PKCS8PRV"==e&&"undefined"!=typeof Cr.crypto.ECDSA&&t instanceof Cr.crypto.ECDSA&&1==t.isPrivate){var S=new Cr.asn1.ASN1Util.newObject({seq:[{int:1},{octstr:{hex:t.prvKeyHex}},{tag:["a1",!0,{bitstr:{hex:"00"+t.pubKeyHex}}]}]}),b=S.getEncodedHex(),c=Cr.asn1.ASN1Util.newObject({seq:[{int:0},{seq:[{oid:{name:"ecPublicKey"}},{oid:{name:t.curveName}}]},{octstr:{hex:b}}]}),f=c.getEncodedHex();if(void 0===n||null==n)return u.ASN1Util.getPEMStringFromHex(f,"PRIVATE KEY");var g=v(f,n);return u.ASN1Util.getPEMStringFromHex(g,"ENCRYPTED PRIVATE KEY")}if("PKCS8PRV"==e&&"undefined"!=typeof Cr.crypto.DSA&&t instanceof Cr.crypto.DSA&&1==t.isPrivate){var S=new Cr.asn1.DERInteger({bigint:t.x}),b=S.getEncodedHex(),c=Cr.asn1.ASN1Util.newObject({seq:[{int:0},{seq:[{oid:{name:"dsa"}},{seq:[{int:{bigint:t.p}},{int:{bigint:t.q}},{int:{bigint:t.g}}]}]},{octstr:{hex:b}}]}),f=c.getEncodedHex();if(void 0===n||null==n)return u.ASN1Util.getPEMStringFromHex(f,"PRIVATE KEY");var g=v(f,n);return u.ASN1Util.getPEMStringFromHex(g,"ENCRYPTED PRIVATE KEY")}throw"unsupported object nor format"},Rr.getKeyFromCSRPEM=function(t){var e=Rr.getHexFromPEM(t,"CERTIFICATE REQUEST"),n=Rr.getKeyFromCSRHex(e);return n},Rr.getKeyFromCSRHex=function(t){var e=Rr.parseCSRHex(t),n=Rr.getKey(e.p8pubkeyhex,null,"pkcs8pub");return n},Rr.parseCSRHex=function(t){var e={},n=t;if("30"!=n.substr(0,2))throw"malformed CSR(code:001)";var r=Or.getPosArrayOfChildren_AtObj(n,0);if(r.length<1)throw"malformed CSR(code:002)";if("30"!=n.substr(r[0],2))throw"malformed CSR(code:003)";var i=Or.getPosArrayOfChildren_AtObj(n,r[0]);if(i.length<3)throw"malformed CSR(code:004)";return e.p8pubkeyhex=Or.getHexOfTLV_AtObj(n,i[2]),e},Rr.getJWKFromKey=function(t){var e={};if(t instanceof ve&&t.isPrivate)return e.kty="RSA",e.n=pn(t.n.toString(16)),e.e=pn(t.e.toString(16)),e.d=pn(t.d.toString(16)),e.p=pn(t.p.toString(16)),e.q=pn(t.q.toString(16)),e.dp=pn(t.dmp1.toString(16)),e.dq=pn(t.dmq1.toString(16)),e.qi=pn(t.coeff.toString(16)),e;if(t instanceof ve&&t.isPublic)return e.kty="RSA",e.n=pn(t.n.toString(16)),e.e=pn(t.e.toString(16)),e;if(t instanceof Cr.crypto.ECDSA&&t.isPrivate){var n=t.getShortNISTPCurveName();if("P-256"!==n&&"P-384"!==n)throw"unsupported curve name for JWT: "+n;var r=t.getPublicKeyXYHex();return e.kty="EC",e.crv=n,e.x=pn(r.x),e.y=pn(r.y),e.d=pn(t.prvKeyHex),e}if(t instanceof Cr.crypto.ECDSA&&t.isPublic){var n=t.getShortNISTPCurveName();if("P-256"!==n&&"P-384"!==n)throw"unsupported curve name for JWT: "+n;var r=t.getPublicKeyXYHex();return e.kty="EC",e.crv=n,e.x=pn(r.x),e.y=pn(r.y),e}throw"not supported key object"},ve.prototype.readPrivateKeyFromPEMString=jn,ve.prototype.readPrivateKeyFromASN1HexString=Hn;/*! rsasign-1.2.7.js (c) 2012 Kenji Urushima | kjur.github.com/jsrsasign/license
		 */
	var Ir=new RegExp("");Ir.compile("[^0-9a-f]","gi"),ve.prototype.signWithMessageHash=kn,ve.prototype.signString=In,ve.prototype.signStringWithSHA1=Bn,ve.prototype.signStringWithSHA256=Nn,ve.prototype.sign=In,ve.prototype.signWithSHA1=Bn,ve.prototype.signWithSHA256=Nn,ve.prototype.signWithMessageHashPSS=Kn,ve.prototype.signStringPSS=Mn,ve.prototype.signPSS=Mn,ve.SALT_LEN_HLEN=-1,ve.SALT_LEN_MAX=-2,ve.prototype.verifyWithMessageHash=Yn,ve.prototype.verifyString=zn,ve.prototype.verifyHexSignatureForMessage=Jn,ve.prototype.verify=zn,ve.prototype.verifyHexSignatureForByteArrayMessage=Jn,ve.prototype.verifyWithMessageHashPSS=Xn,ve.prototype.verifyStringPSS=Gn,ve.prototype.verifyPSS=Gn,ve.SALT_LEN_RECOVER=-2,$n.pemToBase64=function(t){var e=t;return e=e.replace("-----BEGIN CERTIFICATE-----",""),e=e.replace("-----END CERTIFICATE-----",""),e=e.replace(/[ \n]+/g,"")},$n.pemToHex=function(t){var e=$n.pemToBase64(t),n=i(e);return n},$n.getSubjectPublicKeyPosFromCertHex=function(t){var e=$n.getSubjectPublicKeyInfoPosFromCertHex(t);if(e==-1)return-1;var n=Or.getPosArrayOfChildren_AtObj(t,e);if(2!=n.length)return-1;var r=n[1];if("03"!=t.substring(r,r+2))return-1;var i=Or.getStartPosOfV_AtObj(t,r);return"00"!=t.substring(i,i+2)?-1:i+2},$n.getSubjectPublicKeyInfoPosFromCertHex=function(t){var e=Or.getStartPosOfV_AtObj(t,0),n=Or.getPosArrayOfChildren_AtObj(t,e);return n.length<1?-1:"a003020102"==t.substring(n[0],n[0]+10)?n.length<6?-1:n[6]:n.length<5?-1:n[5]},$n.getPublicKeyHexArrayFromCertHex=function(t){var e=$n.getSubjectPublicKeyPosFromCertHex(t),n=Or.getPosArrayOfChildren_AtObj(t,e);if(2!=n.length)return[];var r=Or.getHexOfV_AtObj(t,n[0]),i=Or.getHexOfV_AtObj(t,n[1]);return null!=r&&null!=i?[r,i]:[]},$n.getHexTbsCertificateFromCert=function(t){var e=Or.getStartPosOfV_AtObj(t,0);return e},$n.getPublicKeyHexArrayFromCertPEM=function(t){var e=$n.pemToHex(t),n=$n.getPublicKeyHexArrayFromCertHex(e);return n},$n.hex2dn=function(t){for(var e="",n=Or.getPosArrayOfChildren_AtObj(t,0),r=0;r<n.length;r++){var i=Or.getHexOfTLV_AtObj(t,n[r]);e=e+"/"+$n.hex2rdn(i)}return e},$n.hex2rdn=function(t){var e=Or.getDecendantHexTLVByNthList(t,0,[0,0]),n=Or.getDecendantHexVByNthList(t,0,[0,1]),r="";try{r=$n.DN_ATTRHEX[e]}catch(t){r=e}n=n.replace(/(..)/g,"%$1");var i=decodeURIComponent(n);return r+"="+i},$n.DN_ATTRHEX={"0603550406":"C","060355040a":"O","060355040b":"OU","0603550403":"CN","0603550405":"SN","0603550408":"ST","0603550407":"L","0603550409":"streetAddress","060355040f":"businessCategory","0603550411":"postalCode","060b2b0601040182373c020102":"jurisdictionOfIncorporationSP","060b2b0601040182373c020103":"jurisdictionOfIncorporationC"},$n.getPublicKeyFromCertPEM=function(t){var e=$n.getPublicKeyInfoPropOfCertPEM(t);if("2a864886f70d010101"==e.algoid){var n=Rr.parsePublicRawRSAKeyHex(e.keyhex),r=new ve;return r.setPublic(n.n,n.e),r}if("2a8648ce3d0201"==e.algoid){var i=Cr.crypto.OID.oidhex2name[e.algparam],r=new Cr.crypto.ECDSA({curve:i,info:e.keyhex});return r.setPublicKeyHex(e.keyhex),r}if("2a8648ce380401"==e.algoid){var s=Or.getVbyList(e.algparam,0,[0],"02"),a=Or.getVbyList(e.algparam,0,[1],"02"),u=Or.getVbyList(e.algparam,0,[2],"02"),h=Or.getHexOfV_AtObj(e.keyhex,0);h=h.substr(2);var r=new Cr.crypto.DSA;return r.setPublic(new o(s,16),new o(a,16),new o(u,16),new o(h,16)),r}throw"unsupported key"},$n.getPublicKeyInfoPropOfCertPEM=function(t){var e={};e.algparam=null;var n=$n.pemToHex(t),r=Or.getPosArrayOfChildren_AtObj(n,0);if(3!=r.length)throw"malformed X.509 certificate PEM (code:001)";if("30"!=n.substr(r[0],2))throw"malformed X.509 certificate PEM (code:002)";var i=Or.getPosArrayOfChildren_AtObj(n,r[0]),s=6;if("a0"!==n.substr(i[0],2)&&(s=5),i.length<s+1)throw"malformed X.509 certificate PEM (code:003)";var o=Or.getPosArrayOfChildren_AtObj(n,i[s]);if(2!=o.length)throw"malformed X.509 certificate PEM (code:004)";var a=Or.getPosArrayOfChildren_AtObj(n,o[0]);if(2!=a.length)throw"malformed X.509 certificate PEM (code:005)";if(e.algoid=Or.getHexOfV_AtObj(n,a[0]),"06"==n.substr(a[1],2)?e.algparam=Or.getHexOfV_AtObj(n,a[1]):"30"==n.substr(a[1],2)&&(e.algparam=Or.getHexOfTLV_AtObj(n,a[1])),"03"!=n.substr(o[1],2))throw"malformed X.509 certificate PEM (code:006)";var u=Or.getHexOfV_AtObj(n,o[1]);return e.keyhex=u.substr(2),e},$n.getPublicKeyInfoPosOfCertHEX=function(t){var e=Or.getPosArrayOfChildren_AtObj(t,0);if(3!=e.length)throw"malformed X.509 certificate PEM (code:001)";if("30"!=t.substr(e[0],2))throw"malformed X.509 certificate PEM (code:002)";var n=Or.getPosArrayOfChildren_AtObj(t,e[0]);if(n.length<7)throw"malformed X.509 certificate PEM (code:003)";return n[6]},$n.getV3ExtInfoListOfCertHex=function(t){var e=Or.getPosArrayOfChildren_AtObj(t,0);if(3!=e.length)throw"malformed X.509 certificate PEM (code:001)";if("30"!=t.substr(e[0],2))throw"malformed X.509 certificate PEM (code:002)";var n=Or.getPosArrayOfChildren_AtObj(t,e[0]);if(n.length<8)throw"malformed X.509 certificate PEM (code:003)";if("a3"!=t.substr(n[7],2))throw"malformed X.509 certificate PEM (code:004)";var r=Or.getPosArrayOfChildren_AtObj(t,n[7]);if(1!=r.length)throw"malformed X.509 certificate PEM (code:005)";if("30"!=t.substr(r[0],2))throw"malformed X.509 certificate PEM (code:006)";for(var i=Or.getPosArrayOfChildren_AtObj(t,r[0]),s=i.length,o=new Array(s),a=0;a<s;a++)o[a]=$n.getV3ExtItemInfo_AtObj(t,i[a]);return o},$n.getV3ExtItemInfo_AtObj=function(t,e){var n={};n.posTLV=e;var r=Or.getPosArrayOfChildren_AtObj(t,e);if(2!=r.length&&3!=r.length)throw"malformed X.509v3 Ext (code:001)";if("06"!=t.substr(r[0],2))throw"malformed X.509v3 Ext (code:002)";var i=Or.getHexOfV_AtObj(t,r[0]);n.oid=Or.hextooidstr(i),n.critical=!1,3==r.length&&(n.critical=!0);var s=r[r.length-1];if("04"!=t.substr(s,2))throw"malformed X.509v3 Ext (code:003)";return n.posV=Or.getStartPosOfV_AtObj(t,s),n},$n.getHexOfTLV_V3ExtValue=function(t,e){var n=$n.getPosOfTLV_V3ExtValue(t,e);return n==-1?null:Or.getHexOfTLV_AtObj(t,n)},$n.getHexOfV_V3ExtValue=function(t,e){var n=$n.getPosOfTLV_V3ExtValue(t,e);return n==-1?null:Or.getHexOfV_AtObj(t,n)},$n.getPosOfTLV_V3ExtValue=function(t,e){var n=e;if(e.match(/^[0-9.]+$/)||(n=Cr.asn1.x509.OID.name2oid(e)),""==n)return-1;for(var r=$n.getV3ExtInfoListOfCertHex(t),i=0;i<r.length;i++){var s=r[i];if(s.oid==n)return s.posV}return-1},$n.getExtBasicConstraints=function(t){var e=$n.getHexOfV_V3ExtValue(t,"basicConstraints");if(null===e)return null;if(""===e)return{};if("0101ff"===e)return{cA:!0};if("0101ff02"===e.substr(0,8)){var n=Or.getHexOfV_AtObj(e,6),r=parseInt(n,16);return{cA:!0,pathLen:r}}throw"unknown error"},$n.KEYUSAGE_NAME=["digitalSignature","nonRepudiation","keyEncipherment","dataEncipherment","keyAgreement","keyCertSign","cRLSign","encipherOnly","decipherOnly"],$n.getExtKeyUsageBin=function(t){var e=$n.getHexOfV_V3ExtValue(t,"keyUsage");if(""==e)return"";if(e.length%2!=0||e.length<=2)throw"malformed key usage value";var n=parseInt(e.substr(0,2)),r=parseInt(e.substr(2),16).toString(2);return r.substr(0,r.length-n)},$n.getExtKeyUsageString=function(t){for(var e=$n.getExtKeyUsageBin(t),n=new Array,r=0;r<e.length;r++)"1"==e.substr(r,1)&&n.push($n.KEYUSAGE_NAME[r]);return n.join(",")},$n.getExtSubjectKeyIdentifier=function(t){var e=$n.getHexOfV_V3ExtValue(t,"subjectKeyIdentifier");return e},$n.getExtAuthorityKeyIdentifier=function(t){var e={},n=$n.getHexOfTLV_V3ExtValue(t,"authorityKeyIdentifier");if(null===n)return null;for(var r=Or.getPosArrayOfChildren_AtObj(n,0),i=0;i<r.length;i++)"80"===n.substr(r[i],2)&&(e.kid=Or.getHexOfV_AtObj(n,r[i]));return e},$n.getExtExtKeyUsageName=function(t){var e=new Array,n=$n.getHexOfTLV_V3ExtValue(t,"extKeyUsage");if(null===n)return null;for(var r=Or.getPosArrayOfChildren_AtObj(n,0),i=0;i<r.length;i++){var s=Or.getHexOfV_AtObj(n,r[i]),o=Cr.asn1.ASN1Util.oidHexToInt(s),a=Cr.asn1.x509.OID.oid2name(o);e.push(a)}return e},$n.getExtSubjectAltName=function(t){for(var e=new Array,n=$n.getHexOfTLV_V3ExtValue(t,"subjectAltName"),r=Or.getPosArrayOfChildren_AtObj(n,0),i=0;i<r.length;i++)if("82"===n.substr(r[i],2)){var s=Sn(Or.getHexOfV_AtObj(n,r[i]));e.push(s)}return e},$n.getExtCRLDistributionPointsURI=function(t){for(var e=new Array,n=$n.getHexOfTLV_V3ExtValue(t,"cRLDistributionPoints"),r=Or.getPosArrayOfChildren_AtObj(n,0),i=0;i<r.length;i++)for(var s=Or.getHexOfTLV_AtObj(n,r[i]),o=Or.getPosArrayOfChildren_AtObj(s,0),a=0;a<o.length;a++)if("a0"===s.substr(o[a],2)){var u=Or.getHexOfV_AtObj(s,o[a]);if("a0"===u.substr(0,2)){var h=Or.getHexOfV_AtObj(u,0);if("86"===h.substr(0,2)){var c=Or.getHexOfV_AtObj(h,0),f=Sn(c);e.push(f)}}}return e},$n.getExtAIAInfo=function(t){var e={};e.ocsp=[],e.caissuer=[];var n=$n.getPosOfTLV_V3ExtValue(t,"authorityInfoAccess");if(n==-1)return null;if("30"!=t.substr(n,2))throw"malformed AIA Extn Value";for(var r=Or.getPosArrayOfChildren_AtObj(t,n),i=0;i<r.length;i++){var s=r[i],o=Or.getPosArrayOfChildren_AtObj(t,s);if(2!=o.length)throw"malformed AccessDescription of AIA Extn";var a=o[0],u=o[1];"2b06010505073001"==Or.getHexOfV_AtObj(t,a)&&"86"==t.substr(u,2)&&e.ocsp.push(Sn(Or.getHexOfV_AtObj(t,u))),"2b06010505073002"==Or.getHexOfV_AtObj(t,a)&&"86"==t.substr(u,2)&&e.caissuer.push(Sn(Or.getHexOfV_AtObj(t,u)))}return e},$n.getSignatureAlgorithmName=function(t){var e=Or.getDecendantHexVByNthList(t,0,[1,0]),n=Cr.asn1.ASN1Util.oidHexToInt(e),r=Cr.asn1.x509.OID.oid2name(n);return r},$n.getSignatureValueHex=function(t){var e=Or.getDecendantHexVByNthList(t,0,[2]);if("00"!==e.substr(0,2))throw"can't get signature value";return e.substr(2)},$n.getSerialNumberHex=function(t){return Or.getDecendantHexVByNthList(t,0,[0,1])},/*! jws-3.3.4 (c) 2013-2016 Kenji Urushima | kjur.github.com/jsrsasign/license
		 */
	"undefined"!=typeof Cr&&Cr||(Cr={}),"undefined"!=typeof Cr.jws&&Cr.jws||(Cr.jws={}),Cr.jws.JWS=function(){var t=Cr.jws.JWS;this.parseJWS=function(e,n){if(void 0===this.parsedJWS||!n&&void 0===this.parsedJWS.sigvalH){if(null==e.match(/^([^.]+)\.([^.]+)\.([^.]+)$/))throw"JWS signature is not a form of 'Head.Payload.SigValue'.";var r=RegExp.$1,i=RegExp.$2,s=RegExp.$3,o=r+"."+i;if(this.parsedJWS={},this.parsedJWS.headB64U=r,this.parsedJWS.payloadB64U=i,this.parsedJWS.sigvalB64U=s,this.parsedJWS.si=o,!n){var a=gn(s),u=de(a,16);this.parsedJWS.sigvalH=a,this.parsedJWS.sigvalBI=u}var h=Dr(r),c=Dr(i);if(this.parsedJWS.headS=h,this.parsedJWS.payloadS=c,!t.isSafeJSONString(h,this.parsedJWS,"headP"))throw"malformed JSON string for JWS Head: "+h}}},Cr.jws.JWS.sign=function(t,e,n,r,i){var s,o,a,u=Cr.jws.JWS;if("string"!=typeof e&&"object"!=typeof e)throw"spHeader must be JSON string or object: "+e;if("object"==typeof e&&(o=e,s=JSON.stringify(o)),"string"==typeof e){if(s=e,!u.isSafeJSONString(s))throw"JWS Head is not safe JSON string: "+s;o=u.readSafeJSONString(s)}if(a=n,"object"==typeof n&&(a=JSON.stringify(n)),""!=t&&null!=t||void 0===o.alg||(t=o.alg),""!=t&&null!=t&&void 0===o.alg&&(o.alg=t,s=JSON.stringify(o)),t!==o.alg)throw"alg and sHeader.alg doesn't match: "+t+"!="+o.alg;var h=null;if(void 0===u.jwsalg2sigalg[t])throw"unsupported alg name: "+t;h=u.jwsalg2sigalg[t];var c=Tr(s),f=Tr(a),l=c+"."+f,d="";if("Hmac"==h.substr(0,4)){if(void 0===r)throw"mac key shall be specified for HS* alg";var p=new Cr.crypto.Mac({alg:h,prov:"cryptojs",pass:r});p.updateString(l),d=p.doFinal()}else if(h.indexOf("withECDSA")!=-1){var g=new Cr.crypto.Signature({alg:h});g.init(r,i),g.updateString(l),hASN1Sig=g.sign(),d=Cr.crypto.ECDSA.asn1SigToConcatSig(hASN1Sig)}else if("none"!=h){var g=new Cr.crypto.Signature({alg:h});g.init(r,i),g.updateString(l),d=g.sign()}var y=pn(d);return l+"."+y},Cr.jws.JWS.verify=function(t,e,n){var r=Cr.jws.JWS,i=t.split("."),s=i[0],o=i[1],a=s+"."+o,u=gn(i[2]),h=r.readSafeJSONString(Dr(i[0])),c=null,f=null;if(void 0===h.alg)throw"algorithm not specified in header";if(c=h.alg,f=c.substr(0,2),null!=n&&"[object Array]"===Object.prototype.toString.call(n)&&n.length>0){var l=":"+n.join(":")+":";if(l.indexOf(":"+c+":")==-1)throw"algorithm '"+c+"' not accepted in the list"}if("none"!=c&&null===e)throw"key shall be specified to verify.";if("string"==typeof e&&e.indexOf("-----BEGIN ")!=-1&&(e=Rr.getKey(e)),!("RS"!=f&&"PS"!=f||e instanceof ve))throw"key shall be a RSAKey obj for RS* and PS* algs";if("ES"==f&&!(e instanceof Cr.crypto.ECDSA))throw"key shall be a ECDSA obj for ES* algs";var d=null;if(void 0===r.jwsalg2sigalg[h.alg])throw"unsupported alg name: "+c;if(d=r.jwsalg2sigalg[c],"none"==d)throw"not supported";if("Hmac"==d.substr(0,4)){var p=null;if(void 0===e)throw"hexadecimal key shall be specified for HMAC";var g=new Cr.crypto.Mac({alg:d,pass:e});return g.updateString(a),p=g.doFinal(),u==p}if(d.indexOf("withECDSA")!=-1){var y=null;try{y=Cr.crypto.ECDSA.concatSigToASN1Sig(u)}catch(t){return!1}var v=new Cr.crypto.Signature({alg:d});return v.init(e),v.updateString(a),v.verify(y)}var v=new Cr.crypto.Signature({alg:d});return v.init(e),v.updateString(a),v.verify(u)},Cr.jws.JWS.parse=function(t){var e,n,r,i=t.split("."),s={};if(2!=i.length&&3!=i.length)throw"malformed sJWS: wrong number of '.' splitted elements";return e=i[0],n=i[1],3==i.length&&(r=i[2]),s.headerObj=Cr.jws.JWS.readSafeJSONString(Dr(e)),s.payloadObj=Cr.jws.JWS.readSafeJSONString(Dr(n)),s.headerPP=JSON.stringify(s.headerObj,null,"  "),null==s.payloadObj?s.payloadPP=Dr(n):s.payloadPP=JSON.stringify(s.payloadObj,null,"  "),void 0!==r&&(s.sigHex=gn(r)),s},Cr.jws.JWS.verifyJWT=function(t,e,n){var r=Cr.jws.JWS,i=t.split("."),s=i[0],o=i[1],a=(gn(i[2]),r.readSafeJSONString(Dr(s))),u=r.readSafeJSONString(Dr(o));if(void 0===a.alg)return!1;if(void 0===n.alg)throw"acceptField.alg shall be specified";if(!r.inArray(a.alg,n.alg))return!1;if(void 0!==u.iss&&"object"==typeof n.iss&&!r.inArray(u.iss,n.iss))return!1;if(void 0!==u.sub&&"object"==typeof n.sub&&!r.inArray(u.sub,n.sub))return!1;if(void 0!==u.aud&&"object"==typeof n.aud)if("string"==typeof u.aud){if(!r.inArray(u.aud,n.aud))return!1}else if("object"==typeof u.aud&&!r.includedArray(u.aud,n.aud))return!1;var h=Cr.jws.IntDate.getNow();return void 0!==n.verifyAt&&"number"==typeof n.verifyAt&&(h=n.verifyAt),void 0!==n.gracePeriod&&"number"==typeof n.gracePeriod||(n.gracePeriod=0),!(void 0!==u.exp&&"number"==typeof u.exp&&u.exp+n.gracePeriod<h)&&(!(void 0!==u.nbf&&"number"==typeof u.nbf&&h<u.nbf-n.gracePeriod)&&(!(void 0!==u.iat&&"number"==typeof u.iat&&h<u.iat-n.gracePeriod)&&((void 0===u.jti||void 0===n.jti||u.jti===n.jti)&&!!Cr.jws.JWS.verify(t,e,n.alg))))},Cr.jws.JWS.includedArray=function(t,e){var n=Cr.jws.JWS.inArray;if(null===t)return!1;if("object"!=typeof t)return!1;if("number"!=typeof t.length)return!1;for(var r=0;r<t.length;r++)if(!n(t[r],e))return!1;return!0},Cr.jws.JWS.inArray=function(t,e){if(null===e)return!1;if("object"!=typeof e)return!1;if("number"!=typeof e.length)return!1;for(var n=0;n<e.length;n++)if(e[n]==t)return!0;return!1},Cr.jws.JWS.jwsalg2sigalg={HS256:"HmacSHA256",HS384:"HmacSHA384",HS512:"HmacSHA512",RS256:"SHA256withRSA",RS384:"SHA384withRSA",RS512:"SHA512withRSA",ES256:"SHA256withECDSA",ES384:"SHA384withECDSA",PS256:"SHA256withRSAandMGF1",PS384:"SHA384withRSAandMGF1",PS512:"SHA512withRSAandMGF1",none:"none"},Cr.jws.JWS.isSafeJSONString=function(t,e,n){var r=null;try{return r=Pr(t),"object"!=typeof r?0:r.constructor===Array?0:(e&&(e[n]=r),1)}catch(t){return 0}},Cr.jws.JWS.readSafeJSONString=function(t){var e=null;try{return e=Pr(t),"object"!=typeof e?null:e.constructor===Array?null:e}catch(t){return null}},Cr.jws.JWS.getEncodedSignatureValueFromJWS=function(t){if(null==t.match(/^[^.]+\.[^.]+\.([^.]+)$/))throw"JWS signature is not a form of 'Head.Payload.SigValue'.";return RegExp.$1},Cr.jws.JWS.getJWKthumbprint=function(t){if("RSA"!==t.kty&&"EC"!==t.kty&&"oct"!==t.kty)throw"unsupported algorithm for JWK Thumprint";var e="{";if("RSA"===t.kty){if("string"!=typeof t.n||"string"!=typeof t.e)throw"wrong n and e value for RSA key";e+='"e":"'+t.e+'",',e+='"kty":"'+t.kty+'",',e+='"n":"'+t.n+'"}'}else if("EC"===t.kty){if("string"!=typeof t.crv||"string"!=typeof t.x||"string"!=typeof t.y)throw"wrong crv, x and y value for EC key";e+='"crv":"'+t.crv+'",',e+='"kty":"'+t.kty+'",',e+='"x":"'+t.x+'",',e+='"y":"'+t.y+'"}'}else if("oct"===t.kty){if("string"!=typeof t.k)throw"wrong k value for oct(symmetric) key";e+='"kty":"'+t.kty+'",',e+='"k":"'+t.k+'"}'}var n=wn(e),r=Cr.crypto.Util.hashHex(n,"sha256"),i=pn(r);return i},Cr.jws.IntDate={},Cr.jws.IntDate.get=function(t){if("now"==t)return Cr.jws.IntDate.getNow();if("now + 1hour"==t)return Cr.jws.IntDate.getNow()+3600;if("now + 1day"==t)return Cr.jws.IntDate.getNow()+86400;if("now + 1month"==t)return Cr.jws.IntDate.getNow()+2592e3;if("now + 1year"==t)return Cr.jws.IntDate.getNow()+31536e3;if(t.match(/Z$/))return Cr.jws.IntDate.getZulu(t);if(t.match(/^[0-9]+$/))return parseInt(t);throw"unsupported format: "+t},Cr.jws.IntDate.getZulu=function(t){var e;if(e=t.match(/(\d+)(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)Z/)){var n=RegExp.$1,r=parseInt(n);if(4==n.length);else{if(2!=n.length)throw"malformed year string";if(50<=r&&r<100)r=1900+r;else{if(!(0<=r&&r<50))throw"malformed year string for UTCTime";r=2e3+r}}var i=parseInt(RegExp.$2)-1,s=parseInt(RegExp.$3),o=parseInt(RegExp.$4),a=parseInt(RegExp.$5),u=parseInt(RegExp.$6),h=new Date(Date.UTC(r,i,s,o,a,u));return~~(h/1e3)}throw"unsupported format: "+t},Cr.jws.IntDate.getNow=function(){var t=~~(new Date/1e3);return t},Cr.jws.IntDate.intDate2UTCString=function(t){var e=new Date(1e3*t);return e.toUTCString()},Cr.jws.IntDate.intDate2Zulu=function(t){var e=new Date(1e3*t),n=("0000"+e.getUTCFullYear()).slice(-4),r=("00"+(e.getUTCMonth()+1)).slice(-2),i=("00"+e.getUTCDate()).slice(-2),s=("00"+e.getUTCHours()).slice(-2),o=("00"+e.getUTCMinutes()).slice(-2),a=("00"+e.getUTCSeconds()).slice(-2);return n+r+i+s+o+a+"Z"},/*! jwsjs-2.1.0 (c) 2010-2016 Kenji Urushima | kjur.github.com/jsrsasign/license
		 */
	"undefined"!=typeof Cr&&Cr||(Cr={}),"undefined"!=typeof Cr.jws&&Cr.jws||(Cr.jws={}),Cr.jws.JWSJS=function(){var t=Cr.jws.JWS,e=Cr.jws.JWS;this.aHeader=[],this.sPayload="",this.aSignature=[],this.init=function(){this.aHeader=[],this.sPayload=void 0,this.aSignature=[]},this.initWithJWS=function(t){this.init();var e=t.split(".");if(3!=e.length)throw"malformed input JWS";this.aHeader.push(e[0]),this.sPayload=e[1],this.aSignature.push(e[2])},this.addSignature=function(t,e,n,r){if(void 0===this.sPayload||null===this.sPayload)throw"there's no JSON-JS signature to add.";var i=this.aHeader.length;if(this.aHeader.length!=this.aSignature.length)throw"aHeader.length != aSignature.length";try{var s=Cr.jws.JWS.sign(t,e,this.sPayload,n,r),o=s.split(".");o[0],o[2];this.aHeader.push(o[0]),this.aSignature.push(o[2])}catch(t){throw this.aHeader.length>i&&this.aHeader.pop(),this.aSignature.length>i&&this.aSignature.pop(),"addSignature failed: "+t}},this.addSignatureByHeaderKey=function(t,e){var n=Dr(this.sPayload),r=new Cr.jws.JWS;r.generateJWSByP1PrvKey(t,n,e);this.aHeader.push(r.parsedJWS.headB64U),this.aSignature.push(r.parsedJWS.sigvalB64U)},this.addSignatureByHeaderPayloadKey=function(t,e,n){var r=new Cr.jws.JWS;r.generateJWSByP1PrvKey(t,e,n);this.aHeader.push(r.parsedJWS.headB64U),this.sPayload=r.parsedJWS.payloadB64U,this.aSignature.push(r.parsedJWS.sigvalB64U)},this.verifyAll=function(t){if(this.aHeader.length!==t.length||this.aSignature.length!==t.length)return!1;for(var e=0;e<t.length;e++){var n=t[e];if(2!==n.length)return!1;var r=this.verifyNth(e,n[0],n[1]);if(r===!1)return!1}return!0},this.verifyNth=function(t,n,r){if(this.aHeader.length<=t||this.aSignature.length<=t)return!1;var i=this.aHeader[t],s=this.aSignature[t],o=i+"."+this.sPayload+"."+s,a=!1;try{a=e.verify(o,n,r)}catch(t){return!1}return a},this.verifyWithCerts=function(t){if(this.aHeader.length!=t.length)throw"num headers does not match with num certs";if(this.aSignature.length!=t.length)throw"num signatures does not match with num certs";for(var e=this.sPayload,n="",r=0;r<t.length;r++){var i=t[r],s=this.aHeader[r],o=this.aSignature[r],a=s+"."+e+"."+o,u=new Cr.jws.JWS;try{var h=u.verifyJWSByPemX509Cert(a,i);1!=h&&(n+=r+1+"th signature unmatch. ")}catch(t){n+=r+1+"th signature fail("+t+"). "}}if(""==n)return 1;throw n},this.readJWSJS=function(e){if("string"==typeof e){var n=t.readSafeJSONString(e);if(null==n)throw"argument is not safe JSON object string";this.aHeader=n.headers,this.sPayload=n.payload,this.aSignature=n.signatures}else try{if(!(e.headers.length>0))throw"malformed header";if(this.aHeader=e.headers,"string"!=typeof e.payload)throw"malformed signatures";if(this.sPayload=e.payload,!(e.signatures.length>0))throw"malformed signatures";this.signatures=e.signatures}catch(t){throw"malformed JWS-JS JSON object: "+t}},this.getJSON=function(){return{headers:this.aHeader,payload:this.sPayload,signatures:this.aSignature}},this.isEmpty=function(){return 0==this.aHeader.length?1:0}},e.SecureRandom=le,e.rng_seed_time=he,e.BigInteger=o,e.RSAKey=ve,e.ECDSA=Cr.crypto.ECDSA,e.DSA=Cr.crypto.DSA,e.Signature=Cr.crypto.Signature,e.MessageDigest=Cr.crypto.MessageDigest,e.Mac=Cr.crypto.Mac,e.KEYUTIL=Rr,e.ASN1HEX=Or,e.X509=$n,e.CryptoJS=or,e.b64tohex=i,e.b64toBA=s,e.stoBA=sn,e.BAtos=on,e.BAtohex=an,e.stohex=un,e.stob64=hn,e.stob64u=cn,e.b64utos=fn,e.b64tob64u=ln,e.b64utob64=dn,e.hex2b64=r,e.hextob64u=pn,e.b64utohex=gn,e.b64tohex=i,e.utf8tob64u=Tr,e.b64utoutf8=Dr,e.utf8tob64=yn,e.b64toutf8=vn,e.utf8tohex=mn,e.hextoutf8=Sn,e.hextorstr=bn,e.rstrtohex=wn,e.newline_toUnix=Fn,e.newline_toDos=Pn,e.intarystrtohex=On,e.strdiffidx=Hr,e.KJUR=Cr,e.crypto=Cr.crypto,e.asn1=Cr.asn1,e.jws=Cr.jws,e.lang=Cr.lang,e.readFileUTF8=Zn,e.readFileHexByBin=Qn,e.readFile=tr,e.saveFile=er,e.saveFileBinByHex=nr}).call(e,n(13).Buffer)},function(t,e,n){(function(t,r){/*!
		 * The buffer module from node.js, for the browser.
		 *
		 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
		 * @license  MIT
		 */
	"use strict";function i(){try{var t=new Uint8Array(1);return t.__proto__={__proto__:Uint8Array.prototype,foo:function(){return 42}},42===t.foo()&&"function"==typeof t.subarray&&0===t.subarray(1,1).byteLength}catch(t){return!1}}function s(){return t.TYPED_ARRAY_SUPPORT?2147483647:1073741823}function o(e,n){if(s()<n)throw new RangeError("Invalid typed array length");return t.TYPED_ARRAY_SUPPORT?(e=new Uint8Array(n),e.__proto__=t.prototype):(null===e&&(e=new t(n)),e.length=n),e}function t(e,n,r){if(!(t.TYPED_ARRAY_SUPPORT||this instanceof t))return new t(e,n,r);if("number"==typeof e){if("string"==typeof n)throw new Error("If encoding is specified then the first argument must be a string");return c(this,e)}return a(this,e,n,r)}function a(t,e,n,r){if("number"==typeof e)throw new TypeError('"value" argument must not be a number');return"undefined"!=typeof ArrayBuffer&&e instanceof ArrayBuffer?d(t,e,n,r):"string"==typeof e?f(t,e,n):p(t,e)}function u(t){if("number"!=typeof t)throw new TypeError('"size" argument must be a number');if(t<0)throw new RangeError('"size" argument must not be negative')}function h(t,e,n,r){return u(e),e<=0?o(t,e):void 0!==n?"string"==typeof r?o(t,e).fill(n,r):o(t,e).fill(n):o(t,e)}function c(e,n){if(u(n),e=o(e,n<0?0:0|g(n)),!t.TYPED_ARRAY_SUPPORT)for(var r=0;r<n;++r)e[r]=0;return e}function f(e,n,r){if("string"==typeof r&&""!==r||(r="utf8"),!t.isEncoding(r))throw new TypeError('"encoding" must be a valid string encoding');var i=0|v(n,r);e=o(e,i);var s=e.write(n,r);return s!==i&&(e=e.slice(0,s)),e}function l(t,e){var n=e.length<0?0:0|g(e.length);t=o(t,n);for(var r=0;r<n;r+=1)t[r]=255&e[r];return t}function d(e,n,r,i){if(n.byteLength,r<0||n.byteLength<r)throw new RangeError("'offset' is out of bounds");if(n.byteLength<r+(i||0))throw new RangeError("'length' is out of bounds");return n=void 0===r&&void 0===i?new Uint8Array(n):void 0===i?new Uint8Array(n,r):new Uint8Array(n,r,i),t.TYPED_ARRAY_SUPPORT?(e=n,e.__proto__=t.prototype):e=l(e,n),e}function p(e,n){if(t.isBuffer(n)){var r=0|g(n.length);return e=o(e,r),0===e.length?e:(n.copy(e,0,0,r),e)}if(n){if("undefined"!=typeof ArrayBuffer&&n.buffer instanceof ArrayBuffer||"length"in n)return"number"!=typeof n.length||X(n.length)?o(e,0):l(e,n);if("Buffer"===n.type&&Q(n.data))return l(e,n.data)}throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.")}function g(t){if(t>=s())throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+s().toString(16)+" bytes");return 0|t}function y(e){return+e!=e&&(e=0),t.alloc(+e)}function v(e,n){if(t.isBuffer(e))return e.length;if("undefined"!=typeof ArrayBuffer&&"function"==typeof ArrayBuffer.isView&&(ArrayBuffer.isView(e)||e instanceof ArrayBuffer))return e.byteLength;"string"!=typeof e&&(e=""+e);var r=e.length;if(0===r)return 0;for(var i=!1;;)switch(n){case"ascii":case"latin1":case"binary":return r;case"utf8":case"utf-8":case void 0:return W(e).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*r;case"hex":return r>>>1;case"base64":return Y(e).length;default:if(i)return W(e).length;n=(""+n).toLowerCase(),i=!0}}function m(t,e,n){var r=!1;if((void 0===e||e<0)&&(e=0),e>this.length)return"";if((void 0===n||n>this.length)&&(n=this.length),n<=0)return"";if(n>>>=0,e>>>=0,n<=e)return"";for(t||(t="utf8");;)switch(t){case"hex":return j(this,e,n);case"utf8":case"utf-8":return C(this,e,n);case"ascii":return D(this,e,n);case"latin1":case"binary":return H(this,e,n);case"base64":return O(this,e,n);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return R(this,e,n);default:if(r)throw new TypeError("Unknown encoding: "+t);t=(t+"").toLowerCase(),r=!0}}function S(t,e,n){var r=t[e];t[e]=t[n],t[n]=r}function b(e,n,r,i,s){if(0===e.length)return-1;if("string"==typeof r?(i=r,r=0):r>2147483647?r=2147483647:r<-2147483648&&(r=-2147483648),r=+r,isNaN(r)&&(r=s?0:e.length-1),r<0&&(r=e.length+r),r>=e.length){if(s)return-1;r=e.length-1}else if(r<0){if(!s)return-1;r=0}if("string"==typeof n&&(n=t.from(n,i)),t.isBuffer(n))return 0===n.length?-1:w(e,n,r,i,s);if("number"==typeof n)return n&=255,t.TYPED_ARRAY_SUPPORT&&"function"==typeof Uint8Array.prototype.indexOf?s?Uint8Array.prototype.indexOf.call(e,n,r):Uint8Array.prototype.lastIndexOf.call(e,n,r):w(e,[n],r,i,s);throw new TypeError("val must be string, number or Buffer")}function w(t,e,n,r,i){function s(t,e){return 1===o?t[e]:t.readUInt16BE(e*o)}var o=1,a=t.length,u=e.length;if(void 0!==r&&(r=String(r).toLowerCase(),"ucs2"===r||"ucs-2"===r||"utf16le"===r||"utf-16le"===r)){if(t.length<2||e.length<2)return-1;o=2,a/=2,u/=2,n/=2}var h;if(i){var c=-1;for(h=n;h<a;h++)if(s(t,h)===s(e,c===-1?0:h-c)){if(c===-1&&(c=h),h-c+1===u)return c*o}else c!==-1&&(h-=h-c),c=-1}else for(n+u>a&&(n=a-u),h=n;h>=0;h--){for(var f=!0,l=0;l<u;l++)if(s(t,h+l)!==s(e,l)){f=!1;break}if(f)return h}return-1}function E(t,e,n,r){n=Number(n)||0;var i=t.length-n;r?(r=Number(r),r>i&&(r=i)):r=i;var s=e.length;if(s%2!==0)throw new TypeError("Invalid hex string");r>s/2&&(r=s/2);for(var o=0;o<r;++o){var a=parseInt(e.substr(2*o,2),16);if(isNaN(a))return o;t[n+o]=a}return o}function x(t,e,n,r){return G(W(e,t.length-n),t,n,r)}function A(t,e,n,r){return G(J(e),t,n,r)}function _(t,e,n,r){return A(t,e,n,r)}function F(t,e,n,r){return G(Y(e),t,n,r)}function P(t,e,n,r){return G(z(e,t.length-n),t,n,r)}function O(t,e,n){return 0===e&&n===t.length?$.fromByteArray(t):$.fromByteArray(t.slice(e,n))}function C(t,e,n){n=Math.min(t.length,n);for(var r=[],i=e;i<n;){var s=t[i],o=null,a=s>239?4:s>223?3:s>191?2:1;if(i+a<=n){var u,h,c,f;switch(a){case 1:s<128&&(o=s);break;case 2:u=t[i+1],128===(192&u)&&(f=(31&s)<<6|63&u,f>127&&(o=f));break;case 3:u=t[i+1],h=t[i+2],128===(192&u)&&128===(192&h)&&(f=(15&s)<<12|(63&u)<<6|63&h,f>2047&&(f<55296||f>57343)&&(o=f));break;case 4:u=t[i+1],h=t[i+2],c=t[i+3],128===(192&u)&&128===(192&h)&&128===(192&c)&&(f=(15&s)<<18|(63&u)<<12|(63&h)<<6|63&c,f>65535&&f<1114112&&(o=f))}}null===o?(o=65533,a=1):o>65535&&(o-=65536,r.push(o>>>10&1023|55296),o=56320|1023&o),r.push(o),i+=a}return T(r)}function T(t){var e=t.length;if(e<=tt)return String.fromCharCode.apply(String,t);for(var n="",r=0;r<e;)n+=String.fromCharCode.apply(String,t.slice(r,r+=tt));return n}function D(t,e,n){var r="";n=Math.min(t.length,n);for(var i=e;i<n;++i)r+=String.fromCharCode(127&t[i]);return r}function H(t,e,n){var r="";n=Math.min(t.length,n);for(var i=e;i<n;++i)r+=String.fromCharCode(t[i]);return r}function j(t,e,n){var r=t.length;(!e||e<0)&&(e=0),(!n||n<0||n>r)&&(n=r);for(var i="",s=e;s<n;++s)i+=q(t[s]);return i}function R(t,e,n){for(var r=t.slice(e,n),i="",s=0;s<r.length;s+=2)i+=String.fromCharCode(r[s]+256*r[s+1]);return i}function I(t,e,n){if(t%1!==0||t<0)throw new RangeError("offset is not uint");if(t+e>n)throw new RangeError("Trying to access beyond buffer length")}function k(e,n,r,i,s,o){if(!t.isBuffer(e))throw new TypeError('"buffer" argument must be a Buffer instance');if(n>s||n<o)throw new RangeError('"value" argument is out of bounds');if(r+i>e.length)throw new RangeError("Index out of range")}function B(t,e,n,r){e<0&&(e=65535+e+1);for(var i=0,s=Math.min(t.length-n,2);i<s;++i)t[n+i]=(e&255<<8*(r?i:1-i))>>>8*(r?i:1-i)}function N(t,e,n,r){e<0&&(e=4294967295+e+1);for(var i=0,s=Math.min(t.length-n,4);i<s;++i)t[n+i]=e>>>8*(r?i:3-i)&255}function V(t,e,n,r,i,s){if(n+r>t.length)throw new RangeError("Index out of range");if(n<0)throw new RangeError("Index out of range")}function M(t,e,n,r,i){return i||V(t,e,n,4,3.4028234663852886e38,-3.4028234663852886e38),Z.write(t,e,n,r,23,4),n+4}function K(t,e,n,r,i){return i||V(t,e,n,8,1.7976931348623157e308,-1.7976931348623157e308),Z.write(t,e,n,r,52,8),n+8}function L(t){if(t=U(t).replace(et,""),t.length<2)return"";for(;t.length%4!==0;)t+="=";return t}function U(t){return t.trim?t.trim():t.replace(/^\s+|\s+$/g,"")}function q(t){return t<16?"0"+t.toString(16):t.toString(16)}function W(t,e){e=e||1/0;for(var n,r=t.length,i=null,s=[],o=0;o<r;++o){if(n=t.charCodeAt(o),n>55295&&n<57344){if(!i){if(n>56319){(e-=3)>-1&&s.push(239,191,189);continue}if(o+1===r){(e-=3)>-1&&s.push(239,191,189);continue}i=n;continue}if(n<56320){(e-=3)>-1&&s.push(239,191,189),i=n;continue}n=(i-55296<<10|n-56320)+65536}else i&&(e-=3)>-1&&s.push(239,191,189);if(i=null,n<128){if((e-=1)<0)break;s.push(n)}else if(n<2048){if((e-=2)<0)break;s.push(n>>6|192,63&n|128)}else if(n<65536){if((e-=3)<0)break;s.push(n>>12|224,n>>6&63|128,63&n|128)}else{if(!(n<1114112))throw new Error("Invalid code point");if((e-=4)<0)break;s.push(n>>18|240,n>>12&63|128,n>>6&63|128,63&n|128)}}return s}function J(t){for(var e=[],n=0;n<t.length;++n)e.push(255&t.charCodeAt(n));return e}function z(t,e){for(var n,r,i,s=[],o=0;o<t.length&&!((e-=2)<0);++o)n=t.charCodeAt(o),r=n>>8,i=n%256,s.push(i),s.push(r);return s}function Y(t){return $.toByteArray(L(t))}function G(t,e,n,r){for(var i=0;i<r&&!(i+n>=e.length||i>=t.length);++i)e[i+n]=t[i];return i}function X(t){return t!==t}var $=n(14),Z=n(15),Q=n(16);e.Buffer=t,e.SlowBuffer=y,e.INSPECT_MAX_BYTES=50,t.TYPED_ARRAY_SUPPORT=void 0!==r.TYPED_ARRAY_SUPPORT?r.TYPED_ARRAY_SUPPORT:i(),e.kMaxLength=s(),t.poolSize=8192,t._augment=function(e){return e.__proto__=t.prototype,e},t.from=function(t,e,n){return a(null,t,e,n)},t.TYPED_ARRAY_SUPPORT&&(t.prototype.__proto__=Uint8Array.prototype,t.__proto__=Uint8Array,"undefined"!=typeof Symbol&&Symbol.species&&t[Symbol.species]===t&&Object.defineProperty(t,Symbol.species,{value:null,configurable:!0})),t.alloc=function(t,e,n){return h(null,t,e,n)},t.allocUnsafe=function(t){return c(null,t)},t.allocUnsafeSlow=function(t){return c(null,t)},t.isBuffer=function(t){return!(null==t||!t._isBuffer)},t.compare=function(e,n){if(!t.isBuffer(e)||!t.isBuffer(n))throw new TypeError("Arguments must be Buffers");if(e===n)return 0;for(var r=e.length,i=n.length,s=0,o=Math.min(r,i);s<o;++s)if(e[s]!==n[s]){r=e[s],i=n[s];break}return r<i?-1:i<r?1:0},t.isEncoding=function(t){switch(String(t).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1}},t.concat=function(e,n){if(!Q(e))throw new TypeError('"list" argument must be an Array of Buffers');if(0===e.length)return t.alloc(0);var r;if(void 0===n)for(n=0,r=0;r<e.length;++r)n+=e[r].length;var i=t.allocUnsafe(n),s=0;for(r=0;r<e.length;++r){var o=e[r];if(!t.isBuffer(o))throw new TypeError('"list" argument must be an Array of Buffers');o.copy(i,s),s+=o.length}return i},t.byteLength=v,t.prototype._isBuffer=!0,t.prototype.swap16=function(){var t=this.length;if(t%2!==0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(var e=0;e<t;e+=2)S(this,e,e+1);return this},t.prototype.swap32=function(){var t=this.length;if(t%4!==0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(var e=0;e<t;e+=4)S(this,e,e+3),S(this,e+1,e+2);return this},t.prototype.swap64=function(){var t=this.length;if(t%8!==0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(var e=0;e<t;e+=8)S(this,e,e+7),S(this,e+1,e+6),S(this,e+2,e+5),S(this,e+3,e+4);return this},t.prototype.toString=function(){var t=0|this.length;return 0===t?"":0===arguments.length?C(this,0,t):m.apply(this,arguments)},t.prototype.equals=function(e){if(!t.isBuffer(e))throw new TypeError("Argument must be a Buffer");return this===e||0===t.compare(this,e)},t.prototype.inspect=function(){var t="",n=e.INSPECT_MAX_BYTES;return this.length>0&&(t=this.toString("hex",0,n).match(/.{2}/g).join(" "),this.length>n&&(t+=" ... ")),"<Buffer "+t+">"},t.prototype.compare=function(e,n,r,i,s){if(!t.isBuffer(e))throw new TypeError("Argument must be a Buffer");if(void 0===n&&(n=0),void 0===r&&(r=e?e.length:0),void 0===i&&(i=0),void 0===s&&(s=this.length),n<0||r>e.length||i<0||s>this.length)throw new RangeError("out of range index");if(i>=s&&n>=r)return 0;if(i>=s)return-1;if(n>=r)return 1;if(n>>>=0,r>>>=0,i>>>=0,s>>>=0,this===e)return 0;for(var o=s-i,a=r-n,u=Math.min(o,a),h=this.slice(i,s),c=e.slice(n,r),f=0;f<u;++f)if(h[f]!==c[f]){o=h[f],a=c[f];break}return o<a?-1:a<o?1:0},t.prototype.includes=function(t,e,n){return this.indexOf(t,e,n)!==-1},t.prototype.indexOf=function(t,e,n){return b(this,t,e,n,!0)},t.prototype.lastIndexOf=function(t,e,n){return b(this,t,e,n,!1)},t.prototype.write=function(t,e,n,r){if(void 0===e)r="utf8",n=this.length,e=0;else if(void 0===n&&"string"==typeof e)r=e,n=this.length,e=0;else{if(!isFinite(e))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");e|=0,isFinite(n)?(n|=0,void 0===r&&(r="utf8")):(r=n,n=void 0)}var i=this.length-e;if((void 0===n||n>i)&&(n=i),t.length>0&&(n<0||e<0)||e>this.length)throw new RangeError("Attempt to write outside buffer bounds");r||(r="utf8");for(var s=!1;;)switch(r){case"hex":return E(this,t,e,n);case"utf8":case"utf-8":return x(this,t,e,n);case"ascii":return A(this,t,e,n);case"latin1":case"binary":return _(this,t,e,n);case"base64":return F(this,t,e,n);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return P(this,t,e,n);default:if(s)throw new TypeError("Unknown encoding: "+r);r=(""+r).toLowerCase(),s=!0}},t.prototype.toJSON=function(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};var tt=4096;t.prototype.slice=function(e,n){var r=this.length;e=~~e,n=void 0===n?r:~~n,e<0?(e+=r,e<0&&(e=0)):e>r&&(e=r),n<0?(n+=r,n<0&&(n=0)):n>r&&(n=r),n<e&&(n=e);var i;if(t.TYPED_ARRAY_SUPPORT)i=this.subarray(e,n),i.__proto__=t.prototype;else{var s=n-e;i=new t(s,void 0);for(var o=0;o<s;++o)i[o]=this[o+e]}return i},t.prototype.readUIntLE=function(t,e,n){t|=0,e|=0,n||I(t,e,this.length);for(var r=this[t],i=1,s=0;++s<e&&(i*=256);)r+=this[t+s]*i;return r},t.prototype.readUIntBE=function(t,e,n){t|=0,e|=0,n||I(t,e,this.length);for(var r=this[t+--e],i=1;e>0&&(i*=256);)r+=this[t+--e]*i;return r},t.prototype.readUInt8=function(t,e){return e||I(t,1,this.length),this[t]},t.prototype.readUInt16LE=function(t,e){return e||I(t,2,this.length),this[t]|this[t+1]<<8},t.prototype.readUInt16BE=function(t,e){return e||I(t,2,this.length),this[t]<<8|this[t+1]},t.prototype.readUInt32LE=function(t,e){return e||I(t,4,this.length),(this[t]|this[t+1]<<8|this[t+2]<<16)+16777216*this[t+3]},t.prototype.readUInt32BE=function(t,e){return e||I(t,4,this.length),16777216*this[t]+(this[t+1]<<16|this[t+2]<<8|this[t+3])},t.prototype.readIntLE=function(t,e,n){t|=0,e|=0,n||I(t,e,this.length);for(var r=this[t],i=1,s=0;++s<e&&(i*=256);)r+=this[t+s]*i;return i*=128,r>=i&&(r-=Math.pow(2,8*e)),r},t.prototype.readIntBE=function(t,e,n){t|=0,e|=0,n||I(t,e,this.length);for(var r=e,i=1,s=this[t+--r];r>0&&(i*=256);)s+=this[t+--r]*i;return i*=128,s>=i&&(s-=Math.pow(2,8*e)),s},t.prototype.readInt8=function(t,e){return e||I(t,1,this.length),128&this[t]?(255-this[t]+1)*-1:this[t]},t.prototype.readInt16LE=function(t,e){e||I(t,2,this.length);var n=this[t]|this[t+1]<<8;return 32768&n?4294901760|n:n},t.prototype.readInt16BE=function(t,e){e||I(t,2,this.length);var n=this[t+1]|this[t]<<8;return 32768&n?4294901760|n:n},t.prototype.readInt32LE=function(t,e){return e||I(t,4,this.length),this[t]|this[t+1]<<8|this[t+2]<<16|this[t+3]<<24},t.prototype.readInt32BE=function(t,e){return e||I(t,4,this.length),this[t]<<24|this[t+1]<<16|this[t+2]<<8|this[t+3]},t.prototype.readFloatLE=function(t,e){return e||I(t,4,this.length),Z.read(this,t,!0,23,4)},t.prototype.readFloatBE=function(t,e){return e||I(t,4,this.length),Z.read(this,t,!1,23,4)},t.prototype.readDoubleLE=function(t,e){return e||I(t,8,this.length),Z.read(this,t,!0,52,8)},t.prototype.readDoubleBE=function(t,e){return e||I(t,8,this.length),Z.read(this,t,!1,52,8)},t.prototype.writeUIntLE=function(t,e,n,r){if(t=+t,e|=0,n|=0,!r){var i=Math.pow(2,8*n)-1;k(this,t,e,n,i,0)}var s=1,o=0;for(this[e]=255&t;++o<n&&(s*=256);)this[e+o]=t/s&255;return e+n},t.prototype.writeUIntBE=function(t,e,n,r){if(t=+t,e|=0,n|=0,!r){var i=Math.pow(2,8*n)-1;k(this,t,e,n,i,0)}var s=n-1,o=1;for(this[e+s]=255&t;--s>=0&&(o*=256);)this[e+s]=t/o&255;return e+n},t.prototype.writeUInt8=function(e,n,r){return e=+e,n|=0,r||k(this,e,n,1,255,0),t.TYPED_ARRAY_SUPPORT||(e=Math.floor(e)),this[n]=255&e,n+1},t.prototype.writeUInt16LE=function(e,n,r){return e=+e,n|=0,r||k(this,e,n,2,65535,0),t.TYPED_ARRAY_SUPPORT?(this[n]=255&e,this[n+1]=e>>>8):B(this,e,n,!0),n+2},t.prototype.writeUInt16BE=function(e,n,r){return e=+e,n|=0,r||k(this,e,n,2,65535,0),t.TYPED_ARRAY_SUPPORT?(this[n]=e>>>8,this[n+1]=255&e):B(this,e,n,!1),n+2},t.prototype.writeUInt32LE=function(e,n,r){return e=+e,n|=0,r||k(this,e,n,4,4294967295,0),t.TYPED_ARRAY_SUPPORT?(this[n+3]=e>>>24,this[n+2]=e>>>16,this[n+1]=e>>>8,this[n]=255&e):N(this,e,n,!0),n+4},t.prototype.writeUInt32BE=function(e,n,r){return e=+e,n|=0,r||k(this,e,n,4,4294967295,0),t.TYPED_ARRAY_SUPPORT?(this[n]=e>>>24,this[n+1]=e>>>16,this[n+2]=e>>>8,this[n+3]=255&e):N(this,e,n,!1),n+4},t.prototype.writeIntLE=function(t,e,n,r){if(t=+t,e|=0,!r){var i=Math.pow(2,8*n-1);k(this,t,e,n,i-1,-i)}var s=0,o=1,a=0;for(this[e]=255&t;++s<n&&(o*=256);)t<0&&0===a&&0!==this[e+s-1]&&(a=1),this[e+s]=(t/o>>0)-a&255;return e+n},t.prototype.writeIntBE=function(t,e,n,r){if(t=+t,e|=0,!r){var i=Math.pow(2,8*n-1);k(this,t,e,n,i-1,-i)}var s=n-1,o=1,a=0;for(this[e+s]=255&t;--s>=0&&(o*=256);)t<0&&0===a&&0!==this[e+s+1]&&(a=1),this[e+s]=(t/o>>0)-a&255;return e+n},t.prototype.writeInt8=function(e,n,r){return e=+e,n|=0,r||k(this,e,n,1,127,-128),t.TYPED_ARRAY_SUPPORT||(e=Math.floor(e)),e<0&&(e=255+e+1),this[n]=255&e,n+1},t.prototype.writeInt16LE=function(e,n,r){return e=+e,n|=0,r||k(this,e,n,2,32767,-32768),t.TYPED_ARRAY_SUPPORT?(this[n]=255&e,this[n+1]=e>>>8):B(this,e,n,!0),n+2},t.prototype.writeInt16BE=function(e,n,r){return e=+e,n|=0,r||k(this,e,n,2,32767,-32768),t.TYPED_ARRAY_SUPPORT?(this[n]=e>>>8,this[n+1]=255&e):B(this,e,n,!1),n+2},t.prototype.writeInt32LE=function(e,n,r){return e=+e,n|=0,r||k(this,e,n,4,2147483647,-2147483648),t.TYPED_ARRAY_SUPPORT?(this[n]=255&e,this[n+1]=e>>>8,this[n+2]=e>>>16,this[n+3]=e>>>24):N(this,e,n,!0),n+4},t.prototype.writeInt32BE=function(e,n,r){return e=+e,n|=0,r||k(this,e,n,4,2147483647,-2147483648),e<0&&(e=4294967295+e+1),t.TYPED_ARRAY_SUPPORT?(this[n]=e>>>24,this[n+1]=e>>>16,this[n+2]=e>>>8,this[n+3]=255&e):N(this,e,n,!1),n+4},t.prototype.writeFloatLE=function(t,e,n){return M(this,t,e,!0,n)},t.prototype.writeFloatBE=function(t,e,n){return M(this,t,e,!1,n)},t.prototype.writeDoubleLE=function(t,e,n){return K(this,t,e,!0,n)},t.prototype.writeDoubleBE=function(t,e,n){return K(this,t,e,!1,n)},t.prototype.copy=function(e,n,r,i){if(r||(r=0),i||0===i||(i=this.length),n>=e.length&&(n=e.length),n||(n=0),i>0&&i<r&&(i=r),i===r)return 0;if(0===e.length||0===this.length)return 0;if(n<0)throw new RangeError("targetStart out of bounds");if(r<0||r>=this.length)throw new RangeError("sourceStart out of bounds");if(i<0)throw new RangeError("sourceEnd out of bounds");i>this.length&&(i=this.length),e.length-n<i-r&&(i=e.length-n+r);var s,o=i-r;if(this===e&&r<n&&n<i)for(s=o-1;s>=0;--s)e[s+n]=this[s+r];else if(o<1e3||!t.TYPED_ARRAY_SUPPORT)for(s=0;s<o;++s)e[s+n]=this[s+r];else Uint8Array.prototype.set.call(e,this.subarray(r,r+o),n);return o},t.prototype.fill=function(e,n,r,i){if("string"==typeof e){if("string"==typeof n?(i=n,n=0,r=this.length):"string"==typeof r&&(i=r,r=this.length),1===e.length){var s=e.charCodeAt(0);s<256&&(e=s)}if(void 0!==i&&"string"!=typeof i)throw new TypeError("encoding must be a string");if("string"==typeof i&&!t.isEncoding(i))throw new TypeError("Unknown encoding: "+i)}else"number"==typeof e&&(e&=255);if(n<0||this.length<n||this.length<r)throw new RangeError("Out of range index");if(r<=n)return this;n>>>=0,r=void 0===r?this.length:r>>>0,e||(e=0);var o;if("number"==typeof e)for(o=n;o<r;++o)this[o]=e;else{var a=t.isBuffer(e)?e:W(new t(e,i).toString()),u=a.length;for(o=0;o<r-n;++o)this[o+n]=a[o%u]}return this};var et=/[^+\/0-9A-Za-z-_]/g}).call(e,n(13).Buffer,function(){return this}())},function(t,e){"use strict";function n(t){var e=t.length;if(e%4>0)throw new Error("Invalid string. Length must be a multiple of 4");return"="===t[e-2]?2:"="===t[e-1]?1:0}function r(t){return 3*t.length/4-n(t)}function i(t){var e,r,i,s,o,a,u=t.length;o=n(t),a=new c(3*u/4-o),i=o>0?u-4:u;var f=0;for(e=0,r=0;e<i;e+=4,r+=3)s=h[t.charCodeAt(e)]<<18|h[t.charCodeAt(e+1)]<<12|h[t.charCodeAt(e+2)]<<6|h[t.charCodeAt(e+3)],a[f++]=s>>16&255,a[f++]=s>>8&255,a[f++]=255&s;return 2===o?(s=h[t.charCodeAt(e)]<<2|h[t.charCodeAt(e+1)]>>4,a[f++]=255&s):1===o&&(s=h[t.charCodeAt(e)]<<10|h[t.charCodeAt(e+1)]<<4|h[t.charCodeAt(e+2)]>>2,a[f++]=s>>8&255,a[f++]=255&s),a}function s(t){return u[t>>18&63]+u[t>>12&63]+u[t>>6&63]+u[63&t]}function o(t,e,n){for(var r,i=[],o=e;o<n;o+=3)r=(t[o]<<16)+(t[o+1]<<8)+t[o+2],i.push(s(r));return i.join("")}function a(t){for(var e,n=t.length,r=n%3,i="",s=[],a=16383,h=0,c=n-r;h<c;h+=a)s.push(o(t,h,h+a>c?c:h+a));return 1===r?(e=t[n-1],i+=u[e>>2],i+=u[e<<4&63],i+="=="):2===r&&(e=(t[n-2]<<8)+t[n-1],i+=u[e>>10],i+=u[e>>4&63],i+=u[e<<2&63],i+="="),s.push(i),s.join("")}e.byteLength=r,e.toByteArray=i,e.fromByteArray=a;for(var u=[],h=[],c="undefined"!=typeof Uint8Array?Uint8Array:Array,f="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",l=0,d=f.length;l<d;++l)u[l]=f[l],h[f.charCodeAt(l)]=l;h["-".charCodeAt(0)]=62,h["_".charCodeAt(0)]=63},function(t,e){e.read=function(t,e,n,r,i){var s,o,a=8*i-r-1,u=(1<<a)-1,h=u>>1,c=-7,f=n?i-1:0,l=n?-1:1,d=t[e+f];for(f+=l,s=d&(1<<-c)-1,d>>=-c,c+=a;c>0;s=256*s+t[e+f],f+=l,c-=8);for(o=s&(1<<-c)-1,s>>=-c,c+=r;c>0;o=256*o+t[e+f],f+=l,c-=8);if(0===s)s=1-h;else{if(s===u)return o?NaN:(d?-1:1)*(1/0);o+=Math.pow(2,r),s-=h}return(d?-1:1)*o*Math.pow(2,s-r)},e.write=function(t,e,n,r,i,s){var o,a,u,h=8*s-i-1,c=(1<<h)-1,f=c>>1,l=23===i?Math.pow(2,-24)-Math.pow(2,-77):0,d=r?0:s-1,p=r?1:-1,g=e<0||0===e&&1/e<0?1:0;for(e=Math.abs(e),isNaN(e)||e===1/0?(a=isNaN(e)?1:0,o=c):(o=Math.floor(Math.log(e)/Math.LN2),e*(u=Math.pow(2,-o))<1&&(o--,u*=2),e+=o+f>=1?l/u:l*Math.pow(2,1-f),e*u>=2&&(o++,u/=2),o+f>=c?(a=0,o=c):o+f>=1?(a=(e*u-1)*Math.pow(2,i),o+=f):(a=e*Math.pow(2,f-1)*Math.pow(2,i),o=0));i>=8;t[n+d]=255&a,d+=p,a/=256,i-=8);for(o=o<<i|a,h+=i;h>0;t[n+d]=255&o,d+=p,o/=256,h-=8);t[n+d-p]|=128*g}},function(t,e){var n={}.toString;t.exports=Array.isArray||function(t){return"[object Array]"==n.call(t)}},function(t,e){},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(1),o=r(s),a=n(19),u=r(a),h=n(20),c=r(h),f=function(){function t(e){var n=e.url,r=e.client_id,s=e.redirect_uri,a=e.response_type,h=e.scope,f=e.authority,l=e.data,d=e.prompt,p=e.display,g=e.max_age,y=e.ui_locales,v=e.id_token_hint,m=e.login_hint,S=e.acr_values,b=e.resource;if(i(this,t),!n)throw o.default.error("No url passed to SigninRequest"),new Error("url");if(!r)throw o.default.error("No client_id passed to SigninRequest"),new Error("client_id");if(!s)throw o.default.error("No redirect_uri passed to SigninRequest"),new Error("redirect_uri");if(!a)throw o.default.error("No response_type passed to SigninRequest"),new Error("response_type");if(!h)throw o.default.error("No scope passed to SigninRequest"),new Error("scope");if(!f)throw o.default.error("No authority passed to SigninRequest"),new Error("authority");var w=t.isOidc(a);this.state=new c.default({nonce:w,data:l,client_id:r,authority:f}),n=u.default.addQueryParam(n,"client_id",r),n=u.default.addQueryParam(n,"redirect_uri",s),n=u.default.addQueryParam(n,"response_type",a),n=u.default.addQueryParam(n,"scope",h),n=u.default.addQueryParam(n,"state",this.state.id),w&&(n=u.default.addQueryParam(n,"nonce",this.state.nonce));var E={prompt:d,display:p,max_age:g,ui_locales:y,id_token_hint:v,login_hint:m,acr_values:S,resource:b};for(var x in E)E[x]&&(n=u.default.addQueryParam(n,x,E[x]));this.url=n}return t.isOidc=function(t){var e=t.split(/\s+/g).filter(function(t){return"id_token"===t});return!!e[0]},t.isOAuth=function(t){var e=t.split(/\s+/g).filter(function(t){return"token"===t});return!!e[0]},t}();e.default=f,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(1),o=r(s),a=n(5),u=r(a),h=function(){function t(){i(this,t)}return t.addQueryParam=function(t,e,n){return t.indexOf("?")<0&&(t+="?"),"?"!==t[t.length-1]&&(t+="&"),t+=encodeURIComponent(e),t+="=",t+=encodeURIComponent(n)},t.parseUrlFragment=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"#",n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:u.default;o.default.info("UrlUtility.parseUrlFragment"),"string"!=typeof t&&(t=n.location.href);var r=t.lastIndexOf(e);r>=0&&(t=t.substr(r+1));for(var i,s={},a=/([^&=]+)=([^&]*)/g,h=0;i=a.exec(t);)if(s[decodeURIComponent(i[1])]=decodeURIComponent(i[2]),h++>50)return o.default.error("response exceeded expected number of parameters",t),{error:"Response exceeded expected number of parameters"};for(var c in s)return s;return{}},t}();e.default=h,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function s(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=n(1),h=r(u),c=n(21),f=r(c),l=n(22),d=r(l),p=function(t){function e(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=n.nonce,o=n.authority,a=n.client_id;i(this,e);var u=s(this,t.call(this,arguments[0]));return r===!0?u._nonce=(0,d.default)():r&&(u._nonce=r),u._authority=o,u._client_id=a,u}return o(e,t),e.prototype.toStorageString=function(){return h.default.info("SigninState.toStorageString"),JSON.stringify({id:this.id,data:this.data,created:this.created,nonce:this.nonce,authority:this.authority,client_id:this.client_id})},e.fromStorageString=function(t){h.default.info("SigninState.fromStorageString");var n=JSON.parse(t);return new e(n)},a(e,[{key:"nonce",get:function(){return this._nonce}},{key:"authority",get:function(){return this._authority}},{key:"client_id",get:function(){return this._client_id}}]),e}(f.default);e.default=p,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=n(1),a=r(o),u=n(22),h=r(u),c=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=e.id,r=e.data,s=e.created;i(this,t),this._id=n||(0,h.default)(),this._data=r,"number"==typeof s&&s>0?this._created=s:this._created=parseInt(Date.now()/1e3)}return t.prototype.toStorageString=function(){return a.default.info("State.toStorageString"),JSON.stringify({id:this.id,data:this.data,created:this.created})},t.fromStorageString=function(e){return a.default.info("State.fromStorageString"),new t(JSON.parse(e))},t.clearStaleState=function(e,n){a.default.info("State.clearStaleState");var r=Date.now()/1e3-n;return e.getAllKeys().then(function(n){a.default.info("got keys",n);var i=[],s=!0,o=!1,u=void 0;try{for(var h,c=function(){var n=h.value;l=e.get(n).then(function(i){var s=!1;if(i)try{var o=t.fromStorageString(i);a.default.info("got item from key: ",n,o.created),o.created<=r&&(s=!0)}catch(t){a.default.error("Error parsing state for key",n,t.message),s=!0}else a.default.info("no item in storage for key: ",n),s=!0;if(s)return a.default.info("removed item for key: ",n),e.remove(n)}),i.push(l)},f=n[Symbol.iterator]();!(s=(h=f.next()).done);s=!0){var l;c()}}catch(t){o=!0,u=t}finally{try{!s&&f.return&&f.return()}finally{if(o)throw u}}return a.default.info("waiting on promise count:",i.length),Promise.all(i)})},s(t,[{key:"id",get:function(){return this._id}},{key:"data",get:function(){return this._data}},{key:"created",get:function(){return this._created}}]),t}();e.default=c,t.exports=e.default},function(t,e){"use strict";
	// @preserve Copyright (c) Microsoft Open Technologies, Inc.
	function n(){for(var t="xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx",e="0123456789abcdef",n=0,r="",i=0;i<t.length;i++)"-"!==t[i]&&"4"!==t[i]&&(n=16*Math.random()|0),"x"===t[i]?r+=e[n]:"y"===t[i]?(n&=3,n|=8,r+=e[n]):r+=t[i];return r}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=n(19),a=r(o),u="openid",h=function(){function t(e){i(this,t);var n=a.default.parseUrlFragment(e,"#");this.error=n.error,this.error_description=n.error_description,this.error_uri=n.error_uri,this.state=n.state,this.id_token=n.id_token,this.session_state=n.session_state,this.access_token=n.access_token,this.token_type=n.token_type,this.scope=n.scope,this.profile=void 0;var r=parseInt(n.expires_in);if("number"==typeof r&&r>0){var s=parseInt(Date.now()/1e3);this.expires_at=s+r}}return s(t,[{key:"expires_in",get:function(){if(this.expires_at){var t=parseInt(Date.now()/1e3);return this.expires_at-t}}},{key:"expired",get:function(){var t=this.expires_in;if(void 0!==t)return t<=0}},{key:"scopes",get:function(){return(this.scope||"").split(" ")}},{key:"isOpenIdConnect",get:function(){return this.scopes.indexOf(u)>=0||!!this.id_token}}]),t}();e.default=h,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(1),o=r(s),a=n(19),u=r(a),h=n(21),c=r(h),f=function t(e){var n=e.url,r=e.id_token_hint,s=e.post_logout_redirect_uri,a=e.data;if(i(this,t),!n)throw o.default.error("No url passed to SignoutRequest"),new Error("url");r&&(n=u.default.addQueryParam(n,"id_token_hint",r),s&&(n=u.default.addQueryParam(n,"post_logout_redirect_uri",s),a&&(this.state=new c.default({data:a}),n=u.default.addQueryParam(n,"state",this.state.id)))),this.url=n};e.default=f,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(19),o=r(s),a=function t(e){i(this,t);var n=o.default.parseUrlFragment(e,"?");this.error=n.error,this.error_description=n.error_description,this.error_uri=n.error_uri,this.state=n.state};e.default=a,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=n(1),a=r(o),u=function(){function t(){i(this,t),this._data={}}return t.prototype.getItem=function(t){return a.default.info("InMemoryWebStorage.getItem",t),this._data[t]},t.prototype.setItem=function(t,e){a.default.info("InMemoryWebStorage.setItem",t),this._data[t]=e},t.prototype.removeItem=function(t){a.default.info("InMemoryWebStorage.removeItem",t),delete this._data[t]},t.prototype.key=function(t){return Object.getOwnPropertyNames(this._data)[t]},s(t,[{key:"length",get:function(){return Object.getOwnPropertyNames(this._data).length}}]),t}();e.default=u,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function s(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=n(1),h=r(u),c=n(2),f=r(c),l=n(28),d=r(l),p=n(34),g=r(p),y=n(35),v=r(y),m=n(39),S=r(m),b=n(40),w=r(b),E=n(42),x=r(E),A=function(t){function e(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:S.default,o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:w.default,a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:x.default;i(this,e),n instanceof d.default||(n=new d.default(n));var u=s(this,t.call(this,n));return u._events=new v.default(n),u.settings.automaticSilentRenew&&(h.default.info("automaticSilentRenew is configured, setting up silent renew"),u._silentRenewService=new r(u)),u.settings.monitorSession&&(h.default.info("monitorSession is configured, setting up session monitor"),u._sessionMonitor=new o(u)),u._tokenRevocationClient=new a(u._settings),u}return o(e,t),e.prototype.getUser=function(){var t=this;return h.default.info("UserManager.getUser"),this._loadUser().then(function(e){return e?(h.default.info("user loaded"),t._events.load(e,!1),e):(h.default.info("user not found in storage"),null)})},e.prototype.removeUser=function(){var t=this;return h.default.info("UserManager.removeUser"),this._storeUser(null).then(function(){h.default.info("user removed from storage"),t._events.unload()})},e.prototype.signinPopup=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};h.default.info("UserManager.signinPopup");var e=t.redirect_uri||this.settings.popup_redirect_uri||this.settings.redirect_uri;return e?(t.redirect_uri=e,t.display="popup",this._signin(t,this._popupNavigator,{startUrl:e,popupWindowFeatures:t.popupWindowFeatures||this.settings.popupWindowFeatures,popupWindowTarget:t.popupWindowTarget||this.settings.popupWindowTarget})):(h.default.error("No popup_redirect_uri or redirect_uri configured"),Promise.reject(new Error("No popup_redirect_uri or redirect_uri configured")))},e.prototype.signinPopupCallback=function(t){return h.default.info("UserManager.signinPopupCallback"),this._signinCallback(t,this._popupNavigator)},e.prototype.signinSilent=function(){var t=this,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};h.default.info("UserManager.signinSilent");var n=e.redirect_uri||this.settings.silent_redirect_uri;if(!n)return h.default.error("No silent_redirect_uri configured"),Promise.reject(new Error("No silent_redirect_uri configured"));e.redirect_uri=n,e.prompt="none";var r=void 0;return r=e.id_token_hint?Promise.resolve():this._loadUser().then(function(t){e.id_token_hint=t&&t.id_token}),r.then(function(){return t._signin(e,t._iframeNavigator,{startUrl:n,silentRequestTimeout:e.silentRequestTimeout||t.settings.silentRequestTimeout})})},e.prototype.signinSilentCallback=function(t){return h.default.info("UserManager.signinSilentCallback"),this._signinCallback(t,this._iframeNavigator)},e.prototype.querySessionStatus=function(){var t=this,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};h.default.info("UserManager.querySessionStatus");var n=e.redirect_uri||this.settings.silent_redirect_uri;return n?(e.redirect_uri=n,e.prompt="none",e.response_type="id_token",e.scope="openid",this._signinStart(e,this._iframeNavigator,{startUrl:n,silentRequestTimeout:e.silentRequestTimeout||this.settings.silentRequestTimeout}).then(function(e){return t.processSigninResponse(e.url).then(function(t){if(h.default.info("got signin response"),t.session_state&&t.profile.sub&&t.profile.sid)return{session_state:t.session_state,sub:t.profile.sub,sid:t.profile.sid}})})):(h.default.error("No silent_redirect_uri configured"),Promise.reject(new Error("No silent_redirect_uri configured")))},e.prototype.revokeAccessToken=function(){var t=this;return h.default.info("UserManager.revokeAccessToken"),this._loadUser().then(function(e){return t._revokeInternal(e,!0).then(function(n){if(n)return h.default.info("removing token properties from user and re-storing"),e.access_token=null,e.expires_at=null,e.token_type=null,t._storeUser(e).then(function(){h.default.info("user stored"),t._events.load(e)})})})},e.prototype._revokeInternal=function(t,e){h.default.info("checking if token revocation is necessary");var n=t&&t.access_token;return!n||n.indexOf(".")>=0?(h.default.info("no need to revoke due to no user, token, or JWT format"),Promise.resolve(!1)):this._tokenRevocationClient.revoke(n,e).then(function(){return!0})},e.prototype._signin=function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return h.default.info("_signin"),this._signinStart(t,e,r).then(function(t){return n._signinEnd(t.url)})},e.prototype._signinCallback=function(t,e){return h.default.info("_signinCallback"),e.callback(t)},e.prototype._signout=function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return h.default.info("_signout"),this._signoutStart(t,e,r).then(function(t){return n._signoutEnd(t.url)})},e.prototype._signoutCallback=function(t,e){return h.default.info("_signoutCallback"),e.callback(t)},e.prototype.signinRedirect=function(t){return h.default.info("UserManager.signinRedirect"),this._signinStart(t,this._redirectNavigator)},e.prototype.signinRedirectCallback=function(t){return h.default.info("UserManager.signinRedirectCallback"),this._signinEnd(t||this._redirectNavigator.url)},e.prototype.signoutRedirect=function(t){return h.default.info("UserManager.signoutRedirect"),this._signoutStart(t,this._redirectNavigator)},e.prototype.signoutPopup=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};h.default.info("UserManager.signoutPopup");var e=t.redirect_uri||this.settings.popup_redirect_uri||this.settings.redirect_uri;return e?this._signout(t,this._popupNavigator,{startUrl:e,popupWindowFeatures:t.popupWindowFeatures||this.settings.popupWindowFeatures,popupWindowTarget:t.popupWindowTarget||this.settings.popupWindowTarget}):(h.default.error("No popup_redirect_uri or redirect_uri configured"),Promise.reject(new Error("No popup_redirect_uri or redirect_uri configured")))},e.prototype.signoutRedirectCallback=function(t){return h.default.info("UserManager.signoutRedirectCallback"),this._signoutEnd(t||this._redirectNavigator.url)},e.prototype._signinStart=function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return h.default.info("_signinStart"),e.prepare(r).then(function(e){return h.default.info("got navigator window handle"),n.createSigninRequest(t).then(function(t){return h.default.info("got signin request"),r.url=t.url,r.id=t.state.id,e.navigate(r)})})},e.prototype._signinEnd=function(t){var e=this;return h.default.info("_signinEnd"),this.processSigninResponse(t).then(function(t){h.default.info("got signin response");var n=new g.default(t);return e._storeUser(n).then(function(){return h.default.info("user stored"),e._events.load(n),n})})},e.prototype._signoutStart=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=this,n=arguments[1],r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return h.default.info("_signoutStart"),n.prepare(r).then(function(n){return h.default.info("got navigator window handle"),e._loadUser().then(function(i){h.default.info("loaded current user from storage");var s=e._settings.revokeAccessTokenOnSignout?e._revokeInternal(i):Promise.resolve();return s.then(function(){var s=t.id_token_hint||i&&i.id_token;return s&&(h.default.info("Setting id_token into signout request"),t.id_token_hint=s),e.removeUser().then(function(){return h.default.info("user removed, creating signout request"),e.createSignoutRequest(t).then(function(t){return h.default.info("got signout request"),r.url=t.url,n.navigate(r)})})})})})},e.prototype._signoutEnd=function(t){return h.default.info("_signoutEnd"),this.processSignoutResponse(t).then(function(t){return h.default.info("got signout response"),t})},e.prototype._loadUser=function(){return h.default.info("_loadUser"),this._userStore.get(this._userStoreKey).then(function(t){return t?(h.default.info("user storageString loaded"),g.default.fromStorageString(t)):(h.default.info("no user storageString"),null)})},e.prototype._storeUser=function(t){if(t){h.default.info("_storeUser storing user");var e=t.toStorageString();return this._userStore.set(this._userStoreKey,e)}return h.default.info("_storeUser removing user storage"),this._userStore.remove(this._userStoreKey)},a(e,[{key:"_redirectNavigator",get:function(){return this.settings.redirectNavigator}},{key:"_popupNavigator",get:function(){return this.settings.popupNavigator}},{key:"_iframeNavigator",get:function(){return this.settings.iframeNavigator}},{key:"_userStore",get:function(){return this.settings.userStore}},{key:"events",get:function(){return this._events}},{key:"_userStoreKey",get:function(){return"user:"+this.settings.authority+":"+this.settings.client_id}}]),e}(f.default);e.default=A,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function s(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=n(1),h=(r(u),n(3)),c=r(h),f=n(29),l=r(f),d=n(30),p=r(d),g=n(32),y=r(g),v=n(4),m=r(v),S=n(5),b=r(S),w=60,E=2e3,x=function(t){function e(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=n.popup_redirect_uri,o=n.popupWindowFeatures,a=n.popupWindowTarget,u=n.silent_redirect_uri,h=n.silentRequestTimeout,c=n.automaticSilentRenew,f=void 0!==c&&c,d=n.monitorSession,g=void 0===d||d,v=n.checkSessionInterval,S=void 0===v?E:v,x=n.revokeAccessTokenOnSignout,A=void 0!==x&&x,_=n.accessTokenExpiringNotificationTime,F=void 0===_?w:_,P=n.redirectNavigator,O=void 0===P?new l.default:P,C=n.popupNavigator,T=void 0===C?new p.default:C,D=n.iframeNavigator,H=void 0===D?new y.default:D,j=n.userStore,R=void 0===j?new m.default({store:b.default.sessionStorage}):j;i(this,e);var I=s(this,t.call(this,arguments[0]));return I._popup_redirect_uri=r,I._popupWindowFeatures=o,I._popupWindowTarget=a,I._silent_redirect_uri=u,I._silentRequestTimeout=h,I._automaticSilentRenew=!!f,I._accessTokenExpiringNotificationTime=F,I._monitorSession=g,I._checkSessionInterval=S,I._revokeAccessTokenOnSignout=A,I._redirectNavigator=O,I._popupNavigator=T,I._iframeNavigator=H,I._userStore=R,I}return o(e,t),a(e,[{key:"popup_redirect_uri",get:function(){return this._popup_redirect_uri}},{key:"popupWindowFeatures",get:function(){return this._popupWindowFeatures}},{key:"popupWindowTarget",get:function(){return this._popupWindowTarget}},{key:"silent_redirect_uri",get:function(){return this._silent_redirect_uri}},{key:"silentRequestTimeout",get:function(){return this._silentRequestTimeout}},{key:"automaticSilentRenew",get:function(){return!(!this.silent_redirect_uri||!this._automaticSilentRenew)}},{key:"accessTokenExpiringNotificationTime",get:function(){return this._accessTokenExpiringNotificationTime}},{key:"monitorSession",get:function(){return this._monitorSession}},{key:"checkSessionInterval",get:function(){return this._checkSessionInterval}},{key:"revokeAccessTokenOnSignout",get:function(){return this._revokeAccessTokenOnSignout}},{key:"redirectNavigator",get:function(){return this._redirectNavigator}},{key:"popupNavigator",get:function(){return this._popupNavigator}},{key:"iframeNavigator",get:function(){return this._iframeNavigator}},{key:"userStore",get:function(){return this._userStore}}]),e}(c.default);e.default=x,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=n(1),a=r(o),u=function(){function t(){i(this,t)}return t.prototype.prepare=function(){return Promise.resolve(this)},t.prototype.navigate=function(t){return a.default.info("RedirectNavigator.navigate"),t&&t.url?(window.location=t.url,Promise.resolve()):(a.default.error("No url provided"),Promise.reject(new Error("No url provided")))},s(t,[{key:"url",get:function(){return a.default.info("RedirectNavigator.url"),window.location.href}}]),t}();e.default=u,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(1),o=r(s),a=n(31),u=r(a),h=function(){function t(){i(this,t)}return t.prototype.prepare=function(t){var e=new u.default(t);return Promise.resolve(e)},t.prototype.callback=function(t){o.default.info("PopupNavigator.callback");try{return u.default.notifyOpener(t),Promise.resolve()}catch(t){return Promise.reject(t)}},t}();e.default=h,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=n(1),a=r(o),u=n(19),h=r(u),c=500,f="location=no,toolbar=no,width=500,height=500,left=100,top=100;",l="_blank",d=function(){function t(e){var n=this;i(this,t),a.default.info("PopupWindow.ctor"),this._promise=new Promise(function(t,e){n._resolve=t,n._reject=e});var r=e.popupWindowTarget||l,s=e.popupWindowFeatures||f;this._popup=window.open("",r,s),this._popup&&(a.default.info("popup successfully created"),this._checkForPopupClosedTimer=window.setInterval(this._checkForPopupClosed.bind(this),c))}return t.prototype.navigate=function(t){return a.default.info("PopupWindow.navigate"),this._popup?t&&t.url?(a.default.info("Setting URL in popup"),this._id=t.id,window["popupCallback_"+t.id]=this._callback.bind(this),this._popup.focus(),this._popup.window.location=t.url):this._error("No url provided"):this._error("Error opening popup window"),this.promise},t.prototype._success=function(t){this._cleanup(),a.default.info("Successful response from popup window"),this._resolve(t)},t.prototype._error=function(t){this._cleanup(),a.default.error(t),this._reject(new Error(t))},t.prototype._cleanup=function(){a.default.info("PopupWindow._cleanup"),window.clearInterval(this._checkForPopupClosedTimer),this._checkForPopupClosedTimer=null,delete window["popupCallback_"+this._id],this._popup&&this._popup.close(),this._popup=null},t.prototype._checkForPopupClosed=function(){a.default.info("PopupWindow._checkForPopupClosed"),this._popup&&!this._popup.closed||this._error("Popup window closed")},t.prototype._callback=function(t){a.default.info("PopupWindow._callback"),this._cleanup(),t?this._success({url:t}):this._error("Invalid response from popup")},t.notifyOpener=function(t){if(a.default.info("PopupWindow.notifyOpener"),window.opener&&(t=t||window.location.href)){var e=h.default.parseUrlFragment(t);if(e.state){var n="popupCallback_"+e.state,r=window.opener[n];r?(a.default.info("passing url message to opener"),r(t)):a.default.warn("no matching callback found on opener")}else a.default.warn("no state found in response url")}},s(t,[{key:"promise",get:function(){return this._promise}}]),t}();e.default=d,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(1),o=r(s),a=n(33),u=r(a),h=function(){function t(){i(this,t)}return t.prototype.prepare=function(t){var e=new u.default(t);return Promise.resolve(e)},t.prototype.callback=function(t){o.default.info("IFrameNavigator.callback");try{return u.default.notifyParent(t),Promise.resolve()}catch(t){return Promise.reject(t)}},t}();e.default=h,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=n(1),a=r(o),u=5e3,h=function(){function t(e){var n=this;i(this,t),a.default.info("IFrameWindow.ctor"),this._promise=new Promise(function(t,e){n._resolve=t,n._reject=e}),this._boundMessageEvent=this._message.bind(this),window.addEventListener("message",this._boundMessageEvent,!1),this._frame=window.document.createElement("iframe"),this._frame.style.display="none",window.document.body.appendChild(this._frame)}return t.prototype.navigate=function(t){if(a.default.info("IFrameWindow.navigate"),t&&t.url){var e=t.silentRequestTimeout||u;a.default.info("Using timeout of:",e),this._timer=window.setTimeout(this._timeout.bind(this),e),this._frame.src=t.url}else this._error("No url provided");return this.promise},t.prototype._success=function(t){this._cleanup(),a.default.info("Successful response from frame window"),this._resolve(t)},t.prototype._error=function(t){this._cleanup(),a.default.error(t),this._reject(new Error(t))},t.prototype._cleanup=function(){a.default.info("IFrameWindow._cleanup"),window.removeEventListener("message",this._boundMessageEvent,!1),window.clearTimeout(this._timer),window.document.body.removeChild(this._frame),this._timer=null,this._frame=null,this._boundMessageEvent=null},t.prototype._timeout=function(){a.default.info("IFrameWindow._timeout"),this._error("Frame window timed out")},t.prototype._message=function(t){if(a.default.info("IFrameWindow._message"),this._timer&&t.origin===this._origin&&t.source===this._frame.contentWindow){var e=t.data;e?this._success({url:e}):this._error("Invalid response from frame")}},t.notifyParent=function(t){a.default.info("IFrameWindow.notifyParent"),window.parent&&window!==window.parent&&(t=t||window.location.href,t&&(a.default.info("posting url message to parent"),window.parent.postMessage(t,location.protocol+"//"+location.host)))},s(t,[{key:"promise",get:function(){return this._promise}},{key:"_origin",get:function(){return location.protocol+"//"+location.host}}]),t}();e.default=h,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=n(1),a=r(o),u=function(){function t(e){var n=e.id_token,r=e.session_state,s=e.access_token,o=e.token_type,a=e.scope,u=e.profile,h=e.expires_at,c=e.state;i(this,t),this.id_token=n,this.session_state=r,this.access_token=s,this.token_type=o,this.scope=a,this.profile=u,this.expires_at=h,this.state=c}return t.prototype.toStorageString=function(){return a.default.info("User.toStorageString"),JSON.stringify({id_token:this.id_token,session_state:this.session_state,access_token:this.access_token,token_type:this.token_type,scope:this.scope,profile:this.profile,expires_at:this.expires_at})},t.fromStorageString=function(e){return a.default.info("User.fromStorageString"),new t(JSON.parse(e))},s(t,[{key:"expires_in",get:function(){if(this.expires_at){var t=parseInt(Date.now()/1e3);return this.expires_at-t}}},{key:"expired",get:function(){var t=this.expires_in;if(void 0!==t)return t<=0}},{key:"scopes",get:function(){return(this.scope||"").split(" ")}}]),t}();e.default=u,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function s(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=n(1),u=r(a),h=n(36),c=r(h),f=n(38),l=r(f),d=function(t){function e(n){i(this,e);var r=s(this,t.call(this,n));return r._userLoaded=new l.default("User loaded"),r._userUnloaded=new l.default("User unloaded"),r._silentRenewError=new l.default("Silent renew error"),r._userSignedOut=new l.default("User signed out"),r._userSessionChanged=new l.default("User session changed"),r}return o(e,t),e.prototype.load=function(e){var n=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];u.default.info("UserManagerEvents.load"),t.prototype.load.call(this,e),n&&this._userLoaded.raise(e)},e.prototype.unload=function(){u.default.info("UserManagerEvents.unload"),t.prototype.unload.call(this),this._userUnloaded.raise()},e.prototype.addUserLoaded=function(t){this._userLoaded.addHandler(t)},e.prototype.removeUserLoaded=function(t){this._userLoaded.removeHandler(t)},e.prototype.addUserUnloaded=function(t){this._userUnloaded.addHandler(t)},e.prototype.removeUserUnloaded=function(t){this._userUnloaded.removeHandler(t)},e.prototype.addSilentRenewError=function(t){this._silentRenewError.addHandler(t)},e.prototype.removeSilentRenewError=function(t){this._silentRenewError.removeHandler(t)},e.prototype._raiseSilentRenewError=function(t){u.default.info("UserManagerEvents._raiseSilentRenewError",t.message),this._silentRenewError.raise(t)},e.prototype.addUserSignedOut=function(t){this._userSignedOut.addHandler(t)},e.prototype.removeUserSignedOut=function(t){this._userSignedOut.removeHandler(t)},e.prototype._raiseUserSignedOut=function(t){u.default.info("UserManagerEvents._raiseUserSignedOut"),this._userSignedOut.raise(t)},e.prototype.addUserSessionChanged=function(t){this._userSessionChanged.addHandler(t)},e.prototype.removeUserSessionChanged=function(t){this._userSessionChanged.removeHandler(t)},e.prototype._raiseUserSessionChanged=function(t){u.default.info("UserManagerEvents._raiseUserSessionChanged"),this._userSessionChanged.raise(t)},e}(c.default);e.default=d,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(1),o=r(s),a=n(37),u=r(a),h=60,c=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=e.accessTokenExpiringNotificationTime,r=void 0===n?h:n,s=e.accessTokenExpiringTimer,o=void 0===s?new u.default("Access token expiring"):s,a=e.accessTokenExpiredTimer,c=void 0===a?new u.default("Access token expired"):a;i(this,t),this._accessTokenExpiringNotificationTime=r,this._accessTokenExpiring=o,this._accessTokenExpired=c}return t.prototype.load=function(t){if(o.default.info("AccessTokenEvents.load"),this._cancelTimers(),t.access_token){var e=t.expires_in;if(o.default.info("access token present, remaining duration:",e),e>0){var n=e-this._accessTokenExpiringNotificationTime;n<=0&&(n=1),o.default.info("registering expiring timer in:",n),this._accessTokenExpiring.init(n)}var r=e+1;o.default.info("registering expired timer in:",r),this._accessTokenExpired.init(r)}},t.prototype.unload=function(){o.default.info("AccessTokenEvents.unload"),this._cancelTimers()},t.prototype._cancelTimers=function(){o.default.info("canceling existing access token timers"),this._accessTokenExpiring.cancel(),this._accessTokenExpired.cancel()},t.prototype.addAccessTokenExpiring=function(t){this._accessTokenExpiring.addHandler(t)},t.prototype.removeAccessTokenExpiring=function(t){this._accessTokenExpiring.removeHandler(t)},t.prototype.addAccessTokenExpired=function(t){this._accessTokenExpired.addHandler(t)},t.prototype.removeAccessTokenExpired=function(t){this._accessTokenExpired.removeHandler(t)},t}();e.default=c,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function s(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=n(1),h=r(u),c=n(5),f=r(c),l=n(38),d=r(l),p=5,g=function(t){function e(n){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:f.default.timer;i(this,e);var o=s(this,t.call(this,n));return o._timer=r,o._nowFunc=function(){return Date.now()/1e3},o}return o(e,t),e.prototype.init=function(t){this.cancel(),t<=0&&(t=1),t=parseInt(t),h.default.info("Timer.init timer "+this._name+" for duration:",t),this._expiration=this.now+t;var e=p;t<e&&(e=t),this._timerHandle=this._timer.setInterval(this._callback.bind(this),1e3*e)},e.prototype.cancel=function(){this._timerHandle&&(h.default.info("Timer.cancel: ",this._name),this._timer.clearInterval(this._timerHandle),this._timerHandle=null)},e.prototype._callback=function(){var e=this._expiration-this.now;h.default.info("Timer._callback; "+this._name+" timer expires in:",e),this._expiration<=this.now&&(this.cancel(),t.prototype.raise.call(this))},a(e,[{key:"now",get:function(){return parseInt(this._nowFunc());
	}}]),e}(d.default);e.default=g,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(1),o=r(s),a=function(){function t(e){i(this,t),this._name=e,this._callbacks=[]}return t.prototype.addHandler=function(t){this._callbacks.push(t)},t.prototype.removeHandler=function(t){var e=this._callbacks.findIndex(function(e){return e===t});e>=0&&this._callbacks.splice(e,1)},t.prototype.raise=function(){o.default.info("Raising event: "+this._name);var t=!0,e=!1,n=void 0;try{for(var r,i=this._callbacks[Symbol.iterator]();!(t=(r=i.next()).done);t=!0){var s=r.value;s.apply(void 0,arguments)}}catch(t){e=!0,n=t}finally{try{!t&&i.return&&i.return()}finally{if(e)throw n}}},t}();e.default=a,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(1),o=r(s),a=function(){function t(e){i(this,t),this._userManager=e,this._userManager.events.addAccessTokenExpiring(this._tokenExpiring.bind(this)),this._userManager.getUser().then(function(t){}).catch(function(t){o.default.error("Error from getUser:",t.message)})}return t.prototype._tokenExpiring=function(){var t=this;o.default.info("SilentRenewService automatically renewing access token"),this._userManager.signinSilent().then(function(t){o.default.info("Silent token renewal successful")},function(e){o.default.error("Error from signinSilent:",e.message),t._userManager.events._raiseSilentRenewError(e)})},t}();e.default=a,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=n(1),a=r(o),u=n(41),h=r(u),c=function(){function t(e){var n=this,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:h.default;if(i(this,t),!e)throw a.default.error("No user manager passed to SessionMonitor"),new Error("userManager");this._userManager=e,this._CheckSessionIFrameCtor=r,this._userManager.events.addUserLoaded(this._start.bind(this)),this._userManager.events.addUserUnloaded(this._stop.bind(this)),this._userManager.getUser().then(function(t){t&&n._start(t)}).catch(function(t){a.default.error("SessionMonitor ctor; error from getUser:",t.message)})}return t.prototype._start=function(t){var e=this,n=t.session_state;n&&(this._sub=t.profile.sub,this._sid=t.profile.sid,a.default.info("SessionMonitor._start; session_state:",n,", sub:",this._sub),this._checkSessionIFrame?this._checkSessionIFrame.start(n):this._metadataService.getCheckSessionIframe().then(function(t){if(t){a.default.info("Initializing check session iframe");var r=e._client_id,i=e._checkSessionInterval;e._checkSessionIFrame=new e._CheckSessionIFrameCtor(e._callback.bind(e),r,t,i),e._checkSessionIFrame.start(n)}else a.default.warn("No check session iframe found in the metadata")}).catch(function(t){a.default.error("Error from getCheckSessionIframe:",t.message)}))},t.prototype._stop=function(){a.default.info("SessionMonitor._stop"),this._sub=null,this._sid=null,this._checkSessionIFrame&&this._checkSessionIFrame.stop()},t.prototype._callback=function(){var t=this;a.default.info("SessionMonitor._callback"),this._userManager.querySessionStatus().then(function(e){var n=!0;e?e.sub===t._sub?(n=!1,t._checkSessionIFrame.start(e.session_state),e.sid===t._sid?a.default.info("Same sub still logged in at OP, restarting check session iframe; session_state:",e.session_state):(a.default.info("Same sub still logged in at OP, session state has changed, restarting check session iframe; session_state:",e.session_state),t._userManager.events._raiseUserSessionChanged())):a.default.info("Different subject signed into OP:",e.sub):a.default.info("Subject no longer signed into OP"),n&&(a.default.info("SessionMonitor._callback; raising signed out event"),t._userManager.events._raiseUserSignedOut())}).catch(function(e){a.default.info("Error calling queryCurrentSigninSession; raising signed out event",e.message),t._userManager.events._raiseUserSignedOut()})},s(t,[{key:"_settings",get:function(){return this._userManager.settings}},{key:"_metadataService",get:function(){return this._userManager.metadataService}},{key:"_client_id",get:function(){return this._settings.client_id}},{key:"_checkSessionInterval",get:function(){return this._settings.checkSessionInterval}}]),t}();e.default=c,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(1),o=r(s),a=2e3,u=function(){function t(e,n,r,s){i(this,t),this._callback=e,this._client_id=n,this._url=r,this._interval=s||a;var o=r.indexOf("/",r.indexOf("//")+2);this._frame_origin=r.substr(0,o),this._frame=window.document.createElement("iframe"),this._frame.style.display="none",this._frame.src=r,window.document.body.appendChild(this._frame),this._boundMessageEvent=this._message.bind(this),window.addEventListener("message",this._boundMessageEvent,!1)}return t.prototype._message=function(t){t.origin===this._frame_origin&&t.source===this._frame.contentWindow&&("error"===t.data?(o.default.error("error message from check session op iframe"),this.stop()):"changed"===t.data?(o.default.info("changed message from check session op iframe"),this.stop(),this._callback()):o.default.info(t.data+" message from check session op iframe"))},t.prototype.start=function(t){var e=this;this._session_state!==t&&(o.default.info("CheckSessionIFrame.start"),this.stop(),this._session_state=t,this._timer=window.setInterval(function(){e._frame.contentWindow.postMessage(e._client_id+" "+e._session_state,e._frame_origin)},this._interval))},t.prototype.stop=function(){o.default.info("CheckSessionIFrame.stop"),this._session_state=null,this._timer&&(window.clearInterval(this._timer),this._timer=null)},t}();e.default=u,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(1),o=r(s),a=n(7),u=r(a),h=n(5),c=r(h),f="access_token",l=function(){function t(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:c.default.XMLHttpRequest,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:u.default;if(i(this,t),!e)throw o.default.error("No settings provided"),new Error("No settings provided.");this._settings=e,this._XMLHttpRequestCtor=n,this._metadataService=new r(this._settings)}return t.prototype.revoke=function(t,e){var n=this;if(o.default.info("TokenRevocationClient.revoke"),!t)throw o.default.error("No accessToken provided"),new Error("No accessToken provided.");return this._metadataService.getRevocationEndpoint().then(function(r){if(r){var i=n._settings.client_id,s=n._settings.client_secret;return n._revoke(r,i,s,t)}if(e)throw o.default.error("Revocation not supported"),new Error("Revocation not supported")})},t.prototype._revoke=function(t,e,n,r){var i=this;return o.default.info("Calling revocation endpoint"),new Promise(function(s,a){var u=new i._XMLHttpRequestCtor;u.open("POST",t),u.onload=function(){o.default.info("HTTP response received, status",u.status),200===u.status?s():a(Error(u.statusText+" ("+u.status+")"))};var h="client_id="+encodeURIComponent(e);n&&(h+="&client_secret="+encodeURIComponent(n)),h+="&token_type_hint="+encodeURIComponent(f),h+="&token="+encodeURIComponent(r),u.setRequestHeader("Content-Type","application/x-www-form-urlencoded"),u.send(h)})},t}();e.default=l,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(1),o=(r(s),n(44)),a=r(o),u=function(){function t(){i(this,t)}return t.prototype.prepare=function(t){var e=new a.default(t);return Promise.resolve(e)},t}();e.default=u,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=n(1),a=r(o),u="location=no,toolbar=no,zoom=no",h="_blank",c=function(){function t(e){var n=this;i(this,t),a.default.info("CordovaPopupWindow.ctor"),this._promise=new Promise(function(t,e){n._resolve=t,n._reject=e}),this.features=e.popupWindowFeatures||u,this.target=e.popupWindowTarget||h,this.redirect_uri=e.startUrl,a.default.info("redirect_uri: "+this.redirect_uri)}return t.prototype._isInAppBrowserInstalled=function(t){return["cordova-plugin-inappbrowser","cordova-plugin-inappbrowser.inappbrowser","org.apache.cordova.inappbrowser"].some(function(e){return t.hasOwnProperty(e)})},t.prototype.navigate=function(t){if(a.default.info("CordovaPopupWindow.navigate"),t&&t.url){if(!window.cordova)return this._error("cordova is undefined");var e=window.cordova.require("cordova/plugin_list").metadata;if(this._isInAppBrowserInstalled(e)===!1)return this._error("InAppBrowser plugin not found");this._popup=cordova.InAppBrowser.open(t.url,this.target,this.features),this._popup?(a.default.info("popup successfully created"),this._exitCallbackEvent=this._exitCallback.bind(this),this._loadStartCallbackEvent=this._loadStartCallback.bind(this),this._popup.addEventListener("exit",this._exitCallbackEvent,!1),this._popup.addEventListener("loadstart",this._loadStartCallbackEvent,!1)):this._error("Error opening popup window")}else this._error("No url provided");return this.promise},t.prototype._loadStartCallback=function(t){0===t.url.indexOf(this.redirect_uri)&&this._success({url:t.url})},t.prototype._exitCallback=function(t){this._error(t)},t.prototype._success=function(t){this._cleanup(),a.default.info("Successful response from cordova popup window"),this._resolve(t)},t.prototype._error=function(t){this._cleanup(),a.default.error(t),this._reject(new Error(t))},t.prototype._cleanup=function(){a.default.info("CordovaPopupWindow._cleanup"),this._popup&&(this._popup.removeEventListener("exit",this._exitCallbackEvent,!1),this._popup.removeEventListener("loadstart",this._loadStartCallbackEvent,!1),this._popup.close()),this._popup=null},s(t,[{key:"promise",get:function(){return this._promise}}]),t}();e.default=c,t.exports=e.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var s=n(1),o=(r(s),n(44)),a=r(o),u=function(){function t(){i(this,t)}return t.prototype.prepare=function(t){t.popupWindowFeatures="hidden=yes";var e=new a.default(t);return Promise.resolve(e)},t}();e.default=u,t.exports=e.default}])});

/***/ },
/* 445 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" ||
	              (method === "throw" && delegate.iterator[method] === undefined)) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = arg;
	
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(445)))

/***/ },
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */
/***/ function(module, exports) {

	/*!
	 * vue-resource v1.0.3
	 * https://github.com/vuejs/vue-resource
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	/**
	 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
	 */
	
	var RESOLVED = 0;
	var REJECTED = 1;
	var PENDING = 2;
	
	function Promise$1(executor) {
	
	    this.state = PENDING;
	    this.value = undefined;
	    this.deferred = [];
	
	    var promise = this;
	
	    try {
	        executor(function (x) {
	            promise.resolve(x);
	        }, function (r) {
	            promise.reject(r);
	        });
	    } catch (e) {
	        promise.reject(e);
	    }
	}
	
	Promise$1.reject = function (r) {
	    return new Promise$1(function (resolve, reject) {
	        reject(r);
	    });
	};
	
	Promise$1.resolve = function (x) {
	    return new Promise$1(function (resolve, reject) {
	        resolve(x);
	    });
	};
	
	Promise$1.all = function all(iterable) {
	    return new Promise$1(function (resolve, reject) {
	        var count = 0,
	            result = [];
	
	        if (iterable.length === 0) {
	            resolve(result);
	        }
	
	        function resolver(i) {
	            return function (x) {
	                result[i] = x;
	                count += 1;
	
	                if (count === iterable.length) {
	                    resolve(result);
	                }
	            };
	        }
	
	        for (var i = 0; i < iterable.length; i += 1) {
	            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
	        }
	    });
	};
	
	Promise$1.race = function race(iterable) {
	    return new Promise$1(function (resolve, reject) {
	        for (var i = 0; i < iterable.length; i += 1) {
	            Promise$1.resolve(iterable[i]).then(resolve, reject);
	        }
	    });
	};
	
	var p$1 = Promise$1.prototype;
	
	p$1.resolve = function resolve(x) {
	    var promise = this;
	
	    if (promise.state === PENDING) {
	        if (x === promise) {
	            throw new TypeError('Promise settled with itself.');
	        }
	
	        var called = false;
	
	        try {
	            var then = x && x['then'];
	
	            if (x !== null && typeof x === 'object' && typeof then === 'function') {
	                then.call(x, function (x) {
	                    if (!called) {
	                        promise.resolve(x);
	                    }
	                    called = true;
	                }, function (r) {
	                    if (!called) {
	                        promise.reject(r);
	                    }
	                    called = true;
	                });
	                return;
	            }
	        } catch (e) {
	            if (!called) {
	                promise.reject(e);
	            }
	            return;
	        }
	
	        promise.state = RESOLVED;
	        promise.value = x;
	        promise.notify();
	    }
	};
	
	p$1.reject = function reject(reason) {
	    var promise = this;
	
	    if (promise.state === PENDING) {
	        if (reason === promise) {
	            throw new TypeError('Promise settled with itself.');
	        }
	
	        promise.state = REJECTED;
	        promise.value = reason;
	        promise.notify();
	    }
	};
	
	p$1.notify = function notify() {
	    var promise = this;
	
	    nextTick(function () {
	        if (promise.state !== PENDING) {
	            while (promise.deferred.length) {
	                var deferred = promise.deferred.shift(),
	                    onResolved = deferred[0],
	                    onRejected = deferred[1],
	                    resolve = deferred[2],
	                    reject = deferred[3];
	
	                try {
	                    if (promise.state === RESOLVED) {
	                        if (typeof onResolved === 'function') {
	                            resolve(onResolved.call(undefined, promise.value));
	                        } else {
	                            resolve(promise.value);
	                        }
	                    } else if (promise.state === REJECTED) {
	                        if (typeof onRejected === 'function') {
	                            resolve(onRejected.call(undefined, promise.value));
	                        } else {
	                            reject(promise.value);
	                        }
	                    }
	                } catch (e) {
	                    reject(e);
	                }
	            }
	        }
	    });
	};
	
	p$1.then = function then(onResolved, onRejected) {
	    var promise = this;
	
	    return new Promise$1(function (resolve, reject) {
	        promise.deferred.push([onResolved, onRejected, resolve, reject]);
	        promise.notify();
	    });
	};
	
	p$1.catch = function (onRejected) {
	    return this.then(undefined, onRejected);
	};
	
	/**
	 * Promise adapter.
	 */
	
	if (typeof Promise === 'undefined') {
	    window.Promise = Promise$1;
	}
	
	function PromiseObj(executor, context) {
	
	    if (executor instanceof Promise) {
	        this.promise = executor;
	    } else {
	        this.promise = new Promise(executor.bind(context));
	    }
	
	    this.context = context;
	}
	
	PromiseObj.all = function (iterable, context) {
	    return new PromiseObj(Promise.all(iterable), context);
	};
	
	PromiseObj.resolve = function (value, context) {
	    return new PromiseObj(Promise.resolve(value), context);
	};
	
	PromiseObj.reject = function (reason, context) {
	    return new PromiseObj(Promise.reject(reason), context);
	};
	
	PromiseObj.race = function (iterable, context) {
	    return new PromiseObj(Promise.race(iterable), context);
	};
	
	var p = PromiseObj.prototype;
	
	p.bind = function (context) {
	    this.context = context;
	    return this;
	};
	
	p.then = function (fulfilled, rejected) {
	
	    if (fulfilled && fulfilled.bind && this.context) {
	        fulfilled = fulfilled.bind(this.context);
	    }
	
	    if (rejected && rejected.bind && this.context) {
	        rejected = rejected.bind(this.context);
	    }
	
	    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
	};
	
	p.catch = function (rejected) {
	
	    if (rejected && rejected.bind && this.context) {
	        rejected = rejected.bind(this.context);
	    }
	
	    return new PromiseObj(this.promise.catch(rejected), this.context);
	};
	
	p.finally = function (callback) {
	
	    return this.then(function (value) {
	        callback.call(this);
	        return value;
	    }, function (reason) {
	        callback.call(this);
	        return Promise.reject(reason);
	    });
	};
	
	/**
	 * Utility functions.
	 */
	
	var debug = false;var util = {};var slice = [].slice;
	
	
	function Util (Vue) {
	    util = Vue.util;
	    debug = Vue.config.debug || !Vue.config.silent;
	}
	
	function warn(msg) {
	    if (typeof console !== 'undefined' && debug) {
	        console.warn('[VueResource warn]: ' + msg);
	    }
	}
	
	function error(msg) {
	    if (typeof console !== 'undefined') {
	        console.error(msg);
	    }
	}
	
	function nextTick(cb, ctx) {
	    return util.nextTick(cb, ctx);
	}
	
	function trim(str) {
	    return str.replace(/^\s*|\s*$/g, '');
	}
	
	function toLower(str) {
	    return str ? str.toLowerCase() : '';
	}
	
	function toUpper(str) {
	    return str ? str.toUpperCase() : '';
	}
	
	var isArray = Array.isArray;
	
	function isString(val) {
	    return typeof val === 'string';
	}
	
	function isBoolean(val) {
	    return val === true || val === false;
	}
	
	function isFunction(val) {
	    return typeof val === 'function';
	}
	
	function isObject(obj) {
	    return obj !== null && typeof obj === 'object';
	}
	
	function isPlainObject(obj) {
	    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
	}
	
	function isBlob(obj) {
	    return typeof Blob !== 'undefined' && obj instanceof Blob;
	}
	
	function isFormData(obj) {
	    return typeof FormData !== 'undefined' && obj instanceof FormData;
	}
	
	function when(value, fulfilled, rejected) {
	
	    var promise = PromiseObj.resolve(value);
	
	    if (arguments.length < 2) {
	        return promise;
	    }
	
	    return promise.then(fulfilled, rejected);
	}
	
	function options(fn, obj, opts) {
	
	    opts = opts || {};
	
	    if (isFunction(opts)) {
	        opts = opts.call(obj);
	    }
	
	    return merge(fn.bind({ $vm: obj, $options: opts }), fn, { $options: opts });
	}
	
	function each(obj, iterator) {
	
	    var i, key;
	
	    if (obj && typeof obj.length == 'number') {
	        for (i = 0; i < obj.length; i++) {
	            iterator.call(obj[i], obj[i], i);
	        }
	    } else if (isObject(obj)) {
	        for (key in obj) {
	            if (obj.hasOwnProperty(key)) {
	                iterator.call(obj[key], obj[key], key);
	            }
	        }
	    }
	
	    return obj;
	}
	
	var assign = Object.assign || _assign;
	
	function merge(target) {
	
	    var args = slice.call(arguments, 1);
	
	    args.forEach(function (source) {
	        _merge(target, source, true);
	    });
	
	    return target;
	}
	
	function defaults(target) {
	
	    var args = slice.call(arguments, 1);
	
	    args.forEach(function (source) {
	
	        for (var key in source) {
	            if (target[key] === undefined) {
	                target[key] = source[key];
	            }
	        }
	    });
	
	    return target;
	}
	
	function _assign(target) {
	
	    var args = slice.call(arguments, 1);
	
	    args.forEach(function (source) {
	        _merge(target, source);
	    });
	
	    return target;
	}
	
	function _merge(target, source, deep) {
	    for (var key in source) {
	        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
	            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
	                target[key] = {};
	            }
	            if (isArray(source[key]) && !isArray(target[key])) {
	                target[key] = [];
	            }
	            _merge(target[key], source[key], deep);
	        } else if (source[key] !== undefined) {
	            target[key] = source[key];
	        }
	    }
	}
	
	/**
	 * Root Prefix Transform.
	 */
	
	function root (options, next) {
	
	    var url = next(options);
	
	    if (isString(options.root) && !url.match(/^(https?:)?\//)) {
	        url = options.root + '/' + url;
	    }
	
	    return url;
	}
	
	/**
	 * Query Parameter Transform.
	 */
	
	function query (options, next) {
	
	    var urlParams = Object.keys(Url.options.params),
	        query = {},
	        url = next(options);
	
	    each(options.params, function (value, key) {
	        if (urlParams.indexOf(key) === -1) {
	            query[key] = value;
	        }
	    });
	
	    query = Url.params(query);
	
	    if (query) {
	        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
	    }
	
	    return url;
	}
	
	/**
	 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
	 */
	
	function expand(url, params, variables) {
	
	    var tmpl = parse(url),
	        expanded = tmpl.expand(params);
	
	    if (variables) {
	        variables.push.apply(variables, tmpl.vars);
	    }
	
	    return expanded;
	}
	
	function parse(template) {
	
	    var operators = ['+', '#', '.', '/', ';', '?', '&'],
	        variables = [];
	
	    return {
	        vars: variables,
	        expand: function (context) {
	            return template.replace(/\{([^\{\}]+)\}|([^\{\}]+)/g, function (_, expression, literal) {
	                if (expression) {
	
	                    var operator = null,
	                        values = [];
	
	                    if (operators.indexOf(expression.charAt(0)) !== -1) {
	                        operator = expression.charAt(0);
	                        expression = expression.substr(1);
	                    }
	
	                    expression.split(/,/g).forEach(function (variable) {
	                        var tmp = /([^:\*]*)(?::(\d+)|(\*))?/.exec(variable);
	                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
	                        variables.push(tmp[1]);
	                    });
	
	                    if (operator && operator !== '+') {
	
	                        var separator = ',';
	
	                        if (operator === '?') {
	                            separator = '&';
	                        } else if (operator !== '#') {
	                            separator = operator;
	                        }
	
	                        return (values.length !== 0 ? operator : '') + values.join(separator);
	                    } else {
	                        return values.join(',');
	                    }
	                } else {
	                    return encodeReserved(literal);
	                }
	            });
	        }
	    };
	}
	
	function getValues(context, operator, key, modifier) {
	
	    var value = context[key],
	        result = [];
	
	    if (isDefined(value) && value !== '') {
	        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
	            value = value.toString();
	
	            if (modifier && modifier !== '*') {
	                value = value.substring(0, parseInt(modifier, 10));
	            }
	
	            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
	        } else {
	            if (modifier === '*') {
	                if (Array.isArray(value)) {
	                    value.filter(isDefined).forEach(function (value) {
	                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
	                    });
	                } else {
	                    Object.keys(value).forEach(function (k) {
	                        if (isDefined(value[k])) {
	                            result.push(encodeValue(operator, value[k], k));
	                        }
	                    });
	                }
	            } else {
	                var tmp = [];
	
	                if (Array.isArray(value)) {
	                    value.filter(isDefined).forEach(function (value) {
	                        tmp.push(encodeValue(operator, value));
	                    });
	                } else {
	                    Object.keys(value).forEach(function (k) {
	                        if (isDefined(value[k])) {
	                            tmp.push(encodeURIComponent(k));
	                            tmp.push(encodeValue(operator, value[k].toString()));
	                        }
	                    });
	                }
	
	                if (isKeyOperator(operator)) {
	                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
	                } else if (tmp.length !== 0) {
	                    result.push(tmp.join(','));
	                }
	            }
	        }
	    } else {
	        if (operator === ';') {
	            result.push(encodeURIComponent(key));
	        } else if (value === '' && (operator === '&' || operator === '?')) {
	            result.push(encodeURIComponent(key) + '=');
	        } else if (value === '') {
	            result.push('');
	        }
	    }
	
	    return result;
	}
	
	function isDefined(value) {
	    return value !== undefined && value !== null;
	}
	
	function isKeyOperator(operator) {
	    return operator === ';' || operator === '&' || operator === '?';
	}
	
	function encodeValue(operator, value, key) {
	
	    value = operator === '+' || operator === '#' ? encodeReserved(value) : encodeURIComponent(value);
	
	    if (key) {
	        return encodeURIComponent(key) + '=' + value;
	    } else {
	        return value;
	    }
	}
	
	function encodeReserved(str) {
	    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
	        if (!/%[0-9A-Fa-f]/.test(part)) {
	            part = encodeURI(part);
	        }
	        return part;
	    }).join('');
	}
	
	/**
	 * URL Template (RFC 6570) Transform.
	 */
	
	function template (options) {
	
	    var variables = [],
	        url = expand(options.url, options.params, variables);
	
	    variables.forEach(function (key) {
	        delete options.params[key];
	    });
	
	    return url;
	}
	
	/**
	 * Service for URL templating.
	 */
	
	var ie = document.documentMode;
	var el = document.createElement('a');
	
	function Url(url, params) {
	
	    var self = this || {},
	        options = url,
	        transform;
	
	    if (isString(url)) {
	        options = { url: url, params: params };
	    }
	
	    options = merge({}, Url.options, self.$options, options);
	
	    Url.transforms.forEach(function (handler) {
	        transform = factory(handler, transform, self.$vm);
	    });
	
	    return transform(options);
	}
	
	/**
	 * Url options.
	 */
	
	Url.options = {
	    url: '',
	    root: null,
	    params: {}
	};
	
	/**
	 * Url transforms.
	 */
	
	Url.transforms = [template, query, root];
	
	/**
	 * Encodes a Url parameter string.
	 *
	 * @param {Object} obj
	 */
	
	Url.params = function (obj) {
	
	    var params = [],
	        escape = encodeURIComponent;
	
	    params.add = function (key, value) {
	
	        if (isFunction(value)) {
	            value = value();
	        }
	
	        if (value === null) {
	            value = '';
	        }
	
	        this.push(escape(key) + '=' + escape(value));
	    };
	
	    serialize(params, obj);
	
	    return params.join('&').replace(/%20/g, '+');
	};
	
	/**
	 * Parse a URL and return its components.
	 *
	 * @param {String} url
	 */
	
	Url.parse = function (url) {
	
	    if (ie) {
	        el.href = url;
	        url = el.href;
	    }
	
	    el.href = url;
	
	    return {
	        href: el.href,
	        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
	        port: el.port,
	        host: el.host,
	        hostname: el.hostname,
	        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
	        search: el.search ? el.search.replace(/^\?/, '') : '',
	        hash: el.hash ? el.hash.replace(/^#/, '') : ''
	    };
	};
	
	function factory(handler, next, vm) {
	    return function (options) {
	        return handler.call(vm, options, next);
	    };
	}
	
	function serialize(params, obj, scope) {
	
	    var array = isArray(obj),
	        plain = isPlainObject(obj),
	        hash;
	
	    each(obj, function (value, key) {
	
	        hash = isObject(value) || isArray(value);
	
	        if (scope) {
	            key = scope + '[' + (plain || hash ? key : '') + ']';
	        }
	
	        if (!scope && array) {
	            params.add(value.name, value.value);
	        } else if (hash) {
	            serialize(params, value, key);
	        } else {
	            params.add(key, value);
	        }
	    });
	}
	
	/**
	 * XDomain client (Internet Explorer).
	 */
	
	function xdrClient (request) {
	    return new PromiseObj(function (resolve) {
	
	        var xdr = new XDomainRequest(),
	            handler = function (_ref) {
	            var type = _ref.type;
	
	
	            var status = 0;
	
	            if (type === 'load') {
	                status = 200;
	            } else if (type === 'error') {
	                status = 500;
	            }
	
	            resolve(request.respondWith(xdr.responseText, { status: status }));
	        };
	
	        request.abort = function () {
	            return xdr.abort();
	        };
	
	        xdr.open(request.method, request.getUrl());
	        xdr.timeout = 0;
	        xdr.onload = handler;
	        xdr.onerror = handler;
	        xdr.ontimeout = handler;
	        xdr.onprogress = function () {};
	        xdr.send(request.getBody());
	    });
	}
	
	/**
	 * CORS Interceptor.
	 */
	
	var ORIGIN_URL = Url.parse(location.href);
	var SUPPORTS_CORS = 'withCredentials' in new XMLHttpRequest();
	
	function cors (request, next) {
	
	    if (!isBoolean(request.crossOrigin) && crossOrigin(request)) {
	        request.crossOrigin = true;
	    }
	
	    if (request.crossOrigin) {
	
	        if (!SUPPORTS_CORS) {
	            request.client = xdrClient;
	        }
	
	        delete request.emulateHTTP;
	    }
	
	    next();
	}
	
	function crossOrigin(request) {
	
	    var requestUrl = Url.parse(Url(request));
	
	    return requestUrl.protocol !== ORIGIN_URL.protocol || requestUrl.host !== ORIGIN_URL.host;
	}
	
	/**
	 * Body Interceptor.
	 */
	
	function body (request, next) {
	
	    if (isFormData(request.body)) {
	
	        request.headers.delete('Content-Type');
	    } else if (isObject(request.body) || isArray(request.body)) {
	
	        if (request.emulateJSON) {
	            request.body = Url.params(request.body);
	            request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
	        } else {
	            request.body = JSON.stringify(request.body);
	        }
	    }
	
	    next(function (response) {
	
	        Object.defineProperty(response, 'data', {
	            get: function () {
	                return this.body;
	            },
	            set: function (body) {
	                this.body = body;
	            }
	        });
	
	        return response.bodyText ? when(response.text(), function (text) {
	
	            var type = response.headers.get('Content-Type');
	
	            if (isString(type) && type.indexOf('application/json') === 0) {
	
	                try {
	                    response.body = JSON.parse(text);
	                } catch (e) {
	                    response.body = null;
	                }
	            } else {
	                response.body = text;
	            }
	
	            return response;
	        }) : response;
	    });
	}
	
	/**
	 * JSONP client.
	 */
	
	function jsonpClient (request) {
	    return new PromiseObj(function (resolve) {
	
	        var name = request.jsonp || 'callback',
	            callback = '_jsonp' + Math.random().toString(36).substr(2),
	            body = null,
	            handler,
	            script;
	
	        handler = function (_ref) {
	            var type = _ref.type;
	
	
	            var status = 0;
	
	            if (type === 'load' && body !== null) {
	                status = 200;
	            } else if (type === 'error') {
	                status = 500;
	            }
	
	            resolve(request.respondWith(body, { status: status }));
	
	            delete window[callback];
	            document.body.removeChild(script);
	        };
	
	        request.params[name] = callback;
	
	        window[callback] = function (result) {
	            body = JSON.stringify(result);
	        };
	
	        script = document.createElement('script');
	        script.src = request.getUrl();
	        script.type = 'text/javascript';
	        script.async = true;
	        script.onload = handler;
	        script.onerror = handler;
	
	        document.body.appendChild(script);
	    });
	}
	
	/**
	 * JSONP Interceptor.
	 */
	
	function jsonp (request, next) {
	
	    if (request.method == 'JSONP') {
	        request.client = jsonpClient;
	    }
	
	    next(function (response) {
	
	        if (request.method == 'JSONP') {
	
	            return when(response.json(), function (json) {
	
	                response.body = json;
	
	                return response;
	            });
	        }
	    });
	}
	
	/**
	 * Before Interceptor.
	 */
	
	function before (request, next) {
	
	    if (isFunction(request.before)) {
	        request.before.call(this, request);
	    }
	
	    next();
	}
	
	/**
	 * HTTP method override Interceptor.
	 */
	
	function method (request, next) {
	
	    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
	        request.headers.set('X-HTTP-Method-Override', request.method);
	        request.method = 'POST';
	    }
	
	    next();
	}
	
	/**
	 * Header Interceptor.
	 */
	
	function header (request, next) {
	
	    var headers = assign({}, Http.headers.common, !request.crossOrigin ? Http.headers.custom : {}, Http.headers[toLower(request.method)]);
	
	    each(headers, function (value, name) {
	        if (!request.headers.has(name)) {
	            request.headers.set(name, value);
	        }
	    });
	
	    next();
	}
	
	/**
	 * Timeout Interceptor.
	 */
	
	function timeout (request, next) {
	
	    var timeout;
	
	    if (request.timeout) {
	        timeout = setTimeout(function () {
	            request.abort();
	        }, request.timeout);
	    }
	
	    next(function (response) {
	
	        clearTimeout(timeout);
	    });
	}
	
	/**
	 * XMLHttp client.
	 */
	
	function xhrClient (request) {
	    return new PromiseObj(function (resolve) {
	
	        var xhr = new XMLHttpRequest(),
	            handler = function (event) {
	
	            var response = request.respondWith('response' in xhr ? xhr.response : xhr.responseText, {
	                status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
	                statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
	            });
	
	            each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
	                response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
	            });
	
	            resolve(response);
	        };
	
	        request.abort = function () {
	            return xhr.abort();
	        };
	
	        if (request.progress) {
	            if (request.method === 'GET') {
	                xhr.addEventListener('progress', request.progress);
	            } else if (/^(POST|PUT)$/i.test(request.method)) {
	                xhr.upload.addEventListener('progress', request.progress);
	            }
	        }
	
	        xhr.open(request.method, request.getUrl(), true);
	
	        if ('responseType' in xhr) {
	            xhr.responseType = 'blob';
	        }
	
	        if (request.credentials === true) {
	            xhr.withCredentials = true;
	        }
	
	        request.headers.forEach(function (value, name) {
	            xhr.setRequestHeader(name, value);
	        });
	
	        xhr.timeout = 0;
	        xhr.onload = handler;
	        xhr.onerror = handler;
	        xhr.send(request.getBody());
	    });
	}
	
	/**
	 * Base client.
	 */
	
	function Client (context) {
	
	    var reqHandlers = [sendRequest],
	        resHandlers = [],
	        handler;
	
	    if (!isObject(context)) {
	        context = null;
	    }
	
	    function Client(request) {
	        return new PromiseObj(function (resolve) {
	
	            function exec() {
	
	                handler = reqHandlers.pop();
	
	                if (isFunction(handler)) {
	                    handler.call(context, request, next);
	                } else {
	                    warn('Invalid interceptor of type ' + typeof handler + ', must be a function');
	                    next();
	                }
	            }
	
	            function next(response) {
	
	                if (isFunction(response)) {
	
	                    resHandlers.unshift(response);
	                } else if (isObject(response)) {
	
	                    resHandlers.forEach(function (handler) {
	                        response = when(response, function (response) {
	                            return handler.call(context, response) || response;
	                        });
	                    });
	
	                    when(response, resolve);
	
	                    return;
	                }
	
	                exec();
	            }
	
	            exec();
	        }, context);
	    }
	
	    Client.use = function (handler) {
	        reqHandlers.push(handler);
	    };
	
	    return Client;
	}
	
	function sendRequest(request, resolve) {
	
	    var client = request.client || xhrClient;
	
	    resolve(client(request));
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	/**
	 * HTTP Headers.
	 */
	
	var Headers = function () {
	    function Headers(headers) {
	        var _this = this;
	
	        classCallCheck(this, Headers);
	
	
	        this.map = {};
	
	        each(headers, function (value, name) {
	            return _this.append(name, value);
	        });
	    }
	
	    Headers.prototype.has = function has(name) {
	        return getName(this.map, name) !== null;
	    };
	
	    Headers.prototype.get = function get(name) {
	
	        var list = this.map[getName(this.map, name)];
	
	        return list ? list[0] : null;
	    };
	
	    Headers.prototype.getAll = function getAll(name) {
	        return this.map[getName(this.map, name)] || [];
	    };
	
	    Headers.prototype.set = function set(name, value) {
	        this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
	    };
	
	    Headers.prototype.append = function append(name, value) {
	
	        var list = this.getAll(name);
	
	        if (list.length) {
	            list.push(trim(value));
	        } else {
	            this.set(name, value);
	        }
	    };
	
	    Headers.prototype.delete = function _delete(name) {
	        delete this.map[getName(this.map, name)];
	    };
	
	    Headers.prototype.forEach = function forEach(callback, thisArg) {
	        var _this2 = this;
	
	        each(this.map, function (list, name) {
	            each(list, function (value) {
	                return callback.call(thisArg, value, name, _this2);
	            });
	        });
	    };
	
	    return Headers;
	}();
	
	function getName(map, name) {
	    return Object.keys(map).reduce(function (prev, curr) {
	        return toLower(name) === toLower(curr) ? curr : prev;
	    }, null);
	}
	
	function normalizeName(name) {
	
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	        throw new TypeError('Invalid character in header field name');
	    }
	
	    return trim(name);
	}
	
	/**
	 * HTTP Response.
	 */
	
	var Response = function () {
	    function Response(body, _ref) {
	        var url = _ref.url;
	        var headers = _ref.headers;
	        var status = _ref.status;
	        var statusText = _ref.statusText;
	        classCallCheck(this, Response);
	
	
	        this.url = url;
	        this.ok = status >= 200 && status < 300;
	        this.status = status || 0;
	        this.statusText = statusText || '';
	        this.headers = new Headers(headers);
	        this.body = body;
	
	        if (isString(body)) {
	
	            this.bodyText = body;
	        } else if (isBlob(body)) {
	
	            this.bodyBlob = body;
	
	            if (isBlobText(body)) {
	                this.bodyText = blobText(body);
	            }
	        }
	    }
	
	    Response.prototype.blob = function blob() {
	        return when(this.bodyBlob);
	    };
	
	    Response.prototype.text = function text() {
	        return when(this.bodyText);
	    };
	
	    Response.prototype.json = function json() {
	        return when(this.text(), function (text) {
	            return JSON.parse(text);
	        });
	    };
	
	    return Response;
	}();
	
	function blobText(body) {
	    return new PromiseObj(function (resolve) {
	
	        var reader = new FileReader();
	
	        reader.readAsText(body);
	        reader.onload = function () {
	            resolve(reader.result);
	        };
	    });
	}
	
	function isBlobText(body) {
	    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
	}
	
	/**
	 * HTTP Request.
	 */
	
	var Request = function () {
	    function Request(options) {
	        classCallCheck(this, Request);
	
	
	        this.body = null;
	        this.params = {};
	
	        assign(this, options, {
	            method: toUpper(options.method || 'GET')
	        });
	
	        if (!(this.headers instanceof Headers)) {
	            this.headers = new Headers(this.headers);
	        }
	    }
	
	    Request.prototype.getUrl = function getUrl() {
	        return Url(this);
	    };
	
	    Request.prototype.getBody = function getBody() {
	        return this.body;
	    };
	
	    Request.prototype.respondWith = function respondWith(body, options) {
	        return new Response(body, assign(options || {}, { url: this.getUrl() }));
	    };
	
	    return Request;
	}();
	
	/**
	 * Service for sending network requests.
	 */
	
	var CUSTOM_HEADERS = { 'X-Requested-With': 'XMLHttpRequest' };
	var COMMON_HEADERS = { 'Accept': 'application/json, text/plain, */*' };
	var JSON_CONTENT_TYPE = { 'Content-Type': 'application/json;charset=utf-8' };
	
	function Http(options) {
	
	    var self = this || {},
	        client = Client(self.$vm);
	
	    defaults(options || {}, self.$options, Http.options);
	
	    Http.interceptors.forEach(function (handler) {
	        client.use(handler);
	    });
	
	    return client(new Request(options)).then(function (response) {
	
	        return response.ok ? response : PromiseObj.reject(response);
	    }, function (response) {
	
	        if (response instanceof Error) {
	            error(response);
	        }
	
	        return PromiseObj.reject(response);
	    });
	}
	
	Http.options = {};
	
	Http.headers = {
	    put: JSON_CONTENT_TYPE,
	    post: JSON_CONTENT_TYPE,
	    patch: JSON_CONTENT_TYPE,
	    delete: JSON_CONTENT_TYPE,
	    custom: CUSTOM_HEADERS,
	    common: COMMON_HEADERS
	};
	
	Http.interceptors = [before, timeout, method, body, jsonp, header, cors];
	
	['get', 'delete', 'head', 'jsonp'].forEach(function (method) {
	
	    Http[method] = function (url, options) {
	        return this(assign(options || {}, { url: url, method: method }));
	    };
	});
	
	['post', 'put', 'patch'].forEach(function (method) {
	
	    Http[method] = function (url, body, options) {
	        return this(assign(options || {}, { url: url, method: method, body: body }));
	    };
	});
	
	/**
	 * Service for interacting with RESTful services.
	 */
	
	function Resource(url, params, actions, options) {
	
	    var self = this || {},
	        resource = {};
	
	    actions = assign({}, Resource.actions, actions);
	
	    each(actions, function (action, name) {
	
	        action = merge({ url: url, params: assign({}, params) }, options, action);
	
	        resource[name] = function () {
	            return (self.$http || Http)(opts(action, arguments));
	        };
	    });
	
	    return resource;
	}
	
	function opts(action, args) {
	
	    var options = assign({}, action),
	        params = {},
	        body;
	
	    switch (args.length) {
	
	        case 2:
	
	            params = args[0];
	            body = args[1];
	
	            break;
	
	        case 1:
	
	            if (/^(POST|PUT|PATCH)$/i.test(options.method)) {
	                body = args[0];
	            } else {
	                params = args[0];
	            }
	
	            break;
	
	        case 0:
	
	            break;
	
	        default:
	
	            throw 'Expected up to 4 arguments [params, body], got ' + args.length + ' arguments';
	    }
	
	    options.body = body;
	    options.params = assign({}, options.params, params);
	
	    return options;
	}
	
	Resource.actions = {
	
	    get: { method: 'GET' },
	    save: { method: 'POST' },
	    query: { method: 'GET' },
	    update: { method: 'PUT' },
	    remove: { method: 'DELETE' },
	    delete: { method: 'DELETE' }
	
	};
	
	/**
	 * Install plugin.
	 */
	
	function plugin(Vue) {
	
	    if (plugin.installed) {
	        return;
	    }
	
	    Util(Vue);
	
	    Vue.url = Url;
	    Vue.http = Http;
	    Vue.resource = Resource;
	    Vue.Promise = PromiseObj;
	
	    Object.defineProperties(Vue.prototype, {
	
	        $url: {
	            get: function () {
	                return options(Vue.url, this, this.$options.url);
	            }
	        },
	
	        $http: {
	            get: function () {
	                return options(Vue.http, this, this.$options.http);
	            }
	        },
	
	        $resource: {
	            get: function () {
	                return Vue.resource.bind(this);
	            }
	        },
	
	        $promise: {
	            get: function () {
	                var _this = this;
	
	                return function (executor) {
	                    return new Vue.Promise(executor, _this);
	                };
	            }
	        }
	
	    });
	}
	
	if (typeof window !== 'undefined' && window.Vue) {
	    window.Vue.use(plugin);
	}
	
	module.exports = plugin;

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	/**
	  * vue-router v2.1.1
	  * (c) 2016 Evan You
	  * @license MIT
	  */
	'use strict';
	
	var View = {
	  name: 'router-view',
	  functional: true,
	  props: {
	    name: {
	      type: String,
	      default: 'default'
	    }
	  },
	  render: function render (h, ref) {
	    var props = ref.props;
	    var children = ref.children;
	    var parent = ref.parent;
	    var data = ref.data;
	
	    data.routerView = true
	
	    var route = parent.$route
	    var cache = parent._routerViewCache || (parent._routerViewCache = {})
	    var depth = 0
	    var inactive = false
	
	    while (parent) {
	      if (parent.$vnode && parent.$vnode.data.routerView) {
	        depth++
	      }
	      if (parent._inactive) {
	        inactive = true
	      }
	      parent = parent.$parent
	    }
	
	    data.routerViewDepth = depth
	    var matched = route.matched[depth]
	    if (!matched) {
	      return h()
	    }
	
	    var name = props.name
	    var component = inactive
	      ? cache[name]
	      : (cache[name] = matched.components[name])
	
	    if (!inactive) {
	      var hooks = data.hook || (data.hook = {})
	      hooks.init = function (vnode) {
	        matched.instances[name] = vnode.child
	      }
	      hooks.prepatch = function (oldVnode, vnode) {
	        matched.instances[name] = vnode.child
	      }
	      hooks.destroy = function (vnode) {
	        if (matched.instances[name] === vnode.child) {
	          matched.instances[name] = undefined
	        }
	      }
	    }
	
	    return h(component, data, children)
	  }
	}
	
	/*  */
	
	function assert (condition, message) {
	  if (!condition) {
	    throw new Error(("[vue-router] " + message))
	  }
	}
	
	function warn (condition, message) {
	  if (!condition) {
	    typeof console !== 'undefined' && console.warn(("[vue-router] " + message))
	  }
	}
	
	/*  */
	
	var encode = encodeURIComponent
	var decode = decodeURIComponent
	
	function resolveQuery (
	  query,
	  extraQuery
	) {
	  if ( extraQuery === void 0 ) extraQuery = {};
	
	  if (query) {
	    var parsedQuery
	    try {
	      parsedQuery = parseQuery(query)
	    } catch (e) {
	      ("production") !== 'production' && warn(false, e.message)
	      parsedQuery = {}
	    }
	    for (var key in extraQuery) {
	      parsedQuery[key] = extraQuery[key]
	    }
	    return parsedQuery
	  } else {
	    return extraQuery
	  }
	}
	
	function parseQuery (query) {
	  var res = {}
	
	  query = query.trim().replace(/^(\?|#|&)/, '')
	
	  if (!query) {
	    return res
	  }
	
	  query.split('&').forEach(function (param) {
	    var parts = param.replace(/\+/g, ' ').split('=')
	    var key = decode(parts.shift())
	    var val = parts.length > 0
	      ? decode(parts.join('='))
	      : null
	
	    if (res[key] === undefined) {
	      res[key] = val
	    } else if (Array.isArray(res[key])) {
	      res[key].push(val)
	    } else {
	      res[key] = [res[key], val]
	    }
	  })
	
	  return res
	}
	
	function stringifyQuery (obj) {
	  var res = obj ? Object.keys(obj).map(function (key) {
	    var val = obj[key]
	
	    if (val === undefined) {
	      return ''
	    }
	
	    if (val === null) {
	      return encode(key)
	    }
	
	    if (Array.isArray(val)) {
	      var result = []
	      val.slice().forEach(function (val2) {
	        if (val2 === undefined) {
	          return
	        }
	        if (val2 === null) {
	          result.push(encode(key))
	        } else {
	          result.push(encode(key) + '=' + encode(val2))
	        }
	      })
	      return result.join('&')
	    }
	
	    return encode(key) + '=' + encode(val)
	  }).filter(function (x) { return x.length > 0; }).join('&') : null
	  return res ? ("?" + res) : ''
	}
	
	/*  */
	
	function createRoute (
	  record,
	  location,
	  redirectedFrom
	) {
	  var route = {
	    name: location.name || (record && record.name),
	    meta: (record && record.meta) || {},
	    path: location.path || '/',
	    hash: location.hash || '',
	    query: location.query || {},
	    params: location.params || {},
	    fullPath: getFullPath(location),
	    matched: record ? formatMatch(record) : []
	  }
	  if (redirectedFrom) {
	    route.redirectedFrom = getFullPath(redirectedFrom)
	  }
	  return Object.freeze(route)
	}
	
	// the starting route that represents the initial state
	var START = createRoute(null, {
	  path: '/'
	})
	
	function formatMatch (record) {
	  var res = []
	  while (record) {
	    res.unshift(record)
	    record = record.parent
	  }
	  return res
	}
	
	function getFullPath (ref) {
	  var path = ref.path;
	  var query = ref.query; if ( query === void 0 ) query = {};
	  var hash = ref.hash; if ( hash === void 0 ) hash = '';
	
	  return (path || '/') + stringifyQuery(query) + hash
	}
	
	var trailingSlashRE = /\/$/
	function isSameRoute (a, b) {
	  if (b === START) {
	    return a === b
	  } else if (!b) {
	    return false
	  } else if (a.path && b.path) {
	    return (
	      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
	      a.hash === b.hash &&
	      isObjectEqual(a.query, b.query)
	    )
	  } else if (a.name && b.name) {
	    return (
	      a.name === b.name &&
	      a.hash === b.hash &&
	      isObjectEqual(a.query, b.query) &&
	      isObjectEqual(a.params, b.params)
	    )
	  } else {
	    return false
	  }
	}
	
	function isObjectEqual (a, b) {
	  if ( a === void 0 ) a = {};
	  if ( b === void 0 ) b = {};
	
	  var aKeys = Object.keys(a)
	  var bKeys = Object.keys(b)
	  if (aKeys.length !== bKeys.length) {
	    return false
	  }
	  return aKeys.every(function (key) { return String(a[key]) === String(b[key]); })
	}
	
	function isIncludedRoute (current, target) {
	  return (
	    current.path.indexOf(target.path.replace(/\/$/, '')) === 0 &&
	    (!target.hash || current.hash === target.hash) &&
	    queryIncludes(current.query, target.query)
	  )
	}
	
	function queryIncludes (current, target) {
	  for (var key in target) {
	    if (!(key in current)) {
	      return false
	    }
	  }
	  return true
	}
	
	/*  */
	
	// work around weird flow bug
	var toTypes = [String, Object]
	
	var Link = {
	  name: 'router-link',
	  props: {
	    to: {
	      type: toTypes,
	      required: true
	    },
	    tag: {
	      type: String,
	      default: 'a'
	    },
	    exact: Boolean,
	    append: Boolean,
	    replace: Boolean,
	    activeClass: String,
	    event: {
	      type: [String, Array],
	      default: 'click'
	    }
	  },
	  render: function render (h) {
	    var this$1 = this;
	
	    var router = this.$router
	    var current = this.$route
	    var ref = router.resolve(this.to, current, this.append);
	    var normalizedTo = ref.normalizedTo;
	    var resolved = ref.resolved;
	    var href = ref.href;
	    var classes = {}
	    var activeClass = this.activeClass || router.options.linkActiveClass || 'router-link-active'
	    var compareTarget = normalizedTo.path ? createRoute(null, normalizedTo) : resolved
	    classes[activeClass] = this.exact
	      ? isSameRoute(current, compareTarget)
	      : isIncludedRoute(current, compareTarget)
	
	    var handler = function (e) {
	      if (guardEvent(e)) {
	        if (this$1.replace) {
	          router.replace(normalizedTo)
	        } else {
	          router.push(normalizedTo)
	        }
	      }
	    }
	
	    var on = { click: guardEvent }
	    if (Array.isArray(this.event)) {
	      this.event.forEach(function (e) { on[e] = handler })
	    } else {
	      on[this.event] = handler
	    }
	
	    var data = {
	      class: classes
	    }
	
	    if (this.tag === 'a') {
	      data.on = on
	      data.attrs = { href: href }
	    } else {
	      // find the first <a> child and apply listener and href
	      var a = findAnchor(this.$slots.default)
	      if (a) {
	        // in case the <a> is a static node
	        a.isStatic = false
	        var extend = _Vue.util.extend
	        var aData = a.data = extend({}, a.data)
	        aData.on = on
	        var aAttrs = a.data.attrs = extend({}, a.data.attrs)
	        aAttrs.href = href
	      } else {
	        // doesn't have <a> child, apply listener to self
	        data.on = on
	      }
	    }
	
	    return h(this.tag, data, this.$slots.default)
	  }
	}
	
	function guardEvent (e) {
	  // don't redirect with control keys
	  /* istanbul ignore if */
	  if (e.metaKey || e.ctrlKey || e.shiftKey) { return }
	  // don't redirect when preventDefault called
	  /* istanbul ignore if */
	  if (e.defaultPrevented) { return }
	  // don't redirect on right click
	  /* istanbul ignore if */
	  if (e.button !== 0) { return }
	  // don't redirect if `target="_blank"`
	  /* istanbul ignore if */
	  var target = e.target.getAttribute('target')
	  if (/\b_blank\b/i.test(target)) { return }
	
	  e.preventDefault()
	  return true
	}
	
	function findAnchor (children) {
	  if (children) {
	    var child
	    for (var i = 0; i < children.length; i++) {
	      child = children[i]
	      if (child.tag === 'a') {
	        return child
	      }
	      if (child.children && (child = findAnchor(child.children))) {
	        return child
	      }
	    }
	  }
	}
	
	var _Vue
	
	function install (Vue) {
	  if (install.installed) { return }
	  install.installed = true
	
	  _Vue = Vue
	
	  Object.defineProperty(Vue.prototype, '$router', {
	    get: function get () { return this.$root._router }
	  })
	
	  Object.defineProperty(Vue.prototype, '$route', {
	    get: function get$1 () { return this.$root._route }
	  })
	
	  Vue.mixin({
	    beforeCreate: function beforeCreate () {
	      if (this.$options.router) {
	        this._router = this.$options.router
	        this._router.init(this)
	        Vue.util.defineReactive(this, '_route', this._router.history.current)
	      }
	    }
	  })
	
	  Vue.component('router-view', View)
	  Vue.component('router-link', Link)
	
	  var strats = Vue.config.optionMergeStrategies
	  // use the same hook merging strategy for route hooks
	  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.created
	}
	
	/*  */
	
	function resolvePath (
	  relative,
	  base,
	  append
	) {
	  if (relative.charAt(0) === '/') {
	    return relative
	  }
	
	  if (relative.charAt(0) === '?' || relative.charAt(0) === '#') {
	    return base + relative
	  }
	
	  var stack = base.split('/')
	
	  // remove trailing segment if:
	  // - not appending
	  // - appending to trailing slash (last segment is empty)
	  if (!append || !stack[stack.length - 1]) {
	    stack.pop()
	  }
	
	  // resolve relative path
	  var segments = relative.replace(/^\//, '').split('/')
	  for (var i = 0; i < segments.length; i++) {
	    var segment = segments[i]
	    if (segment === '.') {
	      continue
	    } else if (segment === '..') {
	      stack.pop()
	    } else {
	      stack.push(segment)
	    }
	  }
	
	  // ensure leading slash
	  if (stack[0] !== '') {
	    stack.unshift('')
	  }
	
	  return stack.join('/')
	}
	
	function parsePath (path) {
	  var hash = ''
	  var query = ''
	
	  var hashIndex = path.indexOf('#')
	  if (hashIndex >= 0) {
	    hash = path.slice(hashIndex)
	    path = path.slice(0, hashIndex)
	  }
	
	  var queryIndex = path.indexOf('?')
	  if (queryIndex >= 0) {
	    query = path.slice(queryIndex + 1)
	    path = path.slice(0, queryIndex)
	  }
	
	  return {
	    path: path,
	    query: query,
	    hash: hash
	  }
	}
	
	function cleanPath (path) {
	  return path.replace(/\/\//g, '/')
	}
	
	/*  */
	
	function createRouteMap (routes) {
	  var pathMap = Object.create(null)
	  var nameMap = Object.create(null)
	
	  routes.forEach(function (route) {
	    addRouteRecord(pathMap, nameMap, route)
	  })
	
	  return {
	    pathMap: pathMap,
	    nameMap: nameMap
	  }
	}
	
	function addRouteRecord (
	  pathMap,
	  nameMap,
	  route,
	  parent,
	  matchAs
	) {
	  var path = route.path;
	  var name = route.name;
	  if (false) {
	    assert(path != null, "\"path\" is required in a route configuration.")
	    assert(
	      typeof route.component !== 'string',
	      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
	      "string id. Use an actual component instead."
	    )
	  }
	
	  var record = {
	    path: normalizePath(path, parent),
	    components: route.components || { default: route.component },
	    instances: {},
	    name: name,
	    parent: parent,
	    matchAs: matchAs,
	    redirect: route.redirect,
	    beforeEnter: route.beforeEnter,
	    meta: route.meta || {}
	  }
	
	  if (route.children) {
	    // Warn if route is named and has a default child route.
	    // If users navigate to this route by name, the default child will
	    // not be rendered (GH Issue #629)
	    if (false) {
	      if (route.name && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
	        warn(false, ("Named Route '" + (route.name) + "' has a default child route.\n          When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), the default child route will not be rendered.\n          Remove the name from this route and use the name of the default child route for named links instead.")
	        )
	      }
	    }
	    route.children.forEach(function (child) {
	      addRouteRecord(pathMap, nameMap, child, record)
	    })
	  }
	
	  if (route.alias !== undefined) {
	    if (Array.isArray(route.alias)) {
	      route.alias.forEach(function (alias) {
	        addRouteRecord(pathMap, nameMap, { path: alias }, parent, record.path)
	      })
	    } else {
	      addRouteRecord(pathMap, nameMap, { path: route.alias }, parent, record.path)
	    }
	  }
	
	  if (!pathMap[record.path]) {
	    pathMap[record.path] = record
	  }
	  if (name) {
	    if (!nameMap[name]) {
	      nameMap[name] = record
	    } else if (false) {
	      warn(false, ("Duplicate named routes definition: { name: \"" + name + "\", path: \"" + (record.path) + "\" }"))
	    }
	  }
	}
	
	function normalizePath (path, parent) {
	  path = path.replace(/\/$/, '')
	  if (path[0] === '/') { return path }
	  if (parent == null) { return path }
	  return cleanPath(((parent.path) + "/" + path))
	}
	
	var __moduleExports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};
	
	var isarray = __moduleExports
	
	/**
	 * Expose `pathToRegexp`.
	 */
	var index = pathToRegexp
	var parse_1 = parse
	var compile_1 = compile
	var tokensToFunction_1 = tokensToFunction
	var tokensToRegExp_1 = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}
	
	index.parse = parse_1;
	index.compile = compile_1;
	index.tokensToFunction = tokensToFunction_1;
	index.tokensToRegExp = tokensToRegExp_1;
	
	/*  */
	
	var regexpCache = Object.create(null)
	
	function getRouteRegex (path) {
	  var hit = regexpCache[path]
	  var keys, regexp
	
	  if (hit) {
	    keys = hit.keys
	    regexp = hit.regexp
	  } else {
	    keys = []
	    regexp = index(path, keys)
	    regexpCache[path] = { keys: keys, regexp: regexp }
	  }
	
	  return { keys: keys, regexp: regexp }
	}
	
	var regexpCompileCache = Object.create(null)
	
	function fillParams (
	  path,
	  params,
	  routeMsg
	) {
	  try {
	    var filler =
	      regexpCompileCache[path] ||
	      (regexpCompileCache[path] = index.compile(path))
	    return filler(params || {}, { pretty: true })
	  } catch (e) {
	    if (false) {
	      warn(false, ("missing param for " + routeMsg + ": " + (e.message)))
	    }
	    return ''
	  }
	}
	
	/*  */
	
	function normalizeLocation (
	  raw,
	  current,
	  append
	) {
	  var next = typeof raw === 'string' ? { path: raw } : raw
	  // named target
	  if (next.name || next._normalized) {
	    return next
	  }
	
	  // relative params
	  if (!next.path && next.params && current) {
	    next = assign({}, next)
	    next._normalized = true
	    var params = assign(assign({}, current.params), next.params)
	    if (current.name) {
	      next.name = current.name
	      next.params = params
	    } else if (current.matched) {
	      var rawPath = current.matched[current.matched.length - 1].path
	      next.path = fillParams(rawPath, params, ("path " + (current.path)))
	    } else if (false) {
	      warn(false, "relative params navigation requires a current route.")
	    }
	    return next
	  }
	
	  var parsedPath = parsePath(next.path || '')
	  var basePath = (current && current.path) || '/'
	  var path = parsedPath.path
	    ? resolvePath(parsedPath.path, basePath, append || next.append)
	    : (current && current.path) || '/'
	  var query = resolveQuery(parsedPath.query, next.query)
	  var hash = next.hash || parsedPath.hash
	  if (hash && hash.charAt(0) !== '#') {
	    hash = "#" + hash
	  }
	
	  return {
	    _normalized: true,
	    path: path,
	    query: query,
	    hash: hash
	  }
	}
	
	function assign (a, b) {
	  for (var key in b) {
	    a[key] = b[key]
	  }
	  return a
	}
	
	/*  */
	
	function createMatcher (routes) {
	  var ref = createRouteMap(routes);
	  var pathMap = ref.pathMap;
	  var nameMap = ref.nameMap;
	
	  function match (
	    raw,
	    currentRoute,
	    redirectedFrom
	  ) {
	    var location = normalizeLocation(raw, currentRoute)
	    var name = location.name;
	
	    if (name) {
	      var record = nameMap[name]
	      var paramNames = getRouteRegex(record.path).keys
	        .filter(function (key) { return !key.optional; })
	        .map(function (key) { return key.name; })
	
	      if (typeof location.params !== 'object') {
	        location.params = {}
	      }
	
	      if (currentRoute && typeof currentRoute.params === 'object') {
	        for (var key in currentRoute.params) {
	          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
	            location.params[key] = currentRoute.params[key]
	          }
	        }
	      }
	
	      if (record) {
	        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""))
	        return _createRoute(record, location, redirectedFrom)
	      }
	    } else if (location.path) {
	      location.params = {}
	      for (var path in pathMap) {
	        if (matchRoute(path, location.params, location.path)) {
	          return _createRoute(pathMap[path], location, redirectedFrom)
	        }
	      }
	    }
	    // no match
	    return _createRoute(null, location)
	  }
	
	  function redirect (
	    record,
	    location
	  ) {
	    var originalRedirect = record.redirect
	    var redirect = typeof originalRedirect === 'function'
	        ? originalRedirect(createRoute(record, location))
	        : originalRedirect
	
	    if (typeof redirect === 'string') {
	      redirect = { path: redirect }
	    }
	
	    if (!redirect || typeof redirect !== 'object') {
	      ("production") !== 'production' && warn(
	        false, ("invalid redirect option: " + (JSON.stringify(redirect)))
	      )
	      return _createRoute(null, location)
	    }
	
	    var re = redirect
	    var name = re.name;
	    var path = re.path;
	    var query = location.query;
	    var hash = location.hash;
	    var params = location.params;
	    query = re.hasOwnProperty('query') ? re.query : query
	    hash = re.hasOwnProperty('hash') ? re.hash : hash
	    params = re.hasOwnProperty('params') ? re.params : params
	
	    if (name) {
	      // resolved named direct
	      var targetRecord = nameMap[name]
	      if (false) {
	        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."))
	      }
	      return match({
	        _normalized: true,
	        name: name,
	        query: query,
	        hash: hash,
	        params: params
	      }, undefined, location)
	    } else if (path) {
	      // 1. resolve relative redirect
	      var rawPath = resolveRecordPath(path, record)
	      // 2. resolve params
	      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""))
	      // 3. rematch with existing query and hash
	      return match({
	        _normalized: true,
	        path: resolvedPath,
	        query: query,
	        hash: hash
	      }, undefined, location)
	    } else {
	      warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))))
	      return _createRoute(null, location)
	    }
	  }
	
	  function alias (
	    record,
	    location,
	    matchAs
	  ) {
	    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""))
	    var aliasedMatch = match({
	      _normalized: true,
	      path: aliasedPath
	    })
	    if (aliasedMatch) {
	      var matched = aliasedMatch.matched
	      var aliasedRecord = matched[matched.length - 1]
	      location.params = aliasedMatch.params
	      return _createRoute(aliasedRecord, location)
	    }
	    return _createRoute(null, location)
	  }
	
	  function _createRoute (
	    record,
	    location,
	    redirectedFrom
	  ) {
	    if (record && record.redirect) {
	      return redirect(record, redirectedFrom || location)
	    }
	    if (record && record.matchAs) {
	      return alias(record, location, record.matchAs)
	    }
	    return createRoute(record, location, redirectedFrom)
	  }
	
	  return match
	}
	
	function matchRoute (
	  path,
	  params,
	  pathname
	) {
	  var ref = getRouteRegex(path);
	  var regexp = ref.regexp;
	  var keys = ref.keys;
	  var m = pathname.match(regexp)
	
	  if (!m) {
	    return false
	  } else if (!params) {
	    return true
	  }
	
	  for (var i = 1, len = m.length; i < len; ++i) {
	    var key = keys[i - 1]
	    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i]
	    if (key) { params[key.name] = val }
	  }
	
	  return true
	}
	
	function resolveRecordPath (path, record) {
	  return resolvePath(path, record.parent ? record.parent.path : '/', true)
	}
	
	/*  */
	
	var inBrowser = typeof window !== 'undefined'
	
	var supportsHistory = inBrowser && (function () {
	  var ua = window.navigator.userAgent
	
	  if (
	    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
	    ua.indexOf('Mobile Safari') !== -1 &&
	    ua.indexOf('Chrome') === -1 &&
	    ua.indexOf('Windows Phone') === -1
	  ) {
	    return false
	  }
	
	  return window.history && 'pushState' in window.history
	})()
	
	/*  */
	
	function runQueue (queue, fn, cb) {
	  var step = function (index) {
	    if (index >= queue.length) {
	      cb()
	    } else {
	      if (queue[index]) {
	        fn(queue[index], function () {
	          step(index + 1)
	        })
	      } else {
	        step(index + 1)
	      }
	    }
	  }
	  step(0)
	}
	
	/*  */
	
	
	var History = function History (router, base) {
	  this.router = router
	  this.base = normalizeBase(base)
	  // start with a route object that stands for "nowhere"
	  this.current = START
	  this.pending = null
	};
	
	History.prototype.listen = function listen (cb) {
	  this.cb = cb
	};
	
	History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
	    var this$1 = this;
	
	  var route = this.router.match(location, this.current)
	  this.confirmTransition(route, function () {
	    this$1.updateRoute(route)
	    onComplete && onComplete(route)
	    this$1.ensureURL()
	  }, onAbort)
	};
	
	History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
	    var this$1 = this;
	
	  var current = this.current
	  var abort = function () { onAbort && onAbort() }
	  if (isSameRoute(route, current)) {
	    this.ensureURL()
	    return abort()
	  }
	
	  var ref = resolveQueue(this.current.matched, route.matched);
	    var deactivated = ref.deactivated;
	    var activated = ref.activated;
	
	  var queue = [].concat(
	    // in-component leave guards
	    extractLeaveGuards(deactivated),
	    // global before hooks
	    this.router.beforeHooks,
	    // enter guards
	    activated.map(function (m) { return m.beforeEnter; }),
	    // async components
	    resolveAsyncComponents(activated)
	  )
	
	  this.pending = route
	  var iterator = function (hook, next) {
	    if (this$1.pending !== route) {
	      return abort()
	    }
	    hook(route, current, function (to) {
	      if (to === false) {
	        // next(false) -> abort navigation, ensure current URL
	        this$1.ensureURL(true)
	        abort()
	      } else if (typeof to === 'string' || typeof to === 'object') {
	        // next('/') or next({ path: '/' }) -> redirect
	        (typeof to === 'object' && to.replace) ? this$1.replace(to) : this$1.push(to)
	        abort()
	      } else {
	        // confirm transition and pass on the value
	        next(to)
	      }
	    })
	  }
	
	  runQueue(queue, iterator, function () {
	    var postEnterCbs = []
	    var enterGuards = extractEnterGuards(activated, postEnterCbs, function () {
	      return this$1.current === route
	    })
	    // wait until async components are resolved before
	    // extracting in-component enter guards
	    runQueue(enterGuards, iterator, function () {
	      if (this$1.pending !== route) {
	        return abort()
	      }
	      this$1.pending = null
	      onComplete(route)
	      if (this$1.router.app) {
	        this$1.router.app.$nextTick(function () {
	          postEnterCbs.forEach(function (cb) { return cb(); })
	        })
	      }
	    })
	  })
	};
	
	History.prototype.updateRoute = function updateRoute (route) {
	  var prev = this.current
	  this.current = route
	  this.cb && this.cb(route)
	  this.router.afterHooks.forEach(function (hook) {
	    hook && hook(route, prev)
	  })
	};
	
	function normalizeBase (base) {
	  if (!base) {
	    if (inBrowser) {
	      // respect <base> tag
	      var baseEl = document.querySelector('base')
	      base = baseEl ? baseEl.getAttribute('href') : '/'
	    } else {
	      base = '/'
	    }
	  }
	  // make sure there's the starting slash
	  if (base.charAt(0) !== '/') {
	    base = '/' + base
	  }
	  // remove trailing slash
	  return base.replace(/\/$/, '')
	}
	
	function resolveQueue (
	  current,
	  next
	) {
	  var i
	  var max = Math.max(current.length, next.length)
	  for (i = 0; i < max; i++) {
	    if (current[i] !== next[i]) {
	      break
	    }
	  }
	  return {
	    activated: next.slice(i),
	    deactivated: current.slice(i)
	  }
	}
	
	function extractGuard (
	  def,
	  key
	) {
	  if (typeof def !== 'function') {
	    // extend now so that global mixins are applied.
	    def = _Vue.extend(def)
	  }
	  return def.options[key]
	}
	
	function extractLeaveGuards (matched) {
	  return flatten(flatMapComponents(matched, function (def, instance) {
	    var guard = extractGuard(def, 'beforeRouteLeave')
	    if (guard) {
	      return Array.isArray(guard)
	        ? guard.map(function (guard) { return wrapLeaveGuard(guard, instance); })
	        : wrapLeaveGuard(guard, instance)
	    }
	  }).reverse())
	}
	
	function wrapLeaveGuard (
	  guard,
	  instance
	) {
	  return function routeLeaveGuard () {
	    return guard.apply(instance, arguments)
	  }
	}
	
	function extractEnterGuards (
	  matched,
	  cbs,
	  isValid
	) {
	  return flatten(flatMapComponents(matched, function (def, _, match, key) {
	    var guard = extractGuard(def, 'beforeRouteEnter')
	    if (guard) {
	      return Array.isArray(guard)
	        ? guard.map(function (guard) { return wrapEnterGuard(guard, cbs, match, key, isValid); })
	        : wrapEnterGuard(guard, cbs, match, key, isValid)
	    }
	  }))
	}
	
	function wrapEnterGuard (
	  guard,
	  cbs,
	  match,
	  key,
	  isValid
	) {
	  return function routeEnterGuard (to, from, next) {
	    return guard(to, from, function (cb) {
	      next(cb)
	      if (typeof cb === 'function') {
	        cbs.push(function () {
	          // #750
	          // if a router-view is wrapped with an out-in transition,
	          // the instance may not have been registered at this time.
	          // we will need to poll for registration until current route
	          // is no longer valid.
	          poll(cb, match.instances, key, isValid)
	        })
	      }
	    })
	  }
	}
	
	function poll (
	  cb, // somehow flow cannot infer this is a function
	  instances,
	  key,
	  isValid
	) {
	  if (instances[key]) {
	    cb(instances[key])
	  } else if (isValid()) {
	    setTimeout(function () {
	      poll(cb, instances, key, isValid)
	    }, 16)
	  }
	}
	
	function resolveAsyncComponents (matched) {
	  return flatMapComponents(matched, function (def, _, match, key) {
	    // if it's a function and doesn't have Vue options attached,
	    // assume it's an async component resolve function.
	    // we are not using Vue's default async resolving mechanism because
	    // we want to halt the navigation until the incoming component has been
	    // resolved.
	    if (typeof def === 'function' && !def.options) {
	      return function (to, from, next) {
	        var resolve = function (resolvedDef) {
	          match.components[key] = resolvedDef
	          next()
	        }
	
	        var reject = function (reason) {
	          warn(false, ("Failed to resolve async component " + key + ": " + reason))
	          next(false)
	        }
	
	        var res = def(resolve, reject)
	        if (res && typeof res.then === 'function') {
	          res.then(resolve, reject)
	        }
	      }
	    }
	  })
	}
	
	function flatMapComponents (
	  matched,
	  fn
	) {
	  return flatten(matched.map(function (m) {
	    return Object.keys(m.components).map(function (key) { return fn(
	      m.components[key],
	      m.instances[key],
	      m, key
	    ); })
	  }))
	}
	
	function flatten (arr) {
	  return Array.prototype.concat.apply([], arr)
	}
	
	/*  */
	
	var positionStore = Object.create(null)
	
	function saveScrollPosition (key) {
	  if (!key) { return }
	  positionStore[key] = {
	    x: window.pageXOffset,
	    y: window.pageYOffset
	  }
	}
	
	function getScrollPosition (key) {
	  if (!key) { return }
	  return positionStore[key]
	}
	
	function getElementPosition (el) {
	  var docRect = document.documentElement.getBoundingClientRect()
	  var elRect = el.getBoundingClientRect()
	  return {
	    x: elRect.left - docRect.left,
	    y: elRect.top - docRect.top
	  }
	}
	
	function isValidPosition (obj) {
	  return isNumber(obj.x) || isNumber(obj.y)
	}
	
	function normalizePosition (obj) {
	  return {
	    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
	    y: isNumber(obj.y) ? obj.y : window.pageYOffset
	  }
	}
	
	function isNumber (v) {
	  return typeof v === 'number'
	}
	
	/*  */
	
	
	var genKey = function () { return String(Date.now()); }
	var _key = genKey()
	
	var HTML5History = (function (History) {
	  function HTML5History (router, base) {
	    var this$1 = this;
	
	    History.call(this, router, base)
	
	    var expectScroll = router.options.scrollBehavior
	    window.addEventListener('popstate', function (e) {
	      _key = e.state && e.state.key
	      var current = this$1.current
	      this$1.transitionTo(getLocation(this$1.base), function (next) {
	        if (expectScroll) {
	          this$1.handleScroll(next, current, true)
	        }
	      })
	    })
	
	    if (expectScroll) {
	      window.addEventListener('scroll', function () {
	        saveScrollPosition(_key)
	      })
	    }
	  }
	
	  if ( History ) HTML5History.__proto__ = History;
	  HTML5History.prototype = Object.create( History && History.prototype );
	  HTML5History.prototype.constructor = HTML5History;
	
	  HTML5History.prototype.go = function go (n) {
	    window.history.go(n)
	  };
	
	  HTML5History.prototype.push = function push (location) {
	    var this$1 = this;
	
	    var current = this.current
	    this.transitionTo(location, function (route) {
	      pushState(cleanPath(this$1.base + route.fullPath))
	      this$1.handleScroll(route, current, false)
	    })
	  };
	
	  HTML5History.prototype.replace = function replace (location) {
	    var this$1 = this;
	
	    var current = this.current
	    this.transitionTo(location, function (route) {
	      replaceState(cleanPath(this$1.base + route.fullPath))
	      this$1.handleScroll(route, current, false)
	    })
	  };
	
	  HTML5History.prototype.ensureURL = function ensureURL (push) {
	    if (getLocation(this.base) !== this.current.fullPath) {
	      var current = cleanPath(this.base + this.current.fullPath)
	      push ? pushState(current) : replaceState(current)
	    }
	  };
	
	  HTML5History.prototype.handleScroll = function handleScroll (to, from, isPop) {
	    var router = this.router
	    if (!router.app) {
	      return
	    }
	
	    var behavior = router.options.scrollBehavior
	    if (!behavior) {
	      return
	    }
	    if (false) {
	      assert(typeof behavior === 'function', "scrollBehavior must be a function")
	    }
	
	    // wait until re-render finishes before scrolling
	    router.app.$nextTick(function () {
	      var position = getScrollPosition(_key)
	      var shouldScroll = behavior(to, from, isPop ? position : null)
	      if (!shouldScroll) {
	        return
	      }
	      var isObject = typeof shouldScroll === 'object'
	      if (isObject && typeof shouldScroll.selector === 'string') {
	        var el = document.querySelector(shouldScroll.selector)
	        if (el) {
	          position = getElementPosition(el)
	        } else if (isValidPosition(shouldScroll)) {
	          position = normalizePosition(shouldScroll)
	        }
	      } else if (isObject && isValidPosition(shouldScroll)) {
	        position = normalizePosition(shouldScroll)
	      }
	
	      if (position) {
	        window.scrollTo(position.x, position.y)
	      }
	    })
	  };
	
	  return HTML5History;
	}(History));
	
	function getLocation (base) {
	  var path = window.location.pathname
	  if (base && path.indexOf(base) === 0) {
	    path = path.slice(base.length)
	  }
	  return (path || '/') + window.location.search + window.location.hash
	}
	
	function pushState (url, replace) {
	  // try...catch the pushState call to get around Safari
	  // DOM Exception 18 where it limits to 100 pushState calls
	  var history = window.history
	  try {
	    if (replace) {
	      history.replaceState({ key: _key }, '', url)
	    } else {
	      _key = genKey()
	      history.pushState({ key: _key }, '', url)
	    }
	    saveScrollPosition(_key)
	  } catch (e) {
	    window.location[replace ? 'assign' : 'replace'](url)
	  }
	}
	
	function replaceState (url) {
	  pushState(url, true)
	}
	
	/*  */
	
	
	var HashHistory = (function (History) {
	  function HashHistory (router, base, fallback) {
	    History.call(this, router, base)
	    // check history fallback deeplinking
	    if (fallback && this.checkFallback()) {
	      return
	    }
	    ensureSlash()
	  }
	
	  if ( History ) HashHistory.__proto__ = History;
	  HashHistory.prototype = Object.create( History && History.prototype );
	  HashHistory.prototype.constructor = HashHistory;
	
	  HashHistory.prototype.checkFallback = function checkFallback () {
	    var location = getLocation(this.base)
	    if (!/^\/#/.test(location)) {
	      window.location.replace(
	        cleanPath(this.base + '/#' + location)
	      )
	      return true
	    }
	  };
	
	  HashHistory.prototype.onHashChange = function onHashChange () {
	    if (!ensureSlash()) {
	      return
	    }
	    this.transitionTo(getHash(), function (route) {
	      replaceHash(route.fullPath)
	    })
	  };
	
	  HashHistory.prototype.push = function push (location) {
	    this.transitionTo(location, function (route) {
	      pushHash(route.fullPath)
	    })
	  };
	
	  HashHistory.prototype.replace = function replace (location) {
	    this.transitionTo(location, function (route) {
	      replaceHash(route.fullPath)
	    })
	  };
	
	  HashHistory.prototype.go = function go (n) {
	    window.history.go(n)
	  };
	
	  HashHistory.prototype.ensureURL = function ensureURL (push) {
	    var current = this.current.fullPath
	    if (getHash() !== current) {
	      push ? pushHash(current) : replaceHash(current)
	    }
	  };
	
	  return HashHistory;
	}(History));
	
	function ensureSlash () {
	  var path = getHash()
	  if (path.charAt(0) === '/') {
	    return true
	  }
	  replaceHash('/' + path)
	  return false
	}
	
	function getHash () {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href
	  var index = href.indexOf('#')
	  return index === -1 ? '' : href.slice(index + 1)
	}
	
	function pushHash (path) {
	  window.location.hash = path
	}
	
	function replaceHash (path) {
	  var i = window.location.href.indexOf('#')
	  window.location.replace(
	    window.location.href.slice(0, i >= 0 ? i : 0) + '#' + path
	  )
	}
	
	/*  */
	
	
	var AbstractHistory = (function (History) {
	  function AbstractHistory (router) {
	    History.call(this, router)
	    this.stack = []
	    this.index = -1
	  }
	
	  if ( History ) AbstractHistory.__proto__ = History;
	  AbstractHistory.prototype = Object.create( History && History.prototype );
	  AbstractHistory.prototype.constructor = AbstractHistory;
	
	  AbstractHistory.prototype.push = function push (location) {
	    var this$1 = this;
	
	    this.transitionTo(location, function (route) {
	      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route)
	      this$1.index++
	    })
	  };
	
	  AbstractHistory.prototype.replace = function replace (location) {
	    var this$1 = this;
	
	    this.transitionTo(location, function (route) {
	      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route)
	    })
	  };
	
	  AbstractHistory.prototype.go = function go (n) {
	    var this$1 = this;
	
	    var targetIndex = this.index + n
	    if (targetIndex < 0 || targetIndex >= this.stack.length) {
	      return
	    }
	    var route = this.stack[targetIndex]
	    this.confirmTransition(route, function () {
	      this$1.index = targetIndex
	      this$1.updateRoute(route)
	    })
	  };
	
	  AbstractHistory.prototype.ensureURL = function ensureURL () {
	    // noop
	  };
	
	  return AbstractHistory;
	}(History));
	
	/*  */
	
	var VueRouter = function VueRouter (options) {
	  if ( options === void 0 ) options = {};
	
	  this.app = null
	  this.options = options
	  this.beforeHooks = []
	  this.afterHooks = []
	  this.match = createMatcher(options.routes || [])
	
	  var mode = options.mode || 'hash'
	  this.fallback = mode === 'history' && !supportsHistory
	  if (this.fallback) {
	    mode = 'hash'
	  }
	  if (!inBrowser) {
	    mode = 'abstract'
	  }
	  this.mode = mode
	
	  switch (mode) {
	    case 'history':
	      this.history = new HTML5History(this, options.base)
	      break
	    case 'hash':
	      this.history = new HashHistory(this, options.base, this.fallback)
	      break
	    case 'abstract':
	      this.history = new AbstractHistory(this)
	      break
	    default:
	      ("production") !== 'production' && assert(false, ("invalid mode: " + mode))
	  }
	};
	
	var prototypeAccessors = { currentRoute: {} };
	
	prototypeAccessors.currentRoute.get = function () {
	  return this.history && this.history.current
	};
	
	VueRouter.prototype.init = function init (app /* Vue component instance */) {
	    var this$1 = this;
	
	  ("production") !== 'production' && assert(
	    install.installed,
	    "not installed. Make sure to call `Vue.use(VueRouter)` " +
	    "before creating root instance."
	  )
	
	  this.app = app
	
	  var history = this.history
	
	  if (history instanceof HTML5History) {
	    history.transitionTo(getLocation(history.base))
	  } else if (history instanceof HashHistory) {
	    var setupHashListener = function () {
	      window.addEventListener('hashchange', function () {
	        history.onHashChange()
	      })
	    }
	    history.transitionTo(getHash(), setupHashListener, setupHashListener)
	  }
	
	  history.listen(function (route) {
	    this$1.app._route = route
	  })
	};
	
	VueRouter.prototype.beforeEach = function beforeEach (fn) {
	  this.beforeHooks.push(fn)
	};
	
	VueRouter.prototype.afterEach = function afterEach (fn) {
	  this.afterHooks.push(fn)
	};
	
	VueRouter.prototype.push = function push (location) {
	  this.history.push(location)
	};
	
	VueRouter.prototype.replace = function replace (location) {
	  this.history.replace(location)
	};
	
	VueRouter.prototype.go = function go (n) {
	  this.history.go(n)
	};
	
	VueRouter.prototype.back = function back () {
	  this.go(-1)
	};
	
	VueRouter.prototype.forward = function forward () {
	  this.go(1)
	};
	
	VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
	  var route = to
	    ? this.resolve(to).resolved
	    : this.currentRoute
	  if (!route) {
	    return []
	  }
	  return [].concat.apply([], route.matched.map(function (m) {
	    return Object.keys(m.components).map(function (key) {
	      return m.components[key]
	    })
	  }))
	};
	
	VueRouter.prototype.resolve = function resolve (
	  to,
	  current,
	  append
	) {
	  var normalizedTo = normalizeLocation(to, current || this.history.current, append)
	  var resolved = this.match(normalizedTo, current)
	  var fullPath = resolved.redirectedFrom || resolved.fullPath
	  var base = this.history.base
	  var href = createHref(base, fullPath, this.mode)
	  return {
	    normalizedTo: normalizedTo,
	    resolved: resolved,
	    href: href
	  }
	};
	
	Object.defineProperties( VueRouter.prototype, prototypeAccessors );
	
	function createHref (base, fullPath, mode) {
	  var path = mode === 'hash' ? '#' + fullPath : fullPath
	  return base ? cleanPath(base + '/' + path) : path
	}
	
	VueRouter.install = install
	
	if (inBrowser && window.Vue) {
	  window.Vue.use(VueRouter)
	}
	
	module.exports = VueRouter;

/***/ },
/* 493 */
/***/ function(module, exports) {

	exports.sync = function (store, router) {
	  store.registerModule('route', {
	    state: {},
	    mutations: {
	      'router/ROUTE_CHANGED': function (state, to) {
	        store.state.route = Object.freeze({
	          name: to.name,
	          path: to.path,
	          hash: to.hash,
	          query: to.query,
	          params: to.params,
	          fullPath: to.fullPath
	        })
	      }
	    }
	  })
	
	  var isTimeTraveling = false
	  var currentPath
	
	  // sync router on store change
	  store.watch(
	    function (state) { return state.route },
	    function (route) {
	      if (route.fullPath === currentPath) {
	        return
	      }
	      isTimeTraveling = true
	      currentPath = route.fullPath
	      router.push(route)
	    },
	    { sync: true }
	  )
	
	  // sync store on router navigation
	  router.afterEach(function (to) {
	    if (isTimeTraveling) {
	      isTimeTraveling = false
	      return
	    }
	    currentPath = to.fullPath
	    store.commit('router/ROUTE_CHANGED', to)
	  })
	}


/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * vuex v2.1.1
	 * (c) 2016 Evan You
	 * @license MIT
	 */
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Vuex = factory());
	}(this, (function () { 'use strict';
	
	var devtoolHook =
	  typeof window !== 'undefined' &&
	  window.__VUE_DEVTOOLS_GLOBAL_HOOK__
	
	function devtoolPlugin (store) {
	  if (!devtoolHook) { return }
	
	  store._devtoolHook = devtoolHook
	
	  devtoolHook.emit('vuex:init', store)
	
	  devtoolHook.on('vuex:travel-to-state', function (targetState) {
	    store.replaceState(targetState)
	  })
	
	  store.subscribe(function (mutation, state) {
	    devtoolHook.emit('vuex:mutation', mutation, state)
	  })
	}
	
	function applyMixin (Vue) {
	  var version = Number(Vue.version.split('.')[0])
	
	  if (version >= 2) {
	    var usesInit = Vue.config._lifecycleHooks.indexOf('init') > -1
	    Vue.mixin(usesInit ? { init: vuexInit } : { beforeCreate: vuexInit })
	  } else {
	    // override init and inject vuex init procedure
	    // for 1.x backwards compatibility.
	    var _init = Vue.prototype._init
	    Vue.prototype._init = function (options) {
	      if ( options === void 0 ) options = {};
	
	      options.init = options.init
	        ? [vuexInit].concat(options.init)
	        : vuexInit
	      _init.call(this, options)
	    }
	  }
	
	  /**
	   * Vuex init hook, injected into each instances init hooks list.
	   */
	
	  function vuexInit () {
	    var options = this.$options
	    // store injection
	    if (options.store) {
	      this.$store = options.store
	    } else if (options.parent && options.parent.$store) {
	      this.$store = options.parent.$store
	    }
	  }
	}
	
	var mapState = normalizeNamespace(function (namespace, states) {
	  var res = {}
	  normalizeMap(states).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    res[key] = function mappedState () {
	      var state = this.$store.state
	      var getters = this.$store.getters
	      if (namespace) {
	        var module = this.$store._modulesNamespaceMap[namespace]
	        if (!module) {
	          warnNamespace('mapState', namespace)
	          return
	        }
	        state = module.state
	        getters = module.context.getters
	      }
	      return typeof val === 'function'
	        ? val.call(this, state, getters)
	        : state[val]
	    }
	  })
	  return res
	})
	
	var mapMutations = normalizeNamespace(function (namespace, mutations) {
	  var res = {}
	  normalizeMap(mutations).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    val = namespace + val
	    res[key] = function mappedMutation () {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	
	      return this.$store.commit.apply(this.$store, [val].concat(args))
	    }
	  })
	  return res
	})
	
	var mapGetters = normalizeNamespace(function (namespace, getters) {
	  var res = {}
	  normalizeMap(getters).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    val = namespace + val
	    res[key] = function mappedGetter () {
	      if (!(val in this.$store.getters)) {
	        console.error(("[vuex] unknown getter: " + val))
	      }
	      return this.$store.getters[val]
	    }
	  })
	  return res
	})
	
	var mapActions = normalizeNamespace(function (namespace, actions) {
	  var res = {}
	  normalizeMap(actions).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    val = namespace + val
	    res[key] = function mappedAction () {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	
	      return this.$store.dispatch.apply(this.$store, [val].concat(args))
	    }
	  })
	  return res
	})
	
	function normalizeMap (map) {
	  return Array.isArray(map)
	    ? map.map(function (key) { return ({ key: key, val: key }); })
	    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
	}
	
	function normalizeNamespace (fn) {
	  return function (namespace, map) {
	    if (typeof namespace !== 'string') {
	      map = namespace
	      namespace = ''
	    } else if (namespace.charAt(namespace.length - 1) !== '/') {
	      namespace += '/'
	    }
	    return fn(namespace, map)
	  }
	}
	
	function warnNamespace (helper, namespace) {
	  console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace))
	}
	
	/**
	 * forEach for object
	 */
	function forEachValue (obj, fn) {
	  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); })
	}
	
	function isObject (obj) {
	  return obj !== null && typeof obj === 'object'
	}
	
	function isPromise (val) {
	  return val && typeof val.then === 'function'
	}
	
	function assert (condition, msg) {
	  if (!condition) { throw new Error(("[vuex] " + msg)) }
	}
	
	var Module = function Module (rawModule, runtime) {
	  this.runtime = runtime
	  this._children = Object.create(null)
	  this._rawModule = rawModule
	};
	
	var prototypeAccessors$1 = { state: {},namespaced: {} };
	
	prototypeAccessors$1.state.get = function () {
	  return this._rawModule.state || {}
	};
	
	prototypeAccessors$1.namespaced.get = function () {
	  return !!this._rawModule.namespaced
	};
	
	Module.prototype.addChild = function addChild (key, module) {
	  this._children[key] = module
	};
	
	Module.prototype.removeChild = function removeChild (key) {
	  delete this._children[key]
	};
	
	Module.prototype.getChild = function getChild (key) {
	  return this._children[key]
	};
	
	Module.prototype.update = function update (rawModule) {
	  this._rawModule.namespaced = rawModule.namespaced
	  if (rawModule.actions) {
	    this._rawModule.actions = rawModule.actions
	  }
	  if (rawModule.mutations) {
	    this._rawModule.mutations = rawModule.mutations
	  }
	  if (rawModule.getters) {
	    this._rawModule.getters = rawModule.getters
	  }
	};
	
	Module.prototype.forEachChild = function forEachChild (fn) {
	  forEachValue(this._children, fn)
	};
	
	Module.prototype.forEachGetter = function forEachGetter (fn) {
	  if (this._rawModule.getters) {
	    forEachValue(this._rawModule.getters, fn)
	  }
	};
	
	Module.prototype.forEachAction = function forEachAction (fn) {
	  if (this._rawModule.actions) {
	    forEachValue(this._rawModule.actions, fn)
	  }
	};
	
	Module.prototype.forEachMutation = function forEachMutation (fn) {
	  if (this._rawModule.mutations) {
	    forEachValue(this._rawModule.mutations, fn)
	  }
	};
	
	Object.defineProperties( Module.prototype, prototypeAccessors$1 );
	
	var ModuleCollection = function ModuleCollection (rawRootModule) {
	  var this$1 = this;
	
	  // register root module (Vuex.Store options)
	  this.root = new Module(rawRootModule, false)
	
	  // register all nested modules
	  if (rawRootModule.modules) {
	    forEachValue(rawRootModule.modules, function (rawModule, key) {
	      this$1.register([key], rawModule, false)
	    })
	  }
	};
	
	ModuleCollection.prototype.get = function get (path) {
	  return path.reduce(function (module, key) {
	    return module.getChild(key)
	  }, this.root)
	};
	
	ModuleCollection.prototype.getNamespace = function getNamespace (path) {
	  var module = this.root
	  return path.reduce(function (namespace, key) {
	    module = module.getChild(key)
	    return namespace + (module.namespaced ? key + '/' : '')
	  }, '')
	};
	
	ModuleCollection.prototype.update = function update$1 (rawRootModule) {
	  update(this.root, rawRootModule)
	};
	
	ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
	    var this$1 = this;
	    if ( runtime === void 0 ) runtime = true;
	
	  var parent = this.get(path.slice(0, -1))
	  var newModule = new Module(rawModule, runtime)
	  parent.addChild(path[path.length - 1], newModule)
	
	  // register nested modules
	  if (rawModule.modules) {
	    forEachValue(rawModule.modules, function (rawChildModule, key) {
	      this$1.register(path.concat(key), rawChildModule, runtime)
	    })
	  }
	};
	
	ModuleCollection.prototype.unregister = function unregister (path) {
	  var parent = this.get(path.slice(0, -1))
	  var key = path[path.length - 1]
	  if (!parent.getChild(key).runtime) { return }
	
	  parent.removeChild(key)
	};
	
	function update (targetModule, newModule) {
	  // update target module
	  targetModule.update(newModule)
	
	  // update nested modules
	  if (newModule.modules) {
	    for (var key in newModule.modules) {
	      if (!targetModule.getChild(key)) {
	        console.warn(
	          "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
	          'manual reload is needed'
	        )
	        return
	      }
	      update(targetModule.getChild(key), newModule.modules[key])
	    }
	  }
	}
	
	var Vue // bind on install
	
	var Store = function Store (options) {
	  var this$1 = this;
	  if ( options === void 0 ) options = {};
	
	  assert(Vue, "must call Vue.use(Vuex) before creating a store instance.")
	  assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.")
	
	  var state = options.state; if ( state === void 0 ) state = {};
	  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
	  var strict = options.strict; if ( strict === void 0 ) strict = false;
	
	  // store internal state
	  this._committing = false
	  this._actions = Object.create(null)
	  this._mutations = Object.create(null)
	  this._wrappedGetters = Object.create(null)
	  this._modules = new ModuleCollection(options)
	  this._modulesNamespaceMap = Object.create(null)
	  this._subscribers = []
	  this._watcherVM = new Vue()
	
	  // bind commit and dispatch to self
	  var store = this
	  var ref = this;
	  var dispatch = ref.dispatch;
	  var commit = ref.commit;
	    this.dispatch = function boundDispatch (type, payload) {
	    return dispatch.call(store, type, payload)
	  }
	  this.commit = function boundCommit (type, payload, options) {
	    return commit.call(store, type, payload, options)
	    }
	
	    // strict mode
	  this.strict = strict
	
	  // init root module.
	  // this also recursively registers all sub-modules
	  // and collects all module getters inside this._wrappedGetters
	  installModule(this, state, [], this._modules.root)
	
	  // initialize the store vm, which is responsible for the reactivity
	  // (also registers _wrappedGetters as computed properties)
	  resetStoreVM(this, state)
	
	  // apply plugins
	  plugins.concat(devtoolPlugin).forEach(function (plugin) { return plugin(this$1); })
	};
	
	var prototypeAccessors = { state: {} };
	
	prototypeAccessors.state.get = function () {
	  return this._vm.$data.state
	};
	
	prototypeAccessors.state.set = function (v) {
	  assert(false, "Use store.replaceState() to explicit replace store state.")
	};
	
	Store.prototype.commit = function commit (_type, _payload, _options) {
	    var this$1 = this;
	
	  // check object-style commit
	  var ref = unifyObjectStyle(_type, _payload, _options);
	    var type = ref.type;
	    var payload = ref.payload;
	    var options = ref.options;
	
	  var mutation = { type: type, payload: payload }
	  var entry = this._mutations[type]
	  if (!entry) {
	    console.error(("[vuex] unknown mutation type: " + type))
	    return
	  }
	  this._withCommit(function () {
	    entry.forEach(function commitIterator (handler) {
	      handler(payload)
	    })
	  })
	  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); })
	
	  if (options && options.silent) {
	    console.warn(
	      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
	      'Use the filter functionality in the vue-devtools'
	    )
	  }
	};
	
	Store.prototype.dispatch = function dispatch (_type, _payload) {
	  // check object-style dispatch
	  var ref = unifyObjectStyle(_type, _payload);
	    var type = ref.type;
	    var payload = ref.payload;
	
	  var entry = this._actions[type]
	  if (!entry) {
	    console.error(("[vuex] unknown action type: " + type))
	    return
	  }
	  return entry.length > 1
	    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
	    : entry[0](payload)
	};
	
	Store.prototype.subscribe = function subscribe (fn) {
	  var subs = this._subscribers
	  if (subs.indexOf(fn) < 0) {
	    subs.push(fn)
	  }
	  return function () {
	    var i = subs.indexOf(fn)
	    if (i > -1) {
	      subs.splice(i, 1)
	    }
	  }
	};
	
	Store.prototype.watch = function watch (getter, cb, options) {
	    var this$1 = this;
	
	  assert(typeof getter === 'function', "store.watch only accepts a function.")
	  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
	};
	
	Store.prototype.replaceState = function replaceState (state) {
	    var this$1 = this;
	
	  this._withCommit(function () {
	    this$1._vm.state = state
	  })
	};
	
	Store.prototype.registerModule = function registerModule (path, rawModule) {
	  if (typeof path === 'string') { path = [path] }
	  assert(Array.isArray(path), "module path must be a string or an Array.")
	  this._modules.register(path, rawModule)
	  installModule(this, this.state, path, this._modules.get(path))
	  // reset store to update getters...
	  resetStoreVM(this, this.state)
	};
	
	Store.prototype.unregisterModule = function unregisterModule (path) {
	    var this$1 = this;
	
	  if (typeof path === 'string') { path = [path] }
	  assert(Array.isArray(path), "module path must be a string or an Array.")
	    this._modules.unregister(path)
	  this._withCommit(function () {
	    var parentState = getNestedState(this$1.state, path.slice(0, -1))
	    Vue.delete(parentState, path[path.length - 1])
	  })
	  resetStore(this)
	};
	
	Store.prototype.hotUpdate = function hotUpdate (newOptions) {
	  this._modules.update(newOptions)
	  resetStore(this)
	};
	
	Store.prototype._withCommit = function _withCommit (fn) {
	  var committing = this._committing
	  this._committing = true
	  fn()
	  this._committing = committing
	};
	
	Object.defineProperties( Store.prototype, prototypeAccessors );
	
	function resetStore (store) {
	  store._actions = Object.create(null)
	  store._mutations = Object.create(null)
	  store._wrappedGetters = Object.create(null)
	  store._modulesNamespaceMap = Object.create(null)
	  var state = store.state
	  // init all modules
	  installModule(store, state, [], store._modules.root, true)
	  // reset vm
	  resetStoreVM(store, state)
	}
	
	function resetStoreVM (store, state) {
	  var oldVm = store._vm
	
	  // bind store public getters
	  store.getters = {}
	  var wrappedGetters = store._wrappedGetters
	  var computed = {}
	  forEachValue(wrappedGetters, function (fn, key) {
	    // use computed to leverage its lazy-caching mechanism
	    computed[key] = function () { return fn(store); }
	    Object.defineProperty(store.getters, key, {
	      get: function () { return store._vm[key]; },
	      enumerable: true // for local getters
	    })
	  })
	
	  // use a Vue instance to store the state tree
	  // suppress warnings just in case the user has added
	  // some funky global mixins
	  var silent = Vue.config.silent
	  Vue.config.silent = true
	  store._vm = new Vue({
	    data: { state: state },
	    computed: computed
	  })
	  Vue.config.silent = silent
	
	  // enable strict mode for new vm
	  if (store.strict) {
	    enableStrictMode(store)
	  }
	
	  if (oldVm) {
	    // dispatch changes in all subscribed watchers
	    // to force getter re-evaluation.
	    store._withCommit(function () {
	      oldVm.state = null
	    })
	    Vue.nextTick(function () { return oldVm.$destroy(); })
	  }
	}
	
	function installModule (store, rootState, path, module, hot) {
	  var isRoot = !path.length
	  var namespace = store._modules.getNamespace(path)
	
	  // register in namespace map
	  if (namespace) {
	    store._modulesNamespaceMap[namespace] = module
	  }
	
	  // set state
	  if (!isRoot && !hot) {
	    var parentState = getNestedState(rootState, path.slice(0, -1))
	    var moduleName = path[path.length - 1]
	    store._withCommit(function () {
	      Vue.set(parentState, moduleName, module.state)
	    })
	  }
	
	  var local = module.context = makeLocalContext(store, namespace)
	
	  module.forEachMutation(function (mutation, key) {
	    var namespacedType = namespace + key
	    registerMutation(store, namespacedType, mutation, path)
	  })
	
	  module.forEachAction(function (action, key) {
	    var namespacedType = namespace + key
	    registerAction(store, namespacedType, action, local, path)
	  })
	
	  module.forEachGetter(function (getter, key) {
	    var namespacedType = namespace + key
	    registerGetter(store, namespacedType, getter, local, path)
	  })
	
	  module.forEachChild(function (child, key) {
	    installModule(store, rootState, path.concat(key), child, hot)
	  })
	}
	
	/**
	 * make localized dispatch, commit and getters
	 * if there is no namespace, just use root ones
	 */
	function makeLocalContext (store, namespace) {
	  var noNamespace = namespace === ''
	
	  var local = {
	    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
	      var args = unifyObjectStyle(_type, _payload, _options)
	      var payload = args.payload;
	      var options = args.options;
	      var type = args.type;
	
	      if (!options || !options.root) {
	        type = namespace + type
	        if (!store._actions[type]) {
	          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type))
	          return
	        }
	      }
	
	      return store.dispatch(type, payload)
	    },
	
	    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
	      var args = unifyObjectStyle(_type, _payload, _options)
	      var payload = args.payload;
	      var options = args.options;
	      var type = args.type;
	
	      if (!options || !options.root) {
	        type = namespace + type
	        if (!store._mutations[type]) {
	          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type))
	          return
	        }
	      }
	
	      store.commit(type, payload, options)
	    }
	  }
	
	  // getters object must be gotten lazily
	  // because store.getters will be changed by vm update
	  Object.defineProperty(local, 'getters', {
	    get: noNamespace ? function () { return store.getters; } : function () { return makeLocalGetters(store, namespace); }
	  })
	
	  return local
	}
	
	function makeLocalGetters (store, namespace) {
	  var gettersProxy = {}
	
	  var splitPos = namespace.length
	  Object.keys(store.getters).forEach(function (type) {
	    // skip if the target getter is not match this namespace
	    if (type.slice(0, splitPos) !== namespace) { return }
	
	    // extract local getter type
	    var localType = type.slice(splitPos)
	
	    // Add a port to the getters proxy.
	    // Define as getter property because
	    // we do not want to evaluate the getters in this time.
	    Object.defineProperty(gettersProxy, localType, {
	      get: function () { return store.getters[type]; },
	      enumerable: true
	    })
	  })
	
	  return gettersProxy
	}
	
	function registerMutation (store, type, handler, path) {
	  var entry = store._mutations[type] || (store._mutations[type] = [])
	  entry.push(function wrappedMutationHandler (payload) {
	    handler(getNestedState(store.state, path), payload)
	  })
	}
	
	function registerAction (store, type, handler, local, path) {
	  var entry = store._actions[type] || (store._actions[type] = [])
	  entry.push(function wrappedActionHandler (payload, cb) {
	    var res = handler({
	      dispatch: local.dispatch,
	      commit: local.commit,
	      getters: local.getters,
	      state: getNestedState(store.state, path),
	      rootGetters: store.getters,
	      rootState: store.state
	    }, payload, cb)
	    if (!isPromise(res)) {
	      res = Promise.resolve(res)
	    }
	    if (store._devtoolHook) {
	      return res.catch(function (err) {
	        store._devtoolHook.emit('vuex:error', err)
	        throw err
	      })
	    } else {
	      return res
	    }
	  })
	}
	
	function registerGetter (store, type, rawGetter, local, path) {
	  if (store._wrappedGetters[type]) {
	    console.error(("[vuex] duplicate getter key: " + type))
	    return
	  }
	  store._wrappedGetters[type] = function wrappedGetter (store) {
	    return rawGetter(
	      getNestedState(store.state, path), // local state
	      local.getters, // local getters
	      store.state, // root state
	      store.getters // root getters
	    )
	  }
	}
	
	function enableStrictMode (store) {
	  store._vm.$watch('state', function () {
	    assert(store._committing, "Do not mutate vuex store state outside mutation handlers.")
	  }, { deep: true, sync: true })
	}
	
	function getNestedState (state, path) {
	  return path.length
	    ? path.reduce(function (state, key) { return state[key]; }, state)
	    : state
	}
	
	function unifyObjectStyle (type, payload, options) {
	  if (isObject(type) && type.type) {
	    options = payload
	    payload = type
	    type = type.type
	  }
	  return { type: type, payload: payload, options: options }
	}
	
	function install (_Vue) {
	  if (Vue) {
	    console.error(
	      '[vuex] already installed. Vue.use(Vuex) should be called only once.'
	    )
	    return
	  }
	  Vue = _Vue
	  applyMixin(Vue)
	}
	
	// auto install in dist mode
	if (typeof window !== 'undefined' && window.Vue) {
	  install(window.Vue)
	}
	
	var index = {
	  Store: Store,
	  install: install,
	  version: '2.1.1',
	  mapState: mapState,
	  mapMutations: mapMutations,
	  mapGetters: mapGetters,
	  mapActions: mapActions
	}
	
	return index;
	
	})));

/***/ },
/* 495 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if (media) {
			styleElement.setAttribute("media", media);
		}
	
		if (sourceMap) {
			// https://developer.chrome.com/devtools/docs/javascript-debugging
			// this makes source maps inside style tags work properly in Chrome
			css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */';
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}


/***/ }
]);


// WEBPACK FOOTER //
// static/js/vendor.bcea13d6af2b49c2010e.js